webpackJsonp([1],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(895);
	module.exports = __webpack_require__(1937);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UserConsent = exports.AlbumThumbDescrition = exports.ProjectReportProgressProperty = exports.ProjectReportProperty = exports.ProjectRecipientReportDetailed = exports.ProjectRecipientReportInformation = exports.ProjectReportSkippedUsers = exports.ProjectReportPlayedUsers = exports.ProjectReportFileInfo = exports.ProjectReportRecipientsStatistic = exports.ProjectReportInformation = exports.NoRecords = exports.Tooltip = exports.PasswordValidationTicks = undefined;
	exports.CloudUploader = exports.CloudUploadStatusIcon = exports.CloudUploaderItem = exports.CloudConnectButton = exports.CloudBrowser = exports.BoxcomPopup = exports.BoxcomConnectButton = exports.BoxcomPicker = exports.DropboxConnectButton = exports.DropboxPopup = exports.DropboxPicker = exports.ContactUsInfo = exports.CookiePolicy = exports.VatPolicy = exports.TermOfService = exports.Security = exports.PrivacyPolicy = exports.CopyrightPolicy = exports.ProgressStatus = exports.Button = exports.LoadScript = exports.AdBar = exports.QuickSendReplyButton = exports.QuickSendActions = exports.QuickSendTracklist = exports.QuickSendUploadArea = exports.QuickSendForm = exports.QuickSendList = exports.QuickSendBoxTabs = exports.Footer = exports.AppHeader = exports.HomeHeader = exports.RegistrationForm = exports.AuthEmailString = exports.TermsAcceptance = exports.TermsAgreeLink = exports.Pagination = exports.DownloadTracksButton = exports.WatermarkWarning = exports.Labels = exports.BackButton = exports.ProjectsListWrapper = exports.SortableItemPreview = exports.SortableListItem = exports.SortableList = exports.ProjectStatus = exports.MediaListPopover = exports.MediaList = exports.AutosuggestField = exports.SSProjectsList = exports.SSTeamMembers = exports.ProjectCover = exports.ProjectBreadcrumbs = exports.ForgotPasswordForm = exports.ManageLink = exports.SelectGroupsList = exports.SelectContactsList = exports.FeedbackForm = exports.CsvHint = exports.ContactsImportButton = exports.GroupsList = exports.ContactsList = exports.AccountEmailForm = exports.CoverStyle = exports.RecipientStatus = exports.RecipientsLinksForm = exports.RecipientsEmailWysiwyg = exports.ReplaceMediaFile = exports.Prompt = exports.PopoverMenu = exports.CropUploader = exports.Cropper = exports.ListItem = exports.List = exports.UniversalUploaderItem = exports.FileSize = exports.FileTypeThumb = exports.TotalProgress = exports.UploadStatusIcon = exports.UploadStatus = exports.UploaderFilesize = exports.ButtonUploader = exports.UploadArea = exports.DropZone = exports.UploaderItem = exports.UploaderThumb = exports.FileInput = exports.ProgressBar = exports.FileName = exports.DragBar = exports.AudioPlayer = exports.Checkbox = exports.LoginContactForm = exports.Thumb = exports.ChangePasswordForm = exports.LoginForm = exports.Modal = exports.LangSelector = exports.Loader = exports.SideMenu = undefined;
	
	var _SideMenu2 = __webpack_require__(2097);
	
	var _SideMenu3 = _interopRequireDefault(_SideMenu2);
	
	var _Loader2 = __webpack_require__(60);
	
	var _Loader3 = _interopRequireDefault(_Loader2);
	
	var _LangSelector2 = __webpack_require__(2028);
	
	var _LangSelector3 = _interopRequireDefault(_LangSelector2);
	
	var _Modal2 = __webpack_require__(212);
	
	var _Modal3 = _interopRequireDefault(_Modal2);
	
	var _LoginForm2 = __webpack_require__(1955);
	
	var _LoginForm3 = _interopRequireDefault(_LoginForm2);
	
	var _ChangePasswordForm2 = __webpack_require__(1962);
	
	var _ChangePasswordForm3 = _interopRequireDefault(_ChangePasswordForm2);
	
	var _Thumb2 = __webpack_require__(259);
	
	var _Thumb3 = _interopRequireDefault(_Thumb2);
	
	var _LoginContactForm2 = __webpack_require__(2030);
	
	var _LoginContactForm3 = _interopRequireDefault(_LoginContactForm2);
	
	var _Checkbox2 = __webpack_require__(180);
	
	var _Checkbox3 = _interopRequireDefault(_Checkbox2);
	
	var _AudioPlayer2 = __webpack_require__(1951);
	
	var _AudioPlayer3 = _interopRequireDefault(_AudioPlayer2);
	
	var _DragBar2 = __webpack_require__(1987);
	
	var _DragBar3 = _interopRequireDefault(_DragBar2);
	
	var _FileName2 = __webpack_require__(1995);
	
	var _FileName3 = _interopRequireDefault(_FileName2);
	
	var _ProgressBar2 = __webpack_require__(1996);
	
	var _ProgressBar3 = _interopRequireDefault(_ProgressBar2);
	
	var _FileInput2 = __webpack_require__(1994);
	
	var _FileInput3 = _interopRequireDefault(_FileInput2);
	
	var _Thumb4 = __webpack_require__(2000);
	
	var _Thumb5 = _interopRequireDefault(_Thumb4);
	
	var _UploaderItem2 = __webpack_require__(2006);
	
	var _UploaderItem3 = _interopRequireDefault(_UploaderItem2);
	
	var _DropZone2 = __webpack_require__(1993);
	
	var _DropZone3 = _interopRequireDefault(_DropZone2);
	
	var _UploadArea2 = __webpack_require__(2002);
	
	var _UploadArea3 = _interopRequireDefault(_UploadArea2);
	
	var _ButtonUploader2 = __webpack_require__(823);
	
	var _ButtonUploader3 = _interopRequireDefault(_ButtonUploader2);
	
	var _UploaderFilesize2 = __webpack_require__(2005);
	
	var _UploaderFilesize3 = _interopRequireDefault(_UploaderFilesize2);
	
	var _UploadStatus2 = __webpack_require__(2003);
	
	var _UploadStatus3 = _interopRequireDefault(_UploadStatus2);
	
	var _UploadStatusIcon2 = __webpack_require__(2004);
	
	var _UploadStatusIcon3 = _interopRequireDefault(_UploadStatusIcon2);
	
	var _TotalProgress2 = __webpack_require__(2001);
	
	var _TotalProgress3 = _interopRequireDefault(_TotalProgress2);
	
	var _FileTypeThumb2 = __webpack_require__(1992);
	
	var _FileTypeThumb3 = _interopRequireDefault(_FileTypeThumb2);
	
	var _FileSize2 = __webpack_require__(1991);
	
	var _FileSize3 = _interopRequireDefault(_FileSize2);
	
	var _UniversalUploaderItem2 = __webpack_require__(2132);
	
	var _UniversalUploaderItem3 = _interopRequireDefault(_UniversalUploaderItem2);
	
	var _List2 = __webpack_require__(182);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _ListItem2 = __webpack_require__(76);
	
	var _ListItem3 = _interopRequireDefault(_ListItem2);
	
	var _Cropper2 = __webpack_require__(1982);
	
	var _Cropper3 = _interopRequireDefault(_Cropper2);
	
	var _CropUploader2 = __webpack_require__(1981);
	
	var _CropUploader3 = _interopRequireDefault(_CropUploader2);
	
	var _PopoverMenu2 = __webpack_require__(258);
	
	var _PopoverMenu3 = _interopRequireDefault(_PopoverMenu2);
	
	var _Prompt2 = __webpack_require__(2069);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _ReplaceMediaFile2 = __webpack_require__(2094);
	
	var _ReplaceMediaFile3 = _interopRequireDefault(_ReplaceMediaFile2);
	
	var _EmailWysiwyg = __webpack_require__(2085);
	
	var _EmailWysiwyg2 = _interopRequireDefault(_EmailWysiwyg);
	
	var _LinksForm = __webpack_require__(2086);
	
	var _LinksForm2 = _interopRequireDefault(_LinksForm);
	
	var _RecipientStatus2 = __webpack_require__(845);
	
	var _RecipientStatus3 = _interopRequireDefault(_RecipientStatus2);
	
	var _CoverStyle2 = __webpack_require__(2084);
	
	var _CoverStyle3 = _interopRequireDefault(_CoverStyle2);
	
	var _EmailForm = __webpack_require__(1938);
	
	var _EmailForm2 = _interopRequireDefault(_EmailForm);
	
	var _ContactsList2 = __webpack_require__(1974);
	
	var _ContactsList3 = _interopRequireDefault(_ContactsList2);
	
	var _GroupsList2 = __webpack_require__(1976);
	
	var _GroupsList3 = _interopRequireDefault(_GroupsList2);
	
	var _ContactsImportButton2 = __webpack_require__(1973);
	
	var _ContactsImportButton3 = _interopRequireDefault(_ContactsImportButton2);
	
	var _CsvHint2 = __webpack_require__(1975);
	
	var _CsvHint3 = _interopRequireDefault(_CsvHint2);
	
	var _FeedbackForm2 = __webpack_require__(829);
	
	var _FeedbackForm3 = _interopRequireDefault(_FeedbackForm2);
	
	var _SelectContactsList2 = __webpack_require__(1978);
	
	var _SelectContactsList3 = _interopRequireDefault(_SelectContactsList2);
	
	var _SelectGroupsList2 = __webpack_require__(1979);
	
	var _SelectGroupsList3 = _interopRequireDefault(_SelectGroupsList2);
	
	var _ManageLink2 = __webpack_require__(1977);
	
	var _ManageLink3 = _interopRequireDefault(_ManageLink2);
	
	var _ForgotPasswordForm2 = __webpack_require__(2009);
	
	var _ForgotPasswordForm3 = _interopRequireDefault(_ForgotPasswordForm2);
	
	var _ProjectBreadcrumbs2 = __webpack_require__(2046);
	
	var _ProjectBreadcrumbs3 = _interopRequireDefault(_ProjectBreadcrumbs2);
	
	var _ProjectCover2 = __webpack_require__(2047);
	
	var _ProjectCover3 = _interopRequireDefault(_ProjectCover2);
	
	var _SSTeamMembers2 = __webpack_require__(2051);
	
	var _SSTeamMembers3 = _interopRequireDefault(_SSTeamMembers2);
	
	var _SSProjectsList2 = __webpack_require__(2050);
	
	var _SSProjectsList3 = _interopRequireDefault(_SSProjectsList2);
	
	var _AutosuggestField2 = __webpack_require__(1958);
	
	var _AutosuggestField3 = _interopRequireDefault(_AutosuggestField2);
	
	var _MediaList2 = __webpack_require__(2048);
	
	var _MediaList3 = _interopRequireDefault(_MediaList2);
	
	var _MediaListPopover2 = __webpack_require__(2049);
	
	var _MediaListPopover3 = _interopRequireDefault(_MediaListPopover2);
	
	var _ProjectStatus2 = __webpack_require__(516);
	
	var _ProjectStatus3 = _interopRequireDefault(_ProjectStatus2);
	
	var _SortableList2 = __webpack_require__(2105);
	
	var _SortableList3 = _interopRequireDefault(_SortableList2);
	
	var _SortableListItem2 = __webpack_require__(2106);
	
	var _SortableListItem3 = _interopRequireDefault(_SortableListItem2);
	
	var _SortableItemPreview2 = __webpack_require__(2104);
	
	var _SortableItemPreview3 = _interopRequireDefault(_SortableItemPreview2);
	
	var _ProjectsListWrapper2 = __webpack_require__(2067);
	
	var _ProjectsListWrapper3 = _interopRequireDefault(_ProjectsListWrapper2);
	
	var _BackButton2 = __webpack_require__(256);
	
	var _BackButton3 = _interopRequireDefault(_BackButton2);
	
	var _Labels2 = __webpack_require__(2039);
	
	var _Labels3 = _interopRequireDefault(_Labels2);
	
	var _WatermarkWarning2 = __webpack_require__(830);
	
	var _WatermarkWarning3 = _interopRequireDefault(_WatermarkWarning2);
	
	var _DownloadTracksButton2 = __webpack_require__(2038);
	
	var _DownloadTracksButton3 = _interopRequireDefault(_DownloadTracksButton2);
	
	var _Pagination2 = __webpack_require__(351);
	
	var _Pagination3 = _interopRequireDefault(_Pagination2);
	
	var _TermsAgreeLink2 = __webpack_require__(1954);
	
	var _TermsAgreeLink3 = _interopRequireDefault(_TermsAgreeLink2);
	
	var _TermsAcceptance2 = __webpack_require__(1953);
	
	var _TermsAcceptance3 = _interopRequireDefault(_TermsAcceptance2);
	
	var _AuthEmailString2 = __webpack_require__(1952);
	
	var _AuthEmailString3 = _interopRequireDefault(_AuthEmailString2);
	
	var _RegistrationForm2 = __webpack_require__(1956);
	
	var _RegistrationForm3 = _interopRequireDefault(_RegistrationForm2);
	
	var _HomeHeader2 = __webpack_require__(2019);
	
	var _HomeHeader3 = _interopRequireDefault(_HomeHeader2);
	
	var _AppHeader2 = __webpack_require__(2018);
	
	var _AppHeader3 = _interopRequireDefault(_AppHeader2);
	
	var _Footer2 = __webpack_require__(2008);
	
	var _Footer3 = _interopRequireDefault(_Footer2);
	
	var _QuickSendBoxTabs2 = __webpack_require__(2071);
	
	var _QuickSendBoxTabs3 = _interopRequireDefault(_QuickSendBoxTabs2);
	
	var _QuickSendList2 = __webpack_require__(2075);
	
	var _QuickSendList3 = _interopRequireDefault(_QuickSendList2);
	
	var _QuickSendForm2 = __webpack_require__(2072);
	
	var _QuickSendForm3 = _interopRequireDefault(_QuickSendForm2);
	
	var _QuickSendUploadArea2 = __webpack_require__(2078);
	
	var _QuickSendUploadArea3 = _interopRequireDefault(_QuickSendUploadArea2);
	
	var _QuickSendTracklist2 = __webpack_require__(836);
	
	var _QuickSendTracklist3 = _interopRequireDefault(_QuickSendTracklist2);
	
	var _QuickSendActions2 = __webpack_require__(2070);
	
	var _QuickSendActions3 = _interopRequireDefault(_QuickSendActions2);
	
	var _QuickSendReplyButton2 = __webpack_require__(2077);
	
	var _QuickSendReplyButton3 = _interopRequireDefault(_QuickSendReplyButton2);
	
	var _AdBar2 = __webpack_require__(1940);
	
	var _AdBar3 = _interopRequireDefault(_AdBar2);
	
	var _LoadScript2 = __webpack_require__(2029);
	
	var _LoadScript3 = _interopRequireDefault(_LoadScript2);
	
	var _Button2 = __webpack_require__(42);
	
	var _Button3 = _interopRequireDefault(_Button2);
	
	var _ProgressStatus2 = __webpack_require__(2045);
	
	var _ProgressStatus3 = _interopRequireDefault(_ProgressStatus2);
	
	var _CopyrightPolicy2 = __webpack_require__(2023);
	
	var _CopyrightPolicy3 = _interopRequireDefault(_CopyrightPolicy2);
	
	var _PrivacyPolicy2 = __webpack_require__(2024);
	
	var _PrivacyPolicy3 = _interopRequireDefault(_PrivacyPolicy2);
	
	var _Security2 = __webpack_require__(2025);
	
	var _Security3 = _interopRequireDefault(_Security2);
	
	var _TermOfService2 = __webpack_require__(2026);
	
	var _TermOfService3 = _interopRequireDefault(_TermOfService2);
	
	var _VatPolicy2 = __webpack_require__(2027);
	
	var _VatPolicy3 = _interopRequireDefault(_VatPolicy2);
	
	var _CookiePolicy2 = __webpack_require__(2022);
	
	var _CookiePolicy3 = _interopRequireDefault(_CookiePolicy2);
	
	var _ContactUsInfo2 = __webpack_require__(2021);
	
	var _ContactUsInfo3 = _interopRequireDefault(_ContactUsInfo2);
	
	var _DropboxPicker2 = __webpack_require__(1989);
	
	var _DropboxPicker3 = _interopRequireDefault(_DropboxPicker2);
	
	var _DropboxPopup2 = __webpack_require__(1990);
	
	var _DropboxPopup3 = _interopRequireDefault(_DropboxPopup2);
	
	var _DropboxConnectButton2 = __webpack_require__(1988);
	
	var _DropboxConnectButton3 = _interopRequireDefault(_DropboxConnectButton2);
	
	var _BoxcomPicker2 = __webpack_require__(1960);
	
	var _BoxcomPicker3 = _interopRequireDefault(_BoxcomPicker2);
	
	var _BoxcomConnectButton2 = __webpack_require__(1959);
	
	var _BoxcomConnectButton3 = _interopRequireDefault(_BoxcomConnectButton2);
	
	var _BoxcomPopup2 = __webpack_require__(1961);
	
	var _BoxcomPopup3 = _interopRequireDefault(_BoxcomPopup2);
	
	var _CloudBrowser2 = __webpack_require__(1968);
	
	var _CloudBrowser3 = _interopRequireDefault(_CloudBrowser2);
	
	var _CloudConnectButton2 = __webpack_require__(1969);
	
	var _CloudConnectButton3 = _interopRequireDefault(_CloudConnectButton2);
	
	var _CloudUploaderItem2 = __webpack_require__(1972);
	
	var _CloudUploaderItem3 = _interopRequireDefault(_CloudUploaderItem2);
	
	var _CloudUploadStatusIcon2 = __webpack_require__(1970);
	
	var _CloudUploadStatusIcon3 = _interopRequireDefault(_CloudUploadStatusIcon2);
	
	var _CloudUploader2 = __webpack_require__(1971);
	
	var _CloudUploader3 = _interopRequireDefault(_CloudUploader2);
	
	var _PasswordValidationTicks2 = __webpack_require__(2037);
	
	var _PasswordValidationTicks3 = _interopRequireDefault(_PasswordValidationTicks2);
	
	var _Tooltip2 = __webpack_require__(522);
	
	var _Tooltip3 = _interopRequireDefault(_Tooltip2);
	
	var _NoRecords2 = __webpack_require__(2035);
	
	var _NoRecords3 = _interopRequireDefault(_NoRecords2);
	
	var _ProjectReportInformation2 = __webpack_require__(2055);
	
	var _ProjectReportInformation3 = _interopRequireDefault(_ProjectReportInformation2);
	
	var _ProjectReportRecipientsStatistic2 = __webpack_require__(2059);
	
	var _ProjectReportRecipientsStatistic3 = _interopRequireDefault(_ProjectReportRecipientsStatistic2);
	
	var _ProjectReportFileInfo2 = __webpack_require__(2054);
	
	var _ProjectReportFileInfo3 = _interopRequireDefault(_ProjectReportFileInfo2);
	
	var _ProjectReportPlayedUsers2 = __webpack_require__(2056);
	
	var _ProjectReportPlayedUsers3 = _interopRequireDefault(_ProjectReportPlayedUsers2);
	
	var _ProjectReportSkippedUsers2 = __webpack_require__(2060);
	
	var _ProjectReportSkippedUsers3 = _interopRequireDefault(_ProjectReportSkippedUsers2);
	
	var _ProjectRecipientReportInformation2 = __webpack_require__(2053);
	
	var _ProjectRecipientReportInformation3 = _interopRequireDefault(_ProjectRecipientReportInformation2);
	
	var _ProjectRecipientReportDetailed2 = __webpack_require__(2052);
	
	var _ProjectRecipientReportDetailed3 = _interopRequireDefault(_ProjectRecipientReportDetailed2);
	
	var _ProjectReportProperty2 = __webpack_require__(2058);
	
	var _ProjectReportProperty3 = _interopRequireDefault(_ProjectReportProperty2);
	
	var _ProjectReportProgressProperty2 = __webpack_require__(2057);
	
	var _ProjectReportProgressProperty3 = _interopRequireDefault(_ProjectReportProgressProperty2);
	
	var _AlbumThumbDescrition2 = __webpack_require__(511);
	
	var _AlbumThumbDescrition3 = _interopRequireDefault(_AlbumThumbDescrition2);
	
	var _UserConsent2 = __webpack_require__(2133);
	
	var _UserConsent3 = _interopRequireDefault(_UserConsent2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.SideMenu = _SideMenu3.default; /**
	                                        *  Point of contact for component modules
	                                        *
	                                        *  ie: import { CounterButton, InfoBar } from 'components';
	                                        *
	                                        */
	
	exports.Loader = _Loader3.default;
	exports.LangSelector = _LangSelector3.default;
	exports.Modal = _Modal3.default;
	exports.LoginForm = _LoginForm3.default;
	exports.ChangePasswordForm = _ChangePasswordForm3.default;
	exports.Thumb = _Thumb3.default;
	exports.LoginContactForm = _LoginContactForm3.default;
	exports.Checkbox = _Checkbox3.default;
	exports.AudioPlayer = _AudioPlayer3.default;
	exports.DragBar = _DragBar3.default;
	exports.FileName = _FileName3.default;
	exports.ProgressBar = _ProgressBar3.default;
	exports.FileInput = _FileInput3.default;
	exports.UploaderThumb = _Thumb5.default;
	exports.UploaderItem = _UploaderItem3.default;
	exports.DropZone = _DropZone3.default;
	exports.UploadArea = _UploadArea3.default;
	exports.ButtonUploader = _ButtonUploader3.default;
	exports.UploaderFilesize = _UploaderFilesize3.default;
	exports.UploadStatus = _UploadStatus3.default;
	exports.UploadStatusIcon = _UploadStatusIcon3.default;
	exports.TotalProgress = _TotalProgress3.default;
	exports.FileTypeThumb = _FileTypeThumb3.default;
	exports.FileSize = _FileSize3.default;
	exports.UniversalUploaderItem = _UniversalUploaderItem3.default;
	exports.List = _List3.default;
	exports.ListItem = _ListItem3.default;
	exports.Cropper = _Cropper3.default;
	exports.CropUploader = _CropUploader3.default;
	exports.PopoverMenu = _PopoverMenu3.default;
	exports.Prompt = _Prompt3.default;
	exports.ReplaceMediaFile = _ReplaceMediaFile3.default;
	exports.RecipientsEmailWysiwyg = _EmailWysiwyg2.default;
	exports.RecipientsLinksForm = _LinksForm2.default;
	exports.RecipientStatus = _RecipientStatus3.default;
	exports.CoverStyle = _CoverStyle3.default;
	exports.AccountEmailForm = _EmailForm2.default;
	exports.ContactsList = _ContactsList3.default;
	exports.GroupsList = _GroupsList3.default;
	exports.ContactsImportButton = _ContactsImportButton3.default;
	exports.CsvHint = _CsvHint3.default;
	exports.FeedbackForm = _FeedbackForm3.default;
	exports.SelectContactsList = _SelectContactsList3.default;
	exports.SelectGroupsList = _SelectGroupsList3.default;
	exports.ManageLink = _ManageLink3.default;
	exports.ForgotPasswordForm = _ForgotPasswordForm3.default;
	exports.ProjectBreadcrumbs = _ProjectBreadcrumbs3.default;
	exports.ProjectCover = _ProjectCover3.default;
	exports.SSTeamMembers = _SSTeamMembers3.default;
	exports.SSProjectsList = _SSProjectsList3.default;
	exports.AutosuggestField = _AutosuggestField3.default;
	exports.MediaList = _MediaList3.default;
	exports.MediaListPopover = _MediaListPopover3.default;
	exports.ProjectStatus = _ProjectStatus3.default;
	exports.SortableList = _SortableList3.default;
	exports.SortableListItem = _SortableListItem3.default;
	exports.SortableItemPreview = _SortableItemPreview3.default;
	exports.ProjectsListWrapper = _ProjectsListWrapper3.default;
	exports.BackButton = _BackButton3.default;
	exports.Labels = _Labels3.default;
	exports.WatermarkWarning = _WatermarkWarning3.default;
	exports.DownloadTracksButton = _DownloadTracksButton3.default;
	exports.Pagination = _Pagination3.default;
	exports.TermsAgreeLink = _TermsAgreeLink3.default;
	exports.TermsAcceptance = _TermsAcceptance3.default;
	exports.AuthEmailString = _AuthEmailString3.default;
	exports.RegistrationForm = _RegistrationForm3.default;
	exports.HomeHeader = _HomeHeader3.default;
	exports.AppHeader = _AppHeader3.default;
	exports.Footer = _Footer3.default;
	exports.QuickSendBoxTabs = _QuickSendBoxTabs3.default;
	exports.QuickSendList = _QuickSendList3.default;
	exports.QuickSendForm = _QuickSendForm3.default;
	exports.QuickSendUploadArea = _QuickSendUploadArea3.default;
	exports.QuickSendTracklist = _QuickSendTracklist3.default;
	exports.QuickSendActions = _QuickSendActions3.default;
	exports.QuickSendReplyButton = _QuickSendReplyButton3.default;
	exports.AdBar = _AdBar3.default;
	exports.LoadScript = _LoadScript3.default;
	exports.Button = _Button3.default;
	exports.ProgressStatus = _ProgressStatus3.default;
	exports.CopyrightPolicy = _CopyrightPolicy3.default;
	exports.PrivacyPolicy = _PrivacyPolicy3.default;
	exports.Security = _Security3.default;
	exports.TermOfService = _TermOfService3.default;
	exports.VatPolicy = _VatPolicy3.default;
	exports.CookiePolicy = _CookiePolicy3.default;
	exports.ContactUsInfo = _ContactUsInfo3.default;
	exports.DropboxPicker = _DropboxPicker3.default;
	exports.DropboxPopup = _DropboxPopup3.default;
	exports.DropboxConnectButton = _DropboxConnectButton3.default;
	exports.BoxcomPicker = _BoxcomPicker3.default;
	exports.BoxcomConnectButton = _BoxcomConnectButton3.default;
	exports.BoxcomPopup = _BoxcomPopup3.default;
	exports.CloudBrowser = _CloudBrowser3.default;
	exports.CloudConnectButton = _CloudConnectButton3.default;
	exports.CloudUploaderItem = _CloudUploaderItem3.default;
	exports.CloudUploadStatusIcon = _CloudUploadStatusIcon3.default;
	exports.CloudUploader = _CloudUploader3.default;
	exports.PasswordValidationTicks = _PasswordValidationTicks3.default;
	exports.Tooltip = _Tooltip3.default;
	exports.NoRecords = _NoRecords3.default;
	exports.ProjectReportInformation = _ProjectReportInformation3.default;
	exports.ProjectReportRecipientsStatistic = _ProjectReportRecipientsStatistic3.default;
	exports.ProjectReportFileInfo = _ProjectReportFileInfo3.default;
	exports.ProjectReportPlayedUsers = _ProjectReportPlayedUsers3.default;
	exports.ProjectReportSkippedUsers = _ProjectReportSkippedUsers3.default;
	exports.ProjectRecipientReportInformation = _ProjectRecipientReportInformation3.default;
	exports.ProjectRecipientReportDetailed = _ProjectRecipientReportDetailed3.default;
	exports.ProjectReportProperty = _ProjectReportProperty3.default;
	exports.ProjectReportProgressProperty = _ProjectReportProgressProperty3.default;
	exports.AlbumThumbDescrition = _AlbumThumbDescrition3.default;
	exports.UserConsent = _UserConsent3.default;

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(34);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _uniq3 = __webpack_require__(457);
	
	var _uniq4 = _interopRequireDefault(_uniq3);
	
	var _assign3 = __webpack_require__(1547);
	
	var _assign4 = _interopRequireDefault(_assign3);
	
	var _map3 = __webpack_require__(241);
	
	var _map4 = _interopRequireDefault(_map3);
	
	var _keyBy3 = __webpack_require__(322);
	
	var _keyBy4 = _interopRequireDefault(_keyBy3);
	
	var _get3 = __webpack_require__(19);
	
	var _get4 = _interopRequireDefault(_get3);
	
	exports.findIndexInObjectByKw = findIndexInObjectByKw;
	exports.filterObjectsByKw = filterObjectsByKw;
	exports.filterObjectsByKws = filterObjectsByKws;
	exports.mergeObjectArraysByKey = mergeObjectArraysByKey;
	exports.stopEvent = stopEvent;
	exports.isIOS = isIOS;
	exports.secondsToTime = secondsToTime;
	exports.customEvent = customEvent;
	exports.popupWindowCenter = popupWindowCenter;
	
	var _strings = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import xregexp from 'xregexp';
	
	
	function findIndexInObjectByKw(object, fields) {
	  var kw = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	  var foundIndex = 0;
	
	  if (kw) {
	    foundIndex = -1;
	    fields.map(function (field) {
	      var index = (0, _strings.cleanString)((0, _get4.default)(object, field, '')).indexOf(kw);
	      if (index !== -1) {
	        if (foundIndex === -1) {
	          foundIndex = index;
	        }
	        foundIndex = Math.min(foundIndex, index);
	      }
	    });
	  }
	
	  return foundIndex;
	}
	
	function filterObjectsByKw(objects, fields) {
	  var kw = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	  var firstMatches = [];
	  var lastMatches = [];
	  var clearKw = (0, _strings.cleanString)(kw);
	
	  objects.map(function (object) {
	    var foundIndex = findIndexInObjectByKw(object, fields, clearKw);
	    if (foundIndex === 0) {
	      firstMatches.push(object);
	    } else if (foundIndex > 0) {
	      lastMatches.push(object);
	    }
	  });
	
	  return [].concat(firstMatches, lastMatches);
	}
	
	function filterObjectsByKws(_ref) {
	  var objects = _ref.objects,
	      fields = _ref.fields,
	      _ref$kw = _ref.kw,
	      kw = _ref$kw === undefined ? '' : _ref$kw;
	
	  var firstMatches = [];
	  var lastMatches = [];
	  // parse keywords string to array of uniq words
	  // xregexp to support Unicode
	  // const regexp = xregexp('[\\pL]{1,}', 'igm');
	  // const regexp = new RegExp(/[\w]{1,}/igm);
	  // const kws = _uniq((kw.match(regexp) || []).map(kwPart => cleanString(kwPart)));
	
	  // split words by special characters - works with utf8 but not so universal as split by words
	  var splitRegex = new RegExp(/[ ,\.\(\):@"'\\/?!#№$;%^&*\[\]=\+\-_~`<>]{1,}/igm); // eslint-disable-line no-useless-escape
	  var kws = (0, _uniq4.default)(kw.split(splitRegex).map(function (kwPart) {
	    return (0, _strings.cleanString)(kwPart);
	  }));
	
	  if (!kws.length) {
	    return objects;
	  }
	
	  objects.map(function (object) {
	    var foundIndexes = [];
	    kws.map(function (kwPart) {
	      var foundIndex = findIndexInObjectByKw(object, fields, kwPart);
	      if (foundIndex > -1) {
	        foundIndexes.push(foundIndex);
	      }
	    });
	
	    // only if all keywords found in object fields
	    if (foundIndexes.length === kws.length) {
	      var firstFoundIndex = foundIndexes.sort()[0];
	      if (firstFoundIndex === 0) {
	        firstMatches.push(object);
	      } else if (firstFoundIndex > 0) {
	        lastMatches.push(object);
	      }
	    }
	  });
	
	  return [].concat(firstMatches, lastMatches);
	}
	
	function mergeObjectArraysByKey(key) {
	  var normalizedArrays = [];
	
	  for (var _len = arguments.length, arrays = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    arrays[_key - 1] = arguments[_key];
	  }
	
	  arrays.map(function (array) {
	    normalizedArrays.push((0, _keyBy4.default)([].concat((0, _toConsumableArray3.default)(array)), key));
	  });
	  return (0, _map4.default)(_assign4.default.apply(undefined, normalizedArrays));
	}
	
	function stopEvent(e) {
	  if (e) {
	    e.preventDefault();
	    e.stopPropagation();
	  }
	  return e;
	}
	
	function isIOS() {
	  return typeof navigator !== 'undefined' && (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i));
	}
	
	function secondsToTime(_ref2) {
	  var seconds = _ref2.seconds,
	      _ref2$separator = _ref2.separator,
	      separator = _ref2$separator === undefined ? ':' : _ref2$separator,
	      _ref2$infinityStr = _ref2.infinityStr,
	      infinityStr = _ref2$infinityStr === undefined ? 'calculating...' : _ref2$infinityStr;
	
	  if (seconds === Infinity) {
	    return infinityStr;
	  }
	  var hour = Math.floor(seconds / 3600);
	  var min = Math.floor((seconds - hour * 3600) / 60);
	  var sec = seconds - hour * 3600 - min * 60;
	  var timeToStr = function timeToStr(time) {
	    return ('0' + time).substr(-2);
	  };
	  var res = timeToStr(min) + separator + timeToStr(sec);
	  return hour ? hour + separator + res : res;
	}
	
	function customEvent(name, data) {
	  if (typeof window === 'undefined') {
	    return false;
	  }
	
	  function CustomEventPolyfill(event, params) {
	    var evParams = params || { bubbles: false, cancelable: false, detail: undefined };
	    var evt = document.createEvent('CustomEvent');
	    evt.initCustomEvent(event, evParams.bubbles, evParams.cancelable, evParams.detail);
	    return evt;
	  }
	
	  if (typeof window.CustomEvent !== 'function') {
	    CustomEventPolyfill.prototype = window.Event.prototype;
	    window.CustomEvent = CustomEventPolyfill;
	  }
	  return new window.CustomEvent(name, { detail: data });
	}
	
	function popupWindowCenter(url, title, windowWidth, windowHeight) {
	  if (typeof window === 'undefined') {
	    return false;
	  }
	
	  // Fixes dual-screen position                                       Most browsers      Firefox
	  var dualScreenLeft = typeof window.screenLeft !== 'undefined' ? window.screenLeft : screen.left;
	  var dualScreenTop = typeof window.screenTop !== 'undefined' ? window.screenTop : screen.top;
	
	  var _document$documentEle = document.documentElement,
	      clientWidth = _document$documentEle.clientWidth,
	      clientHeight = _document$documentEle.clientHeight;
	
	  var width = window.innerWidth ? window.innerWidth : clientWidth || screen.width;
	  var height = window.innerHeight ? window.innerHeight : clientHeight || screen.height;
	
	  var left = width / 2 - windowWidth / 2 + dualScreenLeft;
	  var top = height / 2 - windowHeight / 2 + dualScreenTop;
	  var windowProps = 'scrollbars=yes, width=' + windowWidth + ', height=' + windowHeight + ', top=' + top + ', left=' + left + ', menubar=no, toolbar=no, location=no';
	  var newWindow = window.open(url, title, windowProps);
	
	  // Puts focus on the newWindow
	  if (window.focus) {
	    newWindow.focus();
	  }
	
	  return newWindow;
	}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(34);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _typeof2 = __webpack_require__(102);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _reactReduxToastr = __webpack_require__(494);
	
	var _strings = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var customToastr = {};
	
	var isArgsWithOptions = function isArgsWithOptions(args) {
	  return (0, _typeof3.default)(args[args.length - 1]) === 'object';
	};
	
	function bindArgs(args) {
	  var t = __webpack_require__(56).getT();
	  var defaultOpts = {
	    showCloseButton: true,
	    timeOut: 4000,
	    transitionIn: 'fadeIn',
	    transitionOut: 'fadeOut',
	    okText: t('OK'),
	    cancelText: t('Cancel'),
	    progressBar: false
	  };
	
	  if (isArgsWithOptions(args)) {
	    args[args.length - 1] = (0, _extends3.default)({}, defaultOpts, args[args.length - 1]);
	  } else {
	    args.push(defaultOpts);
	  }
	
	  return args;
	}
	
	['success', 'info', 'warning', 'error', 'message', 'confirm'].map(function (method) {
	  customToastr[method] = function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    // add default title
	    if (method !== 'confirm') {
	      if (args.length === 1 || isArgsWithOptions(args) && args.length < 3) {
	        var _t = __webpack_require__(56).getT();
	        args.unshift(_t((0, _strings.capitalize)(method)));
	      }
	    }
	    return _reactReduxToastr.toastr[method].apply(_reactReduxToastr.toastr, (0, _toConsumableArray3.default)(bindArgs(args)));
	  };
	});
	
	exports.default = customToastr;
	module.exports = exports['default'];

/***/ }),
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.projectStatus = exports.quickSendBox = exports.projectTypes = exports.pageLimit = undefined;
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _get2 = __webpack_require__(19);
	
	var _get3 = _interopRequireDefault(_get2);
	
	exports.getProjectStatusTexts = getProjectStatusTexts;
	exports.getProjectStatusText = getProjectStatusText;
	exports.prepareProject = prepareProject;
	exports.processProject = processProject;
	exports.processProjects = processProjects;
	exports.prepareProjects = prepareProjects;
	exports.getFilteredProjects = getFilteredProjects;
	exports.getProjectPermissions = getProjectPermissions;
	exports.transformProjectsResponse = transformProjectsResponse;
	
	var _TypeCast = __webpack_require__(260);
	
	var _strings = __webpack_require__(59);
	
	var _datetime = __webpack_require__(68);
	
	var _moment = __webpack_require__(20);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _utils = __webpack_require__(24);
	
	var _recipients = __webpack_require__(264);
	
	var _Playlists = __webpack_require__(214);
	
	var _ordering = __webpack_require__(533);
	
	var _ordering2 = _interopRequireDefault(_ordering);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pageLimit = exports.pageLimit = 100;
	
	var filteredFields = ['artist_name', 'titleName1', 'titleName2', 'owName', 'projectId', 'iRef', 'statusText'];
	
	var projectTypes = exports.projectTypes = {
	  quickSend: 'QS',
	  audio: 'audio',
	  video: 'video',
	  sharespace: 'sharespace',
	  newsletter: 'newsletter',
	  all: 'all'
	};
	
	var quickSendBox = exports.quickSendBox = {
	  inbox: 'inbox',
	  sent: 'sent',
	  draft: 'draft'
	};
	
	var projectStatus = exports.projectStatus = {
	  created: 'Created',
	  draft: 'Draft',
	  suspended: 'Suspended',
	  toProcess: 'toProcess',
	  active: 'Active',
	  expired: 'Expired',
	  deleted: 'Deleted',
	  published: 'Published',
	  hidden: 'hidden'
	};
	
	var projectStatusTexts = null;
	
	function getProjectStatusTexts() {
	  if (!projectStatusTexts) {
	    var _projectStatusTexts;
	
	    var t = __webpack_require__(56).getT();
	    projectStatusTexts = (_projectStatusTexts = {}, (0, _defineProperty3.default)(_projectStatusTexts, projectStatus.created, t('Pending')), (0, _defineProperty3.default)(_projectStatusTexts, projectStatus.draft, t('Pending')), (0, _defineProperty3.default)(_projectStatusTexts, projectStatus.suspended, t('Suspended')), (0, _defineProperty3.default)(_projectStatusTexts, projectStatus.toProcess, t('Processing')), (0, _defineProperty3.default)(_projectStatusTexts, projectStatus.active, t('Published')), (0, _defineProperty3.default)(_projectStatusTexts, projectStatus.expired, t('Expired')), (0, _defineProperty3.default)(_projectStatusTexts, projectStatus.deleted, t('Deleted')), (0, _defineProperty3.default)(_projectStatusTexts, projectStatus.published, t('Published')), (0, _defineProperty3.default)(_projectStatusTexts, projectStatus.hidden, t('hidden')), _projectStatusTexts);
	  }
	
	  return projectStatusTexts;
	}
	
	function getProjectStatusText(project) {
	  return getProjectStatusTexts()[project.status];
	}
	
	function prepareProject(project) {
	  var _ref = project || {},
	      mainProject = _ref.mainProject;
	
	  var processedProject = {};
	  if (mainProject) {
	    processedProject = (0, _extends3.default)({}, project, mainProject);
	    delete processedProject.mainProject;
	  } else {
	    processedProject = (0, _extends3.default)({}, project);
	  }
	
	  // duct tape for the API that has a different names for the same fields in the different requests
	  var _processedProject = processedProject,
	      track_name = _processedProject.track_name,
	      track_name2 = _processedProject.track_name2,
	      title = _processedProject.title,
	      title2 = _processedProject.title2,
	      album = _processedProject.album,
	      album2 = _processedProject.album2;
	
	  var titleName1 = track_name || title || album; // eslint-disable-line camelcase
	  var titleName2 = track_name2 || title2 || album2; // eslint-disable-line camelcase
	
	  processedProject.titleName1 = titleName1;
	  processedProject.titleName2 = titleName2;
	
	  processedProject.projectId = processedProject.projectId || processedProject.project_id || processedProject.id;
	  processedProject.owName = (0, _strings.concat)(' ', processedProject.owFirstname || processedProject.ownerFirstname || processedProject.ownerName, processedProject.owLastname || processedProject.ownerLastname || processedProject.ownerSurname);
	  processedProject.fullTitle = (0, _strings.concat)(' : ', processedProject.artist_name, (0, _strings.concat)(' ', titleName1, titleName2));
	  processedProject.projectContentType = processedProject.projectType === 'root_project' ? projectTypes.sharespace : processedProject.audiovideo;
	  processedProject.statusText = getProjectStatusText(processedProject);
	  processedProject._isPrepared = true;
	
	  return processedProject;
	}
	
	function processProject(project) {
	  var processedProject = (0, _get3.default)(project, '_isPrepared', false) ? (0, _extends3.default)({}, project) : prepareProject(project);
	
	  processedProject.canEdit = (0, _TypeCast.asBoolean)(processedProject.canEdit);
	  processedProject.lockedSharespace = (0, _TypeCast.asNumberArray)(processedProject.lockedSharespace);
	  processedProject.directAccessWatermark = processedProject.directAccessWatermark || 0;
	  processedProject.hideSender = processedProject.hideSender || 0;
	  processedProject.watermarkTracks = !!processedProject.watermarkTracks;
	  processedProject.expiryDate = (0, _datetime.formatDateToSql)(processedProject.expiryDate);
	  processedProject.expiryDateText = processedProject.expiryDate ? (0, _moment2.default)(processedProject.expiryDate).format(_datetime.dateFormat.date) : '';
	  processedProject.shortExpiryDateText = processedProject.expiryDate ? (0, _datetime.formatShortDate)(processedProject.expiryDate) : '';
	  processedProject.isExpired = (0, _datetime.isExpired)({ time: 0, duration: new Date(processedProject.expiryDate) });
	  processedProject.sentDate = processedProject.sentDate || processedProject.sent_date || (0, _get3.default)(processedProject, ['recipients', 0, 'sent_date']);
	  processedProject.sentDateText = processedProject.sentDate ? (0, _moment2.default)(processedProject.sentDate).format(_datetime.dateFormat.date) : '';
	  processedProject.sentDateTimeText = processedProject.sentDate ? (0, _moment2.default)(processedProject.sentDate).format(_datetime.dateFormat.dateTime) : '';
	  processedProject.releaseDate = (0, _datetime.formatDateToSql)(processedProject.releaseDate);
	  processedProject.impactDate = (0, _datetime.formatDateToSql)(processedProject.impactDate);
	  processedProject.dispatchDate = (0, _datetime.formatDateTimeToSql)(processedProject.dispatchDate, true);
	
	  if (processedProject.recipients) {
	    processedProject.recipients = (0, _recipients.processRecipients)((0, _TypeCast.asArray)(processedProject.recipients));
	  }
	  if (processedProject.tracks) {
	    processedProject.tracks = (0, _Playlists.processTracks)({ tracks: (0, _TypeCast.asArray)(processedProject.tracks) });
	  }
	
	  return processedProject;
	}
	
	function processProjects(projects) {
	  console.time('processProjects');
	  var result = projects.map(processProject);
	  console.timeEnd('processProjects');
	  return result;
	}
	
	function prepareProjects(projects) {
	  console.time('prepareProjects');
	  var result = projects.map(prepareProject);
	  console.timeEnd('prepareProjects');
	  return result;
	}
	
	function getFilteredProjects(projects, activeOrder, order, kw) {
	  console.time('getFilteredProjects');
	  var res = (0, _utils.filterObjectsByKws)({ objects: projects, fields: filteredFields, kw: kw });
	  console.timeEnd('getFilteredProjects');
	  return (0, _ordering2.default)({ data: res, activeOrder: activeOrder, order: order });
	}
	
	function getProjectPermissions(_ref2) {
	  var project = _ref2.project,
	      userPermissions = _ref2.userPermissions;
	
	  var permissions = {};
	  var isSharespace = project.projectContentType === projectTypes.sharespace;
	
	  permissions.canDelete = isSharespace ? project.canEdit : true;
	  permissions.canEdit = project.canEdit;
	  permissions.canGetReport = project.projectContentType === projectTypes.audio && userPermissions.statsEnable;
	  permissions.canCreateSubproject = isSharespace && !project.canEdit;
	
	  return permissions;
	}
	
	function transformProjectsResponse(resp) {
	  (0, _get3.default)(resp, 'data.listOfMasterProject', []).map(function (project) {
	    project.id = (0, _get3.default)(project, 'mainProject.id');
	  });
	
	  return resp;
	}

/***/ }),
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClientSideComponent = function (_Component) {
	  (0, _inherits3.default)(ClientSideComponent, _Component);
	
	  function ClientSideComponent() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, ClientSideComponent);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClientSideComponent.__proto__ || (0, _getPrototypeOf2.default)(ClientSideComponent)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { isMounted: false };
	    _this._mountTimeout = null;
	    return _this;
	  }
	
	  (0, _createClass3.default)(ClientSideComponent, [{
	    key: 'componentDidMount',
	    value: function componentDidMount(onDidMount) {
	      var _this2 = this;
	
	      var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      this._mountTimeout = setTimeout(function () {
	        if (onDidMount) {
	          onDidMount();
	        }
	        _this2.setState({ isMounted: true });
	      }, delay);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount(onWillUnmount) {
	      clearTimeout(this._mountTimeout);
	      if (this.state.isMounted) {
	        if (onWillUnmount) {
	          onWillUnmount();
	        }
	      }
	    }
	  }]);
	  return ClientSideComponent;
	}(_react.Component); /**
	                      React Component class for inheritance by the app components.
	                      Implements client-side only functionality when `window` or `document` is required
	                     */
	
	exports.default = ClientSideComponent;
	module.exports = exports['default'];

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ACTIONS = exports.notSessionActions = exports.LOGOUT_SUCCESS = exports.LOGOUT = undefined;
	
	var _objectWithoutProperties2 = __webpack_require__(21);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends4 = __webpack_require__(8);
	
	var _extends5 = _interopRequireDefault(_extends4);
	
	var _get2 = __webpack_require__(19);
	
	var _get3 = _interopRequireDefault(_get2);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case 'RESET':
	      return (0, _extends5.default)({}, initialState, {
	        loaded: state.loaded
	      });
	    case LOAD:
	      return (0, _extends5.default)({}, state, {
	        loading: true
	      });
	    case LOAD_SUCCESS:
	      return (0, _extends5.default)({}, state, {
	        loading: false,
	        loaded: true,
	        user: (0, _get3.default)(action, 'result.data.user')
	      });
	    case LOAD_FAIL:
	      return (0, _extends5.default)({}, state, {
	        loading: false,
	        loaded: true,
	        error: action.error
	      });
	    case LOGIN:
	      return (0, _extends5.default)({}, state, {
	        loggingIn: true
	      });
	    case LOGIN_SUCCESS:
	      {
	        return (0, _extends5.default)({}, state, {
	          loggingIn: false,
	          loaded: true,
	          user: (0, _get3.default)(action, 'result.data.user')
	        });
	      }
	    case LOGIN_FAIL:
	      return (0, _extends5.default)({}, state, {
	        loggingIn: false,
	        loaded: false,
	        user: null,
	        loginError: action.error
	      });
	    case LOGOUT:
	      return (0, _extends5.default)({}, state, {
	        loggingOut: true,
	        user: null
	      });
	    case LOGOUT_SUCCESS:
	      return (0, _extends5.default)({}, state, {
	        loggingOut: false,
	        user: null,
	        loaded: true
	      });
	    case LOGOUT_FAIL:
	      return (0, _extends5.default)({}, state, {
	        loggingOut: false,
	        user: null,
	        logoutError: action.error
	      });
	    case ACCEPT_TERMS:
	      return (0, _extends5.default)({}, state, {
	        termsAccepted: action.termsAccepted
	      });
	    case SET_REDIRECT:
	      return (0, _extends5.default)({}, state, {
	        redirect: action.redirect
	      });
	    case SET_LOGIN_DATA:
	      return (0, _extends5.default)({}, state, {
	        loginData: action.loginData
	      });
	    case REMOVE_LOGIN_DATA:
	      return (0, _extends5.default)({}, state, {
	        loginData: {}
	      });
	    case SET_LOGIN_FORM_STATE:
	      return (0, _extends5.default)({}, state, {
	        loginFormState: action.loginFormState
	      });
	    case UPDATE_BOX_TOKEN:
	    case constants.SET_BOX_TOKEN_SUCCESS:
	      return (0, _extends5.default)({}, reducer(state, action), {
	        user: (0, _extends5.default)({}, state.user, (0, _defineProperty3.default)({}, action.service + 'Token', action.token))
	      });
	    case constants.DELETE_BOX_TOKEN_SUCCESS:
	      return (0, _extends5.default)({}, reducer(state, action), {
	        user: (0, _extends5.default)({}, state.user, (0, _defineProperty3.default)({}, action.service + 'Token', undefined))
	      });
	    case _account.ACTIONS.UPDATE_ACCOUNT_SUCCESS:
	      {
	        return (0, _qim.update)(['user', ['name', (0, _qim.$set)((0, _get3.default)(action, 'result.data.firstName', state.user.name))], ['surname', (0, _qim.$set)((0, _get3.default)(action, 'result.data.lastName', state.user.surname))]], reducer(state, action));
	      }
	    default:
	      return reducer(state, action);
	  }
	};
	
	exports.isLoaded = isLoaded;
	exports.isAuthed = isAuthed;
	exports.load = load;
	exports.login = login;
	exports.logout = logout;
	exports.contact = contact;
	exports.resetPassword = resetPassword;
	exports.activateAccount = activateAccount;
	exports.changePassword = changePassword;
	exports.setNewPassword = setNewPassword;
	exports.acceptTerms = acceptTerms;
	exports.setRedirect = setRedirect;
	exports.setLoginData = setLoginData;
	exports.removeLoginData = removeLoginData;
	exports.register = register;
	exports.setBoxToken = setBoxToken;
	exports.deleteBoxToken = deleteBoxToken;
	exports.updateBoxToken = updateBoxToken;
	exports.setLoginFormState = setLoginFormState;
	exports.reset = reset;
	exports.isLoggedIn = isLoggedIn;
	
	var _loadReducer = __webpack_require__(69);
	
	var _loadReducer2 = _interopRequireDefault(_loadReducer);
	
	var _account = __webpack_require__(184);
	
	var _qim = __webpack_require__(110);
	
	var _auth = __webpack_require__(356);
	
	var _responseCodes = __webpack_require__(99);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LOAD = 'auth/LOAD'; /* Auth redux reducer and action creators */
	
	var LOAD_SUCCESS = 'auth/LOAD_SUCCESS';
	var LOAD_FAIL = 'auth/LOAD_FAIL';
	var LOGIN = 'auth/LOGIN';
	var LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS';
	var LOGIN_FAIL = 'auth/LOGIN_FAIL';
	var LOGOUT = exports.LOGOUT = 'auth/LOGOUT';
	var LOGOUT_SUCCESS = exports.LOGOUT_SUCCESS = 'auth/LOGOUT_SUCCESS';
	var LOGOUT_FAIL = 'auth/LOGOUT_FAIL';
	var SET_REDIRECT = 'auth/SET_REDIRECT';
	var SET_LOGIN_DATA = 'auth/SET_LOGIN_DATA';
	var REMOVE_LOGIN_DATA = 'auth/REMOVE_LOGIN_DATA';
	var UPDATE_BOX_TOKEN = 'auth/UPDATE_BOX_TOKEN';
	var SET_LOGIN_FORM_STATE = 'auth/SET_LOGIN_FORM_STATE';
	var ACCEPT_TERMS = 'auth/ACCEPT_TERMS';
	
	var loadReducer = (0, _loadReducer2.default)('auth', {
	  contact: {},
	  resetPassword: {},
	  activateAccount: {},
	  changePassword: {},
	  setNewPassword: {},
	  register: {},
	  setBoxToken: {},
	  deleteBoxToken: {},
	  loginFormState: _auth.loginFormStates.login
	});
	
	var constants = loadReducer.constants,
	    constantsByKey = loadReducer.constantsByKey,
	    reducer = loadReducer.reducer;
	var notSessionActions = exports.notSessionActions = [LOGOUT, LOGOUT_SUCCESS, LOGOUT_FAIL];
	
	var ACTIONS = exports.ACTIONS = constants;
	
	var initialState = (0, _extends5.default)({}, loadReducer.initialState, {
	  loaded: false,
	  user: null,
	  loginData: {},
	  termsAccepted: false
	});
	
	function isLoaded(globalState) {
	  return (0, _get3.default)(globalState, 'auth.loaded', false);
	}
	
	function isAuthed(globalState) {
	  return !!(0, _get3.default)(globalState, 'auth.user');
	}
	
	function load() {
	  return {
	    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
	    promise: function promise(client) {
	      return client.post('/project_wa/getAccount', { hideErrorCodes: [1] });
	    }
	  };
	}
	
	function login(email, password) {
	  var data = { userEmail: email, userPassword: password };
	  return {
	    types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
	    promise: function promise(client) {
	      return client.post('/auth/login', { data: data, successCodes: [_responseCodes.loginCodes.reset, _responseCodes.loginCodes.unlock] });
	    }
	  };
	}
	
	function logout() {
	  var hideErrors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	  return {
	    types: [LOGOUT, LOGOUT_SUCCESS, LOGOUT_FAIL],
	    promise: function promise(client) {
	      return client.post('/auth/logout');
	    },
	    hideErrors: hideErrors
	  };
	}
	
	function contact(data) {
	  return {
	    types: constantsByKey.contact,
	    promise: function promise(client) {
	      return client.post('auth/contact', { data: data });
	    }
	  };
	}
	
	function resetPassword(data) {
	  return (0, _extends5.default)({
	    types: constantsByKey.resetPassword,
	    promise: function promise(client) {
	      return client.post('auth/resetPassword', { data: data });
	    }
	  }, data);
	}
	
	function activateAccount(data) {
	  return (0, _extends5.default)({
	    types: constantsByKey.activateAccount,
	    promise: function promise(client) {
	      return client.post('auth/resetPasswordNewUser', { data: data });
	    }
	  }, data);
	}
	
	function changePassword(data) {
	  return (0, _extends5.default)({
	    types: constantsByKey.changePassword,
	    promise: function promise(client) {
	      return client.post('auth/changePassword', { data: data });
	    }
	  }, data);
	}
	
	function setNewPassword(code, key, data) {
	  var isNew = data.isNew,
	      postData = (0, _objectWithoutProperties3.default)(data, ['isNew']);
	
	  return (0, _extends5.default)({
	    types: constantsByKey.setNewPassword,
	    promise: function promise(client) {
	      return client.post('auth/setNewPassword/' + key + '/' + code + (isNew && '?new=1'), { data: (0, _extends5.default)({ code: code, key: key }, postData) });
	    },
	    code: code,
	    key: key
	  }, data);
	}
	
	function acceptTerms(termsAccepted) {
	  return {
	    type: ACCEPT_TERMS,
	    termsAccepted: termsAccepted
	  };
	}
	
	function setRedirect(redirect) {
	  return {
	    type: SET_REDIRECT,
	    redirect: redirect
	  };
	}
	
	function setLoginData(loginData) {
	  return {
	    type: SET_LOGIN_DATA,
	    loginData: loginData
	  };
	}
	
	function removeLoginData() {
	  return {
	    type: REMOVE_LOGIN_DATA
	  };
	}
	
	function register(data) {
	  return (0, _extends5.default)({
	    types: constantsByKey.register,
	    promise: function promise(client) {
	      return client.post('auth/register', { data: data });
	    }
	  }, data);
	}
	
	function setBoxToken(service, token) {
	  return {
	    types: constantsByKey.setBoxToken,
	    promise: function promise(client) {
	      return client.post('project_wa/setBoxToken', { data: { type: service, token: token } });
	    },
	    service: service,
	    token: token
	  };
	}
	
	function deleteBoxToken(service) {
	  return {
	    types: constantsByKey.deleteBoxToken,
	    promise: function promise(client) {
	      return client.post('project_wa/deleteBoxToken', { data: { type: service } });
	    },
	    service: service
	  };
	}
	
	function updateBoxToken(service, token) {
	  return {
	    type: UPDATE_BOX_TOKEN,
	    service: service,
	    token: token
	  };
	}
	
	function setLoginFormState(loginFormState) {
	  return {
	    type: SET_LOGIN_FORM_STATE,
	    loginFormState: loginFormState
	  };
	}
	
	function reset() {
	  return {
	    type: 'RESET'
	  };
	}
	
	function isLoggedIn() {
	  return function (dispatch, getState) {
	    var user = getState().auth.user;
	    return !!user;
	  };
	}

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _toConsumableArray2 = __webpack_require__(34);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends5 = __webpack_require__(8);
	
	var _extends6 = _interopRequireDefault(_extends5);
	
	var _findIndex3 = __webpack_require__(318);
	
	var _findIndex4 = _interopRequireDefault(_findIndex3);
	
	var _reject3 = __webpack_require__(200);
	
	var _reject4 = _interopRequireDefault(_reject3);
	
	var _get3 = __webpack_require__(19);
	
	var _get4 = _interopRequireDefault(_get3);
	
	exports.default = reducer;
	exports.init = init;
	exports.initProject = initProject;
	exports.initSubmittedFiles = initSubmittedFiles;
	exports.initSubmittedReplaceFile = initSubmittedReplaceFile;
	exports.isLoaded = isLoaded;
	exports.isLoadProjectTime = isLoadProjectTime;
	exports.loadProject = loadProject;
	exports.saveProject = saveProject;
	exports.publish = publish;
	exports.publishSharespace = publishSharespace;
	exports.stopPublish = stopPublish;
	exports.submitMediaFile = submitMediaFile;
	exports.submitCloudFile = submitCloudFile;
	exports.deleteMediaFile = deleteMediaFile;
	exports.submitMediaReplaceFile = submitMediaReplaceFile;
	exports.submitPressFile = submitPressFile;
	exports.deletePressFile = deletePressFile;
	exports.toggleEmailWysiwyg = toggleEmailWysiwyg;
	exports.saveEmail = saveEmail;
	exports.loadRecipientsList = loadRecipientsList;
	exports.copyProject = copyProject;
	exports.loadCommon = loadCommon;
	exports.loadMediaList = loadMediaList;
	exports.loadPressList = loadPressList;
	exports.deleteMedia = deleteMedia;
	exports.deleteCloudFile = deleteCloudFile;
	exports.deletePress = deletePress;
	exports.editMedia = editMedia;
	exports.addMedia = addMedia;
	exports.addFailedMedia = addFailedMedia;
	exports.addPress = addPress;
	exports.replaceMedia = replaceMedia;
	exports.addRecipient = addRecipient;
	exports.addRecipients = addRecipients;
	exports.deleteRecipient = deleteRecipient;
	exports.deleteRecipientsGroup = deleteRecipientsGroup;
	exports.clearRecipientsList = clearRecipientsList;
	exports.editProjectLinks = editProjectLinks;
	exports.deleteCover = deleteCover;
	exports.setCover = setCover;
	exports.testEmail = testEmail;
	exports.sendEmail = sendEmail;
	exports.loadConfirmation = loadConfirmation;
	exports.loadStatusInfo = loadStatusInfo;
	exports.updateCoverStyle = updateCoverStyle;
	exports.addRecipientsFromContacts = addRecipientsFromContacts;
	exports.addRecipientsFromGroups = addRecipientsFromGroups;
	exports.setMultipleBoxsets = setMultipleBoxsets;
	exports.editRecipient = editRecipient;
	exports.loadTeamMembers = loadTeamMembers;
	exports.editTeamMember = editTeamMember;
	exports.deleteTeamMember = deleteTeamMember;
	exports.loadUsersList = loadUsersList;
	exports.addTeamMember = addTeamMember;
	exports.loadSSProjects = loadSSProjects;
	exports.deleteSSProject = deleteSSProject;
	exports.canSuspendSharespace = canSuspendSharespace;
	exports.canPublishSharespace = canPublishSharespace;
	exports.suspendSharespace = suspendSharespace;
	exports.createSubproject = createSubproject;
	exports.updateMediaOrder = updateMediaOrder;
	exports.ssCreate = ssCreate;
	exports.projectCreate = projectCreate;
	exports.addSender = addSender;
	exports.deleteSender = deleteSender;
	exports.setRecipientsDownload = setRecipientsDownload;
	exports.resortMediaList = resortMediaList;
	exports.setCloudFileStatus = setCloudFileStatus;
	exports.setCloudFileFailedStatus = setCloudFileFailedStatus;
	exports.setCloudFileSuccessStatus = setCloudFileSuccessStatus;
	exports.setCloudFileMetadata = setCloudFileMetadata;
	
	var _loadReducer = __webpack_require__(69);
	
	var _loadReducer2 = _interopRequireDefault(_loadReducer);
	
	var _utils = __webpack_require__(24);
	
	var _update = __webpack_require__(501);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _qim = __webpack_require__(110);
	
	var qim = _interopRequireWildcard(_qim);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* Project redux reducer and action creators */
	
	var INIT = 'project/INIT';
	var INIT_PROJECT = 'project/INIT_PROJECT';
	var INIT_SUBMITTED_FILES = 'project/INIT_SUBMITTED_FILES';
	var INIT_SUBMITTED_REPLACE_FILE = 'project/INIT_SUBMITTED_REPLACE_FILE';
	var SUBMIT_MEDIA_FILE = 'project/SUBMIT_MEDIA_FILE';
	var DELETE_MEDIA_FILE = 'project/DELETE_MEDIA_FILE';
	var SUBMIT_MEDIA_REPLACE_FILE = 'project/SUBMIT_MEDIA_REPLACE_FILE';
	var SUBMIT_PRESS_FILE = 'project/SUBMIT_PRESS_FILE';
	var DELETE_PRESS_FILE = 'project/DELETE_PRESS_FILE';
	var UPDATE = 'project/UPDATE';
	var TOGGLE_EMAIL_WYSIWYG = 'project/TOGGLE_EMAIL_WYSIWYG';
	var ADD_MEDIA = 'project/ADD_MEDIA';
	var ADD_FAILED_MEDIA = 'project/ADD_FAILED_MEDIA';
	var ADD_PRESS = 'project/ADD_PRESS';
	var REPLACE_MEDIA = 'project/REPLACE_MEDIA';
	var ADD_RECIPIENTS = 'project/ADD_RECIPIENTS';
	var SET_COVER = 'project/SET_COVER';
	var EDIT_RECIPIENT = 'project/EDIT_RECIPIENT';
	var EDIT_RECIPIENT_SUCCESS = 'project/EDIT_RECIPIENT_SUCCESS';
	var EDIT_RECIPIENT_FAIL = 'project/EDIT_RECIPIENT_FAIL';
	var RESORT_MEDIA_LIST = 'project/RESORT_MEDIA_LIST';
	var SUBMIT_CLOUD_FILE = 'project/SUBMIT_CLOUD_FILE';
	var SET_CLOUD_FILE_DATA = 'project/SET_CLOUD_FILE_DATA';
	var CLEAR_RECIPIENTS_LIST = 'project/CLEAR_RECIPIENTS_LIST';
	
	var loadReducer = (0, _loadReducer2.default)('project', {
	  project: { action: 'load', init: null, field: ['project'] },
	  common: { action: 'load', init: {} },
	  copyProject: { init: null },
	  recipientsList: { action: 'load', init: [] },
	  saveProject: {},
	  mediaList: { action: 'load', init: [] },
	  deleteMedia: {},
	  deleteCloudFile: {},
	  editMedia: {},
	  pressList: { action: 'load', init: [] },
	  deletePress: {},
	  addRecipient: {},
	  deleteRecipient: {},
	  deleteRecipientsGroup: {},
	  saveEmail: {},
	  editLinks: {},
	  deleteCover: {},
	  testEmail: {},
	  sendEmail: {},
	  confirmation: { action: 'load', init: {} },
	  statusInfo: { action: 'load', init: {} },
	  publish: {},
	  publishSharespace: {},
	  stopPublish: {},
	  updateCoverStyle: {},
	  addRecipientsFromContacts: {},
	  addRecipientsFromGroups: {},
	  setMultipleBoxsets: {},
	  teamMembersList: { action: 'load', init: [] },
	  editTeamMember: {},
	  deleteTeamMember: {},
	  usersList: { action: 'load', init: [] },
	  suggestionList: { action: 'load', init: { contacts: [] } },
	  addTeamMember: {},
	  ssProjectsList: { action: 'load', init: [] },
	  deleteSSProject: {},
	  canSuspendSharespace: {},
	  canPublishSharespace: {},
	  suspendSharespace: {},
	  createSubproject: {},
	  updateMediaOrder: {},
	  ssCreate: {},
	  projectCreate: {},
	  addSender: {},
	  deleteSender: {},
	  setRecipientsDownload: {}
	});
	
	var initialState = (0, _extends6.default)({}, loadReducer.initialState, {
	  submittedMediaFiles: [],
	  submittedCloudFiles: [],
	  submittedPressFiles: [],
	  submittedMediaReplaceFile: [],
	  mediaFailedListData: [],
	  showEmailWysiwyg: false,
	  loadingEditRecipient: {}
	});
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case 'RESET':
	      return initialState;
	    case INIT:
	      return (0, _extends6.default)({}, initialState);
	    case INIT_PROJECT:
	      return (0, _extends6.default)({}, state, {
	        projectData: {},
	        projectActionData: {},
	        projectLoaded: false,
	        teamMembersListData: [],
	        recipientsListData: [],
	        mediaListData: []
	      });
	    case INIT_SUBMITTED_FILES:
	      return (0, _extends6.default)({}, state, {
	        submittedMediaFiles: [],
	        submittedPressFiles: [],
	        submittedMediaReplaceFile: [],
	        submittedCloudFiles: [],
	        mediaFailedListData: []
	      });
	    case INIT_SUBMITTED_REPLACE_FILE:
	      return (0, _extends6.default)({}, state, {
	        submittedMediaReplaceFile: []
	      });
	    case loadReducer.constants.LOAD_PROJECT:
	      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
	        submittedMediaFiles: [],
	        submittedPressFiles: [],
	        submittedMediaReplaceFile: [],
	        mediaFailedListData: [],
	        publishLoaded: false,
	        publishSharespaceLoaded: false,
	        stopPublishLoaded: false,
	        suspendSharespaceLoaded: false
	      });
	    case loadReducer.constants.SAVE_PROJECT_SUCCESS:
	      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
	        projectData: (0, _extends6.default)({}, state.projectData, action.projectData, action.result.data)
	      });
	    case loadReducer.constants.EDIT_LINKS_SUCCESS:
	      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
	        projectData: (0, _extends6.default)({}, state.projectData, action.result.data)
	      });
	    case SUBMIT_MEDIA_FILE:
	      return (0, _extends6.default)({}, state, {
	        submittedMediaFiles: [].concat((0, _toConsumableArray3.default)(state.submittedMediaFiles), [action.fileId])
	      });
	    case SUBMIT_CLOUD_FILE:
	      return (0, _extends6.default)({}, state, {
	        submittedCloudFiles: [].concat((0, _toConsumableArray3.default)(state.submittedCloudFiles), [action.file])
	      });
	    case DELETE_MEDIA_FILE:
	      return (0, _extends6.default)({}, state, {
	        submittedMediaFiles: state.submittedMediaFiles.filter(function (item) {
	          return action.fileId !== item;
	        })
	      });
	    case SUBMIT_MEDIA_REPLACE_FILE:
	      return (0, _extends6.default)({}, state, {
	        submittedMediaReplaceFile: [action.fileId]
	      });
	    case SUBMIT_PRESS_FILE:
	      return (0, _extends6.default)({}, state, {
	        submittedPressFiles: [].concat((0, _toConsumableArray3.default)(state.submittedPressFiles), [action.fileId])
	      });
	    case DELETE_PRESS_FILE:
	      return (0, _extends6.default)({}, state, {
	        submittedPressFiles: state.submittedPressFiles.filter(function (item) {
	          return action.fileId !== item;
	        })
	      });
	    case UPDATE:
	      return (0, _extends6.default)({}, state, {
	        projectData: action.project
	      });
	    case TOGGLE_EMAIL_WYSIWYG:
	      return (0, _extends6.default)({}, state, {
	        showEmailWysiwyg: !state.showEmailWysiwyg
	      });
	    case loadReducer.constants.SAVE_EMAIL_SUCCESS:
	      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
	        projectData: (0, _extends6.default)({}, state.projectData, action.result.data),
	        showEmailWysiwyg: false
	      });
	    case loadReducer.constants.DELETE_MEDIA_SUCCESS:
	      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
	        mediaListData: (0, _reject4.default)(state.mediaListData, { id: action.uploadId }),
	        submittedMediaFiles: state.submittedMediaFiles.filter(function (item) {
	          return action.uploaderId !== item;
	        })
	      });
	    case loadReducer.constants.DELETE_CLOUD_FILE_SUCCESS:
	      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
	        mediaListData: (0, _reject4.default)(state.mediaListData, { id: action.uploadId }),
	        submittedCloudFiles: state.submittedCloudFiles.filter(function (item) {
	          return action.uploadId !== (0, _get4.default)(item, 'metadata.id');
	        })
	      });
	    case loadReducer.constants.EDIT_MEDIA_SUCCESS:
	      {
	        var editedIndex = (0, _findIndex4.default)(state.mediaListData, function (mediaItem) {
	          return mediaItem.id === action.uploadId;
	        });
	        var mediaListData = [].concat((0, _toConsumableArray3.default)(state.mediaListData));
	        mediaListData[editedIndex] = (0, _get4.default)(action, 'result.data.media[0]');
	        return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
	          mediaListData: mediaListData
	        });
	      }
	    case ADD_MEDIA:
	      return (0, _extends6.default)({}, state, {
	        mediaListData: [].concat((0, _toConsumableArray3.default)(state.mediaListData), [action.media])
	      });
	    case ADD_FAILED_MEDIA:
	      return (0, _extends6.default)({}, state, {
	        mediaFailedListData: [].concat((0, _toConsumableArray3.default)(state.mediaFailedListData), [action.media])
	      });
	    case REPLACE_MEDIA:
	      {
	        var replacedIndex = (0, _findIndex4.default)(state.mediaListData, function (mediaItem) {
	          return mediaItem.id === action.oldMediaId;
	        });
	        var _mediaListData = [].concat((0, _toConsumableArray3.default)(state.mediaListData));
	        _mediaListData[replacedIndex] = action.media;
	        return (0, _extends6.default)({}, state, {
	          mediaListData: _mediaListData
	        });
	      }
	    case loadReducer.constants.DELETE_PRESS_SUCCESS:
	      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
	        pressListData: (0, _reject4.default)(state.pressListData, { pressId: action.pressId })
	      });
	    case loadReducer.constants.ADD_RECIPIENT_SUCCESS:
	      {
	        var respCode = (0, _get4.default)(action, 'result.code');
	        var newRecipientsListData = [].concat((0, _toConsumableArray3.default)(state.recipientsListData));
	        var _editedIndex = -1;
	
	        if (respCode === 201) {
	          _editedIndex = (0, _findIndex4.default)(state.recipientsListData, function (recipient) {
	            return recipient.recipientId === action.result.data.recipientId;
	          });
	        }
	        if (_editedIndex > -1) {
	          newRecipientsListData[_editedIndex] = (0, _get4.default)(action, 'result.data');
	        } else {
	          newRecipientsListData.push((0, _get4.default)(action, 'result.data'));
	        }
	
	        return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
	          recipientsListData: newRecipientsListData
	        });
	      }
	    case loadReducer.constants.DELETE_RECIPIENT_SUCCESS:
	      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
	        recipientsListData: (0, _reject4.default)(state.recipientsListData, { recipientId: action.recipientId })
	      });
	    case loadReducer.constants.DELETE_RECIPIENTS_GROUP_SUCCESS:
	      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
	        recipientsListData: (0, _reject4.default)(state.recipientsListData, { groupId: action.groupId })
	      });
	    case ADD_PRESS:
	      return (0, _extends6.default)({}, state, {
	        pressListData: [].concat((0, _toConsumableArray3.default)(state.pressListData), [action.press])
	      });
	    case ADD_RECIPIENTS:
	      {
	        var recipients = action.recipients.filter(function (recipient) {
	          return !recipient.result;
	        });
	        return (0, _extends6.default)({}, state, {
	          recipientsListData: [].concat((0, _toConsumableArray3.default)((0, _utils.mergeObjectArraysByKey)('recipientId', state.recipientsListData, recipients)))
	        });
	      }
	    case CLEAR_RECIPIENTS_LIST:
	      return (0, _extends6.default)({}, state, {
	        recipientsListData: []
	      });
	    /*case loadReducer.constants.ADD_RECIPIENTS_FROM_CONTACTS_SUCCESS:
	      return {
	        ...loadReducer.reducer(state, action),
	        recipientsListData: [...mergeObjectArraysByKey('recipientId', state.recipientsListData, action.result.data)]
	      };*/
	    case loadReducer.constants.DELETE_COVER_SUCCESS:
	      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
	        projectData: (0, _extends6.default)({}, state.projectData, {
	          imageThumb: ''
	        })
	      });
	    case loadReducer.constants.UPDATE_COVER_STYLE_SUCCESS:
	      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
	        projectData: (0, _extends6.default)({}, state.projectData, {
	          coverStyle: action.coverStyle
	        })
	      });
	    case SET_COVER:
	      return (0, _extends6.default)({}, state, {
	        projectData: (0, _extends6.default)({}, state.projectData, {
	          imageThumb: action.cover
	        })
	      });
	    case loadReducer.constants.SET_MULTIPLE_BOXSETS_SUCCESS:
	      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
	        projectData: (0, _extends6.default)({}, state.projectData, {
	          multipleBoxsets: action.multipleBoxsets
	        })
	      });
	    case EDIT_RECIPIENT:
	      return (0, _extends6.default)({}, state, {
	        loadingEditRecipient: (0, _extends6.default)({}, state.loadingEditRecipient, (0, _defineProperty3.default)({}, action.recipientId, true))
	      });
	    case EDIT_RECIPIENT_SUCCESS:
	      return (0, _extends6.default)({}, state, {
	        recipientsListData: [].concat((0, _toConsumableArray3.default)((0, _utils.mergeObjectArraysByKey)('recipientId', state.recipientsListData, [action.result.data]))),
	        loadingEditRecipient: (0, _extends6.default)({}, state.loadingEditRecipient, (0, _defineProperty3.default)({}, action.recipientId, false))
	      });
	    case EDIT_RECIPIENT_FAIL:
	      return (0, _extends6.default)({}, state, {
	        loadingEditRecipient: (0, _extends6.default)({}, state.loadingEditRecipient, (0, _defineProperty3.default)({}, action.recipientId, false))
	      });
	    case loadReducer.constants.EDIT_TEAM_MEMBER_SUCCESS:
	      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
	        teamMembersListData: [].concat((0, _toConsumableArray3.default)((0, _utils.mergeObjectArraysByKey)('shareeId', state.teamMembersListData, action.result.data)))
	      });
	    case loadReducer.constants.DELETE_TEAM_MEMBER_SUCCESS:
	      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
	        teamMembersListData: (0, _reject4.default)(state.teamMembersListData, { shareeId: action.shareeId })
	      });
	    case loadReducer.constants.ADD_TEAM_MEMBER_SUCCESS:
	      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
	        teamMembersListData: [].concat((0, _toConsumableArray3.default)((0, _utils.mergeObjectArraysByKey)('shareeId', state.teamMembersListData, action.result.data)))
	      });
	    case loadReducer.constants.DELETE_S_S_PROJECT_SUCCESS:
	      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
	        ssProjectsListData: (0, _reject4.default)(state.ssProjectsListData, { id: action.projectId })
	      });
	    case loadReducer.constants.SUSPEND_SHARESPACE_SUCCESS:
	      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
	        publishLoaded: false,
	        publishSharespaceLoaded: false
	      });
	    case loadReducer.constants.LOAD_CONFIRMATION_SUCCESS:
	      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
	        publishLoaded: false
	      });
	    case loadReducer.constants.PUBLISH_SHARESPACE_SUCCESS:
	      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
	        suspendSharespaceLoaded: false
	      });
	    case loadReducer.constants.SS_CREATE:
	      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
	        ssCreateData: null
	      });
	    case loadReducer.constants.PROJECT_CREATE:
	      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
	        projectCreateData: null
	      });
	    case loadReducer.constants.SET_RECIPIENTS_DOWNLOAD_SUCCESS:
	      {
	        return qim.update([['recipientsListData', qim.$each, 'download', qim.$set(Number(action.download))]], loadReducer.reducer(state, action));
	      }
	    case RESORT_MEDIA_LIST:
	      {
	        var dragItem = state.mediaListData[action.dragIndex];
	        return (0, _extends6.default)({}, state, {
	          mediaListData: (0, _update2.default)(state.mediaListData, {
	            $splice: [[action.dragIndex, 1], [action.hoverIndex, 0, dragItem]]
	          })
	        });
	      }
	    case SET_CLOUD_FILE_DATA:
	      {
	        var editedCloudFileIndex = (0, _findIndex4.default)(state.submittedCloudFiles, function (cloudFile) {
	          return cloudFile.uniqId === action.uniqId;
	        });
	        var submittedCloudFiles = [].concat((0, _toConsumableArray3.default)(state.submittedCloudFiles));
	        if (editedCloudFileIndex > -1) {
	          submittedCloudFiles[editedCloudFileIndex] = (0, _extends6.default)({}, submittedCloudFiles[editedCloudFileIndex], action.data);
	        }
	        return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
	          submittedCloudFiles: submittedCloudFiles
	        });
	      }
	    default:
	      return loadReducer.reducer(state, action);
	  }
	}
	
	function init() {
	  return {
	    type: INIT
	  };
	}
	
	function initProject() {
	  return {
	    type: INIT_PROJECT
	  };
	}
	
	function initSubmittedFiles() {
	  return {
	    type: INIT_SUBMITTED_FILES
	  };
	}
	
	function initSubmittedReplaceFile() {
	  return {
	    type: INIT_SUBMITTED_REPLACE_FILE
	  };
	}
	
	function isLoaded(id, globalState) {
	  var loadedProjectId = (0, _get4.default)(globalState, 'project.projectActionData.projectId');
	  return (0, _get4.default)(globalState, 'project.projectLoaded', false) && id === loadedProjectId;
	}
	
	function isLoadProjectTime(id, globalState) {
	  return (/*!isLoaded(id, globalState) && */(0, _get4.default)(globalState, 'auth.user', false)
	  );
	}
	
	function loadProject(projectId) {
	  return {
	    types: loadReducer.constantsByKey.project,
	    promise: function promise(client) {
	      return client.post('project_wa/getProject', { data: { projectId: projectId } });
	    },
	    projectId: Number(projectId)
	  };
	}
	
	function saveProject(projectData) {
	  var endpoint = projectData.projectId ? 'project_wa/editProject' : 'project_wa/addProject';
	  return {
	    types: loadReducer.constantsByKey.saveProject,
	    promise: function promise(client) {
	      return client.post(endpoint, { data: (0, _extends6.default)({}, projectData) });
	    },
	    projectData: projectData
	  };
	}
	
	function publish(projectId) {
	  return {
	    types: loadReducer.constantsByKey.publish,
	    promise: function promise(client) {
	      return client.post('project_wa/publish', { data: { projectId: projectId } });
	    },
	    projectId: projectId
	  };
	}
	
	function publishSharespace(projectId) {
	  return {
	    types: loadReducer.constantsByKey.publishSharespace,
	    promise: function promise(client) {
	      return client.post('project_wa/publishSharespace', { data: { projectId: projectId } });
	    },
	    projectId: projectId
	  };
	}
	
	function stopPublish(projectId) {
	  return {
	    types: loadReducer.constantsByKey.stopPublish,
	    promise: function promise(client) {
	      return client.post('project_wa/stopPublish', { data: { projectId: projectId } });
	    },
	    projectId: projectId
	  };
	}
	
	function submitMediaFile(fileId) {
	  return {
	    type: SUBMIT_MEDIA_FILE,
	    fileId: fileId
	  };
	}
	
	function submitCloudFile(file) {
	  return {
	    type: SUBMIT_CLOUD_FILE,
	    file: file
	  };
	}
	
	function deleteMediaFile(fileId) {
	  return {
	    type: DELETE_MEDIA_FILE,
	    fileId: fileId
	  };
	}
	
	function submitMediaReplaceFile(fileId) {
	  return {
	    type: SUBMIT_MEDIA_REPLACE_FILE,
	    fileId: fileId
	  };
	}
	
	function submitPressFile(fileId) {
	  return {
	    type: SUBMIT_PRESS_FILE,
	    fileId: fileId
	  };
	}
	
	function deletePressFile(fileId) {
	  return {
	    type: DELETE_PRESS_FILE,
	    fileId: fileId
	  };
	}
	
	function toggleEmailWysiwyg() {
	  return {
	    type: TOGGLE_EMAIL_WYSIWYG
	  };
	}
	
	function saveEmail(projectId, data) {
	  return (0, _extends6.default)({
	    types: loadReducer.constantsByKey.saveEmail,
	    promise: function promise(client) {
	      return client.post('project_wa/editEmailTemplate', { data: (0, _extends6.default)({ projectId: projectId }, data) });
	    },
	    projectId: projectId
	  }, data);
	}
	
	function loadRecipientsList(projectId) {
	  return {
	    types: loadReducer.constantsByKey.recipientsList,
	    promise: function promise(client) {
	      return client.post('project_wa/getRecipientList', { data: { projectId: projectId } });
	    },
	    projectId: projectId
	  };
	}
	
	function copyProject(projectId) {
	  return {
	    types: loadReducer.constantsByKey.copyProject,
	    promise: function promise(client) {
	      return client.post('project_wa/copyProject', { data: { projectId: projectId } });
	    },
	    projectId: projectId
	  };
	}
	
	function loadCommon() {
	  return {
	    types: loadReducer.constantsByKey.common,
	    promise: function promise(client) {
	      return client.post('project_wa/getCommonData');
	    }
	  };
	}
	
	function loadMediaList(projectId) {
	  return {
	    types: loadReducer.constantsByKey.mediaList,
	    promise: function promise(client) {
	      return client.post('project_wa/getAudioList', { data: { projectId: projectId } });
	    },
	    projectId: projectId
	  };
	}
	
	function loadPressList(projectId) {
	  return {
	    types: loadReducer.constantsByKey.pressList,
	    promise: function promise(client) {
	      return client.post('project_wa/getPressList', { data: { projectId: projectId } });
	    },
	    projectId: projectId
	  };
	}
	
	function deleteMedia(projectId, uploadId, uploaderId) {
	  return {
	    types: loadReducer.constantsByKey.deleteMedia,
	    promise: function promise(client) {
	      return client.post('project_wa/deleteMedia', { data: { projectId: projectId, uploadId: uploadId } });
	    },
	    projectId: projectId,
	    uploadId: uploadId,
	    uploaderId: uploaderId
	  };
	}
	
	function deleteCloudFile(projectId, uploadId) {
	  return {
	    types: loadReducer.constantsByKey.deleteCloudFile,
	    promise: function promise(client) {
	      return client.post('project_wa/deleteMedia', { data: { projectId: projectId, uploadId: uploadId } });
	    },
	    projectId: projectId,
	    uploadId: uploadId
	  };
	}
	
	function deletePress(projectId, pressId) {
	  return {
	    types: loadReducer.constantsByKey.deletePress,
	    promise: function promise(client) {
	      return client.post('project_wa/deletePress', { data: { projectId: projectId, pressId: pressId } });
	    },
	    projectId: projectId,
	    pressId: pressId
	  };
	}
	
	function editMedia(projectId, uploadId, data) {
	  return {
	    types: loadReducer.constantsByKey.editMedia,
	    promise: function promise(client) {
	      return client.post('project_wa/editMedia', { data: (0, _extends6.default)({ projectId: projectId, uploadId: uploadId }, data) });
	    },
	    projectId: projectId,
	    uploadId: uploadId
	  };
	}
	
	function addMedia(media, projectId) {
	  return {
	    type: ADD_MEDIA,
	    media: media,
	    projectId: projectId
	  };
	}
	
	function addFailedMedia(media, projectId) {
	  return {
	    type: ADD_FAILED_MEDIA,
	    media: media,
	    projectId: projectId
	  };
	}
	
	function addPress(press, projectId) {
	  return {
	    type: ADD_PRESS,
	    press: press,
	    projectId: projectId
	  };
	}
	
	function replaceMedia(media, projectId, oldMediaId) {
	  return {
	    type: REPLACE_MEDIA,
	    media: media,
	    projectId: projectId,
	    oldMediaId: oldMediaId
	  };
	}
	
	function addRecipient(projectId, data) {
	  return (0, _extends6.default)({
	    types: loadReducer.constantsByKey.addRecipient,
	    promise: function promise(client) {
	      return client.post('project_wa/addRecipientFromEmail', { data: (0, _extends6.default)({ projectId: projectId }, data), successCodes: [201] });
	    }
	  }, data, {
	    projectId: projectId
	  });
	}
	
	function addRecipients(projectId, recipients) {
	  return {
	    type: ADD_RECIPIENTS,
	    projectId: projectId,
	    recipients: recipients
	  };
	}
	
	function deleteRecipient(projectId, recipientId) {
	  return {
	    types: loadReducer.constantsByKey.deleteRecipient,
	    promise: function promise(client) {
	      return client.post('project_wa/deleteRecipient', { data: { projectId: projectId, recipientId: recipientId } });
	    },
	    projectId: projectId,
	    recipientId: recipientId
	  };
	}
	
	function deleteRecipientsGroup(projectId, groupId) {
	  return {
	    types: loadReducer.constantsByKey.deleteRecipientsGroup,
	    promise: function promise(client) {
	      return client.post('project_wa/deleteRecipientsOfGroup', { data: { projectId: projectId, groupId: groupId } });
	    },
	    projectId: projectId,
	    groupId: groupId
	  };
	}
	
	function clearRecipientsList() {
	  return {
	    type: CLEAR_RECIPIENTS_LIST
	  };
	}
	
	function editProjectLinks(projectId, data) {
	  return (0, _extends6.default)({
	    types: loadReducer.constantsByKey.editLinks,
	    promise: function promise(client) {
	      return client.post('project_wa/updateLinks', { data: (0, _extends6.default)({ projectId: projectId }, data) });
	    },
	    projectId: projectId
	  }, data);
	}
	
	function deleteCover(projectId) {
	  return {
	    types: loadReducer.constantsByKey.deleteCover,
	    promise: function promise(client) {
	      return client.post('project_wa/deleteCover', { data: { projectId: projectId } });
	    },
	    projectId: projectId
	  };
	}
	
	function setCover(projectId, cover) {
	  return {
	    type: SET_COVER,
	    projectId: projectId,
	    cover: cover
	  };
	}
	
	function testEmail(projectId) {
	  return {
	    types: loadReducer.constantsByKey.testEmail,
	    promise: function promise(client) {
	      return client.post('project_wa/sendTestEmail', { data: { projectId: projectId } });
	    },
	    projectId: projectId
	  };
	}
	
	function sendEmail(projectId, sendType) {
	  return {
	    types: loadReducer.constantsByKey.sendEmail,
	    promise: function promise(client) {
	      return client.post('project_wa/setSendType', { data: { projectId: projectId, sendType: sendType } });
	    },
	    projectId: projectId,
	    sendType: sendType
	  };
	}
	
	function loadConfirmation(projectId) {
	  return {
	    types: loadReducer.constantsByKey.confirmation,
	    promise: function promise(client) {
	      return client.post('project_wa/getConfirmation', { data: { projectId: projectId } });
	    },
	    projectId: projectId
	  };
	}
	
	function loadStatusInfo(projectId) {
	  return {
	    types: loadReducer.constantsByKey.statusInfo,
	    promise: function promise(client) {
	      return client.post('project_wa/getProjectStatusInfo', { data: { projectId: projectId } });
	    },
	    projectId: projectId
	  };
	}
	
	function updateCoverStyle(projectId, coverStyle) {
	  return {
	    types: loadReducer.constantsByKey.updateCoverStyle,
	    promise: function promise(client) {
	      return client.post('project_wa/updateCoverStyle', { data: { projectId: projectId, coverStyle: coverStyle } });
	    },
	    projectId: projectId,
	    coverStyle: coverStyle
	  };
	}
	
	function addRecipientsFromContacts(projectId, contacts) {
	  return {
	    types: loadReducer.constantsByKey.addRecipientsFromContacts,
	    promise: function promise(client) {
	      return client.post('project_wa/addRecipientFromContacts', { data: { projectId: projectId, contacts: '[' + contacts.toString() + ']' } });
	    },
	    projectId: projectId,
	    contacts: contacts
	  };
	}
	
	function addRecipientsFromGroups(projectId, groups) {
	  return {
	    types: loadReducer.constantsByKey.addRecipientsFromGroups,
	    promise: function promise(client) {
	      return client.post('project_wa/addRecipientFromGroups', { data: { projectId: projectId, groups: '[' + groups.toString() + ']' } });
	    },
	    projectId: projectId,
	    groups: groups
	  };
	}
	
	function setMultipleBoxsets(projectId, multipleBoxsets) {
	  return {
	    types: loadReducer.constantsByKey.setMultipleBoxsets,
	    promise: function promise(client) {
	      return client.post('project_wa/updateMultipleBoxset', { data: { projectId: projectId, multipleBoxsets: multipleBoxsets } });
	    },
	    projectId: projectId,
	    multipleBoxsets: multipleBoxsets
	  };
	}
	
	function editRecipient(projectId, recipientId, data) {
	  return (0, _extends6.default)({
	    types: [EDIT_RECIPIENT, EDIT_RECIPIENT_SUCCESS, EDIT_RECIPIENT_FAIL],
	    promise: function promise(client) {
	      return client.post('project_wa/editRecipient', { data: (0, _extends6.default)({ projectId: projectId, recipientId: recipientId }, data) });
	    },
	    projectId: projectId,
	    recipientId: recipientId
	  }, data);
	}
	
	function loadTeamMembers(projectId) {
	  return {
	    types: loadReducer.constantsByKey.teamMembersList,
	    promise: function promise(client) {
	      return client.post('project_wa/listSharees', { data: { projectId: projectId } });
	    },
	    projectId: Number(projectId)
	  };
	}
	
	function editTeamMember(projectId, shareeId, data) {
	  return (0, _extends6.default)({
	    types: loadReducer.constantsByKey.editTeamMember,
	    promise: function promise(client) {
	      return client.post('project_wa/editShareeMode', { data: (0, _extends6.default)({ projectId: projectId, shareeId: shareeId }, data) });
	    },
	    projectId: projectId,
	    shareeId: shareeId
	  }, data);
	}
	
	function deleteTeamMember(projectId, shareeId) {
	  return {
	    types: loadReducer.constantsByKey.deleteTeamMember,
	    promise: function promise(client) {
	      return client.post('project_wa/deleteSharee', { data: { projectId: projectId, shareeId: shareeId } });
	    },
	    projectId: projectId,
	    shareeId: shareeId
	  };
	}
	
	function loadUsersList(kw) {
	  return {
	    types: loadReducer.constantsByKey.usersList,
	    promise: function promise(client) {
	      return client.post('project_wa/getUsersList', { data: { kw: kw } });
	    },
	    kw: kw
	  };
	}
	
	function addTeamMember(projectId, userId) {
	  return {
	    types: loadReducer.constantsByKey.addTeamMember,
	    promise: function promise(client) {
	      return client.post('project_wa/addSharee', { data: { projectId: projectId, userId: userId } });
	    },
	    projectId: projectId,
	    userId: userId
	  };
	}
	
	function loadSSProjects(projectId) {
	  return {
	    types: loadReducer.constantsByKey.ssProjectsList,
	    promise: function promise(client) {
	      return client.post('project_wa/listSharespaceProjects', { data: { projectId: projectId } });
	    },
	    projectId: projectId
	  };
	}
	
	function deleteSSProject(projectId) {
	  return {
	    types: loadReducer.constantsByKey.deleteSSProject,
	    promise: function promise(client) {
	      return client.post('project_wa/deleteProject', { data: { projectId: projectId } });
	    },
	    projectId: projectId
	  };
	}
	
	function canSuspendSharespace(projectId) {
	  return {
	    types: loadReducer.constantsByKey.canSuspendSharespace,
	    promise: function promise(client) {
	      return client.post('project_wa/canSuspendSharespace', { data: { projectId: projectId } });
	    },
	    projectId: projectId
	  };
	}
	
	function canPublishSharespace(projectId) {
	  return {
	    types: loadReducer.constantsByKey.canPublishSharespace,
	    promise: function promise(client) {
	      return client.post('project_wa/canPublishSharespace', { data: { projectId: projectId } });
	    },
	    projectId: projectId
	  };
	}
	
	function suspendSharespace(projectId) {
	  return {
	    types: loadReducer.constantsByKey.suspendSharespace,
	    promise: function promise(client) {
	      return client.post('project_wa/suspendSharespace', { data: { projectId: projectId } });
	    },
	    projectId: projectId
	  };
	}
	
	function createSubproject(_ref) {
	  var projectId = _ref.projectId,
	      data = _ref.data,
	      tracks = _ref.tracks,
	      press = _ref.press;
	
	  var postData = (0, _extends6.default)({
	    projectId: projectId,
	    music: '[' + tracks.toString() + ']',
	    listPress: '[' + press.toString() + ']'
	  }, data);
	  return (0, _extends6.default)({
	    types: loadReducer.constantsByKey.createSubproject,
	    promise: function promise(client) {
	      return client.post('project_wa/createSubproject', { data: postData });
	    }
	  }, postData);
	}
	
	function updateMediaOrder(projectId, ids) {
	  return {
	    types: loadReducer.constantsByKey.updateMediaOrder,
	    promise: function promise(client) {
	      return client.post('FileUpload_wa/reOrderUploads', { data: { projectId: projectId, uploadIds: '[' + ids.toString() + ']' } });
	    },
	    projectId: projectId,
	    ids: ids
	  };
	}
	
	function ssCreate() {
	  return {
	    types: loadReducer.constantsByKey.ssCreate,
	    promise: function promise(client) {
	      return client.post('project_wa/createSharespace');
	    }
	  };
	}
	
	function projectCreate() {
	  return {
	    types: loadReducer.constantsByKey.projectCreate,
	    promise: function promise(client) {
	      return client.post('project_wa/createMinimalProject');
	    }
	  };
	}
	
	function addSender(_ref2) {
	  var projectId = _ref2.projectId,
	      email = _ref2.email,
	      name = _ref2.name,
	      surname = _ref2.surname;
	
	  var data = { email: email, name: name, surname: surname, projectId: projectId };
	  return {
	    types: loadReducer.constantsByKey.addSender,
	    promise: function promise(client) {
	      return client.post('project_wa/addSenderToProject', { data: data });
	    }
	  };
	}
	
	function deleteSender(_ref3) {
	  var projectId = _ref3.projectId;
	
	  var data = { projectId: projectId };
	  return {
	    types: loadReducer.constantsByKey.deleteSender,
	    promise: function promise(client) {
	      return client.post('project_wa/deleteSenderFromProject', { data: data });
	    }
	  };
	}
	
	function setRecipientsDownload(_ref4) {
	  var projectId = _ref4.projectId,
	      download = _ref4.download;
	
	  var data = { projectId: projectId, download: Number(download) };
	  return {
	    types: loadReducer.constantsByKey.setRecipientsDownload,
	    promise: function promise(client) {
	      return client.post('project_wa/setAllRecipientsDownload', { data: data });
	    },
	    projectId: projectId,
	    download: download
	  };
	}
	
	function resortMediaList(dragIndex, hoverIndex) {
	  return {
	    type: RESORT_MEDIA_LIST,
	    dragIndex: dragIndex,
	    hoverIndex: hoverIndex
	  };
	}
	
	function setCloudFileStatus(_ref5) {
	  var uniqId = _ref5.uniqId,
	      status = _ref5.status;
	
	  return {
	    type: SET_CLOUD_FILE_DATA,
	    uniqId: uniqId,
	    data: { status: status }
	  };
	}
	
	function setCloudFileFailedStatus(uniqId) {
	  return {
	    type: SET_CLOUD_FILE_DATA,
	    uniqId: uniqId,
	    data: { status: 'failed' }
	  };
	}
	
	function setCloudFileSuccessStatus(uniqId) {
	  return {
	    type: SET_CLOUD_FILE_DATA,
	    uniqId: uniqId,
	    data: { status: 'success' }
	  };
	}
	
	function setCloudFileMetadata(_ref6) {
	  var uniqId = _ref6.uniqId,
	      metadata = _ref6.metadata;
	
	  return {
	    type: SET_CLOUD_FILE_DATA,
	    uniqId: uniqId,
	    data: { metadata: metadata }
	  };
	}

/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _assign = __webpack_require__(186);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* Config for project. Use `app` to configure the app */
	
	__webpack_require__(537);
	
	var environment = {
	  development: {
	    isProduction: false
	  },
	  production: {
	    isProduction: true
	  }
	}[("production") || 'development'];
	
	module.exports = (0, _assign2.default)({
	  host: ({"NODE_ENV":"production"}).HOST || 'localhost',
	  port: ({"NODE_ENV":"production"}).PORT,
	  devApiHost: ({"NODE_ENV":"production"}).DEVAPIHOST || 'localhost',
	  devApiPort: ({"NODE_ENV":"production"}).DEVAPIPORT || 8081,
	  apiHost: ({"NODE_ENV":"production"}).APIHOST || 'cright.com',
	  apiPort: ({"NODE_ENV":"production"}).APIPORT || 443,
	  apiProtocol: ({"NODE_ENV":"production"}).APIPROTOCOL || 'https',
	  apiRoot: '/webapi/api',
	  useApiProxy: true,
	  response: {
	    dataField: 'data',
	    statusField: 'code',
	    messageField: 'msg'
	  },
	  app: {
	    title: 'CRight Web App',
	    description: 'CRight Web App.',
	    head: {
	      titleTemplate: 'CRight Web App: %s',
	      meta: [{ name: 'description', content: 'CRight Web App.' }, { charset: 'utf-8' }, { property: 'og:site_name', content: 'CRight' }, { property: 'og:locale', content: 'en_US' }, { property: 'og:title', content: 'CRight' }, { property: 'og:description', content: 'CRight Web App.' }, { property: 'og:card', content: 'summary' }, { property: 'og:site', content: '@citronium' }, { property: 'og:creator', content: '@citronium' }, { property: 'og:image:width', content: '200' }, { property: 'og:image:height', content: '200' }]
	    },
	    mainColor: '#0f73ed',
	    urlParts: {
	      thumb: 'https://111-eu-cright-images-depot.s3.amazonaws.com/thumb_',
	      press: 'https://www.cright.com/webapi/fileExchange/',
	      audio: 'https://cright.com/cright/bo/files/zipwav/',
	      audioArchive: 'https://cright.com/cright/bo/files/bizip/',
	      label: 'https://cright.com/cright/Content/logo/',
	      download: 'https://cright.com/cright/loginViewerwip/dwnsa/',
	      report: 'https://cright.com/webapi/fileExchange/'
	    },
	    srcMasks: {
	      audio: 'https://111-eu-cright-audiostream.s3.amazonaws.com/<trackName>.mp3',
	      video: 'http://wsvideo.cright.com/<trackName>.mp4'
	    },
	    langs: [{ code: 'en', name: 'English', abbr: 'ENG' }, { code: 'fr', name: 'Français', abbr: 'FR' }, { code: 'de', name: 'Deutsch', abbr: 'DE' }, { code: 'es', name: 'Español', abbr: 'ESP' }, { code: 'it', name: 'Italiano', abbr: 'IT' }, { code: 'pt', name: 'Portugues', abbr: 'PT' }, { code: 'ja', name: '日本語', abbr: 'JAP' }, { code: 'zh-CN', name: '中國', abbr: 'CN' }],
	    uploaderSupportedFormats: {
	      audio: ['mp3', 'aiff', 'wav', 'm4a', 'ogg'],
	      video: ['mp4', 'wmv', 'mov', 'avi'],
	      press: ['pdf', 'zip', 'jpg', 'png', 'tiff', 'xls', 'doc', 'docx'],
	      cover: ['jpg', 'jpeg', 'png', 'bmp']
	    },
	    audioPrecacheBeforeTime: 10, // seconds to song end, when the next track caching is starting
	    storeUrls: {
	      ios: 'https://itunes.apple.com/ru/app/cright/id905744164',
	      android: 'https://play.google.com/store/apps/details?id=com.cright.mobile'
	    },
	    dropbox: {
	      appKey: 'cgvkohm0zfq09au',
	      fileFields: { link: 'link', name: 'name' },
	      serviceName: 'dropbox'
	    },
	    boxcom: {
	      clientId: '6e6bqhb028n581povng5bsum2dkbkwvp',
	      fileFields: { link: 'url', name: 'name' },
	      serviceName: 'boxcom'
	    },
	    defaultUserRoute: '/playlists/all',
	    defaultRedirectRoute: '/',
	    ga: {
	      devKey: 'UA-91317123-1'
	    },
	    googleMaps: {
	      apiKey: 'AIzaSyDqgEcCRYfJ0vuDD8rnMCIwdc_Rvw9W84o'
	    },
	    productionUrl: 'https://web.cright.com'
	  }
	}, environment);

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(21);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _components = __webpack_require__(15);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(Button, _Component);
	
	  function Button() {
	    (0, _classCallCheck3.default)(this, Button);
	    return (0, _possibleConstructorReturn3.default)(this, (Button.__proto__ || (0, _getPrototypeOf2.default)(Button)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Button, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          loading = _props.loading,
	          className = _props.className,
	          children = _props.children,
	          disabled = _props.disabled,
	          type = _props.type,
	          small = _props.small,
	          rest = (0, _objectWithoutProperties3.default)(_props, ['loading', 'className', 'children', 'disabled', 'type', 'small']);
	
	
	      return _react2.default.createElement(
	        'button',
	        (0, _extends3.default)({}, rest, { type: type, className: (0, _classnames2.default)('btn pos-rel', className), disabled: loading || disabled }),
	        children,
	        loading && _react2.default.createElement(_components.Loader, { mask: true, small: small })
	      );
	    }
	  }]);
	  return Button;
	}(_react.Component), _class.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  className: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  loading: _propTypes2.default.bool,
	  small: _propTypes2.default.bool,
	  type: _propTypes2.default.string
	}, _class.defaultProps = {
	  type: 'button'
	}, _temp);
	exports.default = Button;
	module.exports = exports['default'];

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = asyncPromise;
	function asyncPromise(promise) {
	  return  true ? null : promise;
	}
	module.exports = exports["default"];

/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(20);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18nUniversal = function () {
	  function I18nUniversal() {
	    (0, _classCallCheck3.default)(this, I18nUniversal);
	
	    if (true) {
	      var i18n = __webpack_require__(2229);
	      i18n.changeLanguage(window.__i18n.locale);
	      i18n.addResourceBundle('en', 'common', window.__i18n.resources.en, true);
	      i18n.addResourceBundle(window.__i18n.locale, 'common', window.__i18n.resources[window.__i18n.locale], true);
	      _moment2.default.locale(window.__i18n.locale);
	      this.i18n = i18n;
	      this.locale = window.__i18n.locale;
	    } else {
	      this.i18n = require('./i18n-server');
	      this.setLocale('en');
	    }
	    return this;
	  }
	
	  (0, _createClass3.default)(I18nUniversal, [{
	    key: 'setI18n',
	    value: function setI18n(i18n) {
	      this.i18n = i18n;
	      return this;
	    }
	  }, {
	    key: 'getI18n',
	    value: function getI18n() {
	      return this.i18n;
	    }
	  }, {
	    key: 'setLocale',
	    value: function setLocale(locale) {
	      this.locale = locale;
	      _moment2.default.locale(locale);
	      this.i18n.changeLanguage(locale);
	      return this;
	    }
	  }, {
	    key: 'getLocale',
	    value: function getLocale() {
	      return this.locale;
	    }
	  }, {
	    key: 'getT',
	    value: function getT() {
	      return this.i18n.getFixedT();
	    }
	  }]);
	  return I18nUniversal;
	}();
	
	exports.default = new I18nUniversal();
	module.exports = exports['default'];

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get2 = __webpack_require__(19);
	
	var _get3 = _interopRequireDefault(_get2);
	
	exports.loadProjectStatsViewers = loadProjectStatsViewers;
	exports.addStatsViewer = addStatsViewer;
	exports.deleteStatsViewer = deleteStatsViewer;
	exports.loadActivityStats = loadActivityStats;
	exports.loadPlayStats = loadPlayStats;
	exports.loadPopularityStats = loadPopularityStats;
	exports.loadCoverageStats = loadCoverageStats;
	exports.loadGeographyStats = loadGeographyStats;
	exports.loadDevicesStats = loadDevicesStats;
	exports.loadRecipientDetailedStats = loadRecipientDetailedStats;
	exports.loadRecipientOverallStats = loadRecipientOverallStats;
	exports.loadTracksDetailsStats = loadTracksDetailsStats;
	exports.isAvailableProjectsLoadTime = isAvailableProjectsLoadTime;
	exports.loadAvailableProjects = loadAvailableProjects;
	exports.isMyProjectsLoadTime = isMyProjectsLoadTime;
	exports.loadMyProjects = loadMyProjects;
	exports.projectsReorder = projectsReorder;
	exports.recipientsReorder = recipientsReorder;
	exports.recipientProjectsReorder = recipientProjectsReorder;
	exports.coverageRecipientsReorder = coverageRecipientsReorder;
	exports.filterProjects = filterProjects;
	exports.filterRecipients = filterRecipients;
	exports.setProjectsTab = setProjectsTab;
	exports.setPeriodName = setPeriodName;
	exports.setReportDates = setReportDates;
	exports.setPeriod = setPeriod;
	exports.setProjectId = setProjectId;
	exports.setRecipientId = setRecipientId;
	exports.isProjectInfoLoadTime = isProjectInfoLoadTime;
	exports.loadProjectInfo = loadProjectInfo;
	exports.isRecipientsLoadTime = isRecipientsLoadTime;
	exports.loadRecipients = loadRecipients;
	exports.getLink = getLink;
	exports.sendReminders = sendReminders;
	exports.setProjectsListPage = setProjectsListPage;
	
	var _loadReducer = __webpack_require__(69);
	
	var _loadReducer2 = _interopRequireDefault(_loadReducer);
	
	var _StatisticsReducer = __webpack_require__(2240);
	
	var _StatisticsReducer2 = _interopRequireDefault(_StatisticsReducer);
	
	var _statistics = __webpack_require__(2231);
	
	var _statistics2 = _interopRequireDefault(_statistics);
	
	var _statistics3 = __webpack_require__(67);
	
	var _loadReducer3 = __webpack_require__(69);
	
	var _ApiClient = __webpack_require__(866);
	
	var _projects = __webpack_require__(28);
	
	var _datetime = __webpack_require__(68);
	
	var _moment = __webpack_require__(20);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestCacheTime = 10 * 60 * 1000; // msec
	
	/* Statistics redux reducer and action creators */
	
	var loadReducer = (0, _loadReducer2.default)(_statistics.moduleName, {
	  statsViewers: {},
	  availableProjects: { action: 'load', init: [] },
	  myProjects: {
	    action: 'load',
	    init: { newsletters: [], sharespace: [], audio: [], video: [] },
	    fields: {
	      newsletters: 'listNewsletters',
	      sharespace: 'listOfMasterProject',
	      audio: 'listOfAudioProjects',
	      video: 'listOfVideoProjects'
	    }
	  },
	  addStatsViewer: {},
	  deleteStatsViewer: { loaderKeys: ['projectId', 'email'] },
	  activityStats: { action: 'load' },
	  playStats: { action: 'load' },
	  popularityStats: { action: 'load' },
	  coverageStats: { action: 'load' },
	  geographyStats: { action: 'load' },
	  devicesStats: { action: 'load' },
	  recipientDetailedStats: { action: 'load' },
	  recipientOverallStats: { action: 'load' },
	  tracksDetailsStats: { action: 'load' },
	  projectInfo: { action: 'load' },
	  recipients: { action: 'load', field: 'usersList' },
	  getLink: { loaderKeys: ['projectId'] }, //TODO: change
	  sendReminders: {}
	});
	
	var initialState = (0, _extends3.default)({}, loadReducer.initialState, {
	  projectsOrder: {
	    id: 'desc',
	    fullTitle: 'asc',
	    owName: 'asc',
	    statusText: 'asc',
	    iRef: 'asc'
	  },
	  projectsActiveOrder: 'id',
	  recipientsOrder: {
	    id: 'desc',
	    fullName: 'asc',
	    email: 'asc'
	  },
	  recipientsActiveOrder: 'email',
	  coverageRecipientsOrder: {
	    recipientId: 'desc',
	    fullName: 'asc',
	    email: 'asc',
	    downloaded: 'asc',
	    recepEd: 'asc'
	  },
	  coverageRecipientsActiveOrder: 'fullName',
	  recipientProjectsOrder: {
	    id: 'desc',
	    fullTitle: 'asc',
	    played: 'asc',
	    downloaded: 'asc',
	    expiryDate: 'asc'
	  },
	  recipientProjectsActiveOrder: 'id',
	  projectsKw: '',
	  recipientsKw: '',
	  periodName: null,
	  myProjectsListPage: 1
	});
	
	exports.default = new _StatisticsReducer2.default({
	  apiConstants: loadReducer.constants,
	  mainReducer: loadReducer.reducer,
	  constants: _statistics2.default,
	  initialState: initialState
	}).reducer;
	var constantsByKey = loadReducer.constantsByKey;
	function loadProjectStatsViewers(_ref) {
	  var projectId = _ref.projectId;
	
	  var data = { projectId: projectId };
	  return (0, _extends3.default)({
	    types: constantsByKey.statsViewers,
	    promise: function promise(client) {
	      return client.post('stats_wa/getStatsViewersForProject', { data: data });
	    }
	  }, data);
	}
	
	function addStatsViewer(_ref2) {
	  var projectId = _ref2.projectId,
	      email = _ref2.email,
	      name = _ref2.name,
	      surname = _ref2.surname;
	
	  var data = { email: email, name: name, surname: surname, projectId: projectId };
	  return (0, _extends3.default)({
	    types: constantsByKey.addStatsViewer,
	    promise: function promise(client) {
	      return client.post('stats_wa/addUserToProjectStats', { data: data });
	    }
	  }, data);
	}
	
	function deleteStatsViewer(_ref3) {
	  var projectId = _ref3.projectId,
	      email = _ref3.email;
	
	  var data = { projectId: projectId, email: email };
	  return (0, _extends3.default)({
	    types: constantsByKey.deleteStatsViewer,
	    promise: function promise(client) {
	      return client.post('stats_wa/removeUserFromProjectStats', { data: data });
	    }
	  }, data);
	}
	
	function getReportDates(_ref4) {
	  var startDate = _ref4.startDate,
	      endDate = _ref4.endDate,
	      _ref4$isUnix = _ref4.isUnix,
	      isUnix = _ref4$isUnix === undefined ? false : _ref4$isUnix;
	
	  return function (dispatch, getState) {
	    var sqlStartDate = startDate || getState().statistics.startDate;
	    var sqlEndDate = endDate || getState().statistics.endDate;
	    return {
	      startDate: isUnix ? (0, _datetime.formatDateToUnix)(sqlStartDate) : sqlStartDate,
	      endDate: isUnix ? (0, _datetime.formatDateToUnix)(sqlEndDate) : sqlEndDate
	    };
	  };
	}
	
	function loadActivityStats(_ref5) {
	  var projectId = _ref5.projectId,
	      startDate = _ref5.startDate,
	      endDate = _ref5.endDate;
	
	  return function (dispatch) {
	    var data = (0, _extends3.default)({ projectId: projectId }, dispatch(getReportDates({ startDate: startDate, endDate: endDate })));
	    return dispatch({
	      types: constantsByKey.activityStats,
	      promise: function promise(client) {
	        return client.post('stats_wa/getActivity', { data: data });
	      },
	      projectId: projectId,
	      startDate: startDate,
	      endDate: endDate,
	      abortable: true
	    });
	  };
	}
	
	function loadPlayStats(_ref6) {
	  var projectId = _ref6.projectId,
	      startDate = _ref6.startDate,
	      endDate = _ref6.endDate;
	
	  return function (dispatch) {
	    var data = (0, _extends3.default)({ projectId: projectId }, dispatch(getReportDates({ startDate: startDate, endDate: endDate })));
	    return dispatch({
	      types: constantsByKey.playStats,
	      promise: function promise(client) {
	        return client.post('stats_wa/getPlayStats', { data: data });
	      },
	      projectId: projectId,
	      startDate: startDate,
	      endDate: endDate,
	      abortable: true
	    });
	  };
	}
	
	function loadPopularityStats(_ref7) {
	  var projectId = _ref7.projectId,
	      recipientId = _ref7.recipientId,
	      startDate = _ref7.startDate,
	      endDate = _ref7.endDate;
	
	  return function (dispatch) {
	    var data = (0, _extends3.default)({ projectId: projectId, recipientId: recipientId }, dispatch(getReportDates({ startDate: startDate, endDate: endDate })));
	    return dispatch({
	      types: constantsByKey.popularityStats,
	      promise: function promise(client) {
	        return client.post('stats_wa/getPopularity', { data: data });
	      },
	      projectId: projectId,
	      recipientId: recipientId,
	      startDate: startDate,
	      endDate: endDate,
	      abortable: true
	    });
	  };
	}
	
	function loadCoverageStats(_ref8) {
	  var projectId = _ref8.projectId,
	      startDate = _ref8.startDate,
	      endDate = _ref8.endDate;
	
	  return function (dispatch) {
	    var data = (0, _extends3.default)({ projectId: projectId }, dispatch(getReportDates({ startDate: startDate, endDate: endDate })));
	    return dispatch({
	      types: constantsByKey.coverageStats,
	      promise: function promise(client) {
	        return client.post('stats_wa/getCoverage', { data: data });
	      },
	      projectId: projectId,
	      startDate: startDate,
	      endDate: endDate,
	      abortable: true
	    });
	  };
	}
	
	function loadGeographyStats(_ref9) {
	  var projectId = _ref9.projectId,
	      startDate = _ref9.startDate,
	      endDate = _ref9.endDate;
	
	  return function (dispatch) {
	    var data = (0, _extends3.default)({ projectId: projectId }, dispatch(getReportDates({ startDate: startDate, endDate: endDate })));
	    return dispatch({
	      types: constantsByKey.geographyStats,
	      promise: function promise(client) {
	        return client.post('stats_wa/getGeography', { data: data });
	      },
	      projectId: projectId,
	      startDate: startDate,
	      endDate: endDate,
	      abortable: true
	    });
	  };
	}
	
	function loadDevicesStats() {
	  var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      projectId = _ref10.projectId,
	      startDate = _ref10.startDate,
	      endDate = _ref10.endDate;
	
	  return function (dispatch) {
	    var data = (0, _extends3.default)({ projectId: projectId }, dispatch(getReportDates({ startDate: startDate, endDate: endDate })));
	    return dispatch({
	      types: constantsByKey.devicesStats,
	      promise: function promise(client) {
	        return client.post('stats_wa/getDevices', { data: data });
	      },
	      projectId: projectId,
	      startDate: startDate,
	      endDate: endDate,
	      abortable: true
	    });
	  };
	}
	
	function loadRecipientDetailedStats() {
	  var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      projectId = _ref11.projectId,
	      recipientId = _ref11.recipientId,
	      startDate = _ref11.startDate,
	      endDate = _ref11.endDate;
	
	  return function (dispatch) {
	    var data = (0, _extends3.default)({ projectId: projectId, recipientId: recipientId }, dispatch(getReportDates({ startDate: startDate, endDate: endDate })));
	    return dispatch({
	      types: constantsByKey.recipientDetailedStats,
	      promise: function promise(client) {
	        return client.post('stats_wa/getRecipientDetailedActivity', { data: data });
	      },
	      projectId: projectId,
	      startDate: startDate,
	      endDate: endDate,
	      abortable: true
	    });
	  };
	}
	
	function loadRecipientOverallStats() {
	  var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      userId = _ref12.userId,
	      startDate = _ref12.startDate,
	      endDate = _ref12.endDate;
	
	  return function (dispatch) {
	    var data = (0, _extends3.default)({ userId: userId }, dispatch(getReportDates({ startDate: startDate, endDate: endDate })));
	    return dispatch({
	      types: constantsByKey.recipientOverallStats,
	      promise: function promise(client) {
	        return client.post('stats_wa/getRecipientOverallActivity', { data: data });
	      },
	      userId: userId,
	      startDate: startDate,
	      endDate: endDate,
	      abortable: true
	    });
	  };
	}
	
	function loadTracksDetailsStats() {
	  var _ref13 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      projectId = _ref13.projectId,
	      recipientId = _ref13.recipientId,
	      startDate = _ref13.startDate,
	      endDate = _ref13.endDate;
	
	  return function (dispatch) {
	    var data = (0, _extends3.default)({ projectId: projectId, recipientId: recipientId }, dispatch(getReportDates({ startDate: startDate, endDate: endDate })));
	    return dispatch({
	      types: constantsByKey.tracksDetailsStats,
	      promise: function promise(client) {
	        return client.post('stats_wa/getTrackDetails', { data: data });
	      },
	      projectId: projectId,
	      startDate: startDate,
	      endDate: endDate,
	      abortable: true
	    });
	  };
	}
	
	function isAvailableProjectsLoadTime() {
	  var _ref14 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref14$useCache = _ref14.useCache,
	      useCache = _ref14$useCache === undefined ? true : _ref14$useCache,
	      _ref14$cacheTime = _ref14.cacheTime,
	      cacheTime = _ref14$cacheTime === undefined ? requestCacheTime : _ref14$cacheTime;
	
	  return function (dispatch, getState) {
	    return (0, _loadReducer3.isLoadTime)({ useCache: useCache, cacheTime: cacheTime, key: 'availableProjects', state: getState().statistics });
	  };
	}
	
	function loadAvailableProjects() {
	  var _ref15 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      useCache = _ref15.useCache,
	      cacheTime = _ref15.cacheTime;
	
	  return function (dispatch) {
	    var needLoad = dispatch(isAvailableProjectsLoadTime({ useCache: useCache, cacheTime: cacheTime }));
	    if (needLoad) {
	      return dispatch({
	        types: constantsByKey.availableProjects,
	        promise: function promise(client) {
	          return client.post('/Stats_wa/getMyStatsProjectList');
	        }
	      });
	    }
	    return _ApiClient.noopResponse;
	  };
	}
	
	function isMyProjectsLoadTime() {
	  var _ref16 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref16$useCache = _ref16.useCache,
	      useCache = _ref16$useCache === undefined ? true : _ref16$useCache,
	      _ref16$cacheTime = _ref16.cacheTime,
	      cacheTime = _ref16$cacheTime === undefined ? requestCacheTime : _ref16$cacheTime;
	
	  return function (dispatch, getState) {
	    return (0, _loadReducer3.isLoadTime)({ useCache: useCache, cacheTime: cacheTime, key: 'myProjects', state: getState().statistics });
	  };
	}
	
	function loadMyProjects() {
	  var _ref17 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      useCache = _ref17.useCache,
	      cacheTime = _ref17.cacheTime;
	
	  return function (dispatch) {
	    var needLoad = dispatch(isMyProjectsLoadTime({ useCache: useCache, cacheTime: cacheTime }));
	    if (needLoad) {
	      return dispatch({
	        types: constantsByKey.myProjects,
	        promise: function promise(client) {
	          var result = client.post('project_wa/getList');
	          result.promise.then(_projects.transformProjectsResponse);
	          return result;
	        }
	      });
	    }
	    return _ApiClient.noopResponse;
	  };
	}
	
	function projectsReorder(name) {
	  return {
	    type: _statistics2.default.PROJECTS_REORDER,
	    name: name
	  };
	}
	
	function recipientsReorder(name) {
	  return {
	    type: _statistics2.default.RECIPIENTS_REORDER,
	    name: name
	  };
	}
	
	function recipientProjectsReorder(name) {
	  return {
	    type: _statistics2.default.RECIPIENT_PROJECTS_REORDER,
	    name: name
	  };
	}
	
	function coverageRecipientsReorder(name) {
	  return {
	    type: _statistics2.default.COVERAGE_RECIPIENTS_REORDER,
	    name: name
	  };
	}
	
	function filterProjects() {
	  var kw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	  return {
	    type: _statistics2.default.PROJECTS_FILTER,
	    kw: kw
	  };
	}
	
	function filterRecipients() {
	  var kw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	  return {
	    type: _statistics2.default.RECIPIENTS_FILTER,
	    kw: kw
	  };
	}
	
	function setProjectsTab() {
	  var tab = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _statistics3.projectTabs.my;
	
	  return {
	    type: _statistics2.default.SET_PROJECTS_TAB,
	    tab: tab
	  };
	}
	
	function setPeriodName(_ref18) {
	  var periodName = _ref18.periodName;
	
	  return {
	    type: _statistics2.default.SET_PERIOD_NAME,
	    periodName: periodName
	  };
	}
	
	function setReportDates(_ref19) {
	  var startDate = _ref19.startDate,
	      endDate = _ref19.endDate;
	
	  return {
	    type: _statistics2.default.SET_REPORT_DATES,
	    startDate: startDate,
	    endDate: endDate
	  };
	}
	
	function setPeriod(_ref20) {
	  var periodName = _ref20.periodName,
	      _ref20$periodValue = _ref20.periodValue,
	      periodValue = _ref20$periodValue === undefined ? 1 : _ref20$periodValue;
	
	  return function (dispatch) {
	    var startDate = (0, _datetime.formatDateToSql)((0, _moment2.default)().subtract(periodValue, periodName));
	    var endDate = (0, _datetime.formatDateToSql)(Date.now());
	    dispatch(setReportDates({ startDate: startDate, endDate: endDate }));
	    dispatch(setPeriodName({ periodName: periodName }));
	  };
	}
	
	function setProjectId(_ref21) {
	  var projectId = _ref21.projectId;
	
	  return {
	    type: _statistics2.default.SET_PROJECT_ID,
	    projectId: projectId
	  };
	}
	
	function setRecipientId(_ref22) {
	  var recipientId = _ref22.recipientId;
	
	  return {
	    type: _statistics2.default.SET_RECIPIENT_ID,
	    recipientId: recipientId
	  };
	}
	
	function isProjectInfoLoadTime() {
	  var _ref23 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      projectId = _ref23.projectId,
	      _ref23$useCache = _ref23.useCache,
	      useCache = _ref23$useCache === undefined ? true : _ref23$useCache,
	      _ref23$cacheTime = _ref23.cacheTime,
	      cacheTime = _ref23$cacheTime === undefined ? requestCacheTime : _ref23$cacheTime;
	
	  return function (dispatch, getState) {
	    if (projectId !== (0, _get3.default)(getState().statistics, 'projectInfoData.projectId')) {
	      return true;
	    }
	    return (0, _loadReducer3.isLoadTime)({ useCache: useCache, cacheTime: cacheTime, key: 'projectInfo', state: getState().statistics });
	  };
	}
	
	function loadProjectInfo(_ref24) {
	  var projectId = _ref24.projectId;
	
	  return function (dispatch) {
	    var needLoad = dispatch(isProjectInfoLoadTime({ projectId: projectId, cacheTime: Infinity }));
	    if (needLoad) {
	      return dispatch({
	        types: constantsByKey.projectInfo,
	        promise: function promise(client) {
	          return client.post('stats_wa/getSimpleProject', { data: { projectId: projectId } });
	        },
	        projectId: Number(projectId)
	      });
	    }
	    return _ApiClient.noopResponse;
	  };
	}
	
	function isRecipientsLoadTime() {
	  var _ref25 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref25$useCache = _ref25.useCache,
	      useCache = _ref25$useCache === undefined ? true : _ref25$useCache,
	      _ref25$cacheTime = _ref25.cacheTime,
	      cacheTime = _ref25$cacheTime === undefined ? requestCacheTime : _ref25$cacheTime;
	
	  return function (dispatch, getState) {
	    return (0, _loadReducer3.isLoadTime)({ useCache: useCache, cacheTime: cacheTime, key: 'recipients', state: getState().statistics });
	  };
	}
	
	function loadRecipients() {
	  return function (dispatch) {
	    var needLoad = dispatch(isRecipientsLoadTime());
	    if (needLoad) {
	      return dispatch({
	        types: constantsByKey.recipients,
	        promise: function promise(client) {
	          return client.post('stats_wa/getProjectsRecipients');
	        }
	      });
	    }
	    return _ApiClient.noopResponse;
	  };
	}
	
	function getLink() {
	  var _ref26 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref26$projectId = _ref26.projectId,
	      projectId = _ref26$projectId === undefined ? 2286386 : _ref26$projectId;
	
	  //TODO: remove
	  var data = { projectId: projectId };
	  return {
	    types: constantsByKey.getLink,
	    promise: function promise(client) {
	      return client.post('/project_wa/downloadRecipientLinks', { data: data });
	    },
	    projectId: projectId,
	    abortable: true
	  };
	}
	
	function sendReminders(_ref27) {
	  var projectId = _ref27.projectId,
	      sendType = _ref27.sendType;
	
	  var data = { projectId: projectId, sendType: sendType };
	  return (0, _extends3.default)({
	    types: constantsByKey.sendReminders,
	    promise: function promise(client) {
	      return client.post('/stats_wa/sendReminders', { data: data });
	    }
	  }, data);
	}
	
	function setProjectsListPage(_ref28) {
	  var page = _ref28.page;
	
	  return {
	    type: _statistics2.default.SET_PROJECTS_LIST_PAGE,
	    page: page
	  };
	}

/***/ }),
/* 58 */,
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compact3 = __webpack_require__(447);
	
	var _compact4 = _interopRequireDefault(_compact3);
	
	exports.toUnderscore = toUnderscore;
	exports.toUpperUnderscore = toUpperUnderscore;
	exports.capitalize = capitalize;
	exports.concat = concat;
	exports.cleanString = cleanString;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toUnderscore(str) {
	  return str.replace(/([A-Z])/g, function ($1) {
	    return '_' + $1;
	  });
	}
	
	function toUpperUnderscore(str) {
	  return toUnderscore(str).toUpperCase();
	}
	
	function capitalize(str) {
	  return str.replace(/\b\w/g, function (matchStr) {
	    return matchStr.toUpperCase();
	  });
	}
	
	function concat(delim) {
	  for (var _len = arguments.length, strs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    strs[_key - 1] = arguments[_key];
	  }
	
	  return (0, _compact4.default)(strs).join(delim).trim();
	}
	
	function cleanString(str) {
	  return ('' + str).trim().toLowerCase();
	}

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1279);
	
	var cn = _bind2.default.bind(styles);
	
	var Loader = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(Loader, _PureComponent);
	
	  function Loader() {
	    (0, _classCallCheck3.default)(this, Loader);
	    return (0, _possibleConstructorReturn3.default)(this, (Loader.__proto__ || (0, _getPrototypeOf2.default)(Loader)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Loader, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          color = _props.color,
	          size = _props.size,
	          mask = _props.mask,
	          small = _props.small,
	          className = _props.className,
	          inline = _props.inline,
	          left = _props.left,
	          right = _props.right,
	          center = _props.center,
	          transparent = _props.transparent,
	          alignCenter = _props.alignCenter,
	          onClick = _props.onClick,
	          show = _props.show;
	
	      if (!show) {
	        return null;
	      }
	
	      var smallSize = 25;
	      var loaderClass = cn(className, 'loader', { colored: !color, inline: inline, left: left, right: right, center: center });
	
	      var loadIndicator = _react2.default.createElement(
	        'div',
	        { className: loaderClass, style: { width: (small ? smallSize : size) + 'px' }, onClick: onClick },
	        _react2.default.createElement(
	          'svg',
	          { className: styles.circular, viewBox: '25 25 50 50' },
	          _react2.default.createElement('circle', { className: styles.path, cx: '50', cy: '50', r: '20', stroke: color || null, fill: 'none' })
	        )
	      );
	
	      var indicator = mask ? _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(styles.mask, (0, _defineProperty3.default)({}, styles.transparent, transparent)) },
	        loadIndicator
	      ) : loadIndicator;
	
	      if (alignCenter) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          indicator
	        );
	      }
	
	      return indicator;
	    }
	  }]);
	  return Loader;
	}(_react.PureComponent), _class.propTypes = {
	  alignCenter: _propTypes2.default.bool,
	  center: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  color: _propTypes2.default.string,
	  inline: _propTypes2.default.bool,
	  left: _propTypes2.default.bool,
	  mask: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  right: _propTypes2.default.bool,
	  show: _propTypes2.default.bool, // TODO: refactor all loaders to use show prop
	  size: _propTypes2.default.number,
	  small: _propTypes2.default.bool,
	  transparent: _propTypes2.default.bool
	}, _class.defaultProps = {
	  onClick: _noop3.default,
	  show: true,
	  size: 40
	}, _temp);
	exports.default = Loader;
	module.exports = exports['default'];

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(34);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _map2 = __webpack_require__(241);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _reject2 = __webpack_require__(200);
	
	var _reject3 = _interopRequireDefault(_reject2);
	
	var _get2 = __webpack_require__(19);
	
	var _get3 = _interopRequireDefault(_get2);
	
	exports.default = reducer;
	exports.filter = filter;
	exports.loadContacts = loadContacts;
	exports.deleteContact = deleteContact;
	exports.addContact = addContact;
	exports.addContacts = addContacts;
	exports.loadGroups = loadGroups;
	exports.deleteGroup = deleteGroup;
	exports.addGroup = addGroup;
	exports.loadGroupContacts = loadGroupContacts;
	exports.removeContactFromGroup = removeContactFromGroup;
	exports.addAllContactsToGroup = addAllContactsToGroup;
	exports.removeAllContactsFromGroup = removeAllContactsFromGroup;
	exports.saveGroupContacts = saveGroupContacts;
	exports.moveContactToGroup = moveContactToGroup;
	exports.deleteGroupContact = deleteGroupContact;
	exports.deleteGroupContacts = deleteGroupContacts;
	exports.setContactsListLimit = setContactsListLimit;
	exports.loadSuggestionUsersList = loadSuggestionUsersList;
	exports.setGroupContactsPage = setGroupContactsPage;
	exports.filterGroupContacts = filterGroupContacts;
	exports.updateCheckedGroupContacts = updateCheckedGroupContacts;
	
	var _loadReducer = __webpack_require__(69);
	
	var _loadReducer2 = _interopRequireDefault(_loadReducer);
	
	var _utils = __webpack_require__(24);
	
	var _qim = __webpack_require__(110);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UPDATE = 'contacts/UPDATE'; /* Contacts and groups redux reducer and action creators */
	
	var FILTER = 'contacts/FILTER';
	var ADD_CONTACTS = 'contacts/ADD_CONTACTS';
	var UPDATE_GROUP = 'contacts/UPDATE_GROUP';
	var SET_CONTACTS_LIST_LIMIT = 'contacts/SET_CONTACTS_LIST_LIMIT';
	var SET_GROUP_CONTACTS_PAGE = 'contacts/SET_GROUP_CONTACTS_PAGE';
	var FILTER_GROUP_CONTACTS = 'contacts/FILTER_GROUP_CONTACTS';
	var UPDATE_CHECKED_GROUP_CONTACTS = 'contacts/UPDATE_CHECKED_GROUP_CONTACTS';
	
	var loadReducer = (0, _loadReducer2.default)('contacts', {
	  contactsList: { action: 'load', init: { contacts: [] }, keepOnLoad: true },
	  deleteContact: {},
	  groupsList: { action: 'load', init: [] },
	  deleteGroup: {},
	  addContact: {},
	  addGroup: {},
	  groupContactsList: { action: 'load', init: [] },
	  contactsWithoutGroup: { action: 'load', init: [] },
	  saveGroupContacts: { init: {} },
	  suggestionList: { action: 'load', init: { contacts: [] } }
	});
	
	var initialState = (0, _extends3.default)({}, loadReducer.initialState, {
	  contactsManageGroupData: [],
	  kw: '',
	  groupContactsKw: '',
	  contactsListLimit: 100,
	  contactsListPage: 1,
	  contactsListPaginateBy: [10, 30, 60, 100],
	  groupContactsPage: 1,
	  checkedGroupContacts: {}
	});
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case 'RESET':
	      return initialState;
	    case loadReducer.constants.SAVE_GROUP_CONTACTS_SUCCESS:
	      {
	        if (action.groupId === state.groupContactsListActionData.groupId) {
	          return (0, _extends3.default)({}, loadReducer.reducer(state, action), {
	            groupContactsListData: (0, _get3.default)(action, 'result.data', [])
	          });
	        }
	        return loadReducer.reducer(state, action);
	      }
	    case loadReducer.constants.LOAD_CONTACTS_LIST:
	      return (0, _extends3.default)({}, loadReducer.reducer(state, action), {
	        kw: action.kw,
	        contactsListPage: action.page
	      });
	    case loadReducer.constants.DELETE_CONTACT_SUCCESS:
	      return (0, _extends3.default)({}, loadReducer.reducer(state, action), {
	        contactsListData: (0, _extends3.default)({}, state.contactsListData, {
	          contacts: (0, _reject3.default)(state.contactsListData.contacts, { id: action.contactId })
	        })
	      });
	    case loadReducer.constants.DELETE_GROUP_SUCCESS:
	      return (0, _extends3.default)({}, loadReducer.reducer(state, action), {
	        groupsListData: (0, _reject3.default)(state.groupsListData, { id: action.groupId })
	      });
	    case loadReducer.constants.ADD_CONTACT_SUCCESS:
	      return (0, _extends3.default)({}, loadReducer.reducer(state, action), {
	        contactsListData: (0, _extends3.default)({}, state.contactsListData, {
	          contacts: [].concat((0, _toConsumableArray3.default)(state.contactsListData.contacts), [(0, _get3.default)(action, 'result.data')])
	        }),
	        groupContactsListData: action.groupId ? [].concat((0, _toConsumableArray3.default)(state.groupContactsListData), [(0, _get3.default)(action, 'result.data')]) : state.groupContactsListData
	      });
	    case loadReducer.constants.ADD_GROUP_SUCCESS:
	      return (0, _extends3.default)({}, loadReducer.reducer(state, action), {
	        groupsListData: [].concat((0, _toConsumableArray3.default)(state.groupsListData), [(0, _get3.default)(action, 'result.data.group[0]')])
	      });
	    case ADD_CONTACTS:
	      {
	        return (0, _qim.update)(['contactsListData', 'contacts', _qim.$end, (0, _qim.$set)(action.contacts.filter(function (contact) {
	          return !contact.result;
	        }))], state);
	      }
	    case UPDATE_GROUP:
	      return (0, _extends3.default)({}, state, {
	        groupContactsListData: action.groupContactsListData
	      });
	    case UPDATE:
	      return (0, _extends3.default)({}, state, {
	        contactsManageGroupData: action.contactsManageGroup,
	        contactsWithoutGroupData: action.contactsWithoutGroup,
	        kw: action.kw
	      });
	    case FILTER:
	      return (0, _extends3.default)({}, state, {
	        kw: action.kw
	      });
	    case SET_CONTACTS_LIST_LIMIT:
	      return (0, _extends3.default)({}, state, {
	        contactsListLimit: action.limit
	      });
	    case SET_GROUP_CONTACTS_PAGE:
	      return (0, _extends3.default)({}, state, {
	        groupContactsPage: action.page
	      });
	    case FILTER_GROUP_CONTACTS:
	      return (0, _extends3.default)({}, state, {
	        groupContactsKw: action.kw,
	        groupContactsPage: 1
	      });
	    case UPDATE_CHECKED_GROUP_CONTACTS:
	      return (0, _extends3.default)({}, state, {
	        checkedGroupContacts: action.checkedGroupContacts
	      });
	    default:
	      return loadReducer.reducer(state, action);
	  }
	}
	
	function filter() {
	  var kw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	  return {
	    type: FILTER,
	    kw: kw
	  };
	}
	
	function loadContacts() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      page = _ref.page,
	      limit = _ref.limit,
	      kw = _ref.kw;
	
	  return {
	    types: loadReducer.constantsByKey.contactsList,
	    promise: function promise(client) {
	      return client.post('contacts_wa/getContactsList', { data: { page: page, items: limit, kw: kw } });
	    },
	    page: page,
	    limit: limit,
	    kw: kw
	  };
	}
	
	function deleteContact(contactId) {
	  return {
	    types: loadReducer.constantsByKey.deleteContact,
	    promise: function promise(client) {
	      return client.post('contacts_wa/deleteContact', { data: { contactId: contactId } });
	    },
	    contactId: contactId
	  };
	}
	
	function addContact(data) {
	  return (0, _extends3.default)({
	    types: loadReducer.constantsByKey.addContact,
	    promise: function promise(client) {
	      return client.post('contacts_wa/addContact', { data: data });
	    }
	  }, data);
	}
	
	function addContacts(groupId, contacts) {
	  return {
	    type: ADD_CONTACTS,
	    groupId: groupId,
	    contacts: contacts
	  };
	}
	
	function loadGroups() {
	  return {
	    types: loadReducer.constantsByKey.groupsList,
	    promise: function promise(client) {
	      return client.post('contacts_wa/listGroups');
	    }
	  };
	}
	
	function deleteGroup(groupId) {
	  return {
	    types: loadReducer.constantsByKey.deleteGroup,
	    promise: function promise(client) {
	      return client.post('contacts_wa/deleteGroup', { data: { groupId: groupId } });
	    },
	    groupId: groupId
	  };
	}
	
	function addGroup(groupName) {
	  return {
	    types: loadReducer.constantsByKey.addGroup,
	    promise: function promise(client) {
	      return client.post('contacts_wa/addGroup', { data: { groupName: groupName } });
	    },
	    groupName: groupName
	  };
	}
	
	function loadGroupContacts(groupId) {
	  return {
	    types: loadReducer.constantsByKey.groupContactsList,
	    promise: function promise(client) {
	      return client.post('contacts_wa/getContactsFromGroup', { data: { groupId: groupId } });
	    },
	    groupId: groupId
	  };
	}
	
	function removeContactFromGroup(contact) {
	  return function (dispatch, getState) {
	    var state = getState();
	    var groupContactsListData = (0, _reject3.default)(state.contacts.groupContactsListData, { id: contact.id });
	
	    dispatch({
	      type: UPDATE_GROUP,
	      groupContactsListData: groupContactsListData
	    });
	  };
	}
	
	function addAllContactsToGroup() {
	  return function (dispatch, getState) {
	    var state = getState();
	    var _state$contacts = state.contacts,
	        contactsListData = _state$contacts.contactsListData,
	        groupContactsListData = _state$contacts.groupContactsListData;
	
	    var newGroupData = (0, _utils.mergeObjectArraysByKey)('id', groupContactsListData, contactsListData.contacts);
	
	    dispatch({
	      type: UPDATE_GROUP,
	      groupContactsListData: newGroupData
	    });
	  };
	}
	
	function removeAllContactsFromGroup() {
	  return {
	    type: UPDATE_GROUP,
	    groupContactsListData: []
	  };
	}
	
	function saveGroupContacts(_ref2) {
	  var groupId = _ref2.groupId,
	      contacts = _ref2.contacts;
	
	  return {
	    types: loadReducer.constantsByKey.saveGroupContacts,
	    promise: function promise(client) {
	      return client.post('contacts_wa/resetGroupContacts', { data: { contacts: '[' + contacts.toString() + ']', groupId: groupId } });
	    },
	    contacts: contacts,
	    groupId: groupId,
	    abortable: true
	  };
	}
	
	function moveContactToGroup(_ref3) {
	  var contact = _ref3.contact,
	      groupId = _ref3.groupId;
	
	  return function (dispatch, getState) {
	    var state = getState().contacts;
	    var groupContactsIds = (0, _map3.default)(state.groupContactsListData, 'id');
	    var groupContactsListData = [].concat((0, _toConsumableArray3.default)(state.groupContactsListData), [contact]);
	
	    var result = dispatch(saveGroupContacts({ groupId: groupId, contacts: [].concat((0, _toConsumableArray3.default)(groupContactsIds), [contact.id]) }));
	
	    dispatch({
	      type: UPDATE_GROUP,
	      groupContactsListData: groupContactsListData
	    });
	    return result;
	  };
	}
	
	function deleteGroupContact(_ref4) {
	  var contact = _ref4.contact,
	      groupId = _ref4.groupId;
	
	  return function (dispatch, getState) {
	    var state = getState().contacts;
	    var groupContacts = (0, _qim.update)([[_qim.$each, function (groupContact) {
	      return groupContact.id === contact.id;
	    }, _qim.$none]], state.groupContactsListData);
	
	    var result = dispatch(saveGroupContacts({ groupId: groupId, contacts: (0, _map3.default)(groupContacts, 'id') }));
	
	    dispatch({
	      type: UPDATE_GROUP,
	      groupContactsListData: groupContacts
	    });
	    return result;
	  };
	}
	/*
	
	
	function updateGroupContactsPageIfNecessary() {
	  return (dispatch, getState) => {
	    const state = getState().contacts;
	    const page = state.groupContactsPage;
	  };
	}
	*/
	
	function deleteGroupContacts(_ref5) {
	  var contacts = _ref5.contacts,
	      groupId = _ref5.groupId;
	
	  return function (dispatch, getState) {
	    var state = getState().contacts;
	    var groupContacts = (0, _qim.update)([[_qim.$each, function (groupContact) {
	      return contacts.includes(groupContact.id);
	    }, _qim.$none]], state.groupContactsListData);
	
	    var result = dispatch(saveGroupContacts({ groupId: groupId, contacts: (0, _map3.default)(groupContacts, 'id') }));
	
	    dispatch({
	      type: UPDATE_GROUP,
	      groupContactsListData: groupContacts
	    });
	    return result;
	  };
	}
	
	function setContactsListLimit(limit) {
	  return function (dispatch, getState) {
	    var state = getState().contacts;
	    dispatch(loadContacts({ page: 1, limit: limit, kw: state.kw }));
	
	    dispatch({
	      type: SET_CONTACTS_LIST_LIMIT,
	      limit: limit
	    });
	  };
	}
	
	function loadSuggestionUsersList(kw) {
	  var data = { kw: kw };
	  return function (dispatch, getState) {
	    var state = getState().project;
	    if (!state.suggestionListLoading && !state.suggestionListLoaded /* && state.suggestionListActionData.kw !== kw*/) {
	        return dispatch({
	          types: loadReducer.constantsByKey.suggestionList,
	          promise: function promise(client) {
	            return client.post('contacts_wa/getContactsList', { data: data });
	          },
	          kw: kw
	        });
	      }
	  };
	}
	
	function setGroupContactsPage(_ref6) {
	  var page = _ref6.page;
	
	  return {
	    type: SET_GROUP_CONTACTS_PAGE,
	    page: page
	  };
	}
	
	function filterGroupContacts(kw) {
	  return {
	    type: FILTER_GROUP_CONTACTS,
	    kw: kw
	  };
	}
	
	function updateCheckedGroupContacts(checkedGroupContacts) {
	  return {
	    type: UPDATE_CHECKED_GROUP_CONTACTS,
	    checkedGroupContacts: checkedGroupContacts
	  };
	}

/***/ }),
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.reportPeriods = exports.recipientTabs = exports.coverageTabs = exports.projectTabs = exports.coverageRecipientsColumnsArray = exports.coverageRecipientsColumns = exports.defaultDetailedData = exports.defaultGeographyData = exports.defaultDevicesData = exports.defaultChartData = exports.pageLimit = undefined;
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _entries = __webpack_require__(72);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _slicedToArray2 = __webpack_require__(78);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _toConsumableArray2 = __webpack_require__(34);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends3 = __webpack_require__(8);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _values = __webpack_require__(158);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _toPairs2 = __webpack_require__(1567);
	
	var _toPairs3 = _interopRequireDefault(_toPairs2);
	
	var _sortBy2 = __webpack_require__(676);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	var _round2 = __webpack_require__(1564);
	
	var _round3 = _interopRequireDefault(_round2);
	
	var _reverse2 = __webpack_require__(453);
	
	var _reverse3 = _interopRequireDefault(_reverse2);
	
	var _keyBy2 = __webpack_require__(322);
	
	var _keyBy3 = _interopRequireDefault(_keyBy2);
	
	var _isEmpty2 = __webpack_require__(81);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _clamp2 = __webpack_require__(446);
	
	var _clamp3 = _interopRequireDefault(_clamp2);
	
	var _capitalize2 = __webpack_require__(667);
	
	var _capitalize3 = _interopRequireDefault(_capitalize2);
	
	exports.processStatsViewer = processStatsViewer;
	exports.processStatsViewers = processStatsViewers;
	exports.processPopularityData = processPopularityData;
	exports.processGeographyCountriesData = processGeographyCountriesData;
	exports.processGeographyCitiesData = processGeographyCitiesData;
	exports.processDevicesData = processDevicesData;
	exports.processRecipientGlobalData = processRecipientGlobalData;
	exports.processCoverageData = processCoverageData;
	exports.processPlayStatsData = processPlayStatsData;
	exports.getOrderedCoverageData = getOrderedCoverageData;
	exports.processProjectInfo = processProjectInfo;
	exports.processRecipientDetailedData = processRecipientDetailedData;
	exports.processTracksDetailsData = processTracksDetailsData;
	exports.processRecipientProjects = processRecipientProjects;
	exports.processRecipientProjectsPlayStats = processRecipientProjectsPlayStats;
	
	var _strings = __webpack_require__(59);
	
	var _datetime = __webpack_require__(68);
	
	var _ordering = __webpack_require__(533);
	
	var _ordering2 = _interopRequireDefault(_ordering);
	
	var _projects = __webpack_require__(28);
	
	var _countryCodes = __webpack_require__(2243);
	
	var _countryCodes2 = _interopRequireDefault(_countryCodes);
	
	var _uuid = __webpack_require__(270);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _moment = __webpack_require__(20);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var daySeconds = 3600 * 24;
	
	var pageLimit = exports.pageLimit = 100;
	var defaultChartData = exports.defaultChartData = { data: [], hasData: false };
	var defaultDevicesData = exports.defaultDevicesData = { devices: [], sources: [] };
	var defaultGeographyData = exports.defaultGeographyData = { plays: [], downloads: [] };
	var defaultDetailedData = exports.defaultDetailedData = { tracks: {}, timings: [] };
	var coverageRecipientsColumns = exports.coverageRecipientsColumns = {
	  recipientId: 'recipientId',
	  fullName: 'fullName',
	  email: 'email',
	  downloaded: 'downloaded',
	  expiryDate: 'expiryDate',
	  details: 'details',
	  info: 'info',
	  share: 'share'
	};
	var coverageRecipientsColumnsArray = exports.coverageRecipientsColumnsArray = (0, _values2.default)(coverageRecipientsColumns);
	
	var projectTabs = exports.projectTabs = {
	  my: 'my',
	  available: 'available'
	};
	
	var coverageTabs = exports.coverageTabs = {
	  played: 'played',
	  notAccessed: 'not accessed'
	};
	
	var recipientTabs = exports.recipientTabs = {
	  info: 'file info',
	  detailed: 'detailed action'
	};
	
	var reportPeriods = exports.reportPeriods = {
	  week: 'week',
	  month: 'month',
	  custom: 'custom'
	};
	
	function processStatsViewer(viewer) {
	  var result = (0, _extends4.default)({}, viewer);
	  result.fullName = (0, _strings.concat)(' ', viewer.name, viewer.surname);
	  return result;
	}
	
	function processStatsViewers(viewers) {
	  return viewers.map(processStatsViewer);
	}
	
	function processPopularityData() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  return [].concat((0, _toConsumableArray3.default)(data)).map(function (item) {
	    item.avgPlaytime = (0, _clamp3.default)((0, _round3.default)(item.avgPlaytime, 2), 0, Infinity);
	    item.avgPlaytimeString = (0, _datetime.secToMinString)(item.avgPlaytime);
	    item.avgPlaytimeDate = new Date(item.avgPlaytime * 1000);
	    return item;
	  });
	}
	
	function processStatsData(_ref) {
	  var stats = _ref.stats,
	      getName = _ref.getName,
	      getValue = _ref.getValue,
	      _ref$replaceEmpty = _ref.replaceEmpty,
	      replaceEmpty = _ref$replaceEmpty === undefined ? null : _ref$replaceEmpty,
	      notEmpty = _ref.notEmpty;
	
	  var hasData = false;
	  var processedData = [];
	  (0, _toPairs3.default)(stats).map(function (stat) {
	    var _stat = (0, _slicedToArray3.default)(stat, 2),
	        name = _stat[0],
	        value = _stat[1];
	
	    var resultName = getName ? getName(name) : name;
	    var resultValue = getValue ? getValue(value) : value || replaceEmpty;
	    if (resultValue) {
	      hasData = true;
	    }
	    if (notEmpty && resultValue || !notEmpty) {
	      processedData.push([resultName, resultValue]);
	    }
	  });
	
	  return { data: processedData, hasData: hasData };
	}
	
	function processGeographyCountriesData() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { plays: {}, downloads: {} };
	
	  var getName = function getName(name) {
	    return _countryCodes2.default[name];
	  };
	  var getValue = function getValue() {
	    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return value.count || 0;
	  };
	
	  return {
	    plays: processStatsData({ stats: data.plays, getName: getName, getValue: getValue, notEmpty: true }),
	    downloads: processStatsData({ stats: data.downloads, getName: getName, getValue: getValue, notEmpty: true })
	  };
	}
	
	function processGeographyCitiesData() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { plays: {}, downloads: {} };
	
	  var mapCities = function mapCities(stats) {
	    var citiesStats = [];
	    var hasData = false;
	    (0, _values2.default)(stats).forEach(function (countryStats) {
	      var cities = !(0, _isEmpty3.default)(countryStats.cities) ? countryStats.cities : {};
	      (0, _entries2.default)(cities).forEach(function (_ref2) {
	        var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
	            city = _ref3[0],
	            count = _ref3[1];
	
	        if (count) {
	          hasData = true;
	          citiesStats.push([city, count]);
	        }
	      });
	    });
	    return { data: citiesStats, hasData: hasData };
	  };
	
	  return {
	    plays: mapCities(data.plays),
	    downloads: mapCities(data.downloads)
	  };
	}
	
	function processDevicesData() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { devices: {}, sources: {} };
	
	  return {
	    devices: processStatsData({ stats: data.devices }),
	    sources: processStatsData({ stats: data.sources })
	  };
	}
	
	function processRecipientGlobalData() {
	  var stats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var _t = __webpack_require__(56).getT();
	  var getName = function getName(name) {
	    return _t((0, _capitalize3.default)(name));
	  };
	  return processStatsData({ stats: stats, getName: getName });
	}
	
	function processRecipients() {
	  var recipients = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  return recipients.map(function (recipient) {
	    return (0, _extends4.default)({}, recipient, {
	      fullName: (0, _strings.concat)(' ', recipient.name, recipient.surname),
	      downloadRights: !!recipient.download,
	      downloaded: !!recipient.downloaded,
	      date: (0, _datetime.formatDateTime)(recipient.uxt),
	      expiryDate: (0, _datetime.formatDate)(recipient.recepEd),
	      isExpirySoon: (0, _datetime.isExpired)({ time: 0, duration: new Date(recipient.recepEd) })
	    });
	  });
	}
	
	function processCoverageData() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if ((0, _isEmpty3.default)(data)) {
	    return { stats: {} };
	  }
	
	  return {
	    stats: {
	      played: parseInt(data.played, 10),
	      downloads: parseInt(data.downloads, 10)
	    },
	    playedRecipients: processRecipients(data.playedRecipients),
	    notAccessedRecipients: processRecipients(data.notAccessedRecipients)
	  };
	}
	
	function getPlayStatObject(date) {
	  return {
	    plays: 0,
	    downloads: 0,
	    unixDate: date,
	    date: new Date(date * 1000),
	    dateTime: date
	  };
	}
	
	function getStartOfDay(date) {
	  return (0, _datetime.getMomentDate)(date).startOf('day').unix();
	}
	
	function getEmptyPlayStatsPeriod() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var statDates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  var dates = (statDates.length ? statDates : data).map(function (stat) {
	    return getStartOfDay(stat.dateTime);
	  });
	  if (!dates.length) {
	    return [];
	  }
	  var minDate = Math.min.apply(Math, (0, _toConsumableArray3.default)(dates));
	  var maxDate = Math.max.apply(Math, (0, _toConsumableArray3.default)(dates));
	  var duration = _moment2.default.duration(maxDate - minDate, 'seconds').days();
	  var daysDates = [getPlayStatObject(minDate), getPlayStatObject(maxDate)];
	  for (var i = 1; i < duration; i += 1) {
	    daysDates.splice(1, 0, getPlayStatObject(getStartOfDay(minDate + i * daySeconds)));
	  }
	  return daysDates;
	}
	
	function processPlayStatsData() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var dates = arguments[1];
	
	  var daysDates = getEmptyPlayStatsPeriod(data, dates);
	
	  var result = data.reduce(function (accumulator, current) {
	    var date = (0, _datetime.getMomentDate)(current.dateTime).startOf('day').unix();
	    var item = accumulator[date] || { plays: 0, downloads: 0 };
	    var plays = (item.plays || item.play || 0) + (current.play || current.plays || 0); //FIXME: API duct tape
	    var downloads = (item.downloads || 0) + current.downloads;
	    return (0, _extends4.default)({}, accumulator, (0, _defineProperty3.default)({}, date, {
	      plays: plays,
	      downloads: downloads,
	      unixDate: date,
	      date: new Date(date * 1000),
	      dateTime: current.dateTime
	    }));
	  }, (0, _keyBy3.default)(daysDates, 'unixDate'));
	  // TODO: remove after merge
	  // const afterWeek = Math.round(Date.now() / 1000) + (3600 * 24 * 7);
	  // result[afterWeek] = {plays: 5, downloads: 3, unixDate: afterWeek, date: new Date(1000 * afterWeek)};
	  var sortedData = (0, _sortBy3.default)((0, _values2.default)(result), 'unixDate');
	
	  return sortedData;
	}
	
	function getOrderedCoverageData(_ref4) {
	  var data = _ref4.data,
	      activeOrder = _ref4.activeOrder,
	      order = _ref4.order;
	
	  var processedData = processCoverageData(data);
	  processedData.playedRecipients = (0, _ordering2.default)({ data: processedData.playedRecipients, activeOrder: activeOrder, order: order });
	  processedData.notAccessedRecipients = (0, _ordering2.default)({ data: processedData.notAccessedRecipients, activeOrder: activeOrder, order: order });
	  return processedData;
	}
	
	function processProjectInfo(project) {
	  return (0, _projects.processProject)(project);
	}
	
	function getDetailedTiming(_ref5) {
	  var trackTiming = _ref5.trackTiming,
	      trackId = _ref5.trackId;
	
	  return (0, _extends4.default)({}, trackTiming, {
	    uuid: (0, _uuid2.default)(),
	    trackId: trackId,
	    durationString: (0, _datetime.secToMinString)(trackTiming.listeningDuration),
	    dateString: (0, _datetime.formatDateTime)(trackTiming.date)
	  });
	}
	
	function formatDetailedTrack(_ref6) {
	  var data = _ref6.data;
	  var artist = data.artist,
	      duration = data.duration,
	      filename = data.filename,
	      trackId = data.trackId;
	
	  return { artist: artist, duration: duration, filename: filename, trackId: trackId, fullName: (0, _strings.concat)(': ', artist, filename) };
	}
	
	function processRecipientDetailedData() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  var timings = [];
	  var tracks = data.map(function (stat) {
	    var trackId = stat.trackId,
	        _stat$timings = stat.timings,
	        trackTimings = _stat$timings === undefined ? [] : _stat$timings;
	
	    trackTimings.map(function (trackTiming) {
	      if (trackTiming.listeningDuration) {
	        timings.push(getDetailedTiming({ trackTiming: trackTiming, trackId: trackId }));
	      }
	    });
	    return formatDetailedTrack({ data: stat });
	  });
	
	  return {
	    tracks: (0, _keyBy3.default)(tracks, 'trackId'),
	    timings: (0, _reverse3.default)((0, _sortBy3.default)(timings, 'date'))
	  };
	}
	
	function processTracksDetailsData() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  var dates = data.reduce(function (accumulator, current) {
	    return [].concat((0, _toConsumableArray3.default)(accumulator), (0, _toConsumableArray3.default)(current.stats));
	  }, []);
	
	  return data.map(function (trackData) {
	    return (0, _extends4.default)({}, trackData, {
	      fullName: (0, _strings.concat)(': ', trackData.artist, trackData.trackName),
	      stats: processPlayStatsData(trackData.stats, dates)
	    });
	  });
	}
	
	function processRecipientProjects(_ref7) {
	  var _ref7$data = _ref7.data,
	      data = _ref7$data === undefined ? [] : _ref7$data,
	      activeOrder = _ref7.activeOrder,
	      order = _ref7.order;
	
	  var projectsData = data.map(function (project) {
	    return (0, _extends4.default)({}, project, project.projectInfo);
	  });
	  return (0, _ordering2.default)({ data: (0, _projects.processProjects)(projectsData), activeOrder: activeOrder, order: order });
	}
	
	function processRecipientProjectsPlayStats(_ref8) {
	  var _ref8$data = _ref8.data,
	      data = _ref8$data === undefined ? [] : _ref8$data;
	
	  var statsData = data.reduce(function (accumulator, current) {
	    return [].concat((0, _toConsumableArray3.default)(accumulator), (0, _toConsumableArray3.default)(current.stats));
	  }, []);
	  return processPlayStatsData(statsData);
	}

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dateFormat = undefined;
	
	var _isFinite = __webpack_require__(218);
	
	var _isFinite2 = _interopRequireDefault(_isFinite);
	
	exports.normalizeDate = normalizeDate;
	exports.isDaySavingLight = isDaySavingLight;
	exports.getTimeDifference = getTimeDifference;
	exports.getMomentDate = getMomentDate;
	exports.formatDate = formatDate;
	exports.formatShortDate = formatShortDate;
	exports.formatDateTime = formatDateTime;
	exports.formatDateToSql = formatDateToSql;
	exports.formatDateToUnix = formatDateToUnix;
	exports.formatDateTimeToSql = formatDateTimeToSql;
	exports.secToMin = secToMin;
	exports.secToMinString = secToMinString;
	exports.isExpired = isExpired;
	exports.todayDate = todayDate;
	
	var _moment = __webpack_require__(20);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormat = exports.dateFormat = {
	  date: 'DD MMM YYYY',
	  dateTime: 'DD MMM YYYY, HH:mm',
	  shortDate: 'MM/DD/YY',
	  sql: 'YYYY-MM-DD',
	  sqlDateTime: 'YYYY-MM-DD HH:mm:00'
	};
	
	function normalizeDate(date) {
	  var result = date;
	  if ((0, _isFinite2.default)(date) && date && date < Date.now() / 100) {
	    result = date * 1000;
	  }
	  return result;
	}
	
	function isDaySavingLight() {
	  return (0, _moment2.default)().isDST() ? 1 : 0;
	}
	
	function getTimeDifference() {
	  return (0, _moment2.default)().format('Z');
	}
	
	function getMomentDate(dateTime) {
	  return (0, _moment2.default)(normalizeDate(dateTime));
	}
	
	function formatDate(date) {
	  return getMomentDate(date).format(dateFormat.date);
	}
	
	function formatShortDate(date) {
	  return getMomentDate(date).format(dateFormat.shortDate);
	}
	
	function formatDateTime(dateTime) {
	  return getMomentDate(dateTime).format(dateFormat.dateTime);
	}
	
	function formatDateToSql(date) {
	  var withTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var formattedDate = date;
	  if ((0, _isFinite2.default)(date) && date && date < Date.now() / 100) {
	    formattedDate = new Date(date * 1000);
	  }
	  return formattedDate ? (0, _moment2.default)(formattedDate).format(withTime ? dateFormat.sqlDateTime : dateFormat.sql) : null;
	}
	
	function formatDateToUnix(date) {
	  return (0, _moment2.default)(date, 'YYYY-MM-DD').unix();
	}
	
	function formatDateTimeToSql(date) {
	  return formatDateToSql(date, true);
	}
	
	function getDurationTimes(position) {
	  var duration = _moment2.default.duration(position, 'seconds');
	  var minutes = Math.floor(duration.asMinutes());
	  var seconds = ('0' + duration.seconds()).substr(-2);
	  return { minutes: minutes, seconds: seconds };
	}
	
	function secToMin(position) {
	  var _getDurationTimes = getDurationTimes(position),
	      minutes = _getDurationTimes.minutes,
	      seconds = _getDurationTimes.seconds;
	
	  return minutes + ':' + seconds;
	}
	
	function secToMinString(position) {
	  var _getDurationTimes2 = getDurationTimes(position),
	      minutes = _getDurationTimes2.minutes,
	      seconds = _getDurationTimes2.seconds;
	
	  var t = __webpack_require__(56).getT();
	  return t('{{minutes}} min {{seconds}} sec', { minutes: minutes, seconds: seconds });
	}
	
	function isExpired(_ref) {
	  var time = _ref.time,
	      duration = _ref.duration;
	
	  return Date.now() - time > duration;
	}
	
	function todayDate() {
	  return formatDate();
	}

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(102);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _toConsumableArray2 = __webpack_require__(34);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _objectWithoutProperties2 = __webpack_require__(21);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(8);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _assign = __webpack_require__(186);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _slicedToArray2 = __webpack_require__(78);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(72);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _getIterator2 = __webpack_require__(539);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _get2 = __webpack_require__(19);
	
	var _get3 = _interopRequireDefault(_get2);
	
	exports.isLoadTime = isLoadTime;
	exports.getLoaderKey = getLoaderKey;
	exports.getLoaderState = getLoaderState;
	
	var _TypeCast = __webpack_require__(260);
	
	var _strings = __webpack_require__(59);
	
	var _config = __webpack_require__(41);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _datetime = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Create default reducer for API request with (example for user module)
	 *
	 * createLoadReducer('auth', {<name>: params})
	 *
	 * name - action name
	 * params.action - string, optional: prefix for constants
	 * params.init - any, optional: initial state
	 * params.keepOnLoad - boolean: keep old data while performing a new request
	 * params.loaderKeys - array: array of field names of action object for set unique loading keys for each request
	 * params.field - string|array - field name in response to use as data source
	 *
	 * createLoadReducer('auth', {user: {action: 'load', init: {data: []}}})
	 * will generate
	 *
	 * constants:
	 * LOAD_USER = 'auth/LOAD_USER'
	 * LOAD_USER_SUCCESS = 'auth/LOAD_USER_SUCCESS'
	 * LOAD_USER_FAIL = 'auth/LOAD_USER_FAIL'
	 *
	 * initialState:
	 * userData: []
	 * userActionData: {}
	 * userLoading: false
	 * userLoaded: false
	 * userLoadError: null
	 *
	 * appropriate reducer actions
	 *
	 */
	
	function getKey(mappedKey, objKey) {
	  return '' + mappedKey + (0, _strings.capitalize)(objKey);
	}
	
	function mapToKey(mappedKey, obj) {
	  var res = {};
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = (0, _getIterator3.default)((0, _entries2.default)(obj)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
	          key = _step$value[0],
	          val = _step$value[1];
	
	      //eslint-disable-line no-restricted-syntax
	      res[getKey(mappedKey, key)] = val;
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return res;
	}
	
	function isLoadTime(_ref) {
	  var _ref$useCache = _ref.useCache,
	      useCache = _ref$useCache === undefined ? true : _ref$useCache,
	      key = _ref.key,
	      state = _ref.state,
	      cacheTime = _ref.cacheTime;
	
	  if (!useCache) {
	    return true;
	  }
	  var loaded = state[key + 'Loaded'],
	      loading = state[key + 'Loading'],
	      time = state[key + 'Timestamp'];
	
	  return !(loading || loaded && !(0, _datetime.isExpired)({ time: time, duration: cacheTime }));
	}
	
	function getActionKeys(key, opts) {
	  var constKey = (0, _strings.toUpperUnderscore)(key);
	  var constAction = typeof opts.action === 'undefined' ? '' : opts.action.toUpperCase() + '_';
	  var actionKey = constAction + constKey;
	  var actionKeySuccess = '' + constAction + constKey + '_SUCCESS';
	  var actionKeyFail = '' + constAction + constKey + '_FAIL';
	
	  return { actionKey: actionKey, actionKeySuccess: actionKeySuccess, actionKeyFail: actionKeyFail };
	}
	
	function getInitial(module, keys) {
	  var constants = {};
	  var constantsByKey = {};
	  var initialState = {};
	
	  var _iteratorNormalCompletion2 = true;
	  var _didIteratorError2 = false;
	  var _iteratorError2 = undefined;
	
	  try {
	    for (var _iterator2 = (0, _getIterator3.default)((0, _entries2.default)(keys)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	      var _step2$value = (0, _slicedToArray3.default)(_step2.value, 2),
	          key = _step2$value[0],
	          opts = _step2$value[1];
	
	      //eslint-disable-line no-restricted-syntax
	      var _getActionKeys = getActionKeys(key, opts),
	          actionKey = _getActionKeys.actionKey,
	          actionKeySuccess = _getActionKeys.actionKeySuccess,
	          actionKeyFail = _getActionKeys.actionKeyFail;
	
	      constants[actionKey] = module + '/' + actionKey;
	      constants[actionKeySuccess] = module + '/' + actionKeySuccess;
	      constants[actionKeyFail] = module + '/' + actionKeyFail;
	      constants[key] = {
	        start: constants[actionKey],
	        success: constants[actionKeySuccess],
	        fail: constants[actionKeyFail]
	      };
	
	      constantsByKey[key] = [constants[actionKey], constants[actionKeySuccess], constants[actionKeyFail]];
	
	      (0, _assign2.default)(initialState, mapToKey(key, {
	        data: opts.init,
	        actionData: {},
	        loading: false,
	        loaded: false,
	        loadError: null,
	        loaders: {}
	      }));
	    }
	  } catch (err) {
	    _didIteratorError2 = true;
	    _iteratorError2 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion2 && _iterator2.return) {
	        _iterator2.return();
	      }
	    } finally {
	      if (_didIteratorError2) {
	        throw _iteratorError2;
	      }
	    }
	  }
	
	  return { constants: constants, constantsByKey: constantsByKey, initialState: initialState };
	}
	
	function formatField(field) {
	  var formattedField = [];
	  if (typeof field === 'string') {
	    formattedField = field.split('.');
	  } else if (typeof field === 'number') {
	    formattedField.push(field);
	  } else if (field instanceof Array) {
	    formattedField = field;
	  }
	
	  return formattedField;
	}
	
	function setStateData(state, stateData, key) {
	  return (0, _extends4.default)({}, state, mapToKey(key, stateData));
	}
	
	function getLoaderKey(parts) {
	  var key = 'lid';
	  parts.map(function (part) {
	    return key += '_' + part;
	  }); //eslint-disable-line no-return-assign
	  return key;
	}
	
	function getLoaderState(_ref2) {
	  var loader = _ref2.loader,
	      keys = _ref2.keys;
	
	  var loaderKey = getLoaderKey(keys);
	  return loader[loaderKey];
	}
	
	function getLoaderKeyFromAction(loaderKeys, action) {
	  var keyParts = loaderKeys.map(function (loaderKey) {
	    return action[loaderKey];
	  });
	  return getLoaderKey(keyParts);
	}
	
	function updateLoaders(_ref3) {
	  var state = _ref3.state,
	      stateData = _ref3.stateData,
	      key = _ref3.key,
	      opts = _ref3.opts,
	      action = _ref3.action,
	      value = _ref3.value;
	
	  if (opts.loaderKeys) {
	    if (value) {
	      stateData.loaders = (0, _extends4.default)({}, state[getKey(key, 'loaders')], (0, _defineProperty3.default)({}, getLoaderKeyFromAction(opts.loaderKeys, action), value));
	    } else {
	      stateData.loaders = (0, _extends4.default)({}, state[getKey(key, 'loaders')]);
	      delete stateData.loaders[getLoaderKeyFromAction(opts.loaderKeys, action)];
	    }
	  }
	}
	
	function onStart(key, opts, state, action) {
	  var _stateData;
	
	  var type = action.type,
	      actionData = (0, _objectWithoutProperties3.default)(action, ['type']); // eslint-disable-line no-unused-vars
	
	  var _config$response = _config2.default.response,
	      statusField = _config$response.statusField,
	      messageField = _config$response.messageField;
	
	  var stateData = (_stateData = {
	    actionData: actionData
	  }, (0, _defineProperty3.default)(_stateData, statusField, null), (0, _defineProperty3.default)(_stateData, messageField, null), (0, _defineProperty3.default)(_stateData, 'loading', true), (0, _defineProperty3.default)(_stateData, 'loaded', false), _stateData);
	
	  updateLoaders({ state: state, stateData: stateData, key: key, opts: opts, action: action, value: true });
	
	  if (!opts.keepOnLoad) {
	    stateData.data = opts.init;
	  }
	
	  return setStateData(state, stateData, key);
	}
	
	function onSuccess(key, opts, state, action) {
	  var _stateData2;
	
	  var type = action.type,
	      result = action.result,
	      actionData = (0, _objectWithoutProperties3.default)(action, ['type', 'result']); // eslint-disable-line no-unused-vars
	
	  var _config$response2 = _config2.default.response,
	      statusField = _config$response2.statusField,
	      messageField = _config$response2.messageField,
	      dataField = _config$response2.dataField;
	
	  var data = opts.init;
	  var stateData = (_stateData2 = {}, (0, _defineProperty3.default)(_stateData2, statusField, (0, _get3.default)(action, ['result', statusField], null)), (0, _defineProperty3.default)(_stateData2, messageField, (0, _get3.default)(action, ['result', messageField], null)), (0, _defineProperty3.default)(_stateData2, 'actionData', actionData), (0, _defineProperty3.default)(_stateData2, 'loading', false), (0, _defineProperty3.default)(_stateData2, 'loaded', true), (0, _defineProperty3.default)(_stateData2, 'loadError', null), (0, _defineProperty3.default)(_stateData2, 'timestamp', Date.now()), _stateData2);
	
	  if (opts.fields) {
	    var fieldsData = {};
	    (0, _entries2.default)(opts.fields).map(function (_ref4) {
	      var _ref5 = (0, _slicedToArray3.default)(_ref4, 2),
	          fldName = _ref5[0],
	          val = _ref5[1];
	
	      var formattedField = formatField(val);
	      var fieldPath = formattedField.length ? ['result', dataField].concat((0, _toConsumableArray3.default)(formatField(val))) : ['result', dataField];
	      var fieldData = (0, _get3.default)(action, fieldPath, opts.init[fldName]);
	      fieldsData[fldName] = (0, _get3.default)(opts, ['init', fldName]) instanceof Array ? (0, _TypeCast.asArray)(fieldData) : fieldData;
	    });
	    if (fieldsData) {
	      data = (typeof data === 'undefined' ? 'undefined' : (0, _typeof3.default)(data)) !== 'object' ? fieldsData : (0, _extends4.default)({}, data, fieldsData);
	    }
	  } else {
	    var fieldData = (0, _get3.default)(action, ['result', dataField].concat((0, _toConsumableArray3.default)(formatField(opts.field))), opts.init);
	    data = opts.init instanceof Array ? (0, _TypeCast.asArray)(fieldData) : fieldData;
	  }
	  stateData.data = data;
	
	  if (opts.map) {
	    (0, _entries2.default)(opts.map).map(function (_ref6) {
	      var _ref7 = (0, _slicedToArray3.default)(_ref6, 2),
	          field = _ref7[0],
	          cb = _ref7[1];
	
	      state[field] = cb((0, _get3.default)(action, ['result', dataField]));
	    });
	  }
	
	  updateLoaders({ state: state, stateData: stateData, key: key, opts: opts, action: action, value: false });
	
	  return setStateData(state, stateData, key);
	}
	
	function onFail(key, opts, state, action) {
	  var _stateData3;
	
	  var type = action.type,
	      actionData = (0, _objectWithoutProperties3.default)(action, ['type']); // eslint-disable-line no-unused-vars
	
	  var _config$response3 = _config2.default.response,
	      statusField = _config$response3.statusField,
	      messageField = _config$response3.messageField;
	
	  var stateData = (_stateData3 = {
	    data: opts.init
	  }, (0, _defineProperty3.default)(_stateData3, statusField, (0, _get3.default)(action, ['result', statusField], null)), (0, _defineProperty3.default)(_stateData3, messageField, (0, _get3.default)(action, ['result', messageField], null)), (0, _defineProperty3.default)(_stateData3, 'actionData', actionData), (0, _defineProperty3.default)(_stateData3, 'loading', false), (0, _defineProperty3.default)(_stateData3, 'loaded', false), (0, _defineProperty3.default)(_stateData3, 'loadError', action.error), _stateData3);
	
	  updateLoaders({ state: state, stateData: stateData, key: key, opts: opts, action: action, value: false });
	
	  return setStateData(state, stateData, key);
	}
	
	function reducerFn(keys, constants) {
	  var actionFunction = {};
	
	  (0, _entries2.default)(keys).map(function (_ref8) {
	    var _ref9 = (0, _slicedToArray3.default)(_ref8, 2),
	        key = _ref9[0],
	        opts = _ref9[1];
	
	    var _getActionKeys2 = getActionKeys(key, opts),
	        actionKey = _getActionKeys2.actionKey,
	        actionKeySuccess = _getActionKeys2.actionKeySuccess,
	        actionKeyFail = _getActionKeys2.actionKeyFail;
	
	    actionFunction[constants[actionKey]] = onStart.bind(null, key, opts);
	    actionFunction[constants[actionKeySuccess]] = onSuccess.bind(null, key, opts);
	    actionFunction[constants[actionKeyFail]] = onFail.bind(null, key, opts);
	  });
	
	  return function (state, action) {
	    return actionFunction[action.type] ? actionFunction[action.type](state, action) : state;
	  };
	}
	
	exports.default = function (module, keys) {
	  var _getInitial = getInitial(module, keys),
	      constants = _getInitial.constants,
	      constantsByKey = _getInitial.constantsByKey,
	      initialState = _getInitial.initialState;
	
	  var reducer = reducerFn(keys, constants);
	
	  return { constants: constants, constantsByKey: constantsByKey, initialState: initialState, reducer: reducer };
	};

/***/ }),
/* 70 */,
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CheckboxField = exports.formTagsInput = exports.formAutosuggestInput = exports.formLineTextInput = exports.formSimpleTextInput = exports.formRadio = exports.formCheckbox = exports.formDatetime = exports.formDate = exports.datePickerProps = undefined;
	
	var _datePickerProps2 = __webpack_require__(861);
	
	var _datePickerProps3 = _interopRequireDefault(_datePickerProps2);
	
	var _formDate2 = __webpack_require__(524);
	
	var _formDate3 = _interopRequireDefault(_formDate2);
	
	var _formDatetime2 = __webpack_require__(2135);
	
	var _formDatetime3 = _interopRequireDefault(_formDatetime2);
	
	var _formCheckbox2 = __webpack_require__(2134);
	
	var _formCheckbox3 = _interopRequireDefault(_formCheckbox2);
	
	var _formRadio2 = __webpack_require__(2137);
	
	var _formRadio3 = _interopRequireDefault(_formRadio2);
	
	var _formSimpleTextInput2 = __webpack_require__(2138);
	
	var _formSimpleTextInput3 = _interopRequireDefault(_formSimpleTextInput2);
	
	var _formLineTextInput2 = __webpack_require__(2136);
	
	var _formLineTextInput3 = _interopRequireDefault(_formLineTextInput2);
	
	var _formAutosuggestInput2 = __webpack_require__(862);
	
	var _formAutosuggestInput3 = _interopRequireDefault(_formAutosuggestInput2);
	
	var _formTagsInput2 = __webpack_require__(2139);
	
	var _formTagsInput3 = _interopRequireDefault(_formTagsInput2);
	
	var _CheckboxField2 = __webpack_require__(523);
	
	var _CheckboxField3 = _interopRequireDefault(_CheckboxField2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.datePickerProps = _datePickerProps3.default;
	exports.formDate = _formDate3.default;
	exports.formDatetime = _formDatetime3.default;
	exports.formCheckbox = _formCheckbox3.default;
	exports.formRadio = _formRadio3.default;
	exports.formSimpleTextInput = _formSimpleTextInput3.default;
	exports.formLineTextInput = _formLineTextInput3.default;
	exports.formAutosuggestInput = _formAutosuggestInput3.default;
	exports.formTagsInput = _formTagsInput3.default;
	exports.CheckboxField = _CheckboxField3.default;

/***/ }),
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(623);
	
	var cn = _bind2.default.bind(styles);
	
	var ListItem = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(ListItem, _Component);
	
	  function ListItem() {
	    (0, _classCallCheck3.default)(this, ListItem);
	    return (0, _possibleConstructorReturn3.default)(this, (ListItem.__proto__ || (0, _getPrototypeOf2.default)(ListItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ListItem, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          isTitle = _props.isTitle,
	          className = _props.className,
	          fullWidth = _props.fullWidth,
	          onClick = _props.onClick;
	
	      var rootClass = cn(className, 'listItemRoot', { listItemTitle: isTitle, fullWidth: fullWidth });
	
	      return _react2.default.createElement(
	        'li',
	        { className: rootClass, onClick: onClick },
	        this.props.children
	      );
	    }
	  }]);
	  return ListItem;
	}(_react.Component), _class.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  className: _propTypes2.default.string,
	  fullWidth: _propTypes2.default.bool,
	  isTitle: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func
	}, _temp);
	exports.default = ListItem;
	module.exports = exports['default'];

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getPermissions = exports.getUser = undefined;
	
	var _slicedToArray2 = __webpack_require__(78);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(72);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get3 = __webpack_require__(19);
	
	var _get4 = _interopRequireDefault(_get3);
	
	var _reselect = __webpack_require__(125);
	
	var _strings = __webpack_require__(59);
	
	var _permissions = __webpack_require__(215);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _getUser = function _getUser(state) {
	  return state.auth.user;
	};
	
	function getPermissionFn(user) {
	  var _ref = user || {},
	      _ref$rightMngt = _ref.rightMngt,
	      rightMngt = _ref$rightMngt === undefined ? {} : _ref$rightMngt;
	
	  return function (permission) {
	    return permission ? !!rightMngt[permission] : rightMngt;
	  };
	}
	
	function processPermissions(user) {
	  var getPermission = getPermissionFn(user);
	  var res = (0, _extends3.default)({}, getPermission());
	  (0, _entries2.default)(_permissions.permissionsMap).map(function (_ref2) {
	    var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
	        key = _ref3[0],
	        field = _ref3[1];
	
	    res[key] = getPermission(field);
	  });
	
	  return res;
	}
	
	var getUser = exports.getUser = (0, _reselect.createSelector)([_getUser], function (user) {
	  if (user) {
	    var res = (0, _extends3.default)({}, user);
	    res.fullName = (0, _strings.concat)(' ', user.name, user.surname);
	    res.permissions = processPermissions(user);
	    res.type = (0, _get4.default)(user, 'rightMngt.accType');
	    return res;
	  }
	  return null;
	});
	
	var getPermissions = exports.getPermissions = (0, _reselect.createSelector)([_getUser], function (user) {
	  return processPermissions(user);
	});

/***/ }),
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isUndefined2 = __webpack_require__(240);
	
	var _isUndefined3 = _interopRequireDefault(_isUndefined2);
	
	var _get3 = __webpack_require__(19);
	
	var _get4 = _interopRequireDefault(_get3);
	
	exports.default = reducer;
	exports.updatePosition = updatePosition;
	exports.playStartStat = playStartStat;
	exports.playStopStat = playStopStat;
	exports.playPauseStat = playPauseStat;
	exports.playUnpauseStat = playUnpauseStat;
	exports.playPlayStat = playPlayStat;
	exports.stop = stop;
	exports.albumEnded = albumEnded;
	exports.albumDenied = albumDenied;
	exports.flushAlbumDeniedFlag = flushAlbumDeniedFlag;
	exports.togglePause = togglePause;
	exports.playAlbum = playAlbum;
	exports.playPause = playPause;
	exports.setVolume = setVolume;
	exports.seek = seek;
	exports.play = play;
	exports.playNext = playNext;
	exports.playPrev = playPrev;
	exports.toggleExpand = toggleExpand;
	exports.updateAlbumName = updateAlbumName;
	
	var _loadReducer = __webpack_require__(69);
	
	var _loadReducer2 = _interopRequireDefault(_loadReducer);
	
	var _AudioPlayer = __webpack_require__(135);
	
	var _AudioPlayer2 = _interopRequireDefault(_AudioPlayer);
	
	var _playstats = __webpack_require__(358);
	
	var _auth = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* Audioplayer redux reducer and action creators. Dealing with audioplayer helper */
	
	var PLAY_ALBUM = 'audioplayer/PLAY_ALBUM';
	var PLAY_TRACK = 'audioplayer/PLAY_TRACK';
	var SET_VOLUME = 'audioplayer/SET_VOLUME';
	var SEEK = 'audioplayer/SEEK';
	var PLAY_NEXT = 'audioplayer/PLAY_NEXT';
	var PLAY_PREV = 'audioplayer/PLAY_PREV';
	var UPDATE_POSITION = 'audioplayer/UPDATE_POSITION';
	var PAUSE = 'audioplayer/PAUSE';
	var PLAY = 'audioplayer/PLAY';
	var STOP = 'audioplayer/STOP';
	var TOGGLE_EXPAND = 'audioplayer/TOGGLE_EXPAND';
	var ALBUM_ENDED = 'audioplayer/ALBUM_ENDED';
	var ALBUM_DENIED = 'audioplayer/ALBUM_DENIED';
	var FLUSH_ALBUM_DENIED_FLAG = 'audioplayer/FLUSH_ALBUM_DENIED_FLAG';
	var UPDATE_ALBUM_NAME = 'audioplayer/UPDATE_ALBUM_NAME';
	
	var positionInterval = null;
	var playStatInterval = null;
	var endedHandler = function endedHandler() {};
	var playStatDelay = 10000;
	
	var loadReducer = (0, _loadReducer2.default)('audioplayer', {
	  playStartStat: { keepOnLoad: true },
	  playStopStat: {},
	  playPauseStat: {},
	  playUnpauseStat: {},
	  playPlayStat: {}
	});
	
	var initialState = {
	  album: {},
	  lastAlbum: {},
	  tracks: [],
	  lastTracks: [],
	  playerStatus: _AudioPlayer2.default.status.stop,
	  volume: _AudioPlayer2.default.volume(),
	  currentTrackIndex: 0,
	  position: 0,
	  humanizedPosition: '0:00',
	  expanded: false,
	  playSession: null
	};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case PLAY_ALBUM:
	      return (0, _extends3.default)({}, state, {
	        album: action.album,
	        tracks: action.tracks,
	        playerStatus: _AudioPlayer2.default.status.play,
	        currentTrackIndex: action.currentTrackIndex,
	        isAlbumEnded: false,
	        isAlbumDenied: false
	      });
	    case PLAY_TRACK:
	      return (0, _extends3.default)({}, state, {
	        playerStatus: _AudioPlayer2.default.status.play,
	        currentTrackIndex: action.currentTrackIndex,
	        isAlbumEnded: false,
	        isAlbumDenied: false
	      });
	    case PLAY_NEXT:
	      {
	        var nextTrackIndex = state.tracks.length > state.currentTrackIndex + 1 ? state.currentTrackIndex + 1 : 0;
	        return (0, _extends3.default)({}, state, {
	          currentTrackIndex: nextTrackIndex,
	          playerStatus: _AudioPlayer2.default.status.play,
	          isAlbumEnded: false,
	          isAlbumDenied: false
	        });
	      }
	    case PLAY_PREV:
	      {
	        var prevTrackIndex = state.currentTrackIndex === 0 ? state.tracks.length - 1 : state.currentTrackIndex - 1;
	        return (0, _extends3.default)({}, state, {
	          currentTrackIndex: prevTrackIndex,
	          playerStatus: _AudioPlayer2.default.status.play,
	          isAlbumEnded: false,
	          isAlbumDenied: false
	        });
	      }
	    case SET_VOLUME:
	      return (0, _extends3.default)({}, state, {
	        volume: action.volume,
	        isVolumeNeedUpdate: action.isVolumeNeedUpdate
	      });
	    case SEEK:
	      return (0, _extends3.default)({}, state, {
	        position: action.position,
	        preventUpdate: action.preventUpdate
	      });
	    case UPDATE_POSITION:
	      return (0, _extends3.default)({}, state, {
	        position: action.position,
	        humanizedPosition: action.humanizedPosition
	      });
	    case PAUSE:
	      return (0, _extends3.default)({}, state, {
	        playerStatus: _AudioPlayer2.default.status.pause
	      });
	    case STOP:
	      return (0, _extends3.default)({}, state, initialState, {
	        lastAlbum: state.album,
	        lastTracks: state.tracks
	      });
	    case PLAY:
	      return (0, _extends3.default)({}, state, {
	        playerStatus: _AudioPlayer2.default.status.play,
	        isAlbumEnded: false,
	        isAlbumDenied: false
	      });
	    case TOGGLE_EXPAND:
	      return (0, _extends3.default)({}, state, {
	        expanded: !state.expanded
	      });
	    case ALBUM_ENDED:
	      return (0, _extends3.default)({}, state, {
	        isAlbumEnded: action.isAlbumEnded
	      });
	    case ALBUM_DENIED:
	      return (0, _extends3.default)({}, state, {
	        isAlbumDenied: true
	      });
	    case FLUSH_ALBUM_DENIED_FLAG:
	      return (0, _extends3.default)({}, state, {
	        isAlbumDenied: false
	      });
	    case UPDATE_ALBUM_NAME:
	      return (0, _extends3.default)({}, state, {
	        album: (0, _extends3.default)({}, state.album, {
	          name: action.name,
	          artist_name: action.name
	        })
	      });
	    case loadReducer.constants.PLAY_START_STAT:
	      return (0, _extends3.default)({}, loadReducer.reducer(state, action), {
	        playSession: null
	      });
	    case loadReducer.constants.PLAY_START_STAT_SUCCESS:
	      return (0, _extends3.default)({}, loadReducer.reducer(state, action), {
	        playSession: (0, _get4.default)(action, 'result.data.session')
	      });
	    case loadReducer.constants.PLAY_STOP_STAT:
	      return (0, _extends3.default)({}, loadReducer.reducer(state, action), {
	        playSession: null
	      });
	    default:
	      return state;
	  }
	}
	
	function updatePosition(position) {
	  return function (dispatch) {
	    dispatch({
	      type: UPDATE_POSITION,
	      position: position,
	      humanizedPosition: _AudioPlayer2.default.getHumanizedPosition(position)
	    });
	  };
	}
	
	function getStatRequestParams(_ref) {
	  var trackNumber = _ref.trackNumber;
	
	  return function (dispatch, getState) {
	    var globalState = getState();
	    var track = (0, _get4.default)(globalState, ['audioplayer', 'tracks', trackNumber], {});
	    var wFilename = track.wFileName || '';
	    var recipientId = (0, _get4.default)(globalState, ['audioplayer', 'album', 'recipient_id'], 0) || track.recipientId;
	    var contentKey = (0, _get4.default)(globalState, ['audioplayer', 'album', 'contentKey']) || track.contentKey;
	    return { wFilename: wFilename, recipientId: recipientId, contentKey: contentKey };
	  };
	}
	
	function getStatRequestData(_ref2) {
	  var trackNumber = _ref2.trackNumber,
	      session = _ref2.session;
	
	  return function (dispatch) {
	    var _dispatch = dispatch(getStatRequestParams({ trackNumber: trackNumber })),
	        wFilename = _dispatch.wFilename,
	        contentKey = _dispatch.contentKey;
	
	    return {
	      session: session,
	      wFilename: wFilename,
	      track_number: trackNumber + 1,
	      key: contentKey
	    };
	  };
	}
	
	function playStartStat(trackNumber) {
	  return function (dispatch) {
	    var data = dispatch(getStatRequestData({ trackNumber: trackNumber }));
	    var isUser = dispatch((0, _auth.isLoggedIn)());
	    dispatch({
	      types: loadReducer.constantsByKey.playStartStat,
	      promise: function promise(client) {
	        return client.post(isUser ? 'viewer_wa/play_start' : 'auth/play_start', { data: data, hideErrors: true });
	      }
	    });
	  };
	}
	
	function playStopStat() {
	  return function (dispatch, getState) {
	    var _getState$audioplayer = getState().audioplayer,
	        session = _getState$audioplayer.playSession,
	        trackNumber = _getState$audioplayer.currentTrackIndex,
	        tracks = _getState$audioplayer.tracks,
	        playerStatus = _getState$audioplayer.playerStatus;
	
	    var isPlayerRunning = [_AudioPlayer2.default.status.play, _AudioPlayer2.default.status.pause].includes(playerStatus);
	
	    if (isPlayerRunning && tracks.length && session) {
	      dispatch((0, _playstats.increasePlaysCount)({ trackId: (0, _get4.default)(tracks, [trackNumber, 'id']) }));
	      var data = dispatch(getStatRequestData({ session: session, trackNumber: trackNumber }));
	      var isUser = dispatch((0, _auth.isLoggedIn)());
	      return dispatch({
	        types: loadReducer.constantsByKey.playStopStat,
	        promise: function promise(client) {
	          return client.post(isUser ? 'viewer_wa/play_stop' : 'auth/play_stop', { data: data, hideErrors: true });
	        }
	      });
	    }
	  };
	}
	
	function playPauseStat(_ref3) {
	  var session = _ref3.session,
	      trackNumber = _ref3.trackNumber;
	
	  return function (dispatch) {
	    var data = dispatch(getStatRequestData({ session: session, trackNumber: trackNumber }));
	    var isUser = dispatch((0, _auth.isLoggedIn)());
	    dispatch({
	      types: loadReducer.constantsByKey.playPauseStat,
	      promise: function promise(client) {
	        return client.post(isUser ? 'viewer_wa/pause_start' : 'auth/pause_start', { data: data, hideErrors: true });
	      }
	    });
	  };
	}
	
	function playUnpauseStat(_ref4) {
	  var session = _ref4.session,
	      trackNumber = _ref4.trackNumber;
	
	  return function (dispatch) {
	    var data = dispatch(getStatRequestData({ trackNumber: trackNumber, session: session }));
	    var isUser = dispatch((0, _auth.isLoggedIn)());
	    dispatch({
	      types: loadReducer.constantsByKey.playUnpauseStat,
	      promise: function promise(client) {
	        return client.post(isUser ? 'viewer_wa/pause_stop' : 'auth/pause_stop', { data: data, hideErrors: true });
	      }
	    });
	  };
	}
	
	function playPlayStat() {
	  return function (dispatch, getState) {
	    var _getState$audioplayer2 = getState().audioplayer,
	        session = _getState$audioplayer2.playSession,
	        trackNumber = _getState$audioplayer2.currentTrackIndex;
	
	    var data = dispatch(getStatRequestData({ trackNumber: trackNumber, session: session }));
	    var isUser = dispatch((0, _auth.isLoggedIn)());
	    dispatch({
	      types: loadReducer.constantsByKey.playPlayStat,
	      promise: function promise(client) {
	        return client.post(isUser ? 'viewer_wa/play_play' : 'auth/play_play', { data: data, hideErrors: true });
	      }
	    });
	  };
	}
	
	function getNextTrackInfo(tracks, currentTrackIndex) {
	  return function (dispatch) {
	    if (!Array.isArray(tracks)) {
	      return {};
	    }
	
	    var _dispatch2 = dispatch((0, _playstats.getAllowedTracksInfo)({ tracks: tracks, currentTrackIndex: currentTrackIndex })),
	        allowedNextIndex = _dispatch2.allowedNextIndex;
	
	    var track = allowedNextIndex !== null ? tracks[allowedNextIndex] : {};
	    return { index: allowedNextIndex, track: track };
	  };
	}
	
	function getPrevTrackInfo(tracks, currentTrackIndex) {
	  return function (dispatch) {
	    if (!Array.isArray(tracks)) {
	      return {};
	    }
	
	    var _dispatch3 = dispatch((0, _playstats.getAllowedTracksInfo)({ tracks: tracks, currentTrackIndex: currentTrackIndex })),
	        allowedPrevIndex = _dispatch3.allowedPrevIndex;
	
	    var track = allowedPrevIndex !== null ? tracks[allowedPrevIndex] : {};
	    return { index: allowedPrevIndex, track: track };
	  };
	}
	
	function trackPosition() {
	  return function (dispatch) {
	    var runUpdate = function runUpdate() {
	      return dispatch(updatePosition(_AudioPlayer2.default.getPosition()));
	    };
	    runUpdate();
	    clearInterval(positionInterval);
	    positionInterval = setInterval(runUpdate, 500);
	  };
	}
	
	function stopTrackPosition() {
	  clearInterval(positionInterval);
	}
	
	function trackPlayStat() {
	  return function (dispatch) {
	    var runUpdate = function runUpdate() {
	      return dispatch(playPlayStat());
	    };
	    clearInterval(playStatInterval);
	    playStatInterval = setInterval(runUpdate, playStatDelay);
	  };
	}
	
	function stopTrackPlayStat() {
	  clearInterval(playStatInterval);
	}
	
	function getPlayerTrack() {
	  var track = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return { src: track.audioSrc, title: track.trackName };
	}
	
	function playAudio() {
	  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      track = _ref5.track,
	      nextTrack = _ref5.nextTrack;
	
	  return function (dispatch) {
	    _AudioPlayer2.default.play(getPlayerTrack(track), getPlayerTrack(nextTrack));
	    _AudioPlayer2.default.off('ended', endedHandler);
	    endedHandler = function endedHandler() {
	      return dispatch(playNext(true));
	    }; // eslint-disable-line no-use-before-define
	    _AudioPlayer2.default.on('ended', endedHandler);
	    dispatch(trackPosition());
	    dispatch(trackPlayStat());
	  };
	}
	
	function pause() {
	  return function (dispatch, getState) {
	    var state = getState().audioplayer;
	    stopTrackPosition();
	    stopTrackPlayStat();
	    if (_AudioPlayer2.default.getAudio()) {
	      _AudioPlayer2.default.pause();
	    }
	    dispatch(playPauseStat({ trackNumber: state.currentTrackIndex, session: state.playSession }));
	    return dispatch({ type: PAUSE });
	  };
	}
	
	function unpause() {
	  return function (dispatch, getState) {
	    var state = getState().audioplayer;
	    dispatch(playAudio());
	    dispatch(playUnpauseStat({ trackNumber: state.currentTrackIndex, session: state.playSession }));
	    dispatch({ type: PLAY });
	  };
	}
	
	function stop() {
	  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref6$sendStat = _ref6.sendStat,
	      sendStat = _ref6$sendStat === undefined ? true : _ref6$sendStat;
	
	  return function (dispatch) {
	    if (sendStat) {
	      dispatch(playStopStat());
	    }
	    if (_AudioPlayer2.default.getAudio()) {
	      _AudioPlayer2.default.stop();
	    }
	    stopTrackPosition();
	    stopTrackPlayStat();
	
	    dispatch({
	      type: STOP
	    });
	  };
	}
	
	function albumEnded(isAlbumEnded) {
	  return {
	    type: ALBUM_ENDED,
	    isAlbumEnded: isAlbumEnded
	  };
	}
	
	function albumDenied() {
	  return {
	    type: ALBUM_DENIED
	  };
	}
	
	function flushAlbumDeniedFlag() {
	  return {
	    type: FLUSH_ALBUM_DENIED_FLAG
	  };
	}
	
	function togglePause() {
	  return function (dispatch, getState) {
	    var state = getState().audioplayer;
	    if (state.playerStatus === _AudioPlayer2.default.status.play) {
	      dispatch(pause());
	    } else {
	      dispatch(unpause());
	    }
	  };
	}
	
	function checkAlbumDenied(_ref7) {
	  var tracks = _ref7.tracks;
	
	  return function (dispatch) {
	    var _dispatch4 = dispatch((0, _playstats.getAllowedTracksInfo)({ tracks: tracks })),
	        allowedTracks = _dispatch4.allowedTracks;
	
	    var isDenied = !allowedTracks.length;
	    if (isDenied) {
	      dispatch(stop({ sendStat: false }));
	      dispatch(albumDenied());
	    }
	
	    return isDenied;
	  };
	}
	
	function checkTrackDenied(_ref8) {
	  var _ref8$track = _ref8.track,
	      track = _ref8$track === undefined ? {} : _ref8$track;
	
	  return function (dispatch) {
	    return !dispatch((0, _playstats.isCanPlay)({ trackId: track.id }));
	  };
	}
	
	function getFirstAllowedTrackIndex(_ref9) {
	  var tracks = _ref9.tracks;
	
	  return function (dispatch) {
	    var _dispatch5 = dispatch((0, _playstats.getAllowedTracksInfo)({ tracks: tracks })),
	        allowedIndexes = _dispatch5.allowedIndexes;
	
	    return allowedIndexes.length ? allowedIndexes[0] : null;
	  };
	}
	
	function playAlbumTrack(_ref10) {
	  var album = _ref10.album,
	      tracks = _ref10.tracks,
	      currentTrackIndex = _ref10.currentTrackIndex;
	
	  return function (dispatch) {
	    var nextTrack = (0, _get4.default)(dispatch(getNextTrackInfo(tracks, currentTrackIndex)), 'track');
	    dispatch(playAudio({ track: tracks[currentTrackIndex], nextTrack: nextTrack }));
	
	    dispatch({
	      type: PLAY_ALBUM,
	      album: album,
	      tracks: tracks,
	      currentTrackIndex: currentTrackIndex
	    });
	
	    dispatch(playStartStat(currentTrackIndex));
	  };
	}
	
	function playAlbum() {
	  var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      album = _ref11.album,
	      tracks = _ref11.tracks,
	      currentTrackIndex = _ref11.currentTrackIndex;
	
	  return function (dispatch, getState) {
	    var index = (0, _isUndefined3.default)(currentTrackIndex) ? dispatch(getFirstAllowedTrackIndex({ tracks: tracks })) : currentTrackIndex;
	    var state = getState().audioplayer;
	    var isSameAlbum = album.recipient_id && state.album.recipient_id === album.recipient_id || !album.recipient_id && state.album.projectId === album.projectId;
	    var isSameTrackIndex = state.currentTrackIndex === index && index !== null;
	    var isSameTrack = isSameAlbum && isSameTrackIndex;
	
	    if (isSameTrack) {
	      return dispatch(togglePause());
	    }
	
	    var isTrackDenied = index === null || dispatch(checkTrackDenied({ track: tracks[index] }));
	    var isAlbumDenied = dispatch(checkAlbumDenied({ tracks: tracks }));
	    if (!isTrackDenied) {
	      dispatch(playStopStat());
	      if (!isAlbumDenied) {
	        dispatch(playAlbumTrack({ album: album, tracks: tracks, currentTrackIndex: index }));
	      }
	    }
	  };
	}
	
	function playPause() {
	  if (_AudioPlayer2.default.getAudio()) {
	    return function (dispatch) {
	      return dispatch(togglePause());
	    };
	  }
	}
	
	function setVolume(volume) {
	  var isVolumeNeedUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  return function (dispatch) {
	    _AudioPlayer2.default.volume(Number(volume));
	    dispatch({
	      type: SET_VOLUME,
	      volume: Number(volume),
	      isVolumeNeedUpdate: isVolumeNeedUpdate
	    });
	  };
	}
	
	function seek(position) {
	  return function (dispatch) {
	    if (_AudioPlayer2.default.getAudio()) {
	      _AudioPlayer2.default.seek(position);
	      dispatch({
	        type: SEEK,
	        position: position,
	        humanizedPosition: _AudioPlayer2.default.getHumanizedPosition(position)
	      });
	    }
	  };
	}
	
	function play() {
	  if (_AudioPlayer2.default.getAudio()) {
	    _AudioPlayer2.default.play();
	  }
	  return {
	    type: PLAY
	  };
	}
	
	function tryPlayTrack(_ref12) {
	  var track = _ref12.track,
	      index = _ref12.index;
	
	  return function (dispatch, getState) {
	    var state = getState().audioplayer;
	    var isAlbumDenied = dispatch(checkAlbumDenied({ tracks: state.tracks }));
	
	    if (!isAlbumDenied && track) {
	      var trackAfter = (0, _get4.default)(dispatch(getNextTrackInfo(state.tracks, index)), 'track');
	      dispatch(playAudio({ track: track, nextTrack: trackAfter }));
	      dispatch(playStartStat(index));
	
	      dispatch({
	        type: PLAY_TRACK,
	        currentTrackIndex: index
	      });
	    }
	  };
	}
	
	function playNext() {
	  var isCheckAlbumEnd = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	  return function (dispatch, getState) {
	    dispatch(playStopStat());
	
	    var state = getState().audioplayer;
	
	    var _dispatch6 = dispatch(getNextTrackInfo(state.tracks, state.currentTrackIndex)),
	        index = _dispatch6.index,
	        track = _dispatch6.track;
	
	    if (index === 0 && isCheckAlbumEnd) {
	      dispatch(stop({ sendStat: false }));
	      return dispatch(albumEnded(true));
	    }
	
	    dispatch(tryPlayTrack({ track: track, index: index }));
	  };
	}
	
	function playPrev() {
	  return function (dispatch, getState) {
	    dispatch(playStopStat());
	
	    var state = getState().audioplayer;
	
	    var _dispatch7 = dispatch(getPrevTrackInfo(state.tracks, state.currentTrackIndex)),
	        index = _dispatch7.index,
	        track = _dispatch7.track;
	
	    dispatch(tryPlayTrack({ track: track, index: index }));
	  };
	}
	
	function toggleExpand() {
	  return {
	    type: TOGGLE_EXPAND
	  };
	}
	
	function updateAlbumName(_ref13) {
	  var name = _ref13.name;
	
	  return {
	    type: UPDATE_ALBUM_NAME,
	    name: name
	  };
	}

/***/ }),
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(34);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _stringify = __webpack_require__(365);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(8);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _reject2 = __webpack_require__(200);
	
	var _reject3 = _interopRequireDefault(_reject2);
	
	var _find2 = __webpack_require__(95);
	
	var _find3 = _interopRequireDefault(_find2);
	
	var _get2 = __webpack_require__(19);
	
	var _get3 = _interopRequireDefault(_get2);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case 'RESET':
	      return initialState;
	    case constants.DELETE_MY_PLAYLIST_SUCCESS:
	      {
	        var myPlaylistsData = (0, _reject3.default)(state.myPlaylistsData, { guid: action.guid });
	        return (0, _extends4.default)({}, loadReducer.reducer(state, action), {
	          myPlaylistsData: myPlaylistsData
	        });
	      }
	    case constants.UPDATE_MY_PLAYLISTS_SUCCESS:
	    case constants.ADD_MY_PLAYLIST_SUCCESS:
	    case constants.ADD_MY_PLAYLIST_TRACKS_SUCCESS:
	    case constants.DELETE_MY_PLAYLIST_TRACK_SUCCESS:
	      {
	        return (0, _extends4.default)({}, loadReducer.reducer(state, action), {
	          myPlaylistsData: (0, _get3.default)(action, 'result.data', state.myPlaylistsData)
	        });
	      }
	    case SET_MY_PLAYLISTS_FILTER:
	      {
	        return (0, _extends4.default)({}, state, {
	          kw: action.kw
	        });
	      }
	    case UPDATE_CHECKED_PLAYLISTS:
	      {
	        return (0, _extends4.default)({}, state, {
	          checkedPlaylists: action.checkedPlaylists
	        });
	      }
	    case CHECK_PLAYLIST:
	      {
	        return (0, _extends4.default)({}, state, {
	          checkedPlaylists: (0, _extends4.default)({}, state.checkedPlaylists, (0, _defineProperty3.default)({}, action.guid, true))
	        });
	      }
	    default:
	      return reducer(state, action);
	  }
	};
	
	exports.isLoaded = isLoaded;
	exports.loadMyPlaylists = loadMyPlaylists;
	exports.updateMyPlaylists = updateMyPlaylists;
	exports.updateMyPlaylistName = updateMyPlaylistName;
	exports.deleteMyPlaylist = deleteMyPlaylist;
	exports.addMyPlaylist = addMyPlaylist;
	exports.deleteMyPlaylistTrack = deleteMyPlaylistTrack;
	exports.setMyPlaylistsFilter = setMyPlaylistsFilter;
	exports.updateCheckedPlaylists = updateCheckedPlaylists;
	exports.checkPlaylist = checkPlaylist;
	exports.addMyPlaylistTracks = addMyPlaylistTracks;
	
	var _loadReducer = __webpack_require__(69);
	
	var _loadReducer2 = _interopRequireDefault(_loadReducer);
	
	var _log = __webpack_require__(267);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _uuid = __webpack_require__(270);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TAG = 'modules/my-playlists'; /* Playlist redux reducer and action creators */
	
	var SET_MY_PLAYLISTS_FILTER = 'myPlaylists/SET_MY_PLAYLISTS_FILTER';
	var UPDATE_CHECKED_PLAYLISTS = 'myPlaylists/UPDATE_CHECKED_PLAYLISTS';
	var CHECK_PLAYLIST = 'myPlaylists/CHECK_PLAYLIST';
	
	var playlistActions = {
	  noChanges: 0,
	  changed: 1,
	  removed: 2
	};
	
	var loadReducer = (0, _loadReducer2.default)('myPlaylists', {
	  myPlaylists: {},
	  updateMyPlaylists: {},
	  deleteMyPlaylist: {},
	  addMyPlaylist: {},
	  deleteMyPlaylistTrack: {},
	  addMyPlaylistTracks: {}
	});
	
	var reducer = loadReducer.reducer,
	    constantsByKey = loadReducer.constantsByKey,
	    constants = loadReducer.constants;
	
	
	var initialState = (0, _extends4.default)({}, loadReducer.initialState, {
	  kw: '',
	  checkedPlaylists: {},
	  myPlaylistsPopupVisible: false
	});
	
	function isLoaded() {
	  return function (dispatch, getState) {
	    return (0, _get3.default)(getState(), 'myPlaylists.myPlaylistsLoaded');
	  };
	}
	
	function loadMyPlaylists() {
	  return {
	    types: constantsByKey.myPlaylists,
	    promise: function promise(client) {
	      return client.post('viewer_wa/getMyPlaylists');
	    }
	  };
	}
	
	function getRequestArguments(_ref) {
	  var playlist = _ref.playlist;
	
	  var data = void 0;
	  try {
	    data = { playlist: (0, _stringify2.default)(playlist) };
	  } catch (err) {
	    _log2.default.warning(TAG, 'updateMyPlaylists stringify error');
	  }
	
	  return data;
	}
	
	function getPlaylistByGuid(_ref2) {
	  var guid = _ref2.guid;
	
	  return function (dispatch, getState) {
	    var myPlaylists = (0, _get3.default)(getState(), 'myPlaylists.myPlaylistsData', []);
	    return (0, _find3.default)(myPlaylists, { guid: guid });
	  };
	}
	
	function updateMyPlaylists(_ref3) {
	  var playlist = _ref3.playlist;
	
	  var data = getRequestArguments({ playlist: playlist });
	  return {
	    types: constantsByKey.updateMyPlaylists,
	    promise: function promise(client) {
	      return client.post('viewer_wa/setMyplaylist', { data: data });
	    },
	    playlist: playlist
	  };
	}
	
	function updateMyPlaylistName(_ref4) {
	  var guid = _ref4.guid,
	      name = _ref4.name;
	
	  return function (dispatch, getState) {
	    var myPlaylists = (0, _get3.default)(getState(), 'myPlaylists.myPlaylistsData', []);
	    var playlist = (0, _find3.default)(myPlaylists, { guid: guid });
	    if (playlist) {
	      var updatedPlaylist = (0, _extends4.default)({}, playlist);
	      updatedPlaylist.name = name;
	      updatedPlaylist.action = playlistActions.changed;
	      return dispatch(updateMyPlaylists({ playlist: [updatedPlaylist] }));
	    }
	    return false;
	  };
	}
	
	function deleteMyPlaylist(_ref5) {
	  var guid = _ref5.guid;
	
	  var data = getRequestArguments({
	    playlist: [{
	      guid: guid,
	      action: playlistActions.removed,
	      name: '',
	      list: []
	    }]
	  });
	
	  return {
	    types: constantsByKey.deleteMyPlaylist,
	    promise: function promise(client) {
	      return client.post('viewer_wa/setMyplaylist', { data: data });
	    },
	    guid: guid
	  };
	}
	
	function addMyPlaylist() {
	  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref6$name = _ref6.name,
	      name = _ref6$name === undefined ? 'New playlist' : _ref6$name;
	
	  var guid = (0, _uuid2.default)();
	  var data = getRequestArguments({
	    playlist: [{
	      guid: guid,
	      action: playlistActions.changed,
	      name: name,
	      list: []
	    }]
	  });
	
	  return {
	    types: constantsByKey.addMyPlaylist,
	    promise: function promise(client) {
	      return client.post('viewer_wa/setMyplaylist', { data: data });
	    },
	    guid: guid
	  };
	}
	
	function deleteMyPlaylistTrack(_ref7) {
	  var guid = _ref7.guid,
	      trackId = _ref7.trackId;
	
	  return function (dispatch) {
	    var playlist = (0, _extends4.default)({}, dispatch(getPlaylistByGuid({ guid: guid })));
	    if (playlist) {
	      playlist.list = playlist.list.filter(function (id) {
	        return id !== trackId;
	      });
	      playlist.action = playlistActions.changed;
	      var data = getRequestArguments({ playlist: [playlist] });
	      return dispatch({
	        types: constantsByKey.deleteMyPlaylistTrack,
	        promise: function promise(client) {
	          return client.post('viewer_wa/setMyplaylist', { data: data });
	        },
	        guid: guid,
	        trackId: trackId
	      });
	    }
	    return null;
	  };
	}
	
	function setMyPlaylistsFilter(_ref8) {
	  var kw = _ref8.kw;
	
	  return {
	    type: SET_MY_PLAYLISTS_FILTER,
	    kw: kw
	  };
	}
	
	function updateCheckedPlaylists(checkedPlaylists) {
	  return {
	    type: UPDATE_CHECKED_PLAYLISTS,
	    checkedPlaylists: checkedPlaylists
	  };
	}
	
	function checkPlaylist(_ref9) {
	  var guid = _ref9.guid;
	
	  return {
	    type: CHECK_PLAYLIST,
	    guid: guid
	  };
	}
	
	function addMyPlaylistTracks(_ref10) {
	  var guids = _ref10.guids,
	      tracksId = _ref10.tracksId;
	
	  return function (dispatch) {
	    var playlists = [];
	    guids.map(function (guid) {
	      var playlist = (0, _extends4.default)({}, dispatch(getPlaylistByGuid({ guid: guid })));
	      if (playlist) {
	        playlist.list = [].concat((0, _toConsumableArray3.default)(playlist.list), (0, _toConsumableArray3.default)(tracksId));
	        playlist.action = playlistActions.changed;
	        playlists.push(playlist);
	      }
	    });
	    if (playlists.length) {
	      var data = getRequestArguments({ playlist: playlists });
	      return dispatch({
	        types: constantsByKey.addMyPlaylistTracks,
	        promise: function promise(client) {
	          return client.post('viewer_wa/setMyplaylist', { data: data });
	        },
	        guids: guids,
	        tracksId: tracksId
	      });
	    }
	    return {};
	  };
	}

/***/ }),
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var playlistCodes = exports.playlistCodes = {
	  loginRequired: 3,
	  registrationRequired: 11,
	  contentLocked: 12,
	  notAvailable: 8,
	  userConsentRequired: 13
	};
	
	var importRecipientsCodes = exports.importRecipientsCodes = {
	  invalidContact: 5,
	  emailExists: 6,
	  groupEmailExists: 3,
	  recipientExists: 2
	};
	
	var downloadTracksCodes = exports.downloadTracksCodes = {
	  emailSent: 3,
	  needLogin: 3,
	  requireAuth: 30
	};
	
	var loginCodes = exports.loginCodes = {
	  reset: 90,
	  unlock: 91
	};
	
	var allCodes = {
	  success: 0,
	  sessionError: 1,
	  playlistCodes: playlistCodes,
	  importRecipientsCodes: importRecipientsCodes,
	  downloadTracksCodes: downloadTracksCodes,
	  loginCodes: loginCodes
	};
	
	exports.default = allCodes;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(8);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _reject2 = __webpack_require__(200);
	
	var _reject3 = _interopRequireDefault(_reject2);
	
	var _get2 = __webpack_require__(19);
	
	var _get3 = _interopRequireDefault(_get2);
	
	exports.default = reducer;
	exports.isLoaded = isLoaded;
	exports.isLoadTime = isLoadTime;
	exports.loadPlaylists = loadPlaylists;
	exports.loadPress = loadPress;
	exports.loadTracks = loadTracks;
	exports.reorder = reorder;
	exports.toggleView = toggleView;
	exports.deletePlaylist = deletePlaylist;
	exports.setTypeFilter = setTypeFilter;
	exports.filter = filter;
	
	var _loadReducer = __webpack_require__(69);
	
	var _loadReducer2 = _interopRequireDefault(_loadReducer);
	
	var _playstats = __webpack_require__(358);
	
	var _auth = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ORDER = 'playlists/ORDER'; /* Playlists (albums) redux reducer and action creators */
	
	var TOGGLE_VIEW = 'playlists/TOGGLE_VIEW';
	var SET_TYPE_FILTER = 'playlists/SET_TYPE_FILTER';
	var FILTER = 'playlists/FILTER';
	
	var loadReducer = (0, _loadReducer2.default)('playlists', {
	  playlists: { action: 'load', init: { albums: [], tracks: {} } },
	  press: { action: 'load', init: null },
	  tracks: { action: 'load', init: null },
	  deletePlaylist: { init: {} }
	});
	
	var initialState = (0, _extends4.default)({}, loadReducer.initialState, {
	  order: {
	    artist_name: 'asc',
	    sent_date: 'desc',
	    sender: 'asc',
	    label_name: 'asc',
	    releaseDate: 'desc'
	  },
	  activeOrder: 'sent_date',
	  showGroups: false,
	  orders: [{ name: 'artist_name', title: 'Artist' }, { name: 'sent_date', title: 'Date' }, { name: 'sender', title: 'Sender' }, { name: 'label_name', title: 'Label' }, { name: 'releaseDate', title: 'Release Date' }],
	  viewType: 'grid',
	  typeFilter: '',
	  kw: '',
	  displayInfo: {}
	});
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case 'RESET':
	      return initialState;
	    case ORDER:
	      return (0, _extends4.default)({}, state, {
	        order: (0, _extends4.default)({}, state.order, (0, _defineProperty3.default)({}, action.name, state.activeOrder === action.name ? state.order[action.name] === 'asc' ? 'desc' : 'asc' : state.order[action.name])),
	        showGroups: action.name !== 'sent_date',
	        activeOrder: action.name
	      });
	    case TOGGLE_VIEW:
	      return (0, _extends4.default)({}, state, {
	        viewType: state.viewType === 'grid' ? 'list' : 'grid'
	      });
	    case SET_TYPE_FILTER:
	      return (0, _extends4.default)({}, state, {
	        typeFilter: action.typeFilter
	      });
	    case loadReducer.constants.LOAD_PLAYLISTS:
	      return (0, _extends4.default)({}, loadReducer.reducer(state, action), {
	        typeFilter: action.typeFilter
	      });
	    case loadReducer.constants.LOAD_PLAYLISTS_SUCCESS:
	      return (0, _extends4.default)({}, loadReducer.reducer(state, action), {
	        typeFilter: action.typeFilter,
	        displayInfo: action.result.data.displayInfo
	      });
	    case loadReducer.constants.DELETE_PLAYLIST_SUCCESS:
	      {
	        var albums = state.playlistsData.albums;
	
	        return (0, _extends4.default)({}, state, {
	          playlistsData: (0, _extends4.default)({}, state.playlistsData, {
	            albums: (0, _reject3.default)(albums, { contentKey: action.key })
	          })
	        });
	      }
	    case FILTER:
	      return (0, _extends4.default)({}, state, {
	        kw: action.kw
	      });
	    default:
	      return loadReducer.reducer(state, action);
	  }
	}
	
	function isLoaded() {
	  return function (dispatch, getState) {
	    return (0, _get3.default)(getState(), 'playlists.playlistsLoaded');
	  };
	}
	
	function isLoadTime() {
	  return function (dispatch, getState) {
	    var state = getState();
	    return !(0, _get3.default)(state, 'playlists.playlistsLoaded') && !(0, _get3.default)(state, 'auth.user');
	  };
	}
	
	function loadPlaylists(type) {
	  var data = { type: type !== 'all' ? type : undefined };
	
	  return function (dispatch) {
	    return dispatch({
	      types: loadReducer.constantsByKey.playlists,
	      promise: function promise(client) {
	        var result = client.post('viewer_wa/playlists', { data: data });
	        result.promise.then(function (resp) {
	          dispatch((0, _playstats.setData)({ albums: resp.data.albums, albumsTracks: resp.data.tracks }));
	          return resp;
	        }).catch(function (err) {
	          return err;
	        });
	        return result;
	      },
	      typeFilter: type
	    });
	  };
	}
	
	function loadPress(_ref) {
	  var key = _ref.key;
	
	  return function (dispatch) {
	    var data = { key: key };
	    var isUser = dispatch((0, _auth.isLoggedIn)());
	    return dispatch({
	      types: loadReducer.constantsByKey.press,
	      promise: function promise(client) {
	        return client.post(isUser ? 'viewer_wa/downloadPress' : 'auth/downloadPressFromKey', { data: data });
	      }
	    });
	  };
	}
	
	function loadTracks(projectId, recipientId) {
	  var data = { project_id: projectId, recipient_id: recipientId };
	  return {
	    types: loadReducer.constantsByKey.tracks,
	    promise: function promise(client) {
	      return client.post('viewer_wa/album_tracks', { data: data });
	    }
	  };
	}
	
	function reorder(name) {
	  return {
	    type: ORDER,
	    name: name
	  };
	}
	
	function toggleView() {
	  return {
	    type: TOGGLE_VIEW
	  };
	}
	
	function deletePlaylist(_ref2) {
	  var key = _ref2.key;
	
	  var data = { key: key };
	  return {
	    types: loadReducer.constantsByKey.deletePlaylist,
	    promise: function promise(client) {
	      return client.post('viewer_wa/delete', { data: data });
	    },
	    key: key
	  };
	}
	
	function setTypeFilter(typeFilter) {
	  return {
	    type: SET_TYPE_FILTER,
	    typeFilter: typeFilter
	  };
	}
	
	function filter() {
	  var kw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	  return {
	    type: FILTER,
	    kw: kw
	  };
	}

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isUploadComplete = exports.isUploadCanceled = exports.isUploadFailed = exports.isUploadSuccess = exports.activeStatuses = exports.STATUS = undefined;
	
	var _slicedToArray2 = __webpack_require__(78);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(72);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _keys = __webpack_require__(113);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _isFinite = __webpack_require__(218);
	
	var _isFinite2 = _interopRequireDefault(_isFinite);
	
	exports.getUploaderErrorMessage = getUploaderErrorMessage;
	exports.getUploaderAcceptableFormats = getUploaderAcceptableFormats;
	exports.getSize = getSize;
	exports.formatSizeAndUnits = formatSizeAndUnits;
	exports.areUnitsEqual = areUnitsEqual;
	exports.getProgress = getProgress;
	exports.formatCloudFilesList = formatCloudFilesList;
	
	var _config = __webpack_require__(41);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// We can't import STATUS from fine-uploader library as it requires window object, so copy-paste it here
	// TODO: check and update this part if necessary on library update
	var STATUS = exports.STATUS = {
	  SUBMITTING: 'submitting',
	  SUBMITTED: 'submitted',
	  REJECTED: 'rejected',
	  QUEUED: 'queued',
	  CANCELED: 'canceled',
	  PAUSED: 'paused',
	  UPLOADING: 'uploading',
	  UPLOAD_RETRYING: 'retrying upload',
	  UPLOAD_SUCCESSFUL: 'upload successful',
	  UPLOAD_FAILED: 'upload failed',
	  DELETE_FAILED: 'delete failed',
	  DELETING: 'deleting',
	  DELETED: 'deleted'
	};
	
	var activeStatuses = exports.activeStatuses = [STATUS.SUBMITTING, STATUS.SUBMITTED, STATUS.QUEUED, STATUS.UPLOADING, STATUS.UPLOAD_RETRYING, STATUS.UPLOAD_FAILED, STATUS.UPLOAD_SUCCESSFUL];
	
	var isUploadSuccess = exports.isUploadSuccess = function isUploadSuccess(status) {
	  return status === STATUS.UPLOAD_SUCCESSFUL;
	};
	var isUploadFailed = exports.isUploadFailed = function isUploadFailed(status) {
	  return status === STATUS.UPLOAD_FAILED;
	};
	var isUploadCanceled = exports.isUploadCanceled = function isUploadCanceled(status) {
	  return status === STATUS.CANCELED;
	};
	var isUploadComplete = exports.isUploadComplete = function isUploadComplete(status) {
	  return isUploadSuccess(status) || isUploadFailed(status) || isUploadCanceled(status);
	};
	
	function getUploaderErrorMessage(err) {
	  var t = __webpack_require__(56).getT();
	  var msg = err;
	  switch (err) {
	    case 'tooManyFilesError':
	      msg = t('Too many files');break;
	    default:
	      msg = err;break;
	  }
	
	  return msg;
	}
	
	function getUploaderAcceptableFormats(type) {
	  var supportedFormats = _config2.default.app.uploaderSupportedFormats[type] || _config2.default.app.uploaderSupportedFormats.audio;
	  return supportedFormats.map(function (val) {
	    return '.' + val;
	  }).join(', ');
	}
	
	function getSize(uploader, id) {
	  var res = 0;
	  if ((0, _isFinite2.default)(id)) {
	    res = uploader.methods.getSize(id);
	  } else {
	    var filter = { status: activeStatuses };
	    var uploads = uploader.methods.getUploads(filter);
	    uploads.map(function (upload) {
	      return res += upload.size;
	    });
	  }
	
	  return (0, _isFinite2.default)(res) ? res : null;
	}
	
	function formatSizeAndUnits(size) {
	  var units = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { byte: 'B', kilobyte: 'KB', megabyte: 'MB', gigabyte: 'GB', terabyte: 'TB' };
	
	  var formattedSize = void 0;
	  var formattedUnits = void 0;
	
	  if (size < 1e+3) {
	    formattedSize = size;
	    formattedUnits = units.byte;
	  } else if (size >= 1e+3 && size < 1e+6) {
	    formattedSize = (size / 1e+3).toFixed(2);
	    formattedUnits = units.kilobyte;
	  } else if (size >= 1e+6 && size < 1e+9) {
	    formattedSize = (size / 1e+6).toFixed(2);
	    formattedUnits = units.megabyte;
	  } else if (size >= 1e+9 && size < 1e+12) {
	    formattedSize = (size / 1e+9).toFixed(2);
	    formattedUnits = units.gigabyte;
	  } else {
	    formattedSize = (size / 1e+12).toFixed(2);
	    formattedUnits = units.terabyte;
	  }
	
	  return { formattedSize: formattedSize, formattedUnits: formattedUnits };
	}
	
	function areUnitsEqual(units1, units2) {
	  var keys1 = (0, _keys2.default)(units1);
	
	  if (keys1.length === (0, _keys2.default)(units2).length) {
	    return keys1.every(function (key1) {
	      return units1[key1] === units2[key1];
	    });
	  }
	
	  return false;
	}
	
	function getProgress(bytesUploaded, totalSize) {
	  return totalSize ? Math.ceil(100 * bytesUploaded / totalSize) : null;
	}
	
	function formatCloudFilesList(files, service, fields) {
	  var formattedList = [];
	  var links = [];
	
	  files.map(function (file) {
	    var fileObject = { service: service };
	    (0, _entries2.default)(fields).map(function (_ref) {
	      var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	          formattedField = _ref2[0],
	          serviceField = _ref2[1];
	
	      fileObject[formattedField] = file[serviceField];
	    });
	    formattedList.push(fileObject);
	
	    links.push(fileObject.link);
	  });
	
	  return { files: formattedList, links: links };
	}

/***/ }),
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getRecipientPlayStats = exports.getRecipientProjects = exports.getRecipientDetailedData = exports.getProjectInfo = exports.getPlayStatsData = exports.getRecipientGlobalData = exports.getDevicesData = exports.getGeographyCitiesData = exports.getGeographyCountriesData = exports.getTracksDetailsData = exports.getRecipientFromList = exports.getCoverageDataRecipient = exports.getCoverageData = exports.getPopularityData = exports.getRecipients = exports.getMyProjects = exports.getPreparedFilteredMyProjects = exports.getAvailableProjects = exports.getStatsViewers = undefined;
	
	var _toConsumableArray2 = __webpack_require__(34);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _get2 = __webpack_require__(19);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _find2 = __webpack_require__(95);
	
	var _find3 = _interopRequireDefault(_find2);
	
	var _reselect = __webpack_require__(125);
	
	var _statistics = __webpack_require__(67);
	
	var _projects = __webpack_require__(28);
	
	var _recipients = __webpack_require__(264);
	
	var _pagination = __webpack_require__(357);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _getStatsViewers = function _getStatsViewers(state) {
	  return state.statistics.statsViewersData || [];
	};
	var _getAvailableProjects = function _getAvailableProjects(state) {
	  return state.statistics.availableProjectsData || [];
	};
	var _getProjectsActiveOrder = function _getProjectsActiveOrder(state) {
	  return state.statistics.projectsActiveOrder;
	};
	var _getProjectsOrder = function _getProjectsOrder(state) {
	  return state.statistics.projectsOrder;
	};
	var _getProjectsKw = function _getProjectsKw(state) {
	  return state.statistics.projectsKw;
	};
	var _getRecipients = function _getRecipients(state) {
	  return state.statistics.recipientsData;
	};
	var _getRecipientsActiveOrder = function _getRecipientsActiveOrder(state) {
	  return state.statistics.recipientsActiveOrder;
	};
	var _getRecipientsOrder = function _getRecipientsOrder(state) {
	  return state.statistics.recipientsOrder;
	};
	var _getRecipientsKw = function _getRecipientsKw(state) {
	  return state.statistics.recipientsKw;
	};
	var _getAllMyProjects = function _getAllMyProjects(state) {
	  return state.statistics.myProjectsData;
	};
	var _getPopularityData = function _getPopularityData(state, standalone) {
	  return (0, _get3.default)(state.statistics, standalone ? 'popularityStatsData' : ['activityStatsData', 'popularity']);
	};
	var _getCoverageData = function _getCoverageData(state, standalone) {
	  return (0, _get3.default)(state.statistics, standalone ? 'coverageStatsData' : ['activityStatsData', 'coverage']);
	};
	var _getGeographyData = function _getGeographyData(state, standalone) {
	  return (0, _get3.default)(state.statistics, standalone ? 'geographyStatsData' : ['activityStatsData', 'geography']);
	};
	var _getDevicesData = function _getDevicesData(state, standalone) {
	  return (0, _get3.default)(state.statistics, standalone ? 'devicesStatsData' : ['activityStatsData', 'devices']);
	};
	var _getPlayStatsData = function _getPlayStatsData(state, standalone) {
	  return (0, _get3.default)(state.statistics, standalone ? 'playStatsData' : ['activityStatsData', 'playStats']);
	};
	var _getTracksDetailsData = function _getTracksDetailsData(state) {
	  return (0, _get3.default)(state.statistics, 'tracksDetailsStatsData');
	};
	var _getCoverageRecipientsActiveOrder = function _getCoverageRecipientsActiveOrder(state) {
	  return state.statistics.coverageRecipientsActiveOrder;
	};
	var _getCoverageRecipientsOrder = function _getCoverageRecipientsOrder(state) {
	  return state.statistics.coverageRecipientsOrder;
	};
	var _getProjectInfo = function _getProjectInfo(state) {
	  return state.statistics.projectInfoData;
	};
	var _getRecipientDetailedData = function _getRecipientDetailedData(state) {
	  return state.statistics.recipientDetailedStatsData || [];
	};
	var _getCoverageDataRecipientId = function _getCoverageDataRecipientId(state, recipientId) {
	  return recipientId;
	};
	var _getRecipientsDataRecipientId = function _getRecipientsDataRecipientId(state, recipientId) {
	  return recipientId;
	};
	var _getRecipientGlobalData = function _getRecipientGlobalData(state) {
	  return (0, _get3.default)(state.statistics, 'recipientOverallStatsData.generalStats');
	};
	var _getRecipientProjects = function _getRecipientProjects(state) {
	  return (0, _get3.default)(state.statistics, 'recipientOverallStatsData.projects');
	};
	var _getRecipientProjectsActiveOrder = function _getRecipientProjectsActiveOrder(state) {
	  return state.statistics.recipientProjectsActiveOrder;
	};
	var _getRecipientProjectsOrder = function _getRecipientProjectsOrder(state) {
	  return state.statistics.recipientProjectsOrder;
	};
	var _getMyProjectsListPage = function _getMyProjectsListPage(state) {
	  return state.statistics.myProjectsListPage;
	};
	
	var getStatsViewers = exports.getStatsViewers = (0, _reselect.createSelector)([_getStatsViewers], function (data) {
	  return (0, _statistics.processStatsViewers)(data);
	});
	
	var getProcessedAvailableProjects = (0, _reselect.createSelector)([_getAvailableProjects], _projects.processProjects);
	
	var getAvailableProjects = exports.getAvailableProjects = (0, _reselect.createSelector)([getProcessedAvailableProjects, _getProjectsActiveOrder, _getProjectsOrder, _getProjectsKw], function () {
	  return _projects.getFilteredProjects.apply(undefined, arguments);
	});
	
	var getAllMyProjects = (0, _reselect.createSelector)([_getAllMyProjects], function (projectsByTypes) {
	  return [].concat((0, _toConsumableArray3.default)(projectsByTypes[_projects.projectTypes.audio]), (0, _toConsumableArray3.default)(projectsByTypes[_projects.projectTypes.video]));
	});
	
	var getPreparedMyProjects = (0, _reselect.createSelector)([getAllMyProjects], _projects.prepareProjects);
	
	var getPreparedFilteredMyProjects = exports.getPreparedFilteredMyProjects = (0, _reselect.createSelector)([getPreparedMyProjects, _getProjectsActiveOrder, _getProjectsOrder, _getProjectsKw], function () {
	  return _projects.getFilteredProjects.apply(undefined, arguments);
	});
	
	var getMyProjects = exports.getMyProjects = (0, _reselect.createSelector)([getPreparedFilteredMyProjects, _getMyProjectsListPage], function (projects, page) {
	  var _getFromTo = (0, _pagination.getFromTo)({ page: page, limit: _statistics.pageLimit }),
	      from = _getFromTo.from,
	      to = _getFromTo.to;
	
	  var countAll = projects.length;
	  return {
	    projects: (0, _projects.processProjects)(projects.slice(from, to)),
	    countAll: countAll
	  };
	});
	
	var getRecipients = exports.getRecipients = (0, _reselect.createSelector)([_getRecipients, _getRecipientsActiveOrder, _getRecipientsOrder, _getRecipientsKw], function () {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var recipients = args[0],
	      activeOrder = args[1],
	      order = args[2],
	      kw = args[3];
	
	  return (0, _recipients.getFilteredRecipients)({ recipients: recipients, activeOrder: activeOrder, order: order, kw: kw });
	});
	
	var getPopularityData = exports.getPopularityData = (0, _reselect.createSelector)([_getPopularityData], _statistics.processPopularityData);
	
	var getCoverageData = exports.getCoverageData = (0, _reselect.createSelector)([_getCoverageData, _getCoverageRecipientsActiveOrder, _getCoverageRecipientsOrder], function (data, activeOrder, order) {
	  return (0, _statistics.getOrderedCoverageData)({ data: data, activeOrder: activeOrder, order: order });
	});
	
	var getCoverageDataRecipient = exports.getCoverageDataRecipient = (0, _reselect.createSelector)([getCoverageData, _getCoverageDataRecipientId], function (data, recipientId) {
	  return (0, _find3.default)((0, _get3.default)(data, 'playedRecipients', []), { recipientId: recipientId });
	});
	
	var getRecipientFromList = exports.getRecipientFromList = (0, _reselect.createSelector)([_getRecipients, _getRecipientsDataRecipientId], function () {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var recipientId = arguments[1];
	  return (0, _find3.default)((0, _recipients.processRecipients)(data), { id: recipientId });
	});
	
	var getTracksDetailsData = exports.getTracksDetailsData = (0, _reselect.createSelector)([_getTracksDetailsData], _statistics.processTracksDetailsData);
	
	var getGeographyCountriesData = exports.getGeographyCountriesData = (0, _reselect.createSelector)([_getGeographyData], _statistics.processGeographyCountriesData);
	
	var getGeographyCitiesData = exports.getGeographyCitiesData = (0, _reselect.createSelector)([_getGeographyData], _statistics.processGeographyCitiesData);
	
	var getDevicesData = exports.getDevicesData = (0, _reselect.createSelector)([_getDevicesData], _statistics.processDevicesData);
	
	var getRecipientGlobalData = exports.getRecipientGlobalData = (0, _reselect.createSelector)([_getRecipientGlobalData], _statistics.processRecipientGlobalData);
	
	var getPlayStatsData = exports.getPlayStatsData = (0, _reselect.createSelector)([_getPlayStatsData], _statistics.processPlayStatsData);
	
	var getProjectInfo = exports.getProjectInfo = (0, _reselect.createSelector)([_getProjectInfo], _statistics.processProjectInfo);
	
	var getRecipientDetailedData = exports.getRecipientDetailedData = (0, _reselect.createSelector)([_getRecipientDetailedData], _statistics.processRecipientDetailedData);
	
	var getRecipientProjects = exports.getRecipientProjects = (0, _reselect.createSelector)([_getRecipientProjects, _getRecipientProjectsActiveOrder, _getRecipientProjectsOrder], function (data, activeOrder, order) {
	  return (0, _statistics.processRecipientProjects)({ data: data, activeOrder: activeOrder, order: order });
	});
	
	var getRecipientPlayStats = exports.getRecipientPlayStats = (0, _reselect.createSelector)([_getRecipientProjects], function (data) {
	  return (0, _statistics.processRecipientProjectsPlayStats)({ data: data });
	});

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.nodes = exports.node = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var node = exports.node = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]);
	
	var nodes = exports.nodes = _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]);

/***/ }),
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _isFinite = __webpack_require__(218);
	
	var _isFinite2 = _interopRequireDefault(_isFinite);
	
	var _promise = __webpack_require__(62);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _desc, _value, _class;
	
	var _audioplayer = __webpack_require__(83);
	
	var _config = __webpack_require__(41);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _reactCookie = __webpack_require__(174);
	
	var _utils = __webpack_require__(24);
	
	var _datetime = __webpack_require__(68);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var cookies = new _reactCookie.Cookies();
	
	var _endedHandler = function endedHandler() {};
	var useCrossfade = true;
	// check audio position every N msec
	var checkPositionIntervalMs = 50;
	/* stop playback for N msec before the end of the song for gapless playing
	 HTML5 audio 'ended' event has a small gap between the song actually ends, so check the end of the song by interval */
	var stopBeforeMs = (0, _utils.isIOS)() ? 1500 : 700; // iPhone is very slow to do crossfade in less 1 second
	// time before the current audio will be stopped after the next audio starts
	var crossfadeDelay = checkPositionIntervalMs * 2;
	// volume changes steps count, every 50 ms but not more than 20 steps
	var crossfadeSteps = Math.ceil(Math.min(stopBeforeMs / 50, 20));
	var startPlayingFrom = 0; // seconds
	var defaultTitle = 'No Artist';
	
	var AudioPlayer = (_class = function () {
	  function AudioPlayer() {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, AudioPlayer);
	
	    this.getTrackSrc = function (trackName) {
	      return _config2.default.app.srcMasks.audio.replace('<trackName>', trackName);
	    };
	
	    this.getPosition = function () {
	      return _this.audio ? _this.audio.currentTime : 0;
	    };
	
	    this.getDuration = function () {
	      var audio = _this.getAudio();
	
	      var res = new _promise2.default(function (resolve, reject) {
	        if (!audio) {
	          reject(0);
	          return res;
	        }
	
	        if (audio.readyState) {
	          resolve(audio.duration);
	        } else {
	          _this.audio.addEventListener('loadedmetadata', function onLoaded() {
	            resolve(audio.duration);
	            audio.removeEventListener('loadedmetadata', onLoaded);
	          });
	        }
	      });
	
	      return res;
	    };
	
	    this._volume = Number(cookies.get('volume')) || 1;
	    this.audioContainer = {};
	    this.positionInterval = 0;
	    this.callbacks = {};
	    this.status = {
	      stop: 'stop',
	      play: 'play',
	      pause: 'pause'
	    };
	  }
	
	  (0, _createClass3.default)(AudioPlayer, [{
	    key: 'on',
	    value: function on(event, cb) {
	      if (!this.callbacks[event]) {
	        this.callbacks[event] = [];
	      }
	      this.callbacks[event].push(cb);
	    }
	  }, {
	    key: 'off',
	    value: function off(event, cb) {
	      var _this2 = this;
	
	      if (!this.callbacks[event]) {
	        return false;
	      }
	      this.callbacks[event].map(function (eventCb, index) {
	        if (eventCb === cb) {
	          _this2.callbacks[event].splice(index, 1);
	        }
	      });
	    }
	  }, {
	    key: 'runCallbacks',
	    value: function runCallbacks(event) {
	      this.callbacks[event].map(function (eventCb) {
	        if (eventCb) {
	          eventCb();
	        }
	      });
	    }
	  }, {
	    key: 'getHumanizedPosition',
	    value: function getHumanizedPosition() {
	      var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getPosition();
	
	      return (0, _datetime.secToMin)(position);
	    }
	
	    /* Mobile browsers don't have access to play()
	     * we create 2 Audio: first for current playing audio and second for precache next audio
	     * and switch between them for gapless playing */
	
	  }, {
	    key: '_initAudioContainer',
	    value: function _initAudioContainer() {
	      var audioContainer = this.audioContainer;
	
	
	      if (!audioContainer.audio) {
	        audioContainer.audio = [new Audio(), new Audio()];
	        // play() and pause() are needed for mobile devices, where audio can be played only by user interaction
	        audioContainer.audio[0].play();
	        audioContainer.audio[0].pause();
	        audioContainer.audio[1].play();
	        audioContainer.audio[1].pause();
	        audioContainer.audioIndex = 1;
	        audioContainer.queueIndex = 0;
	      }
	    }
	  }, {
	    key: '_switchPrecacheActiveAudio',
	    value: function _switchPrecacheActiveAudio() {
	      this.audioContainer.audioIndex = this.audioContainer.audioIndex ? 0 : 1;
	      this.audioContainer.queueIndex = this.audioContainer.queueIndex ? 0 : 1;
	      console.log('_switchPrecacheActiveAudio ' + this.audioContainer.audioIndex);
	    }
	  }, {
	    key: 'getAudio',
	    value: function getAudio() {
	      return this.audioContainer.audio ? this.audioContainer.audio[this.audioContainer.audioIndex] : null;
	    }
	  }, {
	    key: 'getQueuedAudio',
	    value: function getQueuedAudio() {
	      return this.audioContainer.audio ? this.audioContainer.audio[this.audioContainer.queueIndex] : null;
	    }
	  }, {
	    key: '_startPrecache',
	    value: function _startPrecache() {
	      var audioContainer = this.audioContainer;
	
	      var audio = this.getQueuedAudio();
	      if (!audioContainer.src) {
	        return false;
	      }
	
	      console.log('start audioContainer to ' + this.audioContainer.queueIndex + ': ' + audioContainer.src);
	
	      if (audio.src === audioContainer.src) {
	        this.setCurrentTime(audio, 0);
	      } else {
	        audio.src = audioContainer.src;
	        audio.title = audioContainer.title;
	        this.setCurrentTime(audio, 0);
	        /* HACK: force preload .mp3 for slow connections
	         * Chrome doesn't preload mp3 if connection is slow until audio starting play && volume > 0 */
	        audio.preload = 'auto';
	        audio.volume = 0.001;
	        // audioContainer.initPlayTimer = setTimeout(() => audio.pause(), 150);
	        audio.addEventListener('playing', function onLoaded() {
	          console.log('on playing callback');
	          audio.pause();
	          audio.volume = 0;
	          audio.removeEventListener('playing', onLoaded);
	        });
	        audio.play();
	      }
	    }
	  }, {
	    key: '_stopPrecacheTimer',
	    value: function _stopPrecacheTimer() {
	      clearTimeout(this.audioContainer.precacheTimer);
	      clearTimeout(this.audioContainer.initPlayTimer);
	    }
	  }, {
	    key: 'updatePrecacheTimer',
	    value: function updatePrecacheTimer(duration) {
	      if (!this.audio || this.audioContainer.src === this.audio.src) {
	        return false;
	      }
	
	      var delay = duration - this.getPosition() - _config2.default.app.audioPrecacheBeforeTime;
	      if (delay < 0) {
	        delay = 0;
	      }
	      console.log('set precache delay ' + delay);
	      this.audioContainer.precacheTimer = setTimeout(this._startPrecache, delay * 1000);
	    }
	  }, {
	    key: 'updatePositionInterval',
	    value: function updatePositionInterval(duration) {
	      var _this3 = this;
	
	      clearInterval(this.positionInterval);
	      var audio = this.audio;
	
	      if (audio) {
	        if (duration) {
	          this.positionInterval = setInterval(function () {
	            if ((duration - _this3.getPosition()) * 1000 < stopBeforeMs) {
	              clearInterval(_this3.positionInterval);
	              _this3.runCallbacks('ended');
	            }
	          }, checkPositionIntervalMs);
	        } else {
	          // rare bug on android when can't calc duration
	          audio.removeEventListener('ended', _endedHandler);
	          _endedHandler = function endedHandler() {
	            audio.removeEventListener('ended', _endedHandler);
	            _this3.runCallbacks('ended');
	          };
	          audio.addEventListener('ended', _endedHandler);
	        }
	      }
	    }
	  }, {
	    key: 'updatePlayTimers',
	    value: function updatePlayTimers() {
	      var _this4 = this;
	
	      this._stopPrecacheTimer();
	
	      this.getDuration().then(function (duration) {
	        _this4.updatePrecacheTimer(duration);
	        _this4.updatePositionInterval(duration);
	      });
	    }
	  }, {
	    key: 'clearPrecache',
	    value: function clearPrecache() {
	      this._stopPrecacheTimer();
	    }
	  }, {
	    key: 'crossfade',
	    value: function crossfade(fromAudio, toAudio) {
	      console.log('crossfading');
	      var fromLeftTime = (fromAudio.duration - fromAudio.currentTime) * 1000;
	      if (fromLeftTime && fromLeftTime > checkPositionIntervalMs) {
	        var stepDelay = fromLeftTime / crossfadeSteps;
	        var fromVolume = fromAudio.volume;
	        var toVolume = toAudio.volume;
	
	        var runCrossfadeStep = function runCrossfadeStep(step) {
	          var percent = step / crossfadeSteps;
	          fromAudio.volume = fromVolume * Math.cos(0.5 * percent * Math.PI);
	          toAudio.volume = step === crossfadeSteps ? toVolume : toVolume * Math.cos(0.5 * (1 - percent) * Math.PI);
	          // console.log('crossfade from ' + fromAudio.volume);
	          // console.log('crossfade to ' + toAudio.volume);
	        };
	
	        var crossfadeStep = function crossfadeStep(step) {
	          if (step > crossfadeSteps) {
	            return fromAudio.pause();
	          }
	          if (step === 1) {
	            runCrossfadeStep(0);
	          }
	          setTimeout(function () {
	            runCrossfadeStep(step);
	            crossfadeStep(step + 1);
	          }, stepDelay);
	        };
	
	        crossfadeStep(1);
	      }
	    }
	  }, {
	    key: 'getTitle',
	    value: function getTitle(title) {
	      return title || defaultTitle;
	    }
	  }, {
	    key: 'setCurrentTime',
	    value: function setCurrentTime(audio, time) {
	      try {
	        audio.currentTime = time;
	      } catch (err) {
	        // stupid IE workaround
	        console.warn('Error: Direct setting of audio.currentTime. Trying to set current time on loadedmetadata', err);
	        audio.addEventListener('loadedmetadata', function onLoaded() {
	          audio.currentTime = time;
	          audio.removeEventListener('loadedmetadata', onLoaded);
	        });
	      }
	    }
	  }, {
	    key: 'getLeftTime',
	    value: function getLeftTime(audio) {
	      return (audio.duration - audio.currentTime) * 1000;
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      var current = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      this._initAudioContainer();
	      var precacheAudio = this.getQueuedAudio();
	      var currentAudio = null;
	      var currentLeft = 0;
	
	      if (current.src) {
	        if (precacheAudio && precacheAudio.src === current.src) {
	          currentAudio = this.getAudio();
	          currentLeft = this.getLeftTime(currentAudio);
	          this._switchPrecacheActiveAudio();
	          this.audio = this.getAudio();
	          this.clearPrecache();
	        } else {
	          this.audio = this.getAudio();
	          this.audio.pause();
	          this.audio.src = current.src;
	          this.audio.title = this.getTitle(current.title);
	        }
	
	        (0, _audioplayer.updatePosition)(0);
	        this.volume(this._volume);
	
	        if (next.src) {
	          this.audioContainer.src = next.src;
	          this.audioContainer.title = this.getTitle(next.title);
	        }
	
	        this.setCurrentTime(this.audio, startPlayingFrom);
	      }
	
	      if (currentAudio) {
	        // is it last seconds of the song?
	        // add 2 x checkPositionIntervalMs to be sure that after stop event occurs, song doesn't have a time to progress more than stopBeforeMs time
	        if (currentLeft && currentLeft < stopBeforeMs + checkPositionIntervalMs * 2) {
	          if (useCrossfade) {
	            this.crossfade(currentAudio, this.audio);
	          }
	        } else {
	          setTimeout(function () {
	            currentAudio.pause();
	            currentAudio.currentTime = startPlayingFrom;
	          }, crossfadeDelay);
	        }
	      }
	
	      if (this.audio) {
	        this.audio.play();
	        this.updatePlayTimers();
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      var audio = this.getAudio();
	
	      if (audio) {
	        audio.pause();
	        this._stopPrecacheTimer();
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      var audio = this.getAudio();
	
	      if (audio) {
	        audio.pause();
	        this._stopPrecacheTimer();
	      }
	      this._initAudioContainer();
	
	      return false;
	    }
	  }, {
	    key: 'volume',
	    value: function volume() {
	      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      if (val !== null) {
	        this._volume = val;
	        cookies.set('volume', val, { path: '/' });
	
	        var audio = this.getAudio();
	        if (audio) {
	          audio.volume = val;
	        }
	      }
	      return this._volume;
	    }
	  }, {
	    key: 'seek',
	    value: function seek(sec) {
	      var audio = this.getAudio();
	
	      if (audio.src && (0, _isFinite2.default)(sec)) {
	        audio.currentTime = sec;
	        this.updatePlayTimers();
	        return sec;
	      }
	      return null;
	    }
	  }, {
	    key: 'getPlayingInfo',
	    value: function getPlayingInfo(_ref) {
	      var track = _ref.track,
	          album = _ref.album,
	          playerAlbum = _ref.playerAlbum,
	          currentPlayerTrack = _ref.currentPlayerTrack,
	          playerStatus = _ref.playerStatus;
	
	      var isAlbumPlaying = album.projectId === playerAlbum.projectId;
	      var isActiveTrack = isAlbumPlaying && currentPlayerTrack.id === track.id;
	      var isPlayerPlaying = playerStatus === this.status.play;
	      var isTrackPlaying = isActiveTrack && isPlayerPlaying;
	
	      return { isAlbumPlaying: isAlbumPlaying, isActiveTrack: isActiveTrack, isPlayerPlaying: isPlayerPlaying, isTrackPlaying: isTrackPlaying };
	    }
	  }]);
	  return AudioPlayer;
	}(), (_applyDecoratedDescriptor(_class.prototype, '_startPrecache', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_startPrecache'), _class.prototype)), _class);
	exports.default = new AudioPlayer();
	module.exports = exports['default'];

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getSharespaceProjects = exports.getGroupedRecipients = exports.getRecipients = exports.getProjectData = exports.getProjects = exports.getPreparedFilteredProjects = exports.getPreparedProjects = exports.getVideoProjects = exports.getAudioProjects = exports.getSharespaces = exports.getNewsletters = exports.getPartTracks = undefined;
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _toConsumableArray2 = __webpack_require__(34);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _reselect = __webpack_require__(125);
	
	var _projects = __webpack_require__(28);
	
	var _recipients = __webpack_require__(264);
	
	var _Playlists = __webpack_require__(214);
	
	var _pagination = __webpack_require__(357);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _getRecipients = function _getRecipients(state) {
	  return state.project.recipientsListData;
	}; /* Projects reselect */
	
	var _getProject = function _getProject(state) {
	  return state.project.projectData;
	};
	var _getNewsletters = function _getNewsletters(state) {
	  return state.projects.projectsData.newsletters;
	};
	var _getSharespaces = function _getSharespaces(state) {
	  return state.projects.projectsData.sharespace;
	};
	var _getAudioProjects = function _getAudioProjects(state) {
	  return state.projects.projectsData.audio;
	};
	var _getVideoProjects = function _getVideoProjects(state) {
	  return state.projects.projectsData.video;
	};
	var _getActiveOrder = function _getActiveOrder(state) {
	  return state.projects.activeOrder;
	};
	var _getOrder = function _getOrder(state) {
	  return state.projects.order;
	};
	var _getKw = function _getKw(state) {
	  return state.projects.kw;
	};
	var _getProjectsType = function _getProjectsType(state, props) {
	  return props.projectType;
	};
	var _getSSProjects = function _getSSProjects(state) {
	  return state.project.ssProjectsListData;
	};
	var _getMediaList = function _getMediaList(state) {
	  return state.project.mediaListData;
	};
	var _getProjectsListPage = function _getProjectsListPage(state) {
	  return state.projects.projectsListPage;
	};
	
	var getPartTracks = exports.getPartTracks = (0, _reselect.createSelector)([_getMediaList], function (tracks) {
	  return (0, _Playlists.getPartTracks)(tracks);
	});
	
	var getProcessedNewsletters = (0, _reselect.createSelector)([_getNewsletters], _projects.processProjects);
	var getProcessedSharespaces = (0, _reselect.createSelector)([_getSharespaces], _projects.processProjects);
	var getProcessedAudioProjects = (0, _reselect.createSelector)([_getAudioProjects], _projects.processProjects);
	var getProcessedVideoProjects = (0, _reselect.createSelector)([_getVideoProjects], _projects.processProjects);
	
	var getNewsletters = exports.getNewsletters = (0, _reselect.createSelector)([getProcessedNewsletters, _getActiveOrder, _getOrder, _getKw], function () {
	  return _projects.getFilteredProjects.apply(undefined, arguments);
	});
	
	var getSharespaces = exports.getSharespaces = (0, _reselect.createSelector)([getProcessedSharespaces, _getActiveOrder, _getOrder, _getKw], function () {
	  return _projects.getFilteredProjects.apply(undefined, arguments);
	});
	
	var getAudioProjects = exports.getAudioProjects = (0, _reselect.createSelector)([getProcessedAudioProjects, _getActiveOrder, _getOrder, _getKw], function () {
	  return _projects.getFilteredProjects.apply(undefined, arguments);
	});
	
	var getVideoProjects = exports.getVideoProjects = (0, _reselect.createSelector)([getProcessedVideoProjects, _getActiveOrder, _getOrder, _getKw], function () {
	  return _projects.getFilteredProjects.apply(undefined, arguments);
	});
	
	var getProjectsOfType = (0, _reselect.createSelector)([_getProjectsType, _getSharespaces, _getAudioProjects, _getVideoProjects], function (type, sharespaces, audioProjects, videoProjects) {
	  var _types;
	
	  var types = (_types = {}, (0, _defineProperty3.default)(_types, _projects.projectTypes.sharespace, sharespaces), (0, _defineProperty3.default)(_types, _projects.projectTypes.audio, audioProjects), (0, _defineProperty3.default)(_types, _projects.projectTypes.video, videoProjects), (0, _defineProperty3.default)(_types, 'all', [].concat((0, _toConsumableArray3.default)(audioProjects), (0, _toConsumableArray3.default)(videoProjects), (0, _toConsumableArray3.default)(sharespaces))), _types);
	  return types[type] || audioProjects;
	});
	
	var getPreparedProjects = exports.getPreparedProjects = (0, _reselect.createSelector)([getProjectsOfType], _projects.prepareProjects);
	
	var getPreparedFilteredProjects = exports.getPreparedFilteredProjects = (0, _reselect.createSelector)([getPreparedProjects, _getActiveOrder, _getOrder, _getKw], function () {
	  return _projects.getFilteredProjects.apply(undefined, arguments);
	});
	
	var getProjects = exports.getProjects = (0, _reselect.createSelector)([getPreparedFilteredProjects, _getProjectsListPage], function (projects, page) {
	  var _getFromTo = (0, _pagination.getFromTo)({ page: page, limit: _projects.pageLimit }),
	      from = _getFromTo.from,
	      to = _getFromTo.to;
	
	  var countAll = projects.length;
	  return {
	    projects: (0, _projects.processProjects)(projects.slice(from, to)),
	    countAll: countAll
	  };
	});
	
	var getProjectData = exports.getProjectData = (0, _reselect.createSelector)([_getProject], function (project) {
	  return (0, _projects.processProject)(project);
	});
	
	var getRecipients = exports.getRecipients = (0, _reselect.createSelector)([_getRecipients], _recipients.processRecipients);
	
	var getGroupedRecipients = exports.getGroupedRecipients = (0, _reselect.createSelector)([_getRecipients], _recipients.groupRecipients);
	
	var getSharespaceProjects = exports.getSharespaceProjects = (0, _reselect.createSelector)([_getSSProjects], function (projects) {
	  return (0, _projects.processProjects)(projects);
	});

/***/ }),
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"h1":"_38GXPlhZNl8qCOrtFgd-FA","h2":"_2KCrPi0ICdig__Kt6rbirH","h3":"_1-VyYz6Gy3thrxQ3vFornk","margin-free":"_3qwusSAhc7NOICliISNKkB","h5":"_3rx1qpGehv3jd9hSNUlTrG","hint":"SAVFDKFTnUzF29_Uc7jDq","small":"_2vYT2zbjpISghqVzVXsbdz","default":"_3tVsQ6VHtOBIcoHycHPcYZ","text-overflow":"_2ooWi1_hvj9smoVDvX6I_p","nowrap":"_2gm2tSkJX_bGP3yF6NSYFR","break-word":"_29DDG144nkjfVd-A3ZfdsL","u":"wuW3H4eOszmrZAEi9Enk","underline":"_3opuwfHyPshTecbIsjjOh2","bold":"suasPBekQWWlEKhXtZ8vI","b":"_8eq-OQsPkmrR5LFx6JCId","italic":"_2GBAN1Kj0eSUTcq391NaLY","upper":"RxK8KpcGolMFSCJ5KS8lj","lower":"eRCxojbn4CFImN36Il46t","text-z1":"Q-4feGw8j2bG035jVHHVV","text-z2":"_1zup8ateLTq9a8kXgWXCHl","disabled":"_3BzfnE5iEtuj5E-sQcUqZa","error":"_3qHks_mYcP2PnSksOMoyKz","danger":"S59RJsRGc9Wl1vxtrwWl-","colorLighten":"_1dJYsBBwVJp_Su-Zh-cudn","colorLight":"_3-C7bkmXDyITqZ_CP0giEr","colorMiddle":"CM9h_YpjD2uLAl3YQiFSf","colorDark":"_1RavaQWbJTC2hIEcocDbLv","colorDarken":"_2mSzv6qY32fDLBxRjftsGM","colorSuccess":"_3HghW3_z1vcAxwIiKI-JQV","colorInfo":"oV_gzR8JYQjxtVmRffyni","colorWarning":"_3TZ10HFBomW-DIE9La3Jd","colorError":"_1ot0mHTzQBP0A9dxO9qNrc","colorPrimary":"_2-5m6IpoEFnqjA_ehgc1wM","empty-space":"_2a2EmoxikSCsNv-E8wLrsU","no-select":"_8AJ4jZ17wDBlDXUzQt5uH","z1":"_2AIywK3ryKy8-UOZfFwsLs","z2":"_2oqH7GVSo2iXCr3dvEJ3Nr","pos-rel":"OjpVlI-l-SqXJMA5-tlY7","pos-abs":"i2hNI0jCRD_VfN5PFcQ-P","overflow-hidden":"_15Nfo7EFnCGm6dw-3k7pk4","overflow-x-auto":"_2g4_5zUROYvsnS4cVFeKOY","inline-block":"_3_3PSV5bSs4W89GoFs_WV2","table":"_3ame2X-iVFU6Lx5WFDBXnQ","table-row":"_1e992I1xp9x3lcPqthYGu9","table-cell":"q8aj4NutkVh4wTy0HZSaD","three-d":"_1dRYEKgn4dqBjZnDiYrjq","z-layer":"_13iCQxET-zgumO2Qyl_uvz","ratio-cont":"_14uwWirt1TcG8E8hZpLDTt","padding-5":"_15Qscaqj5t_G3rNWUtahEb","padding-10":"_2sC0zNE-6m0AYNit-C8kQP","padding-15":"_18WcgvmOSVl00rrSW5ofml","padding-top-5":"_1IH8OR0EMENjl-ECoHOC3b","padding-left-10":"_277-I0E9l5fhmyhMJdWQSn","padding-right-10":"_3ri5F5mU0AB9v8bsM_PPu4","padding-right-20":"_7o3_2W-ihUzqxSnFTdSz-","margin-10":"lD85iED_CLCwYAbmyfjOr","margin-top-10":"px7S0CDqJNwnq8njE25SW","margin-top-15":"fYp6HBaXfT4TeSdwge6kw","margin-top-20":"_1PAsFG3hAohpSqtQxHxlaI","margin-top-25":"_1O5JbGB55CqL7KfXghpI8U","margin-top-30":"_2rA4bFDrsDcJvQZQMEaw5p","margin-top-40":"HDIuayxQwaiwIk7ieS22b","margin-bottom-10":"gUVbLGjcOSoSvIAsGjAMq","margin-bottom-20":"_12JaR-1JCwpprnhGSoXngo","margin-left-5":"_3mXgwFBWo0dW2BR0_fELpo","margin-left-10":"_3Qv-m-eEdDG3xK3l0W5_uC","margin-left-15":"_1-iPPukLPaFqy4s5k5Bz7Q","margin-left-20":"w5cSKF0J167lIsUFmQX-9","margin-right-5":"NuKfDYOckFLiutYCd2EZC","margin-right-10":"K5ndy_1Bxt2-HuDOH624r","margin-right-20":"_26MlxiS2DLgt55TsoXnXSo","margin-vert-5":"_1LmvezRnFhJ6nzC655HDHh","margin-vert-10":"_32Fx3hP1NZZDF9Sp6n26Oa","margin-vert-15":"_20xCPH-g8eVWfHaefQniE0","margin-vert-20":"_3BTs1wLa9RL-PIje_tgqcF","margin-vert-40":"i4LjTJRdDPiZR1sGLpAyb","width-perc-1":"_2hELuCQdYnWFN8QD8qmng9","width-perc-100":"_15pZn-4uVf0E4fP4PiqmL8","max-width-100":"_3A_lRmIbXjFWFFlnhsCAUr","vertical-bottom":"JSyaEaW_2QLcF7FgeJy84","vertical-top":"_1hZBoZbPPrHebqi37bN5ay","vertical-middle":"_10avF6csxWKdAuVJTFCR38","clear":"_7hMTbxy7me5kGg8sTz_Iw","cursor-pointer":"_2XQmg5UcNhc_geN8Zp7D4b","dropZone":"_1I6xpBOloOPHzvIdg0vh-f","clickable":"ZDqAVQZd23w5cvlJvyF_b","fileName":"_34xqnqgdWaLsFtXcJkOUns","progressBar":"_2JiZAGhPYyCboXNGUnxsw3","altStyle":"_2rqSFneyr09w90wVxyiU71","progress":"_1jCiyPoJTROiQ7TOIQDNjZ","isSuccess":"d5wO5q0bVpts6gFswWig9","isCanceled":"_1hglEY9GI05tndavGMsPMD","isFailed":"bowq-bVZG6WJV_EBcoalP","percent":"_1b7KGgher0R4NiTSleaoEa","totalProgress":"_2HJLoY9_457_gnfRJJ-L1X","fileSize":"_2WmYhDJjGcplZgFHHRAsrt","bottomLine":"_1SIcYJy9Mqbwr7LpY7QZqq","timeLeft":"_1WDbJHhuS9HFMyjbq9apPO","statusIconContainer":"_23c09OSZ7xwUB6COu2fx_L","statusIcon":"_3TE4ZNVSc_DfkrE7OXJG-w","clickableArea":"xRbGyfrvIhSK7Zknk98Dw","uploadButtons":"_19WtC7ebARbSHpAteO0X1b","disabledButton":"_2-5kNILhaHscYeijqWLTsb"};

/***/ }),
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _reject3 = __webpack_require__(200);
	
	var _reject4 = _interopRequireDefault(_reject3);
	
	exports.default = reducer;
	exports.qsCreate = qsCreate;
	exports.loadBox = loadBox;
	exports.qsSave = qsSave;
	exports.isLoaded = isLoaded;
	exports.qsDelete = qsDelete;
	exports.toggleBoxView = toggleBoxView;
	exports.setOutdated = setOutdated;
	
	var _loadReducer = __webpack_require__(69);
	
	var _loadReducer2 = _interopRequireDefault(_loadReducer);
	
	var _datetime = __webpack_require__(68);
	
	var _projects = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TOGGLE_BOX_VIEW = 'quicksend/TOGGLE_BOX_VIEW';
	var SET_OUTDATED = 'quicksend/SET_OUTDATED';
	var LOADED_BOX_TYPE = 'quicksend/LOADED_BOX_TYPE';
	
	var loadReducer = (0, _loadReducer2.default)('playlist', {
	  qsCreate: {},
	  qsList: { action: 'load', init: null },
	  qsSave: {},
	  qsDelete: {}
	});
	
	var initialState = (0, _extends3.default)({}, loadReducer.initialState, {
	  boxView: 'box',
	  loadedBoxType: _projects.quickSendBox.inbox
	});
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case 'RESET':
	      return initialState;
	    case loadReducer.constants.QS_DELETE_SUCCESS:
	      if (state.qsListData.albums) {
	        return (0, _extends3.default)({}, loadReducer.reducer(state, action), {
	          qsListData: (0, _extends3.default)({}, state.qsListData, {
	            albums: (0, _reject4.default)(state.qsListData.albums, { project_id: action.qsId })
	          })
	        });
	      }
	      return (0, _extends3.default)({}, loadReducer.reducer(state, action), {
	        qsListData: (0, _reject4.default)(state.qsListData, { projectId: action.qsId })
	      });
	    case loadReducer.constants.LOAD_QS_LIST:
	      return (0, _extends3.default)({}, loadReducer.reducer(state, action), {
	        boxView: 'box'
	      });
	    case loadReducer.constants.LOAD_QS_LIST_SUCCESS:
	      return (0, _extends3.default)({}, loadReducer.reducer(state, action), {
	        loadedBoxType: action.box
	      });
	    case TOGGLE_BOX_VIEW:
	      return (0, _extends3.default)({}, loadReducer.reducer(state, action), {
	        boxView: action.boxView || (state.boxView === 'box' ? 'item' : 'box')
	      });
	    case SET_OUTDATED:
	      return (0, _extends3.default)({}, loadReducer.reducer(state, action), {
	        qsListLoaded: false
	      });
	    case LOADED_BOX_TYPE:
	      {
	        return (0, _extends3.default)({}, loadReducer.reducer(state, action), {
	          loadedBoxType: action.box
	        });
	      }
	    default:
	      return loadReducer.reducer(state, action);
	  }
	}
	
	function qsCreate() {
	  return {
	    types: loadReducer.constantsByKey.qsCreate,
	    promise: function promise(client) {
	      return client.post('project_wa/createQS');
	    }
	  };
	}
	
	function loadBox(box) {
	  return function (dispatch) {
	    return dispatch({
	      types: loadReducer.constantsByKey.qsList,
	      promise: function promise(client) {
	        return client.post('project_wa/getQSBox', { data: { box: box } });
	      },
	      box: box
	    });
	  };
	}
	
	function qsSave() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  data.daySavingLight = (0, _datetime.isDaySavingLight)();
	  data.timeDifference = (0, _datetime.getTimeDifference)();
	
	  return (0, _extends3.default)({
	    types: loadReducer.constantsByKey.qsSave,
	    promise: function promise(client) {
	      return client.post('project_wa/setQSInfo', { data: data });
	    }
	  }, data);
	}
	
	function isLoaded(type, state) {
	  return state.quicksend.qsListLoaded && state.quicksend.qsListActionData.box === type;
	}
	
	function qsDelete(qsId) {
	  return {
	    types: loadReducer.constantsByKey.qsDelete,
	    promise: function promise(client) {
	      return client.post('project_wa/deleteProject', { data: { projectId: qsId } });
	    },
	    qsId: qsId
	  };
	}
	
	function toggleBoxView(boxView) {
	  return {
	    type: TOGGLE_BOX_VIEW,
	    boxView: boxView
	  };
	}
	
	function setOutdated() {
	  return {
	    type: SET_OUTDATED
	  };
	}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.passwordRegExps = undefined;
	
	var _keys = __webpack_require__(113);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _isInteger = __webpack_require__(888);
	
	var _isInteger2 = _interopRequireDefault(_isInteger);
	
	var _isEmpty3 = __webpack_require__(81);
	
	var _isEmpty4 = _interopRequireDefault(_isEmpty3);
	
	exports.email = email;
	exports.password = password;
	exports.passwordCondition = passwordCondition;
	exports.required = required;
	exports.minLength = minLength;
	exports.maxLength = maxLength;
	exports.integer = integer;
	exports.oneOf = oneOf;
	exports.match = match;
	exports.createValidator = createValidator;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* Validation rules and regexps for forms */
	
	var isEmpty = function isEmpty(value) {
	  return value === undefined || value === null || value === '';
	};
	var join = function join(rules) {
	  return function (value, data) {
	    return rules.map(function (rule) {
	      return rule(value, data);
	    }).filter(function (error) {
	      return !!error;
	    })[0];
	  };
	};
	
	var passwordRegExps = exports.passwordRegExps = {
	  all: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&=\-+~#()^:,."'\\/_]).{8,}/,
	  uppercase: /[A-Z]/,
	  lowercase: /[a-z]/,
	  number: /[\d]/,
	  symbol: /[$@$!%*?&=\-+~#()^:,."'\\/_]/,
	  length: /.{8}/
	};
	
	function email(value) {
	  var t = __webpack_require__(56).getT();
	  // Let's not start a debate on email regex. This is just for an example app!
	  if (!isEmpty(value) && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
	    return t('Invalid email address');
	  }
	}
	
	function password(value) {
	  var t = __webpack_require__(56).getT();
	  if (!isEmpty(value) && !passwordRegExps.all.test(value)) {
	    return t('Invalid password');
	  } else if (isEmpty(value)) {
	    return t('Required');
	  }
	}
	
	function passwordCondition(value) {
	  var t = __webpack_require__(56).getT();
	  var errors = {};
	
	  if (!(0, _isEmpty4.default)(value)) {
	    if (!passwordRegExps.uppercase.test(value)) {
	      errors.uppercase = t('Password should contain at least one uppercase character');
	    }
	    if (!passwordRegExps.lowercase.test(value)) {
	      errors.lowercase = t('Password should contain at least one lowercase character');
	    }
	    if (!passwordRegExps.number.test(value)) {
	      errors.number = t('Password should contain at least one number');
	    }
	    if (!passwordRegExps.symbol.test(value)) {
	      errors.symbol = t('Password should contain at least one special symbol');
	    }
	    if (!passwordRegExps.length.test(value)) {
	      errors.length = t('Password length should be minimum 8 characters');
	    }
	  }
	
	  return (0, _isEmpty4.default)(errors) ? null : errors;
	}
	
	function required(value) {
	  if (isEmpty(value)) {
	    var t = __webpack_require__(56).getT();
	    return t('Required');
	  }
	}
	
	function minLength(min) {
	  return function (value) {
	    if (!isEmpty(value) && value.length < min) {
	      var t = __webpack_require__(56).getT();
	      return t('Must be at least {{count}} characters', { count: min });
	    }
	  };
	}
	
	function maxLength(max) {
	  return function (value) {
	    if (!isEmpty(value) && value.length > max) {
	      var t = __webpack_require__(56).getT();
	      return t('Must be no more than {{count}} characters', { count: max });
	    }
	  };
	}
	
	function integer(value) {
	  if (!(0, _isInteger2.default)(Number(value))) {
	    var t = __webpack_require__(56).getT();
	    return t('Must be an integer');
	  }
	}
	
	function oneOf(enumeration) {
	  return function (value) {
	    if (enumeration.indexOf(value) === -1) {
	      var t = __webpack_require__(56).getT();
	      return t('Must be one of: {{oneOf}}', { oneOf: enumeration.join(', ') });
	    }
	  };
	}
	
	function match(field) {
	  return function (value, data) {
	    if (data) {
	      if (value !== data[field]) {
	        var t = __webpack_require__(56).getT();
	        return t('Do not match');
	      }
	    }
	  };
	}
	
	function createValidator(rules) {
	  return function () {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var errors = {};
	    (0, _keys2.default)(rules).forEach(function (key) {
	      var rule = join([].concat(rules[key])); // concat enables both functions and arrays of functions
	      var error = rule(data[key], data);
	      if (error) {
	        errors[key] = error;
	      }
	    });
	    return errors;
	  };
	}

/***/ }),
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(21);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Checkbox = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(Checkbox, _Component);
	
	  function Checkbox() {
	    (0, _classCallCheck3.default)(this, Checkbox);
	    return (0, _possibleConstructorReturn3.default)(this, (Checkbox.__proto__ || (0, _getPrototypeOf2.default)(Checkbox)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Checkbox, [{
	    key: 'render',
	    value: function render() {
	      var _classNames;
	
	      var styles = __webpack_require__(1252);
	      var _props = this.props,
	          textBefore = _props.textBefore,
	          textAfter = _props.textAfter,
	          className = _props.className,
	          children = _props.children,
	          radio = _props.radio,
	          small = _props.small,
	          thin = _props.thin,
	          formProps = (0, _objectWithoutProperties3.default)(_props, ['textBefore', 'textAfter', 'className', 'children', 'radio', 'small', 'thin']);
	
	
	      return _react2.default.createElement(
	        'label',
	        { className: (0, _classnames2.default)(styles.checkbox, className, { radio: radio }) },
	        children,
	        _react2.default.createElement('input', (0, _extends3.default)({ type: radio ? 'radio' : 'checkbox' }, formProps)),
	        textBefore && _react2.default.createElement(
	          'span',
	          { className: styles.textBefore },
	          textBefore
	        ),
	        _react2.default.createElement('i', { className: (0, _classnames2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, styles.small, small), (0, _defineProperty3.default)(_classNames, styles.thin, thin), _classNames)) }),
	        textAfter && _react2.default.createElement(
	          'span',
	          { className: styles.textAfter },
	          textAfter
	        )
	      );
	    }
	  }]);
	  return Checkbox;
	}(_react.Component), _class.propTypes = {
	  checked: _propTypes2.default.bool,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  className: _propTypes2.default.string,
	  defaultChecked: _propTypes2.default.bool,
	  name: _propTypes2.default.string,
	  onChange: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  radio: _propTypes2.default.bool,
	  small: _propTypes2.default.bool,
	  textAfter: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
	  textBefore: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
	  thin: _propTypes2.default.bool
	}, _class.defaultProps = {
	  name: 'checkbox',
	  textBefore: '',
	  textAfter: '',
	  checked: false,
	  onChange: function onChange() {}
	}, _temp);
	exports.default = Checkbox;
	module.exports = exports['default'];

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactScrollspy = __webpack_require__(1801);
	
	var _utils = __webpack_require__(24);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _reactScroll = __webpack_require__(251);
	
	var _reactScroll2 = _interopRequireDefault(_reactScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scroll = _reactScroll2.default.animateScroll;
	
	function removeSpaces(text) {
	  return text.replace(/[\s\W]/g, '');
	}
	
	function getId(text) {
	  return removeSpaces(text).toLowerCase();
	}
	
	// since link anchors don't working on iOS use js scroll to anchors
	var scrollTo = function scrollTo(id) {
	  if (!document) {
	    return false;
	  }
	  var el = document.querySelector('#' + id);
	  if (el) {
	    scroll.scrollMore(el.getBoundingClientRect().top);
	  }
	};
	
	var InfoPartition = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    user: state.auth.user
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(InfoPartition, _Component);
	
	  function InfoPartition() {
	    (0, _classCallCheck3.default)(this, InfoPartition);
	    return (0, _possibleConstructorReturn3.default)(this, (InfoPartition.__proto__ || (0, _getPrototypeOf2.default)(InfoPartition)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(InfoPartition, [{
	    key: 'render',
	    value: function render() {
	      var styles = __webpack_require__(1275);
	      var _props = this.props,
	          text = _props.text,
	          _props$text = _props.text,
	          preKey = _props$text.preKey,
	          articles = _props$text.articles,
	          user = _props.user;
	
	
	      var headers = [];
	      var nav = [];
	
	      var content = articles.map(function (article) {
	        var header = article.header,
	            chapter = article.chapter,
	            bodies = article.bodies;
	
	        var _id = getId(article.key);
	        headers.push(_id);
	        var parentKey = article.key;
	        var body = bodies.map(function (item, index) {
	          var key = preKey + parentKey + index;
	          return _react2.default.createElement(
	            'div',
	            { className: styles.body, key: key },
	            item
	          );
	        });
	
	        nav.push(_react2.default.createElement(
	          'li',
	          { className: styles.scrollSpyItemCont, key: 'scroll-spy-' + _id },
	          _react2.default.createElement(
	            'a',
	            { className: styles.scrollSpyItem, onClick: function onClick(e) {
	                return (0, _utils.stopEvent)(e) && scrollTo(_id);
	              } },
	            chapter === null ? '' : chapter || header
	          )
	        ));
	        return _react2.default.createElement(
	          'section',
	          { className: styles.section, key: 'section-' + article.key },
	          _react2.default.createElement(
	            'a',
	            { className: 'anchor', id: _id },
	            '\xA0'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: styles.header },
	            header
	          ),
	          body
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'margin-top-20' },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _bind2.default)('col-xs-60', styles.scrollSpy, (0, _defineProperty3.default)({}, styles.withMenu, !!user)) },
	          _react2.default.createElement(
	            _reactScrollspy.Scrollspy,
	            { items: headers, currentClassName: styles.scrollSpyCurrent },
	            nav
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-60 col-lg-35 ' + styles.content },
	          text.body && _react2.default.createElement(
	            'section',
	            { className: styles.section },
	            _react2.default.createElement(
	              'div',
	              { className: styles.body },
	              text.body
	            )
	          ),
	          content
	        )
	      );
	    }
	  }]);
	  return InfoPartition;
	}(_react.Component), _class2.propTypes = {
	  text: _propTypes2.default.object,
	  user: _propTypes2.default.object
	}, _temp)) || _class);
	exports.default = InfoPartition;
	module.exports = exports['default'];

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var List = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(List, _Component);
	
	  function List() {
	    (0, _classCallCheck3.default)(this, List);
	    return (0, _possibleConstructorReturn3.default)(this, (List.__proto__ || (0, _getPrototypeOf2.default)(List)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(List, [{
	    key: 'render',
	    value: function render() {
	      var styles = __webpack_require__(1278);
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'overflow-x-auto clear' },
	        _react2.default.createElement(
	          'ul',
	          { className: (0, _bind2.default)(styles.root, className) },
	          children
	        )
	      );
	    }
	  }]);
	  return List;
	}(_react.Component), _class.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  className: _propTypes2.default.string
	}, _temp);
	exports.default = List;
	module.exports = exports['default'];

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _ClearableInput = __webpack_require__(819);
	
	var _ClearableInput2 = _interopRequireDefault(_ClearableInput);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1311);
	
	var SearchBar = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_class2 = (_temp = _class3 = function (_PureComponent) {
	  (0, _inherits3.default)(SearchBar, _PureComponent);
	
	  function SearchBar() {
	    (0, _classCallCheck3.default)(this, SearchBar);
	    return (0, _possibleConstructorReturn3.default)(this, (SearchBar.__proto__ || (0, _getPrototypeOf2.default)(SearchBar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SearchBar, [{
	    key: 'onChange',
	    value: function onChange(kw) {
	      this.filter(kw);
	    }
	  }, {
	    key: 'filter',
	    value: function filter(kw) {
	      var _props = this.props,
	          onSetFilter = _props.onSetFilter,
	          onChange = _props.onChange;
	
	      onSetFilter({ kw: kw });
	      onChange(kw);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          t = _props2.t,
	          className = _props2.className,
	          inputClass = _props2.inputClass,
	          kw = _props2.kw,
	          title = _props2.title,
	          autoFocus = _props2.autoFocus,
	          delay = _props2.delay;
	
	      var displayedTitle = title || t('Search');
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(styles.container, className) },
	        _react2.default.createElement(_ClearableInput2.default, {
	          delay: delay,
	          autoFocus: autoFocus,
	          inputClassName: (0, _bind2.default)(styles.input, inputClass),
	          title: displayedTitle,
	          onChange: this.onChange,
	          kw: kw,
	          inputProps: { autoFocus: autoFocus }
	        })
	      );
	    }
	  }]);
	  return SearchBar;
	}(_react.PureComponent), _class3.propTypes = {
	  autoFocus: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  delay: _propTypes2.default.number,
	  inputClass: _propTypes2.default.string,
	  kw: _propTypes2.default.string,
	  onChange: _propTypes2.default.func,
	  onSetFilter: _propTypes2.default.func,
	  t: _propTypes2.default.func,
	  title: _propTypes2.default.string
	}, _class3.defaultProps = {
	  delay: 300,
	  onChange: _noop3.default,
	  onSetFilter: _noop3.default
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onChange', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onChange'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'filter', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'filter'), _class2.prototype)), _class2)) || _class);
	exports.default = SearchBar;
	module.exports = exports['default'];

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ACTIONS = undefined;
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get2 = __webpack_require__(19);
	
	var _get3 = _interopRequireDefault(_get2);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case 'RESET':
	      return initialState;
	    case constants.UPDATE_ACCOUNT_SUCCESS:
	      {
	        return (0, _qim.update)(['accountData', (0, _qim.$merge)((0, _get3.default)(action, 'result.data', {}))], reducer(state, action));
	      }
	    case constants.MAKE_EMAIL_PRIMARY_SUCCESS:
	    case constants.DELETE_EMAIL_SUCCESS:
	      return (0, _extends3.default)({}, reducer(state, action), {
	        userEmailsData: action.result.data
	      });
	    default:
	      return reducer(state, action);
	  }
	};
	
	exports.isLoaded = isLoaded;
	exports.isLoadTime = isLoadTime;
	exports.loadAccount = loadAccount;
	exports.loadUserEmails = loadUserEmails;
	exports.addEmail = addEmail;
	exports.deleteEmail = deleteEmail;
	exports.makeEmailPrimary = makeEmailPrimary;
	exports.updatePassword = updatePassword;
	exports.addEmailConfirm = addEmailConfirm;
	exports.updateAccount = updateAccount;
	
	var _qim = __webpack_require__(110);
	
	var _loadReducer = __webpack_require__(69);
	
	var _loadReducer2 = _interopRequireDefault(_loadReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* Account redux reducer and action creators */
	
	var loadReducer = (0, _loadReducer2.default)('account', {
	  account: { action: 'load', init: null },
	  userEmails: { action: 'load', init: null },
	  addEmail: { init: null },
	  deleteEmail: { init: null },
	  makeEmailPrimary: { init: null },
	  updatePassword: { init: null },
	  addEmailConfirm: { init: null },
	  updateAccount: {}
	});
	
	var initialState = (0, _extends3.default)({}, loadReducer.initialState);
	
	var constants = loadReducer.constants,
	    reducer = loadReducer.reducer,
	    constantsByKey = loadReducer.constantsByKey;
	var ACTIONS = exports.ACTIONS = constants;
	
	function isLoaded(globalState) {
	  return (0, _get3.default)(globalState, 'account.loaded', false);
	}
	
	function isLoadTime(globalState) {
	  return !isLoaded(globalState) && (0, _get3.default)(globalState, 'auth.authKey', false);
	}
	
	function loadAccount() {
	  return {
	    types: constantsByKey.account,
	    promise: function promise(client) {
	      return client.post('users_wa/account');
	    }
	  };
	}
	
	function loadUserEmails() {
	  return {
	    types: constantsByKey.userEmails,
	    promise: function promise(client) {
	      return client.post('users_wa/getUserEmails');
	    }
	  };
	}
	
	function addEmail(email) {
	  return {
	    types: constantsByKey.addEmail,
	    promise: function promise(client) {
	      return client.post('users_wa/addEmail', { data: { email: email } });
	    },
	    email: email
	  };
	}
	
	function deleteEmail(email) {
	  return {
	    types: constantsByKey.deleteEmail,
	    promise: function promise(client) {
	      return client.post('users_wa/removeEmail', { data: { email: email } });
	    },
	    email: email
	  };
	}
	
	function makeEmailPrimary(email) {
	  return {
	    types: constantsByKey.makeEmailPrimary,
	    promise: function promise(client) {
	      return client.post('users_wa/makePrimary', { data: { email: email } });
	    },
	    email: email
	  };
	}
	
	function updatePassword(newPassword, currentPassword) {
	  return {
	    types: constantsByKey.updatePassword,
	    promise: function promise(client) {
	      return client.post('users_wa/updatePassword', { data: { newPassword: newPassword, currentPassword: currentPassword } });
	    },
	    newPassword: newPassword,
	    currentPassword: currentPassword
	  };
	}
	
	function addEmailConfirm(key, code) {
	  return {
	    types: constantsByKey.addEmailConfirm,
	    promise: function promise(client) {
	      return client.post('auth/addEmailKeyCheck', { data: { key: key, code: code } });
	    },
	    key: key,
	    code: code
	  };
	}
	
	function updateAccount(_ref) {
	  var firstName = _ref.firstName,
	      lastName = _ref.lastName;
	
	  return function (dispatch, getState) {
	    var _getState$account$acc = getState().account.accountData,
	        accountData = _getState$account$acc === undefined ? {} : _getState$account$acc;
	
	    var data = {
	      firstName: firstName || accountData.firstName,
	      lastName: lastName || accountData.lastName
	    };
	
	    return dispatch({
	      types: constantsByKey.updateAccount,
	      promise: function promise(client) {
	        return client.post('users_wa/editAccount', { data: data });
	      },
	      firstName: firstName,
	      lastName: lastName
	    });
	  };
	}

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCheckedGroupContactsArray = exports.getGroupContactsSuggestionList = exports.getSuggestionList = exports.getGroup = exports.getFreeContacts = exports.getFilteredGroupContactsPage = exports.getGroupContacts = exports.getContacts = undefined;
	
	var _map2 = __webpack_require__(241);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _keyBy2 = __webpack_require__(322);
	
	var _keyBy3 = _interopRequireDefault(_keyBy2);
	
	var _invertBy2 = __webpack_require__(132);
	
	var _invertBy3 = _interopRequireDefault(_invertBy2);
	
	var _get2 = __webpack_require__(19);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _find2 = __webpack_require__(95);
	
	var _find3 = _interopRequireDefault(_find2);
	
	var _differenceBy2 = __webpack_require__(1550);
	
	var _differenceBy3 = _interopRequireDefault(_differenceBy2);
	
	var _reselect = __webpack_require__(125);
	
	var _utils = __webpack_require__(24);
	
	var _recipients = __webpack_require__(264);
	
	var _contacts = __webpack_require__(868);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* Contacts and groups reselect */
	
	var _getGroupId = function _getGroupId(state) {
	  return state.contacts.groupContactsListActionData.groupId;
	};
	var _getGroups = function _getGroups(state) {
	  return state.contacts.groupsListData;
	};
	var _getGroupContacts = function _getGroupContacts(state) {
	  return state.contacts.groupContactsListData;
	};
	var _getContacts = function _getContacts(state) {
	  return state.contacts.contactsListData.contacts;
	};
	var _getKw = function _getKw(state) {
	  return state.contacts.kw;
	};
	var _getGroupContactsKw = function _getGroupContactsKw(state) {
	  return state.contacts.groupContactsKw;
	};
	var _getSuggestionList = function _getSuggestionList(state) {
	  return (0, _get3.default)(state.contacts, 'suggestionListData.contacts', []);
	};
	var _getGroupContactsPage = function _getGroupContactsPage(state) {
	  return state.contacts.groupContactsPage;
	};
	var _getCheckedGroupContacts = function _getCheckedGroupContacts(state) {
	  return state.contacts.checkedGroupContacts;
	};
	
	var getContacts = exports.getContacts = (0, _reselect.createSelector)([_getContacts], function (contacts) {
	  return (0, _contacts.processContacts)(contacts);
	});
	
	var getGroupContacts = exports.getGroupContacts = (0, _reselect.createSelector)([_getGroupContacts], function (contacts) {
	  return (0, _contacts.processContacts)(contacts);
	});
	
	var getFilteredGroupContactsPage = exports.getFilteredGroupContactsPage = (0, _reselect.createSelector)([_getGroupContacts, _getGroupContactsKw, _getGroupContactsPage], function (contacts, kw, page) {
	  return (0, _contacts.getFilteredContactsPage)({ contacts: contacts, kw: kw, page: page });
	});
	
	var groupContactsByIds = (0, _reselect.createSelector)([getGroupContacts, getContacts], function (groupContacts, allContacts) {
	  var freeContacts = (0, _keyBy3.default)(allContacts, 'id');
	
	  groupContacts.map(function (groupContact) {
	    if (freeContacts[groupContact.id]) {
	      delete freeContacts[groupContact.id];
	    }
	  });
	
	  return { groupContacts: groupContacts, freeContacts: (0, _map3.default)(freeContacts) };
	});
	
	var getFreeContacts = exports.getFreeContacts = (0, _reselect.createSelector)([groupContactsByIds, _getKw], function (contacts, kw) {
	  return (0, _utils.filterObjectsByKw)(contacts.freeContacts, ['fullName', 'userEmail'], kw);
	});
	
	var getGroup = exports.getGroup = (0, _reselect.createSelector)([_getGroupId, _getGroups], function (groupId, groups) {
	  return (0, _find3.default)(groups, { id: groupId }) || {};
	});
	
	var getSuggestionList = exports.getSuggestionList = (0, _reselect.createSelector)([_getSuggestionList], function (contacts) {
	  return (0, _recipients.processRecipients)(contacts);
	});
	
	var getGroupContactsSuggestionList = exports.getGroupContactsSuggestionList = (0, _reselect.createSelector)([_getSuggestionList, _getGroupContacts], function (contacts, groupContacts) {
	  var filteredContacts = (0, _differenceBy3.default)(contacts, groupContacts, 'id');
	  return (0, _recipients.processRecipients)(filteredContacts);
	});
	
	var getCheckedGroupContactsArray = exports.getCheckedGroupContactsArray = (0, _reselect.createSelector)([_getCheckedGroupContacts], function (items) {
	  return ((0, _invertBy3.default)(items).true || []).map(Number);
	});

/***/ }),
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _toConsumableArray2 = __webpack_require__(34);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reverse2 = __webpack_require__(453);
	
	var _reverse3 = _interopRequireDefault(_reverse2);
	
	var _clamp2 = __webpack_require__(446);
	
	var _clamp3 = _interopRequireDefault(_clamp2);
	
	var _get2 = __webpack_require__(19);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _take2 = __webpack_require__(454);
	
	var _take3 = _interopRequireDefault(_take2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _ChartShowMoreToggle = __webpack_require__(1967);
	
	var _ChartShowMoreToggle2 = _interopRequireDefault(_ChartShowMoreToggle);
	
	var _Chart = __webpack_require__(1964);
	
	var _Chart2 = _interopRequireDefault(_Chart);
	
	var _qim = __webpack_require__(110);
	
	var _chart = __webpack_require__(261);
	
	var _Loader = __webpack_require__(60);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ChartNoData = __webpack_require__(519);
	
	var _ChartNoData2 = _interopRequireDefault(_ChartNoData);
	
	var _chartColors = __webpack_require__(513);
	
	var _chartColors2 = _interopRequireDefault(_chartColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1251);
	
	var ChartWrapper = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(ChartWrapper, _PureComponent);
	
	  function ChartWrapper() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, ChartWrapper);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = ChartWrapper.__proto__ || (0, _getPrototypeOf2.default)(ChartWrapper)).call.apply(_ref, [this].concat(args)));
	
	    var isHasMoreData = _this.hasMoreData(args[0]);
	    _this.state = { showMoreToggle: isHasMoreData, showAllData: !isHasMoreData };
	    return _this;
	  }
	
	  (0, _createClass3.default)(ChartWrapper, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var isHasMoreData = this.hasMoreData(nextProps);
	      this.setState({ showMoreToggle: isHasMoreData, showAllData: !isHasMoreData });
	    }
	  }, {
	    key: 'onShowMore',
	    value: function onShowMore() {
	      var showAllData = this.state.showAllData;
	
	      this.setState({ showAllData: !showAllData });
	      this.props.onShowMore(!showAllData);
	    }
	  }, {
	    key: 'getDataPartition',
	    value: function getDataPartition() {
	      var _props = this.props,
	          data = _props.chartProps.data,
	          limit = _props.limit;
	
	      var partSize = limit + 1; // +1 to include header
	      var isHasMoreData = this.hasMoreData();
	      var showAllData = this.state.showAllData;
	
	      return showAllData || !isHasMoreData ? data : (0, _take3.default)(data, partSize);
	    }
	  }, {
	    key: 'getChartProps',
	    value: function getChartProps() {
	      var _props2 = this.props,
	          chartProps = _props2.chartProps,
	          itemHeight = _props2.itemHeight,
	          height = _props2.height,
	          minHeight = _props2.minHeight,
	          legendHeight = _props2.legendHeight,
	          showScale = _props2.showScale,
	          scaleHeight = _props2.scaleHeight,
	          reverseColors = _props2.reverseColors;
	
	      var data = this.getDataPartition();
	      var areaHeight = (0, _clamp3.default)(height || data.length * itemHeight, minHeight, Infinity);
	      var showLegend = (0, _get3.default)(chartProps, 'options.legend.position') !== _chart.chartLegendPosition.none;
	      var chartHeight = areaHeight - (showLegend ? legendHeight : 0) - (showScale ? scaleHeight : 0);
	      var colors = reverseColors ? (0, _reverse3.default)([].concat((0, _toConsumableArray3.default)(_chartColors2.default))) : [].concat((0, _toConsumableArray3.default)(_chartColors2.default));
	
	      return (0, _qim.update)([['data', (0, _qim.$set)(data)], ['height', (0, _qim.$set)(areaHeight + 'px')], ['options', ['height', (0, _qim.$set)(areaHeight)], ['chartArea', 'height', (0, _qim.$set)(chartHeight)], ['colors', (0, _qim.$set)(colors)]]], chartProps);
	    }
	  }, {
	    key: 'hasMoreData',
	    value: function hasMoreData() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var data = props.chartProps.data,
	          limit = props.limit;
	
	      var partSize = limit + 1; // +1 to include header
	      return !!limit && data.length > partSize;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var chartProps = this.getChartProps();
	      var _props3 = this.props,
	          className = _props3.className,
	          loading = _props3.loading,
	          _props3$hasData = _props3.hasData,
	          hasData = _props3$hasData === undefined ? chartProps.data.length > 1 : _props3$hasData;
	
	
	      if (loading) {
	        return _react2.default.createElement(_Loader2.default, { alignCenter: true });
	      } else if (!hasData) {
	        return _react2.default.createElement(_ChartNoData2.default, null);
	      }
	
	      var _state = this.state,
	          showMoreToggle = _state.showMoreToggle,
	          showAllData = _state.showAllData;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(styles.wrapper, className) },
	        _react2.default.createElement(_Chart2.default, chartProps),
	        showMoreToggle && _react2.default.createElement(_ChartShowMoreToggle2.default, {
	          onClick: this.onShowMore,
	          isOpen: showAllData
	        })
	      );
	    }
	  }]);
	  return ChartWrapper;
	}(_react.PureComponent), _class2.propTypes = {
	  chartProps: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  hasData: _propTypes2.default.bool,
	  height: _propTypes2.default.number,
	  itemHeight: _propTypes2.default.number,
	  legendHeight: _propTypes2.default.number,
	  limit: _propTypes2.default.number,
	  loading: _propTypes2.default.bool,
	  minHeight: _propTypes2.default.number,
	  onShowMore: _propTypes2.default.func,
	  reverseColors: _propTypes2.default.bool,
	  scaleHeight: _propTypes2.default.number,
	  showScale: _propTypes2.default.bool
	}, _class2.contextTypes = {
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  chartProps: {},
	  height: 0,
	  itemHeight: 40,
	  legendHeight: 40,
	  scaleHeight: 20,
	  limit: 0,
	  minHeight: 30,
	  onShowMore: _noop3.default,
	  reverseColors: false
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onShowMore', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onShowMore'), _class.prototype)), _class);
	exports.default = ChartWrapper;
	module.exports = exports['default'];

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Modal = __webpack_require__(463);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1281);
	
	var cn = _bind2.default.bind(styles);
	
	var Modal = (_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(Modal, _Component);
	
	  function Modal() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = Modal.__proto__ || (0, _getPrototypeOf2.default)(Modal)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { isOpened: _this.props.show };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Modal, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.show !== this.props.show) {
	        this.setState({ isOpened: nextProps.show });
	      }
	    }
	  }, {
	    key: 'open',
	    value: function open() {
	      this.setState({ isOpened: true });
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.setState({ isOpened: false });
	      this.props.onHide();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          footerActions = _props.footerActions,
	          closeButton = _props.closeButton,
	          autoFocus = _props.autoFocus,
	          backdrop = _props.backdrop,
	          closeByEsc = _props.closeByEsc,
	          bsSize = _props.bsSize,
	          dialogClassName = _props.dialogClassName,
	          withoutPadding = _props.withoutPadding,
	          simpleHeader = _props.simpleHeader,
	          className = _props.className,
	          warningTitle = _props.warningTitle;
	
	
	      return _react2.default.createElement(
	        _Modal2.default,
	        {
	          show: this.state.isOpened,
	          onHide: this.close,
	          className: (0, _bind2.default)(styles.root, className),
	          autoFocus: autoFocus,
	          backdrop: backdrop,
	          keyboard: closeByEsc,
	          bsSize: bsSize,
	          dialogClassName: dialogClassName
	        },
	        _react2.default.createElement(
	          _Modal2.default.Header,
	          { closeButton: closeButton, className: (0, _bind2.default)(styles.header, (0, _defineProperty3.default)({}, styles.simple, simpleHeader)) },
	          _react2.default.createElement(
	            _Modal2.default.Title,
	            { className: (0, _bind2.default)(styles.title, (0, _defineProperty3.default)({}, styles.isWarning, warningTitle)) },
	            title
	          )
	        ),
	        _react2.default.createElement(
	          _Modal2.default.Body,
	          { className: cn('body', { withoutPadding: withoutPadding }) },
	          this.props.children
	        ),
	        !!footerActions && _react2.default.createElement(
	          _Modal2.default.Footer,
	          { className: styles.footer },
	          footerActions
	        )
	      );
	    }
	  }]);
	  return Modal;
	}(_react.Component), _class2.propTypes = {
	  autoFocus: _propTypes2.default.bool,
	  backdrop: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  bsSize: _propTypes2.default.oneOf(['lg', 'large', 'sm', 'small']),
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  className: _propTypes2.default.string,
	  closeButton: _propTypes2.default.bool,
	  closeByEsc: _propTypes2.default.bool,
	  dialogClassName: _propTypes2.default.string,
	  footerActions: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  onHide: _propTypes2.default.func,
	  show: _propTypes2.default.bool,
	  simpleHeader: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  warningTitle: _propTypes2.default.bool,
	  withoutPadding: _propTypes2.default.bool
	}, _class2.defaultProps = {
	  autoFocus: true,
	  backdrop: false,
	  closeByEsc: true,
	  closeButton: true,
	  onHide: _noop3.default,
	  show: false,
	  warningTitle: false
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'close', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'close'), _class.prototype)), _class);
	exports.default = Modal;
	module.exports = exports['default'];

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MyPlaylist = exports.MyPlaylists = exports.BoxcomAuth = exports.DropboxAuth = exports.QuickSendNew = exports.QuickSendItem = exports.QuickSend = exports.ContactUs = exports.Download = exports.EmailConfirm = exports.Service = exports.ForgotPasswordDialog = exports.GroupContacts = exports.Groups = exports.Contacts = exports.ProjectRecipientReport = exports.ProjectReport = exports.ProjectCreateFromSS = exports.ProjectConfirmation = exports.ProjectRecipients = exports.ProjectMaterials = exports.ProjectInfo = exports.Info = exports.Account = exports.Registration = exports.Login = exports.LoginContact = exports.LoginDialog = exports.NewProject = exports.Projects = exports.Playlist = exports.Playlists = exports.Home = exports.NotFound = exports.App = undefined;
	
	var _Project = __webpack_require__(2202);
	
	Object.defineProperty(exports, 'ProjectInfo', {
	  enumerable: true,
	  get: function get() {
	    return _Project.ProjectInfo;
	  }
	});
	Object.defineProperty(exports, 'ProjectMaterials', {
	  enumerable: true,
	  get: function get() {
	    return _Project.ProjectMaterials;
	  }
	});
	Object.defineProperty(exports, 'ProjectRecipients', {
	  enumerable: true,
	  get: function get() {
	    return _Project.ProjectRecipients;
	  }
	});
	Object.defineProperty(exports, 'ProjectConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _Project.ProjectConfirmation;
	  }
	});
	Object.defineProperty(exports, 'ProjectCreateFromSS', {
	  enumerable: true,
	  get: function get() {
	    return _Project.ProjectCreateFromSS;
	  }
	});
	
	var _Contacts = __webpack_require__(2154);
	
	Object.defineProperty(exports, 'Contacts', {
	  enumerable: true,
	  get: function get() {
	    return _Contacts.Contacts;
	  }
	});
	Object.defineProperty(exports, 'Groups', {
	  enumerable: true,
	  get: function get() {
	    return _Contacts.Groups;
	  }
	});
	Object.defineProperty(exports, 'GroupContacts', {
	  enumerable: true,
	  get: function get() {
	    return _Contacts.GroupContacts;
	  }
	});
	
	var _App2 = __webpack_require__(2142);
	
	var _App3 = _interopRequireDefault(_App2);
	
	var _NotFound2 = __webpack_require__(2177);
	
	var _NotFound3 = _interopRequireDefault(_NotFound2);
	
	var _Home2 = __webpack_require__(2159);
	
	var _Home3 = _interopRequireDefault(_Home2);
	
	var _Playlists2 = __webpack_require__(2181);
	
	var _Playlists3 = _interopRequireDefault(_Playlists2);
	
	var _Playlist2 = __webpack_require__(2178);
	
	var _Playlist3 = _interopRequireDefault(_Playlist2);
	
	var _Projects2 = __webpack_require__(2205);
	
	var _Projects3 = _interopRequireDefault(_Projects2);
	
	var _NewProject2 = __webpack_require__(2176);
	
	var _NewProject3 = _interopRequireDefault(_NewProject2);
	
	var _LoginDialog2 = __webpack_require__(863);
	
	var _LoginDialog3 = _interopRequireDefault(_LoginDialog2);
	
	var _LoginContact2 = __webpack_require__(2161);
	
	var _LoginContact3 = _interopRequireDefault(_LoginContact2);
	
	var _Login2 = __webpack_require__(2143);
	
	var _Login3 = _interopRequireDefault(_Login2);
	
	var _Registration2 = __webpack_require__(2144);
	
	var _Registration3 = _interopRequireDefault(_Registration2);
	
	var _Account2 = __webpack_require__(2140);
	
	var _Account3 = _interopRequireDefault(_Account2);
	
	var _Info2 = __webpack_require__(2160);
	
	var _Info3 = _interopRequireDefault(_Info2);
	
	var _ProjectReport2 = __webpack_require__(2204);
	
	var _ProjectReport3 = _interopRequireDefault(_ProjectReport2);
	
	var _ProjectRecipientReport2 = __webpack_require__(2203);
	
	var _ProjectRecipientReport3 = _interopRequireDefault(_ProjectRecipientReport2);
	
	var _ForgotPasswordDialog2 = __webpack_require__(2158);
	
	var _ForgotPasswordDialog3 = _interopRequireDefault(_ForgotPasswordDialog2);
	
	var _Service2 = __webpack_require__(2209);
	
	var _Service3 = _interopRequireDefault(_Service2);
	
	var _EmailConfirm2 = __webpack_require__(2157);
	
	var _EmailConfirm3 = _interopRequireDefault(_EmailConfirm2);
	
	var _Download2 = __webpack_require__(2155);
	
	var _Download3 = _interopRequireDefault(_Download2);
	
	var _ContactUs2 = __webpack_require__(2146);
	
	var _ContactUs3 = _interopRequireDefault(_ContactUs2);
	
	var _QuickSends = __webpack_require__(2208);
	
	var _QuickSends2 = _interopRequireDefault(_QuickSends);
	
	var _QuickSendItem2 = __webpack_require__(2206);
	
	var _QuickSendItem3 = _interopRequireDefault(_QuickSendItem2);
	
	var _QuickSendNew2 = __webpack_require__(2207);
	
	var _QuickSendNew3 = _interopRequireDefault(_QuickSendNew2);
	
	var _DropboxAuth2 = __webpack_require__(2156);
	
	var _DropboxAuth3 = _interopRequireDefault(_DropboxAuth2);
	
	var _BoxcomAuth2 = __webpack_require__(2145);
	
	var _BoxcomAuth3 = _interopRequireDefault(_BoxcomAuth2);
	
	var _MyPlaylists2 = __webpack_require__(2170);
	
	var _MyPlaylists3 = _interopRequireDefault(_MyPlaylists2);
	
	var _MyPlaylist2 = __webpack_require__(2162);
	
	var _MyPlaylist3 = _interopRequireDefault(_MyPlaylist2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.App = _App3.default;
	exports.NotFound = _NotFound3.default;
	exports.Home = _Home3.default;
	exports.Playlists = _Playlists3.default;
	exports.Playlist = _Playlist3.default;
	exports.Projects = _Projects3.default;
	exports.NewProject = _NewProject3.default;
	exports.LoginDialog = _LoginDialog3.default;
	exports.LoginContact = _LoginContact3.default;
	exports.Login = _Login3.default;
	exports.Registration = _Registration3.default;
	exports.Account = _Account3.default;
	exports.Info = _Info3.default;
	exports.ProjectReport = _ProjectReport3.default;
	exports.ProjectRecipientReport = _ProjectRecipientReport3.default;
	exports.ForgotPasswordDialog = _ForgotPasswordDialog3.default;
	exports.Service = _Service3.default;
	exports.EmailConfirm = _EmailConfirm3.default;
	exports.Download = _Download3.default;
	exports.ContactUs = _ContactUs3.default;
	exports.QuickSend = _QuickSends2.default;
	exports.QuickSendItem = _QuickSendItem3.default;
	exports.QuickSendNew = _QuickSendNew3.default;
	exports.DropboxAuth = _DropboxAuth3.default;
	exports.BoxcomAuth = _BoxcomAuth3.default;
	exports.MyPlaylists = _MyPlaylists3.default;
	exports.MyPlaylist = _MyPlaylist3.default;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.viewTypes = undefined;
	
	var _keys = __webpack_require__(113);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _groupBy3 = __webpack_require__(669);
	
	var _groupBy4 = _interopRequireDefault(_groupBy3);
	
	exports.processAlbums = processAlbums;
	exports.processTracks = processTracks;
	exports.getSortedAlbums = getSortedAlbums;
	exports.getFilteredAlbums = getFilteredAlbums;
	exports.getPartTracks = getPartTracks;
	
	var _moment = __webpack_require__(20);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _config = __webpack_require__(41);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _utils = __webpack_require__(24);
	
	var _datetime = __webpack_require__(68);
	
	var _projects = __webpack_require__(28);
	
	var _uuid = __webpack_require__(270);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var filteredFields = ['album', 'album2', 'artist_name', 'subject', 'title'];
	
	var viewTypes = exports.viewTypes = {
	  grid: 'grid',
	  list: 'list'
	};
	
	function processTrack(_ref) {
	  var track = _ref.track,
	      albumId = _ref.albumId,
	      _ref$album = _ref.album,
	      album = _ref$album === undefined ? {} : _ref$album;
	
	  var duration = _moment2.default.duration(Number(track.duration), 'seconds');
	  var minutes = Math.floor(duration.asMinutes());
	  var seconds = ('0' + duration.seconds()).substr(-2);
	  track.durationTime = minutes + ':' + seconds;
	  track.audioSrc = _config2.default.app.srcMasks.audio.replace('<trackName>', track.wFileName);
	  track.videoSrc = _config2.default.app.srcMasks.video.replace('<trackName>', track.wFileName);
	  track.albumId = albumId || album.project_id;
	  if (album) {
	    track.albumArtist = album.artist_name || album.subject;
	    track.multPlays = album.multPlays;
	    track.recipientId = album.recipient_id;
	    track.contentKey = album.contentKey;
	  }
	  return track;
	}
	
	function processAlbum(album) {
	  if (!album.project_id) {
	    return album;
	  }
	  album.sender = album.senderName || [album.owFirstname, album.owLastname].join(' ').trim();
	  album.albumName = [album.album, album.album2].join(' ').trim() || album.subject;
	  album.shortSentDate = (0, _datetime.formatDate)(album.sent_date);
	  album.fullSentDate = (0, _datetime.formatDateTime)(album.sent_date);
	  album.expiryDateText = (0, _datetime.formatDate)(album.expiryDate);
	  album.project_id = Number(album.project_id);
	  album.projectId = album.project_id;
	  album.recipient_id = Number(album.recipient_id);
	  album.downloadable = !!album.downloadable;
	  album.isPress = !!album.isPress;
	  album.projectContentType = album.projectType === _projects.projectTypes.quickSend ? _projects.projectTypes.quickSend : album.audiovideo;
	  album.labelName = album.senderLabel || album.label_name;
	  return album;
	}
	
	function processAlbums(albums) {
	  if (Array.isArray(albums)) {
	    albums.map(function (album) {
	      return processAlbum(album);
	    });
	  } else {
	    processAlbum(albums);
	  }
	
	  return albums;
	}
	
	function processTracks(_ref2) {
	  var tracks = _ref2.tracks,
	      albumId = _ref2.albumId,
	      album = _ref2.album;
	
	  if (Array.isArray(tracks)) {
	    tracks.map(function (track) {
	      return processTrack({ track: track, albumId: albumId, album: album });
	    });
	  } else {
	    processTrack({ track: tracks, albumId: albumId, album: album });
	  }
	
	  return tracks;
	}
	
	function getSortedAlbums(albums, activeOrder, order) {
	  if (!activeOrder) {
	    return [{ title: '', data: albums }];
	  }
	
	  var isDateOrder = activeOrder === 'sent_date' || activeOrder === 'releaseDate';
	  var groupedAlbums = (0, _groupBy4.default)(albums, activeOrder);
	  var sortedKeys = (0, _keys2.default)(groupedAlbums).sort(function (keyA, keyB) {
	    var sign = order[activeOrder] === 'asc' ? 1 : -1;
	    var res = sign;
	
	    if (isDateOrder) {
	      var dateA = new Date(keyA || null);
	      var dateB = new Date(keyB || null);
	      res = dateA > dateB ? sign : -sign;
	    } else if (typeof keyA === 'string' && typeof keyB === 'string') {
	      res = keyA.toLowerCase() > keyB.toLowerCase() ? sign : -sign;
	    } else {
	      res = keyA > keyB ? sign : -sign;
	    }
	
	    return res;
	  });
	
	  var sortedAlbums = [];
	  sortedKeys.map(function (key) {
	    var title = key;
	    if (title && isDateOrder) {
	      title = title ? (0, _moment2.default)(new Date(title)).format(_datetime.dateFormat.date) : '';
	    }
	    sortedAlbums.push({ id: (0, _uuid2.default)(), title: title, data: groupedAlbums[key] });
	  });
	
	  return sortedAlbums;
	}
	
	function getFilteredAlbums(albums, kw) {
	  return (0, _utils.filterObjectsByKws)({ objects: albums, fields: filteredFields, kw: kw });
	}
	
	function getPartTracks(allTracks) {
	  var parts = [];
	  var tracks = {};
	
	  allTracks.map(function (track, index) {
	    var part = track.part || 0;
	
	    if (!tracks[part]) {
	      tracks[part] = [];
	    }
	    tracks[part].push(index);
	
	    if (!parts.includes(part)) {
	      parts.push(part);
	    }
	  });
	
	  return { tracks: tracks, parts: parts };
	}

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sectionDeniedUserTypes = exports.permissionsTypesFields = exports.permissionsMap = undefined;
	
	var _slicedToArray2 = __webpack_require__(78);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(72);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _get3 = __webpack_require__(19);
	
	var _get4 = _interopRequireDefault(_get3);
	
	exports.getRawPermissionsTypesFields = getRawPermissionsTypesFields;
	exports.canCreateProjectByType = canCreateProjectByType;
	exports.canUploadMedia = canUploadMedia;
	exports.canEditMedia = canEditMedia;
	exports.hasContactsAccess = hasContactsAccess;
	exports.hasProjectsAccess = hasProjectsAccess;
	exports.hasCloudServicesAccess = hasCloudServicesAccess;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var permissionsMap = exports.permissionsMap = {
	  createSharespace: 'createSh',
	  createProject: 'createProj',
	  createNewsletter: 'createNews',
	  uploadSharespaceContent: 'uploadShContent',
	  uploadSharespaceCover: 'uploadShCover',
	  forwarding: 'fwd',
	  noPasswordFeature: 'noPassword',
	  quickSendAccess: 'quickSend',
	  convertQuickSend: 'convertQS',
	  uploadOwnProjectMusic: 'uploadPrContent',
	  deleteOwnProjectMusic: 'deletePrContent',
	  editProjectCover: 'editCover',
	  newsWrapAccess: 'newsWrapp'
	};
	
	var permissionsTypesFields = exports.permissionsTypesFields = {
	  createProject: {
	    sharespace: 'createSharespace',
	    all: 'createProject',
	    audio: 'createProject',
	    video: 'createProject',
	    newsletter: 'createNewsletter'
	  },
	  uploadMedia: {
	    sharespace: 'uploadSharespaceContent',
	    audio: 'uploadOwnProjectMusic',
	    video: 'uploadOwnProjectMusic'
	  },
	  editMedia: {
	    sharespace: 'uploadSharespaceContent',
	    audio: 'deleteOwnProjectMusic',
	    video: 'deleteOwnProjectMusic'
	  }
	};
	
	var sectionDeniedUserTypes = exports.sectionDeniedUserTypes = {
	  contacts: ['listener'],
	  projects: ['listener'],
	  cloudServices: ['listener']
	};
	
	function getRawPermissionsTypesFields() {
	  var res = {};
	  (0, _entries2.default)(permissionsTypesFields).map(function (_ref) {
	    var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	        type = _ref2[0],
	        map = _ref2[1];
	
	    res[type] = {};
	    (0, _entries2.default)(map).map(function (_ref3) {
	      var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
	          subtype = _ref4[0],
	          field = _ref4[1];
	
	      res[type][subtype] = permissionsMap[field];
	    });
	  });
	
	  return res;
	}
	
	function hasProjectPermissionsType(_ref5) {
	  var permissions = _ref5.permissions,
	      projectType = _ref5.projectType,
	      permissionsType = _ref5.permissionsType;
	
	  var field = permissionsTypesFields[permissionsType][projectType];
	  return !!permissions[field] || false;
	}
	
	function canCreateProjectByType(permissions, projectType) {
	  return hasProjectPermissionsType({ permissions: permissions, projectType: projectType, permissionsType: 'createProject' });
	}
	
	function canUploadMedia(permissions, projectType) {
	  return hasProjectPermissionsType({ permissions: permissions, projectType: projectType, permissionsType: 'uploadMedia' });
	}
	
	function canEditMedia(permissions, projectType) {
	  return hasProjectPermissionsType({ permissions: permissions, projectType: projectType, permissionsType: 'editMedia' });
	}
	
	function hasContactsAccess(user) {
	  return user && !sectionDeniedUserTypes.contacts.includes(user.type);
	}
	
	function hasProjectsAccess(user) {
	  return !sectionDeniedUserTypes.projects.includes((0, _get4.default)(user, 'type'));
	}
	
	function hasCloudServicesAccess(user) {
	  return user && !sectionDeniedUserTypes.cloudServices.includes(user.type);
	}

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(8);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	exports.default = reducer;
	exports.setFiles = setFiles;
	exports.setPath = setPath;
	exports.setPathCollection = setPathCollection;
	exports.setError = setError;
	exports.setProcessing = setProcessing;
	exports.clearFilesCache = clearFilesCache;
	exports.uploadFromCloud = uploadFromCloud;
	exports.setCSRFState = setCSRFState;
	exports.boxcomGetToken = boxcomGetToken;
	exports.boxcomGetFolders = boxcomGetFolders;
	exports.boxcomDownloadFile = boxcomDownloadFile;
	
	var _loadReducer = __webpack_require__(69);
	
	var _loadReducer2 = _interopRequireDefault(_loadReducer);
	
	var _update2 = __webpack_require__(501);
	
	var _update3 = _interopRequireDefault(_update2);
	
	var _auth = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SET_FILES = 'cloud/SET_FILES';
	var SET_PATH = 'cloud/SET_PATH';
	var SET_PATH_COLLECTION = 'cloud/SET_PATH_COLLECTION';
	var SET_ERROR = 'cloud/SET_ERROR';
	var SET_PROCESSING = 'cloud/SET_PROCESSING';
	var CLEAR_FILES_CACHE = 'cloud/CLEAR_FILES_CACHE';
	var SET_CSRF_STATE = 'cloud/SET_CSRF_STATE';
	
	var loadReducer = (0, _loadReducer2.default)('cloud', {
	  uploadFromCloud: {},
	  boxcomToken: {},
	  boxcomGetFolders: {},
	  boxcomDownloadFile: {}
	});
	
	var initialState = (0, _extends4.default)({}, loadReducer.initialState, {
	  dropbox: {
	    files: {},
	    pathId: '',
	    pathCollection: [],
	    error: null,
	    processing: false,
	    csrfState: ''
	  },
	  boxcom: {
	    files: {},
	    pathId: '',
	    pathCollection: [],
	    error: null,
	    processing: false,
	    csrfState: ''
	  },
	  service: ''
	});
	
	function updateServiceState(service, state, data) {
	  return (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, service, (0, _extends4.default)({}, state[service], data)));
	}
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case 'RESET':
	      return initialState;
	    case SET_FILES:
	      return (0, _update3.default)(state, (0, _defineProperty3.default)({}, action.service, {
	        files: (0, _defineProperty3.default)({}, action.pathId, { $set: action.files }),
	        error: { $set: null }
	      }));
	    case SET_PATH:
	      return updateServiceState(action.service, state, {
	        pathId: action.pathId,
	        error: null
	      });
	    case SET_PATH_COLLECTION:
	      return updateServiceState(action.service, state, {
	        pathCollection: action.pathCollection
	      });
	    case SET_ERROR:
	      return updateServiceState(action.service, state, {
	        error: action.error
	      });
	    case SET_PROCESSING:
	      return updateServiceState(action.service, state, {
	        processing: action.processing
	      });
	    case SET_CSRF_STATE:
	      return updateServiceState(action.service, state, {
	        csrfState: action.csrfState
	      });
	    case _auth.ACTIONS.SET_BOX_TOKEN_SUCCESS:
	    case _auth.ACTIONS.DELETE_BOX_TOKEN_SUCCESS:
	    case CLEAR_FILES_CACHE:
	      return updateServiceState(action.service, state, {
	        files: {},
	        error: null
	      });
	    default:
	      return loadReducer.reducer(state, action);
	  }
	}
	
	function setFiles(_ref) {
	  var service = _ref.service,
	      pathId = _ref.pathId,
	      files = _ref.files;
	
	  return {
	    type: SET_FILES,
	    service: service,
	    pathId: pathId,
	    files: files
	  };
	}
	
	function setPath(service, pathId) {
	  return {
	    type: SET_PATH,
	    service: service,
	    pathId: pathId
	  };
	}
	
	function setPathCollection(service, pathCollection) {
	  return {
	    type: SET_PATH_COLLECTION,
	    service: service,
	    pathCollection: pathCollection
	  };
	}
	
	function setError(service, error) {
	  return {
	    type: SET_ERROR,
	    service: service,
	    error: error
	  };
	}
	
	function setProcessing(service, processing) {
	  return {
	    type: SET_PROCESSING,
	    service: service,
	    processing: processing
	  };
	}
	
	function clearFilesCache(service) {
	  return {
	    type: CLEAR_FILES_CACHE,
	    service: service
	  };
	}
	
	function uploadFromCloud(_ref2) {
	  var projectId = _ref2.projectId,
	      name = _ref2.name,
	      url = _ref2.url,
	      _ref2$part = _ref2.part,
	      part = _ref2$part === undefined ? 1 : _ref2$part,
	      _ref2$replacedId = _ref2.replacedId,
	      replacedId = _ref2$replacedId === undefined ? 0 : _ref2$replacedId;
	
	  return {
	    types: loadReducer.constantsByKey.uploadFromCloud,
	    promise: function promise(client) {
	      return client.post('FileUpload_wa/uploadAudioVideoFromURL', { data: { projectId: projectId, url: url, part: part, replacedId: replacedId, qqfilename: name } });
	    },
	    projectId: projectId,
	    url: url,
	    name: name
	  };
	}
	
	function setCSRFState(service, csrfState) {
	  return {
	    type: SET_CSRF_STATE,
	    service: service,
	    csrfState: csrfState
	  };
	}
	
	function boxcomGetToken(authCode) {
	  return {
	    types: loadReducer.constantsByKey.boxcomToken,
	    promise: function promise(client) {
	      return client.post('boxcom/token', { json: true, data: { authCode: authCode } });
	    },
	    authCode: authCode
	  };
	}
	
	function boxcomGetFolders(path) {
	  return {
	    types: loadReducer.constantsByKey.boxcomGetFolders,
	    promise: function promise(client) {
	      return client.get('boxcom/folders', { json: true, params: { path: path } });
	    },
	    pathId: path
	  };
	}
	
	function boxcomDownloadFile(_ref3) {
	  var fileId = _ref3.fileId,
	      fileName = _ref3.fileName,
	      projectId = _ref3.projectId;
	
	  return {
	    types: loadReducer.constantsByKey.boxcomDownloadFile,
	    promise: function promise(client) {
	      return client.post('boxcom/download-file', { json: true, data: { fileId: fileId, fileName: fileName, projectId: projectId } });
	    },
	    fileId: fileId,
	    fileName: fileName,
	    projectId: projectId
	  };
	}

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get3 = __webpack_require__(19);
	
	var _get4 = _interopRequireDefault(_get3);
	
	exports.default = reducer;
	exports.isLoaded = isLoaded;
	exports.isLoadTime = isLoadTime;
	exports.load = load;
	exports.loadByKey = loadByKey;
	exports.loadByKeyOnAcceptDaw = loadByKeyOnAcceptDaw;
	exports.selectFormat = selectFormat;
	exports.downloadTracks = downloadTracks;
	exports.downloadFileFromKey = downloadFileFromKey;
	exports.sendFeedback = sendFeedback;
	exports.clearPlaylistError = clearPlaylistError;
	
	var _loadReducer = __webpack_require__(69);
	
	var _loadReducer2 = _interopRequireDefault(_loadReducer);
	
	var _TypeCast = __webpack_require__(260);
	
	var _playstats = __webpack_require__(358);
	
	var _auth = __webpack_require__(31);
	
	var _responseCodes = __webpack_require__(99);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SELECT_FORMAT = 'playlist/SELECT_FORMAT'; /* Playlist redux reducer and action creators */
	
	var CLEAR_PLAYLIST_ERROR = 'playlist/CLEAR_PLAYLIST_ERROR';
	
	var loadReducer = (0, _loadReducer2.default)('playlist', {
	  playlist: {
	    action: 'load',
	    init: { album: {}, tracks: [], user: {} },
	    fields: { album: 'project', tracks: 'tracks', user: 'user' }
	  },
	  downloadTracks: { init: null },
	  downloadFileFromKey: {},
	  sendFeedback: {}
	});
	
	var initialState = (0, _extends3.default)({}, loadReducer.initialState, {
	  format: 'mp3'
	});
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case 'RESET':
	      return initialState;
	    case SELECT_FORMAT:
	      return (0, _extends3.default)({}, state, {
	        format: action.format
	      });
	    case CLEAR_PLAYLIST_ERROR:
	      return (0, _extends3.default)({}, state, {
	        playlistLoadError: null
	      });
	    default:
	      return loadReducer.reducer(state, action);
	  }
	}
	
	function isLoaded(globalState, id) {
	  return (0, _get4.default)(globalState, ['playlist', 'playlistLoaded', id], false);
	}
	
	function isLoadTime(globalState, id) {
	  return !isLoaded(globalState, id) && (0, _get4.default)(globalState, 'auth.user', false);
	}
	
	function setStatsOnLoad(data) {
	  return function (dispatch) {
	    var _data$project = data.project,
	        project = _data$project === undefined ? {} : _data$project,
	        _data$tracks = data.tracks,
	        tracks = _data$tracks === undefined ? [] : _data$tracks;
	
	    dispatch((0, _playstats.setData)({ albums: [project], albumsTracks: (0, _defineProperty3.default)({}, project.project_id, tracks) }));
	    return data;
	  };
	}
	
	function loadFromEndpoint(_ref) {
	  var key = _ref.key,
	      endpoint = _ref.endpoint,
	      _ref$params = _ref.params,
	      params = _ref$params === undefined ? {} : _ref$params;
	
	  return function (dispatch) {
	    return dispatch({
	      types: loadReducer.constantsByKey.playlist,
	      promise: function promise(client) {
	        var result = client.post(endpoint, (0, _extends3.default)({ data: { key: key } }, params));
	        result.promise.then(function (data) {
	          return dispatch(setStatsOnLoad(data));
	        }).catch(function (err) {
	          return err;
	        });
	        return result;
	      },
	      key: key
	    });
	  };
	}
	
	function load(_ref2) {
	  var key = _ref2.key;
	
	  return function (dispatch) {
	    return dispatch(loadFromEndpoint({ key: key, endpoint: 'viewer_wa/getCompleteAlbum' }));
	  };
	}
	
	function loadByKey(_ref3) {
	  var key = _ref3.key;
	
	  var params = { hideErrorCodes: [_responseCodes.playlistCodes.loginRequired, _responseCodes.playlistCodes.notAvailable, _responseCodes.playlistCodes.contentLocked] };
	  return function (dispatch) {
	    return dispatch(loadFromEndpoint({ key: key, endpoint: 'auth/getAlbumFromKey', params: params }));
	  };
	}
	
	function loadByKeyOnAcceptDaw(_ref4) {
	  var key = _ref4.key;
	
	  return function (dispatch) {
	    return dispatch(loadFromEndpoint({ key: key, endpoint: 'auth/acceptDaw' }));
	  };
	}
	
	function selectFormat(format) {
	  return {
	    type: SELECT_FORMAT,
	    format: format
	  };
	}
	
	function downloadTracks(_ref5) {
	  var key = _ref5.key,
	      _ref5$format = _ref5.format,
	      format = _ref5$format === undefined ? 'mp3' : _ref5$format,
	      tracks = _ref5.tracks,
	      _ref5$getEstimation = _ref5.getEstimation,
	      getEstimation = _ref5$getEstimation === undefined ? false : _ref5$getEstimation;
	
	  return function (dispatch) {
	    var params = { data: { key: key, fmt: format, downloadList: (0, _TypeCast.asPostArray)(tracks, true) }, successCodes: [3, 5] };
	    var isUser = dispatch((0, _auth.isLoggedIn)());
	    var endpoint = getEstimation ? isUser ? 'viewer_wa/getDownloadProcTime' : 'auth/getDownloadProcTime' : isUser ? 'viewer_wa/downloadFiles' : 'auth/downloadNonWatermarkFiles';
	
	    return dispatch({
	      types: loadReducer.constantsByKey.downloadTracks,
	      promise: function promise(client) {
	        return client.post(endpoint, params);
	      },
	      key: key,
	      tracks: tracks,
	      format: format
	    });
	  };
	}
	
	function downloadFileFromKey(key) {
	  return {
	    types: loadReducer.constantsByKey.downloadFileFromKey,
	    promise: function promise(client) {
	      return client.post('auth/dwnFileFromKey', { data: { key: key }, successCodes: [_responseCodes.downloadTracksCodes.needLogin] });
	    },
	    key: key
	  };
	}
	
	function sendFeedback(_ref6) {
	  var key = _ref6.key,
	      feedbackText = _ref6.feedbackText;
	
	  return {
	    types: loadReducer.constantsByKey.sendFeedback,
	    promise: function promise(client) {
	      return client.post('auth/feedback', { data: { key: key, feedbackText: feedbackText } });
	    },
	    key: key,
	    feedbackText: feedbackText
	  };
	}
	
	function clearPlaylistError() {
	  return {
	    type: CLEAR_PLAYLIST_ERROR
	  };
	}

/***/ }),
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactI18next = __webpack_require__(12);
	
	var _reactRouterRedux = __webpack_require__(40);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BackButton = (_dec = (0, _reactRedux.connect)(null, { goBack: _reactRouterRedux.goBack, push: _reactRouterRedux.push }), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(BackButton, _Component);
	
	  function BackButton() {
	    (0, _classCallCheck3.default)(this, BackButton);
	    return (0, _possibleConstructorReturn3.default)(this, (BackButton.__proto__ || (0, _getPrototypeOf2.default)(BackButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(BackButton, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          t = _props.t,
	          asBlock = _props.asBlock,
	          className = _props.className,
	          blockClassName = _props.blockClassName,
	          backUrl = _props.backUrl;
	
	      var buttonClass = (0, _bind2.default)(className, 'btn', 'btn-stroke', 'small');
	
	      var button = _react2.default.createElement(
	        'button',
	        { className: buttonClass, onClick: function onClick() {
	            return backUrl ? _this2.props.push(backUrl) : _this2.props.goBack();
	          } },
	        _react2.default.createElement('i', { className: 'icon-back' }),
	        _react2.default.createElement(
	          'span',
	          { className: 'margin-left-10' },
	          t('Back')
	        )
	      );
	
	      return asBlock ? _react2.default.createElement(
	        'div',
	        { className: blockClassName },
	        button
	      ) : button;
	    }
	  }]);
	  return BackButton;
	}(_react.Component), _class2.propTypes = {
	  asBlock: _propTypes2.default.bool,
	  backUrl: _propTypes2.default.string,
	  blockClassName: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  goBack: _propTypes2.default.func,
	  push: _propTypes2.default.func,
	  t: _propTypes2.default.func
	}, _temp)) || _class) || _class);
	exports.default = BackButton;
	module.exports = exports['default'];

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _assign = __webpack_require__(186);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(113);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _weakMap = __webpack_require__(541);
	
	var _weakMap2 = _interopRequireDefault(_weakMap);
	
	var _defaultsDeep3 = __webpack_require__(448);
	
	var _defaultsDeep4 = _interopRequireDefault(_defaultsDeep3);
	
	var _core = __webpack_require__(1403);
	
	var _core2 = _interopRequireDefault(_core);
	
	var _callbackProxy = __webpack_require__(2007);
	
	var _callbackProxy2 = _interopRequireDefault(_callbackProxy);
	
	var _callbackNames = __webpack_require__(824);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var callbackProxies = new _weakMap2.default();
	
	var createCallbackProxies = function createCallbackProxies(names) {
	  var proxyMap = {};
	
	  names.forEach(function (callbackName) {
	    proxyMap[callbackName] = new _callbackProxy2.default(callbackName);
	  });
	
	  return proxyMap;
	};
	
	var registerOptionsCallbacks = function registerOptionsCallbacks(_ref) {
	  var callbacks = _ref.callbacks,
	      cbProxies = _ref.cbProxies;
	
	  (0, _keys2.default)(callbacks).forEach(function (callbackName) {
	    var callbackProxy = cbProxies[callbackName];
	
	    callbackProxy.add(callbacks[callbackName]);
	  });
	};
	
	var createFineUploader = function createFineUploader(_ref2) {
	  var cbProxies = _ref2.cbProxies,
	      options = _ref2.options;
	
	  var optionsCopy = (0, _assign2.default)({ callbacks: {} }, options);
	
	  (0, _keys2.default)(cbProxies).forEach(function (callbackName) {
	    var proxy = cbProxies[callbackName];
	
	    optionsCopy.callbacks[callbackName] = proxy.proxyFunction;
	  });
	
	  return new _core2.default.FineUploaderBasic(optionsCopy);
	};
	
	var normalizeCallbackName = function normalizeCallbackName(name) {
	  if (!name.match(/^on[A-Z]/)) {
	    return 'on' + name[0].toUpperCase() + name.slice(1);
	  }
	
	  return name;
	};
	
	var FineUploaderTraditional = function () {
	  function FineUploaderTraditional(options) {
	    (0, _classCallCheck3.default)(this, FineUploaderTraditional);
	
	    var defaultOptions = {
	      autoUpload: true,
	      maxConnections: 1,
	      retry: {
	        enableAuto: false,
	        autoAttemptDelay: 5,
	        maxAutoAttempts: 4,
	        preventRetryResponseProperty: 'preventRetry'
	      },
	      request: {
	        endpoint: '/api/upload'
	      },
	      chunking: {
	        enabled: true,
	        mandatory: true,
	        partSize: 2000000,
	        concurrent: {
	          enabled: false
	        },
	        success: {
	          endpoint: '/api/uploaded'
	        }
	      },
	      callbacks: {}
	    };
	
	    var allOptions = (0, _defaultsDeep4.default)(options, defaultOptions);
	    var callbacks = allOptions.callbacks;
	
	
	    var optionsSansCallbacks = allOptions;
	    delete optionsSansCallbacks.callbacks;
	    this.options = optionsSansCallbacks;
	
	    callbackProxies.set(this, createCallbackProxies(_callbackNames.traditional));
	
	    registerOptionsCallbacks({ callbacks: callbacks, cbProxies: callbackProxies.get(this) });
	
	    this.methods = createFineUploader({
	      cbProxies: callbackProxies.get(this),
	      options: optionsSansCallbacks
	    });
	  }
	
	  (0, _createClass3.default)(FineUploaderTraditional, [{
	    key: 'off',
	    value: function off(name, callback) {
	      var normalizedName = normalizeCallbackName(name);
	      var proxy = callbackProxies.get(this)[normalizedName];
	
	      proxy.remove(callback);
	    }
	  }, {
	    key: 'on',
	    value: function on(name, callback) {
	      var normalizedName = normalizeCallbackName(name);
	      var proxy = callbackProxies.get(this)[normalizedName];
	
	      proxy.add(callback);
	    }
	  }]);
	  return FineUploaderTraditional;
	}();
	
	exports.default = FineUploaderTraditional;
	module.exports = exports['default'];

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(21);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(49);
	
	var _Overlay = __webpack_require__(465);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _Popover = __webpack_require__(466);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var PopoverMenu = (_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(PopoverMenu, _Component);
	
	  function PopoverMenu() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, PopoverMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = PopoverMenu.__proto__ || (0, _getPrototypeOf2.default)(PopoverMenu)).call.apply(_ref, [this].concat(args)));
	
	    _this.onResize = function () {
	      _this.hide();
	    };
	
	    _this.state = {
	      show: false,
	      container: _this
	    };
	    _this.data = null;
	    return _this;
	  }
	
	  (0, _createClass3.default)(PopoverMenu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (typeof window !== 'undefined') {
	        window.addEventListener('resize', this.onResize);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.show !== this.props.show) {
	        this.setState({ show: nextProps.show });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (typeof window !== 'undefined') {
	        window.removeEventListener('resize', this.onResize);
	      }
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      this.setState({
	        show: false,
	        data: null
	      });
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle(e, newData) {
	      var _this2 = this;
	
	      e.preventDefault();
	      e.stopPropagation();
	      var newTarget = e.target;
	      var _state = this.state,
	          target = _state.target,
	          show = _state.show;
	
	
	      if (newTarget === target && show) {
	        this.hide();
	      } else {
	        setTimeout(function () {
	          var newShow = newData === _this2.data ? !show : true;
	          _this2.data = newShow ? newData : null;
	          _this2.setState({
	            show: newShow,
	            target: newTarget,
	            container: _this2,
	            containerPadding: 10
	          });
	        }, 0);
	      }
	    }
	
	    // TODO: refactor popovers for eslint
	    /* eslint-disable react/no-find-dom-node */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          id = _props.id,
	          className = _props.className;
	      var _state2 = this.state,
	          _target = _state2.target,
	          props = (0, _objectWithoutProperties3.default)(_state2, ['target']);
	
	
	      return _react2.default.createElement(
	        _Overlay2.default,
	        (0, _extends3.default)({
	          target: function target() {
	            return (0, _reactDom.findDOMNode)(_target);
	          },
	          placement: 'bottom',
	          rootClose: true,
	          onHide: this.hide
	        }, props),
	        _react2.default.createElement(
	          _Popover2.default,
	          { id: id },
	          _react2.default.createElement(
	            'ul',
	            { className: (0, _classnames2.default)('popoverMenu', className), onClick: this.hide },
	            children
	          )
	        )
	      );
	    }
	    /* eslint-enable react/no-find-dom-node */
	
	  }]);
	  return PopoverMenu;
	}(_react.Component), _class2.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  className: _propTypes2.default.string,
	  id: _propTypes2.default.string.isRequired,
	  show: _propTypes2.default.bool
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'hide', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'hide'), _class.prototype)), _class);
	exports.default = PopoverMenu;
	module.exports = exports['default'];

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _config = __webpack_require__(41);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1338);
	
	var Thumb = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(Thumb, _PureComponent);
	
	  function Thumb() {
	    (0, _classCallCheck3.default)(this, Thumb);
	    return (0, _possibleConstructorReturn3.default)(this, (Thumb.__proto__ || (0, _getPrototypeOf2.default)(Thumb)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Thumb, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          fileName = _props.fileName,
	          className = _props.className,
	          onClick = _props.onClick,
	          urlPartName = _props.urlPartName,
	          defaultImageName = _props.defaultImageName,
	          size = _props.size,
	          asBackground = _props.asBackground;
	
	      var noImage = __webpack_require__(2321)("./" + (size ? defaultImageName + '-' + size : defaultImageName) + '.png'); // eslint-disable-line import/no-dynamic-require
	      var thumbUrl = fileName ? _config2.default.app.urlParts[urlPartName] + fileName : noImage;
	
	      if (asBackground) {
	        return _react2.default.createElement('div', {
	          style: { backgroundImage: 'url(\'' + thumbUrl + '\')' },
	          className: (0, _bind2.default)(styles.bg, className),
	          onClick: onClick
	        });
	      }
	
	      return _react2.default.createElement('img', {
	        alt: '',
	        src: thumbUrl,
	        className: className,
	        onClick: onClick,
	        draggable: false,
	        onMouseDown: function onMouseDown(e) {
	          return e.preventDefault();
	        }
	      });
	    }
	  }]);
	  return Thumb;
	}(_react.PureComponent), _class.propTypes = {
	  asBackground: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  defaultImageName: _propTypes2.default.string,
	  fileName: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  size: _propTypes2.default.string,
	  urlPartName: _propTypes2.default.string
	}, _class.defaultProps = {
	  defaultImageName: 'no-image',
	  size: '',
	  urlPartName: 'thumb'
	}, _temp);
	exports.default = Thumb;
	module.exports = exports['default'];

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(34);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _isString3 = __webpack_require__(674);
	
	var _isString4 = _interopRequireDefault(_isString3);
	
	var _isFinite3 = __webpack_require__(1555);
	
	var _isFinite4 = _interopRequireDefault(_isFinite3);
	
	var _isNumber3 = __webpack_require__(673);
	
	var _isNumber4 = _interopRequireDefault(_isNumber3);
	
	var _isObjectLike3 = __webpack_require__(199);
	
	var _isObjectLike4 = _interopRequireDefault(_isObjectLike3);
	
	var _isPlainObject3 = __webpack_require__(87);
	
	var _isPlainObject4 = _interopRequireDefault(_isPlainObject3);
	
	exports.asArray = asArray;
	exports.asNumberArray = asNumberArray;
	exports.asObject = asObject;
	exports.asNumber = asNumber;
	exports.asBoolean = asBoolean;
	exports.asString = asString;
	exports.asPostArray = asPostArray;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* types cast helper for API responses with invalid types of data */
	
	function asArray(val) {
	  var allowNull = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var castAsNumber = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (allowNull && val === null) {
	    return null;
	  }
	  if ((0, _isString4.default)(val)) {
	    if (val.startsWith('(') && val.endsWith(')')) {
	      var str = val.substr(1, val.length - 2);
	      str = str.split(',');
	      var res = [];
	      str.map(function (sVal) {
	        var arrVal = sVal.trim().replace(/^'/gm, '').replace(/'$/gm, '');
	        res.push(castAsNumber ? asNumber(arrVal) : arrVal); // eslint-disable-line no-use-before-define
	      });
	      return res;
	    }
	  }
	  if (!Array.isArray(val)) {
	    return [];
	  }
	  return val;
	}
	
	function asNumberArray(val) {
	  var allowNull = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  return asArray(val, allowNull, true);
	}
	
	function asObject(val) {
	  var asPlain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	  var allowNull = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (allowNull && val === null) {
	    return null;
	  }
	  if (asPlain && !(0, _isPlainObject4.default)(val) || !asPlain && !(0, _isObjectLike4.default)(val)) {
	    return {};
	  }
	  return val;
	}
	
	function asNumber(val) {
	  var isFinite = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	  var allowNull = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (allowNull && val === null) {
	    return null;
	  }
	  var res = Number(val);
	  if (isFinite) {
	    return (0, _isFinite4.default)(res) ? res : 0;
	  }
	  return (0, _isNumber4.default)(res) ? res : 0;
	}
	
	function asBoolean(val) {
	  var allowNull = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  if (allowNull && val === null) {
	    return null;
	  }
	  var isNumber = (0, _isFinite4.default)(Number(val));
	  if (isNumber) {
	    return !!Number(val);
	  }
	  return !!val;
	}
	
	function asString(val) {
	  var allowNull = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  if (allowNull && val === null) {
	    return null;
	  }
	  if ((0, _isString4.default)(val)) {
	    return val;
	  }
	  var isNumber = (0, _isFinite4.default)(Number(val));
	  if (isNumber) {
	    return '' + Number(val);
	  }
	  return '';
	}
	
	function asPostArray(array) {
	  var asStringsArray = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var resultArray = [].concat((0, _toConsumableArray3.default)(array));
	  if (asStringsArray) {
	    resultArray = resultArray.map(function (item) {
	      return '"' + item.toString() + '"';
	    });
	  }
	  return '[' + resultArray.toString() + ']';
	}

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.chartDateFormat = exports.chartLegendPosition = undefined;
	
	var _isFinite = __webpack_require__(218);
	
	var _isFinite2 = _interopRequireDefault(_isFinite);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _toConsumableArray2 = __webpack_require__(34);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends3 = __webpack_require__(8);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _toArray2 = __webpack_require__(1566);
	
	var _toArray3 = _interopRequireDefault(_toArray2);
	
	var _isFunction2 = __webpack_require__(450);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	exports.getDataArray = getDataArray;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var chartLegendPosition = exports.chartLegendPosition = {
	  none: 'none',
	  top: 'top',
	  bottom: 'bottom'
	};
	
	var chartDateFormat = exports.chartDateFormat = {
	  month: 'dd.MM',
	  monthStr: 'dd MMM',
	  date: 'dd MMM yyyy',
	  shortDate: 'dd.MM.yyyy'
	};
	
	function getUniqKeyFor(_ref) {
	  var key = _ref.key,
	      object = _ref.object;
	
	  var uniqKey = key;
	  var i = 1;
	  while (object[uniqKey]) {
	    uniqKey = key + ' (' + i + ')';
	    i += 1;
	  }
	  return uniqKey;
	}
	
	function getDataArray(_ref2) {
	  var data = _ref2.data,
	      keyName = _ref2.keyName,
	      valueName = _ref2.valueName,
	      sortBy = _ref2.sortBy;
	
	  var table = data.reduce(function (prev, current) {
	    var key = getUniqKeyFor({ key: (0, _isFunction3.default)(keyName) ? keyName(current) : current[keyName], object: prev });
	    var value = (0, _isFunction3.default)(valueName) ? valueName(current) : [current[valueName]];
	    return (0, _extends4.default)({}, prev, (0, _defineProperty3.default)({}, key, [key].concat((0, _toConsumableArray3.default)(value))));
	  }, {});
	  var uniqTable = (0, _toArray3.default)(table);
	
	  return !sortBy ? uniqTable : uniqTable.sort(function (first, last) {
	    var isValidValues = (0, _isFinite2.default)(first[1]) && (0, _isFinite2.default)(last[1]) || first[1].getTime && last[1].getTime;
	    if (isValidValues) {
	      return sortBy === 'desc' ? last[1] - first[1] : first[1] - last[1];
	    }
	  });
	}

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(78);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(72);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	exports.download = download;
	exports.downloadForm = downloadForm;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function download(url) {
	  var fileName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  var lnk = document.createElement('a');
	  lnk.href = url;
	  // lnk.target = '_blank'; // FF blocks new windows by default
	  lnk.download = fileName;
	  if (document) {
	    document.body.appendChild(lnk);
	    lnk.click();
	    document.body.removeChild(lnk);
	  }
	  lnk = null;
	}
	
	function downloadForm(url, fields) {
	  var form = document.createElement('form');
	  form.action = url;
	  form.method = 'POST';
	
	  (0, _entries2.default)(fields).map(function (_ref) {
	    var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	        name = _ref2[0],
	        val = _ref2[1];
	
	    var fld = document.createElement('input');
	    fld.type = 'hidden';
	    fld.name = name;
	    fld.value = val;
	    form.appendChild(fld);
	  });
	
	  form.submit();
	  form = null;
	}

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _validation = __webpack_require__(157);
	
	var validation = _interopRequireWildcard(_validation);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var required = validation.required,
	    email = validation.email,
	    minLength = validation.minLength; //This module is required for the same test fields in the application
	
	exports.default = {
	  email: [required, email],
	  emailNotRequired: [email],
	  password: [required, minLength(6)],
	  name: [required, minLength(2)],
	  lastName: [required, minLength(2)],
	  company: [required, minLength(2)],
	  message: [required, minLength(6)],
	  field: [required]
	};
	module.exports = exports['default'];

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isUndefined2 = __webpack_require__(240);
	
	var _isUndefined3 = _interopRequireDefault(_isUndefined2);
	
	exports.processRecipient = processRecipient;
	exports.processRecipients = processRecipients;
	exports.getFilteredRecipients = getFilteredRecipients;
	exports.groupRecipients = groupRecipients;
	
	var _moment = __webpack_require__(20);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _strings = __webpack_require__(59);
	
	var _utils = __webpack_require__(24);
	
	var _ordering = __webpack_require__(533);
	
	var _ordering2 = _interopRequireDefault(_ordering);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var filteredFields = ['id', 'fullName', 'email'];
	
	function processRecipient(recipient) {
	  var processedRecipient = (0, _extends3.default)({}, recipient);
	  processedRecipient.id = processedRecipient.id || processedRecipient.recipientId || processedRecipient.userId;
	  processedRecipient.expirationDate = (0, _moment2.default)(processedRecipient.recepEd || new Date());
	  processedRecipient.fullName = (0, _strings.concat)(' ', processedRecipient.name, processedRecipient.surname);
	  return processedRecipient;
	}
	
	function processRecipients() {
	  var recipients = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  return recipients.map(processRecipient);
	}
	
	function getFilteredRecipients(_ref) {
	  var recipients = _ref.recipients,
	      activeOrder = _ref.activeOrder,
	      order = _ref.order,
	      kw = _ref.kw;
	
	  var data = (0, _utils.filterObjectsByKws)({ objects: processRecipients(recipients), fields: filteredFields, kw: kw });
	  return (0, _ordering2.default)({ data: data, activeOrder: activeOrder, order: order });
	}
	
	function groupRecipients() {
	  var recipients = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  var groupedRecipients = [];
	  var groupMap = {};
	
	  recipients.map(function (recipient) {
	    if (recipient.groupId) {
	      if ((0, _isUndefined3.default)(groupMap[recipient.groupId])) {
	        groupMap[recipient.groupId] = groupedRecipients.length;
	      }
	      var groupIndex = groupMap[recipient.groupId];
	
	      if (!groupedRecipients[groupIndex]) {
	        groupedRecipients[groupIndex] = {
	          groupId: recipient.groupId,
	          groupName: recipient.groupName,
	          recipients: []
	        };
	      }
	      groupedRecipients[groupIndex].recipients.push(processRecipient(recipient));
	    } else {
	      groupedRecipients.push(processRecipient(recipient));
	    }
	  });
	
	  return groupedRecipients;
	}

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	exports.default = reducer;
	exports.setIsMobile = setIsMobile;
	exports.getId = getId;
	exports.setDelayedToast = setDelayedToast;
	exports.clearDelayedToast = clearDelayedToast;
	
	var _qim = __webpack_require__(110);
	
	var SET_IS_MOBILE = 'common/SET_IS_MOBILE';
	var GET_ID = 'common/GET_ID';
	var SET_DELAYED_TOAST = 'common/SET_DELAYED_TOAST';
	var CLEAR_DELAYED_TOAST = 'common/CLEAR_DELAYED_TOAST';
	
	var initialState = exports.initialState = {
	  isMobile: false,
	  ids: {
	    default: 0
	  },
	  delayedToast: {
	    type: 'info',
	    message: null
	  }
	};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case SET_IS_MOBILE:
	      {
	        return (0, _qim.set)(['isMobile'], true, state);
	      }
	    case GET_ID:
	      {
	        return (0, _qim.update)([['ids', action.prefix || 'default', (0, _qim.$apply)(function (id) {
	          return id + 1 || 1;
	        })]], state);
	      }
	    case SET_DELAYED_TOAST:
	      {
	        return (0, _qim.set)(['delayedToast'], { type: action.toastType, message: action.message }, state);
	      }
	    case CLEAR_DELAYED_TOAST:
	      {
	        return (0, _qim.set)(['delayedToast'], { type: null, message: null }, state);
	      }
	    default:
	      {
	        return state;
	      }
	  }
	}
	
	function setIsMobile() {
	  return {
	    type: SET_IS_MOBILE
	  };
	}
	
	function getId(prefix) {
	  return function (dispatch, getState) {
	    var newId = getState().common.ids[prefix || 'default'] + 1 || 1;
	    dispatch({
	      type: GET_ID,
	      prefix: prefix
	    });
	
	    return prefix ? '' + prefix + newId : newId;
	  };
	}
	
	function setDelayedToast(_ref) {
	  var type = _ref.type,
	      message = _ref.message;
	
	  return {
	    type: SET_DELAYED_TOAST,
	    toastType: type,
	    message: message
	  };
	}
	
	function clearDelayedToast() {
	  return {
	    type: CLEAR_DELAYED_TOAST
	  };
	}

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get2 = __webpack_require__(19);
	
	var _get3 = _interopRequireDefault(_get2);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case 'RESET':
	      return initialState;
	    case SET_SONGS_FILTER:
	      {
	        return (0, _extends3.default)({}, state, {
	          kw: action.kw
	        });
	      }
	    case UPDATE_CHECKED_SONGS:
	      {
	        return (0, _extends3.default)({}, state, {
	          checkedSongs: action.checkedSongs
	        });
	      }
	    default:
	      return reducer(state, action);
	  }
	};
	
	exports.isSongsLoaded = isSongsLoaded;
	exports.loadSongs = loadSongs;
	exports.setSongsFilter = setSongsFilter;
	exports.updateCheckedSongs = updateCheckedSongs;
	
	var _loadReducer = __webpack_require__(69);
	
	var _loadReducer2 = _interopRequireDefault(_loadReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SET_SONGS_FILTER = 'songs/SET_SONGS_FILTER'; /* Songs redux reducer and action creators */
	
	var UPDATE_CHECKED_SONGS = 'songs/UPDATE_CHECKED_SONGS';
	
	var loadReducer = (0, _loadReducer2.default)('songs', {
	  songs: { init: { tracks: {} } }
	});
	
	var reducer = loadReducer.reducer,
	    constantsByKey = loadReducer.constantsByKey;
	
	
	var initialState = (0, _extends3.default)({}, loadReducer.initialState, {
	  songsPopupVisible: false,
	  kw: '',
	  checkedSongs: {}
	});
	
	function isSongsLoaded() {
	  return function (dispatch, getState) {
	    return (0, _get3.default)(getState(), 'songs.songsLoaded');
	  };
	}
	
	function loadSongs() {
	  return {
	    types: constantsByKey.songs,
	    promise: function promise(client) {
	      return client.post('viewer_wa/playlists');
	    }
	  };
	}
	
	function setSongsFilter(_ref) {
	  var kw = _ref.kw;
	
	  return {
	    type: SET_SONGS_FILTER,
	    kw: kw
	  };
	}
	
	function updateCheckedSongs(checkedSongs) {
	  return {
	    type: UPDATE_CHECKED_SONGS,
	    checkedSongs: checkedSongs
	  };
	}

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(34);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _get2 = __webpack_require__(19);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _class, _temp;
	
	var _GA = __webpack_require__(826);
	
	var _GA2 = _interopRequireDefault(_GA);
	
	var _ReactUpdates = __webpack_require__(98);
	
	var _ReactUpdates2 = _interopRequireDefault(_ReactUpdates);
	
	var _ReactDefaultBatchingStrategy = __webpack_require__(481);
	
	var _ReactDefaultBatchingStrategy2 = _interopRequireDefault(_ReactDefaultBatchingStrategy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isHandlingError = false;
	
	var Log = (_temp = _class = function () {
	  function Log() {
	    var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] :  false ? this.LEVEL_DEBUG : this.LEVEL_INFO;
	    (0, _classCallCheck3.default)(this, Log);
	
	    this._level = level;
	    this.onErrorHandler();
	  }
	
	  (0, _createClass3.default)(Log, [{
	    key: 'onErrorHandler',
	    value: function onErrorHandler() {
	      var _this = this;
	
	      var self = this;
	
	      var ReactTryCatchBatchingStrategy = {
	        // this is part of the BatchingStrategy API. simply pass along
	        // what the default batching strategy would do.
	        get isBatchingUpdates() {
	          return _ReactDefaultBatchingStrategy2.default.isBatchingUpdates;
	        },
	
	        batchedUpdates: function batchedUpdates() {
	          try {
	            _ReactDefaultBatchingStrategy2.default.batchedUpdates.apply(_ReactDefaultBatchingStrategy2.default, arguments);
	          } catch (err) {
	            if (isHandlingError) {
	              // our error handling code threw an error. just throw now
	              throw err;
	            }
	
	            isHandlingError = true;
	            try {
	              var _ref = err || {},
	                  message = _ref.message,
	                  stack = _ref.stack;
	
	              self.e({ message: message, stack: stack });
	            } finally {
	              isHandlingError = false;
	            }
	          }
	        }
	      };
	      _ReactUpdates2.default.injection.injectBatchingStrategy(ReactTryCatchBatchingStrategy);
	
	      if (typeof window !== 'undefined') {
	        var oldOnError = window.onerror || _noop3.default;
	        window.onerror = function (msg, url, line, column, error) {
	          oldOnError(msg, url, line, column, error);
	          var stack = (0, _get3.default)(error, 'stack');
	          _this.e({ msg: msg, url: url, line: line, column: column || (0, _get3.default)(window, 'event.errorCharacter'), stack: stack });
	          return false;
	        };
	      }
	    }
	  }, {
	    key: 'level',
	    value: function level(_level) {
	      if (typeof _level !== 'undefined') {
	        this._level = _level;
	      }
	      return this._level;
	    }
	  }, {
	    key: 'getLogArgs',
	    value: function getLogArgs(args) {
	      if (args.length > 1) {
	        var tag = args.shift(0);
	        return ['[' + tag + ']'].concat((0, _toConsumableArray3.default)(args));
	      }
	      return args;
	    }
	  }, {
	    key: 'd',
	    value: function d() {
	      var _console;
	
	      // eslint-disable-line id-length
	      if (this._level > this.LEVEL_DEBUG) {
	        return this;
	      }
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      (_console = console).log.apply(_console, (0, _toConsumableArray3.default)(this.getLogArgs(args)));
	      return this;
	    }
	  }, {
	    key: 'i',
	    value: function i() {
	      var _console2;
	
	      // eslint-disable-line id-length
	      if (this._level > this.LEVEL_INFO) {
	        return this;
	      }
	
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      (_console2 = console)[console.info ? 'info' : 'log'].apply(_console2, (0, _toConsumableArray3.default)(this.getLogArgs(args)));
	      return this;
	    }
	  }, {
	    key: 'w',
	    value: function w() {
	      var _console3;
	
	      // eslint-disable-line id-length
	      if (this._level > this.LEVEL_WARNING) {
	        return this;
	      }
	
	      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      (_console3 = console).warn.apply(_console3, (0, _toConsumableArray3.default)(this.getLogArgs(args)));
	      return this;
	    }
	  }, {
	    key: 'e',
	    value: function e() {
	      var _console4;
	
	      for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	
	      // eslint-disable-line id-length
	      if (this._level > this.LEVEL_ERROR) {
	        return this;
	      }
	      (_console4 = console).error.apply(_console4, (0, _toConsumableArray3.default)(this.getLogArgs(args)));
	      if (true) {
	        _GA2.default.exception({ description: args, fatal: true });
	      }
	      return this;
	    }
	  }, {
	    key: 'debug',
	    value: function debug() {
	      return this.d.apply(this, arguments);
	    }
	  }, {
	    key: 'info',
	    value: function info() {
	      return this.i.apply(this, arguments);
	    }
	  }, {
	    key: 'warning',
	    value: function warning() {
	      return this.w.apply(this, arguments);
	    }
	  }, {
	    key: 'error',
	    value: function error() {
	      return this.e.apply(this, arguments);
	    }
	  }]);
	  return Log;
	}(), _class.LEVEL_DEBUG = 0, _class.LEVEL_INFO = 1, _class.LEVEL_WARNING = 2, _class.LEVEL_ERROR = 3, _temp);
	exports.default = new Log();
	module.exports = exports['default'];

/***/ }),
/* 268 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsSAAALEgHS3X78AAADyklEQVRIicWXW0wcZRTHfzM77IXlVkAoLNJAEE3oxUQCpjUKL8YYYvWlsWB9UmNi4qU+aWJM1Da8+WCiURObGB+MD8YGK03EUmJL0iYQSLVugXKvC3XJLssCw+7Md3wYuhdL+iTTk5yHOd838z//c/7fZbTG93791l9U1g14cMdUan11yPAGSzssEbdAAXRvsPRJHRHdRdBtE90QEcRtWOC+AevuwzpmIIKgXAXdLrUC3NWXSKbH+eX26BpK7V4TRBN0EUGEjPsMjdNdDTzVVJoX/z+dLONsjwOGh8ONZdyKm/w2EUPbDcbsVGqRzKjI7hRbEEdckiOuO1hlAQ/dj1VxoLaYzbTN0GSM4ZlVLBv2VfjoaqmkvjzAcmKL/utRZlZMXjsS4vpSkoFwHAFK/DqvHg5xdW6V328mMhhKwBAlKF3lBJ0kjrXWIgKRVRO/18OLrbV8M7zA8HSc3ucfpqywgOXEFhVBL91ttfSen6KjuZwT7SFi638w/vc673TW09Nex9LPEyiJZzB0h7GQX1HnIWUL7/8U5uJknECBzlud9bxypJ7jrbXENtO8dGaMqX9Maku89L7QzJudDXx0boKPjz7CqeeaGQhH6W4LcXYswg+jy3kYgqCLKBzwrANcCEfpuxYlvmkRSaT47OI8CdOivMjLl0NzjC4kSZgW4dsbfDowQ1WJD49H58O+GzxYHuCNjgbGFlb5pH+azfTdGA5jlU0nlRbStrCesrDtrOzMlE3aVohAbCOV907CtFAieD06N5aTmGmboM/gVswkYVp5cyGzjhVC1pMpi/DSGk80ldNc5QcUhi4821LBA8U+lAg97XXsKfQgogh6NXraatiyFLcTm5w62oyuaVyajNJ1qJqX2/aiafkYIgqt5t1fFpVWEMrNqLW+mK9OHEQpGJmLUxwwaGvYw/DUClemY5x8uonZ6AbhpST7KgK0hEo4c2mWmlI/z+zfywdn/+L8n1G+6NnPobpSXv9unAsTWXEZmhJP0ePHT4qmlziicjyS2OLKTIyaUh8PVQcxPBo/jkY43X+Ty9NxJpeTNFYW0lhZyJpp8fngLN+PRDh6sJpz15b4+vIia1s2I/NxDoSKicRNxhcTme9r2GhVb/ctiu7NY5yRvQZ+Q8MWR+W5yjR0Z3tNWUJ6ezX6DA1LCXbOYbdTzKPZYuQq+b9mC6yndh5L25C288fM9N1zd4oJgsH2cnLTRARD3YPxLkLfuYG4zBjFPXu8a8Cy417tjt0Xxs5B7Nz23DURZaTmxwa99Y8eQ9Nc+2nbWlkc/BdaxWHecygP5wAAAABJRU5ErkJggg=="

/***/ }),
/* 269 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsSAAALEgHS3X78AAAGUklEQVRIiaWXe1BU9xXHP/fevfvgDcsuAyLvh4irBiOQhyga1IqPaKaJrTbTsY2dZsbQVGuMbZWM0U4Zg0nUaZNUR2ujnWTSMXWwmBaV+BqRINQUJCsLiCLv8maB3Xv7xyYCYReo+f57zznfc87v/M7ve2EyCIIwqc0j+EgTfvWfZmbh1m14G31ptd5BVdQJ7UWNiGXtSuY8v542ayWDPf3/H7Eka0jKXsqaA0eJX7Ke2MxsoJcH5eUoDqdbH9mg5ektL7Nk50Ei05YRv+QZ+trq6aitR1WUyYkDI8NY+sYeFuTsw8cUCYKAJOuJTFuMX1gADTeuMTwwOMbHK8if5W/uY/6PX0ej8wZBwCsolISlzxIUaaa5qgJ7V697Yo1eZtazq1mdf5SoJ1YianRjgguihpDkVMLmzORe6RUGOrsBCIqezpp33iNx+YuIkjzGR9RoCUlOJSFrOfauRtptNhSHAiCAAMaYCDK3/4bE5RuRZIPbVo5Apc1aSsFrPwMg+/fvExw/zxVrAjiH+6ku/JALeW/SbrsrMX/TelbmHSX88axxGbuHgM4vCElrJ9Qym4j07Cn5iZKMKTGFxGXZKMNtGhSHikZnmDRjV7EK7bUVXHonl8ozhQDYLl1iQU4uxujZIIiTJi3rDShORaLp35Xc++IiYXPn4h08zWMCg73tlP0ln4LXtnD3+k0UhxPF4aS5sprqwr8hyYOY4mchab08ZU3L7RJO52yk+h/nXcPVdb+JO+cLCIwKIyg6CWFU5qpzmIYbhRRs/yllH57C3t03PqmefmzFxTSUFhEYGY5faBSCODK4quLA+q+/cvqVn9BcaYXRU23v7sVaVIikHSbUMh9RI9PTZKP4re38c08u7TX1qKrnBaKqKp0NjVSdPU1/Rx3mGbPQ+QTisPdRcmQv53btpK/1vx79kWSJ9M0b2XDqOMHxkVM6+nEQIDg+ig0nj5O6aQOiPG5fjB8GH3MwUU9mYUpII3ZhJjpvT2fmGTofL2IXLcKUmE7UU1n4mo3fNhmViSAQPm826w6dIDI9G51vMDEZ2USkPUZnfTU9D5onbDWAKIlEpKWwcv9hUn74Kno/M8Fxc4h+6kmaK0vpbmoeSyxqJCzrVrEq/88ERVng69dFECUCwhNIyn4O72AvWqq+ZKjX/eL3CzWxcNuveOa372KMmTsyXIKAjzmC+Kzv0ddaS+tXd1AVVULn60XGq78gc8cBDP4hboNqtF6EP5ZBQlYW9u4HdNhqUZyuxa/Ra0les4LV+X8ifvELrl3tBlrvAGIzs5H1DhorbgqseTsPy3M5iJJ2wjZ+A+fQANaij/g8fy8gsHDrr4lb8v0prFoXFOcQtz55W6K95jYGfwPG2GREzeTkoiRjjJ2FIUAgIjWNGSs2jXtQPMEx2Md/Pj3K5YMHJPo7urEWfUZHbRkhSckYAkIenrHbiocHuHnqAHVXLtDZUEdf2z3MSfMm3teqSkdtBedyf86Vw4fpa+10DYDqVGi5baX63Gm0PiKmeIvbKgZ727n87g7s3Z0sfv0gcYvXYvv879Rf+4ywuelI2vHtdti7Kf/4EGe2vkxDSTmqazbGXuzBnj5qLhTRcvs6psQZeBtDH1bf01RD0b4tBMfNJH3zbmSDH5LWwPT5mXTdt1Lx0R8JtTyO1ifw6yoVWqpLOLtzMyUfHGGgs2c01XgFoioq7bY6Gssvojh7CE6w0F5zk4t527Cs/REzV700ZhZcAiENjV7m6h/2YIyJRTZ4U3Yyn+L9u6m/VvbwBoyC+7OUtDLPHznG/S+u8uBWBVofPQteeQNz0hMefUCltfoGlw/twt7Zg3mGhempmXz80os4h4a+bazxEEMBVSRj61s03bqKX1gUPuZoD4QjRZgSU1m6+326G62EJD+NrbjAFctNbR54VequXEBVeojJyMbbOH0S0hFovfyR9d6UHt/P+d/lYu/udWc28dMjiAKhliQyfrmT2EXrJl0SyrAd26VPKc7fS2P5lxPp8Km9eRq9lqQVy1iQswtjXMoYoQC4JJGtgssH91B55uw4+esGE/9JfAPF4aSl6iuqzn6C6uzClJCMrPcFwN7VzI1jeRTsyOHu9TKPgv87QxAFwubM5IVjJ/jBiZNMS7EgiI+iFh4RGp2MRjcVOewW/wO+zj8m5NT2+AAAAABJRU5ErkJggg=="

/***/ }),
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(8);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _regenerator = __webpack_require__(138);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(137);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClientSideComponent = __webpack_require__(30);
	
	var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);
	
	var _reactI18next = __webpack_require__(12);
	
	var _formComponents = __webpack_require__(71);
	
	var _components = __webpack_require__(15);
	
	var _utils = __webpack_require__(24);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _keyCodes = __webpack_require__(870);
	
	var _keyCodes2 = _interopRequireDefault(_keyCodes);
	
	var _AddContactModal = __webpack_require__(1942);
	
	var _AddContactModal2 = _interopRequireDefault(_AddContactModal);
	
	var _reduxForm = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1237);
	
	var AddContactSuggestForm = (_dec = (0, _reduxForm.reduxForm)({
	  form: 'addContactSuggestForm',
	  propNamespace: 'addContactSuggestForm',
	  initialValues: { userEmail: '' }
	}), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(AddContactSuggestForm, _Component);
	
	  function AddContactSuggestForm() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, AddContactSuggestForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = AddContactSuggestForm.__proto__ || (0, _getPrototypeOf2.default)(AddContactSuggestForm)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { showModal: false };
	    return _this;
	  }
	
	  (0, _createClass3.default)(AddContactSuggestForm, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unmounted = true;
	    }
	  }, {
	    key: 'onSuggestionSelected',
	    value: function () {
	      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(e, _ref3) {
	        var suggestion = _ref3.suggestion;
	
	        var _props, onSuggestionSelected, reset;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                (0, _utils.stopEvent)(e);
	                _props = this.props, onSuggestionSelected = _props.onSuggestionSelected, reset = _props.addContactSuggestForm.reset;
	
	                reset();
	                _context.next = 5;
	                return onSuggestionSelected({ suggestion: suggestion });
	
	              case 5:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function onSuggestionSelected(_x, _x2) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return onSuggestionSelected;
	    }()
	  }, {
	    key: 'onKeyPress',
	    value: function onKeyPress(e) {
	      if (e.which !== _keyCodes2.default.enter) {
	        return false;
	      }
	      (0, _utils.stopEvent)(e);
	      this.openNameModal();
	    }
	  }, {
	    key: 'onEmailBlur',
	    value: function onEmailBlur() {
	      if (!this.props.onAddNewContactLoading) {
	        this.openNameModal();
	      }
	    }
	  }, {
	    key: 'onSubmit',
	    value: function onSubmit() {
	      this.openNameModal();
	    }
	  }, {
	    key: 'onAddNewContact',
	    value: function () {
	      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(formData) {
	        var _props2, onAddNewContact, fieldName, reset, data;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _props2 = this.props, onAddNewContact = _props2.onAddNewContact, fieldName = _props2.fieldName, reset = _props2.addContactSuggestForm.reset;
	                data = (0, _extends4.default)((0, _defineProperty3.default)({}, fieldName, this.emailField.value), formData);
	                _context2.next = 4;
	                return onAddNewContact(data);
	
	              case 4:
	                reset();
	                this.closeNameModal();
	
	              case 6:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function onAddNewContact(_x3) {
	        return _ref4.apply(this, arguments);
	      }
	
	      return onAddNewContact;
	    }()
	  }, {
	    key: 'bindFieldEl',
	    value: function bindFieldEl(el) {
	      this.emailField = el;
	    }
	  }, {
	    key: 'openNameModal',
	    value: function openNameModal() {
	      if (this.emailField.value && !this.unmounted) {
	        this.setState({ showModal: true });
	      }
	    }
	  }, {
	    key: 'closeNameModal',
	    value: function closeNameModal(result) {
	      if (result === null) {
	        this.props.addContactSuggestForm.reset();
	      }
	      if (!this.unmounted) {
	        this.setState({ showModal: false });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          t = _props3.t,
	          items = _props3.items,
	          tags = _props3.tags,
	          loading = _props3.loading,
	          onTagDelete = _props3.onTagDelete,
	          onAddNewContactLoading = _props3.onAddNewContactLoading,
	          withTags = _props3.withTags,
	          fieldClass = _props3.fieldClass,
	          fieldName = _props3.fieldName,
	          nameField = _props3.nameField,
	          autoFocus = _props3.autoFocus,
	          inputClass = _props3.inputClass,
	          tagNameField = _props3.tagNameField,
	          tagKeyField = _props3.tagKeyField,
	          required = _props3.required,
	          withZIndex = _props3.withZIndex,
	          onGetSuggestions = _props3.onGetSuggestions,
	          handleSubmit = _props3.addContactSuggestForm.handleSubmit,
	          maxSuggestions = _props3.maxSuggestions;
	      var showModal = this.state.showModal;
	
	      var showLoader = loading || onAddNewContactLoading;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { onSubmit: handleSubmit(this.onSubmit), className: styles.form },
	          _react2.default.createElement(_reduxForm.Field, {
	            ref: this.bindFieldEl,
	            type: 'email',
	            name: fieldName,
	            readOnly: showLoader,
	            field: nameField,
	            onGetSuggestions: onGetSuggestions,
	            onSuggestionSelected: this.onSuggestionSelected,
	            items: items,
	            onKeyPress: this.onKeyPress,
	            onBlur: this.onEmailBlur,
	            fieldClassName: fieldClass,
	            placeholder: t('Email'),
	            noIndent: true,
	            hideLabel: true,
	            inputClassName: inputClass,
	            component: withTags ? _formComponents.formTagsInput : _formComponents.formAutosuggestInput,
	            onTagDelete: onTagDelete,
	            tags: tags,
	            tagNameField: tagNameField,
	            tagKeyField: tagKeyField,
	            required: required,
	            withZIndex: withZIndex,
	            autoFocus: autoFocus,
	            maxSuggestions: maxSuggestions
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'text-right hide-on-desktop' },
	            _react2.default.createElement(
	              _Button2.default,
	              { className: 'btn-stroke small squared margin-left-5', onClick: this.openNameModal },
	              t('Add')
	            )
	          ),
	          _react2.default.createElement(_components.Loader, { show: showLoader, mask: true, small: true })
	        ),
	        _react2.default.createElement(_AddContactModal2.default, {
	          loading: onAddNewContactLoading,
	          show: showModal,
	          onHide: this.closeNameModal,
	          onSubmit: this.onAddNewContact
	        })
	      );
	    }
	  }]);
	  return AddContactSuggestForm;
	}(_ClientSideComponent2.default), _class3.propTypes = {
	  addContactSuggestForm: _propTypes2.default.object,
	  autoFocus: _propTypes2.default.bool,
	  fieldClass: _propTypes2.default.string,
	  fieldName: _propTypes2.default.string,
	  inputClass: _propTypes2.default.string,
	  items: _propTypes2.default.array,
	  loading: _propTypes2.default.bool,
	  maxSuggestions: _propTypes2.default.number,
	  nameField: _propTypes2.default.string,
	  onAddNewContact: _propTypes2.default.func,
	  onAddNewContactLoading: _propTypes2.default.bool,
	  onGetSuggestions: _propTypes2.default.func,
	  onSuggestionSelected: _propTypes2.default.func,
	  onTagDelete: _propTypes2.default.func,
	  required: _propTypes2.default.bool,
	  t: _propTypes2.default.func,
	  tagKeyField: _propTypes2.default.string,
	  tagNameField: _propTypes2.default.string,
	  tags: _propTypes2.default.array,
	  withTags: _propTypes2.default.bool,
	  withZIndex: _propTypes2.default.bool
	}, _class3.defaultProps = {
	  autoFocus: true,
	  fieldClass: 'width-perc-100',
	  fieldName: 'userEmail',
	  inputClass: 'material',
	  items: [],
	  loading: false,
	  nameField: '_name',
	  onAddNewContact: _noop3.default,
	  onAddNewContactLoading: false,
	  onSuggestionSelected: _noop3.default,
	  onTagDelete: _noop3.default,
	  tagKeyField: 'recipientId',
	  tagNameField: 'userEmail',
	  tags: [],
	  withTags: false
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onSuggestionSelected', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSuggestionSelected'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onKeyPress', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onKeyPress'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onEmailBlur', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onEmailBlur'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onSubmit', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSubmit'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onAddNewContact', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onAddNewContact'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'bindFieldEl', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'bindFieldEl'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'openNameModal', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'openNameModal'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'closeNameModal', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'closeNameModal'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = AddContactSuggestForm;
	module.exports = exports['default'];

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _toConsumableArray2 = __webpack_require__(34);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _reactRouterRedux = __webpack_require__(40);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1266);
	
	var cn = _bind2.default.bind(styles);
	
	var FilterButton = (_dec = (0, _reactRedux.connect)(null, { pushState: _reactRouterRedux.push }), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(FilterButton, _Component);
	
	  function FilterButton() {
	    (0, _classCallCheck3.default)(this, FilterButton);
	    return (0, _possibleConstructorReturn3.default)(this, (FilterButton.__proto__ || (0, _getPrototypeOf2.default)(FilterButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(FilterButton, [{
	    key: 'onClick',
	    value: function onClick() {
	      var _props = this.props,
	          route = _props.route,
	          pushState = _props.pushState,
	          onClick = _props.onClick,
	          onClickArgs = _props.onClickArgs;
	
	      if (route) {
	        pushState(route);
	      }
	      onClick.apply(undefined, (0, _toConsumableArray3.default)(onClickArgs));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          title = _props2.title,
	          iconClass = _props2.iconClass,
	          className = _props2.className,
	          isActive = _props2.isActive,
	          disabled = _props2.disabled,
	          responsive = _props2.responsive;
	
	      var filterClass = cn('sorter', {
	        active: isActive,
	        disabled: disabled,
	        responsive: responsive
	      }, className);
	
	      return _react2.default.createElement(
	        'span',
	        { className: filterClass, onClick: this.onClick },
	        iconClass && _react2.default.createElement('i', { className: iconClass }),
	        _react2.default.createElement(
	          'span',
	          { className: styles.sorterTitle },
	          title
	        )
	      );
	    }
	  }]);
	  return FilterButton;
	}(_react.Component), _class3.propTypes = {
	  className: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  iconClass: _propTypes2.default.string,
	  isActive: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  onClickArgs: _propTypes2.default.array,
	  pushState: _propTypes2.default.func,
	  responsive: _propTypes2.default.bool,
	  route: _propTypes2.default.string,
	  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node])
	}, _class3.defaultProps = {
	  onClick: _noop3.default,
	  onClickArgs: [],
	  responsive: true
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onClick'), _class2.prototype)), _class2)) || _class);
	exports.default = FilterButton;
	module.exports = exports['default'];

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _reactHelmet = __webpack_require__(55);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Page = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(Page, _PureComponent);
	
	  function Page() {
	    (0, _classCallCheck3.default)(this, Page);
	    return (0, _possibleConstructorReturn3.default)(this, (Page.__proto__ || (0, _getPrototypeOf2.default)(Page)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Page, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          children = _props.children,
	          title = _props.title,
	          header = _props.header,
	          pullHeaderLeft = _props.pullHeaderLeft;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)('container-fluid', 'page', className) },
	        _react2.default.createElement(_reactHelmet2.default, { title: title || header }),
	        header && _react2.default.createElement(
	          'h1',
	          { className: (0, _bind2.default)({ 'pull-left': pullHeaderLeft }) },
	          header
	        ),
	        children
	      );
	    }
	  }]);
	  return Page;
	}(_react.PureComponent), _class.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.node)]),
	  className: _propTypes2.default.string,
	  header: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
	  pullHeaderLeft: _propTypes2.default.bool,
	  title: _propTypes2.default.string
	}, _class.defaultProps = {
	  pullHeaderLeft: false
	}, _temp);
	exports.default = Page;
	module.exports = exports['default'];

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _toConsumableArray2 = __webpack_require__(34);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _last2 = __webpack_require__(151);
	
	var _last3 = _interopRequireDefault(_last2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _PageNumber = __webpack_require__(2036);
	
	var _PageNumber2 = _interopRequireDefault(_PageNumber);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(625);
	
	var Pagination = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(Pagination, _PureComponent);
	
	  function Pagination() {
	    (0, _classCallCheck3.default)(this, Pagination);
	    return (0, _possibleConstructorReturn3.default)(this, (Pagination.__proto__ || (0, _getPrototypeOf2.default)(Pagination)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Pagination, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var checkMaxPage = nextProps.checkMaxPage,
	          page = nextProps.page;
	
	      if (checkMaxPage && page > 1) {
	        var pagesCount = this.getPagesCount(nextProps);
	        if (pagesCount < page) {
	          this.changePage(pagesCount);
	        }
	      }
	    }
	  }, {
	    key: 'getPagesCount',
	    value: function getPagesCount() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props,
	          count = _ref.count,
	          limit = _ref.limit;
	
	      return limit ? Math.ceil(count / limit) : 0;
	    }
	  }, {
	    key: 'getPages',
	    value: function getPages() {
	      var _props = this.props,
	          page = _props.page,
	          showAroundCount = _props.showAroundCount,
	          limit = _props.limit;
	
	      if (!limit) {
	        return null;
	      }
	
	      var pagesCount = this.getPagesCount();
	      var start = [];
	      var middle = [];
	      var end = [];
	
	      for (var i = page - showAroundCount; i <= page + showAroundCount; i++) {
	        if (i > 0 && i <= pagesCount) {
	          middle.push(i);
	        }
	      }
	
	      if (middle[0] === 2) {
	        middle.unshift(1);
	      }
	
	      if (middle[middle.length - 1] === pagesCount - 1) {
	        middle.push(pagesCount);
	      }
	
	      if (middle[0] === 3) {
	        middle = [1, 2].concat((0, _toConsumableArray3.default)(middle));
	      } else if (middle[0] > 2) {
	        start.push(1);
	      }
	
	      if ((0, _last3.default)(middle) === pagesCount - 2) {
	        middle = [].concat((0, _toConsumableArray3.default)(middle), [pagesCount - 1, pagesCount]);
	      } else if ((0, _last3.default)(middle) < pagesCount - 1) {
	        end.push(pagesCount);
	      }
	
	      return { start: start, middle: middle, end: end };
	    }
	  }, {
	    key: 'changePage',
	    value: function changePage(newPage) {
	      var _props2 = this.props,
	          page = _props2.page,
	          limit = _props2.limit,
	          onChange = _props2.onChange;
	
	      if (newPage === page) {
	        return false;
	      }
	
	      var offset = newPage * limit - limit;
	
	      onChange({ page: newPage, offset: offset, limit: limit });
	    }
	  }, {
	    key: 'goNext',
	    value: function goNext() {
	      var page = this.props.page;
	
	      var nextPage = page + 1;
	      if (nextPage <= this.getPagesCount()) {
	        this.changePage(nextPage);
	      }
	    }
	  }, {
	    key: 'goPrev',
	    value: function goPrev() {
	      var page = this.props.page;
	
	      var prevPage = page - 1;
	      if (prevPage >= 1) {
	        this.changePage(prevPage);
	      }
	    }
	  }, {
	    key: 'renderPagesNumbers',
	    value: function renderPagesNumbers(pages) {
	      var _this2 = this;
	
	      var page = this.props.page;
	
	      return pages.map(function (pageNumber) {
	        return _react2.default.createElement(_PageNumber2.default, {
	          key: pageNumber,
	          onClick: _this2.changePage,
	          currentPage: page,
	          pageNumber: pageNumber
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          className = _props3.className,
	          limit = _props3.limit;
	
	      var pagesCount = this.getPagesCount();
	      var pages = this.getPages();
	      var hidePagination = !limit || !pages || pagesCount < 2;
	      if (hidePagination) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        _react2.default.createElement(
	          'span',
	          { className: (0, _bind2.default)(styles.pageItem, styles.prevPage), onClick: this.goPrev },
	          _react2.default.createElement('i', { className: 'icon-chevron-thin-left' })
	        ),
	        !!pages.start.length && _react2.default.createElement(
	          'span',
	          null,
	          this.renderPagesNumbers(pages.start),
	          _react2.default.createElement(
	            'span',
	            { className: styles.gap },
	            '...'
	          )
	        ),
	        this.renderPagesNumbers(pages.middle),
	        !!pages.end.length && _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: styles.gap },
	            '...'
	          ),
	          this.renderPagesNumbers(pages.end)
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: (0, _bind2.default)(styles.pageItem, styles.nextPage), onClick: this.goNext },
	          _react2.default.createElement('i', { className: 'icon-chevron-thin-right' })
	        )
	      );
	    }
	  }]);
	  return Pagination;
	}(_react.PureComponent), _class2.propTypes = {
	  checkMaxPage: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  count: _propTypes2.default.number.isRequired, // eslint-disable-line react/no-unused-prop-types
	  limit: _propTypes2.default.number.isRequired,
	  onChange: _propTypes2.default.func.isRequired,
	  page: _propTypes2.default.number.isRequired,
	  showAroundCount: _propTypes2.default.number
	}, _class2.defaultProps = {
	  showAroundCount: 2
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'changePage', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'changePage'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'goNext', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'goNext'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'goPrev', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'goPrev'), _class.prototype)), _class);
	exports.default = Pagination;
	module.exports = exports['default'];

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _propTypes3 = __webpack_require__(127);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1285);
	
	var Panel = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(Panel, _PureComponent);
	
	  function Panel() {
	    (0, _classCallCheck3.default)(this, Panel);
	    return (0, _possibleConstructorReturn3.default)(this, (Panel.__proto__ || (0, _getPrototypeOf2.default)(Panel)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Panel, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          titleClass = _props.titleClass,
	          contentClass = _props.contentClass,
	          title = _props.title,
	          children = _props.children;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(styles.panel, className) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _bind2.default)(styles.title, titleClass) },
	          title
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _bind2.default)(styles.content, contentClass) },
	          children
	        )
	      );
	    }
	  }]);
	  return Panel;
	}(_react.PureComponent), _class.propTypes = {
	  children: _propTypes3.nodes,
	  className: _propTypes2.default.string,
	  contentClass: _propTypes2.default.string,
	  title: _propTypes3.node,
	  titleClass: _propTypes2.default.string
	}, _temp);
	exports.default = Panel;
	module.exports = exports['default'];

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopoverMenuItem = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(PopoverMenuItem, _PureComponent);
	
	  function PopoverMenuItem() {
	    (0, _classCallCheck3.default)(this, PopoverMenuItem);
	    return (0, _possibleConstructorReturn3.default)(this, (PopoverMenuItem.__proto__ || (0, _getPrototypeOf2.default)(PopoverMenuItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PopoverMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          onClick = _props.onClick,
	          iconClass = _props.iconClass,
	          title = _props.title,
	          hidden = _props.hidden;
	
	
	      if (hidden) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'li',
	        { onClick: onClick },
	        title,
	        ' ',
	        _react2.default.createElement('i', { className: iconClass })
	      );
	    }
	  }]);
	  return PopoverMenuItem;
	}(_react.PureComponent), _class.propTypes = {
	  hidden: _propTypes2.default.bool,
	  iconClass: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node])
	}, _class.defaultProps = {
	  onClick: _noop3.default
	}, _temp);
	exports.default = PopoverMenuItem;
	module.exports = exports['default'];

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _extends3 = __webpack_require__(8);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _invertBy2 = __webpack_require__(132);
	
	var _invertBy3 = _interopRequireDefault(_invertBy2);
	
	var _findIndex3 = __webpack_require__(318);
	
	var _findIndex4 = _interopRequireDefault(_findIndex3);
	
	var _desc, _value, _class; /**
	                           * Parent class for selectable lists
	                            * don't forget to set selectable config and this.onSelectionChange(itemsArray) method in child class
	                            * see this.selectableConfig params in constructor
	                           * */
	
	var _react = __webpack_require__(1);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var SelectableList = (_class = function (_PureComponent) {
	  (0, _inherits3.default)(SelectableList, _PureComponent);
	
	  function SelectableList() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, SelectableList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = SelectableList.__proto__ || (0, _getPrototypeOf2.default)(SelectableList)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { checkedItems: {} };
	    _this.selectableConfig = {
	      idField: 'id', // id field name
	      propsField: 'items', // this.props field of selectable items (array)
	      resultAsIndexes: false, // [1, 3, 5, 6] instead of [id1, id3, id5, id6]
	      idAsString: false, // type of id = string
	      checkedItemsPropsField: null, // if null state is used
	      updateFn: null // function to update state with checked songs, used setState if null
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(SelectableList, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.updateCheckedItems({});
	    }
	  }, {
	    key: 'onSelectAllClick',
	    value: function onSelectAllClick() {
	      var isAllItemsSelected = this.state.isAllItemsSelected;
	
	      if (isAllItemsSelected) {
	        this.selectNone();
	      } else {
	        this.selectAll();
	      }
	    }
	  }, {
	    key: 'onSelect',
	    value: function onSelect() {
	      var _this2 = this;
	
	      var checkedItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var listItems = this.props[this.selectableConfig.propsField];
	      var checkedArray = this.getCheckedItemsArray(checkedItems);
	      var result = checkedArray;
	
	      if (this.selectableConfig.resultAsIndexes) {
	        result = [];
	        checkedArray.map(function (itemId) {
	          var index = (0, _findIndex4.default)(listItems, (0, _defineProperty3.default)({}, _this2.selectableConfig.idField, itemId)) + 1;
	          result.push(index);
	        });
	      }
	      if (this.onSelectionChange) {
	        this.onSelectionChange(result);
	      }
	    }
	  }, {
	    key: 'setConfig',
	    value: function setConfig() {
	      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      this.selectableConfig = (0, _extends4.default)({}, this.selectableConfig, config);
	    }
	  }, {
	    key: 'getStateCheckedItems',
	    value: function getStateCheckedItems() {
	      var checkedItemsPropsField = this.selectableConfig.checkedItemsPropsField;
	
	      return checkedItemsPropsField ? this.props[checkedItemsPropsField] : this.state.checkedItems;
	    }
	  }, {
	    key: 'getCheckedItemsArray',
	    value: function getCheckedItemsArray(checkedItems) {
	      var itemsArr = (0, _invertBy3.default)(checkedItems || this.getStateCheckedItems() || {}).true || [];
	      return this.selectableConfig.idAsString ? itemsArr : itemsArr.map(Number);
	    }
	  }, {
	    key: 'toggleItemChecked',
	    value: function toggleItemChecked(id) {
	      var listItems = this.props[this.selectableConfig.propsField];
	      var stateCheckedItems = this.getStateCheckedItems();
	
	      var checkedItems = (0, _extends4.default)({}, stateCheckedItems, (0, _defineProperty3.default)({}, id, !stateCheckedItems[id]));
	      var checkedItemsArr = this.getCheckedItemsArray(checkedItems);
	      this.setState({ isAllItemsSelected: checkedItemsArr.length === listItems.length });
	      this.updateCheckedItems(checkedItems);
	      this.onSelect(checkedItems);
	    }
	  }, {
	    key: 'selectAll',
	    value: function selectAll() {
	      var _this3 = this;
	
	      var listItems = this.props[this.selectableConfig.propsField];
	      var checkedItems = {};
	      listItems.map(function (item) {
	        return checkedItems[item[_this3.selectableConfig.idField]] = true;
	      });
	      this.setState({ isAllItemsSelected: true });
	      this.updateCheckedItems(checkedItems);
	      this.onSelect(checkedItems);
	    }
	  }, {
	    key: 'selectNone',
	    value: function selectNone() {
	      this.setState({ isAllItemsSelected: false });
	      this.updateCheckedItems({});
	      this.onSelect({});
	    }
	  }, {
	    key: 'updateCheckedItems',
	    value: function updateCheckedItems(checkedItems) {
	      var updateFn = this.selectableConfig.updateFn;
	
	      if (updateFn) {
	        updateFn(checkedItems);
	      } else {
	        this.setState({ checkedItems: checkedItems });
	      }
	    }
	  }]);
	  return SelectableList;
	}(_react.PureComponent), (_applyDecoratedDescriptor(_class.prototype, 'onSelectAllClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onSelectAllClick'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'selectAll', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'selectAll'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'selectNone', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'selectNone'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateCheckedItems', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateCheckedItems'), _class.prototype)), _class);
	exports.default = SelectableList;
	module.exports = exports['default'];

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1321);
	
	var cn = _bind2.default.bind(styles);
	
	var SortableListHeader = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(SortableListHeader, _PureComponent);
	
	  function SortableListHeader() {
	    (0, _classCallCheck3.default)(this, SortableListHeader);
	    return (0, _possibleConstructorReturn3.default)(this, (SortableListHeader.__proto__ || (0, _getPrototypeOf2.default)(SortableListHeader)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SortableListHeader, [{
	    key: 'onClick',
	    value: function onClick() {
	      var _props = this.props,
	          name = _props.name,
	          onReorder = _props.onReorder;
	
	      onReorder(name);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          order = _props2.order,
	          activeOrder = _props2.activeOrder,
	          name = _props2.name,
	          title = _props2.title,
	          className = _props2.className;
	
	      var orderClass = (0, _bind2.default)(styles['order-' + order[name]], styles.order);
	      var sorterClass = cn('sorter', className, { active: activeOrder === name });
	
	      return _react2.default.createElement(
	        'div',
	        { className: sorterClass, onClick: this.onClick },
	        title,
	        _react2.default.createElement('i', { className: orderClass })
	      );
	    }
	  }]);
	  return SortableListHeader;
	}(_react.PureComponent), _class2.propTypes = {
	  activeOrder: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  name: _propTypes2.default.string,
	  onReorder: _propTypes2.default.func,
	  order: _propTypes2.default.object,
	  title: _propTypes2.default.string
	}, _class2.defaultProps = {
	  onReorder: _noop3.default,
	  order: {}
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onClick'), _class.prototype)), _class);
	exports.default = SortableListHeader;
	module.exports = exports['default'];

/***/ }),
/* 356 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var loginFormStates = exports.loginFormStates = {
	  login: 'login',
	  forgot: 'forgot password',
	  reset: 'reset password',
	  unlock: 'unlock account'
	};

/***/ }),
/* 357 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getReloadPage = getReloadPage;
	exports.getFromTo = getFromTo;
	function getReloadPage(itemsList, currentPage) {
	  var page = currentPage;
	  if (!itemsList.length && currentPage > 1) {
	    page -= 1;
	  }
	
	  return page;
	}
	
	function getFromTo(_ref) {
	  var page = _ref.page,
	      limit = _ref.limit;
	
	  var from = (page - 1) * limit;
	  var to = page * limit;
	  return { from: from, to: to };
	}

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(78);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(72);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _last2 = __webpack_require__(151);
	
	var _last3 = _interopRequireDefault(_last2);
	
	exports.default = reducer;
	exports.setData = setData;
	exports.increasePlaysCount = increasePlaysCount;
	exports.isCanPlay = isCanPlay;
	exports.getAllowedTracksInfo = getAllowedTracksInfo;
	
	var _qim = __webpack_require__(110);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SET_DATA = 'playstats/SET_DATA';
	var INCREASE_PLAYS_COUNT = 'playstats/INCREASE_PLAYS_COUNT';
	
	var initialState = {
	  albums: {},
	  tracks: {}
	};
	
	var actionsFn = {};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  return actionsFn[action.type] ? actionsFn[action.type]({ state: state, action: action }) : state;
	}
	
	function getLimits(multPlays) {
	  return {
	    multPlays: multPlays,
	    isDenied: multPlays < 0,
	    isUnlimited: !multPlays
	  };
	}
	
	actionsFn.RESET = function () {
	  return initialState;
	};
	
	actionsFn[SET_DATA] = function (_ref) {
	  var state = _ref.state,
	      action = _ref.action;
	  var albums = action.albums,
	      tracks = action.tracks;
	
	  return (0, _qim.update)([['albums', (0, _qim.$merge)(state.albums)], ['tracks', (0, _qim.$merge)(state.tracks)]], { albums: albums, tracks: tracks });
	};
	
	actionsFn[INCREASE_PLAYS_COUNT] = function (_ref2) {
	  var state = _ref2.state,
	      action = _ref2.action;
	  return (0, _qim.update)(['tracks', action.trackId, function () {
	    var track = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return track.multPlays > 0;
	  }, ['multPlays', (0, _qim.$apply)(function (value) {
	    return value - 1 || -1;
	  })], (0, _qim.$apply)(function () {
	    var track = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return (0, _qim.update)([(0, _qim.$merge)(getLimits(track.multPlays))], track);
	  })], state);
	};
	
	function getAlbumsStats(_ref3) {
	  var albums = _ref3.albums;
	
	  return function (dispatch, getState) {
	    var state = getState().playstats;
	    var albumsStats = (0, _extends3.default)({}, state.albums);
	
	    albums.map(function (album) {
	      var multPlays = album.multPlays,
	          id = album.project_id,
	          recipientId = album.recipient_id;
	
	      albumsStats[id] = (0, _extends3.default)({
	        id: id,
	        recipientId: recipientId
	      }, getLimits(multPlays));
	    });
	
	    return albumsStats;
	  };
	}
	
	function getTrackStats(_ref4) {
	  var track = _ref4.track,
	      albumId = _ref4.albumId,
	      albumStats = _ref4.albumStats;
	
	  return (0, _extends3.default)({
	    id: track.id,
	    albumId: Number(albumId),
	    recipientId: track.recipientId || albumStats.recipientId
	  }, getLimits(albumStats.multPlays));
	}
	
	function getAlbumsTracksStats(_ref5) {
	  var albumsTracks = _ref5.albumsTracks,
	      albumsStats = _ref5.albumsStats;
	
	  return function (dispatch, getState) {
	    var state = getState().playstats;
	    var tracksStats = (0, _extends3.default)({}, state.tracks);
	
	    (0, _entries2.default)(albumsTracks).map(function (_ref6) {
	      var _ref7 = (0, _slicedToArray3.default)(_ref6, 2),
	          albumId = _ref7[0],
	          albumTracks = _ref7[1];
	
	      if (Array.isArray(albumTracks)) {
	        var albumStats = albumsStats[albumId] || {};
	        albumTracks.map(function (track) {
	          tracksStats[track.id] = getTrackStats({ track: track, albumId: albumId, albumStats: albumStats });
	        });
	      }
	    });
	
	    return tracksStats;
	  };
	}
	
	function setData(_ref8) {
	  var _ref8$albums = _ref8.albums,
	      albums = _ref8$albums === undefined ? [] : _ref8$albums,
	      _ref8$albumsTracks = _ref8.albumsTracks,
	      albumsTracks = _ref8$albumsTracks === undefined ? {} : _ref8$albumsTracks;
	
	  return function (dispatch) {
	    var albumsStats = dispatch(getAlbumsStats({ albums: albums }));
	    var tracksStats = dispatch(getAlbumsTracksStats({ albumsTracks: albumsTracks, albumsStats: albumsStats }));
	
	    dispatch({
	      type: SET_DATA,
	      albums: albumsStats,
	      tracks: tracksStats
	    });
	  };
	}
	
	function increasePlaysCount(_ref9) {
	  var trackId = _ref9.trackId;
	
	  return function (dispatch) {
	    return dispatch({
	      type: INCREASE_PLAYS_COUNT,
	      trackId: trackId
	    });
	  };
	}
	
	function isCanPlay(_ref10) {
	  var trackId = _ref10.trackId,
	      albumId = _ref10.albumId;
	
	  return function (dispatch, getState) {
	    var state = getState().playstats;
	    var track = state.tracks[trackId] || {};
	    var album = state.albums[albumId] || {};
	    return !(track.isDenied || album.isDenied);
	  };
	}
	
	function getAllowedTracksInfo(_ref11) {
	  var tracks = _ref11.tracks,
	      _ref11$currentTrackIn = _ref11.currentTrackIndex,
	      currentTrackIndex = _ref11$currentTrackIn === undefined ? 0 : _ref11$currentTrackIn;
	
	  return function (dispatch, getState) {
	    var state = getState().playstats;
	    var allowedTracks = [];
	    var allowedIndexes = [];
	    var currentAllowedTrackIndex = 0;
	    var allowedNextIndex = null;
	    var allowedPrevIndex = null;
	
	    tracks.map(function (track, index) {
	      var statsTrack = state.tracks[track.id] || {};
	      if (!statsTrack.isDenied) {
	        allowedTracks.push(track);
	        allowedIndexes.push(index);
	        if (index <= currentTrackIndex) {
	          currentAllowedTrackIndex = index;
	        }
	        if (index < currentTrackIndex) {
	          allowedPrevIndex = index;
	        }
	        if (index > currentTrackIndex && !allowedNextIndex) {
	          allowedNextIndex = index;
	        }
	      }
	    });
	
	    if (allowedIndexes.length) {
	      if (allowedNextIndex === null) {
	        allowedNextIndex = allowedIndexes[0];
	      }
	      if (allowedPrevIndex === null) {
	        allowedPrevIndex = (0, _last3.default)(allowedIndexes);
	      }
	    }
	
	    return { allowedTracks: allowedTracks, allowedIndexes: allowedIndexes, allowedPrevIndex: allowedPrevIndex, allowedNextIndex: allowedNextIndex, currentAllowedTrackIndex: currentAllowedTrackIndex };
	  };
	}

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends4 = __webpack_require__(8);
	
	var _extends5 = _interopRequireDefault(_extends4);
	
	var _reject2 = __webpack_require__(200);
	
	var _reject3 = _interopRequireDefault(_reject2);
	
	var _get2 = __webpack_require__(19);
	
	var _get3 = _interopRequireDefault(_get2);
	
	exports.default = reducer;
	exports.isLoaded = isLoaded;
	exports.isLoadTime = isLoadTime;
	exports.needReloadProjects = needReloadProjects;
	exports.loadProjects = loadProjects;
	exports.reorder = reorder;
	exports.filter = filter;
	exports.deleteProject = deleteProject;
	exports.setProjectsListPage = setProjectsListPage;
	
	var _loadReducer = __webpack_require__(69);
	
	var _loadReducer2 = _interopRequireDefault(_loadReducer);
	
	var _projects = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* Projects redux reducer and action creators */
	
	var ORDER = 'projects/ORDER';
	var FILTER = 'projects/FILTER';
	var NEED_RELOAD = 'projects/NEED_RELOAD';
	var SET_PROJECTS_LIST_PAGE = 'projects/SET_PROJECTS_LIST_PAGE';
	
	var loadReducer = (0, _loadReducer2.default)('projects', {
	  projects: {
	    action: 'load',
	    init: { newsletters: [], sharespace: [], audio: [], video: [] },
	    fields: {
	      newsletters: 'listNewsletters',
	      sharespace: 'listOfMasterProject',
	      audio: 'listOfAudioProjects',
	      video: 'listOfVideoProjects'
	    }
	  },
	  deleteProject: { loaderKeys: ['projectId'] }
	});
	
	var initialState = (0, _extends5.default)({}, loadReducer.initialState, {
	  order: {
	    id: 'desc',
	    fullTitle: 'asc',
	    owName: 'asc',
	    statusText: 'asc',
	    iRef: 'asc'
	  },
	  activeOrder: 'id',
	  kw: '',
	  projectsListPage: 1
	});
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case 'RESET':
	      return initialState;
	    case ORDER:
	      return (0, _extends5.default)({}, state, {
	        order: (0, _extends5.default)({}, state.order, (0, _defineProperty3.default)({}, action.name, state.activeOrder === action.name ? state.order[action.name] === 'asc' ? 'desc' : 'asc' : state.order[action.name])),
	        activeOrder: action.name
	      });
	    case FILTER:
	      return (0, _extends5.default)({}, state, {
	        kw: action.kw,
	        projectsListPage: 1
	      });
	    case NEED_RELOAD:
	      return (0, _extends5.default)({}, state, {
	        loaded: false
	      });
	    case SET_PROJECTS_LIST_PAGE:
	      return (0, _extends5.default)({}, state, {
	        projectsListPage: action.page
	      });
	    case loadReducer.constants.DELETE_PROJECT_SUCCESS:
	      {
	        var projectType = action.projectType,
	            projectId = action.projectId;
	
	        var projects = state.projectsData[projectType];
	        return (0, _extends5.default)({}, loadReducer.reducer(state, action), {
	          projectsData: (0, _extends5.default)({}, state.projectsData, (0, _defineProperty3.default)({}, projectType, (0, _reject3.default)(projects, { id: projectId })))
	        });
	      }
	    default:
	      return loadReducer.reducer(state, action);
	  }
	}
	
	function isLoaded(globalState) {
	  return (0, _get3.default)(globalState, 'projects.loaded', false);
	}
	
	function isLoadTime(globalState) {
	  return (/*!isLoaded(globalState) && */(0, _get3.default)(globalState, 'auth.user', false)
	  );
	}
	
	function needReloadProjects() {
	  return {
	    type: NEED_RELOAD
	  };
	}
	
	function loadProjects() {
	  return {
	    types: loadReducer.constantsByKey.projects,
	    promise: function promise(client) {
	      var result = client.post('project_wa/getList');
	      result.promise.then(_projects.transformProjectsResponse);
	      return result;
	    },
	    abortable: true
	  };
	}
	
	function reorder(name) {
	  return {
	    type: ORDER,
	    name: name
	  };
	}
	
	function filter() {
	  var kw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	  return {
	    type: FILTER,
	    kw: kw
	  };
	}
	
	function deleteProject(projectId, projectType) {
	  return {
	    types: loadReducer.constantsByKey.deleteProject,
	    promise: function promise(client) {
	      return client.post('project_wa/deleteProject', { data: { projectId: projectId } });
	    },
	    projectId: projectId,
	    projectType: projectType
	  };
	}
	
	function setProjectsListPage(_ref) {
	  var page = _ref.page;
	
	  return {
	    type: SET_PROJECTS_LIST_PAGE,
	    page: page
	  };
	}

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  return actionsFn[action.type] ? actionsFn[action.type]({ state: state, action: action }) : reducer(state, action);
	};
	
	exports.loadReport = loadReport;
	exports.loadRecipientReport = loadRecipientReport;
	exports.getLinks = getLinks;
	exports.downloadReport = downloadReport;
	
	var _loadReducer = __webpack_require__(69);
	
	var _loadReducer2 = _interopRequireDefault(_loadReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loadReducer = (0, _loadReducer2.default)('report', {
	  report: { action: 'load' },
	  recipientReport: { action: 'load' },
	  getLinks: {},
	  downloadReport: {}
	}); /* Reports redux reducer and action creators */
	
	var constantsByKey = loadReducer.constantsByKey,
	    reducer = loadReducer.reducer;
	
	
	var initialState = (0, _extends3.default)({}, loadReducer.initialState);
	
	var actionsFn = {};
	
	actionsFn.RESET = function () {
	  return initialState;
	};
	
	function loadReport(_ref) {
	  var projectId = _ref.projectId;
	
	  var data = { projectId: projectId };
	  return {
	    types: constantsByKey.report,
	    promise: function promise(client) {
	      return client.post('project_wa/getProjectStats', { data: data });
	    },
	    projectId: projectId
	  };
	}
	
	function loadRecipientReport(_ref2) {
	  var projectId = _ref2.projectId,
	      recipientId = _ref2.recipientId;
	
	  var data = { projectId: projectId, recipientId: recipientId };
	  return (0, _extends3.default)({
	    types: constantsByKey.recipientReport,
	    promise: function promise(client) {
	      return client.post('project_wa/getRecipientStats', { data: data });
	    }
	  }, data);
	}
	
	function getLinks(projectId) {
	  var data = { projectId: projectId };
	  return {
	    types: constantsByKey.getLinks,
	    promise: function promise(client) {
	      return client.post('/project_wa/downloadRecipientLinks', { data: data });
	    },
	    projectId: projectId
	  };
	}
	
	function downloadReport(projectId) {
	  var data = { projectId: projectId };
	  return {
	    types: constantsByKey.downloadReport,
	    promise: function promise(client) {
	      return client.post('/project_wa/downloadReport', { data: data });
	    },
	    projectId: projectId
	  };
	}

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCheckedPlaylistsArray = exports.getMyPlaylisTracks = exports.getMyPlaylist = exports.getFilteredPlaylists = exports.getMyPlaylists = undefined;
	
	var _invertBy2 = __webpack_require__(132);
	
	var _invertBy3 = _interopRequireDefault(_invertBy2);
	
	var _get2 = __webpack_require__(19);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _find2 = __webpack_require__(95);
	
	var _find3 = _interopRequireDefault(_find2);
	
	var _reselect = __webpack_require__(125);
	
	var _myPlaylists = __webpack_require__(527);
	
	var _playlists = __webpack_require__(362);
	
	var _utils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _getMyPlaylists = function _getMyPlaylists(state) {
	  return state.myPlaylists.myPlaylistsData || [];
	};
	var _getMyPlaylist = function _getMyPlaylist(state, guid) {
	  return (0, _find3.default)((0, _get3.default)(state, 'myPlaylists.myPlaylistsData'), { guid: guid }) || {};
	};
	var _getCheckedPlaylists = function _getCheckedPlaylists(state) {
	  return state.myPlaylists.checkedPlaylists;
	};
	var _getKw = function _getKw(state) {
	  return state.myPlaylists.kw;
	};
	
	var filteredFields = ['name'];
	
	var getMyPlaylists = exports.getMyPlaylists = (0, _reselect.createSelector)([_getMyPlaylists], _myPlaylists.processMyPlaylists);
	
	var getFilteredPlaylists = exports.getFilteredPlaylists = (0, _reselect.createSelector)([getMyPlaylists, _getKw], function (objects, kw) {
	  return (0, _utils.filterObjectsByKws)({ objects: objects, fields: filteredFields, kw: kw });
	});
	
	var getMyPlaylist = exports.getMyPlaylist = (0, _reselect.createSelector)([_getMyPlaylist], _myPlaylists.processMyPlaylist);
	
	var getMyPlaylisTracks = exports.getMyPlaylisTracks = (0, _reselect.createSelector)([getMyPlaylist, _playlists.getAllTracks], _myPlaylists.processMyPlaylistTracks);
	
	var getCheckedPlaylistsArray = exports.getCheckedPlaylistsArray = (0, _reselect.createSelector)([_getCheckedPlaylists], function (playlists) {
	  return (0, _invertBy3.default)(playlists).true || [];
	});

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getSortedAlbums = exports.processAlbum = exports.getAllTracks = exports.getPlaylistsTracks = exports.getAlbumsById = exports.processAlbums = exports.getPartTracks = exports.processTracks = undefined;
	
	var _slicedToArray2 = __webpack_require__(78);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(72);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _values = __webpack_require__(158);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _reselect = __webpack_require__(125);
	
	var _Playlists = __webpack_require__(214);
	
	var _TypeCast = __webpack_require__(260);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getTracks = function getTracks(state) {
	  return (0, _TypeCast.asArray)(state.playlist.playlistData.tracks);
	}; /* Playlists and albums reselect */
	
	var getAlbum = function getAlbum(state) {
	  return (0, _TypeCast.asObject)(state.playlist.playlistData.album);
	};
	var getPlaylists = function getPlaylists(state) {
	  return state.playlists.playlistsData;
	};
	var getActiveOrder = function getActiveOrder(state) {
	  return state.playlists.activeOrder;
	};
	var getOrder = function getOrder(state) {
	  return state.playlists.order;
	};
	var getKw = function getKw(state) {
	  return state.playlists.kw;
	};
	
	var processTracks = exports.processTracks = (0, _reselect.createSelector)([getTracks, getAlbum], function (tracks, album) {
	  return (0, _Playlists.processTracks)({ tracks: tracks, album: album });
	});
	
	var getPartTracks = exports.getPartTracks = (0, _reselect.createSelector)([processTracks], function (tracks) {
	  return (0, _Playlists.getPartTracks)(tracks);
	});
	
	var processAlbums = exports.processAlbums = (0, _reselect.createSelector)([getPlaylists], function (playlists) {
	  var _ref = playlists || { albums: [] },
	      albums = _ref.albums;
	
	  return (0, _Playlists.processAlbums)(albums);
	});
	
	var getAlbumsById = exports.getAlbumsById = (0, _reselect.createSelector)([getPlaylists], function (playlists) {
	  var _ref2 = playlists || { albums: [] },
	      albums = _ref2.albums;
	
	  var albumsById = {};
	  (0, _values2.default)(albums).map(function (album) {
	    return albumsById[album.project_id] = (0, _Playlists.processAlbums)(album);
	  });
	  return albumsById;
	});
	
	var getPlaylistsTracks = exports.getPlaylistsTracks = (0, _reselect.createSelector)([getPlaylists, getAlbumsById], function (playlists, albumsById) {
	  var _ref3 = playlists || { tracks: {} },
	      tracks = _ref3.tracks;
	
	  var processedTracks = {};
	  (0, _entries2.default)(tracks).map(function (_ref4) {
	    var _ref5 = (0, _slicedToArray3.default)(_ref4, 2),
	        albumId = _ref5[0],
	        albumTracks = _ref5[1];
	
	    var album = albumsById[albumId];
	    processedTracks[albumId] = (0, _Playlists.processTracks)({ tracks: (0, _TypeCast.asArray)(albumTracks), albumId: Number(albumId), album: album });
	  });
	  return processedTracks;
	});
	
	var getAllTracks = exports.getAllTracks = (0, _reselect.createSelector)([getPlaylistsTracks], function (albumsTracks) {
	  var processedTracks = {};
	  (0, _values2.default)(albumsTracks).map(function (albumTracks) {
	    albumTracks.map(function (albumTrack) {
	      processedTracks[albumTrack.id] = albumTrack;
	    });
	  });
	  return processedTracks;
	});
	
	var processAlbum = exports.processAlbum = (0, _reselect.createSelector)([getAlbum], function (album) {
	  return (0, _Playlists.processAlbums)(album);
	});
	
	var getSortedAlbums = exports.getSortedAlbums = (0, _reselect.createSelector)([processAlbums, getActiveOrder, getOrder, getKw], function (albums, activeOrder, order, kw) {
	  return (0, _Playlists.getSortedAlbums)((0, _Playlists.getFilteredAlbums)(albums, kw), activeOrder, order);
	});

/***/ }),
/* 363 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH4QEMEB0J/OyDRwAAARpJREFUSMftlq1OBDEUhb9CEaxgkoJAYHiHKgRPQFAkqF2Hx/YJKggWgdhk5RreggTRd0ATkiaEhDCTzBRTMZkFtstP1/So9k5vvtwzR1yhjT8HbgBFHj0Dl0IbXwNbwDsQMoC3gU4CEngF9oH2P4nOqkYb74Ed2as3zqo2k91ssCYVcAEXcAEXcAEX8AI4ZFwCAr21p9LGh5wTS+AUmK1g+x4wGtSegDqxvwHGAkAbLwCR2DgHzga1Y+A+1WpnVZBx+wupq+0Xv6RzVnV/mmpt/LD0WQjrJT0LEolT3gJH8XoAVIMnj8AbsAlcOaumKeFK0cWS74e98zUw/dXE0bJJTH2qWmAXeHFW/dxqbfxdTO0qOnFWPXz34AOPvUmsZl6yGQAAAABJRU5ErkJggg=="

/***/ }),
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"icon":"_2JitMxoO7ltfbKRu8He2ow","groupIcon":"_244JEf_-KIQJxDONNF2yat","deleteButton":"_3qpNq3-wUk92W2RdXSpwnE","icon-cloud-error":"iaE_pNf67trafpkQiUry9","icon-admin":"eLKEjlZ88YglWhmV6PGtI","icon-info":"_3ekWVZSh0ZkSA_Nzev3L6f","icon-info-outline":"_15sQxnCg-g63cuLZ8_oP81","icon-text":"_2IaQW5zd6cJY3JzFKL96Vq","icon-background":"_1KHDUiIyL9xZwvpVoEIYdy","icon-add_album":"KXDJinDa-sVzrvAB2bzPi","icon-add2":"_1RFERPQiQFKYmfPnO3fq_T","icon-color":"mXbinYaXu4fvCwf-aqz1R","icon-image":"_36RBbGD0DBsgaF90y2J-oK","icon-tipe-1":"VYinOT1u3AUahfJ1N_J-X","icon-tipe-2":"hsrP9G8Re0FuaJJlySgyL","icon-tipe-3":"-ZyaQpabH_pjjdRrugTSz","icon-control_point":"_-4Wx_vGAMlcoQbCYFbsKx","icon-chart":"_2wVwzEp-bnGjWTSJBYxn7F","icon-check-circle":"_39mkYOAWSj2JwHubW6MZl5","icon-circle":"_185o9yr-R-9xvRgJ_KmKOe","icon-checkbox-thin-unchecked":"_3ysEHGhFnruNwoIb0CSVwP","icon-arrow-back":"_6KAmVZoOnU2AXlKOGRxD8","icon-sync":"_2piq6ELg_qEBq-a8xZJKU-","icon-add-box":"ShDknVrG4Qki8b3F2_kiN","icon-chevron-thin-left":"_3_MCPNqeGEczf_JC-yDVm2","icon-chevron-thin-right":"_2Hbp-1u9outKx4kl0z0BTT","icon-download":"i1tT4zIO-k7iHGU_9TNOO","icon-paperclip":"_2r1ERES1AX5ndj04idMjue","icon-media-all":"qlQ5qXGxmjckDCilN2sZV","icon-newsletter":"_3gKQfCvx8xTomSmO1yH5p4","icon-video":"_2UCsyhG1qp2L5Xag_fUaYC","icon-sort-alpha-asc":"_3MpND35nWPQq2MVL1kDa8g","icon-sort-alpha-desc":"kzzJfoELeG36SyZsi_5JC","icon-attach":"_1GLKttKc2jlXAImp5qk5S1","icon-collapse":"_1GKdRdZ1vyrIajAeYAZial","icon-zoom":"_1DlyR2GQuVs-qGxpALyTFL","icon-previous":"u0Sro2ihAAVErTxqLnnJv","icon-next":"_2-rPMeSBGCkrPzcYYpaC6p","icon-pause-round":"FT9XrKVqO6my6mLE_36ey","icon-play-round":"_3rIlQnhWKl0e0AFDRAr1lm","icon-sound":"_2_9woRr6QJ2-IKOqJDOLKY","icon-reply":"_2Oh-f1dqJuSgO6qlOG-X_w","icon-chevron-thin-down":"_3Vns_1Wwv87Vp3CBByRamW","icon-chevron-thin-up":"_3pUSK01TIdF6hk5ThBlnNO","icon-import-export":"_3RKsGGmvZWk7f1dRjqF6ht","icon-drag":"k2irxPdsfmsWzKmXo6ufD","icon-music":"_2XDQQJmDoXIUL3juc_307i","icon-paper-plane":"uFp592qLofJH75Zm7c583","icon-lock-open":"_2WoxNvubtwBZuJPj3W4Eq1","icon-radio-unchecked":"QKeqpC0VTu-KCDi2973Or","icon-radio-checked":"_1mrURiInHMEjEDgCG-clv5","icon-upload":"O-JDeuwxbR09Mio-xNJKH","icon-add":"_21cWdgrBiVV4slInaQRtQB","icon-remove":"_2RIM5R6bDuPRmE-nPBdyae","icon-mode-edit":"BM96fZFCEv_USu2ieXZlu","icon-search":"_2Sg7EmH9QCZnXG9j9zpMDZ","icon-grid":"_1o6NMYYLsomDoQIid_Nj7H","icon-list":"_3N0eGfLeZ7nA82WkxExwcB","icon-chevron-bold-down":"dpA3L2MVGmGcn88ClPdJO","icon-chevron-bold-up":"_2xk-G-M4tUJZBvSNoBFWpQ","icon-home":"_2q2nWLHHYvJ8Eywz8OHXDZ","icon-volume-down":"N-UUt4mcYwxMh3MZdZ16k","icon-volume-up":"_3X4_4bF1GXxZwZDKaT13MH","icon-checkbox-checked":"_3golm0RJRAOCUnwRAEOyD-","icon-checkbox-unchecked":"P7DQKG7BC_KBZ2USdeYTm","icon-priority":"_3gGPgUoSZ6ql0F5l66pOUK","icon-check":"_35d2T3PP-YZsMp9Q61fXPO","icon-close":"_29yuLOhaqlAxpEU9vIvxs4","icon-warning":"MM6uSMshsTAo6swCJBzw_","icon-back":"_3XoLdnfXIJpmskII3nfcKa","icon-order-down":"qCeZM9oAlfYkgKqmbLaj","icon-order-up":"c11kUNVpbsRzKuQWqFOfK","icon-menu":"_3RFNUX1esU7rpQu2E_4mq7","icon-delete":"_1yLEqSsNf0UlojlaAC9akI","icon-more-vert":"_2hvUHrNCzuPhNivTJ3luN_","icon-more-horiz":"_239TYpQ4ewNL6z7UoKwPvq","icon-play":"Kn46ftVEs9KlkYHpwXW_n","icon-pause":"_368z8UXLfi0fV1tag5pxi4","icon-exit":"_1ava_Oc1oCH0BgNunR7G_X","icon-users":"_25K7B34n_qlmSpyRSVS9Ao","icon-user":"_3cTt5A1NmZN3WRbY0kwvww","icon-playlist":"_1TzcHExZKU-ah7Ul6VN8Y9","icon-forward":"_2AwAIWSezjHk2o17Xy7G29","icon-stats-bars":"_2Ts_wFiJ-xmL0JNQZO1oey","icon-bug":"_3Wt79aGVupsag6YeMuFHxj","icon-users-folder":"_2qdsljL4iXq80kqBQqa7A5","list":"_1ncvFNqdT9K_Q5WWlN2LzA","recipientRow":"_1WRy1Dx-6DoYVE_pbzk-aP","groupRow":"_1y3KN8xfpJJjgYYpXP5PWp","idColumn":"_1NMBVMRsqhkTY8oM9UZwOq","nameColumn":"zds8HTU5l0pzdr2yYUCvm","dateColumn":"PdU_8eO_TZG1m1nr_9Zct","statusColumn":"_18ma9HV4zZArn4CkgfsJNg","authColumn":"_1_iG7oS4fBqhZIwnqJusK","actionsColumn":"_3qxRaiVZww8vM7fFPengWd","groupRecipientRow":"_3--SInmx42Z3XgHJkcQtfw","checkbox":"_3xykFDoM2jJHtc2oGCojdF","groupContainer":"rFbArEaZJ7mgVXDvrvL6n","moreButton":"_27XpCO6pQCfNAhb30Snb2q"};

/***/ }),
/* 424 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"timeCell":"_9tUjinES2IiUGEyf8HtMd","track":"_32TESR5R9L-wOmbZTXn_3C","denied":"_2ou1L2vOqTP_y3hRMjc2aP","more":"_1glXeZkHwvzfWPW4O_988p","moreButton":"gWb0FJcog8Ocv8lWmVvqU","tracks":"_2jp0P_mu3dzB--kd369VMm","trackNumber":"_2DpPgdH3n3b-wQ-3irAjr6","trackArtist":"_2c0FEALVxbjQXg7XTsDEei"};

/***/ }),
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _projects = __webpack_require__(28);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1243);
	
	var AlbumThumbDescrition = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(AlbumThumbDescrition, _PureComponent);
	
	  function AlbumThumbDescrition() {
	    (0, _classCallCheck3.default)(this, AlbumThumbDescrition);
	    return (0, _possibleConstructorReturn3.default)(this, (AlbumThumbDescrition.__proto__ || (0, _getPrototypeOf2.default)(AlbumThumbDescrition)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AlbumThumbDescrition, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          album = _props.album;
	
	      var isQS = album.projectContentType === _projects.projectTypes.quickSend || album.projectType === _projects.projectTypes.quickSend;
	      var t = this.context.t;
	
	
	      if (album.imageThumb) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(className, styles.description, { isQS: isQS }) },
	        isQS ? t('Quick Send') : t('No image available')
	      );
	    }
	  }]);
	  return AlbumThumbDescrition;
	}(_react.PureComponent), _class.propTypes = {
	  album: _propTypes2.default.object,
	  className: _propTypes2.default.string
	}, _class.contextTypes = {
	  t: _propTypes2.default.func
	}, _class.defaultProps = {
	  album: {}
	}, _temp);
	exports.default = AlbumThumbDescrition;
	module.exports = exports['default'];

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TermsHint = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(TermsHint, _Component);
	
	  function TermsHint() {
	    (0, _classCallCheck3.default)(this, TermsHint);
	    return (0, _possibleConstructorReturn3.default)(this, (TermsHint.__proto__ || (0, _getPrototypeOf2.default)(TermsHint)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TermsHint, [{
	    key: 'render',
	
	
	    /* eslint-disable max-len */
	    value: function render() {
	      var _props = this.props,
	          t = _props.t,
	          className = _props.className,
	          nonStyled = _props.nonStyled;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)({ 'text-center margin-top-10 colorDark': !nonStyled }, className) },
	        t('Cright is processing the User Files and your Personal Data and providing the Service on behalf of a third party and in accordance with the third party’s instructions and control.')
	      );
	    }
	    /* eslint-enable max-len */
	
	  }]);
	  return TermsHint;
	}(_react.Component), _class2.propTypes = {
	  className: _propTypes2.default.string,
	  nonStyled: _propTypes2.default.bool,
	  t: _propTypes2.default.func
	}, _temp)) || _class);
	exports.default = TermsHint;
	module.exports = exports['default'];

/***/ }),
/* 513 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ['#108cc0', '#DF4B25', '#FF9900', '#109618', '#990099', '#3B3EAC', '#0099C6', '#DD4477', '#66AA00', '#B82E2E', '#316395', '#994499', '#22AA99', '#AAAA11', '#6633CC', '#E67300', '#8B0707', '#329262', '#5574A6', '#3baca0'];
	var geographyColors = exports.geographyColors = ['#f5f5f5', '#108cc0'];

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _assign = __webpack_require__(186);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _uploads = __webpack_require__(112);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UploadStatusBaseClass = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(UploadStatusBaseClass, _Component);
	
	  function UploadStatusBaseClass(props) {
	    var _text;
	
	    (0, _classCallCheck3.default)(this, UploadStatusBaseClass);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (UploadStatusBaseClass.__proto__ || (0, _getPrototypeOf2.default)(UploadStatusBaseClass)).call(this, props));
	
	    var t = __webpack_require__(56).getT();
	    var text = (_text = {}, (0, _defineProperty3.default)(_text, _uploads.STATUS.DELETING, t('Deleting')), (0, _defineProperty3.default)(_text, _uploads.STATUS.PAUSED, t('Paused')), (0, _defineProperty3.default)(_text, _uploads.STATUS.QUEUED, t('Queued')), (0, _defineProperty3.default)(_text, _uploads.STATUS.UPLOAD_RETRYING, t('Retrying')), (0, _defineProperty3.default)(_text, _uploads.STATUS.SUBMITTING, t('Submitting')), (0, _defineProperty3.default)(_text, _uploads.STATUS.UPLOADING, t('Uploading')), (0, _defineProperty3.default)(_text, _uploads.STATUS.UPLOAD_FAILED, t('Failed')), (0, _defineProperty3.default)(_text, _uploads.STATUS.UPLOAD_SUCCESSFUL, t('Completed')), (0, _defineProperty3.default)(_text, 'processing', t('Processing')), _text);
	
	    _this.state = {
	      bytesUploaded: null,
	      hidden: props.hideBeforeStart,
	      isCanceled: false,
	      isComplete: false,
	      isFailed: false,
	      progress: null,
	      status: '',
	      statusText: '',
	      text: (0, _assign2.default)({}, text, props.text || {}),
	      totalSize: null
	    };
	
	    _this._createEventHandlers();
	    return _this;
	  }
	
	  (0, _createClass3.default)(UploadStatusBaseClass, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.uploader.on('statusChange', this._trackStatusEventHandler);
	      this.props.uploader.on(this._isTotalProgress ? 'totalProgress' : 'progress', this._trackProgressEventHandler);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.text) {
	        this.setState({
	          text: (0, _assign2.default)({}, this.state.text, nextProps.text)
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._unmounted = true;
	      this._unregisterEventHandlers();
	    }
	  }, {
	    key: '_unregisterEventHandlers',
	    value: function _unregisterEventHandlers() {
	      this.props.uploader.off(this._isTotalProgress ? 'totalProgress' : 'progress', this._trackProgressEventHandler);
	      this.props.uploader.off('statusChange', this._trackStatusEventHandler);
	    }
	  }, {
	    key: '_updateProgressState',
	    value: function _updateProgressState(bytesUploaded, totalSize) {
	      this.setState({
	        bytesUploaded: bytesUploaded,
	        totalSize: totalSize,
	        progress: (0, _uploads.getProgress)(bytesUploaded, totalSize)
	      });
	
	      if (this.onUpdateProgress) {
	        this.onUpdateProgress();
	      }
	    }
	  }, {
	    key: '_createEventHandlers',
	    value: function _createEventHandlers() {
	      var _this2 = this;
	
	      if (this._isTotalProgress) {
	        this._trackProgressEventHandler = function (bytesUploaded, totalSize) {
	          _this2._updateProgressState(bytesUploaded, totalSize);
	        };
	      } else {
	        this._trackProgressEventHandler = function (id, name, bytesUploaded, totalSize) {
	          if (id === _this2.props.id) {
	            _this2._updateProgressState(bytesUploaded, totalSize);
	          }
	        };
	      }
	
	      this._trackStatusEventHandler = function (id, oldStatus, newStatus) {
	        var state = _this2.state;
	        var _props = _this2.props,
	            hideOnComplete = _props.hideOnComplete,
	            uploader = _props.uploader;
	
	        var isSuccess = (0, _uploads.isUploadSuccess)(newStatus);
	        var isFailed = (0, _uploads.isUploadFailed)(newStatus);
	        var isCanceled = (0, _uploads.isUploadCanceled)(newStatus);
	        var isComplete = (0, _uploads.isUploadComplete)(newStatus);
	        var needHide = !state.hidden && hideOnComplete && isComplete;
	
	        if (!_this2._unmounted) {
	          if (id === _this2.props.id) {
	            var statusText = state.text ? state.text[newStatus] : '';
	            _this2.setState({ status: newStatus, statusText: statusText, isComplete: isComplete, isFailed: isFailed, isCanceled: isCanceled, isSuccess: isSuccess });
	
	            if (newStatus === _uploads.STATUS.UPLOADING && state.hidden) {
	              _this2.setState({ hidden: false });
	            } else if (needHide && !uploader.methods.getInProgress()) {
	              _this2.setState({ hidden: true });
	            }
	          }
	
	          if (_this2.onStatusChange) {
	            _this2.onStatusChange(id, oldStatus, newStatus);
	          }
	        }
	      };
	    }
	  }, {
	    key: '_isTotalProgress',
	    get: function get() {
	      return typeof this.props.id === 'undefined';
	    }
	  }, {
	    key: 'uploadStatus',
	    get: function get() {
	      var _state = this.state,
	          status = _state.status,
	          statusText = _state.statusText,
	          progress = _state.progress,
	          text = _state.text;
	
	      var isProcessing = progress === 100 && status === _uploads.STATUS.UPLOADING;
	
	      var uploadStatus = isProcessing ? text.processing : statusText;
	      if (status === _uploads.STATUS.UPLOADING && progress !== 100 && progress !== null) {
	        uploadStatus += ' ' + progress + '%';
	      }
	
	      if (this._isTotalProgress && progress !== null) {
	        uploadStatus = progress + '%';
	      }
	
	      return uploadStatus;
	    }
	  }]);
	  return UploadStatusBaseClass;
	}(_react.Component), _class.propTypes = {
	  hideBeforeStart: _propTypes2.default.bool,
	  hideOnComplete: _propTypes2.default.bool,
	  id: _propTypes2.default.number,
	  text: _propTypes2.default.shape({
	    deleting: _propTypes2.default.string,
	    paused: _propTypes2.default.string,
	    processing: _propTypes2.default.string,
	    queued: _propTypes2.default.string,
	    retryingUpload: _propTypes2.default.string,
	    submitting: _propTypes2.default.string,
	    uploading: _propTypes2.default.string,
	    uploadFailed: _propTypes2.default.string,
	    uploadSuccessful: _propTypes2.default.string
	  }),
	  uploader: _propTypes2.default.object.isRequired
	}, _class.defaultProps = {
	  hideBeforeStart: false,
	  hideOnComplete: false
	}, _temp);
	exports.default = UploadStatusBaseClass;
	module.exports = exports['default'];

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _Loader = __webpack_require__(60);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _utils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1282);
	
	var MoreButton = (_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(MoreButton, _Component);
	
	  function MoreButton() {
	    (0, _classCallCheck3.default)(this, MoreButton);
	    return (0, _possibleConstructorReturn3.default)(this, (MoreButton.__proto__ || (0, _getPrototypeOf2.default)(MoreButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MoreButton, [{
	    key: 'onClick',
	    value: function onClick(e) {
	      var _props = this.props,
	          onClick = _props.onClick,
	          loading = _props.loading;
	
	      if (!loading) {
	        onClick(e);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          loading = _props2.loading,
	          containerClass = _props2.containerClass,
	          buttonClass = _props2.buttonClass;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(styles.more, containerClass) },
	        _react2.default.createElement('i', { className: (0, _bind2.default)(styles.moreIcon, buttonClass, (0, _defineProperty3.default)({}, styles.loading, loading)), onClick: this.onClick }),
	        _react2.default.createElement(_Loader2.default, { onClick: _utils.stopEvent, show: loading, small: true, transparent: true, mask: true })
	      );
	    }
	  }]);
	  return MoreButton;
	}(_react.Component), _class2.propTypes = {
	  buttonClass: _propTypes2.default.string,
	  containerClass: _propTypes2.default.string,
	  loading: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func
	}, _class2.defaultProps = {
	  loading: false,
	  onClick: _noop3.default
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onClick'), _class.prototype)), _class);
	exports.default = MoreButton;
	module.exports = exports['default'];

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _projects = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectStatus = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(ProjectStatus, _Component);
	
	  function ProjectStatus() {
	    (0, _classCallCheck3.default)(this, ProjectStatus);
	    return (0, _possibleConstructorReturn3.default)(this, (ProjectStatus.__proto__ || (0, _getPrototypeOf2.default)(ProjectStatus)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProjectStatus, [{
	    key: 'render',
	    value: function render() {
	      var status = this.props.status;
	
	      var statusTexts = (0, _projects.getProjectStatusTexts)();
	
	      return _react2.default.createElement(
	        'span',
	        { className: 'projectStatus ' + status },
	        statusTexts[status] || status
	      );
	    }
	  }]);
	  return ProjectStatus;
	}(_react.Component), _class.propTypes = {
	  status: _propTypes2.default.string
	}, _temp);
	exports.default = ProjectStatus;
	module.exports = exports['default'];

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _ProjectIrefImage = __webpack_require__(832);
	
	var _ProjectIrefImage2 = _interopRequireDefault(_ProjectIrefImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1298);
	
	var ProjectLegendLine = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(ProjectLegendLine, _PureComponent);
	
	  function ProjectLegendLine() {
	    (0, _classCallCheck3.default)(this, ProjectLegendLine);
	    return (0, _possibleConstructorReturn3.default)(this, (ProjectLegendLine.__proto__ || (0, _getPrototypeOf2.default)(ProjectLegendLine)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProjectLegendLine, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          hideWatermark = _props.hideWatermark;
	      var t = this.context.t;
	
	
	      return _react2.default.createElement(
	        'span',
	        { className: (0, _bind2.default)(styles.legendLine, className) },
	        _react2.default.createElement(
	          'span',
	          { className: styles.legend },
	          _react2.default.createElement(_ProjectIrefImage2.default, null),
	          ' - ',
	          t('internal ref')
	        ),
	        !hideWatermark && _react2.default.createElement(
	          'span',
	          { className: styles.legend },
	          _react2.default.createElement('span', { className: styles.watermarkSign }),
	          ' - ',
	          t('watermark')
	        )
	      );
	    }
	  }]);
	  return ProjectLegendLine;
	}(_react.PureComponent), _class.propTypes = {
	  className: _propTypes2.default.string,
	  hideWatermark: _propTypes2.default.bool
	}, _class.contextTypes = {
	  t: _propTypes2.default.func
	}, _temp);
	exports.default = ProjectLegendLine;
	module.exports = exports['default'];

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1315);
	
	var SimpleTab = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(SimpleTab, _PureComponent);
	
	  function SimpleTab() {
	    (0, _classCallCheck3.default)(this, SimpleTab);
	    return (0, _possibleConstructorReturn3.default)(this, (SimpleTab.__proto__ || (0, _getPrototypeOf2.default)(SimpleTab)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SimpleTab, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          title = _props.title,
	          active = _props.active,
	          onClick = _props.onClick;
	
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _bind2.default)(styles.tab, (0, _defineProperty3.default)({}, styles.active, active), className),
	          onClick: onClick
	        },
	        title
	      );
	    }
	  }]);
	  return SimpleTab;
	}(_react.PureComponent), _class.propTypes = {
	  active: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  title: _propTypes2.default.string
	}, _class.defaultProps = {
	  onClick: _noop3.default
	}, _temp);
	exports.default = SimpleTab;
	module.exports = exports['default'];

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1323);
	
	var ChartNoData = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(ChartNoData, _PureComponent);
	
	  function ChartNoData() {
	    (0, _classCallCheck3.default)(this, ChartNoData);
	    return (0, _possibleConstructorReturn3.default)(this, (ChartNoData.__proto__ || (0, _getPrototypeOf2.default)(ChartNoData)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ChartNoData, [{
	    key: 'render',
	    value: function render() {
	      var className = this.props.className;
	      var t = this.context.t;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(styles.container, className) },
	        t('No data')
	      );
	    }
	  }]);
	  return ChartNoData;
	}(_react.PureComponent), _class.propTypes = {
	  className: _propTypes2.default.string
	}, _class.contextTypes = {
	  t: _propTypes2.default.func
	}, _temp);
	exports.default = ChartNoData;
	module.exports = exports['default'];

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _toConsumableArray2 = __webpack_require__(34);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _ChartWrapper = __webpack_require__(211);
	
	var _ChartWrapper2 = _interopRequireDefault(_ChartWrapper);
	
	var _ChartNoData = __webpack_require__(519);
	
	var _ChartNoData2 = _interopRequireDefault(_ChartNoData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var DevicesChart = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(DevicesChart, _PureComponent);
	
	  function DevicesChart() {
	    (0, _classCallCheck3.default)(this, DevicesChart);
	    return (0, _possibleConstructorReturn3.default)(this, (DevicesChart.__proto__ || (0, _getPrototypeOf2.default)(DevicesChart)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(DevicesChart, [{
	    key: 'getChartData',
	    value: function getChartData() {
	      var data = this.props.data.data;
	      var _context = this.context,
	          t = _context.t,
	          _t = _context.t;
	
	
	      return [[t('Device'), t('Count')]].concat((0, _toConsumableArray3.default)(data.map(function (stat) {
	        return [_t(stat[0]), stat[1]];
	      })));
	    }
	  }, {
	    key: 'getChartProps',
	    value: function getChartProps() {
	      var id = this.props.id;
	
	      var data = this.getChartData();
	
	      return {
	        graphId: id,
	        chartType: 'PieChart',
	        data: data,
	        options: {
	          is3D: false,
	          pieHole: 0.4,
	          chartArea: {
	            left: 10,
	            top: 10,
	            width: '80%'
	          },
	          legend: {
	            position: 'right',
	            alignment: 'top'
	          }
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          hasData = _props.data.hasData,
	          loading = _props.loading,
	          reverseColors = _props.reverseColors;
	
	      var chartProps = this.getChartProps();
	
	      if (!hasData && !loading) {
	        return _react2.default.createElement(_ChartNoData2.default, null);
	      }
	
	      return _react2.default.createElement(_ChartWrapper2.default, {
	        chartProps: chartProps,
	        height: 240,
	        loading: loading,
	        reverseColors: reverseColors
	      });
	    }
	  }]);
	  return DevicesChart;
	}(_react.PureComponent), _class2.propTypes = {
	  data: _propTypes2.default.object,
	  id: _propTypes2.default.string,
	  loading: _propTypes2.default.bool,
	  reverseColors: _propTypes2.default.bool
	}, _class2.contextTypes = {
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  data: { data: [], hasData: false },
	  id: 'devicesChart',
	  reverseColors: false
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'getChartData', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'getChartData'), _class.prototype)), _class);
	exports.default = DevicesChart;
	module.exports = exports['default'];

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _last2 = __webpack_require__(151);
	
	var _last3 = _interopRequireDefault(_last2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PlayStatsColumnChart = __webpack_require__(2114);
	
	var _PlayStatsColumnChart2 = _interopRequireDefault(_PlayStatsColumnChart);
	
	var _PlayStatsLineChart = __webpack_require__(2115);
	
	var _PlayStatsLineChart2 = _interopRequireDefault(_PlayStatsLineChart);
	
	var _moment = __webpack_require__(20);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var longPeriodDuration = 60 * 60 * 24 * 6; //seconds
	
	
	var PlayStatsChart = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(PlayStatsChart, _PureComponent);
	
	  function PlayStatsChart() {
	    (0, _classCallCheck3.default)(this, PlayStatsChart);
	    return (0, _possibleConstructorReturn3.default)(this, (PlayStatsChart.__proto__ || (0, _getPrototypeOf2.default)(PlayStatsChart)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PlayStatsChart, [{
	    key: 'getDaysCount',
	    value: function getDaysCount() {
	      var data = this.props.data;
	
	      return data.length ? _moment2.default.duration((0, _last3.default)(data).unixDate - data[0].unixDate, 'seconds').asDays() + 1 : 0;
	    }
	  }, {
	    key: 'isPeriodLong',
	    value: function isPeriodLong() {
	      var data = this.props.data;
	
	      if (!data.length) {
	        return false;
	      }
	
	      var chartPeriod = (0, _last3.default)(data).unixDate - data[0].unixDate;
	      return chartPeriod > longPeriodDuration;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          data = _props.data,
	          id = _props.id,
	          loading = _props.loading,
	          chartOptions = _props.chartOptions;
	
	      var isPeriodLong = this.isPeriodLong();
	      var daysCount = this.getDaysCount();
	      var props = { data: data, id: id, daysCount: daysCount, loading: loading, chartOptions: chartOptions };
	
	      return isPeriodLong ? _react2.default.createElement(_PlayStatsLineChart2.default, props) : _react2.default.createElement(_PlayStatsColumnChart2.default, props);
	    }
	  }]);
	  return PlayStatsChart;
	}(_react.PureComponent), _class.propTypes = {
	  chartOptions: _propTypes2.default.object,
	  data: _propTypes2.default.array,
	  id: _propTypes2.default.string,
	  loading: _propTypes2.default.bool
	}, _class.defaultProps = {
	  data: []
	}, _temp);
	exports.default = PlayStatsChart;
	module.exports = exports['default'];

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _objectWithoutProperties2 = __webpack_require__(21);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _common = __webpack_require__(265);
	
	var commonActions = _interopRequireWildcard(_common);
	
	var _Tooltip = __webpack_require__(1620);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _OverlayTrigger = __webpack_require__(704);
	
	var _OverlayTrigger2 = _interopRequireDefault(_OverlayTrigger);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tooltip = (_dec = (0, _reactRedux.connect)(null, (0, _extends3.default)({}, commonActions)), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(Tooltip, _Component);
	
	  function Tooltip() {
	    (0, _classCallCheck3.default)(this, Tooltip);
	    return (0, _possibleConstructorReturn3.default)(this, (Tooltip.__proto__ || (0, _getPrototypeOf2.default)(Tooltip)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Tooltip, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.id = this.props.getId('tooltip-');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          title = _props.title,
	          rest = (0, _objectWithoutProperties3.default)(_props, ['children', 'title']);
	
	
	      return _react2.default.createElement(
	        _OverlayTrigger2.default,
	        (0, _extends3.default)({}, rest, { overlay: _react2.default.createElement(
	            _Tooltip2.default,
	            { id: this.id },
	            title
	          ) }),
	        _react2.default.createElement(
	          'span',
	          null,
	          children
	        )
	      );
	    }
	  }]);
	  return Tooltip;
	}(_react.Component), _class2.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  getId: _propTypes2.default.func,
	  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node])
	}, _temp)) || _class);
	exports.default = Tooltip;
	module.exports = exports['default'];

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = CheckboxField;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(50);
	
	var _formComponents = __webpack_require__(71);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CheckboxField(props) {
	  return _react2.default.createElement(_reduxForm.Field, (0, _extends3.default)({ component: _formComponents.formCheckbox }, props, { normalize: function normalize(val) {
	      return val ? 1 : 0;
	    } }));
	}
	module.exports = exports['default'];

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(21);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _isNumber3 = __webpack_require__(673);
	
	var _isNumber4 = _interopRequireDefault(_isNumber3);
	
	exports.default = formDate;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDatetime = __webpack_require__(710);
	
	var _reactDatetime2 = _interopRequireDefault(_reactDatetime);
	
	var _moment = __webpack_require__(20);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _datePickerProps = __webpack_require__(861);
	
	var _datePickerProps2 = _interopRequireDefault(_datePickerProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formDate(props) {
	  // eslint-disable-next-line no-unused-vars
	  var input = props.input,
	      _props$meta = props.meta,
	      touched = _props$meta.touched,
	      error = _props$meta.error,
	      type = props.type,
	      disabled = props.disabled,
	      placeholder = props.placeholder,
	      required = props.required,
	      allowPast = props.allowPast,
	      inputProps = props.inputProps,
	      other = (0, _objectWithoutProperties3.default)(props, ['input', 'meta', 'type', 'disabled', 'placeholder', 'required', 'allowPast', 'inputProps']);
	
	  var datePickerProps = (0, _extends3.default)({}, _datePickerProps2.default);
	  var finalInputProps = (0, _extends3.default)({}, datePickerProps.inputProps, inputProps, { required: required, disabled: disabled, placeholder: placeholder });
	
	  if (allowPast) {
	    datePickerProps.isValidDate = null;
	  }
	
	  if (input && input.value && (0, _isNumber4.default)(input.value)) {
	    //the date from the server comes to the second format, need convert it to ms
	    //todo: think about how to fix this
	    if (input.value < Date.now() / 100) {
	      input.value = new Date(input.value * 1000);
	    }
	  }
	
	  // API dirty hack for wrong dates
	  var dateYear = (0, _moment2.default)(input.value).year() || 0;
	  if (input.value && input.value !== '1970-01-01' && dateYear > 1980) {
	    input.value = (0, _moment2.default)(input.value);
	  } else {
	    // hide zero date (01/01/1970) in the date field
	    input.value = '';
	    datePickerProps.timeFormat = false;
	    datePickerProps.dateFormat = '-';
	  }
	
	  var onFocus = function onFocus() {
	    return finalInputProps.readOnly = true;
	  };
	  var onBlur = function onBlur() {
	    return finalInputProps.readOnly = false;
	  };
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactDatetime2.default, (0, _extends3.default)({}, input, datePickerProps, {
	      inputProps: finalInputProps
	    }, other, {
	      disabled: disabled,
	      onFocus: onFocus,
	      onBlur: onBlur
	    })),
	    touched && error && _react2.default.createElement(
	      'div',
	      { className: 'fieldErrorText' },
	      error
	    )
	  );
	}
	
	formDate.propTypes = {
	  allowPast: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  input: _propTypes2.default.object,
	  inputProps: _propTypes2.default.object,
	  meta: _propTypes2.default.object,
	  placeholder: _propTypes2.default.string,
	  required: _propTypes2.default.bool,
	  type: _propTypes2.default.string
	};
	module.exports = exports['default'];

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.processAlbums = processAlbums;
	exports.getDefaultImageName = getDefaultImageName;
	
	var _datetime = __webpack_require__(68);
	
	var _projects = __webpack_require__(28);
	
	function processAlbum(album) {
	  album.sender = [album.owFirstname, album.owLastname].join(' ').trim();
	  album.albumName = [album.album, album.album2].join(' ').trim();
	  album.shortSentDate = (0, _datetime.formatDate)(album.sent_date);
	  album.fullSentDate = (0, _datetime.formatDateTime)(album.sent_date);
	  return album;
	}
	
	function processAlbums(albums) {
	  if (Array.isArray(albums)) {
	    albums.map(function (album) {
	      return processAlbum(album);
	    });
	  } else {
	    processAlbum(albums);
	  }
	
	  return albums;
	}
	
	function getDefaultImageName(album) {
	  return album.projectContentType === _projects.projectTypes.quickSend || album.projectType === _projects.projectTypes.quickSend ? 'no-image-qs' : 'no-image';
	}

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(78);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(72);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	exports.normalizeFormData = normalizeFormData;
	
	var _moment = __webpack_require__(20);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _datetime = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function normalizeFormData(data) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var normalizedData = {};
	  var _options$dateTimeFiel = options.dateTimeFields,
	      dateTimeFields = _options$dateTimeFiel === undefined ? [] : _options$dateTimeFiel;
	
	
	  (0, _entries2.default)(data).map(function (_ref) {
	    var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	        key = _ref2[0],
	        val = _ref2[1];
	
	    if (val instanceof _moment2.default) {
	      normalizedData[key] = val.format(dateTimeFields.includes(key) ? _datetime.dateFormat.sqlDateTime : _datetime.dateFormat.sql);
	    } else if (typeof val === 'boolean') {
	      normalizedData[key] = val ? 1 : 0;
	    } else {
	      normalizedData[key] = val;
	    }
	  });
	
	  return normalizedData;
	}

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.nameMaxLength = undefined;
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _uniq2 = __webpack_require__(457);
	
	var _uniq3 = _interopRequireDefault(_uniq2);
	
	var _get2 = __webpack_require__(19);
	
	var _get3 = _interopRequireDefault(_get2);
	
	exports.processMyPlaylist = processMyPlaylist;
	exports.processMyPlaylists = processMyPlaylists;
	exports.processMyPlaylistTracks = processMyPlaylistTracks;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var nameMaxLength = exports.nameMaxLength = 30;
	
	function processMyPlaylist(playlist) {
	  var res = (0, _extends3.default)({}, playlist);
	  res.projectId = res.guid;
	  res.artist_name = res.name;
	  res.list = (0, _uniq3.default)(res.list);
	  res.tracksCount = (0, _get3.default)(res, 'list.length', 0);
	  return res;
	}
	
	function processMyPlaylists(playlists) {
	  return playlists.map(processMyPlaylist);
	}
	
	function processMyPlaylistTracks(playlist, albumTracks) {
	  var tracksId = (0, _get3.default)(playlist, 'list', []);
	  var res = [];
	  tracksId.map(function (trackId) {
	    if (albumTracks[trackId]) {
	      res.push(albumTracks[trackId]);
	    }
	  });
	  return res;
	}

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _last2 = __webpack_require__(151);
	
	var _last3 = _interopRequireDefault(_last2);
	
	var _map2 = __webpack_require__(241);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _isUndefined2 = __webpack_require__(240);
	
	var _isUndefined3 = _interopRequireDefault(_isUndefined2);
	
	var _compact2 = __webpack_require__(447);
	
	var _compact3 = _interopRequireDefault(_compact2);
	
	var _get2 = __webpack_require__(19);
	
	var _get3 = _interopRequireDefault(_get2);
	
	exports.getClientIp = getClientIp;
	exports.parseHash = parseHash;
	exports.getRoutesParams = getRoutesParams;
	exports.getRoutesLastParam = getRoutesLastParam;
	exports.getRoutesFirstParam = getRoutesFirstParam;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getClientIp(req) {
	  var regexp = /::(.)*:/igm;
	  var ips = [(0, _get3.default)(req, ['headers', 'x-forwarded-for']), (0, _get3.default)(req, ['headers', 'x-real-ip']), (0, _get3.default)(req, 'connection.remoteAddress').replace(regexp, ''), (0, _get3.default)(req, 'socket.remoteAddress').replace(regexp, ''), (0, _get3.default)(req, 'connection.socket.remoteAddress')];
	  var ip = (0, _compact3.default)(ips)[0] || '0.0.0.0';
	
	  req.visitor.event({
	    ec: 'Client IP',
	    ea: 'Get',
	    el: 'ip = ' + ip + ' (' + ips.toString() + ')'
	  }).send();
	
	  return ip;
	}
	
	function parseHash(hash) {
	  var hashArr = hash.replace(/^#/, '').split(/[&\?]/); // eslint-disable-line no-useless-escape
	  var hashObj = {};
	  hashArr.forEach(function (val) {
	    var keyVal = val.split('=');
	    hashObj[keyVal[0]] = decodeURIComponent(keyVal[1]).replace(/\+/igm, ' ');
	  });
	
	  return hashObj;
	}
	
	function getRoutesParams(_ref) {
	  var _ref$routes = _ref.routes,
	      routes = _ref$routes === undefined ? [] : _ref$routes,
	      name = _ref.name;
	
	  return (0, _map3.default)(routes.filter(function (route) {
	    return !(0, _isUndefined3.default)(route[name]);
	  }), name);
	}
	
	function getRoutesLastParam(_ref2) {
	  var _ref2$routes = _ref2.routes,
	      routes = _ref2$routes === undefined ? [] : _ref2$routes,
	      name = _ref2.name;
	
	  return (0, _last3.default)(getRoutesParams({ routes: routes, name: name }));
	}
	
	function getRoutesFirstParam(_ref3) {
	  var _ref3$routes = _ref3.routes,
	      routes = _ref3$routes === undefined ? [] : _ref3$routes,
	      name = _ref3.name;
	
	  return getRoutesParams({ routes: routes, name: name })[0];
	}

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _reactCookie = __webpack_require__(174);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CookieStorage = function () {
	  function CookieStorage(cookies) {
	    (0, _classCallCheck3.default)(this, CookieStorage);
	    this.cookiePrefix = '__client__';
	
	    this.cookies = cookies || new _reactCookie.Cookies();
	  }
	
	  (0, _createClass3.default)(CookieStorage, [{
	    key: 'set',
	    value: function set(_ref) {
	      var name = _ref.name,
	          value = _ref.value,
	          expires = _ref.expires;
	
	      this.cookies.set('' + this.cookiePrefix + name, value.toString(), { path: '/', expires: expires });
	    }
	  }, {
	    key: 'setAsBoolean',
	    value: function setAsBoolean(_ref2) {
	      var name = _ref2.name,
	          value = _ref2.value,
	          expires = _ref2.expires;
	
	      this.set({ name: name, value: Number(value).toString(), expires: expires });
	    }
	  }, {
	    key: 'get',
	    value: function get(_ref3) {
	      var name = _ref3.name;
	
	      return this.cookies.get('' + this.cookiePrefix + name);
	    }
	  }, {
	    key: 'getAsNumber',
	    value: function getAsNumber(_ref4) {
	      var name = _ref4.name;
	
	      return Number(this.get({ name: name }));
	    }
	  }, {
	    key: 'getAsBoolean',
	    value: function getAsBoolean(_ref5) {
	      var name = _ref5.name;
	
	      return !!this.getAsNumber({ name: name });
	    }
	  }]);
	  return CookieStorage;
	}();
	
	exports.default = CookieStorage;
	module.exports = exports['default'];

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.cookieNames = undefined;
	exports.default = reducer;
	exports.hideAd = hideAd;
	exports.hideCookie = hideCookie;
	
	var _qim = __webpack_require__(110);
	
	var HIDE_AD = 'adbar/HIDE_AD';
	var HIDE_COOKIE = 'adbar/HIDE_COOKIE';
	
	var cookieNames = exports.cookieNames = {
	  cookieBar: 'cookiePolicyBarHidden',
	  adBar: 'adBarHideTime'
	};
	
	var initialState = {
	  adBarHidden: false,
	  cookieBarHidden: false
	};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case HIDE_AD:
	      {
	        return (0, _qim.set)('adBarHidden', true, state);
	      }
	    case HIDE_COOKIE:
	      {
	        return (0, _qim.set)('cookieBarHidden', true, state);
	      }
	    default:
	      {
	        return state;
	      }
	  }
	}
	
	function hideAd() {
	  return {
	    type: HIDE_AD
	  };
	}
	
	function hideCookie() {
	  return {
	    type: HIDE_COOKIE
	  };
	}

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hide = hide;
	exports.show = show;
	
	var _ProgressPopupReducer = __webpack_require__(2239);
	
	var _ProgressPopupReducer2 = _interopRequireDefault(_ProgressPopupReducer);
	
	var _progresspopup = __webpack_require__(2230);
	
	var _progresspopup2 = _interopRequireDefault(_progresspopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	  timeout: 10,
	  visible: false
	};
	
	exports.default = new _ProgressPopupReducer2.default({
	  constants: _progresspopup2.default,
	  initialState: initialState
	}).reducer;
	function hide() {
	  return {
	    type: _progresspopup2.default.HIDE
	  };
	}
	
	function show(_ref) {
	  var text = _ref.text,
	      title = _ref.title,
	      timeout = _ref.timeout;
	
	  var options = { text: text, title: title, timeout: timeout };
	  return {
	    type: _progresspopup2.default.SHOW,
	    options: options
	  };
	}

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getQuickSendItem = exports.processQuickSends = undefined;
	
	var _toConsumableArray2 = __webpack_require__(34);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _get3 = __webpack_require__(19);
	
	var _get4 = _interopRequireDefault(_get3);
	
	var _isArray3 = __webpack_require__(46);
	
	var _isArray4 = _interopRequireDefault(_isArray3);
	
	var _find3 = __webpack_require__(95);
	
	var _find4 = _interopRequireDefault(_find3);
	
	var _reselect = __webpack_require__(125);
	
	var _projects = __webpack_require__(28);
	
	var _Playlists = __webpack_require__(214);
	
	var _TypeCast = __webpack_require__(260);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getProjects = function getProjects(state) {
	  return state.quicksend.qsListData;
	};
	var getProjectParams = function getProjectParams(state) {
	  for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    params[_key - 1] = arguments[_key];
	  }
	
	  return params;
	};
	
	var processQuickSends = exports.processQuickSends = (0, _reselect.createSelector)([getProjects], function (projects) {
	  // duct tape for API different responses for different box types
	  var qsProjects = [];
	  if ((0, _isArray4.default)(projects)) {
	    qsProjects = projects;
	  }
	  if ((0, _get4.default)(projects, 'albums')) {
	    qsProjects = [].concat((0, _toConsumableArray3.default)(projects.albums));
	    qsProjects.map(function (qsProject) {
	      qsProject.tracks = (0, _get4.default)(projects, ['tracks', qsProject.project_id], []);
	    });
	  }
	
	  return (0, _projects.processProjects)(qsProjects);
	});
	
	var getQuickSendItem = exports.getQuickSendItem = (0, _reselect.createSelector)([processQuickSends, getProjectParams], function (projects, params) {
	  var id = params[0];
	  var qsProject = (0, _find4.default)(projects, { projectId: id }) || {};
	  var processedProject = (0, _projects.processProject)(qsProject);
	  processedProject.tracks = processedProject.tracks ? (0, _Playlists.processTracks)({ tracks: (0, _TypeCast.asArray)(processedProject.tracks) }) : [];
	  return processedProject;
	});

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reverse2 = __webpack_require__(453);
	
	var _reverse3 = _interopRequireDefault(_reverse2);
	
	var _sortBy2 = __webpack_require__(676);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	exports.default = ordering;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ordering(_ref) {
	  var _ref$data = _ref.data,
	      data = _ref$data === undefined ? [] : _ref$data,
	      activeOrder = _ref.activeOrder,
	      order = _ref.order;
	
	  console.time('ordering');
	  var sortedArray = (0, _sortBy3.default)(data, activeOrder); // lodash sortBy is extremely faster native Array.sort
	  var res = order[activeOrder] === 'asc' ? sortedArray : (0, _reverse3.default)(sortedArray);
	  console.timeEnd('ordering');
	  return res;
	}
	module.exports = exports['default'];

/***/ }),
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"buttons":"_3b1iEGbE86V7Sd2ZrE7xyM","loginTerms":"_1cjCWAqO5HVeAZQRit7DVm","forgotTerms":"G8CTNXvIC3kDDGsfW_HW0"};

/***/ }),
/* 623 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"homeContent":"tifGuVmDMKk_t2RvWMpLy","compactContent":"_2TZwQFNTxsdXJVRU6SpZ4c","page":"_2tj_H6gzbqF9K4o4F-YgpN","anchor":"vCGsb_B8V2QscA_CUXpUV","fullWidthSm":"_2CKUcJVZ9UGHT6FSa5a9rJ","fullWidthXs":"_3dkqhS-Vyd0LfGOE-yCYKp","narrowContent":"iFSxyipQ9auZVaW3fKEzN","separatorBottom":"_2ekqQqOmSxbeMm80zJa6LT","section":"_3G5KWAWHkztWLrizHjwGNU","separatorTop":"_38ut3HQLmk_4CaHA5MDlbX","h3":"_2RC8yH6Z1JnDo324gzkd4J","row":"eXmlk660lvb_3XxP5Fcdi","wide-border":"_3dftfzq16mcNVVUmNfgSuy","listItemRoot":"_1VyuXruxDG4_2k0xjhetak","listItemTitle":"_2q7cxM4WMwF-SA73SDxXZk","dragHandler":"_3UvPEPcq7_UXU2ZAgY6tFM"};

/***/ }),
/* 624 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"list":"_38WOqKd5gDRYS3mCBLWVsX","bottomContainer":"fhMjMONTC8lrouWmiTsVV","buttonContainer":"wBj0col8tSQm-GLZecG5s","addBar":"_3EL_Xm2hKzIB1p8eEdjwuF","topBars":"_3uXnIsVkArmvzgRHcVihXD"};

/***/ }),
/* 625 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pageItem":"_3GYlqYIzgin-TjFhRWXFnj","active":"_3X5ewrj-Fxx869CyWsu9Pp","nextPage":"_1rQQ6pCm1K4Q7vd-jqVYk3","prevPage":"_29Ck3HSW4egtlY0gXIDtxQ","gap":"yIvn7BYr1WtVJwV3nHT2a"};

/***/ }),
/* 626 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"propertyRow":"_1rrf8tBxD11zJF69R0Ld5I","propertyName":"_12KLN8aXuaWF_yKYT-yEzu","propertyValue":"_1WcDBthdUIF1y6sCe8XWk2","progressContainer":"_3vm7HVhLxQCP-CuB-kkigW","progressStatusContainer":"m1xql56SoCeIEFYBXHDrr"};

/***/ }),
/* 627 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"list":"ydWp9w2ReNXYE6tkCPJIL","bottomContainer":"_2MxQWDCSmoTzNgs9PZJU5L","buttonContainer":"_2x1dpopLzurYBXDhE7iMF9"};

/***/ }),
/* 628 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"list":"_219JD-CCosEk2XHROsl2EX"};

/***/ }),
/* 629 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"h1":"_3KbbdZHzgBo42eJ8VyVIUE","h2":"uEFRyZU18rHF-Sg5UqeJ7","h3":"_1XbAGQxHZ-Qmq6iI3Yud8U","margin-free":"_1uO2Z99Xn9hLHS83_7bmty","h5":"_314yBkI30of68RqRHm_ufe","hint":"_2BkNkAJBcXVSf0bmeAxV4J","small":"dEvEPlyJQO-fJXK48xwfX","default":"_3Zj3VAidmG3ZlgfFsaCKg_","text-overflow":"_3g8x8aWuX4HNBYtmjOifEA","nowrap":"_1TlUhP6RmFwVsmSkuKF6lW","break-word":"O8ziV0wZGPCwAOj-R-xEZ","u":"_2DCJIybM6ZpM1m-FVywxh6","underline":"FIDWpb0khw-4YID14EAUR","bold":"_39Z824HoollghSRMSOx5Fh","b":"_8DBJNQzFJ5NFTZ0iI9YSP","italic":"_1B9DhB8FB4hUD_fmm_h7gt","upper":"U28d9oeKgkwhGPy4vuq2N","lower":"ZQCiwhOektLX7sF0AvKfg","text-z1":"T2Ed-lfw_4tywoSzRuHXW","text-z2":"_2YhcLNUqEy-7-bP_sCjMvw","disabled":"_1q6LF1CUvphO1pkf2CullX","error":"_1mf83QOeUIJDHH8SufBdjE","danger":"_2H2R9zzDQ467Af_yPbZGRZ","colorLighten":"kAhnS1XUk5-QJRwJbpBXB","colorLight":"_3pIp9Gf3wm4X5x9sZya5jm","colorMiddle":"ve_HC0GolGZzCmMXsGL6d","colorDark":"_1es5Dbyr5MWUhTrhIAajVa","colorDarken":"_2ZukXvnUXXyLRhWTWmFyvq","colorSuccess":"_2SssBY081rRfgEKCHSluH6","colorInfo":"_1cqZpenwhc55oeyHp2USp4","colorWarning":"_24o65jH0rm9uecIZQsjReT","colorError":"_3Y7R1cDPGNMmtUV5U1UVBZ","colorPrimary":"_2O5O_HH34QiFjRalWmyxfS","auth":"_23S09ijYc3hOD90DwgMWnX","authForm":"_2LlnZ1cNGZ_D8-wIJ4vj70","header":"PzTqp6o-g8OpoSuMuQozv","registration":"_2eyAMZcVd14KV2sNuleLU2","logo":"_2lP0GJahhZCP00-ZJoJOnc","welcome":"_2Zfa8Pbep9zG1EBvNwFmq5"};

/***/ }),
/* 630 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"CJTPQP8VpSzdJbj0t7Vry","thumb":"_1aGH3OTxkHEqqxrvApWJCV","title":"_IsqYexT7L4-SUlC56kFp","textContainer":"_1N_6nHybeoYmR5C-tJmVNs","name":"_3VapM0LebS1jcvEPrMIuQO","nameInputContainer":"_1uRjsx372F67YRj6xkrbEx","nameInput":"_2psmybOWWrGdS95c4cjIs"};

/***/ }),
/* 631 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"icon":"_1W7Ta4bpvghV4XCswOHMTo","icon-cloud-error":"_1CsD_CHYkyuEFYPPAMHpo1","icon-admin":"_1mQNk3KaW6VfKLTxP6-x9H","icon-info":"_2Pl_hEX4-h2KaRV_Pd0C4K","icon-info-outline":"_137hZzwND1OJqaT_9RGMKj","icon-text":"_2AItOdlsYDM0SFVrLh8MuK","icon-background":"_3ZEpboSL6XHmL9cRzt2gHc","icon-add_album":"_29a1xmK1ZEORVBlDr7jCcc","icon-add2":"YPeqx3rDC1Ah0u6y9m1oc","icon-color":"_3W4rrR2eyZQWua5sy9yiTJ","icon-image":"_3O4M9lPpOXeOIIu1Uj8iDV","icon-tipe-1":"_3KXNtZ-IDs7hOgHPYS8mU4","icon-tipe-2":"WoyCd5Mrc0_j5DK2silMn","icon-tipe-3":"_31YV_duK2-bdyhIiuXSM40","icon-control_point":"_3EhAS2gd2j7n_u9fEyBh8w","icon-chart":"_1xLMykw7-6CQDj3Wc3-IFV","icon-check-circle":"_2sVVl7Wn3GZWKBJMpj3WTy","icon-circle":"Ep17tCq-wmluTCffTwMyD","icon-checkbox-thin-unchecked":"_3jt5kP6ns0eHJQC8Gt6AdN","icon-arrow-back":"_3zIZPkEVQH6o12hlLGDMVD","icon-sync":"_2n1wCFDrV9R-G3iSik4b6a","icon-add-box":"_36dKcRCcoEfenGW-69GkYz","icon-chevron-thin-left":"_5qgP2g_kb7yRq9xgrC02c","icon-chevron-thin-right":"_3GvWfGOttdfrSuc09fuxh5","icon-download":"yMYcXsLI8Qi-3P2u_WGJJ","icon-paperclip":"_1oP6Va-HyB15g9jo-S_SpU","icon-media-all":"_3ig3yRMGtKQ81xamzh4al7","icon-newsletter":"_1Midjh2OQFuJpftLcSOY_2","icon-video":"GPz-qwsd5DukRnmZDxf7Z","icon-sort-alpha-asc":"_3RGgSC9Ya7ldE0AfPfIaPX","icon-sort-alpha-desc":"_29JWdw-YhkWyYmvWzq6kfN","icon-attach":"_22CyXP56CdHBkBDIaPZDuL","icon-collapse":"_3jk1ep2gZPgNKBw_rB6cUV","icon-zoom":"_13tfGic6k30A1sra0ZSFmI","icon-previous":"_3RUGSw8yPQ2fm4nomMOBTT","icon-next":"_1Jmz4BnOICUpGrJbpyDZu","icon-pause-round":"_3k_2OExAYjCCwfnI4yMsfy","icon-play-round":"_1aow8eRQ-HGKDG97oGoF4A","icon-sound":"_23vqqDoYEvgUUt7zpo_GD7","icon-reply":"_1-keNMkAvGfU7lhJYPcwmt","icon-chevron-thin-down":"_1IGEu2_gw9lWORP8RtdAqW","icon-chevron-thin-up":"_1GgyFULqnzU_NcFablWGf7","icon-import-export":"_1WOPQTvw9n6weQmnO-C40T","icon-drag":"_18dSSThxw2X14LZV7Prz9j","icon-music":"_1NjXCp_Ar36Ezg0xyNZjGG","icon-paper-plane":"_1MwCa0XRMj63-gv5HC5d9K","icon-lock-open":"SwUrcXPXfp7shgc0u_XxR","icon-radio-unchecked":"_3u7I-u0lNMoB7zjxWpEDf7","icon-radio-checked":"_1nVgu3lIbf4hUlbx9TsR3g","icon-upload":"_3nEuV2K2_DLlTwfk56QtxT","icon-add":"yOnJr2La-CgwB4vlxcQyo","icon-remove":"MpCuRzOyxfR462vxSX1xH","icon-mode-edit":"_3KtiI3jsv92YlGQBJq_o1_","icon-search":"_1gj2x04wF7RfdbhQ6Zsq","icon-grid":"_1JDOPY0i8--MgRkBEewdEL","icon-list":"_32FAUkrrhVi4yfZNK4iTsW","icon-chevron-bold-down":"IR0C8JJZZnv-9_zai-iKE","icon-chevron-bold-up":"_3kbX7Om4kVfqinNIFxP99z","icon-home":"_1A_0N7Pg1daHXXRAYe33yi","icon-volume-down":"_3Ti5nDcJtSX2X2WG-6bMyW","icon-volume-up":"_2P8LgtzkYU_Wy8KVAdcT_T","icon-checkbox-checked":"_3lPIUUpCdyclQawYYsiKaP","icon-checkbox-unchecked":"_3PklIfCh1dHkaq3kDTk8es","icon-priority":"_1jKWOrvRGfhVdkv4qbPNJ5","icon-check":"v8UMHn9Oo3UTBjIcpc4oa","icon-close":"_2DEnsBLfjKCNcFA8ovPIUD","icon-warning":"_3k5YaRNTDR9xmly_hxfiXh","icon-back":"_1lyRGRDk91TkMl4i2FKkg8","icon-order-down":"_2N-7qR8HpfJliojmEuLZmz","icon-order-up":"FRgV5tpG5cbj-w-wWg4Eb","icon-menu":"_3Oc458A6xONq_PCcOrugHO","icon-delete":"_2Gwb7yfcdJNz-PuzbxarrD","icon-more-vert":"EfPJyjl-Df_W0A1DM5oGX","icon-more-horiz":"wbh1rWeqYKT4LG5wIR6q1","icon-play":"Wqzdhev2emuq9d8B86FCq","icon-pause":"_35R7N-CwoAkARMkM5iXAeI","icon-exit":"_39NN5G-tRyJPag2DTtW3d3","icon-users":"pqvJQzXWOWTdmAQQnz1k2","icon-user":"_13n-Uin0nSh1ntXe_9lX--","icon-playlist":"_3169qZIB3BnUiT4a_oTnhY","icon-forward":"_3S7pK0GC8Ko7_ErEEQr36S","icon-stats-bars":"_1e8A7UEoM90q1y_Iq_xG_c","icon-bug":"_39Vj3wYpEQIJt1NQXSN04V","icon-users-folder":"qUrurXmfBdN_WI4AJzNTa","listItem":"_2xeMEaTMor4dwL0t_E2Oxi","thumb":"_3howO_yn8y1NlMY85AWZqC","description":"_1DX_5nb6F6823qvcq9iib4","title":"_26LAZ5d5LmVdRe1e2bnTog","index":"_1Zq-b6Qs1tY9qF8moGa1dM","checkbox":"_23fFUXU2niCcDS66jrCml9"};

/***/ }),
/* 632 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"selectAllContainer":"BPRHV2uKaqE0WDpXKw3Gk","partHeaderContainer":"_2aVZa73I_phvJVSBN2a8gw","partHeader":"_3JvDKSkitbhyO0er0D3L96","checkboxCell":"_1-uYC3thbt1OghJnF0Gh0d"};

/***/ }),
/* 633 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"section":"_3rhxgX1a_GG0JD2SR_7GWF"};

/***/ }),
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _projects = __webpack_require__(28);
	
	var _utils = __webpack_require__(24);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _AudioPlayer = __webpack_require__(135);
	
	var _AudioPlayer2 = _interopRequireDefault(_AudioPlayer);
	
	var _downloads = __webpack_require__(262);
	
	var _config = __webpack_require__(41);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var AlbumItem = (_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(AlbumItem, _Component);
	
	  function AlbumItem() {
	    (0, _classCallCheck3.default)(this, AlbumItem);
	    return (0, _possibleConstructorReturn3.default)(this, (AlbumItem.__proto__ || (0, _getPrototypeOf2.default)(AlbumItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AlbumItem, [{
	    key: 'gotoAlbum',
	    value: function gotoAlbum(e) {
	      var contentKey = this.props.album.contentKey;
	
	      (0, _utils.stopEvent)(e);
	      this.context.push('/playlists/fromkey/' + contentKey);
	    }
	  }, {
	    key: 'isPlayingState',
	    value: function isPlayingState() {
	      var _props = this.props,
	          playerStatus = _props.playerStatus,
	          playerAlbum = _props.playerAlbum,
	          album = _props.album;
	
	      return playerStatus === _AudioPlayer2.default.status.play && playerAlbum.recipient_id === album.recipient_id;
	    }
	  }, {
	    key: 'playPause',
	    value: function playPause(e) {
	      var _props2 = this.props,
	          album = _props2.album,
	          playAlbum = _props2.playAlbum,
	          tracks = _props2.tracks;
	      var t = this.context.t;
	
	
	      if (album.audiovideo === _projects.projectTypes.video) {
	        return false;
	      }
	
	      if (this.isPlayingState()) {
	        (0, _utils.stopEvent)(e);
	      }
	      var albumTracks = tracks[album.project_id] || [];
	      if (albumTracks.length) {
	        playAlbum({ album: album, tracks: albumTracks });
	      } else {
	        _toastr2.default.error(t('No tracks'));
	      }
	    }
	  }, {
	    key: 'downloadPress',
	    value: function downloadPress() {
	      var _props3 = this.props,
	          pressLoading = _props3.pressLoading,
	          loadPress = _props3.loadPress,
	          album = _props3.album;
	      var t = this.context.t;
	
	
	      if (pressLoading) {
	        return _toastr2.default.info(t('Downloading is in progress'));
	      }
	
	      loadPress({ key: album.contentKey }).promise.then(function (resp) {
	        var filename = resp.data.filename;
	
	        if (filename) {
	          (0, _downloads.download)('' + _config2.default.app.urlParts.press + filename);
	        }
	      });
	    }
	  }, {
	    key: 'deleteAlbum',
	    value: function deleteAlbum() {
	      var _props4 = this.props,
	          album = _props4.album,
	          deletePlaylist = _props4.deletePlaylist;
	      var t = this.context.t;
	
	      var toastrConfirmOptions = {
	        onOk: function onOk() {
	          return deletePlaylist({ key: album.contentKey });
	        }
	      };
	      _toastr2.default.confirm(t('Are you sure you want to delete this album?'), toastrConfirmOptions);
	    }
	  }]);
	  return AlbumItem;
	}(_react.Component), _class2.propTypes = {
	  album: _propTypes2.default.object,
	  deletePlaylist: _propTypes2.default.func,
	  loadPress: _propTypes2.default.func,
	  playAlbum: _propTypes2.default.func,
	  playerAlbum: _propTypes2.default.object,
	  playerStatus: _propTypes2.default.string,
	  pressLoading: _propTypes2.default.bool,
	  tracks: _propTypes2.default.object
	}, _class2.contextTypes = {
	  push: _propTypes2.default.func,
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  album: {},
	  tracks: {}
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'gotoAlbum', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'gotoAlbum'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isPlayingState', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isPlayingState'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'playPause', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'playPause'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'downloadPress', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'downloadPress'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'deleteAlbum', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'deleteAlbum'), _class.prototype)), _class);
	exports.default = AlbumItem;
	module.exports = exports['default'];

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _ByArtistName = __webpack_require__(817);
	
	var _ByArtistName2 = _interopRequireDefault(_ByArtistName);
	
	var _TextLine = __webpack_require__(855);
	
	var _TextLine2 = _interopRequireDefault(_TextLine);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1239);
	
	var AlbumItemInfo = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(AlbumItemInfo, _PureComponent);
	
	  function AlbumItemInfo() {
	    (0, _classCallCheck3.default)(this, AlbumItemInfo);
	    return (0, _possibleConstructorReturn3.default)(this, (AlbumItemInfo.__proto__ || (0, _getPrototypeOf2.default)(AlbumItemInfo)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AlbumItemInfo, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          album = _props.album,
	          overflow = _props.overflow,
	          artistClass = _props.artistClass;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(styles.info, className) },
	        _react2.default.createElement(
	          _TextLine2.default,
	          { className: styles.albumName, overflow: overflow },
	          album.albumName
	        ),
	        _react2.default.createElement(
	          _TextLine2.default,
	          { className: (0, _bind2.default)(styles.artistName, artistClass), title: album.artist_name, overflow: overflow },
	          _react2.default.createElement(_ByArtistName2.default, { artistName: album.artist_name })
	        )
	      );
	    }
	  }]);
	  return AlbumItemInfo;
	}(_react.PureComponent), _class.propTypes = {
	  album: _propTypes2.default.object,
	  artistClass: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  overflow: _propTypes2.default.bool
	}, _class.defaultProps = {
	  album: {}
	}, _temp);
	exports.default = AlbumItemInfo;
	module.exports = exports['default'];

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _FromLabel = __webpack_require__(825);
	
	var _FromLabel2 = _interopRequireDefault(_FromLabel);
	
	var _TextLine = __webpack_require__(855);
	
	var _TextLine2 = _interopRequireDefault(_TextLine);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1240);
	
	var cn = _bind2.default.bind(styles);
	
	var AlbumItemSystemInfo = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(AlbumItemSystemInfo, _PureComponent);
	
	  function AlbumItemSystemInfo() {
	    (0, _classCallCheck3.default)(this, AlbumItemSystemInfo);
	    return (0, _possibleConstructorReturn3.default)(this, (AlbumItemSystemInfo.__proto__ || (0, _getPrototypeOf2.default)(AlbumItemSystemInfo)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AlbumItemSystemInfo, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          album = _props.album,
	          coloredInfo = _props.coloredInfo,
	          overflow = _props.overflow;
	      var t = this.context.t;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(styles.info, className) },
	        _react2.default.createElement(
	          _TextLine2.default,
	          { overflow: overflow },
	          album.sender
	        ),
	        _react2.default.createElement(
	          _TextLine2.default,
	          { title: album.labelName, overflow: overflow },
	          _react2.default.createElement(_FromLabel2.default, { labelName: album.labelName })
	        ),
	        _react2.default.createElement(
	          _TextLine2.default,
	          {
	            className: cn({ coloredInfo: coloredInfo }),
	            overflow: overflow,
	            title: t('Sent date') + ': ' + album.fullSentDate
	          },
	          t('Sent'),
	          ': ',
	          album.shortSentDate
	        ),
	        _react2.default.createElement(
	          _TextLine2.default,
	          {
	            className: styles.expireDate,
	            overflow: overflow,
	            title: t('Expiry date') + ': ' + album.expiryDateText
	          },
	          t('Exp'),
	          ': ',
	          album.expiryDateText
	        )
	      );
	    }
	  }]);
	  return AlbumItemSystemInfo;
	}(_react.PureComponent), _class.propTypes = {
	  album: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  coloredInfo: _propTypes2.default.bool,
	  overflow: _propTypes2.default.bool
	}, _class.defaultProps = {
	  album: {}
	}, _class.contextTypes = {
	  t: _propTypes2.default.func
	}, _temp);
	exports.default = AlbumItemSystemInfo;
	module.exports = exports['default'];

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Albums = __webpack_require__(525);
	
	var _Thumb = __webpack_require__(259);
	
	var _Thumb2 = _interopRequireDefault(_Thumb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlbumItemThumb = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(AlbumItemThumb, _PureComponent);
	
	  function AlbumItemThumb() {
	    (0, _classCallCheck3.default)(this, AlbumItemThumb);
	    return (0, _possibleConstructorReturn3.default)(this, (AlbumItemThumb.__proto__ || (0, _getPrototypeOf2.default)(AlbumItemThumb)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AlbumItemThumb, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          album = _props.album;
	
	
	      return _react2.default.createElement(_Thumb2.default, { fileName: album.imageThumb, className: className, defaultImageName: (0, _Albums.getDefaultImageName)(album) });
	    }
	  }]);
	  return AlbumItemThumb;
	}(_react.PureComponent), _class.propTypes = {
	  album: _propTypes2.default.object,
	  className: _propTypes2.default.string
	}, _class.defaultProps = {
	  album: {}
	}, _temp);
	exports.default = AlbumItemThumb;
	module.exports = exports['default'];

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _projects = __webpack_require__(28);
	
	var _AlbumItemPopover = __webpack_require__(1945);
	
	var _AlbumItemPopover2 = _interopRequireDefault(_AlbumItemPopover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1242);
	
	var AlbumMenuButton = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(AlbumMenuButton, _PureComponent);
	
	  function AlbumMenuButton() {
	    (0, _classCallCheck3.default)(this, AlbumMenuButton);
	    return (0, _possibleConstructorReturn3.default)(this, (AlbumMenuButton.__proto__ || (0, _getPrototypeOf2.default)(AlbumMenuButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AlbumMenuButton, [{
	    key: 'bindPopover',
	    value: function bindPopover(el) {
	      this.popover = el;
	    }
	  }, {
	    key: 'togglePopover',
	    value: function togglePopover(e) {
	      this.popover.toggle(e);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          album = _props.album,
	          className = _props.className,
	          iconClass = _props.iconClass,
	          onPlay = _props.onPlay,
	          onDownloadPress = _props.onDownloadPress,
	          onDelete = _props.onDelete;
	
	
	      return _react2.default.createElement(
	        'button',
	        { className: (0, _bind2.default)(styles.menuButton, className), onClick: this.togglePopover },
	        _react2.default.createElement('i', { className: (0, _bind2.default)(styles.moreDots, iconClass) }),
	        _react2.default.createElement(_AlbumItemPopover2.default, {
	          id: 'albumPopover_' + album.project_id + '_' + album.recipient_id,
	          onInit: this.bindPopover,
	          onPlay: onPlay,
	          onDownloadPress: onDownloadPress,
	          onDelete: onDelete,
	          hidePlay: album.audiovideo === _projects.projectTypes.video,
	          hidePress: !album.isPress
	        })
	      );
	    }
	  }]);
	  return AlbumMenuButton;
	}(_react.PureComponent), _class2.propTypes = {
	  album: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  iconClass: _propTypes2.default.string,
	  onDelete: _propTypes2.default.func,
	  onDownloadPress: _propTypes2.default.func,
	  onPlay: _propTypes2.default.func
	}, _class2.defaultProps = {
	  album: {},
	  onDelete: _noop3.default,
	  onDownloadPress: _noop3.default,
	  onPlay: _noop3.default
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'bindPopover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'bindPopover'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'togglePopover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'togglePopover'), _class.prototype)), _class);
	exports.default = AlbumMenuButton;
	module.exports = exports['default'];

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _AudioPlayer = __webpack_require__(135);
	
	var _AudioPlayer2 = _interopRequireDefault(_AudioPlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var AlbumPlayPauseButton = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    playerAlbum: state.audioplayer.album,
	    playerStatus: state.audioplayer.playerStatus
	  };
	}), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(AlbumPlayPauseButton, _Component);
	
	  function AlbumPlayPauseButton() {
	    (0, _classCallCheck3.default)(this, AlbumPlayPauseButton);
	    return (0, _possibleConstructorReturn3.default)(this, (AlbumPlayPauseButton.__proto__ || (0, _getPrototypeOf2.default)(AlbumPlayPauseButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AlbumPlayPauseButton, [{
	    key: 'onClick',
	    value: function onClick(e) {
	      this.props.onClick(e);
	    }
	  }, {
	    key: 'getPlayPauseIconName',
	    value: function getPlayPauseIconName() {
	      return this.isPlayingState() ? 'icon-pause' : 'icon-play';
	    }
	  }, {
	    key: 'isPlayingState',
	    value: function isPlayingState() {
	      var _props = this.props,
	          playerStatus = _props.playerStatus,
	          playerAlbum = _props.playerAlbum,
	          album = _props.album;
	
	      return playerStatus === _AudioPlayer2.default.status.play && playerAlbum.recipient_id === album.recipient_id;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var playerIconClass = this.getPlayPauseIconName();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'actionButton', onClick: this.onClick },
	        _react2.default.createElement('i', { className: playerIconClass })
	      );
	    }
	  }]);
	  return AlbumPlayPauseButton;
	}(_react.Component), _class3.propTypes = {
	  album: _propTypes2.default.object,
	  onClick: _propTypes2.default.func,
	  playerAlbum: _propTypes2.default.object,
	  playerStatus: _propTypes2.default.string
	}, _class3.defaultProps = {
	  album: {},
	  onClick: _noop3.default
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onClick'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'getPlayPauseIconName', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'getPlayPauseIconName'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isPlayingState', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isPlayingState'), _class2.prototype)), _class2)) || _class);
	exports.default = AlbumPlayPauseButton;
	module.exports = exports['default'];

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _validation = __webpack_require__(157);
	
	var _formValidation = __webpack_require__(263);
	
	var _formValidation2 = _interopRequireDefault(_formValidation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = (0, _validation.createValidator)({
	  email: _formValidation2.default.email,
	  password: _formValidation2.default.password,
	  repassword: _formValidation2.default.password
	});
	
	exports.default = validate;
	module.exports = exports['default'];

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ByArtistName = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(ByArtistName, _PureComponent);
	
	  function ByArtistName() {
	    (0, _classCallCheck3.default)(this, ByArtistName);
	    return (0, _possibleConstructorReturn3.default)(this, (ByArtistName.__proto__ || (0, _getPrototypeOf2.default)(ByArtistName)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ByArtistName, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          artistName = _props.artistName;
	      var t = this.context.t;
	
	
	      if (!artistName) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'span',
	        { className: className },
	        t('by {{artistName}}', { artistName: artistName })
	      );
	    }
	  }]);
	  return ByArtistName;
	}(_react.PureComponent), _class.propTypes = {
	  artistName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  className: _propTypes2.default.string
	}, _class.contextTypes = {
	  t: _propTypes2.default.func
	}, _temp);
	exports.default = ByArtistName;
	module.exports = exports['default'];

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1253);
	
	var CheckedCount = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(CheckedCount, _PureComponent);
	
	  function CheckedCount() {
	    (0, _classCallCheck3.default)(this, CheckedCount);
	    return (0, _possibleConstructorReturn3.default)(this, (CheckedCount.__proto__ || (0, _getPrototypeOf2.default)(CheckedCount)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CheckedCount, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          checkedCount = _props.checkedCount,
	          t = _props.t,
	          buttonClass = _props.buttonClass,
	          onClear = _props.onClear,
	          title = _props.title;
	
	      var displayedTitle = title || t('Clear selection');
	
	      if (!checkedCount) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        t('Checked'),
	        ': ',
	        checkedCount,
	        _react2.default.createElement('i', {
	          className: (0, _bind2.default)(buttonClass, styles.clearIcon),
	          onClick: onClear,
	          title: displayedTitle
	        })
	      );
	    }
	  }]);
	  return CheckedCount;
	}(_react.PureComponent), _class2.propTypes = {
	  buttonClass: _propTypes2.default.string,
	  checkedCount: _propTypes2.default.number,
	  className: _propTypes2.default.string,
	  onClear: _propTypes2.default.func,
	  t: _propTypes2.default.func,
	  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node])
	}, _class2.defaultProps = {
	  onClear: _noop3.default
	}, _temp)) || _class);
	exports.default = CheckedCount;
	module.exports = exports['default'];

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _debounce2 = __webpack_require__(317);
	
	var _debounce3 = _interopRequireDefault(_debounce2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1254);
	
	var ClearableInput = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(ClearableInput, _PureComponent);
	
	  function ClearableInput() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, ClearableInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClearableInput.__proto__ || (0, _getPrototypeOf2.default)(ClearableInput)).call.apply(_ref, [this].concat(args)));
	
	    _this.delayedOnChange = (0, _debounce3.default)(_this.props.onChange, 300);
	
	    _this.state = { kw: _this.props.kw };
	    return _this;
	  }
	
	  (0, _createClass3.default)(ClearableInput, [{
	    key: 'onChange',
	    value: function onChange(e) {
	      this.setKw(e.target.value);
	    }
	  }, {
	    key: 'setKw',
	    value: function setKw(kw) {
	      var _props = this.props,
	          delay = _props.delay,
	          onChange = _props.onChange;
	
	      this.setState({ kw: kw });
	      if (!kw) {
	        this.delayedOnChange.cancel();
	        return setTimeout(function () {
	          return onChange(kw);
	        }, 0);
	      }
	      return delay ? this.delayedOnChange(kw) : onChange(kw);
	    }
	  }, {
	    key: 'clearFilter',
	    value: function clearFilter() {
	      this.setKw('');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          inputProps = _props2.inputProps,
	          inputClassName = _props2.inputClassName,
	          title = _props2.title,
	          showLabel = _props2.showLabel;
	      var kw = this.state.kw;
	
	      var type = inputProps.type || 'text';
	      var isShowLabel = showLabel && title;
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.container },
	        isShowLabel && _react2.default.createElement(
	          'span',
	          { className: styles.title },
	          title,
	          ':'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: styles.inputContainer },
	          _react2.default.createElement('input', (0, _extends3.default)({}, inputProps, {
	            type: type,
	            value: kw,
	            onChange: this.onChange,
	            placeholder: title,
	            className: (0, _bind2.default)(inputClassName)
	          })),
	          _react2.default.createElement('i', { className: 'icon-close', onClick: this.clearFilter })
	        )
	      );
	    }
	  }]);
	  return ClearableInput;
	}(_react.PureComponent), _class2.propTypes = {
	  delay: _propTypes2.default.number,
	  inputClassName: _propTypes2.default.string,
	  inputProps: _propTypes2.default.object,
	  kw: _propTypes2.default.string,
	  onChange: _propTypes2.default.func,
	  showLabel: _propTypes2.default.bool,
	  title: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string])
	}, _class2.defaultProps = {
	  delay: 0,
	  inputProps: {},
	  kw: '',
	  onChange: _noop3.default
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onChange', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onChange'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'clearFilter', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'clearFilter'), _class.prototype)), _class);
	exports.default = ClearableInput;
	module.exports = exports['default'];

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var assetsIcons = exports.assetsIcons = {
	  dropbox: __webpack_require__(269),
	  boxcom: __webpack_require__(268),
	  desktop: __webpack_require__(363)
	};

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keyCodes = __webpack_require__(870);
	
	var _keyCodes2 = _interopRequireDefault(_keyCodes);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1263);
	
	var EditableField = (_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(EditableField, _Component);
	
	  function EditableField() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, EditableField);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = EditableField.__proto__ || (0, _getPrototypeOf2.default)(EditableField)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { isEdited: false, newValue: _this.props.value };
	    return _this;
	  }
	
	  (0, _createClass3.default)(EditableField, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== this.props.value) {
	        this.setState({ newValue: nextProps.value });
	      }
	    }
	  }, {
	    key: 'onSave',
	    value: function onSave() {
	      var onSave = this.props.onSave;
	      var newValue = this.state.newValue;
	
	      this.setState({ isEdited: false });
	      onSave(newValue);
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      if (e.which === _keyCodes2.default.cancel) {
	        this.setState({ isEdited: false, newValue: this.props.value });
	      } else {
	        this.setState({ newValue: e.target.value });
	        if (e.which === _keyCodes2.default.enter) {
	          this.onSave();
	        }
	      }
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur() {
	      if (this.props.saveOnBlur) {
	        this.onSave();
	      }
	    }
	  }, {
	    key: 'edit',
	    value: function edit() {
	      this.setState({ isEdited: true });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          iconClass = _props.iconClass,
	          textClass = _props.textClass,
	          inputClass = _props.inputClass,
	          value = _props.value,
	          okIconClass = _props.okIconClass,
	          containerClass = _props.containerClass,
	          loading = _props.loading,
	          inputProps = _props.inputProps,
	          type = _props.type;
	      var _state = this.state,
	          isEdited = _state.isEdited,
	          newValue = _state.newValue;
	
	      var inputType = type || (typeof value === 'number' ? 'number' : 'text');
	
	      if (isEdited) {
	        return _react2.default.createElement(
	          'div',
	          { className: className },
	          _react2.default.createElement(
	            'span',
	            { className: (0, _classnames2.default)(styles.inputContainer, containerClass) },
	            _react2.default.createElement('input', (0, _extends3.default)({
	              type: inputType,
	              value: newValue,
	              onChange: this.onChange,
	              className: inputClass,
	              autoFocus: true,
	              onKeyDown: this.onChange,
	              onBlur: this.onBlur
	            }, inputProps)),
	            _react2.default.createElement('i', { className: (0, _classnames2.default)(okIconClass, styles.okIcon), onClick: this.onSave })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        _react2.default.createElement(
	          'span',
	          { className: textClass },
	          value
	        ),
	        _react2.default.createElement(_Button2.default, { className: (0, _classnames2.default)(styles.editIcon, iconClass), onClick: this.edit, loading: loading, small: true })
	      );
	    }
	  }]);
	  return EditableField;
	}(_react.Component), _class2.propTypes = {
	  className: _propTypes2.default.string,
	  containerClass: _propTypes2.default.string,
	  iconClass: _propTypes2.default.string,
	  inputClass: _propTypes2.default.string,
	  inputProps: _propTypes2.default.object,
	  loading: _propTypes2.default.bool,
	  okIconClass: _propTypes2.default.string,
	  onSave: _propTypes2.default.func,
	  saveOnBlur: _propTypes2.default.bool,
	  textClass: _propTypes2.default.string,
	  type: _propTypes2.default.string,
	  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	}, _class2.defaultProps = {
	  inputProps: {},
	  okIconClass: 'icon-check',
	  onSave: _noop3.default,
	  saveOnBlur: true
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onSave', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onSave'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onChange', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onChange'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onBlur', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onBlur'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'edit', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'edit'), _class.prototype)), _class);
	exports.default = EditableField;
	module.exports = exports['default'];

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1264);
	
	var ExpiryDate = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(ExpiryDate, _PureComponent);
	
	  function ExpiryDate() {
	    (0, _classCallCheck3.default)(this, ExpiryDate);
	    return (0, _possibleConstructorReturn3.default)(this, (ExpiryDate.__proto__ || (0, _getPrototypeOf2.default)(ExpiryDate)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ExpiryDate, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          dateText = _props.dateText,
	          isExpired = _props.isExpired;
	
	
	      return _react2.default.createElement(
	        'span',
	        { className: (0, _bind2.default)(styles.date, className, (0, _defineProperty3.default)({}, styles.isExpired, isExpired)) },
	        dateText
	      );
	    }
	  }]);
	  return ExpiryDate;
	}(_react.PureComponent), _class.propTypes = {
	  className: _propTypes2.default.string,
	  dateText: _propTypes2.default.string,
	  isExpired: _propTypes2.default.bool
	}, _class.defaultProps = {
	  isExpired: false
	}, _temp);
	exports.default = ExpiryDate;
	module.exports = exports['default'];

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _slicedToArray2 = __webpack_require__(78);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(72);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(58);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClientSideComponent = __webpack_require__(30);
	
	var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);
	
	var _components = __webpack_require__(15);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var ButtonUploader = (_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(ButtonUploader, _Component);
	
	  function ButtonUploader() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, ButtonUploader);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = ButtonUploader.__proto__ || (0, _getPrototypeOf2.default)(ButtonUploader)).call.apply(_ref, [this].concat(args)));
	
	    _this._uploaderOnComplete = function () {
	      _this.setState({ loading: false });
	    };
	
	    _this._uploaderOnUpload = function () {
	      _this.setState({ loading: true });
	    };
	
	    _this._setUploaderCallbacks = function (isOn) {
	      var callbacks = _this.props.callbacks;
	
	      (0, _entries2.default)(callbacks).map(function (_ref2) {
	        var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
	            cbName = _ref3[0],
	            cb = _ref3[1];
	
	        _this.uploader[isOn ? 'on' : 'off'](cbName, cb);
	      });
	    };
	
	    _this.state = { loading: false };
	    return _this;
	  }
	
	  (0, _createClass3.default)(ButtonUploader, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _get3.default)(ButtonUploader.prototype.__proto__ || (0, _getPrototypeOf2.default)(ButtonUploader.prototype), 'componentDidMount', this).call(this, this._mountUploader);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      (0, _get3.default)(ButtonUploader.prototype.__proto__ || (0, _getPrototypeOf2.default)(ButtonUploader.prototype), 'componentWillUnmount', this).call(this, this._unMountUploader);
	    }
	  }, {
	    key: '_mountUploader',
	    value: function _mountUploader() {
	      var FineUploaderTraditional = __webpack_require__(257);
	      var uploaderParams = this.props.uploaderParams;
	
	
	      this.uploader = new FineUploaderTraditional({
	        request: { params: uploaderParams.queryParams },
	        // request: {params: {...uploaderParams.queryParams, qquuid: '685ba435-321a-4439-a370-440e965e8a68'}, uuidName: 'uuid'},
	        chunking: { success: { endpoint: uploaderParams.endpoint } }
	      });
	
	      this.uploader.on('complete', this._uploaderOnComplete);
	      this.uploader.on('upload', this._uploaderOnUpload);
	      this._setUploaderCallbacks(true);
	    }
	  }, {
	    key: '_unMountUploader',
	    value: function _unMountUploader() {
	      if (!this.uploader) {
	        return null;
	      }
	      this.uploader.off('complete', this._uploaderOnComplete);
	      this.uploader.off('upload', this._uploaderOnUpload);
	      this._setUploaderCallbacks(false);
	      this.uploader.methods.cancelAll();
	      this.uploader = null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isMounted = _state.isMounted,
	          loading = _state.loading;
	      var _props = this.props,
	          label = _props.label,
	          accept = _props.accept,
	          multiple = _props.multiple,
	          buttonClass = _props.buttonClass; // eslint-disable-line no-unused-vars
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'inline-block' },
	        isMounted && _react2.default.createElement(
	          'span',
	          null,
	          loading ? _react2.default.createElement(_components.Loader, null) : _react2.default.createElement(
	            _components.FileInput,
	            { uploader: this.uploader, accept: accept, multiple: multiple },
	            _react2.default.createElement(
	              'span',
	              { className: 'btn ' + (buttonClass || 'btn-default') },
	              label
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return ButtonUploader;
	}(_ClientSideComponent2.default), _class2.propTypes = {
	  accept: _propTypes2.default.string,
	  buttonClass: _propTypes2.default.string,
	  callbacks: _propTypes2.default.object,
	  label: _propTypes2.default.string,
	  multiple: _propTypes2.default.bool,
	  uploaderParams: _propTypes2.default.object.isRequired
	}, _class2.defaultProps = {
	  multiple: false,
	  callbacks: {}
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, '_mountUploader', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_mountUploader'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_unMountUploader', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_unMountUploader'), _class.prototype)), _class);
	exports.default = ButtonUploader;
	module.exports = exports['default'];

/***/ }),
/* 824 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var thenable = exports.thenable = ['onCancel', 'onPasteReceived', 'onSubmit', 'onSubmitDelete', 'onValidate', 'onValidateBatch'];
	
	var traditional = exports.traditional = ['onAutoRetry', 'onCancel', 'onComplete', 'onAllComplete', 'onDelete', 'onDeleteComplete', 'onError', 'onManualRetry', 'onPasteReceived', 'onProgress', 'onResume', 'onSessionRequestComplete', 'onStatusChange', 'onSubmit', 'onSubmitDelete', 'onSubmitted', 'onTotalProgress', 'onUpload', 'onUploadChunk', 'onUploadChunkSuccess', 'onValidate', 'onValidateBatch'];

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FromLabel = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(FromLabel, _PureComponent);
	
	  function FromLabel() {
	    (0, _classCallCheck3.default)(this, FromLabel);
	    return (0, _possibleConstructorReturn3.default)(this, (FromLabel.__proto__ || (0, _getPrototypeOf2.default)(FromLabel)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(FromLabel, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          labelName = _props.labelName;
	      var t = this.context.t;
	
	
	      if (!labelName) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'span',
	        { className: className },
	        t('from {{labelName}}', { labelName: labelName })
	      );
	    }
	  }]);
	  return FromLabel;
	}(_react.PureComponent), _class.propTypes = {
	  className: _propTypes2.default.string,
	  labelName: _propTypes2.default.string
	}, _class.contextTypes = {
	  t: _propTypes2.default.func
	}, _temp);
	exports.default = FromLabel;
	module.exports = exports['default'];

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ga = __webpack_require__(2013);
	
	var _ga2 = _interopRequireDefault(_ga);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ga2.default;
	module.exports = exports['default'];

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _ButtonUploader = __webpack_require__(823);
	
	var _ButtonUploader2 = _interopRequireDefault(_ButtonUploader);
	
	var _responseCodes = __webpack_require__(99);
	
	var _responseCodes2 = _interopRequireDefault(_responseCodes);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _log = __webpack_require__(267);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _RecipientsImportReport = __webpack_require__(2201);
	
	var _RecipientsImportReport2 = _interopRequireDefault(_RecipientsImportReport);
	
	var _Modal = __webpack_require__(212);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _RecipientsImportsErrors = __webpack_require__(2093);
	
	var _RecipientsImportsErrors2 = _interopRequireDefault(_RecipientsImportsErrors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1274);
	
	var TAG = 'ImportRecipientsCSVButton';
	
	var ImportRecipientsCSVButton = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(ImportRecipientsCSVButton, _PureComponent);
	
	  function ImportRecipientsCSVButton() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, ImportRecipientsCSVButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = ImportRecipientsCSVButton.__proto__ || (0, _getPrototypeOf2.default)(ImportRecipientsCSVButton)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { importData: null, importMessage: '', isShowModal: false };
	    return _this;
	  }
	
	  (0, _createClass3.default)(ImportRecipientsCSVButton, [{
	    key: 'onImportRecipientsError',
	    value: function onImportRecipientsError(err) {
	      _log2.default.w(TAG, 'Recipients CSV upload error', err);
	      _toastr2.default.error('Uploading error');
	    }
	  }, {
	    key: 'onImportRecipientsComplete',
	    value: function onImportRecipientsComplete(id, name) {
	      var resp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	      var code = resp.code,
	          data = resp.data;
	      var _context = this.context,
	          t = _context.t,
	          logout = _context.logout;
	
	
	      if (code === _responseCodes2.default.sessionError) {
	        return logout();
	      }
	
	      if (code) {
	        this.setState({ importData: resp.data, importMessage: resp.msg, isShowModal: true });
	      } else {
	        _toastr2.default.success(t('Contacts imported'));
	      }
	
	      if (data) {
	        this.props.onImport({ data: data });
	      }
	    }
	  }, {
	    key: 'hideModal',
	    value: function hideModal() {
	      this.setState({ isShowModal: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          uploaderParams = _props.uploaderParams,
	          buttonClass = _props.buttonClass,
	          label = _props.label;
	      var t = this.context.t;
	      var _state = this.state,
	          importData = _state.importData,
	          importMessage = _state.importMessage,
	          isShowModal = _state.isShowModal;
	
	      var importRecipientsCallbacks = {
	        error: this.onImportRecipientsError,
	        complete: this.onImportRecipientsComplete
	      };
	
	      return _react2.default.createElement(
	        'span',
	        { className: (0, _bind2.default)(styles.container, className) },
	        _react2.default.createElement(_ButtonUploader2.default, {
	          label: label || t('Import'),
	          uploaderParams: uploaderParams,
	          accept: '.csv',
	          multiple: false,
	          buttonClass: buttonClass,
	          callbacks: importRecipientsCallbacks
	        }),
	        _react2.default.createElement(
	          _Modal2.default,
	          {
	            className: styles.modal,
	            show: isShowModal,
	            onHide: this.hideModal,
	            title: t('Contacts import report'),
	            bsSize: 'lg',
	            backdrop: true
	          },
	          _react2.default.createElement(_RecipientsImportsErrors2.default, {
	            data: importData,
	            message: importMessage,
	            className: styles.errors
	          }),
	          _react2.default.createElement(_RecipientsImportReport2.default, {
	            className: styles.report,
	            data: importData
	          })
	        )
	      );
	    }
	  }]);
	  return ImportRecipientsCSVButton;
	}(_react.PureComponent), _class2.propTypes = {
	  buttonClass: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  label: _propTypes2.default.string,
	  onImport: _propTypes2.default.func,
	  uploaderParams: _propTypes2.default.object
	}, _class2.contextTypes = {
	  logout: _propTypes2.default.func,
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  buttonClass: 'btn-primary',
	  onImport: _noop3.default,
	  uploaderParams: {}
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onImportRecipientsError', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onImportRecipientsError'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onImportRecipientsComplete', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onImportRecipientsComplete'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'hideModal', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'hideModal'), _class.prototype)), _class);
	exports.default = ImportRecipientsCSVButton;
	module.exports = exports['default'];

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactI18next = __webpack_require__(12);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _MyPlaylistsSelectPopup = __webpack_require__(2033);
	
	var _MyPlaylistsSelectPopup2 = _interopRequireDefault(_MyPlaylistsSelectPopup);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _myPlaylists = __webpack_require__(88);
	
	var myPlaylistsActions = _interopRequireWildcard(_myPlaylists);
	
	var _utils = __webpack_require__(24);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1283);
	
	var MyPlaylistsAddIcon = (_dec = (0, _reactRedux.connect)(null, (0, _extends3.default)({}, myPlaylistsActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(MyPlaylistsAddIcon, _Component);
	
	  function MyPlaylistsAddIcon() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, MyPlaylistsAddIcon);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = MyPlaylistsAddIcon.__proto__ || (0, _getPrototypeOf2.default)(MyPlaylistsAddIcon)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { showPopup: false };
	    return _this;
	  }
	
	  (0, _createClass3.default)(MyPlaylistsAddIcon, [{
	    key: 'onSave',
	    value: function onSave() {
	      var guids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var _props = this.props,
	          track = _props.track,
	          addMyPlaylistTracks = _props.addMyPlaylistTracks;
	
	      if (guids.length) {
	        return addMyPlaylistTracks({ guids: guids, tracksId: [track.id] }).promise;
	      }
	      return null;
	    }
	  }, {
	    key: 'getDefaultIcon',
	    value: function getDefaultIcon() {
	      var _props2 = this.props,
	          t = _props2.t,
	          iconClass = _props2.iconClass;
	
	      return _react2.default.createElement('i', {
	        title: t('Add to playlist'),
	        className: (0, _classnames2.default)(styles.icon, iconClass),
	        onClick: this.showPopup
	      });
	    }
	  }, {
	    key: 'showPopup',
	    value: function showPopup(e) {
	      (0, _utils.stopEvent)(e);
	      this.setState({ showPopup: true });
	    }
	  }, {
	    key: 'hidePopup',
	    value: function hidePopup() {
	      this.setState({ showPopup: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var icon = this.props.icon;
	      var showPopup = this.state.showPopup;
	
	      var iconEl = icon || this.getDefaultIcon();
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        iconEl,
	        _react2.default.createElement(_MyPlaylistsSelectPopup2.default, {
	          show: showPopup,
	          onHide: this.hidePopup,
	          onSave: this.onSave
	        })
	      );
	    }
	  }]);
	  return MyPlaylistsAddIcon;
	}(_react.Component), _class3.propTypes = {
	  addMyPlaylistTracks: _propTypes2.default.func,
	  icon: _propTypes2.default.node,
	  iconClass: _propTypes2.default.string,
	  t: _propTypes2.default.func,
	  track: _propTypes2.default.object
	}, _class3.defaultProps = {
	  track: {}
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onSave', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSave'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'showPopup', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'showPopup'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'hidePopup', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'hidePopup'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = MyPlaylistsAddIcon;
	module.exports = exports['default'];

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _playlist = __webpack_require__(217);
	
	var _reactI18next = __webpack_require__(12);
	
	var _reduxForm = __webpack_require__(50);
	
	var _formComponents = __webpack_require__(71);
	
	var _components = __webpack_require__(15);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1287);
	
	var FeedbackForm = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    sendFeedbackLoaded: state.playlist.sendFeedbackLoaded,
	    sendFeedbackActionData: state.playlist.sendFeedbackActionData
	  };
	}, { sendFeedback: _playlist.sendFeedback }), _dec2 = (0, _reduxForm.reduxForm)({
	  form: 'feedbackForm',
	  propNamespace: 'feedbackForm',
	  initialValues: { feedbackText: '' }
	}), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(FeedbackForm, _Component);
	
	  function FeedbackForm() {
	    (0, _classCallCheck3.default)(this, FeedbackForm);
	    return (0, _possibleConstructorReturn3.default)(this, (FeedbackForm.__proto__ || (0, _getPrototypeOf2.default)(FeedbackForm)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(FeedbackForm, [{
	    key: 'sendFeedback',
	    value: function sendFeedback(formData) {
	      var _props = this.props,
	          contentKey = _props.contentKey,
	          reset = _props.feedbackForm.reset;
	
	
	      var promise = this.props.sendFeedback({ key: contentKey, feedbackText: formData.feedbackText }).promise;
	      promise.then(function () {
	        reset();
	      });
	
	      return promise;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classNames;
	
	      var _props2 = this.props,
	          t = _props2.t,
	          sendFeedbackLoaded = _props2.sendFeedbackLoaded,
	          sendFeedbackActionData = _props2.sendFeedbackActionData,
	          contentKey = _props2.contentKey,
	          sender = _props2.sender,
	          compact = _props2.compact,
	          buttons = _props2.buttons,
	          line = _props2.line,
	          _props2$feedbackForm = _props2.feedbackForm,
	          handleSubmit = _props2$feedbackForm.handleSubmit,
	          submitting = _props2$feedbackForm.submitting,
	          invalid = _props2$feedbackForm.invalid;
	
	
	      return sendFeedbackLoaded && sendFeedbackActionData.key === contentKey ? _react2.default.createElement(
	        'div',
	        { className: 'colorInfo h4' },
	        _react2.default.createElement('i', { className: 'icon-check margin-right-5' }),
	        t('Thank you. Your feedback has been transmitted.')
	      ) : _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', (_classNames = {}, (0, _defineProperty3.default)(_classNames, styles.compact, compact), (0, _defineProperty3.default)(_classNames, styles.line, line), _classNames)) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)({ 'col-sm-15 col-md-20 col-lg-20': !compact }, styles.feedbackHeader) },
	          _react2.default.createElement(
	            'h4',
	            { className: 'margin-top-20' },
	            t('Contact {{username}}', { username: sender }),
	            ':'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)({ 'col-sm-45 col-md-40 col-lg-40': !compact }) },
	          _react2.default.createElement(
	            'form',
	            { className: styles.form, onSubmit: handleSubmit(this.sendFeedback) },
	            _react2.default.createElement(
	              'div',
	              { className: styles.textArea },
	              _react2.default.createElement(_reduxForm.Field, {
	                name: 'feedbackText',
	                type: 'textarea',
	                rows: '4',
	                fieldClassName: 'width-perc-100',
	                placeholder: t('Type your feedback here'),
	                hideLabel: true,
	                component: _formComponents.formSimpleTextInput,
	                required: true
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: styles.buttons },
	              buttons,
	              submitting ? _react2.default.createElement(_components.Loader, null) : _react2.default.createElement(
	                'button',
	                { type: 'submit', className: 'btn btn-default', disabled: submitting || invalid },
	                t('Send')
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return FeedbackForm;
	}(_react.Component), _class3.propTypes = {
	  buttons: _propTypes2.default.node,
	  compact: _propTypes2.default.bool,
	  contentKey: _propTypes2.default.string,
	  feedbackForm: _propTypes2.default.object,
	  line: _propTypes2.default.bool,
	  sender: _propTypes2.default.string.isRequired,
	  sendFeedback: _propTypes2.default.func,
	  sendFeedbackActionData: _propTypes2.default.object,
	  sendFeedbackLoaded: _propTypes2.default.bool,
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'sendFeedback', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'sendFeedback'), _class2.prototype)), _class2)) || _class) || _class) || _class);
	exports.default = FeedbackForm;
	module.exports = exports['default'];

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _projects = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1293);
	var warningImg = __webpack_require__(2288);
	var warningSignImg = __webpack_require__(2287);
	
	var WatermarkWarning = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(WatermarkWarning, _Component);
	
	  function WatermarkWarning() {
	    (0, _classCallCheck3.default)(this, WatermarkWarning);
	    return (0, _possibleConstructorReturn3.default)(this, (WatermarkWarning.__proto__ || (0, _getPrototypeOf2.default)(WatermarkWarning)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(WatermarkWarning, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          t = _props.t,
	          projectType = _props.projectType;
	
	      var useStaticImg = true;
	
	      return useStaticImg ? _react2.default.createElement(
	        'div',
	        { className: className },
	        _react2.default.createElement('img', { src: warningImg, className: (0, _classnames2.default)(styles.warningAnimation, styles.warningImg), alt: '' })
	      ) : _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(styles.warningAnimation, styles.warningContainer, className) },
	        _react2.default.createElement(
	          'div',
	          { className: styles.warnSign },
	          _react2.default.createElement('img', { src: warningSignImg, alt: '' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.text },
	          _react2.default.createElement(
	            'div',
	            { className: styles.header },
	            t('Warning')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: styles.subheader },
	            projectType === _projects.projectTypes.video ? t('This video is watermarked') : t('This audio is watermarked')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: styles.hint },
	            t('Copying, distribution and making available or communicating to the public is strictly prohibited')
	          )
	        )
	      );
	    }
	  }]);
	  return WatermarkWarning;
	}(_react.Component), _class2.propTypes = {
	  className: _propTypes2.default.string,
	  projectType: _propTypes2.default.string.isRequired,
	  t: _propTypes2.default.func
	}, _temp)) || _class);
	exports.default = WatermarkWarning;
	module.exports = exports['default'];

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _objectWithoutProperties2 = __webpack_require__(21);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _common = __webpack_require__(265);
	
	var commonActions = _interopRequireWildcard(_common);
	
	var _Popover = __webpack_require__(466);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _OverlayTrigger = __webpack_require__(704);
	
	var _OverlayTrigger2 = _interopRequireDefault(_OverlayTrigger);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Popover = (_dec = (0, _reactRedux.connect)(null, (0, _extends3.default)({}, commonActions)), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(Popover, _Component);
	
	  function Popover() {
	    (0, _classCallCheck3.default)(this, Popover);
	    return (0, _possibleConstructorReturn3.default)(this, (Popover.__proto__ || (0, _getPrototypeOf2.default)(Popover)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Popover, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.id = this.props.getId('popover-');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          title = _props.title,
	          overlay = _props.overlay,
	          rest = (0, _objectWithoutProperties3.default)(_props, ['children', 'title', 'overlay']);
	
	
	      return _react2.default.createElement(
	        _OverlayTrigger2.default,
	        (0, _extends3.default)({
	          trigger: ['hover', 'focus'],
	          placement: 'bottom',
	          title: title
	        }, rest, {
	          overlay: _react2.default.createElement(
	            _Popover2.default,
	            { id: this.id },
	            overlay
	          )
	        }),
	        children
	      );
	    }
	  }]);
	  return Popover;
	}(_react.Component), _class2.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  getId: _propTypes2.default.func,
	  overlay: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node])
	}, _temp)) || _class);
	exports.default = Popover;
	module.exports = exports['default'];

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var irefImg = __webpack_require__(2289);
	
	var ProjectIrefImage = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(ProjectIrefImage, _PureComponent);
	
	  function ProjectIrefImage() {
	    (0, _classCallCheck3.default)(this, ProjectIrefImage);
	    return (0, _possibleConstructorReturn3.default)(this, (ProjectIrefImage.__proto__ || (0, _getPrototypeOf2.default)(ProjectIrefImage)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProjectIrefImage, [{
	    key: 'render',
	    value: function render() {
	      var className = this.props.className;
	
	
	      return _react2.default.createElement('img', {
	        className: (0, _bind2.default)(className),
	        src: irefImg,
	        alt: ''
	      });
	    }
	  }]);
	  return ProjectIrefImage;
	}(_react.PureComponent), _class.propTypes = {
	  className: _propTypes2.default.string
	}, _temp);
	exports.default = ProjectIrefImage;
	module.exports = exports['default'];

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _Tooltip = __webpack_require__(522);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _ProjectIrefImage = __webpack_require__(832);
	
	var _ProjectIrefImage2 = _interopRequireDefault(_ProjectIrefImage);
	
	var _utils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectIrefTooltip = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(ProjectIrefTooltip, _PureComponent);
	
	  function ProjectIrefTooltip() {
	    (0, _classCallCheck3.default)(this, ProjectIrefTooltip);
	    return (0, _possibleConstructorReturn3.default)(this, (ProjectIrefTooltip.__proto__ || (0, _getPrototypeOf2.default)(ProjectIrefTooltip)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProjectIrefTooltip, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          iRef = _props.iRef;
	
	
	      if (!iRef) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _Tooltip2.default,
	        {
	          placement: 'top',
	          title: iRef,
	          onClick: _utils.stopEvent
	        },
	        _react2.default.createElement(_ProjectIrefImage2.default, { className: (0, _bind2.default)(className) })
	      );
	    }
	  }]);
	  return ProjectIrefTooltip;
	}(_react.PureComponent), _class.propTypes = {
	  className: _propTypes2.default.string,
	  iRef: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	}, _temp);
	exports.default = ProjectIrefTooltip;
	module.exports = exports['default'];

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _components = __webpack_require__(15);
	
	var _ProjectsListHeader = __webpack_require__(2065);
	
	var _ProjectsListHeader2 = _interopRequireDefault(_ProjectsListHeader);
	
	var _ProjectsListItem = __webpack_require__(2066);
	
	var _ProjectsListItem2 = _interopRequireDefault(_ProjectsListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectList = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(ProjectList, _PureComponent);
	
	  function ProjectList() {
	    (0, _classCallCheck3.default)(this, ProjectList);
	    return (0, _possibleConstructorReturn3.default)(this, (ProjectList.__proto__ || (0, _getPrototypeOf2.default)(ProjectList)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProjectList, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          loading = _props.loading,
	          projects = _props.projects,
	          showTypeColumn = _props.showTypeColumn,
	          showActionsColumn = _props.showActionsColumn,
	          deleteLoaders = _props.deleteLoaders,
	          activeOrder = _props.activeOrder,
	          order = _props.order,
	          userPermissions = _props.userPermissions;
	      var _props2 = this.props,
	          onDelete = _props2.onDelete,
	          onCreateSubproject = _props2.onCreateSubproject,
	          onEdit = _props2.onEdit,
	          onReorder = _props2.onReorder,
	          onClick = _props2.onClick;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _components.List,
	          null,
	          _react2.default.createElement(_ProjectsListHeader2.default, {
	            activeOrder: activeOrder,
	            order: order,
	            onReorder: onReorder,
	            showTypeColumn: showTypeColumn,
	            showActionsColumn: showActionsColumn
	          }),
	          projects.map(function (project) {
	            return _react2.default.createElement(_ProjectsListItem2.default, {
	              key: project.id,
	              project: project,
	              onClick: onClick,
	              onDelete: onDelete,
	              onCreateSubproject: onCreateSubproject,
	              onEdit: onEdit,
	              showTypeColumn: showTypeColumn,
	              showActionsColumn: showActionsColumn,
	              deleteLoaders: deleteLoaders,
	              userPermissions: userPermissions
	            });
	          })
	        ),
	        _react2.default.createElement(_components.Loader, { show: loading, alignCenter: true })
	      );
	    }
	  }]);
	  return ProjectList;
	}(_react.PureComponent), _class.propTypes = {
	  activeOrder: _propTypes2.default.string,
	  deleteLoaders: _propTypes2.default.object,
	  loading: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  onCreateSubproject: _propTypes2.default.func,
	  onDelete: _propTypes2.default.func,
	  onEdit: _propTypes2.default.func,
	  onReorder: _propTypes2.default.func,
	  order: _propTypes2.default.object,
	  projects: _propTypes2.default.array.isRequired,
	  showActionsColumn: _propTypes2.default.bool,
	  showTypeColumn: _propTypes2.default.bool,
	  userPermissions: _propTypes2.default.object
	}, _class.defaultProps = {
	  onCreateSubproject: _noop3.default,
	  onDelete: _noop3.default,
	  onEdit: _noop3.default,
	  onReorder: _noop3.default,
	  projects: [],
	  loading: false,
	  showActionsColumn: false,
	  showTypeColumn: false,
	  userPermissions: {}
	}, _temp);
	exports.default = ProjectList;
	module.exports = exports['default'];

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _regenerator = __webpack_require__(138);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(137);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _get2 = __webpack_require__(19);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(11);
	
	var _project = __webpack_require__(37);
	
	var projectActions = _interopRequireWildcard(_project);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(24);
	
	var _QuickSendForwardPopup = __webpack_require__(2074);
	
	var _QuickSendForwardPopup2 = _interopRequireDefault(_QuickSendForwardPopup);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Loader = __webpack_require__(60);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var QuickSendForwardButton = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    copyProjectActionData: state.project.copyProjectActionData,
	    copyProjectLoading: state.project.copyProjectLoading
	  };
	}, (0, _extends3.default)({}, projectActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(QuickSendForwardButton, _Component);
	
	  function QuickSendForwardButton() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, QuickSendForwardButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = QuickSendForwardButton.__proto__ || (0, _getPrototypeOf2.default)(QuickSendForwardButton)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { showPopup: false };
	    return _this;
	  }
	
	  (0, _createClass3.default)(QuickSendForwardButton, [{
	    key: 'onForward',
	    value: function onForward(data) {
	      this.hidePopup();
	      _toastr2.default.success('Quick Send forwarded');
	      this.props.onForward(data);
	    }
	  }, {
	    key: 'showPopup',
	    value: function showPopup(_ref2) {
	      var id = _ref2.id;
	
	      this.setState({ showPopup: true, id: id });
	    }
	  }, {
	    key: 'hidePopup',
	    value: function hidePopup() {
	      this.setState({ showPopup: false });
	    }
	  }, {
	    key: 'forward',
	    value: function () {
	      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(e) {
	        var _props, copyProject, id, resp, newId;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                (0, _utils.stopEvent)(e);
	                _props = this.props, copyProject = _props.copyProject, id = _props.id;
	                _context.prev = 2;
	                _context.next = 5;
	                return copyProject(id).promise;
	
	              case 5:
	                resp = _context.sent;
	                newId = (0, _get3.default)(resp, 'data.projectId');
	
	                if (newId) {
	                  this.showPopup({ id: newId });
	                }
	                _context.next = 13;
	                break;
	
	              case 10:
	                _context.prev = 10;
	                _context.t0 = _context['catch'](2);
	
	                console.log(_context.t0);
	
	              case 13:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[2, 10]]);
	      }));
	
	      function forward(_x) {
	        return _ref3.apply(this, arguments);
	      }
	
	      return forward;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          iconClass = _props2.iconClass,
	          t = _props2.t,
	          copyProjectLoading = _props2.copyProjectLoading,
	          copyProjectActionData = _props2.copyProjectActionData,
	          data = _props2.data;
	      var _state = this.state,
	          showPopup = _state.showPopup,
	          id = _state.id;
	
	      var isLoading = copyProjectLoading && copyProjectActionData.projectId === this.props.id;
	      var isDisabled = isLoading || !data.projectId;
	
	      return _react2.default.createElement(
	        _Button2.default,
	        {
	          className: (0, _classnames2.default)('btn-text', className),
	          onClick: this.forward,
	          disabled: isDisabled
	        },
	        isLoading ? _react2.default.createElement(_Loader2.default, { size: 14, className: 'margin-right-5' }) : _react2.default.createElement('i', { className: (0, _classnames2.default)('icon-forward', iconClass) }),
	        t('Forward'),
	        _react2.default.createElement(_QuickSendForwardPopup2.default, {
	          id: id,
	          data: data,
	          show: showPopup,
	          onHide: this.hidePopup,
	          onForward: this.onForward
	        })
	      );
	    }
	  }]);
	  return QuickSendForwardButton;
	}(_react.Component), _class3.propTypes = {
	  className: _propTypes2.default.string,
	  copyProject: _propTypes2.default.func,
	  copyProjectActionData: _propTypes2.default.object,
	  copyProjectLoading: _propTypes2.default.bool,
	  data: _propTypes2.default.object,
	  iconClass: _propTypes2.default.string,
	  id: _propTypes2.default.number,
	  onForward: _propTypes2.default.func,
	  t: _propTypes2.default.func
	}, _class3.defaultProps = {
	  copyProjectActionData: {},
	  data: {},
	  id: 0,
	  onForward: _noop3.default
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onForward', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onForward'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'showPopup', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'showPopup'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'hidePopup', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'hidePopup'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'forward', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'forward'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = QuickSendForwardButton;
	module.exports = exports['default'];

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _audioplayer = __webpack_require__(83);
	
	var audioplayerActions = _interopRequireWildcard(_audioplayer);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _AudioPlayer = __webpack_require__(135);
	
	var _AudioPlayer2 = _interopRequireDefault(_AudioPlayer);
	
	var _MyPlaylistsAddIcon = __webpack_require__(828);
	
	var _MyPlaylistsAddIcon2 = _interopRequireDefault(_MyPlaylistsAddIcon);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1307);
	
	var QuickSendTracklist = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    currentTrackIndex: state.audioplayer.currentTrackIndex,
	    humanizedPosition: state.audioplayer.humanizedPosition,
	    playerStatus: state.audioplayer.playerStatus,
	    playerTracks: state.audioplayer.tracks
	  };
	}, (0, _extends3.default)({}, audioplayerActions)), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(QuickSendTracklist, _Component);
	
	  function QuickSendTracklist() {
	    (0, _classCallCheck3.default)(this, QuickSendTracklist);
	    return (0, _possibleConstructorReturn3.default)(this, (QuickSendTracklist.__proto__ || (0, _getPrototypeOf2.default)(QuickSendTracklist)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(QuickSendTracklist, [{
	    key: 'play',
	    value: function play(index) {
	      var _props = this.props,
	          playAlbum = _props.playAlbum,
	          album = _props.album,
	          tracks = _props.tracks;
	
	      playAlbum({ album: album, tracks: tracks, currentTrackIndex: index });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          tracks = _props2.tracks,
	          playerTracks = _props2.playerTracks,
	          currentTrackIndex = _props2.currentTrackIndex,
	          playerStatus = _props2.playerStatus,
	          humanizedPosition = _props2.humanizedPosition,
	          playable = _props2.playable,
	          className = _props2.className;
	
	      var currentTrack = playerTracks[currentTrackIndex] || {};
	      var isPlayState = function isPlayState(id) {
	        return currentTrack.id === id && playerStatus === _AudioPlayer2.default.status.play;
	      };
	      var getPlayPauseClass = function getPlayPauseClass(id) {
	        return (0, _classnames2.default)(styles.playPauseIcon, isPlayState(id) ? 'icon-pause' : 'icon-play');
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(styles.tracklist, (0, _defineProperty3.default)({}, styles.playable, playable), className) },
	        tracks.map(function (track, trackIndex) {
	          return _react2.default.createElement(
	            'div',
	            {
	              key: track.id,
	              className: (0, _classnames2.default)(styles.trackItem, (0, _defineProperty3.default)({}, styles.active, currentTrack.id === track.id)),
	              onClick: function onClick() {
	                return playable && _this2.play(trackIndex);
	              }
	            },
	            _react2.default.createElement(
	              'div',
	              { className: 'table-cell break-word' },
	              trackIndex + 1,
	              ' ',
	              track.trackName
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'table-cell width-perc-1' },
	              currentTrack.id === track.id ? humanizedPosition : track.durationTime
	            ),
	            playable && _react2.default.createElement(
	              'div',
	              { className: styles.addPlaylistCell },
	              _react2.default.createElement(_MyPlaylistsAddIcon2.default, { track: track, iconClass: styles.addPlaylistIcon })
	            ),
	            playable && _react2.default.createElement(
	              'div',
	              { className: 'table-cell width-perc-1' },
	              _react2.default.createElement('i', { className: getPlayPauseClass(track.id) })
	            )
	          );
	        })
	      );
	    }
	  }]);
	  return QuickSendTracklist;
	}(_react.Component), _class2.propTypes = {
	  album: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  currentTrackIndex: _propTypes2.default.number,
	  humanizedPosition: _propTypes2.default.string,
	  playable: _propTypes2.default.bool,
	  playAlbum: _propTypes2.default.func,
	  playerStatus: _propTypes2.default.string,
	  playerTracks: _propTypes2.default.array,
	  tracks: _propTypes2.default.array
	}, _temp)) || _class);
	exports.default = QuickSendTracklist;
	module.exports = exports['default'];

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _CheckboxField = __webpack_require__(523);
	
	var _CheckboxField2 = _interopRequireDefault(_CheckboxField);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DownloadField = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(DownloadField, _Component);
	
	  function DownloadField() {
	    (0, _classCallCheck3.default)(this, DownloadField);
	    return (0, _possibleConstructorReturn3.default)(this, (DownloadField.__proto__ || (0, _getPrototypeOf2.default)(DownloadField)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(DownloadField, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          t = _props.t,
	          className = _props.className;
	
	
	      return _react2.default.createElement(
	        'span',
	        { className: (0, _classnames2.default)('inline-block', className) },
	        _react2.default.createElement(_CheckboxField2.default, {
	          name: 'download',
	          small: true,
	          type: 'checkbox',
	          textBefore: t('Downloads')
	        })
	      );
	    }
	  }]);
	  return DownloadField;
	}(_react.Component), _class2.propTypes = {
	  className: _propTypes2.default.string,
	  t: _propTypes2.default.func
	}, _temp)) || _class);
	exports.default = DownloadField;
	module.exports = exports['default'];

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _project = __webpack_require__(37);
	
	var _AddRecipientRow = __webpack_require__(844);
	
	var _AddRecipientRow2 = _interopRequireDefault(_AddRecipientRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var EmailField = (_dec = (0, _reactRedux.connect)(null, { loadRecipientsList: _project.loadRecipientsList }), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(EmailField, _Component);
	
	  function EmailField() {
	    (0, _classCallCheck3.default)(this, EmailField);
	    return (0, _possibleConstructorReturn3.default)(this, (EmailField.__proto__ || (0, _getPrototypeOf2.default)(EmailField)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(EmailField, [{
	    key: 'onAddGroup',
	    value: function onAddGroup() {
	      var projectId = this.props.projectId;
	
	      this.props.loadRecipientsList(projectId);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var projectId = this.props.projectId;
	
	
	      return _react2.default.createElement(_AddRecipientRow2.default, {
	        projectId: projectId,
	        formRowClassName: 'formRow simple wide',
	        hintClassName: '',
	        withTags: true,
	        onAddGroup: this.onAddGroup,
	        required: true
	      });
	    }
	  }]);
	  return EmailField;
	}(_react.Component), _class3.propTypes = {
	  loadRecipientsList: _propTypes2.default.func,
	  projectId: _propTypes2.default.number
	}, _class3.defaultProps = {
	  prop: {}
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onAddGroup', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onAddGroup'), _class2.prototype)), _class2)) || _class);
	exports.default = EmailField;
	module.exports = exports['default'];

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _ExpireDateField = __webpack_require__(2079);
	
	var _ExpireDateField2 = _interopRequireDefault(_ExpireDateField);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExpireDateRow = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(ExpireDateRow, _PureComponent);
	
	  function ExpireDateRow() {
	    (0, _classCallCheck3.default)(this, ExpireDateRow);
	    return (0, _possibleConstructorReturn3.default)(this, (ExpireDateRow.__proto__ || (0, _getPrototypeOf2.default)(ExpireDateRow)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ExpireDateRow, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          t = _props.t,
	          className = _props.className,
	          inputProps = _props.inputProps;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('formRow wide simple', className) },
	        _react2.default.createElement(
	          'div',
	          null,
	          t('Expire Date'),
	          '*'
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_ExpireDateField2.default, { inputProps: inputProps })
	        )
	      );
	    }
	  }]);
	  return ExpireDateRow;
	}(_react.PureComponent), _class2.propTypes = {
	  className: _propTypes2.default.string,
	  inputProps: _propTypes2.default.object,
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  inputProps: {}
	}, _temp)) || _class);
	exports.default = ExpireDateRow;
	module.exports = exports['default'];

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _MessageField = __webpack_require__(2080);
	
	var _MessageField2 = _interopRequireDefault(_MessageField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MessageRow = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(MessageRow, _PureComponent);
	
	  function MessageRow() {
	    (0, _classCallCheck3.default)(this, MessageRow);
	    return (0, _possibleConstructorReturn3.default)(this, (MessageRow.__proto__ || (0, _getPrototypeOf2.default)(MessageRow)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MessageRow, [{
	    key: 'render',
	    value: function render() {
	      var t = this.props.t;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'formRow wide simple' },
	        _react2.default.createElement(
	          'div',
	          null,
	          t('Message'),
	          '*'
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_MessageField2.default, null)
	        )
	      );
	    }
	  }]);
	  return MessageRow;
	}(_react.PureComponent), _class2.propTypes = {
	  t: _propTypes2.default.func
	}, _temp)) || _class);
	exports.default = MessageRow;
	module.exports = exports['default'];

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _SubjectField = __webpack_require__(2082);
	
	var _SubjectField2 = _interopRequireDefault(_SubjectField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SubjectRow = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(SubjectRow, _PureComponent);
	
	  function SubjectRow() {
	    (0, _classCallCheck3.default)(this, SubjectRow);
	    return (0, _possibleConstructorReturn3.default)(this, (SubjectRow.__proto__ || (0, _getPrototypeOf2.default)(SubjectRow)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SubjectRow, [{
	    key: 'render',
	    value: function render() {
	      var t = this.props.t;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'formRow wide simple' },
	        _react2.default.createElement(
	          'div',
	          null,
	          t('Subject'),
	          '*'
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_SubjectField2.default, null)
	        )
	      );
	    }
	  }]);
	  return SubjectRow;
	}(_react.PureComponent), _class2.propTypes = {
	  t: _propTypes2.default.func
	}, _temp)) || _class);
	exports.default = SubjectRow;
	module.exports = exports['default'];

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactI18next = __webpack_require__(12);
	
	var _CheckboxField = __webpack_require__(523);
	
	var _CheckboxField2 = _interopRequireDefault(_CheckboxField);
	
	var _auth = __webpack_require__(77);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WatermarkField = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    permissions: (0, _auth.getPermissions)(state)
	  };
	}), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(WatermarkField, _Component);
	
	  function WatermarkField() {
	    (0, _classCallCheck3.default)(this, WatermarkField);
	    return (0, _possibleConstructorReturn3.default)(this, (WatermarkField.__proto__ || (0, _getPrototypeOf2.default)(WatermarkField)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(WatermarkField, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          t = _props.t,
	          permissions = _props.permissions,
	          className = _props.className;
	
	
	      return _react2.default.createElement(
	        'span',
	        { className: (0, _classnames2.default)('inline-block', className) },
	        _react2.default.createElement(_CheckboxField2.default, {
	          name: 'directAccessWatermark',
	          small: true,
	          type: 'checkbox',
	          textBefore: t('No Password'),
	          disabled: !permissions.noPasswordFeature
	        })
	      );
	    }
	  }]);
	  return WatermarkField;
	}(_react.Component), _class2.propTypes = {
	  className: _propTypes2.default.string,
	  permissions: _propTypes2.default.object,
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  permissions: {}
	}, _temp)) || _class) || _class);
	exports.default = WatermarkField;
	module.exports = exports['default'];

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _validation = __webpack_require__(157);
	
	var _formValidation = __webpack_require__(263);
	
	var _formValidation2 = _interopRequireDefault(_formValidation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = (0, _validation.createValidator)({
	  subject: _formValidation2.default.field,
	  message: _formValidation2.default.field
	});
	
	exports.default = validate;
	module.exports = exports['default'];

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AddRecipientField = __webpack_require__(2083);
	
	var _AddRecipientField2 = _interopRequireDefault(_AddRecipientField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddRecipientRow = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(AddRecipientRow, _PureComponent);
	
	  function AddRecipientRow() {
	    (0, _classCallCheck3.default)(this, AddRecipientRow);
	    return (0, _possibleConstructorReturn3.default)(this, (AddRecipientRow.__proto__ || (0, _getPrototypeOf2.default)(AddRecipientRow)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AddRecipientRow, [{
	    key: 'render',
	    value: function render() {
	      var t = this.context.t;
	      var _props = this.props,
	          formRowClassName = _props.formRowClassName,
	          hintClassName = _props.hintClassName,
	          projectId = _props.projectId,
	          onAddGroup = _props.onAddGroup,
	          withTags = _props.withTags,
	          hideGroups = _props.hideGroups,
	          hintText = _props.hintText,
	          required = _props.required;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: formRowClassName },
	        _react2.default.createElement(
	          'div',
	          { className: hintClassName },
	          hintText || t('Email or group') + '*'
	        ),
	        _react2.default.createElement(_AddRecipientField2.default, {
	          projectId: projectId,
	          onAddGroup: onAddGroup,
	          hideGroups: hideGroups,
	          withTags: withTags,
	          required: required
	        })
	      );
	    }
	  }]);
	  return AddRecipientRow;
	}(_react.PureComponent), _class.propTypes = {
	  formRowClassName: _propTypes2.default.string,
	  hideGroups: _propTypes2.default.bool,
	  hintClassName: _propTypes2.default.string,
	  hintText: _propTypes2.default.string,
	  onAddGroup: _propTypes2.default.func,
	  projectId: _propTypes2.default.number,
	  required: _propTypes2.default.bool,
	  withTags: _propTypes2.default.bool
	}, _class.contextTypes = {
	  t: _propTypes2.default.func
	}, _class.defaultProps = {
	  formRowClassName: 'formRow simple',
	  hintClassName: 'colorDark',
	  withTags: false
	}, _temp);
	exports.default = AddRecipientRow;
	module.exports = exports['default'];

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RecipientStatus = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(RecipientStatus, _Component);
	
	  function RecipientStatus() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, RecipientStatus);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = RecipientStatus.__proto__ || (0, _getPrototypeOf2.default)(RecipientStatus)).call.apply(_ref, [this].concat(args)));
	
	    var t = _this.props.t;
	
	    _this.statusText = {
	      Created: t('New'),
	      EmailSent: t('Email Sent')
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(RecipientStatus, [{
	    key: 'render',
	    value: function render() {
	      var status = this.props.status;
	
	
	      return _react2.default.createElement(
	        'span',
	        { className: 'recipientStatus ' + status },
	        this.statusText[status] || status
	      );
	    }
	  }]);
	  return RecipientStatus;
	}(_react.Component), _class2.propTypes = {
	  status: _propTypes2.default.string,
	  t: _propTypes2.default.func
	}, _temp)) || _class);
	exports.default = RecipientStatus;
	module.exports = exports['default'];

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _propTypes3 = __webpack_require__(127);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1316);
	
	var SimpleTabContent = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(SimpleTabContent, _PureComponent);
	
	  function SimpleTabContent() {
	    (0, _classCallCheck3.default)(this, SimpleTabContent);
	    return (0, _possibleConstructorReturn3.default)(this, (SimpleTabContent.__proto__ || (0, _getPrototypeOf2.default)(SimpleTabContent)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SimpleTabContent, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          children = _props.children;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(styles.content, className) },
	        children
	      );
	    }
	  }]);
	  return SimpleTabContent;
	}(_react.PureComponent), _class.propTypes = {
	  children: _propTypes3.nodes,
	  className: _propTypes2.default.string
	}, _temp);
	exports.default = SimpleTabContent;
	module.exports = exports['default'];

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _toConsumableArray2 = __webpack_require__(34);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _chart = __webpack_require__(261);
	
	var _ChartWrapper = __webpack_require__(211);
	
	var _ChartWrapper2 = _interopRequireDefault(_ChartWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1249);
	
	var PopularityChart = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(PopularityChart, _PureComponent);
	
	  function PopularityChart() {
	    (0, _classCallCheck3.default)(this, PopularityChart);
	    return (0, _possibleConstructorReturn3.default)(this, (PopularityChart.__proto__ || (0, _getPrototypeOf2.default)(PopularityChart)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PopularityChart, [{
	    key: 'getTooltip',
	    value: function getTooltip(_ref) {
	      var isHTML = _ref.isHTML,
	          data = _ref.data;
	      var t = this.context.t;
	
	      if (isHTML) {
	        return '\n        <div class="' + styles.tooltip + '">\n          <div><b>' + data.trackName + '</b></div>\n          <div class="nowrap">' + t('Avg playtime') + ': <b>' + data.avgPlaytimeString + '</b></div>\n          <div class="nowrap">' + t('Times played') + ': <b>' + data.plays + '</b></div>\n          <div class="nowrap">' + t('Times downloaded') + ': <b>' + data.downloads + '</b></div>\n        </div>\n      ';
	      }
	
	      return t('Times played') + ': ' + data.plays;
	    }
	  }, {
	    key: 'getChartData',
	    value: function getChartData() {
	      var _this2 = this;
	
	      var data = this.props.data;
	      var t = this.context.t;
	
	      return [[t('Track name'), t('Avg Playtime (min)'), { type: 'string', role: 'tooltip', p: { html: true } }, // eslint-disable-line id-length
	      { type: 'string', role: 'style' }]].concat((0, _toConsumableArray3.default)((0, _chart.getDataArray)({
	        data: data,
	        keyName: 'trackName',
	        valueName: function valueName(current) {
	          return [current.avgPlaytimeDate, _this2.getTooltip({ data: current, isHTML: true }), 'stroke-width: 100;'];
	        },
	        sortBy: 'desc'
	      })));
	    }
	  }, {
	    key: 'getChartProps',
	    value: function getChartProps() {
	      var id = this.props.id;
	
	      var data = this.getChartData();
	
	      return {
	        graphId: id,
	        chartType: 'BarChart',
	        data: data,
	        options: {
	          hAxis: {
	            minValue: new Date(0),
	            viewWindow: {
	              min: new Date(0)
	            },
	            format: 'mm:ss'
	          },
	          tooltip: { isHtml: true }
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var loading = this.props.loading;
	
	      var chartProps = this.getChartProps();
	
	      return _react2.default.createElement(_ChartWrapper2.default, {
	        legendHeight: 50,
	        showMore: true,
	        limit: 10,
	        chartProps: chartProps,
	        loading: loading
	      });
	    }
	  }]);
	  return PopularityChart;
	}(_react.PureComponent), _class2.propTypes = {
	  data: _propTypes2.default.array,
	  id: _propTypes2.default.string,
	  loading: _propTypes2.default.bool
	}, _class2.contextTypes = {
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  data: [],
	  id: 'popularityChart'
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'getChartData', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'getChartData'), _class.prototype)), _class);
	exports.default = PopularityChart;
	module.exports = exports['default'];

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _ShareLinkButton = __webpack_require__(2095);
	
	var _ShareLinkButton2 = _interopRequireDefault(_ShareLinkButton);
	
	var _statistics = __webpack_require__(57);
	
	var statisticsActions = _interopRequireWildcard(_statistics);
	
	var _config = __webpack_require__(41);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var RecipientShareLinkButton = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    getLinkLoading: state.statistics.getLinkLoading,
	    linkData: state.statistics.getLinkData
	  };
	}, (0, _extends3.default)({}, statisticsActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_PureComponent) {
	  (0, _inherits3.default)(RecipientShareLinkButton, _PureComponent);
	
	  function RecipientShareLinkButton() {
	    (0, _classCallCheck3.default)(this, RecipientShareLinkButton);
	    return (0, _possibleConstructorReturn3.default)(this, (RecipientShareLinkButton.__proto__ || (0, _getPrototypeOf2.default)(RecipientShareLinkButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(RecipientShareLinkButton, [{
	    key: 'onClick',
	    value: function onClick() {
	      var _props = this.props,
	          recipientId = _props.recipientId,
	          projectId = _props.projectId,
	          getLink = _props.getLink;
	
	      getLink({ recipientId: recipientId, projectId: projectId });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          recipientId = _props2.recipientId,
	          projectId = _props2.projectId,
	          link = _props2.linkData.fileName;
	
	      var linkUrl = link ? '' + _config2.default.app.urlParts.report + link : '';
	
	      return _react2.default.createElement(_ShareLinkButton2.default, {
	        className: className,
	        onClick: this.onClick,
	        id: 'share-recipient-link-' + recipientId + '-' + projectId,
	        link: linkUrl
	      });
	    }
	  }]);
	  return RecipientShareLinkButton;
	}(_react.PureComponent), _class3.propTypes = {
	  className: _propTypes2.default.string,
	  getLink: _propTypes2.default.func,
	  linkData: _propTypes2.default.object,
	  projectId: _propTypes2.default.number.isRequired,
	  recipientId: _propTypes2.default.number.isRequired
	}, _class3.defaultProps = {
	  linkData: {},
	  onClick: _noop3.default,
	  projectId: 0,
	  recipientId: 0
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onClick'), _class2.prototype)), _class2)) || _class);
	exports.default = RecipientShareLinkButton;
	module.exports = exports['default'];

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _propTypes3 = __webpack_require__(127);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1329);
	
	var StatisticsInfoLine = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(StatisticsInfoLine, _PureComponent);
	
	  function StatisticsInfoLine() {
	    (0, _classCallCheck3.default)(this, StatisticsInfoLine);
	    return (0, _possibleConstructorReturn3.default)(this, (StatisticsInfoLine.__proto__ || (0, _getPrototypeOf2.default)(StatisticsInfoLine)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(StatisticsInfoLine, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          onChange = _props.onChange,
	          title = _props.title;
	      var t = this.context.t;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.container },
	        _react2.default.createElement(
	          'div',
	          { className: styles.title },
	          title
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            className: (0, _bind2.default)('btn-primary btn-stroke small squared', styles.changeLink),
	            onClick: onChange
	          },
	          t('Change')
	        )
	      );
	    }
	  }]);
	  return StatisticsInfoLine;
	}(_react.PureComponent), _class.propTypes = {
	  onChange: _propTypes2.default.func,
	  title: _propTypes3.node
	}, _class.contextTypes = {
	  t: _propTypes2.default.func
	}, _class.defaultProps = {
	  onChange: _noop3.default
	}, _temp);
	exports.default = StatisticsInfoLine;
	module.exports = exports['default'];

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _BackButton = __webpack_require__(256);
	
	var _BackButton2 = _interopRequireDefault(_BackButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StatisticsRecipientBackButton = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(StatisticsRecipientBackButton, _PureComponent);
	
	  function StatisticsRecipientBackButton() {
	    (0, _classCallCheck3.default)(this, StatisticsRecipientBackButton);
	    return (0, _possibleConstructorReturn3.default)(this, (StatisticsRecipientBackButton.__proto__ || (0, _getPrototypeOf2.default)(StatisticsRecipientBackButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(StatisticsRecipientBackButton, [{
	    key: 'getBackUrl',
	    value: function getBackUrl() {
	      var _props = this.props,
	          referrer = _props.referrer,
	          projectId = _props.projectId,
	          recipientId = _props.recipientId;
	
	      return referrer === 'recipient' ? '/statistics/recipient/' + recipientId : '/statistics/project/' + projectId;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var className = this.props.className;
	
	      var backUrl = this.getBackUrl();
	
	      return _react2.default.createElement(_BackButton2.default, {
	        className: (0, _bind2.default)('margin-vert-20', className),
	        asBlock: true,
	        backUrl: backUrl
	      });
	    }
	  }]);
	  return StatisticsRecipientBackButton;
	}(_react.PureComponent), _class.propTypes = {
	  className: _propTypes2.default.string,
	  projectId: _propTypes2.default.number,
	  recipientId: _propTypes2.default.number,
	  referrer: _propTypes2.default.string
	}, _class.defaultProps = {
	  referrer: 'project'
	}, _temp);
	exports.default = StatisticsRecipientBackButton;
	module.exports = exports['default'];

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _isEmpty2 = __webpack_require__(81);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _ProjectStatus = __webpack_require__(516);
	
	var _ProjectStatus2 = _interopRequireDefault(_ProjectStatus);
	
	var _ValueLine = __webpack_require__(859);
	
	var _ValueLine2 = _interopRequireDefault(_ValueLine);
	
	var _StatisticsInfoLine = __webpack_require__(849);
	
	var _StatisticsInfoLine2 = _interopRequireDefault(_StatisticsInfoLine);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1332);
	
	var StatisticsSelectedProjectInfo = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(StatisticsSelectedProjectInfo, _PureComponent);
	
	  function StatisticsSelectedProjectInfo() {
	    (0, _classCallCheck3.default)(this, StatisticsSelectedProjectInfo);
	    return (0, _possibleConstructorReturn3.default)(this, (StatisticsSelectedProjectInfo.__proto__ || (0, _getPrototypeOf2.default)(StatisticsSelectedProjectInfo)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(StatisticsSelectedProjectInfo, [{
	    key: 'onChange',
	    value: function onChange() {
	      this.context.push('/statistics/project');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          project = _props.project,
	          loading = _props.loading,
	          showChangeButton = _props.showChangeButton;
	      var t = this.context.t;
	
	
	      if ((0, _isEmpty3.default)(project) || loading) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(styles.info, className) },
	        showChangeButton && _react2.default.createElement(_StatisticsInfoLine2.default, {
	          title: t('Project') + ' "' + project.fullTitle + '"',
	          onChange: this.onChange
	        }),
	        !showChangeButton && _react2.default.createElement(_ValueLine2.default, { title: t('Project'), value: project.fullTitle, titleClass: styles.title }),
	        _react2.default.createElement(_ValueLine2.default, { title: t('Project ID'), value: project.projectId, titleClass: styles.title }),
	        _react2.default.createElement(_ValueLine2.default, { title: t('Status'), value: _react2.default.createElement(_ProjectStatus2.default, { status: project.status }), titleClass: styles.title }),
	        _react2.default.createElement(_ValueLine2.default, { title: t('Manager'), value: project.owName, titleClass: styles.title })
	      );
	    }
	  }]);
	  return StatisticsSelectedProjectInfo;
	}(_react.PureComponent), _class2.propTypes = {
	  className: _propTypes2.default.string,
	  loading: _propTypes2.default.bool,
	  project: _propTypes2.default.object,
	  showChangeButton: _propTypes2.default.bool
	}, _class2.contextTypes = {
	  push: _propTypes2.default.func,
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  project: {},
	  showChangeButton: false
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onChange', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onChange'), _class.prototype)), _class);
	exports.default = StatisticsSelectedProjectInfo;
	module.exports = exports['default'];

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _isEmpty2 = __webpack_require__(81);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _ValueLine = __webpack_require__(859);
	
	var _ValueLine2 = _interopRequireDefault(_ValueLine);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _StatisticsInfoLine = __webpack_require__(849);
	
	var _StatisticsInfoLine2 = _interopRequireDefault(_StatisticsInfoLine);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1333);
	
	var StatisticsSelectedRecipientInfo = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(StatisticsSelectedRecipientInfo, _PureComponent);
	
	  function StatisticsSelectedRecipientInfo() {
	    (0, _classCallCheck3.default)(this, StatisticsSelectedRecipientInfo);
	    return (0, _possibleConstructorReturn3.default)(this, (StatisticsSelectedRecipientInfo.__proto__ || (0, _getPrototypeOf2.default)(StatisticsSelectedRecipientInfo)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(StatisticsSelectedRecipientInfo, [{
	    key: 'onChange',
	    value: function onChange() {
	      this.context.push('/statistics/recipient');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          recipient = _props.recipient,
	          loading = _props.loading,
	          showChangeButton = _props.showChangeButton;
	      var t = this.context.t;
	
	      var containerClass = (0, _bind2.default)(styles.container, className);
	
	      if ((0, _isEmpty3.default)(recipient) || loading) {
	        return null;
	      }
	
	      if (showChangeButton) {
	        return _react2.default.createElement(
	          'div',
	          { className: containerClass },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_StatisticsInfoLine2.default, {
	              title: t('Recipient') + ': ' + recipient.fullName,
	              onChange: this.onChange
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: styles.email },
	              recipient.email
	            )
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: containerClass },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_ValueLine2.default, {
	            className: styles.header,
	            title: t('Recipient'),
	            value: recipient.fullName,
	            titleClass: styles.title
	          }),
	          _react2.default.createElement(_ValueLine2.default, {
	            value: recipient.email,
	            titleClass: styles.title
	          })
	        )
	      );
	    }
	  }]);
	  return StatisticsSelectedRecipientInfo;
	}(_react.PureComponent), _class2.propTypes = {
	  className: _propTypes2.default.string,
	  loading: _propTypes2.default.bool,
	  recipient: _propTypes2.default.object,
	  showChangeButton: _propTypes2.default.bool
	}, _class2.contextTypes = {
	  push: _propTypes2.default.func,
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  recipient: {}
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onChange', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onChange'), _class.prototype)), _class);
	exports.default = StatisticsSelectedRecipientInfo;
	module.exports = exports['default'];

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _LinkContainer = __webpack_require__(341);
	
	var _LinkContainer2 = _interopRequireDefault(_LinkContainer);
	
	var _NavItem = __webpack_require__(464);
	
	var _NavItem2 = _interopRequireDefault(_NavItem);
	
	var _propTypes3 = __webpack_require__(127);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1335);
	
	var Tab = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(Tab, _Component);
	
	  function Tab() {
	    (0, _classCallCheck3.default)(this, Tab);
	    return (0, _possibleConstructorReturn3.default)(this, (Tab.__proto__ || (0, _getPrototypeOf2.default)(Tab)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Tab, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          className = _props.className,
	          to = _props.to,
	          title = _props.title,
	          onClick = _props.onClick;
	
	
	      return _react2.default.createElement(
	        _LinkContainer2.default,
	        { to: to },
	        _react2.default.createElement(
	          _NavItem2.default,
	          {
	            className: (0, _bind2.default)(styles.tab, className, (0, _defineProperty3.default)({}, styles.active, active)),
	            onClick: onClick
	          },
	          title
	        )
	      );
	    }
	  }]);
	  return Tab;
	}(_react.Component), _class.propTypes = {
	  active: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  title: _propTypes3.node,
	  to: _propTypes2.default.string
	}, _class.defaultProps = {
	  active: false,
	  onClick: _noop3.default
	}, _temp);
	exports.default = Tab;
	module.exports = exports['default'];

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1336);
	
	var TabsWrapper = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(TabsWrapper, _PureComponent);
	
	  function TabsWrapper() {
	    (0, _classCallCheck3.default)(this, TabsWrapper);
	    return (0, _possibleConstructorReturn3.default)(this, (TabsWrapper.__proto__ || (0, _getPrototypeOf2.default)(TabsWrapper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TabsWrapper, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          children = _props.children,
	          pullRight = _props.pullRight;
	
	
	      return _react2.default.createElement(
	        'ul',
	        { className: (0, _bind2.default)(styles.tabs, className, { 'pull-right': pullRight }) },
	        children
	      );
	    }
	  }]);
	  return TabsWrapper;
	}(_react.PureComponent), _class.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.arrayOf(_propTypes2.default.node)]),
	  className: _propTypes2.default.string,
	  pullRight: _propTypes2.default.bool
	}, _class.defaultProps = {
	  pullRight: false
	}, _temp);
	exports.default = TabsWrapper;
	module.exports = exports['default'];

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(21);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1337);
	
	var TextLine = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(TextLine, _PureComponent);
	
	  function TextLine() {
	    (0, _classCallCheck3.default)(this, TextLine);
	    return (0, _possibleConstructorReturn3.default)(this, (TextLine.__proto__ || (0, _getPrototypeOf2.default)(TextLine)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TextLine, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          children = _props.children,
	          title = _props.title,
	          overflow = _props.overflow,
	          rest = (0, _objectWithoutProperties3.default)(_props, ['className', 'children', 'title', 'overflow']);
	
	      var displayedTitle = title || (typeof children === 'string' ? children : '');
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({
	          className: (0, _bind2.default)(styles.textLine, (0, _defineProperty3.default)({}, styles.overflowHidden, !overflow), className),
	          title: displayedTitle
	        }, rest),
	        children
	      );
	    }
	  }]);
	  return TextLine;
	}(_react.PureComponent), _class.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node, _propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.arrayOf(_propTypes2.default.node)]),
	  className: _propTypes2.default.string,
	  overflow: _propTypes2.default.bool,
	  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	}, _class.defaultProps = {
	  overflow: false
	}, _temp);
	exports.default = TextLine;
	module.exports = exports['default'];

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1339);
	
	var TrackPartHeader = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(TrackPartHeader, _Component);
	
	  function TrackPartHeader() {
	    (0, _classCallCheck3.default)(this, TrackPartHeader);
	    return (0, _possibleConstructorReturn3.default)(this, (TrackPartHeader.__proto__ || (0, _getPrototypeOf2.default)(TrackPartHeader)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TrackPartHeader, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          t = _props.t,
	          children = _props.children,
	          part = _props.part;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.partHeaderContainer },
	        _react2.default.createElement(
	          'span',
	          { className: styles.partHeader },
	          t('Part'),
	          ' ',
	          part
	        ),
	        children
	      );
	    }
	  }]);
	  return TrackPartHeader;
	}(_react.Component), _class2.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.arrayOf(_propTypes2.default.node)]),
	  part: _propTypes2.default.number,
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  part: 0
	}, _temp)) || _class);
	exports.default = TrackPartHeader;
	module.exports = exports['default'];

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isUndefined2 = __webpack_require__(240);
	
	var _isUndefined3 = _interopRequireDefault(_isUndefined2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _audioplayer = __webpack_require__(83);
	
	var audioPlayerActions = _interopRequireWildcard(_audioplayer);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _AudioPlayer = __webpack_require__(135);
	
	var _AudioPlayer2 = _interopRequireDefault(_AudioPlayer);
	
	var _Spectrum = __webpack_require__(2107);
	
	var _Spectrum2 = _interopRequireDefault(_Spectrum);
	
	var _TrackPlayPauseLockedButton = __webpack_require__(2131);
	
	var _TrackPlayPauseLockedButton2 = _interopRequireDefault(_TrackPlayPauseLockedButton);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1340);
	
	var TrackPlayPauseButton = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    currentTrackIndex: state.audioplayer.currentTrackIndex,
	    playerAlbum: state.audioplayer.album,
	    playerStatus: state.audioplayer.playerStatus,
	    playerTracks: state.audioplayer.tracks
	  };
	}, (0, _extends3.default)({}, audioPlayerActions)), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(TrackPlayPauseButton, _Component);
	
	  function TrackPlayPauseButton() {
	    (0, _classCallCheck3.default)(this, TrackPlayPauseButton);
	    return (0, _possibleConstructorReturn3.default)(this, (TrackPlayPauseButton.__proto__ || (0, _getPrototypeOf2.default)(TrackPlayPauseButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TrackPlayPauseButton, [{
	    key: 'getRenderProps',
	    value: function getRenderProps() {
	      var _props = this.props,
	          currentTrackIndex = _props.currentTrackIndex,
	          playerTracks = _props.playerTracks,
	          playerStatus = _props.playerStatus,
	          track = _props.track,
	          album = _props.album,
	          playerAlbum = _props.playerAlbum,
	          trackNumber = _props.trackNumber;
	
	      var currentPlayerTrack = playerTracks[currentTrackIndex] || {};
	
	      var _audioplayer$getPlayi = _AudioPlayer2.default.getPlayingInfo({
	        track: track, album: album, playerAlbum: playerAlbum, currentPlayerTrack: currentPlayerTrack, playerStatus: playerStatus
	      }),
	          isActiveTrack = _audioplayer$getPlayi.isActiveTrack,
	          isPlayerPlaying = _audioplayer$getPlayi.isPlayerPlaying,
	          isTrackPlaying = _audioplayer$getPlayi.isTrackPlaying;
	
	      var buttonClass = (0, _bind2.default)(isTrackPlaying ? 'icon-pause' : 'icon-play', styles.playerIcon);
	      var displayedTrackNumber = !(0, _isUndefined3.default)(trackNumber) ? trackNumber : track.track_number;
	      return { displayedTrackNumber: displayedTrackNumber, buttonClass: buttonClass, isActiveTrack: isActiveTrack, isPlayerPlaying: isPlayerPlaying };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          showSpectrum = _props2.showSpectrum,
	          showTrackNumber = _props2.showTrackNumber,
	          className = _props2.className,
	          isDenied = _props2.isDenied;
	
	      var _getRenderProps = this.getRenderProps(),
	          displayedTrackNumber = _getRenderProps.displayedTrackNumber,
	          buttonClass = _getRenderProps.buttonClass,
	          isActiveTrack = _getRenderProps.isActiveTrack,
	          isPlayerPlaying = _getRenderProps.isPlayerPlaying;
	
	      return _react2.default.createElement(
	        'span',
	        { className: (0, _bind2.default)((0, _defineProperty3.default)({}, styles.withSpectrum, showSpectrum), className) },
	        isDenied ? _react2.default.createElement(_TrackPlayPauseLockedButton2.default, null) : isActiveTrack ? showSpectrum ? _react2.default.createElement(_Spectrum2.default, { isActive: isPlayerPlaying }) : _react2.default.createElement('i', { className: buttonClass }) : showTrackNumber ? displayedTrackNumber : _react2.default.createElement('i', { className: buttonClass })
	      );
	    }
	  }]);
	  return TrackPlayPauseButton;
	}(_react.Component), _class2.propTypes = {
	  album: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  currentTrackIndex: _propTypes2.default.number,
	  isDenied: _propTypes2.default.bool,
	  playerAlbum: _propTypes2.default.object,
	  playerStatus: _propTypes2.default.string,
	  playerTracks: _propTypes2.default.array,
	  showSpectrum: _propTypes2.default.bool,
	  showTrackNumber: _propTypes2.default.bool,
	  track: _propTypes2.default.object,
	  trackNumber: _propTypes2.default.number
	}, _class2.defaultProps = {
	  album: {},
	  playerAlbum: {},
	  showSpectrum: true,
	  track: {}
	}, _temp)) || _class);
	exports.default = TrackPlayPauseButton;
	module.exports = exports['default'];

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1341);
	
	var TracksCount = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(TracksCount, _Component);
	
	  function TracksCount() {
	    (0, _classCallCheck3.default)(this, TracksCount);
	    return (0, _possibleConstructorReturn3.default)(this, (TracksCount.__proto__ || (0, _getPrototypeOf2.default)(TracksCount)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TracksCount, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          count = _props.count;
	
	
	      return _react2.default.createElement(_reactI18next.Interpolate, {
	        className: (0, _bind2.default)(styles.count, className),
	        i18nKey: '{{tracksCount}} tracks',
	        tracksCount: count
	      });
	    }
	  }]);
	  return TracksCount;
	}(_react.Component), _class.propTypes = {
	  className: _propTypes2.default.string,
	  count: _propTypes2.default.number
	}, _class.defaultProps = {
	  count: 0
	}, _temp);
	exports.default = TracksCount;
	module.exports = exports['default'];

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _propTypes3 = __webpack_require__(127);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1344);
	
	var ValueLine = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(ValueLine, _PureComponent);
	
	  function ValueLine() {
	    (0, _classCallCheck3.default)(this, ValueLine);
	    return (0, _possibleConstructorReturn3.default)(this, (ValueLine.__proto__ || (0, _getPrototypeOf2.default)(ValueLine)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ValueLine, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          title = _props.title,
	          value = _props.value,
	          onClick = _props.onClick,
	          titleClass = _props.titleClass,
	          valueClass = _props.valueClass;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(styles.line, className), onClick: onClick },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _bind2.default)(styles.title, titleClass) },
	          title,
	          title && ':'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: valueClass },
	          value
	        )
	      );
	    }
	  }]);
	  return ValueLine;
	}(_react.PureComponent), _class.propTypes = {
	  className: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  title: _propTypes3.node,
	  titleClass: _propTypes2.default.string,
	  value: _propTypes3.nodes,
	  valueClass: _propTypes2.default.string
	}, _class.defaultProps = {
	  onClick: _noop3.default
	}, _temp);
	exports.default = ValueLine;
	module.exports = exports['default'];

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1345);
	
	var cn = _bind2.default.bind(styles);
	
	var YesNoStatus = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(YesNoStatus, _PureComponent);
	
	  function YesNoStatus() {
	    (0, _classCallCheck3.default)(this, YesNoStatus);
	    return (0, _possibleConstructorReturn3.default)(this, (YesNoStatus.__proto__ || (0, _getPrototypeOf2.default)(YesNoStatus)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(YesNoStatus, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          onClick = _props.onClick,
	          success = _props.success,
	          hasRights = _props.hasRights;
	      var t = this.context.t;
	
	
	      return _react2.default.createElement(
	        'span',
	        { className: cn(styles.status, className, { hasRights: hasRights, success: success }), onClick: onClick },
	        success ? t('Yes') : t('No')
	      );
	    }
	  }]);
	  return YesNoStatus;
	}(_react.PureComponent), _class.propTypes = {
	  className: _propTypes2.default.string,
	  hasRights: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  success: _propTypes2.default.bool
	}, _class.contextTypes = {
	  t: _propTypes2.default.func
	}, _class.defaultProps = {
	  onClick: _noop3.default
	}, _temp);
	exports.default = YesNoStatus;
	module.exports = exports['default'];

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _datetime = __webpack_require__(68);
	
	var _moment = __webpack_require__(20);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var yesterday = (0, _moment2.default)().subtract(1, 'day');
	
	var datePickerProps = {
	  dateFormat: _datetime.dateFormat.date,
	  timeFormat: false,
	  closeOnSelect: true,
	  inputProps: { className: 'dateTimeInput' },
	  isValidDate: function isValidDate(current) {
	    return current.isAfter(yesterday);
	  }
	};
	
	exports.default = datePickerProps;
	module.exports = exports['default'];

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(21);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	exports.default = formAutosuggestInput;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _components = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formAutosuggestInput(props) {
	  var input = props.input,
	      _props$meta = props.meta,
	      touched = _props$meta.touched,
	      error = _props$meta.error,
	      type = props.type,
	      disabled = props.disabled,
	      bottomHint = props.bottomHint,
	      field = props.field,
	      onSuggestionSelected = props.onSuggestionSelected,
	      items = props.items,
	      readOnly = props.readOnly,
	      placeholder = props.placeholder,
	      noIndent = props.noIndent,
	      autoWidth = props.autoWidth,
	      onBlur = props.onBlur,
	      onGetSuggestions = props.onGetSuggestions,
	      maxSuggestions = props.maxSuggestions,
	      other = (0, _objectWithoutProperties3.default)(props, ['input', 'meta', 'type', 'disabled', 'bottomHint', 'field', 'onSuggestionSelected', 'items', 'readOnly', 'placeholder', 'noIndent', 'autoWidth', 'onBlur', 'onGetSuggestions', 'maxSuggestions']); // eslint-disable-line react/prop-types
	
	  var formGroupClassName = (0, _bind2.default)(props.fieldClassName, { hasError: touched && error, 'margin-vert-10': !noIndent });
	  var inputProps = (0, _extends3.default)({}, other, input, {
	    disabled: disabled,
	    type: type,
	    placeholder: placeholder,
	    readOnly: readOnly,
	    className: 'width-perc-100'
	  });
	
	  if (onBlur) {
	    var inputOnBlur = input.onBlur;
	    inputProps.onBlur = function (e) {
	      if (inputOnBlur) {
	        inputOnBlur(e);
	      }
	      onBlur(e);
	    };
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: formGroupClassName },
	    _react2.default.createElement(_components.AutosuggestField, {
	      autoWidth: autoWidth,
	      field: field,
	      onSuggestionSelected: onSuggestionSelected,
	      onGetSuggestions: onGetSuggestions,
	      items: items,
	      inputProps: inputProps,
	      maxSuggestions: maxSuggestions
	    }),
	    touched && error && _react2.default.createElement(
	      'div',
	      { className: 'fieldErrorText' },
	      error
	    ),
	    bottomHint && _react2.default.createElement(
	      'div',
	      { className: 'hint small' },
	      bottomHint
	    )
	  );
	}
	
	formAutosuggestInput.propTypes = {
	  autoWidth: _propTypes2.default.bool,
	  bottomHint: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  field: _propTypes2.default.string.isRequired,
	  fieldClassName: _propTypes2.default.string,
	  hideLabel: _propTypes2.default.bool,
	  input: _propTypes2.default.object,
	  items: _propTypes2.default.array.isRequired,
	  labelClass: _propTypes2.default.string,
	  maxSuggestions: _propTypes2.default.number,
	  meta: _propTypes2.default.object,
	  noIndent: _propTypes2.default.bool,
	  onBlur: _propTypes2.default.func,
	  onGetSuggestions: _propTypes2.default.func,
	  onSuggestionSelected: _propTypes2.default.func.isRequired,
	  placeholder: _propTypes2.default.string,
	  readOnly: _propTypes2.default.bool,
	  type: _propTypes2.default.string
	};
	module.exports = exports['default'];

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	var _auth = __webpack_require__(356);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoginDialog = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    loginFormState: state.auth.loginFormState,
	    user: state.auth.user
	  };
	}, null, null, { withRef: true }), _dec2 = (0, _reactI18next.translate)(['common'], { withRef: true }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(LoginDialog, _Component);
	
	  function LoginDialog() {
	    (0, _classCallCheck3.default)(this, LoginDialog);
	    return (0, _possibleConstructorReturn3.default)(this, (LoginDialog.__proto__ || (0, _getPrototypeOf2.default)(LoginDialog)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LoginDialog, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!this.props.user && nextProps.user) {
	        this.close();
	      }
	    }
	  }, {
	    key: 'getModalTitle',
	    value: function getModalTitle() {
	      var _titles;
	
	      var _props = this.props,
	          t = _props.t,
	          loginFormState = _props.loginFormState;
	
	      var titles = (_titles = {}, (0, _defineProperty3.default)(_titles, _auth.loginFormStates.login, t('Login')), (0, _defineProperty3.default)(_titles, _auth.loginFormStates.reset, t('Password expired')), (0, _defineProperty3.default)(_titles, _auth.loginFormStates.unlock, t('Account locked')), _titles);
	      return titles[loginFormState] || t('Request new password');
	    }
	  }, {
	    key: 'isModalTitleWarning',
	    value: function isModalTitleWarning() {
	      var loginFormState = this.props.loginFormState;
	
	      return [_auth.loginFormStates.reset, _auth.loginFormStates.unlock].includes(loginFormState);
	    }
	  }, {
	    key: 'open',
	    value: function open() {
	      this.modal.open();
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.modal.close();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var hint = this.props.hint;
	
	      var modalBackdrop = 'static';
	      var isCloseByEscEnabled = false;
	      var title = this.getModalTitle();
	
	      return _react2.default.createElement(
	        _components.Modal,
	        {
	          ref: function ref(el) {
	            return _this2.modal = el;
	          },
	          title: title,
	          warningTitle: this.isModalTitleWarning(),
	          backdrop: modalBackdrop,
	          closeByEsc: isCloseByEscEnabled,
	          dialogClassName: 'modal-login'
	        },
	        !!hint && _react2.default.createElement(
	          'div',
	          { className: 'danger' },
	          hint
	        ),
	        _react2.default.createElement(_components.LoginForm, null)
	      );
	    }
	  }]);
	  return LoginDialog;
	}(_react.Component), _class2.propTypes = {
	  hint: _propTypes2.default.string,
	  loginFormState: _propTypes2.default.string,
	  t: _propTypes2.default.func,
	  user: _propTypes2.default.object
	}, _temp)) || _class) || _class);
	exports.default = LoginDialog;
	module.exports = exports['default'];

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _MyPlaylistItem = __webpack_require__(2174);
	
	var _MyPlaylistItem2 = _interopRequireDefault(_MyPlaylistItem);
	
	var _Loader = __webpack_require__(60);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _SelectableList2 = __webpack_require__(354);
	
	var _SelectableList3 = _interopRequireDefault(_SelectableList2);
	
	var _myPlaylists = __webpack_require__(88);
	
	var myPlaylistsActions = _interopRequireWildcard(_myPlaylists);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1356);
	
	var MyPlaylistsList = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    checkedPlaylists: state.myPlaylists.checkedPlaylists
	  };
	}, (0, _extends3.default)({}, myPlaylistsActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_SelectableList) {
	  (0, _inherits3.default)(MyPlaylistsList, _SelectableList);
	
	  function MyPlaylistsList() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, MyPlaylistsList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = MyPlaylistsList.__proto__ || (0, _getPrototypeOf2.default)(MyPlaylistsList)).call.apply(_ref, [this].concat(args)));
	
	    _this.selectableConfig = (0, _extends3.default)({}, _this.selectableConfig, {
	      idField: 'guid',
	      propsField: 'playlists',
	      updateFn: _this.props.updateCheckedPlaylists,
	      checkedItemsPropsField: 'checkedPlaylists'
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(MyPlaylistsList, [{
	    key: 'onRowClick',
	    value: function onRowClick(playlist) {
	      this.toggleItemChecked(playlist.guid);
	    }
	  }, {
	    key: 'onSelectionChange',
	    value: function onSelectionChange(checkedSongs) {
	      this.props.onSelect(checkedSongs);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          playlists = _props.playlists,
	          loading = _props.loading,
	          clickable = _props.clickable,
	          selectable = _props.selectable,
	          checkedPlaylists = _props.checkedPlaylists,
	          withOptions = _props.withOptions,
	          withIndex = _props.withIndex,
	          className = _props.className,
	          id = _props.id;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(styles.list, className), id: id },
	        playlists.map(function (playlist, index) {
	          return _react2.default.createElement(_MyPlaylistItem2.default, {
	            selectable: selectable,
	            clickable: clickable,
	            key: playlist.guid,
	            playlist: playlist,
	            onClick: _this2.onRowClick,
	            checked: checkedPlaylists[playlist.guid],
	            withOptions: withOptions,
	            withIndex: withIndex,
	            index: index + 1
	          });
	        }),
	        loading && _react2.default.createElement(_Loader2.default, { alignCenter: true })
	      );
	    }
	  }]);
	  return MyPlaylistsList;
	}(_SelectableList3.default), _class3.propTypes = {
	  checkedPlaylists: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  clickable: _propTypes2.default.bool,
	  id: _propTypes2.default.string,
	  loading: _propTypes2.default.bool,
	  playlists: _propTypes2.default.array,
	  selectable: _propTypes2.default.bool,
	  updateCheckedPlaylists: _propTypes2.default.func,
	  withIndex: _propTypes2.default.bool,
	  withOptions: _propTypes2.default.bool
	}, _class3.defaultProps = {
	  checkedPlaylists: {},
	  onSelect: _noop3.default,
	  playlists: []
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onRowClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onRowClick'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onSelectionChange', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSelectionChange'), _class2.prototype)), _class2)) || _class);
	exports.default = MyPlaylistsList;
	module.exports = exports['default'];

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get2 = __webpack_require__(19);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _project = __webpack_require__(37);
	
	var projectActions = _interopRequireWildcard(_project);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _strings = __webpack_require__(59);
	
	var _projects = __webpack_require__(28);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1373);
	
	var SharespacePublishButton = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    projectLoaded: state.project.projectLoaded,
	    publishSharespaceLoaded: state.project.publishSharespaceLoaded,
	    publishSharespaceLoading: state.project.publishSharespaceLoading,
	    suspendSharespaceLoaded: state.project.suspendSharespaceLoaded,
	    suspendSharespaceLoading: state.project.suspendSharespaceLoading,
	    teamMembersListData: state.project.teamMembersListData
	  };
	}, (0, _extends3.default)({}, projectActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(SharespacePublishButton, _Component);
	
	  function SharespacePublishButton() {
	    (0, _classCallCheck3.default)(this, SharespacePublishButton);
	    return (0, _possibleConstructorReturn3.default)(this, (SharespacePublishButton.__proto__ || (0, _getPrototypeOf2.default)(SharespacePublishButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SharespacePublishButton, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadTeamMembers();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.project !== this.props.project) {
	        this.loadTeamMembers();
	      }
	    }
	  }, {
	    key: 'loadTeamMembers',
	    value: function loadTeamMembers() {
	      var _props = this.props,
	          project = _props.project,
	          loadTeamMembers = _props.loadTeamMembers;
	
	      if ((0, _get3.default)(project, 'id')) {
	        loadTeamMembers(project.id);
	      }
	    }
	  }, {
	    key: 'publishSharespace',
	    value: function publishSharespace() {
	      var _props2 = this.props,
	          publishSharespace = _props2.publishSharespace,
	          project = _props2.project;
	
	      return publishSharespace(project.id);
	    }
	  }, {
	    key: 'suspendSharespace',
	    value: function suspendSharespace() {
	      var _props3 = this.props,
	          suspendSharespace = _props3.suspendSharespace,
	          project = _props3.project;
	
	      return suspendSharespace(project.id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          className = _props4.className,
	          project = _props4.project,
	          publishSharespaceLoading = _props4.publishSharespaceLoading,
	          publishSharespaceLoaded = _props4.publishSharespaceLoaded,
	          suspendSharespaceLoading = _props4.suspendSharespaceLoading,
	          suspendSharespaceLoaded = _props4.suspendSharespaceLoaded,
	          projectLoaded = _props4.projectLoaded,
	          teamMembersListData = _props4.teamMembersListData;
	      var t = this.context.t;
	
	      var isPublished = (0, _get3.default)(project, 'status') === _projects.projectStatus.published && !suspendSharespaceLoaded || publishSharespaceLoaded;
	
	      if (!projectLoaded) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(className, styles.container) },
	        isPublished ? _react2.default.createElement(
	          'div',
	          null,
	          publishSharespaceLoaded ? _react2.default.createElement(
	            'div',
	            { className: 'margin-bottom-20' },
	            _react2.default.createElement(
	              'p',
	              null,
	              t('Done!')
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              t('Your Sharespace is now available to create projects. The following team members have been notified:')
	            ),
	            teamMembersListData.map(function (member) {
	              return _react2.default.createElement(
	                'div',
	                null,
	                '\u2022 ',
	                (0, _strings.concat)(' ', member.name, member.surname),
	                ' (',
	                member.userEmail,
	                ')'
	              );
	            })
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'margin-vert-20' },
	            t('By clicking on the Suspend button below, team members will NO LONGER have access to this sharespace.\n                 Existing projects created from this sharespace will remain active.')
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              className: 'btn-danger wide margin-vert-5 pull-right',
	              onClick: this.suspendSharespace,
	              loading: suspendSharespaceLoading
	            },
	            t('Suspend'),
	            '!'
	          )
	        ) : _react2.default.createElement(
	          'div',
	          null,
	          suspendSharespaceLoaded && _react2.default.createElement(
	            'div',
	            { className: 'margin-bottom-20' },
	            _react2.default.createElement(
	              'p',
	              null,
	              t('Your Workspace is not available for team members to use.')
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              t('However, already created projects are still available to their recipients.')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'margin-vert-20' },
	            t('By clicking on the Publish button below, team members will have access to this sharespace.\n               Until you publish this Sharespace no-one can access it.')
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              className: 'btn-primary wide margin-vert-5 pull-right',
	              onClick: this.publishSharespace,
	              loading: publishSharespaceLoading
	            },
	            t('Publish')
	          )
	        )
	      );
	    }
	  }]);
	  return SharespacePublishButton;
	}(_react.Component), _class3.propTypes = {
	  className: _propTypes2.default.string,
	  loadTeamMembers: _propTypes2.default.func,
	  project: _propTypes2.default.object,
	  projectLoaded: _propTypes2.default.bool,
	  publishSharespace: _propTypes2.default.func,
	  publishSharespaceLoaded: _propTypes2.default.bool,
	  publishSharespaceLoading: _propTypes2.default.bool,
	  suspendSharespace: _propTypes2.default.func,
	  suspendSharespaceLoaded: _propTypes2.default.bool,
	  suspendSharespaceLoading: _propTypes2.default.bool,
	  teamMembersListData: _propTypes2.default.array
	}, _class3.contextTypes = {
	  t: _propTypes2.default.func
	}, _class3.defaultProps = {
	  project: {}
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'publishSharespace', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'publishSharespace'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'suspendSharespace', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'suspendSharespace'), _class2.prototype)), _class2)) || _class);
	exports.default = SharespacePublishButton;
	module.exports = exports['default'];

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.noopResponse = undefined;
	
	var _promise = __webpack_require__(62);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _typeof2 = __webpack_require__(102);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _toConsumableArray2 = __webpack_require__(34);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _get2 = __webpack_require__(19);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _superagent = __webpack_require__(2246);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _config = __webpack_require__(41);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _network = __webpack_require__(528);
	
	var _consoleColor = __webpack_require__(867);
	
	var _responseCodes = __webpack_require__(99);
	
	var _responseCodes2 = _interopRequireDefault(_responseCodes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var methods = ['get', 'post', 'put', 'patch', 'del'];
	
	var noopResponse = exports.noopResponse = { promise: null, request: null };
	
	function formatUrl(path) {
	  if (path.startsWith('http://') || path.startsWith('https://')) {
	    return path;
	  }
	
	  var adjustedPath = path[0] !== '/' ? '/' + path : path;
	  var isDevApi = path.indexOf('/dev/') === 0;
	  if (isDevApi) {
	    adjustedPath = adjustedPath.replace('/dev/', '/');
	  }
	
	  if ((false) || !_config2.default.useApiProxy) {
	    // Prepend host and port of the API server to the path.
	    if (isDevApi) {
	      return 'http://' + _config2.default.devApiHost + ':' + _config2.default.devApiPort + adjustedPath;
	    }
	    return _config2.default.apiProtocol + '://' + _config2.default.apiHost + ':' + _config2.default.apiPort + _config2.default.apiRoot + adjustedPath;
	  }
	  // Prepend `/api` to relative URL, to proxy to API server.
	  if (isDevApi) {
	    return '/dev/api' + adjustedPath;
	  }
	  return '/api' + adjustedPath;
	}
	
	function setServerHeaders(_ref) {
	  var clientRequest = _ref.clientRequest,
	      apiRequest = _ref.apiRequest;
	
	  if (true) {
	    return false;
	  }
	
	  apiRequest.set('X-CLIENT-IP', (0, _network.getClientIp)(clientRequest));
	
	  var cookie = clientRequest.get('cookie');
	  if (cookie) {
	    apiRequest.set('cookie', cookie);
	  }
	
	  var ua = clientRequest.get('user-agent');
	  if (ua) {
	    apiRequest.set('User-Agent', ua);
	  }
	}
	
	function setResponse(_ref2) {
	  var err = _ref2.err,
	      res = _ref2.res,
	      hideErrors = _ref2.hideErrors,
	      _ref2$hideErrorCodes = _ref2.hideErrorCodes,
	      hideErrorCodes = _ref2$hideErrorCodes === undefined ? [] : _ref2$hideErrorCodes,
	      reject = _ref2.reject,
	      resolve = _ref2.resolve,
	      response = _ref2.response,
	      _ref2$successCodes = _ref2.successCodes,
	      successCodes = _ref2$successCodes === undefined ? [_responseCodes2.default.success] : _ref2$successCodes;
	  var _config$response = _config2.default.response,
	      statusField = _config$response.statusField,
	      messageField = _config$response.messageField;
	
	  var isHasRespData = (0, _get3.default)(res, 'body');
	  var respCode = (0, _get3.default)(res, ['body', statusField]);
	  var isSuccessCode = [_responseCodes2.default.success].concat((0, _toConsumableArray3.default)(successCodes)).includes(respCode);
	  var isError = err || isHasRespData && !isSuccessCode;
	
	  var errResp = isError ? res.body || err : null;
	
	  if (errResp) {
	    if ((typeof errResp === 'undefined' ? 'undefined' : (0, _typeof3.default)(errResp)) !== 'object') {
	      errResp = (0, _defineProperty3.default)({}, messageField, errResp);
	    }
	    errResp.hideErrors = hideErrors;
	    errResp.hideErrorCodes = hideErrorCodes;
	  }
	  return errResp ? reject(errResp) : resolve(response);
	}
	
	var ApiClient = function () {
	  function ApiClient(clientRequest) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, ApiClient);
	
	    methods.forEach(function (method) {
	      return (
	        // this[method] = (path, {params, data, raw, withStatus, json, hideErrors} = {}) => new Promise((resolve, reject) => {
	        _this[method] = function (path) {
	          var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	              params = _ref3.params,
	              data = _ref3.data,
	              hideErrors = _ref3.hideErrors,
	              _ref3$hideErrorCodes = _ref3.hideErrorCodes,
	              hideErrorCodes = _ref3$hideErrorCodes === undefined ? [] : _ref3$hideErrorCodes,
	              json = _ref3.json,
	              successCodes = _ref3.successCodes;
	
	          var apiRequest = _superagent2.default[method](formatUrl(path));
	
	          var promise = new _promise2.default(function (resolve, reject) {
	            console.log((0, _consoleColor.shellFg)('green') + 'API request: ' + method.toUpperCase() + ' ' + formatUrl(path) + (0, _consoleColor.shellReset)());
	
	            apiRequest.withCredentials();
	
	            if (!json) {
	              // set the Content-Type to application/x-www-form-urlencoded
	              apiRequest.type('form');
	            }
	
	            setServerHeaders({ clientRequest: clientRequest, apiRequest: apiRequest });
	
	            if (params) {
	              apiRequest.query(params);
	            }
	
	            if (data) {
	              apiRequest.send(data);
	            }
	
	            // should be here to have ability to use .on handler in components. In other case if .on after .end - handler never be triggered
	            apiRequest.on('progress', _noop3.default);
	
	            apiRequest.end(function (err) {
	              var res = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	              return setResponse({ err: err, res: res, hideErrors: hideErrors, hideErrorCodes: hideErrorCodes, successCodes: successCodes, reject: reject, resolve: resolve, response: res.body });
	            });
	          });
	
	          return { promise: promise, request: apiRequest };
	        }
	      );
	    });
	  }
	  /*
	   * There's a V8 bug where, when using Babel, exporting classes with only
	   * constructors sometimes fails. Until it's patched, this is a solution to
	   * "ApiClient is not defined" from issue #14.
	   * https://github.com/erikras/react-redux-universal-hot-example/issues/14
	   *
	   * Relevant Babel bug (but they claim it's V8): https://phabricator.babeljs.io/T2455
	   *
	   * Remove it at your own risk.
	   */
	
	
	  (0, _createClass3.default)(ApiClient, [{
	    key: 'empty',
	    value: function empty() {}
	  }]);
	  return ApiClient;
	}();
	
	exports.default = ApiClient;

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shellFg = shellFg;
	exports.shellBg = shellBg;
	exports.shellStyle = shellStyle;
	exports.shellReset = shellReset;
	var shellColor = exports.shellColor = {
	  reset: '\x1b[0m',
	  bright: '\x1b[1m',
	  dim: '\x1b[2m',
	  underscore: '\x1b[4m',
	  blink: '\x1b[5m',
	  reverse: '\x1b[7m',
	  hidden: '\x1b[8m',
	  fg: {
	    black: '\x1b[30m',
	    red: '\x1b[31m',
	    green: '\x1b[32m',
	    yellow: '\x1b[33m',
	    blue: '\x1b[34m',
	    magenta: '\x1b[35m',
	    cyan: '\x1b[36m',
	    white: '\x1b[37m',
	    crimson: '\x1b[38m'
	  },
	  bg: {
	    black: '\x1b[40m',
	    red: '\x1b[41m',
	    green: '\x1b[42m',
	    yellow: '\x1b[43m',
	    blue: '\x1b[44m',
	    magenta: '\x1b[45m',
	    cyan: '\x1b[46m',
	    white: '\x1b[47m',
	    crimson: '\x1b[48m'
	  }
	};
	
	function shellFg(name) {
	  return  false ? shellColor.fg[name] || '' : '';
	}
	
	function shellBg(name) {
	  return  false ? shellColor.bg[name] || '' : '';
	}
	
	function shellStyle(name) {
	  return  false ? shellColor[name] || '' : '';
	}
	
	function shellReset() {
	  return  false ? shellColor.reset : '';
	}

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pageLimit = undefined;
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.processContact = processContact;
	exports.processContacts = processContacts;
	exports.getFilteredContacts = getFilteredContacts;
	exports.getFilteredContactsPage = getFilteredContactsPage;
	
	var _utils = __webpack_require__(24);
	
	var _strings = __webpack_require__(59);
	
	var _pagination = __webpack_require__(357);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var filteredFields = ['name', 'surname', 'email'];
	
	var pageLimit = exports.pageLimit = 100;
	
	function processContact(contact) {
	  var processedContact = (0, _extends3.default)({}, contact);
	  processedContact.fullName = (0, _strings.concat)(' ', processedContact.name, processedContact.surname);
	  return processedContact;
	}
	
	function processContacts(contacts) {
	  return contacts.map(processContact);
	}
	
	function getFilteredContacts(_ref) {
	  var contacts = _ref.contacts,
	      kw = _ref.kw;
	
	  return processContacts((0, _utils.filterObjectsByKws)({ objects: contacts, fields: filteredFields, kw: kw }));
	}
	
	function getFilteredContactsPage(_ref2) {
	  var contacts = _ref2.contacts,
	      kw = _ref2.kw,
	      page = _ref2.page;
	
	  var _getFromTo = (0, _pagination.getFromTo)({ page: page, limit: pageLimit }),
	      from = _getFromTo.from,
	      to = _getFromTo.to;
	
	  var countAll = contacts.length;
	  var filteredContacts = getFilteredContacts({ contacts: contacts, kw: kw });
	  var filteredPageContacts = filteredContacts.slice(from, to);
	  return {
	    contacts: filteredPageContacts,
	    count: filteredContacts.length,
	    countAll: countAll
	  };
	}

/***/ }),
/* 869 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFileExtention = getFileExtention;
	exports.normalizeFileName = normalizeFileName;
	exports.sortFiles = sortFiles;
	function getFileExtention(fileName) {
	  return (/(?:\.([^.]+))?$/.exec(fileName)[1]
	  );
	}
	
	function normalizeFileName(name) {
	  var replaceFn = function replaceFn(match) {
	    return match.padStart(14, '0');
	  };
	  var filenameRegexp = /\.[^/.]+$/;
	  return name.replace(filenameRegexp, '').replace(/(\d+)/g, replaceFn).toLowerCase();
	}
	
	function sortFiles(files) {
	  var sortedFiles = files.sort(function (file1, file2) {
	    var name1 = normalizeFileName(file1.name);
	    var name2 = normalizeFileName(file2.name);
	    return name1 > name2;
	  });
	
	  return sortedFiles;
	}

/***/ }),
/* 870 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  enter: 13,
	  cancel: 27
	};
	module.exports = exports["default"];

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(8);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	exports.default = reducer;
	exports.show = show;
	exports.hide = hide;
	exports.toggle = toggle;
	exports.toggleSection = toggleSection;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* Side menu redux reducer and action creators */
	
	var SHOW = 'menu/SHOW';
	var HIDE = 'menu/HIDE';
	var TOGGLE = 'menu/TOGGLE';
	var TOGGLE_SECTION = 'menu/TOGGLE_SECTION';
	
	var initialState = {
	  visible: false,
	  hiddenSections: {}
	};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case 'RESET':
	      return initialState;
	    case SHOW:
	      return (0, _extends4.default)({}, state, {
	        visible: true
	      });
	    case HIDE:
	      return (0, _extends4.default)({}, state, {
	        visible: false
	      });
	    case TOGGLE:
	      return (0, _extends4.default)({}, state, {
	        visible: !state.visible
	      });
	    case TOGGLE_SECTION:
	      return (0, _extends4.default)({}, state, {
	        hiddenSections: (0, _extends4.default)({}, state.hiddenSections, (0, _defineProperty3.default)({}, action.section, !state.hiddenSections[action.section]))
	      });
	    default:
	      return state;
	  }
	}
	
	function show() {
	  return {
	    type: SHOW
	  };
	}
	
	function hide() {
	  return {
	    type: HIDE
	  };
	}
	
	function toggle() {
	  return {
	    type: TOGGLE
	  };
	}
	
	function toggleSection(section) {
	  return {
	    type: TOGGLE_SECTION,
	    section: section
	  };
	}

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _slicedToArray2 = __webpack_require__(78);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(72);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _camelCase2 = __webpack_require__(1548);
	
	var _camelCase3 = _interopRequireDefault(_camelCase2);
	
	var _desc, _value, _class;
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _qim = __webpack_require__(110);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var BaseReducer = (_class = function () {
	  function BaseReducer(_ref) {
	    var _ref$apiConstants = _ref.apiConstants,
	        apiConstants = _ref$apiConstants === undefined ? [] : _ref$apiConstants,
	        constants = _ref.constants,
	        initialState = _ref.initialState,
	        _ref$mainReducer = _ref.mainReducer,
	        mainReducer = _ref$mainReducer === undefined ? function (state) {
	      return state;
	    } : _ref$mainReducer;
	    (0, _classCallCheck3.default)(this, BaseReducer);
	
	    this._apiConstants = apiConstants;
	    this._constants = constants;
	    this._initialState = initialState;
	    this._mainReducer = mainReducer;
	    this._bindConstants(this._apiConstants);
	    this._bindConstants(this._constants);
	    this.RESET = this.reset;
	  }
	
	  (0, _createClass3.default)(BaseReducer, [{
	    key: '_bindConstants',
	    value: function _bindConstants(constants) {
	      var _this = this;
	
	      (0, _entries2.default)(constants).map(function (_ref2) {
	        var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
	            key = _ref3[0],
	            value = _ref3[1];
	
	        var method = _this[(0, _camelCase3.default)(key)];
	        if (method) {
	          _this[value] = method;
	        }
	      });
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      return this._initialState;
	    }
	  }, {
	    key: '_reorder',
	    value: function _reorder(_ref4) {
	      var action = _ref4.action,
	          state = _ref4.state,
	          orderFieldName = _ref4.orderFieldName,
	          activeOrderFieldName = _ref4.activeOrderFieldName;
	
	      return (0, _qim.update)([[orderFieldName, action.name, (0, _qim.$apply)(function (stateOrder) {
	        return state[activeOrderFieldName] === action.name ? stateOrder === 'asc' ? 'desc' : 'asc' : stateOrder;
	      })], [activeOrderFieldName, (0, _qim.$set)(action.name)]], this._mainReducer(state, action));
	    }
	  }, {
	    key: 'reducer',
	    value: function reducer() {
	      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._initialState;
	      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return this[action.type] ? this[action.type]({ state: state, action: action }) : this._mainReducer(state, action);
	    }
	  }]);
	  return BaseReducer;
	}(), (_applyDecoratedDescriptor(_class.prototype, 'reducer', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'reducer'), _class.prototype)), _class);
	exports.default = BaseReducer;
	module.exports = exports['default'];

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getProcessing = exports.getPathId = exports.getError = exports.getFiles = undefined;
	
	var _get3 = __webpack_require__(19);
	
	var _get4 = _interopRequireDefault(_get3);
	
	var _reselect = __webpack_require__(125);
	
	var _cloud = __webpack_require__(2227);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _getError = function _getError(state, service) {
	  return (0, _get4.default)(state.cloud, [service, 'error']);
	};
	var _getFiles = function _getFiles(state, service) {
	  return { service: service, files: (0, _get4.default)(state.cloud, [service, 'files']) };
	};
	var _getPathId = function _getPathId(state, service) {
	  return (0, _get4.default)(state.cloud, [service, 'pathId']);
	};
	var _getProcessing = function _getProcessing(state, service) {
	  return (0, _get4.default)(state.cloud, [service, 'processing']);
	};
	
	var getFiles = exports.getFiles = (0, _reselect.createSelector)([_getFiles, _getPathId], function (data, pathId) {
	  return (0, _cloud.processFiles)(data.files[pathId], data.service);
	});
	
	var getError = exports.getError = (0, _reselect.createSelector)([_getError], function (error) {
	  return error;
	});
	
	var getPathId = exports.getPathId = (0, _reselect.createSelector)([_getPathId], function (res) {
	  return res;
	});
	
	var getProcessing = exports.getProcessing = (0, _reselect.createSelector)([_getProcessing], function (res) {
	  return res;
	});

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getRecipientReportData = exports.getReportData = undefined;
	
	var _reselect = __webpack_require__(125);
	
	var _reports = __webpack_require__(2228);
	
	var _getReportData = function _getReportData(state) {
	  return state.report.reportData || {};
	};
	var _getRecipientReportData = function _getRecipientReportData(state) {
	  return state.report.recipientReportData || {};
	};
	
	var getReportData = exports.getReportData = (0, _reselect.createSelector)([_getReportData], function (data) {
	  return (0, _reports.processReport)(data);
	});
	
	var getRecipientReportData = exports.getRecipientReportData = (0, _reselect.createSelector)([_getRecipientReportData], function (data) {
	  return (0, _reports.processRecipientReport)(data);
	});

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCheckedSongsArray = exports.getFilteredSongs = exports.getAllSongs = undefined;
	
	var _toConsumableArray2 = __webpack_require__(34);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _values = __webpack_require__(158);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _invertBy2 = __webpack_require__(132);
	
	var _invertBy3 = _interopRequireDefault(_invertBy2);
	
	var _reselect = __webpack_require__(125);
	
	var _utils = __webpack_require__(24);
	
	var _playlists = __webpack_require__(362);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import {processTracks} from '../helpers/Playlists';
	// import {asArray} from 'helpers/TypeCast';
	var _getAlbumsTracks = function _getAlbumsTracks(state) {
	  return state.songs.songsData.tracks;
	}; /* Playlists and albums reselect */
	
	var getCheckedSongs = function getCheckedSongs(state) {
	  return state.songs.checkedSongs;
	};
	var getKw = function getKw(state) {
	  return state.songs.kw;
	};
	
	var filteredFields = ['trackName', 'artist', 'isrc', 'albumArtist'];
	
	var getAllSongs = exports.getAllSongs = (0, _reselect.createSelector)([_getAlbumsTracks, _playlists.getAllTracks], function (tracks, allTracks) {
	  var tracksArr = [];
	  (0, _values2.default)(allTracks).map(function (track) {
	    tracksArr = [].concat((0, _toConsumableArray3.default)(tracksArr), [track]);
	  });
	  return tracksArr;
	});
	
	var getFilteredSongs = exports.getFilteredSongs = (0, _reselect.createSelector)([getAllSongs, getKw], function (songs, kw) {
	  return (0, _utils.filterObjectsByKws)({ objects: songs, fields: filteredFields, kw: kw });
	});
	
	var getCheckedSongsArray = exports.getCheckedSongsArray = (0, _reselect.createSelector)([getCheckedSongs], function (songs) {
	  return ((0, _invertBy3.default)(songs).true || []).map(Number);
	});

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(8);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	exports.default = mapConstants;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapConstants(_ref) {
	  var moduleName = _ref.moduleName,
	      _ref$constants = _ref.constants,
	      constants = _ref$constants === undefined ? [] : _ref$constants;
	
	  return constants.reduce(function (result, constant) {
	    return (0, _extends4.default)({}, result, (0, _defineProperty3.default)({}, constant, moduleName + "/" + constant));
	  }, {});
	}
	module.exports = exports["default"];

/***/ }),
/* 877 */,
/* 878 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 879 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHoAAAAyCAYAAACTUs/lAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsSAAALEgHS3X78AAAAB3RJTUUH4QERDhcZr396kQAAFW1JREFUeNrtnHl4VNXdxz/nnMlKAgUskoCEJaAsoigiIAraGq2xFkVxZljc6laRzeUtLi22FK1oJa60uFCBmQFxoX3jEmtdEYrihkHFsCRAYkUQEhKyzD3n/eOeCZMhCSEk6PO8Oc8zT+6de++5J+d7ftv39zsjOILWZ/46Nk0/tfa834INKULKFKRIllK2F1L1T42TiUM7J/Tq4JGqtFqvSFZiT0Z7j/YosT9Oil1XD+3kAMx9Zyd3nPVT2lrrNNGch3rNW8OW24a7YOd8nCKEHIcSZ0qpBggp+6BkFykESImQEgdBpzhFskcQJwVJHuEkCYp7p3jW9P1J3PqwMUuvGdp5M8D81d8xfcQxbcj80EBn3PsehbNG0Wvemq5I+bCUcpxQCqSUUkqMVEgpEFIhpADhHiMEQog6L46TkCiEGd0lwfTpGPdpWZWeMnPkMe8/unY3U4Z1akOnBZts6o09Zv8LAOOEMzPmvveM0boEbS7TxkijtUQbtDagNcYYjNYYrcEARoMxmKj+DBDWsF8b8WpJpVy8sXxIcYWzav6aXXm9O3pGtEFzlIE+7s5XACia/XN63PPGPGFYi9FXGm0wRrvAau0eG4MxUWBbkI0xtWBHNw1oA0JAlTb8Z2c1731Tde6qbZXvrsjfuzxy3zOf7m1DqjVVd/ptKyme9yu635HbTUrP60ap/q56lkhXXbt2WCmkVCClEVJWSSXDRsitUskihFwjlUxEyMFCiJ8i5SAhhAeIj7zfIyAOiJeCBClI9kj6to9jZPcEKsN0mTy4w85gfhm+galtiLU00F1nPs83fxlH+u3/GCGlXCE9nnSEBCURUmGsoyWUQkjpoNRbUqp/CClWFUwdsq6hfgc8+6VCJA0VcBYwBrhAAEpAvHDBTpKSZCVIS/ZwZveEqvaJnokX9UtZ8dwXZeKy/qmmDbYWAjpt2nOU5FzGsTNXjFDS866QUkmlQCmQygXYgmykfF0oNVUoVbjllmH7I31kPvoZBVMGx4C8hQ2Te9WeD1xcmABkAE9JGKUExAlXqtt5BKkeSZdExdkZSUYj/nT5gNS7V3xZxqUntEn2EQOd/pulFD8+gbSpy89AyreElEooJVAKWQdgVYCUU4ruHvMaQM/7VrH1t2c0eyADFxeOU/BgnCAjosLbeSQpHknnREV2n0RqjLhubL/Uhcu/2Mf4/ilt6DXXGUu/fjHFj08g/aZAutD6RWGMB2OENhocxzpdBq3NAow5rejuMa/1mPM2wJGCTP6kjOcxnOzA09XaUK1hv6OpdAxl1Zo3tlZjtMl5bfO+vm0gt5DqTr9xSYmQsqtRHowQCClBKYRrn3+9/d7sp1pzUEOWFF4bJ/hbgpQkegSpStIhQdGzvYdTu8ZzYd9UsXLjPn7Vrw3wpjZP5KDblQvZsehaul+36O9Gm65u1OsglLJhkwaHK3f8+aK/Hzcrl233Zh+w6eNzKFk+Lfq8O9AZ6AAIDKJ6X/muip179u7/8P6ixgZ08pJCPp6YsfDUpUU11do8KR3UfgxxNZptpWHSUxR5m/etzeqdMqw5/7DX5ycUDPz/luhuVz81HCHfRMpE43rTGCVBKrQUV33z0KWLGuoobXxOEnALMBboAqQAiRgjtDay69ABWzr37Z6gEuLKjeED5VH3vHZBn61ZuQUiLzuzXk966JLCG+KleCJRufa6Q5yiQ4LinB4JOiVeeM/rk/pcM8FOAhJCwcCeH8NiOBrvqwN0+hUL86SU50bAdb1sgRHqj8WPXv67tOkrKJl/qcuU3fUqRXPOp9u05+LN3j3XmoqKR+t7QXxqu5re548w8SmJ8UYfhOdi4Jq87MyaekDmw4kZDFta+Od4KW9PUoIUj6RDnKR7+zhGdU9YVREW54S1Uz2+f/vDndjXgKwGLs8F5oSCgf1HU+K8Pv94wAdcFgoGwkfQTyKQBHwfvXhqnbH0CU+cKbQ+1xiNsFQm2sFok28E9wG1IGfc+x5Fc85nUM7HSkNISPUooq65146mY5/u+4+/5OxwfLt6QQaYBHyelVtwbFZuQZ0LH07M4LSlhThG3FNjzCfVjmG/o6lwDDvLw3xb7pyhjZN1uCDblgX8B/gdcDdwJ7AQWAPcAXzh9fn7xUpdY+ct0OYA3aPNaTPbg8BqIKGO1512+cMAGGMecTlql6cWxrj8pDHjSh65vCL9pmDtQ4WzRgFQumvnKiHlxci6CQuA9t2Preg2cnASmCRjGuU4+gEP52VnEgv2BxMyWDexR0VYmxnVxlDlGCocTWmNZuPuGuKkCAAsWV/anAn5EPhjKBiYEwoG5gI3AmcAv7Gx/eNen19EAA0FA3h9/mSvz/++1+dPawVVu9+ywkfaegHh2AUjS5ZNJW18zinC6EGuFGvLT2uM0Y8XL5j4Vfr1iyl+zFe3t/vXXI1Up2HTkYgDkZqQwqRmpK3bXbBjzv7d+45HiJFADrCzgcGNz8ot6JmXnVmfnWbdxIy3agxLq42hMqzZHzZs2hMGbVL//lnpmRNPbN/cSakddCgYcAAdCgaesFL9M2B4DKBpQDLwY06tmcb+Ua/RWtVmmYwGR5cKR98HUPzXSQfYrUWb6P3wJ/EiLm46UkqhJEZY3jvyJm18H808+6x1M8bc/e6kkzfmXdBndV525nTgdODjBgZ4W71iNzEDAMeYqTWaymoNFdpQrTXv76giPUXOaqkZslIL8DSwD5gc4zBtAoaFgoH8VlDdrRteWW95CFZtCzQgMVKvIF5uj31gw5V96P/01wNqystPFFIihMQoAVK42Skhbi5ZPm1ZbMgFkJeduQU4JSu3oNKqFhO14M47xDL93oHl1cZMlo6mEsmW0hqqwondH3x/d7tbRnYqb8F5qQF2AIOjF4Ft4fq85Ojv7CKIJqNMKBgwh+NhR/UhoiRVRxZj9Lsa6y+yID1Ae2CAFUVwM4q6Z5eOq1c/5K1XDQjluR4ha7NXtcewAVhSH8hArQ3Oy85MrNdDaiTU+mRihhmypDAUNkyoFkIpbVAOfPpNVe++neMGAB+0INDtgeOBRTGTlgastJL+Zaw2sPdkAj+3C7cD4ABbvD7/y8AboWCg7BDgVHl9/u7AJcAEoK+13euBF7w+/6LoPizwxwC/BKqB44COwBVen7/KjuEFaV3x9MhbHK3plpocvuniMz6sj6oEEEL4hBQI4Uq0Wz0iQfBWyfJpe+oD2QJMfXY46nqjXps2fB6G/4a1plobKrWhqDzcLlGJji0cz860Xz0Wc8tI4DTrtB0kNV6f/7fA+8ATwGigm3WOrgVeBN73+vwnRJmI2LYPuMmCmmNBexUosu98GPgq0kdUG2vNzRLgRIvnY8CT1gu/0AMMiX4iHHYYPaTvfyeeddwn8174nNsuGVR7LX9SBgMXF6YDHdzkhiVUVC3YL7Wmnfl0Usa2wUsKd4UN6cIYlIHysOa7cqc5XKgC4rw+f/Ti8nh9/gnAzcArwLoY6YuoUV2PbZ8LzAK2Ar8IBQPrYhbDXOB/bOh2UigY+KweJ+oc+ykBLgoFA+/G9PEEcDXwhtfnHxYKBnbY8T1pQcXr868EeoaCgZNinbFeB+mt1MRNQB2Qo9pg17N2CxBqpVopwpXVa1sL5BOtNtGGL8JAWBuqHcPeKk1JeficZnR5HrAs6rPcxtZ/A94GbgoFA6aJ9vRGC/IrQGYEZK/PT1R4dgfwC6tec70+f5cGpNoA54aCgXdjr4eCgRut2UgHft8Ira28Pn+7WKAzor9wHE3/fukdD2G/EFKihCvVWroS/e3KW1ut5mf9pIzILLxujCtSNQb2hjXfVTodmhlv/sqqvbH2eBBwFXB2KBjY0kR138Wq+v3Ar0PBgBMde0cvlFAwkAdcbImRcQ0solmhYCA/xgGMXjDLgMeBa70+f1JT43lJPRmslJSEfY3lHWyw7KptIZFS1gmvWrk5GggbCBvDfgcqdLPKlh8MBQMi8gGutN+fFPGQm+gZDwIyLW1a3JijZa+9DHwOTKnvfwNyvD6/qC/0i2ororTS4REGMcqjsYlLjkh0pBABq8aPNiugDTjGsKUsvL0ZXSR6fX4ZBdizVmVP9/r8ZzeF5rSTP8CevloPIA2B9WzUc9H2fzMgG1todky7IhbtiICurtFJAG8X1ivY663r7Up1pEBQumuj26+faW2MZS3Q9rO7yqk4UqLETu48a0Mf8fr8cU1Ui11sHx8dBonSUMLk+0PRoHZM0f9+kyft+zqSYgwC81OA0Rn1OrPbbYh1QKrFAYne8eRVrQ10rTcZKRd2XA+6JZixXOAtYCDgbyJw262kpRwG/33U9x5Jqy4OxBxS8vWm/1JsTLcGnlkdkWghRR3SpPvkv6W31kAHLNocWYh1ivs14Bg+a4kYOsK72793NRLvRj/zlT29/lDqPuraxT8E0HXiPaUkH+VvTS/6pmpUfYRJ/qSMUmCzgNqKUGm9bpMQf1ZrDXTDlb0Z8MymVIzpHJ0Nc+tgKG0BaY44S3uBG4BMr88/uwk291PLks3y+vydGlsc9toVh2Nbm9GExVXGAr0bKIsG+tMtJTI+znNQqU7+pNpI7E8IYfdYuRKt3bqyrMZGkJVbcFAqMpYCbdwBM4MxugvU2d7zHVDcwkmNJdYXudvr8/c/xDN7rG3vDLwUse3RYEcxZ2fbOL01Ww1wDNApegzS0m5fRi+H0soqPvxoy3lvbS3r2IBDthwhvnM5bjdzJaUEwzndrljYLc33WKMUaFZuQWVWbkE4K7egxn5MVm7BisYo0P5PbQTDSGNoZ/PkkUvfWIqQlgI7FAyUA/fbr+bWF+7EPPM0cCtwJrDH6/OPiYmf8fr8U4B/WyW0shWBDlkfwFunwqRk+bTS2ISAozUF23cO9Cg1anRGSn3edznwkFSutx2p9UaIDOM4ywjXDGpAYjOycgvW4VY/KMviRBLkuw6hj5TRzky0JpJ5sXK9Ln9SRlkzVVxj4C2x9veiKAdQRLFP0RIrQsHAg8AM+3+86fX5a7w+/zqvz/+upVkfAV4GegO5DZjROJq2w1VE3R8bpwctQ3ef1+df6/X5X/b6/L+P6PF/4lYlWIcH3v9kM3tKK56tz/vOn5RhVHzCX4wQ66NjadcpE2cIJd8d+sg7S857ZdOIrNyC3lm5BSdl5RbMtxTjKQ0M/t76vuz3uBvN1dSEJxtjuoKxuzTdChjjxqSH224GXmgoPIlSeWPspO2w52/YGPjlmMk1dnHMx018XAsE7YKoBB6wdvniUDBQTEyZj223AC8BVU309APAXxswPZcBd9nQbzCQVrt60sbn7I3Qm+7EOtw/Yyzpx3ace/7xHe+sxyljyIu7E/cVb/+uprS0nVO6l3BZGbJsH7piH8nHdq7qde6wBOlpUuSzPC878/Ks3IJ6s1v9HvmkvfHE7Y0wcFIKhFAgxfYNV/Y+bsCzW9kwuWeTvevDyeU2dG/k3OvzK9yCijWhYEA31GdMSdJ04CHLyDW7CvRwnpNp43Mix/9Tx/v2SB586nXilZr+1tayk2KdsgGLNvPxxZ0qtWGAEWKVsBWj2M3v5SXfJRSv+Xy/VLIytnAwpn0NzKgP5D4PrWPg/A1CC/FUbeWL0ejIMXoq0GSQY5mrQ01SY/dGnY8CVjWSZIiVOA9wHbCxqeNoyvgOCXQkd1yyfNoComq6pBDsLN/PwsDbyVLKxZYpE9HhTt8FG9g0ZXBRfOeuo42QM4R1zIQQCCX5vmBb0tf/fE851TVVDVielcDpedmZxbEg935gLZtmnEollWPRepzRDpg6m+3XGUe/wg/f1gGfALd6ff4zGwqvokBZDvQHHjracXR0u6YueSJ4J38L76z+6sT3tle8PDojpY5X/PUNLl1bWbTJ2fbHrPnGmJ8IIR5Ayg3ADoSoKP92t7PhuX/XlBZ9uy1cWbVbh52NTthZKYQYnpedOTYvO/P72JCr532r2HzrMHrNWzNIaydgtBGYiG3WYIwxWi/44pp+lT80yqFgYB/gtQ7qO16ff7INtaJVrMfr82d6ff6llix5NhQMLDiadWfRNhog0YYAI6IJCQVcdcHpXH7J6c+u/qDgquMz03Ssg5Z+60sUPzDWPZ64UJnqiuNw03HSaC2qyyqqk9K6lO14fe1mdixskJvuMedtiu4aTc/7VvVGyg+ElJ2k8lgWzt3RaZT8IDElacT6ib2dHxroKFvdy3rW2UABkI9bWtXZetqnA6nAlFAw8NjRHudBCjVtfE5P4KBcrDGGq84fxoXnn7zqjG7Jo1p6IMf9Lo9tf3D5low57/RGirVCys4oj8u+qUjyROHxyI5f3jBoDz/C5vX5L8bNT4+yciKsSVwG3B0KBvb8EPu/RAzIlCyfRtr4nEuA5w+mpgyXn3sK2WMGb+rYqd2kocfErba2u6EESNNAjtq012P2G5cKKZcgVQJ2/5dQEW9bGqTK3jT15Ff6Pb6ejb858ccGcqxn3g0oj97j9UNt8qtPoiNg/x6YfRDW2tCjayduuuzM8hNOSP/f049N8B7JALrd/g923H+RC/hdrz4tlbrCCClF7SY/92espPSAkndunjF0buYjn1Jw80n8WNuPccdmo3FP2vicZzhQeVGn6bDmopGDKsf98tTExIS461JTkl5wtLNnWJeEWrvZFEnvOvP5ZKU8P0OplUopYax6rgVZ1O7Nvm/rbcNn9frLB2yZeRptrQWAjq7LThufMxt3M9pB91aHHdonxOtzhp8gB2V03TR8aOYbqe0TPlQe3umfLL5q7MXpU5edboTMRsoLhFKnCiWRQtX+GE5Ebdu/v906a9Sfe85bI7beNrztx2paUqJjwPYDSxvryCOlSU6IEwO7d6kcddrxJYMHdo/XxmyrqXHKd+0u3wg420r2JL/58ZaOG/bsyxJKeoxUCUTRp0IpZATgSEyu1IWFd4/JPdLfSGkD+hAtymYPsmAPbuz+sNY4YY1jDFJ5SExIICkxnrKwg1QK6fEgPe5PSbr7tmx1ipVkKSXC4wEp3xNSTiy659zCjD+8SeHvzm5DqzWBjgE7AZiIu5e366F6FkJZOyuiVLIEq6JRLshGuvSpkAqh1DdSqRlI+eK2P/2iqsfsf1E0++dtSLUwM1Zvi9piU1WyfNpTJcunpQG34+ay6y9QM2CMRjhObaYJo92Mk+WsjXa/F1prYagyxtyqw+GMbfdmh7TjVAFtIB9NiT6EtE/E3VR2Mm5RXZ1crYhswFN1pBbjMl0fGyXzhVSvVDrOsl1PTHDaIPmRAR3jrAH8xFJ8fS3g/XDzob2tc7UNKbej5AapPIVGynwj1V6kLitecIWGA79Y2NZavv0fo/s8LS4TWSEAAAAASUVORK5CYII="

/***/ }),
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */
391,
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1235);
	__webpack_require__(894);

/***/ }),
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1236 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"adBar":"_36TMjv9Gsp6JNZWmwEogJX","hidden":"_1Be6DAkK8IiHD4AnuZzXUZ","content":"_2fORKzscqPMBc1qZ79R3pr","button":"_1zugxErfJrkINgusB2Daey","closer":"_3Dg101HBf5MQJLWCpkXulw"};

/***/ }),
/* 1237 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"form":"_1TS4iTPEFS38knWcUwV1ja"};

/***/ }),
/* 1238 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"empty-space":"_1LU5BLra2GfFsQMG0x_FGN","no-select":"bgBo26AzphXdOS0xF1THJ","z1":"_33uTzRQXv5YSiNMk1Ad535","albumType":"_3JSsRWsCQ4REn0R-3ZtuBh","z2":"_30T_7396mO2ZyyNF7QOU1m","album":"dBw8d-O9KxxPNUtugMfKk","pos-rel":"_2HGlR1eleA2_6048tmSt2p","pos-abs":"_2d4MTavez-g6wuKeotPVPc","overflow-hidden":"_111fCJy3mf5F7mxCa7GlX3","overflow-x-auto":"gWosFhN_ZdOSQxLNrFeEz","inline-block":"_1RY5jfpIkcgRkeD_SmsrR7","table":"_2VZCHI8IippfEzYXtXn47v","table-row":"_3ZbnL9HCRJJGMLUHW3N85h","table-cell":"eCsB2qNV_L9on6ZLYqFSp","three-d":"_3KFY9SzPLS8Rt5ZXkxkO-p","z-layer":"_3pQEe9Fnkb7Wk6Arbdhpmz","ratio-cont":"_3I4S1o6f2v3QttU6rMwWtT","padding-5":"_1hUPTtG5FDMfzIb3_tYO7T","padding-10":"_2_DObwKeNrS8FCJzfPC6Zt","padding-15":"_3J0sFvxjb_WaVd16e0WLFE","padding-top-5":"_1yQqOH9OagkDlo2w1-7zkF","padding-left-10":"_1ahrC1rBkBeDPIrttlzg2m","padding-right-10":"_1V5uUgAv6d2NEYytaE94Dd","padding-right-20":"_1mJxwAJxvgwc8QD8FhpMyT","margin-10":"_1_WcLwXVTS3qTl8o27M6u","margin-top-10":"_3C3KEI4kLDC17ntmk8I14A","margin-top-15":"wMAULDh1O8iDRHsW9WTtg","margin-top-20":"_2YdqzdHDjO9ciNuKiToWC1","margin-top-25":"_4P_OsHxsSrbIoEzQOxYW0","margin-top-30":"_1UuXPhkeTvNJuoNP5EFafC","margin-top-40":"_1tdKMOeDWFwHoeK8JXVoBZ","margin-bottom-10":"_3V-_rI5JiP8Ykh5h5z_166","margin-bottom-20":"_3DwOP5dKEUZCLjh69dvRvJ","margin-left-5":"_2Z6hBKRqmqFp5vui39ezNu","margin-left-10":"VegLNAc6eQBCkR6agSrXl","margin-left-15":"_2CLk_xOxKHE6goFcYsUOMM","margin-left-20":"_2rJBiWOMkkrBtmNErwR7Lz","margin-right-5":"_2LNHhws6C0canoq0TuAuic","margin-right-10":"_3Sm0vc0z-13Lukw_xCsAjw","margin-right-20":"_3r8ypVMbg9QBAss1nXadnz","margin-vert-5":"_1E8g7A7V9Sin0XPnwp-MOs","margin-vert-10":"_1xeh6i1jFNdMGBoG75WLix","margin-vert-15":"_2ZuMcR93X4Sns3U_pNh2yv","margin-vert-20":"zxutveotdqFLmFOXKOzvC","margin-vert-40":"_11zMajseNYV3Tm5qgUe_fV","width-perc-1":"_2qasK_0pfvHVLppa32Tm6R","width-perc-100":"_1TkWrlRpBjTXJzcPwskHWQ","max-width-100":"_2KNWS9SGG2JDV82eKJWcsj","vertical-bottom":"_2uA5bRr6Z7fbPizSEawUYx","vertical-top":"_2puxV5_Q5xPckhWA4MhxCK","vertical-middle":"_3_d8IW2WSYloOlg6kg86zi","clear":"_3omh5DzKo05Us161hOgYao","cursor-pointer":"oek5L-XrMx4P8SstlUSjv","spin":"_2bPkX_q_pghdofx1pa-3b7","reverse":"_3v3Bzk09FNTUFmFrzFxs-_","animation-fading":"_2k-b3EC-f6IXUK5rh2t2Q3","fading":"_3IQvez0ksBHxRi37MY_7xi","animation-fade-in-rotate-x":"_9AGYL2VPTqigsHQImsonI","fade-in-rotate-x":"_12Fqq0O5v9w40XK_3JTmhm","animation-fade-in-rotate-y":"_2Zx-A2pUyajtmGpGqxwQGc","fade-in-rotate-y":"_2Pe5wd9xwBlX-KZMA7HxuM","coverImg":"_1XzEypACxI1NKvuJuX0TD7","coverContainer":"_35Gp_I4hNvF7JByFgjGh9h","cover":"ff-J4YRkJ7-PaEP1ykHG5","video":"Ga5nzvc3Wui9jJgmJDnfm","menuButton":"_2LQSZXcFE6bQfWG90Ke8Rd","moreDots":"_1NKKkTdFT4LqSzCYn5S33p","downloadableIcon":"_3AdOaT44AR2yGf7QYoKeXx","pressIcon":"zweOUykwNpm9qX9I0JXev","info":"_3pGpK_UCuGbdIlOcp4zhBF","system":"_2d6XY5YMxgJO-fl6zo6guV"};

/***/ }),
/* 1239 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"albumName":"_1AaL0tRgQmcTPlOcAx8HK4","artistName":"_3gItD4yo6KAIQJwPyeR_W7"};

/***/ }),
/* 1240 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"coloredInfo":"xk6hmjtHueoCa4nfa_v1-","expireDate":"_1DXk_W6i_T45d48-kII86K"};

/***/ }),
/* 1241 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"empty-space":"_3RH_Jb3XzUb22FohPhIuj3","no-select":"_3neNMtDacD7wxzRYBoHlM6","z1":"_366d44UKlXG-1ANbDtZKY-","z2":"_2Cg0fU2jmzrvEaRVeWOV2H","pos-rel":"_2FwHuKzU-Xhq7Sla3t0YII","pos-abs":"_3tAfG89QstY7KHemmvDqUL","overflow-hidden":"_3lu1xt19WyGhYgsR6CJ9Q-","overflow-x-auto":"_2Bdy65H_WJizkL8X3hIIk9","inline-block":"_3qQI9_u1FYAcsGcMoU1hPv","table":"_1vxriaizZuFK5RValimCXQ","table-row":"_6MAwuKDUKcrBN5p-TWusJ","table-cell":"_2cssUvOHTuywx4KGzGPNu5","three-d":"_3ASh-8V8S7HlvC8xno0PG1","z-layer":"_25iU50ez0nzDvK5Wpetb20","ratio-cont":"z9g6JjPHrt3slKQ_JK2DC","padding-5":"_1FvpG75WLayAJtlUEQh-B7","padding-10":"_3YuwhD0FDNhNdyJCQxVDhE","padding-15":"_2f7o_fVvzh5WlX_y8vVO3j","padding-top-5":"_1L7gC6rrtzYAm-2MQ4zZ5v","padding-left-10":"_1-45Rbar4rW-86S8YLB7T","padding-right-10":"_2Rn3zJDrpsrIJL4JGYNg-k","padding-right-20":"_3HMxJ8AW5nJMa45Z1DFAya","margin-10":"_2aDlYS8GFfrpxB4LkBWmcK","margin-top-10":"_1rUOeI9yAGtVE7XGfn4gxK","margin-top-15":"_2Koip72cTip8RCpbGnD9eS","margin-top-20":"_2jG6GqqMfwCHgfpYHJAwO9","margin-top-25":"_33ej3S2tET-zEuaNRO0Ru6","margin-top-30":"_18QBMOMvTCP9JcOrja1K_-","margin-top-40":"_3sKwv_U5erjvcrWTyZuSU6","margin-bottom-10":"_6Zd8prEsuM86xMlIQdH-o","margin-bottom-20":"ynnNu8b5sKkDE1dAFY9Ir","margin-left-5":"_2EMQyopmQlY_qM3O2T5CFh","margin-left-10":"_23bUk5Pn7Ev22eFIWbu1XD","margin-left-15":"_3qBV-SvViysbemJ0bHRXwM","margin-left-20":"_3lX6RE7K77B1OnYqZ7jBV-","margin-right-5":"_2iHMTkPbTJsqSPjj5Mq9PB","margin-right-10":"_2IQLy-RcGnLdqlz5nzGV3X","margin-right-20":"tPlKocZP4MSHYCGjTHNa5","margin-vert-5":"yv3XgTjwrEG32LvirPBG-","margin-vert-10":"_3FMOM2ftENl5ZX_D5tuoAr","margin-vert-15":"_1RHwtM-slloD1NFgpsA5Va","margin-vert-20":"_3PDr-s25-KcRsioKpvjUNz","margin-vert-40":"_3WscjDKvN9g1loaBrxzeHk","width-perc-1":"_3rbNrLNUnY9Qo4x7d5-Vrc","width-perc-100":"bGFPJxXBD73Y0z4WmQ7Mw","max-width-100":"UXt1JQYG01LtY3QzxAemR","vertical-bottom":"_1qYWQqfYuwHMDUZpyF-GMy","vertical-top":"_3f4cQCQrGl7LwyaIX-DG-M","vertical-middle":"_1WruWK5MNvICrPCzCr6rsW","clear":"_2lWz7SkfwriJUQD8F2JbE9","cursor-pointer":"dgwZcsOnjqGC98WueilKa","spin":"_2pwO9Lp_CFtaeiOSqV4fTh","reverse":"vuSih4Q_HbnsDiu4drq0T","animation-fading":"_3t-cbO8d8LJkxgVYhZAnuy","fading":"_1QKGNEZsq3VZXSe7ndnCOR","animation-fade-in-rotate-x":"_1aJzi34BTTWa8iJb-1IITc","album":"_1hqOnqdq66etOnFPJRnLnG","fade-in-rotate-x":"opx_rXcu4FeqBL7JArdFJ","animation-fade-in-rotate-y":"bHQ6J5mDZpEW4Fee-Sr-e","fade-in-rotate-y":"fbKtwDGvky6sb9yWfRIyp","coverImg":"_2yuaxo_FfDcgjYuUl3ldiD","albumContent":"P5dsXRDYxK7FIxAFn7j1A","cover":"_2aHOiUXvPPncTcl3l5mZgL","menuButton":"_2JpdFmvQVcqXHC_AV_Pcb0","infoContainer":"zPN7n0bxkcZa8p9YQ1bhB","info":"On1MN87t6M1gma8qxxA1H","system":"_1iUv74DaqMIDvsveit5zbB","artistName":"rZluF8bNojxKJhuuzHUWs","albumType":"_3P-7xcPL_y0SQk5NVeE20k","audio":"_3FBWAjNmFuswFnBrgs3EgF","video":"o92ubPyhu0oJAcPwhnB-I"};

/***/ }),
/* 1242 */
1235,
/* 1243 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"description":"_2j3ht9Wc9xGm0j1Tz42gnU"};

/***/ }),
/* 1244 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"h1":"PQ4z8sXwxcPWmyFZ-ctMV","h2":"_2I3UygWpNI6t48n2GkWuNz","h3":"_2PqiaP1Mx7T81uYpsSu9Hc","title":"_1f9iwcSG5kTpKP3DN4_Yjo","margin-free":"otvLdlyx2yHMzIb8H_xfD","h5":"_11O2Jl37DeKRsgZED1d1DD","hint":"_3xH-a7dQWyjdaDh-6_che-","small":"_37nP3jfT9n5-_nBsIl2ifR","default":"_1uW4nL_KLzBG0QjEsF-1D","text-overflow":"Q2b-Qm6HqagRDHeYls4cQ","nowrap":"oFAl38lGLbPmZdHNtWW33","break-word":"Q8Qx7H3m7xL3j_DLObqw-","u":"_1YAhb7-S0HP7_mL80kiCYv","underline":"_1OMWh_1zJEC7QQxeRonYmp","bold":"_13q4XbxVFtv7Br23w6Aifr","b":"_2zTQlHm2xLqAVM6gg6ZGd","italic":"HpKLgTuBBRkVXrbQGlsHd","upper":"h70zJVO_Q5p0Zq5WFMZTI","lower":"_23RryYpdR2YW3F8EUVrujb","text-z1":"_20iTrAwrW6xOoEdK2qnUmR","text-z2":"_3mqdcpdK_1I58-_RnM17oC","disabled":"_3brCxz70_zRKK3TbuWevmS","error":"_1Qc4i1o-a5NS9ndaS713fV","danger":"_3y4Xopfd7ylpOkvHc3V9Vm","colorLighten":"_1oI1y0gS5x-A_BnMGIr5Hv","colorLight":"_1KZJfUf91CxpYKdGXJQUEu","colorMiddle":"_3jF2LeYy2cwiXlNcxEwGD8","colorDark":"_3C6GHicx6OKYuwNhP1ggkD","colorDarken":"_3cBx-QIe87qrZzfB2aRORm","colorSuccess":"_2nKrvR98bg4KiDvUM_fEOr","colorInfo":"_3rpZCYCFPLVqh_4yAfXh7F","colorWarning":"dKB70wo9DO0hqR2otaoN7","colorError":"_2Yv1oeI9XaFJfR0WsUhOJI","colorPrimary":"_3EIewpUVeP-o2kuxKHApWi"};

/***/ }),
/* 1245 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"empty-space":"_1CuZClcTHWkPG1HAsE67wd","no-select":"WJpbIe8FqDI92iLcMEz2s","z1":"_3ylBT0GZrcLb367FO8y7yW","z2":"_2OnWv-4u2TTqOcLgxVUIP0","audioPlayer":"Qz9neMlurEvEU2jjNI2kB","full":"_39NEk60FgBnvaAUolhOPmF","pos-rel":"_2Zgbf3kFI5KMQg8d11vqAY","pos-abs":"_32C1hI2Wbzzu_NB49dc_QR","overflow-hidden":"_1MXvKkYJcaa_k0p2UGqcvr","overflow-x-auto":"_2I8XHu0E5Yatx9jh5KfjfI","inline-block":"_2TuL2PnRummbydONWfu5zz","table":"_3k4m7Yw-3pJpP1U0CxhMVq","table-row":"_2Bbw44yukVLaS8tg7iB8b8","table-cell":"_1TKRkuQc1UD3iLJeWhCxFe","three-d":"cd-2qGAS5hpokEH0cZkFZ","z-layer":"_3QI4xhN104FIzhWb_9rJX9","ratio-cont":"_1fMOMg3KOdiUm5nPbcZotg","padding-5":"_12kE7-E2mQ4FfjGDO8oVBk","padding-10":"_30v20oOh5UsPaZh4H1ATw-","padding-15":"en96HG13lOPOB_fllXsNu","padding-top-5":"ZSosFeulPZdJQM3EO_0cG","padding-left-10":"_3aF_v54rIvRSTvQhCHhj-R","padding-right-10":"_2ByH4UXxlk9UOVEaESeJE3","padding-right-20":"_268o5ee7ZQja1M7EjIsHI_","margin-10":"_2oVmiU36pLcxm4o51c_VJ3","margin-top-10":"_3tU6fjm0_oUQYTtwweMFQ-","margin-top-15":"_34ozdsFzUUvvs0_uEOao9f","margin-top-20":"_14eIUDCq19sorb4-1K3geo","margin-top-25":"_3O41AFuA0_IVYBJHPZuYYq","margin-top-30":"_3pjGNXwXEbztezN-enKX2f","margin-top-40":"_2LSajQ5CUlXngodRfs0Ba1","margin-bottom-10":"_3-ZwfJjUzc7CQGtkcSp9NS","margin-bottom-20":"_3Wv7s_91qeE9Xw_tuhZNaD","margin-left-5":"_2vttXhNht__PYUgdwVTrRH","margin-left-10":"_1tm8gqLkVi-ZNpA9ptAgzA","margin-left-15":"_1nRTbXLfg3ykpK7pe-k46r","margin-left-20":"kUgooDjZtyoPulkMLYmFQ","margin-right-5":"_3CTclxuA1_Z5AUMJsYul5j","margin-right-10":"_2yrknCCMECWuYrQ9SnBMMF","margin-right-20":"_2e5k-stgRp99YS1QtfPK1u","margin-vert-5":"_2G5U4mOwu8SLfA5uYtnjuD","margin-vert-10":"D2mcnLC8KPzPNGp5fHSjR","margin-vert-15":"_1axSfquTrDWxyLSj-XIXf","margin-vert-20":"kKadYVN1g2EPWTcPaHI_D","margin-vert-40":"XURaJ0PsgoODK67tLJqd2","width-perc-1":"K5pTXRMKwjKXW33IHpkGJ","width-perc-100":"_13ZTmSkLoLr0ryL2_9T2cW","max-width-100":"talm-4ehVRxprMEUW78Us","vertical-bottom":"_1-LKRKWVrLGcDBvDJBoh8P","vertical-top":"_1C4v8C1SG5jqqJHDtVttI8","vertical-middle":"_26vvK471jPKhZyFwUsr1Ak","clear":"_1wYHOmSralOK-p6ykSAOzM","cursor-pointer":"_3iWYkLYq5k-y7BVwb91KJ9","icon":"_3ciJDVxELtgVVh1_H6n8eR","icon-cloud-error":"_3hY8Vz4YW4_y_2kZMpAiJD","icon-admin":"bqlsc7ZEhHD-_RqTF9V9y","icon-info":"_1F9xDu1Ho8XO1DeSgkU6s9","icon-info-outline":"_3GPoWZ5lXqDEcJWP-eVsQj","icon-text":"_1hmdtaguqrTzZIHyHzhyH","icon-background":"_3aKB10w0x3DagrTHr_-n1f","icon-add_album":"_1tvNg2vcrJMH3Asd_Un7AB","icon-add2":"AD7U6LxgtDSq_87lezOD9","icon-color":"_1CpAGQVzIbrAi06z1L1ZOM","icon-image":"_2qHpVlickTqYP9wwhk5xh9","icon-tipe-1":"_1l2xuT0pnA1YZO2lkZCyu2","icon-tipe-2":"_55moW8Q4AG2Yyv16Hm_Qu","icon-tipe-3":"_33j7bmVSlzsvU6t350FSdF","icon-control_point":"_3kHc1VfwnhYcvA9aSTBjn8","icon-chart":"_1qZb6XATQP1gU_XuPD15AT","icon-check-circle":"_1Pp2SlgSbAwtMC7Ja-R1II","icon-circle":"_32JpWJ5ZZf-wd_4xe7S5tA","icon-checkbox-thin-unchecked":"_2Ob_n3tEl989sp37YCGJsR","icon-arrow-back":"_1UtWzQ7B2l-G2WZZ9tv21R","icon-sync":"_1QoydXuMTeUWjnY_QoFcfE","icon-add-box":"_l0DnejzbAwLGk5yXufM9","icon-chevron-thin-left":"_3bZhzgMsrm3z_Itf8KFQ6Z","icon-chevron-thin-right":"_2E67EvQmE5NhtbQ5UCcxrV","icon-download":"_13bEswxMLf5ykpO4imb-5E","icon-paperclip":"_2_8cLYilg_jIErY4MMj9W_","icon-media-all":"_22dempUqc06lEXJdGXY-Ye","icon-newsletter":"_37wZN0VEFFeJgzWdoU9dnp","icon-video":"_290sammrlZEzl8ouMONkcI","icon-sort-alpha-asc":"_3bUx6o9BuPTV-Kv8crvTRE","icon-sort-alpha-desc":"_34tGYMTOBhUyL3BUy_SHzV","icon-attach":"_1NqFQZxRMeNy5GQEejLIT-","icon-collapse":"_15vd2tZAh1dRdZU3tq8j_3","icon-zoom":"_3H7wtaAkb1Q1uD8FUAmKN","icon-previous":"_1BcTYPPuH0tz3rN1wJxKri","icon-next":"_16IGb9dQImsT9qg_P1DOV_","icon-pause-round":"_-0td2erSVH6oRVZmla9XV","icon-play-round":"GwUAKUbu_trXYTU7YyYVA","icon-sound":"_1Rszccb-tMRQxRkovJW19H","icon-reply":"_2niln-HbODJI-upTxwbwLH","icon-chevron-thin-down":"_29t-ZMHOqyzzuNKkbz1Iam","icon-chevron-thin-up":"VD8gxQhqeEMwMqS0Tt2Vz","icon-import-export":"fXWFbrgPHm8EGldnGzST","icon-drag":"_1phWrqpyWwGlY31zDU9MtK","icon-music":"UeaeAbn2IF_4ujcazZdWP","icon-paper-plane":"_7aaRb22ohUHz_nyouyXUS","icon-lock-open":"_3tnzdsIXjPfq7zr5wvqwBj","icon-radio-unchecked":"_2FXTA9jJvxCdYI3dVKyEP-","icon-radio-checked":"_3AmFtH8a10Gj4w5jLih2qn","icon-upload":"_1wawVnjWTav-HdqzT8YPUA","icon-add":"_3BigXjGBGW6xm0qnxh4WdP","icon-remove":"Ygv_F_3jXH59sqKYhhFWg","icon-mode-edit":"KuokRzY3YD9vk0WXAJ4an","icon-search":"_2icJhPf-8KNTIhDuYGGrli","icon-grid":"_1vN6bxDYWvJlu1uTO6PcFy","icon-list":"rciykNaTVbn0xgkto85Ic","icon-chevron-bold-down":"k7pxjHmyBQ5BV_Tdsk9TC","icon-chevron-bold-up":"_1eYzy43hRmSGDraYhdErcU","icon-home":"YGpPCTePLOBSArHPkkSpl","icon-volume-down":"_1LIoJ5AedoBA1IaON7geLk","icon-volume-up":"_1g_iVubgFA4dBbnQHcUUjD","icon-checkbox-checked":"_3sHlfKYRxXodjvkRJG2SFW","icon-checkbox-unchecked":"_15XCh6bVCt47Dknz2p_Pty","icon-priority":"_2C4BVtE6TEb7NJ9tfHANjz","icon-check":"_20xr9Gja_U8sK2KUfsgTkE","icon-close":"_9vsGqbqh4R6OWrJNcD_bs","icon-warning":"_11VwdL7ur1NOYDffmAB_Nr","icon-back":"_3zcvUUMgbcA7zFHdvgznJC","icon-order-down":"ojoRnZGjFApnlVaU4qY0q","icon-order-up":"_3Wza7MKMOVsG1ZnUNv3Z-0","icon-menu":"_248YW59BIcXJhlHUGngH8O","icon-delete":"_1SG8FaG_gdmbXaQymbMYFL","icon-more-vert":"xqT3g7LA5jYDZDNklO-h8","icon-more-horiz":"_16AD8q7rmzXdxCMnTWp-CE","icon-play":"_2oey9vFrYyaSwHduRVVbps","icon-pause":"_2pkxk3CBUV91euJ-8X0PeU","icon-exit":"_1PXBGGwt8kfaWvlq0X1Yyb","icon-users":"_3ndgLvSPbuWRv_rAaob2RB","icon-user":"_36myLyPK6EO2qQBiTsqzAA","icon-playlist":"_2WlEcM7R6yux9TYSqFSQOg","icon-forward":"N_ZFoadIB7MfV5AXJxVe4","icon-stats-bars":"_1fhlKAUDqPQGOAn21ccgF9","icon-bug":"_2tT0Q5kpZsNvPd-66CW5K4","icon-users-folder":"_2774ivFKTKYwynvtjdMYEo","seekProgressBar":"_1ic8PnxQgLlw6R8gfcdYoJ","volumeProgressBar":"_28vxDP8kTRjl7VttmpcmaE","controls":"Fe3JOBuHjkQamO5oFQfm1","playBtn":"gu11L-CX1DZsqunkF6InX","inactive":"wOHFXYIV7uYLUDitqCIyW","trackName":"G8U229HL7P-6pnvfdcuOa","artistName":"_3N1Kzp6Mn9sUejELdAEpiE","closer":"_2D8qsL9sol1n1tObpul30","coverContainer":"_3_rFyzJXDmWGzL_LPLlOKk","cover":"_2frCDsET7aGBhIWveq9h0B","control":"_2pF85wpjfIWSJEI7dPLmGQ","title":"_14amuvb9kzpPTUMZVr_xPY","volume":"_19zaYy5-FswPWocusE9dVW","volumeDown":"_2Kk18jR85T32vAjsMzAXa9","volumeUp":"_221-3sf3LlyG_Tt800Lzjr","volumeIcon":"_1tQn0AUV8qLqLWoSSLiKQe","seek":"_1tlln2IOtF_yKGJPDZVFKw","duration":"_28WO5ehsSBrpuxrpEiU-Ik","line":"THtKqSCXIduHhYftVAhy5","cell":"_1J4e6BxMFlqiPTsxi5ZM1o","content":"_1qJUHfzVva7xMfa7zdSA49","seekBar":"dMn_PH2XUC2t1h08R51XG","volumeBar":"_6_70ILW6UNisT-a0cqEfh","volumeContainer":"Qo1p9Kr1q3SfIozkULhPn","times":"_3rTEAlyGKqG_VmCm1XUvdI","expander":"_1OkGpAb2soY0Uq7ojz3r8B","progress":"mlu9iYFckCo8FRptefi6W","progressBar":"_2FqjTPDfizueJIexbibFDT","endModal":"_1-SIG7o5Jz9tw8ePDHS2yd"};

/***/ }),
/* 1246 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"links":"GhvXLJiTJ0eUdw_GKevnT","link":"_3wGk-a39m8Tuj1m3F9r4L9"};

/***/ }),
/* 1247 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"h1":"_1jmdJQAv5o5OhQuWnUvw2L","h2":"yDii06UThW8Octx8J80xU","h3":"_3HCLv7QtG4XKGDlxwf_bVj","margin-free":"_29Ga9REKZw3gbhz6u55mdC","h5":"_1NaXJE49JWH9LqunWQJUTu","hint":"_17oLSgQE9KSSjhgWJzDc7a","small":"mw7cih3DPUwd4Rll6c9cx","default":"_1PU5sDunfftAFfO7hkngcP","text-overflow":"r7g8-8YmDCp9jODqa2Cby","collapsable":"jVcipdnOxg9w05baVL-vP","content":"ppPF-fSheGo8QToOewYMN","nowrap":"lmcwXc5yKqe8p6QNqaUwU","break-word":"_2SLRP_I6p5STPbTPymMo2T","u":"_2leq9vVxhIPAGZn5_USXSI","underline":"_1yudHjA5xeEzKbXeScYl4-","bold":"_1h0nTfHeKE9_tlh8Fhxs0I","b":"_12UIa6x77lfoMFL5U52Zmb","italic":"psKygVvPIkHSB-94wjiOP","upper":"_3Pkote3y3CPzk3MD3z0IjU","lower":"_3-DyR1y_GczqYGhXpM8xSk","text-z1":"_21WIDtNuWQIh7C8mzkapzn","text-z2":"_2V1Lq3vIcMLuMRDDyJAyJy","disabled":"_1pQE7awvFo0fetojEeT372","error":"pH255Hjj2wR9Rq73JtKZJ","danger":"_1KRDIPY0adVJOKeG6KhtbA","colorLighten":"_3oJmXR7Ugk8ftLMlidPyKo","colorLight":"bSZywBnSkNgOrS9Ldgh_G","colorMiddle":"_35Yp2NHOISSFtg_AIfljIi","colorDark":"Cw7CfQTQWV919uue2zxxR","colorDarken":"dCbEuHyPQNakN1CBx_LpQ","colorSuccess":"_1AOId9Ad8gmkMjYm5UToRO","colorInfo":"OsC22kWt1CVSELNKuJkFz","colorWarning":"_1vPI5Oos_vM3OkzvffIiXV","colorError":"_31lUqPi_xQYCec4I57cH4e","colorPrimary":"-LDBDpbJQ17bdM0Dh3gxk","icon":"_3H5xaal3-suTi0leEbDwMy","collapser":"_1tmG2WpuykXSTCxpzXLGjU","icon-cloud-error":"_1hAxSTX-Gs-pP48kg0OPtj","icon-admin":"_6RTmOX5U2fZW5zgC4yMnk","icon-info":"_3qyvfYpq1JXa-sFs73pLEP","icon-info-outline":"_1rsxRg6fDKwAMCD3zSlu68","icon-text":"_3NDGX6jQns4brxb4uGydzs","icon-background":"_8EjFNsb0ZlC1Q6cBzDfkr","icon-add_album":"_2k1wDy4BcIdrHcVsYz7J54","icon-add2":"_2X164gZGG0d3aEV5wuYDQB","icon-color":"_2Z3ozr3OVQ5L1sZ1sOHCHZ","icon-image":"_2FzvNpbYgxIjl9eCPUwNPD","icon-tipe-1":"VD8Q6l82YO9ZCVzbhnbCC","icon-tipe-2":"_3gab5fOvymES-wHJc6_Gbq","icon-tipe-3":"_2Zm_RDaYXhIA75v2hBrJBI","icon-control_point":"_131jx75UeCyuhVcEC7_VTy","icon-chart":"_1JAYTpY8Uc9uCvMamCz-Gi","icon-check-circle":"d_xBeBvzZD5kdj-US47il","icon-circle":"_2gn-yFdU5NVIyLXSrss3_M","icon-checkbox-thin-unchecked":"_11qMqYmSyOSCq2iuB0e-zM","icon-arrow-back":"_1gn5Y4FcZxi8GmNRo20Psf","icon-sync":"_3KjezvV39xYcZulT5J4Lvk","icon-add-box":"_2I6oQrA8izmUtGvZCfOE4d","icon-chevron-thin-left":"_1CJpARn4DIbWKdGnionioF","icon-chevron-thin-right":"_2a85hCRP4J7JfKXEppukom","icon-download":"_1htff2qQevmmka5GXMiUBY","icon-paperclip":"Z6Po1qrBe5VZgj2AQaGAT","icon-media-all":"NPcFmW7KLNulYQek-B07S","icon-newsletter":"DFERhGVW7wzAPJNp-qYAg","icon-video":"_30evKFXe4Q5xAkSTAHiqSe","icon-sort-alpha-asc":"_2k16HYHjpYcs9ol1RX0up0","icon-sort-alpha-desc":"_1jQ_3hMkXwoJu3_KOgjvtc","icon-attach":"_J6xbs0wB8cTYFdNqY0nQ","icon-collapse":"_1L5QuLuyjEUW84RLnJd1Oy","icon-zoom":"_2zBDBLlbfPHztnuBsidY5v","icon-previous":"_31K4Q37HIZptl0Tz8cdtvR","icon-next":"_24kFf9pIdOgbTubUhRDf9k","icon-pause-round":"_1H6TNhWHJ5nIntub8WUoX8","icon-play-round":"X4XU2-tjWyVzVaXq1a6Ui","icon-sound":"_3L3IOCeej90fA4xae0aPxZ","icon-reply":"_3VeNNmvAipD0M95rtnk71y","icon-chevron-thin-down":"_1_WZBO3YWEd0oxU6xzOK6J","icon-chevron-thin-up":"_1FfXgCxzGLQ1EahqfEQRiW","icon-import-export":"_29yET0fm4USdv2Df1EJice","icon-drag":"_88dofcQ579olPA0qwZlD2","icon-music":"_2WxlZ-puFdgGNqlVvKSWST","icon-paper-plane":"_2FY-Eo3TsGODfLDIrzQjjt","icon-lock-open":"_3AQzoJjMxYf-ZkXsb0A8iq","icon-radio-unchecked":"_3kL0wTZr8ekiVp1_Ta9RWk","icon-radio-checked":"_1or6hChe_vhQ0dWFZmwUgI","icon-upload":"cBqYxzASD5KksEFkfBI-L","icon-add":"_2EZYUrhzXTH1FqfWltixmb","icon-remove":"_uwdph7R-wntlk-5ep00m","icon-mode-edit":"_1UI7vKVcLB3GbC-yM6hVzO","icon-search":"_1wJkrxY4Y8221F280ynD-Q","icon-grid":"_2gevY5UgwY80jFhLvQ6f4C","icon-list":"_13-GaJyktzZoarqMbV56vA","icon-chevron-bold-down":"_1GFgedOcouPKN_XkzEpM19","icon-chevron-bold-up":"befbpvkMG-gJmwcPrbNmI","icon-home":"_3QIJXr7eArj1BQeWXGh0By","icon-volume-down":"b_bQUF4eqc6TLzQK2w54p","icon-volume-up":"H5LD5VTQt5r_1uIhfcHGr","icon-checkbox-checked":"_1tQcAz2DJGraRrpL3rWAxf","icon-checkbox-unchecked":"_3eg5WgRk-J4Ew9BhfDhWeM","icon-priority":"_1Wb8J8EKvJ44HeL94In2ZP","icon-check":"_30gdKs85vLi4huSIobRqUQ","icon-close":"tlsj0nvwyAYRgv54sB4dG","icon-warning":"_16Yw-1wdUJ4e79vfo1Kd21","icon-back":"WwcIjRQSri934kxA_sH85","icon-order-down":"_2ZEOvnn33ppd-cQE-AKM4A","icon-order-up":"_1Ahglk61_IH1m0MPPMyGUk","icon-menu":"_1mCRvBM1ke6xIo6UipDq1D","icon-delete":"_3iV-PrXmYHO5v84mkky-4m","icon-more-vert":"_247sBTwU-SjUDu3YApQFHe","icon-more-horiz":"XnS8pL9DcSWnQGMzAoxt8","icon-play":"fLJH7O1W1hO-1YFfXykWA","icon-pause":"_1XF_Vhecqv7-d3t6AKfMZc","icon-exit":"_3Zw1wHI25KqEZV5n5q6Yjc","icon-users":"_3eIVnG7lPOBtRqTG3HPILZ","icon-user":"_22DKfUYnuYUlsmWsUzeR4k","icon-playlist":"_3HlAl9eO5HbFDyic7TpEvW","icon-forward":"_3kxUjf04ApqCTE5J1_0LGA","icon-stats-bars":"_2BHh0700OnjqDVOWqxyArl","icon-bug":"_2nLo3Syq34GonpA848Husf","icon-users-folder":"CwLkJuuPN3m-kgaorVXZ5","wrapper":"lwVvRIkGk_yaQ3KxhrO4d","collapsed":"_3UhhjevF8zxnkJtenz0LEQ","fake":"_3Q3isU1QZvrhBVb0-8nas9"};

/***/ }),
/* 1248 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"fieldGroupItem":"_3jW8dW0r65rwLy5w4jh9Nb","label":"gTtEOYVHC1NFw6iMm75tb","field":"_4-mLO6_-2ruVttVOuZtnt","fieldErrorText":"w50Lm4csK0-Ke8vbxoKck","passwordRules":"_2Kg2DGWpMxfEHgANUNbZF5","passwordRule":"fmzcOh7lkU3PCjrxxo69P"};

/***/ }),
/* 1249 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"tooltip":"_3Dfq5xW_vI0JP7s-pwcDGb"};

/***/ }),
/* 1250 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"showMore":"uzioCMpo5mZOlipxZUiOE","text":"_1W-lT7P-ONa33jga6D0d40"};

/***/ }),
/* 1251 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"_2lnEbbphk_09bqQJpvXqhR"};

/***/ }),
/* 1252 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"icon":"_31PPOTAZjhjGRBTd7PZrSd","checkbox":"_2AreIRmO7rikqyAGgJCmsl","icon-cloud-error":"_1lgrmlaPpXSw3frZ_6r_S9","icon-admin":"_33faU8VlHy7KJ-0hGDxzux","icon-info":"_2u-l0BS4g27PgHi_2Bo6D1","icon-info-outline":"_3G3S2SiD0KHXCjEfwPGwIk","icon-text":"_8hVb13fc-w4W84Q9bnY38","icon-background":"_3CCC116yJAZKSG-cE4HdJR","icon-add_album":"_2pT-DmesA9-lUsbET9CGpA","icon-add2":"Yk5uYJLX8Gz1aOH8YuQP3","icon-color":"njLEKDLqTFUCsmJqQVoOE","icon-image":"_1ncIMe1tX5G11ZYBuEX1tQ","icon-tipe-1":"_20mvkQyyczqPMk-PhQQvK4","icon-tipe-2":"_3kNwXRMJr7E0D5ohUYmnxF","icon-tipe-3":"_2Ti8J-5dRaVzKFRMMKw4bj","icon-control_point":"_1vqFOk4A7lQ8bCRwCQ-dIh","icon-chart":"_2vx_fVCIkZB4p9hRj0guF6","icon-check-circle":"_2XbDLA9kKcyP0l23M_iT1K","icon-circle":"_3zIsumrWO7-GxUNTfDlpA0","icon-checkbox-thin-unchecked":"_2R8Op8QdDRFGnhBVl7dJdl","thin":"mgC9wha2f4FSV7f3HsFNP","icon-arrow-back":"_3yfCDq94BzPYF4EWlQNwY0","icon-sync":"_13IGXCSWhXWiC__PPUepeQ","icon-add-box":"_2Za0h_w_4p16NFvjwD5z1Y","icon-chevron-thin-left":"dpWUufeok_cbJqGPCoqfF","icon-chevron-thin-right":"_14YbfAZQ4U6zMInEIA09bi","icon-download":"_1RlCdkGYETtk4m0qVW8JSZ","icon-paperclip":"_6JgbBuKGvTLYd048gEyIx","icon-media-all":"RvJa-mHvV9ZEFlr1vQFbN","icon-newsletter":"_1aPzmO4_SXSjof24UD_ND0","icon-video":"_3nNk088bycTbLvmXEIdPap","icon-sort-alpha-asc":"IIzVP3u99OJ1rzmuiULo1","icon-sort-alpha-desc":"BISujwDdqsA20B9SonsmR","icon-attach":"_2VtOWmZHbIz3VkuSSc6Pfu","icon-collapse":"_1r9UAVaS4ef-2tYE_E_UtY","icon-zoom":"_12hqY4Cwolaaz10btb7tsI","icon-previous":"_1rKgl4mbp2wX_lOHzNcrK0","icon-next":"_2utoSzBCHTi7PuVd0SNcU0","icon-pause-round":"tBSlTeJNAshRkE7BEvUV7","icon-play-round":"_2ZYKbwQDYjmttt4QcvOlmO","icon-sound":"_1Y8Ga8W0AEBDq4Klfo73Ko","icon-reply":"_2tXc7LEyyMpM3RbRzhFxAh","icon-chevron-thin-down":"TLowrKXAidth-5wSdKHLO","icon-chevron-thin-up":"_29ZL3kxrCE0fFUWNBn3cQV","icon-import-export":"_2YFDYi_BdybdeXYtWDC6p-","icon-drag":"hEUR2YY1cpDrXdfkeaWzq","icon-music":"_1_fKN3l3Qp1j6jj9IWjI9e","icon-paper-plane":"V-q_MOO7bg7cA1MoQT78Y","icon-lock-open":"_2VKhd5uS5sUfocLyNxp5fH","icon-radio-unchecked":"_22mJyTY3Y5Pgf24M93tTRn","icon-radio-checked":"_179sFolV60j-E63Cd57enn","icon-upload":"_3aPscFPJBqY9L-Ym4P8Lkp","icon-add":"_2kWtPDO7tE-VOq6vKO8wly","icon-remove":"_2VYB3pnYCGxMAWXnE6L9-C","icon-mode-edit":"zBE9N9tVdLtjEaaq_qNxK","icon-search":"Km5v2h3rFgTiM7bX7SIyN","icon-grid":"C0xteh7Vqc-_e8ifA-Lw_","icon-list":"_3S-pMOrvkJeW9itLUH15Hv","icon-chevron-bold-down":"_3PuiBxGDOqFdClpwinsavz","icon-chevron-bold-up":"bxltWWMOgGLNbrxvfj6_Y","icon-home":"_2ivKRBcSGPjMRAkhe6awN0","icon-volume-down":"_3cSKivOUkDJHtde8Le8MRa","icon-volume-up":"_35x2Nyi2yUr_nE0HNEviG2","icon-checkbox-checked":"_3cfsQaj8AfmiWr2rNTy8mw","icon-checkbox-unchecked":"k3apmlaspT1MZ0YjX70XU","icon-priority":"_3s1IqFVcdf2iyvluBb8Quv","icon-check":"_17f1qfDWPM82gnLB1nUD1u","icon-close":"_3br9rKR99aU3cb7-m5BRL9","icon-warning":"_1vRHnS-k6jzH4hZ5nEQSrI","icon-back":"_3WiDmYaSup-gAETu7XQ5jt","icon-order-down":"_2r4IC3WGXveTI-Tef_zuCX","icon-order-up":"U1kTYWYJq0GnNsncgIrbf","icon-menu":"_31mR-KC6PBe9MRvyMvfepW","icon-delete":"_3jgHntXzf6CxMOHJOVDSw6","icon-more-vert":"_1asIDHYrDFDDdpWIulgiFi","icon-more-horiz":"_2vh2I6y8cpypIkoWOpoCPF","icon-play":"_1Ceh_yhA4IpR2jurXhd6Og","icon-pause":"_3JwsUi32xXovqLjipStpHM","icon-exit":"_3zyBMZVIIluV1KCE7-amzk","icon-users":"_2AHm-N3yCH3nJOw57oCCl6","icon-user":"_2uwWm8Mzhzuq8y4slH_fiI","icon-playlist":"_2v-ofb5rlgm3GbzCsItq3z","icon-forward":"K-O0SvyW5J_MEPHyTXvQa","icon-stats-bars":"_2zSnza6C4hWm4QoD1-r0et","icon-bug":"_2FfJzSK2GpG7BAKpzk8mjL","icon-users-folder":"uoBU0Zw0Nx9xqAdewgQ1D","small":"_2OdYALp8lHrO3SkrDgVmOj","textBefore":"_1nLndT0yfD51IUzCyETeS8","textAfter":"nfWKgMJiJqhOi36SBlnKK"};

/***/ }),
/* 1253 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"icon":"_39uOvcBxDl39-WW6HxnzdL","clearIcon":"_2dQAc-BhSzh4Ko0VMlaZiM","icon-cloud-error":"_3-ZKU6LvBUsymm64-bogAS","icon-admin":"_9PgS4OgM8Ugi-f3aHhyaq","icon-info":"P5v24lLoNX4sWlyW9Ni21","icon-info-outline":"PzkYcsG_MydamGQ6WejYc","icon-text":"VR3tnapQLc9ghlFnc9OFO","icon-background":"_1d0lAMjz9uS8Qm37Q0x440","icon-add_album":"_1g8skRyRxWiRQMTboCgHIf","icon-add2":"v7CBYyyBrbpb8u9-OHnDG","icon-color":"_3whBS9sPCCADgyZwPqGkEz","icon-image":"_3dmfyCt8AvAo6hIBc6Biid","icon-tipe-1":"_37JINfPNaUb3q4mUTaB5hZ","icon-tipe-2":"_3Rb7q2J1XKiH_AOT0RPHCR","icon-tipe-3":"_3M9I6OBh0XRoaVWRQpDrTn","icon-control_point":"_1_L1Uc9ciSCHWUqdnFLwOR","icon-chart":"YKyfCllNU5lX34ANK8RbD","icon-check-circle":"_2sV264zPH6dbyjtebEmQQG","icon-circle":"_3p5FXlVnSKiEYpL4ESyC6K","icon-checkbox-thin-unchecked":"_1648_psbUVIDbUE7Gzp1L1","icon-arrow-back":"_33Km94SsmKzeArMvms03MD","icon-sync":"_3rbsNv32CE-yRNQloLqJao","icon-add-box":"_3rH0v1sh7t4kDVRGqt3NOf","icon-chevron-thin-left":"_20UAYtCGSASIafjlBrXd2Y","icon-chevron-thin-right":"_2Z0UuWF5jfHzZcFGCv5Nj4","icon-download":"_3LwqwIFOQjktaXhDCWOAWD","icon-paperclip":"_2pzJ7r2LkFpkavSGkbNrP2","icon-media-all":"_4HaHG5oYYCV6uJDqICX_B","icon-newsletter":"_2w0Ga80SJ5H76XG30_GduH","icon-video":"_1O5h1lguLLK00CWFo2FSrr","icon-sort-alpha-asc":"Mz9kQzt-cIB2Cy_ReZBwX","icon-sort-alpha-desc":"jw3TRuP-SzbxOF4-ENIhr","icon-attach":"_2913XwHVmyE2KrROY5FCgN","icon-collapse":"HlAOInRzH1WtJ53Q2rRZI","icon-zoom":"_2xhas6S1L-KR54xnxPcKZi","icon-previous":"_19mmcqjQeCBCayVW5i8b-u","icon-next":"_3lbOEjR0Vr8gW0-lZuTDeA","icon-pause-round":"_6Z0sRrGj5luyd-mmPLqy8","icon-play-round":"_3PjnPe2FSx8Tc_QWhN1TWW","icon-sound":"_3uTJDFCLFFU0zfxRNV1kbb","icon-reply":"_2H-sIPX9PVRZzAFQ40czuq","icon-chevron-thin-down":"_3c8h5FlO9GtEsHDYjZGOT8","icon-chevron-thin-up":"_1AcE66Z5ZqhSkml-IqTzc1","icon-import-export":"_3MsYidCyag_3SI7JElaIoh","icon-drag":"_3vGiTzyk5e0bA8KXFXVX0","icon-music":"_3z0s-MCJLt1o9IFcXiTVen","icon-paper-plane":"_1XyP18lEj0OZxS85F516c4","icon-lock-open":"_1D1EtGtZGYjjxU8desNDTf","icon-radio-unchecked":"BlxgpNIfXkaxaditfmnyv","icon-radio-checked":"_34wLiFZvdScKycvbqDrQzr","icon-upload":"_2DEbPf5rpp30UB5diMMffW","icon-add":"_29Egm6kopYEEW62EPLayAs","icon-remove":"_16Hxwtu659PQjlFAeUQcrO","icon-mode-edit":"_2SAMioyRhXQfaQcNH4pcno","icon-search":"_3dUQBXWnvcvv1zCLqDPXUy","icon-grid":"_2UBGJym4usAj3qW6fDfAHO","icon-list":"_67c5HXrcF5pDdkaKfZJRu","icon-chevron-bold-down":"_2rrfm39Ri7N6CJRueO5AOv","icon-chevron-bold-up":"_2i57FDOzXTBktKg0FQTl3d","icon-home":"_1F-KChLXCOcEgz2Fd0CAvn","icon-volume-down":"_1ErJcTlH09X2BymtaBsKZJ","icon-volume-up":"_3CiA77v_HXUG0xrdHb8A78","icon-checkbox-checked":"_2zONaXT9lmER8G7s4_8LPt","icon-checkbox-unchecked":"_1A6SrjVOABh1nlyzP2Al_l","icon-priority":"_2fYeYYpBqpuI3pxD0u0Fem","icon-check":"_22xhNJ6yKDlyXkmHPqz4oE","icon-close":"_3NJvcTJveqks6R6lTohpwG","icon-warning":"_2jL26XOP-U2JD1C56yeqMj","icon-back":"Gmu5eqH9qtG5NSAENKLBy","icon-order-down":"_3eB2VEM2mTrfqaT7uLNgvo","icon-order-up":"_3Va8KolKOxbmkyWbjLuDuz","icon-menu":"_2BWheGYTHDfLvCH7mL-aZq","icon-delete":"_34PT68s9wecUAM0KH8pQ8Z","icon-more-vert":"_1bBu4gg1xuQyrIKDWieud-","icon-more-horiz":"_3jMKYF_7KOJrnlla1YZPbG","icon-play":"_3mDMOz547pBgjMdCvOgZpr","icon-pause":"_4ebbykWSaOahlyWKvFVMI","icon-exit":"_2xXAE3UUa-9WW7yGjoFJdp","icon-users":"_1paUfQcHr2HcKfZU7rxEJv","icon-user":"_3U7983hZ8raodJ_jM2RiOj","icon-playlist":"_2jd-20jrUxy2G4DNS3urUD","icon-forward":"_17KJ_VEZvCfzOD5vjAEVy0","icon-stats-bars":"_2CkhJOC7EDJ7ilcGMrUyn5","icon-bug":"kCgshbjcoa3xwo61fDu-","icon-users-folder":"_2KvWNZ2gKeG_SFugK4_Q2v"};

/***/ }),
/* 1254 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"material":"_1ANBD24xYkkhGwY1kTpWPn","inputWithIcon":"_3S5DjamgKAWkvHKlUNkhej","clickable":"_2mCO8cdJ5ppkyTXmS_tAJN","inputContainer":"_1FwZqDdkEhMiUp3B_ILrbl","fileInputContainer":"_28yxN7zzfvislclZwM_HhQ","btn":"_39Z7L2sM077cJK12KDj6Qr","fileInput":"_1RojA7dNJ53QALb4kFon8z","title":"KHfyjZU1b1UIqjfJHb28r"};

/***/ }),
/* 1255 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"h1":"_1KaUO4pQbIJ7a99lon1-Bw","h2":"_1oy8lvX_E_wWAuhI1cyO1d","h3":"_2zfluudnXCKx7GWDtM-24B","margin-free":"Sx48e292xDDfJlSQkk6Zk","h5":"_1GRpNPRqki8f_LDsOI3Wps","hint":"_2ixOxTsowFUZ1cpbBa-FPz","small":"_1OQ-danr7RPQKKYEcw0B4A","default":"_8XfZ_gzX0XFPAMkcT_TVZ","text-overflow":"hCZGNkN3hTO3KzGTk2R1v","nowrap":"_1rjgHVZOJF7gYzFfZu87gw","break-word":"_7fCAZa55elU7q8kMt0zPo","u":"_3OCqvmIPLd-RhT07Cj3cfB","underline":"_25Umx-GHvCLSoGwZHadpjk","bold":"_3mkDIFMvaxzYBgUKEPQ23t","b":"_20wD9EPd9X0-fH_a-F4wYh","italic":"_21Suc1YyN-LkiIn3xzCiB","upper":"_3j44sA8Q-I8ZlStR0Fl-DH","lower":"Tvs35rfioMIlj3opKdQjT","text-z1":"_1wnS6tOzRpAfieJwH13YNO","text-z2":"_1YSGSvG8n5dAnWWQXQrIkM","disabled":"_27ZffdBEXY0VhuwgrP5WmD","error":"_3C7a1qAPXGyuHjK1ZNRVQQ","danger":"_1-5k8kEba0mT3B8CyVRBsT","colorLighten":"bOrwLEfR49Gw0tjqtFekj","colorLight":"_30Z7gP6QRLKSIeMXvizN7w","colorMiddle":"_3PxVPPELydB1sIS2Mijh0I","colorDark":"_22ButZDBULbBZ8SUX2oy9L","colorDarken":"dk3c_nt4GQohAMi46U-Fd","colorSuccess":"_3ya3aOdM9ILJoT2WHT0cie","colorInfo":"_2lq93k06NjlIfI_6dnCQYa","colorWarning":"_2HLEn1MiAT5aXODR482J3W","colorError":"rxKRBcOxJn3KHWK432chE","colorPrimary":"_3sWNSe0L7mSQPFNK4cOq6-","breadcrumbsContainer":"_1K56RMW-99ZFYzQrq4Uuiv","files":"_2W-_G65nZ2oajy750KqkFH","footer":"_2tYwnyOQiPbOoFfnIMFMTU","cloudBrowser":"_1wZRBVakaysPTkSZSq1icc","breadcrumbs":"_3OcSywDlyTkSfhfLwMBkV3","serviceImg":"_3iZrB3oxnFbYm7afMZRMfl","item":"_1rnqND-JhbiokrKh02HQ3C","file":"_1cMRuCwTrCbUPJrGiBq3y1","folder":"NVehGOc1GOup431mI-L7_","selected":"_1X9FC-eZGecwBlX7hiLoe_","inactive":"_1Py2yEGrn7Ie7scFVQTlSF","actions":"_1P5Gh9oEZhyJTvroeAJdNl","unselectButton":"_3WyeHtpX1Y9ETTXk46928f"};

/***/ }),
/* 1256 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"_2xKPIbL7L77vxup45TqGKo","reverse":"_1RNuHQOlk7p_Sg72znZsme","hint":"_2HkF_ciNPpRAHsPApUTdSw"};

/***/ }),
/* 1257 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"manageGroupsSection":"A9JR-aFMn2ZHPo2H3u5cK","isBack":"GkCI9kVYhr23RLWzRrCQ7","arrow":"_1QQU02w74h8yvALbDj7qZ9"};

/***/ }),
/* 1258 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"bar":"P4OXfi1eIogFDwYCBaLpw","hidden":"_1I-eJgZnsO1Kxm1Cus12jm","logo":"_2XwtzG4wcTtSj1-b_ujRg5","content":"_2fRkG2-CRTW0Gfx24LA05U","hint":"_1Zlf_JTyYyAiYkjlsSi19E"};

/***/ }),
/* 1259 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"cropperImg":"_34-XABPsqm8pe83H_MIvdW","preview":"_3Nsv00OgT9IlxBI--C9Jek","cropper":"TR6qEfgX2Xv036XSFvzMW"};

/***/ }),
/* 1260 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"hXQTlHbi2khaltwJCGMkJ"};

/***/ }),
/* 1261 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"link":"_2xIegZLhOL6bVIyMPNp8gS","title":"_2-wPsF1TvLsXPcfHC_H47q"};

/***/ }),
/* 1262 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"dragBar":"_1G2mUuQrEp1-FapBzPEsg4","progressBar":"_1HiAgh8YXoqRpGw-BiuG-t","progress":"_2ECVh2l_bKE-D0PBTSX4Sv","subProgress":"R32Qw2eA4ZBSrUhV7_gvY","dragHolder":"S-Rklm2ubBJxQcAyVVTqW","dragSlider":"_1F1hn5ETAKnGKzjoJYR5kz","dragSlide":"_3CQmkq5C4hw0mAjC8j4pIy","dragPoint":"_1_m1cXxRZ1HRWz3MtqChcy"};

/***/ }),
/* 1263 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"icon":"zUpujgNBgQqTfJjAtChCl","more":"_2ace7pIQmYuXCvTaPPd2aI","editIcon":"_1Es1_3JL74rILFfw7VU-pz","icon-cloud-error":"vgevtnRILjnkWPd3JVrVq","icon-admin":"pe2feRkfOTeBWcypyZDiY","icon-info":"_2xaaMs4ERpY0CvaKRZxRcJ","icon-info-outline":"_3OFyVl4c0IFV2me-9NY2IH","icon-text":"_3Yonwkzw0ksLfRDDDtah3","icon-background":"_22MardNBqgoLEPZGHM6aeo","icon-add_album":"_3qC69PyHkX_lXUwj580i7C","icon-add2":"_1yhM4yXWYIQk0SZ0c35dAu","icon-color":"ieH9m_fpzVBkVlcpJX6Ar","icon-image":"_3AZcjyv4LvHVFc2aMBI-LB","icon-tipe-1":"_1vdzzigoar9rELVFde0IuY","icon-tipe-2":"_1YlGeBSZ6dnHeSEjNiG8al","icon-tipe-3":"_1AZMmAfIFIc-1ev0Yidpl3","icon-control_point":"_2K9V5KriMrIW_7lgOdOu_M","icon-chart":"_1Ihj0m-xnzyuDzoOEdosp","icon-check-circle":"_2gOwxPH2Qh1Ho3TMBDV8CL","icon-circle":"_4Sq65UUTV00Z6biJgvhL_","icon-checkbox-thin-unchecked":"uFsvS81qImGoQYZGkOCN3","icon-arrow-back":"_1R0Axj4nSlXqqHthETr7yx","icon-sync":"_1o-wNlHG--6VQLM8E0FSzh","icon-add-box":"_3Ff1YVN_s5lAZCTMNhJvtt","icon-chevron-thin-left":"Cyn2mNZZcmU7XmV82aNfo","icon-chevron-thin-right":"EcNz7LYgOjThxqyLBCF5L","icon-download":"gXy4KI_efmnxhAV0qBHXC","icon-paperclip":"_6vevl2hu02IfwJHXXgycl","icon-media-all":"_2-BgVD9-RiK6AIYi6DvgOR","icon-newsletter":"_1vLLXFs7UC-uH6PWoXXAu4","icon-video":"_2VDkyhRW3sopwEZJaVfPFY","icon-sort-alpha-asc":"_1sVJbfMOedcRC3Y6gxuqO3","icon-sort-alpha-desc":"ZDAD3JFSlWLZmljEdxntg","icon-attach":"_1bYRZo6idkiDiUmryQOqE6","icon-collapse":"_3VsvLGkS_w-dMO-sxcqDPE","icon-zoom":"_2U975vltvJsPtxeEO3RMO1","icon-previous":"_1d7gNfI3u0gDFB6mJT8b2n","icon-next":"_2VpWi3UhCgtJiXJxlv7UPC","icon-pause-round":"EzXB3TO3-jVvnTPxgcA6S","icon-play-round":"MemfgMAdQ-_a24msYQT5J","icon-sound":"_18a4czufhy3K9rLDuEjt1N","icon-reply":"_2fVos3kolzvi38lY3n6xHD","icon-chevron-thin-down":"_1QCkEvFJobuCGvQ859uVU2","icon-chevron-thin-up":"_3PbL7tW8gs3zIBvBf0MEU-","icon-import-export":"_2DsMapmiDOD96Aj4Ui7DV9","icon-drag":"_2_g80Cv1FTTz0IgkkmXMpp","icon-music":"_1jjzZ6s4zdBaNV5Fw5tdhW","icon-paper-plane":"_2TMl_bmGF_mJ4sLMdEGRov","icon-lock-open":"_2XzwRUmZMHYQ8FIZh8zi46","icon-radio-unchecked":"_2yLUKqSiSkOYMjJwFmkBzH","icon-radio-checked":"_2CMBVa8LvvWFdozNR9C_7K","icon-upload":"_1w1puFwdh-58G388KKS9s5","icon-add":"_4HQJN8hqBwzt4awOXorBw","icon-remove":"_1Ch0UiHX3Cs975ijERrkv7","icon-mode-edit":"_2lvfDuf36-zXuDpfJNj7QH","icon-search":"Jbnn3F-MHo2bcJoo64UL8","icon-grid":"K169vKFR6W3JFTekDr5vh","icon-list":"_3ECNKmAoy5ZWS7_VrFTY2Z","icon-chevron-bold-down":"_3DA7VntrvYliVB28TDwz35","icon-chevron-bold-up":"_1mCLb_I5w6H_SpyW0isC9o","icon-home":"_3Sy0Qtj7-QTICh2rWrKIMS","icon-volume-down":"_39Utjm4O3iXdJmSxMCYPuq","icon-volume-up":"_3SEeGL2V0r2VT453snhyfH","icon-checkbox-checked":"_35KSx8lrsSxk444r26A34o","icon-checkbox-unchecked":"_2QVOz2CTpMjJ2ysTiktkeI","icon-priority":"SjBpWjqEX5XJwo__BtD3F","icon-check":"_18khwUpDmoJ9jn94hxdfK3","icon-close":"_2asoXoxL4vUE_ZM2MDHTSv","icon-warning":"_1yq1pwexlg_tQ_K9shQ2MK","icon-back":"_3NQjh9r-Kum-dExwhsmgf_","icon-order-down":"_18TcWX0O62KpLwmvoNmWzt","icon-order-up":"_25UoCcRPVKGhqv0_kBotBV","icon-menu":"_1YJjorQ1LghSE4HjFwGCAK","icon-delete":"_1w4Pgv6bZzzg7Q3RIgfvL8","icon-more-vert":"_3cS0vUsZsyI9ouckGjrKn9","icon-more-horiz":"eWtgACSiMlSq6KaBulVda","icon-play":"_18ATZP-rb8p_RMtVhb-Yk2","icon-pause":"_2LG5E_V9-00NV-iBHvyblK","icon-exit":"_3sbj2Gu6zU-_TSYTdu5EcN","icon-users":"lBKGcyRnURSAElYGb_w7i","icon-user":"_1TsRIvVXYohRextHj0hd6T","icon-playlist":"_2U8ZEDGuQIhOEmJGA0-lnA","icon-forward":"_1x9x0v5PzQ-uBgSWhl0WuL","icon-stats-bars":"_2YtWyAyyt0Y5HwfHQboQvg","icon-bug":"_1H1Sa8tgOhiKaLucdzl-XL","icon-users-folder":"_2fahYPr2AaAF46If6qzKlc","btn":"PdJm0wjqmHXqqPmJrXUZ8","btn-checkbox":"NbzF7RNmHEq0ZEcK_2ndU","disabled":"_2AUZLGqdk8qAXzTgc-jUee","squared":"_1X1_JMiXCrKLIgeEA23ioV","small":"_3PLQ3oCk3GYJjK_T3BWohh","big":"eU-VVyEg5QfgBkrjSxzlN","wide":"_2JBetVTmxn4I4GYLakQtM8","selected":"xORFerJ0-fOZNOrZDvlHQ","btn-default":"_184uD3N9kqUJMBDxvfVLIB","btn-primary":"_3YTh_DNZl14kZPSsSoM6Q-","btn-success":"_1fcFOom__2adqaowiQ53u9","btn-info":"_3vO_H-gRbaEpW5Hbv2DzaU","btn-warning":"_3RjluUiw2XolCWTn1bePTE","btn-accent":"_2QLHFqHsrHTJwapaY6KQNM","btn-danger":"UrFi8rkXubB8OA7tT0PJF","btn-humble":"_1HtKrl1S9fDSBstl4Ofsm_","btn-simple":"_1R1I1aGE_lFTM_NCk40Lwn","btn-clear":"_2uK7imBfOHgYiPYgZQGp4p","btn-stroke":"_17BiMVAfW4QnXQn4oNk244","btn-link":"_36tMm4ZW5EZHMsFqCCkK8E","lower":"_1jzQH_3fKyWRr-axYYnSq3","btn-text":"_3HxLRZ1bbHcBiNMZNlrn3V","btn-icon":"_3ZW98dopVN0yceEhUeyjIr","actionButton":"dn3vBkSUJrJ834JfwI-aZ","btnWithIcon":"_18ZDb4b5Ymsqe-XCXbWu54","btnIcon":"_30O82K36cbLZPkwjIpMs7H","dragBtn":"_3jqNcctTb7UHQVQr98fzX2","material":"_18wfMb6DD61S8JoQMPUSiK","inputWithIcon":"_2b_4JmZHGKk9QSsIO7uVKd","clickable":"_34-ph1iLtrsYWNkgZ0eNiK","fileInputContainer":"_3W21J6dXNv1WtU9nQdoGNZ","fileInput":"_1h-t4jdjhSVaoTxomWNZV_","inputContainer":"_3vx-UuFmOD0pv1gdd2Cq1v","okIcon":"_1LacYGSuOt3E6I51Vypm3f"};

/***/ }),
/* 1264 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"isExpired":"M6gqCa_w1mBMfl1h4WrDP"};

/***/ }),
/* 1265 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"fileTypeThumb":"TMEUi8EvuLa55C-FdOFOq","corner":"_3bKQ0u34rsdR8HuA-AFqPZ","top":"_3Yhde0rFxD8y1J3-zVpsEv","bottom":"_2ygF7cvMZlcEMKbMBQr5bK","fileType":"_3zfzWW5qVidoUgIWNApVFs"};

/***/ }),
/* 1266 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"sorterTitle":"_13vCdI5FcVnPfnknQBjM-k","responsive":"_3a-C1tINkS4JIC9uYPULFr","sorter":"_1Q7JLDRQcAltoMgWqe5m5x","disabled":"_1kl036dKZIt_xIOHYtNOlc","active":"_17JeF0IhSayzrhAgKtPHCV"};

/***/ }),
/* 1267 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"footer":"_2nhzBA1RlNKOVN_nNggXzW","links":"_1_O8IaVfK6gXqH5Zxy3EdP","footerCopyright":"_2-WgL-99TbCXf4jZwKKvOL"};

/***/ }),
/* 1268 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hint":"Q81up85P1UYviOSj92Eou","isWarning":"_3n8EKHsmklZ6qvIOwgtN8z"};

/***/ }),
/* 1269 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"headLine":"_23z1ewTBn5F_cZaOWlZ5gK","count":"_3FC8iivEe26H2NzIhAUZUL"};

/***/ }),
/* 1270 */
1235,
/* 1271 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"checkCell":"_1uvUTAYVbZhjENTRFbRHpq","actionCell":"hZtr9d6v8cPZ38mO1iht","row":"-jq8JRoNLhwXI8A27em1f"};

/***/ }),
/* 1272 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"homeContent":"_3vQBeoDHPh72HT9vxKSJYS","compactContent":"_2GeQDPTDBOOdSQ09DybPiU","headerContainer":"_3JrGFaT9WLIEVIruGoNHW3","page":"_2vNcBm6LgVTf73zRtwR3KA","anchor":"_3_eb8UtnMn5ftjkdsZyI7L","fullWidthSm":"_1amxSsLuOdmFqCljYJDttX","fullWidthXs":"WCBZ6phgp4aOP08YRlrW2","narrowContent":"_1HANTcC926Felhjir3oHfO","separatorBottom":"_3FC74MWlSFHSGgmfuMCQuW","section":"_1n5nLi0GHWklkd5QwVdlTc","separatorTop":"_2ad0UAAwvF2ILZHFPmp3fy","h3":"z4TPJPboktQvLrPHKzadU","row":"_2ccKlfoV-7-3_qMuTYjnFt","wide-border":"_1v3Atwx4lpGbkAzQdx3xXY","logoContainer":"_1BlVog9a9ATaA_UPo0ZFek","audioPlayerContainer":"uaVIxcjde9s--D2pM0FNj","withSideMenu":"_3C2mqsjaFmWSiGCl8orFVM","audioPlayer":"_3X4jgkJOMSRlWwVZbpC1eZ","langSelector":"_2gIt896_mCwmJMmh9CYZyU","langSelect":"_2uPRDd72mexrE_ZOCtbToO"};

/***/ }),
/* 1273 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"icon":"_2ecKoOm8BX5AMBYlhsrooc","more":"_3MuKX-Styq7TbH-xmoKSP3","icon-cloud-error":"p7618mR_vuetMk7R7gG8B","icon-admin":"_1ZyPpaEx-wwdhzOU79VSlE","icon-info":"_3XQx02469y18g8oqJx0T4H","icon-info-outline":"_3BiAdPBrDDi7tVhSYWA3Aj","icon-text":"_2dQsMK570pPbhdwM7pJMVW","icon-background":"_1jYIoc0oS1MChZ0WB4_T5o","icon-add_album":"_3VpvSyEQ0g4mT_qtogBah7","icon-add2":"_3C4RfW2lt1Ur0G3tv0Yu3R","icon-color":"_1I61xXC9DEc8NEMIx6EvyN","icon-image":"_3E0MjvJol2tUB4bghMGoD9","icon-tipe-1":"_3EuqltEBI0CgOx9fqk8gRx","icon-tipe-2":"A93ghBCNz0K-9edHzjksf","icon-tipe-3":"_1co8tVxiXletztYBGUhD_z","icon-control_point":"_2nOO35iV2cpK_UpN6acK4s","icon-chart":"_2SDRv-F0CoFHNxpbQh1tAh","icon-check-circle":"_2hEel0cAmiQJXyXtTWV1M5","icon-circle":"_1kp9XZJMzUe8WIARKUBE5d","icon-checkbox-thin-unchecked":"_1CR4EyIVhxQXy69exDZvex","icon-arrow-back":"_2VsmFxFFvrorBaPyBM0N16","icon-sync":"_2y-VH7yv-7gSjT1oQVVYgQ","icon-add-box":"_2KPJvHu3Va3nDJnm_yIf5f","icon-chevron-thin-left":"EHg0P7_yx7QaY58N1m1KS","icon-chevron-thin-right":"_2Hg4KtBBCKZXVXz1RNtywF","icon-download":"_2Gcm2MXa3hbv9klLOYooOI","icon-paperclip":"_3SBKPOmedvLl3pwb2Bakoc","icon-media-all":"_4a1TrIIJR4p9_cs2TwQam","icon-newsletter":"_1UMoLoiXyDRKAbRb5Ps48q","icon-video":"_4QvShicFlegD0yAnU-KYL","icon-sort-alpha-asc":"n-B0IqEtMmz6HdK4pzbFm","icon-sort-alpha-desc":"xj5lVIbA5GgPeNjyHldhV","icon-attach":"brMAs-C95SMKjrhTJKol6","icon-collapse":"sy_hfEIT7jQRlf5tgzBuQ","icon-zoom":"izwgeAm6CChUeR0eFgX_m","icon-previous":"_2JPMptrp6c5AKWDmzGFfRJ","icon-next":"_1ADfD2d1V_7Ooo3QtSKPQ_","icon-pause-round":"_3ccpPYpbtRi2QA1LSafKTE","icon-play-round":"bK1FSjl6AKdGjqjIrYYnp","icon-sound":"QEkqsTEfSqeB7ZBnweB6u","icon-reply":"_1G98Scqe9Q9WU_GkZJD8du","icon-chevron-thin-down":"_2rPNJljJjvPxnkJ1rMTDtR","icon-chevron-thin-up":"_2_8kRGBaz2tQzfMjdD_dge","icon-import-export":"M_JYx9kr7uudh3Y6RnTxO","icon-drag":"ex9Qb82dUA3GGKG9tlKAZ","icon-music":"crpJ2Pq2VERZ3dtacnpzN","icon-paper-plane":"Mn32En2C1Rv_eW0yw93WK","icon-lock-open":"_22AWZMcUE0vmjeLdDfk9NU","icon-radio-unchecked":"_3Ar3SlBrqUfK6vpL5vXRg1","icon-radio-checked":"_1uXNs2-PnW1mE_ry662ae6","icon-upload":"_2zUuV667T9F009Q0lihmgn","icon-add":"_2YB-ZNDWQ8I0d7Vm-l3_C8","icon-remove":"_4bjBmzG-5_AjCjahpFncT","icon-mode-edit":"_30EqSQng9iLg-yEokBDkj1","icon-search":"_1rhto4DnHXrp8WiA3fB4b3","icon-grid":"iPKcJnkz4DxRs5A-OgmbI","icon-list":"_7HNMuRzu46Ry7BQ10wkSk","icon-chevron-bold-down":"_1N2tFwHmHhAAwIueKPow6F","icon-chevron-bold-up":"Y3KwuwJhrO55Ja-kDH9q0","icon-home":"_1StSFBT9_Q0clntuRVaL8e","icon-volume-down":"Zxoa5SUJqFirG8hf4wlPl","icon-volume-up":"_182M2-W4UDtAOrx-nid5Wg","icon-checkbox-checked":"_2IA642x0M5Y2syPhek3sTC","icon-checkbox-unchecked":"_1IOfEAvvmvPA30hHIk_1OF","icon-priority":"aKEXDqJfVuciSulGOe0VL","icon-check":"_3g0TW_ygFBvLwpNTekIVlE","icon-close":"_2w38WC1BifAbqOyDDWEYKj","icon-warning":"_1fMk7jdZlmTJsRdW1Svsp0","icon-back":"_3ufzM6fmDtGBETAHnZ_5Jw","icon-order-down":"_21_fPZ4LWwHwWriyR5GjNJ","icon-order-up":"_36M2DEkOaJuRCs7MbbxDpy","icon-menu":"K88g_c4xfXz3xMEpovGwr","icon-delete":"_1KGdx8qAWULtBFjyruuYIx","icon-more-vert":"VawIMYnTZtDZcL_rbdYsf","icon-more-horiz":"_1u0yFWkbr_9eU2lWYm7oBa","icon-play":"_38tBDUeTDCnADBTCyStuji","icon-pause":"_1a57u3U45idlp8NtE7FMoq","icon-exit":"_3CFGWQ6lMOfzn95jyE1PUi","icon-users":"_2mef066E8RLRHXLf0cz4FV","icon-user":"_2geS0aAhX-0DNk46mH1YCB","icon-playlist":"_2xH7zAe6aIUXOfdAEBys22","icon-forward":"_2KufVEHmpEzoxRi4rxnZGb","icon-stats-bars":"_1thUSyOfYOvUjOXDW2d9i-","icon-bug":"_1QlDCjnaapGe37if2touGw","icon-users-folder":"_263C0kNb9ibreZd3rNfXZM","btn":"_1UUuKb-s4KUle1soeDTzRc","btn-checkbox":"GMwKjwXQ1yhoISMVOZEKL","disabled":"_1AHUF-QC25VOPtk9xhN-iT","squared":"_1LvyyVyv5IZ3j7xH5rS47o","small":"_2LQVBzgGRgchI6RRI-2Sww","big":"_2uQsJz3-0suTdMlKrs6mkj","wide":"_34nzVflUJ1Bfc1Go5pMXn0","selected":"_3BquLekRkb2J5_yPtEu2Hl","btn-default":"_1-wCQCEEyuLpqqqCQv1EzA","btn-primary":"_3lJ9sNGhAfn-FbUH55onb","btn-success":"_1DoHByiNl0EJkvUyUk__aG","btn-info":"_13nvWT2uMs7Rmj7kQ4H5FH","btn-warning":"_3oqQUKhX3uvB_b1QmsBNjs","btn-accent":"_3wiCqZe237Z_LlQq8vJ3te","btn-danger":"_1y9JxJav9O7VsIH7oteRpj","btn-humble":"_3JXqXpQfA9BYo1BxvPJdxZ","btn-simple":"_2v9akCmkIAQ90ThWIR32S3","btn-clear":"_1klKLmLA95IQxqgrtZ83ry","btn-stroke":"_2ag4m0W_tfBYcI1mcW31cg","btn-link":"_2183ajES7PiQ73Xb-FNM0k","lower":"_2BQUyQgaj4d8TtWbjEFK9e","btn-text":"_1DFaumQ-xTC58hjzHCaWLK","btn-icon":"_23PCTnz5VM2MhXeewSIjv5","actionButton":"_2M1ncywJ7vQO6HBap747va","btnWithIcon":"_2SA8Zwoa0vi3Pg71fc6QhN","btnIcon":"_3aob4hvn8JAT-ENUHKYOKx","dragBtn":"_2Cw-MLefgvTrAYmvm0rg0o","logoContainer":"_3-Z2pX_QzQiYeIZL0LrPrs","nav":"_1LZPf-9P-MIl4MhSY8McKK","menuButton":"Ytxh5QsXziaCKGwgKcy-g","navItems":"_1EOYoILd6HAMAPyemRzg-B","navItem":"_2ecDhWvb4dO4iRb3stdi9E","homeHeader":"_2j-Zie6vQtJr5Q50fIaoZc","isLanding":"EZHCkl0CoL17TVhDZmek1","fixHeader":"_2NzA_XnNvdoEKR9OF9fV83","hiddenFixed":"_1vV-T15HoMAQDcnztGEm-Y","fromTop":"_27r_OAA5rLs97vaLpEIXJ5","toTop":"_33NZeiSbQCuLBI1ffXMNj4","loginBtn":"_3hl7PkDkgI1L75PoKuTOgm","popoverMenu":"_2ofbNfiRVEcl874jA6uo9d","inApp":"_2IXEt60jgvjKxpjkBQwkZD"};

/***/ }),
/* 1274 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"errors":"_1UqI8P7-8o4ARxx_q6D0b2","modal":"_32dr2e2IWQjw14FX3GCA9w","report":"_1WAAYjAp0LYiCdtxXLcZAj"};

/***/ }),
/* 1275 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"title":"_2c0P-xwhtS9l-OIFJm1Ayf","section":"_2tl5uPDdpS3AEiShj7BaM7","header":"_3GMCEMWyZ5EnLj1LS2Bk83","body":"Q6_Sz9I_Fvx5QRbPVWOLf","scrollSpy":"Y23U5mZ7TSuIJFyAP1vfc","scrollSpyCurrent":"_2zx2vCzqaRRKNUWLmUFZ33","scrollSpyItemCont":"OJWtxQksqxgXHwIk7lxnG","scrollSpyItem":"IVyyy7rGMGdiAgN0zXfQs","content":"_37AbpQzVPBiGTVuFRlqOox"};

/***/ }),
/* 1276 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"privacyTable":"_2yss9eFQt9rEj4bQmAbTDv","header":"_1G-X-Vb-ZUYTD06o2GW60Z"};

/***/ }),
/* 1277 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"langSelector":"_1Cl541lX351DzF3P0GcyfX","toggle":"_1ghjfYrLOhvbxzzPHijWuP"};

/***/ }),
/* 1278 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"_3l4EwibiinSJhaxcsRX_5g"};

/***/ }),
/* 1279 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"mask":"_6hOvrzbkgPOkXw_4H4lB5","transparent":"_1l1g8PDbUoI4ssvrQ856dB","loader":"_9WJ7l1cvdI4AFBCK90SVL","circular":"_2GhabjaXr9eSokvcHKFH0W","rotate":"QwjGgX41LQJWHlrmKy_P0","path":"DHt2Fv39zX0mDGZ_ibADg","dash":"flTmVNUC08P1M6Bwr-jae","colored":"_3uSuAiZ5bbmGFfCZLGao1V","color":"lqIK1GSfwvqGIFm6kdMmd","inline":"mYLdUF8u8HAdE9ezAnIU7","left":"Occ_BiBDCw15AewR0yaID","center":"_3jDtnbVp8DMrEf5j1zph_e","right":"_2CJaQsSmLiSQNvrev3xQ6_"};

/***/ }),
/* 1280 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"title":"_1HT3X1pbjrq0M83odJv5gc","fieldErrorText":"_1P7EOmvn58PylySqtbuE70"};

/***/ }),
/* 1281 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"_3ZAhL_sk_5tgF3cWNTOGP6","header":"_3jVSRvNnkAh7qMki7W95hA","simple":"_32g4u1c3HYEM9vNNfMMx3Z","title":"RQatkhlGDfMPm3ILWutbd","isWarning":"_1Fg7SBENbpnT7szWQGaP1v","footer":"JoXC_aydloRn3nN9SeqEP","withoutBottomPadding":"_4GjcRRIErlLTfssN23Fk3","withoutPadding":"_3q4aOZHtMdfoMW8EXNG1AY","body":"NDJfjTZnotQtCDZUlOp05"};

/***/ }),
/* 1282 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"icon":"_1godmY93uayjMT5usUkJlc","moreIcon":"_15Ezzs2jvUI7aVrlGxtS0f","icon-cloud-error":"_1qemC3grIQmX-unTjOp51n","icon-admin":"uVpGAeQyLMqPzsBSCr_jo","icon-info":"_3oLH6B22sbjnf2jC_n8_zb","icon-info-outline":"JH3v0yMTcRKJAjrsnt5iK","icon-text":"_3xRXiFZcNoFT8MKgS34rhh","icon-background":"C4O_HNc85OLgb6248Bz39","icon-add_album":"_2njudiB4F06PlPi1v-GhCm","icon-add2":"cn1NX0H7xmxQeQmyUpogs","icon-color":"_1B7kRL2A2g1OUfxReqemGG","icon-image":"_1IFTZ5psQ434TDuvD2VB54","icon-tipe-1":"_2m8UvsrtwH-Xbp8fjIdCtD","icon-tipe-2":"_389UjFXdCwadwr5j241lIs","icon-tipe-3":"V4EkcZKltJc5FSaYu_Gmf","icon-control_point":"_1RNOHFMOKRzt4hsjHw9UXF","icon-chart":"_2ULEjcSnF3IXE07IpK0q85","icon-check-circle":"AMcLV320avQxuzo2B01_D","icon-circle":"RK-AxlEMNkbu7UZoPwzf3","icon-checkbox-thin-unchecked":"_1IyqCVKuB-FM0IDR7UPnWB","icon-arrow-back":"Rt82aTdLgJT-gYiBPcObK","icon-sync":"_2xfGoQxjNlXtgyk9rALX49","icon-add-box":"_2t86beVyyjGUYjveZZ0663","icon-chevron-thin-left":"CloA4Ia9ilaMMKvcy1W9m","icon-chevron-thin-right":"_1oMiLqhs-BGyrDfN6F1xGB","icon-download":"_3uIqo4l9PwKkZuuwF4CLvF","icon-paperclip":"_213vkQlSXVQfqAgBtJKpaU","icon-media-all":"_2_EA00blAlFPVtA7BUrm1l","icon-newsletter":"_1nWPxIPebLASZcR7fwSA4i","icon-video":"_1vig9ddl1DQQS63YPEpkYP","icon-sort-alpha-asc":"_2nIwb_5AsgZiCjrczApwzw","icon-sort-alpha-desc":"_27XeVQfL5n7rWcPdz0K2-_","icon-attach":"z_dA7ye5HfRcoYYQCp0l6","icon-collapse":"_3ooJghFD-Bho2VGbpTYAE_","icon-zoom":"_1CkKSJg8adu-lOycog3PiT","icon-previous":"_3mwE5oxqeKtw3U4hN4gjur","icon-next":"_1udNvD_c5y2jWGasolzocB","icon-pause-round":"_1FGWQikDZ30DzH-M-nEGfK","icon-play-round":"_3Xd7j0sJVlWN3EzGcJEuX5","icon-sound":"_1_9VtMwvxlUsTcewmK0OTR","icon-reply":"_1k7Igsl75lpRwUZ3oUSuU3","icon-chevron-thin-down":"_2l84O2czbnp5MKsuE7EODF","icon-chevron-thin-up":"_3j9Bik28QX-HeQ66nNtAuu","icon-import-export":"_3aFD91EAgFT0IhVN0XlOVd","icon-drag":"_3exdHkajZuCks5Ru8BEOrE","icon-music":"_367EyvdcE2SZtPOS_WZi5J","icon-paper-plane":"_2ERcgaT2-dF3ZsjZBd52ZT","icon-lock-open":"_1rDEUFDNoL4qVj1h-7Idi5","icon-radio-unchecked":"_2KGWYyLmIEbvW2zrsBc_j9","icon-radio-checked":"jLLwb0aqFJV-KcLDhVpJo","icon-upload":"_1nccQOlSBVuOdjnRU-0oZV","icon-add":"_14p92uR1xIe3X9udyY_KJu","icon-remove":"_2ml1LAxkPJGY0YutWewnKT","icon-mode-edit":"_2d67Wd-6E-U9gllPrEMbAn","icon-search":"_2j-KKG3pwmux7Ags4Hg0gb","icon-grid":"_1sTZS8isk1btUrzjuEIeV4","icon-list":"_2uGuj_nzffys84LJHh703k","icon-chevron-bold-down":"_1bpdvt9RulFS2-NhMmOkQQ","icon-chevron-bold-up":"_12eF1s21IqGtHy3OByJTLw","icon-home":"_2WYWxd7eEIJyuM-2TcwN3p","icon-volume-down":"_2_bDmWmnsoB9-MOfhp_KYR","icon-volume-up":"_3qNOJ1v2xewtKb8H67V51_","icon-checkbox-checked":"_61-8M9o5RGsve2Dasptbk","icon-checkbox-unchecked":"_1BVTPVY3PcxlwF2lHgogmK","icon-priority":"VnRE4rZV1h3f5ZtsWOjr3","icon-check":"_1CT3NoL7pVyn1ccHr55EoZ","icon-close":"_3ZM5YFICkbexyIghUDopWJ","icon-warning":"_2N9me--wYHuv30NusmORQu","icon-back":"_1JZoJRVshFHe2nGDwqvT4v","icon-order-down":"_2iTiR63t2ZQoxopvS2mxCl","icon-order-up":"_1ZcNR395rtAt4BF_zTxgKl","icon-menu":"_3aflqbd2dKrIsad9eV0WBC","icon-delete":"_1RSKKARXbZZZjS0BWBlkdC","icon-more-vert":"aS0qBGBcAbSM8R64X4Hua","icon-more-horiz":"_1qhmVCdpISQ4hY79dLuM_Y","icon-play":"_1oJMkpCTNFOHomng2_3l4d","icon-pause":"udbX25C5Ic-_d-Dr49Wmn","icon-exit":"OdPhonQLfd2P5feJ9vM97","icon-users":"_16yXqNdYL-QABRvalj1U3a","icon-user":"_3X7x4Oigi5cAMjJ7xYPnzB","icon-playlist":"_1lFHbYip-ebCBytGKM5RiW","icon-forward":"ddnPUHzK3kOXam_X-aM_V","icon-stats-bars":"jPqwjnoMl0f3TtE4NQaXP","icon-bug":"_1KoDbEBt5K8GIiTggliAML","icon-users-folder":"_2HPe5BpLOjovqIu7uhmirO","more":"_3RzjzWgiKW26OFB794KpdF","loading":"YIE6dRzZ_66mjlHLy8khU"};

/***/ }),
/* 1283 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"icon":"_1KGDx9lXbXi_13FgG1V3IK","icon-cloud-error":"_3NS3JjSrB87RliXZgmmXwK","icon-admin":"_2qy-txFmvk9zmeUeFaY74V","icon-info":"_1MfrSIx5g5JkhubFVpD9L-","icon-info-outline":"fqC8mEf8XBPPh2EY12Ozp","icon-text":"_2SAHnXotl-gbUVc5sGdF7H","icon-background":"_2Ht-FuRfQfMn-xQr06xLEq","icon-add_album":"_2ymYzsn2JfvFgqFcHoS5rT","icon-add2":"_2ytfmO7RRpUs_YeIgTv_ZZ","icon-color":"_3aX38tambGWgURob_MhJR2","icon-image":"_3vlrm6ka-uVZA3k3VDaN_N","icon-tipe-1":"_2kQy4v36rai3c4jM8sZ81U","icon-tipe-2":"_1kvUL0Qk87Ww6des4Rp-dV","icon-tipe-3":"_2LyBCvIdtl99AwhfCHizj_","icon-control_point":"S-dvIG5Z50z2GY3sLWq9M","icon-chart":"jrWR9wT6pyuAVQxZTUKBu","icon-check-circle":"_17lzDVak-LVFmNNSPKfu2W","icon-circle":"_3dx4Eu0LnJWtZiAiAHBD4R","icon-checkbox-thin-unchecked":"_4lhKKlNTHSvaqstfHgG4s","icon-arrow-back":"_39SMfMlgq3RVxfsgFME5rR","icon-sync":"_2ocC70mqZqlRri7mwvo60m","icon-add-box":"_11IoxG_V3XEq13RwV_z3gC","icon-chevron-thin-left":"_3cSaR8AfymKp_rHWiQnhdk","icon-chevron-thin-right":"_3ykG7LX9RMrZWdp9GQ4G_3","icon-download":"_3KZXAqGCPk8HuGAic5q815","icon-paperclip":"_2zvLPJycZSLIQ9ffSPYBBX","icon-media-all":"_3mUjeVM8T9Su1amg3vScZP","icon-newsletter":"MOKI3-qgWAcrv8PWF0dLv","icon-video":"_3wzWWx6pqzcXY9aGjAOpZJ","icon-sort-alpha-asc":"_1k78OW0CxuBiq1Ng1JYXQr","icon-sort-alpha-desc":"_3Vdek5BqjM49sjEIDqOLAg","icon-attach":"_1N6jjiDQnahYF9m1H81bin","icon-collapse":"_1tZ3fTfdjm3XHU0wmoVe3W","icon-zoom":"_3hHvAp8si3ZsUpHRHolXeh","icon-previous":"_2iJSEMY6tNJLe8M-NTt8jm","icon-next":"_1vsZ_1UkYabK4p0I7Ta0-d","icon-pause-round":"_1dgzkWVFSmlVB1bp0DjsNM","icon-play-round":"Q3kdpktjv_RatMHVxaKhc","icon-sound":"nVOQ1j0X97Z1E48LgjJzD","icon-reply":"_2ePZYGq_g8FXzcwqEIxBk3","icon-chevron-thin-down":"_3QN4FO--W5LDZ89fXbIb9y","icon-chevron-thin-up":"_1za9-sBYwziVlfc6CmrlhW","icon-import-export":"_25aGoJ6AqFNbxwRrZ2wSDz","icon-drag":"_12pY_y9SL1nO5u10OeuO-P","icon-music":"_2cAu6XLjZybucU1BilRVda","icon-paper-plane":"qAbxuLCJBML8thN7ta0D9","icon-lock-open":"_1YiRZyHZ7ZXxtfZYYhO--T","icon-radio-unchecked":"_3NjLnTGNiLjbiXkjbiOE8d","icon-radio-checked":"_2mhrZlGcOxQhL0mugrHjgf","icon-upload":"_3GP_XyhV6_F45YTYj1h1K7","icon-add":"_3SkHlwZCVe-iDVUITHH1Pc","icon-remove":"_2MI8scfFmRKyrWRbOq43YP","icon-mode-edit":"_2VGMGuIXgBQOBdOYAbAnu-","icon-search":"_2OXypel9jnjBLHunZxTKPR","icon-grid":"_3wMHisD6V9Muzf7hQZzCkO","icon-list":"_12oDXIqu42hlXKkr5NpRXZ","icon-chevron-bold-down":"_2gqBNkkAy8PmJ_RXDfFEKp","icon-chevron-bold-up":"_1W3groDo-14nnjVQfl9FZu","icon-home":"_2eacST7uzsrVoE6W0YP1QL","icon-volume-down":"_3ZKVXWBcBpkZ4OYLfpY5_F","icon-volume-up":"tP5LXePfu9X0JfIz5hf0J","icon-checkbox-checked":"_4Ul7TI7aVtBhnoSwzljEF","icon-checkbox-unchecked":"_1H__mk5K2F_mnSd9fI9W9h","icon-priority":"_26F8gicBwVXs4p-25BFtSX","icon-check":"_3FnBsP9ckHq9itgQuGJO1s","icon-close":"xSVN8dhtdjQlearg-bFB9","icon-warning":"_3pevghN_kR2tKFt75dTIpB","icon-back":"T4tyJVIAJEv5sR2r4IYib","icon-order-down":"_33QjEWjKalbgY51mY0XaQM","icon-order-up":"_2rGMcMlqqE4g_uV9Dk6K9A","icon-menu":"_3ePYDBkZAvlsBXYuvbcIwf","icon-delete":"T7IW7P5AKNhnp96dx3xVe","icon-more-vert":"_1FrEuEut94UdBaSCNQySNR","icon-more-horiz":"mUFcZpmyCni3OrsEPQc24","icon-play":"_3rDBbHJ0GpT2bNhOxXmfCt","icon-pause":"_3N5sk9qHvxExVOsppv9jo6","icon-exit":"_1PgZhx6mueM7vGa7FnRoDx","icon-users":"EnTvXy79YxFFCop1LDNth","icon-user":"_2X1Tv2gvcg4BU63kE5p8xp","icon-playlist":"_2Zy_tk0qiGSnNQiLHDSlAc","icon-forward":"Xi-koDQzRu1yA6X1_ud5T","icon-stats-bars":"_25PmAflkZI9jiYfglygxXN","icon-bug":"_1h637ZXiVq1R8MTSXHVETq","icon-users-folder":"_24kxkf7CckXX-K6TOm4ODY"};

/***/ }),
/* 1284 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"form":"_2SWt0gqkYxw7kuSH-92ynR","inputContainer":"_239As9lagAz3qwJ8LtJW_J"};

/***/ }),
/* 1285 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"title":"XBSBzBqcaWSbSYHBxcp6X","content":"_2hzQyZ4DwpDS7WrWjmF2jF","panel":"_147ZsWkOL9SiBVqu318oYF"};

/***/ }),
/* 1286 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"icon":"_2xmoOSYrkOfoTzQnFfu_bO","success":"_7A0QgqScwbgsRUZpkp_Pi","error":"_1saTohvXBztBpOSprrBEtc","icon-cloud-error":"_1T7rzbYTAqTfRFqIhrV83J","icon-admin":"_3F9l6qRWGv7_Kfwdr2Ulr0","icon-info":"XqCFvKf7wm0ncNHnxGG0V","icon-info-outline":"sIu98rLLigMl_mkonj2s8","icon-text":"_3cZyMkqRDr-w4djgwp5iLg","icon-background":"_3RdyJzgMY5hmY7x-GDk1W4","icon-add_album":"i20IYAXhZ3O1rsI61d060","icon-add2":"vtvR8BJfry1WHpy0O6zft","icon-color":"_9X-v2YoccvepSGbDPq2SZ","icon-image":"_29AappUtcfGf7RJc5UkjEp","icon-tipe-1":"_3Z07drKmRaVv6wgLWW_7ez","icon-tipe-2":"_2iMdev2Th3929pCtJyx_bF","icon-tipe-3":"_2RibiLSKgZlGphgGJO_wAV","icon-control_point":"_1PFmWj_nPwFVThxsUAK0w9","icon-chart":"_1X2VP13M8E1f6H7682h937","icon-check-circle":"_2rzZkQHfASQlyOpWGp0pLg","icon-circle":"_3yX7gjIK1vWXf1ihmEZmYt","icon-checkbox-thin-unchecked":"ebIr1wW32PjFbNi8a1LXV","icon-arrow-back":"_2Cx0YrxUia-Pp1-JLAmE50","icon-sync":"eB7i3P_hWwKAMlQD7BHaV","icon-add-box":"_3Ed1oTrNzSjbEEG8NQqkes","icon-chevron-thin-left":"zTGImJ6GxGlU9QsUodXXN","icon-chevron-thin-right":"_2d_cmREiHOBwTP61iiTlVf","icon-download":"_2kAex5GgKaXkABSdYh1Bdw","icon-paperclip":"_29b5mpdj0k9UCu7CvgLTV3","icon-media-all":"Y904i_rFqrzeQxqDgHxEf","icon-newsletter":"_129MrkXzp2YJ_Sam0rXsV0","icon-video":"_3VQkcBICeWIPusBGQk-hB","icon-sort-alpha-asc":"_2GyOT3cNp5zmhqIBKDAUtf","icon-sort-alpha-desc":"tO-VVwcH3gvfovDunLgWy","icon-attach":"_3bvBtPBKy9bgBdfbbOlWFk","icon-collapse":"Pj2gyZjktjYaSMRkzvPoe","icon-zoom":"lhHJfgDIIbA0ltgKpW4Yv","icon-previous":"_1pz4DxtRdyFquA7g5HKAo9","icon-next":"_33X438D6dwwwszerC4V3Ox","icon-pause-round":"j6wcju6BQwEmEOijCeqXv","icon-play-round":"bgKb0hc6ZxWyOohqRxhK7","icon-sound":"_2ywZy0ZapNjMsNpAPKYUTV","icon-reply":"_3ld7JpwQg-c7apjUAtRHiU","icon-chevron-thin-down":"_2sPCp_wL3kFT-wQhzlAcAs","icon-chevron-thin-up":"_2oVSYionjke9yKFB1ylyJk","icon-import-export":"_3esFSP-yRfKwgdIpKSG9td","icon-drag":"_2XuJLlu9jYf-jDXi0UKK3x","icon-music":"_391j5kAy3bXbkqXQ3I9_Oh","icon-paper-plane":"_2sE507xSQ_djHkKKEu5R8F","icon-lock-open":"_1YtRkUV3KEWPoOpxClyK5r","icon-radio-unchecked":"_1UkZvUktWvJCM7ru8SVtol","icon-radio-checked":"Yg5GCjhQ9sxMjHDxdAdL_","icon-upload":"FmK2muDv5EiD0k9QmYZnR","icon-add":"_1ako238rZKqFdSew7eMS9D","icon-remove":"_2sYt9n2qU9l0FCNMYttvl3","icon-mode-edit":"_1nJlWLI3a041GIdK6pMAOw","icon-search":"_3G-YN-k-cQVp87BX99F4hM","icon-grid":"_1aaDPdo-WhrnFQHxSa-hKE","icon-list":"_1XnNBxcMwN919yMMOQFInh","icon-chevron-bold-down":"_3zeRCWsrjaXXEiYXj4-p6i","icon-chevron-bold-up":"_WUqLuXWU2CLU5Li905-j","icon-home":"_6eTucBMGyZhmWLS4kCJ7h","icon-volume-down":"_1tM0qU0INPW51A-fkhZ2bc","icon-volume-up":"HgbnPzkkBaTT5ZEfkaQvd","icon-checkbox-checked":"_1_eFK0FAITQvaWBrLwfQQA","icon-checkbox-unchecked":"_3o03NSA4fXDg4Qy2AMezUJ","icon-priority":"_2WPnvqrVZJPLfAk47ULDwF","icon-check":"HjLHOZkPXY97i6HFaeYPJ","icon-close":"xRL8cgnla698AmBWgUc2-","icon-warning":"_2i9EQwHyKsPWHhzIXa6gnd","icon-back":"_21sN-443KPHuvEuTsEct6x","icon-order-down":"_2W0tFieznLAWoM3s3eHhmy","icon-order-up":"_31VVrs95o9F2cHTYFwaH_q","icon-menu":"hrsd8FFoKQTCLbeGoP6FW","icon-delete":"zxVtQ6eCqoAhHqw4O0q5u","icon-more-vert":"_17bBZJR-5Rjge14A6xjZE","icon-more-horiz":"_3h8yPQgwx8rnOgNr-y_8df","icon-play":"GUywoRV4ERHiLuKwXLiCz","icon-pause":"_16CzwjKmTwCsBXlqPSIkqw","icon-exit":"_33AkJmP_QsuCP0p3tKIplM","icon-users":"_3fch74vcEpUScpgEGBTQkO","icon-user":"_3tdbmJPJxq2Y018yoR2ZiM","icon-playlist":"_3pyq_1kU2VhYWC9WnLXtzj","icon-forward":"_3EWnQxUUT-3lp9N1xAvS7O","icon-stats-bars":"_2jOh5RSx6alyN79IBHNAuG","icon-bug":"_1LOjGsIaplxqo7IoDxtkrA","icon-users-folder":"_2P5rrQV83FaBCIKJy1cBy_"};

/***/ }),
/* 1287 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"feedbackHeader":"zS051v6HRA7kp2UTsII6J","compact":"_1KwdzpWiFwGKmVZuitpNQR","buttons":"_1bAKj1FpK1DjM9fCrPT6Pj","line":"_1pghOqS1X1-G3F6Mj4FE1Y","form":"PdCwb2XjWq88M2NAP7r-H","textArea":"eUpFF33S1nDsM9wD--BvR"};

/***/ }),
/* 1288 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"labels":"_1rjliWfF-YhSytTLOeG8LI","homeContent":"jtmSLDMq1DbtGB0s8RcKK","compactContent":"_1MFDn7j65X_ybp6EN4taoo","page":"_2BH7hIvbxWmZSLeJZ3IhGO","anchor":"_2jzPWD7d6-vMu9KWtKUIrf","fullWidthSm":"EnkXArAppROSS_BTxC6wD","fullWidthXs":"_2ZJWbmAMjlnQ32Setz3E8d","narrowContent":"_1968tJz7mS-OljpxAJSAJP","separatorBottom":"_3dJ7dmVcs9e_Buri7bZzZ8","section":"_1mJY9szNj_RGwK5eMoU-FH","separatorTop":"_36-VbhmB6vJLDoRjtJ39hQ","h3":"_37k09pLhtOBDq797uIwc2D","row":"_3hf2RIj0kEjzUxKpQyGKo3","wide-border":"nMp__qC14pcOxuQBQZorE","labelsContainer":"_1AeqtSKJ3_VLEom40fd8Vj","visible":"_2l8E25G_VzVyvtQQJ_q0X4","label":"_2SbmBuCUrXFpzR-oLspnJm","collapser":"_2IUn2-c27F-2BTA7hqbsOt"};

/***/ }),
/* 1289 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"album":"_3cvPJ9XWbb7Q0jbuy3GIQr","mainInfo":"_1-vZ4kak0PCSMAPljkp2Hm","watermark":"_239qezIR26AxLfh2V27v33"};

/***/ }),
/* 1290 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"cover":"qI5wl3ECW0Eokte6G_jz1"};

/***/ }),
/* 1291 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"albumInfo":"Cd52IejDhDu5AVo19FC51","infoTable":"_30nPKRGYKb8hRFAzTjUEyr","infoCell":"_3sOXC8IXA3qyyH-5EWW-qW","watermarkContainer":"_1guJoid6ewrNn3_JUvwWRF","albumName":"_28nW7PGo3eHrHyLsN6NfFX","artist":"rfmKB3EJPtakbe_qm98mz","smallHeader":"_2RmUzWechAiotZQag1bS2O","sentBy":"N4KumltMEtW1W9rtHTT8Y"};

/***/ }),
/* 1292 */
1235,
/* 1293 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"watermarkContainer":"_26Y1-FJqrsq94ehHsh0kgq","watermarkContent":"_1DLhgx1yRh8bQFRh4eGD1A","warnSign":"zbS3iJJ2foyHHXXN3kIiz","header":"SksiLqgdfnESaVGw0FKup","warningImg":"_2XB2lWBYieBxwIiGs2z_LR","warningContainer":"_1TRpPjjMwznDGXcAXlr0zq","text":"_2TnKXTrJn57TaayGfq9GT4","subheader":"_2MK_daCAAoN0Jgbwg-LFnn","hint":"AKoSkVVXhYI1YoLxnkB1G","warningAnimation":"_1YIpyhU1NGW0pS6KRwA37","warning":"_23uC_baBS4ifFrykpnii8P"};

/***/ }),
/* 1294 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"icon":"xnXIR2Qmk_ABeikpqJLWx","infoIcon":"_2F4zpGZsj-mD7uR4oGdW72","icon-cloud-error":"tGJQmjwIcq4rCh08UNgi7","icon-admin":"_2qRI9YYz7ZPVYKs07x6GFS","icon-info":"_3PG8SJsVidb33FntQnj-wp","icon-info-outline":"_1QgFhI9h4jLFvxWVOe9BI4","icon-text":"_1jjkHu_MdXPM0PN6bGssxD","icon-background":"_3BeVafLgcPTK8muf65b1Ij","icon-add_album":"-K0tbDAdrYp57gFshKBxz","icon-add2":"_1Fo9X-oFLNmOBfGXaXhWP9","icon-color":"_3ASYxsOnXkn8abXf55nAYz","icon-image":"_1edXuKr0aCDNufZZnCiIfQ","icon-tipe-1":"_2Er59bxq0xAJD4V6H4gCSm","icon-tipe-2":"bCjLKZOhjj6EBQgmRWRPo","icon-tipe-3":"_1K1V7sAoHY9O7vEjCNchD4","icon-control_point":"_1zTvdEmPr0M11U82OVYidJ","icon-chart":"rQUAJvVJDaReL52fMdBul","icon-check-circle":"_3YuWXT9acdxRe6_i-1liOg","icon-circle":"_27bQbWe-78xh49SbdbUYTl","icon-checkbox-thin-unchecked":"_3vG-uADNYdUJm8uo15Anh0","icon-arrow-back":"_3OlFtZ7plxzYgsFW2RnGa7","icon-sync":"_3CHLor7ZTOfkGia1fxUXjT","icon-add-box":"_1S_BIh8cb_LLmff3p8uI3a","icon-chevron-thin-left":"_2irjbDecEOXjJYucgFAigR","icon-chevron-thin-right":"_2omewWMQQq39jn5CGBUVuK","icon-download":"_1aIlfjFiLnqs4TQcfMwAmz","icon-paperclip":"_3QNYQU_-Py_QkKxZeJ7b3F","icon-media-all":"_2vE_jxIoEmWqasyhIQgh6k","icon-newsletter":"MR1p6xrwN2c2UkW_ffm82","icon-video":"_3bXo_bfT7mcjW8MsURQQkM","icon-sort-alpha-asc":"qF8lH0T4l-lZ6x9iDCPe_","icon-sort-alpha-desc":"_1xBYimOCbUSRpFl3v_LnA4","icon-attach":"_2gyyEFYbe-nhP8nNlY3XA_","icon-collapse":"_30D5aRZTq7UMv1bS5eg3ed","icon-zoom":"_2xTdwPvIfeVrKLBHw_4d2q","icon-previous":"_3FeKFYGOkpRT8Vw8-uuKf","icon-next":"xyd2VeFAeCo7DdBvZGaD7","icon-pause-round":"_3WX_PN4cSdbkwexPg6NcF_","icon-play-round":"_3qOHECrwdcQI6Q_GR7_Du6","icon-sound":"h5VJ9eJ02LaWqELpKEJY3","icon-reply":"_2-AfcPjDhr5u3Tce9-Bf5w","icon-chevron-thin-down":"_220j2oJHuR6XKsPcwJvqn4","icon-chevron-thin-up":"_1EMiC1-mPpWV8DI3TKd-9Z","icon-import-export":"cMD_9hV56CTZRdjlFGYCb","icon-drag":"_2eXbwOhiBce9bmH1T2aB8R","icon-music":"_3S2wfbMyqAX8I0MiM7R8wS","icon-paper-plane":"B-Yh2oGn4eZ5bHNF2D2dO","icon-lock-open":"fXwIGr-75sW7Nmu2bBIaj","icon-radio-unchecked":"_1BDTzddJYuaXtCl8YSFk0H","icon-radio-checked":"thP7AaXoF2QL69tNmp7Yw","icon-upload":"_3ZY7wQQS5x-g0EUlsKueH","icon-add":"_1NXw7raW74A9FS05O0xniG","icon-remove":"_2WJ_cRJPVMRKJLijBaB6P","icon-mode-edit":"_2dx6JRrgWkg7RWMY1cNe3S","icon-search":"_2cbknr6txQKW_vlr0wA_3r","icon-grid":"_2lIU7q-uYB6ZtRDhk7uDYc","icon-list":"_2etn5qZ8-iA3NRiHfGwjk9","icon-chevron-bold-down":"_2zO6epsLhzEIPlan34PrYF","icon-chevron-bold-up":"_2D-YKingvKduOZkRM4Tliz","icon-home":"_3VOyKQgHVi73FFNVcWVYv3","icon-volume-down":"_10-QOGzGs6NoV5WGDeMcvS","icon-volume-up":"_1o-zDkn0LNBwAhEl8UCDQM","icon-checkbox-checked":"_1g6zlvMy2COF_ZUYHwJHA_","icon-checkbox-unchecked":"_1JADXkwhv2hpbTdmT3YxUs","icon-priority":"_1JFIMeQAXbnSUWiRoBIWyr","icon-check":"UqKBOe5-Q8mOeHlW0b3_3","icon-close":"EE88hTxZkIA1iBE-vOm6h","icon-warning":"_37h-la8fZ0LZoT9juuX2ZG","icon-back":"_1AMqryeDGuuAVE7b_kr1Af","icon-order-down":"FpvqKf8N81zQILslhaQpC","icon-order-up":"_1pELzyWdCMHpOGUpwtmupY","icon-menu":"_2Fuv5aleE8U4jO1cjZO_rB","icon-delete":"_3_wWn-hi_iNan4CuSnVczV","icon-more-vert":"_3UEPVzPWwP_dPG1GLYR3y0","icon-more-horiz":"_3FEamNSLu8k9ImiaAFfI9-","icon-play":"_1-S4HIPlOfl9QxeirsTTkF","icon-pause":"_2YKj2zqXADQ_gmKsuUmfBt","icon-exit":"_2GA26o7vVobzMg1MIR_kjT","icon-users":"XhRVFF3tcG4yfzUuxX2ii","icon-user":"_3AsGEN24VImVkmMVMjQwBZ","icon-playlist":"_3aRuCQ1iEmfjTVOqASqvvh","icon-forward":"_2-GsAbQ1TJA2jYTADmS_80","icon-stats-bars":"_2FZNQCf2Dut82V60iHdzeA","icon-bug":"_1iZdkfWKyaUPAR0BtnEaeq","icon-users-folder":"_3WvsUGT3LIeqFwIiHnn6lx","popup":"_1OQGg1s4iIp4Zji9DKw4_Z","container":"_3pSuiGKGPetCvngX7hv81L","progressBar":"_3K_EZhbyq95Q8qTCVSxH2O","timer":"_2iP78cFOziXN8Gup8jzSzB","textContainer":"_3-sxuN-23K8bL4F56ULUnj","message":"R6FqLAyu9vUnTdWHZIXX","closeButton":"_1T1OXvhkR8wnDlC_IQbPBK","title":"_1yXniZGHj4vWWXtFZ1TmfV","header":"_1eHQ4AbE3hWdyJx6CfjrG0"};

/***/ }),
/* 1295 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"_2q2SKEggkrq-yxrmOqp-dx","bar":"_2A3RtDomXhShlkVrGwhpzX"};

/***/ }),
/* 1296 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"h1":"_230DsfSYIo7C41Pup6tabS","h2":"_2YqdP8hStlNDEMR7vkuaoR","h3":"_1XdnMwFHAIPoPyUMnJjvtp","margin-free":"_2AkvPquJniXCsX79w1Ukfv","h5":"Jj5BpO6q0QUzLI_wxpAnc","hint":"_1C--822NbHfl03VEklgPMt","small":"_5JlRfPM395Avh6fgyW7s-","default":"_69iS2D6L1ovskEvGT1cRL","text-overflow":"_2KWO4nhGDOXd95qQ-Ked8C","breadcrumbContent":"_3LslzBdMO9Y8zgAWoRwKY0","nowrap":"_3DHGHztXZ_leJCUuAuJ0p5","break-word":"nnsmvCmjw5pnUowq4GE_-","u":"jA0QlmA9d5XtyNaTrxahQ","underline":"_1YW3RbapRhHFHCkV2Y1OPF","bold":"_1eCMoTzDL60SllBN6-b7Dj","b":"qwB0zbu3dJtPg2MPccd3c","italic":"_128P4961wB9ZAs02uf6s8_","upper":"_3_O5bZAQ3swBGMP4egzx8A","lower":"YvTIJR-cSU-_bC-ONhJiN","text-z1":"_139RN3unDsFsru2dIYdt3n","text-z2":"_1r9J_0RUUsLPCsIvVNr4aR","disabled":"_19xxYtkvbbVyf5QgR1mGY1","error":"_2R8sK9ziTN3xvrEOxjU141","danger":"_3T9xlLh23k5NSX5Bo7JFp0","colorLighten":"_1P_1gHkR5JKAl7GAseC6h2","colorLight":"Fxm9qEdipu-jqA7KA7iJO","colorMiddle":"_1Tsog0ag9kTDuCYeEktdez","colorDark":"_1mHisN33cAQITIYKwmm3Mk","colorDarken":"K-BgEMhTjqrdIwZ7GTe-U","colorSuccess":"_2x4q-NZugepOa_PReyNe7y","colorInfo":"_1-O9d8wBZ-dU92BjpUB6ZC","colorWarning":"_3_G5D-mNpBg4qhnAtS8aPr","colorError":"gewANz5Cx_tdZ2d3xOTc0","colorPrimary":"-IEUeSsNEjRMh4F1Y5Ofj","breadcrumbs":"_1CGVAUrpumG3SEtmzL-cT","breadcrumb":"_3jQkywELHf26khk6NxsJf9"};

/***/ }),
/* 1297 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"coverCropper":"_29kfbNH5jObOuy5cGHguIW","cover":"_1VB9NhJPvzywuJAn0wVJNV","coverActions":"_1TOeF-wvQObh6fY6S0zE4b","coverButtons":"_2eRrLevrKo-mouTaDvmtbG"};

/***/ }),
/* 1298 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"watermarkBackground":"_2ZKZzxmk9bGl045dLNYWbx","watermarkSign":"_20rdY7ysItszGShTYfZGMH","watermarkBackgroundMuted":"_2jbyZWb9zSUUWqsLk3oZqG","legendLine":"_2RRFsLInA9GSykTQTq-ZwZ","legend":"_3-lQEZFV4ZeOIbT3OSgLEg"};

/***/ }),
/* 1299 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"watermarkBackground":"VnosaD4PGnVTVlI9Iu9Gu","isWatermark":"oGyNYKCHyJGFnsM8f27hI","watermarkBackgroundMuted":"_3_iLsajhl9FKUN7TljNhFv","typeCell":"qOLwhJ4ycdE9_0bPLuJDG","irefCell":"_155Mxgg0XyTRm19a2Yqk_t","actionsCell":"_1Et8sFg26CLUXVQ5MY0lBY","actions":"_11lmigH02LrqtzeM04mDa4","actionsMenu":"_3XoK_CCcnYuVgS2Brh6GuW","moreContainer":"_2MFAJzfEut3p9-4A_CjGi7","moreIcon":"_3SnRpQf4S6RoKfZY6GV-Yn"};

/***/ }),
/* 1300 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"headLine":"_3jug6Tu3fcAD8ZClqX4RIh","homeContent":"_2bPDoewLvdIGlxGxh_02oR","compactContent":"_2mNMIBefm5dL2i1LS0WWei","page":"_1hasytU8ly7Tf59CrGmkcq","anchor":"_1x0n1EhD1KoeuqPv3-vKcj","fullWidthSm":"_1FHX-4OVUtD5jinsegf09b","fullWidthXs":"_2WZPVRxS64StapjRO1nBYH","narrowContent":"_18Lu0rivKMrBXyw0n10jFY","separatorBottom":"_372GxyFHrSq_4bnXtVLcQj","section":"_3RuMdq7N9IYy02XpxmVIjU","separatorTop":"_2iuo30Tkq322b-vwQVCGxS","h3":"_2sor1hWFaNon-A3B2Zvgr6","row":"_2XKOx7bGl52mklsTI1FMcx","wide-border":"J4u8jWhRhvWy6g8DEDBqN","icon":"_3crpf1c-RDulTI16AjNotu","more":"_3_R9sfOKJktOUEc8taSN3K","icon-cloud-error":"_2sqwRWtKDvBY6DCN7YyfO0","icon-admin":"_2eIx2nFykWxnXcwBDN9Mut","icon-info":"_28SqyAJKyyyimDpxKdjJcc","icon-info-outline":"I5JN35FFQjerOLdm0bxow","icon-text":"_1dpyCuJNQnCp38FllT75Zj","icon-background":"_2Gsfo2Z0aO7BtExEWzENWC","icon-add_album":"_2i8Ik2fZWKCiVTjvRUxg--","icon-add2":"_2gT6D1al_uOtD0iijtmvpa","icon-color":"ctzToVc9DgxlZYdVvVk9r","icon-image":"_2hDt4EgX9kce2r1PZ61wOB","icon-tipe-1":"_3dNAb0sk4ZmqcnPrLBbPfR","icon-tipe-2":"_1vLHFdnHBFVgkN5mXr0Ljt","icon-tipe-3":"_308wpveW_xfZFbilMpCvDA","icon-control_point":"GOEGRIJ1Vg-UHpwptq-KO","icon-chart":"_1sLn_h8erUjquXynLBdp1G","icon-check-circle":"_1MDc5Vr3JYG39Wfi-EwxW3","icon-circle":"_3ZnXsc7v5obzM3HPwulzcA","icon-checkbox-thin-unchecked":"_2bk6JYR01mf6rM2IfPNXpr","icon-arrow-back":"_1kEQEOWkGryqb_wvVjXbF0","icon-sync":"_1nS0qiS3hUwOph2xYRGuTf","icon-add-box":"_3-c2EzTWc9r8cOAXHXWM1x","icon-chevron-thin-left":"_3QD-CQwP8P9qi8TkpTAQ-8","icon-chevron-thin-right":"_3qb1iX4K9w8F0GqiUOw0SW","icon-download":"lzGGk1QmDA5y2uxs9Zwif","icon-paperclip":"_2GgXKaDGsM01-OuDSxvfl6","icon-media-all":"_1b-S_qsdwxPvvHV5ppbRkT","icon-newsletter":"TOisUU9-16pYzAfeb-hos","icon-video":"Z486w3PauMVm4Jf8iI-7X","icon-sort-alpha-asc":"_3o6KzVgx6pNYqQ-wpzSLNA","icon-sort-alpha-desc":"_3sDk-PuLrhy8ZbZOzNGoRs","icon-attach":"_1W7jSjLsflW6pFvvFbb_El","icon-collapse":"DYmZ3yKfThsSlYED4GVke","icon-zoom":"_14DRBqqEkI4NVuoRgQRXSO","icon-previous":"_3OZRN6-yKTl5lNjkr_thK5","icon-next":"_2A1WJ_Q--X42WURUoYHsrk","icon-pause-round":"_3DHZJzzHcApU6donVtZB7m","icon-play-round":"_1IQw6CiOOclISDqSgowDDe","icon-sound":"_1tRufoNrwvHq8a2AGb18gC","icon-reply":"OFQGaKhz89CERWGjmyLt8","icon-chevron-thin-down":"_1bXRyNHajtctKS-FyMfSUo","icon-chevron-thin-up":"EcU-1rbxieJL1QVaFWJtL","icon-import-export":"_1vh7vEMYv71GmWMua5JE7O","icon-drag":"oKSBroytARgxlITL2h5ok","icon-music":"_3taUH7ZF6UnIaZVY8uMc8L","icon-paper-plane":"_1EB4WtkdDIru1lTj3cWDTh","icon-lock-open":"_13H_5hEtFDY0qLxwcH6uAu","icon-radio-unchecked":"_2OJ3ACIG8-PrTPvh-vIvmK","icon-radio-checked":"_1a_Ehh-1RGiQm4s7dEmkIU","icon-upload":"_1vLA5JUiM03MThhSCTDT0C","icon-add":"_1Xb1p2wgFNt6O_tPxmURTS","icon-remove":"_2Xl2uKyNlFiktNAK7xwYGZ","icon-mode-edit":"_2LldU-pqHEfoNFfFsCc2sT","icon-search":"_2X9-WV3HxJkq3XU3Hd9BkJ","icon-grid":"QRs-ezvQZ2lHD2m488Kzh","icon-list":"A6b2FjaOT73EBH1TPyeAq","icon-chevron-bold-down":"s9sJ8T-D-YykSRTgIZJHS","icon-chevron-bold-up":"_3vjAb1NLFxX--arq5nu_aY","icon-home":"_1fAwPFF7uUd1HVholgDywN","icon-volume-down":"Xudu79420inzyNeZ_yoKE","icon-volume-up":"_3LXlbhYxp2nfqoujdFmPam","icon-checkbox-checked":"EmYwCDiDRVKRVQScBytgA","icon-checkbox-unchecked":"_206i6mKyzB9wcJfarjiWgE","icon-priority":"_31PptRAHyHpuopQr-stho6","icon-check":"_3Ic12gUD1PAUtGrGlbBKPd","icon-close":"_1w-_p1Cm_fv8mGiHS3V_tj","icon-warning":"_1O4-SohRogrJT0ab5UznMK","icon-back":"_1ZNQyI_rP538P00CE0LPr_","icon-order-down":"_3EYZ92A3a0V-dh7wXGo9fE","icon-order-up":"_1abuRTMgjSEZzCAwgS_9zA","icon-menu":"_30Y8pgUhwUQwWmfM4y3zzw","icon-delete":"U3jS3y-0nyGr-Y-88DjWG","icon-more-vert":"_3DO0J-CPCARnpa03kWgoa1","icon-more-horiz":"GVnvCqD4msEOGxWp7Q584","icon-play":"I1lDqskVmsB65LCAHnDdq","icon-pause":"_2cjRPKNAEDhGUF62TNlcdX","icon-exit":"_1_qLcGv6IlgttXSdIJpXUk","icon-users":"rvmm3C-59YNC16T81CcMJ","icon-user":"_299NmU92bOr0MXM4GhY5WX","icon-playlist":"_2zLnWltbACerhSH-QW82nP","icon-forward":"_3T4cKu3PsRRSk5l8ZGGN7z","icon-stats-bars":"_1PpiUgUCN7JmZBTqT_9mCW","icon-bug":"_3s8GOnVuJnKMGZlfge4gsF","icon-users-folder":"_3sJmpFkfdGmx4Z9kZ716Jn","btn":"_2L8ouDy_As2i19sPOJ_lFC","btn-checkbox":"_2MrRwayi-OPKCuNBcAqJgv","button":"_39qlZ_B0BhGVRJf6fTMaMn","disabled":"_2mQX0zyR1VEn_EhKIu7OMQ","squared":"_2pVsxh9JLwnEbrwGX5hWda","small":"pizinSqJvNk-iS9OhqUwb","big":"_3-hWwMGjgYm3DMIkyD5PM9","wide":"_1ZToW75hZiOeEDZgCJaYmG","selected":"_2NlNkwuAj8lnBXw1r2HL8e","btn-default":"_1iM2XAgEhLYc5GF-zUiIJA","btn-primary":"_3Gzaf7xJX9-cGg0zTIeIwG","btn-success":"_13voIYoUcx8p-m0qbkfxuW","btn-info":"_2PTud3m3em-YIwPMPyYCFM","btn-warning":"_3V0Y5Do8YGQGLqZzlzCszP","btn-accent":"_1mOhriRNDEt4oE6c8MBB3y","btn-danger":"fpjft8HiNjdFkIdUnFFZ6","btn-humble":"_1jGXL-70VdPiz4fFeAG-Ur","btn-simple":"_1PUJCRLGDlL_panNJMfEtD","btn-clear":"_2E5PrOviH8pCoNqYdVsV96","btn-stroke":"_2rZ8lnKr9Yak63TcQSbn43","btn-link":"_3ystpUH8osK5vPwWCZ7_8_","lower":"_2dNPa0oLTPB6aMi75ZO7Tt","btn-text":"_299FydajkoQS7R7F5l4j0i","btn-icon":"_2OF8UKr3hY5V7Awz6Jw8fd","actionButton":"_3em0BppIL3yzJAnCLP1U0D","btnWithIcon":"_1VuXY31Iu9J0XjSEfU7lgP","btnIcon":"_3VmXju3_OpMq40NAhUIRqB","dragBtn":"CALHeXr-aENFjrIhtjUjz","actionButtons":"_1NxjdzHk1u1XNSq3NE7Gwr"};

/***/ }),
/* 1301 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"tabs":"_2SejuTcIlka7Qaozg3oP8f","tab":"Uk8j8j3GtU9RgcpLy_UOL","title":"_3anXAqWeBSYucWbUYlAUd1","switch":"_1PCajxVFlmigq4gWsLGrsd","active":"_369kFTOFZD27rYS40GkdUP","addTab":"Ziot5KbDOiQoqP2tb-Alm"};

/***/ }),
/* 1302 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"slider":"_2ZqBFwjako55baqvkntM4J","optionsSection":"_1wvbhAmnrNgwWjjnEZFhPP","mainForm":"TWEy7J_2kky5pjjhr_UFG","uploadForm":"_3dU0kPrDoCbhHA6f7YiuBx","filesManagement":"_3_MZdDa1RomBk3JU7MV0P0","optionsForm":"_2Mp5dL7XZzY2MRVOh-LeHs","backButton":"_3kjSUwu1Q3aZJAFml3xYA","step2":"_3M8pMXNwdoWKgYO06MV1tG","step1":"pOdfZh9uhIo3g0UhzXIAe","mainSection":"_3cHO0S0EpdBxrMj9DPs8My","visible":"_2step3ZHlGDQc2Tnum2TPd","recipients":"q-wFa8vEKNICbOJRdpLnI"};

/***/ }),
/* 1303 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"trackList":"zrZ4SJBEWcb0e3g7cDY_-"};

/***/ }),
/* 1304 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"h1":"_3TEJ7kyAJn4CS4Ena3vzeO","h2":"_3IqiKGqEueAaPybgocYS7i","h3":"_2Q61e3OmGDpIfhdQlT8kNz","margin-free":"_1ImkFkzE0wR8nU_2MLG8w","h5":"_11iPz2nrAFkbl_AluK1pY1","hint":"_1JrwVDfGHZ1A8Nuadmw3VM","small":"zVw1VzNFyuxJ4RNYQQ3Kv","default":"_2Y0MRHC2B5eRpHxGerdWDG","text-overflow":"_3naMPJm71vxYvagNANFdq2","sender":"_1ymUSr8hhcB18WRNQ1KS2t","nowrap":"_331i7sqGdibLGjdA2twoVm","break-word":"_4QvMzWCu-2sPEs6mjngUM","u":"_3MfRjzW2kFJo5Gc4rJXecm","underline":"_1P13688rynaEYghdCajg5v","bold":"vTVLqBW466ZgbGQr-fnss","b":"_3K3TymR_w38rEr61w70HiM","italic":"_2WSxNxapFWVP4UaDsE1KsM","upper":"_2W62pucF_GD8GgYvBo919G","lower":"_3_RlHoYFKYO4GSPNdCR8jY","text-z1":"_1X84I86Z46ZNYInAGOARLM","text-z2":"H4BS-S8mcUKhhu1II9s0a","disabled":"_3kxFJC7o2dcHbcQzLUpCV9","error":"gvodnk_875V84oNRm_EvR","danger":"_25QaT3rVuyLUQY-UMH9EzQ","colorLighten":"_3jMcuokAN-PZHOR-XJyfwH","colorLight":"_2V6DYM3kmYWZiJ2twZhaFh","colorMiddle":"_2xOZ5EfuFq6Ygb2oYU9gpI","colorDark":"_3FItjO6UuEsBps_FY7_uS0","colorDarken":"_17fnZnDaSUrdaP9jmdpUCe","colorSuccess":"NA782yv_e02ccZvTm8KAr","colorInfo":"_1vgWq7qfGPTQRa9AXFaa05","colorWarning":"_3e4TNR1Ue_UGUucFPbSuVm","colorError":"_1WdAbN2YnriaHoE0cd10aK","colorPrimary":"_3eVi9dpgLXFSbsxt_LonJj","item":"_1mjEt4MA0eKcAn3G54LYJf","active":"_2eSezxY8i-jm2Z0-4gL3ZS","title":"_9uqQIqPjN_HCY55QMijvN","message":"Lj4q3Fi0hKV96S36y8shC","bottom":"_2Xgyk_EozPvaFxRwG_D4yE","date":"_1wFqCW7Cu2y7SfGDO8xosl","forwardButton":"_7DWL9u5Lrf1z-eH5H0ngH"};

/***/ }),
/* 1305 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"list":"_2XYyv-3haOjM0R0IT5UiTq"};

/***/ }),
/* 1306 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"replyBtn":"_2tr44Yy_x2iO3oMoSAayP5"};

/***/ }),
/* 1307 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"tracklist":"_2QL6og2o2mT4FTYSFAEVLW","playable":"_1h0B-VRrAlzlnnFgQ1nipO","playPauseIcon":"_28Wty0zySQXKtaACbldAdl","trackItem":"_3p5KW61zb7GeWWWQyEdk4E","active":"_3Y56xqVG-deosoMK6qr-c2","addPlaylistCell":"_2RQGYHoY0lKetFZ8eM5kKi","addPlaylistIcon":"_1jWdD1p0UudBi6r1_yWizX"};

/***/ }),
/* 1308 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"uploadHint":"_290VrE5vI31NFyKh9AeILs","cloudButtons":"_2VLGlCt9FETJm4pti_io-V"};

/***/ }),
/* 1309 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"preview":"_2_nbd8ssb4wOFBVB-XLVaS"};

/***/ }),
/* 1310 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"message":"_3xHhQN3oR2haE2iacGkirL"};

/***/ }),
/* 1311 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"_3oxEfjXygEclVlMxi4x1Ok","input":"WQthM_wSFfzM7N7CRQwR0"};

/***/ }),
/* 1312 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"icon":"_3gMj-D8D7ED0DRHkw-fqnq","button":"_2Msbruxnc4U8OflMr13glQ","icon-cloud-error":"pST4M8vne7Bqe17G0qLdo","icon-admin":"_1ikKjX-QYK-gtNEK0GRbWC","icon-info":"_2Skr8CsPQphdq7vacVV1u3","icon-info-outline":"_3w5J0hxc-osr4PGWt5kf4N","icon-text":"glkSPbDJU_OgQrF3fEkHO","icon-background":"_2tngL_eCdnltXk-cqQ_Pan","icon-add_album":"_1k2j3e1Wx6FoD-P7QDywrN","icon-add2":"_2RNyPtEDCW3BruA1UIiiA3","icon-color":"_1WoZM2aaI2S5FScHlwmXBW","icon-image":"_2iRwyB0C2FK12Y0dRL1Lt6","icon-tipe-1":"Sb_Y5Kk9Tv1CiUaclvPai","icon-tipe-2":"_3emOfVX-jeojMVnsnLcSm1","icon-tipe-3":"_3RfsArjPZ484oGd1sZDT7a","icon-control_point":"iUEx70TJbTZuFzDtIkwl4","icon-chart":"_2hzmVbBd_PKfBfbq69zsJI","icon-check-circle":"id_T0J3ebHjV0XTpLvMJO","icon-circle":"OyDtOp1Ta9LQ7JjprHPQe","icon-checkbox-thin-unchecked":"_3BvXPUTmtpWLSmgPVabe4t","icon-arrow-back":"RwjEwH27ytxLCflQ_Jn26","icon-sync":"_3mcUmB2l33CZ728tKBkIbf","icon-add-box":"_nLcwtkKO4ZAEW0lof0-5","icon-chevron-thin-left":"_2PPRvJNhSA6MXPHYQQVG1P","icon-chevron-thin-right":"_1wXP7KxfZ-aex6R5Uvw9nK","icon-download":"_3uPLXD-2-27Mw7cTamwoOe","icon-paperclip":"UqslqwtubHOFDJrMVYAdq","icon-media-all":"_3mP4Hpdud-xELMgF2X3hZ8","icon-newsletter":"_3egwbQqLJa2LC4Dh2CXfNG","icon-video":"_1YH2DGyxaXToDDPSSj37nC","icon-sort-alpha-asc":"_33j6IuNXiJF8EsWn0R63qu","icon-sort-alpha-desc":"_2rScnhf0u-rBMGg-JT-Dcn","icon-attach":"_1xUU71TKXEqNIByWAUNR2k","icon-collapse":"OB-FfDYNxg8HU90HNyYA-","icon-zoom":"_33BHr0HF9aYenx2mojALGY","icon-previous":"sNJpIEaQTMZuElcUhZG6e","icon-next":"_2ASfajP30IXLutJuPwTbgn","icon-pause-round":"_1x7iftu-zm3-wSJqkvBVa_","icon-play-round":"_3yOjLspgMyFk3XXc6FUkcY","icon-sound":"_3-pUUctBNaWCX-qbHcHQTa","icon-reply":"_16mtmMui_mAqI6f4yCZ3Pu","icon-chevron-thin-down":"LjPR2mptc5rwQI2UsEWAG","icon-chevron-thin-up":"_269ahBzL8Rg2FUey-qePeJ","icon-import-export":"ailTZkWvmLNFW9MtX0JVI","icon-drag":"_1DuYHG5C9zU8y0LO3Ux8xH","icon-music":"rGflIgJriUlTQMYF_XtIL","icon-paper-plane":"_3iEmHaWXVbxCO-NPI7VyJx","icon-lock-open":"HIOyEBtW1lDUMgdsbRY-a","icon-radio-unchecked":"_2XJosXDHEa-vQBau9qGAMq","icon-radio-checked":"K0rIcmWjg4t3rhTD5-0gG","icon-upload":"_2F-_luAxD4qo8ItcglPYOK","icon-add":"MnmWpwFa4sJLlyRUWzTzt","icon-remove":"_21F335rnBk-_FbsbZKUOWB","icon-mode-edit":"_1FJ8qcpBom9TvsNNiLDgTN","icon-search":"_1j4odhnVVB3pyfeO74yjrB","icon-grid":"_2eEAiGd_LPhChQxqTtOlay","icon-list":"yMp9GLnDUnKupA-iQaDm1","icon-chevron-bold-down":"_1OBfG_2TfL_rKODFGQvP55","icon-chevron-bold-up":"ft_M263kpWa7wgyok5gSn","icon-home":"_2rVlHl1uBmByOGfDZuw7B8","icon-volume-down":"_3Qs2bRII2nXlriiB9e2GEv","icon-volume-up":"_3tF5F2pqxZOgUeiBXBgyK4","icon-checkbox-checked":"_2E0cgWRDq9nouvIB1CUqOv","icon-checkbox-unchecked":"vThy73SNgTXClBKriYBPK","icon-priority":"_2ji7436icPtSc6Wj5Xs4Ms","icon-check":"_1s8_IxMP_KIt1wHHKHTeqd","icon-close":"_1Wa5KIovmrvEbqQalLc8Xt","icon-warning":"_7qwEMJd3Ut692RUPWnGrl","icon-back":"GK5L_KbFsipO4KnIJ57y6","icon-order-down":"_1Xyquy_xx4k4SczE4A59Xg","icon-order-up":"_2TS4gzQcd8Qpy0MmCjTjLh","icon-menu":"_1U03exNe8bXnjvNjwzCemy","icon-delete":"_2rtZIo9y0jfNVd_PUk-xDj","icon-more-vert":"ZzOxSvIEzgrnFhIuxM-g9","icon-more-horiz":"_3wcm3PX3vGAKAjLLSSPEIs","icon-play":"-YqOM_TsLw3GWMgE1ld_U","icon-pause":"_3lOcUf-IAi44IqMIkf846P","icon-exit":"owPxYYoTkqa-mSkefrU8p","icon-users":"_1-HOqRBYKIkZtp3mhBlsTT","icon-user":"_43X-rUHU3kImH3_HQGM6t","icon-playlist":"amn4Km7A5G4sUe6C97PQN","icon-forward":"_1F2vCpSdwcLvbakI54DeU3","icon-stats-bars":"_3BpMEjSnRwpHmzqFMvp4fZ","icon-bug":"_1jkIxdWdoqUIqYnCmFil_y","icon-users-folder":"M1BzbjBpmSR3Fu8rxXicq"};

/***/ }),
/* 1313 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"material":"_2qXXA3h5yBK9H7emlJawMh","inputContainer":"ks4zDk6QAcLO_7agO3DrV","input":"_3erC5yQuq_9jVvFrl2xb9I","inputWithIcon":"_1I7nsDJCm_f7EG2a2ORS9J","clickable":"_3EyXT6NyWCu9x0gZGtmoFk","fileInputContainer":"uJOAZVKZ6f20Vnp9mdb5s","btn":"gn3VFo7z4iYY_T31owndF","fileInput":"_1eBCMaMq9-Gs0v-zl_JX22","popoverContainer":"_1K4SfkA5P5M-vM0xZpNC2l","title":"_24wIZvElKamqLIKpX_idFc"};

/***/ }),
/* 1314 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"scroll":"_11fKWPvsYs9U9JZikvFV0q","sideMenu":"_53t0xAQ93DQ9DmbWUdRok","mask":"XJ5QDwKIbO8frMK8zqqI-","hamburger":"_2vE1RaNlOmWA3q1apUbAx8","logo":"DoEUZkWIhZh_JdTLGq97j","username":"_4SaeI1rUqNIHrQ6WE2JAu","section":"_3NS7VJxx6dDKpQGgbAs16g","expander":"_3PRGljUfp6Olpqzixu7P4D","links":"_154eYy0kZVmXsaiP1yKY3v","visible":"_2aoBFgevzmC7YbL-ymhJJ3"};

/***/ }),
/* 1315 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"tab":"_1iuHIgFzFwMpty9IFlwGwa","active":"_2pmxa4PqOPmrKXVEE_5VhJ"};

/***/ }),
/* 1316 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"content":"_26n_j22XkeU9mS-e1fuz4Q"};

/***/ }),
/* 1317 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"searchBar":"_1MVwjAUsaMY5rTj1JiPLZZ","emptyResults":"_2NaRINzEquImGgxXgHr3PV"};

/***/ }),
/* 1318 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"h1":"NFhqwt3dAnoISjP_bhz2Z","h2":"_3K7xfqmtUEBqugVtdqO8pq","h3":"_2Z8edrwvRXAGDiGoJAGDmD","margin-free":"_23Shog98ZClfb-SsUdIuRf","h5":"_2z_sDffwSjVYBPk7W9vlRV","hint":"_1J0vJkGg36a6QKTEPaWfJg","small":"_1unNyko5bt5YOYQEIag0Zu","default":"_1uF225nOYOuhtuae5ky0jS","text-overflow":"_16wH3u4xrx83wl127dRz1p","nowrap":"_3XBzfPyNY7tM8RRqAqqTMP","break-word":"_2sxMv62zwiZVIYPjaeHseu","title":"kOP4L8s0d0czHMvkdVOF","u":"_2n8byT36zZqLwD5fqZuadz","underline":"mq4RL1YheiTrulaB-SxUh","bold":"_2-nYbH8l3K6Rc8NGEL49Sz","b":"_3GupXSjnmqNi1yNFLVzuu5","italic":"_2RPClKtT1hZDdv-qiEL9Gl","upper":"_1LVW2Pzt2_zBggTeZ4-DI7","lower":"_3-qO2XOOlI3e4TeXum-7qa","text-z1":"cqZC0-l_AjZ4npH3EZH9i","text-z2":"fq5QKD05_5dwPwkmWgdIK","disabled":"_3jE1pCRm7tcOSE4rY-OLby","error":"_3FNiqCyzgI1rCoF84skKtB","danger":"_2mFmuB40WR-8OqTO3fUXfC","colorLighten":"_132EOokJAPpSp_fwxKNz0j","colorLight":"_2AFK4l-_ZfD_2SvngSQXWZ","colorMiddle":"_287bAiOOgdvm-6Blcr0qqN","colorDark":"vFGiNT9lJMRbJAstL_A83","colorDarken":"vFGuwQTQP-n-_m-0KP1Yf","colorSuccess":"_3XoErPWVrqeQDg70gwZRtY","colorInfo":"_3AvB-R_SC-Rfb20MPSOMIU","colorWarning":"_1aM4_ql41MudDrQIOj4KRr","colorError":"_1NEkYopmDp5Gjj0QgfvcnG","colorPrimary":"_3TLcHACfWhM1FSExCbjoLd","row":"_1yUYqYk-lcFErXZcGKHl6c","index":"ooX50GGbUBC5huOctvMWY","artist":"_2nHsd4m0lBl8GaPEYXow9q"};

/***/ }),
/* 1319 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"bar":"_1M8_4P1UwEcUfHDHqgVnOy"};

/***/ }),
/* 1320 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"preview":"_1d6TLQFCiYAkBGdhk-JNIW"};

/***/ }),
/* 1321 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"icon":"wV_aOYGwuoUB2mGQ4hQs3","order":"_32d2uEPAxxZjOehU98Bc1G","icon-cloud-error":"u7g8On0DxYrXjAxE2I0Tk","icon-admin":"_30NiKHxwBDSX7YbkstTf8k","icon-info":"vUAL12odMnJaDabbVzmi7","icon-info-outline":"_3RXI0kaP5F_039Tj5nBewp","icon-text":"_3MsJLY07Fd9CC33rhlP2EJ","icon-background":"_1aWgOF3-nr43bRkATwJubV","icon-add_album":"_1WnMe3lf6cXw4p8UER9Dxn","icon-add2":"_1ofDN1Qzhqo52va1T41HI","icon-color":"_1MNtq2UOXkapyzbctY1QXP","icon-image":"_1FhOTje-XaedH7prKRsJTd","icon-tipe-1":"_2kI3RdxXb2ZeNemXtRZ70U","icon-tipe-2":"lpyUMhgwtSKrovZVyZxs7","icon-tipe-3":"_7uRnQLvE_t31gj2ZyKdNZ","icon-control_point":"ZSTImFZqJiN0j5Xf9i9o2","icon-chart":"jlIsiPsRtm9w4j2JZhZyp","icon-check-circle":"_1xyVIjnTfxudlFCqgR-mRo","icon-circle":"_4segfbKF-6PXWmYE23eMK","icon-checkbox-thin-unchecked":"ByLPBx6oks9G4twGlWiN9","icon-arrow-back":"_3X7V7Wm8396V25jeP6yUUb","icon-sync":"_3StPdU1bsgeXOAOndf2Bm0","icon-add-box":"_3hT8FD_GiE04_KC9Erh7dL","icon-chevron-thin-left":"w5XWCW9aANNvFLV7MNJnj","icon-chevron-thin-right":"_1vcJoIZSv55QGQXJLTlc7v","icon-download":"d28aIlvUPkkr0EQbCuth3","icon-paperclip":"_3rlcJarI2FUq7KxUMCuCaJ","icon-media-all":"_1bzaT0-QTJUx2EjJbPczug","icon-newsletter":"h3RbsdgibFDCn67Zdu_cr","icon-video":"Lve4BtFHplhL5ikyhsnMp","icon-sort-alpha-asc":"_2_zhk6NZhAqVULqglVhO2G","icon-sort-alpha-desc":"xHYrpupgcsPrQU-9CrxhS","icon-attach":"_1C9pZYrhmFlrmygIWDEjal","icon-collapse":"_3Gu-NyS4fEyDNksrDs9JYx","icon-zoom":"zionG2psHsmvWH_zJ7Dp9","icon-previous":"_18IvJgfvFiA8DAWZer7Sxk","icon-next":"_1gj1JKml4Nscvp1JFihhdr","icon-pause-round":"_16aVqHLjcRCoxQzSIdg1y8","icon-play-round":"A1vzLCCSqQy4Ot9ZIDgmm","icon-sound":"_8X6bARhjFDBWCTA1Vdzvy","icon-reply":"Wleuz6-R2_Vhuedd7V3sE","icon-chevron-thin-down":"KCUTVO3vCZIpS_UgCZCVd","icon-chevron-thin-up":"_1TqLIfVbrQXWDJ7Ajpj_jo","icon-import-export":"_3y1aKcevuw3OcdHyxdlhow","icon-drag":"_1Axx4kvzAjswKPxJ7zmyCM","icon-music":"_1kQulhNDSvRmp0X3Sq5Ahv","icon-paper-plane":"_2QhyH2AHW-HnZ38yMqhrTB","icon-lock-open":"_14Ej1twDmeI25deQxwnscY","icon-radio-unchecked":"_2avA-hYMV_VlEPulMXdmUc","icon-radio-checked":"_28YPnviVXyn6JmTWUkSS7X","icon-upload":"_1a7f8U-vAkDM6wr6wS50Wy","icon-add":"HztLgM6-Y0EB9cV0B9BTu","icon-remove":"_2Zup-bOwAnWwbK1bI-oNhG","icon-mode-edit":"_2JJPT6FHx_fBXlFLbTYHMc","icon-search":"_1eiEafX-Y4MmhytF3ryVWf","icon-grid":"_2zjXprND3uzNRUpeilgLC_","icon-list":"_1IYqhGqAskvgMSTqMMgPqg","icon-chevron-bold-down":"_1hNiMmaRGFb-3vSqi5MoPH","icon-chevron-bold-up":"_3rT4vuwEabLiSPfZcm3QFX","icon-home":"_1PZ9NztIqUwMG9GRGwSBzW","icon-volume-down":"_7Co-p9acGOm-RaqRPY5fI","icon-volume-up":"_3b0PxDb1DeHfkg_vFvHl7B","icon-checkbox-checked":"_2M_niCP_Zw5LQI8S-xOMOY","icon-checkbox-unchecked":"_3PVlUEzOy21mwk5pRMaNd8","icon-priority":"_1sVDmITMiwhgNzt-K82PaL","icon-check":"_1hC9rSPKmc2YPnBYYurOQ3","icon-close":"_13JbzZpkd2T0DupD8u0Cnv","icon-warning":"_10w1uW2gJz5hJg711jFl5h","icon-back":"_2S3rM_5BsMmu0hcLMxelgW","icon-order-down":"_1DoW4mGnHnbrvREKm6oHJh","order-desc":"_2-yddEVDP4gL2nSyQufnLe","icon-order-up":"_274mzOODgz-zOQEZEgkdvF","order-asc":"_2Q9rhv8P6FFc0nQOaK0gJP","icon-menu":"_2lc8gXzbpcfYs50IUd_p2K","icon-delete":"_3gtvReY2n6FeqH1_yhjud2","icon-more-vert":"_1K824RSYFixJDsQ66Ck8kk","icon-more-horiz":"_26IYQIDc9Jwt8Q4AvB2Om9","icon-play":"_3UUWyJW2xrSX3R_aYU-6YJ","icon-pause":"rLiG5aojygGeUPl3--fl_","icon-exit":"_3kMT5040WwSawsokoZ3wSF","icon-users":"_2GQWiKBEYmCwKA-hDF0W-0","icon-user":"_3xkGxRovMIrWtDlX0a9Xk3","icon-playlist":"uV7eYQ_ihI9TlcsGdxP_8","icon-forward":"_1eqspq43y5eUJ6KxZMB4LV","icon-stats-bars":"vDF0NrOCGB3DLAvGqJP8P","icon-bug":"_2R7_SVPDQtseUIdE8wg0wK","icon-users-folder":"_2khg1J3YVaGVFFwivsDaGE","sorter":"_3RetPbDH3MgZRNuX1i3b-X","active":"_3Y8eRqnzguVlzpAVdu92iU"};

/***/ }),
/* 1322 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"spectrum":"DO1b8ZUOw4_K_Ipd68vBV","active":"_2r3XAEAp8R88fRqIXoDseq"};

/***/ }),
/* 1323 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"_1UFfxvA0QT_dA38yqb270n"};

/***/ }),
/* 1324 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"infoIcon":"dalhwoKMS7UocmlMhzhXS","expirySoon":"kB2StdV9yzah2PU12yik0"};

/***/ }),
/* 1325 */
1235,
/* 1326 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"toggler":"_26o4cuq53fCpgZtMC7oWB9","buttons":"_3veM_df1UHH2u-oWtMjOyr","citiesCheckbox":"_1mA2akcTwraEGXFkR37l__"};

/***/ }),
/* 1327 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"shareButtonCell":"_3thxOxCOjvkcPJFsV_Tz6V","shareButton":"_1RlVN5qqebkSCQ3hIPl89I"};

/***/ }),
/* 1328 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"chart":"_3pS3FguelgsZBZ7Bj8bRSw"};

/***/ }),
/* 1329 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"_2X9ksABckf5xjYtY_OkLnV","title":"_9tx_bDcOO1DHML-v5SRCj","changeLink":"j-lLFJ6qJbwbfA1x9t-Tw"};

/***/ }),
/* 1330 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"periodContainer":"_1LxhGu-3a2ly4sce8PrBU0"};

/***/ }),
/* 1331 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"icon":"_2OnA4UWyGQ245F345SmCLy","icon-cloud-error":"riFNiyJXj8QdL5eCaK1Xq","icon-admin":"_3CzrRaZ9n8I4SKVzpZRyoZ","icon-info":"_3i-9ubrqH_CaeP_n-63FLK","icon-info-outline":"_2zV2v9BUjPcAtJIea_XD3Y","icon-text":"UBVe3PS_J1WqX4vJpf-bn","icon-background":"_3tHbJJXOeWEM9KqCtLg4W4","icon-add_album":"_3-Vu6aaTTPRdBYIoxctxXx","icon-add2":"JOwvJ_MdpJOTgoqRDBMCO","icon-color":"_8iCnfE6qkxh8qJEBb5Zs4","icon-image":"_389bIstopny7cNZnakf5P7","icon-tipe-1":"_3GDS0iTRGIynbKcCwTsTmp","icon-tipe-2":"_3A3KWsWJ7oerns0lyKSDE-","icon-tipe-3":"_1sn_LJo4B0WwKEgSgptE0n","icon-control_point":"_1i-X3ycHD1TY45l-65ob-V","icon-chart":"_3pXnAibfBGbMZ2yKLU88q4","icon-check-circle":"la49FvASCtTjGIv5vIeEj","icon-circle":"_19Ei2sbyZubDSCnQP8h0Uc","icon-checkbox-thin-unchecked":"_3oB2zZnScHYQMOzqRJrwAX","icon-arrow-back":"_2patqNPi4RE4jBRbO16TcQ","icon-sync":"R9-8JKNZczTyMiHtyUeDZ","icon-add-box":"_35KNo4607vO7Gtb7ci5guX","icon-chevron-thin-left":"_3uAVz-4U5wks3TCXidP832","icon-chevron-thin-right":"_1oAFzEKEZpVR4zJZwnM167","icon-download":"_3TwIIJzWy-sZjCcIWPGrOY","icon-paperclip":"_1z65MzBoiNdhQpl1mSyLNI","icon-media-all":"_2P4q_b6CCjYUBVF73DdSvQ","icon-newsletter":"gkFlW1pgoyEpj_oAozvs5","icon-video":"_1b2h-IIzJFsvkCsZiPZTxC","icon-sort-alpha-asc":"Zc1SauTJEUXb_hbTlaVzB","icon-sort-alpha-desc":"_1xkIBFkkbS3vVlq62gw0-h","icon-attach":"_3lY9gR6j9c_zeeY1AlnGic","icon-collapse":"_3xlM6WEGXgUMBaiSL5I414","icon-zoom":"_3xSBNHZ8YzslBEu3EMk2Vh","icon-previous":"_3UPvg8QxfuJjDfSNeg_gEn","icon-next":"_3Koko-aLeHh685sX-5eAf3","icon-pause-round":"OLDFzMlDZu1V5lOLUijAy","icon-play-round":"nnDaVsdAXwxp9IckZQlCA","icon-sound":"_15eEzpI83KOxGcFw0rqt36","icon-reply":"_2uBPc7bdIK8IGApW9ber7C","icon-chevron-thin-down":"_1-Jflu_qjadAcppbxsE_wC","icon-chevron-thin-up":"U85-o19PcxnU3OVddJ96S","icon-import-export":"D4TsiPzh1TP0DsTSWIPnL","icon-drag":"_2EuKfzkxGb-sUpDRb-js-t","icon-music":"-_ejU2goGqf89pIrceipI","icon-paper-plane":"_3y6Jt-IzQWzwNrvLHNyqu8","icon-lock-open":"_2ZMaWJayRReJ5T2LgjhKzh","icon-radio-unchecked":"_3iIiRTHSHTl9cZJ2kiKsU6","icon-radio-checked":"_3TNT5JCqi6KG8ngUQXXuOO","icon-upload":"_3ss_5TZ9WUU7GY9ibY0Ky4","icon-add":"QUbfQHYrfducqGUTOheZB","icon-remove":"lXCJHMbcaYMHE6FORl8HD","icon-mode-edit":"_29C8O4VdeAIhj-rULp6p9r","icon-search":"_1OBGrjhYRNUKi0t7wbe-MP","icon-grid":"-Okt0EvXbVE03VyEhF3KA","icon-list":"_7bUqvjsH5RufQRj7i9R_W","icon-chevron-bold-down":"_2UZjECgbHvvz-TP12xNHsS","icon-chevron-bold-up":"_205PxumFh-vquVNrokZbGy","icon-home":"Y8vjeBWHOe-QsMxw4vMkQ","icon-volume-down":"_1M9niW7zGveJnjAlQrVE-B","icon-volume-up":"_3ABEP2S3oIkiPVUEdJzPvD","icon-checkbox-checked":"_5vNVFLhGvk2-ikP3vb-t6","icon-checkbox-unchecked":"_3DWn8YdToPrTruL_XPRi19","icon-priority":"_3INxCoQsPcanv-gf_sAdoP","icon-check":"_2zdhd6pnseZXOIMJAxSoyZ","icon-close":"_2pZERvfdmwnGsWsPiNHpfO","icon-warning":"_2K-wUeIFMIBQ7iqC5tV26d","icon-back":"_3zw3VZCr3PiRU53w_Y5V7l","icon-order-down":"_3_mjK-lCbFaRK47Ym3qX_j","icon-order-up":"_1tpxpJRmxzXkvXLQCJ0Uvo","icon-menu":"_2umC2Ua3xujm8Mb0Srz1wJ","icon-delete":"_2kQGdtUS_VeoHN4eiD3BiU","icon-more-vert":"_1f61G8FNx-In4t6HFl7QQa","icon-more-horiz":"AzDdTF-bg07dX4JeBPAoF","icon-play":"AQJZMGjLLdQ8PQotDl_gS","icon-pause":"_2D2oWFSmSk_ZV83hSAwGxg","icon-exit":"_1DgQPyVAGcM4OQu0myF8CW","icon-users":"_2ZgxE3T6b8EViRL07hBls2","icon-user":"az-ojjh0UywFGZpLZtpPN","icon-playlist":"_3wqg2Q1fptkLHvLFH-qIT7","icon-forward":"XEQhxAiGWIKKGQWfrwwn1","icon-stats-bars":"_1RDdtvP9F40EEww1xAARpY","icon-bug":"_1PHPi4gEZNgSd4Kt5dsjJG","icon-users-folder":"_1IsXEo2juNQwrpydikqTw3"};

/***/ }),
/* 1332 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"title":"_1b-iY5mzlb7F8dHtUNX6Mw"};

/***/ }),
/* 1333 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"_1Z51Oa3VB78difH2RATI4b","email":"_3PTWuoRaeWx0k-te-L07q3","title":"_1aUyiX8dRwo1_ixOAe00r2","header":"Tdk3H6s446bEFF1Cw1Ikp"};

/***/ }),
/* 1334 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"panel":"_2sjeC5prnfvW_w0CCA1shI"};

/***/ }),
/* 1335 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"tab":"_1ob4fdycExRTUiPnXDRq8R","active":"_2Db03QLl5Nmn0O3oFqMrNx"};

/***/ }),
/* 1336 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"tabs":"_2eGIViMBhoE9XDfDffP17i"};

/***/ }),
/* 1337 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"empty-space":"_1Hsqsd4xOqTcvshGX1Kz29","textLine":"_2RvxZSPAR-E4hHcO4EOJUe","no-select":"SOblamjL_SffVoFpl1BDf","z1":"_3mLxVzpPTr-X_2qn3H1ok9","z2":"_3XH4Ipr_tdiSnH-pxVQyIe","pos-rel":"_1BJY02IiPxVevSmUc7QIlB","pos-abs":"_3gy9yZZt2JzokycBObOywV","overflow-hidden":"_2eueAAnoJ_vK9h4rLki8W8","overflow-x-auto":"_2Lz01-1iBXWPSOK2FUyxYu","inline-block":"_2NyaXW_vNdi1LqScpJbzLS","table":"_2WHfjjfFgDuNMYiYz1m5Wx","table-row":"_1mYRg2iJw6E548Vh6hjR4l","table-cell":"_3wZ91piSU7eYxb4ntzCCJm","three-d":"_3hJAKOpG0WBarHEzjLHvsU","z-layer":"_35dxh7Ij6q1WiQTazjT1Du","ratio-cont":"-De1sNRcAVRm-MrUAaSJX","padding-5":"_3XJL1rbGTyND1f3hR95Y51","padding-10":"hhbW2aoGDUnOCWWumKg23","padding-15":"_2TUaISutzWm6Ghl8ZJrBUB","padding-top-5":"_1chNkbL_ca48xYRmkvT58S","padding-left-10":"Babynxd7l-Sjs6X4wpPt6","padding-right-10":"QXiC9RifPr3BGSUx2RT1i","padding-right-20":"_3yDjepN2Yen9rQbLRWsYQN","margin-10":"_2sk8D_bULf3kQyZ5YyPHPO","margin-top-10":"_2Eu_6F024RtBSp1AkGf7Ul","margin-top-15":"_1oyUv59iOphTZRZwVgYgYs","margin-top-20":"_3FGbt9zGKwbsp-r38L4EBk","margin-top-25":"CD_I5sdu0fkILvGmQjpFy","margin-top-30":"_1gYQSKEomwPPUOEHdJnkqO","margin-top-40":"_3ptdH9FDh9BxmyYRr0FO_A","margin-bottom-10":"_32957zRc8Ydl_6jBFAL2MJ","margin-bottom-20":"_11RZzdQIS8Gh1BHKtK0HlK","margin-left-5":"_2pSGQpJVSpGbL0Y4pdn6FX","margin-left-10":"_24S832TaRnS6GoiTSbEoo6","margin-left-15":"_1AOZZ7IOcxq40nGgfeGfYK","margin-left-20":"_2honZFma5Fr6MKxeYT0Foc","margin-right-5":"_3zy3ZRJZg7iuGDxfNkTcli","margin-right-10":"_3U6626xBOHjVfvv9XqzlCp","margin-right-20":"_1sm2vTAzx4JIOwktRep7xE","margin-vert-5":"_346Qr-UZBFqIsqmDxmZjXH","margin-vert-10":"_3DWTzaEV0NN8VGBGElDSeq","margin-vert-15":"_3qZqzhyx3JJFWJUXh_Vtn7","margin-vert-20":"BqlVCxEAOYb8nneHsuMcK","margin-vert-40":"_3sdNdFNzaB1WJ4smRQfH5","width-perc-1":"Qqte3chckXjx0Ak_DqIGE","width-perc-100":"_135xdXpKS_2e-auLFLOmyf","max-width-100":"_2rSf_0gV7fBLsrO549uf85","vertical-bottom":"P4_lmQfXHB97Pr5_AfsOh","vertical-top":"_1qDFTGFLdWUBojIl5wn7OV","vertical-middle":"u41IQfHP8i_FGLJv3yW3P","clear":"OVqymj2fY56vErBzSCgg","cursor-pointer":"ZilBhL-8bNZt1mbBxnYaI","h1":"_2OOlAjDfTDhyq51i0Y2vf1","h2":"_1mAFn_qB0lMO1Dhe3Ttkb5","h3":"_2dgMbT7KTsCkmucbGUi1U2","margin-free":"_2WGJPh6Hc_Rq4CPJL0lCvh","h5":"BR9gBNlZWxa29yCgBD3mA","hint":"_1Z69qEOKwQB_Qfq429Gge4","small":"_3NCHTidOJZyf8l54qrx7bM","default":"_2DonDGsNKZEODbsSjvtw8d","text-overflow":"_39hldCATRIMfyK52n0dsZ8","overflowHidden":"PNTeXFGnBKKcfmSsRNoHS","nowrap":"_3QdPKdknisyC05baYvp9Gf","break-word":"_2R60CH3nQ4S46u7iRUAUqg","u":"_3YujVgU5s8i077g5MBZOOA","underline":"_34sNGZPCLThQYm_5q3GipL","bold":"m8TlDk3wYvXyGF_bqI8Mr","b":"_2zffVgwuL5Ba15QEo63Scv","italic":"bhw75JjuaZTbzvAIWTMJQ","upper":"_3UyOuwgJBt3Ku455qU1dRR","lower":"_2n9PuZVL1qq88FyJONXdWt","text-z1":"_3B_E9w_NTv5jYqyQrnQ2y5","text-z2":"yIWXq3exPKbHrIKFa535g","disabled":"SaTXDhKsmML4-ykQJDr4w","error":"_20QJLdrgCiIygjQI9ZiPFN","danger":"_1B8uGWhyiCnlb_O_WVl2zc","colorLighten":"_3__sxmyYynbvA6QqZH2YU4","colorLight":"_1xoOBdgejSiXVjCJjX5jx4","colorMiddle":"_3xSwo8myENOiR_rnleUGg8","colorDark":"_3rJm1aq4BT6fCGMoJozqfj","colorDarken":"_3IKcIjAQDVJpvTH3U0en2a","colorSuccess":"_2Jpsg5QW-Uj92jDIiv5anB","colorInfo":"_3G9zS6Ro300QEC_aWeQc-q","colorWarning":"y6BQ0oZ5CCsBZ4jd-GCoF","colorError":"zzYGmsC-c4tR28Vrvg2h_","colorPrimary":"_9uMpAMESaPjFIKXYDnc9Q"};

/***/ }),
/* 1338 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"bg":"xxS0fpe0XTOMHyuoeGtjI"};

/***/ }),
/* 1339 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"partHeaderContainer":"_1Dp8Gdnt9INtx31RY-xIhm","partHeader":"_2UxAnww5PnVg9cIu5rBu3"};

/***/ }),
/* 1340 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"playerIcon":"UKXjSZ2znT9v5KhJjrKJD","withSpectrum":"N8KDxPVk7kFk02196Zb7t"};

/***/ }),
/* 1341 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"count":"_34pKkBurbJhhbptmM4fMjj"};

/***/ }),
/* 1342 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"h1":"XJdmARqe4GP5zGV2Hx7AE","h2":"LB3t3JwfZuP5IRuoVlZIr","h3":"_17xJkuirlLv0L1S4eQhR2Y","margin-free":"_3jq0smgpP_N3m0XK1zfxiH","h5":"LzTT89haBsMEJsAbG7cmu","hint":"TfFY6muUcyMcIzmrmd4WP","small":"WJ7MahoroPDQ7NKlZxYV","default":"_2wyfgOO-WOyXeqY6Jwisl","text-overflow":"eKmHEIB3tGqW9urcx6TzA","uploaderItem":"WEKE1AOfwzhuseLbpEdJ","fileName":"_3dmMEwIuAmfDg5LM_heWzO","nowrap":"RlyJGpZU5sf-csPExH9t-","break-word":"_3KCxuMIgbWZn8AAUwmQ8Nm","u":"_3JiDTEu2quSKJqV3EujURZ","underline":"_2hY1IIRT7ptHGOpaCS_TFL","bold":"F0dgdDgVkMsLqeBaLn3Ya","b":"_39aDwVEAwBMnkPYg3j3DIZ","italic":"vTlzcFKttYzXfTOFByAmU","upper":"_1syc7ZI1f1tqPx05g2M9pI","lower":"_2L5WsA52Rzn8jsHdZFcPUs","text-z1":"_1mzKJuCvqhUfT8dpD609LG","text-z2":"_3v2s75b6WXuiMd-aVI-T0b","disabled":"_1zcMlo9tyN9JLJoI9MwpVU","error":"_3fl9EoYnmRNkgNmi31YRvp","danger":"fGx6xiJpixIIgh3H0WkTz","colorLighten":"_3j7jWCkQAKdrW7UGjynBvT","colorLight":"_2SfyBqErJCdzMW3TYMQBpn","colorMiddle":"_2cXQ6TQHQvZIBIlvNjnRTW","colorDark":"_2tSZpu-jpXHf7jlkaG7YF3","colorDarken":"_36ROyAllD6ptv9GSwIK1A-","colorSuccess":"_1RvKdRy1HQdcaq6-pjpMVM","colorInfo":"bLHUpP3Qob1KjkBbA4Yfs","colorWarning":"Ue2GXMCvGh-d1j9qlS_so","colorError":"_1DZqoQnIkPYMZVUMzElpnX","colorPrimary":"_2ZstnCPvBQsoB5yvggKKwJ","thumbContainer":"_1rotx_k6ZiDVY1FX9VcP9m","progressStatus":"_1SnImtWCnfBjC-u_TB-yaQ","uploadStatus":"IGB7PnUjJ6R_3joQNkXXo","fileSize":"_1vuKxEhnIhjVm19xXqvpne"};

/***/ }),
/* 1343 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"watermarkBackground":"_1a5vPEnTne-6R-f4ofTpcl","watermarkBackgroundMuted":"wTOss0zzGO7JWa2nFHmR-","header":"pJsstSepP-ig4Leao_6QD","page":"_1LZ1gPd2EoJqg8R9o7MBFL","content":"_3yj8l4Bl5PJo_z3jmK8Ot5","buttons":"_3Cb5B3E98XnJWEHhzdpVhh","terms":"_2fh6BUD3gOcTAhKp3Ecom8","marker":"_3_7q4wXhd8m-peAfZKJyTT"};

/***/ }),
/* 1344 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"line":"_3-85JkQ8a9EcYGHRSDa0aB","title":"_385EtDF2iMsaAT6PU1LS0X"};

/***/ }),
/* 1345 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"status":"_2WGG7xsmdigxpC5p9gjmpw","hasRights":"lEnH2aL2rtfkzC4o9lBTg","success":"_1vCFvfsZLD7iWPOwgajC86"};

/***/ }),
/* 1346 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"h1":"_3bqvTF7Acj5ZTQJ3cazVZ_","h2":"_3hXDdJP_hecxe7HVGotjg-","h3":"_229Gsfl3DJol328MLMzNxG","margin-free":"_1OR68G9B2C6II_s-t50HUv","h5":"QX3F7ykdJALHpu71Kjkoy","hint":"dCnxMKTf7emzcBN90j7S2","small":"_1HlNKIgDj90gZ1SbQ7Tdzd","default":"_2igOwfHFUv-BzmSWHEkxkC","text-overflow":"_1EcYFZ9pJwsVBroq0qDMvG","tag":"_3czJ5Fb8tB4rkTfCdAlPbU","nowrap":"_2msysVx38B8INrFzOUvhWW","break-word":"_3OQwW63227FvHjZw87hbZa","u":"_1A4Evbu8MnXb41vyZ5C90B","underline":"_3Ay5Qn-2paXnptiiNavB85","bold":"i577Sr5gR4X0SBj2reYdq","b":"_3drDsA9rfZY4g0oXEbc4j6","italic":"hs4F67JjPu9kNRvC3OvMu","upper":"_1Tj3FvvibHiYCtD7kz1yIB","lower":"Qi_osmlpr9rRT5vtYo4zV","text-z1":"_3yQZSqeMX_4xpypg-avq3y","text-z2":"_2CSxr3hCN_PIxB-fR81iVK","disabled":"n9l_5_9A-_UxAb9vZMtVk","error":"RUOhqp0MSUa51-OmWrgeL","danger":"_15dTVk74TsSK3Uh6PxSHXF","colorLighten":"VcXQ5JdkGEWc95Cx4bBBg","colorLight":"_1n5b8_XKDM3AEH198ll1zv","colorMiddle":"_3cla39IkI4p_3_oj4UMvY_","colorDark":"_1cOMMBJpXhVHAUL8P_yUS4","colorDarken":"Jzb12YqNYdGYvT72a8oVk","colorSuccess":"cxxgPJINn6TaLB4g14CfS","colorInfo":"_1ma1AMZdQBm4ev__qGJpOW","colorWarning":"_3Mo86fQMQEZ1ee14HI6HhB","colorError":"_2FxTgX26vpxIthHfdrpOoS","colorPrimary":"_1oW3cNJ7cuca2lNj_j8tIc","tagsInput":"_2JNX-AB8YPzj03rW9GKzz8","focused":"_1q_DgVR_SpQZPQv6WEsUV0","tags":"_1SuMbElEYf6cNIhvoyI7hm","selected":"_1ie3vn_RDErsjKhA9vSD1G","deleting":"qrnYNEtaMtA8Vv5rAtIhW","closer":"_3ZqVwKaTsFPF8-qYpcNRn4","autosuggest":"_1BqYgALj6eBUqd1nSW2KoL"};

/***/ }),
/* 1347 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"section":"_3MtEFmnV-x4s7KReyAujAr","personalInfoGroupItem":"_3Wn4XvADX-pmMPGsGaA3ew","emailType":"_3_6tsOaL5IDGLcu5k-U4G-","emailStatus":"_3GLlTS7_leBBXGR-tifq_t","emailVerified":"_2Klx3fw-ZoxZX8SmXxwigx","emailNotVerified":"_3vJ3d3vmgxlQhURi4Fu_1E","nameField":"rsv_yeE6qd9m54xbT3_ih"};

/***/ }),
/* 1348 */
1235,
/* 1349 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"app":"_3sz-Jorbvi2LDO38TpQcMl","withSideMenu":"_2P7aVzcOZDvkxBQEYO7xgG","rainbow":"HZB3NKzYHhH24XAHwK3D-","header":"_3Ee_zvmheo5MP90PEzHqmK","content":"_1xM1AikmVov8veARQ3yrpP"};

/***/ }),
/* 1350 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"page":"_3eWgKFdtz4L8NUlOQCg-2V","headLine":"_2zTWxT7pKc6hOznKLvXFWy","bottomLine":"LcXlb2RnBK5ZZPMdcMu8x","buttonContainer":"iiZ23eOz1FXaX8UWCyWo7","pagination":"_30o7Jl70WEvy-1SS--uHzI","optionContainer":"_1e5mLZfRmqDDG4RRQOkz3M","form":"ZyG5WQIbJbK2nhSfugRrS"};

/***/ }),
/* 1351 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"feature":"_1fTHS5se6bnMqyCDehK_4k","homeContent":"WfjRZfDdDD-jbY56ZzywJ","compactContent":"_1dl6-2QunJ8vuMwMzdUa6","page":"_2Gs0EsXTnOeTU4WVDQ7QRs","anchor":"_2CtVr6rV2HTyywYKrwJd-l","fullWidthSm":"_19RivcOiX0u7wrRjPQ1JPc","fullWidthXs":"lt2yFgs6dEljDTwhEZzeJ","narrowContent":"_3Ons6bpC4PzGAmvpF0z1Hq","separatorBottom":"_3BuIy3mCFE9bp2DxSiQIFw","section":"_1LfSw5vnQBNOPB7Wax5R-a","separatorTop":"_3UVBVnLfR6pqn7eyEIn64d","h3":"RveNQaaqvzPndIrQnJDCK","row":"_3i-RfGoZZRO1cbDVdLIxYC","wide-border":"_2z6Jfge_3PJwNGB2wQ6bjd","home":"_1bkobqFU5kVT0oGiIQTgp_","copyright":"_1XLVZk574eGzpQFImOFXHn","withBg":"_rY9ZulLwOlK18v1a6-D0","mask":"BpDlBNrQwgorzZz0NWxnq","title":"_1ShFSmeyY0Z-GgQ-dszjwt","subTitle":"_1ytILAhWDf1yY8vZ_P5hN8","text":"gkjeHc-OaW1jd5hkcfg6c","buttonContainer":"_2Z-BZGvOvG0WEgF6jPZn1_","content":"_3arQiZcnYl6j337OW7vhKp","scrollHint":"_3NqVzOEO3SFOXQeQpvSiKq","scrollButton":"lAQZeta9_SUNkrKrVaLT8","features":"_19Yqo6ZxfErMwt2AgoT1Hu","graphics":"_3VKXHWMVYyNFBoRBUdHonf","left":"hZQXGeBKAlezHMpkxxunm","right":"_1R_BjGsG6gFb3g-OiBUZ65","header":"_3z3JyEjK7O1rJR5SOwBqzF","headIcon":"PmvLC-ytwu8vAKaDEaw4a","textBlock":"_1pVNn0CpX5ogoe9ZZUTODk","feedbackText":"_3sllpS5BlDCWFYX3PtiGlk","feedbackAuthor":"_2r7gt0yiOO5x5Et1M67QJ3","moreLine":"_3lunr2OY07Llwcwf-B7Lhj","moreHeader":"_3KfuPF2l4HZjINQC9UeMSJ"};

/***/ }),
/* 1352 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"infoPartition":"_27oQ1MbMXp35dz_AklzwDu","nav":"_38d6WFoHMQmPjHUGNuyXnO","active":"_2I5ngMoa8BxFV1rXZz-9y0"};

/***/ }),
/* 1353 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"headLine":"_3ZZZB4oD6MLlaqXW2669lO","info":"_3tsRhRpFVbaLK5HY37HXIv"};

/***/ }),
/* 1354 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"icon":"_3PKisBWTugvAUUSMnayjSy","icon-cloud-error":"TaPzutuAZQlXJWCKNaOuH","icon-admin":"LZFfsHzFxiVRd28sSx8Mo","icon-info":"Zpqe2jubeO6DReZ5SdkI8","icon-info-outline":"_1FiGFq-5ch_gFN17CbgIo8","icon-text":"_35-zWBzCk1ZbTBXQ43bbjo","icon-background":"Z9P5zOIA-fYka7TD_v21D","icon-add_album":"_2FGgDWSkXUL1_Zak4gJstX","icon-add2":"_1ov3rGKlGd69Irv2mlsu0Z","icon-color":"_3cyFs17eQ8jFlNWhXe6-TU","icon-image":"QxMK5wLeFJC85wbYNR3-Y","icon-tipe-1":"_3wbmocsedy7twuH4jLfCxq","icon-tipe-2":"_2vG2a0lMOb96YXVZ9EYFgA","icon-tipe-3":"_31tFF-x6nvnOINYAhD4dn9","icon-control_point":"_3RnNeQfq6UcWdtrgobpddA","icon-chart":"_2qG3QqoBIzotWo8HHHHdHU","icon-check-circle":"zLvWtsRNH0t4L2N2YZtU3","icon-circle":"_2qgRxgVpfJSfOU3SnZnEGV","icon-checkbox-thin-unchecked":"_24iHyirsec9zPsNsnM0CSd","icon-arrow-back":"_1-diyEfX2NhBWDoafmE6AG","icon-sync":"_2tBzFiJOTsjThIKqMFLT_M","icon-add-box":"_31JtkuBZOr89MWz5OsUHAn","icon-chevron-thin-left":"_1PGhtbmT3JK3x9DYaH5rxn","icon-chevron-thin-right":"_1GxnNHos1MpycNgrse1tus","icon-download":"_1IX7Ph6_tjiVOHno3kkfTr","icon-paperclip":"_1eCk8aqi4xjZDcQc4bHGkP","icon-media-all":"_32SPh_PDrzWx729y95nucH","icon-newsletter":"_2HdYjgjpn8a9xeOlx4UmYO","icon-video":"_12EydCi9oAsy2VhkYflwbA","icon-sort-alpha-asc":"_280FpDUFpT0dtd8xnENOTZ","icon-sort-alpha-desc":"_3rrdRoAH1HZNbsSaG00vmc","icon-attach":"_3MBomAwU1uImI4U36vu9yL","icon-collapse":"pf_7aD-I8nvjpNdFNncG1","icon-zoom":"_2RnQpBk2KKlWXBGlaa1AWD","icon-previous":"_1uwgkMFhEEA7cE3cQSY6uH","icon-next":"bGgN6sqKX9vdJobuYa5xO","icon-pause-round":"DnwKF6Hiq64-WaxOXaSD_","icon-play-round":"_1IA6gPlq7QOpH13UJEWFIy","icon-sound":"iKO4gLGnNqPwNQ6yvMf-3","icon-reply":"_1_WZXBTDQ8g25aHLQljJUu","icon-chevron-thin-down":"_3TnRp76YOm3HMMMQxvVSIn","icon-chevron-thin-up":"_1Ml-MskEyOFwvziMgd5trP","icon-import-export":"_35lv5BZ8F60JCVLTrVWHp6","icon-drag":"_6YgWHtJ8KizspZF98h_Ki","icon-music":"MpnTYTFzfrUrsVafl9nQ4","icon-paper-plane":"_3vk_npyFCbKwyhbwM261ex","icon-lock-open":"_1Mo2KAQJFaTQYUOjQhhK3r","icon-radio-unchecked":"EX47SW-CdrBO0ZVTgxtWE","icon-radio-checked":"_2gl3_gMkqYs8MHDBh1XB4J","icon-upload":"_3ua9zya14eEwdMZhfPnM0T","icon-add":"_2rP25_70mANf9LIohnKMIu","icon-remove":"_10ikBJINe4MVT3Eg2mgB46","icon-mode-edit":"e6cIfVTvwo1mZIj25i8rl","icon-search":"_3ygUVPl3vYgFbjqmhAdGHa","icon-grid":"_2cpzUC7MTmmQ_PUMF3kD1A","icon-list":"_3fGS2wjLNGZjuTyAv3QFV8","icon-chevron-bold-down":"k8XqEGER5QfTwCFbriFU_","icon-chevron-bold-up":"_1kyLkBVJsa6IgrXshl6ojh","icon-home":"_3vrL-dHZoWEpF57ymwcx91","icon-volume-down":"_2H2pCracZ74ZEugd6_DZwn","icon-volume-up":"vRDmo7M7TLE6LXFzMcsLT","icon-checkbox-checked":"VHK6ZbhHEGjjjZSAEBZEP","icon-checkbox-unchecked":"Hh1AJVF0ppy_a5A2lY6FT","icon-priority":"QsXLgbed1qORQvBIPKacd","icon-check":"_24LP08qR8Bb7xPHpU4OfD5","icon-close":"iyN_wVjD1BCdKsF1UgE-g","icon-warning":"_1eEuWNnMnmkXjwXKdj0b3u","icon-back":"_34ODOHfj8kxA6CJcWTHR_Z","icon-order-down":"_1mx3AmlJJByFctNOI1PolL","icon-order-up":"_15d_BJ0tt94uAr05xKW41L","icon-menu":"_2QWvMeJoPJjtFMx2ZDBE4E","icon-delete":"_1a0Djn_8fBBJBU-lUQBzso","icon-more-vert":"_2CBSxzXq6rqBwAbCexETkh","icon-more-horiz":"Jdb4KVXK6zWOSKOp0mSfK","icon-play":"_32nliRIBPt7v8Fz4Gs464S","icon-pause":"_25M6f16434ml61LWAW1tVx","icon-exit":"QAdn-VIULHtVGmhIwNCFA","icon-users":"_3j0DJZV_cynrg7yZDgsMd1","icon-user":"_15FVRKfQF-FpTu9mrr2w-g","icon-playlist":"_1RTnAJ4DGVeIo5PtEQmYhQ","icon-forward":"_2JhS-xkss6CjtIv6HKDMGS","icon-stats-bars":"_2U4f7DVx6O2TO8CmcxgwsP","icon-bug":"_3RbIq38xq3ou3-Y_GlGBLA","icon-users-folder":"_3ejEog-wUUJatIYrdYbkpS","container":"_1CoPKRYI9bi5vh-0ZLpto6"};

/***/ }),
/* 1355 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"headLine":"fhtX1cSw5MhEiFM7CQs8Q"};

/***/ }),
/* 1356 */
1235,
/* 1357 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"bar":"_3jULjZvTymUaGANA8Tj8PS"};

/***/ }),
/* 1358 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"panel":"_1AhhfUmTdEbIECjTnx73cc","thumb":"_3eumtQcF7iwEY5M6SaKyH8","descr":"_2TEXCttXk9mtppGggh4VHC","header":"cpzZDIfNSBz-sQpKvaRuV"};

/***/ }),
/* 1359 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"playlist":"_2j4L4SXyRpgDG0q305Fp1d","trackRow":"_3SMwmRP13gkJQU2epITPo","denied":"_2cy4rJj-PmEpD4zU7f56zH","timeCell":"u1lkvfzoZ13JwBrqv9Eoc","checkCell":"_1zrZgLaoDDiBMgThYOQXVV","playerIcon":"SDBTqcuX1kdEe5IKdJocq","feedback":"_2PGxhqxxIQxPD1j0qzTT1t","selectAllContainer":"_1O8LZYZB9DSU67ANoci606","downloadFormat":"_2SkGw28TB8Df2cZONZhS3S","spectrum":"_7ta1CCLzpeoiX0-7Gl0Ch","active":"g4GZMiYhoO60IYPG22lTW","addPlaylistCell":"_2COVzebwyWCe-dxlq-kKV-"};

/***/ }),
/* 1360 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"homeBtn":"_2LWtmMMqWRfAndCXF9WdEe"};

/***/ }),
/* 1361 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"empty-space":"ydqwNPDiJ2rzMXULzWnBx","no-select":"_3LRBg_YT2Le_AQq-aQf2z","z1":"_2zaX2v8cB85-HYEbXSHKiI","z2":"VBWuiKbnNsP8RSmv-GcLh","pos-rel":"_3o8Ip6JT0FIIwBx396uTGF","pos-abs":"_8gYoeARvzkJK4cijsHmAW","overflow-hidden":"_2Ftgo6EPtkd83yhlOyXn2O","overflow-x-auto":"_1VMlCWpf_4fcqTi1Nc0buV","inline-block":"_1QNbQYhQ9eIYskqnBmhH-w","table":"_3unxpfYhepQuFjVs_rVqHs","table-row":"_6BILMyljku9ncImRc7_EP","table-cell":"WQc3cMO45pNXoHDI6P_3T","three-d":"_3zmmIErOWJeMqeG-53hzB","z-layer":"_3wh4WurgBGGBHXfEdiYlhj","ratio-cont":"_1nd2Od4ICklUDsgF50Mx7N","padding-5":"_2_XyimR7ZDZHhJB2aOx4pd","padding-10":"_9aYovtRU2P6AlJnDzBgua","padding-15":"_2AqwhZ7rZRuVU-PWQDGm46","padding-top-5":"_39ps7f2yNRRUF-X524E3Wb","padding-left-10":"_39yMhv5Gk_uU_jQ-oRoI5X","padding-right-10":"BOLBzstjSHcr6SxYEC3H2","padding-right-20":"_3B_4ctmT_HtFHYs4phcJ9u","margin-10":"_2XiKrSciTjLWxgam4YNi2G","margin-top-10":"_35IfrowmreU0MMDu-8-xnt","margin-top-15":"_1iZCiMemdIbZFXT-PahZm3","margin-top-20":"_2-VHjLms0geSEenowKd8rg","margin-top-25":"_1dguaSrurM7mC_VkupQyaH","margin-top-30":"_2jI8u-eI-Pbaah44rJ7lHn","margin-top-40":"_1vl-t3Uh40fWgJmDvmoq0B","margin-bottom-10":"Npzrh0YXfOcOJyRFDC1D5","margin-bottom-20":"_2vsjdczEvsdrSHeG_gh44K","margin-left-5":"_1aqoc8x-zgQaGmdhYXJJS7","margin-left-10":"_2kE_ovF6So6gKXDNkqmpJb","margin-left-15":"_3CFC-USe4pxxO6Zz0MZA9G","margin-left-20":"_2eAg7M4jl_Z6lsVraaOUGT","margin-right-5":"_2nM71i1gDdaSeR4TTHfTrj","margin-right-10":"_3QDuPaU-brCyW0KXypbPE1","margin-right-20":"_2KB3uhZgOOOAUA6lsv_LaA","margin-vert-5":"NdIv9jndZ4IHPv3MDi01Z","margin-vert-10":"_2bfS75aMlrKKOMrXdwkYYT","margin-vert-15":"_3L9vrVl9laFdkhdVBB5BDf","margin-vert-20":"_1xqJKZHPzB_G9FkGfr-GPO","margin-vert-40":"_23_n1NKDVJP0KXn65ksswc","width-perc-1":"_1HH9JJJ8qfnpU18s204dQs","width-perc-100":"_2fb7O9d0heTFfQLDYJ3Jx8","max-width-100":"_2X4v9-3iuSowWxvnGScTmA","vertical-bottom":"gfRxMZOSpJjakQh-pyuYo","vertical-top":"_346CriAOiCFD8oYjlzZgNq","vertical-middle":"_2oXZjSFY3HNhDy46q8xPvn","clear":"_3X4SLrbW8xQJ6K-LnDRWbR","cursor-pointer":"_34FM2J2jjTmu9INPOU0Psk","h1":"_2bLgibkPr1iWUj6RWZqauy","h2":"_3vrdEt3-BjGmnByXLh0IWK","h3":"_36Rg35llkDHtVn0dIZBVzR","margin-free":"_3g4_ZhTl9Al-0rM9tmplIs","h5":"_35lwI7yfCHDWef3CqD21zL","hint":"_1H9A8DaX3uErL0kSII6raW","small":"_2WOaR4nMRYV7QAqM0GxBSA","default":"_9CBjuyTKDbi8CviI9j-uL","text-overflow":"_2cgC1dOFAxjdFYoYGt81_e","nowrap":"_1nwCoYUuEfHXQDByiyZY1u","break-word":"_34pDyy3A885-IlhVv5Kiki","u":"_22rCcQHjK-__QIQkKX0HOW","underline":"_33q9l_CXSFW3yiHv68gqJm","bold":"_3rKquliHn1WCa238ViypxV","b":"_2StGJzoe59nTadL7qtweal","italic":"_2FbAcaG5Ij6t4mz6mhMOXP","upper":"_2z2KToRP65pfMBmbw5N7fr","lower":"_2RidFQre_tXYTbY2mMoXzN","text-z1":"_3Vs3CxZ0_fF5uPkxrvL0pp","text-z2":"_20wgqGWVIgPh1fymzbod-y","disabled":"_1w6x1qwn6eOwcDfo8hPRct","error":"TGyQliscpAzBd461AA-HN","danger":"_2hZ0fYwZixP_iEO03cJhh-","colorLighten":"_3V8bSemRHwuR_NzEpgMQka","colorLight":"_3l2yK-0sZY_ribCk9ZUrcq","colorMiddle":"_35wLYXHTsDnUwcwfb7aOyw","colorDark":"_14yE6L5XThqK-YIarc6q_a","colorDarken":"_3q0Jbo214WowcpIPLi1HlG","colorSuccess":"CkYvvtLuqJNlJQUfb6zzl","colorInfo":"_271SOyoUHbEHrkU7qEIrtT","colorWarning":"_2FwKZ-d0dAptqb4BLyGGcW","colorError":"_322bWQtH6coAESCvpecXNJ","colorPrimary":"_3j9A25ewBJT4r7Z9WydE99","playlists":"xhe4OdihYdNEpNCLyToh_","filters":"_1K1yEw-WLmMR40IQeZXf9S"};

/***/ }),
/* 1362 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"sorterGroup":"_3dFpbiQEU992kM75na1vL"};

/***/ }),
/* 1363 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"searchBar":"_4p-qup3gR8iNajEi41UiJ"};

/***/ }),
/* 1364 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"sortTitle":"_13Ogo9p4EoxNDjWmOIzPWz","sorterBlock":"ZPqmpM2oeQvTBacFp5-vO","orderSelect":"_2yymHW5dI24Ef-UpYIzhxQ"};

/***/ }),
/* 1365 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"viewToggle":"_3waobOwyXbWUDrnTWdyNKw"};

/***/ }),
/* 1366 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"infoRow":"cmziboEw9jh-wH2SQN8Mf"};

/***/ }),
/* 1367 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pageContainer":"_11Urg2gVfvsXqlnzVK8as6","copyrights":"lRhraN_Rsh0kOeuw5_5-l","sectionToggle":"_2c-ktJLzRYSp0FKWFhMvIR","withToggleHint":"_2ap3SV2jvifBmea7d5TPpJ","checkboxRow":"kixRQO4J1nEJqKpuJmTmt","toggleHint":"_11YQ-I0DmyfgLvd1QVBVwx","listRow":"_1CzOtjasn5yByGb9453Ze6"};

/***/ }),
/* 1368 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"panel":"_37eiA_2EmQDnS3VceHCE5h","title":"_2OHr3MG9Cyy967Hj7WYC3n","content":"n5ZSM3GYolsepThXsVBR_","projectsHeader":"f7hj4vmCwvkGHq5teuI_c"};

/***/ }),
/* 1369 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"sendEmailButtons":"_3bxpAk4HTmxafZjyyOYySl","sendEmailButton":"_2Ye3YR-UZlSeVoAak0Pe2H","remindersHint":"_1dlbgPXLEdTWLni8Cc-vVU","addOption":"_1LC3cHYhGuw-D3dRRuERXl","csvHint":"_2SzQoKgNK_2vOZD91bBjAH","remindersRadios":"_1T2bcsjTHxZTxmO6_o5_tm","reminderRadio":"_1Gn1CvWhe_D0sW5gvQtGM9","reminderText":"_1_EJTeLwY43r1u5wFds63v","reminderHint":"LKUAXOJKGGqFNO7M2da4T"};

/***/ }),
/* 1370 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"senderInfo":"gTcj42GjqdyZw7a5u_LmR","senderName":"_2lsV0Czi9a9mK4pmcIoVXQ","deleteSenderContainer":"_2HGOeEcTImy8qWs_B_pAEr"};

/***/ }),
/* 1371 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"actionsCell":"MN9t8eDNt0rwW0aUaowek"};

/***/ }),
/* 1372 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"header":"_1cyy-ZKyEfhPlkKWicJRau","subheader":"_2RCvYEjT_iTKPzDMN2xWc","row":"_3wG8SdTsz6KNiyTewLTRW_","name":"_35_DptpEnlsoBLi65s3qcc","error":"ODjzkL9_w4Gy3aUxHTuJl"};

/***/ }),
/* 1373 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"_3Kb603qHw-hEDR0RunUDBe"};

/***/ }),
/* 1374 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"projects":"_24WPq1Bw1VxYMtg5M9tn8H","header":"FS_42G_pyMsKUFi3bCuHh","headerHint":"_1Al1O-t7_vh1Tzz6JH86eI","searchBar":"UB5SjkZAwvhJIA9XpBSSm","searchInput":"_2g29N77wd29FCrjuXs07Yn","legendLine":"ANRsFzzV9rG-o6fvAvDOO"};

/***/ }),
/* 1375 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"homeContent":"_29H1GzIyBiepMt3rgppVop","compactContent":"_2z23UeBpR_vnomEdBa-HdQ","page":"rc0tqDgb8GmZaQGvL3Qcy","anchor":"_2lbom9nKuDsA7xGcdXIyDa","fullWidthSm":"_1D2VsNRB48KpXtmL6Za1HR","fullWidthXs":"_3sp9gFTV4l-r22fDJ9sRhM","narrowContent":"_1ng9VUp4eqKwXIFT3xP4Sn","separatorBottom":"_1suxIwETu1h37RF5QUlmpy","section":"-R4vQTAa-n2p5d67EHPIE","separatorTop":"_3saX362oRR7h-7PNue3VSc","playlist":"_1Q4sNxAldAt191mCsdyVq3","h3":"_3B3WKj8iPU4YlvQY54t33M","row":"_10nHnPqBrL7QF32CHPq_au","wide-border":"B44HKgWfdWpc74XfLGWoN","item":"_1Y56NA6VIpiAP6NwSbCwTJ","message":"_151JXff7bfNvo6AY2_5Bdv","subject":"_1gNTR3aZBSg2BsQJXq6prm","fromInfo":"ojrEMHy1kCKgNa4bDPwty"};

/***/ }),
/* 1376 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"E42kuTyBsvRs5MWHPrQwl","homeContent":"_1H4Ym7-t8k541bqPLj2MzA","compactContent":"tG9Gd3AmqwplR5Yv6UDm0","page":"_19cECsjLtlvodIQwW9nHB-","anchor":"_32SAY8WYMCHVb21KHSm1oL","fullWidthSm":"gn0DQkoShLunkVFisO_fE","fullWidthXs":"_2vugcIfNzfNwqp24SPbi8n","narrowContent":"_3GbMv59IcP2MVaXtv4Xe-D","separatorBottom":"_2liEf_YdfNsDfjGfKTn9a","section":"ILZCrX9IFataJOU945U7","separatorTop":"_4fn572y2IjAcnZGcHprGo","h3":"_1lYiIz9f_YW9FnCi43aIea","row":"_1VGKpJuEtvH_294dbsXlXl","wide-border":"_1cIjbhnHhMlJacIUhT3qsl","content":"V21lrIFnBIh_iQI-z0kd7"};

/***/ }),
/* 1377 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"mG9pCO5sIVyc5iOBI6CDR","boxSection":"_33eS4hYTMou0mDfVGIHLeV","viewSection":"_2S_fMcmgsilxSaz-JyXID7","showItem":"Wf3WkfVBqxzwX8rv3L85k","boxContainer":"_2VSv5LBUIdZ-47qHAjK7zQ"};

/***/ }),
/* 1378 */
1235,
/* 1379 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"indent":"_3Z5Q9NzL0BpSvV0AVv6iez"};

/***/ }),
/* 1380 */
1235,
/* 1381 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"indent":"_3OoutmwkIJz4HVdCNayY_P","chartContent":"_3M49Ka25izFt2r0idiBDCB"};

/***/ }),
/* 1382 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"indent":"_1Z2jY1-Pmc4Km-7lsJ1qe2","reminders":"_13SK_dan9IsaSzgtaBGAxI"};

/***/ }),
/* 1383 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"indent":"_24tGFdurKbLODtxlkmP1hh"};

/***/ }),
/* 1384 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"page":"_2NgE9TGp6tAVysykpNanS1","periodLine":"_2CvI1bcD9j09fI5c3e7aGF"};

/***/ }),
/* 1385 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"list":"_3dRv3HseuIiR84aPtXWtnZ","searchLine":"_3VoulkSaD5FkCF_OLdC0Xv","searchBar":"_3aQ69w7wKkRAhoA2gLax1P","searchInput":"_3kUXMvIdzKq9JGC9OaLdqr","legendLine":"Bl6Umlip9zDZW46zJN2mt","searchHint":"_1pDZVuCTvJ0hzUBW_ab7YW"};

/***/ }),
/* 1386 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"searchInput":"TMGNSEsiL-6eFP9XK0CQU","searchHint":"kVRM61Nsk5Ky-rINcIpTE","list":"QIFIz5-Wp2HkHZjxugdUS"};

/***/ }),
/* 1387 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"_22d8rsWZpwY5UVHLHAwyGh"};

/***/ }),
/* 1388 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"_3qs4IqxHpqk0PW9qMRZapP","containerWithZIndex":"_3ZGebDDQRctpXBrrEUFOV8","suggestionsContainer":"_3xq2OHMEIGNJl6HhFpnXbs","suggestionsList":"_2M5sNOaZwRrsi_j3WQDE3s","suggestion":"_2pX_6uy9DIoI86JA94Sh2r","suggestionHighlighted":"_2UIAq1nrd_903gk_uT_j7B"};

/***/ }),
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */,
/* 1709 */,
/* 1710 */,
/* 1711 */,
/* 1712 */,
/* 1713 */,
/* 1714 */,
/* 1715 */,
/* 1716 */,
/* 1717 */,
/* 1718 */,
/* 1719 */,
/* 1720 */,
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */,
/* 1725 */,
/* 1726 */,
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */,
/* 1735 */,
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */,
/* 1793 */,
/* 1794 */,
/* 1795 */,
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */,
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */,
/* 1805 */,
/* 1806 */,
/* 1807 */,
/* 1808 */,
/* 1809 */,
/* 1810 */,
/* 1811 */,
/* 1812 */,
/* 1813 */,
/* 1814 */,
/* 1815 */,
/* 1816 */,
/* 1817 */,
/* 1818 */,
/* 1819 */,
/* 1820 */,
/* 1821 */,
/* 1822 */,
/* 1823 */,
/* 1824 */,
/* 1825 */,
/* 1826 */,
/* 1827 */,
/* 1828 */,
/* 1829 */,
/* 1830 */,
/* 1831 */,
/* 1832 */,
/* 1833 */,
/* 1834 */,
/* 1835 */,
/* 1836 */,
/* 1837 */,
/* 1838 */,
/* 1839 */,
/* 1840 */,
/* 1841 */,
/* 1842 */,
/* 1843 */,
/* 1844 */,
/* 1845 */,
/* 1846 */,
/* 1847 */,
/* 1848 */,
/* 1849 */,
/* 1850 */,
/* 1851 */,
/* 1852 */,
/* 1853 */,
/* 1854 */,
/* 1855 */,
/* 1856 */,
/* 1857 */,
/* 1858 */,
/* 1859 */,
/* 1860 */,
/* 1861 */,
/* 1862 */,
/* 1863 */,
/* 1864 */,
/* 1865 */,
/* 1866 */,
/* 1867 */,
/* 1868 */,
/* 1869 */,
/* 1870 */,
/* 1871 */,
/* 1872 */,
/* 1873 */,
/* 1874 */,
/* 1875 */,
/* 1876 */,
/* 1877 */,
/* 1878 */,
/* 1879 */,
/* 1880 */,
/* 1881 */,
/* 1882 */,
/* 1883 */,
/* 1884 */,
/* 1885 */,
/* 1886 */,
/* 1887 */,
/* 1888 */,
/* 1889 */,
/* 1890 */,
/* 1891 */,
/* 1892 */,
/* 1893 */,
/* 1894 */,
/* 1895 */,
/* 1896 */,
/* 1897 */,
/* 1898 */,
/* 1899 */,
/* 1900 */,
/* 1901 */,
/* 1902 */,
/* 1903 */,
/* 1904 */,
/* 1905 */,
/* 1906 */,
/* 1907 */,
/* 1908 */,
/* 1909 */,
/* 1910 */,
/* 1911 */,
/* 1912 */,
/* 1913 */,
/* 1914 */,
/* 1915 */,
/* 1916 */,
/* 1917 */,
/* 1918 */,
/* 1919 */,
/* 1920 */,
/* 1921 */,
/* 1922 */,
/* 1923 */,
/* 1924 */,
/* 1925 */,
/* 1926 */,
/* 1927 */,
/* 1928 */,
/* 1929 */,
/* 1930 */,
/* 1931 */,
/* 1932 */,
/* 1933 */,
/* 1934 */,
/* 1935 */,
/* 1936 */,
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	__webpack_require__(537);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(49);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _create = __webpack_require__(2232);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _ApiClient = __webpack_require__(866);
	
	var _ApiClient2 = _interopRequireDefault(_ApiClient);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactRouter = __webpack_require__(124);
	
	var _reactRouterRedux = __webpack_require__(40);
	
	var _reduxConnect = __webpack_require__(33);
	
	var _useScroll = __webpack_require__(1779);
	
	var _useScroll2 = _interopRequireDefault(_useScroll);
	
	var _reactCookie = __webpack_require__(174);
	
	var _routes = __webpack_require__(2241);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _i18nUniversal = __webpack_require__(56);
	
	var _i18nUniversal2 = _interopRequireDefault(_i18nUniversal);
	
	var _reactReduxToastr = __webpack_require__(494);
	
	var _reactReduxToastr2 = _interopRequireDefault(_reactReduxToastr);
	
	var _ProgressPopup = __webpack_require__(2044);
	
	var _ProgressPopup2 = _interopRequireDefault(_ProgressPopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * THIS IS THE ENTRY POINT FOR THE CLIENT, JUST LIKE server.js IS THE ENTRY POINT FOR THE SERVER.
	 */
	var client = new _ApiClient2.default();
	var dest = document.getElementById('content');
	var store = (0, _create2.default)(_reactRouter.browserHistory, client, window.__data);
	var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);
	
	var i18n = _i18nUniversal2.default.getI18n();
	
	document.documentElement.className += 'ontouchstart' in document.documentElement ? ' touch' : ' no-touch';
	
	var scrollBehavior = (0, _useScroll2.default)(function (prevRouterProps, _ref) {
	  var routes = _ref.routes;
	
	  if (routes.some(function (route) {
	    return route.ignoreScrollBehavior;
	  })) {
	    return false;
	  }
	
	  if (routes.some(function (route) {
	    return route.scrollToTop;
	  })) {
	    return [0, 0];
	  }
	
	  return true;
	});
	
	var component = _react2.default.createElement(
	  _reactRouter.Router,
	  {
	    render: function render(props) {
	      return _react2.default.createElement(_reduxConnect.ReduxAsyncConnect, (0, _extends3.default)({}, props, {
	        helpers: { client: client },
	        filter: function filter(item) {
	          return !item.deferred;
	        },
	        render: (0, _reactRouter.applyRouterMiddleware)(scrollBehavior)
	      }));
	    },
	    history: history
	  },
	  (0, _routes2.default)(store)
	);
	
	_reactDom2.default.render(_react2.default.createElement(
	  _reactCookie.CookiesProvider,
	  null,
	  _react2.default.createElement(
	    _reactI18next.I18nextProvider,
	    { i18n: i18n },
	    _react2.default.createElement(
	      _reactRedux.Provider,
	      { store: store, key: 'provider' },
	      _react2.default.createElement(
	        'div',
	        null,
	        component,
	        _react2.default.createElement(
	          'div',
	          { className: 'toastr-container' },
	          _react2.default.createElement(_reactReduxToastr2.default, { position: 'top-center' })
	        ),
	        _react2.default.createElement(_ProgressPopup2.default, null)
	      )
	    )
	  )
	), dest);
	
	if (false) {
	  window.React = _react2.default; // enable debugger
	
	  if (!dest || !dest.firstChild || !dest.firstChild.attributes || !dest.firstChild.attributes['data-react-checksum']) {
	    console.error('Server-side React render was discarded. Make sure that your initial render does not contain any client-side code.');
	  }
	}
	
	if (false) {
	  var DevTools = require('./containers/DevTools/DevTools');
	  _reactDom2.default.render(_react2.default.createElement(
	    _reactCookie.CookiesProvider,
	    null,
	    _react2.default.createElement(
	      _reactI18next.I18nextProvider,
	      { i18n: i18n },
	      _react2.default.createElement(
	        _reactRedux.Provider,
	        { store: store, key: 'provider' },
	        _react2.default.createElement(
	          'div',
	          null,
	          component,
	          _react2.default.createElement(
	            'div',
	            { className: 'toastr-container' },
	            _react2.default.createElement(_reactReduxToastr2.default, { position: 'top-center' })
	          ),
	          _react2.default.createElement(_ProgressPopup2.default, null),
	          _react2.default.createElement(DevTools, null)
	        )
	      )
	    )
	  ), dest);
	}

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _account = __webpack_require__(184);
	
	var _reactI18next = __webpack_require__(12);
	
	var _reduxForm = __webpack_require__(50);
	
	var _formComponents = __webpack_require__(71);
	
	var _components = __webpack_require__(15);
	
	var _EmailFormValidation = __webpack_require__(1939);
	
	var _EmailFormValidation2 = _interopRequireDefault(_EmailFormValidation);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var accountEmailFormDefaults = {
	  email: ''
	};
	
	var AccountEmailForm = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    addEmailLoading: state.account.addEmailLoading
	  };
	}, { addEmail: _account.addEmail }), _dec2 = (0, _reduxForm.reduxForm)({
	  form: 'AccountEmailForm',
	  propNamespace: 'accountEmailForm',
	  initialValues: accountEmailFormDefaults,
	  validate: _EmailFormValidation2.default
	}), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(AccountEmailForm, _Component);
	
	  function AccountEmailForm() {
	    (0, _classCallCheck3.default)(this, AccountEmailForm);
	    return (0, _possibleConstructorReturn3.default)(this, (AccountEmailForm.__proto__ || (0, _getPrototypeOf2.default)(AccountEmailForm)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AccountEmailForm, [{
	    key: 'addEmail',
	    value: function addEmail(formData) {
	      var email = formData.email;
	
	      if (!email) {
	        return false;
	      }
	
	      var _props = this.props,
	          t = _props.t,
	          reset = _props.accountEmailForm.reset;
	
	      var promise = this.props.addEmail(email).promise;
	      promise.then(function () {
	        _toastr2.default.info(t('An email has been sent.'));
	        reset();
	      });
	      return promise;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          t = _props2.t,
	          _props2$accountEmailF = _props2.accountEmailForm,
	          handleSubmit = _props2$accountEmailF.handleSubmit,
	          submitting = _props2$accountEmailF.submitting,
	          addEmailLoading = _props2.addEmailLoading;
	
	
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit(this.addEmail) },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-60 col-sm-45 col-md-35 col-lg-30' },
	            _react2.default.createElement(
	              _reduxForm.Field,
	              { type: 'email', name: 'email', component: _formComponents.formLineTextInput, placeholder: t('Enter email'), hideLabel: true },
	              _react2.default.createElement(
	                'button',
	                { type: 'submit', className: 'btn btn-simple squared small pos-rel', disabled: submitting },
	                t('Add'),
	                addEmailLoading && _react2.default.createElement(_components.Loader, { mask: true })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return AccountEmailForm;
	}(_react.Component), _class3.propTypes = {
	  accountEmailForm: _propTypes2.default.object,
	  addEmail: _propTypes2.default.func,
	  addEmailLoading: _propTypes2.default.bool,
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'addEmail', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'addEmail'), _class2.prototype)), _class2)) || _class) || _class) || _class);
	exports.default = AccountEmailForm;
	module.exports = exports['default'];

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _validation = __webpack_require__(157);
	
	var _formValidation = __webpack_require__(263);
	
	var _formValidation2 = _interopRequireDefault(_formValidation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _validation.createValidator)({
	  email: _formValidation2.default.emailNotRequired
	});
	module.exports = exports['default'];

/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactI18next = __webpack_require__(12);
	
	var _config = __webpack_require__(41);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _adbar = __webpack_require__(530);
	
	var adbarActions = _interopRequireWildcard(_adbar);
	
	var _reactCookie = __webpack_require__(174);
	
	var _storage = __webpack_require__(529);
	
	var _storage2 = _interopRequireDefault(_storage);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1236);
	var googleBtnImg = __webpack_require__(2266);
	var appleBtnImg = __webpack_require__(2265);
	
	var hideOnTime = 24 * 60 * 60 * 1000; // msec, hide ad time
	
	
	var AdBar = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    hidden: state.adbar.adBarHidden
	  };
	}, (0, _extends3.default)({}, adbarActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (0, _reactCookie.withCookies)(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(AdBar, _Component);
	
	  function AdBar(props) {
	    (0, _classCallCheck3.default)(this, AdBar);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (AdBar.__proto__ || (0, _getPrototypeOf2.default)(AdBar)).call(this, props));
	
	    _this.cookies = new _storage2.default(props.cookies);
	    return _this;
	  }
	
	  (0, _createClass3.default)(AdBar, [{
	    key: 'hide',
	    value: function hide() {
	      var _this2 = this;
	
	      var hideAd = this.props.hideAd;
	
	      var now = Date.now();
	      setTimeout(function () {
	        _this2.cookies.set({ name: adbarActions.cookieNames.adBar, value: now, expires: new Date(now + hideOnTime) });
	      }, 500);
	      hideAd();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          t = _props.t,
	          hidden = _props.hidden;
	
	      var adBarHideTime = this.cookies.get({ name: adbarActions.cookieNames.adBar }) || 0;
	
	      if (adBarHideTime) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(styles.adBar, (0, _defineProperty3.default)({}, styles.hidden, hidden)) },
	        _react2.default.createElement(
	          'div',
	          { className: styles.content },
	          _react2.default.createElement(
	            'span',
	            null,
	            t('For music on the go, download our app')
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'nowrap' },
	            _react2.default.createElement(
	              'a',
	              { className: styles.button, href: _config2.default.app.storeUrls.ios, target: '_blank' },
	              _react2.default.createElement('img', { src: appleBtnImg, alt: '' })
	            ),
	            _react2.default.createElement(
	              'a',
	              { className: styles.button, href: _config2.default.app.storeUrls.android, target: '_blank' },
	              _react2.default.createElement('img', { src: googleBtnImg, alt: '' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: (0, _classnames2.default)('btn btn-clear', styles.closer), onClick: this.hide },
	          _react2.default.createElement('i', { className: 'icon icon-close' })
	        )
	      );
	    }
	  }]);
	  return AdBar;
	}(_react.Component), _class3.propTypes = {
	  cookies: _propTypes2.default.object,
	  hidden: _propTypes2.default.bool,
	  hideAd: _propTypes2.default.func,
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'hide', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'hide'), _class2.prototype)), _class2)) || _class) || _class) || _class);
	exports.default = AdBar;
	module.exports = exports['default'];

/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _index = __webpack_require__(71);
	
	var _reduxForm = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddContactForm = (_dec = (0, _reduxForm.reduxForm)({
	  form: 'addContactForm',
	  propNamespace: 'addContactForm',
	  initialValues: {
	    name: '',
	    surname: ''
	  }
	}), _dec(_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(AddContactForm, _PureComponent);
	
	  function AddContactForm() {
	    (0, _classCallCheck3.default)(this, AddContactForm);
	    return (0, _possibleConstructorReturn3.default)(this, (AddContactForm.__proto__ || (0, _getPrototypeOf2.default)(AddContactForm)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AddContactForm, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          loading = _props.loading,
	          onSubmit = _props.onSubmit,
	          _props$addContactForm = _props.addContactForm,
	          handleSubmit = _props$addContactForm.handleSubmit,
	          submitting = _props$addContactForm.submitting,
	          invalid = _props$addContactForm.invalid;
	      var t = this.context.t;
	
	      var showLoader = submitting || loading;
	
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit(onSubmit) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _bind2.default)(className) },
	          _react2.default.createElement(_reduxForm.Field, {
	            name: 'name',
	            type: 'text',
	            autoFocus: true,
	            fieldClassName: 'width-perc-100',
	            placeholder: t('First Name') + '*',
	            hideLabel: true,
	            component: _index.formSimpleTextInput,
	            required: true
	          }),
	          _react2.default.createElement(_reduxForm.Field, {
	            name: 'surname',
	            type: 'text',
	            fieldClassName: 'width-perc-100',
	            placeholder: t('Last Name') + '*',
	            hideLabel: true,
	            component: _index.formSimpleTextInput,
	            required: true
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'text-right' },
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                type: 'submit',
	                className: 'btn-default wide pos-rel',
	                disabled: invalid,
	                loading: showLoader
	              },
	              t('Add')
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return AddContactForm;
	}(_react.PureComponent), _class2.propTypes = {
	  addContactForm: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  loading: _propTypes2.default.bool,
	  onSubmit: _propTypes2.default.func
	}, _class2.contextTypes = {
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  onSubmit: _noop3.default
	}, _temp)) || _class);
	exports.default = AddContactForm;
	module.exports = exports['default'];

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Modal = __webpack_require__(212);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _AddContactForm = __webpack_require__(1941);
	
	var _AddContactForm2 = _interopRequireDefault(_AddContactForm);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var RecipientAddModal = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(RecipientAddModal, _PureComponent);
	
	  function RecipientAddModal() {
	    (0, _classCallCheck3.default)(this, RecipientAddModal);
	    return (0, _possibleConstructorReturn3.default)(this, (RecipientAddModal.__proto__ || (0, _getPrototypeOf2.default)(RecipientAddModal)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(RecipientAddModal, [{
	    key: 'onHide',
	    value: function onHide() {
	      var onHide = this.props.onHide;
	
	      onHide(null);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          loading = _props.loading,
	          onSubmit = _props.onSubmit,
	          show = _props.show;
	      var t = this.context.t;
	
	
	      return _react2.default.createElement(
	        _Modal2.default,
	        {
	          backdrop: true,
	          closeByEsc: true,
	          title: t('Enter user name'),
	          onHide: this.onHide,
	          show: show,
	          autoFocus: true
	        },
	        _react2.default.createElement(_AddContactForm2.default, {
	          loading: loading,
	          onSubmit: onSubmit
	        })
	      );
	    }
	  }]);
	  return RecipientAddModal;
	}(_react.PureComponent), _class2.propTypes = {
	  loading: _propTypes2.default.bool,
	  onHide: _propTypes2.default.func,
	  onSubmit: _propTypes2.default.func,
	  show: _propTypes2.default.bool
	}, _class2.contextTypes = {
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  onHide: _noop3.default,
	  onSubmit: _noop3.default
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onHide', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onHide'), _class.prototype)), _class);
	exports.default = RecipientAddModal;
	module.exports = exports['default'];

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AlbumItem2 = __webpack_require__(810);
	
	var _AlbumItem3 = _interopRequireDefault(_AlbumItem2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _reactRouterRedux = __webpack_require__(40);
	
	var _audioplayer = __webpack_require__(83);
	
	var audioplayerActions = _interopRequireWildcard(_audioplayer);
	
	var _playlists = __webpack_require__(100);
	
	var playlistsActions = _interopRequireWildcard(_playlists);
	
	var _AlbumThumbDescrition = __webpack_require__(511);
	
	var _AlbumThumbDescrition2 = _interopRequireDefault(_AlbumThumbDescrition);
	
	var _Loader = __webpack_require__(60);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _AlbumPlayPauseButton = __webpack_require__(815);
	
	var _AlbumPlayPauseButton2 = _interopRequireDefault(_AlbumPlayPauseButton);
	
	var _AlbumMenuButton = __webpack_require__(814);
	
	var _AlbumMenuButton2 = _interopRequireDefault(_AlbumMenuButton);
	
	var _AlbumItemPressIcon = __webpack_require__(1946);
	
	var _AlbumItemPressIcon2 = _interopRequireDefault(_AlbumItemPressIcon);
	
	var _AlbumItemDownloadableIcon = __webpack_require__(1944);
	
	var _AlbumItemDownloadableIcon2 = _interopRequireDefault(_AlbumItemDownloadableIcon);
	
	var _AlbumItemInfo = __webpack_require__(811);
	
	var _AlbumItemInfo2 = _interopRequireDefault(_AlbumItemInfo);
	
	var _AlbumItemSystemInfo = __webpack_require__(812);
	
	var _AlbumItemSystemInfo2 = _interopRequireDefault(_AlbumItemSystemInfo);
	
	var _AlbumItemThumb = __webpack_require__(813);
	
	var _AlbumItemThumb2 = _interopRequireDefault(_AlbumItemThumb);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1238);
	
	var AlbumGridItem = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    playerAlbum: state.audioplayer.album,
	    playerStatus: state.audioplayer.playerStatus,
	    pressLoading: state.playlists.pressLoading
	  };
	}, (0, _extends3.default)({}, playlistsActions, { playAlbum: audioplayerActions.playAlbum, pushState: _reactRouterRedux.push })), _dec(_class = (_temp = _class2 = function (_AlbumItem) {
	  (0, _inherits3.default)(AlbumGridItem, _AlbumItem);
	
	  function AlbumGridItem() {
	    (0, _classCallCheck3.default)(this, AlbumGridItem);
	    return (0, _possibleConstructorReturn3.default)(this, (AlbumGridItem.__proto__ || (0, _getPrototypeOf2.default)(AlbumGridItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AlbumGridItem, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          loading = _props.loading,
	          album = _props.album,
	          coloredInfo = _props.coloredInfo,
	          tracks = _props.tracks;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'col-xs-30 col-sm-20 col-md-12 col-lg-10' },
	        _react2.default.createElement(
	          'div',
	          { className: styles.album, onClick: this.gotoAlbum },
	          _react2.default.createElement(_Loader2.default, { show: loading, mask: true }),
	          _react2.default.createElement(
	            'div',
	            { className: styles.cover },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _bind2.default)('ratio-cont', styles.coverContainer) },
	              _react2.default.createElement(_AlbumItemThumb2.default, { album: album, className: styles.coverImg }),
	              _react2.default.createElement(_AlbumThumbDescrition2.default, { album: album }),
	              _react2.default.createElement(_AlbumPlayPauseButton2.default, {
	                album: album,
	                tracks: tracks,
	                onClick: this.playPause
	              }),
	              _react2.default.createElement(_AlbumMenuButton2.default, {
	                album: album,
	                className: styles.menuButton,
	                iconClass: styles.moreDots,
	                onPlay: this.playPause,
	                onDownloadPress: this.downloadPress,
	                onDelete: this.deleteAlbum
	              })
	            ),
	            _react2.default.createElement(_AlbumItemDownloadableIcon2.default, {
	              className: styles.downloadableIcon,
	              album: album
	            })
	          ),
	          _react2.default.createElement(_AlbumItemPressIcon2.default, {
	            className: styles.pressIcon,
	            album: album
	          }),
	          _react2.default.createElement(_AlbumItemInfo2.default, {
	            className: styles.info,
	            album: album
	          }),
	          _react2.default.createElement(_AlbumItemSystemInfo2.default, {
	            className: (0, _bind2.default)(styles.info, styles.system),
	            album: album,
	            coloredInfo: coloredInfo
	          })
	        )
	      );
	    }
	  }]);
	  return AlbumGridItem;
	}(_AlbumItem3.default), _class2.propTypes = {
	  album: _propTypes2.default.object,
	  coloredInfo: _propTypes2.default.bool,
	  loading: _propTypes2.default.bool,
	  pushState: _propTypes2.default.func,
	  t: _propTypes2.default.func,
	  tracks: _propTypes2.default.object
	}, _class2.defaultProps = {
	  album: {},
	  tracks: {}
	}, _temp)) || _class);
	exports.default = AlbumGridItem;
	module.exports = exports['default'];

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlbumItemDownloadableIcon = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(AlbumItemDownloadableIcon, _PureComponent);
	
	  function AlbumItemDownloadableIcon() {
	    (0, _classCallCheck3.default)(this, AlbumItemDownloadableIcon);
	    return (0, _possibleConstructorReturn3.default)(this, (AlbumItemDownloadableIcon.__proto__ || (0, _getPrototypeOf2.default)(AlbumItemDownloadableIcon)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AlbumItemDownloadableIcon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          album = _props.album,
	          className = _props.className;
	
	
	      return _react2.default.createElement(
	        'span',
	        { className: (0, _bind2.default)({ hidden: !album.downloadable }, className) },
	        _react2.default.createElement('i', { className: 'icon-download' })
	      );
	    }
	  }]);
	  return AlbumItemDownloadableIcon;
	}(_react.PureComponent), _class.propTypes = {
	  album: _propTypes2.default.object,
	  className: _propTypes2.default.string
	}, _class.defaultProps = {
	  album: {}
	}, _temp);
	exports.default = AlbumItemDownloadableIcon;
	module.exports = exports['default'];

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PopoverMenuItem = __webpack_require__(353);
	
	var _PopoverMenuItem2 = _interopRequireDefault(_PopoverMenuItem);
	
	var _PopoverMenu = __webpack_require__(258);
	
	var _PopoverMenu2 = _interopRequireDefault(_PopoverMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlbumItemPopover = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(AlbumItemPopover, _PureComponent);
	
	  function AlbumItemPopover() {
	    (0, _classCallCheck3.default)(this, AlbumItemPopover);
	    return (0, _possibleConstructorReturn3.default)(this, (AlbumItemPopover.__proto__ || (0, _getPrototypeOf2.default)(AlbumItemPopover)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AlbumItemPopover, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          id = _props.id,
	          onInit = _props.onInit,
	          onDelete = _props.onDelete,
	          onPlay = _props.onPlay,
	          onDownloadPress = _props.onDownloadPress,
	          hidePlay = _props.hidePlay,
	          hidePress = _props.hidePress;
	      var t = this.context.t;
	
	
	      return _react2.default.createElement(
	        _PopoverMenu2.default,
	        { id: id, ref: onInit },
	        _react2.default.createElement(_PopoverMenuItem2.default, { onClick: onPlay, title: t('Play All'), iconClass: 'icon-play', hidden: hidePlay }),
	        _react2.default.createElement(_PopoverMenuItem2.default, { onClick: onDownloadPress, title: t('Press'), iconClass: 'icon-download', hidden: hidePress }),
	        _react2.default.createElement(_PopoverMenuItem2.default, { onClick: onDelete, title: t('Delete'), iconClass: 'icon-delete' })
	      );
	    }
	  }]);
	  return AlbumItemPopover;
	}(_react.PureComponent), _class.propTypes = {
	  hidePlay: _propTypes2.default.bool,
	  hidePress: _propTypes2.default.bool,
	  id: _propTypes2.default.string,
	  onDelete: _propTypes2.default.func,
	  onDownloadPress: _propTypes2.default.func,
	  onInit: _propTypes2.default.func,
	  onPlay: _propTypes2.default.func
	}, _class.contextTypes = {
	  t: _propTypes2.default.func
	}, _class.defaultProps = {
	  onDelete: _noop3.default,
	  onDownloadPress: _noop3.default,
	  onInit: _noop3.default,
	  onPlay: _noop3.default
	}, _temp);
	exports.default = AlbumItemPopover;
	module.exports = exports['default'];

/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlbumItemPressIcon = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(AlbumItemPressIcon, _PureComponent);
	
	  function AlbumItemPressIcon() {
	    (0, _classCallCheck3.default)(this, AlbumItemPressIcon);
	    return (0, _possibleConstructorReturn3.default)(this, (AlbumItemPressIcon.__proto__ || (0, _getPrototypeOf2.default)(AlbumItemPressIcon)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AlbumItemPressIcon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          album = _props.album,
	          className = _props.className;
	
	
	      return _react2.default.createElement(
	        'span',
	        { className: (0, _bind2.default)({ hidden: !album.isPress }, className) },
	        _react2.default.createElement('i', { className: 'icon-paperclip' })
	      );
	    }
	  }]);
	  return AlbumItemPressIcon;
	}(_react.PureComponent), _class.propTypes = {
	  album: _propTypes2.default.object,
	  className: _propTypes2.default.string
	}, _class.defaultProps = {
	  album: {}
	}, _temp);
	exports.default = AlbumItemPressIcon;
	module.exports = exports['default'];

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AlbumItem2 = __webpack_require__(810);
	
	var _AlbumItem3 = _interopRequireDefault(_AlbumItem2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _audioplayer = __webpack_require__(83);
	
	var audioplayerActions = _interopRequireWildcard(_audioplayer);
	
	var _playlists = __webpack_require__(100);
	
	var playlistsActions = _interopRequireWildcard(_playlists);
	
	var _reactRouterRedux = __webpack_require__(40);
	
	var _Loader = __webpack_require__(60);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _AlbumPlayPauseButton = __webpack_require__(815);
	
	var _AlbumPlayPauseButton2 = _interopRequireDefault(_AlbumPlayPauseButton);
	
	var _AlbumItemThumb = __webpack_require__(813);
	
	var _AlbumItemThumb2 = _interopRequireDefault(_AlbumItemThumb);
	
	var _AlbumMenuButton = __webpack_require__(814);
	
	var _AlbumMenuButton2 = _interopRequireDefault(_AlbumMenuButton);
	
	var _AlbumItemInfo = __webpack_require__(811);
	
	var _AlbumItemInfo2 = _interopRequireDefault(_AlbumItemInfo);
	
	var _AlbumItemSystemInfo = __webpack_require__(812);
	
	var _AlbumItemSystemInfo2 = _interopRequireDefault(_AlbumItemSystemInfo);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1241);
	
	var cn = _bind2.default.bind(styles);
	
	var AlbumListItem = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    playerAlbum: state.audioplayer.album,
	    playerStatus: state.audioplayer.playerStatus,
	    pressLoading: state.playlists.pressLoading
	  };
	}, (0, _extends3.default)({}, playlistsActions, { playAlbum: audioplayerActions.playAlbum, pushState: _reactRouterRedux.push })), _dec(_class = (_temp = _class2 = function (_AlbumItem) {
	  (0, _inherits3.default)(AlbumListItem, _AlbumItem);
	
	  function AlbumListItem() {
	    (0, _classCallCheck3.default)(this, AlbumListItem);
	    return (0, _possibleConstructorReturn3.default)(this, (AlbumListItem.__proto__ || (0, _getPrototypeOf2.default)(AlbumListItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AlbumListItem, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          loading = _props.loading,
	          album = _props.album,
	          coloredInfo = _props.coloredInfo,
	          tracks = _props.tracks;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'col-xs-60' },
	        _react2.default.createElement(
	          'div',
	          { className: styles.album, onClick: this.gotoAlbum },
	          _react2.default.createElement(_Loader2.default, { show: loading, mask: true }),
	          _react2.default.createElement(
	            'div',
	            { className: styles.albumContent },
	            _react2.default.createElement(
	              'div',
	              { className: styles.cover },
	              _react2.default.createElement(
	                'div',
	                { className: 'ratio-cont' },
	                _react2.default.createElement(_AlbumItemThumb2.default, { album: album, className: styles.coverImg }),
	                _react2.default.createElement(_AlbumPlayPauseButton2.default, {
	                  album: album,
	                  tracks: tracks,
	                  onClick: this.playPause
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: styles.infoContainer },
	              _react2.default.createElement(
	                'div',
	                { className: styles.info },
	                _react2.default.createElement(_AlbumItemInfo2.default, {
	                  album: album,
	                  artistClass: styles.artistName,
	                  overflow: true
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: cn('albumType', album.audiovideo) },
	                  album.audiovideo
	                )
	              ),
	              _react2.default.createElement(_AlbumItemSystemInfo2.default, {
	                className: styles.system,
	                album: album,
	                coloredInfo: coloredInfo,
	                overflow: true
	              })
	            )
	          ),
	          _react2.default.createElement(_AlbumMenuButton2.default, {
	            album: album,
	            className: styles.menuButton,
	            iconClass: 'more',
	            onPlay: this.playPause,
	            onDownloadPress: this.downloadPress,
	            onDelete: this.deleteAlbum
	          })
	        )
	      );
	    }
	  }]);
	  return AlbumListItem;
	}(_AlbumItem3.default), _class2.propTypes = {
	  album: _propTypes2.default.object,
	  coloredInfo: _propTypes2.default.bool,
	  loading: _propTypes2.default.bool,
	  pushState: _propTypes2.default.func,
	  t: _propTypes2.default.func,
	  tracks: _propTypes2.default.object
	}, _class2.defaultProps = {
	  album: {},
	  tracks: {}
	}, _temp)) || _class);
	exports.default = AlbumListItem;
	module.exports = exports['default'];

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PlaylistsItem = __webpack_require__(2183);
	
	var _PlaylistsItem2 = _interopRequireDefault(_PlaylistsItem);
	
	var _AlbumsItemsGroupWrapper = __webpack_require__(1949);
	
	var _AlbumsItemsGroupWrapper2 = _interopRequireDefault(_AlbumsItemsGroupWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlbumsItemsGroup = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(AlbumsItemsGroup, _PureComponent);
	
	  function AlbumsItemsGroup() {
	    (0, _classCallCheck3.default)(this, AlbumsItemsGroup);
	    return (0, _possibleConstructorReturn3.default)(this, (AlbumsItemsGroup.__proto__ || (0, _getPrototypeOf2.default)(AlbumsItemsGroup)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AlbumsItemsGroup, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          albumsGroup = _props.albumsGroup,
	          showTitles = _props.showTitles,
	          tracks = _props.tracks;
	
	
	      return _react2.default.createElement(
	        _AlbumsItemsGroupWrapper2.default,
	        { showTitles: showTitles, title: albumsGroup.title },
	        albumsGroup.data.map(function (album) {
	          return _react2.default.createElement(_PlaylistsItem2.default, {
	            key: album.project_id + '_' + album.recipient_id,
	            album: album,
	            tracks: tracks,
	            coloredInfo: !showTitles
	          });
	        })
	      );
	    }
	  }]);
	  return AlbumsItemsGroup;
	}(_react.PureComponent), _class.propTypes = {
	  albumsGroup: _propTypes2.default.object,
	  showTitles: _propTypes2.default.bool,
	  tracks: _propTypes2.default.object
	}, _class.defaultProps = {
	  albumsGroup: { data: [] },
	  tracks: {}
	}, _temp);
	exports.default = AlbumsItemsGroup;
	module.exports = exports['default'];

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1244);
	
	var AlbumsItemsGroupWrapper = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(AlbumsItemsGroupWrapper, _PureComponent);
	
	  function AlbumsItemsGroupWrapper() {
	    (0, _classCallCheck3.default)(this, AlbumsItemsGroupWrapper);
	    return (0, _possibleConstructorReturn3.default)(this, (AlbumsItemsGroupWrapper.__proto__ || (0, _getPrototypeOf2.default)(AlbumsItemsGroupWrapper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AlbumsItemsGroupWrapper, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          showTitles = _props.showTitles,
	          title = _props.title,
	          children = _props.children;
	
	
	      if (showTitles) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _bind2.default)('col-xs-60', styles.title) },
	            title
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            children
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        children
	      );
	    }
	  }]);
	  return AlbumsItemsGroupWrapper;
	}(_react.PureComponent), _class.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.arrayOf(_propTypes2.default.node)]),
	  showTitles: _propTypes2.default.bool,
	  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	}, _temp);
	exports.default = AlbumsItemsGroupWrapper;
	module.exports = exports['default'];

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _AlbumsItemsGroup = __webpack_require__(1948);
	
	var _AlbumsItemsGroup2 = _interopRequireDefault(_AlbumsItemsGroup);
	
	var _components = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlbumsItemsGroups = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(AlbumsItemsGroups, _PureComponent);
	
	  function AlbumsItemsGroups() {
	    (0, _classCallCheck3.default)(this, AlbumsItemsGroups);
	    return (0, _possibleConstructorReturn3.default)(this, (AlbumsItemsGroups.__proto__ || (0, _getPrototypeOf2.default)(AlbumsItemsGroups)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AlbumsItemsGroups, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          albums = _props.albums,
	          tracks = _props.tracks,
	          loading = _props.loading,
	          showTitles = _props.showTitles;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)({ 'margin-top-30 row': !showTitles }) },
	        albums.map(function (albumsGroup) {
	          return _react2.default.createElement(_AlbumsItemsGroup2.default, {
	            key: albumsGroup.id,
	            albumsGroup: albumsGroup,
	            tracks: tracks,
	            showTitles: showTitles
	          });
	        }),
	        _react2.default.createElement(_components.Loader, { show: loading, alignCenter: true })
	      );
	    }
	  }]);
	  return AlbumsItemsGroups;
	}(_react.PureComponent), _class.propTypes = {
	  albums: _propTypes2.default.array,
	  loading: _propTypes2.default.bool,
	  showTitles: _propTypes2.default.bool,
	  tracks: _propTypes2.default.object
	}, _class.defaultProps = {
	  albums: [],
	  tracks: {}
	}, _temp);
	exports.default = AlbumsItemsGroups;
	module.exports = exports['default'];

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get3 = __webpack_require__(19);
	
	var _get4 = _interopRequireDefault(_get3);
	
	var _throttle3 = __webpack_require__(455);
	
	var _throttle4 = _interopRequireDefault(_throttle3);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _audioplayer = __webpack_require__(83);
	
	var audioPlayerActions = _interopRequireWildcard(_audioplayer);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	var _reactRouterRedux = __webpack_require__(40);
	
	var _reactDraggable = __webpack_require__(744);
	
	var _reactDraggable2 = _interopRequireDefault(_reactDraggable);
	
	var _AudioPlayer = __webpack_require__(135);
	
	var _AudioPlayer2 = _interopRequireDefault(_AudioPlayer);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _auth = __webpack_require__(77);
	
	var _Albums = __webpack_require__(525);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1245);
	
	var cn = _bind2.default.bind(styles);
	
	var AudioPlayer = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    album: state.audioplayer.album,
	    currentTrackIndex: state.audioplayer.currentTrackIndex,
	    expanded: state.audioplayer.expanded,
	    humanizedPosition: state.audioplayer.humanizedPosition,
	    isAlbumDenied: state.audioplayer.isAlbumDenied,
	    isAlbumEnded: state.audioplayer.isAlbumEnded,
	    lastAlbum: state.audioplayer.lastAlbum,
	    lastTracks: state.audioplayer.lastTracks,
	    playerStatus: state.audioplayer.playerStatus,
	    playlistKey: (0, _get4.default)(state, 'playlist.playlistActionData.key'),
	    position: state.audioplayer.position,
	    tracks: state.audioplayer.tracks,
	    user: (0, _auth.getUser)(state),
	    volume: state.audioplayer.volume
	  };
	}, (0, _extends3.default)({}, audioPlayerActions, { pushState: _reactRouterRedux.push })), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(AudioPlayer, _Component);
	
	  function AudioPlayer() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, AudioPlayer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = AudioPlayer.__proto__ || (0, _getPrototypeOf2.default)(AudioPlayer)).call.apply(_ref, [this].concat(args)));
	
	    _this.onVolumeDrag = (0, _throttle4.default)(function (e, position, progress) {
	      _this.props.setVolume(progress);
	    }, 200);
	
	    _this.isPreventUppdatePosition = false;
	    _this.isPreventUppdateVolume = false;
	    _this.seekStartPosition = 0;
	    return _this;
	  }
	
	  (0, _createClass3.default)(AudioPlayer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.setVolume(_AudioPlayer2.default.volume());
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          isAlbumDenied = _props.isAlbumDenied,
	          isAlbumEnded = _props.isAlbumEnded;
	
	      if (nextProps.isAlbumEnded && !isAlbumEnded && this.endModal) {
	        this.endModal.open();
	      }
	      if (nextProps.isAlbumDenied && !isAlbumDenied && this.deniedModal) {
	        this.deniedModal.open();
	      }
	    }
	  }, {
	    key: 'onVolumeInit',
	    value: function onVolumeInit() /*position, progress*/{
	      // this.props.setVolume(progress);
	    }
	  }, {
	    key: 'onVolumeDragStart',
	    value: function onVolumeDragStart(e, position, progress) {
	      this.isPreventUppdateVolume = true;
	      this.props.setVolume(progress);
	    }
	  }, {
	    key: 'onVolumeDragStop',
	    value: function onVolumeDragStop(e, position, progress) {
	      this.isPreventUppdateVolume = false;
	      this.props.setVolume(progress);
	    }
	  }, {
	    key: 'onSeekDragStart',
	    value: function onSeekDragStart(e, position, progress) {
	      this.isPreventUppdatePosition = true;
	      this.seekStartPosition = progress;
	      this.seek(progress, true);
	    }
	  }, {
	    key: 'onSeekDragStop',
	    value: function onSeekDragStop(e, position, progress) {
	      this.isPreventUppdatePosition = false;
	      if (this.seekStartPosition !== progress) {
	        this.seek(progress, false);
	      }
	    }
	  }, {
	    key: 'getCurrentDuration',
	    value: function getCurrentDuration() {
	      var _props2 = this.props,
	          tracks = _props2.tracks,
	          currentTrackIndex = _props2.currentTrackIndex;
	
	      var duration = Number((0, _get4.default)(tracks, [currentTrackIndex, 'duration'], 0));
	      var audio = _AudioPlayer2.default.audio;
	      if (!duration && audio) {
	        duration = audio.duration;
	      }
	      return duration;
	    }
	  }, {
	    key: 'volumeDown',
	    value: function volumeDown() {
	      this.props.setVolume(0, true);
	    }
	  }, {
	    key: 'volumeUp',
	    value: function volumeUp() {
	      this.props.setVolume(1, true);
	    }
	  }, {
	    key: 'seek',
	    value: function seek(progress) {
	      var duration = this.getCurrentDuration();
	      var sec = duration * progress;
	      this.props.seek(sec);
	    }
	  }, {
	    key: 'goPlaylist',
	    value: function goPlaylist() {
	      var _props3 = this.props,
	          pushState = _props3.pushState,
	          contentKey = _props3.album.contentKey;
	
	      if (contentKey) {
	        pushState('/playlists/fromkey/' + contentKey);
	      }
	    }
	  }, {
	    key: 'replay',
	    value: function replay() {
	      var _props4 = this.props,
	          playAlbum = _props4.playAlbum,
	          album = _props4.lastAlbum,
	          tracks = _props4.lastTracks;
	
	      this.endModal.close();
	      playAlbum({ album: album, tracks: tracks });
	    }
	  }, {
	    key: 'isTrackLoaded',
	    value: function isTrackLoaded() {
	      var _props5 = this.props,
	          tracks = _props5.tracks,
	          currentTrackIndex = _props5.currentTrackIndex;
	
	      return !!tracks[currentTrackIndex];
	    }
	  }, {
	    key: 'playPrev',
	    value: function playPrev() {
	      if (this.isTrackLoaded()) {
	        this.props.playPrev();
	      }
	    }
	  }, {
	    key: 'playNext',
	    value: function playNext() {
	      if (this.isTrackLoaded()) {
	        this.props.playNext();
	      }
	    }
	  }, {
	    key: 'playPause',
	    value: function playPause() {
	      if (this.isTrackLoaded()) {
	        this.props.playPause();
	      }
	    }
	  }, {
	    key: 'renderFull',
	    value: function renderFull() {
	      var _props6 = this.props,
	          playerStatus = _props6.playerStatus,
	          tracks = _props6.tracks,
	          currentTrackIndex = _props6.currentTrackIndex,
	          album = _props6.album,
	          volume = _props6.volume,
	          humanizedPosition = _props6.humanizedPosition,
	          position = _props6.position,
	          expanded = _props6.expanded,
	          className = _props6.className,
	          toggleExpand = _props6.toggleExpand;
	
	      var positionProgress = position / this.getCurrentDuration();
	      var playerTrack = tracks[currentTrackIndex];
	      var playBtnClass = (0, _bind2.default)(styles.control, styles.playBtn, 'dragStop', playerStatus === _AudioPlayer2.default.status.play ? 'icon-pause' : 'icon-play');
	      var trackLoaded = this.isTrackLoaded();
	
	      return _react2.default.createElement(
	        _reactDraggable2.default,
	        { cancel: '.dragStop', bounds: 'html', onStart: function onStart(e) {
	            return e.preventDefault();
	          } },
	        !expanded || !trackLoaded ? _react2.default.createElement('div', null) : _react2.default.createElement(
	          'div',
	          { className: cn('audioPlayer', 'full', className) },
	          _react2.default.createElement('i', { type: 'button', className: (0, _bind2.default)('icon-close', styles.closer, 'dragStop'), onClick: toggleExpand }),
	          _react2.default.createElement(
	            'div',
	            { className: styles.coverContainer },
	            _react2.default.createElement(_components.Thumb, { className: styles.cover, fileName: album.imageThumb, defaultImageName: (0, _Albums.getDefaultImageName)(album) })
	          ),
	          trackLoaded && _react2.default.createElement(
	            'div',
	            { onClick: this.goPlaylist, className: (0, _bind2.default)(styles.title, 'dragStop') },
	            _react2.default.createElement(
	              'div',
	              { className: styles.trackName },
	              playerTrack.trackName
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: styles.artistName },
	              album.artist_name
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: styles.controls },
	            _react2.default.createElement('i', { className: (0, _bind2.default)('icon-previous pull-left dragStop', styles.control), onClick: this.playPrev }),
	            _react2.default.createElement('i', { className: (0, _bind2.default)('icon-next pull-right dragStop', styles.control), onClick: this.playNext }),
	            _react2.default.createElement('i', { className: playBtnClass, onClick: this.playPause })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: styles.seek },
	            _react2.default.createElement(
	              'div',
	              { className: cn(styles.duration) },
	              humanizedPosition
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _bind2.default)(styles.seekBar, 'dragStop') },
	              _react2.default.createElement(_components.DragBar, {
	                value: positionProgress,
	                forceUpdate: !this.isPreventUppdatePosition,
	                onStart: this.onSeekDragStart,
	                onStop: this.onSeekDragStop,
	                progressBarClass: styles.seekProgressBar,
	                hideProgress: true
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: cn(styles.duration) },
	              playerTrack.durationTime
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: styles.volume },
	            _react2.default.createElement('i', { className: (0, _bind2.default)('icon-sound', styles.volumeDown) }),
	            _react2.default.createElement(
	              'div',
	              { className: cn(styles.volumeBar, 'dragStop') },
	              _react2.default.createElement(_components.DragBar, {
	                value: volume,
	                forceUpdate: !this.isPreventUppdateVolume,
	                onInit: this.onVolumeInit,
	                onStart: this.onVolumeDragStart,
	                onStop: this.onVolumeDragStop,
	                onDrag: this.onVolumeDrag,
	                progressBarClass: styles.volumeProgressBar,
	                hideProgress: true
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderLine',
	    value: function renderLine() {
	      var _props7 = this.props,
	          playerStatus = _props7.playerStatus,
	          tracks = _props7.tracks,
	          currentTrackIndex = _props7.currentTrackIndex,
	          album = _props7.album,
	          toggleExpand = _props7.toggleExpand,
	          expanded = _props7.expanded,
	          position = _props7.position,
	          t = _props7.t,
	          volume = _props7.volume,
	          humanizedPosition = _props7.humanizedPosition,
	          className = _props7.className;
	
	      var playerTrack = tracks[currentTrackIndex];
	      var trackLoaded = this.isTrackLoaded();
	      var playBtnClass = (0, _bind2.default)(styles.control, styles.playBtn, playerStatus === _AudioPlayer2.default.status.play ? 'icon-pause' : 'icon-play', (0, _defineProperty3.default)({}, styles.inactive, !trackLoaded));
	      var expandIconClass = expanded ? 'icon-collapse' : 'icon-zoom';
	      var positionProgress = position / this.getCurrentDuration();
	
	      return _react2.default.createElement(
	        'div',
	        { className: cn('audioPlayer', 'line', className, { inactive: !trackLoaded }) },
	        _react2.default.createElement(
	          'div',
	          { className: cn('controls', 'cell') },
	          _react2.default.createElement('i', { className: (0, _bind2.default)('icon-previous pull-left', styles.control, (0, _defineProperty3.default)({}, styles.inactive, !trackLoaded)), onClick: this.playPrev }),
	          _react2.default.createElement('i', { className: playBtnClass, onClick: this.playPause }),
	          _react2.default.createElement('i', { className: (0, _bind2.default)('icon-next pull-right', styles.control, (0, _defineProperty3.default)({}, styles.inactive, !trackLoaded)), onClick: this.playNext })
	        ),
	        trackLoaded && _react2.default.createElement(
	          'div',
	          { className: styles.content },
	          _react2.default.createElement(_components.Thumb, {
	            className: cn('cover', 'cell'),
	            fileName: album.imageThumb,
	            onClick: this.goPlaylist,
	            defaultImageName: (0, _Albums.getDefaultImageName)(album)
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: styles.title },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: cn(styles.trackName, 'text-overflow'), title: playerTrack.trackName },
	                playerTrack.trackName
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: cn(styles.artistName, 'text-overflow'), title: album.artist_name },
	                album.artist_name
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: styles.times },
	                humanizedPosition,
	                ' / ',
	                playerTrack.durationTime
	              )
	            ),
	            _react2.default.createElement(_components.DragBar, {
	              className: styles.seekBar,
	              value: positionProgress,
	              forceUpdate: !this.isPreventUppdatePosition,
	              onStart: this.onSeekDragStart,
	              onStop: this.onSeekDragStop,
	              progressBarClass: styles.seekProgressBar,
	              hideProgress: true
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: styles.volumeContainer },
	            _react2.default.createElement('i', { className: (0, _bind2.default)('icon-sound', styles.volumeIcon) }),
	            _react2.default.createElement(_components.DragBar, {
	              className: styles.volumeBar,
	              value: volume,
	              forceUpdate: !this.isPreventUppdateVolume,
	              onInit: this.onVolumeInit,
	              onStart: this.onVolumeDragStart,
	              onStop: this.onVolumeDragStop,
	              onDrag: this.onVolumeDrag,
	              progressBarClass: styles.volumeProgressBar,
	              hideProgress: true
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: styles.expander, onClick: toggleExpand, title: t('Click to pop out') },
	            _react2.default.createElement('i', { className: expandIconClass })
	          )
	        ),
	        this.renderEndModal(),
	        this.renderDeniedModal()
	      );
	    }
	  }, {
	    key: 'renderEndModal',
	    value: function renderEndModal() {
	      var _this2 = this;
	
	      var t = this.props.t;
	
	      var modalProps = {
	        backdrop: 'static',
	        closeByEsc: false,
	        title: t('Session complete'),
	        bsSize: 'lg',
	        className: styles.endModal
	      };
	
	      return _react2.default.createElement(
	        _components.Modal,
	        (0, _extends3.default)({ ref: function ref(el) {
	            return _this2.endModal = el;
	          } }, modalProps),
	        _react2.default.createElement(
	          'h3',
	          { className: styles.title },
	          t('Play again?')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'text-center margin-top-20' },
	          _react2.default.createElement(
	            'button',
	            { type: 'button', className: 'btn btn-humble margin-top-10', onClick: function onClick() {
	                return _this2.endModal.close();
	              } },
	            t('No')
	          ),
	          _react2.default.createElement(
	            'button',
	            { type: 'button', className: 'btn btn-primary margin-left-20 margin-top-10', onClick: this.replay },
	            t('Yes')
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderDeniedModal',
	    value: function renderDeniedModal() {
	      var _this3 = this;
	
	      var _props8 = this.props,
	          t = _props8.t,
	          flushAlbumDeniedFlag = _props8.flushAlbumDeniedFlag;
	
	      var modalProps = {
	        backdrop: true,
	        closeByEsc: true,
	        title: t('Warning'),
	        bsSize: 'lg',
	        className: styles.endModal,
	        onHide: flushAlbumDeniedFlag
	      };
	
	      return _react2.default.createElement(
	        _components.Modal,
	        (0, _extends3.default)({ ref: function ref(el) {
	            return _this3.deniedModal = el;
	          } }, modalProps),
	        _react2.default.createElement(
	          'h3',
	          { className: styles.title },
	          t('You have exceeded the maximum number of allocated plays')
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var view = this.props.view;
	
	
	      switch (view) {
	        case 'line':
	          return this.renderLine();
	        case 'full':
	        default:
	          return this.renderFull();
	      }
	    }
	  }]);
	  return AudioPlayer;
	}(_react.Component), _class3.propTypes = {
	  album: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  currentTrackIndex: _propTypes2.default.number,
	  expanded: _propTypes2.default.bool,
	  flushAlbumDeniedFlag: _propTypes2.default.func,
	  humanizedPosition: _propTypes2.default.string,
	  isAlbumDenied: _propTypes2.default.bool,
	  isAlbumEnded: _propTypes2.default.bool,
	  lastAlbum: _propTypes2.default.object,
	  lastTracks: _propTypes2.default.array,
	  playAlbum: _propTypes2.default.func,
	  playerStatus: _propTypes2.default.string,
	  playlistKey: _propTypes2.default.string,
	  playNext: _propTypes2.default.func,
	  playPause: _propTypes2.default.func,
	  playPrev: _propTypes2.default.func,
	  position: _propTypes2.default.number,
	  pushState: _propTypes2.default.func,
	  seek: _propTypes2.default.func,
	  setVolume: _propTypes2.default.func,
	  t: _propTypes2.default.func,
	  toggleExpand: _propTypes2.default.func,
	  tracks: _propTypes2.default.array,
	  user: _propTypes2.default.object,
	  view: _propTypes2.default.string,
	  volume: _propTypes2.default.number
	}, _class3.defaultProps = {
	  view: 'full'
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onVolumeInit', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onVolumeInit'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onVolumeDragStart', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onVolumeDragStart'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onVolumeDragStop', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onVolumeDragStop'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onSeekDragStart', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSeekDragStart'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onSeekDragStop', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSeekDragStop'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'volumeDown', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'volumeDown'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'volumeUp', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'volumeUp'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'goPlaylist', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'goPlaylist'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'replay', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'replay'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'playPrev', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'playPrev'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'playNext', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'playNext'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'playPause', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'playPause'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = AudioPlayer;
	module.exports = exports['default'];

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactI18next = __webpack_require__(12);
	
	var _auth = __webpack_require__(31);
	
	var authActions = _interopRequireWildcard(_auth);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuthEmailString = (_dec = (0, _reactRedux.connect)(null, (0, _extends3.default)({}, authActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(AuthEmailString, _Component);
	
	  function AuthEmailString() {
	    (0, _classCallCheck3.default)(this, AuthEmailString);
	    return (0, _possibleConstructorReturn3.default)(this, (AuthEmailString.__proto__ || (0, _getPrototypeOf2.default)(AuthEmailString)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AuthEmailString, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          t = _props.t,
	          removeLoginData = _props.removeLoginData,
	          className = _props.className,
	          email = _props.email;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        _react2.default.createElement(
	          'span',
	          null,
	          email
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'a margin-left-5', onClick: removeLoginData },
	          t('change user')
	        )
	      );
	    }
	  }]);
	  return AuthEmailString;
	}(_react.Component), _class2.propTypes = {
	  className: _propTypes2.default.string,
	  email: _propTypes2.default.string,
	  removeLoginData: _propTypes2.default.func,
	  t: _propTypes2.default.func
	}, _temp)) || _class) || _class);
	exports.default = AuthEmailString;
	module.exports = exports['default'];

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	var _auth = __webpack_require__(31);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _Link = __webpack_require__(82);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _TermsHint = __webpack_require__(512);
	
	var _TermsHint2 = _interopRequireDefault(_TermsHint);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var TermsAcceptance = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    termsAccepted: state.auth.termsAccepted
	  };
	}, { acceptTerms: _auth.acceptTerms }), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(TermsAcceptance, _Component);
	
	  function TermsAcceptance() {
	    (0, _classCallCheck3.default)(this, TermsAcceptance);
	    return (0, _possibleConstructorReturn3.default)(this, (TermsAcceptance.__proto__ || (0, _getPrototypeOf2.default)(TermsAcceptance)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TermsAcceptance, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.acceptTerms(false);
	    }
	  }, {
	    key: 'getTermsText',
	    value: function getTermsText() {
	      var t = this.props.t;
	
	
	      return _react2.default.createElement(_reactI18next.Interpolate, {
	        i18nKey: 'I agree to the {{privacyPolicy}}, {{termsOfService}} and {{cookiePolicy}} of this website.',
	        privacyPolicy: _react2.default.createElement(
	          _Link2.default,
	          { target: '_blank', to: '/info/privacy-policy' },
	          t('Privacy Policy')
	        ),
	        termsOfService: _react2.default.createElement(
	          _Link2.default,
	          { target: '_blank', to: '/info/terms-of-service' },
	          t('Terms of Service')
	        ),
	        cookiePolicy: _react2.default.createElement(
	          _Link2.default,
	          { target: '_blank', to: '/info/cookie-policy' },
	          t('Cookie Policy')
	        )
	      });
	    }
	  }, {
	    key: 'toggleTerms',
	    value: function toggleTerms(e) {
	      this.props.acceptTerms(e.target.checked);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          termsAccepted = _props.termsAccepted,
	          hintClassName = _props.hintClassName;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: className },
	          _react2.default.createElement(
	            'div',
	            { className: 'margin-bottom-10' },
	            _react2.default.createElement(_components.Checkbox, {
	              small: true,
	              checked: termsAccepted,
	              onChange: this.toggleTerms,
	              textAfter: this.getTermsText()
	            })
	          )
	        ),
	        _react2.default.createElement(_TermsHint2.default, { className: hintClassName })
	      );
	    }
	  }]);
	  return TermsAcceptance;
	}(_react.Component), _class3.propTypes = {
	  acceptTerms: _propTypes2.default.func,
	  className: _propTypes2.default.string,
	  hintClassName: _propTypes2.default.string,
	  t: _propTypes2.default.func,
	  termsAccepted: _propTypes2.default.bool
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'toggleTerms', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'toggleTerms'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = TermsAcceptance;
	module.exports = exports['default'];

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _reactRouter = __webpack_require__(124);
	
	var _TermsHint = __webpack_require__(512);
	
	var _TermsHint2 = _interopRequireDefault(_TermsHint);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1246);
	
	var TermsAgreeLink = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(TermsAgreeLink, _Component);
	
	  function TermsAgreeLink() {
	    (0, _classCallCheck3.default)(this, TermsAgreeLink);
	    return (0, _possibleConstructorReturn3.default)(this, (TermsAgreeLink.__proto__ || (0, _getPrototypeOf2.default)(TermsAgreeLink)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TermsAgreeLink, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          t = _props.t,
	          className = _props.className;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        _react2.default.createElement(
	          'div',
	          { className: styles.links },
	          _react2.default.createElement(
	            'div',
	            { className: styles.link },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { target: '_blank', to: '/info/terms-of-service' },
	              t('Terms of Service')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: styles.link },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { target: '_blank', to: '/info/privacy-policy' },
	              t('Privacy Policy')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: styles.link },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { target: '_blank', to: '/info/cookie-policy' },
	              t('Cookie Policy')
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'text-center margin-top-10 colorDark' },
	          _react2.default.createElement(_TermsHint2.default, null)
	        )
	      );
	    }
	  }]);
	  return TermsAgreeLink;
	}(_react.Component), _class2.propTypes = {
	  className: _propTypes2.default.string,
	  t: _propTypes2.default.func
	}, _temp)) || _class);
	exports.default = TermsAgreeLink;
	module.exports = exports['default'];

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClientSideComponent = __webpack_require__(30);
	
	var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reduxForm = __webpack_require__(50);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	var _auth = __webpack_require__(31);
	
	var authActions = _interopRequireWildcard(_auth);
	
	var _authFormValidation = __webpack_require__(816);
	
	var _authFormValidation2 = _interopRequireDefault(_authFormValidation);
	
	var _formComponents = __webpack_require__(71);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _auth2 = __webpack_require__(356);
	
	var _responseCodes = __webpack_require__(99);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(622);
	
	var LoginForm = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    loginData: state.auth.loginData
	  };
	}, (0, _extends3.default)({}, authActions), null, { withRef: true }), _dec2 = (0, _reduxForm.reduxForm)({
	  form: 'LoginForm',
	  propNamespace: 'loginForm',
	  validate: _authFormValidation2.default
	}), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(LoginForm, _Component);
	
	  function LoginForm() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, LoginForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = LoginForm.__proto__ || (0, _getPrototypeOf2.default)(LoginForm)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = {};
	    return _this;
	  }
	
	  (0, _createClass3.default)(LoginForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var setLoginFormState = this.props.setLoginFormState;
	
	      setLoginFormState(_auth2.loginFormStates.login);
	    }
	  }, {
	    key: 'submit',
	    value: function submit(formData) {
	      var _this2 = this;
	
	      var _props = this.props,
	          login = _props.login,
	          loginData = _props.loginData;
	      var password = formData.password;
	
	      var email = loginData.email || loginData.userEmail || formData.email;
	      // catch requires for properly update form state
	      return login(email, password).promise.then(function (resp) {
	        if (resp.code === _responseCodes.loginCodes.reset) {
	          _this2.toggleForm(_auth2.loginFormStates.reset);
	        }
	        if (resp.code === _responseCodes.loginCodes.unlock) {
	          _this2.toggleForm(_auth2.loginFormStates.unlock);
	        }
	      }).catch(function (err) {
	        return err;
	      });
	    }
	  }, {
	    key: 'toggleForm',
	    value: function toggleForm(formState) {
	      this.props.setLoginFormState(formState);
	      this.setState({ formState: formState });
	    }
	  }, {
	    key: 'showLoginForm',
	    value: function showLoginForm() {
	      this.toggleForm(_auth2.loginFormStates.login);
	    }
	  }, {
	    key: 'showForgotForm',
	    value: function showForgotForm() {
	      this.toggleForm(_auth2.loginFormStates.forgot);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          _props2$loginForm = _props2.loginForm,
	          submitting = _props2$loginForm.submitting,
	          handleSubmit = _props2$loginForm.handleSubmit,
	          invalid = _props2$loginForm.invalid,
	          t = _props2.t,
	          className = _props2.className,
	          loginData = _props2.loginData,
	          showTerms = _props2.showTerms;
	      var _state = this.state,
	          isMounted = _state.isMounted,
	          formState = _state.formState;
	
	      var email = loginData.email || loginData.userEmail;
	      var isShowForgotForm = [_auth2.loginFormStates.forgot, _auth2.loginFormStates.reset, _auth2.loginFormStates.unlock].includes(formState);
	
	      if (isShowForgotForm) {
	        return _react2.default.createElement(_components.ForgotPasswordForm, {
	          className: className,
	          termsHintClassName: styles.forgotTerms,
	          showCancel: true,
	          onCancel: this.showLoginForm
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'form',
	          { className: 'form-horizontal ' + className, onSubmit: handleSubmit(this.submit) },
	          email ? _react2.default.createElement(_components.AuthEmailString, { email: email }) : _react2.default.createElement(_reduxForm.Field, { name: 'email', type: 'email', component: _formComponents.formSimpleTextInput, hideLabel: true, placeholder: t('Email'), autoFocus: true }),
	          _react2.default.createElement(_reduxForm.Field, { name: 'password', type: 'password', component: _formComponents.formSimpleTextInput, hideLabel: true, placeholder: t('Password') }),
	          _react2.default.createElement(
	            'div',
	            { className: styles.buttons },
	            _react2.default.createElement(
	              'button',
	              { type: 'submit', className: 'btn btn-primary pull-right margin-vert-10 pos-rel', disabled: isMounted && (submitting || invalid) },
	              t('Sign in'),
	              submitting && _react2.default.createElement(_components.Loader, { mask: true })
	            ),
	            _react2.default.createElement(
	              'button',
	              { type: 'button', className: 'btn btn-link lower margin-vert-10', onClick: this.showForgotForm },
	              t('Forgot your password'),
	              '?'
	            )
	          )
	        ),
	        showTerms && _react2.default.createElement(_components.TermsAgreeLink, { className: styles.loginTerms, buttonName: t('Sign in') })
	      );
	    }
	  }]);
	  return LoginForm;
	}(_ClientSideComponent2.default), _class3.propTypes = {
	  className: _propTypes2.default.string,
	  login: _propTypes2.default.func,
	  loginData: _propTypes2.default.object,
	  loginForm: _propTypes2.default.object,
	  setLoginFormState: _propTypes2.default.func,
	  showTerms: _propTypes2.default.bool,
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'submit', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'submit'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'toggleForm', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'toggleForm'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'showLoginForm', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'showLoginForm'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'showForgotForm', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'showForgotForm'), _class2.prototype)), _class2)) || _class) || _class) || _class);
	exports.default = LoginForm;
	module.exports = exports['default'];

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClientSideComponent = __webpack_require__(30);
	
	var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reduxForm = __webpack_require__(50);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	var _auth = __webpack_require__(31);
	
	var authActions = _interopRequireWildcard(_auth);
	
	var _authFormValidation = __webpack_require__(816);
	
	var _authFormValidation2 = _interopRequireDefault(_authFormValidation);
	
	var _formComponents = __webpack_require__(71);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var RegistrationForm = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    loginData: state.auth.loginData,
	    user: state.auth.user
	  };
	}, (0, _extends3.default)({}, authActions)), _dec2 = (0, _reduxForm.reduxForm)({
	  form: 'RegistrationForm',
	  propNamespace: 'registrationForm',
	  validate: _authFormValidation2.default
	}), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(RegistrationForm, _Component);
	
	  function RegistrationForm() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, RegistrationForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = RegistrationForm.__proto__ || (0, _getPrototypeOf2.default)(RegistrationForm)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { showForgotForm: false };
	    return _this;
	  }
	
	  (0, _createClass3.default)(RegistrationForm, [{
	    key: 'submit',
	    value: function submit(formData) {
	      var _props = this.props,
	          register = _props.register,
	          loginData = _props.loginData;
	      var password = formData.password;
	
	      var email = loginData.email || formData.email;
	      // catch requires for properly update form state
	      return register(email, password).promise.catch(function (err) {
	        return err;
	      });
	    }
	  }, {
	    key: 'toggleForm',
	    value: function toggleForm() {
	      this.setState({ showForgotForm: !this.state.showForgotForm });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          _props2$registrationF = _props2.registrationForm,
	          submitting = _props2$registrationF.submitting,
	          handleSubmit = _props2$registrationF.handleSubmit,
	          invalid = _props2$registrationF.invalid,
	          t = _props2.t,
	          className = _props2.className,
	          loginData = _props2.loginData,
	          showTerms = _props2.showTerms;
	      var isMounted = this.state.isMounted;
	
	      var styles = __webpack_require__(622);
	
	      return this.state.showForgotForm ? _react2.default.createElement(
	        'div',
	        { className: className },
	        _react2.default.createElement(_components.ForgotPasswordForm, null),
	        _react2.default.createElement(
	          'button',
	          { type: 'button', className: 'btn btn-default margin-top-10', onClick: this.toggleForm },
	          t('Login')
	        )
	      ) : _react2.default.createElement(
	        'form',
	        { className: 'form-horizontal ' + className, onSubmit: handleSubmit(this.submit) },
	        _react2.default.createElement(
	          'div',
	          null,
	          loginData.email ? _react2.default.createElement(_components.AuthEmailString, { email: loginData.email }) : _react2.default.createElement(_reduxForm.Field, { name: 'email', type: 'email', component: _formComponents.formSimpleTextInput, hideLabel: true, placeholder: t('Email') }),
	          _react2.default.createElement(_reduxForm.Field, { name: 'password', type: 'password', component: _formComponents.formSimpleTextInput, hideLabel: true, placeholder: t('Password') }),
	          _react2.default.createElement(_reduxForm.Field, { name: 'repassword', type: 'password', component: _formComponents.formSimpleTextInput, hideLabel: true, placeholder: t('Confirm password') }),
	          _react2.default.createElement(
	            'div',
	            { className: styles.buttons },
	            _react2.default.createElement(
	              'button',
	              { type: 'submit', className: 'btn btn-primary pull-right margin-vert-10 pos-rel', disabled: isMounted && (submitting || invalid) },
	              t('Send'),
	              submitting && _react2.default.createElement(_components.Loader, { mask: true })
	            ),
	            _react2.default.createElement(
	              'button',
	              { type: 'button', className: 'btn btn-default margin-vert-10', onClick: this.toggleForm },
	              t('Forgot your password'),
	              '?'
	            )
	          ),
	          showTerms && _react2.default.createElement(_components.TermsAgreeLink, { className: 'text-center margin-top-30', buttonName: t('Send') })
	        )
	      );
	    }
	  }]);
	  return RegistrationForm;
	}(_ClientSideComponent2.default), _class3.propTypes = {
	  className: _propTypes2.default.string,
	  loginData: _propTypes2.default.object,
	  register: _propTypes2.default.func,
	  registrationForm: _propTypes2.default.object,
	  showTerms: _propTypes2.default.bool,
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'submit', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'submit'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'toggleForm', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'toggleForm'), _class2.prototype)), _class2)) || _class) || _class) || _class);
	exports.default = RegistrationForm;
	module.exports = exports['default'];

/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(58);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ClientSideComponent2 = __webpack_require__(30);
	
	var _ClientSideComponent3 = _interopRequireDefault(_ClientSideComponent2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1247);
	
	var cn = _bind2.default.bind(styles);
	
	var AutoCollapser = (_class = (_temp = _class2 = function (_ClientSideComponent) {
	  (0, _inherits3.default)(AutoCollapser, _ClientSideComponent);
	
	  function AutoCollapser() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, AutoCollapser);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = AutoCollapser.__proto__ || (0, _getPrototypeOf2.default)(AutoCollapser)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { collapsable: false, collapsed: false };
	    return _this;
	  }
	
	  (0, _createClass3.default)(AutoCollapser, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _get3.default)(AutoCollapser.prototype.__proto__ || (0, _getPrototypeOf2.default)(AutoCollapser.prototype), 'componentDidMount', this).call(this, this.initCollapser);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.children !== this.props.children) {
	        this.changeCollapser({ collapsed: false });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (typeof window !== 'undefined') {
	        window.removeEventListener('resize', this.changeCollapser);
	      }
	    }
	  }, {
	    key: 'initCollapser',
	    value: function initCollapser() {
	      if (typeof window !== 'undefined') {
	        window.addEventListener('resize', this.changeCollapser);
	      }
	      this.changeCollapser();
	    }
	  }, {
	    key: 'changeCollapser',
	    value: function changeCollapser() {
	      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref2$collapsed = _ref2.collapsed,
	          collapsed = _ref2$collapsed === undefined ? this.state.collapsed : _ref2$collapsed;
	
	      var contentRect = this.contentEl.getBoundingClientRect();
	      var wrapperRect = this.wrapperEl.getBoundingClientRect();
	      var collapsable = contentRect.width > wrapperRect.width;
	      this.setState({ collapsable: collapsable, collapsed: collapsed });
	    }
	  }, {
	    key: 'initContentEl',
	    value: function initContentEl(el) {
	      this.contentEl = el;
	    }
	  }, {
	    key: 'initWrapperEl',
	    value: function initWrapperEl(el) {
	      this.wrapperEl = el;
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      var collapsed = this.state.collapsed;
	
	      this.setState({ collapsed: !collapsed });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          contentClass = _props.contentClass,
	          iconClass = _props.iconClass;
	      var _state = this.state,
	          collapsed = _state.collapsed,
	          collapsable = _state.collapsable,
	          isMounted = _state.isMounted;
	
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: cn('wrapper', { collapsed: collapsed, collapsable: collapsable, isMounted: isMounted }, className),
	          onClick: this.toggle,
	          ref: this.initWrapperEl
	        },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _bind2.default)(styles.content, contentClass) },
	          children
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _bind2.default)(styles.content, styles.fake, contentClass), ref: this.initContentEl },
	          children
	        ),
	        _react2.default.createElement('i', { className: (0, _bind2.default)(styles.collapser, iconClass) })
	      );
	    }
	  }]);
	  return AutoCollapser;
	}(_ClientSideComponent3.default), _class2.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node, _propTypes2.default.arrayOf(_propTypes2.default.node)]),
	  className: _propTypes2.default.string,
	  contentClass: _propTypes2.default.string,
	  iconClass: _propTypes2.default.string
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'initCollapser', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'initCollapser'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'changeCollapser', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'changeCollapser'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'initContentEl', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'initContentEl'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'initWrapperEl', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'initWrapperEl'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'toggle', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'toggle'), _class.prototype)), _class);
	exports.default = AutoCollapser;
	module.exports = exports['default'];

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(21);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _take2 = __webpack_require__(454);
	
	var _take3 = _interopRequireDefault(_take2);
	
	var _get2 = __webpack_require__(19);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactAutosuggest = __webpack_require__(1601);
	
	var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);
	
	var _utils = __webpack_require__(24);
	
	var _reactAttrsFilter = __webpack_require__(1587);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var suggestionTheme = __webpack_require__(1388);
	
	var AutosuggestField = (_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(AutosuggestField, _Component);
	
	  function AutosuggestField() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, AutosuggestField);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = AutosuggestField.__proto__ || (0, _getPrototypeOf2.default)(AutosuggestField)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { value: '', suggestions: [] };
	    return _this;
	  }
	
	  (0, _createClass3.default)(AutosuggestField, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.changeWidth();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unmounted = true;
	    }
	  }, {
	    key: 'onSuggestionKwChange',
	    value: function onSuggestionKwChange(event, _ref2) {
	      var newValue = _ref2.newValue;
	
	      if (typeof newValue !== 'undefined' && !this.unmounted) {
	        this.setState({ value: newValue });
	      }
	    }
	  }, {
	    key: 'onSuggestionsFetchRequested',
	    value: function onSuggestionsFetchRequested(_ref3) {
	      var value = _ref3.value;
	
	      if (!this.unmounted) {
	        this.setState({ suggestions: this.getSuggestions(value) });
	      }
	    }
	  }, {
	    key: 'onSuggestionsClearRequested',
	    value: function onSuggestionsClearRequested() {
	      if (!this.unmounted) {
	        this.setState({ suggestions: [] });
	      }
	    }
	  }, {
	    key: 'onSuggestionSelected',
	    value: function onSuggestionSelected(e, val) {
	      var _this2 = this;
	
	      this.props.onSuggestionSelected(e, val).then(function () {
	        if (!_this2.unmounted) {
	          _this2.setState({ value: '' });
	        }
	        _this2.changeWidth();
	      });
	    }
	  }, {
	    key: 'getSuggestionValue',
	    value: function getSuggestionValue(suggestion) {
	      return (0, _get3.default)(suggestion, this.props.field);
	    }
	  }, {
	    key: 'getSuggestions',
	    value: function getSuggestions(value) {
	      var _props = this.props,
	          onGetSuggestions = _props.onGetSuggestions,
	          items = _props.items,
	          field = _props.field,
	          maxSuggestions = _props.maxSuggestions;
	
	      var suggestions = onGetSuggestions ? onGetSuggestions(value) : (0, _utils.filterObjectsByKw)(items, [field], value);
	      return maxSuggestions ? (0, _take3.default)(suggestions, maxSuggestions) : suggestions;
	    }
	  }, {
	    key: 'changeWidth',
	    value: function changeWidth() {
	      if (!this.props.autoWidth || typeof document === 'undefined' || typeof window === 'undefined') {
	        return false;
	      }
	      var inputEl = this.fieldEl.input;
	      var tmp = document.createElement('span');
	      var inputStyle = window.getComputedStyle(inputEl);
	      tmp.innerHTML = inputEl.value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	      tmp.style.padding = inputStyle.padding;
	      tmp.style.paddingLeft = inputStyle['padding-left'];
	      tmp.style.paddingRight = inputStyle['padding-right'];
	      tmp.style.fontSize = inputStyle.fontSize;
	      tmp.style.border = inputStyle.border;
	      tmp.style.visibility = 'hidden';
	      inputEl.parentNode.appendChild(tmp);
	      var theWidth = Math.ceil(tmp.getBoundingClientRect().width);
	      inputEl.parentNode.removeChild(tmp);
	      inputEl.style.width = theWidth + 5 + 'px';
	
	      return theWidth;
	    }
	  }, {
	    key: 'renderSuggestion',
	    value: function renderSuggestion(suggestion) {
	      return _react2.default.createElement(
	        'span',
	        null,
	        (0, _get3.default)(suggestion, this.props.field)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          readOnly = _props2.readOnly,
	          placeholder = _props2.placeholder,
	          onSuggestionSelected = _props2.onSuggestionSelected,
	          items = _props2.items,
	          field = _props2.field,
	          autoWidth = _props2.autoWidth,
	          withZIndex = _props2.withZIndex,
	          otherProps = (0, _objectWithoutProperties3.default)(_props2, ['readOnly', 'placeholder', 'onSuggestionSelected', 'items', 'field', 'autoWidth', 'withZIndex']); // eslint-disable-line no-unused-vars
	
	      var _state = this.state,
	          suggestions = _state.suggestions,
	          value = _state.value;
	
	      var inputProps = (0, _extends3.default)({
	        placeholder: placeholder,
	        value: value,
	        readOnly: readOnly
	      }, otherProps.inputProps);
	
	      var onChange = inputProps.onChange;
	      inputProps.onChange = function (e) {
	        if (onChange) {
	          onChange(e);
	        }
	        _this3.onSuggestionKwChange(e, { newValue: e.target.value });
	        _this3.changeWidth();
	      };
	
	      var filteredInputProps = (0, _reactAttrsFilter.filterPropsFor)(inputProps, 'input');
	      if (inputProps.onKeyPress) {
	        filteredInputProps.onKeyPress = inputProps.onKeyPress;
	      }
	
	      var theme = (0, _extends3.default)({}, suggestionTheme);
	      if (withZIndex) {
	        theme.container = theme.containerWithZIndex;
	      }
	
	      return _react2.default.createElement(_reactAutosuggest2.default, (0, _extends3.default)({
	        ref: function ref(el) {
	          return _this3.fieldEl = el;
	        }
	      }, otherProps, {
	        suggestions: suggestions,
	        onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
	        onSuggestionsClearRequested: this.onSuggestionsClearRequested,
	        getSuggestionValue: this.getSuggestionValue,
	        renderSuggestion: this.renderSuggestion,
	        onSuggestionSelected: this.onSuggestionSelected,
	        theme: suggestionTheme,
	        focusFirstSuggestion: true,
	        inputProps: filteredInputProps,
	        highlightFirstSuggestion: true
	      }));
	    }
	  }]);
	  return AutosuggestField;
	}(_react.Component), _class2.propTypes = {
	  autoWidth: _propTypes2.default.bool,
	  field: _propTypes2.default.string.isRequired,
	  items: _propTypes2.default.array.isRequired,
	  maxSuggestions: _propTypes2.default.number,
	  onGetSuggestions: _propTypes2.default.func,
	  onSuggestionSelected: _propTypes2.default.func.isRequired,
	  placeholder: _propTypes2.default.string,
	  readOnly: _propTypes2.default.bool,
	  withZIndex: _propTypes2.default.bool
	}, _class2.defaultProps = {
	  maxSuggestions: 30,
	  withZIndex: true
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onSuggestionsFetchRequested', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onSuggestionsFetchRequested'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onSuggestionsClearRequested', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onSuggestionsClearRequested'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onSuggestionSelected', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onSuggestionSelected'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getSuggestionValue', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'getSuggestionValue'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getSuggestions', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'getSuggestions'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'renderSuggestion', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'renderSuggestion'), _class.prototype)), _class);
	exports.default = AutosuggestField;
	module.exports = exports['default'];

/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get3 = __webpack_require__(19);
	
	var _get4 = _interopRequireDefault(_get3);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClientSideComponent = __webpack_require__(30);
	
	var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);
	
	var _reactRedux = __webpack_require__(11);
	
	var _utils = __webpack_require__(24);
	
	var _components = __webpack_require__(15);
	
	var _config = __webpack_require__(41);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _cloud = __webpack_require__(216);
	
	var cloudActions = _interopRequireWildcard(_cloud);
	
	var _auth = __webpack_require__(31);
	
	var authActions = _interopRequireWildcard(_auth);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var service = 'boxcom';
	
	var BoxcomConnectButton = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    csrfState: state.cloud[service].csrfState,
	    user: state.auth.user
	  };
	}, (0, _extends3.default)({}, cloudActions, authActions)), _dec(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
	  (0, _inherits3.default)(BoxcomConnectButton, _Component);
	
	  function BoxcomConnectButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, BoxcomConnectButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BoxcomConnectButton.__proto__ || (0, _getPrototypeOf2.default)(BoxcomConnectButton)).call.apply(_ref, [this].concat(args))), _this), _this.onAuth = function (e) {
	      var _this$props = _this.props,
	          csrfState = _this$props.csrfState,
	          boxcomGetToken = _this$props.boxcomGetToken,
	          updateBoxToken = _this$props.updateBoxToken;
	
	      window.removeEventListener('onBoxcomAuth', _this.onAuth);
	
	      setTimeout(function () {
	        _this.authWindow.close();
	        _this.authWindow = null;
	      }, 1000);
	
	      if (e.detail.state === csrfState) {
	        var authCode = e.detail.code;
	        boxcomGetToken(authCode).promise.then(function (resp) {
	          return updateBoxToken(service, resp.data);
	        });
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(BoxcomConnectButton, [{
	    key: 'connect',
	    value: function connect() {
	      var setCSRFState = this.props.setCSRFState;
	
	      var state = Date.now().toString();
	      setCSRFState(service, state);
	
	      var boxUrl = 'https://account.box.com/api/oauth2/authorize';
	      var redirectUri = encodeURIComponent(document.location.origin + '/processing/cloudauth/boxcom');
	      var clientId = _config2.default.app.boxcom.clientId;
	      var authUrl = boxUrl + '?response_type=code&client_id=' + clientId + '&redirect_uri=' + redirectUri + '&state=' + state;
	      this.authWindow = (0, _utils.popupWindowCenter)(authUrl, service, 400, 500);
	      window.addEventListener('onBoxcomAuth', this.onAuth);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          user = _props.user,
	          connectClassName = _props.connectClassName,
	          disconnectClassName = _props.disconnectClassName;
	
	      var isConnected = !!(0, _get4.default)(user, 'boxcomToken', false);
	
	      return _react2.default.createElement(_components.CloudConnectButton, {
	        isConnected: isConnected,
	        service: service,
	        connectClassName: connectClassName,
	        disconnectClassName: disconnectClassName,
	        connect: this.connect
	      });
	    }
	  }]);
	  return BoxcomConnectButton;
	}(_ClientSideComponent2.default), _class3.propTypes = {
	  boxcomGetToken: _propTypes2.default.func,
	  connectClassName: _propTypes2.default.string,
	  csrfState: _propTypes2.default.string,
	  disconnectClassName: _propTypes2.default.string,
	  setCSRFState: _propTypes2.default.func,
	  updateBoxToken: _propTypes2.default.func,
	  user: _propTypes2.default.object
	}, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'connect', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'connect'), _class2.prototype)), _class2)) || _class);
	exports.default = BoxcomConnectButton;
	module.exports = exports['default'];

/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(58);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClientSideComponent = __webpack_require__(30);
	
	var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);
	
	var _uploads = __webpack_require__(112);
	
	var _config = __webpack_require__(41);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var boxImg = __webpack_require__(268);
	
	var BoxcomPicker = (_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(BoxcomPicker, _Component);
	
	  function BoxcomPicker() {
	    (0, _classCallCheck3.default)(this, BoxcomPicker);
	    return (0, _possibleConstructorReturn3.default)(this, (BoxcomPicker.__proto__ || (0, _getPrototypeOf2.default)(BoxcomPicker)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(BoxcomPicker, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _get3.default)(BoxcomPicker.prototype.__proto__ || (0, _getPrototypeOf2.default)(BoxcomPicker.prototype), 'componentDidMount', this).call(this, this.initBoxcom);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.BoxSelect) {
	        this.BoxSelect.unregister(this.BoxSelect.SUCCESS_EVENT_TYPE);
	        this.BoxSelect._destroy();
	        this.BoxSelect = null;
	      }
	    }
	  }, {
	    key: 'onSelect',
	    value: function onSelect(files) {
	      var onSelect = this.props.onSelect;
	
	
	      if (onSelect) {
	        var _config$app$boxcom = _config2.default.app.boxcom,
	            serviceName = _config$app$boxcom.serviceName,
	            fileFields = _config$app$boxcom.fileFields;
	
	        var formattedList = (0, _uploads.formatCloudFilesList)(files, serviceName, fileFields);
	        onSelect(formattedList);
	      }
	    }
	  }, {
	    key: 'initBoxcom',
	    value: function initBoxcom() {
	      if (this.BoxSelect) {
	        return false;
	      }
	
	      var options = {
	        clientId: _config2.default.app.boxcom.clientId,
	        linkType: 'direct',
	        multiselect: true
	      };
	
	      var BoxSelect = __webpack_require__(2242).boxSelect();
	      this.BoxSelect = new BoxSelect(options);
	      this.BoxSelect.success(this.onSelect);
	    }
	  }, {
	    key: 'openBoxcom',
	    value: function openBoxcom() {
	      this.BoxSelect.launchPopup();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'button',
	        { type: 'button', className: 'btn btn-clear', onClick: this.openBoxcom, title: 'Box.com' },
	        _react2.default.createElement('img', { src: boxImg, alt: '' })
	      );
	    }
	  }]);
	  return BoxcomPicker;
	}(_ClientSideComponent2.default), _class2.propTypes = {
	  onSelect: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onSelect', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onSelect'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'initBoxcom', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'initBoxcom'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'openBoxcom', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'openBoxcom'), _class.prototype)), _class);
	exports.default = BoxcomPicker;
	module.exports = exports['default'];

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _toConsumableArray2 = __webpack_require__(34);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _promise = __webpack_require__(62);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _values = __webpack_require__(158);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClientSideComponent = __webpack_require__(30);
	
	var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactI18next = __webpack_require__(12);
	
	var _utils = __webpack_require__(24);
	
	var _auth = __webpack_require__(31);
	
	var authAction = _interopRequireWildcard(_auth);
	
	var _cloud = __webpack_require__(216);
	
	var cloudActions = _interopRequireWildcard(_cloud);
	
	var _project = __webpack_require__(37);
	
	var projectActions = _interopRequireWildcard(_project);
	
	var _components = __webpack_require__(15);
	
	var _cloud2 = __webpack_require__(873);
	
	var _config = __webpack_require__(41);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _projects = __webpack_require__(28);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var boxcomImg = __webpack_require__(268);
	
	var service = 'boxcom';
	
	var BoxcomPopup = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    csrfState: state.cloud[service].csrfState,
	    error: (0, _cloud2.getError)(state, service),
	    files: (0, _cloud2.getFiles)(state, service),
	    pathId: (0, _cloud2.getPathId)(state, service),
	    pathCollection: state.cloud[service].pathCollection,
	    processing: (0, _cloud2.getProcessing)(state, service),
	    user: state.auth.user
	  };
	}, (0, _extends3.default)({}, authAction, projectActions, cloudActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(BoxcomPopup, _Component);
	
	  function BoxcomPopup() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, BoxcomPopup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = BoxcomPopup.__proto__ || (0, _getPrototypeOf2.default)(BoxcomPopup)).call.apply(_ref, [this].concat(args)));
	
	    _this.onAuth = function (e) {
	      var _this$props = _this.props,
	          csrfState = _this$props.csrfState,
	          boxcomGetToken = _this$props.boxcomGetToken,
	          updateBoxToken = _this$props.updateBoxToken;
	      var _e$detail = e.detail,
	          state = _e$detail.state,
	          code = _e$detail.code;
	
	
	      window.removeEventListener('onBoxcomAuth', _this.onAuth);
	      setTimeout(function () {
	        _this.authWindow.close();
	        _this.authWindow = null;
	      }, 1000);
	
	      if (state === csrfState && code) {
	        boxcomGetToken(code).promise.then(function (resp) {
	          updateBoxToken(service, resp.data);
	          _this.openCloudBrowser();
	        });
	      }
	    };
	
	    _this.getFileFromResp = function (item) {
	      return {
	        service: service,
	        uniqId: item.__id + '-' + Date.now(),
	        url: '',
	        name: item.name,
	        size: item.size
	      };
	    };
	
	    _this.state = { files: [] };
	    return _this;
	  }
	
	  (0, _createClass3.default)(BoxcomPopup, [{
	    key: 'onSelect',
	    value: function onSelect(item, breadcrumb) {
	      if (item && item.__type === 'folder') {
	        this.loadPath(item.id, this.getPathCollection(item));
	      } else if (typeof breadcrumb !== 'undefined') {
	        this.loadPath(breadcrumb.id, breadcrumb.pathCollection);
	      }
	    }
	  }, {
	    key: 'onDownload',
	    value: function onDownload(_ref2) {
	      var fileItem = _ref2.fileItem,
	          resp = _ref2.resp,
	          err = _ref2.err;
	      var _props = this.props,
	          setCloudFileSuccessStatus = _props.setCloudFileSuccessStatus,
	          setCloudFileFailedStatus = _props.setCloudFileFailedStatus,
	          setCloudFileMetadata = _props.setCloudFileMetadata,
	          onUpload = _props.onUpload,
	          projectId = _props.projectId,
	          addFailedMedia = _props.addFailedMedia;
	
	      var res = (0, _extends3.default)({}, fileItem, resp.data);
	
	      setCloudFileMetadata({ uniqId: fileItem.uniqId, metadata: resp.data });
	      if (err) {
	        addFailedMedia((0, _extends3.default)({}, fileItem), projectId);
	        setCloudFileFailedStatus(fileItem.uniqId);
	      } else {
	        onUpload(res);
	        setCloudFileSuccessStatus(fileItem.uniqId);
	      }
	
	      return res;
	    }
	  }, {
	    key: 'onResult',
	    value: function onResult(items) {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          boxcomDownloadFile = _props2.boxcomDownloadFile,
	          setProcessing = _props2.setProcessing,
	          submitCloudFile = _props2.submitCloudFile,
	          projectId = _props2.projectId,
	          projectType = _props2.projectType;
	
	
	      var itemsArr = (0, _values2.default)(items);
	      if (!itemsArr.length) {
	        return false;
	      }
	
	      setProcessing(service, true);
	      this.closeCloudBrowser();
	      var promises = [];
	
	      itemsArr.map(function (item) {
	        var fileItem = (0, _extends3.default)({}, _this2.getFileFromResp(item));
	        var promise = boxcomDownloadFile({ fileId: item.__id, fileName: item.__name, projectId: projectId, projectType: projectType }).promise.then(function (resp) {
	          return _this2.onDownload({ fileItem: fileItem, resp: resp });
	        }).catch(function (err) {
	          return _this2.onDownload({ fileItem: fileItem, err: err });
	        });
	        promises.push(promise);
	        submitCloudFile(fileItem);
	      });
	
	      _promise2.default.all(promises).then(function () {
	        return setProcessing(service, false);
	      }).catch(function () {
	        return setProcessing(service, false);
	      });
	    }
	  }, {
	    key: 'getRootPathCollection',
	    value: function getRootPathCollection() {
	      var t = this.props.t;
	
	      return [{ id: '0', name: t('Box files') }];
	    }
	  }, {
	    key: 'getPathCollection',
	    value: function getPathCollection(item) {
	      var _this3 = this;
	
	      var res = [];
	      item.path_collection.entries.map(function (entry, index) {
	        if (!index) {
	          res.push.apply(res, (0, _toConsumableArray3.default)(_this3.getRootPathCollection()));
	        } else {
	          res.push({ id: entry.id, name: entry.name });
	        }
	      });
	      res.push({ id: item.id, name: item.name });
	      return res;
	    }
	  }, {
	    key: 'loadPath',
	    value: function loadPath(pathId) {
	      var _this4 = this;
	
	      var pathCollection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getRootPathCollection();
	      var _props3 = this.props,
	          setFiles = _props3.setFiles,
	          setError = _props3.setError,
	          setPath = _props3.setPath,
	          setPathCollection = _props3.setPathCollection,
	          boxcomGetFolders = _props3.boxcomGetFolders;
	
	      var isSamePath = function isSamePath() {
	        return _this4.props.pathId === pathId;
	      };
	      setPath(service, pathId);
	      setPathCollection(service, pathCollection);
	
	      boxcomGetFolders(pathId).promise.then(function (resp) {
	        return isSamePath() ? setFiles({ service: service, pathId: pathId, files: resp.data.entries }) : false;
	      }).catch(function (err) {
	        return isSamePath() ? setError(service, err.msg || err.error) : false;
	      });
	    }
	  }, {
	    key: 'openCloudBrowser',
	    value: function openCloudBrowser() {
	      this.modal.open();
	      this.loadPath('0');
	    }
	  }, {
	    key: 'closeCloudBrowser',
	    value: function closeCloudBrowser() {
	      this.modal.close();
	    }
	  }, {
	    key: 'openBoxcom',
	    value: function openBoxcom(forceAuth) {
	      var _props4 = this.props,
	          user = _props4.user,
	          setCSRFState = _props4.setCSRFState;
	
	      var state = Date.now().toString();
	      setCSRFState(service, state);
	
	      if (!user.boxcomToken || forceAuth) {
	        var redirectUri = encodeURIComponent(document.location.origin + '/processing/cloudauth/boxcom');
	        var baseUrl = 'https://account.box.com/api/oauth2/authorize';
	        var authUrl = baseUrl + '?response_type=code&client_id=' + _config2.default.app.boxcom.clientId + '&redirect_uri=' + redirectUri + '&state=' + state;
	        this.authWindow = (0, _utils.popupWindowCenter)(authUrl, service, 400, 500);
	        window.addEventListener('onBoxcomAuth', this.onAuth);
	      } else {
	        this.openCloudBrowser();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _props5 = this.props,
	          t = _props5.t,
	          files = _props5.files,
	          error = _props5.error,
	          pathId = _props5.pathId,
	          pathCollection = _props5.pathCollection,
	          processing = _props5.processing,
	          fileTypes = _props5.fileTypes,
	          disabled = _props5.disabled;
	
	
	      var modalProps = {
	        backdrop: true,
	        closeByEsc: false,
	        title: t('Add Box files'),
	        bsSize: 'lg',
	        withoutPadding: true,
	        simpleHeader: true
	      };
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          'button',
	          { type: 'button', className: 'btn btn-clear', onClick: function onClick() {
	              return _this5.openBoxcom();
	            }, disabled: disabled },
	          _react2.default.createElement(
	            _components.Tooltip,
	            { placement: 'bottom', title: 'Box.com' },
	            _react2.default.createElement('img', { src: boxcomImg, alt: '' })
	          )
	        ),
	        _react2.default.createElement(
	          _components.Modal,
	          (0, _extends3.default)({ ref: function ref(el) {
	              return _this5.modal = el;
	            } }, modalProps),
	          _react2.default.createElement(_components.CloudBrowser, {
	            items: files,
	            fileTypes: fileTypes,
	            service: service,
	            pathId: pathId,
	            pathCollection: pathCollection,
	            error: error,
	            processing: processing,
	            onCancel: this.closeCloudBrowser,
	            onSelect: this.onSelect,
	            onResult: this.onResult,
	            onError: function onError() {
	              return _this5.openBoxcom(true);
	            }
	          })
	        )
	      );
	    }
	  }]);
	  return BoxcomPopup;
	}(_ClientSideComponent2.default), _class3.propTypes = {
	  addFailedMedia: _propTypes2.default.func,
	  boxcomDownloadFile: _propTypes2.default.func,
	  boxcomGetFolders: _propTypes2.default.func,
	  boxcomGetToken: _propTypes2.default.func,
	  csrfState: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  error: _propTypes2.default.string,
	  files: _propTypes2.default.array,
	  fileTypes: _propTypes2.default.array,
	  onUpload: _propTypes2.default.func,
	  pathCollection: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    id: _propTypes2.default.string,
	    name: _propTypes2.default.string,
	    path: _propTypes2.default.string
	  })),
	  pathId: _propTypes2.default.string,
	  processing: _propTypes2.default.bool,
	  projectId: _propTypes2.default.number,
	  projectType: _propTypes2.default.string,
	  setCloudFileFailedStatus: _propTypes2.default.func,
	  setCloudFileMetadata: _propTypes2.default.func,
	  setCloudFileSuccessStatus: _propTypes2.default.func,
	  setCSRFState: _propTypes2.default.func,
	  setError: _propTypes2.default.func,
	  setFiles: _propTypes2.default.func,
	  setPath: _propTypes2.default.func,
	  setPathCollection: _propTypes2.default.func,
	  setProcessing: _propTypes2.default.func,
	  submitCloudFile: _propTypes2.default.func,
	  t: _propTypes2.default.func,
	  updateBoxToken: _propTypes2.default.func,
	  user: _propTypes2.default.object
	}, _class3.defaultProps = {
	  onUpload: function onUpload() {},
	  projectType: _projects.projectTypes.audio
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onSelect', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSelect'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onResult', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onResult'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'closeCloudBrowser', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'closeCloudBrowser'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = BoxcomPopup;
	module.exports = exports['default'];

/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _ChangePasswordFormValidation = __webpack_require__(1963);
	
	var _ChangePasswordFormValidation2 = _interopRequireDefault(_ChangePasswordFormValidation);
	
	var _account = __webpack_require__(184);
	
	var _formComponents = __webpack_require__(71);
	
	var _reactI18next = __webpack_require__(12);
	
	var _reduxForm = __webpack_require__(50);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _components = __webpack_require__(15);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1248);
	
	var ChangePasswordForm = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    updatePasswordLoading: state.account.updatePasswordLoading
	  };
	}, { updatePassword: _account.updatePassword }), _dec2 = (0, _reduxForm.reduxForm)({
	  form: 'changePasswordForm',
	  propNamespace: 'changePasswordForm',
	  validate: _ChangePasswordFormValidation2.default
	}), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(ChangePasswordForm, _Component);
	
	  function ChangePasswordForm() {
	    (0, _classCallCheck3.default)(this, ChangePasswordForm);
	    return (0, _possibleConstructorReturn3.default)(this, (ChangePasswordForm.__proto__ || (0, _getPrototypeOf2.default)(ChangePasswordForm)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ChangePasswordForm, [{
	    key: 'getPasswordRulesElement',
	    value: function getPasswordRulesElement() {
	      var t = this.props.t;
	
	      var passwordRules = [t('No obvious password'), t('One lowercase character'), t('One uppercase character'), t('One number'), t('One special character'), t('Eight characters minimum')];
	      // eslint-disable-next-line react/no-array-index-key
	      return passwordRules.map(function (rule, key) {
	        return _react2.default.createElement(
	          'li',
	          { className: styles.passwordRule, key: key },
	          rule
	        );
	      });
	    }
	  }, {
	    key: 'changePassword',
	    value: function changePassword(formData) {
	      var newPassword = formData.newPassword,
	          currentPassword = formData.currentPassword;
	
	      if (!newPassword) {
	        return false;
	      }
	
	      var _props = this.props,
	          t = _props.t,
	          reset = _props.changePasswordForm.reset;
	
	      var promise = this.props.updatePassword(newPassword, currentPassword).promise;
	      promise.then(function () {
	        _toastr2.default.info(t('Password has been successfully updated'));
	        reset();
	      });
	      return promise;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          _props2$changePasswor = _props2.changePasswordForm,
	          handleSubmit = _props2$changePasswor.handleSubmit,
	          submitting = _props2$changePasswor.submitting,
	          t = _props2.t,
	          updatePasswordLoading = _props2.updatePasswordLoading;
	
	
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit(this.changePassword) },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-35 col-sm-30 col-md-25 col-lg-20' },
	            _react2.default.createElement(_reduxForm.Field, {
	              type: 'password',
	              name: 'currentPassword',
	              component: _formComponents.formSimpleTextInput,
	              placeholder: t('Enter current password'),
	              hideLabel: true
	            }),
	            _react2.default.createElement(_reduxForm.Field, {
	              type: 'password',
	              name: 'newPassword',
	              component: _formComponents.formSimpleTextInput,
	              placeholder: t('Enter new password'),
	              hideLabel: true
	            }),
	            _react2.default.createElement(_reduxForm.Field, {
	              type: 'password',
	              name: 'passwordConfirm',
	              component: _formComponents.formSimpleTextInput,
	              placeholder: t('Confirm new password'),
	              hideLabel: true
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-25 col-sm-30 col-md-35 col-lg-40' },
	            _react2.default.createElement(
	              'ul',
	              { className: styles.passwordRules },
	              this.getPasswordRulesElement()
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'text-right margin-top-20' },
	          updatePasswordLoading && _react2.default.createElement(_components.Loader, null),
	          _react2.default.createElement(
	            'button',
	            { type: 'submit', className: 'btn btn-primary', disabled: submitting },
	            t('Change password')
	          )
	        )
	      );
	    }
	  }]);
	  return ChangePasswordForm;
	}(_react.Component), _class3.propTypes = {
	  changePasswordForm: _propTypes2.default.object,
	  t: _propTypes2.default.func,
	  updatePassword: _propTypes2.default.func,
	  updatePasswordLoading: _propTypes2.default.bool
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'changePassword', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'changePassword'), _class2.prototype)), _class2)) || _class) || _class) || _class);
	exports.default = ChangePasswordForm;
	module.exports = exports['default'];

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _validation = __webpack_require__(157);
	
	var validate = function validate(values) {
	  var currentPassword = values.currentPassword,
	      newPassword = values.newPassword,
	      passwordConfirm = values.passwordConfirm;
	
	  var t = __webpack_require__(56).getT();
	  var errors = {
	    currentPassword: (0, _validation.required)(currentPassword),
	    newPassword: (0, _validation.password)(newPassword),
	    passwordConfirm: (0, _validation.password)(passwordConfirm)
	  };
	
	  if (newPassword && passwordConfirm && newPassword !== passwordConfirm) {
	    errors.passwordConfirm = t('Password and confirmation do not match');
	  }
	
	  return errors;
	};
	
	exports.default = validate;
	module.exports = exports['default'];

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _get2 = __webpack_require__(19);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _defaultsDeep2 = __webpack_require__(448);
	
	var _defaultsDeep3 = _interopRequireDefault(_defaultsDeep2);
	
	var _debounce2 = __webpack_require__(317);
	
	var _debounce3 = _interopRequireDefault(_debounce2);
	
	var _desc, _value, _class, _class2, _temp; // based on https://github.com/RakanNimer/react-google-charts
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _chartColors = __webpack_require__(513);
	
	var _chartColors2 = _interopRequireDefault(_chartColors);
	
	var _googleChartLoader = __webpack_require__(1966);
	
	var _googleChartLoader2 = _interopRequireDefault(_googleChartLoader);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _Loader = __webpack_require__(60);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _chartDefaultOptions = __webpack_require__(1965);
	
	var _chartDefaultOptions2 = _interopRequireDefault(_chartDefaultOptions);
	
	var _config = __webpack_require__(41);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var Chart = (_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(Chart, _Component);
	
	  function Chart(props, context) {
	    (0, _classCallCheck3.default)(this, Chart);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Chart.__proto__ || (0, _getPrototypeOf2.default)(Chart)).call(this, props));
	
	    _this.state = { graphID: props.graphId || context.getId('chart-') };
	    _this.chart = null;
	    _this.wrapper = null;
	    _this.hiddenColumns = {};
	    _this.dataTable = [];
	
	    _this.onResize = _this.onResize.bind(_this); //autobind doesn't work in case of reassigning onResize
	    return _this;
	  }
	
	  (0, _createClass3.default)(Chart, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (typeof window === 'undefined') {
	        return;
	      }
	      var _props = this.props,
	          loadCharts = _props.loadCharts,
	          packages = _props.chartPackages,
	          version = _props.chartVersion;
	
	      if (loadCharts) {
	        var mapsApiKey = _config2.default.app.googleMaps.apiKey;
	        _googleChartLoader2.default.init({ packages: packages, version: version, mapsApiKey: mapsApiKey }).then(this.drawChart);
	        this.onResize = (0, _debounce3.default)(this.onResize, 200);
	        window.addEventListener('resize', this.onResize);
	      } else {
	        this.drawChart();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var loadCharts = this.props.loadCharts;
	
	      if (!loadCharts) {
	        this.drawChart();
	      } else if (_googleChartLoader2.default.isLoading) {
	        _googleChartLoader2.default.initPromise.then(this.drawChart);
	      } else if (_googleChartLoader2.default.isLoaded) {
	        this.drawChart();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (window) {
	        if ((0, _get3.default)(window, 'google.visualization')) {
	          window.google.visualization.events.removeAllListeners(this.wrapper);
	        }
	        window.removeEventListener('resize', this.onResize);
	      }
	      this.wrapper = null;
	    }
	  }, {
	    key: 'onResize',
	    value: function onResize() {
	      this.drawChart();
	    }
	  }, {
	    key: 'onSelectToggle',
	    value: function onSelectToggle() {
	      var selection = this.chart.getSelection();
	      if (selection) {
	        if (selection[0].row === null) {
	          var column = selection[0].column;
	          this.togglePoints(column);
	        }
	      }
	    }
	  }, {
	    key: 'getChartOptions',
	    value: function getChartOptions() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.options;
	
	      return (0, _defaultsDeep3.default)(options, _chartDefaultOptions2.default);
	    }
	  }, {
	    key: 'getColumnColor',
	    value: function getColumnColor(columnIndex) {
	      var _getChartOptions = this.getChartOptions(),
	          colors = _getChartOptions.colors;
	
	      if (colors) {
	        if (colors[columnIndex]) {
	          return colors[columnIndex];
	        }
	      } else if (columnIndex in _chartColors2.default) {
	        return _chartColors2.default[columnIndex];
	      }
	      return _chartColors2.default[0];
	    }
	  }, {
	    key: 'buildDataTableFromProps',
	    value: function buildDataTableFromProps() {
	      var _props2 = this.props,
	          diffdata = _props2.diffdata,
	          data = _props2.data;
	      var t = this.context.t;
	
	      var result = null;
	      var errorMessage = null;
	      var error = null;
	
	      if (diffdata) {
	        result = this.computeDataTableDiff();
	      } else if (data === null) {
	        errorMessage = this.validateBuildingDataTableProps();
	      } else {
	        try {
	          this.wrapper.setDataTable(data);
	          result = this.wrapper.getDataTable();
	          this.formatDataTable({ dataTable: result });
	        } catch (err) {
	          errorMessage = t('Failed to set DataTable from data props!');
	          error = err;
	        }
	      }
	
	      if (errorMessage) {
	        throw new Error(errorMessage, error);
	      }
	
	      return result !== null ? result : this.generateDataTable();
	    }
	  }, {
	    key: 'validateBuildingDataTableProps',
	    value: function validateBuildingDataTableProps() {
	      var _props3 = this.props,
	          rows = _props3.rows,
	          allowEmptyRows = _props3.allowEmptyRows,
	          columns = _props3.columns;
	      var t = this.context.t;
	
	      var error = null;
	
	      if (!rows.length && !allowEmptyRows) {
	        error = t('Can\'t build DataTable from rows and columns: rows array in props is empty');
	      }
	      if (!columns.length) {
	        error = t('Can\'t build DataTable from rows and columns: columns array in props is empty');
	      }
	
	      return error;
	    }
	  }, {
	    key: 'computeDataTableDiff',
	    value: function computeDataTableDiff() {
	      var _props4 = this.props,
	          diffdata = _props4.diffdata,
	          chartType = _props4.chartType;
	      var oldDiffdata = diffdata.old,
	          newDiffdata = diffdata.new;
	
	      var oldData = window.google.visualization.arrayToDataTable(oldDiffdata);
	      var newData = window.google.visualization.arrayToDataTable(newDiffdata);
	      // must take computeDiff from prototypes since not available with charts early in process
	      var computeDiff = window.google.visualization[chartType].prototype.computeDiff;
	      return computeDiff(oldData, newData);
	    }
	  }, {
	    key: 'formatDataTable',
	    value: function formatDataTable(_ref) {
	      var dataTable = _ref.dataTable;
	      var _props5 = this.props,
	          numberFormat = _props5.numberFormat,
	          dateFormat = _props5.dateFormat;
	
	
	      if (numberFormat) {
	        var formatter = new window.google.visualization.NumberFormat(numberFormat.options);
	        formatter.format(dataTable, numberFormat.column);
	      }
	
	      if (dateFormat) {
	        var dateFormatter = new window.google.visualization.DateFormat(dateFormat.options);
	        dateFormat.columns.forEach(function (columnIdx) {
	          return dateFormatter.format(dataTable, columnIdx);
	        });
	      }
	    }
	  }, {
	    key: 'generateDataTable',
	    value: function generateDataTable() {
	      var _props6 = this.props,
	          rows = _props6.rows,
	          columns = _props6.columns;
	
	      var dataTable = new window.google.visualization.DataTable();
	      columns.forEach(function (column) {
	        return dataTable.addColumn(column);
	      });
	      dataTable.addRows(rows);
	      this.formatDataTable({ dataTable: dataTable });
	      return dataTable;
	    }
	  }, {
	    key: 'updateDataTable',
	    value: function updateDataTable() {
	      window.google.visualization.errors.removeAll(document.getElementById(this.wrapper.getContainerId()));
	      this.dataTable.removeRows(0, this.dataTable.getNumberOfRows());
	      this.dataTable.removeColumns(0, this.dataTable.getNumberOfColumns());
	      this.dataTable = this.buildDataTableFromProps();
	      return this.dataTable;
	    }
	  }, {
	    key: 'drawChart',
	    value: function drawChart() {
	      var _this2 = this;
	
	      var chartType = this.props.chartType;
	
	      var options = this.getChartOptions();
	      var graphID = this.state.graphID;
	
	
	      if (!this.wrapper) {
	        var chartConfig = {
	          chartType: chartType,
	          options: options,
	          containerId: graphID
	        };
	        this.wrapper = new window.google.visualization.ChartWrapper(chartConfig);
	        this.dataTable = this.buildDataTableFromProps();
	        this.wrapper.setDataTable(this.dataTable);
	
	        window.google.visualization.events.addOneTimeListener(this.wrapper, 'ready', function () {
	          _this2.chart = _this2.wrapper.getChart();
	          _this2.listenToChartEvents();
	          _this2.addChartActions();
	        });
	      } else {
	        this.updateDataTable();
	        this.wrapper.setDataTable(this.dataTable);
	        this.wrapper.setOptions(options);
	        if (this.wrapper.getChartType() !== chartType) {
	          window.google.visualization.events.removeAllListeners(this.wrapper);
	          this.wrapper.setChartType(chartType);
	          var self = this;
	          window.google.visualization.events.addOneTimeListener(this.wrapper, 'ready', function () {
	            self.chart = self.wrapper.getChart();
	            self.listenToChartEvents.call(self);
	          });
	        }
	      }
	      this.wrapper.draw();
	    }
	  }, {
	    key: 'addChartActions',
	    value: function addChartActions() {
	      var _this3 = this;
	
	      var chartActions = this.props.chartActions;
	
	
	      if (chartActions === null) {
	        return;
	      }
	
	      chartActions.forEach(function (chartAction) {
	        _this3.chart.setAction({
	          id: chartAction.id,
	          text: chartAction.text,
	          action: chartAction.action.bind(_this3, _this3.chart)
	        });
	      });
	    }
	  }, {
	    key: 'listenToChartEvents',
	    value: function listenToChartEvents() {
	      var _this4 = this;
	
	      var _props7 = this.props,
	          legendToggle = _props7.legendToggle,
	          chartEvents = _props7.chartEvents;
	
	
	      if (legendToggle) {
	        window.google.visualization.events.addListener(this.wrapper, 'select', this.onSelectToggle);
	      }
	      chartEvents.forEach(function (chartEvent) {
	        if (chartEvent.eventName === 'ready') {
	          chartEvent.callback(_this4);
	        } else {
	          (function (event) {
	            window.google.visualization.events.addListener(_this4.chart, event.eventName, function (e) {
	              event.callback(_this4, e);
	            });
	          })(chartEvent);
	        }
	      });
	    }
	  }, {
	    key: 'buildColumnFromSourceData',
	    value: function buildColumnFromSourceData(columnIndex) {
	      return {
	        label: this.dataTable.getColumnLabel(columnIndex),
	        type: this.dataTable.getColumnType(columnIndex),
	        sourceColumn: columnIndex,
	        role: this.dataTable.getColumnRole(columnIndex)
	      };
	    }
	  }, {
	    key: 'buildEmptyColumnFromSourceData',
	    value: function buildEmptyColumnFromSourceData(columnIndex) {
	      return {
	        label: this.dataTable.getColumnLabel(columnIndex),
	        type: this.dataTable.getColumnType(columnIndex),
	        calc: function calc() {
	          return null;
	        },
	        role: this.dataTable.getColumnRole(columnIndex)
	      };
	    }
	  }, {
	    key: 'addEmptyColumnTo',
	    value: function addEmptyColumnTo(columns, columnIndex) {
	      var emptyColumn = this.buildEmptyColumnFromSourceData(columnIndex);
	      columns.push(emptyColumn);
	    }
	  }, {
	    key: 'hideColumn',
	    value: function hideColumn(colors, columnIndex) {
	      if (!this.isHidden(columnIndex)) {
	        this.hiddenColumns[columnIndex] = { color: this.getColumnColor(columnIndex - 1) };
	      }
	      colors.push('#CCCCCC');
	    }
	  }, {
	    key: 'addSourceColumnTo',
	    value: function addSourceColumnTo(columns, columnIndex) {
	      var sourceColumn = this.buildColumnFromSourceData(columnIndex);
	      columns.push(sourceColumn);
	    }
	  }, {
	    key: 'isHidden',
	    value: function isHidden(columnIndex) {
	      return this.hiddenColumns[columnIndex] !== undefined;
	    }
	  }, {
	    key: 'restoreColorTo',
	    value: function restoreColorTo(colors, columnIndex) {
	      var previousColor = void 0;
	      if (this.isHidden(columnIndex)) {
	        previousColor = this.hiddenColumns[columnIndex].color;
	        delete this.hiddenColumns[columnIndex];
	      } else {
	        previousColor = this.getColumnColor(columnIndex - 1);
	      }
	      if (columnIndex) {
	        colors.push(previousColor);
	      }
	    }
	  }, {
	    key: 'togglePoints',
	    value: function togglePoints(column) {
	      var _this5 = this;
	
	      var options = this.getChartOptions();
	      var view = new window.google.visualization.DataView(this.wrapper.getDataTable());
	      var columnCount = view.getNumberOfColumns();
	      var colors = [];
	      var columns = [];
	
	      var hide = function hide(_ref2) {
	        var columnIndex = _ref2.columnIndex;
	
	        _this5.addEmptyColumnTo(columnIndex);
	        _this5.hideColumn(columnIndex);
	      };
	      var show = function show(_ref3) {
	        var columnIndex = _ref3.columnIndex;
	
	        _this5.addSourceColumnTo(columns, columnIndex);
	        _this5.restoreColorTo(colors, columnIndex);
	      };
	
	      for (var columnIndex = 0; columnIndex < columnCount; columnIndex += 1) {
	        var isHidden = this.isHidden(columnIndex);
	        // If user clicked on legend
	        if (!columnIndex) {
	          this.addSourceColumnTo(columns, columnIndex);
	        } else if (columnIndex === column) {
	          if (isHidden) {
	            show({ columnIndex: columnIndex });
	          } else {
	            hide({ columnIndex: columnIndex });
	          }
	        } else if (isHidden) {
	          hide({ columnIndex: columnIndex });
	        } else {
	          show({ columnIndex: columnIndex });
	        }
	      }
	      view.setColumns(columns);
	      options.colors = colors;
	      this.chart.draw(view, options);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props8 = this.props,
	          height = _props8.height,
	          width = _props8.width,
	          loader = _props8.loader;
	      var t = this.context.t;
	      var graphID = this.state.graphID;
	
	      var options = this.getChartOptions();
	
	      var divStyle = {
	        height: height || options.height,
	        width: width || options.width
	      };
	      return _react2.default.createElement(
	        'div',
	        { id: graphID, style: divStyle },
	        loader || t('Rendering Chart...')
	      );
	    }
	  }]);
	  return Chart;
	}(_react.Component), _class2.propTypes = {
	  allowEmptyRows: _propTypes2.default.bool,
	  chartActions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    id: _propTypes2.default.string,
	    text: _propTypes2.default.string,
	    action: _propTypes2.default.func
	  })),
	  chartEvents: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    eventName: _propTypes2.default.string,
	    callback: _propTypes2.default.func
	  })),
	  chartPackages: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  chartType: _propTypes2.default.string,
	  chartVersion: _propTypes2.default.string,
	  columns: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  data: _propTypes2.default.arrayOf(_propTypes2.default.array),
	  dateFormat: _propTypes2.default.shape({
	    columns: _propTypes2.default.arrayOf(_propTypes2.default.number),
	    options: _propTypes2.default.shape({
	      formatType: _propTypes2.default.string,
	      pattern: _propTypes2.default.string,
	      timeZone: _propTypes2.default.number
	    })
	  }),
	  diffdata: _propTypes2.default.shape({
	    on: _propTypes2.default.array,
	    off: _propTypes2.default.array
	  }),
	  graphId: _propTypes2.default.string,
	  height: _propTypes2.default.string,
	  legendToggle: _propTypes2.default.bool,
	  loadCharts: _propTypes2.default.bool,
	  loader: _propTypes2.default.node,
	  numberFormat: _propTypes2.default.shape({
	    column: _propTypes2.default.number,
	    options: _propTypes2.default.shape({
	      decimalSymbol: _propTypes2.default.string,
	      fractionDigits: _propTypes2.default.number,
	      groupingSymbol: _propTypes2.default.string,
	      negativeColor: _propTypes2.default.string,
	      negativeParens: _propTypes2.default.bool,
	      pattern: _propTypes2.default.string,
	      prefix: _propTypes2.default.string,
	      suffix: _propTypes2.default.string
	    })
	  }),
	  options: _propTypes2.default.object,
	  rows: _propTypes2.default.arrayOf(_propTypes2.default.array),
	  width: _propTypes2.default.string
	}, _class2.defaultProps = {
	  allowEmptyRows: false,
	  chartActions: null,
	  chartEvents: [],
	  chartPackages: ['corechart'],
	  chartType: 'LineChart',
	  chartVersion: 'current',
	  columns: [],
	  data: null,
	  dateFormat: null,
	  diffdata: null,
	  height: '300px',
	  legendToggle: false,
	  loadCharts: true,
	  loader: _react2.default.createElement(_Loader2.default, { alignCenter: true }),
	  numberFormat: null,
	  options: {
	    chart: {
	      title: 'Chart Title',
	      subtitle: 'Subtitle'
	    },
	    hAxis: { title: 'X Label' },
	    vAxis: { title: 'Y Label' },
	    width: '100%',
	    height: '300px'
	  },
	  rows: [],
	  width: '100%'
	}, _class2.contextTypes = {
	  getId: _propTypes2.default.func,
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onSelectToggle', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onSelectToggle'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'buildDataTableFromProps', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'buildDataTableFromProps'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateDataTable', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateDataTable'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'drawChart', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'drawChart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'addChartActions', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'addChartActions'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'listenToChartEvents', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'listenToChartEvents'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'hideColumn', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'hideColumn'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'addSourceColumnTo', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'addSourceColumnTo'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'restoreColorTo', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'restoreColorTo'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'togglePoints', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'togglePoints'), _class.prototype)), _class);
	exports.default = Chart;
	module.exports = exports['default'];

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _chartColors = __webpack_require__(513);
	
	var _chartColors2 = _interopRequireDefault(_chartColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  animation: {
	    duration: 500,
	    easing: 'out',
	    startup: true
	  },
	  legend: {
	    position: 'bottom'
	  },
	  chartArea: {
	    width: '70%',
	    top: 0,
	    left: '35%'
	  },
	  colors: _chartColors2.default,
	  annotations: {
	    alwaysOutside: true,
	    style: 'point',
	    textStyle: {
	      fontSize: 14,
	      color: '#000'
	    }
	  },
	  defaultColor: _chartColors.geographyColors[0],
	  colorAxis: {
	    colors: _chartColors.geographyColors,
	    minValue: 0
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(62);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// GoogleChartLoader Singleton
	// Based on http://blog.arkency.com/2014/09/react-dot-js-and-google-charts/
	
	var script = typeof window !== 'undefined' ? __webpack_require__(1437) : function (link, _ref) {
	  var callback = _ref.success;
	  return callback();
	};
	
	var GoogleChartLoader = function () {
	  function GoogleChartLoader() {
	    (0, _classCallCheck3.default)(this, GoogleChartLoader);
	
	    this.isLoaded = false;
	    this.isLoading = false;
	    this.initPromise = {};
	  }
	
	  (0, _createClass3.default)(GoogleChartLoader, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref2$packages = _ref2.packages,
	          packages = _ref2$packages === undefined ? ['corechart', 'bar', 'geochart'] : _ref2$packages,
	          _ref2$version = _ref2.version,
	          version = _ref2$version === undefined ? 'current' : _ref2$version,
	          mapsApiKey = _ref2.mapsApiKey;
	
	      if (this.isLoading || this.isLoaded) {
	        return this.initPromise;
	      }
	      this.isLoading = true;
	
	      this.initPromise = new _promise2.default(function (resolve) {
	        script('https://www.gstatic.com/charts/loader.js', {
	          success: function success() {
	            window.google.charts.load(version, { packages: packages, mapsApiKey: mapsApiKey });
	            window.google.charts.setOnLoadCallback(function () {
	              _this.isLoaded = true;
	              _this.isLoading = false;
	              resolve();
	            });
	          }
	        });
	      });
	
	      return this.initPromise;
	    }
	  }]);
	  return GoogleChartLoader;
	}();
	
	exports.default = new GoogleChartLoader();
	module.exports = exports['default'];

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1250);
	
	var ChartShowMore = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(ChartShowMore, _PureComponent);
	
	  function ChartShowMore() {
	    (0, _classCallCheck3.default)(this, ChartShowMore);
	    return (0, _possibleConstructorReturn3.default)(this, (ChartShowMore.__proto__ || (0, _getPrototypeOf2.default)(ChartShowMore)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ChartShowMore, [{
	    key: 'onClick',
	    value: function onClick() {
	      this.props.onClick();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          isOpen = _props.isOpen,
	          style = _props.style;
	      var t = this.context.t;
	
	
	      return _react2.default.createElement(
	        'a',
	        {
	          className: (0, _bind2.default)(styles.showMore, className),
	          style: style,
	          onClick: this.onClick
	        },
	        _react2.default.createElement(
	          'span',
	          { className: styles.text },
	          isOpen ? t('Show less') : t('Show more')
	        ),
	        _react2.default.createElement('i', { className: isOpen ? 'icon-order-up' : 'icon-order-down' })
	      );
	    }
	  }]);
	  return ChartShowMore;
	}(_react.PureComponent), _class2.propTypes = {
	  className: _propTypes2.default.string,
	  isOpen: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  style: _propTypes2.default.object
	}, _class2.contextTypes = {
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  onClick: _noop3.default,
	  style: {}
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onClick'), _class.prototype)), _class);
	exports.default = ChartShowMore;
	module.exports = exports['default'];

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _keys = __webpack_require__(113);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _toConsumableArray2 = __webpack_require__(34);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _isEmpty3 = __webpack_require__(81);
	
	var _isEmpty4 = _interopRequireDefault(_isEmpty3);
	
	var _take3 = __webpack_require__(454);
	
	var _take4 = _interopRequireDefault(_take3);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClientSideComponent = __webpack_require__(30);
	
	var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);
	
	var _reactI18next = __webpack_require__(12);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _update = __webpack_require__(501);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _index = __webpack_require__(15);
	
	var _strings = __webpack_require__(59);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _cloudConfig = __webpack_require__(820);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1255);
	
	var CloudBrowser = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(CloudBrowser, _Component);
	
	  function CloudBrowser() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, CloudBrowser);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = CloudBrowser.__proto__ || (0, _getPrototypeOf2.default)(CloudBrowser)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { selectedFiles: {} };
	    return _this;
	  }
	
	  (0, _createClass3.default)(CloudBrowser, [{
	    key: 'onSelect',
	    value: function onSelect(item, breadcrumb) {
	      if (item && !this.isAcceptableFile(item)) {
	        return false;
	      }
	
	      var onSelect = this.props.onSelect;
	
	      if (item && item.__type === 'file') {
	        var newState = void 0;
	        if (this.state.selectedFiles[item.__id]) {
	          var selectedFiles = (0, _extends3.default)({}, this.state.selectedFiles);
	          delete selectedFiles[item.__id];
	          newState = (0, _extends3.default)({}, this.state, { selectedFiles: selectedFiles });
	        } else {
	          newState = (0, _update2.default)(this.state, { selectedFiles: (0, _defineProperty3.default)({}, item.__id, { $set: item }) });
	        }
	
	        this.setState(newState);
	      }
	
	      onSelect(item, breadcrumb);
	    }
	  }, {
	    key: 'getBreadcrums',
	    value: function getBreadcrums() {
	      var pathCollection = this.props.pathCollection;
	
	      var breadcrumbs = [];
	      var pathFull = '';
	      var lastBreadcrumb = {};
	
	      pathCollection.map(function (pathItem) {
	        if (pathItem) {
	          pathFull += '/' + pathItem.name;
	          var bcCollection = [].concat((0, _toConsumableArray3.default)(pathCollection));
	
	          lastBreadcrumb = {
	            id: pathItem.id,
	            name: pathItem.name,
	            path: pathFull,
	            pathCollection: (0, _take4.default)(bcCollection, breadcrumbs.length + 1)
	          };
	          breadcrumbs.push(lastBreadcrumb);
	        }
	      });
	
	      return breadcrumbs;
	    }
	  }, {
	    key: 'unselect',
	    value: function unselect() {
	      this.setState({ selectedFiles: {} });
	    }
	  }, {
	    key: 'add',
	    value: function add() {
	      var onResult = this.props.onResult;
	      var selectedFiles = this.state.selectedFiles;
	
	      onResult(selectedFiles);
	    }
	  }, {
	    key: 'isAcceptableFile',
	    value: function isAcceptableFile(item) {
	      var fileTypes = this.props.fileTypes;
	
	      return item.__type !== 'file' || (0, _isEmpty4.default)(fileTypes) || fileTypes.indexOf(item.__ext) !== -1;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          items = _props.items,
	          error = _props.error,
	          t = _props.t,
	          onError = _props.onError,
	          onCancel = _props.onCancel,
	          processing = _props.processing,
	          service = _props.service;
	      var selectedFiles = this.state.selectedFiles;
	
	      var selectedCount = (0, _keys2.default)(selectedFiles).length;
	      var breadcrumbs = this.getBreadcrums();
	      var serviceImg = _cloudConfig.assetsIcons[service];
	      var errorText = t('An error has occurred with {{service}}. Please, try to "Reconnect"', { service: (0, _strings.capitalize)(service) });
	      var fileItemClass = function fileItemClass(item) {
	        var _classNames;
	
	        return (0, _classnames2.default)(styles.item, styles[item.__type], (_classNames = {}, (0, _defineProperty3.default)(_classNames, styles.selected, selectedFiles[item.__id]), (0, _defineProperty3.default)(_classNames, styles.inactive, !_this2.isAcceptableFile(item)), _classNames));
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.cloudBrowser },
	        _react2.default.createElement(
	          'div',
	          { className: styles.breadcrumbsContainer },
	          _react2.default.createElement(
	            'ul',
	            { className: styles.breadcrumbs },
	            breadcrumbs.map(function (bc, index) {
	              return _react2.default.createElement(
	                'li',
	                { key: bc.id, onClick: function onClick() {
	                    return _this2.onSelect(null, bc);
	                  } },
	                !index && _react2.default.createElement('img', { className: styles.serviceImg, src: serviceImg, alt: '' }),
	                ' ',
	                bc.name
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.files },
	          error && _react2.default.createElement(
	            'div',
	            { className: 'error text-center' },
	            _react2.default.createElement(
	              'div',
	              null,
	              errorText
	            ),
	            _react2.default.createElement(
	              'button',
	              { type: 'button', className: 'btn btn-primary small squared margin-top-10', onClick: onError },
	              t('Reconnect')
	            )
	          ),
	          !!items && !error && items.map(function (item) {
	            return _react2.default.createElement(
	              'div',
	              {
	                key: item.__id,
	                className: fileItemClass(item),
	                onClick: function onClick() {
	                  return _this2.onSelect(item);
	                }
	              },
	              item.__name
	            );
	          }),
	          !error && !items && _react2.default.createElement(_index.Loader, { mask: true })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.footer },
	          _react2.default.createElement(
	            'span',
	            { className: styles.selectedHint },
	            !!selectedCount && _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'vertical-middle' },
	                t('Selected'),
	                ': ',
	                selectedCount
	              ),
	              _react2.default.createElement('i', { className: (0, _classnames2.default)('icon-close', styles.unselectButton), onClick: this.unselect, title: t('Clear selection') })
	            )
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: styles.actions },
	            _react2.default.createElement(
	              'button',
	              { type: 'button', className: 'btn btn-clear small squared margin-left-10', onClick: onCancel },
	              t('Cancel')
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary small squared margin-left-10 pos-rel',
	                onClick: this.add,
	                disabled: !selectedCount || processing
	              },
	              t('Add'),
	              processing && _react2.default.createElement(_index.Loader, { mask: true, small: true })
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return CloudBrowser;
	}(_ClientSideComponent2.default), _class3.propTypes = {
	  error: _propTypes2.default.string,
	  fileTypes: _propTypes2.default.array,
	  items: _propTypes2.default.array,
	  onCancel: _propTypes2.default.func,
	  onError: _propTypes2.default.func,
	  onResult: _propTypes2.default.func,
	  onSelect: _propTypes2.default.func,
	  pathCollection: _propTypes2.default.array,
	  processing: _propTypes2.default.bool,
	  service: _propTypes2.default.string,
	  t: _propTypes2.default.func
	}, _class3.defaultProps = {
	  onCancel: function onCancel() {},
	  onError: function onError() {},
	  onResult: function onResult() {},
	  onSelect: function onSelect() {}
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'unselect', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'unselect'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'add', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'add'), _class2.prototype)), _class2)) || _class);
	exports.default = CloudBrowser;
	module.exports = exports['default'];

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClientSideComponent = __webpack_require__(30);
	
	var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactI18next = __webpack_require__(12);
	
	var _auth = __webpack_require__(31);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _index = __webpack_require__(15);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var CloudConnectButton = (_dec = (0, _reactRedux.connect)(null, { setBoxToken: _auth.setBoxToken, deleteBoxToken: _auth.deleteBoxToken }), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(CloudConnectButton, _Component);
	
	  function CloudConnectButton() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, CloudConnectButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = CloudConnectButton.__proto__ || (0, _getPrototypeOf2.default)(CloudConnectButton)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { processing: false };
	    return _this;
	  }
	
	  (0, _createClass3.default)(CloudConnectButton, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.accessToken && !this.props.isConnected) {
	        this.onGetToken(nextProps.accessToken);
	      }
	    }
	  }, {
	    key: 'onGetToken',
	    value: function onGetToken(accessToken) {
	      var _this2 = this;
	
	      if (this.state.processing) {
	        return false;
	      }
	
	      this.setProcessing(true);
	      this.props.setBoxToken(this.props.service, accessToken).promise.then(function () {
	        return _this2.setProcessing(false);
	      }).catch(function () {
	        return _this2.setProcessing(false);
	      });
	    }
	  }, {
	    key: 'setProcessing',
	    value: function setProcessing(processing) {
	      if (this.state.isMounted) {
	        this.setState({ processing: processing });
	      }
	    }
	  }, {
	    key: 'disconnect',
	    value: function disconnect() {
	      var _this3 = this;
	
	      this.setProcessing(true);
	      this.props.deleteBoxToken(this.props.service).promise.then(function () {
	        return _this3.setProcessing(false);
	      }).catch(function () {
	        return _this3.setProcessing(false);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          t = _props.t,
	          isConnected = _props.isConnected,
	          connectClassName = _props.connectClassName,
	          disconnectClassName = _props.disconnectClassName;
	      var processing = this.state.processing;
	
	      var renderLoader = processing && _react2.default.createElement(_index.Loader, { small: true, mask: true });
	
	      return !isConnected ? _react2.default.createElement(
	        'button',
	        { type: 'button', className: (0, _classnames2.default)(connectClassName, 'pos-rel'), onClick: this.props.connect, disabled: processing },
	        t('Connect'),
	        renderLoader
	      ) : _react2.default.createElement(
	        'button',
	        { type: 'button', className: (0, _classnames2.default)(disconnectClassName, 'pos-rel'), onClick: this.disconnect, disabled: processing },
	        t('Disconnect'),
	        renderLoader
	      );
	    }
	  }]);
	  return CloudConnectButton;
	}(_ClientSideComponent2.default), _class3.propTypes = {
	  accessToken: _propTypes2.default.string,
	  connect: _propTypes2.default.func,
	  connectClassName: _propTypes2.default.string,
	  deleteBoxToken: _propTypes2.default.func,
	  disconnectClassName: _propTypes2.default.string,
	  isConnected: _propTypes2.default.bool,
	  service: _propTypes2.default.string,
	  setBoxToken: _propTypes2.default.func,
	  t: _propTypes2.default.func
	}, _class3.defaultProps = {
	  connectClassName: 'btn btn-primary btn-stroke squared wide small',
	  disconnectClassName: 'btn btn-accent btn-stroke squared wide small'
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'disconnect', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'disconnect'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = CloudConnectButton;
	module.exports = exports['default'];

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _index = __webpack_require__(15);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var uploaderStyles = __webpack_require__(147);
	
	var CloudUploadStatusIcon = (_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(CloudUploadStatusIcon, _Component);
	
	  function CloudUploadStatusIcon() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, CloudUploadStatusIcon);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = CloudUploadStatusIcon.__proto__ || (0, _getPrototypeOf2.default)(CloudUploadStatusIcon)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { processingStatus: false };
	    return _this;
	  }
	
	  (0, _createClass3.default)(CloudUploadStatusIcon, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unmounted = true;
	    }
	  }, {
	    key: 'setProcessing',
	    value: function setProcessing(val) {
	      if (!this.unmounted) {
	        this.setState({ processingStatus: val });
	      }
	    }
	  }, {
	    key: 'deleteFile',
	    value: function deleteFile() {
	      var _this2 = this;
	
	      var onDelete = this.props.onDelete;
	
	      this.setProcessing(true);
	      onDelete().then(function () {
	        return _this2.setProcessing(false);
	      }).catch(function () {
	        return _this2.setProcessing(false);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          deletable = _props.deletable,
	          status = _props.status;
	      var processingStatus = this.state.processingStatus;
	
	      var renderRes = null;
	
	      if (!status || processingStatus) {
	        renderRes = _react2.default.createElement(_index.Loader, { size: 16 });
	      } else if (status === 'success') {
	        renderRes = deletable ? _react2.default.createElement('i', { className: (0, _bind2.default)('statusIcon', className, uploaderStyles.statusIcon, 'icon-close colorError'), onClick: this.deleteFile }) : _react2.default.createElement('i', { className: (0, _bind2.default)('statusIcon', className, uploaderStyles.statusIcon, 'icon-check colorSuccess') });
	      } else {
	        renderRes = _react2.default.createElement('i', { className: (0, _bind2.default)('statusIcon', className, uploaderStyles.statusIcon, 'icon-warning colorError') });
	      }
	
	      return _react2.default.createElement(
	        'span',
	        { className: (0, _bind2.default)('statusIconContainer', uploaderStyles.statusIconContainer) },
	        renderRes
	      );
	    }
	  }]);
	  return CloudUploadStatusIcon;
	}(_react.Component), _class2.propTypes = {
	  className: _propTypes2.default.string,
	  deletable: _propTypes2.default.bool,
	  onDelete: _propTypes2.default.func,
	  status: _propTypes2.default.string
	}, _class2.defaultProps = {
	  onDelete: function onDelete() {}
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'deleteFile', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'deleteFile'), _class.prototype)), _class);
	exports.default = CloudUploadStatusIcon;
	module.exports = exports['default'];

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get3 = __webpack_require__(19);
	
	var _get4 = _interopRequireDefault(_get3);
	
	var _isEmpty3 = __webpack_require__(81);
	
	var _isEmpty4 = _interopRequireDefault(_isEmpty3);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _cloud = __webpack_require__(216);
	
	var cloudActions = _interopRequireWildcard(_cloud);
	
	var _project = __webpack_require__(37);
	
	var projectActions = _interopRequireWildcard(_project);
	
	var _index = __webpack_require__(15);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var CloudUploader = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    submittedCloudFiles: state.project.submittedCloudFiles
	  };
	}, (0, _extends3.default)({}, cloudActions, projectActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(CloudUploader, _Component);
	
	  function CloudUploader() {
	    (0, _classCallCheck3.default)(this, CloudUploader);
	    return (0, _possibleConstructorReturn3.default)(this, (CloudUploader.__proto__ || (0, _getPrototypeOf2.default)(CloudUploader)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CloudUploader, [{
	    key: 'onAddFromCloud',
	    value: function onAddFromCloud(files) {
	      var _props = this.props,
	          uploadFromCloud = _props.uploadFromCloud,
	          submitCloudFile = _props.submitCloudFile,
	          projectId = _props.projectId,
	          setCloudFileSuccessStatus = _props.setCloudFileSuccessStatus,
	          setCloudFileFailedStatus = _props.setCloudFileFailedStatus,
	          addFailedMedia = _props.addFailedMedia,
	          onCloudUpload = _props.onCloudUpload,
	          setCloudFileMetadata = _props.setCloudFileMetadata,
	          part = _props.part;
	
	      if ((0, _isEmpty4.default)(files)) {
	        return false;
	      }
	
	      files.map(function (file) {
	        submitCloudFile((0, _extends3.default)({}, file));
	        uploadFromCloud((0, _extends3.default)({ projectId: projectId, part: part }, file)).promise.then(function (resp) {
	          var cloudFile = (0, _get4.default)(resp.data, [0]);
	          setCloudFileMetadata({ uniqId: file.uniqId, metadata: cloudFile });
	          onCloudUpload(cloudFile);
	          return setCloudFileSuccessStatus(file.uniqId);
	        }).catch(function () {
	          addFailedMedia((0, _extends3.default)({}, file), projectId);
	          return setCloudFileFailedStatus(file.uniqId);
	        });
	      });
	    }
	  }, {
	    key: 'onUploadFromCloud',
	    value: function onUploadFromCloud(file) {
	      var onCloudUpload = this.props.onCloudUpload;
	
	      onCloudUpload(file);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          projectId = _props2.projectId,
	          fileTypes = _props2.fileTypes,
	          disabled = _props2.disabled;
	
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(_index.DropboxPopup, { onAdd: this.onAddFromCloud, fileTypes: fileTypes, disabled: disabled }),
	        _react2.default.createElement(_index.BoxcomPopup, { projectId: projectId, onUpload: this.onUploadFromCloud, fileTypes: fileTypes, disabled: disabled })
	      );
	    }
	  }]);
	  return CloudUploader;
	}(_react.Component), _class3.propTypes = {
	  addFailedMedia: _propTypes2.default.func,
	  disabled: _propTypes2.default.bool,
	  fileTypes: _propTypes2.default.array,
	  onCloudUpload: _propTypes2.default.func,
	  part: _propTypes2.default.number,
	  projectId: _propTypes2.default.number,
	  setCloudFileFailedStatus: _propTypes2.default.func,
	  setCloudFileMetadata: _propTypes2.default.func,
	  setCloudFileSuccessStatus: _propTypes2.default.func,
	  submitCloudFile: _propTypes2.default.func,
	  uploadFromCloud: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onAddFromCloud', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onAddFromCloud'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onUploadFromCloud', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onUploadFromCloud'), _class2.prototype)), _class2)) || _class);
	exports.default = CloudUploader;
	module.exports = exports['default'];

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _index = __webpack_require__(15);
	
	var _files = __webpack_require__(869);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _cloudConfig = __webpack_require__(820);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var uploaderStyles = __webpack_require__(147);
	
	var CloudUploaderItem = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(CloudUploaderItem, _Component);
	
	  function CloudUploaderItem() {
	    (0, _classCallCheck3.default)(this, CloudUploaderItem);
	    return (0, _possibleConstructorReturn3.default)(this, (CloudUploaderItem.__proto__ || (0, _getPrototypeOf2.default)(CloudUploaderItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CloudUploaderItem, [{
	    key: 'uploaderThumbNode',
	    value: function uploaderThumbNode() {
	      var cloudFile = this.props.cloudFile;
	
	      return (0, _files.getFileExtention)(cloudFile.name);
	    }
	  }, {
	    key: 'fileExtNode',
	    value: function fileExtNode() {
	      var cloudFile = this.props.cloudFile;
	
	      return (0, _files.getFileExtention)(cloudFile.name);
	    }
	  }, {
	    key: 'fileNameNode',
	    value: function fileNameNode() {
	      var cloudFile = this.props.cloudFile;
	
	      return cloudFile.name;
	    }
	  }, {
	    key: 'uploadStatusNode',
	    value: function uploadStatusNode() {
	      var cloudFile = this.props.cloudFile;
	
	      var serviceImg = _cloudConfig.assetsIcons[cloudFile.service];
	      return _react2.default.createElement('img', { className: 'serviceImg', src: serviceImg, alt: '' });
	    }
	  }, {
	    key: 'fileSizeNode',
	    value: function fileSizeNode() {
	      var cloudFile = this.props.cloudFile;
	
	      return _react2.default.createElement(_index.FileSize, { size: cloudFile.size });
	    }
	  }, {
	    key: 'progressBarNode',
	    value: function progressBarNode() {
	      var _classNames;
	
	      var cloudFile = this.props.cloudFile;
	
	      var progressClass = (0, _classnames2.default)(uploaderStyles.progress, (_classNames = {}, (0, _defineProperty3.default)(_classNames, uploaderStyles.isSuccess, cloudFile.status === 'success'), (0, _defineProperty3.default)(_classNames, uploaderStyles.isFailed, cloudFile.status === 'failed'), _classNames));
	
	      var progressBarClass = (0, _classnames2.default)('progressBar', uploaderStyles.progressBar, uploaderStyles.file);
	      return _react2.default.createElement(
	        'div',
	        { className: progressBarClass },
	        _react2.default.createElement('s', { className: progressClass, style: { width: '100%' } })
	      );
	    }
	  }, {
	    key: 'uploadStatusIconNode',
	    value: function uploadStatusIconNode() {
	      var _props = this.props,
	          deletable = _props.deletable,
	          onDelete = _props.onDelete,
	          cloudFile = _props.cloudFile;
	
	      return _react2.default.createElement(_index.CloudUploadStatusIcon, {
	        className: uploaderStyles.statusIcon,
	        status: cloudFile.status,
	        deletable: deletable,
	        onDelete: onDelete
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          showOnSuccess = _props2.showOnSuccess,
	          cloudFile = _props2.cloudFile;
	
	      var hidden = !showOnSuccess && cloudFile.status === 'success';
	
	      return _react2.default.createElement(_index.UniversalUploaderItem, {
	        className: (0, _classnames2.default)(className, { hidden: hidden }),
	        fileExtNode: this.fileExtNode(),
	        fileNameNode: this.fileNameNode(),
	        uploadStatusNode: this.uploadStatusNode(),
	        fileSizeNode: this.fileSizeNode(),
	        progressBarNode: this.progressBarNode(),
	        uploadStatusIconNode: this.uploadStatusIconNode(),
	        uploaderThumbNode: this.uploaderThumbNode()
	      });
	    }
	  }]);
	  return CloudUploaderItem;
	}(_react.Component), _class.propTypes = {
	  className: _propTypes2.default.string,
	  cloudFile: _propTypes2.default.object,
	  deletable: _propTypes2.default.bool,
	  onDelete: _propTypes2.default.func,
	  showOnSuccess: _propTypes2.default.bool
	}, _temp);
	exports.default = CloudUploaderItem;
	module.exports = exports['default'];

/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _contacts = __webpack_require__(61);
	
	var _components = __webpack_require__(15);
	
	var _ImportRecipientsCSVButton = __webpack_require__(827);
	
	var _ImportRecipientsCSVButton2 = _interopRequireDefault(_ImportRecipientsCSVButton);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1256);
	
	var ContactsImportButton = (_dec = (0, _reactRedux.connect)(null, { addContacts: _contacts.addContacts }), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(ContactsImportButton, _Component);
	
	  function ContactsImportButton() {
	    (0, _classCallCheck3.default)(this, ContactsImportButton);
	    return (0, _possibleConstructorReturn3.default)(this, (ContactsImportButton.__proto__ || (0, _getPrototypeOf2.default)(ContactsImportButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ContactsImportButton, [{
	    key: 'onImportRecipients',
	    value: function onImportRecipients(_ref) {
	      var data = _ref.data;
	      var _props = this.props,
	          onImport = _props.onImport,
	          groupId = _props.groupId;
	
	      this.props.addContacts(groupId, data);
	      onImport(groupId, data);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          groupId = _props2.groupId,
	          hintBefore = _props2.hintBefore;
	
	      var importContactParams = { queryParams: { groupId: groupId }, endpoint: '/api/contacts_wa/addContactsCSV' };
	
	      return _react2.default.createElement(
	        'span',
	        { className: (0, _bind2.default)(styles.container, (0, _defineProperty3.default)({}, styles.reverse, hintBefore)) },
	        _react2.default.createElement(_ImportRecipientsCSVButton2.default, {
	          uploaderParams: importContactParams,
	          onImport: this.onImportRecipients
	        }),
	        _react2.default.createElement(_components.CsvHint, { className: styles.hint })
	      );
	    }
	  }]);
	  return ContactsImportButton;
	}(_react.Component), _class3.propTypes = {
	  addContacts: _propTypes2.default.func,
	  groupId: _propTypes2.default.number,
	  hintBefore: _propTypes2.default.bool,
	  onImport: _propTypes2.default.func
	}, _class3.defaultProps = {
	  groupId: 0,
	  onImport: _noop3.default
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onImportRecipients', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onImportRecipients'), _class2.prototype)), _class2)) || _class);
	exports.default = ContactsImportButton;
	module.exports = exports['default'];

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _contacts = __webpack_require__(61);
	
	var contactsActions = _interopRequireWildcard(_contacts);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _strings = __webpack_require__(59);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _SearchBar = __webpack_require__(183);
	
	var _SearchBar2 = _interopRequireDefault(_SearchBar);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var ContactsList = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    contactsCount: state.contacts.contactsListData.contactsNb,
	    contactsCurrentPage: state.contacts.contactsListActionData.page,
	    contactsList: state.contacts.contactsListData.contacts,
	    contactsListLimit: state.contacts.contactsListLimit,
	    contactsListLoading: state.contacts.contactsListLoading,
	    contactsListPage: state.contacts.contactsListPage,
	    contactsListPaginateBy: state.contacts.contactsListPaginateBy,
	    deleteContactActionData: state.contacts.deleteContactActionData,
	    deleteContactLoading: state.contacts.deleteContactLoading,
	    kw: state.contacts.kw
	  };
	}, (0, _extends3.default)({}, contactsActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(ContactsList, _Component);
	
	  function ContactsList() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, ContactsList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = ContactsList.__proto__ || (0, _getPrototypeOf2.default)(ContactsList)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { cachedCount: 0 };
	    return _this;
	  }
	
	  (0, _createClass3.default)(ContactsList, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var contactsCount = this.props.contactsCount;
	
	      if (typeof nextProps.contactsCount === 'undefined' && contactsCount) {
	        this.setState({ cachedCount: contactsCount });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.filter('');
	    }
	  }, {
	    key: 'setLimit',
	    value: function setLimit(limit) {
	      this.props.setContactsListLimit(Number(limit));
	    }
	  }, {
	    key: 'deleteContact',
	    value: function deleteContact(contact) {
	      var _props = this.props,
	          deleteContact = _props.deleteContact,
	          t = _props.t,
	          onDelete = _props.onDelete;
	
	      var toastrConfirmOptions = {
	        onOk: function onOk() {
	          deleteContact(contact.id).promise.then(onDelete);
	        },
	        onCancel: function onCancel() {}
	      };
	      _toastr2.default.confirm(t('Are you sure you want to delete this contact?'), toastrConfirmOptions);
	    }
	  }, {
	    key: 'loadContactsPage',
	    value: function loadContactsPage(_ref2) {
	      var page = _ref2.page,
	          limit = _ref2.limit;
	      var _props2 = this.props,
	          loadContacts = _props2.loadContacts,
	          kw = _props2.kw;
	
	      loadContacts({ page: page, limit: limit, kw: kw });
	    }
	  }, {
	    key: 'filter',
	    value: function filter(kw) {
	      var _props3 = this.props,
	          contactsListLimit = _props3.contactsListLimit,
	          contactsListPage = _props3.contactsListPage,
	          loadContacts = _props3.loadContacts;
	
	      loadContacts({ page: contactsListPage, limit: contactsListLimit, kw: kw });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          t = _props4.t,
	          contactsList = _props4.contactsList,
	          deleteContactLoading = _props4.deleteContactLoading,
	          deleteContactActionData = _props4.deleteContactActionData,
	          contactsListLoading = _props4.contactsListLoading,
	          limit = _props4.limit,
	          kw = _props4.kw,
	          contactsCurrentPage = _props4.contactsCurrentPage,
	          contactsCount = _props4.contactsCount,
	          contactsListPaginateBy = _props4.contactsListPaginateBy,
	          contactsListLimit = _props4.contactsListLimit;
	      var cachedCount = this.state.cachedCount;
	
	      var count = typeof contactsCount === 'undefined' ? cachedCount : contactsCount;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_SearchBar2.default, {
	          delay: 600,
	          className: 'margin-vert-20',
	          kw: kw,
	          onChange: this.filter
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'pos-rel' },
	          _react2.default.createElement(
	            _components.List,
	            null,
	            _react2.default.createElement(
	              _components.ListItem,
	              { fullWidth: true, isTitle: true },
	              _react2.default.createElement(
	                'div',
	                null,
	                t('Email')
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                t('Name')
	              ),
	              _react2.default.createElement('div', null)
	            ),
	            contactsList.map(function (contact) {
	              return _react2.default.createElement(
	                _components.ListItem,
	                { fullWidth: true, key: contact.id },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'break-word' },
	                  contact.email
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'break-word' },
	                  (0, _strings.concat)(' ', contact.name, contact.surname)
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'moreCell' },
	                  _react2.default.createElement('i', { className: 'more', onClick: function onClick(e) {
	                      return _this2.contactPopover.toggle(e, contact);
	                    } }),
	                  deleteContactLoading && deleteContactActionData.contactId === contact.id && _react2.default.createElement(_components.Loader, { small: true, mask: true })
	                )
	              );
	            })
	          ),
	          contactsListLoading && _react2.default.createElement(_components.Loader, { mask: true })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'margin-top-20' },
	          _react2.default.createElement(
	            'div',
	            { className: 'pull-left padding-right-10 margin-bottom-10 nowrap' },
	            _react2.default.createElement(
	              'span',
	              { className: 'margin-right-5' },
	              t('View by'),
	              ':'
	            ),
	            _react2.default.createElement(
	              'select',
	              { value: contactsListLimit, onChange: function onChange(e) {
	                  return _this2.setLimit(e.target.value);
	                } },
	              contactsListPaginateBy.map(function (val) {
	                return _react2.default.createElement(
	                  'option',
	                  { key: val, value: val },
	                  val
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(_components.Pagination, {
	            className: 'pull-right text-right',
	            page: contactsCurrentPage || 1,
	            count: count,
	            limit: limit,
	            onChange: this.loadContactsPage
	          })
	        ),
	        _react2.default.createElement(
	          _components.PopoverMenu,
	          { id: 'contactPopover', ref: function ref(el) {
	              return _this2.contactPopover = el;
	            } },
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.deleteContact(_this2.contactPopover.data);
	              } },
	            t('Delete'),
	            _react2.default.createElement('i', { className: 'icon-delete' })
	          )
	        )
	      );
	    }
	  }]);
	  return ContactsList;
	}(_react.Component), _class3.propTypes = {
	  contactsCount: _propTypes2.default.number,
	  contactsCurrentPage: _propTypes2.default.number,
	  contactsList: _propTypes2.default.array,
	  contactsListLimit: _propTypes2.default.number,
	  contactsListLoading: _propTypes2.default.bool,
	  contactsListPage: _propTypes2.default.number,
	  contactsListPaginateBy: _propTypes2.default.array,
	  deleteContact: _propTypes2.default.func,
	  deleteContactActionData: _propTypes2.default.object,
	  deleteContactLoading: _propTypes2.default.bool,
	  filter: _propTypes2.default.func,
	  kw: _propTypes2.default.string,
	  limit: _propTypes2.default.number.isRequired,
	  loadContacts: _propTypes2.default.func,
	  onDelete: _propTypes2.default.func,
	  setContactsListLimit: _propTypes2.default.func,
	  t: _propTypes2.default.func
	}, _class3.defaultProps = {
	  onDelete: function onDelete() {}
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'loadContactsPage', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'loadContactsPage'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'filter', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'filter'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = ContactsList;
	module.exports = exports['default'];

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _Popover = __webpack_require__(831);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hintImg = __webpack_require__(2267);
	
	var CsvHint = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(CsvHint, _Component);
	
	  function CsvHint() {
	    (0, _classCallCheck3.default)(this, CsvHint);
	    return (0, _possibleConstructorReturn3.default)(this, (CsvHint.__proto__ || (0, _getPrototypeOf2.default)(CsvHint)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CsvHint, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          t = _props.t,
	          className = _props.className;
	
	      var overlay = _react2.default.createElement(
	        'div',
	        { className: 'padding-5' },
	        _react2.default.createElement(
	          'span',
	          null,
	          t('Only CSV files can be uploaded. The CSV file must contain 3 columns:')
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'bold margin-left-5' },
	          'Name, Surname, Email'
	        ),
	        '.',
	        _react2.default.createElement(
	          'span',
	          { className: 'margin-left-5' },
	          t('Each column header must be configured as per this example.')
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('img', { src: hintImg, className: 'max-width-100', alt: '' })
	        )
	      );
	
	      return _react2.default.createElement(
	        'span',
	        { className: className },
	        _react2.default.createElement(
	          _Popover2.default,
	          { overlay: overlay },
	          _react2.default.createElement(_Button2.default, { className: 'btn-stroke small icon-info' })
	        )
	      );
	    }
	  }]);
	  return CsvHint;
	}(_react.Component), _class2.propTypes = {
	  className: _propTypes2.default.string,
	  t: _propTypes2.default.func
	}, _temp)) || _class);
	exports.default = CsvHint;
	module.exports = exports['default'];

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _contacts = __webpack_require__(61);
	
	var contactsActions = _interopRequireWildcard(_contacts);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _reactRouterRedux = __webpack_require__(40);
	
	var _utils = __webpack_require__(24);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GroupsList = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    groupsList: state.contacts.groupsListData,
	    groupsListLoading: state.contacts.groupsListLoading,
	    deleteGroupLoading: state.contacts.deleteGroupLoading,
	    deleteGroupActionData: state.contacts.deleteGroupActionData
	  };
	}, (0, _extends3.default)({}, contactsActions, { pushState: _reactRouterRedux.push })), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(GroupsList, _Component);
	
	  function GroupsList() {
	    (0, _classCallCheck3.default)(this, GroupsList);
	    return (0, _possibleConstructorReturn3.default)(this, (GroupsList.__proto__ || (0, _getPrototypeOf2.default)(GroupsList)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(GroupsList, [{
	    key: 'gotoGroup',
	    value: function gotoGroup(e, group) {
	      (0, _utils.stopEvent)(e);
	      this.props.pushState('/contacts/groups/' + group.id);
	    }
	  }, {
	    key: 'deleteGroup',
	    value: function deleteGroup(group) {
	      var _props = this.props,
	          deleteGroup = _props.deleteGroup,
	          t = _props.t;
	
	      var toastrConfirmOptions = {
	        onOk: function onOk() {
	          return deleteGroup(group.id);
	        },
	        onCancel: function onCancel() {}
	      };
	      _toastr2.default.confirm(t('Are you sure you want to delete this group?'), toastrConfirmOptions);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          t = _props2.t,
	          groupsList = _props2.groupsList,
	          deleteGroupLoading = _props2.deleteGroupLoading,
	          deleteGroupActionData = _props2.deleteGroupActionData,
	          groupsListLoading = _props2.groupsListLoading;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _components.List,
	          null,
	          _react2.default.createElement(
	            _components.ListItem,
	            { fullWidth: true, isTitle: true },
	            _react2.default.createElement(
	              'div',
	              null,
	              t('Group Name')
	            ),
	            _react2.default.createElement('div', null)
	          ),
	          groupsList.map(function (group) {
	            return _react2.default.createElement(
	              _components.ListItem,
	              { fullWidth: true, key: group.id, onClick: function onClick(e) {
	                  return _this2.gotoGroup(e, group);
	                }, className: 'cursor-pointer' },
	              _react2.default.createElement(
	                'div',
	                null,
	                group.name
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'moreCell' },
	                _react2.default.createElement('i', { className: 'more', onClick: function onClick(e) {
	                    return _this2.groupPopover.toggle(e, group);
	                  } }),
	                deleteGroupLoading && deleteGroupActionData.groupId === group.id && _react2.default.createElement(_components.Loader, { small: true, mask: true })
	              )
	            );
	          })
	        ),
	        groupsListLoading && _react2.default.createElement(_components.Loader, null),
	        _react2.default.createElement(
	          _components.PopoverMenu,
	          { id: 'groupPopover', ref: function ref(el) {
	              return _this2.groupPopover = el;
	            } },
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick(e) {
	                return _this2.gotoGroup(e, _this2.groupPopover.data);
	              } },
	            t('Edit'),
	            _react2.default.createElement('i', { className: 'icon-mode-edit' })
	          ),
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.deleteGroup(_this2.groupPopover.data);
	              } },
	            t('Delete'),
	            _react2.default.createElement('i', { className: 'icon-delete' })
	          )
	        )
	      );
	    }
	  }]);
	  return GroupsList;
	}(_react.Component), _class2.propTypes = {
	  deleteGroup: _propTypes2.default.func,
	  deleteGroupActionData: _propTypes2.default.object,
	  deleteGroupLoading: _propTypes2.default.bool,
	  groupsList: _propTypes2.default.array,
	  groupsListLoading: _propTypes2.default.bool,
	  pushState: _propTypes2.default.func,
	  t: _propTypes2.default.func
	}, _temp)) || _class) || _class);
	exports.default = GroupsList;
	module.exports = exports['default'];

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactRouterRedux = __webpack_require__(40);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1257);
	
	var ManageLink = (_dec = (0, _reactRedux.connect)(null, { pushState: _reactRouterRedux.push }), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(ManageLink, _Component);
	
	  function ManageLink() {
	    (0, _classCallCheck3.default)(this, ManageLink);
	    return (0, _possibleConstructorReturn3.default)(this, (ManageLink.__proto__ || (0, _getPrototypeOf2.default)(ManageLink)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ManageLink, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          pushState = _props.pushState,
	          isBack = _props.isBack,
	          link = _props.link,
	          text = _props.text,
	          header = _props.header;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(className, styles.manageGroupsSection, (0, _defineProperty3.default)({}, styles.isBack, isBack)), onClick: function onClick() {
	            return pushState(link);
	          } },
	        _react2.default.createElement(
	          'h3',
	          { className: 'margin-free' },
	          header
	        ),
	        !!text && _react2.default.createElement(
	          'div',
	          { className: 'margin-top-10' },
	          text
	        ),
	        _react2.default.createElement('i', { className: (0, _classnames2.default)(styles.arrow, isBack ? 'icon-chevron-thin-left' : 'icon-chevron-thin-right') })
	      );
	    }
	  }]);
	  return ManageLink;
	}(_react.Component), _class2.propTypes = {
	  className: _propTypes2.default.string,
	  header: _propTypes2.default.string.isRequired,
	  isBack: _propTypes2.default.bool,
	  link: _propTypes2.default.string.isRequired,
	  pushState: _propTypes2.default.func,
	  text: _propTypes2.default.string
	}, _temp)) || _class);
	exports.default = ManageLink;
	module.exports = exports['default'];

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends3 = __webpack_require__(8);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _invertBy3 = __webpack_require__(132);
	
	var _invertBy4 = _interopRequireDefault(_invertBy3);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _contacts = __webpack_require__(61);
	
	var contactsActions = _interopRequireWildcard(_contacts);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	var _strings = __webpack_require__(59);
	
	var _utils = __webpack_require__(24);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var SelectContactsList = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    contactsList: state.contacts.contactsListData.contacts,
	    contactsListLoading: state.contacts.contactsListLoading,
	    contactsListLoaded: state.contacts.contactsListLoaded
	  };
	}, (0, _extends4.default)({}, contactsActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(SelectContactsList, _Component);
	
	  function SelectContactsList() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, SelectContactsList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = SelectContactsList.__proto__ || (0, _getPrototypeOf2.default)(SelectContactsList)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { checkedContacts: {} };
	    return _this;
	  }
	
	  (0, _createClass3.default)(SelectContactsList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.loadContacts();
	    }
	  }, {
	    key: 'toggleContactChecked',
	    value: function toggleContactChecked(e, id) {
	      this.setState({
	        checkedContacts: (0, _extends4.default)({}, this.state.checkedContacts, (0, _defineProperty3.default)({}, id, !this.state.checkedContacts[id]))
	      });
	    }
	  }, {
	    key: 'select',
	    value: function select() {
	      var onSelect = this.props.onSelect;
	
	      var _ref2 = this.state || {},
	          checkedContacts = _ref2.checkedContacts;
	
	      var checkedContactsArr = (0, _invertBy4.default)(checkedContacts).true || []; // eslint-disable-line dot-notation
	      onSelect(checkedContactsArr);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          t = _props.t,
	          contactsList = _props.contactsList,
	          contactsListLoading = _props.contactsListLoading,
	          contactsListLoaded = _props.contactsListLoaded;
	      var checkedContacts = this.state.checkedContacts;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _components.List,
	          null,
	          _react2.default.createElement(
	            _components.ListItem,
	            { fullWidth: true, isTitle: true },
	            _react2.default.createElement(
	              'div',
	              null,
	              t('Email')
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              t('Name')
	            ),
	            _react2.default.createElement('div', null)
	          ),
	          contactsList.map(function (contact) {
	            return _react2.default.createElement(
	              _components.ListItem,
	              { fullWidth: true, key: contact.id, onClick: function onClick(e) {
	                  return _this2.toggleContactChecked(e, contact.id);
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'break-word' },
	                contact.email
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'break-word' },
	                (0, _strings.concat)(' ', contact.name, contact.surname)
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'text-center' },
	                _react2.default.createElement(_components.Checkbox, {
	                  className: 'padding-5 inline',
	                  checked: checkedContacts[contact.id],
	                  onClick: _utils.stopEvent
	                })
	              )
	            );
	          })
	        ),
	        contactsListLoading && _react2.default.createElement(_components.Loader, null),
	        contactsListLoaded && _react2.default.createElement(
	          'div',
	          { className: 'text-right margin-top-20' },
	          _react2.default.createElement(
	            'button',
	            { type: 'button', className: 'btn btn-primary wide', onClick: this.select },
	            t('Ok')
	          )
	        )
	      );
	    }
	  }]);
	  return SelectContactsList;
	}(_react.Component), _class3.propTypes = {
	  contactsList: _propTypes2.default.array,
	  contactsListLoaded: _propTypes2.default.bool,
	  contactsListLoading: _propTypes2.default.bool,
	  loadContacts: _propTypes2.default.func,
	  onSelect: _propTypes2.default.func.isRequired,
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'select', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'select'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = SelectContactsList;
	module.exports = exports['default'];

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends3 = __webpack_require__(8);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _invertBy3 = __webpack_require__(132);
	
	var _invertBy4 = _interopRequireDefault(_invertBy3);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _contacts = __webpack_require__(61);
	
	var contactsActions = _interopRequireWildcard(_contacts);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	var _utils = __webpack_require__(24);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var SelectGroupsList = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    groupsList: state.contacts.groupsListData,
	    groupsListLoading: state.contacts.groupsListLoading,
	    groupsListLoaded: state.contacts.groupsListLoaded
	  };
	}, (0, _extends4.default)({}, contactsActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(SelectGroupsList, _Component);
	
	  function SelectGroupsList() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, SelectGroupsList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = SelectGroupsList.__proto__ || (0, _getPrototypeOf2.default)(SelectGroupsList)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { checkedGroups: {} };
	    return _this;
	  }
	
	  (0, _createClass3.default)(SelectGroupsList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.loadGroups();
	    }
	  }, {
	    key: 'toggleGroupChecked',
	    value: function toggleGroupChecked(e, id) {
	      this.setState({
	        checkedGroups: (0, _extends4.default)({}, this.state.checkedGroups, (0, _defineProperty3.default)({}, id, !this.state.checkedGroups[id]))
	      });
	    }
	  }, {
	    key: 'select',
	    value: function select() {
	      var onSelect = this.props.onSelect;
	
	      var _ref2 = this.state || {},
	          checkedGroups = _ref2.checkedGroups;
	
	      var checkedGroupsArr = (0, _invertBy4.default)(checkedGroups).true || []; // eslint-disable-line dot-notation
	      onSelect(checkedGroupsArr);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          t = _props.t,
	          groupsList = _props.groupsList,
	          groupsListLoading = _props.groupsListLoading,
	          groupsListLoaded = _props.groupsListLoaded;
	      var checkedGroups = this.state.checkedGroups;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _components.List,
	          null,
	          _react2.default.createElement(
	            _components.ListItem,
	            { fullWidth: true, isTitle: true },
	            _react2.default.createElement(
	              'div',
	              null,
	              t('Group Name')
	            ),
	            _react2.default.createElement('div', null)
	          ),
	          groupsList.map(function (group) {
	            return _react2.default.createElement(
	              _components.ListItem,
	              { fullWidth: true, key: group.id, onClick: function onClick(e) {
	                  return _this2.toggleGroupChecked(e, group.id);
	                } },
	              _react2.default.createElement(
	                'div',
	                null,
	                group.name
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'text-center' },
	                _react2.default.createElement(_components.Checkbox, {
	                  className: 'padding-5 inline',
	                  checked: checkedGroups[group.id],
	                  onClick: _utils.stopEvent
	                })
	              )
	            );
	          })
	        ),
	        groupsListLoading && _react2.default.createElement(_components.Loader, null),
	        groupsListLoaded && _react2.default.createElement(
	          'div',
	          { className: 'text-right margin-top-20' },
	          _react2.default.createElement(
	            'button',
	            { type: 'button', className: 'btn btn-primary wide', onClick: this.select },
	            t('Ok')
	          )
	        )
	      );
	    }
	  }]);
	  return SelectGroupsList;
	}(_react.Component), _class3.propTypes = {
	  groupsList: _propTypes2.default.array,
	  groupsListLoaded: _propTypes2.default.bool,
	  groupsListLoading: _propTypes2.default.bool,
	  loadGroups: _propTypes2.default.func,
	  onSelect: _propTypes2.default.func.isRequired,
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'select', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'select'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = SelectGroupsList;
	module.exports = exports['default'];

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactI18next = __webpack_require__(12);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _adbar = __webpack_require__(530);
	
	var adbarActions = _interopRequireWildcard(_adbar);
	
	var _reactCookie = __webpack_require__(174);
	
	var _storage = __webpack_require__(529);
	
	var _storage2 = _interopRequireDefault(_storage);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _Link = __webpack_require__(82);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1258);
	var logoImg = __webpack_require__(878);
	
	var expireMonths = 6;
	
	var CookiePolicyBar = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    hidden: state.adbar.cookieBarHidden
	  };
	}, (0, _extends3.default)({}, adbarActions)), _dec(_class = (0, _reactCookie.withCookies)(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(CookiePolicyBar, _Component);
	
	  function CookiePolicyBar(props) {
	    (0, _classCallCheck3.default)(this, CookiePolicyBar);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (CookiePolicyBar.__proto__ || (0, _getPrototypeOf2.default)(CookiePolicyBar)).call(this, props));
	
	    _this.cookies = new _storage2.default(props.cookies);
	    return _this;
	  }
	
	  (0, _createClass3.default)(CookiePolicyBar, [{
	    key: 'hide',
	    value: function hide() {
	      var hideCookie = this.props.hideCookie;
	
	      var expires = new Date();
	      expires.setMonth(expires.getMonth() + expireMonths);
	      this.cookies.setAsBoolean({ name: adbarActions.cookieNames.cookieBar, value: true, expires: expires });
	      hideCookie();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var hidden = this.props.hidden;
	      var t = this.context.t;
	
	      var isBarHidden = this.cookies.getAsBoolean({ name: adbarActions.cookieNames.cookieBar });
	
	      if (isBarHidden) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(styles.bar, (0, _defineProperty3.default)({}, styles.hidden, hidden)) },
	        _react2.default.createElement('img', { src: logoImg, alt: 'logo', className: styles.logo }),
	        _react2.default.createElement(
	          'div',
	          { className: styles.content },
	          _react2.default.createElement(
	            'p',
	            { className: styles.hint },
	            t('We use cookies to give you the best experience on our website')
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(_reactI18next.Interpolate, {
	              i18nKey: 'By using our website you agree to our use of cookies in accordance with our {{cookiePolicy}}.',
	              cookiePolicy: _react2.default.createElement(
	                _Link2.default,
	                { to: '/info/cookie-policy' },
	                t('cookie policy', { context: 'in accordance with our [cookie policy]' })
	              )
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          { className: (0, _classnames2.default)('btn-stroke', styles.closer), onClick: this.hide },
	          t('Accept')
	        )
	      );
	    }
	  }]);
	  return CookiePolicyBar;
	}(_react.Component), _class3.propTypes = {
	  cookies: _propTypes2.default.object,
	  hidden: _propTypes2.default.bool,
	  hideCookie: _propTypes2.default.func
	}, _class3.contextTypes = {
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'hide', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'hide'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = CookiePolicyBar;
	module.exports = exports['default'];

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _objectWithoutProperties2 = __webpack_require__(21);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(58);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClientSideComponent = __webpack_require__(30);
	
	var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);
	
	var _components = __webpack_require__(15);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var CropUploader = (_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(CropUploader, _Component);
	
	  function CropUploader() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, CropUploader);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = CropUploader.__proto__ || (0, _getPrototypeOf2.default)(CropUploader)).call.apply(_ref, [this].concat(args)));
	
	    _this._uploaderOnComplete = function (id, name, response) {
	      var onUpload = _this.props.onUpload;
	
	      _this.cropper.getWrappedInstance().destroy();
	      if (onUpload) {
	        onUpload(id, name, response);
	      }
	    };
	
	    _this.state = { loading: false };
	    return _this;
	  }
	
	  (0, _createClass3.default)(CropUploader, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _get3.default)(CropUploader.prototype.__proto__ || (0, _getPrototypeOf2.default)(CropUploader.prototype), 'componentDidMount', this).call(this, this._mountUploader);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      (0, _get3.default)(CropUploader.prototype.__proto__ || (0, _getPrototypeOf2.default)(CropUploader.prototype), 'componentWillUnmount', this).call(this, this._unMountUploader);
	    }
	  }, {
	    key: 'onImageSelected',
	    value: function onImageSelected(e) {
	      this.cropper.getWrappedInstance().onImageSelected(e);
	    }
	  }, {
	    key: '_mountUploader',
	    value: function _mountUploader() {
	      var FineUploaderTraditional = __webpack_require__(257);
	      var uploaderParams = this.props.uploaderParams;
	
	
	      this.uploader = new FineUploaderTraditional({
	        request: { params: uploaderParams.queryParams },
	        chunking: { success: { endpoint: uploaderParams.endpoint } }
	      });
	      this.uploader.on('complete', this._uploaderOnComplete);
	    }
	  }, {
	    key: '_unMountUploader',
	    value: function _unMountUploader() {
	      this.uploader.off('complete', this._uploaderOnComplete);
	      this.uploader.methods.cancelAll();
	      this.uploader = null;
	    }
	  }, {
	    key: '_onCrop',
	    value: function _onCrop(originalFile, cropped, fileName, cropper) {
	      var _props = this.props,
	          uploadCropped = _props.uploadCropped,
	          uploaderParams = _props.uploaderParams;
	
	
	      if (uploadCropped) {
	        this.uploader.methods.addFiles([{ canvas: cropped, name: fileName, quality: 80, type: 'image/jpeg' }]);
	      } else {
	        var cropData = cropper.getData(true);
	        var x1 = cropData.x;
	        var x2 = cropData.x + cropData.width;
	        var y1 = cropData.y;
	        var y2 = cropData.y + cropData.height;
	        this.uploader.methods.setParams((0, _extends3.default)({ x1: x1, x2: x2, y1: y1, y2: y2 }, uploaderParams.queryParams));
	        this.uploader.methods.addFiles(originalFile);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var isMounted = this.state.isMounted;
	      var _props2 = this.props,
	          uploaderParams = _props2.uploaderParams,
	          onUpload = _props2.onUpload,
	          cropperProps = (0, _objectWithoutProperties3.default)(_props2, ['uploaderParams', 'onUpload']); // eslint-disable-line no-unused-vars
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        isMounted && _react2.default.createElement(_components.Cropper, (0, _extends3.default)({ ref: function ref(el) {
	            return _this2.cropper = el;
	          } }, cropperProps, { onCrop: this._onCrop }))
	      );
	    }
	  }]);
	  return CropUploader;
	}(_ClientSideComponent2.default), _class2.propTypes = {
	  className: _propTypes2.default.string,
	  onUpload: _propTypes2.default.func,
	  uploadCropped: _propTypes2.default.bool,
	  uploaderParams: _propTypes2.default.object.isRequired
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, '_mountUploader', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_mountUploader'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_unMountUploader', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_unMountUploader'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_onCrop', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_onCrop'), _class.prototype)), _class);
	exports.default = CropUploader;
	module.exports = exports['default'];

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(58);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _defaultsDeep3 = __webpack_require__(448);
	
	var _defaultsDeep4 = _interopRequireDefault(_defaultsDeep3);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClientSideComponent = __webpack_require__(30);
	
	var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var CropperFactory = null;
	
	var Cropper = (_dec = (0, _reactI18next.translate)(['common'], { withRef: true }), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(Cropper, _Component);
	
	  function Cropper() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, Cropper);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = Cropper.__proto__ || (0, _getPrototypeOf2.default)(Cropper)).call.apply(_ref, [this].concat(args)));
	
	    _this._setCropper = function (file) {
	      var options = _this.props.options;
	
	      var defaultOptions = {
	        aspectRatio: 1,
	        viewMode: 1,
	        autoCropArea: 1,
	        movable: false,
	        rotatable: false,
	        scalable: true, //important!
	        zoomable: false,
	        preview: '#' + _this.state.previewId
	      };
	      var cropperOptions = (0, _defaultsDeep4.default)(options, defaultOptions);
	
	      if (_this.cropper) {
	        _this.cropper.destroy();
	      }
	
	      _this.cropper = new CropperFactory(_this.coverImg, cropperOptions);
	      _this.cropper.originalFile = file;
	    };
	
	    _this.state = {
	      coverSrc: null,
	      loading: false,
	      fileName: 'image'
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Cropper, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _get3.default)(Cropper.prototype.__proto__ || (0, _getPrototypeOf2.default)(Cropper.prototype), 'componentDidMount', this).call(this, this.mountCropper);
	    }
	  }, {
	    key: 'onImageSelected',
	    value: function onImageSelected(e) {
	      var _this2 = this;
	
	      var reader = new FileReader();
	      var file = e.target.files ? e.target.files[0] : null;
	
	      reader.addEventListener('load', function () {
	        _this2.setState({ coverSrc: reader.result });
	        _this2._setCropper(file);
	      }, false);
	
	      if (file) {
	        reader.readAsDataURL(file);
	        this.setState({ fileName: file.name || 'image' });
	      }
	    }
	  }, {
	    key: 'mountCropper',
	    value: function mountCropper() {
	      CropperFactory = __webpack_require__(1173).default;
	      this.setState({ previewId: 'cropPreview' + Date.now() });
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      if (this.cropper) {
	        this.cropper.destroy();
	      }
	      this.setState({
	        coverSrc: null,
	        loading: false
	      });
	    }
	  }, {
	    key: '_crop',
	    value: function _crop() {
	      if (!this.cropper) {
	        return false;
	      }
	      this.setState({ loading: true });
	
	      var _props = this.props,
	          onCrop = _props.onCrop,
	          width = _props.width,
	          height = _props.height,
	          fillColor = _props.fillColor;
	      // this.cropper.getCroppedCanvas({fillColor: '#fff'}).toBlob((blob) => {
	      //   this.uploader.methods.addFiles([blob]);
	      // }, 'image/jpeg');
	
	      var cropped = this.cropper.getCroppedCanvas({ width: width, height: height, fillColor: fillColor });
	
	      if (onCrop) {
	        // onCrop(cropped, this.state.fileName, this.cropper);
	        onCrop(this.cropper.originalFile, cropped, this.state.fileName, this.cropper);
	      }
	    }
	  }, {
	    key: '_cancel',
	    value: function _cancel() {
	      this.setState({ coverSrc: null });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var styles = __webpack_require__(1259);
	      var _state = this.state,
	          isMounted = _state.isMounted,
	          coverSrc = _state.coverSrc,
	          loading = _state.loading,
	          previewId = _state.previewId;
	      var _props2 = this.props,
	          className = _props2.className,
	          cropperClassName = _props2.cropperClassName,
	          t = _props2.t;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        isMounted && coverSrc && _react2.default.createElement(
	          'div',
	          { className: className },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('div', { id: previewId, className: styles.preview }),
	            _react2.default.createElement(
	              'div',
	              { className: styles.cropper },
	              _react2.default.createElement(
	                'div',
	                { className: cropperClassName },
	                _react2.default.createElement('img', { src: coverSrc, ref: function ref(el) {
	                    return _this3.coverImg = el;
	                  }, className: styles.cropperImg, alt: '' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'margin-top-10 text-right' },
	            loading ? _react2.default.createElement(_components.Loader, null) : _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'button',
	                { type: 'button', className: 'btn btn-default', onClick: this._cancel },
	                t('Cancel')
	              ),
	              _react2.default.createElement(
	                'button',
	                { type: 'button', className: 'btn btn-primary margin-left-10', onClick: this._crop },
	                t('Save')
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return Cropper;
	}(_ClientSideComponent2.default), _class3.propTypes = {
	  className: _propTypes2.default.string,
	  cropperClassName: _propTypes2.default.string,
	  fillColor: _propTypes2.default.string,
	  height: _propTypes2.default.number,
	  onCrop: _propTypes2.default.func,
	  options: _propTypes2.default.object,
	  t: _propTypes2.default.func.isRequired,
	  width: _propTypes2.default.number
	}, _class3.defaultProps = {
	  fillColor: '#fff'
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'mountCropper', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'mountCropper'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, '_crop', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, '_crop'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, '_cancel', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, '_cancel'), _class2.prototype)), _class2)) || _class);
	exports.default = Cropper;
	module.exports = exports['default'];

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _omit2 = __webpack_require__(1561);
	
	var _omit3 = _interopRequireDefault(_omit2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMomentProptypes = __webpack_require__(177);
	
	var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
	var _DateRangePicker = __webpack_require__(1632);
	
	var _DateRangePicker2 = _interopRequireDefault(_DateRangePicker);
	
	var _moment = __webpack_require__(20);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _datePickerConstants = __webpack_require__(1984);
	
	var _datePickerProps = __webpack_require__(1985);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1260);
	
	var DateRangePickerWrapper = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(DateRangePickerWrapper, _PureComponent);
	
	  function DateRangePickerWrapper() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, DateRangePickerWrapper);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = DateRangePickerWrapper.__proto__ || (0, _getPrototypeOf2.default)(DateRangePickerWrapper)).call.apply(_ref, [this].concat(args)));
	
	    var _args$ = args[0],
	        startDate = _args$.startDate,
	        endDate = _args$.endDate,
	        initialStartDate = _args$.initialStartDate,
	        initialEndDate = _args$.initialEndDate;
	
	    _this.state = {
	      focusedInput: null,
	      startDate: startDate ? (0, _moment2.default)(startDate) : initialStartDate,
	      endDate: endDate ? (0, _moment2.default)(endDate) : initialEndDate
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(DateRangePickerWrapper, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var startDate = nextProps.startDate,
	          endDate = nextProps.endDate;
	
	      if (this.props.startDate !== startDate || this.props.endDate !== endDate) {
	        this.setState({
	          startDate: startDate ? (0, _moment2.default)(startDate) : null,
	          endDate: endDate ? (0, _moment2.default)(endDate) : null
	        });
	      }
	    }
	  }, {
	    key: 'onDatesChange',
	    value: function onDatesChange(_ref2) {
	      var startDate = _ref2.startDate,
	          endDate = _ref2.endDate;
	      var focusedInput = this.state.focusedInput;
	
	      this.setState({ startDate: startDate, endDate: endDate });
	      this.props.onChange({ startDate: startDate, endDate: endDate, focusedInput: focusedInput });
	    }
	  }, {
	    key: 'onFocusChange',
	    value: function onFocusChange(focusedInput) {
	      this.setState({ focusedInput: focusedInput });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          focusedInput = _state.focusedInput,
	          startDate = _state.startDate,
	          endDate = _state.endDate;
	      var className = this.props.className;
	      var _context = this.context,
	          t = _context.t,
	          isMobile = _context.isMobile;
	
	      var props = (0, _omit3.default)(this.props, _datePickerProps.omittedProps);
	
	      return _react2.default.createElement(
	        'span',
	        { className: (0, _bind2.default)(styles.wrapper, className) },
	        _react2.default.createElement(_DateRangePicker2.default, (0, _extends3.default)({
	          startDatePlaceholderText: t('Start date'),
	          endDatePlaceholderText: t('End date')
	        }, props, {
	          onDatesChange: this.onDatesChange,
	          onFocusChange: this.onFocusChange,
	          focusedInput: focusedInput,
	          startDate: startDate,
	          endDate: endDate,
	          withFullScreenPortal: isMobile || props.withFullScreenPortal,
	          orientation: isMobile ? _datePickerConstants.VERTICAL_ORIENTATION : props.orientation
	        }))
	      );
	    }
	  }]);
	  return DateRangePickerWrapper;
	}(_react.PureComponent), _class2.propTypes = {
	  autoFocusEndDate: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  daySize: _propTypes2.default.number,
	  displayFormat: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  enableOutsideDays: _propTypes2.default.bool,
	  endDate: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  hideKeyboardShortcutsPanel: _propTypes2.default.bool,
	  initialEndDate: _reactMomentProptypes2.default.momentObj,
	  initialStartDate: _reactMomentProptypes2.default.momentObj,
	  initialVisibleMonth: _propTypes2.default.func,
	  isDayBlocked: _propTypes2.default.func,
	  isDayHighlighted: _propTypes2.default.func,
	  isOutsideRange: _propTypes2.default.func,
	  isRTL: _propTypes2.default.bool,
	  keepOpenOnDateSelect: _propTypes2.default.bool,
	  minimumNights: _propTypes2.default.number,
	  monthFormat: _propTypes2.default.string,
	  navNext: _propTypes2.default.node,
	  navPrev: _propTypes2.default.node,
	  numberOfMonths: _propTypes2.default.number,
	  onChange: _propTypes2.default.func,
	  onNextMonthClick: _propTypes2.default.func,
	  onOutsideClick: _propTypes2.default.func,
	  onPrevMonthClick: _propTypes2.default.func,
	  renderCalendarInfo: _propTypes2.default.func,
	  renderDay: _propTypes2.default.func,
	  reopenPickerOnClearDates: _propTypes2.default.bool,
	  showClearDates: _propTypes2.default.bool,
	  showDefaultInputIcon: _propTypes2.default.bool,
	  startDate: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  withFullScreenPortal: _propTypes2.default.bool,
	  withPortal: _propTypes2.default.bool
	}, _class2.contextTypes = {
	  isMobile: _propTypes2.default.bool,
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  anchorDirection: _datePickerConstants.ANCHOR_RIGHT,
	  autoFocusEndDate: false,
	  daySize: _datePickerConstants.DAY_SIZE,
	  displayFormat: _datePickerConstants.DISPLAY_FORMAT,
	  enableOutsideDays: false,
	  hideKeyboardShortcutsPanel: true,
	  initialEndDate: null,
	  initialStartDate: null,
	  initialVisibleMonth: null,
	  isDayBlocked: function isDayBlocked() {
	    return false;
	  },
	  isDayHighlighted: function isDayHighlighted() {
	    return false;
	  },
	  isOutsideRange: _noop3.default,
	  isRTL: false,
	  keepOpenOnDateSelect: false,
	  minimumNights: 1,
	  monthFormat: 'MMMM YYYY',
	  navNext: null,
	  navPrev: null,
	  numberOfMonths: 2,
	  onNextMonthClick: function onNextMonthClick() {},
	  onOutsideClick: function onOutsideClick() {},
	  onPrevMonthClick: function onPrevMonthClick() {},
	
	  orientation: _datePickerConstants.HORIZONTAL_ORIENTATION,
	  renderCalendarInfo: null,
	  renderDay: null,
	  reopenPickerOnClearDates: false,
	  showClearDates: false,
	  showDefaultInputIcon: false,
	  withFullScreenPortal: false,
	  withPortal: false
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onDatesChange', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onDatesChange'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onFocusChange', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onFocusChange'), _class.prototype)), _class);
	exports.default = DateRangePickerWrapper;
	module.exports = exports['default'];

/***/ }),
/* 1984 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  DISPLAY_FORMAT: 'DD MMM YYYY',
	  ISO_FORMAT: 'YYYY-MM-DD',
	
	  START_DATE: 'startDate',
	  END_DATE: 'endDate',
	
	  HORIZONTAL_ORIENTATION: 'horizontal',
	  VERTICAL_ORIENTATION: 'vertical',
	  VERTICAL_SCROLLABLE: 'verticalScrollable',
	
	  ANCHOR_LEFT: 'left',
	  ANCHOR_RIGHT: 'right',
	
	  DAY_SIZE: 35,
	  BLOCKED_MODIFIER: 'blocked'
	};

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.omittedProps = undefined;
	
	var _datetime = __webpack_require__(68);
	
	exports.default = {
	  dateFormat: _datetime.dateFormat.date,
	  timeFormat: false,
	  closeOnSelect: true,
	  inputProps: { className: 'dateTimeInput' },
	  isValidDate: function isValidDate(current) {
	    return current.isBefore();
	  }
	};
	var omittedProps = exports.omittedProps = ['onChange', 'className', 'autoFocus', 'autoFocusEndDate', 'initialStartDate', 'initialEndDate', 'onOutsideClick'];

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _Link = __webpack_require__(82);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1261);
	
	var DetailsLink = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(DetailsLink, _PureComponent);
	
	  function DetailsLink() {
	    (0, _classCallCheck3.default)(this, DetailsLink);
	    return (0, _possibleConstructorReturn3.default)(this, (DetailsLink.__proto__ || (0, _getPrototypeOf2.default)(DetailsLink)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(DetailsLink, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          to = _props.to,
	          title = _props.title,
	          onClick = _props.onClick;
	
	      var rootClass = (0, _bind2.default)(styles.link, className);
	      var titleEl = _react2.default.createElement(
	        'span',
	        { className: styles.title },
	        title
	      );
	
	      return onClick ? _react2.default.createElement(
	        'a',
	        { className: rootClass, onClick: onClick },
	        titleEl,
	        ' >'
	      ) : _react2.default.createElement(
	        _Link2.default,
	        { className: rootClass, to: to },
	        titleEl,
	        ' >'
	      );
	    }
	  }]);
	  return DetailsLink;
	}(_react.PureComponent), _class.propTypes = {
	  className: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  title: _propTypes2.default.string,
	  to: _propTypes2.default.string.isRequired
	}, _class.defaultProps = {
	  onClick: null,
	  title: ''
	}, _temp);
	exports.default = DetailsLink;
	module.exports = exports['default'];

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get4 = __webpack_require__(58);
	
	var _get5 = _interopRequireDefault(_get4);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _get6 = __webpack_require__(19);
	
	var _get7 = _interopRequireDefault(_get6);
	
	var _clamp3 = __webpack_require__(446);
	
	var _clamp4 = _interopRequireDefault(_clamp3);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClientSideComponent = __webpack_require__(30);
	
	var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);
	
	var _reactDraggable = __webpack_require__(744);
	
	var _reactDraggable2 = _interopRequireDefault(_reactDraggable);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1262);
	
	var cn = _bind2.default.bind(styles);
	
	var DragBar = (_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(DragBar, _Component);
	
	  function DragBar() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, DragBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = DragBar.__proto__ || (0, _getPrototypeOf2.default)(DragBar)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = {
	      dragPosition: { x: 0, y: 0 }
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(DragBar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _get5.default)(DragBar.prototype.__proto__ || (0, _getPrototypeOf2.default)(DragBar.prototype), 'componentDidMount', this).call(this, this.init);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (typeof nextProps.value !== 'undefined' && nextProps.forceUpdate && nextProps.value !== this.props.value) {
	        this.getProgress(null, null, nextProps.value);
	      }
	    }
	  }, {
	    key: 'onDrag',
	    value: function onDrag(e, position) {
	      var _getProgress = this.getProgress(e, position),
	          progress = _getProgress.progress;
	
	      if (this.props.onDrag) this.props.onDrag(e, position, progress);
	    }
	  }, {
	    key: 'onDragStop',
	    value: function onDragStop(e, position) {
	      var _getProgress2 = this.getProgress(e, position),
	          progress = _getProgress2.progress;
	
	      if (this.props.onStop) this.props.onStop(e, position, progress);
	    }
	  }, {
	    key: 'onDragStart',
	    value: function onDragStart(e, position) {
	      var _getProgress3 = this.getProgress(e, position),
	          progress = _getProgress3.progress;
	
	      if (this.props.onStart) this.props.onStart(e, position, progress);
	    }
	  }, {
	    key: 'getProgress',
	    value: function getProgress(e, position, value) {
	      if (!this.progressBar) {
	        return { x: 0, progress: 0 };
	      }
	      var barWidth = this.progressBar.clientWidth;
	      var barRect = this.progressBar.getBoundingClientRect ? this.progressBar.getBoundingClientRect() : { left: 0 };
	
	      var _ref2 = e || {},
	          target = _ref2.target,
	          nativeEvent = _ref2.nativeEvent;
	
	      var newX = 0;
	
	      if (target && nativeEvent) {
	        var clientX = (0, _get7.default)(nativeEvent, 'clientX') || (0, _get7.default)(nativeEvent, 'touches[0].clientX', 0);
	        newX = clientX - barRect.left;
	      } else if (position) {
	        newX = position.x;
	      } else if (value) {
	        newX = value * barWidth;
	      }
	
	      var x = (0, _clamp4.default)(newX, 0, barWidth);
	      var progress = (0, _clamp4.default)(x / barWidth, 0, 1);
	
	      this.updateState(x, 0, progress);
	
	      return { x: x, progress: progress };
	    }
	  }, {
	    key: 'init',
	    value: function init() {
	      var _getProgress4 = this.getProgress(null, null, this.props.value),
	          x = _getProgress4.x,
	          progress = _getProgress4.progress;
	
	      if (this.props.onInit) this.props.onInit(x, progress);
	    }
	  }, {
	    key: 'updateState',
	    value: function updateState(x, y, progress) {
	      this.setState({
	        dragPosition: { x: x, y: y },
	        progress: progress
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          dragPosition = _state.dragPosition,
	          progress = _state.progress;
	      var _props = this.props,
	          subValue = _props.subValue,
	          className = _props.className,
	          progressBarClass = _props.progressBarClass,
	          hideProgress = _props.hideProgress;
	
	      var dragBarClass = cn('dragBar', className);
	
	      return _react2.default.createElement(
	        'div',
	        { className: dragBarClass, ref: function ref(el) {
	            return _this2.dragBar = el;
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: cn('progressBar', progressBarClass), ref: function ref(el) {
	              return _this2.progressBar = el;
	            } },
	          !!subValue && _react2.default.createElement('div', { className: styles.subProgress, style: { width: subValue * 100 + '%' } }),
	          !hideProgress && _react2.default.createElement('div', { className: styles.progress, ref: function ref(el) {
	              return _this2.progress = el;
	            }, style: { width: progress * 100 + '%' } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.dragHolder, ref: function ref(el) {
	              return _this2.dragHolder = el;
	            } },
	          _react2.default.createElement(
	            _reactDraggable2.default,
	            {
	              axis: 'x',
	              bounds: 'parent',
	              position: dragPosition,
	              onStart: this.onDragStart,
	              onStop: this.onDragStop,
	              onDrag: this.onDrag
	            },
	            _react2.default.createElement('span', { className: styles.dragPoint, ref: function ref(el) {
	                return _this2.dragPoint = el;
	              } })
	          )
	        )
	      );
	    }
	  }]);
	  return DragBar;
	}(_ClientSideComponent2.default), _class2.propTypes = {
	  className: _propTypes2.default.string,
	  forceUpdate: _propTypes2.default.bool,
	  hideProgress: _propTypes2.default.bool,
	  onDrag: _propTypes2.default.func,
	  onInit: _propTypes2.default.func,
	  onStart: _propTypes2.default.func,
	  onStop: _propTypes2.default.func,
	  progressBarClass: _propTypes2.default.string,
	  subValue: _propTypes2.default.number,
	  value: _propTypes2.default.number
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onDrag', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onDrag'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onDragStop', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onDragStop'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onDragStart', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onDragStart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'init', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'init'), _class.prototype)), _class);
	exports.default = DragBar;
	module.exports = exports['default'];

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _get3 = __webpack_require__(19);
	
	var _get4 = _interopRequireDefault(_get3);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClientSideComponent = __webpack_require__(30);
	
	var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);
	
	var _reactRedux = __webpack_require__(11);
	
	var _config = __webpack_require__(41);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _dropbox = __webpack_require__(614);
	
	var _dropbox2 = _interopRequireDefault(_dropbox);
	
	var _utils = __webpack_require__(24);
	
	var _components = __webpack_require__(15);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var service = 'dropbox';
	
	var DropboxConnectButton = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    user: state.auth.user
	  };
	}), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(DropboxConnectButton, _Component);
	
	  function DropboxConnectButton() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, DropboxConnectButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = DropboxConnectButton.__proto__ || (0, _getPrototypeOf2.default)(DropboxConnectButton)).call.apply(_ref, [this].concat(args)));
	
	    _this.onAuth = function (e) {
	      window.removeEventListener('onDropboxAuth', _this.onAuth);
	      _this.authWindow.close();
	      _this.authWindow = null;
	
	      var accessToken = e.detail.access_token;
	      if (_this.state.isMounted) {
	        _this.setState({ accessToken: accessToken });
	      }
	    };
	
	    _this.state = { accessToken: null };
	    return _this;
	  }
	
	  (0, _createClass3.default)(DropboxConnectButton, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.Dropbox = null;
	    }
	  }, {
	    key: 'initDropboxClient',
	    value: function initDropboxClient(params) {
	      this.Dropbox = null;
	      this.Dropbox = new _dropbox2.default((0, _extends3.default)({ clientId: _config2.default.app.dropbox.appKey }, params));
	    }
	  }, {
	    key: 'connect',
	    value: function connect() {
	      this.initDropboxClient();
	      var authUrl = this.Dropbox.getAuthenticationUrl(document.location.origin + '/processing/cloudauth/dropbox');
	      this.authWindow = (0, _utils.popupWindowCenter)(authUrl, service, 360, 460);
	      window.addEventListener('onDropboxAuth', this.onAuth);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          user = _props.user,
	          connectClassName = _props.connectClassName,
	          disconnectClassName = _props.disconnectClassName;
	      var accessToken = this.state.accessToken;
	
	      var isConnected = !!(0, _get4.default)(user, 'dropboxToken', false);
	
	      return _react2.default.createElement(_components.CloudConnectButton, {
	        isConnected: isConnected,
	        connectClassName: connectClassName,
	        disconnectClassName: disconnectClassName,
	        accessToken: accessToken,
	        service: service,
	        connect: this.connect
	      });
	    }
	  }]);
	  return DropboxConnectButton;
	}(_ClientSideComponent2.default), _class3.propTypes = {
	  connectClassName: _propTypes2.default.string,
	  disconnectClassName: _propTypes2.default.string,
	  user: _propTypes2.default.object
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'connect', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'connect'), _class2.prototype)), _class2)) || _class);
	exports.default = DropboxConnectButton;
	module.exports = exports['default'];

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(58);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClientSideComponent = __webpack_require__(30);
	
	var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);
	
	var _uploads = __webpack_require__(112);
	
	var _config = __webpack_require__(41);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var dropboxImg = __webpack_require__(269);
	
	var DropboxPicker = (_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(DropboxPicker, _Component);
	
	  function DropboxPicker() {
	    (0, _classCallCheck3.default)(this, DropboxPicker);
	    return (0, _possibleConstructorReturn3.default)(this, (DropboxPicker.__proto__ || (0, _getPrototypeOf2.default)(DropboxPicker)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(DropboxPicker, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _get3.default)(DropboxPicker.prototype.__proto__ || (0, _getPrototypeOf2.default)(DropboxPicker.prototype), 'componentDidMount', this).call(this, this.initDropbox);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.Dropbox = null;
	    }
	  }, {
	    key: 'onSelect',
	    value: function onSelect(files) {
	      var onSelect = this.props.onSelect;
	
	
	      if (onSelect) {
	        var _config$app$dropbox = _config2.default.app.dropbox,
	            serviceName = _config$app$dropbox.serviceName,
	            fileFields = _config$app$dropbox.fileFields;
	
	        var formattedList = (0, _uploads.formatCloudFilesList)(files, serviceName, fileFields);
	        onSelect(formattedList);
	      }
	    }
	  }, {
	    key: 'initDropbox',
	    value: function initDropbox() {
	      if (!this.Dropbox) {
	        this.Dropbox = __webpack_require__(2244).dropbox();
	      }
	
	      if (this.Dropbox) {
	        this.Dropbox.appKey = _config2.default.app.dropbox.appKey;
	      }
	    }
	  }, {
	    key: 'openDropbox',
	    value: function openDropbox() {
	      var options = {
	        success: this.onSelect,
	        multiselect: true,
	        linkType: 'direct',
	        extensions: (0, _uploads.getUploaderAcceptableFormats)('audio').split(', ')
	      };
	
	      this.Dropbox.choose(options);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'button',
	        { type: 'button', className: 'btn btn-clear', onClick: this.openDropbox, title: 'Dropbox' },
	        _react2.default.createElement('img', { src: dropboxImg, alt: '' })
	      );
	    }
	  }]);
	  return DropboxPicker;
	}(_ClientSideComponent2.default), _class2.propTypes = {
	  onSelect: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onSelect', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onSelect'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'initDropbox', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'initDropbox'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'openDropbox', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'openDropbox'), _class.prototype)), _class);
	exports.default = DropboxPicker;
	module.exports = exports['default'];

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _toConsumableArray2 = __webpack_require__(34);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _promise = __webpack_require__(62);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _values = __webpack_require__(158);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(58);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClientSideComponent = __webpack_require__(30);
	
	var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactI18next = __webpack_require__(12);
	
	var _config = __webpack_require__(41);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _dropbox = __webpack_require__(614);
	
	var _dropbox2 = _interopRequireDefault(_dropbox);
	
	var _utils = __webpack_require__(24);
	
	var _auth = __webpack_require__(31);
	
	var authAction = _interopRequireWildcard(_auth);
	
	var _cloud = __webpack_require__(216);
	
	var cloudActions = _interopRequireWildcard(_cloud);
	
	var _components = __webpack_require__(15);
	
	var _cloud2 = __webpack_require__(873);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var dropboxImg = __webpack_require__(269);
	
	var service = 'dropbox';
	
	var DropboxPopup = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    error: (0, _cloud2.getError)(state, service),
	    files: (0, _cloud2.getFiles)(state, service),
	    pathId: (0, _cloud2.getPathId)(state, service),
	    pathCollection: state.cloud[service].pathCollection,
	    processing: (0, _cloud2.getProcessing)(state, service),
	    user: state.auth.user
	  };
	}, (0, _extends3.default)({}, authAction, cloudActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(DropboxPopup, _Component);
	
	  function DropboxPopup() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, DropboxPopup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = DropboxPopup.__proto__ || (0, _getPrototypeOf2.default)(DropboxPopup)).call.apply(_ref, [this].concat(args)));
	
	    _this.onAuth = function (e) {
	      window.removeEventListener('onDropboxAuth', _this.onAuth);
	      _this.authWindow.close();
	      _this.authWindow = null;
	
	      var accessToken = e.detail.access_token;
	      if (accessToken) {
	        _this.props.setBoxToken(service, accessToken).promise.then(function () {
	          _this.initDropboxClient({ accessToken: accessToken });
	          _this.openCloudBrowser();
	        });
	      }
	    };
	
	    _this.getFileFromResp = function (item) {
	      return {
	        service: service,
	        uniqId: item.__id + '-' + Date.now(),
	        url: item.link,
	        name: item.metadata.name,
	        size: item.metadata.size
	      };
	    };
	
	    _this.state = { files: [] };
	    return _this;
	  }
	
	  (0, _createClass3.default)(DropboxPopup, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _get3.default)(DropboxPopup.prototype.__proto__ || (0, _getPrototypeOf2.default)(DropboxPopup.prototype), 'componentDidMount', this).call(this, this.initDropbox);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      (0, _get3.default)(DropboxPopup.prototype.__proto__ || (0, _getPrototypeOf2.default)(DropboxPopup.prototype), 'componentWillUnmount', this).call(this, this.destroyDropbox);
	    }
	  }, {
	    key: 'onSelect',
	    value: function onSelect(item, breadcrumb) {
	      if (item && item.__type === 'folder') {
	        this.loadPath(item.path_lower, this.getPathCollection(item));
	      } else if (typeof breadcrumb !== 'undefined') {
	        this.loadPath(breadcrumb.id, breadcrumb.pathCollection);
	      }
	    }
	  }, {
	    key: 'onResult',
	    value: function onResult(items) {
	      var _this2 = this;
	
	      var itemsArr = (0, _values2.default)(items);
	      if (!itemsArr.length) {
	        return false;
	      }
	
	      var _props = this.props,
	          setProcessing = _props.setProcessing,
	          onAdd = _props.onAdd;
	
	
	      setProcessing(service, true);
	      var promises = [];
	
	      itemsArr.map(function (item) {
	        var promise = _this2.Dropbox.filesGetTemporaryLink({ path: item.path_lower });
	        promises.push(promise.then(_this2.getFileFromResp));
	      });
	
	      _promise2.default.all(promises).then(function (resp) {
	        _this2.closeCloudBrowser();
	        setProcessing(service, false);
	        onAdd(resp);
	      }).catch(function () {
	        return setProcessing(service, false);
	      });
	    }
	  }, {
	    key: 'getRootPathCollection',
	    value: function getRootPathCollection() {
	      var t = this.props.t;
	
	      return [{ id: '', name: t('Dropbox files') }];
	    }
	  }, {
	    key: 'getPathCollection',
	    value: function getPathCollection(item) {
	      var _this3 = this;
	
	      var res = [];
	      var pathArr = item.path_lower.split('/');
	      var fullPath = '';
	
	      pathArr.map(function (entry, index) {
	        if (!index) {
	          res.push.apply(res, (0, _toConsumableArray3.default)(_this3.getRootPathCollection()));
	        } else {
	          fullPath += '/' + entry;
	          res.push({ id: fullPath, name: entry });
	        }
	      });
	
	      return res;
	    }
	  }, {
	    key: 'destroyDropbox',
	    value: function destroyDropbox() {
	      this.Dropbox = null;
	    }
	  }, {
	    key: 'initDropboxClient',
	    value: function initDropboxClient(params) {
	      this.Dropbox = null;
	      this.Dropbox = new _dropbox2.default((0, _extends3.default)({ clientId: _config2.default.app.dropbox.appKey }, params));
	    }
	  }, {
	    key: 'loadPath',
	    value: function loadPath(pathId) {
	      var _this4 = this;
	
	      var pathCollection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getRootPathCollection();
	      var _props2 = this.props,
	          setFiles = _props2.setFiles,
	          setError = _props2.setError,
	          setPath = _props2.setPath,
	          setPathCollection = _props2.setPathCollection;
	
	      var isSamePath = function isSamePath() {
	        return _this4.props.pathId === pathId;
	      };
	      setPath(service, pathId);
	      setPathCollection(service, pathCollection);
	
	      this.Dropbox.filesListFolder({ path: pathId }).then(function (resp) {
	        return isSamePath() ? setFiles({ service: service, pathId: pathId, files: resp.entries }) : false;
	      }).catch(function (err) {
	        return isSamePath() ? setError(service, err.error) : false;
	      });
	    }
	  }, {
	    key: 'openCloudBrowser',
	    value: function openCloudBrowser() {
	      this.modal.open();
	      this.loadPath('');
	    }
	  }, {
	    key: 'closeCloudBrowser',
	    value: function closeCloudBrowser() {
	      this.modal.close();
	    }
	  }, {
	    key: 'initDropbox',
	    value: function initDropbox() {
	      var user = this.props.user;
	
	      var params = {};
	      if (user.dropboxToken) {
	        params.accessToken = user.dropboxToken;
	      }
	      this.initDropboxClient(params);
	    }
	  }, {
	    key: 'openDropbox',
	    value: function openDropbox(forceAuth) {
	      var user = this.props.user;
	
	
	      if (!user.dropboxToken || forceAuth) {
	        var authUrl = this.Dropbox.getAuthenticationUrl(document.location.origin + '/processing/cloudauth/dropbox');
	        this.authWindow = (0, _utils.popupWindowCenter)(authUrl, service, 380, 480);
	        window.addEventListener('onDropboxAuth', this.onAuth);
	      } else {
	        this.openCloudBrowser();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _props3 = this.props,
	          t = _props3.t,
	          files = _props3.files,
	          error = _props3.error,
	          pathId = _props3.pathId,
	          pathCollection = _props3.pathCollection,
	          processing = _props3.processing,
	          fileTypes = _props3.fileTypes,
	          disabled = _props3.disabled;
	
	
	      var modalProps = {
	        backdrop: true,
	        closeByEsc: false,
	        title: t('Add Dropbox files'),
	        bsSize: 'lg',
	        withoutPadding: true,
	        simpleHeader: true
	      };
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          'button',
	          { type: 'button', className: 'btn btn-clear', onClick: function onClick() {
	              return _this5.openDropbox();
	            }, disabled: disabled },
	          _react2.default.createElement(
	            _components.Tooltip,
	            { placement: 'bottom', title: 'Dropbox' },
	            _react2.default.createElement('img', { src: dropboxImg, alt: '' })
	          )
	        ),
	        _react2.default.createElement(
	          _components.Modal,
	          (0, _extends3.default)({ ref: function ref(el) {
	              return _this5.modal = el;
	            } }, modalProps),
	          _react2.default.createElement(_components.CloudBrowser, {
	            items: files,
	            fileTypes: fileTypes,
	            service: service,
	            pathId: pathId,
	            pathCollection: pathCollection,
	            error: error,
	            processing: processing,
	            onCancel: this.closeCloudBrowser,
	            onSelect: this.onSelect,
	            onResult: this.onResult,
	            onError: function onError() {
	              return _this5.openDropbox(true);
	            }
	          })
	        )
	      );
	    }
	  }]);
	  return DropboxPopup;
	}(_ClientSideComponent2.default), _class3.propTypes = {
	  disabled: _propTypes2.default.bool,
	  error: _propTypes2.default.string,
	  files: _propTypes2.default.array,
	  fileTypes: _propTypes2.default.array,
	  onAdd: _propTypes2.default.func,
	  pathCollection: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    id: _propTypes2.default.string,
	    name: _propTypes2.default.string,
	    path: _propTypes2.default.string
	  })),
	  pathId: _propTypes2.default.string,
	  processing: _propTypes2.default.bool,
	  setBoxToken: _propTypes2.default.func,
	  setError: _propTypes2.default.func,
	  setFiles: _propTypes2.default.func,
	  setPath: _propTypes2.default.func,
	  setPathCollection: _propTypes2.default.func,
	  setProcessing: _propTypes2.default.func,
	  t: _propTypes2.default.func,
	  user: _propTypes2.default.object
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onSelect', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSelect'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onResult', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onResult'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'destroyDropbox', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'destroyDropbox'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'closeCloudBrowser', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'closeCloudBrowser'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'initDropbox', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'initDropbox'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = DropboxPopup;
	module.exports = exports['default'];

/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _uploads = __webpack_require__(112);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileSize = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(FileSize, _Component);
	
	  function FileSize() {
	    (0, _classCallCheck3.default)(this, FileSize);
	    return (0, _possibleConstructorReturn3.default)(this, (FileSize.__proto__ || (0, _getPrototypeOf2.default)(FileSize)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(FileSize, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return !(0, _uploads.areUnitsEqual)(nextProps.units, this.props.units);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          size = _props.size,
	          units = _props.units;
	
	
	      if (size === null || size < 0) {
	        return _react2.default.createElement('span', { className: className });
	      }
	
	      var _formatSizeAndUnits = (0, _uploads.formatSizeAndUnits)(size, units),
	          formattedSize = _formatSizeAndUnits.formattedSize,
	          formattedUnits = _formatSizeAndUnits.formattedUnits;
	
	      return _react2.default.createElement(
	        'span',
	        { className: className },
	        _react2.default.createElement(
	          'span',
	          null,
	          formattedSize
	        ),
	        _react2.default.createElement('span', null),
	        _react2.default.createElement(
	          'span',
	          null,
	          formattedUnits
	        )
	      );
	    }
	  }]);
	  return FileSize;
	}(_react.Component), _class.propTypes = {
	  className: _propTypes2.default.string,
	  size: _propTypes2.default.number,
	  units: _propTypes2.default.shape({
	    byte: _propTypes2.default.string,
	    kilobyte: _propTypes2.default.string,
	    megabyte: _propTypes2.default.string,
	    gigabyte: _propTypes2.default.string,
	    terabyte: _propTypes2.default.string
	  })
	}, _class.defaultProps = {
	  units: {
	    byte: 'B',
	    kilobyte: 'KB',
	    megabyte: 'MB',
	    gigabyte: 'GB',
	    terabyte: 'TB'
	  }
	}, _temp);
	exports.default = FileSize;
	module.exports = exports['default'];

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1265);
	
	var FileTypeThumb = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(FileTypeThumb, _Component);
	
	  function FileTypeThumb() {
	    (0, _classCallCheck3.default)(this, FileTypeThumb);
	    return (0, _possibleConstructorReturn3.default)(this, (FileTypeThumb.__proto__ || (0, _getPrototypeOf2.default)(FileTypeThumb)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(FileTypeThumb, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          children = _props.children;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(styles.fileTypeThumb, className) },
	        _react2.default.createElement('div', { className: styles.corner }),
	        _react2.default.createElement('div', { className: styles.top }),
	        _react2.default.createElement('div', { className: styles.bottom }),
	        _react2.default.createElement(
	          'div',
	          { className: styles.fileType },
	          children
	        )
	      );
	    }
	  }]);
	  return FileTypeThumb;
	}(_react.Component), _class.propTypes = {
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string
	}, _temp);
	exports.default = FileTypeThumb;
	module.exports = exports['default'];

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(58);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _keys = __webpack_require__(113);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClientSideComponent = __webpack_require__(30);
	
	var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _uploads = __webpack_require__(112);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var getElementProps = function getElementProps(actualProps) {
	  var actualPropsCopy = (0, _extends3.default)({}, actualProps);
	  var expectedPropNames = (0, _keys2.default)(DropzoneElement.propTypes); // eslint-disable-line no-use-before-define
	  expectedPropNames.forEach(function (expectedPropName) {
	    return delete actualPropsCopy[expectedPropName];
	  });
	  return actualPropsCopy;
	};
	
	var DropzoneElement = (_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(DropzoneElement, _Component);
	
	  function DropzoneElement() {
	    (0, _classCallCheck3.default)(this, DropzoneElement);
	    return (0, _possibleConstructorReturn3.default)(this, (DropzoneElement.__proto__ || (0, _getPrototypeOf2.default)(DropzoneElement)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(DropzoneElement, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _get3.default)(DropzoneElement.prototype.__proto__ || (0, _getPrototypeOf2.default)(DropzoneElement.prototype), 'componentDidMount', this).call(this, this._registerDropzone);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.disabled !== this.props.disabled) {
	        if (nextProps.disabled) {
	          this._unregisterDropzone();
	        } else {
	          this._registerDropzone();
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this._registerDropzone();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      (0, _get3.default)(DropzoneElement.prototype.__proto__ || (0, _getPrototypeOf2.default)(DropzoneElement.prototype), 'componentWillUnmount', this).call(this, this._unregisterDropzone);
	    }
	  }, {
	    key: '_unregisterDropzone',
	    value: function _unregisterDropzone() {
	      if (this._qqDropzone) {
	        this._qqDropzone.dispose();
	      }
	    }
	  }, {
	    key: '_onDropError',
	    value: function _onDropError(errorCode, errorData) {
	      var onDropError = this.props.onDropError;
	
	      if (onDropError) {
	        onDropError((0, _uploads.getUploaderErrorMessage)(errorCode), errorData);
	      }
	    }
	  }, {
	    key: '_onProcessingDroppedFilesComplete',
	    value: function _onProcessingDroppedFilesComplete(files) {
	      var _props = this.props,
	          uploader = _props.uploader,
	          onProcessingDroppedFilesComplete = _props.onProcessingDroppedFilesComplete;
	
	      uploader.methods.addFiles(files);
	      if (onProcessingDroppedFilesComplete) {
	        onProcessingDroppedFilesComplete(files);
	      }
	    }
	  }, {
	    key: '_registerDropzone',
	    value: function _registerDropzone() {
	      if (this.props.disabled) {
	        return false;
	      }
	
	      this._unregisterDropzone();
	
	      var _props2 = this.props,
	          element = _props2.element,
	          multiple = _props2.multiple,
	          onProcessingDroppedFiles = _props2.onProcessingDroppedFiles,
	          dropActiveClassName = _props2.dropActiveClassName;
	
	      var dropzoneEl = element || this.dropZone;
	      var dnd = __webpack_require__(1404);
	
	      this._qqDropzone = new dnd.DragAndDrop({
	        allowMultipleItems: !!multiple,
	        callbacks: {
	          dropError: this._onDropError,
	          processingDroppedFiles: onProcessingDroppedFiles || function () {},
	          processingDroppedFilesComplete: this._onProcessingDroppedFilesComplete
	        },
	        classes: {
	          dropActive: dropActiveClassName || 'active'
	        },
	        dropZoneElements: [dropzoneEl]
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var styles = __webpack_require__(147);
	      var _props3 = this.props,
	          className = _props3.className,
	          children = _props3.children,
	          clickable = _props3.clickable;
	
	      var dropZoneClass = (0, _bind2.default)(className, styles.dropZone, (0, _defineProperty3.default)({}, styles.clickable, clickable));
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, getElementProps(this.props), { className: dropZoneClass, ref: function ref(el) {
	            return _this2.dropZone = el;
	          } }),
	        children
	      );
	    }
	  }]);
	  return DropzoneElement;
	}(_ClientSideComponent2.default), _class2.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  className: _propTypes2.default.string,
	  clickable: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  dropActiveClassName: _propTypes2.default.string,
	  element: _propTypes2.default.string,
	  multiple: _propTypes2.default.bool,
	  onDropError: _propTypes2.default.func,
	  onProcessingDroppedFiles: _propTypes2.default.func,
	  onProcessingDroppedFilesComplete: _propTypes2.default.func,
	  uploader: _propTypes2.default.object.isRequired
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, '_unregisterDropzone', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_unregisterDropzone'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_onDropError', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_onDropError'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_onProcessingDroppedFilesComplete', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_onProcessingDroppedFilesComplete'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_registerDropzone', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_registerDropzone'), _class.prototype)), _class);
	exports.default = DropzoneElement;
	module.exports = exports['default'];

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(21);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var newKey = function newKey() {
	  return Date.now();
	};
	
	var FileInput = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(FileInput, _Component);
	
	  function FileInput() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, FileInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = FileInput.__proto__ || (0, _getPrototypeOf2.default)(FileInput)).call.apply(_ref, [this].concat(args)));
	
	    _this._onFilesSelected = function (e) {
	      _this.props.uploader.methods.addFiles(e.target);
	      _this._resetInput();
	    };
	
	    _this.state = { key: newKey() };
	    return _this;
	  }
	
	  (0, _createClass3.default)(FileInput, [{
	    key: '_resetInput',
	    value: function _resetInput() {
	      this.setState({ key: newKey() });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          uploader = _props.uploader,
	          className = _props.className,
	          elementProps = (0, _objectWithoutProperties3.default)(_props, ['children', 'uploader', 'className']); // eslint-disable-line no-unused-vars
	
	      return _react2.default.createElement(
	        'label',
	        { className: (0, _classnames2.default)('fileInputContainer', className), key: this.state.key },
	        children,
	        _react2.default.createElement('input', (0, _extends3.default)({ type: 'file' }, elementProps, { className: 'fileInput', onChange: this._onFilesSelected }))
	      );
	    }
	  }]);
	  return FileInput;
	}(_react.Component), _class.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  className: _propTypes2.default.string,
	  uploader: _propTypes2.default.object.isRequired
	}, _temp);
	exports.default = FileInput;
	module.exports = exports['default'];

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileName = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(FileName, _Component);
	
	  function FileName(props) {
	    (0, _classCallCheck3.default)(this, FileName);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (FileName.__proto__ || (0, _getPrototypeOf2.default)(FileName)).call(this, props));
	
	    _this.state = {
	      filename: props.uploader.methods.getName(props.id)
	    };
	
	    _this._interceptSetName();
	    return _this;
	  }
	
	  (0, _createClass3.default)(FileName, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return nextState.filename !== this.state.filename;
	    }
	  }, {
	    key: '_interceptSetName',
	    value: function _interceptSetName() {
	      var _this2 = this;
	
	      var oldSetName = this.props.uploader.methods.setName;
	
	      this.props.uploader.methods.setName = function (id, newName) {
	        oldSetName.call(_this2.props.uploader.methods, id, newName);
	
	        if (id === _this2.props.id) {
	          _this2.setState({
	            filename: newName
	          });
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var filename = this.state.filename;
	      var _props = this.props,
	          hideName = _props.hideName,
	          className = _props.className;
	
	      var displayName = filename;
	      if (hideName && filename) {
	        displayName = filename.split('.').pop();
	      }
	
	      return _react2.default.createElement(
	        'span',
	        { className: className, title: displayName },
	        displayName
	      );
	    }
	  }]);
	  return FileName;
	}(_react.Component), _class.propTypes = {
	  className: _propTypes2.default.string,
	  hideName: _propTypes2.default.bool,
	  id: _propTypes2.default.number.isRequired,
	  uploader: _propTypes2.default.object.isRequired
	}, _temp);
	exports.default = FileName;
	module.exports = exports['default'];

/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _toConsumableArray2 = __webpack_require__(34);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(58);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _UploadStatusBaseClass = __webpack_require__(514);
	
	var _UploadStatusBaseClass2 = _interopRequireDefault(_UploadStatusBaseClass);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _reactI18next = __webpack_require__(12);
	
	var _utils = __webpack_require__(24);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(147);
	
	var cn = _bind2.default.bind(styles);
	
	var ProgressBar = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(ProgressBar, _Component);
	
	  function ProgressBar() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, ProgressBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = ProgressBar.__proto__ || (0, _getPrototypeOf2.default)(ProgressBar)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { progressTime: [] };
	    _this.progressTimer = null;
	    return _this;
	  }
	
	  (0, _createClass3.default)(ProgressBar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _get3.default)(ProgressBar.prototype.__proto__ || (0, _getPrototypeOf2.default)(ProgressBar.prototype), 'componentDidMount', this).call(this);
	      this.startProgressTimer();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      (0, _get3.default)(ProgressBar.prototype.__proto__ || (0, _getPrototypeOf2.default)(ProgressBar.prototype), 'componentWillUnmount', this).call(this);
	      this.stopProgressTimer();
	    }
	  }, {
	    key: 'onUpdateProgress',
	    value: function onUpdateProgress() {
	      this.startProgressTimer();
	    }
	
	    // time left calculated by average speed for last N seconds
	
	  }, {
	    key: 'getLeftForTime',
	    value: function getLeftForTime(minTime, maxTime) {
	      var _state = this.state,
	          bytesUploaded = _state.bytesUploaded,
	          totalSize = _state.totalSize,
	          progressTime = _state.progressTime;
	
	      var sizeLeft = totalSize - bytesUploaded;
	      var stepsStored = progressTime.length;
	
	      var res = 0;
	      if (stepsStored > minTime) {
	        var calcTime = Math.min(maxTime, stepsStored - 1);
	        var bytesUploadedForTime = 0;
	
	        for (var i = stepsStored; i > stepsStored - calcTime; i--) {
	          bytesUploadedForTime += progressTime[i - 1].bytesUploadedForTick;
	        }
	
	        var speed = bytesUploadedForTime / calcTime;
	        res = Math.max(sizeLeft / speed, 0);
	      }
	      return Math.round(res);
	    }
	  }, {
	    key: 'startProgressTimer',
	    value: function startProgressTimer() {
	      if (this.props.showLeftTime && !this.progressTimer) {
	        this.progressTimer = setInterval(this.updateProgressTime, 1000);
	      }
	    }
	  }, {
	    key: 'stopProgressTimer',
	    value: function stopProgressTimer() {
	      clearInterval(this.progressTimer);
	      this.progressTimer = null;
	    }
	  }, {
	    key: 'updateProgressTime',
	    value: function updateProgressTime() {
	      var _state2 = this.state,
	          bytesUploaded = _state2.bytesUploaded,
	          totalSize = _state2.totalSize,
	          progressTime = _state2.progressTime;
	
	      var newProgressTime = [].concat((0, _toConsumableArray3.default)(progressTime));
	
	      if (bytesUploaded) {
	        var bytesUploadedForTick = progressTime.length ? bytesUploaded - progressTime[progressTime.length - 1].bytesUploaded : 0;
	        // if we cancel some uploads then bytesUploaded and totalSize will be very different from last stored, so compensate it
	        if (bytesUploadedForTick < 0) {
	          bytesUploadedForTick = progressTime.length ? progressTime[progressTime.length - 1].bytesUploadedForTick : 0;
	        }
	
	        newProgressTime.push({
	          bytesUploaded: bytesUploaded,
	          totalSize: totalSize,
	          bytesUploadedForTick: bytesUploadedForTick
	        });
	      }
	
	      var timeLeft = this.getLeftForTime(1, 20);
	
	      if (timeLeft === 0) {
	        this.stopProgressTimer();
	      }
	
	      if (newProgressTime.length > 30) {
	        newProgressTime.splice(0, 1);
	      }
	
	      this.setState({ progressTime: newProgressTime, timeLeft: timeLeft });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          t = _props.t,
	          className = _props.className,
	          timeLeftClass = _props.timeLeftClass,
	          altStyle = _props.altStyle;
	      var _state3 = this.state,
	          progress = _state3.progress,
	          hidden = _state3.hidden,
	          isComplete = _state3.isComplete,
	          isFailed = _state3.isFailed,
	          isCanceled = _state3.isCanceled,
	          isSuccess = _state3.isSuccess,
	          timeLeft = _state3.timeLeft;
	
	      var progressBarClass = (0, _bind2.default)('progressBar', className, styles.progressBar, this._isTotalProgress ? styles.total : styles.file, (0, _defineProperty3.default)({}, styles.altStyle, altStyle));
	      var timeLeftStr = (0, _utils.secondsToTime)({ seconds: timeLeft, infinityStr: t('Calculating...') });
	
	      return _react2.default.createElement(
	        'div',
	        { className: progressBarClass, hidden: hidden },
	        _react2.default.createElement('s', { className: cn('progress', { isFailed: isFailed, isCanceled: isCanceled, isSuccess: isSuccess, isComplete: isComplete }), style: { width: progress ? progress + '%' : 0 } }),
	        !!timeLeft && _react2.default.createElement(
	          'div',
	          { className: timeLeftClass },
	          timeLeftStr
	        )
	      );
	    }
	  }]);
	  return ProgressBar;
	}(_UploadStatusBaseClass2.default), _class3.propTypes = {
	  altStyle: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  showLeftTime: _propTypes2.default.bool,
	  t: _propTypes2.default.func,
	  timeLeftClass: _propTypes2.default.string
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'updateProgressTime', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateProgressTime'), _class2.prototype)), _class2)) || _class);
	exports.default = ProgressBar;
	module.exports = exports['default'];

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotAvailablePlaceholder = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(NotAvailablePlaceholder, _Component);
	
	  function NotAvailablePlaceholder() {
	    (0, _classCallCheck3.default)(this, NotAvailablePlaceholder);
	    return (0, _possibleConstructorReturn3.default)(this, (NotAvailablePlaceholder.__proto__ || (0, _getPrototypeOf2.default)(NotAvailablePlaceholder)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(NotAvailablePlaceholder, [{
	    key: 'render',
	
	
	    /* eslint-disable max-len */
	    value: function render() {
	      return _react2.default.createElement(
	        'svg',
	        { height: this.props.maxSize, width: this.props.maxSize, viewBox: '0 0 252 300', version: '1.1' },
	        _react2.default.createElement('path', { fill: '#ffffff', d: ' M 0.00 0.00 L 252.00 0.00 L 252.00 300.00 L 0.00 300.00 L 0.00 279.07 C 0.21 281.56 2.43 283.73 4.98 283.51 C 54.33 283.52 103.68 283.47 153.03 283.53 C 163.75 293.62 178.22 299.86 193.02 299.75 C 209.68 300.16 226.27 292.72 237.25 280.22 C 246.51 269.83 252.00 255.97 251.75 242.00 C 252.22 227.72 246.68 213.46 237.19 202.83 C 236.46 201.92 235.43 201.19 235.01 200.08 C 234.92 158.48 235.13 116.87 234.91 75.28 C 215.93 56.82 196.64 38.69 177.62 20.28 C 170.86 14.13 164.58 7.44 157.65 1.49 C 106.73 1.51 55.82 1.49 4.90 1.50 C 2.72 1.29 1.25 3.08 0.00 4.58 L 0.00 0.00 Z' }),
	        _react2.default.createElement('path', { fill: '#525352', d: ' M 0.00 4.58 C 1.25 3.08 2.72 1.29 4.90 1.50 C 55.82 1.49 106.73 1.51 157.65 1.49 C 164.58 7.44 170.86 14.13 177.62 20.28 C 196.64 38.69 215.93 56.82 234.91 75.28 C 235.13 116.87 234.92 158.48 235.01 200.08 C 235.43 201.19 236.46 201.92 237.19 202.83 C 246.68 213.46 252.22 227.72 251.75 242.00 C 252.00 255.97 246.51 269.83 237.25 280.22 C 226.27 292.72 209.68 300.16 193.02 299.75 C 178.22 299.86 163.75 293.62 153.03 283.53 C 103.68 283.47 54.33 283.52 4.98 283.51 C 2.43 283.73 0.21 281.56 0.00 279.07 L 0.00 4.58 Z' }),
	        _react2.default.createElement('path', { fill: '#bababa', d: ' M 18.27 19.97 C 19.84 19.39 21.63 19.90 23.28 19.79 C 21.74 21.53 19.73 22.95 18.62 25.03 C 18.50 28.06 18.60 31.09 18.69 34.11 C 23.87 29.67 28.43 24.52 33.33 19.77 C 37.67 19.77 42.01 19.65 46.34 19.84 C 37.18 29.45 27.59 38.65 18.27 48.11 C 18.40 38.72 17.69 29.36 18.27 19.97 Z' }),
	        _react2.default.createElement('path', { fill: '#ffffff', d: ' M 23.28 19.79 C 26.63 19.71 29.98 19.75 33.33 19.77 C 28.43 24.52 23.87 29.67 18.69 34.11 C 18.60 31.09 18.50 28.06 18.62 25.03 C 19.73 22.95 21.74 21.53 23.28 19.79 Z' }),
	        _react2.default.createElement('path', { fill: '#ffffff', d: ' M 46.34 19.84 C 49.71 19.63 53.13 19.80 56.52 19.77 C 43.83 32.57 31.13 45.37 18.25 57.99 C 18.26 54.69 18.22 51.40 18.27 48.11 C 27.59 38.65 37.18 29.45 46.34 19.84 Z' }),
	        _react2.default.createElement('path', { fill: '#bababa', d: ' M 56.52 19.77 C 60.83 19.74 65.14 19.71 69.45 19.79 C 52.52 37.03 35.29 53.98 18.27 71.12 C 18.23 66.74 18.25 62.36 18.25 57.99 C 31.13 45.37 43.83 32.57 56.52 19.77 Z' }),
	        _react2.default.createElement('path', { fill: '#ffffff', d: ' M 69.45 19.79 C 72.81 19.70 76.17 19.76 79.53 19.77 C 59.20 40.32 38.60 60.61 18.28 81.17 C 18.23 77.82 18.23 74.47 18.27 71.12 C 35.29 53.98 52.52 37.03 69.45 19.79 Z' }),
	        _react2.default.createElement('path', { fill: '#bababa', d: ' M 79.53 19.77 C 83.77 19.95 88.19 19.29 92.32 20.11 C 67.83 44.98 43.05 69.60 18.30 94.22 C 18.22 89.87 18.23 85.52 18.28 81.17 C 38.60 60.61 59.20 40.32 79.53 19.77 Z' }),
	        _react2.default.createElement('path', { fill: '#ffffff', d: ' M 92.32 20.11 L 92.70 19.72 C 96.04 19.80 99.39 19.71 102.74 19.77 C 74.71 48.09 46.39 76.13 18.28 104.37 C 18.25 100.98 18.20 97.60 18.30 94.22 C 43.05 69.60 67.83 44.98 92.32 20.11 Z' }),
	        _react2.default.createElement('path', { fill: '#bababa', d: ' M 102.74 19.77 C 106.92 19.93 111.25 19.32 115.34 20.09 C 112.00 23.83 108.31 27.23 104.81 30.81 C 75.95 59.59 47.26 88.53 18.30 117.21 C 18.22 112.93 18.23 108.64 18.28 104.37 C 46.39 76.13 74.71 48.09 102.74 19.77 Z' }),
	        _react2.default.createElement('path', { fill: '#ffffff', d: ' M 115.34 20.09 L 115.69 19.72 C 119.04 19.80 122.38 19.71 125.73 19.77 C 90.04 55.76 54.06 91.46 18.28 127.37 C 18.25 123.98 18.19 120.59 18.30 117.21 C 47.26 88.53 75.95 59.59 104.81 30.81 C 108.31 27.23 112.00 23.83 115.34 20.09 Z' }),
	        _react2.default.createElement('path', { fill: '#bababa', d: ' M 125.73 19.77 C 129.88 20.06 134.43 19.06 138.31 20.29 C 136.70 22.34 134.76 24.09 132.93 25.94 C 102.10 56.77 71.27 87.60 40.44 118.43 C 33.04 125.71 25.89 133.24 18.33 140.34 C 18.18 136.02 18.25 131.69 18.28 127.37 C 54.06 91.46 90.04 55.76 125.73 19.77 Z' }),
	        _react2.default.createElement('path', { fill: '#ffffff', d: ' M 138.31 20.29 L 138.78 19.74 C 142.18 19.77 145.58 19.73 148.97 19.77 C 105.53 63.48 61.86 106.99 18.27 150.56 C 18.28 147.15 18.15 143.74 18.33 140.34 C 25.89 133.24 33.04 125.71 40.44 118.43 C 71.27 87.60 102.10 56.77 132.93 25.94 C 134.76 24.09 136.70 22.34 138.31 20.29 Z' }),
	        _react2.default.createElement('path', { fill: '#bababa', d: ' M 148.97 19.77 C 149.41 19.77 150.29 19.77 150.73 19.77 C 150.76 23.59 150.76 27.40 150.74 31.21 C 109.55 72.22 68.53 113.39 27.41 154.46 C 24.39 157.43 21.49 160.54 18.32 163.36 C 18.18 159.09 18.26 154.82 18.27 150.56 C 61.86 106.99 105.53 63.48 148.97 19.77 Z' }),
	        _react2.default.createElement('path', { fill: '#ffffff', d: ' M 27.41 154.46 C 68.53 113.39 109.55 72.22 150.74 31.21 C 150.76 34.49 150.75 37.78 150.75 41.06 C 106.64 85.27 62.49 129.44 18.26 173.53 C 18.28 170.14 18.16 166.74 18.32 163.36 C 21.49 160.54 24.39 157.43 27.41 154.46 Z' }),
	        _react2.default.createElement('path', { fill: '#bababa', d: ' M 18.26 173.53 C 62.49 129.44 106.64 85.27 150.75 41.06 C 150.74 45.52 150.78 49.99 150.73 54.45 C 106.53 98.56 62.38 142.72 18.26 186.92 C 18.25 182.46 18.23 177.99 18.26 173.53 Z' }),
	        _react2.default.createElement('path', { fill: '#ffffff', d: ' M 18.26 186.92 C 62.38 142.72 106.53 98.56 150.73 54.45 C 150.69 57.78 150.90 61.14 150.64 64.46 C 149.89 65.10 149.15 65.76 148.44 66.44 C 105.03 109.79 61.71 153.23 18.27 196.56 C 18.23 193.34 18.24 190.13 18.26 186.92 Z' }),
	        _react2.default.createElement('path', { fill: '#bababa', d: ' M 148.44 66.44 C 149.15 65.76 149.89 65.10 150.64 64.46 C 150.87 68.77 150.72 73.11 150.73 77.43 C 106.56 121.58 62.35 165.71 18.26 209.94 C 18.26 205.48 18.22 201.01 18.27 196.56 C 61.71 153.23 105.03 109.79 148.44 66.44 Z' }),
	        _react2.default.createElement('path', { fill: '#ffffff', d: ' M 18.26 209.94 C 62.35 165.71 106.56 121.58 150.73 77.43 C 150.51 80.16 150.59 83.44 153.47 84.78 C 108.27 129.65 63.42 174.88 18.26 219.80 C 18.24 216.51 18.24 213.22 18.26 209.94 Z' }),
	        _react2.default.createElement('path', { fill: '#bababa', d: ' M 153.47 84.78 C 157.68 85.24 161.92 84.84 166.14 85.07 C 117.01 134.57 67.55 183.74 18.27 233.09 C 18.24 228.66 18.24 224.23 18.26 219.80 C 63.42 174.88 108.27 129.65 153.47 84.78 Z' }),
	        _react2.default.createElement('path', { fill: '#ffffff', d: ' M 166.14 85.07 C 169.49 84.92 172.85 85.00 176.20 85.04 C 123.43 137.48 71.02 190.31 18.26 242.77 C 18.25 239.54 18.22 236.32 18.27 233.09 C 67.55 183.74 117.01 134.57 166.14 85.07 Z' }),
	        _react2.default.createElement('path', { fill: '#bababa', d: ' M 176.20 85.04 C 180.51 84.97 184.82 84.95 189.12 85.08 C 132.35 142.26 75.19 199.07 18.27 256.11 C 18.24 251.66 18.24 247.22 18.26 242.77 C 71.02 190.31 123.43 137.48 176.20 85.04 Z' }),
	        _react2.default.createElement('path', { fill: '#ffffff', d: ' M 189.12 85.08 C 192.54 84.91 195.97 85.01 199.39 85.03 C 142.78 141.53 86.28 198.13 29.71 254.67 C 26.34 258.11 22.79 261.40 19.56 264.98 L 18.98 265.60 C 17.33 263.02 18.67 259.18 18.27 256.11 C 75.19 199.07 132.35 142.26 189.12 85.08 Z' }),
	        _react2.default.createElement('path', { fill: '#bababa', d: ' M 199.39 85.03 C 203.66 85.00 207.95 84.90 212.22 85.11 C 198.55 99.45 184.25 113.18 170.34 127.28 C 124.40 173.28 78.35 219.17 32.48 265.23 C 28.18 265.12 23.80 265.58 19.56 264.98 C 22.79 261.40 26.34 258.11 29.71 254.67 C 86.28 198.13 142.78 141.53 199.39 85.03 Z' }),
	        _react2.default.createElement('path', { fill: '#ffffff', d: ' M 212.22 85.11 C 213.79 84.88 215.40 85.02 216.98 85.01 C 216.96 86.94 217.14 88.89 216.87 90.80 C 201.36 105.62 186.47 121.10 171.20 136.17 C 139.03 168.35 106.85 200.53 74.67 232.70 C 64.06 243.45 53.17 253.94 42.73 264.85 L 42.33 265.28 C 39.05 265.20 35.76 265.29 32.48 265.23 C 78.35 219.17 124.40 173.28 170.34 127.28 C 184.25 113.18 198.55 99.45 212.22 85.11 Z' }),
	        _react2.default.createElement('path', { fill: '#bababa', d: ' M 171.20 136.17 C 186.47 121.10 201.36 105.62 216.87 90.80 C 217.12 95.07 216.98 99.35 216.97 103.62 C 163.19 157.54 109.22 211.27 55.49 265.23 C 51.26 265.02 46.80 265.76 42.73 264.85 C 53.17 253.94 64.06 243.45 74.67 232.70 C 106.85 200.53 139.03 168.35 171.20 136.17 Z' }),
	        _react2.default.createElement('path', { fill: '#ffffff', d: ' M 55.49 265.23 C 109.22 211.27 163.19 157.54 216.97 103.62 C 216.98 107.04 217.09 110.47 216.92 113.89 C 169.72 160.66 122.91 207.83 75.87 254.76 C 72.45 258.24 68.88 261.57 65.61 265.19 C 62.24 265.32 58.86 265.23 55.49 265.23 Z' }),
	        _react2.default.createElement('path', { fill: '#bababa', d: ' M 75.87 254.76 C 122.91 207.83 169.72 160.66 216.92 113.89 C 217.06 118.13 217.01 122.37 216.97 126.61 C 170.87 172.88 124.54 218.92 78.49 265.23 C 74.20 265.25 69.90 265.31 65.61 265.19 C 68.88 261.57 72.45 258.24 75.87 254.76 Z' }),
	        _react2.default.createElement('path', { fill: '#ffffff', d: ' M 78.49 265.23 C 124.54 218.92 170.87 172.88 216.97 126.61 C 217.00 130.02 217.07 133.43 216.94 136.83 C 199.92 153.51 183.23 170.52 166.31 187.30 C 164.81 188.76 163.34 190.26 162.10 191.94 C 159.60 194.48 156.45 196.32 153.93 198.86 C 150.05 202.08 147.44 206.51 143.95 210.08 C 140.61 212.64 137.88 215.88 134.84 218.78 C 119.44 234.28 103.85 249.59 88.57 265.20 C 85.21 265.30 81.85 265.23 78.49 265.23 Z' }),
	        _react2.default.createElement('path', { fill: '#bababa', d: ' M 166.31 187.30 C 183.23 170.52 199.92 153.51 216.94 136.83 C 217.03 141.15 217.04 145.47 216.95 149.78 C 205.65 161.41 194.02 172.72 182.63 184.27 C 175.92 185.62 169.42 188.04 163.54 191.58 C 163.18 191.67 162.46 191.85 162.10 191.94 C 163.34 190.26 164.81 188.76 166.31 187.30 Z' }),
	        _react2.default.createElement('path', { fill: '#ffffff', d: ' M 182.63 184.27 C 194.02 172.72 205.65 161.41 216.95 149.78 C 217.02 153.17 217.03 156.56 216.97 159.95 C 209.19 167.66 201.42 175.39 193.74 183.20 C 190.01 183.32 186.30 183.64 182.63 184.27 Z' }),
	        _react2.default.createElement('path', { fill: '#bababa', d: ' M 193.74 183.20 C 201.42 175.39 209.19 167.66 216.97 159.95 C 217.01 164.23 217.04 168.51 216.96 172.80 C 213.60 176.97 208.68 179.97 206.09 184.65 C 202.04 183.69 197.88 183.37 193.74 183.20 Z' }),
	        _react2.default.createElement('path', { fill: '#ffffff', d: ' M 206.09 184.65 C 208.68 179.97 213.60 176.97 216.96 172.80 C 216.97 176.81 217.19 180.83 216.73 184.83 L 215.42 184.54 C 215.53 185.11 215.73 186.25 215.83 186.82 C 212.45 186.71 209.40 185.16 206.09 184.65 Z' }),
	        _react2.default.createElement('path', { fill: '#bababa', d: ' M 134.84 218.78 C 137.88 215.88 140.61 212.64 143.95 210.08 C 143.87 210.46 143.70 211.23 143.62 211.61 C 140.00 217.58 137.54 224.21 136.28 231.07 L 136.28 231.07 C 135.42 231.60 134.62 232.21 133.92 232.93 C 123.19 243.72 112.39 254.43 101.67 265.23 C 97.30 265.26 92.93 265.29 88.57 265.20 C 103.85 249.59 119.44 234.28 134.84 218.78 Z' }),
	        _react2.default.createElement('path', { fill: '#ffffff', d: ' M 133.92 232.93 C 134.62 232.21 135.42 231.60 136.28 231.07 C 135.60 234.54 135.44 238.06 135.44 241.58 C 127.40 249.32 119.58 257.30 111.72 265.22 C 108.37 265.29 105.02 265.25 101.67 265.23 C 112.39 254.43 123.19 243.72 133.92 232.93 Z' }),
	        _react2.default.createElement('path', { fill: '#ffffff', d: ' M 162.75 232.54 C 183.33 232.46 203.91 232.49 224.48 232.52 C 224.51 238.51 224.52 244.49 224.48 250.48 C 203.91 250.50 183.33 250.54 162.76 250.47 C 162.74 244.49 162.75 238.51 162.75 232.54 Z' }),
	        _react2.default.createElement('path', { fill: '#bababa', d: ' M 111.72 265.22 C 119.58 257.30 127.40 249.32 135.44 241.58 C 135.36 245.55 135.82 249.48 136.51 253.39 C 132.54 257.31 128.60 261.27 124.66 265.23 C 120.35 265.27 116.03 265.28 111.72 265.22 Z' }),
	        _react2.default.createElement('path', { fill: '#ffffff', d: ' M 124.66 265.23 C 128.60 261.27 132.54 257.31 136.51 253.39 C 136.91 256.83 139.27 260.12 138.36 263.61 L 139.68 263.56 C 139.81 263.80 140.07 264.30 140.20 264.54 C 138.21 264.75 136.08 264.17 134.27 265.28 C 131.07 265.21 127.86 265.29 124.66 265.23 Z' })
	      );
	    }
	    /* eslint-enable max-len */
	
	  }]);
	  return NotAvailablePlaceholder;
	}(_react.Component), _class.propTypes = {
	  maxSize: _propTypes2.default.number
	}, _temp);
	exports.default = NotAvailablePlaceholder;
	module.exports = exports['default'];

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Placeholder = function Placeholder(_ref) {
	  var image = _ref.image,
	      size = _ref.size;
	
	  var style = {
	    maxHeight: size
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: style },
	    image
	  );
	};
	
	Placeholder.propTypes = {
	  image: _propTypes2.default.node.isRequired,
	  size: _propTypes2.default.number.isRequired
	  // status: PropTypes.string.isRequired,
	};
	
	exports.default = Placeholder;
	module.exports = exports['default'];

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WaitingPlaceholder = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(WaitingPlaceholder, _Component);
	
	  function WaitingPlaceholder() {
	    (0, _classCallCheck3.default)(this, WaitingPlaceholder);
	    return (0, _possibleConstructorReturn3.default)(this, (WaitingPlaceholder.__proto__ || (0, _getPrototypeOf2.default)(WaitingPlaceholder)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(WaitingPlaceholder, [{
	    key: 'render',
	
	
	    /* eslint-disable max-len */
	    value: function render() {
	      return _react2.default.createElement(
	        'svg',
	        { height: this.props.maxSize, width: this.props.maxSize, viewBox: '0 0 251 300', version: '1.1' },
	        _react2.default.createElement('path', { fill: '#ffffff', d: ' M 0.00 0.00 L 5.50 0.00 C 3.57 0.58 1.55 1.87 1.38 4.07 C 1.02 9.12 1.37 14.18 1.25 19.24 C 3.20 19.24 5.16 19.25 7.11 19.25 C 7.40 28.45 9.49 37.52 12.75 46.10 C 18.73 61.86 27.86 76.33 38.93 89.01 C 51.26 103.08 66.33 115.05 83.64 122.38 C 92.38 125.91 101.16 130.29 107.51 137.46 C 111.25 141.69 113.80 147.59 112.27 153.28 C 110.17 161.20 103.40 166.70 96.69 170.79 C 89.30 175.47 80.72 177.72 73.23 182.19 C 49.26 195.79 30.23 217.29 17.84 241.76 C 11.88 253.74 7.50 266.77 7.12 280.25 C 5.17 280.24 3.21 280.25 1.25 280.25 C 1.33 285.16 1.08 290.08 1.33 294.98 C 1.27 297.00 2.89 298.48 4.63 299.18 L 3.28 300.00 L 0.00 300.00 L 0.00 0.00 Z' }),
	        _react2.default.createElement('path', { fill: '#525352', d: ' M 5.50 0.00 L 247.37 0.00 C 248.74 1.06 250.50 2.15 250.61 4.09 C 250.98 9.13 250.63 14.20 250.74 19.25 C 248.78 19.25 246.83 19.25 244.88 19.24 C 165.62 19.26 86.37 19.25 7.11 19.25 C 5.16 19.25 3.20 19.24 1.25 19.24 C 1.37 14.18 1.02 9.12 1.38 4.07 C 1.55 1.87 3.57 0.58 5.50 0.00 Z' }),
	        _react2.default.createElement('path', { fill: '#ffffff', d: ' M 247.37 0.00 L 251.00 0.00 L 251.00 280.03 C 248.96 280.02 246.91 280.00 244.88 280.00 C 244.45 266.87 240.25 254.16 234.50 242.45 C 221.25 215.98 200.24 192.80 173.59 179.46 C 165.71 175.90 157.44 172.91 150.54 167.53 C 144.88 163.36 139.54 157.36 139.33 149.97 C 139.30 143.07 143.94 137.23 149.09 133.12 C 153.86 129.29 159.25 126.29 164.85 123.87 C 192.12 113.26 214.12 91.86 229.08 67.08 C 237.62 52.52 244.37 36.33 244.88 19.24 C 246.83 19.25 248.78 19.25 250.74 19.25 C 250.63 14.20 250.98 9.13 250.61 4.09 C 250.50 2.15 248.74 1.06 247.37 0.00 Z' }),
	        _react2.default.createElement('path', { fill: '#bababa', d: ' M 7.11 19.25 C 86.37 19.25 165.62 19.26 244.88 19.24 C 244.37 36.33 237.62 52.52 229.08 67.08 C 214.12 91.86 192.12 113.26 164.85 123.87 C 159.25 126.29 153.86 129.29 149.09 133.12 C 143.94 137.23 139.30 143.07 139.33 149.97 C 139.54 157.36 144.88 163.36 150.54 167.53 C 157.44 172.91 165.71 175.90 173.59 179.46 C 200.24 192.80 221.25 215.98 234.50 242.45 C 240.25 254.16 244.45 266.87 244.88 280.00 C 246.91 280.00 248.96 280.02 251.00 280.03 L 251.00 300.00 L 3.28 300.00 L 4.63 299.18 C 32.74 298.76 60.88 299.12 88.99 299.00 C 141.33 298.98 193.67 299.04 246.01 298.97 C 248.39 299.36 250.34 297.28 250.43 295.00 C 250.84 290.16 250.49 285.30 250.54 280.46 C 235.08 280.04 219.61 280.35 204.14 280.24 C 204.25 271.94 200.83 262.74 192.78 259.18 C 179.36 253.86 164.31 255.95 150.76 251.10 C 146.18 249.52 142.78 245.77 140.47 241.63 C 136.29 234.23 134.05 225.89 132.66 217.56 C 129.77 193.84 127.20 169.41 132.91 145.89 C 135.79 134.35 141.55 122.37 152.34 116.37 C 169.77 109.21 183.92 95.49 193.57 79.51 C 199.34 69.89 203.67 59.09 204.10 47.77 C 151.96 47.74 99.82 47.74 47.69 47.77 C 48.53 64.72 57.24 80.21 67.92 92.97 C 76.39 102.82 86.86 111.13 98.92 116.11 C 109.46 121.51 115.24 132.92 118.35 143.87 C 124.19 165.77 122.50 188.78 119.91 211.03 C 119.06 220.86 116.79 230.67 112.47 239.57 C 109.94 244.79 105.92 249.73 100.15 251.43 C 87.83 255.43 74.51 254.35 62.11 258.03 C 57.61 259.31 53.55 262.18 51.19 266.26 C 48.40 270.33 47.98 275.36 47.70 280.13 C 34.18 280.41 20.65 280.18 7.12 280.25 C 7.50 266.77 11.88 253.74 17.84 241.76 C 30.23 217.29 49.26 195.79 73.23 182.19 C 80.72 177.72 89.30 175.47 96.69 170.79 C 103.40 166.70 110.17 161.20 112.27 153.28 C 113.80 147.59 111.25 141.69 107.51 137.46 C 101.16 130.29 92.38 125.91 83.64 122.38 C 66.33 115.05 51.26 103.08 38.93 89.01 C 27.86 76.33 18.73 61.86 12.75 46.10 C 9.49 37.52 7.40 28.45 7.11 19.25 Z' }),
	        _react2.default.createElement('path', { fill: '#525352', d: ' M 47.69 47.77 C 99.82 47.74 151.96 47.74 204.10 47.77 C 203.67 59.09 199.34 69.89 193.57 79.51 C 183.92 95.49 169.77 109.21 152.34 116.37 C 141.55 122.37 135.79 134.35 132.91 145.89 C 127.20 169.41 129.77 193.84 132.66 217.56 C 134.05 225.89 136.29 234.23 140.47 241.63 C 142.78 245.77 146.18 249.52 150.76 251.10 C 164.31 255.95 179.36 253.86 192.78 259.18 C 200.83 262.74 204.25 271.94 204.14 280.24 C 219.61 280.35 235.08 280.04 250.54 280.46 C 250.49 285.30 250.84 290.16 250.43 295.00 C 250.34 297.28 248.39 299.36 246.01 298.97 C 193.67 299.04 141.33 298.98 88.99 299.00 C 60.88 299.12 32.74 298.76 4.63 299.18 C 2.89 298.48 1.27 297.00 1.33 294.98 C 1.08 290.08 1.33 285.16 1.25 280.25 C 3.21 280.25 5.17 280.24 7.12 280.25 C 20.65 280.18 34.18 280.41 47.70 280.13 C 47.98 275.36 48.40 270.33 51.19 266.26 C 53.55 262.18 57.61 259.31 62.11 258.03 C 74.51 254.35 87.83 255.43 100.15 251.43 C 105.92 249.73 109.94 244.79 112.47 239.57 C 116.79 230.67 119.06 220.86 119.91 211.03 C 122.50 188.78 124.19 165.77 118.35 143.87 C 115.24 132.92 109.46 121.51 98.92 116.11 C 86.86 111.13 76.39 102.82 67.92 92.97 C 57.24 80.21 48.53 64.72 47.69 47.77 Z' })
	      );
	    }
	    /* eslint-enable max-len */
	
	  }]);
	  return WaitingPlaceholder;
	}(_react.Component), _class.propTypes = {
	  maxSize: _propTypes2.default.number
	}, _temp);
	exports.default = WaitingPlaceholder;
	module.exports = exports['default'];

/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.waitingStatus = exports.notAvailableStatus = exports.defaultMaxSize = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Placeholder = __webpack_require__(1998);
	
	var _Placeholder2 = _interopRequireDefault(_Placeholder);
	
	var _NotAvailablePlaceholder = __webpack_require__(1997);
	
	var _NotAvailablePlaceholder2 = _interopRequireDefault(_NotAvailablePlaceholder);
	
	var _WaitingPlaceholder = __webpack_require__(1999);
	
	var _WaitingPlaceholder2 = _interopRequireDefault(_WaitingPlaceholder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultMaxSize = exports.defaultMaxSize = 120;
	var notAvailableStatus = exports.notAvailableStatus = 'not-available';
	var waitingStatus = exports.waitingStatus = 'waiting';
	
	var Thumbnail = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(Thumbnail, _Component);
	
	  function Thumbnail() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, Thumbnail);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = Thumbnail.__proto__ || (0, _getPrototypeOf2.default)(Thumbnail)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = {
	      drawComplete: false
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Thumbnail, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.props.uploader.methods.drawThumbnail(this.props.id, this.canvas, this.props.maxSize).then(function () {
	        return _this2.setState({ drawComplete: true, success: true });
	      }, function () {
	        return _this2.setState({ drawComplete: true, success: false });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('canvas', { ref: function ref(el) {
	            return _this3.canvas = el;
	          }, hidden: !this.state.drawComplete || this._failure }),
	        this._maybePlaceholder
	      );
	    }
	  }, {
	    key: '_failure',
	    get: function get() {
	      return this.state.drawComplete && !this.state.success;
	    }
	  }, {
	    key: '_maybePlaceholder',
	    get: function get() {
	      if (this._failure) {
	        var notAvailableImage = _react2.default.createElement(_NotAvailablePlaceholder2.default, { maxSize: this.props.maxSize });
	        return _react2.default.createElement(_Placeholder2.default, { image: notAvailableImage, size: this.props.maxSize, status: notAvailableStatus });
	      } else if (!this.state.drawComplete) {
	        var waitingImage = _react2.default.createElement(_WaitingPlaceholder2.default, { maxSize: this.props.maxSize });
	        return _react2.default.createElement(_Placeholder2.default, { image: waitingImage, size: this.props.maxSize, status: waitingStatus });
	      }
	      return _react2.default.createElement('span', null);
	    }
	  }]);
	  return Thumbnail;
	}(_react.Component), _class.propTypes = {
	  id: _propTypes2.default.number.isRequired,
	  maxSize: _propTypes2.default.number,
	  uploader: _propTypes2.default.object.isRequired
	}, _class.defaultProps = {
	  maxSize: defaultMaxSize
	}, _temp);
	exports.default = Thumbnail;

/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(58);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClientSideComponent = __webpack_require__(30);
	
	var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(147);
	
	var TotalProgress = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(TotalProgress, _Component);
	
	  function TotalProgress() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, TotalProgress);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = TotalProgress.__proto__ || (0, _getPrototypeOf2.default)(TotalProgress)).call.apply(_ref, [this].concat(args)));
	
	    _this.onAllComplete = function () {
	      _this.setState({ hidden: true });
	    };
	
	    _this.onSubmitted = function () {
	      _this.setState({ hidden: false });
	    };
	
	    _this.state = { hidden: false };
	
	    var uploader = _this.props.uploader;
	
	    uploader.on('allComplete', _this.onAllComplete);
	    uploader.on('submitted', _this.onSubmitted);
	    return _this;
	  }
	
	  (0, _createClass3.default)(TotalProgress, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _this2 = this;
	
	      var uploader = this.props.uploader;
	
	
	      (0, _get3.default)(TotalProgress.prototype.__proto__ || (0, _getPrototypeOf2.default)(TotalProgress.prototype), 'componentWillUnmount', this).call(this, function () {
	        uploader.off('allComplete', _this2.onAllComplete);
	        uploader.off('submitted', _this2.onSubmitted);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          uploader = _props.uploader,
	          altStyle = _props.altStyle,
	          t = _props.t;
	      var hidden = this.state.hidden;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.totalProgress, hidden: hidden },
	        _react2.default.createElement(_components.UploaderFilesize, { uploader: uploader, className: styles.fileSize }),
	        _react2.default.createElement(_components.ProgressBar, { uploader: uploader, timeLeftClass: styles.timeLeft, showLeftTime: true, altStyle: altStyle }),
	        _react2.default.createElement(
	          'div',
	          { className: styles.bottomLine },
	          _react2.default.createElement(
	            'span',
	            { className: 'pull-left' },
	            t('Total')
	          ),
	          _react2.default.createElement(_components.UploadStatus, { uploader: uploader, className: 'pull-right' })
	        )
	      );
	    }
	  }]);
	  return TotalProgress;
	}(_ClientSideComponent2.default), _class2.propTypes = {
	  altStyle: _propTypes2.default.bool,
	  t: _propTypes2.default.func,
	  uploader: _propTypes2.default.object
	}, _class2.defaultProps = {
	  multiple: true
	}, _temp)) || _class);
	exports.default = TotalProgress;
	module.exports = exports['default'];

/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _isEmpty3 = __webpack_require__(81);
	
	var _isEmpty4 = _interopRequireDefault(_isEmpty3);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(147);
	var desktopImg = __webpack_require__(363);
	
	var UploadArea = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(UploadArea, _Component);
	
	  function UploadArea() {
	    (0, _classCallCheck3.default)(this, UploadArea);
	    return (0, _possibleConstructorReturn3.default)(this, (UploadArea.__proto__ || (0, _getPrototypeOf2.default)(UploadArea)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(UploadArea, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          uploader = _props.uploader,
	          t = _props.t,
	          submittedFiles = _props.submittedFiles,
	          children = _props.children,
	          accept = _props.accept,
	          multiple = _props.multiple,
	          onDropError = _props.onDropError,
	          hideHeader = _props.hideHeader,
	          clickable = _props.clickable,
	          showStatusIcon = _props.showStatusIcon,
	          _onDelete = _props.onDelete,
	          _onCancel = _props.onCancel,
	          submittedCloudFiles = _props.submittedCloudFiles,
	          uploadButtons = _props.uploadButtons,
	          disabled = _props.disabled;
	
	      var isMediaFiles = !(0, _isEmpty4.default)(submittedFiles);
	      var isCloudFiles = !(0, _isEmpty4.default)(submittedCloudFiles);
	      var isDisplayedCloudFiles = !!(submittedCloudFiles && submittedCloudFiles.filter(function (file) {
	        return file.status !== 'success';
	      }).length);
	
	      return _react2.default.createElement(
	        _components.DropZone,
	        {
	          clickable: clickable,
	          multiple: multiple,
	          uploader: uploader,
	          onDropError: onDropError,
	          disabled: disabled,
	          className: (0, _classnames2.default)({ disabled: disabled })
	        },
	        clickable ? _react2.default.createElement(
	          _components.FileInput,
	          { className: styles.clickableArea, multiple: multiple, accept: accept, uploader: uploader, disabled: disabled },
	          _react2.default.createElement(
	            'div',
	            { className: 'overflow-hidden' },
	            !hideHeader && _react2.default.createElement(
	              'span',
	              null,
	              t('Drop Files Here')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            children
	          )
	        ) : _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'overflow-hidden' },
	            !hideHeader && _react2.default.createElement(
	              'span',
	              null,
	              t('Drop Files Here')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: styles.uploadButtons },
	              _react2.default.createElement(
	                _components.FileInput,
	                { className: styles.computerButton, uploader: uploader, accept: accept, multiple: true, disabled: disabled },
	                _react2.default.createElement(
	                  'span',
	                  { className: (0, _classnames2.default)('btn btn-clear', (0, _defineProperty3.default)({}, styles.disabledButton, disabled)) },
	                  _react2.default.createElement(
	                    _components.Tooltip,
	                    { placement: 'bottom', title: t('Upload from computer') },
	                    _react2.default.createElement('img', { src: desktopImg, alt: '' })
	                  )
	                )
	              ),
	              uploadButtons
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            children
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('margin-top-10', { 'padding-10': clickable }) },
	          isMediaFiles && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'hint small' },
	              t('Files from the computer')
	            ),
	            submittedFiles.map(function (id) {
	              return _react2.default.createElement(_components.UploaderItem, {
	                className: 'margin-bottom-10',
	                key: id,
	                id: id,
	                uploader: uploader,
	                showStatusIcon: showStatusIcon,
	                onDelete: function onDelete() {
	                  return _onDelete(id);
	                },
	                onCancel: function onCancel() {
	                  return _onCancel(id);
	                },
	                cancelable: true
	              });
	            })
	          ),
	          isCloudFiles && _react2.default.createElement(
	            'div',
	            null,
	            isDisplayedCloudFiles && _react2.default.createElement(
	              'div',
	              { className: 'hint small' },
	              t('Files from the cloud services')
	            ),
	            submittedCloudFiles.map(function (cloudFile) {
	              return _react2.default.createElement(_components.CloudUploaderItem, {
	                key: cloudFile.uniqId,
	                showOnSuccess: false,
	                deletable: true,
	                onDelete: function onDelete() {
	                  return _this2.deleteCloudItem(cloudFile);
	                },
	                cloudFile: cloudFile
	              });
	            })
	          ),
	          isMediaFiles && _react2.default.createElement(_components.TotalProgress, { uploader: uploader })
	        )
	      );
	    }
	  }]);
	  return UploadArea;
	}(_react.Component), _class2.propTypes = {
	  accept: _propTypes2.default.string,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  clickable: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  hideHeader: _propTypes2.default.bool,
	  multiple: _propTypes2.default.bool,
	  onCancel: _propTypes2.default.func,
	  onDelete: _propTypes2.default.func,
	  onDropError: _propTypes2.default.func,
	  showStatusIcon: _propTypes2.default.bool,
	  submittedCloudFiles: _propTypes2.default.array,
	  submittedFiles: _propTypes2.default.array,
	  t: _propTypes2.default.func,
	  uploadButtons: _propTypes2.default.node,
	  uploader: _propTypes2.default.object
	}, _class2.defaultProps = {
	  multiple: true
	}, _temp)) || _class);
	exports.default = UploadArea;
	module.exports = exports['default'];

/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _UploadStatusBaseClass = __webpack_require__(514);
	
	var _UploadStatusBaseClass2 = _interopRequireDefault(_UploadStatusBaseClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UploadStatus = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(UploadStatus, _Component);
	
	  function UploadStatus() {
	    (0, _classCallCheck3.default)(this, UploadStatus);
	    return (0, _possibleConstructorReturn3.default)(this, (UploadStatus.__proto__ || (0, _getPrototypeOf2.default)(UploadStatus)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(UploadStatus, [{
	    key: 'render',
	    value: function render() {
	      var className = this.props.className;
	
	
	      return _react2.default.createElement(
	        'span',
	        { className: className },
	        this.uploadStatus
	      );
	    }
	  }]);
	  return UploadStatus;
	}(_UploadStatusBaseClass2.default), _class.propTypes = {
	  className: _propTypes2.default.string
	}, _class.defaultProps = {
	  className: ''
	}, _temp);
	exports.default = UploadStatus;
	module.exports = exports['default'];

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _UploadStatusBaseClass = __webpack_require__(514);
	
	var _UploadStatusBaseClass2 = _interopRequireDefault(_UploadStatusBaseClass);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _components = __webpack_require__(15);
	
	var _uploads = __webpack_require__(112);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(147);
	
	var UploadStatusIcon = (_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(UploadStatusIcon, _Component);
	
	  function UploadStatusIcon() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, UploadStatusIcon);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = UploadStatusIcon.__proto__ || (0, _getPrototypeOf2.default)(UploadStatusIcon)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { processingStatus: false };
	    return _this;
	  }
	
	  (0, _createClass3.default)(UploadStatusIcon, [{
	    key: 'setProcessing',
	    value: function setProcessing(val) {
	      this.setState({ processingStatus: val });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      var _this2 = this;
	
	      var _props = this.props,
	          onCancel = _props.onCancel,
	          onDelete = _props.onDelete,
	          uploader = _props.uploader,
	          id = _props.id;
	      var _state = this.state,
	          isComplete = _state.isComplete,
	          isSuccess = _state.isSuccess;
	
	
	      if (isSuccess) {
	        if (onDelete) {
	          this.setProcessing(true);
	
	          onDelete().then(function () {
	            uploader.methods.cancel(id);
	            _this2.setProcessing(false);
	          }).catch(function () {
	            return _this2.setProcessing(false);
	          });
	        }
	      } else if (!isComplete) {
	        uploader.methods.cancel(id);
	        if (onCancel) {
	          onCancel();
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          containerClassName = _props2.containerClassName,
	          cancelable = _props2.cancelable,
	          deletable = _props2.deletable;
	      var _state2 = this.state,
	          status = _state2.status,
	          progress = _state2.progress,
	          isSuccess = _state2.isSuccess,
	          isComplete = _state2.isComplete,
	          processingStatus = _state2.processingStatus;
	
	      var isProcessing = progress === 100 && status === _uploads.STATUS.UPLOADING || processingStatus;
	      var renderRes = null;
	
	      if (isProcessing) {
	        renderRes = _react2.default.createElement(_components.Loader, { size: 16 });
	      } else if (isSuccess) {
	        renderRes = deletable ? _react2.default.createElement('i', { className: (0, _bind2.default)('statusIcon', className, styles.statusIcon, 'icon-close colorError'), onClick: this.cancel }) : _react2.default.createElement('i', { className: (0, _bind2.default)('statusIcon', className, styles.statusIcon, 'icon-check colorSuccess') });
	      } else if (!isComplete) {
	        if (cancelable) {
	          renderRes = _react2.default.createElement('i', { className: (0, _bind2.default)('statusIcon', className, styles.statusIcon, 'icon-close colorError'), onClick: this.cancel });
	        }
	      }
	
	      return _react2.default.createElement(
	        'span',
	        { className: (0, _bind2.default)('statusIconContainer', styles.statusIconContainer, containerClassName) },
	        renderRes
	      );
	    }
	  }]);
	  return UploadStatusIcon;
	}(_UploadStatusBaseClass2.default), _class2.propTypes = {
	  cancelable: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  containerClassName: _propTypes2.default.string,
	  deletable: _propTypes2.default.bool,
	  id: _propTypes2.default.number,
	  onCancel: _propTypes2.default.func,
	  onDelete: _propTypes2.default.func,
	  uploader: _propTypes2.default.object
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'cancel', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'cancel'), _class.prototype)), _class);
	exports.default = UploadStatusIcon;
	module.exports = exports['default'];

/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _uploads = __webpack_require__(112);
	
	var _components = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UploaderFilesize = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(UploaderFilesize, _Component);
	
	  function UploaderFilesize(args) {
	    (0, _classCallCheck3.default)(this, UploaderFilesize);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (UploaderFilesize.__proto__ || (0, _getPrototypeOf2.default)(UploaderFilesize)).call(this, args));
	
	    _this.state = {
	      size: (0, _uploads.getSize)(args.uploader, args.id)
	    };
	
	    _this.initUploaderEvents();
	    return _this;
	  }
	
	  (0, _createClass3.default)(UploaderFilesize, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this._onUploadHandler) {
	        this.props.uploader.on('upload', this._onUploadHandler);
	      }
	      this.props.uploader.on('submit', this._onSubmitHandler);
	      this.props.uploader.on('statusChange', this._onStatusChangeHandler);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return nextState.size !== this.state.size;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._unmounted = true;
	      if (this._onUploadHandler) {
	        this.props.uploader.off('upload', this._onUploadHandler);
	      }
	      this.props.uploader.off('submit', this._onSubmitHandler);
	      this.props.uploader.off('statusChange', this._onStatusChangeHandler);
	    }
	  }, {
	    key: 'updateSize',
	    value: function updateSize(id) {
	      if (this._unmounted) {
	        return false;
	      }
	      this.setState({
	        size: (0, _uploads.getSize)(this.props.uploader, id)
	      });
	    }
	  }, {
	    key: 'initUploaderEvents',
	    value: function initUploaderEvents() {
	      var _this2 = this;
	
	      // Don't bother to check size at upload time if scaling feature is not enabled.
	      var scalingOption = this.props.uploader.options.scaling;
	      if (scalingOption && scalingOption.sizes.length) {
	        // If this is a scaled image, the size won't be known until upload time.
	        this._onUploadHandler = function (id) {
	          if (id === _this2.props.id) {
	            _this2.updateSize(id);
	          }
	        };
	      }
	
	      this._onSubmitHandler = function () {
	        if (_this2._isTotalProgress) {
	          _this2.updateSize();
	        }
	      };
	
	      this._onStatusChangeHandler = function () {
	        if (_this2._isTotalProgress) {
	          _this2.updateSize();
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          units = _props.units;
	      var size = this.state.size;
	
	
	      return _react2.default.createElement(_components.FileSize, { size: size, units: units, className: className });
	    }
	  }, {
	    key: '_isTotalProgress',
	    get: function get() {
	      return typeof this.props.id === 'undefined';
	    }
	  }]);
	  return UploaderFilesize;
	}(_react.Component), _class.propTypes = {
	  className: _propTypes2.default.string,
	  id: _propTypes2.default.number,
	  units: _propTypes2.default.object,
	  uploader: _propTypes2.default.object.isRequired
	}, _temp);
	exports.default = UploaderFilesize;
	module.exports = exports['default'];

/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _components = __webpack_require__(15);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(147);
	
	var UploaderItem = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(UploaderItem, _Component);
	
	  function UploaderItem() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, UploaderItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = UploaderItem.__proto__ || (0, _getPrototypeOf2.default)(UploaderItem)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { uploadSuccess: false };
	    _this._createEventHandlers();
	    return _this;
	  }
	
	  (0, _createClass3.default)(UploaderItem, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.uploader.on('complete', this._onComplete);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._unmounted = true;
	      this._unregisterEventHandlers();
	    }
	  }, {
	    key: '_unregisterEventHandlers',
	    value: function _unregisterEventHandlers() {
	      this.props.uploader.off('complete', this._onComplete);
	    }
	  }, {
	    key: '_createEventHandlers',
	    value: function _createEventHandlers() {
	      var _this2 = this;
	
	      this._onComplete = function (id, name, resp) {
	        console.log(resp);
	        if (id === _this2.props.id && !_this2._unmounted && resp.data.success) {
	          _this2.setState({ uploadSuccess: true });
	        }
	      };
	    }
	  }, {
	    key: 'uploaderThumbNode',
	    value: function uploaderThumbNode() {
	      var _props = this.props,
	          id = _props.id,
	          uploader = _props.uploader,
	          maxSize = _props.maxSize;
	
	      return _react2.default.createElement(_components.UploaderThumb, { id: id, uploader: uploader, maxSize: maxSize });
	    }
	  }, {
	    key: 'fileExtNode',
	    value: function fileExtNode() {
	      var _props2 = this.props,
	          id = _props2.id,
	          uploader = _props2.uploader;
	
	      return _react2.default.createElement(_components.FileName, { id: id, uploader: uploader, hideName: true });
	    }
	  }, {
	    key: 'fileNameNode',
	    value: function fileNameNode() {
	      var _props3 = this.props,
	          id = _props3.id,
	          uploader = _props3.uploader;
	
	      return _react2.default.createElement(_components.FileName, { id: id, uploader: uploader });
	    }
	  }, {
	    key: 'uploadStatusNode',
	    value: function uploadStatusNode() {
	      var _props4 = this.props,
	          id = _props4.id,
	          uploader = _props4.uploader;
	
	      return _react2.default.createElement(_components.UploadStatus, { id: id, uploader: uploader });
	    }
	  }, {
	    key: 'fileSizeNode',
	    value: function fileSizeNode() {
	      var _props5 = this.props,
	          id = _props5.id,
	          uploader = _props5.uploader;
	
	      return _react2.default.createElement(_components.UploaderFilesize, { id: id, uploader: uploader, className: styles.fileSize });
	    }
	  }, {
	    key: 'progressBarNode',
	    value: function progressBarNode() {
	      var _props6 = this.props,
	          id = _props6.id,
	          uploader = _props6.uploader,
	          altStyle = _props6.altStyle;
	
	      return _react2.default.createElement(_components.ProgressBar, { id: id, uploader: uploader, className: styles.progressBar, altStyle: altStyle });
	    }
	  }, {
	    key: 'uploadStatusIconNode',
	    value: function uploadStatusIconNode() {
	      var _props7 = this.props,
	          id = _props7.id,
	          uploader = _props7.uploader,
	          cancelable = _props7.cancelable,
	          deletable = _props7.deletable,
	          onCancel = _props7.onCancel,
	          onDelete = _props7.onDelete;
	
	      return _react2.default.createElement(_components.UploadStatusIcon, {
	        className: styles.statusIcon,
	        cancelable: cancelable,
	        deletable: deletable,
	        id: id,
	        uploader: uploader,
	        onCancel: onCancel,
	        onDelete: onDelete
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props8 = this.props,
	          className = _props8.className,
	          showOnSuccess = _props8.showOnSuccess,
	          showThumb = _props8.showThumb;
	      var uploadSuccess = this.state.uploadSuccess;
	
	
	      return _react2.default.createElement(_components.UniversalUploaderItem, {
	        className: (0, _classnames2.default)(className, { hidden: !showOnSuccess && uploadSuccess }),
	        showThumb: showThumb,
	        fileExtNode: this.fileExtNode(),
	        fileNameNode: this.fileNameNode(),
	        uploadStatusNode: this.uploadStatusNode(),
	        fileSizeNode: this.fileSizeNode(),
	        progressBarNode: this.progressBarNode(),
	        uploadStatusIconNode: this.uploadStatusIconNode(),
	        uploaderThumbNode: this.uploaderThumbNode()
	      });
	    }
	  }]);
	  return UploaderItem;
	}(_react.Component), _class.propTypes = {
	  altStyle: _propTypes2.default.bool,
	  cancelable: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  deletable: _propTypes2.default.bool,
	  id: _propTypes2.default.number.isRequired,
	  maxSize: _propTypes2.default.number,
	  onCancel: _propTypes2.default.func,
	  onDelete: _propTypes2.default.func,
	  showOnSuccess: _propTypes2.default.bool,
	  showThumb: _propTypes2.default.bool,
	  uploader: _propTypes2.default.object.isRequired
	}, _class.defaultProps = {
	  maxSize: 70
	}, _temp);
	exports.default = UploaderItem;
	module.exports = exports['default'];

/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _assign = __webpack_require__(186);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _toConsumableArray2 = __webpack_require__(34);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _promise = __webpack_require__(62);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _weakMap = __webpack_require__(541);
	
	var _weakMap2 = _interopRequireDefault(_weakMap);
	
	var _callbackNames = __webpack_require__(824);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var privateData = new _weakMap2.default();
	var callbacks = new _weakMap2.default();
	
	var executeThenableCallback = function executeThenableCallback(_ref) {
	  var registeredCallbacks = _ref.registeredCallbacks,
	      originalCallbackArguments = _ref.originalCallbackArguments;
	  return new _promise2.default(function (resolve, reject) {
	    var callback = registeredCallbacks.pop();
	
	    var returnValue = callback.apply(undefined, (0, _toConsumableArray3.default)(originalCallbackArguments));
	
	    if (returnValue && returnValue.then) {
	      returnValue.then(function (result) {
	        if (registeredCallbacks.length) {
	          executeThenableCallback({ registeredCallbacks: registeredCallbacks, originalCallbackArguments: originalCallbackArguments }).then(resolve, reject);
	        } else {
	          resolve(result);
	        }
	      }).catch(function (error) {
	        return reject(error);
	      });
	    } else if (returnValue === false) {
	      reject();
	    } else if (registeredCallbacks.length) {
	      executeThenableCallback({ registeredCallbacks: registeredCallbacks, originalCallbackArguments: originalCallbackArguments }).then(resolve, reject);
	    } else {
	      resolve();
	    }
	  });
	};
	
	var executeThenableCallbacks = function executeThenableCallbacks(_ref2) {
	  var registeredCallbacks = _ref2.registeredCallbacks,
	      originalCallbackArguments = _ref2.originalCallbackArguments;
	
	  if (registeredCallbacks.length) {
	    return executeThenableCallback({
	      registeredCallbacks: (0, _assign2.default)([], registeredCallbacks).reverse(),
	      originalCallbackArguments: originalCallbackArguments
	    });
	  }
	
	  return _promise2.default.resolve();
	};
	
	var getProxyFunction = function getProxyFunction(_ref3) {
	  var name = _ref3.name;
	
	  var proxyClassContext = this;
	
	  return function () {
	    for (var _len = arguments.length, originalCallbackArguments = Array(_len), _key = 0; _key < _len; _key++) {
	      originalCallbackArguments[_key] = arguments[_key];
	    }
	
	    var isThenable = _callbackNames.thenable.indexOf(name) >= 0;
	    var registeredCallbacks = callbacks.get(proxyClassContext);
	    var callbackReturnValue = void 0;
	
	    if (isThenable) {
	      callbackReturnValue = executeThenableCallbacks({ registeredCallbacks: registeredCallbacks, originalCallbackArguments: originalCallbackArguments });
	    } else {
	      (0, _assign2.default)([], registeredCallbacks).every(function (callback) {
	        var returnValue = callback.apply(undefined, originalCallbackArguments);
	
	        callbackReturnValue = returnValue;
	
	        return returnValue !== false;
	      });
	    }
	
	    return callbackReturnValue;
	  };
	};
	
	var CallbackProxy = function () {
	  function CallbackProxy(name) {
	    (0, _classCallCheck3.default)(this, CallbackProxy);
	
	    callbacks.set(this, []);
	
	    privateData.set(this, {
	      name: name,
	      proxyFunction: getProxyFunction.call(this, { name: name })
	    });
	  }
	
	  (0, _createClass3.default)(CallbackProxy, [{
	    key: 'add',
	    value: function add(callback) {
	      callbacks.get(this).push(callback);
	    }
	  }, {
	    key: 'remove',
	    value: function remove(callback) {
	      var index = callbacks.get(this).indexOf(callback);
	      if (index >= 0) {
	        callbacks.get(this).splice(index, 1);
	      }
	    }
	  }, {
	    key: 'name',
	    get: function get() {
	      return privateData.get(this).name;
	    }
	  }, {
	    key: 'proxyFunction',
	    get: function get() {
	      return privateData.get(this).proxyFunction;
	    }
	  }]);
	  return CallbackProxy;
	}();
	
	exports.default = CallbackProxy;
	module.exports = exports['default'];

/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _containers = __webpack_require__(213);
	
	var _Link = __webpack_require__(82);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1267);
	
	var Footer = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(Footer, _Component);
	
	  function Footer() {
	    (0, _classCallCheck3.default)(this, Footer);
	    return (0, _possibleConstructorReturn3.default)(this, (Footer.__proto__ || (0, _getPrototypeOf2.default)(Footer)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Footer, [{
	    key: 'openContactForm',
	    value: function openContactForm() {
	      this.loginContact.getWrappedInstance().open();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var t = this.props.t;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.footer },
	        _react2.default.createElement(
	          'div',
	          { className: 'homeContent' },
	          _react2.default.createElement(
	            'div',
	            { className: styles.links },
	            _react2.default.createElement(
	              _Link2.default,
	              { to: '/info/terms-of-service' },
	              t('Terms of service')
	            ),
	            _react2.default.createElement(
	              _Link2.default,
	              { to: '/info/security' },
	              t('Security')
	            ),
	            _react2.default.createElement(
	              _Link2.default,
	              { to: '/info/copyright-policy' },
	              t('Copyright Policy')
	            ),
	            _react2.default.createElement(
	              _Link2.default,
	              { to: '/info/privacy-policy' },
	              t('Privacy Policy')
	            ),
	            _react2.default.createElement(
	              _Link2.default,
	              { to: '/info/cookie-policy' },
	              t('Cookie Policy')
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'a', onClick: this.openContactForm },
	              t('Contact Us')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: styles.footerCopyright },
	            '\xA9 2011-',
	            new Date().getFullYear(),
	            ' Secure Arts Ltd'
	          )
	        ),
	        _react2.default.createElement(_containers.LoginContact, { ref: function ref(el) {
	            return _this2.loginContact = el;
	          } })
	      );
	    }
	  }]);
	  return Footer;
	}(_react.Component), _class3.propTypes = {
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'openContactForm', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'openContactForm'), _class2.prototype)), _class2)) || _class);
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _auth = __webpack_require__(31);
	
	var authActions = _interopRequireWildcard(_auth);
	
	var _reactI18next = __webpack_require__(12);
	
	var _reduxForm = __webpack_require__(50);
	
	var _formComponents = __webpack_require__(71);
	
	var _components = __webpack_require__(15);
	
	var _auth2 = __webpack_require__(77);
	
	var _ForgotPasswordFormValidation = __webpack_require__(2010);
	
	var _ForgotPasswordFormValidation2 = _interopRequireDefault(_ForgotPasswordFormValidation);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _auth3 = __webpack_require__(356);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var formSelector = (0, _reduxForm.formValueSelector)('forgotPasswordForm');
	
	var styles = __webpack_require__(1268);
	
	var ForgotPasswordForm = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    loginFormState: state.auth.loginFormState,
	    newPasswordValue: formSelector(state, 'newPassword'),
	    termsAccepted: state.auth.termsAccepted,
	    user: (0, _auth2.getUser)(state)
	  };
	}, (0, _extends3.default)({}, authActions)), _dec2 = (0, _reduxForm.reduxForm)({
	  form: 'forgotPasswordForm',
	  propNamespace: 'forgotPasswordForm',
	  validate: _ForgotPasswordFormValidation2.default
	}), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(ForgotPasswordForm, _Component);
	
	  function ForgotPasswordForm() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, ForgotPasswordForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = ForgotPasswordForm.__proto__ || (0, _getPrototypeOf2.default)(ForgotPasswordForm)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { step: _this.props.step };
	    return _this;
	  }
	
	  (0, _createClass3.default)(ForgotPasswordForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.initForm({ userEmail: this.props.passwordEmail });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.passwordEmail !== this.props.passwordEmail) {
	        this.initForm({ userEmail: nextProps.passwordEmail });
	      }
	    }
	  }, {
	    key: 'getFormHint',
	    value: function getFormHint() {
	      var _hints;
	
	      var _props = this.props,
	          loginFormState = _props.loginFormState,
	          t = _props.t;
	
	      var hints = (_hints = {}, (0, _defineProperty3.default)(_hints, _auth3.loginFormStates.reset, t('Your password has expired. You need to create a new password.')), (0, _defineProperty3.default)(_hints, _auth3.loginFormStates.unlock, t('Your account is locked due to too many failed passwords. You need to reset your password to unlock it.')), _hints);
	      return hints[loginFormState] || '';
	    }
	  }, {
	    key: 'setSubmit',
	    value: function setSubmit(formData) {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          setNewPassword = _props2.setNewPassword,
	          passwordCode = _props2.passwordCode,
	          passwordKey = _props2.passwordKey,
	          afterSet = _props2.afterSet,
	          isNew = _props2.isNew;
	
	      return setNewPassword(passwordCode, passwordKey, (0, _extends3.default)({}, formData, { isNew: isNew })).promise.then(function (resp) {
	        _this2.setState({ step: 'afterSet' });
	        afterSet((0, _extends3.default)({}, resp.data, formData));
	      });
	    }
	  }, {
	    key: 'isWarningHint',
	    value: function isWarningHint() {
	      var loginFormState = this.props.loginFormState;
	
	      return [_auth3.loginFormStates.reset, _auth3.loginFormStates.unlock].includes(loginFormState);
	    }
	  }, {
	    key: 'initForm',
	    value: function initForm(props) {
	      this.props.forgotPasswordForm.initialize(props);
	    }
	  }, {
	    key: 'resetSubmit',
	    value: function resetSubmit(formData) {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          resetPassword = _props3.resetPassword,
	          changePassword = _props3.changePassword,
	          user = _props3.user;
	
	      var promise = user ? changePassword({ userEmail: user.userEmail }).promise : resetPassword(formData).promise;
	      return promise.then(function () {
	        _this3.setState({ step: 'afterReset' });
	      });
	    }
	  }, {
	    key: 'submit',
	    value: function submit(formData) {
	      var step = this.state.step;
	
	      var submitMethod = this[step + 'Submit'];
	      return submitMethod ? submitMethod(formData) : false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props4 = this.props,
	          t = _props4.t,
	          isNew = _props4.isNew,
	          user = _props4.user,
	          newPasswordValue = _props4.newPasswordValue,
	          showCancel = _props4.showCancel,
	          onCancel = _props4.onCancel,
	          termsAccepted = _props4.termsAccepted,
	          className = _props4.className,
	          termsHintClassName = _props4.termsHintClassName,
	          _props4$forgotPasswor = _props4.forgotPasswordForm,
	          handleSubmit = _props4$forgotPasswor.handleSubmit,
	          submitting = _props4$forgotPasswor.submitting,
	          invalid = _props4$forgotPasswor.invalid,
	          error = _props4$forgotPasswor.error;
	      var step = this.state.step;
	
	      var isSubmitDisabled = submitting || step === 'set' && invalid || step === 'reset' && !user && !termsAccepted;
	      var hint = this.getFormHint();
	      var isWarningHint = this.isWarningHint();
	
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit(this.submit) },
	        step === 'reset' && _react2.default.createElement(
	          'div',
	          null,
	          user ? _react2.default.createElement(
	            'div',
	            { className: className },
	            _react2.default.createElement(
	              'p',
	              { className: 'hint' },
	              t('Press the button to request password changing')
	            )
	          ) : _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: className },
	              _react2.default.createElement(
	                'p',
	                { className: 'danger' },
	                hint
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: (0, _classnames2.default)(styles.hint, 'hint small', (0, _defineProperty3.default)({}, styles.isWarning, isWarningHint)) },
	                t('Please enter your email below to initiate the process')
	              ),
	              _react2.default.createElement(_reduxForm.Field, {
	                name: 'userEmail',
	                type: 'email',
	                fieldClassName: 'width-perc-100',
	                placeholder: t('Email') + '*',
	                hideLabel: true,
	                component: _formComponents.formSimpleTextInput,
	                required: true
	              })
	            ),
	            _react2.default.createElement(_components.TermsAcceptance, { className: (0, _classnames2.default)(className, 'margin-top-20'), hintClassName: termsHintClassName })
	          )
	        ),
	        step === 'afterReset' && _react2.default.createElement(
	          'div',
	          { className: className },
	          _react2.default.createElement(
	            'h3',
	            null,
	            t('Password reset - Check your email')
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            t('We have sent you an email with reset instructions. If the email does not arrive soon, check your spam folder. It was sent from mailer@cright.com')
	          )
	        ),
	        step === 'set' && _react2.default.createElement(
	          'div',
	          { className: className },
	          _react2.default.createElement(
	            'p',
	            { className: 'hint' },
	            isNew ? t('Create your own unique password') : t('Please enter your new password')
	          ),
	          _react2.default.createElement(_reduxForm.Field, {
	            name: 'newPassword',
	            type: 'password',
	            fieldClassName: 'width-perc-100',
	            placeholder: (isNew ? t('Password') : t('New password')) + '*',
	            hideLabel: true,
	            component: _formComponents.formSimpleTextInput,
	            autoComplete: 'off',
	            required: true
	          }),
	          _react2.default.createElement(_reduxForm.Field, {
	            name: 'confPassword',
	            type: 'password',
	            fieldClassName: 'width-perc-100',
	            placeholder: t('Confirm password') + '*',
	            hideLabel: true,
	            component: _formComponents.formSimpleTextInput,
	            autoComplete: 'off',
	            required: true
	          }),
	          _react2.default.createElement(_components.PasswordValidationTicks, { errors: error, value: newPasswordValue })
	        ),
	        step === 'afterSet' && _react2.default.createElement(
	          'div',
	          { className: className },
	          _react2.default.createElement(
	            'h3',
	            null,
	            t('Password changed')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: className },
	          step !== 'afterReset' && step !== 'afterSet' && _react2.default.createElement(
	            _components.Button,
	            {
	              type: 'submit',
	              className: 'btn-primary wide margin-top-10 margin-left-10 pull-right',
	              disabled: isSubmitDisabled
	            },
	            step === 'reset' ? t('Send') : t('Ok'),
	            submitting && _react2.default.createElement(_components.Loader, { mask: true })
	          ),
	          step === 'set' && !isNew && _react2.default.createElement(
	            'button',
	            { type: 'button', className: 'btn btn-default wide margin-top-10 pull-right', onClick: function onClick() {
	                return _this4.setState({ step: 'reset' });
	              } },
	            t('Cancel')
	          ),
	          showCancel && _react2.default.createElement(
	            'button',
	            { type: 'button', className: 'btn btn-default margin-top-10', onClick: onCancel },
	            step === 'afterReset' ? t('Ok') : t('Cancel')
	          )
	        )
	      );
	    }
	  }]);
	  return ForgotPasswordForm;
	}(_react.Component), _class3.propTypes = {
	  afterSet: _propTypes2.default.func,
	  changePassword: _propTypes2.default.func,
	  className: _propTypes2.default.string,
	  forgotPasswordForm: _propTypes2.default.object,
	  isNew: _propTypes2.default.bool,
	  loginFormState: _propTypes2.default.string,
	  newPasswordValue: _propTypes2.default.string,
	  onCancel: _propTypes2.default.func,
	  passwordCode: _propTypes2.default.string,
	  passwordEmail: _propTypes2.default.string,
	  passwordKey: _propTypes2.default.string,
	  resetPassword: _propTypes2.default.func,
	  setNewPassword: _propTypes2.default.func,
	  showCancel: _propTypes2.default.bool,
	  step: _propTypes2.default.string,
	  t: _propTypes2.default.func,
	  termsAccepted: _propTypes2.default.bool,
	  termsHintClassName: _propTypes2.default.string,
	  user: _propTypes2.default.object
	}, _class3.defaultProps = {
	  onCancel: function onCancel() {},
	  step: 'reset'
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'setSubmit', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setSubmit'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetSubmit', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetSubmit'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'submit', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'submit'), _class2.prototype)), _class2)) || _class) || _class) || _class);
	exports.default = ForgotPasswordForm;
	module.exports = exports['default'];

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _validation = __webpack_require__(157);
	
	var validate = function validate(values) {
	  var newPassword = values.newPassword,
	      confPassword = values.confPassword;
	
	  var t = __webpack_require__(56).getT();
	  var errors = {
	    _error: null
	  };
	
	  if (newPassword && confPassword && newPassword !== confPassword) {
	    errors.confPassword = t('Password and confirmation do not match');
	  }
	
	  errors._error = (0, _validation.passwordCondition)(newPassword);
	
	  return errors;
	};
	
	exports.default = validate;
	module.exports = exports['default'];

/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _propTypes3 = __webpack_require__(127);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormRow = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(FormRow, _PureComponent);
	
	  function FormRow() {
	    (0, _classCallCheck3.default)(this, FormRow);
	    return (0, _possibleConstructorReturn3.default)(this, (FormRow.__proto__ || (0, _getPrototypeOf2.default)(FormRow)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(FormRow, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          children = _props.children,
	          title = _props.title,
	          hint = _props.hint,
	          titleClass = _props.titleClass,
	          fieldClass = _props.fieldClass,
	          hintClass = _props.hintClass,
	          isRequired = _props.isRequired;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)('formRow', className) },
	        title && _react2.default.createElement(
	          'div',
	          { className: titleClass },
	          title,
	          isRequired ? '*' : ''
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: fieldClass },
	          children
	        ),
	        hint && _react2.default.createElement(
	          'div',
	          { className: hintClass },
	          hint
	        )
	      );
	    }
	  }]);
	  return FormRow;
	}(_react.PureComponent), _class.propTypes = {
	  children: _propTypes3.nodes,
	  className: _propTypes2.default.string,
	  fieldClass: _propTypes2.default.string,
	  hint: _propTypes3.nodes,
	  hintClass: _propTypes2.default.string,
	  isRequired: _propTypes2.default.bool,
	  title: _propTypes3.nodes,
	  titleClass: _propTypes2.default.string
	}, _temp);
	exports.default = FormRow;
	module.exports = exports['default'];

/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(102);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.default = initGoogleAnalytics;
	
	var _log = __webpack_require__(267);
	
	var _log2 = _interopRequireDefault(_log);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function initGoogleAnalytics() {
	  if (typeof window === 'undefined') {
	    return _log2.default.w('Init GA error. Window is not defined');
	  }
	
	  /**
	   * GA doesn't have a node package
	   * File downloaded from https://www.google-analytics.com/analytics.js
	   */
	  (function () {
	    console.log('INIT GA SCRIPT');var $c = function $c(a) {
	      this.w = a || [];
	    };$c.prototype.set = function (a) {
	      this.w[a] = !0;
	    };$c.prototype.encode = function () {
	      for (var a = [], b = 0; b < this.w.length; b++) {
	        this.w[b] && (a[Math.floor(b / 6)] ^= 1 << b % 6);
	      }for (b = 0; b < a.length; b++) {
	        a[b] = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_".charAt(a[b] || 0);
	      }return a.join("") + "~";
	    };var vd = new $c();function J(a) {
	      vd.set(a);
	    }var Nd = function Nd(a, b) {
	      var c = new $c(Dd(a));c.set(b);a.set(Gd, c.w);
	    },
	        Td = function Td(a) {
	      a = Dd(a);a = new $c(a);for (var b = vd.w.slice(), c = 0; c < a.w.length; c++) {
	        b[c] = b[c] || a.w[c];
	      }return new $c(b).encode();
	    },
	        Dd = function Dd(a) {
	      a = a.get(Gd);ka(a) || (a = []);return a;
	    };var ea = function ea(a) {
	      return "function" == typeof a;
	    },
	        ka = function ka(a) {
	      return "[object Array]" == Object.prototype.toString.call(Object(a));
	    },
	        qa = function qa(a) {
	      return void 0 != a && -1 < (a.constructor + "").indexOf("String");
	    },
	        D = function D(a, b) {
	      return 0 == a.indexOf(b);
	    },
	        sa = function sa(a) {
	      return a ? a.replace(/^[\s\xa0]+|[\s\xa0]+$/g, "") : "";
	    },
	        ga = function ga() {
	      for (var a = O.navigator.userAgent + (M.cookie ? M.cookie : "") + (M.referrer ? M.referrer : ""), b = a.length, c = O.history.length; 0 < c;) {
	        a += c-- ^ b++;
	      }return [hd() ^ La(a) & 2147483647, Math.round(new Date().getTime() / 1E3)].join(".");
	    },
	        ta = function ta(a) {
	      var b = M.createElement("img");b.width = 1;b.height = 1;b.src = a;return b;
	    },
	        ua = function ua() {},
	        K = function K(a) {
	      if (encodeURIComponent instanceof Function) return encodeURIComponent(a);J(28);return a;
	    },
	        L = function L(a, b, c, d) {
	      try {
	        a.addEventListener ? a.addEventListener(b, c, !!d) : a.attachEvent && a.attachEvent("on" + b, c);
	      } catch (e) {
	        J(27);
	      }
	    },
	        f = /^[\w\-:/.?=&%!]+$/,
	        wa = function wa(a, b, c, d) {
	      a && (c ? (d = "", b && f.test(b) && (d = ' id="' + b + '"'), f.test(a) && M.write("<script" + d + ' src="' + a + '">\x3c/script>')) : (c = M.createElement("script"), c.type = "text/javascript", c.async = !0, c.src = a, d && (c.onload = d), b && (c.id = b), a = M.getElementsByTagName("script")[0], a.parentNode.insertBefore(c, a)));
	    },
	        Ud = function Ud() {
	      return "https:" == M.location.protocol;
	    },
	        E = function E(a, b) {
	      return (a = a.match("(?:&|#|\\?)" + K(b).replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1") + "=([^&#]*)")) && 2 == a.length ? a[1] : "";
	    },
	        xa = function xa() {
	      var a = "" + M.location.hostname;return 0 == a.indexOf("www.") ? a.substring(4) : a;
	    },
	        ya = function ya(a) {
	      var b = M.referrer;if (/^https?:\/\//i.test(b)) {
	        if (a) return b;a = "//" + M.location.hostname;
	        var c = b.indexOf(a);if (5 == c || 6 == c) if (a = b.charAt(c + a.length), "/" == a || "?" == a || "" == a || ":" == a) return;return b;
	      }
	    },
	        za = function za(a, b) {
	      if (1 == b.length && null != b[0] && "object" === (0, _typeof3.default)(b[0])) return b[0];for (var c = {}, d = Math.min(a.length + 1, b.length), e = 0; e < d; e++) {
	        if ("object" === (0, _typeof3.default)(b[e])) {
	          for (var g in b[e]) {
	            b[e].hasOwnProperty(g) && (c[g] = b[e][g]);
	          }break;
	        } else e < a.length && (c[a[e]] = b[e]);
	      }return c;
	    };var ee = function ee() {
	      this.keys = [];this.values = {};this.m = {};
	    };ee.prototype.set = function (a, b, c) {
	      this.keys.push(a);c ? this.m[":" + a] = b : this.values[":" + a] = b;
	    };ee.prototype.get = function (a) {
	      return this.m.hasOwnProperty(":" + a) ? this.m[":" + a] : this.values[":" + a];
	    };ee.prototype.map = function (a) {
	      for (var b = 0; b < this.keys.length; b++) {
	        var c = this.keys[b],
	            d = this.get(c);d && a(c, d);
	      }
	    };var O = window,
	        M = document;var F = window,
	        G = function G(a) {
	      var b = F._gaUserPrefs;if (b && b.ioo && b.ioo() || a && !0 === F["ga-disable-" + a]) return !0;try {
	        var c = F.external;if (c && c._gaUserPrefs && "oo" == c._gaUserPrefs) return !0;
	      } catch (d) {}return !1;
	    };var Ca = function Ca(a) {
	      var b = [],
	          c = M.cookie.split(";");a = new RegExp("^\\s*" + a + "=\\s*(.*?)\\s*$");for (var d = 0; d < c.length; d++) {
	        var e = c[d].match(a);e && b.push(e[1]);
	      }return b;
	    },
	        zc = function zc(a, b, c, d, e, g) {
	      e = G(e) ? !1 : eb.test(M.location.hostname) || "/" == c && vc.test(d) ? !1 : !0;if (!e) return !1;b && 1200 < b.length && (b = b.substring(0, 1200), J(24));c = a + "=" + b + "; path=" + c + "; ";g && (c += "expires=" + new Date(new Date().getTime() + g).toGMTString() + "; ");d && "none" != d && (c += "domain=" + d + ";");d = M.cookie;M.cookie = c;if (!(d = d != M.cookie)) a: {
	        a = Ca(a);for (d = 0; d < a.length; d++) {
	          if (b == a[d]) {
	            d = !0;break a;
	          }
	        }d = !1;
	      }return d;
	    },
	        Cc = function Cc(a) {
	      return K(a).replace(/\(/g, "%28").replace(/\)/g, "%29");
	    },
	        vc = /^(www\.)?google(\.com?)?(\.[a-z]{2})?$/,
	        eb = /(^|\.)doubleclick\.net$/i;var oc = function oc() {
	      return (Ba || Ud() ? "https:" : "http:") + "//www.google-analytics.com";
	    },
	        Da = function Da(a) {
	      this.name = "len";this.message = a + "-8192";
	    },
	        ba = function ba(a, b, c) {
	      c = c || ua;if (2036 >= b.length) wc(a, b, c);else if (8192 >= b.length) x(a, b, c) || wd(a, b, c) || wc(a, b, c);else throw ge("len", b.length), new Da(b.length);
	    },
	        wc = function wc(a, b, c) {
	      var d = ta(a + "?" + b);d.onload = d.onerror = function () {
	        d.onload = null;d.onerror = null;c();
	      };
	    },
	        wd = function wd(a, b, c) {
	      var d = O.XMLHttpRequest;if (!d) return !1;var e = new d();if (!("withCredentials" in e)) return !1;
	      a = a.replace(/^http:/, "https:");e.open("POST", a, !0);e.withCredentials = !0;e.setRequestHeader("Content-Type", "text/plain");e.onreadystatechange = function () {
	        4 == e.readyState && (c(), e = null);
	      };e.send(b);return !0;
	    },
	        x = function x(a, b, c) {
	      return O.navigator.sendBeacon ? O.navigator.sendBeacon(a, b) ? (c(), !0) : !1 : !1;
	    },
	        ge = function ge(a, b, c) {
	      1 <= 100 * Math.random() || G("?") || (a = ["t=error", "_e=" + a, "_v=j56", "sr=1"], b && a.push("_f=" + b), c && a.push("_m=" + K(c.substring(0, 100))), a.push("aip=1"), a.push("z=" + hd()), wc(oc() + "/collect", a.join("&"), ua));
	    };var h = function h(a) {
	      var b = O.gaData = O.gaData || {};return b[a] = b[a] || {};
	    };var Ha = function Ha() {
	      this.M = [];
	    };Ha.prototype.add = function (a) {
	      this.M.push(a);
	    };Ha.prototype.D = function (a) {
	      try {
	        for (var b = 0; b < this.M.length; b++) {
	          var c = a.get(this.M[b]);c && ea(c) && c.call(O, a);
	        }
	      } catch (d) {}b = a.get(Ia);b != ua && ea(b) && (a.set(Ia, ua, !0), setTimeout(b, 10));
	    };function Ja(a) {
	      if (100 != a.get(Ka) && La(P(a, Q)) % 1E4 >= 100 * R(a, Ka)) throw "abort";
	    }function Ma(a) {
	      if (G(P(a, Na))) throw "abort";
	    }function Oa() {
	      var a = M.location.protocol;if ("http:" != a && "https:" != a) throw "abort";
	    }
	    function Pa(a) {
	      try {
	        O.navigator.sendBeacon ? J(42) : O.XMLHttpRequest && "withCredentials" in new O.XMLHttpRequest() && J(40);
	      } catch (c) {}a.set(ld, Td(a), !0);a.set(Ac, R(a, Ac) + 1);var b = [];Qa.map(function (c, d) {
	        d.F && (c = a.get(c), void 0 != c && c != d.defaultValue && ("boolean" == typeof c && (c *= 1), b.push(d.F + "=" + K("" + c))));
	      });b.push("z=" + Bd());a.set(Ra, b.join("&"), !0);
	    }
	    function Sa(a) {
	      var b = P(a, gd) || oc() + "/collect",
	          c = P(a, fa);!c && a.get(Vd) && (c = "beacon");if (c) {
	        var d = P(a, Ra),
	            e = a.get(Ia),
	            e = e || ua;"image" == c ? wc(b, d, e) : "xhr" == c && wd(b, d, e) || "beacon" == c && x(b, d, e) || ba(b, d, e);
	      } else ba(b, P(a, Ra), a.get(Ia));b = a.get(Na);b = h(b);c = b.hitcount;b.hitcount = c ? c + 1 : 1;b = a.get(Na);delete h(b).pending_experiments;a.set(Ia, ua, !0);
	    }
	    function Hc(a) {
	      (O.gaData = O.gaData || {}).expId && a.set(Nc, (O.gaData = O.gaData || {}).expId);(O.gaData = O.gaData || {}).expVar && a.set(Oc, (O.gaData = O.gaData || {}).expVar);var b = a.get(Na);if (b = h(b).pending_experiments) {
	        var c = [];for (d in b) {
	          b.hasOwnProperty(d) && b[d] && c.push(encodeURIComponent(d) + "." + encodeURIComponent(b[d]));
	        }var d = c.join("!");
	      } else d = void 0;d && a.set(m, d, !0);
	    }function cd() {
	      if (O.navigator && "preview" == O.navigator.loadPurpose) throw "abort";
	    }
	    function yd(a) {
	      var b = O.gaDevIds;ka(b) && 0 != b.length && a.set("&did", b.join(","), !0);
	    }function vb(a) {
	      if (!a.get(Na)) throw "abort";
	    };var hd = function hd() {
	      return Math.round(2147483647 * Math.random());
	    },
	        Bd = function Bd() {
	      try {
	        var a = new Uint32Array(1);O.crypto.getRandomValues(a);return a[0] & 2147483647;
	      } catch (b) {
	        return hd();
	      }
	    };function Ta(a) {
	      var b = R(a, Ua);500 <= b && J(15);var c = P(a, Va);if ("transaction" != c && "item" != c) {
	        var c = R(a, Wa),
	            d = new Date().getTime(),
	            e = R(a, Xa);0 == e && a.set(Xa, d);e = Math.round(2 * (d - e) / 1E3);0 < e && (c = Math.min(c + e, 20), a.set(Xa, d));if (0 >= c) throw "abort";a.set(Wa, --c);
	      }a.set(Ua, ++b);
	    };var Ya = function Ya() {
	      this.data = new ee();
	    },
	        Qa = new ee(),
	        Za = [];Ya.prototype.get = function (a) {
	      var b = $a(a),
	          c = this.data.get(a);b && void 0 == c && (c = ea(b.defaultValue) ? b.defaultValue() : b.defaultValue);return b && b.Z ? b.Z(this, a, c) : c;
	    };var P = function P(a, b) {
	      a = a.get(b);return void 0 == a ? "" : "" + a;
	    },
	        R = function R(a, b) {
	      a = a.get(b);return void 0 == a || "" === a ? 0 : 1 * a;
	    };Ya.prototype.set = function (a, b, c) {
	      if (a) if ("object" == (typeof a === 'undefined' ? 'undefined' : (0, _typeof3.default)(a))) for (var d in a) {
	        a.hasOwnProperty(d) && ab(this, d, a[d], c);
	      } else ab(this, a, b, c);
	    };
	    var ab = function ab(a, b, c, d) {
	      if (void 0 != c) switch (b) {case Na:
	          wb.test(c);}var e = $a(b);e && e.o ? e.o(a, b, c, d) : a.data.set(b, c, d);
	    },
	        bb = function bb(a, b, c, d, e) {
	      this.name = a;this.F = b;this.Z = d;this.o = e;this.defaultValue = c;
	    },
	        $a = function $a(a) {
	      var b = Qa.get(a);if (!b) for (var c = 0; c < Za.length; c++) {
	        var d = Za[c],
	            e = d[0].exec(a);if (e) {
	          b = d[1](e);Qa.set(b.name, b);break;
	        }
	      }return b;
	    },
	        yc = function yc(a) {
	      var b;Qa.map(function (c, d) {
	        d.F == a && (b = d);
	      });return b && b.name;
	    },
	        S = function S(a, b, c, d, e) {
	      a = new bb(a, b, c, d, e);Qa.set(a.name, a);return a.name;
	    },
	        cb = function cb(a, b) {
	      Za.push([new RegExp("^" + a + "$"), b]);
	    },
	        T = function T(a, b, c) {
	      return S(a, b, c, void 0, db);
	    },
	        db = function db() {};var gb = qa(window.GoogleAnalyticsObject) && sa(window.GoogleAnalyticsObject) || "ga",
	        Ba = !1,
	        hb = T("apiVersion", "v"),
	        ib = T("clientVersion", "_v");S("anonymizeIp", "aip");var jb = S("adSenseId", "a"),
	        Va = S("hitType", "t"),
	        Ia = S("hitCallback"),
	        Ra = S("hitPayload");S("nonInteraction", "ni");S("currencyCode", "cu");S("dataSource", "ds");var Vd = S("useBeacon", void 0, !1),
	        fa = S("transport");S("sessionControl", "sc", "");S("sessionGroup", "sg");S("queueTime", "qt");var Ac = S("_s", "_s");S("screenName", "cd");
	    var kb = S("location", "dl", ""),
	        lb = S("referrer", "dr"),
	        mb = S("page", "dp", "");S("hostname", "dh");var nb = S("language", "ul"),
	        ob = S("encoding", "de");S("title", "dt", function () {
	      return M.title || void 0;
	    });cb("contentGroup([0-9]+)", function (a) {
	      return new bb(a[0], "cg" + a[1]);
	    });var pb = S("screenColors", "sd"),
	        qb = S("screenResolution", "sr"),
	        rb = S("viewportSize", "vp"),
	        sb = S("javaEnabled", "je"),
	        tb = S("flashVersion", "fl");S("campaignId", "ci");S("campaignName", "cn");S("campaignSource", "cs");S("campaignMedium", "cm");
	    S("campaignKeyword", "ck");S("campaignContent", "cc");var ub = S("eventCategory", "ec"),
	        xb = S("eventAction", "ea"),
	        yb = S("eventLabel", "el"),
	        zb = S("eventValue", "ev"),
	        Bb = S("socialNetwork", "sn"),
	        Cb = S("socialAction", "sa"),
	        Db = S("socialTarget", "st"),
	        Eb = S("l1", "plt"),
	        Fb = S("l2", "pdt"),
	        Gb = S("l3", "dns"),
	        Hb = S("l4", "rrt"),
	        Ib = S("l5", "srt"),
	        Jb = S("l6", "tcp"),
	        Kb = S("l7", "dit"),
	        Lb = S("l8", "clt"),
	        Mb = S("timingCategory", "utc"),
	        Nb = S("timingVar", "utv"),
	        Ob = S("timingLabel", "utl"),
	        Pb = S("timingValue", "utt");S("appName", "an");
	    S("appVersion", "av", "");S("appId", "aid", "");S("appInstallerId", "aiid", "");S("exDescription", "exd");S("exFatal", "exf");var Nc = S("expId", "xid"),
	        Oc = S("expVar", "xvar"),
	        m = S("exp", "exp"),
	        Rc = S("_utma", "_utma"),
	        Sc = S("_utmz", "_utmz"),
	        Tc = S("_utmht", "_utmht"),
	        Ua = S("_hc", void 0, 0),
	        Xa = S("_ti", void 0, 0),
	        Wa = S("_to", void 0, 20);cb("dimension([0-9]+)", function (a) {
	      return new bb(a[0], "cd" + a[1]);
	    });cb("metric([0-9]+)", function (a) {
	      return new bb(a[0], "cm" + a[1]);
	    });S("linkerParam", void 0, void 0, Bc, db);
	    var ld = S("usage", "_u"),
	        Gd = S("_um");S("forceSSL", void 0, void 0, function () {
	      return Ba;
	    }, function (a, b, c) {
	      J(34);Ba = !!c;
	    });var ed = S("_j1", "jid"),
	        ia = S("_j2", "gjid");cb("\\&(.*)", function (a) {
	      var b = new bb(a[0], a[1]),
	          c = yc(a[0].substring(1));c && (b.Z = function (a) {
	        return a.get(c);
	      }, b.o = function (a, b, g, ca) {
	        a.set(c, g, ca);
	      }, b.F = void 0);return b;
	    });
	    var Qb = T("_oot"),
	        dd = S("previewTask"),
	        Rb = S("checkProtocolTask"),
	        md = S("validationTask"),
	        Sb = S("checkStorageTask"),
	        Uc = S("historyImportTask"),
	        Tb = S("samplerTask"),
	        Vb = S("_rlt"),
	        Wb = S("buildHitTask"),
	        Xb = S("sendHitTask"),
	        Vc = S("ceTask"),
	        zd = S("devIdTask"),
	        Cd = S("timingTask"),
	        Ld = S("displayFeaturesTask"),
	        oa = S("customTask"),
	        V = T("name"),
	        Q = T("clientId", "cid"),
	        n = T("clientIdTime"),
	        Ad = S("userId", "uid"),
	        Na = T("trackingId", "tid"),
	        U = T("cookieName", void 0, "_ga"),
	        W = T("cookieDomain"),
	        Yb = T("cookiePath", void 0, "/"),
	        Zb = T("cookieExpires", void 0, 63072E3),
	        $b = T("legacyCookieDomain"),
	        Wc = T("legacyHistoryImport", void 0, !0),
	        ac = T("storage", void 0, "cookie"),
	        bc = T("allowLinker", void 0, !1),
	        cc = T("allowAnchor", void 0, !0),
	        Ka = T("sampleRate", "sf", 100),
	        dc = T("siteSpeedSampleRate", void 0, 1),
	        ec = T("alwaysSendReferrer", void 0, !1),
	        I = T("_gid", "_gid"),
	        ja = T("_ge"),
	        la = T("_gcn"),
	        gd = S("transportUrl"),
	        Md = S("_r", "_r");function X(a, b, c, d) {
	      b[a] = function () {
	        try {
	          return d && J(d), c.apply(this, arguments);
	        } catch (e) {
	          throw ge("exc", a, e && e.name), e;
	        }
	      };
	    };var Od = function Od(a, b, c) {
	      this.V = a;this.fa = b;this.$ = !1;this.oa = c;this.ea = 1;
	    },
	        Ed = function Ed(a, b, c) {
	      if (a.fa && a.$) return 0;a.$ = !0;if (b) {
	        if (a.oa && R(b, a.oa)) return R(b, a.oa);if (0 == b.get(dc)) return 0;
	      }if (0 == a.V) return 0;void 0 === c && (c = Bd());return 0 == c % a.V ? Math.floor(c / a.V) % a.ea + 1 : 0;
	    };function fc() {
	      var a, b;if ((b = (b = O.navigator) ? b.plugins : null) && b.length) for (var c = 0; c < b.length && !a; c++) {
	        var d = b[c];-1 < d.name.indexOf("Shockwave Flash") && (a = d.description);
	      }if (!a) try {
	        var e = new ActiveXObject("ShockwaveFlash.ShockwaveFlash.7");a = e.GetVariable("$version");
	      } catch (g) {}if (!a) try {
	        e = new ActiveXObject("ShockwaveFlash.ShockwaveFlash.6"), a = "WIN 6,0,21,0", e.AllowScriptAccess = "always", a = e.GetVariable("$version");
	      } catch (g) {}if (!a) try {
	        e = new ActiveXObject("ShockwaveFlash.ShockwaveFlash"), a = e.GetVariable("$version");
	      } catch (g) {}a && (e = a.match(/[\d]+/g)) && 3 <= e.length && (a = e[0] + "." + e[1] + " r" + e[2]);return a || void 0;
	    };var aa = function aa(a) {
	      var b = Math.min(R(a, dc), 100);return La(P(a, Q)) % 100 >= b ? !1 : !0;
	    },
	        gc = function gc(a) {
	      var b = {};if (Ec(b) || Fc(b)) {
	        var c = b[Eb];void 0 == c || Infinity == c || isNaN(c) || (0 < c ? (Y(b, Gb), Y(b, Jb), Y(b, Ib), Y(b, Fb), Y(b, Hb), Y(b, Kb), Y(b, Lb), setTimeout(function () {
	          a(b);
	        }, 10)) : L(O, "load", function () {
	          gc(a);
	        }, !1));
	      }
	    },
	        Ec = function Ec(a) {
	      var b = O.performance || O.webkitPerformance,
	          b = b && b.timing;if (!b) return !1;var c = b.navigationStart;if (0 == c) return !1;a[Eb] = b.loadEventStart - c;a[Gb] = b.domainLookupEnd - b.domainLookupStart;a[Jb] = b.connectEnd - b.connectStart;a[Ib] = b.responseStart - b.requestStart;a[Fb] = b.responseEnd - b.responseStart;a[Hb] = b.fetchStart - c;a[Kb] = b.domInteractive - c;a[Lb] = b.domContentLoadedEventStart - c;return !0;
	    },
	        Fc = function Fc(a) {
	      if (O.top != O) return !1;var b = O.external,
	          c = b && b.onloadT;b && !b.isValidLoadTime && (c = void 0);2147483648 < c && (c = void 0);0 < c && b.setPageReadyTime();if (void 0 == c) return !1;a[Eb] = c;return !0;
	    },
	        Y = function Y(a, b) {
	      var c = a[b];if (isNaN(c) || Infinity == c || 0 > c) a[b] = void 0;
	    },
	        Fd = function Fd(a) {
	      return function (b) {
	        if ("pageview" == b.get(Va) && !a.I) {
	          a.I = !0;var c = aa(b);b = 0 < E(b.get(kb), "gclid").length;(c || b) && gc(function (b) {
	            a.send(c ? "timing" : "adtiming", b);
	          });
	        }
	      };
	    };var hc = !1,
	        mc = function mc(a) {
	      "cookie" == P(a, ac) && (ma(a, Q, U), a.get(ja) && ma(a, I, la, 864E5));
	    },
	        ma = function ma(a, b, c, d) {
	      var e = nd(a, b);if (e) {
	        c = P(a, c);b = kc(P(a, Yb));var g = lc(P(a, W));d = d || 1E3 * R(a, Zb);var ca = P(a, Na);if ("auto" != g) zc(c, e, b, g, ca, d) && (hc = !0);else {
	          J(32);a: {
	            e = [];g = xa().split(".");if (4 == g.length) {
	              var l = g[g.length - 1];if (parseInt(l, 10) == l) {
	                l = ["none"];break a;
	              }
	            }for (l = g.length - 2; 0 <= l; l--) {
	              e.push(g.slice(l).join("."));
	            }e.push("none");l = e;
	          }for (var k = 0; k < l.length; k++) {
	            if (g = l[k], a.data.set(W, g), e = nd(a, Q), zc(c, e, b, g, ca, d)) {
	              hc = !0;return;
	            }
	          }a.data.set(W, "auto");
	        }
	      } else a.get(ja) || J(54);
	    },
	        nc = function nc(a) {
	      if ("cookie" == P(a, ac) && !hc && (mc(a), !hc)) throw "abort";
	    },
	        Yc = function Yc(a) {
	      if (a.get(Wc)) {
	        var b = P(a, W),
	            c = P(a, $b) || xa(),
	            d = Xc("__utma", c, b);d && (J(19), a.set(Tc, new Date().getTime(), !0), a.set(Rc, d.R), (b = Xc("__utmz", c, b)) && d.hash == b.hash && a.set(Sc, b.R));
	      }
	    },
	        nd = function nd(a, b) {
	      b = Cc(P(a, b));var c = lc(P(a, W)).split(".").length;a = jc(P(a, Yb));1 < a && (c += "-" + a);return b ? ["GA1", c, b].join(".") : "";
	    },
	        na = function na(a, b) {
	      if (!b || 1 > b.length) J(12);else {
	        for (var c = [], d = 0; d < b.length; d++) {
	          var e = b[d];var g = e.split(".");var ca = g.shift();("GA1" == ca || "1" == ca) && 1 < g.length ? (e = g.shift().split("-"), 1 == e.length && (e[1] = "1"), e[0] *= 1, e[1] *= 1, g = { H: e, s: g.join(".") }) : g = /^amp-/.test(e) ? { H: [0, 0], s: e } : void 0;g && c.push(g);
	        }if (1 == c.length) return J(13), c[0].s;if (0 == c.length) J(12);else {
	          J(14);b = lc(P(a, W)).split(".").length;c = Gc(c, b, 0);if (1 == c.length) return c[0].s;a = jc(P(a, Yb));c = Gc(c, a, 1);1 < c.length && J(41);return c[0] && c[0].s;
	        }
	      }
	    },
	        Gc = function Gc(a, b, c) {
	      for (var d = [], e = [], g, ca = 0; ca < a.length; ca++) {
	        var l = a[ca];l.H[c] == b ? d.push(l) : void 0 == g || l.H[c] < g ? (e = [l], g = l.H[c]) : l.H[c] == g && e.push(l);
	      }return 0 < d.length ? d : e;
	    },
	        lc = function lc(a) {
	      return 0 == a.indexOf(".") ? a.substr(1) : a;
	    },
	        kc = function kc(a) {
	      if (!a) return "/";1 < a.length && a.lastIndexOf("/") == a.length - 1 && (a = a.substr(0, a.length - 1));0 != a.indexOf("/") && (a = "/" + a);return a;
	    },
	        jc = function jc(a) {
	      a = kc(a);return "/" == a ? 1 : a.split("/").length;
	    };function Xc(a, b, c) {
	      "none" == b && (b = "");var d = [],
	          e = Ca(a);a = "__utma" == a ? 6 : 2;for (var g = 0; g < e.length; g++) {
	        var ca = ("" + e[g]).split(".");ca.length >= a && d.push({ hash: ca[0], R: e[g], O: ca });
	      }if (0 != d.length) return 1 == d.length ? d[0] : Zc(b, d) || Zc(c, d) || Zc(null, d) || d[0];
	    }function Zc(a, b) {
	      if (null == a) var c = a = 1;else c = La(a), a = La(D(a, ".") ? a.substring(1) : "." + a);for (var d = 0; d < b.length; d++) {
	        if (b[d].hash == c || b[d].hash == a) return b[d];
	      }
	    };var od = new RegExp(/^https?:\/\/([^\/:]+)/),
	        pd = /(.*)([?&#])(?:_ga=[^&#]*)(?:&?)(.*)/;function Bc(a) {
	      var b = a.get(Q);if (a.get(ja)) {
	        var c = a.get(I);a = pa(c + b, 0);return "_ga=2." + K(a + "." + c + "-" + b);
	      }a = pa(b, 0);return "_ga=1." + K(a + "." + b);
	    }function Ic(a, b) {
	      var c = new Date(),
	          d = O.navigator,
	          e = d.plugins || [];a = [a, d.userAgent, c.getTimezoneOffset(), c.getYear(), c.getDate(), c.getHours(), c.getMinutes() + b];for (b = 0; b < e.length; ++b) {
	        a.push(e[b].description);
	      }return La(a.join("."));
	    }
	    function pa(a, b) {
	      var c = new Date(),
	          d = O.navigator;return La([a, d.userAgent, d.language || "", c.getTimezoneOffset(), c.getYear(), c.getDate(), c.getHours(), c.getMinutes() + b].join("."));
	    }var Dc = function Dc(a) {
	      J(48);this.target = a;this.T = !1;
	    };Dc.prototype.ca = function (a, b) {
	      if (a.tagName) {
	        if ("a" == a.tagName.toLowerCase()) {
	          a.href && (a.href = qd(this, a.href, b));return;
	        }if ("form" == a.tagName.toLowerCase()) return rd(this, a);
	      }if ("string" == typeof a) return qd(this, a, b);
	    };
	    var qd = function qd(a, b, c) {
	      var d = pd.exec(b);d && 3 <= d.length && (b = d[1] + (d[3] ? d[2] + d[3] : ""));a = a.target.get("linkerParam");var e = b.indexOf("?"),
	          d = b.indexOf("#");c ? b += (-1 == d ? "#" : "&") + a : (c = -1 == e ? "?" : "&", b = -1 == d ? b + (c + a) : b.substring(0, d) + c + a + b.substring(d));return b = b.replace(/&+_ga=/, "&_ga=");
	    },
	        rd = function rd(a, b) {
	      if (b && b.action) if ("get" == b.method.toLowerCase()) {
	        a = a.target.get("linkerParam").split("=")[1];for (var c = b.childNodes || [], d = 0; d < c.length; d++) {
	          if ("_ga" == c[d].name) {
	            c[d].setAttribute("value", a);return;
	          }
	        }c = M.createElement("input");
	        c.setAttribute("type", "hidden");c.setAttribute("name", "_ga");c.setAttribute("value", a);b.appendChild(c);
	      } else "post" == b.method.toLowerCase() && (b.action = qd(a, b.action));
	    };
	    Dc.prototype.S = function (a, b, c) {
	      function d(c) {
	        try {
	          c = c || O.event;a: {
	            var d = c.target || c.srcElement;for (c = 100; d && 0 < c;) {
	              if (d.href && d.nodeName.match(/^a(?:rea)?$/i)) {
	                var g = d;break a;
	              }d = d.parentNode;c--;
	            }g = {};
	          }("http:" == g.protocol || "https:" == g.protocol) && sd(a, g.hostname || "") && g.href && (g.href = qd(e, g.href, b));
	        } catch (k) {
	          J(26);
	        }
	      }var e = this;this.T || (this.T = !0, L(M, "mousedown", d, !1), L(M, "keyup", d, !1));c && L(M, "submit", function (b) {
	        b = b || O.event;if ((b = b.target || b.srcElement) && b.action) {
	          var c = b.action.match(od);c && sd(a, c[1]) && rd(e, b);
	        }
	      });
	    };function sd(a, b) {
	      if (b == M.location.hostname) return !1;for (var c = 0; c < a.length; c++) {
	        if (a[c] instanceof RegExp) {
	          if (a[c].test(b)) return !0;
	        } else if (0 <= b.indexOf(a[c])) return !0;
	      }return !1;
	    };var p = /^(GTM|OPT)-[A-Z0-9]+$/,
	        q = /;_gaexp=[^;]*/g,
	        r = /;((__utma=)|([^;=]+=GAX?\d+\.))[^;]*/g,
	        Aa = /^https?:\/\/[\w\-.]+\.google.com(:\d+)?\/optimize\/opt-launch\.html\?.*$/,
	        t = function t(a) {
	      function b(a, b) {
	        b && (c += "&" + a + "=" + K(b));
	      }var c = "https://www.google-analytics.com/gtm/js?id=" + K(a.id);"dataLayer" != a.B && b("l", a.B);b("t", a.target);b("cid", a.clientId);b("cidt", a.ka);b("gac", a.la);b("aip", a.ia);a.sync && b("m", "sync");b("cycle", a.G);a.qa && b("gclid", a.qa);Aa.test(M.referrer) && b("cb", String(hd()));return c;
	    };var Jd = function Jd(a, b, c) {
	      this.U = ed;this.aa = b;(b = c) || (b = (b = P(a, V)) && "t0" != b ? Wd.test(b) ? "_gat_" + Cc(P(a, Na)) : "_gat_" + Cc(b) : "_gat");this.Y = b;
	    },
	        Rd = function Rd(a, b) {
	      var c = b.get(Wb);b.set(Wb, function (b) {
	        Pd(a, b, a.U);Pd(a, b, ia);var d = c(b);Qd(a, b);return d;
	      });var d = b.get(Xb);b.set(Xb, function (b) {
	        var c = d(b);Id(a, b);return c;
	      });
	    },
	        Pd = function Pd(a, b, c) {
	      b.get(c) || ("1" == Ca(a.Y)[0] ? b.set(c, "", !0) : b.set(c, "" + hd(), !0));
	    },
	        Qd = function Qd(a, b) {
	      b.get(a.U) && zc(a.Y, "1", b.get(Yb), b.get(W), b.get(Na), 6E4);
	    },
	        Id = function Id(a, b) {
	      if (b.get(a.U)) {
	        var c = new ee(),
	            d = function d(a) {
	          $a(a).F && c.set($a(a).F, b.get(a));
	        };d(hb);d(ib);d(Na);d(Q);d(Ad);d(a.U);d(ia);d(I);c.set($a(ld).F, Td(b));var e = a.aa;c.map(function (a, b) {
	          e += K(a) + "=";e += K("" + b) + "&";
	        });e += "z=" + hd();ta(e);b.set(a.U, "", !0);
	      }
	    },
	        Wd = /^gtm\d+$/;var fd = function fd(a, b) {
	      a = a.b;if (!a.get("dcLoaded")) {
	        Nd(a, 29);b = b || {};var c;b[U] && (c = Cc(b[U]));b = new Jd(a, "https://stats.g.doubleclick.net/r/collect?t=dc&aip=1&_r=3&", c);Rd(b, a);a.set("dcLoaded", !0);
	      }
	    };var Sd = function Sd(a) {
	      if (!a.get("dcLoaded") && "cookie" == a.get(ac)) {
	        Nd(a, 51);var b = new Jd(a);Pd(b, a, b.U);Pd(b, a, ia);Qd(b, a);a.get(b.U) && (a.set(Md, 1, !0), a.set(gd, oc() + "/r/collect", !0));
	      }
	    };var Lc = function Lc() {
	      var a = O.gaGlobal = O.gaGlobal || {};return a.hid = a.hid || hd();
	    };var ad,
	        bd = function bd(a, b, c) {
	      if (!ad) {
	        var d = M.location.hash;var e = O.name,
	            g = /^#?gaso=([^&]*)/;if (e = (d = (d = d && d.match(g) || e && e.match(g)) ? d[1] : Ca("GASO")[0] || "") && d.match(/^(?:!([-0-9a-z.]{1,40})!)?([-.\w]{10,1200})$/i)) zc("GASO", "" + d, c, b, a, 0), window._udo || (window._udo = b), window._utcp || (window._utcp = c), a = e[1], wa("https://www.google.com/analytics/web/inpage/pub/inpage.js?" + (a ? "prefix=" + a + "&" : "") + hd(), "_gasojs");ad = !0;
	      }
	    };var H = function H(a) {
	      return a ? (1 * a).toFixed(3) : "0";
	    },
	        da = function da(a) {
	      var b = O.performance;if (b && b.getEntriesByName) {
	        J(35);var c = "https://www.google-analytics.com/analytics.js?wpid=" + a;wa(c, void 0, void 0, function () {
	          try {
	            var d = 1,
	                e = b.getEntriesByName("https://www.google-analytics.com/analytics.js");e && 0 != e.length || (e = b.getEntriesByName("http://www.google-analytics.com/analytics.js"), d = 0);var g = b.getEntriesByName(c);if (e && 1 == e.length && g && 1 == g.length) {
	              J(37);var ca = e[0],
	                  l = g[0],
	                  k = { tid: a, ad: H(ca.duration), bd: H(l.duration),
	                ar: H(ca.responseEnd - ca.requestStart), br: H(l.responseEnd - l.requestStart), an: H(ca.domainLookupEnd - ca.domainLookupStart), bn: H(l.domainLookupEnd - l.domainLookupStart), ac: H(ca.connectEnd - ca.connectStart), bc: H(l.connectEnd - l.connectStart), as: d },
	                  d = [];d.push("_v=j56");d.push("id=10");for (var w in k) {
	                k.hasOwnProperty(w) && d.push(w + "=" + K(k[w]));
	              }d.push("z=" + hd());wc("https://www.google-analytics.com/u/d", d.join("&"), ua);
	            }
	          } catch (ha) {}
	        });
	      }
	    };var wb = /^(UA|YT|MO|GP)-(\d+)-(\d+)$/,
	        pc = function pc(a) {
	      function b(a, b) {
	        d.b.data.set(a, b);
	      }function c(a, c) {
	        b(a, c);d.filters.add(a);
	      }var d = this;this.b = new Ya();this.filters = new Ha();b(V, a[V]);b(Na, sa(a[Na]));b(U, a[U]);b(W, a[W] || xa());b(Yb, a[Yb]);b(Zb, a[Zb]);b($b, a[$b]);b(Wc, a[Wc]);b(bc, a[bc]);b(cc, a[cc]);b(Ka, a[Ka]);b(dc, a[dc]);b(ec, a[ec]);b(ac, a[ac]);b(Ad, a[Ad]);b(n, a[n]);b(ja, a[ja]);b(hb, 1);b(ib, "j56");c(Qb, Ma);c(oa, ua);c(dd, cd);c(Rb, Oa);c(md, vb);c(Sb, nc);c(Uc, Yc);c(Tb, Ja);c(Vb, Ta);c(Vc, Hc);c(zd, yd);c(Ld, Sd);c(Wb, Pa);c(Xb, Sa);c(Cd, Fd(this));Jc(this.b, a[Q]);Kc(this.b);this.b.set(jb, Lc());bd(this.b.get(Na), this.b.get(W), this.b.get(Yb));this.ra = new Od(1E4, !0, "gaexp10");
	    },
	        Jc = function Jc(a, b) {
	      a.data.set(ja, a.get(ja) || 1 == Ed(new Od(1, !0), void 0, La(a.get(Q))));if (a.get(ja)) {
	        var c = P(a, U);a.data.set(la, "_ga" == c ? "_gid" : c + "_gid");
	      }if ("cookie" == P(a, ac)) {
	        hc = !1;c = Ca(P(a, U));if (!(c = na(a, c))) {
	          var c = P(a, W),
	              d = P(a, $b) || xa();c = Xc("__utma", d, c);void 0 != c ? (J(10), c = c.O[1] + "." + c.O[2]) : c = void 0;
	        }c && (a.data.set(Q, c), c = Ca(P(a, la)), (c = na(a, c)) && a.data.set(I, c), hc = !0);
	      }a: if (c = a.get(cc), d = E(M.location[c ? "href" : "search"], "_ga")) if (a.get(bc)) {
	        if (c = d.indexOf("."), -1 == c) J(22);else {
	          var e = d.substring(0, c),
	              g = d.substring(c + 1),
	              c = g.indexOf("."),
	              d = g.substring(0, c),
	              g = g.substring(c + 1);if ("1" == e) {
	            if (c = g, d != Ic(c, 0) && d != Ic(c, -1) && d != Ic(c, -2) && d != pa(c, 0) && d != pa(c, -1) && d != pa(c, -2)) {
	              J(23);break a;
	            }
	          } else if ("2" == e) {
	            c = g.indexOf("-");e = g.substring(0, c);c = g.substring(c + 1);if (d != Ic(e + c, 0) && d != Ic(e + c, -1) && d != Ic(e + c, -2) && d != pa(e + c, 0) && d != pa(e + c, -1) && d != pa(e + c, -2)) {
	              J(53);break a;
	            }J(2);a.data.set(I, e);
	          } else {
	            J(22);break a;
	          }J(11);a.data.set(Q, c);
	        }
	      } else J(21);b && (J(9), a.data.set(Q, K(b)));a.get(Q) || ((b = (b = O.gaGlobal && O.gaGlobal.vid) && -1 != b.search(/^(?:utma\.)?\d+\.\d+$/) ? b : void 0) ? (J(17), a.data.set(Q, b)) : (J(8), a.data.set(Q, ga())));a.get(ja) && !a.get(I) && (J(3), a.data.set(I, ga()));mc(a);
	    },
	        Kc = function Kc(a) {
	      var b = O.navigator,
	          c = O.screen,
	          d = M.location;a.set(lb, ya(a.get(ec)));if (d) {
	        var e = d.pathname || "";"/" != e.charAt(0) && (J(31), e = "/" + e);a.set(kb, d.protocol + "//" + d.hostname + e + d.search);
	      }c && a.set(qb, c.width + "x" + c.height);c && a.set(pb, c.colorDepth + "-bit");var c = M.documentElement,
	          g = (e = M.body) && e.clientWidth && e.clientHeight,
	          ca = [];c && c.clientWidth && c.clientHeight && ("CSS1Compat" === M.compatMode || !g) ? ca = [c.clientWidth, c.clientHeight] : g && (ca = [e.clientWidth, e.clientHeight]);c = 0 >= ca[0] || 0 >= ca[1] ? "" : ca.join("x");a.set(rb, c);a.set(tb, fc());a.set(ob, M.characterSet || M.charset);a.set(sb, b && "function" === typeof b.javaEnabled && b.javaEnabled() || !1);a.set(nb, (b && (b.language || b.browserLanguage) || "").toLowerCase());if (d && a.get(cc) && (b = M.location.hash)) {
	        b = b.split(/[?&#]+/);d = [];for (c = 0; c < b.length; ++c) {
	          (D(b[c], "utm_id") || D(b[c], "utm_campaign") || D(b[c], "utm_source") || D(b[c], "utm_medium") || D(b[c], "utm_term") || D(b[c], "utm_content") || D(b[c], "gclid") || D(b[c], "dclid") || D(b[c], "gclsrc")) && d.push(b[c]);
	        }0 < d.length && (b = "#" + d.join("&"), a.set(kb, a.get(kb) + b));
	      }
	    };pc.prototype.get = function (a) {
	      return this.b.get(a);
	    };pc.prototype.set = function (a, b) {
	      this.b.set(a, b);
	    };
	    var qc = { pageview: [mb], event: [ub, xb, yb, zb], social: [Bb, Cb, Db], timing: [Mb, Nb, Pb, Ob] };pc.prototype.send = function (a) {
	      if (!(1 > arguments.length)) {
	        if ("string" === typeof arguments[0]) {
	          var b = arguments[0];var c = [].slice.call(arguments, 1);
	        } else b = arguments[0] && arguments[0][Va], c = arguments;b && (c = za(qc[b] || [], c), c[Va] = b, this.b.set(c, void 0, !0), this.filters.D(this.b), this.b.data.m = {}, Ed(this.ra, this.b) && da(this.b.get(Na)));
	      }
	    };
	    pc.prototype.ma = function (a, b) {
	      var c = this;u(a, c, b) || (v(a, function () {
	        u(a, c, b);
	      }), y(String(c.get(V)), a, void 0, b, !0));
	    };var rc = function rc(a) {
	      if ("prerender" == M.visibilityState) return !1;a();return !0;
	    },
	        z = function z(a) {
	      if (!rc(a)) {
	        J(16);var b = !1,
	            c = function c() {
	          if (!b && rc(a)) {
	            b = !0;var d = c,
	                e = M;e.removeEventListener ? e.removeEventListener("visibilitychange", d, !1) : e.detachEvent && e.detachEvent("onvisibilitychange", d);
	          }
	        };L(M, "visibilitychange", c);
	      }
	    };var td = /^(?:(\w+)\.)?(?:(\w+):)?(\w+)$/,
	        sc = function sc(a) {
	      if (ea(a[0])) this.u = a[0];else {
	        var b = td.exec(a[0]);null != b && 4 == b.length && (this.c = b[1] || "t0", this.K = b[2] || "", this.C = b[3], this.a = [].slice.call(a, 1), this.K || (this.A = "create" == this.C, this.i = "require" == this.C, this.g = "provide" == this.C, this.ba = "remove" == this.C), this.i && (3 <= this.a.length ? (this.X = this.a[1], this.W = this.a[2]) : this.a[1] && (qa(this.a[1]) ? this.X = this.a[1] : this.W = this.a[1])));b = a[1];a = a[2];if (!this.C) throw "abort";if (this.i && (!qa(b) || "" == b)) throw "abort";
	        if (this.g && (!qa(b) || "" == b || !ea(a))) throw "abort";if (ud(this.c) || ud(this.K)) throw "abort";if (this.g && "t0" != this.c) throw "abort";
	      }
	    };function ud(a) {
	      return 0 <= a.indexOf(".") || 0 <= a.indexOf(":");
	    };var Yd, Zd, $d, A;Yd = new ee();$d = new ee();A = new ee();Zd = { ec: 45, ecommerce: 46, linkid: 47 };
	    var u = function u(a, b, c) {
	      b == N || b.get(V);var d = Yd.get(a);if (!ea(d)) return !1;b.plugins_ = b.plugins_ || new ee();if (b.plugins_.get(a)) return !0;b.plugins_.set(a, new d(b, c || {}));return !0;
	    },
	        y = function y(a, b, c, d, e) {
	      if (!ea(Yd.get(b)) && !$d.get(b)) {
	        Zd.hasOwnProperty(b) && J(Zd[b]);if (p.test(b)) {
	          J(52);a = N.j(a);if (!a) return !0;c = d || {};d = { id: b, B: c.dataLayer || "dataLayer", ia: !!a.get("anonymizeIp"), sync: e, G: !1 };a.get("&gtm") == b && (d.G = !0);var g = String(a.get("name"));"t0" != g && (d.target = g);G(String(a.get("trackingId"))) || (d.clientId = String(a.get(Q)), d.ka = Number(a.get(n)), c = c.palindrome ? r : q, c = (c = M.cookie.replace(/^|(; +)/g, ";").match(c)) ? c.sort().join("").substring(1) : void 0, d.la = c, d.qa = E(a.b.get(kb) || "", "gclid"));a = d.B;c = new Date().getTime();O[a] = O[a] || [];c = { "gtm.start": c };e || (c.event = "gtm.js");O[a].push(c);c = t(d);
	        }!c && Zd.hasOwnProperty(b) ? (J(39), c = b + ".js") : J(43);c && (c && 0 <= c.indexOf("/") || (c = (Ba || Ud() ? "https:" : "http:") + "//www.google-analytics.com/plugins/ua/" + c), d = ae(c), a = d.protocol, c = M.location.protocol, ("https:" == a || a == c || ("http:" != a ? 0 : "http:" == c)) && B(d) && (wa(d.url, void 0, e), $d.set(b, !0)));
	      }
	    },
	        v = function v(a, b) {
	      var c = A.get(a) || [];c.push(b);A.set(a, c);
	    },
	        C = function C(a, b) {
	      Yd.set(a, b);b = A.get(a) || [];for (var c = 0; c < b.length; c++) {
	        b[c]();
	      }A.set(a, []);
	    },
	        B = function B(a) {
	      var b = ae(M.location.href);if (D(a.url, "https://www.google-analytics.com/gtm/js?id=")) return !0;if (a.query || 0 <= a.url.indexOf("?") || 0 <= a.path.indexOf("://")) return !1;if (a.host == b.host && a.port == b.port) return !0;b = "http:" == a.protocol ? 80 : 443;return "www.google-analytics.com" == a.host && (a.port || b) == b && D(a.path, "/plugins/") ? !0 : !1;
	    },
	        ae = function ae(a) {
	      function b(a) {
	        var b = (a.hostname || "").split(":")[0].toLowerCase(),
	            c = (a.protocol || "").toLowerCase(),
	            c = 1 * a.port || ("http:" == c ? 80 : "https:" == c ? 443 : "");a = a.pathname || "";D(a, "/") || (a = "/" + a);return [b, "" + c, a];
	      }var c = M.createElement("a");c.href = M.location.href;var d = (c.protocol || "").toLowerCase(),
	          e = b(c),
	          g = c.search || "",
	          ca = d + "//" + e[0] + (e[1] ? ":" + e[1] : "");D(a, "//") ? a = d + a : D(a, "/") ? a = ca + a : !a || D(a, "?") ? a = ca + e[2] + (a || g) : 0 > a.split("/")[0].indexOf(":") && (a = ca + e[2].substring(0, e[2].lastIndexOf("/")) + "/" + a);c.href = a;d = b(c);return { protocol: (c.protocol || "").toLowerCase(), host: d[0], port: d[1], path: d[2], query: c.search || "", url: a || "" };
	    };var Z = { ga: function ga() {
	        Z.f = [];
	      } };Z.ga();Z.D = function (a) {
	      var b = Z.J.apply(Z, arguments),
	          b = Z.f.concat(b);for (Z.f = []; 0 < b.length && !Z.v(b[0]) && !(b.shift(), 0 < Z.f.length);) {}Z.f = Z.f.concat(b);
	    };Z.J = function (a) {
	      for (var b, c = [], d = 0; d < arguments.length; d++) {
	        try {
	          b = new sc(arguments[d]), b.g ? C(b.a[0], b.a[1]) : (b.i && (b.ha = y(b.c, b.a[0], b.X, b.W)), c.push(b));
	        } catch (e) {}
	      }return c;
	    };
	    Z.v = function (a) {
	      try {
	        if (a.u) a.u.call(O, N.j("t0"));else {
	          var b = a.c == gb ? N : N.j(a.c);if (a.A) "t0" != a.c || N.create.apply(N, a.a);else if (a.ba) N.remove(a.c);else if (b) if (a.i) {
	            if (a.ha && (a.ha = y(a.c, a.a[0], a.X, a.W)), !u(a.a[0], b, a.W)) return !0;
	          } else if (a.K) {
	            var c = a.C,
	                d = a.a,
	                e = b.plugins_.get(a.K);e[c].apply(e, d);
	          } else b[a.C].apply(b, a.a);
	        }
	      } catch (g) {}
	    };var N = function N(a) {
	      J(1);Z.D.apply(Z, [arguments]);
	    };N.h = {};N.P = [];N.L = 0;N.answer = 42;var uc = [Na, W, V];N.create = function (a) {
	      var b = za(uc, [].slice.call(arguments));b[V] || (b[V] = "t0");var c = "" + b[V];if (N.h[c]) return N.h[c];b = new pc(b);N.h[c] = b;N.P.push(b);return b;
	    };N.remove = function (a) {
	      for (var b = 0; b < N.P.length; b++) {
	        if (N.P[b].get(V) == a) {
	          N.P.splice(b, 1);N.h[a] = null;break;
	        }
	      }
	    };N.j = function (a) {
	      return N.h[a];
	    };N.getAll = function () {
	      return N.P.slice(0);
	    };
	    N.N = function () {
	      "ga" != gb && J(49);var a = O[gb];if (!a || 42 != a.answer) {
	        N.L = a && a.l;N.loaded = !0;var b = O[gb] = N;X("create", b, b.create);X("remove", b, b.remove);X("getByName", b, b.j, 5);X("getAll", b, b.getAll, 6);b = pc.prototype;X("get", b, b.get, 7);X("set", b, b.set, 4);X("send", b, b.send);X("requireSync", b, b.ma);b = Ya.prototype;X("get", b, b.get);X("set", b, b.set);if (!Ud() && !Ba) {
	          a: {
	            for (var b = M.getElementsByTagName("script"), c = 0; c < b.length && 100 > c; c++) {
	              var d = b[c].src;if (d && 0 == d.indexOf("https://www.google-analytics.com/analytics")) {
	                J(33);
	                b = !0;break a;
	              }
	            }b = !1;
	          }b && (Ba = !0);
	        }Ud() || Ba || !Ed(new Od(1E4)) || (J(36), Ba = !0);(O.gaplugins = O.gaplugins || {}).Linker = Dc;b = Dc.prototype;C("linker", Dc);X("decorate", b, b.ca, 20);X("autoLink", b, b.S, 25);C("displayfeatures", fd);C("adfeatures", fd);a = a && a.q;ka(a) ? Z.D.apply(N, a) : J(50);
	      }
	    };N.da = function () {
	      for (var a = N.getAll(), b = 0; b < a.length; b++) {
	        a[b].get(V);
	      }
	    };var ra = N.N,
	        va = O[gb];va && va.r ? ra() : z(ra);z(function () {
	      Z.D(["provide", "render", ua]);
	    });function La(a) {
	      var b = 1,
	          c;if (a) for (b = 0, c = a.length - 1; 0 <= c; c--) {
	        var d = a.charCodeAt(c);b = (b << 6 & 268435455) + d + (d << 14);d = b & 266338304;b = 0 != d ? b ^ d >> 21 : b;
	      }return b;
	    };
	  })(window);
	} /* eslint-disable */
	module.exports = exports['default'];

/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(365);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(113);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(102);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _log = __webpack_require__(267);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _googleAnalytics = __webpack_require__(2012);
	
	var _googleAnalytics2 = _interopRequireDefault(_googleAnalytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TAG = 'GA';
	var USE_EXTERNAL_SCRIPT = false;
	
	var GA = function () {
	  function GA() {
	    (0, _classCallCheck3.default)(this, GA);
	    this.trackerName = 'dev';
	
	    if (typeof window !== 'undefined' && !window.ga) {
	      /* eslint-disable */
	      if (USE_EXTERNAL_SCRIPT) {
	        (function (i, s, o, g, r, a, m) {
	          i['GoogleAnalyticsObject'] = r;i[r] = i[r] || function () {
	            (i[r].q = i[r].q || []).push(arguments);
	          }, i[r].l = 1 * new Date();a = s.createElement(o), m = s.getElementsByTagName(o)[0];a.async = 1;a.src = g;m.parentNode.insertBefore(a, m);
	        })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
	      } else {
	        window.ga = window.ga || function () {
	          (ga.q = ga.q || []).push(arguments);
	        };ga.l = +new Date();
	        (0, _googleAnalytics2.default)();
	      }
	      /* eslint-enable */
	    }
	
	    this.debug = (false);
	    this.trackers = {};
	  }
	
	  /**
	   * init:
	   * GA initialize
	   * @param {string} trackingId - GA key
	   * @param {Object} fieldsObject
	   * @param {string} [fieldsObject.name] - GA tracker name, default is "dev"
	   * @param {string} [fieldsObject.cookieDomain] - GA cookie domain
	   * @param {boolean} [debug] - debug mode
	   */
	
	
	  (0, _createClass3.default)(GA, [{
	    key: 'init',
	    value: function init(trackingId, fieldsObject) {
	      var debug = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (false);
	
	      if (!trackingId) {
	        return _log2.default.w(TAG, 'gaTrackingID is required in init()');
	      }
	      if (typeof window === 'undefined') {
	        return _log2.default.w(TAG, 'GA init error: window is undefined');
	      }
	
	      this.debug = debug;
	      var defaultFields = { trackingId: trackingId, cookieDomain: 'auto' };
	      if (fieldsObject.name) {
	        this.to(fieldsObject.name);
	      }
	      this.trackers[this.trackerName] = trackingId;
	
	      var params = (0, _extends3.default)({}, defaultFields, fieldsObject);
	      window.ga('create', params);
	      _log2.default.i(TAG, 'create', params);
	
	      if (this.debug) {
	        window.ga(function (tracker) {
	          return _log2.default.i(TAG, 'ready', tracker.get('clientId'));
	        });
	        _log2.default.i(TAG, 'GA created for tracking name = ' + this.trackerName + ' with key = ' + trackingId);
	      }
	
	      _log2.default.d(TAG, 'GA trackers', this.trackers);
	
	      return this;
	    }
	
	    /**
	     * to:
	     * GA set current analytics tracker name
	     * @param {string} trackerName - name of the current tracker
	     */
	
	  }, {
	    key: 'to',
	    value: function to(trackerName) {
	      this.trackerName = trackerName;
	      return this;
	    }
	
	    /**
	     * ga:
	     * Returns the original GA object.
	     */
	
	  }, {
	    key: 'set',
	
	
	    /**
	     * set:
	     * GA tracker set method
	     * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
	     */
	    value: function set(fieldsObject) {
	      if (!window.ga) {
	        return this;
	      }
	
	      if (!fieldsObject) {
	        _log2.default.w(TAG, '`fieldsObject` is required in .set()');
	        return this;
	      }
	
	      if ((typeof fieldsObject === 'undefined' ? 'undefined' : (0, _typeof3.default)(fieldsObject)) !== 'object') {
	        _log2.default.w(TAG, 'Expected `fieldsObject` arg to be an Object');
	        return this;
	      }
	
	      if (!(0, _keys2.default)(fieldsObject).length) {
	        _log2.default.w(TAG, 'empty `fieldsObject` given to .set()');
	      }
	
	      window.ga(this.trackerName + '.set', fieldsObject);
	
	      if (this.debug) {
	        _log2.default.i(TAG, 'called ga(\'' + this.trackerName + '.set\', fieldsObject) with fieldsObject: ', fieldsObject);
	      }
	
	      return this;
	    }
	
	    /**
	     * send:
	     * Clone of the low level `ga.send` method
	     * WARNING: No validations will be applied to this
	     * @param  {Object} fieldObject - field object for tracking different analytics
	     */
	
	  }, {
	    key: 'send',
	    value: function send(fieldObject) {
	      if (!window.ga) {
	        return this;
	      }
	
	      window.ga(this.trackerName + '.send', fieldObject);
	
	      if (this.debug) {
	        _log2.default.i(TAG, 'called ga(\'' + this.trackerName + '.send\', fieldObject); with fieldObject: ', fieldObject);
	      }
	
	      return this;
	    }
	
	    /**
	     * pageview:
	     * Basic GA pageview tracking
	     * @param  {String} path - the current page page e.g. '/about'
	     */
	
	  }, {
	    key: 'pageview',
	    value: function pageview() {
	      var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
	
	      if (!window.ga) {
	        return this;
	      }
	
	      if (!path) {
	        _log2.default.w(TAG, 'path is required in .pageview()');
	        return this;
	      }
	
	      window.ga(this.trackerName + '.send', 'pageview', path);
	
	      if (this.debug) {
	        _log2.default.i(TAG, 'called ga(\'' + this.trackerName + '.send\', \'pageview\', path); with path: ' + path);
	      }
	
	      return this;
	    }
	
	    /**
	     * event:
	     * GA event tracking
	     * @param args.category {String} required
	     * @param args.action {String} required
	     * @param args.label {String} optional
	     * @param args.value {Int} optional
	     * @param args.nonInteraction {boolean} optional
	     */
	
	  }, {
	    key: 'event',
	    value: function event(_ref) {
	      var category = _ref.category,
	          action = _ref.action,
	          label = _ref.label,
	          value = _ref.value,
	          transport = _ref.transport,
	          nonInteraction = _ref.nonInteraction;
	
	      if (!window.ga) {
	        return this;
	      }
	
	      // Simple Validation
	      if (!category || !action) {
	        _log2.default.w(TAG, 'args.category AND args.action are required in event()');
	        return this;
	      }
	
	      // Required Fields
	      var fieldObject = {
	        hitType: 'event',
	        eventCategory: category,
	        eventAction: action
	      };
	
	      // Optional Fields
	      if (label) {
	        fieldObject.eventLabel = label;
	      }
	
	      if (value) {
	        if (typeof value !== 'number') {
	          _log2.default.w(TAG, 'Expected `args.value` arg to be a Number.');
	        } else {
	          fieldObject.eventValue = value;
	        }
	      }
	
	      if (nonInteraction) {
	        fieldObject.nonInteraction = !!nonInteraction;
	      }
	
	      if (transport) {
	        if (typeof transport !== 'string') {
	          _log2.default.w(TAG, '`args.transport` must be a string.');
	        } else {
	          if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
	            _log2.default.w(TAG, '`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
	          }
	
	          fieldObject.transport = transport;
	        }
	      }
	
	      // Send to GA
	      return this.send(fieldObject);
	    }
	
	    /**
	     * exception:
	     * GA exception tracking
	     * @param args.description {String} optional
	     * @param args.fatal {boolean} optional
	     */
	
	  }, {
	    key: 'exception',
	    value: function exception(_ref2) {
	      var description = _ref2.description,
	          _ref2$fatal = _ref2.fatal,
	          fatal = _ref2$fatal === undefined ? false : _ref2$fatal;
	
	      if (!window.ga) {
	        return this;
	      }
	
	      // Required Fields
	      var fieldObject = {
	        hitType: 'exception'
	      };
	
	      // Optional Fields
	      if (description) {
	        try {
	          fieldObject.exDescription = (0, _stringify2.default)({
	            page: document.location.href,
	            description: description
	          });
	        } catch (err) {
	          _log2.default.w(TAG, 'Can not convert error object to JSON', description);
	        }
	      }
	
	      fieldObject.exFatal = fatal;
	
	      // Send to GA
	      return this.send(fieldObject);
	    }
	  }], [{
	    key: 'ga',
	    value: function ga() {
	      var _window;
	
	      if (!window.ga) {
	        return this;
	      }
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      (_window = window).ga.apply(_window, args);
	      if (this.debug) {
	        _log2.default.i(TAG, 'called ga(\'arguments\'); with arguments: ', args);
	      }
	
	      return window.ga;
	    }
	  }]);
	  return GA;
	}();
	
	exports.default = new GA();
	module.exports = exports['default'];

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _SearchBar = __webpack_require__(183);
	
	var _SearchBar2 = _interopRequireDefault(_SearchBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1269);
	
	var GroupContactsHeadLine = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(GroupContactsHeadLine, _PureComponent);
	
	  function GroupContactsHeadLine() {
	    (0, _classCallCheck3.default)(this, GroupContactsHeadLine);
	    return (0, _possibleConstructorReturn3.default)(this, (GroupContactsHeadLine.__proto__ || (0, _getPrototypeOf2.default)(GroupContactsHeadLine)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(GroupContactsHeadLine, [{
	    key: 'filter',
	    value: function filter(kw) {
	      var filter = this.props.filter;
	
	      filter(kw);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          count = _props.count,
	          kw = _props.kw;
	      var t = this.context.t;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(styles.headLine, className) },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_SearchBar2.default, {
	            kw: kw,
	            onChange: this.filter
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.count },
	          t('{{count}} contacts in group', { count: count })
	        )
	      );
	    }
	  }]);
	  return GroupContactsHeadLine;
	}(_react.PureComponent), _class2.propTypes = {
	  className: _propTypes2.default.string,
	  count: _propTypes2.default.number,
	  filter: _propTypes2.default.func,
	  kw: _propTypes2.default.string
	}, _class2.contextTypes = {
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'filter', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'filter'), _class.prototype)), _class);
	exports.default = GroupContactsHeadLine;
	module.exports = exports['default'];

/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _GroupContactsListItem = __webpack_require__(2016);
	
	var _GroupContactsListItem2 = _interopRequireDefault(_GroupContactsListItem);
	
	var _List = __webpack_require__(182);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _SelectableList2 = __webpack_require__(354);
	
	var _SelectableList3 = _interopRequireDefault(_SelectableList2);
	
	var _Loader = __webpack_require__(60);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1270);
	
	var GroupContactsList = (_class = (_temp = _class2 = function (_SelectableList) {
	  (0, _inherits3.default)(GroupContactsList, _SelectableList);
	
	  function GroupContactsList() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, GroupContactsList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = GroupContactsList.__proto__ || (0, _getPrototypeOf2.default)(GroupContactsList)).call.apply(_ref, [this].concat(args)));
	
	    _this.setConfig({
	      propsField: 'contacts',
	      updateFn: _this.props.updateCheckedGroupContacts,
	      checkedItemsPropsField: 'checkedGroupContacts'
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(GroupContactsList, [{
	    key: 'onRowClick',
	    value: function onRowClick(item) {
	      this.toggleItemChecked(item.id);
	    }
	  }, {
	    key: 'onSelectionChange',
	    value: function onSelectionChange(checkedItems) {
	      this.props.onSelectionChange(checkedItems);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          className = _props.className,
	          contacts = _props.contacts,
	          loading = _props.loading,
	          onDelete = _props.onDelete,
	          checkedGroupContacts = _props.checkedGroupContacts;
	
	
	      if (loading) {
	        return _react2.default.createElement(_Loader2.default, { alignCenter: true });
	      }
	
	      return _react2.default.createElement(
	        _List2.default,
	        { className: (0, _bind2.default)(styles.list, className) },
	        contacts.map(function (contact) {
	          return _react2.default.createElement(_GroupContactsListItem2.default, {
	            key: contact.id,
	            contact: contact,
	            checked: checkedGroupContacts[contact.id],
	            onClick: _this2.onRowClick,
	            onDelete: onDelete
	          });
	        })
	      );
	    }
	  }]);
	  return GroupContactsList;
	}(_SelectableList3.default), _class2.propTypes = {
	  checkedGroupContacts: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  contacts: _propTypes2.default.array,
	  loading: _propTypes2.default.bool,
	  onDelete: _propTypes2.default.func,
	  onSelectionChange: _propTypes2.default.func,
	  updateCheckedGroupContacts: _propTypes2.default.func
	}, _class2.defaultProps = {
	  checkedGroupContacts: {},
	  contacts: [],
	  onDelete: _noop3.default,
	  onSelectionChange: _noop3.default,
	  updateCheckedGroupContacts: _noop3.default
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onRowClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onRowClick'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onSelectionChange', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onSelectionChange'), _class.prototype)), _class);
	exports.default = GroupContactsList;
	module.exports = exports['default'];

/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _ListItem = __webpack_require__(76);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _utils = __webpack_require__(24);
	
	var _Checkbox = __webpack_require__(180);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1271);
	
	var GroupContactsListItem = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(GroupContactsListItem, _PureComponent);
	
	  function GroupContactsListItem() {
	    (0, _classCallCheck3.default)(this, GroupContactsListItem);
	    return (0, _possibleConstructorReturn3.default)(this, (GroupContactsListItem.__proto__ || (0, _getPrototypeOf2.default)(GroupContactsListItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(GroupContactsListItem, [{
	    key: 'onClick',
	    value: function onClick() {
	      var _props = this.props,
	          onClick = _props.onClick,
	          contact = _props.contact;
	
	      onClick(contact);
	    }
	  }, {
	    key: 'onDelete',
	    value: function onDelete(e) {
	      (0, _utils.stopEvent)(e);
	      var _props2 = this.props,
	          onDelete = _props2.onDelete,
	          contact = _props2.contact;
	
	      onDelete(contact);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          className = _props3.className,
	          contact = _props3.contact,
	          checked = _props3.checked;
	      var t = this.context.t;
	
	
	      return _react2.default.createElement(
	        _ListItem2.default,
	        {
	          fullWidth: true,
	          onClick: this.onClick,
	          className: (0, _bind2.default)(className, styles.row)
	        },
	        _react2.default.createElement(
	          'div',
	          { className: styles.checkCell },
	          _react2.default.createElement(_Checkbox2.default, {
	            checked: checked,
	            onClick: _utils.stopEvent,
	            small: true
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          contact.fullName
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          contact.email
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.actionCell },
	          _react2.default.createElement(
	            _Button2.default,
	            { className: 'btn-icon', onClick: this.onDelete },
	            _react2.default.createElement(
	              'span',
	              null,
	              t('Delete')
	            ),
	            _react2.default.createElement('i', { className: 'icon-delete' })
	          )
	        )
	      );
	    }
	  }]);
	  return GroupContactsListItem;
	}(_react.PureComponent), _class2.propTypes = {
	  checked: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  contact: _propTypes2.default.object,
	  onClick: _propTypes2.default.func,
	  onDelete: _propTypes2.default.func
	}, _class2.defaultProps = {
	  contact: {},
	  onClick: _noop3.default,
	  onDelete: _noop3.default
	}, _class2.contextTypes = {
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onClick'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onDelete', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onDelete'), _class.prototype)), _class);
	exports.default = GroupContactsListItem;
	module.exports = exports['default'];

/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _SelectableList2 = __webpack_require__(354);
	
	var _SelectableList3 = _interopRequireDefault(_SelectableList2);
	
	var _contacts = __webpack_require__(61);
	
	var contactsActions = _interopRequireWildcard(_contacts);
	
	var _contacts2 = __webpack_require__(185);
	
	var _GroupContactsList = __webpack_require__(2015);
	
	var _GroupContactsList2 = _interopRequireDefault(_GroupContactsList);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GroupContactsListWrapper = (_dec = (0, _reactRedux.connect)(function (state) {
	  var contactsEntities = (0, _contacts2.getFilteredGroupContactsPage)(state);
	  return {
	    checkedGroupContacts: state.contacts.checkedGroupContacts,
	    contacts: contactsEntities.contacts,
	    contactsListLoading: state.contacts.contactsListLoading,
	    groupContactsListLoading: state.contacts.groupContactsListLoading,
	    groupsListLoading: state.contacts.groupsListLoading
	  };
	}, (0, _extends3.default)({}, contactsActions)), _dec(_class = (_temp = _class2 = function (_SelectableList) {
	  (0, _inherits3.default)(GroupContactsListWrapper, _SelectableList);
	
	  function GroupContactsListWrapper() {
	    (0, _classCallCheck3.default)(this, GroupContactsListWrapper);
	    return (0, _possibleConstructorReturn3.default)(this, (GroupContactsListWrapper.__proto__ || (0, _getPrototypeOf2.default)(GroupContactsListWrapper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(GroupContactsListWrapper, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          onSelectionChange = _props.onSelectionChange,
	          contacts = _props.contacts,
	          onDelete = _props.onDelete,
	          contactsListLoading = _props.contactsListLoading,
	          groupContactsListLoading = _props.groupContactsListLoading,
	          updateCheckedGroupContacts = _props.updateCheckedGroupContacts,
	          checkedGroupContacts = _props.checkedGroupContacts;
	
	      var loading = contactsListLoading || groupContactsListLoading;
	
	      return _react2.default.createElement(_GroupContactsList2.default, {
	        className: className,
	        contacts: contacts,
	        loading: loading,
	        onDelete: onDelete,
	        onSelectionChange: onSelectionChange,
	        updateCheckedGroupContacts: updateCheckedGroupContacts,
	        checkedGroupContacts: checkedGroupContacts
	      });
	    }
	  }]);
	  return GroupContactsListWrapper;
	}(_SelectableList3.default), _class2.propTypes = {
	  checkedGroupContacts: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  contacts: _propTypes2.default.array,
	  groupContactsListLoading: _propTypes2.default.bool,
	  groupsListLoading: _propTypes2.default.bool,
	  onDelete: _propTypes2.default.func,
	  onSelectionChange: _propTypes2.default.func,
	  updateCheckedGroupContacts: _propTypes2.default.func
	}, _class2.defaultProps = {
	  checkedGroupContacts: {},
	  contacts: [],
	  onDelete: _noop3.default,
	  onSelectionChange: _noop3.default,
	  updateCheckedGroupContacts: _noop3.default
	}, _temp)) || _class);
	exports.default = GroupContactsListWrapper;
	module.exports = exports['default'];

/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _get3 = __webpack_require__(19);
	
	var _get4 = _interopRequireDefault(_get3);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _auth = __webpack_require__(77);
	
	var _components = __webpack_require__(15);
	
	var _AudioPlayer = __webpack_require__(135);
	
	var _AudioPlayer2 = _interopRequireDefault(_AudioPlayer);
	
	var _reactRouter = __webpack_require__(124);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1272);
	var logoDarkImg = __webpack_require__(879);
	
	var AppHeader = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    playerStatus: state.audioplayer.playerStatus,
	    user: (0, _auth.getUser)(state),
	    playlistKey: (0, _get4.default)(state, 'playlist.playlistActionData.key')
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(AppHeader, _Component);
	
	  function AppHeader() {
	    (0, _classCallCheck3.default)(this, AppHeader);
	    return (0, _possibleConstructorReturn3.default)(this, (AppHeader.__proto__ || (0, _getPrototypeOf2.default)(AppHeader)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AppHeader, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          user = _props.user,
	          playlistKey = _props.playlistKey,
	          playerStatus = _props.playerStatus;
	
	      var isShowPlayer = user || playlistKey || playerStatus !== _AudioPlayer2.default.status.stop;
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.headerContainer },
	        isShowPlayer ? _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(styles.audioPlayerContainer, (0, _defineProperty3.default)({}, styles.withSideMenu, user)) },
	          _react2.default.createElement(_components.AudioPlayer, { className: styles.audioPlayer, view: 'line' })
	        ) : _react2.default.createElement(
	          'div',
	          { className: styles.logoContainer },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/' },
	            _react2.default.createElement('img', { src: logoDarkImg, alt: 'logo' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.langSelector },
	          _react2.default.createElement(_components.LangSelector, { className: styles.langSelect })
	        )
	      );
	    }
	  }]);
	  return AppHeader;
	}(_react.Component), _class2.propTypes = {
	  playerStatus: _propTypes2.default.string,
	  playlistKey: _propTypes2.default.string,
	  user: _propTypes2.default.object
	}, _temp)) || _class);
	exports.default = AppHeader;
	module.exports = exports['default'];

/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get4 = __webpack_require__(58);
	
	var _get5 = _interopRequireDefault(_get4);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get6 = __webpack_require__(19);
	
	var _get7 = _interopRequireDefault(_get6);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClientSideComponent = __webpack_require__(30);
	
	var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactI18next = __webpack_require__(12);
	
	var _auth = __webpack_require__(77);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Link = __webpack_require__(82);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _components = __webpack_require__(15);
	
	var _containers = __webpack_require__(213);
	
	var _auth2 = __webpack_require__(31);
	
	var authActions = _interopRequireWildcard(_auth2);
	
	var _config = __webpack_require__(41);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1273);
	var logoDarkImg = __webpack_require__(879);
	var logoLightImg = __webpack_require__(2268);
	
	var showFixedOnScrollY = 300;
	
	var HomeHeader = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    loggingOut: state.auth.loggingOut,
	    playlistKey: (0, _get7.default)(state, 'playlist.playlistActionData.key'),
	    user: (0, _auth.getUser)(state)
	  };
	}, (0, _extends3.default)({}, authActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(HomeHeader, _Component);
	
	  function HomeHeader() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, HomeHeader);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = HomeHeader.__proto__ || (0, _getPrototypeOf2.default)(HomeHeader)).call.apply(_ref, [this].concat(args)));
	
	    _this.onScroll = function () {
	      var top = window.scrollY;
	      var isFixed = _this.state.fixHeader;
	      var isHiddenFixed = _this.state.hiddenFixed;
	
	      _this.setState({
	        fixHeader: top > showFixedOnScrollY,
	        hiddenFixed: (isHiddenFixed || isFixed) && top > showFixedOnScrollY / 2 && top <= showFixedOnScrollY
	      });
	    };
	
	    _this.state = { fixHeader: false, hiddenFixed: false };
	    return _this;
	  }
	
	  (0, _createClass3.default)(HomeHeader, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      (0, _get5.default)(HomeHeader.prototype.__proto__ || (0, _getPrototypeOf2.default)(HomeHeader.prototype), 'componentDidMount', this).call(this, function () {
	        _this2.onScroll();
	        window.addEventListener('scroll', _this2.onScroll, false);
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _this3 = this;
	
	      (0, _get5.default)(HomeHeader.prototype.__proto__ || (0, _getPrototypeOf2.default)(HomeHeader.prototype), 'componentWillUnmount', this).call(this, function () {
	        return window.removeEventListener('scroll', _this3.onScroll);
	      });
	    }
	  }, {
	    key: 'openLoginDialog',
	    value: function openLoginDialog() {
	      this.loginDialogEl.getWrappedInstance().getWrappedInstance().open();
	    }
	  }, {
	    key: 'openForgotPasswordForm',
	    value: function openForgotPasswordForm() {
	      this.forgotPasswordDialogEl.getWrappedInstance().getWrappedInstance().open();
	    }
	  }, {
	    key: 'openContactForm',
	    value: function openContactForm() {
	      this.loginContactEl.getWrappedInstance().open();
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      this.props.logout();
	    }
	  }, {
	    key: 'renderNavigation',
	    value: function renderNavigation() {
	      var _props = this.props,
	          user = _props.user,
	          t = _props.t,
	          playlistKey = _props.playlistKey,
	          loggingOut = _props.loggingOut;
	
	
	      if (loggingOut) {
	        return _react2.default.createElement(_components.Loader, null);
	      }
	
	      return user ? _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          _Link2.default,
	          { to: _config2.default.app.defaultUserRoute, className: styles.navItem },
	          t('Cright App')
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: styles.navItem, onClick: this.openContactForm },
	          t('Contact Us')
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: styles.navItem, onClick: this.logout },
	          t('Logout')
	        )
	      ) : _react2.default.createElement(
	        'span',
	        null,
	        playlistKey && _react2.default.createElement(
	          _Link2.default,
	          { to: '/playlists/fromkey/' + playlistKey, className: (0, _classnames2.default)('text', styles.navItem) },
	          t('Playlist')
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: styles.navItem, onClick: this.openContactForm },
	          t('Contact Us')
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: styles.navItem, onClick: this.openForgotPasswordForm },
	          t('Forgot password')
	        ),
	        _react2.default.createElement(
	          'button',
	          {
	            className: (0, _classnames2.default)(styles.navItem, styles.loginBtn, 'btn btn-stroke btn-accent'),
	            onClick: this.openLoginDialog
	          },
	          t('Log in')
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classNames,
	          _this4 = this;
	
	      var _props2 = this.props,
	          passwordCode = _props2.passwordCode,
	          passwordKey = _props2.passwordKey,
	          action = _props2.action,
	          isLanding = _props2.isLanding,
	          inApp = _props2.inApp;
	      var _state = this.state,
	          fixHeader = _state.fixHeader,
	          hiddenFixed = _state.hiddenFixed;
	
	      var logoImg = logoDarkImg;
	      if (isLanding && !fixHeader && !hiddenFixed) {
	        logoImg = logoLightImg;
	      }
	      var rootClassName = (0, _classnames2.default)(styles.homeHeader, 'homeContent', (_classNames = {}, (0, _defineProperty3.default)(_classNames, styles.isLanding, isLanding), (0, _defineProperty3.default)(_classNames, styles.fixHeader, fixHeader), (0, _defineProperty3.default)(_classNames, styles.hiddenFixed, hiddenFixed), (0, _defineProperty3.default)(_classNames, styles.inApp, inApp), _classNames));
	
	      return _react2.default.createElement(
	        'div',
	        { className: rootClassName },
	        _react2.default.createElement(
	          'div',
	          { className: styles.logoContainer },
	          _react2.default.createElement(
	            _Link2.default,
	            { to: '/' },
	            _react2.default.createElement('img', { src: logoImg, alt: 'logo' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.nav },
	          _react2.default.createElement(
	            'span',
	            { className: styles.navItems },
	            this.renderNavigation()
	          ),
	          _react2.default.createElement(_components.LangSelector, { className: (0, _classnames2.default)('margin-left-10', fixHeader || hiddenFixed || inApp || !isLanding ? 'accent' : 'light') }),
	          _react2.default.createElement(
	            'span',
	            { className: styles.menuButton, onClick: function onClick(e) {
	                return _this4.menuPopoverEl.toggle(e);
	              } },
	            _react2.default.createElement('i', { className: 'icon-menu' })
	          ),
	          _react2.default.createElement(
	            _components.PopoverMenu,
	            { id: 'menuPopover', ref: function ref(el) {
	                return _this4.menuPopoverEl = el;
	              }, className: styles.popoverMenu },
	            this.renderNavigation()
	          )
	        ),
	        _react2.default.createElement(_containers.LoginContact, { ref: function ref(el) {
	            return _this4.loginContactEl = el;
	          } }),
	        _react2.default.createElement(_containers.ForgotPasswordDialog, { ref: function ref(el) {
	            return _this4.forgotPasswordDialogEl = el;
	          }, passwordKey: passwordKey, passwordCode: passwordCode, step: action }),
	        _react2.default.createElement(_containers.LoginDialog, { ref: function ref(el) {
	            return _this4.loginDialogEl = el;
	          } })
	      );
	    }
	  }]);
	  return HomeHeader;
	}(_ClientSideComponent2.default), _class3.propTypes = {
	  action: _propTypes2.default.string,
	  inApp: _propTypes2.default.bool,
	  isLanding: _propTypes2.default.bool,
	  loggingOut: _propTypes2.default.bool,
	  logout: _propTypes2.default.func,
	  passwordCode: _propTypes2.default.string,
	  passwordKey: _propTypes2.default.string,
	  playlistKey: _propTypes2.default.string,
	  t: _propTypes2.default.func,
	  user: _propTypes2.default.object
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'openLoginDialog', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'openLoginDialog'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'openForgotPasswordForm', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'openForgotPasswordForm'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'openContactForm', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'openContactForm'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'logout', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'logout'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'renderNavigation', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'renderNavigation'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = HomeHeader;
	module.exports = exports['default'];

/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _propTypes3 = __webpack_require__(127);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Hint = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(Hint, _PureComponent);
	
	  function Hint() {
	    (0, _classCallCheck3.default)(this, Hint);
	    return (0, _possibleConstructorReturn3.default)(this, (Hint.__proto__ || (0, _getPrototypeOf2.default)(Hint)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Hint, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          small = _props.small,
	          onClick = _props.onClick;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)('hint', className, { small: small }), onClick: onClick },
	        children
	      );
	    }
	  }]);
	  return Hint;
	}(_react.PureComponent), _class.propTypes = {
	  children: _propTypes3.nodes,
	  className: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  small: _propTypes2.default.bool
	}, _class.defaultProps = {
	  onClick: _noop3.default
	}, _temp);
	exports.default = Hint;
	module.exports = exports['default'];

/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _InfoPartition = __webpack_require__(181);
	
	var _InfoPartition2 = _interopRequireDefault(_InfoPartition);
	
	var _reactI18next = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactUsInfo = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(ContactUsInfo, _Component);
	
	  function ContactUsInfo() {
	    (0, _classCallCheck3.default)(this, ContactUsInfo);
	    return (0, _possibleConstructorReturn3.default)(this, (ContactUsInfo.__proto__ || (0, _getPrototypeOf2.default)(ContactUsInfo)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ContactUsInfo, [{
	    key: 'render',
	    value: function render() {
	      var t = this.props.t;
	
	      var text = {
	        title: t('Contact Us'),
	        preKey: 'contact-us_',
	        body: _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            t('CRight is the trading name of Secure Arts Limited.')
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            t('Secure Arts Limited is registered in the UK with registered company number 04868437. UK registered office: 5 Technology Park, Colindeep Lane,'),
	            _react2.default.createElement('br', null),
	            t('London, NW9 6BX.')
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            t('Email'),
	            ': ',
	            _react2.default.createElement(
	              'a',
	              { target: '_blank', href: 'mailto:security@cright.com', rel: 'noopener noreferrer' },
	              'security@cright.com'
	            )
	          )
	        ),
	        articles: []
	      };
	
	      return _react2.default.createElement(_InfoPartition2.default, { text: text });
	    }
	  }]);
	  return ContactUsInfo;
	}(_react.Component), _class2.propTypes = {
	  t: _propTypes2.default.func.isRequired
	}, _temp)) || _class);
	exports.default = ContactUsInfo;
	module.exports = exports['default'];

/***/ }),
/* 2022 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _InfoPartition = __webpack_require__(181);
	
	var _InfoPartition2 = _interopRequireDefault(_InfoPartition);
	
	var _reactI18next = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CookiePolicy = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(CookiePolicy, _Component);
	
	  function CookiePolicy() {
	    (0, _classCallCheck3.default)(this, CookiePolicy);
	    return (0, _possibleConstructorReturn3.default)(this, (CookiePolicy.__proto__ || (0, _getPrototypeOf2.default)(CookiePolicy)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CookiePolicy, [{
	    key: 'render',
	
	
	    /* eslint-disable max-len */
	    value: function render() {
	      var t = this.props.t;
	
	      var text = {
	        title: t('Cookie Policy'),
	        preKey: 'cookie-policy_',
	        body: _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            t('When you first use this site, the cookies shall be blocked but once you take any action at all, you will consent to the cookies being enabled. You will receive notification to this effect.')
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            t('Cright respects the privacy of all visitors to our website. This Cookie Policy outlines our policy concerning the use of cookies on this website. We may update our Cookie Policy from time to time to reflect any changes in technology or legislation which may affect the way in which cookies are used by us and how you as a user, can manage them and we will publish any updates on this website.')
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            t('What are Cookies?')
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            t('Cookies are small pieces of information that a website sends to your computer for record-keeping purposes. This information is stored in a file on your computer\'s hard drive. Cookies make web-surfing easier for you by saving your preferences so that we can use the saved information to facilitate your use of our website when you return to the website. The use of cookies is an industry standard, and as such, you will find that most major websites use them. By showing how and when users use the website, cookies help us see which areas of the website are popular and which are not. Many improvements and updates to the website are based on such data as total number of visitors and pages viewed. This information is most easily tracked with cookies.')
	          ),
	          _react2.default.createElement(_reactI18next.Interpolate, {
	            i18nKey: 'Most cookies expire after a defined period of time, or you can delete your cookie file at any time. Most web browsers are initially set up to accept cookies. You can reset your web browser to disable cookies or to indicate when a cookie is being sent. However, note that some parts of our Service may not function properly or may be considerably slower if you refuse cookies. Additional information about cookies, including opting-out of certain cookies, please visit: {{siteLink}}.',
	            siteLink: _react2.default.createElement(
	              'a',
	              { target: '_blank', href: 'http://www.aboutcookies.org', rel: 'noopener noreferrer' },
	              'www.aboutcookies.org'
	            )
	          })
	        ),
	        articles: [{
	          key: 'cookie-we-use_',
	          header: t('Which Cookies Do We Use'),
	          bodies: [t('When you use this website the following types of cookies can be set on your device:'), t('1. Strictly Necessary Cookies'), t('These cookies enable Services that you have specifically asked for. These cookies do not usually contain any personally identifiable information and are typically set by websites to provide services such as eCommerce and log in facilities. For example, these cookies identify you as being signed in to websites and enable you to remain logged in throughout your visit;'), t('Our content management system (CMS) uses session cookies that cannot be disabled.'), t('2. Performance Cookies'), t('These cookies are used to collect statistical information about visitors of the website and the pages they view.'), t('These cookies do not collect information that identifies a visitor. The information these cookies collects is aggregated and used anonymously. We use these cookies to understand what content is popular which helps us to improve our website.'), t('3. Functional Cookies'), t('These cookies allow the website to remember choices you make and provide enhanced and more personal features. Some examples of such features include:'), t(' - Remembering your preferences and settings such as redirect to mobile version of the site when you are browsing with a smart phone'), t(' - Remembering your favourites when browsing particular websites'), t('If you have an account on a particular website, a cookie on your computer lets the website remember your user name and email address so you don\'t have to enter it again when you are commenting or writing a review.'), t('4. Targeting and Advertising Cookies'), t('These cookies are used to deliver advertising that is more relevant to you and your interests. They are also used to limit the number of times you see an advertisement as well as help measure the effectiveness of the advertising campaign. They are usually placed by advertising networks with our permission. They remember that you have visited a website; this information is shared with other organisations such as advertisers. Often targeting or advertising cookies will be linked to site functionality provided by the other organisation. Some examples of services that use these types of cookies include Google AdSense or DoubleClick. If you wish to opt-out of targeting and advertising cookies please visit: www.youronlinechoices.com/ie/your-ad-choices'), t('5. Other Third Party Cookies'), t('Some cookies that have been set on our websites are not related to Cright. When you visit a page with content embedded from, for example, YouTube or Facebook, these service providers may set their own cookies on your web browser. We do not control the use of these cookies and cannot access them due to the way that cookies work, as cookies can only be accessed by the party who originally set them. You should check the third party websites for more information about these cookies.'), t('')]
	        }]
	      };
	
	      return _react2.default.createElement(_InfoPartition2.default, { text: text });
	    }
	    /* eslint-enable max-len */
	
	  }]);
	  return CookiePolicy;
	}(_react.Component), _class2.propTypes = {
	  t: _propTypes2.default.func.isRequired
	}, _temp)) || _class);
	exports.default = CookiePolicy;
	module.exports = exports['default'];

/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _InfoPartition = __webpack_require__(181);
	
	var _InfoPartition2 = _interopRequireDefault(_InfoPartition);
	
	var _reactI18next = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CopyrightPolicy = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(CopyrightPolicy, _Component);
	
	  function CopyrightPolicy() {
	    (0, _classCallCheck3.default)(this, CopyrightPolicy);
	    return (0, _possibleConstructorReturn3.default)(this, (CopyrightPolicy.__proto__ || (0, _getPrototypeOf2.default)(CopyrightPolicy)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CopyrightPolicy, [{
	    key: 'render',
	
	
	    /* eslint-disable max-len */
	    value: function render() {
	      var t = this.props.t;
	
	      var text = {
	        title: t('Copyright Policy'),
	        body: _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            t('Cright respects the intellectual property rights of others and expects its users to do the same. In accordance with the DMCA Digital Millennium Copyright Act of 1998 and the EUCD European Union Copyright Directive of 2006 Cright will respond to claims of copyright infringement committed using the Cright service that are reported to Cright as identified in the sample notice below. Violation of trademark, copyright and other intellectual property laws may result in significant civil liability or criminal penalties under applicable law. Any reproduction or use of content, except as authorised by the owners, shall be considered to be an intentional infringement.')
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            t('If you are a copyright owner, authorized to act on behalf of one or authorized to act under any exclusive right under copyright, please report alleged copyright infringements taking place on or through the Cright services (the "Services") by completing the following Notice of Alleged Infringement and delivering it to Cright. Upon receipt of Notice as described below, Cright will take whatever action, in its sole discretion, it deems appropriate, including removal of the challenged use from the Services and/or termination of the Cright user\'s account.')
	          )
	        ),
	        articles: [{
	          key: 'notice-alleged_',
	          header: t('Notice of Alleged Infringement ("Notice")'),
	          bodies: [_react2.default.createElement(
	            'ol',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              t('Identify the copyrighted work that you claim has been infringed, or - if multiple copyrighted works are covered by this Notice - you may provide a representative list of the copyrighted works that you claim have been infringed.')
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              t('Identify the material or link you claim is infringing (or the subject of infringing activity) and that access to which is to be disabled, including at a minimum, if applicable, the URL of the link shown on the relevant website where such material may be found.')
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              t('Provide your mailing address, telephone number, and, if available, email address.')
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              t('Include both of the following statements in the body of the Notice:'),
	              _react2.default.createElement(
	                'p',
	                { className: 'margin-left-20' },
	                'i)"',
	                t('I hereby state that I have a good faith belief that the disputed use of the copyrighted material is not authorized by the copyright owner, its agent, or the law (e.g., as a fair use).'),
	                '"'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'margin-left-20' },
	                'ii)"',
	                t('I hereby state that the information in this Notice is accurate and, under penalty of perjury, that I am the owner, or authorized to act on behalf of the owner, of the copyright or of an exclusive right under the copyright that is allegedly infringed.'),
	                '"'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'margin-left-20' },
	                t('Provide your full legal name and your electronic or physical signature.')
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(_reactI18next.Interpolate, {
	                i18nKey: 'Deliver this Notice, with all items completed, to the following contact: {{email}}',
	                email: _react2.default.createElement(
	                  'a',
	                  { target: '_blank', href: 'mailto:legal@cright.com', rel: 'noopener noreferrer' },
	                  'legal@cright.com'
	                )
	              })
	            )
	          )]
	        }]
	      };
	
	      return _react2.default.createElement(_InfoPartition2.default, { text: text });
	    }
	    /* eslint-enable max-len */
	
	  }]);
	  return CopyrightPolicy;
	}(_react.Component), _class2.propTypes = {
	  t: _propTypes2.default.func.isRequired
	}, _temp)) || _class);
	exports.default = CopyrightPolicy;
	module.exports = exports['default'];

/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _InfoPartition = __webpack_require__(181);
	
	var _InfoPartition2 = _interopRequireDefault(_InfoPartition);
	
	var _reactI18next = __webpack_require__(12);
	
	var _Link = __webpack_require__(82);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1276);
	
	var PrivacyPolicy = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(PrivacyPolicy, _Component);
	
	  function PrivacyPolicy() {
	    (0, _classCallCheck3.default)(this, PrivacyPolicy);
	    return (0, _possibleConstructorReturn3.default)(this, (PrivacyPolicy.__proto__ || (0, _getPrototypeOf2.default)(PrivacyPolicy)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PrivacyPolicy, [{
	    key: 'render',
	
	
	    /* eslint-disable max-len */
	    value: function render() {
	      var t = this.props.t;
	
	      var text = {
	        title: t('Privacy Policy'),
	        preKey: 'privacy-policy_',
	        articles: [{
	          key: 'privacy_introduction',
	          header: '1. ' + t('Introduction'),
	          bodies: [_react2.default.createElement(
	            'p',
	            { className: 'bold' },
	            t('By using our site, you consent to our online Privacy Policy. Your consent is further provided when you register as a user.')
	          ), t('This Privacy Policy was last updated on 10 April 2018.'), t('We recognise the importance of protecting the privacy of personal data or personally identifiable information, being information which relates to an identifiable individual (“Personal Data”) about the users of and visitors to our website. We respect the rights of such users and visitors and the obligations imposed by applicable law and are committed to protecting your privacy in accordance with the Data Protection Acts of 1988 and 2003 (together with Data Protection Directive 95/46/EC and General Data Protection Regulation (“GDPR”) as implemented in UK and other applicable law, the “Data Protection Acts”) and Statutory Instrument 336 of 2011 - European Communities (Electronic Communications Networks and Services) (Privacy and Electronic Communications) Regulations 2011. The following Privacy Policy discloses what information we gather, how we use it, and how to correct or change it. We do not collect any information from anyone under 16 years of age. Use by a child of the Service 16-18 must be with parental/guardian’s consent . Our website, products and services are all directed to people who are at least 16 years old or older.'), t('We reserve the right, in our sole discretion, to modify, alter or update our Privacy Policy at any time. Such modifications, alterations, and updates shall be effective immediately upon posting. Your continued use of this website following the posting of a modified, altered, or updated Privacy Policy will mean you accept those modifications, alterations or updates.')]
	        }, {
	          key: 'data-controller',
	          chapter: '2. ' + t('Data Protection Officer and Data Controller'),
	          header: '2. ' + t('Data Controller, Data Controller’s Representative, Data Protection Officer'),
	          bodies: [t('i. The Data Controller controlling the means of processing of your personal data and the purposes of such processing is:'), t('Secure Arts Limited (trading as Cright)'), t('Registered in UK with company number 04868437'), t('Registered office address: 5 Technology Park, Colindeep Lane,'), t('London, NW9 6BX.'), t('Tel: +44 208 962 3000'), _react2.default.createElement(_reactI18next.Interpolate, {
	            i18nKey: 'Email: {{email}}.',
	            email: _react2.default.createElement(
	              'a',
	              { target: '_blank', rel: 'noopener noreferrer', href: 'mailto:security@cright.com' },
	              'security@cright.com'
	            )
	          }), t('ii. Where one of the Cright group companies is responsible for processing personal data outside the EU, Secure Arts Limited registered in UK is its EU representative.'), t('iii. Cright’s data protection officer can be contacted as follows:'), _react2.default.createElement(
	            'a',
	            { target: '_blank', rel: 'noopener noreferrer', href: 'mailto:DPO@cright.com' },
	            'DPO@cright.com'
	          ), t('Tel: +44 208 962 3000 and ask for the DPO.')]
	        }, {
	          key: 'information-collect_',
	          chapter: '3. ' + t('Purpose of the Processing and the Legal Basis for the Processing'),
	          header: '3. ' + t('Purpose of the Processing and the Legal Basis for the Processing'),
	          bodies: [t('We gather two types of information in the operation of this website:'), t('1. Personal Data:'), t('We collect information from you when you register on our site, place an order or fill out a form. This may be as an administrative user (any employee, agent or subcontractor of Cright’s record company customers who may use and access CRight Services to perform administrative functions) or as an end user (persons of our record company customers’ choosing throughout the World and who are authorized by our customers to access and use the Services, including radio stations, journalists, buyers, DJs, record label employees.) In most circumstances, Cright is Data Processor processing your Personal Data pursuant to a record company’s written instructions and it is the record company which is your Data Controller. In such circumstances, any queries that you may have in respect of your Personal Data may be directed in the first instance to the relevant record company.'), t('When ordering or registering on our site, through the “Contact Us” pages or any other area where you may send emails, submit your CV, request newsletters / blogs or provide feedback, you may be asked to enter your: name, e-mail address or credit card information as appropriate. This information will only be used by us in accordance with the terms herein and you will be asked clearly to tick consent to our processing of necessary categories of Personal Data, for each contractually agreed purpose we are to provide. This will enable you to participate in interactive features of the Service and notifying you about changes to the Service.  The provision of your Personal Data is voluntary. However, it is also necessary to enable us to fulfil our contractual obligations with record companies. Therefore if you do not provide us with the required Personal Data, we may not be able to provide you with the Service you requested.'), t('2. Non-Personal Data:'), t('We may collect information about your visit to and use of this site, including sales data, traffic data and related site information. This information helps us to evaluate and improve our site and may also be used for investment analysis purposes. As Non-Personal Data does not personally identify you, we may use it for any purpose.')]
	        }, {
	          key: 'personal_data_categories_',
	          chapter: '4. ' + t('What categories of personal data we collect, how we collect and use (process) it and for what purpose(s)'),
	          header: '4. ' + t('Categories of Personal Data'),
	          bodies: [t('4.1 With a few exceptions, this information is limited to the kinds of information that are necessary to complete a contract with us. We may ask you for your:'), _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              t('Name')
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              t('Email address')
	            )
	          ), t('4.2 What We Use Your Information For'), t('We, and the third party providers to you of User Files, collect information from you which may be used to:'), _react2.default.createElement(
	            'table',
	            { className: styles.privacyTable },
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                { className: styles.header },
	                t('Purpose')
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                t('Process and administer your Personal Information and process transactions, fulfil your requests, orders and/or to provide other information you requested. Where you have subscribed to a third party service and we are providing that service or User Files to you on behalf of that third party, we shall process Personal Data in accordance with that third party’s instructions, as controlled by them and as agreed with you. We require this Personal Data in order to be able to complete our contractual obligations to them and in turn their obligations to you')
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                t('Complete delivery of your order. We require this Personal Data in order to be able to complete our contractual obligations to you and to the record companies uploading User Files.')
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                t('Retain order details for repeat orders and/or when you open an account with us and where you request us to do so')
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                t('Personalize your experience')
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                t('Improve our website and app and make the website and app easier for you to use')
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                t('Improve customer service')
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                t('To respond to your enquiries or comments submitted through our website')
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                t('Send periodic emails (Please see Direct Marketing below)')
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                t('Notify you about important news or blogs concerning our products, industry updates, events, promotions and competitions, reports and other information')
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                t('Match Personal Data with third party data. Also, we may keep track of what portions of the website and app users are visiting and other user statistics, and aggregate this information to help us create a better experience for users of our website. This is all done in order to describe our products and services to prospective partners, advertisers, and other third parties, and for other lawful purposes.')
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  t('CRight may collect, use and disclose interactions by you with the uploaded content, for sharing with its record company customers')
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  t('Promote our products and services on our website, app and third party partners’ websites')
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                t('Provide you with information about products and services that you request from us or, where you have consented to be contacted, for such purposes which we feel may interest you')
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                t('To obtain your feedback')
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                t('To permit applications for employment with us and related activities to such applications')
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                t('Create statistical reporting regarding our web activities')
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  t('In addition, in order to carry out our lawful activities and for legitimate purposes, we may collect and process your Personal Data to:')
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  t('Allow you to use interactive features on our website or applications')
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  t('Retain a record of incoming and outgoing communications (e.g. email)')
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  t('Protect the security and integrity of the website and app')
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  t('Prevent and detect fraud or other prohibited or illegal activity')
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  t('In response to a court order, request for cooperation from a law enforcement or other government agency')
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  t('To establish or exercise legal rights')
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  t('To bring or defend legal claims')
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  t('For responsible corporate governance or as otherwise required or permitted by applicable laws and/or regulations')
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  t('In circumstances in which we believe disclosure is appropriate in connection with fraud prevention and prevention of other illegal, or unlawful activity or any other activity which is or may be contrary to our legal and regulatory compliance obligations')
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  t('To protect and defend the rights, property or safety of Cright and/or other companies in the Cright group, its/their investors and other clients, staff, and/or service providers.')
	                )
	              )
	            )
	          ), t('We continually strive to improve our website offerings based on the information and feedback we receive from you. Your information helps us to respond more effectively to your requests and support your needs.  Note: If at any time you would like to unsubscribe from receiving future emails, we include detailed unsubscribe instructions at the bottom of each email.')]
	        }, {
	          key: 'your_rights_',
	          chapter: '5. ' + t('Your Rights'),
	          header: '5. ' + t('Your Rights in respect of your Personal Data') + ':',
	          bodies: [_react2.default.createElement(_reactI18next.Interpolate, {
	            i18nKey: 'This Privacy NoticePolicy is intended to provide you with information about what Personal Data Cright collects about you and how it is used. If you have any questions, please contact us at {{email}}.',
	            email: _react2.default.createElement(
	              'a',
	              { target: '_blank', rel: 'noopener noreferrer', href: 'mailto:security@cright.com' },
	              'security@cright.com'
	            )
	          }), _react2.default.createElement(_reactI18next.Interpolate, {
	            i18nKey: 'If you wish to confirm that CRight is processing your Personal Data, or to have access to the Personal Data we may have about you, please contact us at {{email}}.',
	            email: _react2.default.createElement(
	              'a',
	              { target: '_blank', rel: 'noopener noreferrer', href: 'mailto:security@cright.com' },
	              'security@cright.com'
	            )
	          }), t('You have various rights in respect of your Personal Data which can be summarised as follows:'), _react2.default.createElement(
	            'ol',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              t('The right to be informed. Where Cright intends to collect your Personal Data, you have a right to consent or object to such collection for the intended purposes. In respect of each intended purpose you will be asked to tick box to indicate your consent to each intended purpose for processing of your Personal Data.')
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              t('The right of access. You may request to receive a copy of any Personal Data held by us, which personally identifies you. We may charge an administration fee to cover the cost of carrying out your request. We may ask you to verify your identity and for more information about your request.')
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              t('The right to rectification. We will correct or erase inaccuracies in the information we hold about you when we learn of the inaccuracy.')
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              t('The right to erasure. Personal Data may be erased if we do not have a legitimate reason for retaining the information.')
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              t('The right to restrict processing;')
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              t('The right to data portability;')
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              t('The right to object;')
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              t('Rights in relation to automated decision making and profiling. Cright does not carry out any automated decision making.')
	            )
	          ), _react2.default.createElement(
	            'p',
	            { className: 'italic bold' },
	            t('Please contact Cright in writing with any requests and provide verification that you are whom you say that you are.')
	          ), _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'bold' },
	              t('You may withdraw your consent to your Personal Data being processed at any time (the opt out button is available next to the opt in button where you provided your consent). ')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              t('However, if you withdraw consent, we may not be able to provide you with the service you requested.')
	            )
	          )]
	        }, {
	          key: 'right_to_lodge_',
	          chapter: '6. ' + t('Questions, Concerns and Complaint with a Supervisory Authority'),
	          header: '6. ' + t('The Right to Lodge a Complaint with a Supervisory Authority'),
	          bodies: [t('If you have a reason to complain about how your Personal Data has been controlled and processed by Cright, please in the first instance contact Cright and we shall endeavour to resolve your queries promptly. If you remain unsatisfied, you may lodge a complaint with:'), _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'bold' },
	              t('Address: ')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              t('Information Commissioner\'s Office')
	            )
	          ), t('Wycliffe House') + ',', t('Water Lane') + ',', t('Wilmslow') + ',', t('Cheshire') + ',', t('SK9 5AF'), _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'bold' },
	              t('Phone: ')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              '+44 303 123 1113 or 01625 545 745'
	            )
	          ), _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'bold' },
	              t('Email: ')
	            ),
	            _react2.default.createElement(
	              'a',
	              { target: '_blank', rel: 'noopener noreferrer', href: 'mailto:casework@ico.org.uk' },
	              'casework@ico.org.uk'
	            )
	          ), _react2.default.createElement(
	            'p',
	            { className: 'italic bold' },
	            t('Please copy any such communication to us so that we can work to resolve any outstanding issues promptly.')
	          )]
	        }, {
	          key: 'disclosure_of_personal_data_',
	          chapter: '7. ' + t('Disclosure of Personal Data'),
	          header: '7. ' + t('Disclosure of Personal Data'),
	          bodies: [t('Your information, whether public or private, will not be sold, exchanged, transferred, or given to any other company for any reason whatsoever, without your consent, other than for the express purpose of delivering the product or Service requested.'), t('We may disclose your Personal Data to our trusted affiliates, business partners, agents, service providers, professional advisers, and to such other third parties as may reasonably be required in connection with the purposes referred to in this Privacy Policy, such as operating our website, conducting our business, or servicing you, so long as those parties agree to keep this information confidential. The providers of User Files contracted to us whose files you access shall have direct access to your Personal Data and the Service shall be provided to you by us on their behalf, under their control and at their instruction. We reserve the right to disclose any and all pertinent information to law enforcement or other governmental officials as we, in our sole discretion, believe necessary or appropriate. The disclosures of your Personal Data described in this Privacy Policy may, where you have consented to receipt of User Files from third party record companies contracted with us, involve the transfer, storage or processing of your Personal Data to a country outside of the European Economic Area (EEA) where the level of data protection is not as high as in the UK.  By providing us with your Personal Data you agree to such transfers of your Personal Data. We will take all steps reasonably necessary to ensure that your information is treated securely and in accordance with this Privacy Policy.'), t('We may also disclose Personal Data in special cases when we have reason to believe that disclosing this information is necessary to identify, contact or bring legal action against someone who may be violating our Terms of Service, or may be causing injury to or interference with any of our rights or property, other users, or anyone else. We may disclose or access account information when we believe in good faith that the law requires it and for administrative and other purposes that we deem necessary to maintain, service, and improve our products and services. In addition, if we or our assets are acquired, your Personal Data will likely be transferred or disclosed in connection with such acquisition.')]
	        }, {
	          key: 'direct_marketing_',
	          chapter: '8. ' + t('Direct Marketing'),
	          header: '8. ' + t('Direct Marketing'),
	          bodies: [t('On occasion, we engage third parties to mail or send information to you, including items about products you may have purchased, or material from an event sponsor. We have a legitimate interest in processing of Personal Data for direct marketing purposes. We may send postal marketing about a new product; you may opt-out of this. In the context of a sale, we may have sought your consent for electronic marketing, but again you may opt out of this at any time by following the instructions in the marketing communication itself or by contacting us through this website.')]
	        }, {
	          key: 'retention_period_',
	          chapter: '9. ' + t('Retention'),
	          header: '9. ' + t('Retention Period'),
	          bodies: [t('We shall retain and store your Personal Data securely and for as long as necessary in order to fulfil our and our partners’ (where applicable) contracts with you. We shall then only retain Personal Data for as long as necessary to comply with our legal obligations under relevant law. After a transaction, your Personal Data (credit cards, financial information, etc.) will be kept on file in order to enable recurring billing depending on your subscription plan and thereafter until you Unsubscribe in your Accounts settings.'), t('Where you have opened an account with us and requested that we retain your Personal Data, it shall be retained securely using appropriate technological and organisational measures whilst that account remains open, until you opt out of such storage and you request closure of the account.'), _react2.default.createElement(_reactI18next.Interpolate, {
	            i18nKey: 'For more information on where and how long your Personal Data is stored, and for more information on your rights of erasure and portability, please contact {{email}}.',
	            email: _react2.default.createElement(
	              'a',
	              { target: '_blank', rel: 'noopener noreferrer', href: 'mailto:security@cright.com' },
	              'security@cright.com'
	            )
	          })]
	        }, {
	          key: 'information-protect_',
	          chapter: '10. ' + t('How We Protect Your Personal Data'),
	          header: '10. ' + t('How We Protect Your Information'),
	          bodies: [t('We implement a variety of security measures to maintain the safety of your Personal Data when you place an order or enter, submit, or access your Personal Data. To help protect the privacy of data and personally identifiable information you transmit through use of this site, we maintain physical, technical and administrative safeguards. We update and test our security technology on an ongoing basis. We restrict access to your Personal Data to those employees who need to know that information to provide benefits or services to you. In addition, we train our employees about the importance of confidentiality and maintaining the privacy and security of your information. We commit to taking appropriate disciplinary measures to enforce our employees privacy responsibilities.'), t('We offer the use of a secure server. All supplied sensitive/credit information is transmitted via Secure Socket Layer (SSL) technology and then encrypted into our payment gateway providers’ database only to be accessible by those authorized with special access rights to such systems, and are required to keep the information confidential.'), t('Our payment gateway provider is Level 1 PCI compliant.')]
	        }, {
	          key: 'use-cookies_',
	          chapter: '11. ' + t('Terms of Use of this Website and Cookies'),
	          header: '11. ' + t('Terms of Service and Cookies'),
	          bodies: [t('11.1 Please also visit our Terms of Service section establishing the use, disclaimers, and limitations of liability governing the use of our website.'), t('11.2 Cookies are small files that a site or its service provider transfers to your computer’s hard drive through your Web browser (if you allow) that enables the sites or service providers systems to recognize your browser and capture and remember certain information. Cookies make web-surfing easier for you by saving your preferences so that we can use the saved information to facilitate your use of our website when you return to the website. The use of cookies is an industry standard, and as such, you will find that most major websites use them.'), t('We use cookies to compile aggregate data about site traffic and site interaction so that we can offer better site experiences and tools in the future.'), _react2.default.createElement(_reactI18next.Interpolate, {
	            className: 'bold',
	            i18nKey: 'Please see our {{cookiePolicyLink}} and {{securityPolicyLink}} For More Detail',
	            cookiePolicyLink: _react2.default.createElement(
	              _Link2.default,
	              { to: '/info/cookie-policy' },
	              t('Cookie Policy')
	            ),
	            securityPolicyLink: _react2.default.createElement(
	              _Link2.default,
	              { to: '/info/security' },
	              t('Security Policy')
	            )
	          }), _react2.default.createElement(_reactI18next.Interpolate, {
	            i18nKey: 'Please also visit our {{termsOfServiceLink}} section establishing the use, disclaimers, and limitations of liability governing the use of our website.',
	            termsOfServiceLink: _react2.default.createElement(
	              _Link2.default,
	              { to: '/info/terms-of-service' },
	              t('Terms of Service')
	            )
	          })]
	        }, {
	          key: 'policy_change_',
	          chapter: '12. ' + t('Changes and Updates to this Privacy Policy'),
	          header: '12. ' + t('Changes to our Privacy Policy'),
	          bodies: [t('If we decide to change our Privacy Policy, we will post those changes on this page. We reserve the right to amend the Privacy Policy and Terms of Service at any time, for any reason, without notice to you, other than the posting of the amended Privacy Policy and Terms of Service at this site. We may e-mail periodic reminders of our notices and terms and conditions and will e-mail deployment partners of material changes thereto, but you should check our site frequently to see the current Privacy Policy and Terms of Service that is in effect and any changes that may have been made to it.')]
	        }, {
	          key: 'contacting_',
	          chapter: '13. ' + t('Contacting Us'),
	          header: '13. ' + t('Contacting Us'),
	          bodies: [_react2.default.createElement(_reactI18next.Interpolate, {
	            i18nKey: 'If there are any questions regarding this privacy policy you may {{contactLink}}.',
	            contactLink: _react2.default.createElement(
	              'a',
	              { target: '_blank', href: 'mailto:info@cright.com?subject=PP%20enquiry', rel: 'noopener noreferrer' },
	              t('contact us')
	            )
	          })]
	        }, {
	          key: 'access_Amend_information_',
	          chapter: '14. ' + t('Access and Amend Your Personal Data'),
	          header: '14. ' + t('Access and Amend Your Information'),
	          bodies: [t('In accordance with the Data Protection Acts, you may request to receive a copy of any Personal Data held by us, which personally identifies you. We may occasionally charge an administration fee to cover the cost of carrying out your request. We may ask you to verify your identity and for more information about your request.'), t('We will correct or erase inaccuracies in the information we hold about you when we learn of the inaccuracy. Personal Data may be erased if we do not have a legitimate reason for retaining the information. You should include adequate information that you may have that will reasonably assist us in fulfilling your request(s). There is no charge for this service.'), t('If you no longer wish to receive marketing-related e-mails from us, you may opt-out of receiving such marketing-related e-mails.'), _react2.default.createElement(_reactI18next.Interpolate, {
	            i18nKey: 'You should direct any requests relating to your Personal Data, or any other privacy questions, to {{email}} or to the address specified below:',
	            email: _react2.default.createElement(
	              'a',
	              { target: '_blank', href: 'mailto:security@cright.com', rel: 'noopener noreferrer' },
	              'security@Cright.com'
	            )
	          }), t('Registered office address: 5 Technology Park, Colindeep Lane,'), t('London, NW9 6BX.'), t('Attention: Data Protection Officer'), t('Once we receive your inquiry, we will comply with your request as soon as practicable and in any event within not more than 40 days of receipt of your request and verification that you are whom you say you are.')]
	        }]
	      };
	
	      return _react2.default.createElement(_InfoPartition2.default, { text: text });
	    }
	    /* eslint-enable max-len */
	
	  }]);
	  return PrivacyPolicy;
	}(_react.Component), _class2.propTypes = {
	  t: _propTypes2.default.func.isRequired
	}, _temp)) || _class);
	exports.default = PrivacyPolicy;
	module.exports = exports['default'];

/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _InfoPartition = __webpack_require__(181);
	
	var _InfoPartition2 = _interopRequireDefault(_InfoPartition);
	
	var _reactI18next = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Security = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(Security, _Component);
	
	  function Security() {
	    (0, _classCallCheck3.default)(this, Security);
	    return (0, _possibleConstructorReturn3.default)(this, (Security.__proto__ || (0, _getPrototypeOf2.default)(Security)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Security, [{
	    key: 'render',
	
	
	    /* eslint-disable max-len */
	    value: function render() {
	      var t = this.props.t;
	
	      var text = {
	        title: t('Security'),
	        preKey: 'security_',
	        body: t('Cright takes very seriously its obligations in respect of your Personal Data under the Data Protection Acts to prevent unauthorised access to, or alteration or destruction of Personal Data in our possession. Nobody can access your files unless you choose to share them yourself. However, unfortunately, no data transmission over the Internet can be guaranteed to be 100% secure. As a result, we cannot 100% ensure the security of any information you transmit to us or from our online products or Services, and you do so at your own risk. We will take reasonable steps to protect information shared with us from unauthorised access or disclosure.'),
	        articles: [{
	          key: 'storage_',
	          header: t('Secure Storage'),
	          bodies: [t('Cright shares the same secure methods used by the most secure of organizations, such as banks and the military, to protect your data.'), _react2.default.createElement(_reactI18next.Interpolate, {
	            i18nKey: 'On some occasions, Cright may use Amazon S3 for data storage. Amazon stores its data over several large-scale data centres. According to Amazon, they use military grade perimeter control berms, video surveillance, and professional security staff to keep their data centres physically secure. More information on Amazon\\\'s security can be found at {{amazonLink}}. Cright retains data collected on your behalf after termination of any agreement with you in its non-active, back-up archive files on a secure server or other commercially acceptable secure media for up to 12 months to enable it to meet its security obligations.',
	            amazonLink: _react2.default.createElement(
	              'a',
	              { target: '_blank', href: 'http://aws.amazon.com/articles/1697?_encoding=UTF8&jiveRedirect=1', rel: 'noopener noreferrer' },
	              t('Amazon Web Services\' website')
	            )
	          })]
	        }, {
	          key: 'transfers_',
	          header: t('Secure Transfers'),
	          bodies: [t('All transmission of file data and metadata occurs over an encrypted channel (SSL). Any data transferred from Cright over the internet is securely encrypted and safe from interception and/or eavesdroppers.'), t('Cright also employ significant protection against network security issues such as Man in the Middle (MITM) attacks, and packet sniffing.')]
	        }, {
	          key: 'backedup-data_',
	          header: t('Your Data is Backed Up'),
	          bodies: [t('Cright keeps multiple redundant backups of all data over multiple locations to prevent the remote possibility of issues occurring in data centres.')]
	        }, {
	          key: 'privacy-policy_',
	          header: t('Cright\'s Privacy Policy'),
	          bodies: [t('The files stored on your Cright account are accessible only to you via your login. Cright employees are only permitted access to file metadata (file names and locations). No employee is allowed to view the files in your Cright account without your consent.'), t('The information provided in your account profile is used internally for support, maintenance, and improvement of the Cright service. We understand and guard your privacy to the best of our ability as described in this policy. We do our utmost to protect your information from unauthorized access.')]
	        }, {
	          key: 'found-exploit_',
	          header: t('I think I\'ve found a security exploit. Where do I report security concerns?'),
	          bodies: [t('Our top priority is making Cright safe for all of its users. While we\'re very confident in our security technology, we prefer to investigate any and all reported security concerns with any of Cright\'s services or software.'), _react2.default.createElement(_reactI18next.Interpolate, {
	            i18nKey: 'For a direct line to our security experts, report security problems to {{email}}',
	            email: _react2.default.createElement(
	              'a',
	              { target: '_blank', href: 'mailto:security@cright.com', rel: 'noopener noreferrer' },
	              'security@cright.com'
	            )
	          })]
	        }]
	      };
	
	      return _react2.default.createElement(_InfoPartition2.default, { text: text });
	    }
	    /* eslint-enable max-len */
	
	  }]);
	  return Security;
	}(_react.Component), _class2.propTypes = {
	  t: _propTypes2.default.func.isRequired
	}, _temp)) || _class);
	exports.default = Security;
	module.exports = exports['default'];

/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _InfoPartition = __webpack_require__(181);
	
	var _InfoPartition2 = _interopRequireDefault(_InfoPartition);
	
	var _reactI18next = __webpack_require__(12);
	
	var _Link = __webpack_require__(82);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TermOfService = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(TermOfService, _Component);
	
	  function TermOfService() {
	    (0, _classCallCheck3.default)(this, TermOfService);
	    return (0, _possibleConstructorReturn3.default)(this, (TermOfService.__proto__ || (0, _getPrototypeOf2.default)(TermOfService)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TermOfService, [{
	    key: 'render',
	
	
	    /* eslint-disable max-len */
	    value: function render() {
	      var t = this.props.t;
	
	      var text = {
	        title: t('Terms of service'),
	        preKey: 'term-of-service_',
	        body: _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            t('Cright provides this website subject to the following Terms of Service. The purpose of this website is to provide you with access to information about and to use our services, products, and related subject matter. The Terms of Service apply to all visitors to this website.')
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(_reactI18next.Interpolate, {
	              i18nKey: 'This is a legal agreement between you and Secure Arts Limited trading as Cright ("Cright"); please read it carefully. By using or accessing this website or any website hosted at Cright.com (the "Sites"), or by accessing or using any part of the Cright proprietary file transmission services (together with the Sites, the "Service"), you agree to be bound by these Terms of Service including the Cright Privacy Policy, Security Policy and Cookie Policy as at the time of access or use, which are collectively referred to as the "Agreement". If you do not agree to these terms then you have no right to access or use the Service. As a new user at the time of registration, you shall be asked on the Sign-Up page to confirm your agreement to these Terms of Service, {{privacy}}, {{security}} and {{cookiePolicies}} before your registration is confirmed. The terms of this Agreement, as updated or modified by Cright in its sole discretion, will govern all your future use of the Service. Cright recommends that you review this page regularly to note any changes, since you agree to be bound by such modified and updated terms if you access or use this website after we have posted notice of such modifications or updates. If you do not agree to the updated or modified terms then you must cease using the Service. Cright may modify, suspend, or discontinue, temporarily or permanently, the Service and may remove or delete any User Files (defined below) at any time, in its sole discretion.',
	              privacy: _react2.default.createElement(
	                _Link2.default,
	                { to: '/info/privacy-policy' },
	                t('Privacy', { context: 'your agreement to these Terms of Service, [Privacy], Security and Cookie Policies before your registration is confirmed' })
	              ),
	              security: _react2.default.createElement(
	                _Link2.default,
	                { to: '/info/security' },
	                t('Security', { context: 'your agreement to these Terms of Service, Privacy, [Security] and Cookie Policies before your registration is confirmed' })
	              ),
	              cookiePolicies: _react2.default.createElement(
	                _Link2.default,
	                { to: '/info/cookie-policy' },
	                t('Cookie Policies', { context: 'your agreement to these Terms of Service, Privacy, Security and [Cookie Policies] before your registration is confirmed' })
	              )
	            })
	          )
	        ),
	        articles: [{
	          key: 'description_',
	          header: t('Description of the Service'),
	          bodies: [t('The Service enables users to store and send to others files that they provide ("User Files"). The Service provides the option to encrypt the content with codes that enable the users to track the use of the files. User Files can be delivered as Streams or Downloads. Cright offers several accounts types, which fall into the following categories: Subscription and Per Use or recipient use. Trial accounts are offered at no charge. The subscription service requires periodic payments (monthly or annually, depending on the account type). A more detailed description of the Service, and the features associated with different account types, can be found on the Accounts Page. You acknowledge and agree that Cright may establish revised practices and policies concerning use of the Service, including without limitation, the maximum size of the file that a user may store and send through the Service, the maximum number of days that a file will be stored by the Service, the maximum number of times a user may access the Service in a given period of time, and the maximum number of recipients to which a user may send a User File. Notwithstanding the foregoing, the features and limitations in effect when you began your then-current subscription term will remain in effect for the remainder of such subscription term. The only software needed to access the Service is a standard Web browser. However, Cright may make certain software applications available to users that offer additional ways to access the Service. Such software will be made available by Cright under the terms of an end user license agreement, which you should read prior to installing that software.')]
	        }, {
	          key: 'privacy',
	          header: t('Privacy'),
	          bodies: [_react2.default.createElement(_reactI18next.Interpolate, {
	            i18nKey: 'Our collection and use of information about the users and visitors to this website is subject to our Privacy Policy. For more information, please review our {{policyLink}}.',
	            policyLink: _react2.default.createElement(
	              _Link2.default,
	              { to: '/info/privacy-policy' },
	              t('Privacy Policy')
	            )
	          })]
	        }, {
	          key: 'accounts_',
	          header: t('Accounts'),
	          bodies: [t('In order to use the Service and send User Files, or to receive User Files as a recipient user, you must register and create a Cright account. You may create a Cright account on the Sign Up page. Once you have created an account, you will be a "Registered User." In creating an account, you agree to provide accurate, current, and complete information. You are responsible for safeguarding the password that you use to access the Service. You agree not to disclose your password to any third party. You agree to take sole responsibility for any activities or actions under your password, whether or not you have authorized such activities or actions. You will immediately notify Cright of any suspected or actual unauthorized use of your password. You are responsible for keeping your account information current and accurate; Cright will have no liability for failure to deliver notices that result from inaccurate account information or otherwise. You agree to provide true, accurate, current and complete information. If you provide any information that is untrue, inaccurate, not current or incomplete (or we have reasonable grounds to suspect that any information is untrue, inaccurate, not current or incomplete), we have the right to suspend or terminate your access and activity, and refuse any and all current or future use of this website. We may suspend or terminate your service or access to this website if we believe a breach of these terms has occurred.')]
	        }, {
	          key: 'payment_',
	          header: t('Payment'),
	          bodies: [t('When you register for an account, and at any time thereafter, you can select what term of subscription you prefer and the frequency with which you will pay for it. Cright paid accounts are subscription services with recurring credit card charges on a monthly basis (as selected by you during registration or subsequent configuration). For certain premium accounts, Cright may offer the choice of credit card payments or corporate account invoicing. You agree to pay all account charges, and to pay any applicable taxes and other fees that accrue in relation to your use of the Service. For accounts setup on an invoice basis, you agree to pay Cright all amounts stated in such invoices within thirty (30) days of receipt. For more information about the subscription services and available payment methods, refer to the Accounts Page.'), t('If you are a recipient user, you may unsubscribe at any time using the Unsubscribe button in your Accounts settings.')]
	        }, {
	          key: 'data-responsibility_',
	          header: t('Responsibility for Data'),
	          bodies: [t('You have sole responsibility for all User Files that you store on Cright servers through use of the Service. You acknowledge and agree that Cright will not be responsible for any failure of the Service to store a User File, for the deletion of a User File stored on the Service, or for the corruption of or loss of any data, information or content contained in a User File.')]
	        }, {
	          key: 'files-policy_',
	          header: t('User Files and Cright\'s Copyright Policy'),
	          bodies: [t('You will not use the Service to transmit, route, provide connections to or store any material that infringes any copyrights or otherwise violates or promotes the violation of the intellectual property rights of any third party. Cright has adopted and implemented a policy that provides for the termination in appropriate circumstances of the accounts of users who repeatedly infringe or are believed to be infringing the rights of copyright holders. Please see the Cright Copyright Policy for further information. Cright reserves the right, in its sole discretion, at any time, to remove User Files that it believes to be in violation of this Agreement.'), t('We control and operate this website. All content on this website, including text, graphics, photographs, images, illustrations, audio clips, and video clips, is protected by copyrights, trademarks, service marks, and/or other intellectual property rights. The Service and User Files transmitted are protected by copyright, trademark, intellectual property rights and other laws of both the United Kingdom and foreign countries.')]
	        }, {
	          key: 'proprietary-rights_',
	          header: t('Proprietary Rights - Service'),
	          bodies: [t('All right, title, and interest in and to the Service is and will remain the exclusive property of Cright and its licensors. Except as expressly permitted in this Agreement, you may not reproduce, modify, or prepare derivative works based upon, distribute, sell, transfer, publicly display, publicly perform, transmit, or otherwise use the Service.')]
	        }, {
	          key: 'ownership-files_',
	          header: t('Ownership of User Files'),
	          bodies: [t('Cright does not claim any ownership rights in any User Files that you make available through the Service. However, by making User Files available through the Service, you grant Cright the non-exclusive, worldwide, transferable right, on a royalty-free basis, with a right to sublicense this right only to third parties assisting Cright in providing the Service, to use, copy, distribute and process User Files on the Sites and through the Service on your behalf and on behalf of your customers solely for the purposes of ensuring secure transfer and delivery of such User Files.')]
	        }, {
	          key: 'trademarks_',
	          header: t('Trademarks'),
	          bodies: [t('Cright, the Cright logo, and all other Cright (and Secure Arts Limited) trademarks, service marks, product names, and trade names of Cright appearing on the Service are owned by Cright. All other trademarks, service marks, product names, and logos appearing on the Service are the property of their respective owners. You may not use or display any trademark, service mark, product name, trade name, or logo appearing on the Service without the owner\'s prior written consent. Certain corporate accounts do however, include the facility to display other trademark, service mark, product name, trade name, and logo\'s.')]
	        }, {
	          key: 'general-prohibitions_',
	          header: t('General Prohibitions'),
	          bodies: [t('As a condition to your use of the Service, you agree not to:'), _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              t('Upload or transmit any User File: (i) that you do not have the lawful right to copy, transmit, distribute, and display (including any User Files that would violate any confidentiality or fiduciary obligations that you might have with respect to the User Files); (ii) for which you do not have the consent or permission of each identifiable person in the User Files to use the name, voice, signature, photograph, or likeness of each such person (to the extent each is implicated by the User Files); (iii) that infringes or misappropriates the intellectual property rights or violates the privacy rights of any third party (including without limitation copyright, trademark, patent, trade secret, or other intellectual property right, or moral right or right of publicity); (iv) that is false or misleading; (v) that is defamatory; (vi) that is obscene, pornographic, or offensive; (vii) that promotes bigotry, racism, hatred, or harm against any individual or group; or (viii) that violates, or encourages any conduct that would violate, any applicable law or regulation or would give rise to civil liability;')
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              t('Access, tamper with, or use any non-public areas of the Service or Cright\'s computer systems or the technical delivery systems of Cright\'s providers;')
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              t('Frame, deep link, or otherwise incorporate into another website any of the content or other materials on this website without our express prior written consent.')
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              t('Attempt to probe, scan, or test the vulnerability of the Service or any related system or network or breach any security or authentication measures used in connection with the Service and such systems and networks;')
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              t('Attempt to decipher, decompile, disassemble, or reverse engineer any of the software used to provide the Service or computer code comprising or in any way making up a part of this website;')
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              t('Harm or threaten to harm other users in any way or interfere with, or attempt to interfere with, the access of any user, host or network, including without limitation, by sending a virus, overloading, flooding, spamming, or mail-bombing the Service, or taking any action that imposes an unreasonable or disproportionately large load on the website\'s infrastructure;')
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              t('Send unsolicited email, junk mail, spam, chain letters, or promotions or advertisements for products or services;')
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              t('Impersonate or misrepresent your affiliation with any person or entity;')
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              t('Disclosing to or sharing the assigned passwords with any unauthorized third parties or using the assigned passwords for any unauthorised purpose;')
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              t('Using any robot, spider, intelligent agent, other automatic device, or manual process to search, monitor or copy our Web pages, or the content without our prior written permission, provided that generally available third party Web browsers such as Microsoft Internet Explorer may be used for general web-browsing purposes without such permission.')
	            )
	          ), t('Cright will have the right to investigate and prosecute violations of any of the above, including without limitation possible infringement of any intellectual property rights and possible security breaches, to the fullest extent of the law. Cright may involve and cooperate with law enforcement authorities in prosecuting users who violate this Agreement. You acknowledge that, although Cright has no obligation to monitor your access to or use of the Service, it has the right to do so for the purpose of operating the Service, to ensure your compliance with this Agreement, or to comply with applicable law or the order or requirement of a court, administrative agency, or other governmental body. Cright reserves the right at all times to disclose, in its sole discretion, any User Files as necessary to (a) satisfy any law, regulation, or governmental request or (b) reduce or prevent what Cright considers to be, in its sole discretion, a serious or imminent threat to your health or safety, or the health or safety of another.')]
	        }, {
	          key: 'links_',
	          header: t('Links'),
	          bodies: [t('The Service may contain links to third-party websites. Given that monitoring the vast amount of information disseminated and accessible via those sites and resources is impracticable and beyond our resources, such information cannot be guaranteed to be accurate, or up to date and is not endorsed by us. You acknowledge and agree that Cright is not responsible or liable for: (i) the availability or accuracy of such websites; or (ii) the content, products, or services on or available from such websites. Links to such websites do not imply any endorsement by Cright of such websites or the content, products, or services available from such websites nor association with their operators. You acknowledge sole responsibility for and assume all risk arising from your use of any such websites.'), t('The other linked websites may have different privacy statements or policies that are not the same as our Privacy policy, or may not have privacy statements or policies. We encourage you to read the privacy policies (if any) for all such websites as they may differ from our Privacy Policy. Your use of such linked websites through links provided on this website is governed by the terms and privacy statements or policies of those sites, not this website.')]
	        }, {
	          key: 'termination_',
	          header: t('Termination'),
	          bodies: [t('You may cancel a paid account at any time in your account settings on the Sites. Your account will remain active until the end of that month at which time you will be billed for usage under the terms of your account. Cright reserves the right to discontinue the Service or to change the Service at any time and without notice, except that Cright will provide notice of such discontinuation to corporate account holders. In the event of such discontinuation by Cright, Cright will refund any fees paid by you, prorated proportionally to the amount of time remaining in the then-current subscription period. For month-to-month accounts, that period is one month, for annual accounts, that period is one year. If you breach this Agreement, Cright will have the right to terminate this Agreement immediately, without notice, and to deactivate your account. In the event of your breach of this Agreement, Cright will not be required to refund any fees paid by you.'), t('If you are a recipient user and use the Unsubscribe button in Accounts settings, your account will be terminated promptly and all your Personal Data (held pursuant to the Privacy Policy) will be deleted from Cright’s active systems. Cright shall retain such data in its non-active, back-up archive files on a secure server or other commercially acceptable secure media for up to 12 months to enable it to meet its security obligations.')]
	        }, {
	          key: 'disclaimer-warranties_',
	          header: t('Disclaimer of Warranties'),
	          bodies: [t('The contents of the Service are provided "AS-IS," without warranty of any kind, either express or implied. Without limiting the foregoing, Cright explicitly disclaims any warranties of merchantability, fitness for a particular purpose and non-infringement. Cright makes no warranty that the Service will meet your requirements or will be available on an uninterrupted, secure, or error-free basis. Your use of the Service is at your own risk. You acknowledge and agree that Cright will not be responsible for any damages to your computer system or the computer system of any third party that result from use of the Service. We do not warrant or make any representations regarding the results that may be obtained from the use of this website, or as to the reliability, accuracy, usefulness, or currency of any content or the Service pursuant to your use of this website. You use this website at your own risk. You (and not us) assume the entire cost of all necessary servicing and repair or correction of your system.'), t('Except for such content that we may elect to create and publish, we are a distributor and not a publisher. We have no more editorial control over such User Files and information and content than does a public library or newsstand. Any opinions, advice, statements, services, offers, or other information expressed or made available by third parties (including in the linked sites) are those of the respective authors or distributors of such content. Where you are a recipient of User Files, the owner of such content shall be contracted to us and will control the Service and use of your Personal Data; we shall provide the Service on their behalf and at their instruction.')]
	        }, {
	          key: 'indemnity_',
	          header: t('Indemnity'),
	          bodies: [t('You will defend, indemnify, and hold harmless Cright, its officers, directors, affiliates, employees and agents, from and against any claims, liabilities, damages, losses, and expenses, including, without limitation, reasonable legal and accounting fees, arising out of or in any way connected with your access to or use of the Service, or your violation of this Agreement, including without limitation third party claims that User Files submitted to the Service by you infringe or misappropriate the intellectual property rights, privacy rights, publicity rights, or moral rights of a third party. We reserve the right to report any wrongdoing, if and when we become aware of it, to any applicable government agencies.')]
	        }, {
	          key: 'limitation-liability_',
	          header: t('Limitation of Liability'),
	          bodies: [t('In no event will Cright nor our affiliated or related entities, nor any of our respective officers, directors, employees or agents, nor any person or entity involved in the creation, production and distribution of this website or any content and the Service related thereto, be liable to you or to any third party for any incidental, special, consequential or punitive damages arising out of or in connection with this Agreement or from the use of or inability to use the Service or any User Files sent through, stored by or downloaded from the Service, whether based on warranty, contract, tort (including negligence) or any other legal theory, and whether or not Cright has been informed of the possibility of such damage, even if any limited remedy set forth herein is found to have failed of its essential purpose. In no event will Cright\'s aggregate liability to you or to any third party for any and all claims arising out of or in connection with the use of the Service exceed the lesser of (a) one hundred U.S. dollars ($100) and (b) the fees paid to Cright by you in the twelve (12) months leading up to the event giving rise to such a claim. The limitations of damages set forth above are fundamental elements of the basis of the bargain between Cright and you; the limitation of liability reflects the allocation of risk between the parties.  This does not limit in any way our liability for death or personal injury caused by our negligence or for any other matter which it would be illegal for us to exclude our liability illegal for us to exclude our liability.')]
	        }, {
	          key: 'jurisdiction-applicable_',
	          header: t('Jurisdiction and applicable law'),
	          bodies: [t('The English courts will have exclusive jurisdiction over any claim arising from, or related to, a visit to our site or use of the Service, although we retain the right to bring proceedings against you for breach of these conditions in your country of residence or any other relevant country. These terms of use and any dispute or claim arising out of or in connection with them or their subject matter or formation (including non-contractual disputes or claims) shall be governed by and construed in accordance with the law of England and Wales. We make no representation that materials on this website are appropriate or available for use in other locations, and accessing them from territories where the content is illegal is prohibited. Those who choose to access this website from other locations do so at their own risk and are responsible for compliance with local laws, including laws regarding the transmission of technical data exported from the country in which you reside.')]
	        }, {
	          key: 'entire-agreement_',
	          header: t('Entire Agreement'),
	          bodies: [t('This Agreement, which includes the Privacy Policy and Cookie Policy, is the entire and exclusive agreement between Cright and you regarding the Service, and this Agreement supersedes and replaces any prior agreements between Cright and you regarding the Service. You also may be subject to additional terms and conditions that may apply when you use or purchase certain other Cright services, affiliate services or third-party content software or services.')]
	        }, {
	          key: 'general_',
	          header: t('General'),
	          bodies: [t('These Terms of Service, including the Privacy Policy, are for the benefit of us and the providers of User Files contracted to us, our and their officers, directors, employees, affiliates, agents, licensors, and suppliers. Each of these individuals or entities shall have the right to assert and enforce these Terms directly against you on its (or their own) behalf. Our failure to act with respect to a breach by you or others does not waive our right to act with respect to subsequent or similar breaches.'), t('You will not assign any rights granted to you or delegate any of your duties hereunder; any attempt to do so is void and of no effect. Cright may freely assign these Terms of Service and the rights granted hereunder without restriction. Nothing in this Agreement shall constitute a partnership or joint venture between you and Cright; you and we are dealing at arms\' length, creating a commercial relationship. We are not your agent or your fiduciary. In the event that any provision of this Agreement is held to be invalid or unenforceable, the remaining provisions of this Agreement will remain in full force and affect. Cright may provide you with notices, including those regarding changes to the Service by email or by postings on the Service. The failure of Cright to enforce any right or provision of this Agreement will not be deemed a waiver of such right or provision. In the event that any inconsistencies exist between these Terms of Service and any future published terms of use or understanding, the last published Terms of Service shall prevail. The headings and captions are for convenience only and are not to be used in the interpretation of this Agreement.'), _react2.default.createElement(_reactI18next.Interpolate, {
	            i18nKey: 'If you have any questions about this Agreement, please contact Cright at {{email}}.',
	            email: _react2.default.createElement(
	              'a',
	              { target: '_blank', href: 'mailto:info@cright.com', rel: 'noopener noreferrer' },
	              'info@cright.com'
	            )
	          })]
	        }]
	      };
	
	      return _react2.default.createElement(_InfoPartition2.default, { text: text });
	    }
	    /* eslint-enable max-len */
	
	  }]);
	  return TermOfService;
	}(_react.Component), _class2.propTypes = {
	  t: _propTypes2.default.func.isRequired
	}, _temp)) || _class);
	exports.default = TermOfService;
	module.exports = exports['default'];

/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _InfoPartition = __webpack_require__(181);
	
	var _InfoPartition2 = _interopRequireDefault(_InfoPartition);
	
	var _reactI18next = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VatPolicy = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(VatPolicy, _Component);
	
	  function VatPolicy() {
	    (0, _classCallCheck3.default)(this, VatPolicy);
	    return (0, _possibleConstructorReturn3.default)(this, (VatPolicy.__proto__ || (0, _getPrototypeOf2.default)(VatPolicy)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(VatPolicy, [{
	    key: 'render',
	
	
	    /* eslint-disable max-len */
	    value: function render() {
	      var t = this.props.t;
	
	      var text = {
	        title: t('VAT Policy'),
	        preKey: 'vat-policy_',
	        body: t('In accordance with the sales tax regulations of European Union countries in which our Residents live, we must collect and remit Value Added Tax, or VAT, from Residents.'),
	        articles: [{
	          key: 'charged-vat_',
	          header: t('Who should be charged VAT?'),
	          bodies: [t('Currently, only Residents who live in the European Union are charged VAT. The EU allows people and companies to register for VAT exemption, which we abide by.')]
	        }, {
	          key: 'determinate_',
	          header: t('How does CRight determine who to charge VAT for?'),
	          bodies: [t('When you registered your account, you told us what country you live in. If that country is in the EU, then VAT is applied.'), t('If you say that you come from a different country that doesn\'t charge VAT, it\'s very likely that discrepancies between your IP address and your declared country would get caught in our risk detection system and may cause your account to be flagged for review or even suspended.')]
	        }, {
	          key: 'charged-items_',
	          header: t('How can I tell what items had VAT charged?'),
	          bodies: [t('Your account history page will display the transactions you made and the VAT charged on each one, if applicable.')]
	        }, {
	          key: 'exempt-vat_',
	          header: t('I have a VAT registration ID that makes me exempt from VAT. How do I enter it?'),
	          bodies: [t('If you\'re registering for a new account, there\'s a step where you can enter your VAT registration ID.'), t('If you have an existing account for which you want to enter your VAT registration ID, click here to enter it.')]
	        }]
	      };
	
	      return _react2.default.createElement(_InfoPartition2.default, { text: text });
	    }
	    /* eslint-enable max-len */
	
	  }]);
	  return VatPolicy;
	}(_react.Component), _class2.propTypes = {
	  t: _propTypes2.default.func.isRequired
	}, _temp)) || _class);
	exports.default = VatPolicy;
	module.exports = exports['default'];

/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _find3 = __webpack_require__(95);
	
	var _find4 = _interopRequireDefault(_find3);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _ButtonToolbar = __webpack_require__(1609);
	
	var _ButtonToolbar2 = _interopRequireDefault(_ButtonToolbar);
	
	var _Dropdown = __webpack_require__(1611);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _MenuItem = __webpack_require__(1614);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _config = __webpack_require__(41);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactCookie = __webpack_require__(174);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1277);
	
	var LangSelector = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    isMobile: state.common.isMobile
	  };
	}), _dec(_class = (0, _reactCookie.withCookies)(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(LangSelector, _Component);
	
	  function LangSelector() {
	    (0, _classCallCheck3.default)(this, LangSelector);
	    return (0, _possibleConstructorReturn3.default)(this, (LangSelector.__proto__ || (0, _getPrototypeOf2.default)(LangSelector)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LangSelector, [{
	    key: 'changeLang',
	    value: function changeLang(langCode) {
	      this.props.cookies.set('i18next', langCode, { path: '/' });
	      window.location.reload();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var langs = _config2.default.app.langs;
	      var _context$i18n = this.context.i18n;
	      _context$i18n = _context$i18n === undefined ? 'en' : _context$i18n;
	      var language = _context$i18n.language;
	      var _props = this.props,
	          className = _props.className,
	          isMobile = _props.isMobile;
	
	      var currentLang = (0, _find4.default)(langs, { code: language });
	      var getFlagImg = function getFlagImg(code) {
	        return __webpack_require__(2322)("./flag-" + ((isMobile ? 'mobile-' : '') + code.toLowerCase()) + '.png');
	      }; // eslint-disable-line import/no-dynamic-require
	
	      return _react2.default.createElement(
	        _ButtonToolbar2.default,
	        { className: (0, _classnames2.default)(styles.langSelector, className), title: currentLang.name },
	        _react2.default.createElement(
	          _Dropdown2.default,
	          { pullRight: true, id: 'lang-selector-dropdown' },
	          _react2.default.createElement(
	            _Dropdown2.default.Toggle,
	            { className: (0, _classnames2.default)('btn-clear', styles.toggle), bsStyle: 'link' },
	            _react2.default.createElement('img', { src: getFlagImg(currentLang.code), alt: '' })
	          ),
	          _react2.default.createElement(
	            _Dropdown2.default.Menu,
	            { title: '' },
	            langs.map(function (lang) {
	              return _react2.default.createElement(
	                _MenuItem2.default,
	                { key: lang.code, onClick: function onClick() {
	                    return _this2.changeLang(lang.code);
	                  } },
	                _react2.default.createElement('img', { src: getFlagImg(lang.code), alt: '' }),
	                lang.name
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	  return LangSelector;
	}(_react.Component), _class2.propTypes = {
	  className: _propTypes2.default.string,
	  cookies: _propTypes2.default.object,
	  isMobile: _propTypes2.default.bool
	}, _class2.contextTypes = {
	  i18n: _propTypes2.default.object.isRequired
	}, _temp)) || _class) || _class);
	exports.default = LangSelector;
	module.exports = exports['default'];

/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _typeof2 = __webpack_require__(102);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(113);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(21);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _invariant = __webpack_require__(22);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoadScript = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(LoadScript, _Component);
	
	  // A dictionary mapping script URL to a boolean value indicating if the script
	  // has failed to load.
	
	
	  // A dictionary mapping script URLs to a dictionary mapping
	  // component key to component for all components that are waiting
	  // for the script to load.
	  function LoadScript(props) {
	    (0, _classCallCheck3.default)(this, LoadScript);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (LoadScript.__proto__ || (0, _getPrototypeOf2.default)(LoadScript)).call(this, props));
	
	    _this.constructor.idCount += 1;
	    _this.scriptLoaderId = 'id' + _this.constructor.idCount; // eslint-disable-line space-unary-ops
	    return _this;
	  }
	
	  // A counter used to generate a unique id for each component that uses
	  // ScriptLoaderMixin.
	
	
	  // A dictionary mapping script URL to a boolean value indicating if the script
	  // has already been loaded.
	
	
	  (0, _createClass3.default)(LoadScript, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var url = this.props.url;
	
	
	      if (this.constructor.loadedScripts[url]) {
	        this.runCallback('onLoad');
	        return;
	      }
	
	      if (this.constructor.erroredScripts[url]) {
	        this.runCallback('onError');
	        return;
	      }
	
	      // If the script is loading, add the component to the script's observers
	      // and return. Otherwise, initialize the script's observers with the component
	      // and start loading the script.
	      if (this.constructor.scriptObservers[url]) {
	        this.constructor.scriptObservers[url][this.scriptLoaderId] = this.runCallback.bind(this);
	        return;
	      }
	
	      this.constructor.scriptObservers[url] = (0, _defineProperty3.default)({}, this.scriptLoaderId, this.runCallback.bind(this));
	
	      this.createScript();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var url = this.props.url;
	
	      var observers = this.constructor.scriptObservers[url];
	
	      // If the component is waiting for the script to load, remove the
	      // component from the script's observers before unmounting the component.
	      if (observers) {
	        delete observers[this.scriptLoaderId];
	      }
	    }
	  }, {
	    key: 'createScript',
	    value: function createScript() {
	      var _this2 = this;
	
	      var _props = this.props,
	          url = _props.url,
	          onCreate = _props.onCreate,
	          onError = _props.onError,
	          onLoad = _props.onLoad,
	          other = (0, _objectWithoutProperties3.default)(_props, ['url', 'onCreate', 'onError', 'onLoad']); // eslint-disable-line no-unused-vars
	
	      var script = document.createElement('script');
	
	      this.runCallback('onCreate', false);
	
	      script.src = url;
	      script.async = 1;
	
	      console.log(other);
	      // other.map((propName, propVal) => script[propName] = propVal);
	
	      var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(shouldRemoveObserver) {
	        var observers = _this2.constructor.scriptObservers[url];
	        (0, _keys2.default)(observers).forEach(function (key) {
	          if (shouldRemoveObserver(observers[key])) {
	            delete _this2.constructor.scriptObservers[url][_this2.scriptLoaderId];
	          }
	        });
	      };
	      script.onload = function () {
	        _this2.constructor.loadedScripts[url] = true;
	        callObserverFuncAndRemoveObserver(function (observer) {
	          observer('onLoad');
	          return true;
	        });
	      };
	
	      script.onerror = function () {
	        _this2.constructor.erroredScripts[url] = true;
	        callObserverFuncAndRemoveObserver(function (observer) {
	          observer('onError');
	          return true;
	        });
	      };
	
	      document.body.appendChild(script);
	    }
	  }, {
	    key: 'runCallback',
	    value: function runCallback(type) {
	      var required = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      var callback = this.props[type];
	
	      (0, _invariant2.default)(!required || typeof callback === 'function', 'Callback ' + type + ' must be function, got "' + (typeof callback === 'undefined' ? 'undefined' : (0, _typeof3.default)(callback)) + '" instead');
	
	      return callback && callback();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	  return LoadScript;
	}(_react.Component), _class.propTypes = {
	  onCreate: _propTypes2.default.func,
	  onError: _propTypes2.default.func,
	  onLoad: _propTypes2.default.func,
	  url: _propTypes2.default.string.isRequired
	}, _class.scriptObservers = {}, _class.loadedScripts = {}, _class.erroredScripts = {}, _class.idCount = 0, _temp);
	exports.default = LoadScript;
	module.exports = exports['default'];

/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reduxForm = __webpack_require__(50);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	var _loginContactFormValidation = __webpack_require__(2031);
	
	var _loginContactFormValidation2 = _interopRequireDefault(_loginContactFormValidation);
	
	var _auth = __webpack_require__(31);
	
	var _formComponents = __webpack_require__(71);
	
	var _auth2 = __webpack_require__(77);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var LoginContactForm = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    user: (0, _auth2.getUser)(state)
	  };
	}, { contact: _auth.contact }), _dec2 = (0, _reduxForm.reduxForm)({
	  form: 'contactForm',
	  propNamespace: 'contactForm',
	  validate: _loginContactFormValidation2.default
	}), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(LoginContactForm, _Component);
	
	  function LoginContactForm() {
	    (0, _classCallCheck3.default)(this, LoginContactForm);
	    return (0, _possibleConstructorReturn3.default)(this, (LoginContactForm.__proto__ || (0, _getPrototypeOf2.default)(LoginContactForm)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LoginContactForm, [{
	    key: 'submit',
	    value: function submit(formData) {
	      var _props = this.props,
	          onSend = _props.onSend,
	          reset = _props.contactForm.reset;
	
	      return this.props.contact(formData).promise.then(function (resp) {
	        reset();
	        onSend(resp.data);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          _props2$contactForm = _props2.contactForm,
	          submitting = _props2$contactForm.submitting,
	          invalid = _props2$contactForm.invalid,
	          handleSubmit = _props2$contactForm.handleSubmit,
	          user = _props2.user,
	          t = _props2.t;
	
	      var styles = __webpack_require__(1280);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: styles.title },
	          t('contactForm##title')
	        ),
	        _react2.default.createElement(
	          'form',
	          { className: 'form-horizontal', onSubmit: handleSubmit(this.submit) },
	          !user && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_reduxForm.Field, { name: 'firstName', type: 'text', component: _formComponents.formSimpleTextInput, placeholder: t('First name') }),
	            _react2.default.createElement(_reduxForm.Field, { name: 'lastName', type: 'text', component: _formComponents.formSimpleTextInput, placeholder: t('Last name') }),
	            _react2.default.createElement(_reduxForm.Field, { name: 'company', type: 'text', component: _formComponents.formSimpleTextInput, placeholder: t('Company') }),
	            _react2.default.createElement(_reduxForm.Field, { name: 'email', type: 'email', component: _formComponents.formSimpleTextInput, placeholder: t('Email') })
	          ),
	          _react2.default.createElement(_reduxForm.Field, {
	            name: 'enquiryMessage',
	            type: 'textarea',
	            component: _formComponents.formSimpleTextInput,
	            placeholder: t('Question/Request'),
	            bottomHint: t('Feel free to share any relevant information with us.')
	          }),
	          _react2.default.createElement(
	            'button',
	            { type: 'submit', className: 'btn btn-primary pull-right pos-rel', disabled: submitting || invalid },
	            t('send'),
	            submitting && _react2.default.createElement(_components.Loader, { mask: true })
	          )
	        )
	      );
	    }
	  }]);
	  return LoginContactForm;
	}(_react.Component), _class3.propTypes = {
	  contact: _propTypes2.default.func,
	  contactForm: _propTypes2.default.object,
	  onSend: _propTypes2.default.func,
	  t: _propTypes2.default.func,
	  user: _propTypes2.default.object
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'submit', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'submit'), _class2.prototype)), _class2)) || _class) || _class) || _class);
	exports.default = LoginContactForm;
	module.exports = exports['default'];

/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _validation = __webpack_require__(157);
	
	var _formValidation = __webpack_require__(263);
	
	var _formValidation2 = _interopRequireDefault(_formValidation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var name = _formValidation2.default.name,
	    lastName = _formValidation2.default.lastName,
	    company = _formValidation2.default.company,
	    email = _formValidation2.default.email,
	    message = _formValidation2.default.message;
	
	
	var validate = (0, _validation.createValidator)({
	  firstName: name,
	  lastName: lastName,
	  company: company,
	  email: email,
	  enquiryMessage: message
	});
	
	exports.default = validate;
	module.exports = exports['default'];

/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _regenerator = __webpack_require__(138);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(137);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _last2 = __webpack_require__(151);
	
	var _last3 = _interopRequireDefault(_last2);
	
	var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(11);
	
	var _myPlaylists = __webpack_require__(88);
	
	var myPlaylistsActions = _interopRequireWildcard(_myPlaylists);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _reduxForm = __webpack_require__(50);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _myPlaylists2 = __webpack_require__(527);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1284);
	
	var MyPlaylistsCreateBar = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    prop: state.myPlaylists.prop
	  };
	}, (0, _extends3.default)({}, myPlaylistsActions)), _dec2 = (0, _reduxForm.reduxForm)({
	  form: 'createMyPlaylistForm',
	  propNamespace: 'createMyPlaylistForm',
	  initialValues: {
	    name: ''
	  }
	}), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(MyPlaylistsCreateBar, _Component);
	
	  function MyPlaylistsCreateBar() {
	    (0, _classCallCheck3.default)(this, MyPlaylistsCreateBar);
	    return (0, _possibleConstructorReturn3.default)(this, (MyPlaylistsCreateBar.__proto__ || (0, _getPrototypeOf2.default)(MyPlaylistsCreateBar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MyPlaylistsCreateBar, [{
	    key: 'submit',
	    value: function () {
	      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(formData) {
	        var _props, addMyPlaylist, checkPlaylist, checkCreated, onCreated, reset, promise, resp, playlist;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _props = this.props, addMyPlaylist = _props.addMyPlaylist, checkPlaylist = _props.checkPlaylist, checkCreated = _props.checkCreated, onCreated = _props.onCreated, reset = _props.createMyPlaylistForm.reset;
	                promise = addMyPlaylist(formData).promise;
	                _context.next = 4;
	                return promise;
	
	              case 4:
	                resp = _context.sent;
	                playlist = (0, _last3.default)(resp.data);
	
	                reset();
	                if (checkCreated) {
	                  checkPlaylist({ guid: playlist.guid });
	                }
	                onCreated({ playlist: playlist });
	                return _context.abrupt('return', promise);
	
	              case 10:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function submit(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return submit;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          t = _props2.t,
	          disabled = _props2.disabled,
	          _props2$createMyPlayl = _props2.createMyPlaylistForm,
	          handleSubmit = _props2$createMyPlayl.handleSubmit,
	          submitting = _props2$createMyPlayl.submitting,
	          invalid = _props2$createMyPlayl.invalid;
	
	      var isDisabled = invalid || disabled;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(className) },
	        _react2.default.createElement(
	          'h4',
	          null,
	          t('Create new Playlist')
	        ),
	        _react2.default.createElement(
	          'form',
	          { onSubmit: handleSubmit(this.submit), className: styles.form },
	          _react2.default.createElement(
	            'div',
	            { className: styles.inputContainer },
	            _react2.default.createElement(_reduxForm.Field, {
	              component: 'input',
	              type: 'text',
	              name: 'name',
	              placeholder: t('Name'),
	              maxLength: _myPlaylists2.nameMaxLength,
	              required: true
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'text-right' },
	            _react2.default.createElement(
	              _Button2.default,
	              { type: 'submit', className: 'btn-default', disabled: isDisabled, loading: submitting },
	              t('Add')
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return MyPlaylistsCreateBar;
	}(_react.Component), _class3.propTypes = {
	  addMyPlaylist: _propTypes2.default.func,
	  checkCreated: _propTypes2.default.bool,
	  checkPlaylist: _propTypes2.default.func,
	  className: _propTypes2.default.string,
	  createMyPlaylistForm: _propTypes2.default.object,
	  disabled: _propTypes2.default.bool,
	  onCreated: _propTypes2.default.func,
	  t: _propTypes2.default.func
	}, _class3.defaultProps = {
	  onCreated: _noop3.default
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'submit', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'submit'), _class2.prototype)), _class2)) || _class) || _class) || _class);
	exports.default = MyPlaylistsCreateBar;
	module.exports = exports['default'];

/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _regenerator = __webpack_require__(138);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(137);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactI18next = __webpack_require__(12);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _Modal = __webpack_require__(212);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _MyPlaylistsList = __webpack_require__(864);
	
	var _MyPlaylistsList2 = _interopRequireDefault(_MyPlaylistsList);
	
	var _myPlaylists = __webpack_require__(88);
	
	var myPlaylistsActions = _interopRequireWildcard(_myPlaylists);
	
	var _playlists = __webpack_require__(100);
	
	var _MyPlaylistsSelectPopupFooter = __webpack_require__(2034);
	
	var _MyPlaylistsSelectPopupFooter2 = _interopRequireDefault(_MyPlaylistsSelectPopupFooter);
	
	var _myPlaylists2 = __webpack_require__(361);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _MyPLaylistsSearchBar = __webpack_require__(2172);
	
	var _MyPLaylistsSearchBar2 = _interopRequireDefault(_MyPLaylistsSearchBar);
	
	var _MyPlaylistsCreateBar = __webpack_require__(2032);
	
	var _MyPlaylistsCreateBar2 = _interopRequireDefault(_MyPlaylistsCreateBar);
	
	var _reactScroll = __webpack_require__(251);
	
	var _reactScroll2 = _interopRequireDefault(_reactScroll);
	
	var _uuid = __webpack_require__(270);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(624);
	
	var scroll = _reactScroll2.default.animateScroll;
	var listId = (0, _uuid2.default)();
	
	var MyPlaylistsSelectPopup = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    checkedPlaylists: (0, _myPlaylists2.getCheckedPlaylistsArray)(state),
	    myPlaylists: (0, _myPlaylists2.getFilteredPlaylists)(state),
	    myPlaylistsLoading: state.myPlaylists.myPlaylistsLoading,
	    playlistsLoading: state.playlists.playlistsLoading
	  };
	}, (0, _extends3.default)({}, myPlaylistsActions, { isPlaylistsLoaded: _playlists.isLoaded, loadPlaylists: _playlists.loadPlaylists })), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_PureComponent) {
	  (0, _inherits3.default)(MyPlaylistsSelectPopup, _PureComponent);
	
	  function MyPlaylistsSelectPopup() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, MyPlaylistsSelectPopup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = MyPlaylistsSelectPopup.__proto__ || (0, _getPrototypeOf2.default)(MyPlaylistsSelectPopup)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { saving: false };
	    return _this;
	  }
	
	  (0, _createClass3.default)(MyPlaylistsSelectPopup, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _props = this.props,
	          isLoaded = _props.isLoaded,
	          loadMyPlaylists = _props.loadMyPlaylists,
	          myPlaylistsLoading = _props.myPlaylistsLoading,
	          playlistsLoading = _props.playlistsLoading,
	          show = _props.show;
	
	      var isShowing = !prevProps.show && show;
	      var needLoadMyPlaylists = !isLoaded() && !myPlaylistsLoading;
	      var needLoadPlaylists = !this.props.isPlaylistsLoaded() && !playlistsLoading;
	
	      if (isShowing) {
	        if (needLoadMyPlaylists) {
	          loadMyPlaylists();
	        }
	        if (needLoadPlaylists) {
	          this.props.loadPlaylists();
	        }
	      }
	    }
	  }, {
	    key: 'onHide',
	    value: function onHide() {
	      var _props2 = this.props,
	          onHide = _props2.onHide,
	          setMyPlaylistsFilter = _props2.setMyPlaylistsFilter;
	
	      setTimeout(function () {
	        return setMyPlaylistsFilter({ kw: '' });
	      }, 300);
	      onHide();
	    }
	  }, {
	    key: 'onCreated',
	    value: function onCreated() {
	      scroll.scrollToBottom({ containerId: listId });
	    }
	  }, {
	    key: 'save',
	    value: function () {
	      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	        var _props3, onSave, checkedPlaylists, t;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _props3 = this.props, onSave = _props3.onSave, checkedPlaylists = _props3.checkedPlaylists, t = _props3.t;
	
	                this.setState({ saving: true });
	                _context.next = 4;
	                return onSave(checkedPlaylists);
	
	              case 4:
	                this.onHide();
	                this.setState({ saving: false });
	                _toastr2.default.success(t('Successfully saved!'));
	
	              case 7:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function save() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return save;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          t = _props4.t,
	          show = _props4.show,
	          checkedPlaylists = _props4.checkedPlaylists,
	          myPlaylistsLoading = _props4.myPlaylistsLoading,
	          myPlaylists = _props4.myPlaylists;
	      var saving = this.state.saving;
	
	      var modalProps = {
	        backdrop: true,
	        closeByEsc: false,
	        title: t('Add to My playlists'),
	        bsSize: 'lg',
	        withoutPadding: true
	      };
	
	      return _react2.default.createElement(
	        _Modal2.default,
	        (0, _extends3.default)({}, modalProps, { show: show, onHide: this.onHide }),
	        _react2.default.createElement(
	          'div',
	          { className: styles.topBars },
	          _react2.default.createElement(_MyPlaylistsCreateBar2.default, {
	            className: styles.addBar,
	            disabled: myPlaylistsLoading,
	            checkCreated: true,
	            onCreated: this.onCreated
	          }),
	          _react2.default.createElement(_MyPLaylistsSearchBar2.default, { autoFocus: true })
	        ),
	        _react2.default.createElement(_MyPlaylistsList2.default, {
	          loading: myPlaylistsLoading,
	          playlists: myPlaylists,
	          selectable: true,
	          clickable: false,
	          withOptions: false,
	          withIndex: true,
	          className: styles.list,
	          id: listId
	        }),
	        _react2.default.createElement(_MyPlaylistsSelectPopupFooter2.default, {
	          checkedCount: checkedPlaylists.length,
	          onSave: this.save,
	          loading: saving
	        })
	      );
	    }
	  }]);
	  return MyPlaylistsSelectPopup;
	}(_react.PureComponent), _class3.propTypes = {
	  checkedPlaylists: _propTypes2.default.array,
	  isLoaded: _propTypes2.default.func,
	  isPlaylistsLoaded: _propTypes2.default.func,
	  loadMyPlaylists: _propTypes2.default.func,
	  loadPlaylists: _propTypes2.default.func,
	  myPlaylists: _propTypes2.default.array,
	  myPlaylistsLoading: _propTypes2.default.bool,
	  onHide: _propTypes2.default.func,
	  onSave: _propTypes2.default.func,
	  playlistsLoading: _propTypes2.default.bool,
	  setMyPlaylistsFilter: _propTypes2.default.func,
	  show: _propTypes2.default.bool,
	  t: _propTypes2.default.func
	}, _class3.defaultProps = {
	  checkedPlaylists: [],
	  onHide: _noop3.default,
	  onSave: _noop3.default
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onHide', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onHide'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onCreated', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onCreated'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'save', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'save'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = MyPlaylistsSelectPopup;
	module.exports = exports['default'];

/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactI18next = __webpack_require__(12);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CheckedCount = __webpack_require__(818);
	
	var _CheckedCount2 = _interopRequireDefault(_CheckedCount);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _myPlaylists = __webpack_require__(88);
	
	var myPlaylistsActions = _interopRequireWildcard(_myPlaylists);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(624);
	
	var MyPlaylistsSelectPopupFooter = (_dec = (0, _reactRedux.connect)(null, (0, _extends3.default)({}, myPlaylistsActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(MyPlaylistsSelectPopupFooter, _Component);
	
	  function MyPlaylistsSelectPopupFooter() {
	    (0, _classCallCheck3.default)(this, MyPlaylistsSelectPopupFooter);
	    return (0, _possibleConstructorReturn3.default)(this, (MyPlaylistsSelectPopupFooter.__proto__ || (0, _getPrototypeOf2.default)(MyPlaylistsSelectPopupFooter)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MyPlaylistsSelectPopupFooter, [{
	    key: 'clearSelection',
	    value: function clearSelection() {
	      var updateCheckedPlaylists = this.props.updateCheckedPlaylists;
	
	      updateCheckedPlaylists({});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          t = _props.t,
	          checkedCount = _props.checkedCount,
	          onSave = _props.onSave,
	          loading = _props.loading;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.bottomContainer },
	        _react2.default.createElement(_CheckedCount2.default, { checkedCount: checkedCount, onClear: this.clearSelection }),
	        _react2.default.createElement(
	          'div',
	          { className: styles.buttonContainer },
	          _react2.default.createElement(
	            _Button2.default,
	            { className: 'btn-primary', onClick: onSave, loading: loading },
	            t('Save')
	          )
	        )
	      );
	    }
	  }]);
	  return MyPlaylistsSelectPopupFooter;
	}(_react.Component), _class3.propTypes = {
	  checkedCount: _propTypes2.default.number,
	  loading: _propTypes2.default.bool,
	  onSave: _propTypes2.default.func,
	  t: _propTypes2.default.func,
	  updateCheckedPlaylists: _propTypes2.default.func
	}, _class3.defaultProps = {
	  checkedCount: 0,
	  onSave: _noop3.default,
	  updateCheckedPlaylists: _noop3.default
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'clearSelection', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'clearSelection'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = MyPlaylistsSelectPopupFooter;
	module.exports = exports['default'];

/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NoRecords = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(NoRecords, _Component);
	
	  function NoRecords() {
	    (0, _classCallCheck3.default)(this, NoRecords);
	    return (0, _possibleConstructorReturn3.default)(this, (NoRecords.__proto__ || (0, _getPrototypeOf2.default)(NoRecords)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(NoRecords, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          t = _props.t,
	          message = _props.message,
	          className = _props.className;
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        message || t('No record found.')
	      );
	    }
	  }]);
	  return NoRecords;
	}(_react.Component), _class2.propTypes = {
	  className: _propTypes2.default.string,
	  message: _propTypes2.default.string,
	  t: _propTypes2.default.func
	}, _temp)) || _class);
	exports.default = NoRecords;
	module.exports = exports['default'];

/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(625);
	
	var PageNumber = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(PageNumber, _PureComponent);
	
	  function PageNumber() {
	    (0, _classCallCheck3.default)(this, PageNumber);
	    return (0, _possibleConstructorReturn3.default)(this, (PageNumber.__proto__ || (0, _getPrototypeOf2.default)(PageNumber)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PageNumber, [{
	    key: 'onClick',
	    value: function onClick() {
	      var _props = this.props,
	          onClick = _props.onClick,
	          pageNumber = _props.pageNumber;
	
	      onClick(pageNumber);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          pageNumber = _props2.pageNumber,
	          currentPage = _props2.currentPage;
	
	
	      return _react2.default.createElement(
	        'span',
	        {
	          className: (0, _bind2.default)(className, styles.pageItem, (0, _defineProperty3.default)({}, styles.active, pageNumber === currentPage)),
	          key: pageNumber,
	          onClick: this.onClick
	        },
	        pageNumber
	      );
	    }
	  }]);
	  return PageNumber;
	}(_react.PureComponent), _class2.propTypes = {
	  className: _propTypes2.default.string,
	  currentPage: _propTypes2.default.number,
	  onClick: _propTypes2.default.func,
	  pageNumber: _propTypes2.default.number
	}, _class2.defaultProps = {
	  onClick: _noop3.default
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onClick'), _class.prototype)), _class);
	exports.default = PageNumber;
	module.exports = exports['default'];

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1286);
	
	var PasswordValidationTicks = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(PasswordValidationTicks, _Component);
	
	  function PasswordValidationTicks() {
	    (0, _classCallCheck3.default)(this, PasswordValidationTicks);
	    return (0, _possibleConstructorReturn3.default)(this, (PasswordValidationTicks.__proto__ || (0, _getPrototypeOf2.default)(PasswordValidationTicks)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PasswordValidationTicks, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          t = _props.t,
	          value = _props.value,
	          _props$errors = _props.errors,
	          errors = _props$errors === undefined ? {} : _props$errors;
	
	      var getClass = function getClass(isError) {
	        return (0, _classnames2.default)(isError || !value ? styles.error : styles.success);
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-60 col-sm-30' },
	          _react2.default.createElement(
	            'div',
	            { className: getClass(errors.lowercase) },
	            _react2.default.createElement('i', null),
	            _react2.default.createElement(
	              'span',
	              null,
	              t('One lowercase character')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: getClass(errors.uppercase) },
	            _react2.default.createElement('i', null),
	            _react2.default.createElement(
	              'span',
	              null,
	              t('One uppercase character')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: getClass(errors.number) },
	            _react2.default.createElement('i', null),
	            _react2.default.createElement(
	              'span',
	              null,
	              t('One number')
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-60 col-sm-30' },
	          _react2.default.createElement(
	            'div',
	            { className: getClass(errors.symbol) },
	            _react2.default.createElement('i', null),
	            _react2.default.createElement(
	              'span',
	              null,
	              t('One special symbol')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: getClass(errors.length) },
	            _react2.default.createElement('i', null),
	            _react2.default.createElement(
	              'span',
	              null,
	              t('8 characters minimum')
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return PasswordValidationTicks;
	}(_react.Component), _class2.propTypes = {
	  errors: _propTypes2.default.object,
	  t: _propTypes2.default.func,
	  value: _propTypes2.default.string
	}, _temp)) || _class);
	exports.default = PasswordValidationTicks;
	module.exports = exports['default'];

/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _regenerator = __webpack_require__(138);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(137);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _get2 = __webpack_require__(19);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactI18next = __webpack_require__(12);
	
	var _index = __webpack_require__(15);
	
	var _index2 = __webpack_require__(213);
	
	var _playlist = __webpack_require__(217);
	
	var _downloads = __webpack_require__(262);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _config = __webpack_require__(41);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _auth = __webpack_require__(31);
	
	var _progresspopup = __webpack_require__(531);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _responseCodes = __webpack_require__(99);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var maxFilesToShowToast = 7;
	var estimationCorrection = 0;
	var wavFormat = 'wav';
	
	var DownloadTracksButton = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    downloadTracksLoading: state.playlist.downloadTracksLoading,
	    user: state.auth.user
	  };
	}, { downloadTracks: _playlist.downloadTracks, setRedirect: _auth.setRedirect, setLoginData: _auth.setLoginData, showProgressPopup: _progresspopup.show, hideProgressPopup: _progresspopup.hide }), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(DownloadTracksButton, _Component);
	
	  function DownloadTracksButton() {
	    (0, _classCallCheck3.default)(this, DownloadTracksButton);
	    return (0, _possibleConstructorReturn3.default)(this, (DownloadTracksButton.__proto__ || (0, _getPrototypeOf2.default)(DownloadTracksButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(DownloadTracksButton, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!this.props.user && nextProps.user) {
	        if (this.props.requireAuth) {
	          this.download();
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.hideProgressPopup();
	    }
	  }, {
	    key: 'onDownload',
	    value: function onDownload() {
	      var _props = this.props,
	          t = _props.t,
	          requireAuth = _props.requireAuth,
	          contentKey = _props.contentKey,
	          playlistUser = _props.playlistUser,
	          tracksNumbers = _props.tracksNumbers;
	
	      if (!tracksNumbers.length) {
	        return _toastr2.default.warning(t('Please select tracks to download.'));
	      }
	
	      if (requireAuth) {
	        this.props.setRedirect('/playlists/fromkey/' + contentKey);
	        this.props.setLoginData((0, _extends3.default)({}, playlistUser));
	        this.loginDialogEl.getWrappedInstance().getWrappedInstance().open();
	      } else {
	        this.download();
	      }
	    }
	  }, {
	    key: 'getEstimation',
	    value: function () {
	      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref2) {
	        var params = _ref2.params;
	        var estimation;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                _context.next = 3;
	                return this.props.downloadTracks((0, _extends3.default)({}, params, { getEstimation: true })).promise;
	
	              case 3:
	                estimation = _context.sent;
	
	                if (!(0, _get3.default)(estimation, 'code')) {
	                  this.props.showProgressPopup({ timeout: (0, _get3.default)(estimation, 'data.time') + estimationCorrection });
	                }
	                _context.next = 10;
	                break;
	
	              case 7:
	                _context.prev = 7;
	                _context.t0 = _context['catch'](0);
	
	                console.log(_context.t0);
	
	              case 10:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[0, 7]]);
	      }));
	
	      function getEstimation(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return getEstimation;
	    }()
	  }, {
	    key: 'download',
	    value: function () {
	      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
	        var _props2, t, format, tracksNumbers, contentKey, params, isWaitForArchive, _ref4, code, msg, data, _t, zipFileName;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _props2 = this.props, t = _props2.t, format = _props2.format, tracksNumbers = _props2.tracksNumbers, contentKey = _props2.contentKey;
	                params = { format: format, tracks: tracksNumbers, key: contentKey };
	                isWaitForArchive = tracksNumbers.length <= maxFilesToShowToast && format === wavFormat || format !== wavFormat;
	
	                if (!isWaitForArchive) {
	                  _context2.next = 6;
	                  break;
	                }
	
	                _context2.next = 6;
	                return this.getEstimation({ params: params });
	
	              case 6:
	                _context2.next = 8;
	                return this.props.downloadTracks(params).promise;
	
	              case 8:
	                _ref4 = _context2.sent;
	                code = _ref4.code;
	                msg = _ref4.msg;
	                data = _ref4.data;
	
	                this.props.hideProgressPopup();
	                if (code === _responseCodes.downloadTracksCodes.emailSent) {
	                  _toastr2.default.info(t('We\'re preparing your download...'), t('It can take a few minutes to process and secure your files. When your file is ready we will send you an email with a link that will enable you to complete the download process.'), // eslint-disable-line
	                  { timeOut: 12000 });
	                } else if (code) {
	                  _t = t;
	
	                  _toastr2.default.warning(_t(msg));
	                }
	                zipFileName = data.zipFileName;
	
	                if (zipFileName) {
	                  (0, _downloads.download)('' + _config2.default.app.urlParts.audio + zipFileName);
	                }
	
	              case 16:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function download() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return download;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          t = _props3.t,
	          downloadTracksLoading = _props3.downloadTracksLoading,
	          title = _props3.title,
	          className = _props3.className;
	
	
	      return _react2.default.createElement(
	        _Button2.default,
	        {
	          className: (0, _classnames2.default)('btn-primary pos-rel', className),
	          disabled: downloadTracksLoading,
	          onClick: this.onDownload
	        },
	        title || t('Download'),
	        downloadTracksLoading && _react2.default.createElement(_index.Loader, { mask: true }),
	        _react2.default.createElement(_index2.LoginDialog, { ref: function ref(el) {
	            return _this2.loginDialogEl = el;
	          } })
	      );
	    }
	  }]);
	  return DownloadTracksButton;
	}(_react.Component), _class3.propTypes = {
	  className: _propTypes2.default.string,
	  contentKey: _propTypes2.default.string,
	  downloadTracks: _propTypes2.default.func,
	  downloadTracksLoading: _propTypes2.default.bool,
	  format: _propTypes2.default.string.isRequired,
	  hideProgressPopup: _propTypes2.default.func,
	  playlistUser: _propTypes2.default.object,
	  requireAuth: _propTypes2.default.bool,
	  setLoginData: _propTypes2.default.func,
	  setRedirect: _propTypes2.default.func,
	  showProgressPopup: _propTypes2.default.func,
	  t: _propTypes2.default.func,
	  title: _propTypes2.default.string,
	  tracksNumbers: _propTypes2.default.array.isRequired,
	  user: _propTypes2.default.object
	}, _class3.defaultProps = {
	  playlistUser: {},
	  tracksNumbers: []
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onDownload', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onDownload'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = DownloadTracksButton;
	module.exports = exports['default'];

/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _index = __webpack_require__(15);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1288);
	
	var Labels = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(Labels, _Component);
	
	  function Labels() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, Labels);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = Labels.__proto__ || (0, _getPrototypeOf2.default)(Labels)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { visible: true };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Labels, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({ visible: !this.state.visible });
	    }
	
	    /* eslint-disable react/no-array-index-key */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          t = _props.t,
	          labels = _props.labels,
	          className = _props.className;
	      var visible = this.state.visible;
	
	
	      if (!labels || !labels.length) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(styles.labelsContainer, className, (0, _defineProperty3.default)({}, styles.visible, visible)) },
	        _react2.default.createElement(
	          'div',
	          { className: styles.labels },
	          visible && labels.map(function (label, key) {
	            return _react2.default.createElement(_index.Thumb, { key: key, fileName: label.subLabelLogo, urlPartName: 'label', className: styles.label });
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: styles.collapser, onClick: this.toggle },
	            visible ? _react2.default.createElement(
	              'span',
	              null,
	              t('Hide'),
	              ' ',
	              _react2.default.createElement('i', { className: 'icon-order-up' })
	            ) : _react2.default.createElement(
	              'span',
	              null,
	              t('Show labels'),
	              ' ',
	              _react2.default.createElement('i', { className: 'icon-order-down' })
	            )
	          )
	        )
	      );
	    }
	    /* eslint-enable react/no-array-index-key */
	
	  }]);
	  return Labels;
	}(_react.Component), _class3.propTypes = {
	  className: _propTypes2.default.string,
	  labels: _propTypes2.default.array,
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'toggle', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'toggle'), _class2.prototype)), _class2)) || _class);
	exports.default = Labels;
	module.exports = exports['default'];

/***/ }),
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _isEmpty2 = __webpack_require__(81);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _PlaylistAlbumCover = __webpack_require__(2041);
	
	var _PlaylistAlbumCover2 = _interopRequireDefault(_PlaylistAlbumCover);
	
	var _PlaylistAlbumInfo = __webpack_require__(2042);
	
	var _PlaylistAlbumInfo2 = _interopRequireDefault(_PlaylistAlbumInfo);
	
	var _WatermarkWarning = __webpack_require__(830);
	
	var _WatermarkWarning2 = _interopRequireDefault(_WatermarkWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1289);
	
	var PlaylistAlbum = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(PlaylistAlbum, _PureComponent);
	
	  function PlaylistAlbum() {
	    (0, _classCallCheck3.default)(this, PlaylistAlbum);
	    return (0, _possibleConstructorReturn3.default)(this, (PlaylistAlbum.__proto__ || (0, _getPrototypeOf2.default)(PlaylistAlbum)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PlaylistAlbum, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          album = _props.album;
	
	
	      if ((0, _isEmpty3.default)(album)) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(styles.album, className) },
	        _react2.default.createElement(
	          'div',
	          { className: styles.mainInfo },
	          _react2.default.createElement(_PlaylistAlbumCover2.default, { album: album }),
	          _react2.default.createElement(_PlaylistAlbumInfo2.default, { album: album })
	        ),
	        !!album.isWatermark && _react2.default.createElement(_WatermarkWarning2.default, { className: styles.watermark, projectType: album.audiovideo })
	      );
	    }
	  }]);
	  return PlaylistAlbum;
	}(_react.PureComponent), _class.propTypes = {
	  album: _propTypes2.default.object,
	  className: _propTypes2.default.string
	}, _class.defaultProps = {
	  album: {}
	}, _temp);
	exports.default = PlaylistAlbum;
	module.exports = exports['default'];

/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _Albums = __webpack_require__(525);
	
	var _AlbumThumbDescrition = __webpack_require__(511);
	
	var _AlbumThumbDescrition2 = _interopRequireDefault(_AlbumThumbDescrition);
	
	var _Thumb = __webpack_require__(259);
	
	var _Thumb2 = _interopRequireDefault(_Thumb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1290);
	
	var PlaylistCover = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(PlaylistCover, _PureComponent);
	
	  function PlaylistCover() {
	    (0, _classCallCheck3.default)(this, PlaylistCover);
	    return (0, _possibleConstructorReturn3.default)(this, (PlaylistCover.__proto__ || (0, _getPrototypeOf2.default)(PlaylistCover)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PlaylistCover, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          album = _props.album;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(styles.cover, className) },
	        _react2.default.createElement(_Thumb2.default, { fileName: album.imageThumb, defaultImageName: (0, _Albums.getDefaultImageName)(album) }),
	        _react2.default.createElement(_AlbumThumbDescrition2.default, { album: album })
	      );
	    }
	  }]);
	  return PlaylistCover;
	}(_react.PureComponent), _class.propTypes = {
	  album: _propTypes2.default.object,
	  className: _propTypes2.default.string
	}, _class.defaultProps = {
	  album: {}
	}, _temp);
	exports.default = PlaylistCover;
	module.exports = exports['default'];

/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _ByArtistName = __webpack_require__(817);
	
	var _ByArtistName2 = _interopRequireDefault(_ByArtistName);
	
	var _FromLabel = __webpack_require__(825);
	
	var _FromLabel2 = _interopRequireDefault(_FromLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1291);
	
	var PlaylistInfo = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(PlaylistInfo, _PureComponent);
	
	  function PlaylistInfo() {
	    (0, _classCallCheck3.default)(this, PlaylistInfo);
	    return (0, _possibleConstructorReturn3.default)(this, (PlaylistInfo.__proto__ || (0, _getPrototypeOf2.default)(PlaylistInfo)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PlaylistInfo, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          album = _props.album;
	      var t = this.context.t;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(styles.albumInfo, className) },
	        _react2.default.createElement(
	          'div',
	          { className: styles.infoTable },
	          _react2.default.createElement(
	            'div',
	            { className: styles.infoCell },
	            _react2.default.createElement(
	              'div',
	              { className: styles.albumName },
	              album.albumName
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: styles.artist },
	              _react2.default.createElement(_ByArtistName2.default, { artistName: album.artist_name })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: styles.smallHeader },
	              t('Sent by'),
	              ':'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: styles.sentBy },
	              _react2.default.createElement(
	                'div',
	                null,
	                album.senderName || album.sender
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_FromLabel2.default, { labelName: album.labelName })
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                album.fullSentDate
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return PlaylistInfo;
	}(_react.PureComponent), _class.propTypes = {
	  album: _propTypes2.default.object,
	  className: _propTypes2.default.string
	}, _class.contextTypes = {
	  t: _propTypes2.default.func
	}, _class.defaultProps = {
	  album: {}
	}, _temp);
	exports.default = PlaylistInfo;
	module.exports = exports['default'];

/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _FeedbackForm = __webpack_require__(829);
	
	var _FeedbackForm2 = _interopRequireDefault(_FeedbackForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1292);
	
	var PlaylistFeedbackForm = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(PlaylistFeedbackForm, _PureComponent);
	
	  function PlaylistFeedbackForm() {
	    (0, _classCallCheck3.default)(this, PlaylistFeedbackForm);
	    return (0, _possibleConstructorReturn3.default)(this, (PlaylistFeedbackForm.__proto__ || (0, _getPrototypeOf2.default)(PlaylistFeedbackForm)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PlaylistFeedbackForm, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          album = _props.album,
	          line = _props.line,
	          className = _props.className;
	
	
	      if (!album.recipient_id) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(styles.feedback, className) },
	        _react2.default.createElement(_FeedbackForm2.default, {
	          recipientId: album.recipient_id,
	          contentKey: album.contentKey,
	          sender: album.sender,
	          line: line
	        })
	      );
	    }
	  }]);
	  return PlaylistFeedbackForm;
	}(_react.PureComponent), _class.propTypes = {
	  album: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  line: _propTypes2.default.bool
	}, _class.defaultProps = {
	  album: {}
	}, _temp);
	exports.default = PlaylistFeedbackForm;
	module.exports = exports['default'];

/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _reactI18next = __webpack_require__(12);
	
	var _propTypes3 = __webpack_require__(127);
	
	var _datetime = __webpack_require__(68);
	
	var _progresspopup = __webpack_require__(531);
	
	var actions = _interopRequireWildcard(_progresspopup);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1294);
	
	var timerTimeout = null;
	
	var ProgressPopup = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    text: state.progresspopup.text,
	    timeout: state.progresspopup.timeout,
	    title: state.progresspopup.title,
	    visible: state.progresspopup.visible
	  };
	}, (0, _extends3.default)({}, actions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(ProgressPopup, _Component);
	
	  function ProgressPopup() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, ProgressPopup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = ProgressPopup.__proto__ || (0, _getPrototypeOf2.default)(ProgressPopup)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { width: '100%', timer: '00:00' };
	    return _this;
	  }
	
	  (0, _createClass3.default)(ProgressPopup, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.update();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.visible) {
	        clearTimeout(timerTimeout);
	        this.update({ timeout: nextProps.timeout });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unmounted = true;
	      clearTimeout(timerTimeout);
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var _this2 = this;
	
	      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref2$timeout = _ref2.timeout,
	          timeout = _ref2$timeout === undefined ? this.props.timeout : _ref2$timeout;
	
	      this.setState({ width: '100%', timeout: timeout });
	      setTimeout(function () {
	        if (!_this2.unmounted) {
	          _this2.setState({ width: 0, timeout: timeout });
	          _this2.updateTimer();
	        }
	      }, 100);
	    }
	  }, {
	    key: 'updateTimer',
	    value: function updateTimer() {
	      var _this3 = this;
	
	      if (!this.unmounted) {
	        var timeout = this.state.timeout;
	
	        this.setState({ timer: (0, _datetime.secToMin)(timeout), timeout: timeout - 1, isTimeEnd: timeout <= 0 });
	        if (timeout) {
	          timerTimeout = setTimeout(function () {
	            return _this3.updateTimer();
	          }, 1000);
	        }
	      }
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      this.props.hide();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          t = _props.t,
	          text = _props.text,
	          timeout = _props.timeout,
	          title = _props.title,
	          visible = _props.visible;
	      var _state = this.state,
	          width = _state.width,
	          timer = _state.timer,
	          isTimeEnd = _state.isTimeEnd;
	
	
	      if (!visible) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(styles.popup, className) },
	        _react2.default.createElement(
	          'div',
	          { className: styles.container },
	          _react2.default.createElement(
	            'div',
	            { className: styles.textContainer },
	            _react2.default.createElement('span', { className: styles.infoIcon }),
	            _react2.default.createElement(
	              'span',
	              { className: styles.message },
	              _react2.default.createElement(
	                'div',
	                { className: styles.title },
	                title || t('Information')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: styles.text },
	                text || t('Please wait while we prepare your download files')
	              )
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: styles.closeButton, onClick: this.hide },
	              '\u2715'
	            )
	          ),
	          !isTimeEnd && _react2.default.createElement(
	            'span',
	            { className: styles.timer },
	            timer
	          ),
	          _react2.default.createElement('div', { className: styles.progressBar, style: { transitionDuration: timeout + 's', width: width } })
	        )
	      );
	    }
	  }]);
	  return ProgressPopup;
	}(_react.Component), _class3.propTypes = {
	  className: _propTypes2.default.string,
	  hide: _propTypes2.default.func,
	  t: _propTypes2.default.func,
	  text: _propTypes3.node,
	  timeout: _propTypes2.default.number,
	  title: _propTypes3.node,
	  visible: _propTypes2.default.bool
	}, _class3.defaultProps = {
	  timeout: 10
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'hide', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'hide'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = ProgressPopup;
	module.exports = exports['default'];

/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1295);
	
	var ProgressStatus = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(ProgressStatus, _Component);
	
	  function ProgressStatus() {
	    (0, _classCallCheck3.default)(this, ProgressStatus);
	    return (0, _possibleConstructorReturn3.default)(this, (ProgressStatus.__proto__ || (0, _getPrototypeOf2.default)(ProgressStatus)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProgressStatus, [{
	    key: 'getBarStyle',
	    value: function getBarStyle() {
	      var _props = this.props,
	          countAll = _props.countAll,
	          count = _props.count;
	
	      var percents = count / countAll * 100;
	      return { width: percents + '%' };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          containerClassName = _props2.containerClassName,
	          barClassName = _props2.barClassName;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(styles.container, containerClassName) },
	        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.bar, barClassName), style: this.getBarStyle() })
	      );
	    }
	  }]);
	  return ProgressStatus;
	}(_react.Component), _class.propTypes = {
	  barClassName: _propTypes2.default.string,
	  containerClassName: _propTypes2.default.string,
	  count: _propTypes2.default.number,
	  countAll: _propTypes2.default.number
	}, _temp);
	exports.default = ProgressStatus;
	module.exports = exports['default'];

/***/ }),
/* 2046 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(124);
	
	var _reactI18next = __webpack_require__(12);
	
	var _projects = __webpack_require__(28);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1296);
	
	var ProjectBreadcrumbs = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(ProjectBreadcrumbs, _Component);
	
	  function ProjectBreadcrumbs() {
	    (0, _classCallCheck3.default)(this, ProjectBreadcrumbs);
	    return (0, _possibleConstructorReturn3.default)(this, (ProjectBreadcrumbs.__proto__ || (0, _getPrototypeOf2.default)(ProjectBreadcrumbs)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProjectBreadcrumbs, [{
	    key: 'renderCrumb',
	    value: function renderCrumb(section, title) {
	      var isProjectRequired = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	      var _props = this.props,
	          projectId = _props.projectId,
	          projectType = _props.projectType,
	          activeSection = _props.activeSection,
	          notClickable = _props.notClickable;
	
	      var isClickable = !notClickable && (projectId || !isProjectRequired);
	
	      return isClickable ? _react2.default.createElement(
	        _reactRouter.Link,
	        { className: styles.breadcrumb, to: '/projects/' + projectType + '/' + projectId + '/' + section, activeClassName: 'active' },
	        _react2.default.createElement(
	          'div',
	          { className: styles.breadcrumbContent },
	          title
	        )
	      ) : _react2.default.createElement(
	        'span',
	        { className: (0, _bind2.default)(styles.breadcrumb, { active: activeSection === section }) },
	        _react2.default.createElement(
	          'div',
	          { className: styles.breadcrumbContent },
	          title
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          t = _props2.t,
	          projectType = _props2.projectType;
	
	      var infoTitle = projectType === _projects.projectTypes.sharespace ? t('Sharespace Information') : t('Project Information');
	      var materialsTitle = projectType === _projects.projectTypes.video ? t('Video & Press Material') : t('Audio & Press Material');
	      var recipientsTitle = t('Recipients');
	      var confirmationTitle = t('Confirmation');
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.breadcrumbs },
	        this.renderCrumb('info', infoTitle, false),
	        this.renderCrumb('materials', materialsTitle, false),
	        projectType !== _projects.projectTypes.sharespace && this.renderCrumb('recipients', recipientsTitle, false),
	        projectType !== _projects.projectTypes.sharespace && this.renderCrumb('confirmation', confirmationTitle)
	      );
	    }
	  }]);
	  return ProjectBreadcrumbs;
	}(_react.Component), _class3.propTypes = {
	  activeSection: _propTypes2.default.string,
	  notClickable: _propTypes2.default.bool,
	  projectId: _propTypes2.default.number,
	  projectType: _propTypes2.default.string,
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'renderCrumb', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'renderCrumb'), _class2.prototype)), _class2)) || _class);
	exports.default = ProjectBreadcrumbs;
	module.exports = exports['default'];

/***/ }),
/* 2047 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get3 = __webpack_require__(19);
	
	var _get4 = _interopRequireDefault(_get3);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _auth = __webpack_require__(31);
	
	var _project = __webpack_require__(37);
	
	var projectActions = _interopRequireWildcard(_project);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _uploads = __webpack_require__(112);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1297);
	
	var newKey = function newKey() {
	  return Date.now();
	};
	var coverSupportedFormats = (0, _uploads.getUploaderAcceptableFormats)('cover');
	
	var ProjectCover = (_dec = (0, _reactRedux.connect)(null, (0, _extends3.default)({}, projectActions, { logout: _auth.logout })), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(ProjectCover, _Component);
	
	  function ProjectCover() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, ProjectCover);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = ProjectCover.__proto__ || (0, _getPrototypeOf2.default)(ProjectCover)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = {};
	    return _this;
	  }
	
	  (0, _createClass3.default)(ProjectCover, [{
	    key: 'onImageSelected',
	    value: function onImageSelected(e) {
	      this.coverCropper.onImageSelected(e);
	      this.setState({ coverButtonKey: newKey() });
	    }
	  }, {
	    key: 'onCoverUpload',
	    value: function onCoverUpload(id, name, resp) {
	      var code = resp.code,
	          msg = resp.msg;
	      var _props = this.props,
	          setCover = _props.setCover,
	          project = _props.project;
	
	      if (code === 1) {
	        return this.props.logout();
	      }
	
	      if (code && msg) {
	        _toastr2.default.error(msg);
	      }
	
	      var cover = (0, _get4.default)(resp, 'data.imageThumb');
	      if (cover) {
	        setCover(project.id, cover);
	      }
	    }
	  }, {
	    key: 'deleteCover',
	    value: function deleteCover() {
	      var project = this.props.project;
	
	      this.props.deleteCover(project.id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          t = _props2.t,
	          project = _props2.project,
	          disabled = _props2.disabled;
	      var coverButtonKey = this.state.coverButtonKey;
	
	      var coverUploaderParams = { queryParams: { projectId: project.id }, endpoint: '/api/FileUpload_wa/uploadCover' };
	      var isLocked = disabled;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'clearfix' },
	          _react2.default.createElement(_components.Thumb, { className: styles.cover, fileName: project.imageThumb }),
	          _react2.default.createElement(
	            'div',
	            { className: styles.coverActions },
	            _react2.default.createElement(
	              'div',
	              { className: 'hint small' },
	              _react2.default.createElement(
	                'span',
	                null,
	                t('Optional - Cover picture will be displayed on the email sent to the recipients and on the player.')
	              ),
	              isLocked && _react2.default.createElement(
	                'span',
	                null,
	                ' ',
	                t('Upload file here.')
	              )
	            )
	          ),
	          !isLocked && _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('clearfix', styles.coverButtons) },
	            _react2.default.createElement(
	              'div',
	              { className: 'hint small' },
	              t('Images (jpg, png, bmp) accepted.')
	            ),
	            _react2.default.createElement(
	              'label',
	              { className: 'fileInputContainer margin-right-10', key: coverButtonKey },
	              _react2.default.createElement(
	                'span',
	                { className: 'btn btn-primary margin-vert-5' },
	                t('Upload new')
	              ),
	              _react2.default.createElement('input', { type: 'file', className: 'fileInput', accept: coverSupportedFormats, onChange: this.onImageSelected })
	            ),
	            _react2.default.createElement(
	              'button',
	              { type: 'button', className: 'btn btn-accent margin-vert-5', onClick: this.deleteCover },
	              t('Delete')
	            )
	          )
	        ),
	        _react2.default.createElement(_components.CropUploader, {
	          ref: function ref(el) {
	            return _this2.coverCropper = el;
	          },
	          onUpload: this.onCoverUpload,
	          className: 'margin-top-10',
	          cropperClassName: styles.coverCropper,
	          uploaderParams: coverUploaderParams
	        })
	      );
	    }
	  }]);
	  return ProjectCover;
	}(_react.Component), _class3.propTypes = {
	  deleteCover: _propTypes2.default.func,
	  disabled: _propTypes2.default.bool,
	  logout: _propTypes2.default.func,
	  project: _propTypes2.default.object.isRequired,
	  setCover: _propTypes2.default.func,
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onImageSelected', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onImageSelected'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onCoverUpload', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onCoverUpload'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'deleteCover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'deleteCover'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = ProjectCover;
	module.exports = exports['default'];

/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _map3 = __webpack_require__(241);
	
	var _map4 = _interopRequireDefault(_map3);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _project = __webpack_require__(37);
	
	var projectActions = _interopRequireWildcard(_project);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	var _strings = __webpack_require__(59);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var MediaList = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    deleteMediaActionData: state.project.deleteMediaActionData,
	    deleteMediaLoading: state.project.deleteMediaLoading,
	    editMediaActionData: state.project.editMediaActionData,
	    editMediaLoading: state.project.editMediaLoading,
	    mediaList: state.project.mediaListData,
	    mediaListLoading: state.project.mediaListLoading,
	    updateMediaOrderLoading: state.project.updateMediaOrderLoading
	  };
	}, (0, _extends3.default)({}, projectActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(MediaList, _Component);
	
	  function MediaList() {
	    (0, _classCallCheck3.default)(this, MediaList);
	    return (0, _possibleConstructorReturn3.default)(this, (MediaList.__proto__ || (0, _getPrototypeOf2.default)(MediaList)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MediaList, [{
	    key: 'onMove',
	    value: function onMove(dragIndex, hoverIndex) {
	      var resortMediaList = this.props.resortMediaList;
	
	      resortMediaList(dragIndex, hoverIndex);
	    }
	  }, {
	    key: 'onDrop',
	    value: function onDrop() {
	      var _props = this.props,
	          updateMediaOrder = _props.updateMediaOrder,
	          mediaList = _props.mediaList,
	          projectId = _props.projectId;
	
	      var ids = (0, _map4.default)(mediaList, 'id');
	      return updateMediaOrder(projectId, ids);
	    }
	  }, {
	    key: 'getMediaListPopover',
	    value: function getMediaListPopover(el) {
	      if (el) {
	        this.mediaListPopover = el.getWrappedInstance().getWrappedInstance();
	      }
	    }
	  }, {
	    key: 'isMediaEdited',
	    value: function isMediaEdited(id) {
	      var _props2 = this.props,
	          deleteMediaLoading = _props2.deleteMediaLoading,
	          deleteMediaActionData = _props2.deleteMediaActionData,
	          editMediaLoading = _props2.editMediaLoading,
	          editMediaActionData = _props2.editMediaActionData;
	
	      return deleteMediaLoading && deleteMediaActionData.uploadId === id || editMediaLoading && editMediaActionData.uploadId === id;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          t = _props3.t,
	          mediaList = _props3.mediaList,
	          mediaListLoading = _props3.mediaListLoading,
	          projectId = _props3.projectId,
	          projectType = _props3.projectType,
	          updateMediaOrderLoading = _props3.updateMediaOrderLoading,
	          multipleBoxsets = _props3.multipleBoxsets,
	          isLocked = _props3.isLocked,
	          isStandardMode = _props3.isStandardMode,
	          hideOwner = _props3.hideOwner,
	          hideReplaceFile = _props3.hideReplaceFile,
	          hideDelete = _props3.hideDelete,
	          hideIsrc = _props3.hideIsrc,
	          hidePackId = _props3.hidePackId;
	
	
	      var hideDragHandler = false;
	      var lockSort = isLocked || mediaList.length < 2;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'pos-rel' },
	          _react2.default.createElement(
	            _components.SortableList,
	            { className: 'margin-bottom-20 no-select' },
	            _react2.default.createElement(
	              _components.ListItem,
	              { fullWidth: true, isTitle: true },
	              !hideDragHandler && _react2.default.createElement('div', null),
	              multipleBoxsets && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'hidden-sm hidden-xs' },
	                  t('Part')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'visible-sm visible-xs' },
	                  '#'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                t('Artist')
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                t('File Name')
	              ),
	              !hideOwner && _react2.default.createElement(
	                'div',
	                null,
	                t('Owner')
	              ),
	              _react2.default.createElement('div', null)
	            ),
	            mediaList.map(function (media, index) {
	              return _react2.default.createElement(
	                _components.SortableListItem,
	                {
	                  fullWidth: true,
	                  hideDragHandler: hideDragHandler,
	                  isLocked: lockSort,
	                  key: media.id,
	                  onMove: _this2.onMove,
	                  onDrop: _this2.onDrop,
	                  index: index,
	                  id: media.id
	                },
	                multipleBoxsets && _react2.default.createElement(
	                  'div',
	                  null,
	                  media.part
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  media.artist
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  media.filename,
	                  !hideIsrc && _react2.default.createElement(
	                    'span',
	                    { className: 'hint small margin-left-10' },
	                    media.isrc
	                  )
	                ),
	                !hideOwner && _react2.default.createElement(
	                  'div',
	                  null,
	                  (0, _strings.concat)(' ', media.name, media.surname)
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'moreCell' },
	                  !isLocked && _react2.default.createElement('i', { className: 'more', onClick: function onClick(e) {
	                      return _this2.mediaListPopover.toggle(e, media);
	                    } }),
	                  _this2.isMediaEdited(media.id) && _react2.default.createElement(_components.Loader, { small: true, mask: true })
	                )
	              );
	            })
	          ),
	          (mediaListLoading || updateMediaOrderLoading) && _react2.default.createElement(_components.Loader, { mask: true })
	        ),
	        _react2.default.createElement(_components.MediaListPopover, {
	          projectId: projectId,
	          projectType: projectType,
	          ref: this.getMediaListPopover,
	          isStandardMode: isStandardMode,
	          hideReplaceFile: hideReplaceFile,
	          hideDelete: hideDelete,
	          hideIsrc: hideIsrc,
	          hidePackId: hidePackId
	        })
	      );
	    }
	  }]);
	  return MediaList;
	}(_react.Component), _class3.propTypes = {
	  deleteMediaActionData: _propTypes2.default.object,
	  deleteMediaLoading: _propTypes2.default.bool,
	  editMediaActionData: _propTypes2.default.object,
	  editMediaLoading: _propTypes2.default.bool,
	  hideDelete: _propTypes2.default.bool,
	  hideIsrc: _propTypes2.default.bool,
	  hideOwner: _propTypes2.default.bool,
	  hidePackId: _propTypes2.default.bool,
	  hideReplaceFile: _propTypes2.default.bool,
	  isLocked: _propTypes2.default.bool,
	  isStandardMode: _propTypes2.default.bool,
	  mediaList: _propTypes2.default.array,
	  mediaListLoading: _propTypes2.default.bool,
	  multipleBoxsets: _propTypes2.default.bool,
	  projectId: _propTypes2.default.number.isRequired,
	  projectType: _propTypes2.default.string.isRequired,
	  resortMediaList: _propTypes2.default.func,
	  t: _propTypes2.default.func,
	  updateMediaOrder: _propTypes2.default.func,
	  updateMediaOrderLoading: _propTypes2.default.bool
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onMove', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onMove'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onDrop', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onDrop'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'getMediaListPopover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'getMediaListPopover'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = MediaList;
	module.exports = exports['default'];

/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _project = __webpack_require__(37);
	
	var projectActions = _interopRequireWildcard(_project);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _projects = __webpack_require__(28);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var MediaListPopover = (_dec = (0, _reactRedux.connect)(null, (0, _extends3.default)({}, projectActions), null, { withRef: true }), _dec2 = (0, _reactI18next.translate)(['common'], { withRef: true }), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(MediaListPopover, _Component);
	
	  function MediaListPopover() {
	    (0, _classCallCheck3.default)(this, MediaListPopover);
	    return (0, _possibleConstructorReturn3.default)(this, (MediaListPopover.__proto__ || (0, _getPrototypeOf2.default)(MediaListPopover)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MediaListPopover, [{
	    key: 'onDropError',
	    value: function onDropError(error) {
	      return _toastr2.default.error(error);
	    }
	  }, {
	    key: 'getReplaceMediaFile',
	    value: function getReplaceMediaFile(el) {
	      if (el) {
	        this.replaceMediaFile = el.getWrappedInstance().getWrappedInstance();
	      }
	    }
	  }, {
	    key: 'deleteMedia',
	    value: function deleteMedia(media) {
	      var _props = this.props,
	          deleteMedia = _props.deleteMedia,
	          projectId = _props.projectId,
	          t = _props.t;
	
	      var toastrConfirmOptions = {
	        onOk: function onOk() {
	          return deleteMedia(projectId, media.id);
	        },
	        onCancel: function onCancel() {}
	      };
	      _toastr2.default.confirm(t('Are you sure you want to delete this file?'), toastrConfirmOptions);
	    }
	  }, {
	    key: 'editMedia',
	    value: function editMedia(reqField) {
	      var mediaField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : reqField;
	      var media = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.popover.data;
	      var _props2 = this.props,
	          editMedia = _props2.editMedia,
	          projectId = _props2.projectId,
	          t = _props2.t;
	
	
	      this.prompt.getWrappedInstance().show({
	        title: t('Edit media'),
	        value: media[mediaField],
	        onOk: function onOk(val) {
	          return editMedia(projectId, media.id, (0, _defineProperty3.default)({}, reqField, val));
	        }
	      });
	    }
	  }, {
	    key: 'replaceMedia',
	    value: function replaceMedia(media) {
	      var _props3 = this.props,
	          t = _props3.t,
	          projectId = _props3.projectId;
	
	
	      this.replaceMediaFile.show({
	        title: t('Replace media file'),
	        onOk: function onOk(val) {
	          return console.log(val);
	        },
	        media: media,
	        postParams: { projectId: projectId }
	      });
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle(e, media) {
	      this.popover.toggle(e, media);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          t = _props4.t,
	          projectType = _props4.projectType,
	          projectId = _props4.projectId,
	          hideReplaceFile = _props4.hideReplaceFile,
	          hideDelete = _props4.hideDelete,
	          hideIsrc = _props4.hideIsrc,
	          hidePackId = _props4.hidePackId,
	          isStandardMode = _props4.isStandardMode;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _components.PopoverMenu,
	          { id: 'mediaListPopover', ref: function ref(el) {
	              _this2.popover = el;
	            } },
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.editMedia('fileName', 'filename');
	              } },
	            t('Edit File Name'),
	            _react2.default.createElement('i', { className: 'icon-mode-edit' })
	          ),
	          !hidePackId && _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.editMedia('part');
	              } },
	            t('Edit Pack ID'),
	            _react2.default.createElement('i', { className: 'icon-mode-edit' })
	          ),
	          !hideIsrc && _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.editMedia('isrc');
	              } },
	            t('Edit ISRC'),
	            _react2.default.createElement('i', { className: 'icon-mode-edit' })
	          ),
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.editMedia('artist');
	              } },
	            t('Edit Artist'),
	            _react2.default.createElement('i', { className: 'icon-mode-edit' })
	          ),
	          !hideReplaceFile && !isStandardMode && projectType !== _projects.projectTypes.video && _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.replaceMedia(_this2.popover.data);
	              } },
	            t('Replace Track'),
	            _react2.default.createElement('i', { className: 'icon-upload' })
	          ),
	          !hideDelete && _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.deleteMedia(_this2.popover.data);
	              } },
	            t('Delete Track'),
	            _react2.default.createElement('i', { className: 'icon-delete' })
	          )
	        ),
	        !hideReplaceFile && _react2.default.createElement(_components.ReplaceMediaFile, { ref: this.getReplaceMediaFile, projectId: projectId, projectType: projectType, onDropError: this.onDropError }),
	        _react2.default.createElement(_components.Prompt, { ref: function ref(el) {
	            return _this2.prompt = el;
	          } })
	      );
	    }
	  }]);
	  return MediaListPopover;
	}(_react.Component), _class3.propTypes = {
	  deleteMedia: _propTypes2.default.func,
	  editMedia: _propTypes2.default.func,
	  hideDelete: _propTypes2.default.bool,
	  hideIsrc: _propTypes2.default.bool,
	  hidePackId: _propTypes2.default.bool,
	  hideReplaceFile: _propTypes2.default.bool,
	  isStandardMode: _propTypes2.default.bool,
	  projectId: _propTypes2.default.number.isRequired,
	  projectType: _propTypes2.default.string.isRequired,
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onDropError', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onDropError'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'getReplaceMediaFile', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'getReplaceMediaFile'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = MediaListPopover;
	module.exports = exports['default'];

/***/ }),
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _project = __webpack_require__(37);
	
	var projectActions = _interopRequireWildcard(_project);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	var _reactRouterRedux = __webpack_require__(40);
	
	var _projects = __webpack_require__(136);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _ProjectIrefTooltip = __webpack_require__(833);
	
	var _ProjectIrefTooltip2 = _interopRequireDefault(_ProjectIrefTooltip);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var SSProjectsList = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    deleteSSProjectActionData: state.project.deleteSSProjectActionData,
	    deleteSSProjectLoading: state.project.deleteSSProjectLoading,
	    ssProjectsList: (0, _projects.getSharespaceProjects)(state),
	    ssProjectsListLoading: state.project.ssProjectsListLoading,
	    user: state.auth.user
	  };
	}, (0, _extends3.default)({}, projectActions, { pushState: _reactRouterRedux.push })), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(SSProjectsList, _Component);
	
	  function SSProjectsList() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, SSProjectsList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = SSProjectsList.__proto__ || (0, _getPrototypeOf2.default)(SSProjectsList)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { ssProjectsListPopoverHideDelete: false };
	    return _this;
	  }
	
	  (0, _createClass3.default)(SSProjectsList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          projectId = _props.projectId,
	          loadSSProjects = _props.loadSSProjects;
	
	      loadSSProjects(projectId);
	    }
	  }, {
	    key: 'gotoProject',
	    value: function gotoProject(project) {
	      this.props.pushState('/projects/' + project.audiovideo + '/' + project.id + '/materials');
	    }
	  }, {
	    key: 'deleteProject',
	    value: function deleteProject(project) {
	      var _props2 = this.props,
	          deleteSSProject = _props2.deleteSSProject,
	          t = _props2.t;
	
	      var toastrConfirmOptions = {
	        onOk: function onOk() {
	          return deleteSSProject(project.id);
	        }
	      };
	      _toastr2.default.confirm(t('Are you sure you want to delete this project?'), toastrConfirmOptions);
	    }
	  }, {
	    key: 'toggleSSProjectsListPopover',
	    value: function toggleSSProjectsListPopover(e, project) {
	      var user = this.props.user;
	
	      this.setState({ ssProjectsListPopoverHideDelete: project.owId !== user.userId });
	      this.ssProjectsListPopover.toggle(e, project);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          t = _props3.t,
	          ssProjectsList = _props3.ssProjectsList,
	          ssProjectsListLoading = _props3.ssProjectsListLoading,
	          deleteSSProjectLoading = _props3.deleteSSProjectLoading,
	          deleteSSProjectActionData = _props3.deleteSSProjectActionData;
	
	      var showSSProjectLoader = function showSSProjectLoader(project) {
	        return deleteSSProjectLoading && deleteSSProjectActionData.projectId === project.id;
	      };
	      var ssProjectsListPopoverHideDelete = this.state.ssProjectsListPopoverHideDelete;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _components.List,
	          { className: 'margin-bottom-20' },
	          _react2.default.createElement(
	            _components.ListItem,
	            { fullWidth: true, isTitle: true },
	            _react2.default.createElement(
	              'div',
	              null,
	              t('Package')
	            ),
	            _react2.default.createElement('div', null),
	            _react2.default.createElement(
	              'div',
	              null,
	              t('Status')
	            ),
	            _react2.default.createElement('div', null)
	          ),
	          ssProjectsList.map(function (project) {
	            return _react2.default.createElement(
	              _components.ListItem,
	              { fullWidth: true, key: project.id },
	              _react2.default.createElement(
	                'div',
	                null,
	                project.fullTitle,
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'text-muted' },
	                  t('Created by: {{owner}}', { owner: project.owName }),
	                  '. ',
	                  t('{{count}} recipients', { count: Number(project.nbreceps) })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_ProjectIrefTooltip2.default, { iRef: project.iRef })
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_components.ProjectStatus, { status: project.status })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'moreCell' },
	                _react2.default.createElement('i', { className: 'more', onClick: function onClick(e) {
	                    return _this2.toggleSSProjectsListPopover(e, project);
	                  } }),
	                showSSProjectLoader(project) && _react2.default.createElement(_components.Loader, { small: true, mask: true })
	              )
	            );
	          })
	        ),
	        ssProjectsListLoading && _react2.default.createElement(_components.Loader, null),
	        _react2.default.createElement(
	          _components.PopoverMenu,
	          { id: 'ssProjectsListPopover', ref: function ref(el) {
	              return _this2.ssProjectsListPopover = el;
	            } },
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.gotoProject(_this2.ssProjectsListPopover.data);
	              } },
	            t('Edit'),
	            _react2.default.createElement('i', { className: 'icon-mode-edit' })
	          ),
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.deleteProject(_this2.ssProjectsListPopover.data);
	              }, hidden: ssProjectsListPopoverHideDelete },
	            t('Delete'),
	            _react2.default.createElement('i', { className: 'icon-delete' })
	          )
	        )
	      );
	    }
	  }]);
	  return SSProjectsList;
	}(_react.Component), _class3.propTypes = {
	  deleteSSProject: _propTypes2.default.func,
	  deleteSSProjectActionData: _propTypes2.default.object,
	  deleteSSProjectLoading: _propTypes2.default.bool,
	  loadSSProjects: _propTypes2.default.func,
	  projectId: _propTypes2.default.number.isRequired,
	  pushState: _propTypes2.default.func,
	  ssProjectsList: _propTypes2.default.array,
	  ssProjectsListLoading: _propTypes2.default.bool,
	  t: _propTypes2.default.func,
	  user: _propTypes2.default.object
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'toggleSSProjectsListPopover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'toggleSSProjectsListPopover'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = SSProjectsList;
	module.exports = exports['default'];

/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _project = __webpack_require__(37);
	
	var projectActions = _interopRequireWildcard(_project);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	var _strings = __webpack_require__(59);
	
	var _utils = __webpack_require__(24);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var SSTeamMembers = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    addTeamMemberLoading: state.project.addTeamMemberLoading,
	    deleteTeamMemberActionData: state.project.deleteTeamMemberActionData,
	    deleteTeamMemberLoading: state.project.deleteTeamMemberLoading,
	    editTeamMemberActionData: state.project.editTeamMemberActionData,
	    editTeamMemberLoading: state.project.editTeamMemberLoading,
	    teamMembersList: state.project.teamMembersListData,
	    teamMembersListLoading: state.project.teamMembersListLoading,
	    usersList: state.project.usersListData
	  };
	}, (0, _extends3.default)({}, projectActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(SSTeamMembers, _Component);
	
	  function SSTeamMembers() {
	    (0, _classCallCheck3.default)(this, SSTeamMembers);
	    return (0, _possibleConstructorReturn3.default)(this, (SSTeamMembers.__proto__ || (0, _getPrototypeOf2.default)(SSTeamMembers)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SSTeamMembers, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          projectId = _props.projectId,
	          loadTeamMembers = _props.loadTeamMembers,
	          loadUsersList = _props.loadUsersList;
	
	      loadUsersList();
	      if (projectId) {
	        loadTeamMembers(projectId);
	      }
	    }
	  }, {
	    key: 'onSuggestionSelected',
	    value: function onSuggestionSelected(e, _ref) {
	      var suggestion = _ref.suggestion;
	
	      (0, _utils.stopEvent)(e);
	      var _props2 = this.props,
	          addTeamMember = _props2.addTeamMember,
	          projectId = _props2.projectId;
	
	      return addTeamMember(projectId, suggestion.userId).promise;
	    }
	  }, {
	    key: 'changeRights',
	    value: function changeRights(member) {
	      var _props3 = this.props,
	          editTeamMember = _props3.editTeamMember,
	          projectId = _props3.projectId;
	
	      editTeamMember(projectId, member.shareeId, { isLocked: member.isLocked ? 0 : 1 });
	    }
	  }, {
	    key: 'deleteTeamMember',
	    value: function deleteTeamMember(member) {
	      var _props4 = this.props,
	          deleteTeamMember = _props4.deleteTeamMember,
	          projectId = _props4.projectId;
	
	      deleteTeamMember(projectId, member.shareeId);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props5 = this.props,
	          t = _props5.t,
	          teamMembersList = _props5.teamMembersList,
	          teamMembersListLoading = _props5.teamMembersListLoading,
	          deleteTeamMemberLoading = _props5.deleteTeamMemberLoading,
	          deleteTeamMemberActionData = _props5.deleteTeamMemberActionData,
	          editTeamMemberLoading = _props5.editTeamMemberLoading,
	          editTeamMemberActionData = _props5.editTeamMemberActionData,
	          addTeamMemberLoading = _props5.addTeamMemberLoading,
	          usersList = _props5.usersList,
	          projectId = _props5.projectId;
	
	      var showMemberLoader = function showMemberLoader(member) {
	        return deleteTeamMemberLoading && deleteTeamMemberActionData.shareeId === member.shareeId || editTeamMemberLoading && editTeamMemberActionData.shareeId === member.shareeId;
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          { className: 'bold' },
	          t('Share this Sharespace with other users in your organisation.')
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'hint small' },
	          t('Sharers will be able to use and upload audio and press content of this sharespace. Email address of the recipients will remain private. As a sharespace creator you will have access to all the projects created from this sharespace')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'formRow' },
	          _react2.default.createElement(
	            'div',
	            null,
	            t('Enter their email there')
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_components.AutosuggestField, {
	              field: 'userEmail',
	              onSuggestionSelected: this.onSuggestionSelected,
	              items: usersList,
	              readOnly: addTeamMemberLoading || !projectId,
	              placeholder: t('Type a recipient')
	            }),
	            addTeamMemberLoading && _react2.default.createElement(_components.Loader, { small: true, mask: true })
	          ),
	          !projectId && _react2.default.createElement(
	            'div',
	            { className: 'hint small danger' },
	            t('You need to save project before adding recipients')
	          )
	        ),
	        _react2.default.createElement(
	          _components.List,
	          { className: 'margin-bottom-20' },
	          _react2.default.createElement(
	            _components.ListItem,
	            { fullWidth: true, isTitle: true },
	            _react2.default.createElement(
	              'div',
	              null,
	              t('Name')
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              t('Email')
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              t('Rights')
	            ),
	            _react2.default.createElement('div', null)
	          ),
	          teamMembersList.map(function (member) {
	            return _react2.default.createElement(
	              _components.ListItem,
	              { fullWidth: true, key: member.shareeId },
	              _react2.default.createElement(
	                'div',
	                null,
	                (0, _strings.concat)(' ', member.name, member.surname)
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                member.userEmail
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: member.isLocked ? 'colorError' : 'colorSuccess' },
	                member.isLocked ? t('Locked') : t('Standard')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'moreCell' },
	                _react2.default.createElement('i', { className: 'more', onClick: function onClick(e) {
	                    return _this2.teamMembersListPopover.toggle(e, member);
	                  } }),
	                showMemberLoader(member) && _react2.default.createElement(_components.Loader, { small: true, mask: true })
	              )
	            );
	          })
	        ),
	        teamMembersListLoading && _react2.default.createElement(_components.Loader, null),
	        _react2.default.createElement(
	          _components.PopoverMenu,
	          { id: 'teamMembersListPopover', ref: function ref(el) {
	              return _this2.teamMembersListPopover = el;
	            } },
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.changeRights(_this2.teamMembersListPopover.data);
	              } },
	            t('Change rights'),
	            _react2.default.createElement('i', { className: 'icon-lock-open' })
	          ),
	          _react2.default.createElement(
	            'li',
	            { onClick: function onClick() {
	                return _this2.deleteTeamMember(_this2.teamMembersListPopover.data);
	              } },
	            t('Delete'),
	            _react2.default.createElement('i', { className: 'icon-delete' })
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'colorError' },
	            t('Locked mode')
	          ),
	          ': ',
	          t('sharees can\'t modify audio, cover photo or any security settings')
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'colorSuccess' },
	            t('Standard mode')
	          ),
	          ': ',
	          t('sharees can modify parameters according to their own privileges')
	        )
	      );
	    }
	  }]);
	  return SSTeamMembers;
	}(_react.Component), _class3.propTypes = {
	  addTeamMember: _propTypes2.default.func,
	  addTeamMemberLoading: _propTypes2.default.bool,
	  deleteTeamMember: _propTypes2.default.func,
	  deleteTeamMemberActionData: _propTypes2.default.object,
	  deleteTeamMemberLoading: _propTypes2.default.bool,
	  editTeamMember: _propTypes2.default.func,
	  editTeamMemberActionData: _propTypes2.default.object,
	  editTeamMemberLoading: _propTypes2.default.bool,
	  loadTeamMembers: _propTypes2.default.func,
	  loadUsersList: _propTypes2.default.func,
	  projectId: _propTypes2.default.number.isRequired,
	  t: _propTypes2.default.func,
	  teamMembersList: _propTypes2.default.array,
	  teamMembersListLoading: _propTypes2.default.bool,
	  usersList: _propTypes2.default.array
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onSuggestionSelected', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSuggestionSelected'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = SSTeamMembers;
	module.exports = exports['default'];

/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectRecipientReportDetailed = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(ProjectRecipientReportDetailed, _Component);
	
	  function ProjectRecipientReportDetailed() {
	    (0, _classCallCheck3.default)(this, ProjectRecipientReportDetailed);
	    return (0, _possibleConstructorReturn3.default)(this, (ProjectRecipientReportDetailed.__proto__ || (0, _getPrototypeOf2.default)(ProjectRecipientReportDetailed)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProjectRecipientReportDetailed, [{
	    key: 'render',
	
	
	    /* eslint-disable react/no-array-index-key */
	    value: function render() {
	      var _props = this.props,
	          t = _props.t,
	          reportData = _props.reportData;
	      var _reportData$timings = reportData.timings,
	          timings = _reportData$timings === undefined ? [] : _reportData$timings,
	          _reportData$files = reportData.files,
	          files = _reportData$files === undefined ? {} : _reportData$files;
	
	
	      if (!timings.length) {
	        return _react2.default.createElement(_components.NoRecords, null);
	      }
	
	      return _react2.default.createElement(
	        _components.List,
	        null,
	        _react2.default.createElement(
	          _components.ListItem,
	          { fullWidth: true, isTitle: true },
	          _react2.default.createElement(
	            'div',
	            null,
	            t('Track')
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            t('Duration')
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            t('Time')
	          )
	        ),
	        timings.map(function (timing, index) {
	          return _react2.default.createElement(
	            _components.ListItem,
	            { key: timing.uploadId + '_' + index, fullWidth: true },
	            _react2.default.createElement(
	              'div',
	              null,
	              files[timing.uploadId].filename
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              t('Play'),
	              ' ',
	              timing.durationString
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              timing.dateString
	            )
	          );
	        })
	      );
	    }
	    /* eslint-enable react/no-array-index-key */
	
	  }]);
	  return ProjectRecipientReportDetailed;
	}(_react.Component), _class2.propTypes = {
	  reportData: _propTypes2.default.object,
	  t: _propTypes2.default.func
	}, _temp)) || _class);
	exports.default = ProjectRecipientReportDetailed;
	module.exports = exports['default'];

/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectRecipientReportInformation = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(ProjectRecipientReportInformation, _Component);
	
	  function ProjectRecipientReportInformation() {
	    (0, _classCallCheck3.default)(this, ProjectRecipientReportInformation);
	    return (0, _possibleConstructorReturn3.default)(this, (ProjectRecipientReportInformation.__proto__ || (0, _getPrototypeOf2.default)(ProjectRecipientReportInformation)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProjectRecipientReportInformation, [{
	    key: 'getMessage',
	    value: function getMessage(file) {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(_reactI18next.Interpolate, { i18nKey: '{{count}} Plays', count: file.playCount }),
	        ',',
	        _react2.default.createElement(_reactI18next.Interpolate, { className: 'margin-left-10', i18nKey: 'Avge Playtime: {{time}}', time: file.avgPlaytimeMinutes })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var reportData = this.props.reportData;
	      var _reportData$filesArra = reportData.filesArray,
	          filesArray = _reportData$filesArra === undefined ? [] : _reportData$filesArra;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        filesArray.map(function (file) {
	          return _react2.default.createElement(_components.ProjectReportProgressProperty, {
	            key: file.uploadId,
	            title: file.filename,
	            message: _this2.getMessage(file),
	            count: file.playCount,
	            countAll: reportData.maxPlaysNumber
	          });
	        })
	      );
	    }
	  }]);
	  return ProjectRecipientReportInformation;
	}(_react.Component), _class.propTypes = {
	  reportData: _propTypes2.default.object
	}, _temp);
	exports.default = ProjectRecipientReportInformation;
	module.exports = exports['default'];

/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	var _datetime = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectReportFileInfo = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(ProjectReportFileInfo, _Component);
	
	  function ProjectReportFileInfo() {
	    (0, _classCallCheck3.default)(this, ProjectReportFileInfo);
	    return (0, _possibleConstructorReturn3.default)(this, (ProjectReportFileInfo.__proto__ || (0, _getPrototypeOf2.default)(ProjectReportFileInfo)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProjectReportFileInfo, [{
	    key: 'getMessage',
	    value: function getMessage(file) {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(_reactI18next.Interpolate, { i18nKey: '{{count}} Plays', count: file.nbPlays }),
	        ',',
	        _react2.default.createElement(_reactI18next.Interpolate, { className: 'margin-left-10', i18nKey: 'Avge Playtime: {{time}}', time: (0, _datetime.secToMinString)(file.timePlayed) })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var reportData = this.props.reportData;
	      var _reportData$averageSt = reportData.averageStat,
	          averageStat = _reportData$averageSt === undefined ? [] : _reportData$averageSt,
	          _reportData$files = reportData.files,
	          files = _reportData$files === undefined ? {} : _reportData$files;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        averageStat.map(function (file) {
	          return _react2.default.createElement(_components.ProjectReportProgressProperty, {
	            key: file.uploadId,
	            title: files[file.uploadId].filename,
	            message: _this2.getMessage(file),
	            count: file.nbPlays,
	            countAll: reportData.maxPlaysNumber
	          });
	        })
	      );
	    }
	  }]);
	  return ProjectReportFileInfo;
	}(_react.Component), _class.propTypes = {
	  reportData: _propTypes2.default.object
	}, _temp);
	exports.default = ProjectReportFileInfo;
	module.exports = exports['default'];

/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	var _report = __webpack_require__(360);
	
	var reportActions = _interopRequireWildcard(_report);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _downloads = __webpack_require__(262);
	
	var _config = __webpack_require__(41);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var ProjectReportInformation = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    downloadReportLoading: state.report.downloadReportLoading,
	    getLinksLoading: state.report.getLinksLoading
	  };
	}, (0, _extends3.default)({}, reportActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(ProjectReportInformation, _Component);
	
	  function ProjectReportInformation() {
	    (0, _classCallCheck3.default)(this, ProjectReportInformation);
	    return (0, _possibleConstructorReturn3.default)(this, (ProjectReportInformation.__proto__ || (0, _getPrototypeOf2.default)(ProjectReportInformation)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProjectReportInformation, [{
	    key: 'getLinks',
	    value: function getLinks() {
	      return this.download(this.props.getLinks);
	    }
	  }, {
	    key: 'downloadReport',
	    value: function downloadReport() {
	      return this.download(this.props.downloadReport);
	    }
	  }, {
	    key: 'download',
	    value: function download(method) {
	      var _props$reportData$pro = this.props.reportData.project,
	          project = _props$reportData$pro === undefined ? {} : _props$reportData$pro;
	
	      return method(project.projectId).promise.then(function (resp) {
	        return (0, _downloads.download)('' + _config2.default.app.urlParts.report + resp.data.filePath, resp.data.fileName);
	      }).catch(function (err) {
	        return err;
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          t = _props.t,
	          reportData = _props.reportData,
	          getLinksLoading = _props.getLinksLoading,
	          downloadReportLoading = _props.downloadReportLoading;
	      var _reportData$project = reportData.project,
	          project = _reportData$project === undefined ? {} : _reportData$project;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_components.ProjectReportProperty, { title: t('Project'), value: '#' + project.id }),
	        _react2.default.createElement(_components.ProjectReportProperty, { title: t('Status'), value: _react2.default.createElement(_components.ProjectStatus, { status: project.status }) }),
	        _react2.default.createElement(_components.ProjectReportProperty, { title: t('Manager'), value: project.owName }),
	        _react2.default.createElement(
	          'div',
	          { className: 'text-right margin-top-20' },
	          _react2.default.createElement(
	            _components.Button,
	            { type: 'button', className: 'btn btn-primary', onClick: this.getLinks, loading: getLinksLoading },
	            t('Get Links')
	          ),
	          _react2.default.createElement(
	            _components.Button,
	            { type: 'button', className: 'btn btn-primary margin-left-20', onClick: this.downloadReport, loading: downloadReportLoading },
	            t('Download Report')
	          )
	        )
	      );
	    }
	  }]);
	  return ProjectReportInformation;
	}(_react.Component), _class3.propTypes = {
	  downloadReport: _propTypes2.default.func,
	  downloadReportLoading: _propTypes2.default.bool,
	  getLinks: _propTypes2.default.func,
	  getLinksLoading: _propTypes2.default.bool,
	  reportData: _propTypes2.default.object,
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'getLinks', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'getLinks'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'downloadReport', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'downloadReport'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = ProjectReportInformation;
	module.exports = exports['default'];

/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	var _Link = __webpack_require__(82);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectReportPlayedUsers = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(ProjectReportPlayedUsers, _Component);
	
	  function ProjectReportPlayedUsers() {
	    (0, _classCallCheck3.default)(this, ProjectReportPlayedUsers);
	    return (0, _possibleConstructorReturn3.default)(this, (ProjectReportPlayedUsers.__proto__ || (0, _getPrototypeOf2.default)(ProjectReportPlayedUsers)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProjectReportPlayedUsers, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          t = _props.t,
	          reportData = _props.reportData;
	      var _reportData$viewers = reportData.viewers,
	          viewers = _reportData$viewers === undefined ? [] : _reportData$viewers,
	          _reportData$project = reportData.project,
	          project = _reportData$project === undefined ? {} : _reportData$project,
	          _reportData$downloade = reportData.downloadedViewers,
	          downloadedViewers = _reportData$downloade === undefined ? {} : _reportData$downloade;
	
	
	      if (!viewers.length) {
	        return _react2.default.createElement(_components.NoRecords, null);
	      }
	
	      return _react2.default.createElement(
	        _components.List,
	        null,
	        _react2.default.createElement(
	          _components.ListItem,
	          { fullWidth: true, isTitle: true },
	          _react2.default.createElement(
	            'div',
	            null,
	            'ID'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            'IP'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            t('Name')
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            t('Downloaded')
	          ),
	          _react2.default.createElement('div', null)
	        ),
	        viewers.map(function (recipient) {
	          return _react2.default.createElement(
	            _components.ListItem,
	            { key: recipient.recipientId, fullWidth: true },
	            _react2.default.createElement(
	              'div',
	              null,
	              recipient.recipientId
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              recipient.ip
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              recipient.fullName
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              downloadedViewers[recipient.recipientId] ? t('Yes') : t('No')
	            ),
	            _react2.default.createElement(
	              _Link2.default,
	              { to: '/projects/' + project.projectContentType + '/' + project.projectId + '/report/' + recipient.recipientId },
	              t('details')
	            )
	          );
	        })
	      );
	    }
	  }]);
	  return ProjectReportPlayedUsers;
	}(_react.Component), _class2.propTypes = {
	  reportData: _propTypes2.default.object,
	  t: _propTypes2.default.func
	}, _temp)) || _class);
	exports.default = ProjectReportPlayedUsers;
	module.exports = exports['default'];

/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _components = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(626);
	
	var ProjectReportProgressProperty = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(ProjectReportProgressProperty, _Component);
	
	  function ProjectReportProgressProperty() {
	    (0, _classCallCheck3.default)(this, ProjectReportProgressProperty);
	    return (0, _possibleConstructorReturn3.default)(this, (ProjectReportProgressProperty.__proto__ || (0, _getPrototypeOf2.default)(ProjectReportProgressProperty)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProjectReportProgressProperty, [{
	    key: 'getValue',
	    value: function getValue() {
	      var _props = this.props,
	          count = _props.count,
	          countAll = _props.countAll,
	          message = _props.message;
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.progressContainer },
	        _react2.default.createElement(_components.ProgressStatus, { count: count, countAll: countAll, containerClassName: styles.progressStatusContainer }),
	        message
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var title = this.props.title;
	
	      var progressValue = this.getValue();
	
	      return _react2.default.createElement(_components.ProjectReportProperty, { title: title, value: progressValue });
	    }
	  }]);
	  return ProjectReportProgressProperty;
	}(_react.Component), _class.propTypes = {
	  count: _propTypes2.default.number,
	  countAll: _propTypes2.default.number,
	  message: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string, _propTypes2.default.number]),
	  title: _propTypes2.default.string
	}, _temp);
	exports.default = ProjectReportProgressProperty;
	module.exports = exports['default'];

/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(626);
	
	var ProjectReportProperty = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(ProjectReportProperty, _Component);
	
	  function ProjectReportProperty() {
	    (0, _classCallCheck3.default)(this, ProjectReportProperty);
	    return (0, _possibleConstructorReturn3.default)(this, (ProjectReportProperty.__proto__ || (0, _getPrototypeOf2.default)(ProjectReportProperty)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProjectReportProperty, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          value = _props.value;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.propertyRow },
	        _react2.default.createElement(
	          'div',
	          { className: styles.propertyName },
	          title
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.propertyValue },
	          value
	        )
	      );
	    }
	  }]);
	  return ProjectReportProperty;
	}(_react.Component), _class.propTypes = {
	  title: _propTypes2.default.string,
	  value: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string, _propTypes2.default.number])
	}, _temp);
	exports.default = ProjectReportProperty;
	module.exports = exports['default'];

/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectReportRecipientsStatistic = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(ProjectReportRecipientsStatistic, _Component);
	
	  function ProjectReportRecipientsStatistic() {
	    (0, _classCallCheck3.default)(this, ProjectReportRecipientsStatistic);
	    return (0, _possibleConstructorReturn3.default)(this, (ProjectReportRecipientsStatistic.__proto__ || (0, _getPrototypeOf2.default)(ProjectReportRecipientsStatistic)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProjectReportRecipientsStatistic, [{
	    key: 'getRecipientsProgressMessage',
	    value: function getRecipientsProgressMessage(count, countAll) {
	      return _react2.default.createElement(_reactI18next.Interpolate, {
	        i18nKey: '{{count}} recipients / {{countAll}}',
	        count: count,
	        countAll: countAll
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          t = _props.t,
	          reportData = _props.reportData;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_components.ProjectReportProgressProperty, {
	          title: t('Played'),
	          message: this.getRecipientsProgressMessage(reportData.totalViews, reportData.totalRecipients),
	          count: reportData.totalViews,
	          countAll: reportData.totalRecipients
	        }),
	        _react2.default.createElement(_components.ProjectReportProgressProperty, {
	          title: t('Downloads'),
	          message: this.getRecipientsProgressMessage(reportData.totalDwn, reportData.totalPossibleDwn),
	          count: reportData.totalDwn,
	          countAll: reportData.totalPossibleDwn
	        })
	      );
	    }
	  }]);
	  return ProjectReportRecipientsStatistic;
	}(_react.Component), _class2.propTypes = {
	  reportData: _propTypes2.default.object,
	  t: _propTypes2.default.func
	}, _temp)) || _class);
	exports.default = ProjectReportRecipientsStatistic;
	module.exports = exports['default'];

/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectReportSkippedUsers = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(ProjectReportSkippedUsers, _Component);
	
	  function ProjectReportSkippedUsers() {
	    (0, _classCallCheck3.default)(this, ProjectReportSkippedUsers);
	    return (0, _possibleConstructorReturn3.default)(this, (ProjectReportSkippedUsers.__proto__ || (0, _getPrototypeOf2.default)(ProjectReportSkippedUsers)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProjectReportSkippedUsers, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          t = _props.t,
	          reportData = _props.reportData;
	      var _reportData$nonViewer = reportData.nonViewers,
	          nonViewers = _reportData$nonViewer === undefined ? [] : _reportData$nonViewer;
	
	
	      if (!nonViewers.length) {
	        return _react2.default.createElement(_components.NoRecords, null);
	      }
	
	      return _react2.default.createElement(
	        _components.List,
	        null,
	        _react2.default.createElement(
	          _components.ListItem,
	          { fullWidth: true, isTitle: true },
	          _react2.default.createElement(
	            'div',
	            null,
	            'ID'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            t('Name')
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            t('Email')
	          )
	        ),
	        nonViewers.map(function (recipient) {
	          return _react2.default.createElement(
	            _components.ListItem,
	            {
	              key: recipient.recipientId,
	              fullWidth: true
	            },
	            _react2.default.createElement(
	              'div',
	              null,
	              recipient.recipientId
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              recipient.fullName
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              recipient.email
	            )
	          );
	        })
	      );
	    }
	  }]);
	  return ProjectReportSkippedUsers;
	}(_react.Component), _class2.propTypes = {
	  reportData: _propTypes2.default.object,
	  t: _propTypes2.default.func
	}, _temp)) || _class);
	exports.default = ProjectReportSkippedUsers;
	module.exports = exports['default'];

/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var projectTypeImg = {
	  audio: __webpack_require__(2290),
	  video: __webpack_require__(2292),
	  sharespace: __webpack_require__(2291)
	};
	
	var ProjectTypeIcon = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(ProjectTypeIcon, _PureComponent);
	
	  function ProjectTypeIcon() {
	    (0, _classCallCheck3.default)(this, ProjectTypeIcon);
	    return (0, _possibleConstructorReturn3.default)(this, (ProjectTypeIcon.__proto__ || (0, _getPrototypeOf2.default)(ProjectTypeIcon)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProjectTypeIcon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          type = _props.type;
	
	
	      return _react2.default.createElement('img', {
	        className: (0, _bind2.default)(className),
	        src: projectTypeImg[type] || projectTypeImg.audio,
	        alt: ''
	      });
	    }
	  }]);
	  return ProjectTypeIcon;
	}(_react.PureComponent), _class.propTypes = {
	  className: _propTypes2.default.string,
	  type: _propTypes2.default.string
	}, _temp);
	exports.default = ProjectTypeIcon;
	module.exports = exports['default'];

/***/ }),
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _ProjectTypeIcon = __webpack_require__(2061);
	
	var _ProjectTypeIcon2 = _interopRequireDefault(_ProjectTypeIcon);
	
	var _utils = __webpack_require__(24);
	
	var _Tooltip = __webpack_require__(522);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectTypeTooltip = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(ProjectTypeTooltip, _PureComponent);
	
	  function ProjectTypeTooltip() {
	    (0, _classCallCheck3.default)(this, ProjectTypeTooltip);
	    return (0, _possibleConstructorReturn3.default)(this, (ProjectTypeTooltip.__proto__ || (0, _getPrototypeOf2.default)(ProjectTypeTooltip)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProjectTypeTooltip, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          projectType = _props.projectType;
	
	
	      return _react2.default.createElement(
	        _Tooltip2.default,
	        {
	          placement: 'top',
	          title: projectType,
	          onClick: _utils.stopEvent
	        },
	        _react2.default.createElement(_ProjectTypeIcon2.default, { className: (0, _bind2.default)(className), type: projectType })
	      );
	    }
	  }]);
	  return ProjectTypeTooltip;
	}(_react.PureComponent), _class.propTypes = {
	  className: _propTypes2.default.string,
	  projectType: _propTypes2.default.string
	}, _temp);
	exports.default = ProjectTypeTooltip;
	module.exports = exports['default'];

/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _projects = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectItemActions = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(ProjectItemActions, _PureComponent);
	
	  function ProjectItemActions() {
	    (0, _classCallCheck3.default)(this, ProjectItemActions);
	    return (0, _possibleConstructorReturn3.default)(this, (ProjectItemActions.__proto__ || (0, _getPrototypeOf2.default)(ProjectItemActions)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProjectItemActions, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          project = _props.project,
	          onCreateSubproject = _props.onCreateSubproject,
	          onEdit = _props.onEdit,
	          onReport = _props.onReport,
	          onDelete = _props.onDelete,
	          userPermissions = _props.userPermissions;
	      var t = this.context.t;
	
	      var _getProjectPermission = (0, _projects.getProjectPermissions)({ project: project, userPermissions: userPermissions }),
	          canDelete = _getProjectPermission.canDelete,
	          canEdit = _getProjectPermission.canEdit,
	          canGetReport = _getProjectPermission.canGetReport,
	          canCreateSubproject = _getProjectPermission.canCreateSubproject;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(className) },
	        canCreateSubproject && _react2.default.createElement(
	          'a',
	          { onClick: onCreateSubproject },
	          t('Create project')
	        ),
	        canEdit && _react2.default.createElement(
	          'a',
	          { onClick: onEdit },
	          t('Edit')
	        ),
	        canGetReport && _react2.default.createElement(
	          'a',
	          { onClick: onReport },
	          t('Report')
	        ),
	        canDelete && _react2.default.createElement(
	          'a',
	          { onClick: onDelete },
	          t('Delete')
	        )
	      );
	    }
	  }]);
	  return ProjectItemActions;
	}(_react.PureComponent), _class.propTypes = {
	  className: _propTypes2.default.string,
	  onCreateSubproject: _propTypes2.default.func,
	  onDelete: _propTypes2.default.func,
	  onEdit: _propTypes2.default.func,
	  onReport: _propTypes2.default.func,
	  project: _propTypes2.default.object,
	  userPermissions: _propTypes2.default.object
	}, _class.contextTypes = {
	  t: _propTypes2.default.func
	}, _class.defaultProps = {
	  onCreateSubproject: _noop3.default,
	  onDelete: _noop3.default,
	  onEdit: _noop3.default,
	  onReport: _noop3.default,
	  project: {},
	  userPermissions: {}
	}, _temp);
	exports.default = ProjectItemActions;
	module.exports = exports['default'];

/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PopoverMenu = __webpack_require__(258);
	
	var _PopoverMenu2 = _interopRequireDefault(_PopoverMenu);
	
	var _PopoverMenuItem = __webpack_require__(353);
	
	var _PopoverMenuItem2 = _interopRequireDefault(_PopoverMenuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectItemPopover = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(ProjectItemPopover, _PureComponent);
	
	  function ProjectItemPopover() {
	    (0, _classCallCheck3.default)(this, ProjectItemPopover);
	    return (0, _possibleConstructorReturn3.default)(this, (ProjectItemPopover.__proto__ || (0, _getPrototypeOf2.default)(ProjectItemPopover)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProjectItemPopover, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          onCreateSubproject = _props.onCreateSubproject,
	          onDelete = _props.onDelete,
	          onEdit = _props.onEdit,
	          onReport = _props.onReport,
	          onInit = _props.onInit;
	      var _props2 = this.props,
	          id = _props2.id,
	          hideCreateSubproject = _props2.hideCreateSubproject,
	          hideEdit = _props2.hideEdit,
	          hideReport = _props2.hideReport,
	          hideDelete = _props2.hideDelete;
	      var t = this.context.t;
	
	
	      return _react2.default.createElement(
	        _PopoverMenu2.default,
	        { id: id, ref: onInit },
	        _react2.default.createElement(_PopoverMenuItem2.default, { onClick: onCreateSubproject, title: t('Create project'), iconClass: 'icon-add', hidden: hideCreateSubproject }),
	        _react2.default.createElement(_PopoverMenuItem2.default, { onClick: onEdit, title: t('Edit'), iconClass: 'icon-mode-edit', hidden: hideEdit }),
	        _react2.default.createElement(_PopoverMenuItem2.default, { onClick: onReport, title: t('Report'), iconClass: 'icon-chart', hidden: hideReport }),
	        _react2.default.createElement(_PopoverMenuItem2.default, { onClick: onDelete, title: t('Delete'), iconClass: 'icon-delete', hidden: hideDelete })
	      );
	    }
	  }]);
	  return ProjectItemPopover;
	}(_react.PureComponent), _class.propTypes = {
	  hideCreateSubproject: _propTypes2.default.bool,
	  hideDelete: _propTypes2.default.bool,
	  hideEdit: _propTypes2.default.bool,
	  hideReport: _propTypes2.default.bool,
	  id: _propTypes2.default.string,
	  onCreateSubproject: _propTypes2.default.func,
	  onDelete: _propTypes2.default.func,
	  onEdit: _propTypes2.default.func,
	  onInit: _propTypes2.default.func,
	  onReport: _propTypes2.default.func
	}, _class.contextTypes = {
	  t: _propTypes2.default.func
	}, _class.defaultProps = {
	  onCreateSubproject: _noop3.default,
	  onDelete: _noop3.default,
	  onEdit: _noop3.default,
	  onInit: _noop3.default,
	  onReport: _noop3.default
	}, _temp);
	exports.default = ProjectItemPopover;
	module.exports = exports['default'];

/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SortableListHeader = __webpack_require__(355);
	
	var _SortableListHeader2 = _interopRequireDefault(_SortableListHeader);
	
	var _ListItem = __webpack_require__(76);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectsListHeader = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(ProjectsListHeader, _PureComponent);
	
	  function ProjectsListHeader() {
	    (0, _classCallCheck3.default)(this, ProjectsListHeader);
	    return (0, _possibleConstructorReturn3.default)(this, (ProjectsListHeader.__proto__ || (0, _getPrototypeOf2.default)(ProjectsListHeader)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProjectsListHeader, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          order = _props.order,
	          activeOrder = _props.activeOrder,
	          onReorder = _props.onReorder,
	          showTypeColumn = _props.showTypeColumn,
	          showActionsColumn = _props.showActionsColumn;
	      var t = this.context.t;
	
	
	      return _react2.default.createElement(
	        _ListItem2.default,
	        { fullWidth: true, isTitle: true },
	        _react2.default.createElement(_SortableListHeader2.default, {
	          title: t('ID'),
	          name: 'id',
	          order: order,
	          activeOrder: activeOrder,
	          onReorder: onReorder
	        }),
	        _react2.default.createElement(_SortableListHeader2.default, {
	          title: t('General information'),
	          name: 'fullTitle',
	          order: order,
	          activeOrder: activeOrder,
	          onReorder: onReorder
	        }),
	        showTypeColumn && _react2.default.createElement('div', null),
	        _react2.default.createElement('div', null),
	        _react2.default.createElement(_SortableListHeader2.default, {
	          title: t('Manager'),
	          name: 'owName',
	          order: order,
	          activeOrder: activeOrder,
	          onReorder: onReorder
	        }),
	        _react2.default.createElement(_SortableListHeader2.default, {
	          title: t('Status'),
	          name: 'statusText',
	          order: order,
	          activeOrder: activeOrder,
	          onReorder: onReorder
	        }),
	        showActionsColumn && _react2.default.createElement('div', null)
	      );
	    }
	  }]);
	  return ProjectsListHeader;
	}(_react.PureComponent), _class.propTypes = {
	  activeOrder: _propTypes2.default.string,
	  onReorder: _propTypes2.default.func,
	  order: _propTypes2.default.object,
	  showActionsColumn: _propTypes2.default.bool,
	  showTypeColumn: _propTypes2.default.bool
	}, _class.contextTypes = {
	  onReorder: _noop3.default,
	  t: _propTypes2.default.func
	}, _temp);
	exports.default = ProjectsListHeader;
	module.exports = exports['default'];

/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _upperFirst2 = __webpack_require__(678);
	
	var _upperFirst3 = _interopRequireDefault(_upperFirst2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _ProjectTypeTooltip = __webpack_require__(2062);
	
	var _ProjectTypeTooltip2 = _interopRequireDefault(_ProjectTypeTooltip);
	
	var _ProjectIrefTooltip = __webpack_require__(833);
	
	var _ProjectIrefTooltip2 = _interopRequireDefault(_ProjectIrefTooltip);
	
	var _ListItem = __webpack_require__(76);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _ProjectStatus = __webpack_require__(516);
	
	var _ProjectStatus2 = _interopRequireDefault(_ProjectStatus);
	
	var _MoreButton = __webpack_require__(515);
	
	var _MoreButton2 = _interopRequireDefault(_MoreButton);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _utils = __webpack_require__(24);
	
	var _ProjectItemPopover = __webpack_require__(2064);
	
	var _ProjectItemPopover2 = _interopRequireDefault(_ProjectItemPopover);
	
	var _projects = __webpack_require__(28);
	
	var _ProjectItemActions = __webpack_require__(2063);
	
	var _ProjectItemActions2 = _interopRequireDefault(_ProjectItemActions);
	
	var _loadReducer = __webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1299);
	
	var useOldReports = true; //TODO: remove?
	
	
	var ProjectsListItem = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(ProjectsListItem, _PureComponent);
	
	  function ProjectsListItem() {
	    (0, _classCallCheck3.default)(this, ProjectsListItem);
	    return (0, _possibleConstructorReturn3.default)(this, (ProjectsListItem.__proto__ || (0, _getPrototypeOf2.default)(ProjectsListItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProjectsListItem, [{
	    key: 'onClickEdit',
	    value: function onClickEdit() {
	      this.editProject();
	    }
	  }, {
	    key: 'onClickPopup',
	    value: function onClickPopup() {
	      return _toastr2.default.info(this.context.t('You don\'t have permissions to edit this project'));
	    }
	  }, {
	    key: 'onClickCreateProj',
	    value: function onClickCreateProj() {
	      return this.createSubproject();
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick() {
	      var _props = this.props,
	          project = _props.project,
	          onClick = _props.onClick;
	
	      if (onClick) {
	        return onClick(project);
	      }
	
	      var actionOnClick = project.actionOnClick;
	
	      if (actionOnClick) {
	        var method = 'onClick' + (0, _upperFirst3.default)(actionOnClick);
	        return this[method] ? this[method]() : false;
	      }
	    }
	  }, {
	    key: 'projectReport',
	    value: function projectReport(e) {
	      (0, _utils.stopEvent)(e);
	      var project = this.props.project;
	      var push = this.context.push;
	
	      if (useOldReports) {
	        push('/projects/' + project.projectContentType + '/' + project.id + '/report');
	      } else {
	        push('/statistics/project/' + project.id);
	      }
	    }
	  }, {
	    key: 'editProject',
	    value: function editProject(e) {
	      (0, _utils.stopEvent)(e);
	      var push = this.context.push;
	      var _props2 = this.props,
	          onEdit = _props2.onEdit,
	          project = _props2.project;
	
	      onEdit();
	      push('/projects/' + project.projectContentType + '/' + project.id + '/materials');
	    }
	  }, {
	    key: 'deleteProject',
	    value: function deleteProject(e) {
	      (0, _utils.stopEvent)(e);
	      var _props3 = this.props,
	          onDelete = _props3.onDelete,
	          project = _props3.project;
	      var t = this.context.t;
	
	      var toastrConfirmOptions = {
	        onOk: function onOk() {
	          return onDelete(project);
	        },
	        onCancel: function onCancel() {}
	      };
	      _toastr2.default.confirm(t('Are you sure you want to delete this project?'), toastrConfirmOptions);
	    }
	  }, {
	    key: 'createSubproject',
	    value: function createSubproject(e) {
	      (0, _utils.stopEvent)(e);
	      var _props4 = this.props,
	          onCreateSubproject = _props4.onCreateSubproject,
	          project = _props4.project;
	      var push = this.context.push;
	
	      onCreateSubproject();
	      push('/projects/' + project.projectContentType + '/' + project.id + '/create');
	    }
	  }, {
	    key: 'togglePopover',
	    value: function togglePopover(e) {
	      this.popover.toggle(e);
	    }
	  }, {
	    key: 'bindPopover',
	    value: function bindPopover(el) {
	      this.popover = el;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          className = _props5.className,
	          project = _props5.project,
	          showTypeColumn = _props5.showTypeColumn,
	          showActionsColumn = _props5.showActionsColumn,
	          deleteLoaders = _props5.deleteLoaders,
	          userPermissions = _props5.userPermissions;
	
	      var _getProjectPermission = (0, _projects.getProjectPermissions)({ project: project, userPermissions: userPermissions }),
	          canDelete = _getProjectPermission.canDelete,
	          canEdit = _getProjectPermission.canEdit,
	          canGetReport = _getProjectPermission.canGetReport,
	          canCreateSubproject = _getProjectPermission.canCreateSubproject;
	
	      var isDeleting = deleteLoaders[(0, _loadReducer.getLoaderKey)([project.id])];
	
	      return _react2.default.createElement(
	        _ListItem2.default,
	        { fullWidth: true, key: project.id, className: (0, _bind2.default)('cursor-pointer', className), onClick: this.onClick },
	        _react2.default.createElement(
	          'div',
	          { className: 'pos-rel' },
	          project.watermarkTracks && _react2.default.createElement('div', { className: styles.isWatermark }),
	          project.id
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          project.fullTitle
	        ),
	        showTypeColumn && _react2.default.createElement(
	          'div',
	          { className: styles.typeCell },
	          _react2.default.createElement(_ProjectTypeTooltip2.default, { projectType: project.projectContentType })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.irefCell },
	          _react2.default.createElement(_ProjectIrefTooltip2.default, { iRef: project.iRef })
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          project.owName
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_ProjectStatus2.default, { status: project.status })
	        ),
	        showActionsColumn && _react2.default.createElement(
	          'div',
	          { className: styles.actionsCell },
	          _react2.default.createElement(_ProjectItemActions2.default, {
	            className: (0, _bind2.default)(styles.actions, 'hidden-md hidden-sm hidden-xs'),
	            project: project,
	            onReport: this.projectReport,
	            onCreateSubproject: this.createSubproject,
	            onDelete: this.deleteProject,
	            onEdit: this.editProject,
	            userPermissions: userPermissions
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _bind2.default)('moreCell hidden-lg', styles.actionsMenu) },
	            _react2.default.createElement(_MoreButton2.default, {
	              onClick: this.togglePopover,
	              loading: isDeleting,
	              containerClass: styles.moreContainer,
	              buttonClass: styles.moreIcon
	            })
	          )
	        ),
	        showActionsColumn && _react2.default.createElement(_ProjectItemPopover2.default, {
	          id: 'projectItemPopover_' + project.id,
	          onEdit: this.editProject,
	          onDelete: this.deleteProject,
	          onCreateSubproject: this.createSubproject,
	          onReport: this.projectReport,
	          onInit: this.bindPopover,
	          hideCreateSubproject: !canCreateSubproject,
	          hideEdit: !canEdit,
	          hideReport: !canGetReport,
	          hideDelete: !canDelete
	        })
	      );
	    }
	  }]);
	  return ProjectsListItem;
	}(_react.PureComponent), _class2.propTypes = {
	  className: _propTypes2.default.string,
	  deleteLoaders: _propTypes2.default.object,
	  onClick: _propTypes2.default.func,
	  onCreateSubproject: _propTypes2.default.func,
	  onDelete: _propTypes2.default.func,
	  onEdit: _propTypes2.default.func,
	  project: _propTypes2.default.object,
	  showActionsColumn: _propTypes2.default.bool,
	  showTypeColumn: _propTypes2.default.bool,
	  userPermissions: _propTypes2.default.object
	}, _class2.contextTypes = {
	  push: _propTypes2.default.func,
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  deleteLoaders: {},
	  onCreateSubproject: _noop3.default,
	  onDelete: _noop3.default,
	  onEdit: _noop3.default,
	  project: {},
	  userPermissions: {}
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onClickEdit', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onClickEdit'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onClickPopup', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onClickPopup'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onClickCreateProj', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onClickCreateProj'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onClick'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'projectReport', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'projectReport'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'editProject', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'editProject'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'deleteProject', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'deleteProject'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'createSubproject', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'createSubproject'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'togglePopover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'togglePopover'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'bindPopover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'bindPopover'), _class.prototype)), _class);
	exports.default = ProjectsListItem;
	module.exports = exports['default'];

/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _project = __webpack_require__(37);
	
	var projectActions = _interopRequireWildcard(_project);
	
	var _projects = __webpack_require__(359);
	
	var projectsActions = _interopRequireWildcard(_projects);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _ProjectsList = __webpack_require__(834);
	
	var _ProjectsList2 = _interopRequireDefault(_ProjectsList);
	
	var _auth = __webpack_require__(77);
	
	var _projects2 = __webpack_require__(28);
	
	var _Pagination = __webpack_require__(351);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	var _reactScroll = __webpack_require__(251);
	
	var _reactScroll2 = _interopRequireDefault(_reactScroll);
	
	var _projects3 = __webpack_require__(136);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var scroll = _reactScroll2.default.animateScroll;
	
	var ProjectsListWrapper = (_dec = (0, _reactRedux.connect)(function (state, ownProps) {
	  var projectsEntities = (0, _projects3.getProjects)(state, ownProps);
	  return {
	    activeOrder: state.projects.activeOrder,
	    order: state.projects.order,
	    projects: projectsEntities.projects,
	    projectsCount: projectsEntities.countAll,
	    projectsListPage: state.projects.projectsListPage,
	    projectsListPagesCount: state.projects.projectsListPagesCount,
	    projectsLoading: state.projects.projectsLoading,
	    deleteProjectLoaders: state.projects.deleteProjectLoaders,
	    userPermissions: (0, _auth.getPermissions)(state)
	  };
	}, (0, _extends3.default)({}, projectActions, projectsActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(ProjectsListWrapper, _Component);
	
	  function ProjectsListWrapper() {
	    (0, _classCallCheck3.default)(this, ProjectsListWrapper);
	    return (0, _possibleConstructorReturn3.default)(this, (ProjectsListWrapper.__proto__ || (0, _getPrototypeOf2.default)(ProjectsListWrapper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProjectsListWrapper, [{
	    key: 'onEdit',
	    value: function onEdit() {
	      this.props.initProject();
	    }
	  }, {
	    key: 'onDelete',
	    value: function onDelete(project) {
	      this.props.deleteProject(project.id, project.projectContentType);
	    }
	  }, {
	    key: 'onCreateSubproject',
	    value: function onCreateSubproject() {
	      this.props.initProject();
	    }
	  }, {
	    key: 'onPageChange',
	    value: function onPageChange(_ref) {
	      var page = _ref.page;
	
	      this.props.setProjectsListPage({ page: page });
	      scroll.scrollToTop();
	    }
	  }, {
	    key: 'reorder',
	    value: function reorder(name) {
	      this.props.reorder(name);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          projectsLoading = _props.projectsLoading,
	          projects = _props.projects,
	          showTypeColumn = _props.showTypeColumn,
	          showActionsColumn = _props.showActionsColumn,
	          deleteProjectLoaders = _props.deleteProjectLoaders,
	          activeOrder = _props.activeOrder,
	          order = _props.order,
	          userPermissions = _props.userPermissions,
	          projectsListPage = _props.projectsListPage,
	          projectsCount = _props.projectsCount;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_ProjectsList2.default, {
	          activeOrder: activeOrder,
	          order: order,
	          onReorder: this.reorder,
	          projects: projects,
	          onDelete: this.onDelete,
	          onCreateSubproject: this.onCreateSubproject,
	          onEdit: this.onEdit,
	          showTypeColumn: showTypeColumn,
	          showActionsColumn: showActionsColumn,
	          deleteLoaders: deleteProjectLoaders,
	          loading: projectsLoading,
	          userPermissions: userPermissions
	        }),
	        _react2.default.createElement(_Pagination2.default, {
	          className: 'margin-top-20 text-right',
	          count: projectsCount,
	          page: projectsListPage,
	          limit: _projects2.pageLimit,
	          onChange: this.onPageChange
	        })
	      );
	    }
	  }]);
	  return ProjectsListWrapper;
	}(_react.Component), _class3.propTypes = {
	  activeOrder: _propTypes2.default.string,
	  deleteProject: _propTypes2.default.func,
	  deleteProjectLoaders: _propTypes2.default.object,
	  initProject: _propTypes2.default.func,
	  order: _propTypes2.default.object,
	  projects: _propTypes2.default.array.isRequired,
	  projectsCount: _propTypes2.default.number,
	  projectsListPage: _propTypes2.default.number,
	  projectsLoading: _propTypes2.default.bool,
	  reorder: _propTypes2.default.func,
	  setProjectsListPage: _propTypes2.default.func,
	  showActionsColumn: _propTypes2.default.bool,
	  showTypeColumn: _propTypes2.default.bool,
	  userPermissions: _propTypes2.default.object
	}, _class3.defaultProps = {
	  projects: [],
	  projectsLoading: false,
	  showActionsColumn: false,
	  showTypeColumn: false
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onEdit', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onEdit'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onDelete', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onDelete'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onCreateSubproject', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onCreateSubproject'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onPageChange', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onPageChange'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'reorder', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'reorder'), _class2.prototype)), _class2)) || _class);
	exports.default = ProjectsListWrapper;
	module.exports = exports['default'];

/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _TabsWrapper = __webpack_require__(854);
	
	var _TabsWrapper2 = _interopRequireDefault(_TabsWrapper);
	
	var _Tab = __webpack_require__(853);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectsTabs = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(ProjectsTabs, _Component);
	
	  function ProjectsTabs() {
	    (0, _classCallCheck3.default)(this, ProjectsTabs);
	    return (0, _possibleConstructorReturn3.default)(this, (ProjectsTabs.__proto__ || (0, _getPrototypeOf2.default)(ProjectsTabs)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProjectsTabs, [{
	    key: 'render',
	    value: function render() {
	      var className = this.props.className;
	      var t = this.context.t;
	
	
	      return _react2.default.createElement(
	        _TabsWrapper2.default,
	        { pullRight: true, className: (0, _bind2.default)(className) },
	        _react2.default.createElement(_Tab2.default, { title: t('View All'), to: '/projects/all' }),
	        _react2.default.createElement(_Tab2.default, { title: t('Audio'), to: '/projects/audio' }),
	        _react2.default.createElement(_Tab2.default, { title: t('Video'), to: '/projects/video' }),
	        _react2.default.createElement(_Tab2.default, { title: t('Sharespaces'), to: '/projects/sharespace' })
	      );
	    }
	  }]);
	  return ProjectsTabs;
	}(_react.Component), _class.propTypes = {
	  className: _propTypes2.default.string
	}, _class.contextTypes = {
	  t: _propTypes2.default.func
	}, _temp);
	exports.default = ProjectsTabs;
	module.exports = exports['default'];

/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Modal = __webpack_require__(463);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactI18next = __webpack_require__(12);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var Prompt = (_dec = (0, _reactI18next.translate)(['common'], { withRef: true }), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(Prompt, _Component);
	
	  function Prompt() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, Prompt);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = Prompt.__proto__ || (0, _getPrototypeOf2.default)(Prompt)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { show: false };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Prompt, [{
	    key: 'show',
	    value: function show(params) {
	      this.setState((0, _extends3.default)({ show: true }, params));
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      var onCancel = this.props.onCancel;
	
	      this.setState({ show: false });
	      if (onCancel) {
	        onCancel(this.state.value);
	      }
	    }
	  }, {
	    key: 'submit',
	    value: function submit(value) {
	      var onOk = this.state.onOk;
	
	      this.hide();
	      onOk(value);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var t = this.props.t;
	      var _state = this.state,
	          title = _state.title,
	          message = _state.message,
	          okText = _state.okText,
	          cancelText = _state.cancelText,
	          show = _state.show,
	          value = _state.value;
	
	
	      return _react2.default.createElement(
	        _Modal2.default,
	        { show: show, onHide: this.hide },
	        title && _react2.default.createElement(
	          _Modal2.default.Header,
	          null,
	          _react2.default.createElement(
	            _Modal2.default.Title,
	            null,
	            title
	          )
	        ),
	        _react2.default.createElement(
	          _Modal2.default.Body,
	          null,
	          message && _react2.default.createElement(
	            'h4',
	            null,
	            message
	          ),
	          _react2.default.createElement('input', {
	            type: 'text',
	            className: 'width-perc-100',
	            value: value,
	            onChange: function onChange(e) {
	              return _this2.setState({ value: e.target.value });
	            },
	            autoFocus: true,
	            onFocus: function onFocus(e) {
	              return e.target.value += '';
	            },
	            onKeyDown: function onKeyDown(e) {
	              return e.which === 13 && _this2.submit(value);
	            }
	          })
	        ),
	        _react2.default.createElement(
	          _Modal2.default.Footer,
	          null,
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-accent', onClick: this.hide },
	            cancelText || t('Cancel')
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-success', onClick: function onClick() {
	                return _this2.submit(value);
	              } },
	            okText || t('Ok')
	          )
	        )
	      );
	    }
	  }]);
	  return Prompt;
	}(_react.Component), _class3.propTypes = {
	  onCancel: _propTypes2.default.func,
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'hide', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'hide'), _class2.prototype)), _class2)) || _class);
	exports.default = Prompt;
	module.exports = exports['default'];

/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _find3 = __webpack_require__(95);
	
	var _find4 = _interopRequireDefault(_find3);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactI18next = __webpack_require__(12);
	
	var _quicksend = __webpack_require__(156);
	
	var quickSendActions = _interopRequireWildcard(_quicksend);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _components = __webpack_require__(15);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _quicksend2 = __webpack_require__(532);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _QuickSendForwardButton = __webpack_require__(835);
	
	var _QuickSendForwardButton2 = _interopRequireDefault(_QuickSendForwardButton);
	
	var _projects = __webpack_require__(28);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1300);
	
	var QuickSendActions = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    qsDeleteLoading: state.quicksend.qsDeleteLoading,
	    qsList: (0, _quicksend2.processQuickSends)(state),
	    qsListLoading: state.quicksend.qsListLoading,
	    user: state.auth.user
	  };
	}, (0, _extends3.default)({}, quickSendActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(QuickSendActions, _Component);
	
	  function QuickSendActions() {
	    (0, _classCallCheck3.default)(this, QuickSendActions);
	    return (0, _possibleConstructorReturn3.default)(this, (QuickSendActions.__proto__ || (0, _getPrototypeOf2.default)(QuickSendActions)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(QuickSendActions, [{
	    key: 'onForward',
	    value: function onForward() {
	      var _props = this.props,
	          loadBox = _props.loadBox,
	          boxType = _props.boxType;
	
	      loadBox(boxType);
	    }
	  }, {
	    key: 'refresh',
	    value: function refresh() {
	      var _props2 = this.props,
	          loadBox = _props2.loadBox,
	          boxType = _props2.boxType,
	          onRefresh = _props2.onRefresh,
	          qsListLoading = _props2.qsListLoading;
	
	      if (!qsListLoading) {
	        loadBox(boxType).promise.then(onRefresh);
	      }
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {
	      var _props3 = this.props,
	          qsId = _props3.qsId,
	          qsDelete = _props3.qsDelete,
	          t = _props3.t,
	          onDelete = _props3.onDelete,
	          qsDeleteLoading = _props3.qsDeleteLoading;
	
	
	      if (qsDeleteLoading) {
	        return false;
	      }
	
	      var toastrConfirmOptions = {
	        onOk: function onOk() {
	          return qsDelete(qsId).promise.then(onDelete);
	        }
	      };
	      _toastr2.default.confirm(t('Are you sure you want to delete this Quick Send?'), toastrConfirmOptions);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          t = _props4.t,
	          qsDeleteLoading = _props4.qsDeleteLoading,
	          qsListLoading = _props4.qsListLoading,
	          qsList = _props4.qsList,
	          qsId = _props4.qsId,
	          className = _props4.className,
	          toggleBoxView = _props4.toggleBoxView,
	          user = _props4.user,
	          boxType = _props4.boxType;
	
	      var qsItem = (0, _find4.default)(qsList, { projectId: qsId }) || {};
	      var isSentType = boxType === _projects.quickSendBox.sent;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(styles.headLine, className) },
	        _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: (0, _classnames2.default)(styles.button, 'actionBackButton'), onClick: function onClick() {
	                return toggleBoxView('box');
	              } },
	            _react2.default.createElement('i', { className: 'icon-arrow-back' })
	          )
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: styles.actionButtons },
	          isSentType && _react2.default.createElement(_QuickSendForwardButton2.default, {
	            id: qsId,
	            data: qsItem,
	            className: styles.button,
	            iconClass: 'margin-right-5',
	            onForward: this.onForward
	          }),
	          _react2.default.createElement(
	            'button',
	            { className: styles.button, onClick: this.refresh },
	            _react2.default.createElement('i', { className: (0, _classnames2.default)('icon-sync', { 'spin reverse': qsListLoading }) }),
	            t('Refresh')
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              className: styles.button,
	              disabled: !user || qsItem.owId !== user.userId,
	              onClick: this.remove
	            },
	            _react2.default.createElement(
	              'i',
	              { className: 'icon-delete margin-right-5 pos-rel' },
	              qsDeleteLoading && _react2.default.createElement(_components.Loader, { mask: true, small: true })
	            ),
	            t('Delete')
	          )
	        )
	      );
	    }
	  }]);
	  return QuickSendActions;
	}(_react.Component), _class3.propTypes = {
	  boxType: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  loadBox: _propTypes2.default.func,
	  onDelete: _propTypes2.default.func,
	  onRefresh: _propTypes2.default.func,
	  qsDelete: _propTypes2.default.func,
	  qsDeleteLoading: _propTypes2.default.bool,
	  qsId: _propTypes2.default.number,
	  qsList: _propTypes2.default.array,
	  qsListLoading: _propTypes2.default.bool,
	  t: _propTypes2.default.func,
	  toggleBoxView: _propTypes2.default.func,
	  user: _propTypes2.default.object
	}, _class3.defaultProps = {
	  onDelete: function onDelete() {},
	  onRefresh: function onRefresh() {}
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onForward', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onForward'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'refresh', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'refresh'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'remove', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'remove'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = QuickSendActions;
	module.exports = exports['default'];

/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouter = __webpack_require__(124);
	
	var _projects = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1301);
	
	var QuickSendBoxTabs = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(QuickSendBoxTabs, _Component);
	
	  function QuickSendBoxTabs() {
	    (0, _classCallCheck3.default)(this, QuickSendBoxTabs);
	    return (0, _possibleConstructorReturn3.default)(this, (QuickSendBoxTabs.__proto__ || (0, _getPrototypeOf2.default)(QuickSendBoxTabs)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(QuickSendBoxTabs, [{
	    key: 'renderTab',
	    value: function renderTab(type, title) {
	      var active = this.props.active;
	
	
	      return _react2.default.createElement(
	        _reactRouter.Link,
	        { className: (0, _classnames2.default)(styles.tab, styles.switch, (0, _defineProperty3.default)({}, styles.active, active === type)), to: '/quick-send/' + type },
	        _react2.default.createElement(
	          'span',
	          { className: styles.title },
	          title
	        ),
	        _react2.default.createElement(
	          'svg',
	          { viewBox: '0 0 49 40', id: 'svg4138', version: '1.1' },
	          _react2.default.createElement(
	            'g',
	            { id: 'layer1' },
	            _react2.default.createElement('path', {
	              d: 'M 0,0 C 11,0 14,3 19,11 c 5,8.5 3.5,6 6,10 2.5,3.5 3.5,6 6.5,10 5,5.5 9,8 18.5,9 L 0,40 Z',
	              id: 'path6174'
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var t = this.props.t;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.tabs },
	        this.renderTab(_projects.quickSendBox.inbox, t('Inbox')),
	        this.renderTab(_projects.quickSendBox.sent, t('Sent')),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(styles.tab, styles.addTab) },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { className: 'btn btn-accent squared small', to: '/quick-send/new' },
	            _react2.default.createElement('i', { className: 'icon-add-box' }),
	            t('Create New')
	          )
	        )
	      );
	    }
	  }]);
	  return QuickSendBoxTabs;
	}(_react.Component), _class2.propTypes = {
	  active: _propTypes2.default.string,
	  t: _propTypes2.default.func
	}, _temp)) || _class);
	exports.default = QuickSendBoxTabs;
	module.exports = exports['default'];

/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isEmpty3 = __webpack_require__(81);
	
	var _isEmpty4 = _interopRequireDefault(_isEmpty3);
	
	var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _quicksend = __webpack_require__(156);
	
	var quickSendActions = _interopRequireWildcard(_quicksend);
	
	var _reactI18next = __webpack_require__(12);
	
	var _reduxForm = __webpack_require__(50);
	
	var _components = __webpack_require__(15);
	
	var _forms = __webpack_require__(526);
	
	var _reactRouterRedux = __webpack_require__(40);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _project = __webpack_require__(37);
	
	var _quickSendFormValidation = __webpack_require__(843);
	
	var _quickSendFormValidation2 = _interopRequireDefault(_quickSendFormValidation);
	
	var _projects = __webpack_require__(136);
	
	var _projects2 = __webpack_require__(28);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _SubjectRow = __webpack_require__(841);
	
	var _SubjectRow2 = _interopRequireDefault(_SubjectRow);
	
	var _MessageRow = __webpack_require__(840);
	
	var _MessageRow2 = _interopRequireDefault(_MessageRow);
	
	var _ExpireDateRow = __webpack_require__(839);
	
	var _ExpireDateRow2 = _interopRequireDefault(_ExpireDateRow);
	
	var _EmailField = __webpack_require__(838);
	
	var _EmailField2 = _interopRequireDefault(_EmailField);
	
	var _WatermarkField = __webpack_require__(842);
	
	var _WatermarkField2 = _interopRequireDefault(_WatermarkField);
	
	var _DownloadField = __webpack_require__(837);
	
	var _DownloadField2 = _interopRequireDefault(_DownloadField);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _QuickSendFormButtons = __webpack_require__(2081);
	
	var _QuickSendFormButtons2 = _interopRequireDefault(_QuickSendFormButtons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1302);
	
	var formDefaults = {
	  subject: '',
	  message: '',
	  expiryDate: '',
	  directAccessWatermark: false,
	  fwd: false,
	  download: false
	};
	
	var QuickSendForm = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    mediaFailedListData: state.project.mediaFailedListData,
	    mediaList: state.project.mediaListData,
	    recipientsList: (0, _projects.getRecipients)(state),
	    submittedCloudFiles: state.project.submittedCloudFiles,
	    submittedMediaFiles: state.project.submittedMediaFiles
	  };
	}, (0, _extends3.default)({}, quickSendActions, { publish: _project.publish, pushState: _reactRouterRedux.push })), _dec2 = (0, _reduxForm.reduxForm)({
	  form: 'quickSendForm',
	  propNamespace: 'quickSendForm',
	  initialValues: formDefaults,
	  validate: _quickSendFormValidation2.default
	}), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(QuickSendForm, _Component);
	
	  function QuickSendForm() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, QuickSendForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = QuickSendForm.__proto__ || (0, _getPrototypeOf2.default)(QuickSendForm)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { step: 1 };
	    return _this;
	  }
	
	  (0, _createClass3.default)(QuickSendForm, [{
	    key: 'cancel',
	    value: function cancel() {
	      this.props.pushState('/quick-send/sent');
	    }
	  }, {
	    key: 'publish',
	    value: function publish() {
	      var projectId = this.props.projectId;
	
	      return this.props.publish(projectId).promise;
	    }
	  }, {
	    key: 'goStep',
	    value: function goStep(step) {
	      this.setState({ step: step });
	    }
	  }, {
	    key: 'goNextStep',
	    value: function goNextStep() {
	      this.goStep(this.state.step + 1);
	    }
	  }, {
	    key: 'submit',
	    value: function submit(formData) {
	      var _this2 = this;
	
	      var _props = this.props,
	          projectId = _props.projectId,
	          t = _props.t,
	          qsSave = _props.qsSave,
	          setOutdated = _props.setOutdated;
	
	      var data = (0, _forms.normalizeFormData)(formData);
	      data.projectId = projectId;
	      return qsSave(data).promise.then(this.publish).then(function () {
	        setOutdated();
	        _toastr2.default.success(t('Successfully sent!'));
	        return _this2.cancel();
	      }).catch(function (err) {
	        return err;
	      });
	    }
	  }, {
	    key: 'isUploadsCompleted',
	    value: function isUploadsCompleted() {
	      var _props2 = this.props,
	          mediaList = _props2.mediaList,
	          submittedCloudFiles = _props2.submittedCloudFiles,
	          submittedMediaFiles = _props2.submittedMediaFiles,
	          mediaFailedListData = _props2.mediaFailedListData;
	
	      var submittedFilesCount = submittedMediaFiles.length + submittedCloudFiles.length;
	      var failedFilesCount = mediaFailedListData.length;
	      var uploadedFilesCount = mediaList.length;
	      return uploadedFilesCount && uploadedFilesCount === submittedFilesCount - failedFilesCount;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          t = _props3.t,
	          projectId = _props3.projectId,
	          recipientsList = _props3.recipientsList,
	          _props3$quickSendForm = _props3.quickSendForm,
	          handleSubmit = _props3$quickSendForm.handleSubmit,
	          submitting = _props3$quickSendForm.submitting,
	          invalid = _props3$quickSendForm.invalid;
	      var step = this.state.step;
	
	      var isSubmitDisabled = submitting || invalid || (0, _isEmpty4.default)(recipientsList) || !this.isUploadsCompleted();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'pos-rel' },
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            className: (0, _classnames2.default)('btn-clear', styles.backButton, (0, _defineProperty3.default)({}, styles.visible, step > 1)),
	            onClick: function onClick() {
	              return _this3.goStep(1);
	            }
	          },
	          _react2.default.createElement('i', { className: 'icon-chevron-thin-left' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('row wide-border', styles.slider, styles['step' + step]) },
	          _react2.default.createElement(
	            'div',
	            { className: styles.mainSection },
	            _react2.default.createElement(
	              'div',
	              { className: 'row wide-border' },
	              _react2.default.createElement(
	                'div',
	                { className: styles.mainForm },
	                _react2.default.createElement(_EmailField2.default, { projectId: projectId }),
	                _react2.default.createElement(
	                  'form',
	                  { onSubmit: handleSubmit(this.submit) },
	                  _react2.default.createElement(_SubjectRow2.default, null),
	                  _react2.default.createElement(_MessageRow2.default, null)
	                )
	              ),
	              _react2.default.createElement(_components.QuickSendUploadArea, { projectId: projectId, className: styles.uploadForm })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: styles.optionsSection },
	            _react2.default.createElement(
	              'div',
	              { className: 'row wide-border' },
	              _react2.default.createElement(
	                'div',
	                { className: styles.filesManagement },
	                _react2.default.createElement(
	                  'h4',
	                  { className: 'hint' },
	                  t('Files Management')
	                ),
	                _react2.default.createElement(_components.MediaList, {
	                  projectId: projectId,
	                  projectType: _projects2.projectTypes.quickSend,
	                  multipleBoxsets: false,
	                  hideOwner: true,
	                  hideIsrc: true,
	                  hidePackId: true,
	                  hideReplaceFile: true,
	                  hideDelete: true
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: styles.optionsForm },
	                _react2.default.createElement(
	                  'h4',
	                  { className: 'hint' },
	                  t('Options')
	                ),
	                _react2.default.createElement(_ExpireDateRow2.default, null),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'margin-top-20' },
	                  _react2.default.createElement(_WatermarkField2.default, { className: 'margin-right-20' }),
	                  _react2.default.createElement(_DownloadField2.default, null)
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_QuickSendFormButtons2.default, {
	          submitting: submitting,
	          isSubmitDisabled: isSubmitDisabled,
	          onNext: this.goNextStep,
	          onSubmit: handleSubmit(this.submit),
	          step: step
	        })
	      );
	    }
	  }]);
	  return QuickSendForm;
	}(_react.Component), _class3.propTypes = {
	  mediaFailedListData: _propTypes2.default.array,
	  mediaList: _propTypes2.default.array,
	  projectId: _propTypes2.default.number,
	  publish: _propTypes2.default.func,
	  pushState: _propTypes2.default.func,
	  qsSave: _propTypes2.default.func,
	  quickSendForm: _propTypes2.default.object,
	  recipientsList: _propTypes2.default.array,
	  setOutdated: _propTypes2.default.func,
	  submittedCloudFiles: _propTypes2.default.array,
	  submittedMediaFiles: _propTypes2.default.array,
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'cancel', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'cancel'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'publish', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'publish'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'goNextStep', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'goNextStep'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'submit', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'submit'), _class2.prototype)), _class2)) || _class) || _class) || _class);
	exports.default = QuickSendForm;
	module.exports = exports['default'];

/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _get2 = __webpack_require__(19);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(11);
	
	var _quicksend = __webpack_require__(156);
	
	var quicksendActions = _interopRequireWildcard(_quicksend);
	
	var _project = __webpack_require__(37);
	
	var projectActions = _interopRequireWildcard(_project);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _reduxForm = __webpack_require__(50);
	
	var _quickSendFormValidation = __webpack_require__(843);
	
	var _quickSendFormValidation2 = _interopRequireDefault(_quickSendFormValidation);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _EmailField = __webpack_require__(838);
	
	var _EmailField2 = _interopRequireDefault(_EmailField);
	
	var _SubjectRow = __webpack_require__(841);
	
	var _SubjectRow2 = _interopRequireDefault(_SubjectRow);
	
	var _MessageRow = __webpack_require__(840);
	
	var _MessageRow2 = _interopRequireDefault(_MessageRow);
	
	var _ExpireDateRow = __webpack_require__(839);
	
	var _ExpireDateRow2 = _interopRequireDefault(_ExpireDateRow);
	
	var _WatermarkField = __webpack_require__(842);
	
	var _WatermarkField2 = _interopRequireDefault(_WatermarkField);
	
	var _DownloadField = __webpack_require__(837);
	
	var _DownloadField2 = _interopRequireDefault(_DownloadField);
	
	var _projects = __webpack_require__(136);
	
	var _forms = __webpack_require__(526);
	
	var _QuickSendTracklist = __webpack_require__(836);
	
	var _QuickSendTracklist2 = _interopRequireDefault(_QuickSendTracklist);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1303);
	
	var formDefaults = {
	  subject: '',
	  message: '',
	  expiryDate: '',
	  directAccessWatermark: false,
	  fwd: false,
	  download: false
	};
	
	var QuickSendForwardForm = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    recipientsList: (0, _projects.getRecipients)(state)
	  };
	}, (0, _extends3.default)({}, quicksendActions, projectActions)), _dec2 = (0, _reduxForm.reduxForm)({
	  form: 'quickSendForwardForm',
	  propNamespace: 'quickSendForwardForm',
	  initialValues: formDefaults,
	  validate: _quickSendFormValidation2.default
	}), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(QuickSendForwardForm, _Component);
	
	  function QuickSendForwardForm() {
	    (0, _classCallCheck3.default)(this, QuickSendForwardForm);
	    return (0, _possibleConstructorReturn3.default)(this, (QuickSendForwardForm.__proto__ || (0, _getPrototypeOf2.default)(QuickSendForwardForm)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(QuickSendForwardForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          data = _props.data,
	          clearRecipientsList = _props.clearRecipientsList,
	          initialize = _props.quickSendForwardForm.initialize;
	
	      clearRecipientsList();
	      var directAccessWatermark = data.directAccessWatermark,
	          expiryDate = data.expiryDate,
	          recipients = data.recipients,
	          subject = data.subject,
	          message = data.message;
	
	      var download = (0, _get3.default)(recipients, [0, 'download']);
	      initialize({ subject: subject, message: message, directAccessWatermark: directAccessWatermark, fwd: false, expiryDate: expiryDate, download: download });
	    }
	  }, {
	    key: 'publish',
	    value: function publish() {
	      var _props2 = this.props,
	          publish = _props2.publish,
	          id = _props2.id;
	
	      return publish(id).promise;
	    }
	  }, {
	    key: 'submit',
	    value: function submit(formData) {
	      var _props3 = this.props,
	          qsSave = _props3.qsSave,
	          id = _props3.id,
	          onForward = _props3.onForward;
	
	      return qsSave((0, _forms.normalizeFormData)((0, _extends3.default)({}, formData, { projectId: id }))).promise.then(this.publish).then(onForward).catch(function (err) {
	        return err;
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          id = _props4.id,
	          t = _props4.t,
	          data = _props4.data,
	          recipientsList = _props4.recipientsList,
	          _props4$quickSendForw = _props4.quickSendForwardForm,
	          handleSubmit = _props4$quickSendForw.handleSubmit,
	          submitting = _props4$quickSendForw.submitting,
	          invalid = _props4$quickSendForw.invalid;
	
	      var isSubmitDisabled = invalid || submitting || !recipientsList.length;
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.form },
	        _react2.default.createElement(_EmailField2.default, { projectId: id }),
	        _react2.default.createElement(
	          'form',
	          { onSubmit: handleSubmit(this.submit) },
	          _react2.default.createElement(_SubjectRow2.default, null),
	          _react2.default.createElement(_MessageRow2.default, null),
	          _react2.default.createElement(_ExpireDateRow2.default, { inputProps: { className: 'material' } }),
	          _react2.default.createElement(
	            'div',
	            { className: 'margin-top-20' },
	            _react2.default.createElement(_WatermarkField2.default, { className: 'margin-right-20' }),
	            _react2.default.createElement(_DownloadField2.default, null)
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h3',
	              null,
	              t('Tracklist')
	            ),
	            _react2.default.createElement(_QuickSendTracklist2.default, {
	              className: styles.trackList,
	              tracks: data.tracks,
	              album: data,
	              playable: false
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'text-right' },
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                type: 'submit',
	                className: 'btn-default',
	                disabled: isSubmitDisabled,
	                loading: submitting
	              },
	              t('Send')
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return QuickSendForwardForm;
	}(_react.Component), _class3.propTypes = {
	  clearRecipientsList: _propTypes2.default.func,
	  data: _propTypes2.default.object,
	  id: _propTypes2.default.number,
	  onForward: _propTypes2.default.func,
	  publish: _propTypes2.default.func,
	  qsSave: _propTypes2.default.func,
	  quickSendForwardForm: _propTypes2.default.object,
	  recipientsList: _propTypes2.default.array,
	  t: _propTypes2.default.func
	}, _class3.defaultProps = {
	  data: { tracks: [] },
	  onForward: _noop3.default,
	  quickSendForwardForm: {},
	  recipientsList: []
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'publish', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'publish'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'submit', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'submit'), _class2.prototype)), _class2)) || _class) || _class) || _class);
	exports.default = QuickSendForwardForm;
	module.exports = exports['default'];

/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(11);
	
	var _quicksend = __webpack_require__(156);
	
	var quicksendActions = _interopRequireWildcard(_quicksend);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _Modal = __webpack_require__(212);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _QuickSendForwardForm = __webpack_require__(2073);
	
	var _QuickSendForwardForm2 = _interopRequireDefault(_QuickSendForwardForm);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var QuickSendForwardPopup = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    prop: state.quicksend.prop
	  };
	}, (0, _extends3.default)({}, quicksendActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(QuickSendForwardPopup, _Component);
	
	  function QuickSendForwardPopup() {
	    (0, _classCallCheck3.default)(this, QuickSendForwardPopup);
	    return (0, _possibleConstructorReturn3.default)(this, (QuickSendForwardPopup.__proto__ || (0, _getPrototypeOf2.default)(QuickSendForwardPopup)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(QuickSendForwardPopup, [{
	    key: 'onHide',
	    value: function onHide() {
	      var onHide = this.props.onHide;
	
	      onHide();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          t = _props.t,
	          show = _props.show,
	          id = _props.id,
	          data = _props.data,
	          onForward = _props.onForward;
	
	      var modalProps = {
	        backdrop: true,
	        closeByEsc: false,
	        title: t('Forward'),
	        bsSize: 'lg'
	      };
	
	      return _react2.default.createElement(
	        _Modal2.default,
	        (0, _extends3.default)({}, modalProps, { show: show, onHide: this.onHide }),
	        _react2.default.createElement(_QuickSendForwardForm2.default, { id: id, data: data, onForward: onForward })
	      );
	    }
	  }]);
	  return QuickSendForwardPopup;
	}(_react.Component), _class3.propTypes = {
	  data: _propTypes2.default.object,
	  id: _propTypes2.default.number,
	  onForward: _propTypes2.default.func,
	  onHide: _propTypes2.default.func,
	  show: _propTypes2.default.bool,
	  t: _propTypes2.default.func
	}, _class3.defaultProps = {
	  data: {},
	  onForward: _noop3.default,
	  onHide: _noop3.default
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onHide', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onHide'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = QuickSendForwardPopup;
	module.exports = exports['default'];

/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isArray3 = __webpack_require__(46);
	
	var _isArray4 = _interopRequireDefault(_isArray3);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactRouterRedux = __webpack_require__(40);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _quicksend = __webpack_require__(156);
	
	var quickSendActions = _interopRequireWildcard(_quicksend);
	
	var _components = __webpack_require__(15);
	
	var _QuickSendForwardButton = __webpack_require__(835);
	
	var _QuickSendForwardButton2 = _interopRequireDefault(_QuickSendForwardButton);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _projects = __webpack_require__(28);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1304);
	
	var QuickSendList = (_dec = (0, _reactRedux.connect)(null, (0, _extends3.default)({}, quickSendActions, { pushState: _reactRouterRedux.push })), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(QuickSendList, _Component);
	
	  function QuickSendList() {
	    (0, _classCallCheck3.default)(this, QuickSendList);
	    return (0, _possibleConstructorReturn3.default)(this, (QuickSendList.__proto__ || (0, _getPrototypeOf2.default)(QuickSendList)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(QuickSendList, [{
	    key: 'onForward',
	    value: function onForward() {
	      var _props = this.props,
	          loadBox = _props.loadBox,
	          boxType = _props.boxType;
	
	      loadBox(boxType);
	    }
	  }, {
	    key: 'openItem',
	    value: function openItem(id) {
	      var _props2 = this.props,
	          pushState = _props2.pushState,
	          boxType = _props2.boxType,
	          toggleBoxView = _props2.toggleBoxView;
	
	      toggleBoxView('item');
	      pushState('/quick-send/' + boxType + '/' + id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          items = _props3.items,
	          boxType = _props3.boxType,
	          activeId = _props3.activeId;
	
	      var getRecipientsNames = function getRecipientsNames(recipients) {
	        return (0, _isArray4.default)(recipients) ? recipients.map(function (recipient) {
	          return recipient.fullName;
	        }).join(', ') : '';
	      };
	      var isInboxType = boxType === _projects.quickSendBox.inbox;
	      var isSentType = boxType === _projects.quickSendBox.sent;
	      var isCanReply = function isCanReply(qsItem) {
	        return isInboxType && !!qsItem.recipient_id;
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.list },
	        items.map(function (item) {
	          return _react2.default.createElement(
	            'div',
	            {
	              className: (0, _classnames2.default)(styles.item, (0, _defineProperty3.default)({}, styles.active, activeId === item.projectId)),
	              key: item.projectId,
	              onClick: function onClick() {
	                return _this2.openItem(item.projectId);
	              }
	            },
	            isSentType && _react2.default.createElement(_QuickSendForwardButton2.default, {
	              id: item.projectId,
	              data: item,
	              className: styles.forwardButton,
	              iconClass: 'margin-right-5',
	              onForward: _this2.onForward
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: styles.title },
	              item.subject || '———',
	              isCanReply(item) && _react2.default.createElement(_components.QuickSendReplyButton, { contentKey: item.contentKey, senderName: item.owName })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: styles.message },
	              item.message
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: styles.bottom },
	              _react2.default.createElement(
	                'div',
	                { className: styles.date },
	                item.sentDateText
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: styles.sender },
	                isInboxType ? item.owName : getRecipientsNames(item.recipients)
	              )
	            )
	          );
	        })
	      );
	    }
	  }]);
	  return QuickSendList;
	}(_react.Component), _class3.propTypes = {
	  activeId: _propTypes2.default.number,
	  boxType: _propTypes2.default.string,
	  items: _propTypes2.default.array,
	  loadBox: _propTypes2.default.func,
	  pushState: _propTypes2.default.func,
	  toggleBoxView: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onForward', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onForward'), _class2.prototype)), _class2)) || _class);
	exports.default = QuickSendList;
	module.exports = exports['default'];

/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AutoCollapser = __webpack_require__(1957);
	
	var _AutoCollapser2 = _interopRequireDefault(_AutoCollapser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1305);
	
	var QuickSendRecipients = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(QuickSendRecipients, _PureComponent);
	
	  function QuickSendRecipients() {
	    (0, _classCallCheck3.default)(this, QuickSendRecipients);
	    return (0, _possibleConstructorReturn3.default)(this, (QuickSendRecipients.__proto__ || (0, _getPrototypeOf2.default)(QuickSendRecipients)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(QuickSendRecipients, [{
	    key: 'render',
	    value: function render() {
	      var recipients = this.props.recipients;
	
	      var recipientsList = recipients.map(function (recipient) {
	        return recipient.fullName;
	      }).join(', ');
	
	      return _react2.default.createElement(
	        _AutoCollapser2.default,
	        { className: styles.list },
	        recipientsList
	      );
	    }
	  }]);
	  return QuickSendRecipients;
	}(_react.PureComponent), _class.propTypes = {
	  recipients: _propTypes2.default.array
	}, _class.defaultProps = {
	  recipients: []
	}, _temp);
	exports.default = QuickSendRecipients;
	module.exports = exports['default'];

/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	var _utils = __webpack_require__(24);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1306);
	
	var QuickSendReplyButton = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(QuickSendReplyButton, _Component);
	
	  function QuickSendReplyButton() {
	    (0, _classCallCheck3.default)(this, QuickSendReplyButton);
	    return (0, _possibleConstructorReturn3.default)(this, (QuickSendReplyButton.__proto__ || (0, _getPrototypeOf2.default)(QuickSendReplyButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(QuickSendReplyButton, [{
	    key: 'reply',
	    value: function reply(e) {
	      (0, _utils.stopEvent)(e);
	      this.replyModal.open();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          t = _props.t,
	          contentKey = _props.contentKey,
	          senderName = _props.senderName;
	
	      var modalProps = { backdrop: true, closeByEsc: true, title: t('Reply') };
	
	      return _react2.default.createElement(
	        'span',
	        { className: styles.replyBtn, onClick: this.reply, title: t('Reply') },
	        _react2.default.createElement('i', { className: 'icon-reply' }),
	        _react2.default.createElement(
	          _components.Modal,
	          (0, _extends3.default)({ ref: function ref(el) {
	              return _this2.replyModal = el;
	            } }, modalProps),
	          _react2.default.createElement(_components.FeedbackForm, { contentKey: contentKey, sender: senderName, compact: true })
	        )
	      );
	    }
	  }]);
	  return QuickSendReplyButton;
	}(_react.Component), _class3.propTypes = {
	  contentKey: _propTypes2.default.string,
	  senderName: _propTypes2.default.string,
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'reply', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'reply'), _class2.prototype)), _class2)) || _class);
	exports.default = QuickSendReplyButton;
	module.exports = exports['default'];

/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get4 = __webpack_require__(58);
	
	var _get5 = _interopRequireDefault(_get4);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isEmpty3 = __webpack_require__(81);
	
	var _isEmpty4 = _interopRequireDefault(_isEmpty3);
	
	var _find3 = __webpack_require__(95);
	
	var _find4 = _interopRequireDefault(_find3);
	
	var _get6 = __webpack_require__(19);
	
	var _get7 = _interopRequireDefault(_get6);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClientSideComponent = __webpack_require__(30);
	
	var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	var _project = __webpack_require__(37);
	
	var projectActions = _interopRequireWildcard(_project);
	
	var _auth = __webpack_require__(31);
	
	var _uploads = __webpack_require__(112);
	
	var _config = __webpack_require__(41);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _cloud = __webpack_require__(216);
	
	var cloudActions = _interopRequireWildcard(_cloud);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1308);
	var uploadImg = __webpack_require__(2293);
	var desktopImg = __webpack_require__(363);
	
	var QuickSendUploadArea = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    mediaList: state.project.mediaListData,
	    submittedCloudFiles: state.project.submittedCloudFiles,
	    submittedMediaFiles: state.project.submittedMediaFiles
	  };
	}, (0, _extends3.default)({}, projectActions, cloudActions, { logout: _auth.logout })), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(QuickSendUploadArea, _Component);
	
	  function QuickSendUploadArea() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, QuickSendUploadArea);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = QuickSendUploadArea.__proto__ || (0, _getPrototypeOf2.default)(QuickSendUploadArea)).call.apply(_ref, [this].concat(args)));
	
	    _this._uploaderOnSubmitted = function (id) {
	      _this.props.submitMediaFile(id);
	    };
	
	    _this._uploaderOnComplete = function (id, name, resp) {
	      var code = resp.code,
	          msg = resp.msg;
	      var projectId = _this.props.projectId;
	
	      if (code === 1) {
	        return _this.props.logout();
	      }
	      if (code && msg) {
	        _toastr2.default.error(msg);
	      }
	      var data = (0, _get7.default)(resp, 'data[0]');
	      if (data) {
	        _this.props.addMedia((0, _extends3.default)({}, data, { uploaderId: id }), projectId);
	      }
	    };
	
	    _this._uploaderStatusChange = function (id, oldStatus, newStatus) {
	      var _this$props = _this.props,
	          projectId = _this$props.projectId,
	          addFailedMedia = _this$props.addFailedMedia;
	
	      var isFailed = (0, _uploads.isUploadFailed)(newStatus);
	      if (isFailed) {
	        addFailedMedia({ uploaderId: id }, projectId);
	      }
	    };
	
	    _this._mountUploader = function () {
	      var FineUploaderTraditional = __webpack_require__(257);
	      var projectId = _this.props.projectId;
	
	      var postParams = { projectId: projectId };
	
	      _this.uploader = new FineUploaderTraditional({
	        request: { params: (0, _extends3.default)({}, postParams, { replacedId: 0, part: 0 }) },
	        chunking: { success: { endpoint: '/api/FileUpload_wa/uploadAudioVideo' } },
	        validation: {
	          acceptFiles: (0, _uploads.getUploaderAcceptableFormats)('audio'),
	          allowedExtensions: _config2.default.app.uploaderSupportedFormats.audio
	        }
	      });
	
	      _this.uploader.on('submitted', _this._uploaderOnSubmitted);
	      _this.uploader.on('complete', _this._uploaderOnComplete);
	      _this.uploader.on('statusChange', _this._uploaderStatusChange);
	    };
	
	    _this._unMountUploader = function () {
	      _this.uploader.off('submitted', _this._uploaderOnSubmitted);
	      _this.uploader.off('complete', _this._uploaderOnComplete);
	      _this.uploader.off('statusChange', _this._uploaderStatusChange);
	      _this.uploader.methods.cancelAll();
	      _this.uploader = null;
	    };
	
	    _this.uploader = null;
	    return _this;
	  }
	
	  (0, _createClass3.default)(QuickSendUploadArea, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _get5.default)(QuickSendUploadArea.prototype.__proto__ || (0, _getPrototypeOf2.default)(QuickSendUploadArea.prototype), 'componentDidMount', this).call(this, this._mountUploader);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      (0, _get5.default)(QuickSendUploadArea.prototype.__proto__ || (0, _getPrototypeOf2.default)(QuickSendUploadArea.prototype), 'componentWillUnmount', this).call(this, this._unMountUploader);
	    }
	  }, {
	    key: 'onCloudUpload',
	    value: function onCloudUpload(cloudFile) {
	      var _props = this.props,
	          addMedia = _props.addMedia,
	          projectId = _props.projectId;
	
	      if (cloudFile) {
	        addMedia(cloudFile, projectId);
	      }
	    }
	  }, {
	    key: 'deleteItem',
	    value: function deleteItem(uploaderId) {
	      var _props2 = this.props,
	          projectId = _props2.projectId,
	          mediaList = _props2.mediaList,
	          deleteMedia = _props2.deleteMedia;
	
	      var media = (0, _find4.default)(mediaList, { uploaderId: uploaderId });
	      if (media) {
	        return deleteMedia(projectId, media.id, uploaderId).promise;
	      }
	    }
	  }, {
	    key: 'deleteCloudItem',
	    value: function deleteCloudItem(cloudFile) {
	      var _props3 = this.props,
	          projectId = _props3.projectId,
	          deleteCloudFile = _props3.deleteCloudFile;
	
	      var id = (0, _get7.default)(cloudFile, 'metadata.id');
	      return deleteCloudFile(projectId, id).promise;
	    }
	  }, {
	    key: 'cancelItem',
	    value: function cancelItem(id) {
	      this.props.deleteMediaFile(id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          t = _props4.t,
	          submittedMediaFiles = _props4.submittedMediaFiles,
	          submittedCloudFiles = _props4.submittedCloudFiles,
	          projectId = _props4.projectId,
	          className = _props4.className;
	
	      var supportedFormats = (0, _uploads.getUploaderAcceptableFormats)('audio');
	      var supportedFileTypes = _config2.default.app.uploaderSupportedFormats.audio;
	      var uploader = this.uploader;
	
	      var isMediaFiles = !(0, _isEmpty4.default)(submittedMediaFiles);
	      var isCloudFiles = !(0, _isEmpty4.default)(submittedCloudFiles);
	
	      if (!uploader) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        _react2.default.createElement(
	          _components.UploadArea,
	          {
	            uploader: uploader,
	            hideHeader: true,
	            clickable: true,
	            accept: supportedFormats
	          },
	          _react2.default.createElement(
	            'div',
	            { className: styles.uploadHint },
	            _react2.default.createElement(
	              'div',
	              { className: 'padding-5' },
	              _react2.default.createElement('img', { src: uploadImg, alt: '' })
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              t('Drag & Drop files to upload or press to select')
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.cloudButtons },
	          _react2.default.createElement(
	            _components.FileInput,
	            { uploader: uploader, className: styles.computerButton, accept: supportedFormats, multiple: true },
	            _react2.default.createElement(
	              'span',
	              { className: 'btn btn-clear' },
	              _react2.default.createElement(
	                _components.Tooltip,
	                { placement: 'bottom', title: t('Upload from computer') },
	                _react2.default.createElement('img', { src: desktopImg, alt: '' })
	              )
	            )
	          ),
	          _react2.default.createElement(_components.CloudUploader, { projectId: projectId, onCloudUpload: this.onCloudUpload, part: 0, fileTypes: supportedFileTypes })
	        ),
	        isMediaFiles && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'hint small' },
	            t('Files from the computer')
	          ),
	          submittedMediaFiles.map(function (id) {
	            return _react2.default.createElement(_components.UploaderItem, {
	              className: 'margin-bottom-10',
	              key: id,
	              id: id,
	              uploader: uploader,
	              showOnSuccess: true,
	              cancelable: true,
	              deletable: true,
	              showStatusIcon: true,
	              onCancel: function onCancel() {
	                return _this2.cancelItem(id);
	              },
	              onDelete: function onDelete() {
	                return _this2.deleteItem(id);
	              }
	            });
	          })
	        ),
	        isCloudFiles && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'hint small' },
	            t('Files from the cloud services')
	          ),
	          submittedCloudFiles.map(function (cloudFile) {
	            return _react2.default.createElement(_components.CloudUploaderItem, {
	              key: cloudFile.uniqId,
	              showOnSuccess: true,
	              deletable: true,
	              onDelete: function onDelete() {
	                return _this2.deleteCloudItem(cloudFile);
	              },
	              cloudFile: cloudFile
	            });
	          })
	        ),
	        isMediaFiles && _react2.default.createElement(_components.TotalProgress, { uploader: uploader })
	      );
	    }
	  }]);
	  return QuickSendUploadArea;
	}(_ClientSideComponent2.default), _class3.propTypes = {
	  addFailedMedia: _propTypes2.default.func,
	  addMedia: _propTypes2.default.func,
	  className: _propTypes2.default.string,
	  deleteCloudFile: _propTypes2.default.func,
	  deleteMedia: _propTypes2.default.func,
	  deleteMediaFile: _propTypes2.default.func,
	  logout: _propTypes2.default.func,
	  mediaList: _propTypes2.default.array,
	  projectId: _propTypes2.default.number,
	  submitMediaFile: _propTypes2.default.func,
	  submittedCloudFiles: _propTypes2.default.array,
	  submittedMediaFiles: _propTypes2.default.array,
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onCloudUpload', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onCloudUpload'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = QuickSendUploadArea;
	module.exports = exports['default'];

/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _reduxForm = __webpack_require__(50);
	
	var _formDate = __webpack_require__(524);
	
	var _formDate2 = _interopRequireDefault(_formDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExpireDateField = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(ExpireDateField, _PureComponent);
	
	  function ExpireDateField() {
	    (0, _classCallCheck3.default)(this, ExpireDateField);
	    return (0, _possibleConstructorReturn3.default)(this, (ExpireDateField.__proto__ || (0, _getPrototypeOf2.default)(ExpireDateField)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ExpireDateField, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          t = _props.t,
	          className = _props.className,
	          inputProps = _props.inputProps;
	
	      // disableOnClickOutside=false breaks dnd events
	
	      return _react2.default.createElement(_reduxForm.Field, {
	        className: className,
	        inputProps: inputProps,
	        name: 'expiryDate',
	        noIndent: true,
	        hideLabel: true,
	        component: _formDate2.default,
	        placeholder: t('Expire Date') + '*',
	        required: true,
	        disableOnClickOutside: true
	      });
	    }
	  }]);
	  return ExpireDateField;
	}(_react.PureComponent), _class2.propTypes = {
	  className: _propTypes2.default.string,
	  inputProps: _propTypes2.default.object,
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  inputProps: {}
	}, _temp)) || _class);
	exports.default = ExpireDateField;
	module.exports = exports['default'];

/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _formComponents = __webpack_require__(71);
	
	var _reduxForm = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MessageField = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(MessageField, _PureComponent);
	
	  function MessageField() {
	    (0, _classCallCheck3.default)(this, MessageField);
	    return (0, _possibleConstructorReturn3.default)(this, (MessageField.__proto__ || (0, _getPrototypeOf2.default)(MessageField)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MessageField, [{
	    key: 'render',
	    value: function render() {
	      var t = this.props.t;
	
	
	      return _react2.default.createElement(_reduxForm.Field, {
	        inputClassName: 'material',
	        name: 'message',
	        type: 'textarea',
	        noIndent: true,
	        hideLabel: true,
	        placeholder: t('Message'),
	        component: _formComponents.formSimpleTextInput,
	        required: true
	      });
	    }
	  }]);
	  return MessageField;
	}(_react.PureComponent), _class2.propTypes = {
	  t: _propTypes2.default.func
	}, _temp)) || _class);
	exports.default = MessageField;
	module.exports = exports['default'];

/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(11);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _reactRouterRedux = __webpack_require__(40);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var QuickSendFormButtons = (_dec = (0, _reactRedux.connect)(null, { pushState: _reactRouterRedux.push }), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(QuickSendFormButtons, _Component);
	
	  function QuickSendFormButtons() {
	    (0, _classCallCheck3.default)(this, QuickSendFormButtons);
	    return (0, _possibleConstructorReturn3.default)(this, (QuickSendFormButtons.__proto__ || (0, _getPrototypeOf2.default)(QuickSendFormButtons)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(QuickSendFormButtons, [{
	    key: 'onOk',
	    value: function onOk() {
	      var _props = this.props,
	          step = _props.step,
	          onSubmit = _props.onSubmit,
	          onNext = _props.onNext;
	
	      if (step === 1) {
	        return onNext();
	      }
	      return onSubmit();
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.props.pushState('/quick-send/sent');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          t = _props2.t,
	          submitting = _props2.submitting,
	          isSubmitDisabled = _props2.isSubmitDisabled,
	          step = _props2.step,
	          className = _props2.className;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)('text-center', className) },
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            type: 'submit',
	            className: 'btn-primary wide margin-right-20 margin-top-10',
	            onClick: this.onOk,
	            disabled: isSubmitDisabled,
	            loading: submitting
	          },
	          step === 1 ? t('Next') : t('Send')
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          { className: 'btn-stroke wide margin-top-10', onClick: this.cancel },
	          t('Cancel')
	        )
	      );
	    }
	  }]);
	  return QuickSendFormButtons;
	}(_react.Component), _class3.propTypes = {
	  className: _propTypes2.default.string,
	  isSubmitDisabled: _propTypes2.default.bool,
	  onNext: _propTypes2.default.func,
	  onSubmit: _propTypes2.default.func,
	  pushState: _propTypes2.default.func,
	  step: _propTypes2.default.number,
	  submitting: _propTypes2.default.bool,
	  t: _propTypes2.default.func
	}, _class3.defaultProps = {
	  onNext: _noop3.default,
	  onSubmit: _noop3.default
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onOk', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onOk'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'cancel', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'cancel'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = QuickSendFormButtons;
	module.exports = exports['default'];

/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _formComponents = __webpack_require__(71);
	
	var _reduxForm = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SubjectField = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(SubjectField, _PureComponent);
	
	  function SubjectField() {
	    (0, _classCallCheck3.default)(this, SubjectField);
	    return (0, _possibleConstructorReturn3.default)(this, (SubjectField.__proto__ || (0, _getPrototypeOf2.default)(SubjectField)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SubjectField, [{
	    key: 'render',
	    value: function render() {
	      var t = this.props.t;
	
	
	      return _react2.default.createElement(_reduxForm.Field, {
	        inputClassName: 'material',
	        name: 'subject',
	        type: 'text',
	        noIndent: true,
	        hideLabel: true,
	        placeholder: t('Subject'),
	        component: _formComponents.formSimpleTextInput,
	        required: true
	      });
	    }
	  }]);
	  return SubjectField;
	}(_react.PureComponent), _class2.propTypes = {
	  t: _propTypes2.default.func
	}, _temp)) || _class);
	exports.default = SubjectField;
	module.exports = exports['default'];

/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClientSideComponent = __webpack_require__(30);
	
	var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);
	
	var _reactRedux = __webpack_require__(11);
	
	var _project = __webpack_require__(37);
	
	var projectActions = _interopRequireWildcard(_project);
	
	var _contacts = __webpack_require__(61);
	
	var _projects = __webpack_require__(136);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _AddContactSuggestForm = __webpack_require__(348);
	
	var _AddContactSuggestForm2 = _interopRequireDefault(_AddContactSuggestForm);
	
	var _contacts2 = __webpack_require__(185);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var AddRecipientField = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    addRecipientLoading: state.project.addRecipientLoading,
	    addRecipientsFromGroupsLoading: state.project.addRecipientsFromGroupsLoading,
	    groupsList: state.contacts.groupsListData,
	    recipientsList: (0, _projects.getRecipients)(state),
	    recipientsListLoading: state.project.recipientsListLoading,
	    suggestionUsersList: (0, _contacts2.getSuggestionList)(state)
	  };
	}, (0, _extends3.default)({}, projectActions, { loadSuggestionUsersList: _contacts.loadSuggestionUsersList })), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(AddRecipientField, _Component);
	
	  function AddRecipientField() {
	    (0, _classCallCheck3.default)(this, AddRecipientField);
	    return (0, _possibleConstructorReturn3.default)(this, (AddRecipientField.__proto__ || (0, _getPrototypeOf2.default)(AddRecipientField)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AddRecipientField, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.loadSuggestionUsersList();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var clearRecipientsList = this.props.clearRecipientsList;
	
	      clearRecipientsList();
	    }
	  }, {
	    key: 'onSuggestionSelected',
	    value: function onSuggestionSelected(_ref) {
	      var suggestion = _ref.suggestion;
	
	      var user = {
	        userEmail: suggestion.email,
	        name: suggestion.name,
	        surname: suggestion.surname
	      };
	      return suggestion._type === 'user' ? this.addRecipient(user) : this.addGroup(suggestion.id);
	    }
	  }, {
	    key: 'getAutosuggestItems',
	    value: function getAutosuggestItems() {
	      var _props = this.props,
	          suggestionUsersList = _props.suggestionUsersList,
	          groupsList = _props.groupsList,
	          hideGroups = _props.hideGroups;
	
	      var items = [];
	      if (!hideGroups) {
	        groupsList.map(function (group) {
	          return items.push((0, _extends3.default)({}, group, { _name: group.name, _type: 'group' }));
	        });
	      }
	      suggestionUsersList.map(function (user) {
	        return items.push((0, _extends3.default)({}, user, { _name: user.email, _type: 'user' }));
	      });
	      return items;
	    }
	  }, {
	    key: 'addRecipient',
	    value: function addRecipient(data) {
	      var _props2 = this.props,
	          projectId = _props2.projectId,
	          onAdd = _props2.onAdd;
	
	
	      var promise = this.props.addRecipient(projectId, data).promise;
	      promise.then(function () {
	        return onAdd();
	      }).catch(function (err) {
	        return err;
	      });
	      return promise;
	    }
	  }, {
	    key: 'addGroup',
	    value: function addGroup(groupId) {
	      var _props3 = this.props,
	          projectId = _props3.projectId,
	          onAddGroup = _props3.onAddGroup;
	
	      var promise = this.props.addRecipientsFromGroups(projectId, ['"' + groupId + '"']).promise;
	      promise.then(function () {
	        return onAddGroup();
	      }).catch(function (err) {
	        return err;
	      });
	      return promise;
	    }
	  }, {
	    key: 'deleteRecipient',
	    value: function deleteRecipient(recipient) {
	      var projectId = this.props.projectId;
	
	      return this.props.deleteRecipient(projectId, recipient.recipientId).promise;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          addRecipientLoading = _props4.addRecipientLoading,
	          withTags = _props4.withTags,
	          addRecipientsFromGroupsLoading = _props4.addRecipientsFromGroupsLoading,
	          recipientsListLoading = _props4.recipientsListLoading,
	          recipientsList = _props4.recipientsList,
	          required = _props4.required;
	
	      var emailsAndGroupsList = this.getAutosuggestItems();
	      var showTagsLoader = withTags && (addRecipientLoading || addRecipientsFromGroupsLoading || recipientsListLoading);
	
	      return _react2.default.createElement(_AddContactSuggestForm2.default, {
	        onSuggestionSelected: this.onSuggestionSelected,
	        withTags: withTags,
	        onTagDelete: this.deleteRecipient,
	        loading: showTagsLoader,
	        onSubmit: this.onSubmit,
	        items: emailsAndGroupsList,
	        onAddNewContact: this.addRecipient,
	        onAddNewContactLoading: addRecipientLoading,
	        tags: recipientsList,
	        required: required
	      });
	    }
	  }]);
	  return AddRecipientField;
	}(_ClientSideComponent2.default), _class3.propTypes = {
	  addRecipient: _propTypes2.default.func,
	  addRecipientLoading: _propTypes2.default.bool,
	  addRecipientsFromGroups: _propTypes2.default.func,
	  addRecipientsFromGroupsLoading: _propTypes2.default.bool,
	  clearRecipientsList: _propTypes2.default.func,
	  deleteRecipient: _propTypes2.default.func,
	  groupsList: _propTypes2.default.array,
	  hideGroups: _propTypes2.default.bool,
	  loadSuggestionUsersList: _propTypes2.default.func,
	  onAdd: _propTypes2.default.func,
	  onAddGroup: _propTypes2.default.func,
	  projectId: _propTypes2.default.number.isRequired,
	  recipientsList: _propTypes2.default.array,
	  recipientsListLoading: _propTypes2.default.bool,
	  required: _propTypes2.default.bool,
	  suggestionUsersList: _propTypes2.default.array,
	  withTags: _propTypes2.default.bool
	}, _class3.defaultProps = {
	  onAdd: _noop3.default,
	  onAddGroup: _noop3.default,
	  recipientsList: [],
	  withTags: false
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onSuggestionSelected', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSuggestionSelected'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'addRecipient', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'addRecipient'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'deleteRecipient', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'deleteRecipient'), _class2.prototype)), _class2)) || _class);
	exports.default = AddRecipientField;
	module.exports = exports['default'];

/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _project = __webpack_require__(37);
	
	var projectActions = _interopRequireWildcard(_project);
	
	var _components = __webpack_require__(15);
	
	var _reactI18next = __webpack_require__(12);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var coverCenteredImg = __webpack_require__(2294);
	var coverFullImg = __webpack_require__(2295);
	
	var CoverStyle = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    project: state.project.projectData || {},
	    updateCoverStyleLoading: state.project.updateCoverStyleLoading,
	    updateCoverStyleActionData: state.project.updateCoverStyleActionData
	  };
	}, (0, _extends3.default)({}, projectActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(CoverStyle, _Component);
	
	  function CoverStyle() {
	    (0, _classCallCheck3.default)(this, CoverStyle);
	    return (0, _possibleConstructorReturn3.default)(this, (CoverStyle.__proto__ || (0, _getPrototypeOf2.default)(CoverStyle)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CoverStyle, [{
	    key: 'updateCoverStyle',
	    value: function updateCoverStyle(coverStyle) {
	      var _props = this.props,
	          project = _props.project,
	          updateCoverStyle = _props.updateCoverStyle;
	
	      return updateCoverStyle(project.id, coverStyle);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          t = _props2.t,
	          project = _props2.project,
	          updateCoverStyleLoading = _props2.updateCoverStyleLoading,
	          coverStyle = _props2.updateCoverStyleActionData.coverStyle;
	
	
	      var renderOption = function renderOption(val, image, title) {
	        var isStyleActive = project.coverStyle === val;
	        return _react2.default.createElement(
	          'div',
	          { className: 'col-xs-30 col-md-20 col-lg-15' },
	          _react2.default.createElement(
	            _components.Checkbox,
	            {
	              textAfter: title,
	              checked: isStyleActive,
	              disabled: updateCoverStyleLoading,
	              onChange: function onChange() {
	                return _this2.updateCoverStyle(val);
	              }
	            },
	            _react2.default.createElement(
	              'span',
	              { className: 'pos-rel inline-block' },
	              _react2.default.createElement('img', { src: image, className: 'max-width-100', alt: '' }),
	              updateCoverStyleLoading && coverStyle === val && _react2.default.createElement(_components.Loader, { mask: true })
	            ),
	            _react2.default.createElement('br', null)
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        renderOption(0, coverCenteredImg, t('Centered')),
	        renderOption(1, coverFullImg, t('Full width'))
	      );
	    }
	  }]);
	  return CoverStyle;
	}(_react.Component), _class2.propTypes = {
	  project: _propTypes2.default.object,
	  t: _propTypes2.default.func,
	  updateCoverStyle: _propTypes2.default.func,
	  updateCoverStyleActionData: _propTypes2.default.object,
	  updateCoverStyleLoading: _propTypes2.default.bool
	}, _temp)) || _class) || _class);
	exports.default = CoverStyle;
	module.exports = exports['default'];

/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _project = __webpack_require__(37);
	
	var projectActions = _interopRequireWildcard(_project);
	
	var _components = __webpack_require__(15);
	
	var _reactI18next = __webpack_require__(12);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1309);
	
	var quillModules = {
	  toolbar: {
	    container: [[{ font: [] }], [{ size: ['small', false, 'large', 'huge'] }], [{ align: [] }], ['bold', 'italic', 'strike', 'underline'], [{ color: [] }, { background: [] }], [{ list: 'ordered' }, { list: 'bullet' }], ['link']],
	    handlers: {}
	  }
	};
	var quillFormats = ['font', 'size', 'align', 'bold', 'italic', 'strike', 'underline', 'color', 'background', 'list', 'bullet', 'link'];
	
	var EmailWysiwyg = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    showEmailWysiwyg: state.project.showEmailWysiwyg,
	    saveEmailLoading: state.project.saveEmailLoading,
	    testEmailLoading: state.project.testEmailLoading,
	    project: state.project.projectData
	  };
	}, (0, _extends3.default)({}, projectActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(EmailWysiwyg, _Component);
	
	  function EmailWysiwyg() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, EmailWysiwyg);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = EmailWysiwyg.__proto__ || (0, _getPrototypeOf2.default)(EmailWysiwyg)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { saveAsTemplate: false };
	    if (typeof window !== 'undefined') {
	      // see https://github.com/zenoamaro/react-quill/issues/122
	      _this.ReactQuill = __webpack_require__(1753);
	    }
	    return _this;
	  }
	
	  (0, _createClass3.default)(EmailWysiwyg, [{
	    key: 'saveEmail',
	    value: function saveEmail() {
	      var _props = this.props,
	          projectId = _props.projectId,
	          saveEmail = _props.saveEmail;
	      var saveAsTemplate = this.state.saveAsTemplate;
	
	      var subject = this.emailSubjectEl.value;
	      var content = this.emailMessageEl.getEditorContents();
	      saveEmail(projectId, { content: content, subject: subject, saveAsTemplate: saveAsTemplate });
	    }
	  }, {
	    key: 'testEmail',
	    value: function testEmail() {
	      var _props2 = this.props,
	          projectId = _props2.projectId,
	          testEmail = _props2.testEmail,
	          t = _props2.t;
	
	      testEmail(projectId).promise.then(function () {
	        return _toastr2.default.success(t('A sampler email was sent to your personal email account.'));
	      });
	    }
	
	    /* eslint-disable react/no-danger */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var ReactQuill = this.ReactQuill;
	      var _props3 = this.props,
	          t = _props3.t,
	          toggleEmailWysiwyg = _props3.toggleEmailWysiwyg,
	          project = _props3.project,
	          showEmailWysiwyg = _props3.showEmailWysiwyg,
	          saveEmailLoading = _props3.saveEmailLoading,
	          testEmailLoading = _props3.testEmailLoading;
	      var saveAsTemplate = this.state.saveAsTemplate;
	
	
	      if (!project) {
	        return null;
	      }
	
	      return showEmailWysiwyg ? _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('input', {
	          type: 'text',
	          className: 'width-perc-100',
	          placeholder: t('Subject'),
	          defaultValue: project.subject,
	          ref: function ref(el) {
	            return _this2.emailSubjectEl = el;
	          }
	        }),
	        ReactQuill && _react2.default.createElement(ReactQuill, {
	          theme: 'snow',
	          modules: quillModules,
	          formats: quillFormats,
	          defaultValue: project.content,
	          ref: function ref(el) {
	            return _this2.emailMessageEl = el;
	          }
	        }),
	        _react2.default.createElement(_components.Checkbox, {
	          name: 'saveAsTemplate',
	          checked: saveAsTemplate,
	          onChange: function onChange(e) {
	            return _this2.setState({ saveAsTemplate: e.target.checked });
	          },
	          textAfter: t('Save this email as template for future use')
	        }),
	        ';',
	        _react2.default.createElement(
	          'div',
	          { className: 'hint small' },
	          t('INFO. The <Name> and <Surname> tags will pull in each recipients names to personalise the email.')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'text-right margin-top-10' },
	          _react2.default.createElement(
	            'button',
	            { type: 'button', className: 'btn btn-default wide', onClick: toggleEmailWysiwyg },
	            t('Cancel')
	          ),
	          saveEmailLoading ? _react2.default.createElement(_components.Loader, null) : _react2.default.createElement(
	            'button',
	            { type: 'button', className: 'btn btn-primary wide margin-left-20', onClick: function onClick() {
	                return _this2.saveEmail();
	              } },
	            t('Save')
	          )
	        )
	      ) : _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          t('Subject'),
	          ': ',
	          project.subject
	        ),
	        _react2.default.createElement('div', { className: (0, _classnames2.default)('ql-editor', styles.preview), dangerouslySetInnerHTML: { __html: project.content } }),
	        _react2.default.createElement(
	          'div',
	          { className: 'text-right margin-top-10' },
	          _react2.default.createElement(
	            'button',
	            { type: 'button', className: 'btn btn-default wide', onClick: toggleEmailWysiwyg },
	            t('Edit')
	          ),
	          testEmailLoading ? _react2.default.createElement(_components.Loader, null) : _react2.default.createElement(
	            'button',
	            { type: 'button', className: 'btn btn-default wide margin-left-20', onClick: this.testEmail },
	            t('Test')
	          )
	        )
	      );
	    }
	    /* eslint-enable react/no-danger */
	
	  }]);
	  return EmailWysiwyg;
	}(_react.Component), _class3.propTypes = {
	  project: _propTypes2.default.object,
	  projectId: _propTypes2.default.number,
	  saveEmail: _propTypes2.default.func,
	  saveEmailLoading: _propTypes2.default.bool,
	  showEmailWysiwyg: _propTypes2.default.bool,
	  t: _propTypes2.default.func,
	  testEmail: _propTypes2.default.func,
	  testEmailLoading: _propTypes2.default.bool,
	  toggleEmailWysiwyg: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'testEmail', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'testEmail'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = EmailWysiwyg;
	module.exports = exports['default'];

/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _project = __webpack_require__(37);
	
	var _reactI18next = __webpack_require__(12);
	
	var _reduxForm = __webpack_require__(50);
	
	var _components = __webpack_require__(15);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var recipientsLinksFormDefaults = {
	  link1: '',
	  link2: ''
	};
	
	var RecipientsLinksForm = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    project: state.project.projectData,
	    initialValues: state.project.projectData
	  };
	}, { editProjectLinks: _project.editProjectLinks }), _dec2 = (0, _reduxForm.reduxForm)({
	  form: 'RecipientsLinksForm',
	  propNamespace: 'recipientsLinksForm',
	  initialValues: recipientsLinksFormDefaults
	}), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(RecipientsLinksForm, _Component);
	
	  function RecipientsLinksForm() {
	    (0, _classCallCheck3.default)(this, RecipientsLinksForm);
	    return (0, _possibleConstructorReturn3.default)(this, (RecipientsLinksForm.__proto__ || (0, _getPrototypeOf2.default)(RecipientsLinksForm)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(RecipientsLinksForm, [{
	    key: 'saveLinks',
	    value: function saveLinks(formData) {
	      var _props = this.props,
	          t = _props.t,
	          projectId = _props.projectId;
	      var link1 = formData.link1,
	          link2 = formData.link2;
	
	      return this.props.editProjectLinks(projectId, { link1: link1, link2: link2 }).promise.then(function () {
	        return _toastr2.default.success(t('Links updated!'));
	      }).catch(function (err) {
	        return err;
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          t = _props2.t,
	          _props2$recipientsLin = _props2.recipientsLinksForm,
	          handleSubmit = _props2$recipientsLin.handleSubmit,
	          submitting = _props2$recipientsLin.submitting;
	
	
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit(this.saveLinks), className: 'pos-rel' },
	        _react2.default.createElement(
	          'div',
	          { className: 'formRow simple' },
	          _react2.default.createElement(
	            'div',
	            null,
	            t('Link'),
	            ' 1'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_reduxForm.Field, { name: 'link1', type: 'text', component: 'input' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'formRow simple' },
	          _react2.default.createElement(
	            'div',
	            null,
	            t('Link'),
	            ' 2'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_reduxForm.Field, { name: 'link2', type: 'text', component: 'input' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'hint small' },
	              t('Optional. Add connected website links to the email.')
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'formRow simple' },
	          _react2.default.createElement('div', null),
	          _react2.default.createElement(
	            'div',
	            { className: 'text-right' },
	            _react2.default.createElement(
	              'button',
	              { type: 'submit', className: 'btn btn-default wide pos-rel', disabled: submitting },
	              t('Update'),
	              submitting && _react2.default.createElement(_components.Loader, { mask: true, small: true })
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return RecipientsLinksForm;
	}(_react.Component), _class3.propTypes = {
	  editProjectLinks: _propTypes2.default.func,
	  projectId: _propTypes2.default.number.isRequired,
	  recipientsLinksForm: _propTypes2.default.object,
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'saveLinks', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'saveLinks'), _class2.prototype)), _class2)) || _class) || _class) || _class);
	exports.default = RecipientsLinksForm;
	module.exports = exports['default'];

/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends3 = __webpack_require__(8);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _every2 = __webpack_require__(1551);
	
	var _every3 = _interopRequireDefault(_every2);
	
	var _isEmpty2 = __webpack_require__(81);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _project = __webpack_require__(37);
	
	var projectActions = _interopRequireWildcard(_project);
	
	var _reactI18next = __webpack_require__(12);
	
	var _index = __webpack_require__(15);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _projects = __webpack_require__(136);
	
	var _datetime = __webpack_require__(68);
	
	var _ProjectRecipientsListItem = __webpack_require__(2089);
	
	var _ProjectRecipientsListItem2 = _interopRequireDefault(_ProjectRecipientsListItem);
	
	var _ProjectRecipientsListGroupItem = __webpack_require__(2088);
	
	var _ProjectRecipientsListGroupItem2 = _interopRequireDefault(_ProjectRecipientsListGroupItem);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _Checkbox = __webpack_require__(180);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(423);
	
	var ProjectRecipientsList = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    deleteRecipientActionData: state.project.deleteRecipientActionData,
	    deleteRecipientLoading: state.project.deleteRecipientLoading,
	    deleteRecipientsGroupActionData: state.project.deleteRecipientsGroupActionData,
	    deleteRecipientsGroupLoading: state.project.deleteRecipientsGroupLoading,
	    loadingEditRecipient: state.project.loadingEditRecipient,
	    recipientsGroupedList: (0, _projects.getGroupedRecipients)(state),
	    recipientsList: (0, _projects.getRecipients)(state),
	    recipientsListLoading: state.project.recipientsListLoading,
	    setRecipientsDownloadLoading: state.project.setRecipientsDownloadLoading
	  };
	}, (0, _extends4.default)({}, projectActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(ProjectRecipientsList, _Component);
	
	  function ProjectRecipientsList() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, ProjectRecipientsList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = ProjectRecipientsList.__proto__ || (0, _getPrototypeOf2.default)(ProjectRecipientsList)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { groupCollapsers: {}, allSelected: false };
	    return _this;
	  }
	
	  (0, _createClass3.default)(ProjectRecipientsList, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var recipientsList = nextProps.recipientsList;
	
	      if (recipientsList !== this.props.recipientsList) {
	        this.checkAllSelected(recipientsList);
	      }
	    }
	  }, {
	    key: 'checkAllSelected',
	    value: function checkAllSelected() {
	      var recipientsList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.recipientsList;
	
	      var allSelected = !!recipientsList.length && (0, _every3.default)(recipientsList, 'download');
	      this.setState({ allSelected: allSelected });
	    }
	  }, {
	    key: 'toggleSelectAll',
	    value: function toggleSelectAll(e) {
	      var _props = this.props,
	          setRecipientsDownload = _props.setRecipientsDownload,
	          projectId = _props.projectId;
	
	      var download = e.target.checked;
	      setRecipientsDownload({ projectId: projectId, download: download });
	    }
	  }, {
	    key: 'deleteRecipient',
	    value: function deleteRecipient(recipient) {
	      var _props2 = this.props,
	          projectId = _props2.projectId,
	          deleteRecipient = _props2.deleteRecipient,
	          t = _props2.t;
	
	      var toastrConfirmOptions = {
	        onOk: function onOk() {
	          return deleteRecipient(projectId, recipient.recipientId);
	        },
	        onCancel: function onCancel() {}
	      };
	      _toastr2.default.confirm(t('Are you sure you want to delete this recipient?'), toastrConfirmOptions);
	    }
	  }, {
	    key: 'deleteGroup',
	    value: function deleteGroup(group) {
	      var _props3 = this.props,
	          projectId = _props3.projectId,
	          deleteRecipientsGroup = _props3.deleteRecipientsGroup,
	          t = _props3.t;
	
	      var toastrConfirmOptions = {
	        onOk: function onOk() {
	          return deleteRecipientsGroup(projectId, group.groupId);
	        },
	        onCancel: function onCancel() {}
	      };
	      _toastr2.default.confirm(t('Are you sure you want to delete this group?'), toastrConfirmOptions);
	    }
	  }, {
	    key: 'updateRecipient',
	    value: function updateRecipient(recipientId, data) {
	      var _props4 = this.props,
	          editRecipient = _props4.editRecipient,
	          projectId = _props4.projectId;
	
	      editRecipient(projectId, recipientId, data);
	    }
	  }, {
	    key: 'updateRecipientDownload',
	    value: function updateRecipientDownload(_ref2) {
	      var recipient = _ref2.recipient,
	          value = _ref2.value;
	
	      this.updateRecipient(recipient.recipientId, { download: value ? 1 : 0 });
	    }
	  }, {
	    key: 'updateRecipientExpirationDate',
	    value: function updateRecipientExpirationDate(_ref3) {
	      var recipient = _ref3.recipient,
	          value = _ref3.value;
	
	      this.updateRecipient(recipient.recipientId, { expirationDate: value.format(_datetime.dateFormat.sql) });
	    }
	  }, {
	    key: 'toggleGroup',
	    value: function toggleGroup(group) {
	      this.setState({ groupCollapsers: (0, _extends4.default)({}, this.state.groupCollapsers, (0, _defineProperty3.default)({}, group.groupId, !this.state.groupCollapsers[group.groupId])) });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props5 = this.props,
	          t = _props5.t,
	          deleteRecipientLoading = _props5.deleteRecipientLoading,
	          deleteRecipientActionData = _props5.deleteRecipientActionData,
	          recipientsListLoading = _props5.recipientsListLoading,
	          downloadAuthorised = _props5.downloadAuthorised,
	          individualExpiryDate = _props5.individualExpiryDate,
	          loadingEditRecipient = _props5.loadingEditRecipient,
	          className = _props5.className,
	          hideEmpty = _props5.hideEmpty,
	          recipientsGroupedList = _props5.recipientsGroupedList,
	          deleteRecipientsGroupLoading = _props5.deleteRecipientsGroupLoading,
	          deleteRecipientsGroupActionData = _props5.deleteRecipientsGroupActionData,
	          setRecipientsDownloadLoading = _props5.setRecipientsDownloadLoading;
	      var _state = this.state,
	          groupCollapsers = _state.groupCollapsers,
	          allSelected = _state.allSelected;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        !(hideEmpty && (0, _isEmpty3.default)(recipientsGroupedList)) && _react2.default.createElement(
	          'div',
	          { className: styles.list },
	          _react2.default.createElement(
	            'div',
	            { className: styles.recipientRow },
	            _react2.default.createElement(
	              'div',
	              { className: styles.idColumn },
	              t('Id')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: styles.nameColumn },
	              t('Recipient')
	            ),
	            individualExpiryDate && _react2.default.createElement(
	              'div',
	              { className: styles.dateColumn },
	              t('Expiry date')
	            ),
	            downloadAuthorised && _react2.default.createElement(
	              'div',
	              { className: styles.authColumn },
	              t('Download'),
	              _react2.default.createElement(
	                'span',
	                { className: 'pos-rel margin-left-5' },
	                _react2.default.createElement(_Checkbox2.default, { checked: allSelected, onChange: this.toggleSelectAll }),
	                _react2.default.createElement(_index.Loader, { show: setRecipientsDownloadLoading, mask: true, small: true })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: styles.statusColumn },
	              t('Status')
	            ),
	            _react2.default.createElement('div', { className: styles.actionsColumn })
	          ),
	          recipientsGroupedList.map(function (recipient) {
	            return recipient.groupId ? _react2.default.createElement(
	              'div',
	              { key: recipient.groupId, className: styles.groupContainer },
	              _react2.default.createElement(_ProjectRecipientsListGroupItem2.default, {
	                onClick: _this2.toggleGroup,
	                group: recipient,
	                individualExpiryDate: individualExpiryDate,
	                downloadAuthorised: downloadAuthorised,
	                loading: deleteRecipientsGroupLoading && deleteRecipientsGroupActionData.groupId === recipient.groupId,
	                onDelete: _this2.deleteGroup
	              }),
	              groupCollapsers[recipient.groupId] && recipient.recipients.map(function (groupRecipient) {
	                return _react2.default.createElement(_ProjectRecipientsListItem2.default, {
	                  key: groupRecipient.recipientId,
	                  recipient: groupRecipient,
	                  className: styles.groupRecipientRow,
	                  individualExpiryDate: individualExpiryDate,
	                  downloadAuthorised: downloadAuthorised,
	                  loadingEditRecipient: loadingEditRecipient,
	                  loading: deleteRecipientLoading && deleteRecipientActionData.recipientId === groupRecipient.recipientId,
	                  onDelete: _this2.deleteRecipient,
	                  onUpdateDownload: _this2.updateRecipientDownload,
	                  onUpdateExpirationDate: _this2.updateRecipientExpirationDate
	                });
	              })
	            ) : _react2.default.createElement(_ProjectRecipientsListItem2.default, {
	              key: recipient.recipientId,
	              recipient: recipient,
	              individualExpiryDate: individualExpiryDate,
	              downloadAuthorised: downloadAuthorised,
	              loadingEditRecipient: loadingEditRecipient,
	              loading: deleteRecipientLoading && deleteRecipientActionData.recipientId === recipient.recipientId,
	              onDelete: _this2.deleteRecipient,
	              onUpdateDownload: _this2.updateRecipientDownload,
	              onUpdateExpirationDate: _this2.updateRecipientExpirationDate
	            });
	          })
	        ),
	        recipientsListLoading && _react2.default.createElement(_index.Loader, null)
	      );
	    }
	  }]);
	  return ProjectRecipientsList;
	}(_react.Component), _class3.propTypes = {
	  className: _propTypes2.default.string,
	  deleteRecipient: _propTypes2.default.func,
	  deleteRecipientActionData: _propTypes2.default.object,
	  deleteRecipientLoading: _propTypes2.default.bool,
	  deleteRecipientsGroup: _propTypes2.default.func,
	  deleteRecipientsGroupActionData: _propTypes2.default.object,
	  deleteRecipientsGroupLoading: _propTypes2.default.bool,
	  downloadAuthorised: _propTypes2.default.bool,
	  editRecipient: _propTypes2.default.func,
	  hideEmpty: _propTypes2.default.bool,
	  individualExpiryDate: _propTypes2.default.bool,
	  loadingEditRecipient: _propTypes2.default.object,
	  projectId: _propTypes2.default.number,
	  recipientsGroupedList: _propTypes2.default.array,
	  recipientsList: _propTypes2.default.array,
	  recipientsListLoading: _propTypes2.default.bool,
	  setRecipientsDownload: _propTypes2.default.func,
	  setRecipientsDownloadLoading: _propTypes2.default.bool,
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'toggleSelectAll', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'toggleSelectAll'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'deleteRecipient', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'deleteRecipient'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'deleteGroup', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'deleteGroup'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateRecipient', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateRecipient'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateRecipientDownload', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateRecipientDownload'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateRecipientExpirationDate', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateRecipientExpirationDate'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'toggleGroup', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'toggleGroup'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = ProjectRecipientsList;
	module.exports = exports['default'];

/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _utils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(423);
	
	var ProjectRecipientsListGroupItem = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(ProjectRecipientsListGroupItem, _PureComponent);
	
	  function ProjectRecipientsListGroupItem() {
	    (0, _classCallCheck3.default)(this, ProjectRecipientsListGroupItem);
	    return (0, _possibleConstructorReturn3.default)(this, (ProjectRecipientsListGroupItem.__proto__ || (0, _getPrototypeOf2.default)(ProjectRecipientsListGroupItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProjectRecipientsListGroupItem, [{
	    key: 'onClick',
	    value: function onClick() {
	      var _props = this.props,
	          onClick = _props.onClick,
	          group = _props.group;
	
	      onClick(group);
	    }
	  }, {
	    key: 'deleteGroup',
	    value: function deleteGroup(e) {
	      (0, _utils.stopEvent)(e);
	      var _props2 = this.props,
	          group = _props2.group,
	          onDelete = _props2.onDelete;
	
	      onDelete(group);
	    }
	  }, {
	    key: 'bindPopover',
	    value: function bindPopover(el) {
	      this.popover = el;
	    }
	  }, {
	    key: 'togglePopover',
	    value: function togglePopover(e) {
	      this.popover.toggle(e);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          className = _props3.className,
	          group = _props3.group,
	          individualExpiryDate = _props3.individualExpiryDate,
	          downloadAuthorised = _props3.downloadAuthorised,
	          loading = _props3.loading;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(className, styles.recipientRow, styles.groupRow), onClick: this.onClick },
	        _react2.default.createElement(
	          'div',
	          { className: styles.idColumn },
	          _react2.default.createElement('i', { className: styles.groupIcon })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.nameColumn },
	          group.groupName
	        ),
	        individualExpiryDate && _react2.default.createElement('div', { className: styles.dateColumn }),
	        downloadAuthorised && _react2.default.createElement('div', { className: styles.authColumn }),
	        _react2.default.createElement('div', { className: styles.statusColumn }),
	        _react2.default.createElement(
	          'div',
	          { className: styles.actionsColumn },
	          _react2.default.createElement(_Button2.default, {
	            className: (0, _bind2.default)('btn-text', styles.deleteButton),
	            onClick: this.deleteGroup,
	            loading: loading,
	            small: true
	          })
	        )
	      );
	    }
	  }]);
	  return ProjectRecipientsListGroupItem;
	}(_react.PureComponent), _class2.propTypes = {
	  className: _propTypes2.default.string,
	  downloadAuthorised: _propTypes2.default.bool,
	  group: _propTypes2.default.object,
	  individualExpiryDate: _propTypes2.default.bool,
	  loading: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  onDelete: _propTypes2.default.func
	}, _class2.defaultProps = {
	  group: {},
	  onClick: _noop3.default,
	  onDelete: _noop3.default
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onClick'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'deleteGroup', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'deleteGroup'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'bindPopover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'bindPopover'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'togglePopover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'togglePopover'), _class.prototype)), _class);
	exports.default = ProjectRecipientsListGroupItem;
	module.exports = exports['default'];

/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _formComponents = __webpack_require__(71);
	
	var _strings = __webpack_require__(59);
	
	var _moment = __webpack_require__(20);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Checkbox = __webpack_require__(180);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _RecipientStatus = __webpack_require__(845);
	
	var _RecipientStatus2 = _interopRequireDefault(_RecipientStatus);
	
	var _reactDatetime = __webpack_require__(710);
	
	var _reactDatetime2 = _interopRequireDefault(_reactDatetime);
	
	var _Loader = __webpack_require__(60);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(423);
	
	var getDatePickerProps = function getDatePickerProps(recipient) {
	  var props = (0, _extends3.default)({}, _formComponents.datePickerProps);
	  if (!recipient.expirationDate.unix()) {
	    props.timeFormat = false;
	    props.dateFormat = '-';
	    recipient.expirationDate = (0, _moment2.default)();
	  }
	  return props;
	};
	
	var ProjectRecipientsListItem = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(ProjectRecipientsListItem, _PureComponent);
	
	  function ProjectRecipientsListItem() {
	    (0, _classCallCheck3.default)(this, ProjectRecipientsListItem);
	    return (0, _possibleConstructorReturn3.default)(this, (ProjectRecipientsListItem.__proto__ || (0, _getPrototypeOf2.default)(ProjectRecipientsListItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProjectRecipientsListItem, [{
	    key: 'onUpdateExpirationDate',
	    value: function onUpdateExpirationDate(value) {
	      var _props = this.props,
	          onUpdateExpirationDate = _props.onUpdateExpirationDate,
	          recipient = _props.recipient;
	
	      onUpdateExpirationDate({ recipient: recipient, value: value });
	    }
	  }, {
	    key: 'onUpdateDownload',
	    value: function onUpdateDownload(e) {
	      var _props2 = this.props,
	          onUpdateDownload = _props2.onUpdateDownload,
	          recipient = _props2.recipient;
	
	      var value = e.target.checked;
	      onUpdateDownload({ recipient: recipient, value: value });
	    }
	  }, {
	    key: 'bindPopover',
	    value: function bindPopover(el) {
	      this.popover = el;
	    }
	  }, {
	    key: 'deleteRecipient',
	    value: function deleteRecipient() {
	      var _props3 = this.props,
	          recipient = _props3.recipient,
	          onDelete = _props3.onDelete;
	
	      onDelete(recipient);
	    }
	  }, {
	    key: 'togglePopover',
	    value: function togglePopover(e) {
	      this.popover.toggle(e);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          className = _props4.className,
	          recipient = _props4.recipient,
	          downloadAuthorised = _props4.downloadAuthorised,
	          individualExpiryDate = _props4.individualExpiryDate,
	          loadingEditRecipient = _props4.loadingEditRecipient,
	          loading = _props4.loading;
	
	      var isRecipientLoading = !!loadingEditRecipient[recipient.recipientId];
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(className, styles.recipientRow) },
	        _react2.default.createElement(
	          'div',
	          { className: styles.idColumn },
	          recipient.recipientId
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.nameColumn },
	          (0, _strings.concat)(', ', recipient.fullName, recipient.userEmail)
	        ),
	        individualExpiryDate && _react2.default.createElement(
	          'div',
	          { className: styles.dateColumn },
	          _react2.default.createElement(_reactDatetime2.default, (0, _extends3.default)({}, getDatePickerProps(recipient), {
	            defaultValue: recipient.expirationDate,
	            value: recipient.expirationDate,
	            onChange: this.onUpdateExpirationDate,
	            inputProps: (0, _extends3.default)({}, _formComponents.datePickerProps.inputProps, { disabled: isRecipientLoading })
	          }))
	        ),
	        downloadAuthorised && _react2.default.createElement(
	          'div',
	          { className: styles.authColumn },
	          _react2.default.createElement(_Checkbox2.default, {
	            checked: !!recipient.download,
	            onChange: this.onUpdateDownload
	          }),
	          _react2.default.createElement(_Loader2.default, { show: isRecipientLoading, small: true, mask: true })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.statusColumn },
	          _react2.default.createElement(_RecipientStatus2.default, { status: recipient.status })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.actionsColumn },
	          _react2.default.createElement(_Button2.default, {
	            className: (0, _bind2.default)('btn-text', styles.deleteButton),
	            onClick: this.deleteRecipient,
	            loading: loading,
	            small: true
	          })
	        )
	      );
	    }
	  }]);
	  return ProjectRecipientsListItem;
	}(_react.PureComponent), _class2.propTypes = {
	  className: _propTypes2.default.string,
	  downloadAuthorised: _propTypes2.default.bool,
	  individualExpiryDate: _propTypes2.default.bool,
	  loading: _propTypes2.default.bool,
	  loadingEditRecipient: _propTypes2.default.object,
	  onDelete: _propTypes2.default.func,
	  onUpdateDownload: _propTypes2.default.func,
	  onUpdateExpirationDate: _propTypes2.default.func,
	  recipient: _propTypes2.default.object
	}, _class2.defaultProps = {
	  loadingEditRecipient: {},
	  onDelete: _noop3.default,
	  onUpdateDownload: _noop3.default,
	  onUpdateExpirationDate: _noop3.default,
	  recipient: {}
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onUpdateExpirationDate', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onUpdateExpirationDate'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onUpdateDownload', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onUpdateDownload'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'bindPopover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'bindPopover'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'deleteRecipient', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'deleteRecipient'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'togglePopover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'togglePopover'), _class.prototype)), _class);
	exports.default = ProjectRecipientsListItem;
	module.exports = exports['default'];

/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _components = __webpack_require__(15);
	
	var _RecipientsListItem = __webpack_require__(2092);
	
	var _RecipientsListItem2 = _interopRequireDefault(_RecipientsListItem);
	
	var _RecipientsListHeader = __webpack_require__(2091);
	
	var _RecipientsListHeader2 = _interopRequireDefault(_RecipientsListHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RecipientsList = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(RecipientsList, _PureComponent);
	
	  function RecipientsList() {
	    (0, _classCallCheck3.default)(this, RecipientsList);
	    return (0, _possibleConstructorReturn3.default)(this, (RecipientsList.__proto__ || (0, _getPrototypeOf2.default)(RecipientsList)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(RecipientsList, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          loading = _props.loading,
	          recipients = _props.recipients,
	          deleteLoaders = _props.deleteLoaders,
	          activeOrder = _props.activeOrder,
	          order = _props.order;
	      var _props2 = this.props,
	          onDelete = _props2.onDelete,
	          onEdit = _props2.onEdit,
	          onReorder = _props2.onReorder,
	          onClick = _props2.onClick;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        _react2.default.createElement(
	          _components.List,
	          null,
	          _react2.default.createElement(_RecipientsListHeader2.default, {
	            activeOrder: activeOrder,
	            order: order,
	            onReorder: onReorder
	          }),
	          recipients.map(function (recipient) {
	            return _react2.default.createElement(_RecipientsListItem2.default, {
	              key: recipient.id,
	              recipient: recipient,
	              onClick: onClick,
	              onDelete: onDelete,
	              onEdit: onEdit,
	              deleteLoaders: deleteLoaders
	            });
	          })
	        ),
	        _react2.default.createElement(_components.Loader, { show: loading, alignCenter: true })
	      );
	    }
	  }]);
	  return RecipientsList;
	}(_react.PureComponent), _class.propTypes = {
	  activeOrder: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  deleteLoaders: _propTypes2.default.object,
	  loading: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  onDelete: _propTypes2.default.func,
	  onEdit: _propTypes2.default.func,
	  onReorder: _propTypes2.default.func,
	  order: _propTypes2.default.object,
	  recipients: _propTypes2.default.array.isRequired
	}, _class.defaultProps = {
	  onDelete: _noop3.default,
	  onEdit: _noop3.default,
	  onReorder: _noop3.default,
	  recipients: [],
	  loading: false
	}, _temp);
	exports.default = RecipientsList;
	module.exports = exports['default'];

/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SortableListHeader = __webpack_require__(355);
	
	var _SortableListHeader2 = _interopRequireDefault(_SortableListHeader);
	
	var _ListItem = __webpack_require__(76);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RecipientsListHeader = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(RecipientsListHeader, _PureComponent);
	
	  function RecipientsListHeader() {
	    (0, _classCallCheck3.default)(this, RecipientsListHeader);
	    return (0, _possibleConstructorReturn3.default)(this, (RecipientsListHeader.__proto__ || (0, _getPrototypeOf2.default)(RecipientsListHeader)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(RecipientsListHeader, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          order = _props.order,
	          activeOrder = _props.activeOrder,
	          onReorder = _props.onReorder;
	      var t = this.context.t;
	
	
	      return _react2.default.createElement(
	        _ListItem2.default,
	        { fullWidth: true, isTitle: true },
	        _react2.default.createElement(_SortableListHeader2.default, {
	          title: t('ID'),
	          name: 'id',
	          order: order,
	          activeOrder: activeOrder,
	          onReorder: onReorder
	        }),
	        _react2.default.createElement(_SortableListHeader2.default, {
	          title: t('General information'),
	          name: 'fullName',
	          order: order,
	          activeOrder: activeOrder,
	          onReorder: onReorder
	        }),
	        _react2.default.createElement(_SortableListHeader2.default, {
	          title: t('Email'),
	          name: 'email',
	          order: order,
	          activeOrder: activeOrder,
	          onReorder: onReorder
	        })
	      );
	    }
	  }]);
	  return RecipientsListHeader;
	}(_react.PureComponent), _class.propTypes = {
	  activeOrder: _propTypes2.default.string,
	  onReorder: _propTypes2.default.func,
	  order: _propTypes2.default.object
	}, _class.contextTypes = {
	  onReorder: _noop3.default,
	  t: _propTypes2.default.func
	}, _temp);
	exports.default = RecipientsListHeader;
	module.exports = exports['default'];

/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _ListItem = __webpack_require__(76);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var RecipientsListItem = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(RecipientsListItem, _PureComponent);
	
	  function RecipientsListItem() {
	    (0, _classCallCheck3.default)(this, RecipientsListItem);
	    return (0, _possibleConstructorReturn3.default)(this, (RecipientsListItem.__proto__ || (0, _getPrototypeOf2.default)(RecipientsListItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(RecipientsListItem, [{
	    key: 'onClick',
	    value: function onClick() {
	      var _props = this.props,
	          recipient = _props.recipient,
	          onClick = _props.onClick;
	
	      if (onClick) {
	        return onClick(recipient);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          recipient = _props2.recipient;
	
	
	      return _react2.default.createElement(
	        _ListItem2.default,
	        {
	          fullWidth: true,
	          className: (0, _bind2.default)('cursor-pointer', className),
	          onClick: this.onClick
	        },
	        _react2.default.createElement(
	          'div',
	          null,
	          recipient.id
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          recipient.fullName
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          recipient.email
	        )
	      );
	    }
	  }]);
	  return RecipientsListItem;
	}(_react.PureComponent), _class2.propTypes = {
	  className: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  recipient: _propTypes2.default.object
	}, _class2.contextTypes = {
	  push: _propTypes2.default.func,
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  recipient: {}
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onClick'), _class.prototype)), _class);
	exports.default = RecipientsListItem;
	module.exports = exports['default'];

/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _uniq2 = __webpack_require__(457);
	
	var _uniq3 = _interopRequireDefault(_uniq2);
	
	var _compact2 = __webpack_require__(447);
	
	var _compact3 = _interopRequireDefault(_compact2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _responseCodes = __webpack_require__(99);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1310);
	
	var RecipientsImportsErrors = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(RecipientsImportsErrors, _PureComponent);
	
	  function RecipientsImportsErrors() {
	    (0, _classCallCheck3.default)(this, RecipientsImportsErrors);
	    return (0, _possibleConstructorReturn3.default)(this, (RecipientsImportsErrors.__proto__ || (0, _getPrototypeOf2.default)(RecipientsImportsErrors)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(RecipientsImportsErrors, [{
	    key: 'getErrorMessage',
	    value: function getErrorMessage() {
	      var _errors;
	
	      var t = this.context.t;
	      var _props = this.props,
	          data = _props.data,
	          message = _props.message;
	
	      var existError = t('Some email addresses already exist');
	      var invalidError = t('Some contacts are invalid');
	
	      var errors = (_errors = {}, (0, _defineProperty3.default)(_errors, _responseCodes.importRecipientsCodes.invalidContact, invalidError), (0, _defineProperty3.default)(_errors, _responseCodes.importRecipientsCodes.recipientExists, existError), (0, _defineProperty3.default)(_errors, _responseCodes.importRecipientsCodes.emailExists, existError), (0, _defineProperty3.default)(_errors, _responseCodes.importRecipientsCodes.groupEmailExists, existError), _errors);
	      var messages = [_react2.default.createElement(
	        'p',
	        { key: 'msg', className: styles.message },
	        message
	      )];
	
	      data.map(function (recipient) {
	        if (errors[recipient.result]) {
	          messages[recipient.result] = _react2.default.createElement(
	            'div',
	            { key: recipient.result, className: 'error' },
	            errors[recipient.result]
	          );
	        }
	      });
	
	      return (0, _compact3.default)((0, _uniq3.default)(messages));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var className = this.props.className;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        this.getErrorMessage()
	      );
	    }
	  }]);
	  return RecipientsImportsErrors;
	}(_react.PureComponent), _class.propTypes = {
	  className: _propTypes2.default.string,
	  data: _propTypes2.default.array,
	  message: _propTypes2.default.string
	}, _class.contextTypes = {
	  t: _propTypes2.default.func
	}, _class.defaultProps = {
	  data: []
	}, _temp);
	exports.default = RecipientsImportsErrors;
	module.exports = exports['default'];

/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get4 = __webpack_require__(58);
	
	var _get5 = _interopRequireDefault(_get4);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get6 = __webpack_require__(19);
	
	var _get7 = _interopRequireDefault(_get6);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClientSideComponent = __webpack_require__(30);
	
	var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);
	
	var _reactRedux = __webpack_require__(11);
	
	var _Modal = __webpack_require__(463);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _project = __webpack_require__(37);
	
	var projectActions = _interopRequireWildcard(_project);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	var _auth = __webpack_require__(31);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _uploads = __webpack_require__(112);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var ReplaceMediaFile = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    submittedMediaReplaceFile: state.project.submittedMediaReplaceFile
	  };
	}, (0, _extends3.default)({}, projectActions, { logout: _auth.logout }), null, { withRef: true }), _dec2 = (0, _reactI18next.translate)(['common'], { withRef: true }), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(ReplaceMediaFile, _Component);
	
	  function ReplaceMediaFile() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, ReplaceMediaFile);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = ReplaceMediaFile.__proto__ || (0, _getPrototypeOf2.default)(ReplaceMediaFile)).call.apply(_ref, [this].concat(args)));
	
	    _this._uploaderOnSubmitted = function (id) {
	      _this.props.submitMediaReplaceFile(id);
	    };
	
	    _this._uploaderOnComplete = function (id, name, resp) {
	      var code = resp.code,
	          success = resp.success;
	      var _this$props = _this.props,
	          replaceMedia = _this$props.replaceMedia,
	          projectId = _this$props.projectId,
	          t = _this$props.t;
	      var media = _this.state.media;
	
	
	      if (code === 1) {
	        return _this.props.logout();
	      }
	
	      var data = (0, _get7.default)(resp, 'data[0]');
	      if (data) {
	        replaceMedia(data, projectId, media.id);
	        _this.setState({ media: data });
	      }
	
	      if (success) {
	        _toastr2.default.success(t('Media file successfully replaced'));
	      }
	    };
	
	    _this._mountUploader = function () {
	      var FineUploaderTraditional = __webpack_require__(257);
	      var postParams = _this.state.postParams;
	
	
	      _this.uploader = new FineUploaderTraditional({
	        request: { params: postParams },
	        chunking: { success: { endpoint: '/api/FileUpload_wa/uploadAudioVideo' } }
	      });
	
	      _this.uploader.on('submitted', _this._uploaderOnSubmitted);
	      _this.uploader.on('complete', _this._uploaderOnComplete);
	    };
	
	    _this._unMountUploader = function () {
	      _this.uploader.off('submitted', _this._uploaderOnSubmitted);
	      _this.uploader.off('complete', _this._uploaderOnComplete);
	      _this.uploader.methods.cancelAll();
	      _this.uploader = null;
	    };
	
	    _this.state = { show: false };
	    _this.uploader = null;
	    return _this;
	  }
	
	  (0, _createClass3.default)(ReplaceMediaFile, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _get5.default)(ReplaceMediaFile.prototype.__proto__ || (0, _getPrototypeOf2.default)(ReplaceMediaFile.prototype), 'componentDidMount', this).call(this, this._mountUploader);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      (0, _get5.default)(ReplaceMediaFile.prototype.__proto__ || (0, _getPrototypeOf2.default)(ReplaceMediaFile.prototype), 'componentWillUnmount', this).call(this, this._unMountUploader);
	    }
	  }, {
	    key: 'show',
	    value: function show(params) {
	      this.setState((0, _extends3.default)({ show: true }, params));
	      var media = params.media,
	          postParams = params.postParams;
	
	      this.uploader.methods.setParams((0, _extends3.default)({}, postParams, { replacedId: media.id, part: media.part }));
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      this.setState({ show: false });
	      this.uploader.methods.cancelAll();
	      this.props.initSubmittedReplaceFile();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          t = _props.t,
	          submittedMediaReplaceFile = _props.submittedMediaReplaceFile,
	          onDropError = _props.onDropError,
	          className = _props.className,
	          projectType = _props.projectType;
	      var _state = this.state,
	          show = _state.show,
	          title = _state.title,
	          message = _state.message,
	          isMounted = _state.isMounted;
	
	      var mediaSupportedFormats = (0, _uploads.getUploaderAcceptableFormats)(projectType);
	
	      return _react2.default.createElement(
	        _Modal2.default,
	        { show: show, onHide: this.hide, className: className },
	        title && _react2.default.createElement(
	          _Modal2.default.Header,
	          null,
	          _react2.default.createElement(
	            _Modal2.default.Title,
	            null,
	            title
	          )
	        ),
	        _react2.default.createElement(
	          _Modal2.default.Body,
	          null,
	          message && _react2.default.createElement(
	            'h4',
	            null,
	            message
	          ),
	          isMounted && _react2.default.createElement(
	            _components.UploadArea,
	            {
	              uploader: this.uploader,
	              submittedFiles: submittedMediaReplaceFile,
	              multiple: false,
	              accept: mediaSupportedFormats,
	              onDropError: onDropError
	            },
	            _react2.default.createElement(
	              'div',
	              { className: 'hint small' },
	              _react2.default.createElement(
	                'div',
	                null,
	                t('Supported file formats: {{formats}}', { formats: mediaSupportedFormats })
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                t('Upload the new file')
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Modal2.default.Footer,
	          null,
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-accent', onClick: this.hide },
	            t('Close')
	          )
	        )
	      );
	    }
	  }]);
	  return ReplaceMediaFile;
	}(_ClientSideComponent2.default), _class3.propTypes = {
	  className: _propTypes2.default.string,
	  initSubmittedReplaceFile: _propTypes2.default.func,
	  logout: _propTypes2.default.func,
	  onDropError: _propTypes2.default.func,
	  projectId: _propTypes2.default.number.isRequired,
	  projectType: _propTypes2.default.string.isRequired,
	  replaceMedia: _propTypes2.default.func,
	  submitMediaReplaceFile: _propTypes2.default.func,
	  submittedMediaReplaceFile: _propTypes2.default.array,
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'hide', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'hide'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = ReplaceMediaFile;
	module.exports = exports['default'];

/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _Overlay = __webpack_require__(465);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _propTypes3 = __webpack_require__(127);
	
	var _ShareLinkPopover = __webpack_require__(2096);
	
	var _ShareLinkPopover2 = _interopRequireDefault(_ShareLinkPopover);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _utils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1312);
	
	var ShareLinkButton = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(ShareLinkButton, _PureComponent);
	
	  function ShareLinkButton() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, ShareLinkButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = ShareLinkButton.__proto__ || (0, _getPrototypeOf2.default)(ShareLinkButton)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { showPopover: false };
	    return _this;
	  }
	
	  (0, _createClass3.default)(ShareLinkButton, [{
	    key: 'onCopy',
	    value: function onCopy(result) {
	      var t = this.context.t;
	      var _props = this.props,
	          onCopy = _props.onCopy,
	          _props$onCopyErrorMes = _props.onCopyErrorMessage,
	          onCopyErrorMessage = _props$onCopyErrorMes === undefined ? t('Link copying error') : _props$onCopyErrorMes,
	          _props$onCopySuccessM = _props.onCopySuccessMessage,
	          onCopySuccessMessage = _props$onCopySuccessM === undefined ? t('Link successfully copied') : _props$onCopySuccessM;
	
	
	      if (result && onCopySuccessMessage) {
	        _toastr2.default.info(onCopySuccessMessage);
	        this.setState({ showPopover: false });
	      }
	      if (!result && onCopyErrorMessage) {
	        _toastr2.default.error(onCopyErrorMessage);
	      }
	
	      onCopy(result);
	    }
	  }, {
	    key: 'togglePopover',
	    value: function togglePopover(e) {
	      (0, _utils.stopEvent)(e);
	      this.setState({ showPopover: !this.state.showPopover, target: this.buttonEl });
	    }
	  }, {
	    key: 'hidePopover',
	    value: function hidePopover() {
	      this.setState({ showPopover: false });
	    }
	  }, {
	    key: 'bindButton',
	    value: function bindButton(el) {
	      this.buttonEl = el;
	      this.setState({ target: el });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var t = this.context.t;
	      var _props2 = this.props,
	          className = _props2.className,
	          buttonClass = _props2.buttonClass,
	          placement = _props2.placement,
	          trigger = _props2.trigger,
	          id = _props2.id,
	          link = _props2.link,
	          onClick = _props2.onClick,
	          title = _props2.title;
	      var _state = this.state,
	          showPopover = _state.showPopover,
	          target = _state.target;
	
	
	      return _react2.default.createElement(
	        'span',
	        { className: className, title: t('Share the link'), onClick: this.togglePopover, ref: this.bindButton },
	        _react2.default.createElement('i', { className: (0, _bind2.default)(styles.button, buttonClass) }),
	        _react2.default.createElement(
	          _Overlay2.default,
	          {
	            show: showPopover,
	            placement: placement,
	            trigger: trigger,
	            rootClose: true,
	            onEnter: onClick,
	            onHide: this.hidePopover,
	            target: target
	          },
	          _react2.default.createElement(_ShareLinkPopover2.default, { id: id, link: link, title: title, onCopy: this.onCopy })
	        )
	      );
	    }
	  }]);
	  return ShareLinkButton;
	}(_react.PureComponent), _class2.propTypes = {
	  buttonClass: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  id: _propTypes2.default.string.isRequired,
	  link: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  onCopy: _propTypes2.default.func,
	  onCopyErrorMessage: _propTypes2.default.string,
	  onCopySuccessMessage: _propTypes2.default.string,
	  placement: _propTypes2.default.string,
	  title: _propTypes3.node,
	  trigger: _propTypes2.default.string
	}, _class2.contextTypes = {
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  link: '',
	  onClick: _noop3.default,
	  onCopy: _noop3.default,
	  placement: 'left',
	  trigger: 'click'
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onCopy', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onCopy'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'togglePopover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'togglePopover'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'hidePopover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'hidePopover'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'bindButton', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'bindButton'), _class.prototype)), _class);
	exports.default = ShareLinkButton;
	module.exports = exports['default'];

/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(21);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _Popover = __webpack_require__(466);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Loader = __webpack_require__(60);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _propTypes3 = __webpack_require__(127);
	
	var _clipboard = __webpack_require__(2226);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1313);
	
	var ShareLinkPopover = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(ShareLinkPopover, _PureComponent);
	
	  function ShareLinkPopover() {
	    (0, _classCallCheck3.default)(this, ShareLinkPopover);
	    return (0, _possibleConstructorReturn3.default)(this, (ShareLinkPopover.__proto__ || (0, _getPrototypeOf2.default)(ShareLinkPopover)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ShareLinkPopover, [{
	    key: 'copyLink',
	    value: function copyLink() {
	      var _props = this.props,
	          link = _props.link,
	          onCopy = _props.onCopy;
	
	      var result = (0, _clipboard.copyTextToClipboard)(link);
	      onCopy(result);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var t = this.context.t;
	      var _props2 = this.props,
	          id = _props2.id,
	          link = _props2.link,
	          _props2$title = _props2.title,
	          title = _props2$title === undefined ? t('Share the link') : _props2$title,
	          rest = (0, _objectWithoutProperties3.default)(_props2, ['id', 'link', 'title']);
	
	
	      return _react2.default.createElement(
	        _Popover2.default,
	        (0, _extends3.default)({ id: id }, rest),
	        _react2.default.createElement(
	          'div',
	          { className: styles.popoverContainer },
	          _react2.default.createElement(
	            'div',
	            { className: styles.title },
	            title
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: styles.inputContainer },
	            _react2.default.createElement('input', { type: 'text', value: link, readOnly: true, className: styles.input }),
	            _react2.default.createElement(_Loader2.default, { small: true, mask: true, show: !link, transparent: true })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'text-right' },
	            _react2.default.createElement(
	              _Button2.default,
	              { className: 'btn-stroke squared small', onClick: this.copyLink, disabled: !link },
	              t('Copy link')
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return ShareLinkPopover;
	}(_react.PureComponent), _class2.propTypes = {
	  id: _propTypes2.default.string.isRequired,
	  link: _propTypes2.default.string,
	  onCopy: _propTypes2.default.func,
	  title: _propTypes3.node
	}, _class2.contextTypes = {
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  link: '',
	  onCopy: _noop3.default
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'copyLink', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'copyLink'), _class.prototype)), _class);
	exports.default = ShareLinkPopover;
	module.exports = exports['default'];

/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get3 = __webpack_require__(19);
	
	var _get4 = _interopRequireDefault(_get3);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _LinkContainer = __webpack_require__(341);
	
	var _LinkContainer2 = _interopRequireDefault(_LinkContainer);
	
	var _Link = __webpack_require__(82);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _NavItem = __webpack_require__(464);
	
	var _NavItem2 = _interopRequireDefault(_NavItem);
	
	var _Collapse = __webpack_require__(702);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _auth = __webpack_require__(31);
	
	var authActions = _interopRequireWildcard(_auth);
	
	var _sidemenu = __webpack_require__(871);
	
	var menuActions = _interopRequireWildcard(_sidemenu);
	
	var _reactI18next = __webpack_require__(12);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _auth2 = __webpack_require__(77);
	
	var _utils = __webpack_require__(24);
	
	var _permissions = __webpack_require__(215);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _config = __webpack_require__(41);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1314);
	
	var cn = _bind2.default.bind(styles);
	var logoImg = __webpack_require__(2296);
	
	var SideMenu = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    hiddenSections: state.sidemenu.hiddenSections,
	    permissions: (0, _auth2.getPermissions)(state),
	    playlistKey: (0, _get4.default)(state, 'playlist.playlistActionData.key'),
	    user: (0, _auth2.getUser)(state),
	    visible: state.sidemenu.visible
	  };
	}, (0, _extends3.default)({}, authActions, menuActions), null, { pure: false }), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(SideMenu, _Component);
	
	  function SideMenu() {
	    (0, _classCallCheck3.default)(this, SideMenu);
	    return (0, _possibleConstructorReturn3.default)(this, (SideMenu.__proto__ || (0, _getPrototypeOf2.default)(SideMenu)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SideMenu, [{
	    key: 'logout',
	    value: function logout() {
	      this.props.logout();
	    }
	  }, {
	    key: 'toggleSection',
	    value: function toggleSection(e, section) {
	      (0, _utils.stopEvent)(e);
	      var toggleSection = this.props.toggleSection;
	
	      toggleSection(section);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          user = _props.user,
	          t = _props.t,
	          show = _props.show,
	          hide = _props.hide,
	          visible = _props.visible,
	          hiddenSections = _props.hiddenSections,
	          playlistKey = _props.playlistKey,
	          permissions = _props.permissions;
	
	      var maskClass = cn('mask', { visible: visible });
	      var hamburgerClass = cn('hamburger', { visible: !visible });
	      var sideMenuClass = cn('sideMenu', { visible: visible });
	      var getExpanderClass = function getExpanderClass(section) {
	        return (0, _bind2.default)(styles.expander, hiddenSections[section] ? 'icon-chevron-thin-down' : 'icon-chevron-thin-up');
	      };
	      var isHasProjectsAccess = (0, _permissions.hasProjectsAccess)(user);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('div', { className: maskClass, onClick: hide }),
	        _react2.default.createElement(
	          'button',
	          { className: hamburgerClass, onClick: show },
	          _react2.default.createElement('i', { className: 'icon-menu' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: sideMenuClass, onClick: hide },
	          user ? _react2.default.createElement(
	            'span',
	            { className: styles.logo },
	            _react2.default.createElement('img', { src: logoImg, alt: '' })
	          ) : _react2.default.createElement(
	            _Link2.default,
	            { to: '/', className: styles.logo },
	            _react2.default.createElement('img', { src: logoImg, alt: '' })
	          ),
	          user && _react2.default.createElement(
	            'div',
	            { className: styles.username, onClick: this.logout },
	            _react2.default.createElement(
	              'div',
	              null,
	              user.fullName
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              t('Log out'),
	              _react2.default.createElement('i', { className: 'icon-exit margin-left-5' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: styles.section, onClick: function onClick(e) {
	                return _this2.toggleSection(e, 'main');
	              } },
	            t('Main'),
	            _react2.default.createElement('i', { className: getExpanderClass('main') })
	          ),
	          _react2.default.createElement(
	            _Collapse2.default,
	            { 'in': !hiddenSections.main },
	            _react2.default.createElement(
	              'ul',
	              { className: styles.links },
	              !user && _react2.default.createElement(
	                _LinkContainer2.default,
	                { to: '/login' },
	                _react2.default.createElement(
	                  _NavItem2.default,
	                  null,
	                  _react2.default.createElement('i', { className: 'icon-user' }),
	                  t('Login')
	                )
	              ),
	              !user && playlistKey && _react2.default.createElement(
	                _LinkContainer2.default,
	                { to: '/playlists/fromkey/' + playlistKey },
	                _react2.default.createElement(
	                  _NavItem2.default,
	                  null,
	                  _react2.default.createElement('i', { className: 'icon-music' }),
	                  t('Playlist')
	                )
	              ),
	              !user && _react2.default.createElement(
	                _LinkContainer2.default,
	                { to: '/contact-us' },
	                _react2.default.createElement(
	                  _NavItem2.default,
	                  null,
	                  _react2.default.createElement('i', { className: 'icon-newsletter' }),
	                  t('Contact us')
	                )
	              ),
	              user && _react2.default.createElement(
	                _LinkContainer2.default,
	                { to: '/account' },
	                _react2.default.createElement(
	                  _NavItem2.default,
	                  null,
	                  _react2.default.createElement('i', { className: 'icon-user' }),
	                  t('Account')
	                )
	              ),
	              (0, _permissions.hasContactsAccess)(user) && _react2.default.createElement(
	                _LinkContainer2.default,
	                { to: '/contacts' },
	                _react2.default.createElement(
	                  _NavItem2.default,
	                  null,
	                  _react2.default.createElement('i', { className: 'icon-users' }),
	                  t('Contacts')
	                )
	              ),
	              _react2.default.createElement(
	                _LinkContainer2.default,
	                { to: '/info' },
	                _react2.default.createElement(
	                  _NavItem2.default,
	                  null,
	                  _react2.default.createElement('i', { className: 'icon-info' }),
	                  t('Information')
	                )
	              )
	            )
	          ),
	          user && _react2.default.createElement(
	            'div',
	            null,
	            (isHasProjectsAccess || permissions.statsEnable) && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: styles.section, onClick: function onClick(e) {
	                    return _this2.toggleSection(e, 'projects');
	                  } },
	                t('Projects'),
	                _react2.default.createElement('i', { className: getExpanderClass('projects') })
	              ),
	              _react2.default.createElement(
	                _Collapse2.default,
	                { 'in': !hiddenSections.projects },
	                _react2.default.createElement(
	                  'ul',
	                  { className: styles.links },
	                  isHasProjectsAccess && _react2.default.createElement(
	                    _LinkContainer2.default,
	                    { to: '/projects/new' },
	                    _react2.default.createElement(
	                      _NavItem2.default,
	                      null,
	                      _react2.default.createElement('i', { className: 'icon-add' }),
	                      t('New')
	                    )
	                  ),
	                  isHasProjectsAccess && _react2.default.createElement(
	                    _LinkContainer2.default,
	                    { to: '/projects' },
	                    _react2.default.createElement(
	                      _NavItem2.default,
	                      null,
	                      _react2.default.createElement('i', { className: 'icon-list' }),
	                      t('Project List')
	                    )
	                  ),
	                  permissions.statsEnable && _react2.default.createElement(
	                    _LinkContainer2.default,
	                    { to: '/statistics' },
	                    _react2.default.createElement(
	                      _NavItem2.default,
	                      null,
	                      _react2.default.createElement('i', { className: 'icon-stats-bars' }),
	                      t('Statistics')
	                    )
	                  ),
	                  isHasProjectsAccess && permissions.quickSendAccess && _react2.default.createElement(
	                    _LinkContainer2.default,
	                    { to: '/quick-send' },
	                    _react2.default.createElement(
	                      _NavItem2.default,
	                      null,
	                      _react2.default.createElement('i', { className: 'icon-paper-plane' }),
	                      t('Quick Send')
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: styles.section, onClick: function onClick(e) {
	                  return _this2.toggleSection(e, 'content');
	                } },
	              t('Content'),
	              _react2.default.createElement('i', { className: getExpanderClass('content') })
	            ),
	            _react2.default.createElement(
	              _Collapse2.default,
	              { 'in': !hiddenSections.content },
	              _react2.default.createElement(
	                'ul',
	                { className: styles.links },
	                _react2.default.createElement(
	                  _LinkContainer2.default,
	                  { to: '/playlists' },
	                  _react2.default.createElement(
	                    _NavItem2.default,
	                    null,
	                    _react2.default.createElement('i', { className: 'icon-music' }),
	                    t('My Content')
	                  )
	                ),
	                _react2.default.createElement(
	                  _LinkContainer2.default,
	                  { to: '/my-playlists' },
	                  _react2.default.createElement(
	                    _NavItem2.default,
	                    null,
	                    _react2.default.createElement('i', { className: 'icon-playlist' }),
	                    t('My Playlists')
	                  )
	                )
	              )
	            ),
	            permissions.admEnable && _react2.default.createElement(
	              'ul',
	              { className: styles.links },
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { href: _config2.default.app.productionUrl + '/advanced/' },
	                  _react2.default.createElement('i', { className: 'icon-admin' }),
	                  t('Admin')
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return SideMenu;
	}(_react.Component), _class3.propTypes = {
	  hiddenSections: _propTypes2.default.object,
	  hide: _propTypes2.default.func,
	  logout: _propTypes2.default.func,
	  permissions: _propTypes2.default.object,
	  playlistKey: _propTypes2.default.string,
	  show: _propTypes2.default.func,
	  t: _propTypes2.default.func,
	  toggleSection: _propTypes2.default.func,
	  user: _propTypes2.default.object,
	  visible: _propTypes2.default.bool
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'logout', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'logout'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = SideMenu;
	module.exports = exports['default'];

/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactI18next = __webpack_require__(12);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _songs = __webpack_require__(266);
	
	var songsActions = _interopRequireWildcard(_songs);
	
	var _playlists = __webpack_require__(100);
	
	var playlistsActions = _interopRequireWildcard(_playlists);
	
	var _songs2 = __webpack_require__(875);
	
	var _SongsListRow = __webpack_require__(2099);
	
	var _SongsListRow2 = _interopRequireDefault(_SongsListRow);
	
	var _Loader = __webpack_require__(60);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _SongsListSearchBar = __webpack_require__(2100);
	
	var _SongsListSearchBar2 = _interopRequireDefault(_SongsListSearchBar);
	
	var _SelectableList2 = __webpack_require__(354);
	
	var _SelectableList3 = _interopRequireDefault(_SelectableList2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1317);
	
	var SongsList = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    checkedSongs: state.songs.checkedSongs,
	    playlistsLoaded: state.playlists.playlistsLoaded,
	    playlistsLoading: state.playlists.playlistsLoading,
	    songsLoaded: state.songs.songsLoaded,
	    songsLoading: state.songs.songsLoading,
	    songs: (0, _songs2.getFilteredSongs)(state)
	  };
	}, (0, _extends3.default)({}, songsActions, playlistsActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_SelectableList) {
	  (0, _inherits3.default)(SongsList, _SelectableList);
	
	  function SongsList() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, SongsList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = SongsList.__proto__ || (0, _getPrototypeOf2.default)(SongsList)).call.apply(_ref, [this].concat(args)));
	
	    _this.selectableConfig = (0, _extends3.default)({}, _this.selectableConfig, {
	      propsField: 'songs',
	      updateFn: _this.props.updateCheckedSongs,
	      checkedItemsPropsField: 'checkedSongs'
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(SongsList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          playlistsLoaded = _props.playlistsLoaded,
	          loadPlaylists = _props.loadPlaylists;
	
	      if (!playlistsLoaded) {
	        loadPlaylists();
	      }
	    }
	  }, {
	    key: 'onRowClick',
	    value: function onRowClick(song) {
	      this.toggleItemChecked(song.id);
	    }
	  }, {
	    key: 'onSelectionChange',
	    value: function onSelectionChange(checkedSongs) {
	      this.props.onSelect(checkedSongs);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          t = _props2.t,
	          songs = _props2.songs,
	          playlistsLoading = _props2.playlistsLoading,
	          className = _props2.className,
	          searchable = _props2.searchable,
	          checkedSongs = _props2.checkedSongs,
	          autoFocus = _props2.autoFocus;
	
	      var isEmptyResult = !playlistsLoading && !songs.length;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        searchable && _react2.default.createElement(_SongsListSearchBar2.default, {
	          className: styles.searchBar,
	          autoFocus: autoFocus
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _bind2.default)(className, styles.list) },
	          songs.map(function (song, index) {
	            return _react2.default.createElement(_SongsListRow2.default, {
	              key: song.id + '_' + song.track_number + '_' + song.wFileName,
	              song: song,
	              index: index,
	              checked: checkedSongs[song.id],
	              onClick: _this2.onRowClick
	            });
	          }),
	          isEmptyResult && _react2.default.createElement(
	            'div',
	            { className: styles.emptyResults },
	            t('Empty results')
	          ),
	          playlistsLoading && _react2.default.createElement(_Loader2.default, { alignCenter: true })
	        )
	      );
	    }
	  }]);
	  return SongsList;
	}(_SelectableList3.default), _class3.propTypes = {
	  autoFocus: _propTypes2.default.bool,
	  checkedSongs: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  loadPlaylists: _propTypes2.default.func,
	  onSelect: _propTypes2.default.func,
	  playlistsLoaded: _propTypes2.default.bool,
	  playlistsLoading: _propTypes2.default.bool,
	  searchable: _propTypes2.default.bool,
	  songs: _propTypes2.default.array,
	  t: _propTypes2.default.func,
	  updateCheckedSongs: _propTypes2.default.func
	}, _class3.defaultProps = {
	  checkedSongs: {},
	  onSelect: _noop3.default,
	  songs: []
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onRowClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onRowClick'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onSelectionChange', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSelectionChange'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = SongsList;
	module.exports = exports['default'];

/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _Checkbox = __webpack_require__(180);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _utils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1318);
	
	var SongsListRow = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(SongsListRow, _PureComponent);
	
	  function SongsListRow() {
	    (0, _classCallCheck3.default)(this, SongsListRow);
	    return (0, _possibleConstructorReturn3.default)(this, (SongsListRow.__proto__ || (0, _getPrototypeOf2.default)(SongsListRow)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SongsListRow, [{
	    key: 'onClick',
	    value: function onClick() {
	      var _props = this.props,
	          onClick = _props.onClick,
	          song = _props.song;
	
	      onClick(song);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          song = _props2.song,
	          index = _props2.index,
	          checked = _props2.checked;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(styles.row), onClick: this.onClick },
	        _react2.default.createElement(
	          'div',
	          { className: styles.index },
	          index + 1
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.title },
	          song.trackName
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.artist },
	          song.albumArtist
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          song.durationTime
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_Checkbox2.default, {
	            className: 'padding-5 inline',
	            checked: checked,
	            onClick: _utils.stopEvent,
	            small: true
	          })
	        )
	      );
	    }
	  }]);
	  return SongsListRow;
	}(_react.PureComponent), _class2.propTypes = {
	  checked: _propTypes2.default.bool,
	  index: _propTypes2.default.number,
	  onClick: _propTypes2.default.func,
	  song: _propTypes2.default.object
	}, _class2.defaultProps = {
	  index: 0,
	  song: {},
	  onClick: _noop3.default
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onClick'), _class.prototype)), _class);
	exports.default = SongsListRow;
	module.exports = exports['default'];

/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _songs = __webpack_require__(266);
	
	var songsActions = _interopRequireWildcard(_songs);
	
	var _SearchBar = __webpack_require__(183);
	
	var _SearchBar2 = _interopRequireDefault(_SearchBar);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1319);
	
	var SongsListSearchBar = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    kw: state.songs.kw
	  };
	}, (0, _extends3.default)({}, songsActions)), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(SongsListSearchBar, _Component);
	
	  function SongsListSearchBar() {
	    (0, _classCallCheck3.default)(this, SongsListSearchBar);
	    return (0, _possibleConstructorReturn3.default)(this, (SongsListSearchBar.__proto__ || (0, _getPrototypeOf2.default)(SongsListSearchBar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SongsListSearchBar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          setSongsFilter = _props.setSongsFilter,
	          className = _props.className,
	          kw = _props.kw,
	          onChange = _props.onChange,
	          autoFocus = _props.autoFocus;
	
	
	      return _react2.default.createElement(_SearchBar2.default, {
	        autoFocus: autoFocus,
	        className: (0, _bind2.default)(className, styles.bar),
	        onChange: onChange,
	        kw: kw,
	        onSetFilter: setSongsFilter
	      });
	    }
	  }]);
	  return SongsListSearchBar;
	}(_react.Component), _class2.propTypes = {
	  autoFocus: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  kw: _propTypes2.default.string,
	  onChange: _propTypes2.default.func,
	  setSongsFilter: _propTypes2.default.func
	}, _class2.defaultProps = {
	  onChange: _noop3.default
	}, _temp)) || _class);
	exports.default = SongsListSearchBar;
	module.exports = exports['default'];

/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SongsSelectPopup = __webpack_require__(2102);
	
	var _SongsSelectPopup2 = _interopRequireDefault(_SongsSelectPopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var SongsSelectButton = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_class2 = (_temp = _class3 = function (_PureComponent) {
	  (0, _inherits3.default)(SongsSelectButton, _PureComponent);
	
	  function SongsSelectButton() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, SongsSelectButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = SongsSelectButton.__proto__ || (0, _getPrototypeOf2.default)(SongsSelectButton)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { showSongsPopup: false };
	    return _this;
	  }
	
	  (0, _createClass3.default)(SongsSelectButton, [{
	    key: 'onSave',
	    value: function onSave(songs) {
	      var onSave = this.props.onSave;
	
	      onSave(songs);
	    }
	  }, {
	    key: 'showSongsSelectPopup',
	    value: function showSongsSelectPopup() {
	      this.setState({ showSongsPopup: true });
	    }
	  }, {
	    key: 'hideSongsPopup',
	    value: function hideSongsPopup() {
	      this.setState({ showSongsPopup: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var t = this.props.t;
	      var showSongsPopup = this.state.showSongsPopup;
	
	
	      return _react2.default.createElement(
	        _Button2.default,
	        { className: 'btn-primary', onClick: this.showSongsSelectPopup },
	        t('Add songs'),
	        _react2.default.createElement(_SongsSelectPopup2.default, {
	          show: showSongsPopup,
	          onHide: this.hideSongsPopup,
	          onSave: this.onSave
	        })
	      );
	    }
	  }]);
	  return SongsSelectButton;
	}(_react.PureComponent), _class3.propTypes = {
	  onSave: _propTypes2.default.func,
	  t: _propTypes2.default.func
	}, _class3.defaultProps = {
	  onSave: _noop3.default
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onSave', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSave'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'showSongsSelectPopup', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'showSongsSelectPopup'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'hideSongsPopup', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'hideSongsPopup'), _class2.prototype)), _class2)) || _class);
	exports.default = SongsSelectButton;
	module.exports = exports['default'];

/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactI18next = __webpack_require__(12);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _Modal = __webpack_require__(212);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _SongsList = __webpack_require__(2098);
	
	var _SongsList2 = _interopRequireDefault(_SongsList);
	
	var _songs = __webpack_require__(266);
	
	var songsActions = _interopRequireWildcard(_songs);
	
	var _SongsSelectPopupFooter = __webpack_require__(2103);
	
	var _SongsSelectPopupFooter2 = _interopRequireDefault(_SongsSelectPopupFooter);
	
	var _songs2 = __webpack_require__(875);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(627);
	
	var SongsSelectPopup = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    checkedSongs: (0, _songs2.getCheckedSongsArray)(state)
	  };
	}, (0, _extends3.default)({}, songsActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_PureComponent) {
	  (0, _inherits3.default)(SongsSelectPopup, _PureComponent);
	
	  function SongsSelectPopup() {
	    (0, _classCallCheck3.default)(this, SongsSelectPopup);
	    return (0, _possibleConstructorReturn3.default)(this, (SongsSelectPopup.__proto__ || (0, _getPrototypeOf2.default)(SongsSelectPopup)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SongsSelectPopup, [{
	    key: 'onHide',
	    value: function onHide() {
	      var _props = this.props,
	          onHide = _props.onHide,
	          setSongsFilter = _props.setSongsFilter;
	
	      setTimeout(function () {
	        return setSongsFilter({ kw: '' });
	      }, 300);
	      onHide();
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _props2 = this.props,
	          onSave = _props2.onSave,
	          checkedSongs = _props2.checkedSongs;
	
	      onSave(checkedSongs);
	      this.onHide();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          t = _props3.t,
	          show = _props3.show,
	          checkedSongs = _props3.checkedSongs;
	
	      var modalProps = {
	        backdrop: true,
	        closeByEsc: false,
	        title: t('Add Songs'),
	        bsSize: 'lg',
	        withoutPadding: true
	      };
	
	      return _react2.default.createElement(
	        _Modal2.default,
	        (0, _extends3.default)({}, modalProps, { show: show, onHide: this.onHide }),
	        _react2.default.createElement(_SongsList2.default, {
	          className: styles.list,
	          onSelect: this.onSelect,
	          searchable: true,
	          autoFocus: true
	        }),
	        _react2.default.createElement(_SongsSelectPopupFooter2.default, {
	          checkedCount: checkedSongs.length,
	          onSave: this.save
	        })
	      );
	    }
	  }]);
	  return SongsSelectPopup;
	}(_react.PureComponent), _class3.propTypes = {
	  checkedSongs: _propTypes2.default.array,
	  onHide: _propTypes2.default.func,
	  onSave: _propTypes2.default.func,
	  setSongsFilter: _propTypes2.default.func,
	  show: _propTypes2.default.bool,
	  t: _propTypes2.default.func
	}, _class3.defaultProps = {
	  checkedSongs: [],
	  onHide: _noop3.default,
	  onSave: _noop3.default
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onHide', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onHide'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'save', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'save'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = SongsSelectPopup;
	module.exports = exports['default'];

/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactI18next = __webpack_require__(12);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CheckedCount = __webpack_require__(818);
	
	var _CheckedCount2 = _interopRequireDefault(_CheckedCount);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _songs = __webpack_require__(266);
	
	var songsActions = _interopRequireWildcard(_songs);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(627);
	
	var SongsSelectPopupFooter = (_dec = (0, _reactRedux.connect)(null, (0, _extends3.default)({}, songsActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(SongsSelectPopupFooter, _Component);
	
	  function SongsSelectPopupFooter() {
	    (0, _classCallCheck3.default)(this, SongsSelectPopupFooter);
	    return (0, _possibleConstructorReturn3.default)(this, (SongsSelectPopupFooter.__proto__ || (0, _getPrototypeOf2.default)(SongsSelectPopupFooter)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SongsSelectPopupFooter, [{
	    key: 'clearSelection',
	    value: function clearSelection() {
	      var updateCheckedSongs = this.props.updateCheckedSongs;
	
	      updateCheckedSongs({});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          t = _props.t,
	          checkedCount = _props.checkedCount,
	          onSave = _props.onSave;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.bottomContainer },
	        _react2.default.createElement(_CheckedCount2.default, { checkedCount: checkedCount, onClear: this.clearSelection }),
	        _react2.default.createElement(
	          'div',
	          { className: styles.buttonContainer },
	          _react2.default.createElement(
	            _Button2.default,
	            { className: 'btn-primary', onClick: onSave },
	            t('Save')
	          )
	        )
	      );
	    }
	  }]);
	  return SongsSelectPopupFooter;
	}(_react.Component), _class3.propTypes = {
	  checkedCount: _propTypes2.default.number,
	  onSave: _propTypes2.default.func,
	  t: _propTypes2.default.func,
	  updateCheckedSongs: _propTypes2.default.func
	}, _class3.defaultProps = {
	  checkedCount: 0,
	  onSave: _noop3.default,
	  updateCheckedSongs: _noop3.default
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'clearSelection', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'clearSelection'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = SongsSelectPopupFooter;
	module.exports = exports['default'];

/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDnd = __webpack_require__(472);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1320);
	
	var layerStyles = {
	  position: 'fixed',
	  pointerEvents: 'none',
	  zIndex: 100,
	  left: 0,
	  top: 0,
	  width: '100%',
	  height: '100%'
	};
	
	var SortableItemPreview = (_dec = (0, _reactDnd.DragLayer)(function (monitor) {
	  return {
	    currentOffset: monitor.getSourceClientOffset(),
	    isDragging: monitor.isDragging(),
	    item: monitor.getItem(),
	    itemType: monitor.getItemType()
	  };
	}), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(SortableItemPreview, _Component);
	
	  function SortableItemPreview() {
	    (0, _classCallCheck3.default)(this, SortableItemPreview);
	    return (0, _possibleConstructorReturn3.default)(this, (SortableItemPreview.__proto__ || (0, _getPrototypeOf2.default)(SortableItemPreview)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SortableItemPreview, [{
	    key: 'getItemStyles',
	    value: function getItemStyles() {
	      var currentOffset = this.props.currentOffset;
	
	      if (!currentOffset) {
	        return { display: 'none' };
	      }
	
	      var _ref = this.layerElement ? this.layerElement.getBoundingClientRect() : {},
	          _ref$top = _ref.top,
	          top = _ref$top === undefined ? 0 : _ref$top,
	          _ref$left = _ref.left,
	          left = _ref$left === undefined ? 0 : _ref$left;
	
	      var x = currentOffset.x,
	          y = currentOffset.y;
	
	      var transform = 'translate(' + (x - left) + 'px, ' + (y - top) + 'px)';
	
	      return {
	        transform: transform,
	        WebkitTransform: transform
	      };
	    }
	  }, {
	    key: 'getLayerElement',
	    value: function getLayerElement(element) {
	      this.layerElement = element;
	    }
	  }, {
	    key: 'renderItem',
	    value: function renderItem() {
	      var item = this.props.item;
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.preview },
	        item.children
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          item = _props.item,
	          itemType = _props.itemType,
	          isDragging = _props.isDragging;
	
	      if (!isDragging) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: layerStyles, ref: this.getLayerElement },
	        _react2.default.createElement(
	          'div',
	          { style: this.getItemStyles() },
	          this.renderItem(itemType, item)
	        )
	      );
	    }
	  }]);
	  return SortableItemPreview;
	}(_react.Component), _class3.propTypes = {
	  currentOffset: _propTypes2.default.shape({
	    x: _propTypes2.default.number.isRequired,
	    y: _propTypes2.default.number.isRequired
	  }),
	  isDragging: _propTypes2.default.bool.isRequired,
	  item: _propTypes2.default.object,
	  itemType: _propTypes2.default.string
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'getLayerElement', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'getLayerElement'), _class2.prototype)), _class2)) || _class);
	exports.default = SortableItemPreview;
	module.exports = exports['default'];

/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	// import html5Backend from 'react-dnd-html5-backend';
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _components = __webpack_require__(15);
	
	var _reactDnd = __webpack_require__(472);
	
	var _reactDndTouchBackend = __webpack_require__(1656);
	
	var _reactDndTouchBackend2 = _interopRequireDefault(_reactDndTouchBackend);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SortableList = (_dec = (0, _reactDnd.DragDropContext)((0, _reactDndTouchBackend2.default)({ enableMouseEvents: true })), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(SortableList, _Component);
	
	  function SortableList() {
	    (0, _classCallCheck3.default)(this, SortableList);
	    return (0, _possibleConstructorReturn3.default)(this, (SortableList.__proto__ || (0, _getPrototypeOf2.default)(SortableList)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SortableList, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'pos-rel' },
	        _react2.default.createElement(
	          _components.List,
	          { className: className },
	          children
	        ),
	        _react2.default.createElement(_components.SortableItemPreview, null)
	      );
	    }
	  }]);
	  return SortableList;
	}(_react.Component), _class2.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  className: _propTypes2.default.string
	}, _temp)) || _class);
	exports.default = SortableList;
	module.exports = exports['default'];

/***/ }),
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(21);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(49);
	
	var _reactDnd = __webpack_require__(472);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(623);
	
	var cn = _bind2.default.bind(styles);
	
	var cardSource = {
	  beginDrag: function beginDrag(props) {
	    return {
	      id: props.id,
	      index: props.index,
	      children: props.children
	    };
	  },
	  endDrag: function endDrag(props) {
	    props.onDrop();
	  }
	};
	
	var cardTarget = {
	  hover: function hover(props, monitor, component) {
	    var dragIndex = monitor.getItem().index;
	    var hoverIndex = props.index;
	    // Don't replace items with themselves
	    if (dragIndex === hoverIndex) {
	      return;
	    }
	    // Determine rectangle on screen
	    var hoverBoundingRect = (0, _reactDom.findDOMNode)(component).getBoundingClientRect(); // eslint-disable-line react/no-find-dom-node
	    // Get vertical middle
	    var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
	    // Determine mouse position
	    var clientOffset = monitor.getClientOffset();
	    // Get pixels to the top
	    var hoverClientY = clientOffset.y - hoverBoundingRect.top;
	    // Only perform the move when the mouse has crossed half of the items height
	    // When dragging downwards, only move when the cursor is below 50%
	    // When dragging upwards, only move when the cursor is above 50%
	    // Dragging downwards
	    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
	      return;
	    }
	    // Dragging upwards
	    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
	      return;
	    }
	    // Time to actually perform the action
	    props.onMove(dragIndex, hoverIndex);
	    // Note: we're mutating the monitor item here!
	    // Generally it's better to avoid mutations,
	    // but it's good here for the sake of performance
	    // to avoid expensive index searches.
	    monitor.getItem().index = hoverIndex;
	  }
	};
	
	var SortableListItem = (_dec = (0, _reactDnd.DropTarget)('listItem', cardTarget, function (connect) {
	  return {
	    connectDropTarget: connect.dropTarget()
	  };
	}), _dec2 = (0, _reactDnd.DragSource)('listItem', cardSource, function (connect, monitor) {
	  return {
	    connectDragSource: connect.dragSource(),
	    connectDragPreview: connect.dragPreview(),
	    isDragging: monitor.isDragging()
	  };
	}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(SortableListItem, _Component);
	
	  function SortableListItem() {
	    (0, _classCallCheck3.default)(this, SortableListItem);
	    return (0, _possibleConstructorReturn3.default)(this, (SortableListItem.__proto__ || (0, _getPrototypeOf2.default)(SortableListItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SortableListItem, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          connectDragSource = _props.connectDragSource,
	          connectDropTarget = _props.connectDropTarget,
	          connectDragPreview = _props.connectDragPreview,
	          isDragging = _props.isDragging,
	          isTitle = _props.isTitle,
	          fullWidth = _props.fullWidth,
	          className = _props.className,
	          hideDragHandler = _props.hideDragHandler,
	          isLocked = _props.isLocked,
	          onMove = _props.onMove,
	          index = _props.index,
	          props = (0, _objectWithoutProperties3.default)(_props, ['children', 'connectDragSource', 'connectDropTarget', 'connectDragPreview', 'isDragging', 'isTitle', 'fullWidth', 'className', 'hideDragHandler', 'isLocked', 'onMove', 'index']); // eslint-disable-line no-unused-vars
	
	      var itemClass = cn(className, 'listItemRoot', { listItemTitle: isTitle, fullWidth: fullWidth, invisible: isDragging });
	
	      if (hideDragHandler) {
	        var node = _react2.default.createElement(
	          'li',
	          (0, _extends3.default)({ className: itemClass }, props),
	          children
	        );
	        return connectDropTarget(connectDragPreview(isLocked ? node : connectDragSource(node)));
	      }
	
	      return connectDropTarget(connectDragPreview(_react2.default.createElement(
	        'li',
	        (0, _extends3.default)({ className: itemClass }, props),
	        isLocked ? _react2.default.createElement('div', null) : connectDragSource(_react2.default.createElement(
	          'div',
	          { className: styles.dragHandler },
	          _react2.default.createElement('i', { className: 'icon-import-export' })
	        )),
	        children
	      )));
	    }
	  }]);
	  return SortableListItem;
	}(_react.Component), _class2.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  className: _propTypes2.default.string,
	  connectDragPreview: _propTypes2.default.func,
	  connectDragSource: _propTypes2.default.func,
	  connectDropTarget: _propTypes2.default.func,
	  fullWidth: _propTypes2.default.bool,
	  hideDragHandler: _propTypes2.default.bool,
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	  index: _propTypes2.default.number.isRequired,
	  isDragging: _propTypes2.default.bool,
	  isLocked: _propTypes2.default.bool,
	  isTitle: _propTypes2.default.bool,
	  onDrop: _propTypes2.default.func.isRequired,
	  onMove: _propTypes2.default.func.isRequired
	}, _temp)) || _class) || _class);
	exports.default = SortableListItem;
	module.exports = exports['default'];

/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1322);
	
	var Spectrum = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(Spectrum, _Component);
	
	  function Spectrum() {
	    (0, _classCallCheck3.default)(this, Spectrum);
	    return (0, _possibleConstructorReturn3.default)(this, (Spectrum.__proto__ || (0, _getPrototypeOf2.default)(Spectrum)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Spectrum, [{
	    key: 'render',
	    value: function render() {
	      var isActive = this.props.isActive;
	
	      var spectrumClass = (0, _bind2.default)(styles.spectrum, (0, _defineProperty3.default)({}, styles.active, isActive));
	
	      return _react2.default.createElement('i', { className: spectrumClass });
	    }
	  }]);
	  return Spectrum;
	}(_react.Component), _class.propTypes = {
	  isActive: _propTypes2.default.bool
	}, _temp);
	exports.default = Spectrum;
	module.exports = exports['default'];

/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _isEmpty2 = __webpack_require__(81);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _ChartWrapper = __webpack_require__(211);
	
	var _ChartWrapper2 = _interopRequireDefault(_ChartWrapper);
	
	var _chart = __webpack_require__(261);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var CoverageChart = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(CoverageChart, _PureComponent);
	
	  function CoverageChart() {
	    (0, _classCallCheck3.default)(this, CoverageChart);
	    return (0, _possibleConstructorReturn3.default)(this, (CoverageChart.__proto__ || (0, _getPrototypeOf2.default)(CoverageChart)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CoverageChart, [{
	    key: 'getChartData',
	    value: function getChartData() {
	      var data = this.props.data;
	      var t = this.context.t;
	
	      if ((0, _isEmpty3.default)(data)) {
	        return [];
	      }
	
	      return [[t('Stats'), t('Percents'), { role: 'annotation' }, { type: 'string', role: 'style' }], [t('Played'), data.played, data.played + '%', 'stroke-width: 100;'], [t('Downloaded'), data.downloads, data.downloads + '%', 'stroke-width: 100;']];
	    }
	  }, {
	    key: 'getChartProps',
	    value: function getChartProps() {
	      var id = this.props.id;
	
	      var data = this.getChartData();
	
	      return {
	        graphId: id,
	        chartType: 'BarChart',
	        data: data,
	        options: {
	          hAxis: {
	            minValue: -1,
	            baseline: -1,
	            maxValue: 100,
	            viewWindow: {
	              max: 100,
	              min: -1
	            }
	          },
	          chartArea: {
	            width: '65%',
	            left: '20%'
	          },
	          tooltip: { isHtml: false },
	          legend: {
	            position: _chart.chartLegendPosition.none
	          }
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          data = _props.data,
	          className = _props.className;
	
	      var loading = (0, _isEmpty3.default)(data);
	      var chartProps = this.getChartProps();
	
	      return _react2.default.createElement(_ChartWrapper2.default, {
	        className: className,
	        chartProps: chartProps,
	        itemHeight: 25,
	        showScale: true,
	        loading: loading
	      });
	    }
	  }]);
	  return CoverageChart;
	}(_react.PureComponent), _class2.propTypes = {
	  className: _propTypes2.default.string,
	  data: _propTypes2.default.object,
	  id: _propTypes2.default.string
	}, _class2.contextTypes = {
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  data: {},
	  id: 'coverageChart'
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'getChartData', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'getChartData'), _class.prototype)), _class);
	exports.default = CoverageChart;
	module.exports = exports['default'];

/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _ListItem = __webpack_require__(76);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _Link = __webpack_require__(82);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _StatisticsRecipientInfoTooltip = __webpack_require__(2126);
	
	var _StatisticsRecipientInfoTooltip2 = _interopRequireDefault(_StatisticsRecipientInfoTooltip);
	
	var _YesNoStatus = __webpack_require__(860);
	
	var _YesNoStatus2 = _interopRequireDefault(_YesNoStatus);
	
	var _RecipientShareLinkButton = __webpack_require__(848);
	
	var _RecipientShareLinkButton2 = _interopRequireDefault(_RecipientShareLinkButton);
	
	var _statistics = __webpack_require__(67);
	
	var _ExpiryDate = __webpack_require__(822);
	
	var _ExpiryDate2 = _interopRequireDefault(_ExpiryDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1324);
	
	var CoverageRecipientListItem = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(CoverageRecipientListItem, _PureComponent);
	
	  function CoverageRecipientListItem() {
	    (0, _classCallCheck3.default)(this, CoverageRecipientListItem);
	    return (0, _possibleConstructorReturn3.default)(this, (CoverageRecipientListItem.__proto__ || (0, _getPrototypeOf2.default)(CoverageRecipientListItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CoverageRecipientListItem, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          recipient = _props.recipient,
	          columns = _props.columns,
	          projectId = _props.projectId;
	      var t = this.context.t;
	
	
	      return _react2.default.createElement(
	        _ListItem2.default,
	        { className: (0, _bind2.default)(styles.row, className) },
	        columns.includes(_statistics.coverageRecipientsColumns.recipientId) && _react2.default.createElement(
	          'div',
	          null,
	          recipient.recipientId
	        ),
	        columns.includes(_statistics.coverageRecipientsColumns.fullName) && _react2.default.createElement(
	          'div',
	          null,
	          recipient.fullName
	        ),
	        columns.includes(_statistics.coverageRecipientsColumns.email) && _react2.default.createElement(
	          'div',
	          null,
	          recipient.email
	        ),
	        columns.includes(_statistics.coverageRecipientsColumns.downloaded) && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_YesNoStatus2.default, {
	            success: recipient.downloaded,
	            hasRights: recipient.downloadRights
	          })
	        ),
	        columns.includes(_statistics.coverageRecipientsColumns.expiryDate) && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_ExpiryDate2.default, { dateText: recipient.expiryDate, isExpired: recipient.isExpirySoon })
	        ),
	        columns.includes(_statistics.coverageRecipientsColumns.details) && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _Link2.default,
	            { to: '/statistics/project/' + projectId + '/recipient/' + recipient.recipientId },
	            t('details')
	          )
	        ),
	        columns.includes(_statistics.coverageRecipientsColumns.info) && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_StatisticsRecipientInfoTooltip2.default, {
	            className: styles.infoIcon,
	            recipient: recipient
	          })
	        ),
	        columns.includes(_statistics.coverageRecipientsColumns.share) && _react2.default.createElement(
	          'div',
	          { className: 'text-right' },
	          _react2.default.createElement(_RecipientShareLinkButton2.default, { recipientId: recipient.recipientId, projectId: projectId })
	        )
	      );
	    }
	  }]);
	  return CoverageRecipientListItem;
	}(_react.PureComponent), _class.propTypes = {
	  className: _propTypes2.default.string,
	  columns: _propTypes2.default.array,
	  projectId: _propTypes2.default.number,
	  recipient: _propTypes2.default.object
	}, _class.contextTypes = {
	  t: _propTypes2.default.func
	}, _class.defaultProps = {
	  columns: [],
	  recipient: {}
	}, _temp);
	exports.default = CoverageRecipientListItem;
	module.exports = exports['default'];

/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _ListItem = __webpack_require__(76);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _SortableListHeader = __webpack_require__(355);
	
	var _SortableListHeader2 = _interopRequireDefault(_SortableListHeader);
	
	var _statistics = __webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CoverageRecipientListHeader = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(CoverageRecipientListHeader, _PureComponent);
	
	  function CoverageRecipientListHeader() {
	    (0, _classCallCheck3.default)(this, CoverageRecipientListHeader);
	    return (0, _possibleConstructorReturn3.default)(this, (CoverageRecipientListHeader.__proto__ || (0, _getPrototypeOf2.default)(CoverageRecipientListHeader)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CoverageRecipientListHeader, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          order = _props.order,
	          activeOrder = _props.activeOrder,
	          onReorder = _props.onReorder,
	          className = _props.className,
	          columns = _props.columns;
	      var t = this.context.t;
	
	
	      return _react2.default.createElement(
	        _ListItem2.default,
	        { fullWidth: true, isTitle: true, className: (0, _bind2.default)(className) },
	        columns.includes(_statistics.coverageRecipientsColumns.recipientId) && _react2.default.createElement(_SortableListHeader2.default, {
	          title: t('ID'),
	          name: 'recipientId',
	          order: order,
	          activeOrder: activeOrder,
	          onReorder: onReorder
	        }),
	        columns.includes(_statistics.coverageRecipientsColumns.fullName) && _react2.default.createElement(_SortableListHeader2.default, {
	          title: t('Name'),
	          name: 'fullName',
	          order: order,
	          activeOrder: activeOrder,
	          onReorder: onReorder
	        }),
	        columns.includes(_statistics.coverageRecipientsColumns.email) && _react2.default.createElement(_SortableListHeader2.default, {
	          title: t('Email'),
	          name: 'email',
	          order: order,
	          activeOrder: activeOrder,
	          onReorder: onReorder
	        }),
	        columns.includes(_statistics.coverageRecipientsColumns.downloaded) && _react2.default.createElement(_SortableListHeader2.default, {
	          title: t('Downloaded'),
	          name: 'downloaded',
	          order: order,
	          activeOrder: activeOrder,
	          onReorder: onReorder
	        }),
	        columns.includes(_statistics.coverageRecipientsColumns.expiryDate) && _react2.default.createElement(_SortableListHeader2.default, {
	          title: t('Exp'),
	          name: 'recepEd',
	          order: order,
	          activeOrder: activeOrder,
	          onReorder: onReorder
	        }),
	        columns.includes(_statistics.coverageRecipientsColumns.details) && _react2.default.createElement('div', null),
	        columns.includes(_statistics.coverageRecipientsColumns.info) && _react2.default.createElement('div', null),
	        columns.includes(_statistics.coverageRecipientsColumns.share) && _react2.default.createElement('div', null)
	      );
	    }
	  }]);
	  return CoverageRecipientListHeader;
	}(_react.PureComponent), _class.propTypes = {
	  activeOrder: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  columns: _propTypes2.default.array,
	  onReorder: _propTypes2.default.func,
	  order: _propTypes2.default.object
	}, _class.contextTypes = {
	  onReorder: _noop3.default,
	  t: _propTypes2.default.func
	}, _class.defaultProps = {
	  columns: []
	}, _temp);
	exports.default = CoverageRecipientListHeader;
	module.exports = exports['default'];

/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _List = __webpack_require__(182);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _CoverageRecipientListItem = __webpack_require__(2109);
	
	var _CoverageRecipientListItem2 = _interopRequireDefault(_CoverageRecipientListItem);
	
	var _CoverageRecipientListHeader = __webpack_require__(2110);
	
	var _CoverageRecipientListHeader2 = _interopRequireDefault(_CoverageRecipientListHeader);
	
	var _statistics = __webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1325);
	
	var CoverageRecipientsList = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(CoverageRecipientsList, _PureComponent);
	
	  function CoverageRecipientsList() {
	    (0, _classCallCheck3.default)(this, CoverageRecipientsList);
	    return (0, _possibleConstructorReturn3.default)(this, (CoverageRecipientsList.__proto__ || (0, _getPrototypeOf2.default)(CoverageRecipientsList)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CoverageRecipientsList, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          recipients = _props.recipients,
	          columns = _props.columns,
	          activeOrder = _props.activeOrder,
	          order = _props.order,
	          onReorder = _props.onReorder,
	          projectId = _props.projectId;
	
	
	      return _react2.default.createElement(
	        _List2.default,
	        { className: (0, _bind2.default)(styles.list, className) },
	        _react2.default.createElement(_CoverageRecipientListHeader2.default, {
	          activeOrder: activeOrder,
	          order: order,
	          onReorder: onReorder,
	          columns: columns
	        }),
	        recipients.map(function (recipient) {
	          return _react2.default.createElement(_CoverageRecipientListItem2.default, {
	            key: recipient.recipientId,
	            recipient: recipient,
	            columns: columns,
	            projectId: projectId
	          });
	        })
	      );
	    }
	  }]);
	  return CoverageRecipientsList;
	}(_react.PureComponent), _class.propTypes = {
	  activeOrder: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  columns: _propTypes2.default.array,
	  onReorder: _propTypes2.default.func,
	  order: _propTypes2.default.object,
	  projectId: _propTypes2.default.number,
	  recipients: _propTypes2.default.array
	}, _class.contextTypes = {
	  t: _propTypes2.default.func
	}, _class.defaultProps = {
	  columns: _statistics.coverageRecipientsColumnsArray,
	  onReorder: _noop3.default,
	  recipients: []
	}, _temp);
	exports.default = CoverageRecipientsList;
	module.exports = exports['default'];

/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _toConsumableArray2 = __webpack_require__(34);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _ChartWrapper = __webpack_require__(211);
	
	var _ChartWrapper2 = _interopRequireDefault(_ChartWrapper);
	
	var _statistics = __webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var GeographyChart = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(GeographyChart, _PureComponent);
	
	  function GeographyChart() {
	    (0, _classCallCheck3.default)(this, GeographyChart);
	    return (0, _possibleConstructorReturn3.default)(this, (GeographyChart.__proto__ || (0, _getPrototypeOf2.default)(GeographyChart)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(GeographyChart, [{
	    key: 'getChartData',
	    value: function getChartData() {
	      var data = this.props.data.data;
	      var t = this.context.t;
	      var statName = this.props.statName;
	
	
	      return [[t('Country'), statName || t('Plays')]].concat((0, _toConsumableArray3.default)(data), [
	      // should be at least one country with non zero value to fix google charts bug
	      // with empty tooltips and blue coloring for all countries
	      ['notExistingCountry', 1]]);
	    }
	  }, {
	    key: 'getChartProps',
	    value: function getChartProps() {
	      var _props = this.props,
	          id = _props.id,
	          displayMode = _props.displayMode;
	
	      var data = this.getChartData();
	
	      return {
	        graphId: id,
	        chartType: 'GeoChart',
	        data: data,
	        options: {
	          displayMode: displayMode,
	          sizeAxis: {
	            minValue: 2,
	            maxSize: 6,
	            minSize: 2
	          }
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var loading = this.props.loading;
	
	      var chartProps = this.getChartProps();
	
	      return _react2.default.createElement(_ChartWrapper2.default, {
	        chartProps: chartProps,
	        height: 460,
	        loading: loading
	      });
	    }
	  }]);
	  return GeographyChart;
	}(_react.PureComponent), _class2.propTypes = {
	  data: _propTypes2.default.object,
	  displayMode: _propTypes2.default.oneOf(['auto', 'regions', 'markers', 'text']),
	  id: _propTypes2.default.string,
	  loading: _propTypes2.default.bool,
	  statName: _propTypes2.default.string
	}, _class2.contextTypes = {
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  data: _statistics.defaultChartData,
	  displayMode: 'regions',
	  id: 'geographyChart'
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'getChartData', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'getChartData'), _class.prototype)), _class);
	exports.default = GeographyChart;
	module.exports = exports['default'];

/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _GeographyChart = __webpack_require__(2112);
	
	var _GeographyChart2 = _interopRequireDefault(_GeographyChart);
	
	var _FilterButton = __webpack_require__(349);
	
	var _FilterButton2 = _interopRequireDefault(_FilterButton);
	
	var _statistics = __webpack_require__(67);
	
	var _Checkbox = __webpack_require__(180);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1326);
	
	var CHART_TYPE = {
	  plays: 'plays',
	  downloads: 'downloads'
	};
	
	var DISPLAY_TYPE = {
	  markers: 'markers',
	  regions: 'regions'
	};
	
	var GeographyChartTypeWrapper = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(GeographyChartTypeWrapper, _PureComponent);
	
	  function GeographyChartTypeWrapper() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, GeographyChartTypeWrapper);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = GeographyChartTypeWrapper.__proto__ || (0, _getPrototypeOf2.default)(GeographyChartTypeWrapper)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { chartType: CHART_TYPE.plays, displayMarkers: false };
	    return _this;
	  }
	
	  (0, _createClass3.default)(GeographyChartTypeWrapper, [{
	    key: 'getData',
	    value: function getData() {
	      var _props = this.props,
	          countriesDownloadsData = _props.countriesDownloadsData,
	          countriesPlaysData = _props.countriesPlaysData,
	          citiesDownloadsData = _props.citiesDownloadsData,
	          citiesPlaysData = _props.citiesPlaysData;
	      var _state = this.state,
	          chartType = _state.chartType,
	          displayMarkers = _state.displayMarkers;
	
	      return chartType === CHART_TYPE.plays ? displayMarkers ? citiesPlaysData : countriesPlaysData : displayMarkers ? citiesDownloadsData : countriesDownloadsData;
	    }
	  }, {
	    key: 'togglePlays',
	    value: function togglePlays() {
	      this.setState({ chartType: CHART_TYPE.plays });
	    }
	  }, {
	    key: 'toggleDownloads',
	    value: function toggleDownloads() {
	      this.setState({ chartType: CHART_TYPE.downloads });
	    }
	  }, {
	    key: 'toggleDisplayMode',
	    value: function toggleDisplayMode() {
	      this.setState({ displayMarkers: !this.state.displayMarkers });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          loading = _props2.loading,
	          id = _props2.id;
	      var t = this.context.t;
	      var _state2 = this.state,
	          chartType = _state2.chartType,
	          displayMarkers = _state2.displayMarkers;
	
	      var statName = chartType === CHART_TYPE.plays ? t('Plays') : t('Downloads');
	      var displayMode = displayMarkers ? DISPLAY_TYPE.markers : DISPLAY_TYPE.regions;
	      var data = this.getData();
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_GeographyChart2.default, {
	          data: data,
	          statName: statName,
	          loading: loading,
	          id: id,
	          displayMode: displayMode
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: styles.buttons },
	          _react2.default.createElement(
	            'div',
	            { className: styles.toggler },
	            _react2.default.createElement(_FilterButton2.default, {
	              onClick: this.togglePlays,
	              title: t('Number of plays'),
	              isActive: chartType === CHART_TYPE.plays,
	              responsive: false
	            }),
	            _react2.default.createElement(_FilterButton2.default, {
	              onClick: this.toggleDownloads,
	              title: t('Number of downloads'),
	              isActive: chartType === CHART_TYPE.downloads,
	              responsive: false
	            })
	          ),
	          _react2.default.createElement(_Checkbox2.default, {
	            className: styles.citiesCheckbox,
	            small: true,
	            checked: displayMarkers,
	            onClick: this.toggleDisplayMode,
	            textAfter: t('Show cities')
	          })
	        )
	      );
	    }
	  }]);
	  return GeographyChartTypeWrapper;
	}(_react.PureComponent), _class2.propTypes = {
	  citiesDownloadsData: _propTypes2.default.object,
	  citiesPlaysData: _propTypes2.default.object,
	  countriesDownloadsData: _propTypes2.default.object,
	  countriesPlaysData: _propTypes2.default.object,
	  id: _propTypes2.default.string,
	  loading: _propTypes2.default.bool
	}, _class2.contextTypes = {
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  citiesDownloadsData: _statistics.defaultChartData,
	  citiesPlaysData: _statistics.defaultChartData,
	  countriesDownloadsData: _statistics.defaultChartData,
	  countriesPlaysData: _statistics.defaultChartData
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'togglePlays', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'togglePlays'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'toggleDownloads', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'toggleDownloads'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'toggleDisplayMode', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'toggleDisplayMode'), _class.prototype)), _class);
	exports.default = GeographyChartTypeWrapper;
	module.exports = exports['default'];

/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(34);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _chart = __webpack_require__(261);
	
	var _ChartWrapper = __webpack_require__(211);
	
	var _ChartWrapper2 = _interopRequireDefault(_ChartWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var PlayStatsColumnChart = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(PlayStatsColumnChart, _PureComponent);
	
	  function PlayStatsColumnChart() {
	    (0, _classCallCheck3.default)(this, PlayStatsColumnChart);
	    return (0, _possibleConstructorReturn3.default)(this, (PlayStatsColumnChart.__proto__ || (0, _getPrototypeOf2.default)(PlayStatsColumnChart)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PlayStatsColumnChart, [{
	    key: 'getChartData',
	    value: function getChartData() {
	      var data = this.props.data;
	      var t = this.context.t;
	
	      var styleColumn = { type: 'string', role: 'style' };
	      var columnStyle = 'stroke-width: 100;';
	
	      return [[t('Date'), t('Plays'), styleColumn, t('Downloads'), styleColumn]].concat((0, _toConsumableArray3.default)((0, _chart.getDataArray)({
	        data: data,
	        keyName: 'date',
	        valueName: function valueName(current) {
	          return [current.plays, columnStyle, current.downloads, columnStyle];
	        }
	      })));
	    }
	  }, {
	    key: 'getChartProps',
	    value: function getChartProps() {
	      var _props = this.props,
	          id = _props.id,
	          daysCount = _props.daysCount,
	          chartOptions = _props.chartOptions;
	      var t = this.context.t;
	
	      var data = this.getChartData();
	
	      return {
	        graphId: id,
	        chartType: 'ColumnChart',
	        data: data,
	        options: (0, _extends3.default)({
	          bar: {
	            groupWidth: daysCount === 1 ? 100 : undefined
	          },
	          chartArea: {
	            width: 'auto',
	            top: 10,
	            left: 'auto'
	          },
	          hAxis: {
	            title: t('Date'),
	            format: _chart.chartDateFormat.monthStr,
	            gridlines: {
	              count: daysCount + 2,
	              units: {
	                milliseconds: { format: [_chart.chartDateFormat.monthStr] }
	              }
	            },
	            minorGridlines: {
	              count: 0,
	              color: '#fff'
	            },
	            ticks: daysCount === 1 ? [data[1][0]] : undefined
	          },
	          vAxis: {
	            title: t('Number of recipients'),
	            format: '#',
	            baseline: -0.05,
	            minValue: 2,
	            viewWindow: {
	              min: -0.05
	            }
	          }
	        }, chartOptions),
	        dateFormat: {
	          columns: [0],
	          options: {
	            pattern: _chart.chartDateFormat.date
	          }
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          height = _props2.height,
	          loading = _props2.loading;
	
	      var chartProps = this.getChartProps();
	
	      return _react2.default.createElement(_ChartWrapper2.default, {
	        height: height,
	        showScale: true,
	        scaleHeight: 50,
	        chartProps: chartProps,
	        loading: loading
	      });
	    }
	  }]);
	  return PlayStatsColumnChart;
	}(_react.PureComponent), _class2.propTypes = {
	  chartOptions: _propTypes2.default.object,
	  data: _propTypes2.default.array,
	  daysCount: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  id: _propTypes2.default.string,
	  loading: _propTypes2.default.bool
	}, _class2.contextTypes = {
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  chartOptions: {},
	  data: [],
	  height: 400,
	  id: 'playStatsColumnChart'
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'getChartData', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'getChartData'), _class.prototype)), _class);
	exports.default = PlayStatsColumnChart;
	module.exports = exports['default'];

/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(34);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _chart = __webpack_require__(261);
	
	var _ChartWrapper = __webpack_require__(211);
	
	var _ChartWrapper2 = _interopRequireDefault(_ChartWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var PlayStatsLineChart = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(PlayStatsLineChart, _PureComponent);
	
	  function PlayStatsLineChart() {
	    (0, _classCallCheck3.default)(this, PlayStatsLineChart);
	    return (0, _possibleConstructorReturn3.default)(this, (PlayStatsLineChart.__proto__ || (0, _getPrototypeOf2.default)(PlayStatsLineChart)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PlayStatsLineChart, [{
	    key: 'getChartData',
	    value: function getChartData() {
	      var data = this.props.data;
	      var t = this.context.t;
	
	
	      return [[t('Date'), t('Plays'), t('Downloads')]].concat((0, _toConsumableArray3.default)((0, _chart.getDataArray)({
	        data: data,
	        keyName: 'date',
	        valueName: function valueName(current) {
	          return [current.plays, current.downloads];
	        }
	      })));
	    }
	  }, {
	    key: 'getChartProps',
	    value: function getChartProps() {
	      var _props = this.props,
	          id = _props.id,
	          chartOptions = _props.chartOptions;
	      var t = this.context.t;
	
	      var data = this.getChartData();
	
	      return {
	        graphId: id,
	        chartType: 'LineChart',
	        data: data,
	        options: (0, _extends3.default)({
	          pointSize: 5,
	          curveType: 'none', //'function',
	          chartArea: {
	            width: 'auto',
	            top: 10,
	            left: 'auto'
	          },
	          hAxis: {
	            title: t('Date'),
	            format: _chart.chartDateFormat.monthStr
	          },
	          vAxis: {
	            title: t('Number of recipients'),
	            format: '#',
	            minValue: 2,
	            viewWindow: {
	              min: -0.05
	            }
	          }
	        }, chartOptions),
	        dateFormat: {
	          columns: [0],
	          options: {
	            pattern: _chart.chartDateFormat.date
	          }
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          height = _props2.height,
	          loading = _props2.loading;
	
	      var chartProps = this.getChartProps();
	
	      return _react2.default.createElement(_ChartWrapper2.default, {
	        height: height,
	        showScale: true,
	        scaleHeight: 50,
	        chartProps: chartProps,
	        loading: loading
	      });
	    }
	  }]);
	  return PlayStatsLineChart;
	}(_react.PureComponent), _class2.propTypes = {
	  chartOptions: _propTypes2.default.object,
	  data: _propTypes2.default.array,
	  height: _propTypes2.default.number,
	  id: _propTypes2.default.string,
	  loading: _propTypes2.default.bool
	}, _class2.contextTypes = {
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  chartOptions: {},
	  data: [],
	  height: 400,
	  id: 'playStatsLineChart'
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'getChartData', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'getChartData'), _class.prototype)), _class);
	exports.default = PlayStatsLineChart;
	module.exports = exports['default'];

/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _List = __webpack_require__(182);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _RecipientDetailedStatsListHeader = __webpack_require__(2117);
	
	var _RecipientDetailedStatsListHeader2 = _interopRequireDefault(_RecipientDetailedStatsListHeader);
	
	var _RecipientDetailedStatsListItem = __webpack_require__(2118);
	
	var _RecipientDetailedStatsListItem2 = _interopRequireDefault(_RecipientDetailedStatsListItem);
	
	var _statistics = __webpack_require__(67);
	
	var _Loader = __webpack_require__(60);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(628);
	
	var RecipientDetailedStatsList = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(RecipientDetailedStatsList, _PureComponent);
	
	  function RecipientDetailedStatsList() {
	    (0, _classCallCheck3.default)(this, RecipientDetailedStatsList);
	    return (0, _possibleConstructorReturn3.default)(this, (RecipientDetailedStatsList.__proto__ || (0, _getPrototypeOf2.default)(RecipientDetailedStatsList)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(RecipientDetailedStatsList, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          loading = _props.loading,
	          _props$data = _props.data,
	          tracks = _props$data.tracks,
	          timings = _props$data.timings;
	
	
	      if (loading) {
	        return _react2.default.createElement(_Loader2.default, { show: loading, alignCenter: true });
	      }
	
	      return _react2.default.createElement(
	        _List2.default,
	        { className: (0, _bind2.default)(styles.list, className) },
	        _react2.default.createElement(_RecipientDetailedStatsListHeader2.default, null),
	        timings.map(function (stat) {
	          return _react2.default.createElement(_RecipientDetailedStatsListItem2.default, {
	            key: stat.uuid,
	            data: stat,
	            track: tracks[stat.trackId]
	          });
	        })
	      );
	    }
	  }]);
	  return RecipientDetailedStatsList;
	}(_react.PureComponent), _class.propTypes = {
	  className: _propTypes2.default.string,
	  data: _propTypes2.default.object,
	  loading: _propTypes2.default.bool
	}, _class.defaultProps = {
	  data: _statistics.defaultDetailedData,
	  loading: false
	}, _temp);
	exports.default = RecipientDetailedStatsList;
	module.exports = exports['default'];

/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _ListItem = __webpack_require__(76);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RecipientDetailedStatsListHeader = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(RecipientDetailedStatsListHeader, _PureComponent);
	
	  function RecipientDetailedStatsListHeader() {
	    (0, _classCallCheck3.default)(this, RecipientDetailedStatsListHeader);
	    return (0, _possibleConstructorReturn3.default)(this, (RecipientDetailedStatsListHeader.__proto__ || (0, _getPrototypeOf2.default)(RecipientDetailedStatsListHeader)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(RecipientDetailedStatsListHeader, [{
	    key: 'render',
	    value: function render() {
	      var className = this.props.className;
	      var t = this.context.t;
	
	
	      return _react2.default.createElement(
	        _ListItem2.default,
	        { fullWidth: true, isTitle: true, className: (0, _bind2.default)(className) },
	        _react2.default.createElement(
	          'div',
	          null,
	          t('Track')
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          t('Listening Duration')
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          t('Time')
	        )
	      );
	    }
	  }]);
	  return RecipientDetailedStatsListHeader;
	}(_react.PureComponent), _class.propTypes = {
	  className: _propTypes2.default.string
	}, _class.contextTypes = {
	  t: _propTypes2.default.func
	}, _temp);
	exports.default = RecipientDetailedStatsListHeader;
	module.exports = exports['default'];

/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _ListItem = __webpack_require__(76);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(628);
	
	var RecipientDetailedStatsListItem = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(RecipientDetailedStatsListItem, _PureComponent);
	
	  function RecipientDetailedStatsListItem() {
	    (0, _classCallCheck3.default)(this, RecipientDetailedStatsListItem);
	    return (0, _possibleConstructorReturn3.default)(this, (RecipientDetailedStatsListItem.__proto__ || (0, _getPrototypeOf2.default)(RecipientDetailedStatsListItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(RecipientDetailedStatsListItem, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          data = _props.data,
	          track = _props.track;
	
	
	      return _react2.default.createElement(
	        _ListItem2.default,
	        { className: (0, _bind2.default)(styles.row, className) },
	        _react2.default.createElement(
	          'div',
	          null,
	          track.fullName
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          data.durationString
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          data.dateString
	        )
	      );
	    }
	  }]);
	  return RecipientDetailedStatsListItem;
	}(_react.PureComponent), _class.propTypes = {
	  className: _propTypes2.default.string,
	  data: _propTypes2.default.object,
	  track: _propTypes2.default.object
	}, _class.defaultProps = {
	  data: {},
	  track: {}
	}, _temp);
	exports.default = RecipientDetailedStatsListItem;
	module.exports = exports['default'];

/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SortableListHeader = __webpack_require__(355);
	
	var _SortableListHeader2 = _interopRequireDefault(_SortableListHeader);
	
	var _ListItem = __webpack_require__(76);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RecipientProjectsListHeader = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(RecipientProjectsListHeader, _PureComponent);
	
	  function RecipientProjectsListHeader() {
	    (0, _classCallCheck3.default)(this, RecipientProjectsListHeader);
	    return (0, _possibleConstructorReturn3.default)(this, (RecipientProjectsListHeader.__proto__ || (0, _getPrototypeOf2.default)(RecipientProjectsListHeader)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(RecipientProjectsListHeader, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          order = _props.order,
	          activeOrder = _props.activeOrder,
	          onReorder = _props.onReorder,
	          showShare = _props.showShare;
	      var t = this.context.t;
	
	
	      return _react2.default.createElement(
	        _ListItem2.default,
	        { fullWidth: true, isTitle: true },
	        _react2.default.createElement(_SortableListHeader2.default, {
	          title: t('ID'),
	          name: 'id',
	          order: order,
	          activeOrder: activeOrder,
	          onReorder: onReorder
	        }),
	        _react2.default.createElement(_SortableListHeader2.default, {
	          title: t('Artist/Title'),
	          name: 'fullTitle',
	          order: order,
	          activeOrder: activeOrder,
	          onReorder: onReorder
	        }),
	        _react2.default.createElement(_SortableListHeader2.default, {
	          title: t('Played'),
	          name: 'played',
	          order: order,
	          activeOrder: activeOrder,
	          onReorder: onReorder
	        }),
	        _react2.default.createElement(_SortableListHeader2.default, {
	          title: t('Downloaded'),
	          name: 'downloaded',
	          order: order,
	          activeOrder: activeOrder,
	          onReorder: onReorder
	        }),
	        _react2.default.createElement(_SortableListHeader2.default, {
	          title: t('Exp'),
	          name: 'expiryDate',
	          order: order,
	          activeOrder: activeOrder,
	          onReorder: onReorder
	        }),
	        showShare && _react2.default.createElement('div', null)
	      );
	    }
	  }]);
	  return RecipientProjectsListHeader;
	}(_react.PureComponent), _class.propTypes = {
	  activeOrder: _propTypes2.default.string,
	  onReorder: _propTypes2.default.func,
	  order: _propTypes2.default.object,
	  showShare: _propTypes2.default.bool
	}, _class.defaultProps = {
	  showShare: false
	}, _class.contextTypes = {
	  onReorder: _noop3.default,
	  t: _propTypes2.default.func
	}, _temp);
	exports.default = RecipientProjectsListHeader;
	module.exports = exports['default'];

/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _ListItem = __webpack_require__(76);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _YesNoStatus = __webpack_require__(860);
	
	var _YesNoStatus2 = _interopRequireDefault(_YesNoStatus);
	
	var _RecipientShareLinkButton = __webpack_require__(848);
	
	var _RecipientShareLinkButton2 = _interopRequireDefault(_RecipientShareLinkButton);
	
	var _ExpiryDate = __webpack_require__(822);
	
	var _ExpiryDate2 = _interopRequireDefault(_ExpiryDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1327);
	
	var RecipientProjectsListItem = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(RecipientProjectsListItem, _PureComponent);
	
	  function RecipientProjectsListItem() {
	    (0, _classCallCheck3.default)(this, RecipientProjectsListItem);
	    return (0, _possibleConstructorReturn3.default)(this, (RecipientProjectsListItem.__proto__ || (0, _getPrototypeOf2.default)(RecipientProjectsListItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(RecipientProjectsListItem, [{
	    key: 'onClick',
	    value: function onClick() {
	      var _props = this.props,
	          project = _props.project,
	          onClick = _props.onClick;
	
	      onClick(project);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          project = _props2.project,
	          recipientId = _props2.recipientId,
	          showShare = _props2.showShare;
	
	
	      return _react2.default.createElement(
	        _ListItem2.default,
	        { fullWidth: true, className: (0, _bind2.default)('cursor-pointer', className), onClick: this.onClick },
	        _react2.default.createElement(
	          'div',
	          null,
	          project.id
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          project.fullTitle
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_YesNoStatus2.default, { success: !!project.played, hasRights: true })
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_YesNoStatus2.default, { success: !!project.downloaded, hasRights: !!project.download })
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_ExpiryDate2.default, { dateText: project.expiryDateText, isExpired: project.isExpired })
	        ),
	        showShare && _react2.default.createElement(
	          'div',
	          { className: styles.shareButtonCell },
	          _react2.default.createElement(_RecipientShareLinkButton2.default, { className: styles.shareButton, recipientId: recipientId, projectId: project.id })
	        )
	      );
	    }
	  }]);
	  return RecipientProjectsListItem;
	}(_react.PureComponent), _class2.propTypes = {
	  className: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  project: _propTypes2.default.object,
	  recipientId: _propTypes2.default.number,
	  showShare: _propTypes2.default.bool
	}, _class2.contextTypes = {
	  push: _propTypes2.default.func,
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  project: {},
	  showShare: false
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onClick'), _class.prototype)), _class);
	exports.default = RecipientProjectsListItem;
	module.exports = exports['default'];

/***/ }),
/* 2121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _SimpleTab = __webpack_require__(518);
	
	var _SimpleTab2 = _interopRequireDefault(_SimpleTab);
	
	var _statistics = __webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var RecipientStatisticsTabs = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(RecipientStatisticsTabs, _PureComponent);
	
	  function RecipientStatisticsTabs() {
	    (0, _classCallCheck3.default)(this, RecipientStatisticsTabs);
	    return (0, _possibleConstructorReturn3.default)(this, (RecipientStatisticsTabs.__proto__ || (0, _getPrototypeOf2.default)(RecipientStatisticsTabs)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(RecipientStatisticsTabs, [{
	    key: 'selectInfo',
	    value: function selectInfo() {
	      this.props.onClick(_statistics.recipientTabs.info);
	    }
	  }, {
	    key: 'selectDetailed',
	    value: function selectDetailed() {
	      this.props.onClick(_statistics.recipientTabs.detailed);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          activeTab = _props.activeTab,
	          tabClass = _props.tabClass;
	      var t = this.context.t;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        _react2.default.createElement(_SimpleTab2.default, {
	          className: tabClass,
	          title: t('File info'),
	          onClick: this.selectInfo,
	          active: activeTab === _statistics.recipientTabs.info
	        }),
	        _react2.default.createElement(_SimpleTab2.default, {
	          className: tabClass,
	          title: t('Detailed action'),
	          onClick: this.selectDetailed,
	          active: activeTab === _statistics.recipientTabs.detailed
	        })
	      );
	    }
	  }]);
	  return RecipientStatisticsTabs;
	}(_react.PureComponent), _class2.propTypes = {
	  activeTab: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  tabClass: _propTypes2.default.string
	}, _class2.contextTypes = {
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  activeTab: _statistics.recipientTabs.info,
	  onClick: _noop3.default
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'selectInfo', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'selectInfo'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'selectDetailed', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'selectDetailed'), _class.prototype)), _class);
	exports.default = RecipientStatisticsTabs;
	module.exports = exports['default'];

/***/ }),
/* 2122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _StatisticsCoverageTabs = __webpack_require__(2123);
	
	var _StatisticsCoverageTabs2 = _interopRequireDefault(_StatisticsCoverageTabs);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _statistics = __webpack_require__(67);
	
	var _CoverageChart = __webpack_require__(2108);
	
	var _CoverageChart2 = _interopRequireDefault(_CoverageChart);
	
	var _CoverageRecipientsListWrapper = __webpack_require__(2210);
	
	var _CoverageRecipientsListWrapper2 = _interopRequireDefault(_CoverageRecipientsListWrapper);
	
	var _SimpleTabContent = __webpack_require__(846);
	
	var _SimpleTabContent2 = _interopRequireDefault(_SimpleTabContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1328);
	
	var notAccessedListColumns = [_statistics.coverageRecipientsColumns.recipientId, _statistics.coverageRecipientsColumns.fullName, _statistics.coverageRecipientsColumns.email, _statistics.coverageRecipientsColumns.expiryDate];
	
	var playedListColumns = [_statistics.coverageRecipientsColumns.fullName, _statistics.coverageRecipientsColumns.email, _statistics.coverageRecipientsColumns.downloaded, _statistics.coverageRecipientsColumns.expiryDate, _statistics.coverageRecipientsColumns.details, _statistics.coverageRecipientsColumns.info];
	
	var StatisticsCoverage = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(StatisticsCoverage, _PureComponent);
	
	  function StatisticsCoverage() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, StatisticsCoverage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = StatisticsCoverage.__proto__ || (0, _getPrototypeOf2.default)(StatisticsCoverage)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { activeTab: _statistics.coverageTabs.played };
	    return _this;
	  }
	
	  (0, _createClass3.default)(StatisticsCoverage, [{
	    key: 'onTabClick',
	    value: function onTabClick(tab) {
	      this.setState({ activeTab: tab });
	      this.props.onTabClick(tab);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          id = _props.id,
	          data = _props.data,
	          loading = _props.loading,
	          projectId = _props.projectId;
	      var activeTab = this.state.activeTab;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(className) },
	        _react2.default.createElement(_StatisticsCoverageTabs2.default, {
	          activeTab: activeTab,
	          tabClass: styles.tab,
	          onClick: this.onTabClick
	        }),
	        _react2.default.createElement(
	          _SimpleTabContent2.default,
	          null,
	          activeTab === _statistics.coverageTabs.played && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_CoverageChart2.default, {
	              className: styles.chart,
	              id: id,
	              data: data.stats
	            }),
	            _react2.default.createElement(_CoverageRecipientsListWrapper2.default, {
	              className: 'margin-top-20',
	              recipients: data.playedRecipients,
	              columns: playedListColumns,
	              loading: loading,
	              projectId: projectId
	            })
	          ),
	          activeTab === _statistics.coverageTabs.notAccessed && _react2.default.createElement(_CoverageRecipientsListWrapper2.default, {
	            recipients: data.notAccessedRecipients,
	            columns: notAccessedListColumns,
	            loading: loading,
	            showLoader: true,
	            projectId: projectId
	          })
	        )
	      );
	    }
	  }]);
	  return StatisticsCoverage;
	}(_react.PureComponent), _class2.propTypes = {
	  className: _propTypes2.default.string,
	  data: _propTypes2.default.object,
	  id: _propTypes2.default.string,
	  loading: _propTypes2.default.bool,
	  onTabClick: _propTypes2.default.func,
	  projectId: _propTypes2.default.number
	}, _class2.contextTypes = {
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  data: {},
	  onTabClick: _noop3.default
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onTabClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onTabClick'), _class.prototype)), _class);
	exports.default = StatisticsCoverage;
	module.exports = exports['default'];

/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _SimpleTab = __webpack_require__(518);
	
	var _SimpleTab2 = _interopRequireDefault(_SimpleTab);
	
	var _statistics = __webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var StatisticsCoverageTabs = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(StatisticsCoverageTabs, _PureComponent);
	
	  function StatisticsCoverageTabs() {
	    (0, _classCallCheck3.default)(this, StatisticsCoverageTabs);
	    return (0, _possibleConstructorReturn3.default)(this, (StatisticsCoverageTabs.__proto__ || (0, _getPrototypeOf2.default)(StatisticsCoverageTabs)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(StatisticsCoverageTabs, [{
	    key: 'selectPlayed',
	    value: function selectPlayed() {
	      this.props.onClick(_statistics.coverageTabs.played);
	    }
	  }, {
	    key: 'selectNotAccessed',
	    value: function selectNotAccessed() {
	      this.props.onClick(_statistics.coverageTabs.notAccessed);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          activeTab = _props.activeTab,
	          tabClass = _props.tabClass;
	      var t = this.context.t;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        _react2.default.createElement(_SimpleTab2.default, {
	          className: tabClass,
	          title: t('Played'),
	          onClick: this.selectPlayed,
	          active: activeTab === _statistics.coverageTabs.played
	        }),
	        _react2.default.createElement(_SimpleTab2.default, {
	          className: tabClass,
	          title: t('Not accessed'),
	          onClick: this.selectNotAccessed,
	          active: activeTab === _statistics.coverageTabs.notAccessed
	        })
	      );
	    }
	  }]);
	  return StatisticsCoverageTabs;
	}(_react.PureComponent), _class2.propTypes = {
	  activeTab: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  tabClass: _propTypes2.default.string
	}, _class2.contextTypes = {
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  activeTab: _statistics.coverageTabs.played,
	  onClick: _noop3.default
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'selectPlayed', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'selectPlayed'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'selectNotAccessed', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'selectNotAccessed'), _class.prototype)), _class);
	exports.default = StatisticsCoverageTabs;
	module.exports = exports['default'];

/***/ }),
/* 2124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _FilterButton = __webpack_require__(349);
	
	var _FilterButton2 = _interopRequireDefault(_FilterButton);
	
	var _statistics = __webpack_require__(57);
	
	var statisticsActions = _interopRequireWildcard(_statistics);
	
	var _statistics2 = __webpack_require__(67);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1330);
	
	var StatisticsPeriod = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    periodName: state.statistics.periodName
	  };
	}, (0, _extends3.default)({}, statisticsActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(StatisticsPeriod, _Component);
	
	  function StatisticsPeriod() {
	    (0, _classCallCheck3.default)(this, StatisticsPeriod);
	    return (0, _possibleConstructorReturn3.default)(this, (StatisticsPeriod.__proto__ || (0, _getPrototypeOf2.default)(StatisticsPeriod)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(StatisticsPeriod, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var periodName = this.props.periodName;
	
	      if (!periodName) {
	        this.setPeriodWeek();
	      }
	    }
	  }, {
	    key: 'setPeriodWeek',
	    value: function setPeriodWeek() {
	      this.props.setPeriod({ periodName: _statistics2.reportPeriods.week });
	    }
	  }, {
	    key: 'setPeriodMonth',
	    value: function setPeriodMonth() {
	      this.props.setPeriod({ periodName: _statistics2.reportPeriods.month });
	    }
	  }, {
	    key: 'setPeriodCustom',
	    value: function setPeriodCustom() {
	      this.props.setPeriodName({ periodName: _statistics2.reportPeriods.custom });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          periodName = _props.periodName;
	      var t = this.context.t;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(styles.periodContainer, className) },
	        _react2.default.createElement(_FilterButton2.default, {
	          onClick: this.setPeriodWeek,
	          title: t('Last week'),
	          isActive: periodName === _statistics2.reportPeriods.week,
	          responsive: false
	        }),
	        _react2.default.createElement(_FilterButton2.default, {
	          onClick: this.setPeriodMonth,
	          title: t('Last month'),
	          isActive: periodName === _statistics2.reportPeriods.month,
	          responsive: false
	        }),
	        _react2.default.createElement(_FilterButton2.default, {
	          onClick: this.setPeriodCustom,
	          title: t('Custom'),
	          isActive: periodName === _statistics2.reportPeriods.custom,
	          responsive: false
	        })
	      );
	    }
	  }]);
	  return StatisticsPeriod;
	}(_react.Component), _class3.propTypes = {
	  className: _propTypes2.default.string,
	  periodName: _propTypes2.default.string,
	  setPeriod: _propTypes2.default.func,
	  setPeriodName: _propTypes2.default.func
	}, _class3.contextTypes = {
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'setPeriodWeek', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setPeriodWeek'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setPeriodMonth', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setPeriodMonth'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setPeriodCustom', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setPeriodCustom'), _class2.prototype)), _class2)) || _class);
	exports.default = StatisticsPeriod;
	module.exports = exports['default'];

/***/ }),
/* 2125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _SimpleTab = __webpack_require__(518);
	
	var _SimpleTab2 = _interopRequireDefault(_SimpleTab);
	
	var _statistics = __webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var StatisticsProjectsListTabs = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(StatisticsProjectsListTabs, _PureComponent);
	
	  function StatisticsProjectsListTabs() {
	    (0, _classCallCheck3.default)(this, StatisticsProjectsListTabs);
	    return (0, _possibleConstructorReturn3.default)(this, (StatisticsProjectsListTabs.__proto__ || (0, _getPrototypeOf2.default)(StatisticsProjectsListTabs)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(StatisticsProjectsListTabs, [{
	    key: 'selectMy',
	    value: function selectMy() {
	      this.props.onClick(_statistics.projectTabs.my);
	    }
	  }, {
	    key: 'selectAvailable',
	    value: function selectAvailable() {
	      this.props.onClick(_statistics.projectTabs.available);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          activeProjectsTab = _props.activeProjectsTab;
	      var t = this.context.t;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        _react2.default.createElement(_SimpleTab2.default, {
	          title: t('My Projects'),
	          onClick: this.selectMy,
	          active: activeProjectsTab === _statistics.projectTabs.my
	        }),
	        _react2.default.createElement(_SimpleTab2.default, {
	          title: t('Available to me'),
	          onClick: this.selectAvailable,
	          active: activeProjectsTab === _statistics.projectTabs.available
	        })
	      );
	    }
	  }]);
	  return StatisticsProjectsListTabs;
	}(_react.PureComponent), _class2.propTypes = {
	  activeProjectsTab: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  onClick: _propTypes2.default.func
	}, _class2.contextTypes = {
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  activeProjectsTab: _statistics.projectTabs.my,
	  onClick: _noop3.default
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'selectMy', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'selectMy'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'selectAvailable', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'selectAvailable'), _class.prototype)), _class);
	exports.default = StatisticsProjectsListTabs;
	module.exports = exports['default'];

/***/ }),
/* 2126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _Popover = __webpack_require__(831);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1331);
	
	var StatisticsRecipientInfoTooltip = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(StatisticsRecipientInfoTooltip, _PureComponent);
	
	  function StatisticsRecipientInfoTooltip() {
	    (0, _classCallCheck3.default)(this, StatisticsRecipientInfoTooltip);
	    return (0, _possibleConstructorReturn3.default)(this, (StatisticsRecipientInfoTooltip.__proto__ || (0, _getPrototypeOf2.default)(StatisticsRecipientInfoTooltip)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(StatisticsRecipientInfoTooltip, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          recipient = _props.recipient;
	      var t = this.context.t;
	
	
	      var overlay = _react2.default.createElement(
	        'div',
	        { className: 'padding-5' },
	        _react2.default.createElement(
	          'div',
	          null,
	          t('ID'),
	          ': ',
	          recipient.recipientId
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          'IP: ',
	          recipient.ip
	        )
	      );
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          _Popover2.default,
	          { overlay: overlay },
	          _react2.default.createElement('i', { className: (0, _bind2.default)(styles.icon, className) })
	        )
	      );
	    }
	  }]);
	  return StatisticsRecipientInfoTooltip;
	}(_react.PureComponent), _class.propTypes = {
	  className: _propTypes2.default.string,
	  recipient: _propTypes2.default.object
	}, _class.contextTypes = {
	  t: _propTypes2.default.func
	}, _class.defaultProps = {
	  recipient: {}
	}, _temp);
	exports.default = StatisticsRecipientInfoTooltip;
	module.exports = exports['default'];

/***/ }),
/* 2127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _get2 = __webpack_require__(19);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _TabsWrapper = __webpack_require__(854);
	
	var _TabsWrapper2 = _interopRequireDefault(_TabsWrapper);
	
	var _Tab = __webpack_require__(853);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StatisticsTabs = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(StatisticsTabs, _Component);
	
	  function StatisticsTabs() {
	    (0, _classCallCheck3.default)(this, StatisticsTabs);
	    return (0, _possibleConstructorReturn3.default)(this, (StatisticsTabs.__proto__ || (0, _getPrototypeOf2.default)(StatisticsTabs)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(StatisticsTabs, [{
	    key: 'getActiveRoute',
	    value: function getActiveRoute() {
	      return (0, _get3.default)(this, ['context', 'router', 'routes', 3, 'path']);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          projectId = _props.projectId,
	          recipientId = _props.recipientId;
	      var t = this.context.t;
	
	      var projectRoute = '/statistics/project' + (projectId ? '/' + projectId : '');
	      var recipientRoute = '/statistics/recipient' + (recipientId ? '/' + recipientId : '');
	      var activeTab = this.getActiveRoute();
	
	      return _react2.default.createElement(
	        _TabsWrapper2.default,
	        { className: (0, _bind2.default)(className), pullRight: true },
	        _react2.default.createElement(_Tab2.default, {
	          title: t('Project Activity'),
	          to: projectRoute,
	          active: activeTab === 'project'
	        }),
	        _react2.default.createElement(_Tab2.default, {
	          title: t('Recipient Activity'),
	          to: recipientRoute,
	          active: activeTab === 'recipient'
	        }),
	        _react2.default.createElement(_Tab2.default, {
	          title: t('Devices'),
	          to: '/statistics/devices',
	          active: activeTab === 'devices'
	        })
	      );
	    }
	  }]);
	  return StatisticsTabs;
	}(_react.Component), _class.propTypes = {
	  className: _propTypes2.default.string,
	  projectId: _propTypes2.default.number,
	  recipientId: _propTypes2.default.number
	}, _class.contextTypes = {
	  router: _propTypes2.default.object,
	  t: _propTypes2.default.func
	}, _temp);
	exports.default = StatisticsTabs;
	module.exports = exports['default'];

/***/ }),
/* 2128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DetailsLink = __webpack_require__(1986);
	
	var _DetailsLink2 = _interopRequireDefault(_DetailsLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StatisticsTracksDetailsLink = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(StatisticsTracksDetailsLink, _PureComponent);
	
	  function StatisticsTracksDetailsLink() {
	    (0, _classCallCheck3.default)(this, StatisticsTracksDetailsLink);
	    return (0, _possibleConstructorReturn3.default)(this, (StatisticsTracksDetailsLink.__proto__ || (0, _getPrototypeOf2.default)(StatisticsTracksDetailsLink)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(StatisticsTracksDetailsLink, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          projectId = _props.projectId;
	      var t = this.context.t;
	
	
	      return _react2.default.createElement(_DetailsLink2.default, {
	        className: className,
	        to: '/statistics/project/' + projectId + '/details',
	        title: t('Details by tracks')
	      });
	    }
	  }]);
	  return StatisticsTracksDetailsLink;
	}(_react.PureComponent), _class.propTypes = {
	  className: _propTypes2.default.string,
	  projectId: _propTypes2.default.number
	}, _class.contextTypes = {
	  t: _propTypes2.default.func
	}, _temp);
	exports.default = StatisticsTracksDetailsLink;
	module.exports = exports['default'];

/***/ }),
/* 2129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _Panel = __webpack_require__(352);
	
	var _Panel2 = _interopRequireDefault(_Panel);
	
	var _PlayStatsChart = __webpack_require__(521);
	
	var _PlayStatsChart2 = _interopRequireDefault(_PlayStatsChart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1334);
	
	var TrackDetailsStatistics = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(TrackDetailsStatistics, _PureComponent);
	
	  function TrackDetailsStatistics() {
	    (0, _classCallCheck3.default)(this, TrackDetailsStatistics);
	    return (0, _possibleConstructorReturn3.default)(this, (TrackDetailsStatistics.__proto__ || (0, _getPrototypeOf2.default)(TrackDetailsStatistics)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TrackDetailsStatistics, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          _props$data = _props.data,
	          fullName = _props$data.fullName,
	          stats = _props$data.stats,
	          trackId = _props$data.trackId;
	
	
	      return _react2.default.createElement(
	        _Panel2.default,
	        {
	          className: (0, _bind2.default)(styles.panel, className),
	          title: fullName
	        },
	        _react2.default.createElement(_PlayStatsChart2.default, { data: stats, id: 'trackDetails' + trackId })
	      );
	    }
	  }]);
	  return TrackDetailsStatistics;
	}(_react.PureComponent), _class.propTypes = {
	  className: _propTypes2.default.string,
	  data: _propTypes2.default.object
	}, _class.defaultProps = {
	  data: { stats: [] }
	}, _temp);
	exports.default = TrackDetailsStatistics;
	module.exports = exports['default'];

/***/ }),
/* 2130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _audioplayer = __webpack_require__(83);
	
	var audioPlayerActions = _interopRequireWildcard(_audioplayer);
	
	var _AudioPlayer = __webpack_require__(135);
	
	var _AudioPlayer2 = _interopRequireDefault(_AudioPlayer);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TrackDuration = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    currentTrackIndex: state.audioplayer.currentTrackIndex,
	    humanizedPosition: state.audioplayer.humanizedPosition,
	    playerAlbum: state.audioplayer.album,
	    playerStatus: state.audioplayer.playerStatus,
	    playerTracks: state.audioplayer.tracks
	  };
	}, (0, _extends3.default)({}, audioPlayerActions)), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(TrackDuration, _Component);
	
	  function TrackDuration() {
	    (0, _classCallCheck3.default)(this, TrackDuration);
	    return (0, _possibleConstructorReturn3.default)(this, (TrackDuration.__proto__ || (0, _getPrototypeOf2.default)(TrackDuration)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TrackDuration, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          currentTrackIndex = _props.currentTrackIndex,
	          playerTracks = _props.playerTracks,
	          playerStatus = _props.playerStatus,
	          className = _props.className,
	          track = _props.track,
	          album = _props.album,
	          playerAlbum = _props.playerAlbum,
	          humanizedPosition = _props.humanizedPosition;
	
	      var currentPlayerTrack = playerTracks[currentTrackIndex] || {};
	
	      var _audioplayer$getPlayi = _AudioPlayer2.default.getPlayingInfo({
	        track: track, album: album, playerAlbum: playerAlbum, currentPlayerTrack: currentPlayerTrack, playerStatus: playerStatus
	      }),
	          isActiveTrack = _audioplayer$getPlayi.isActiveTrack;
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        isActiveTrack ? humanizedPosition : track.durationTime
	      );
	    }
	  }]);
	  return TrackDuration;
	}(_react.Component), _class2.propTypes = {
	  album: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  currentTrackIndex: _propTypes2.default.number,
	  humanizedPosition: _propTypes2.default.string,
	  playerAlbum: _propTypes2.default.object,
	  playerStatus: _propTypes2.default.string,
	  playerTracks: _propTypes2.default.array,
	  track: _propTypes2.default.object
	}, _class2.defaultProps = {
	  album: {},
	  playerAlbum: {},
	  track: {}
	}, _temp)) || _class);
	exports.default = TrackDuration;
	module.exports = exports['default'];

/***/ }),
/* 2131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _components = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TrackPlayPauseLockedButton = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(TrackPlayPauseLockedButton, _PureComponent);
	
	  function TrackPlayPauseLockedButton() {
	    (0, _classCallCheck3.default)(this, TrackPlayPauseLockedButton);
	    return (0, _possibleConstructorReturn3.default)(this, (TrackPlayPauseLockedButton.__proto__ || (0, _getPrototypeOf2.default)(TrackPlayPauseLockedButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TrackPlayPauseLockedButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          t = _props.t;
	
	
	      return _react2.default.createElement(
	        _components.Tooltip,
	        {
	          placement: 'bottom',
	          title: t('You have exceeded the maximum number of allocated plays')
	        },
	        _react2.default.createElement('i', { className: (0, _bind2.default)('icon-lock-open', className) })
	      );
	    }
	  }]);
	  return TrackPlayPauseLockedButton;
	}(_react.PureComponent), _class2.propTypes = {
	  className: _propTypes2.default.string,
	  t: _propTypes2.default.func
	}, _temp)) || _class);
	exports.default = TrackPlayPauseLockedButton;
	module.exports = exports['default'];

/***/ }),
/* 2132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _components = __webpack_require__(15);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1342);
	
	var UniversalUploaderItem = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(UniversalUploaderItem, _Component);
	
	  function UniversalUploaderItem() {
	    (0, _classCallCheck3.default)(this, UniversalUploaderItem);
	    return (0, _possibleConstructorReturn3.default)(this, (UniversalUploaderItem.__proto__ || (0, _getPrototypeOf2.default)(UniversalUploaderItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(UniversalUploaderItem, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          maxSize = _props.maxSize,
	          showThumb = _props.showThumb,
	          uploaderThumbNode = _props.uploaderThumbNode,
	          fileNameNode = _props.fileNameNode,
	          fileExtNode = _props.fileExtNode,
	          uploadStatusNode = _props.uploadStatusNode,
	          fileSizeNode = _props.fileSizeNode,
	          progressBarNode = _props.progressBarNode,
	          uploadStatusIconNode = _props.uploadStatusIconNode;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(styles.uploaderItem, className) },
	        _react2.default.createElement(
	          'div',
	          { className: 'table' },
	          _react2.default.createElement(
	            'div',
	            { className: 'table-cell width-perc-1' },
	            showThumb ? _react2.default.createElement(
	              'div',
	              { style: { minHeight: maxSize + 'px' }, className: styles.thumbContainer },
	              uploaderThumbNode
	            ) : _react2.default.createElement(
	              _components.FileTypeThumb,
	              null,
	              fileExtNode
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'table-cell padding-left-10 pos-rel' },
	            _react2.default.createElement(
	              'div',
	              { className: 'width-perc-100' },
	              _react2.default.createElement(
	                'span',
	                { className: styles.fileName },
	                fileNameNode
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: styles.uploadStatus },
	                uploadStatusNode
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: styles.fileSize },
	                fileSizeNode
	              )
	            ),
	            !!progressBarNode && progressBarNode
	          ),
	          !!uploadStatusIconNode && _react2.default.createElement(
	            'div',
	            { className: 'table-cell width-perc-1 vertical-bottom' },
	            uploadStatusIconNode
	          )
	        )
	      );
	    }
	  }]);
	  return UniversalUploaderItem;
	}(_react.Component), _class.propTypes = {
	  className: _propTypes2.default.string,
	  fileExtNode: _propTypes2.default.node,
	  fileNameNode: _propTypes2.default.node,
	  fileSizeNode: _propTypes2.default.node,
	  maxSize: _propTypes2.default.number,
	  progressBarNode: _propTypes2.default.node,
	  showThumb: _propTypes2.default.bool,
	  uploaderThumbNode: _propTypes2.default.node,
	  uploadStatusIconNode: _propTypes2.default.node,
	  uploadStatusNode: _propTypes2.default.node
	}, _class.defaultProps = {
	  maxSize: 70
	}, _temp);
	exports.default = UniversalUploaderItem;
	module.exports = exports['default'];

/***/ }),
/* 2133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _components = __webpack_require__(15);
	
	var _reactI18next = __webpack_require__(12);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _playlist = __webpack_require__(217);
	
	var playlistActions = _interopRequireWildcard(_playlist);
	
	var _reactRouterRedux = __webpack_require__(40);
	
	var _TermsHint = __webpack_require__(512);
	
	var _TermsHint2 = _interopRequireDefault(_TermsHint);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1343);
	
	var UserConsent = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    playlistLoading: state.playlist.playlistLoading
	  };
	}, (0, _extends3.default)({}, playlistActions, { push: _reactRouterRedux.push })), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(UserConsent, _Component);
	
	  function UserConsent() {
	    (0, _classCallCheck3.default)(this, UserConsent);
	    return (0, _possibleConstructorReturn3.default)(this, (UserConsent.__proto__ || (0, _getPrototypeOf2.default)(UserConsent)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(UserConsent, [{
	    key: 'onCancel',
	    value: function onCancel() {
	      this.props.push('/');
	    }
	  }, {
	    key: 'onAccept',
	    value: function onAccept() {
	      var _props = this.props,
	          loadByKeyOnAcceptDaw = _props.loadByKeyOnAcceptDaw,
	          playlistKey = _props.playlistKey;
	
	      return loadByKeyOnAcceptDaw({ key: playlistKey });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          t = _props2.t,
	          playlistLoading = _props2.playlistLoading;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('homeContent', styles.page) },
	        _react2.default.createElement(
	          'div',
	          { className: styles.header },
	          t('Important information')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.content },
	          _react2.default.createElement(
	            'p',
	            null,
	            t('By clicking “Accept” you acknowledge that'),
	            ':'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            '-',
	            _react2.default.createElement(
	              'span',
	              { className: (0, _classnames2.default)(styles.marker, 'margin-left-5') },
	              _react2.default.createElement(_reactI18next.Interpolate, {
	                i18nKey: 'The content will lock to {{theDeviceThatIt}}',
	                theDeviceThatIt: _react2.default.createElement(
	                  'span',
	                  { className: 'underline' },
	                  t('the device that it is first played on~~The content will lock to...')
	                )
	              })
	            ),
	            '; ',
	            _react2.default.createElement(
	              'span',
	              null,
	              t('and')
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            '-',
	            _react2.default.createElement(
	              'span',
	              { className: 'margin-left-5' },
	              t('You understand and agree to the terms contained in our email to you in respect of receipt of the content')
	            ),
	            '.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(_reactI18next.Interpolate, {
	              i18nKey: 'Click ACCEPT to listen on {{thisDeviceOnly}}',
	              thisDeviceOnly: _react2.default.createElement(
	                'span',
	                { className: 'underline' },
	                t('this device only~~Click ACCEPT to listen on ...')
	              )
	            })
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            t('If you log into CRight using your password you can still listen on any device as usual.')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.buttons },
	          _react2.default.createElement(
	            _components.Button,
	            { className: 'btn-default', onClick: this.onCancel },
	            t('Cancel')
	          ),
	          _react2.default.createElement(
	            _components.Button,
	            { className: 'btn-primary margin-left-20', onClick: this.onAccept, loading: playlistLoading },
	            t('Accept')
	          )
	        ),
	        _react2.default.createElement(_TermsHint2.default, { nonStyled: true, className: styles.terms })
	      );
	    }
	  }]);
	  return UserConsent;
	}(_react.Component), _class3.propTypes = {
	  loadByKeyOnAcceptDaw: _propTypes2.default.func,
	  playlistKey: _propTypes2.default.string,
	  playlistLoading: _propTypes2.default.bool,
	  push: _propTypes2.default.func,
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onCancel', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onCancel'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onAccept', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onAccept'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = UserConsent;
	module.exports = exports['default'];

/***/ }),
/* 2134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(21);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	exports.default = formCheckbox;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _components = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formCheckbox(props) {
	  var input = props.input,
	      meta = props.meta,
	      type = props.type,
	      disabled = props.disabled,
	      other = (0, _objectWithoutProperties3.default)(props, ['input', 'meta', 'type', 'disabled']); // eslint-disable-line no-unused-vars
	
	  return _react2.default.createElement(_components.Checkbox, (0, _extends3.default)({}, other, input, { disabled: disabled }));
	}
	
	formCheckbox.propTypes = {
	  disabled: _propTypes2.default.bool,
	  input: _propTypes2.default.object,
	  meta: _propTypes2.default.object,
	  type: _propTypes2.default.string
	};
	module.exports = exports['default'];

/***/ }),
/* 2135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = formDatetime;
	
	var _formDate = __webpack_require__(524);
	
	var _formDate2 = _interopRequireDefault(_formDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formDatetime(props) {
	  return (0, _formDate2.default)((0, _extends3.default)({}, props, { timeFormat: 'HH:mm', closeOnSelect: false }));
	}
	module.exports = exports['default'];

/***/ }),
/* 2136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(21);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	exports.default = formLineTextInput;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formLineTextInput(props) {
	  var input = props.input,
	      _props$meta = props.meta,
	      touched = _props$meta.touched,
	      error = _props$meta.error,
	      type = props.type,
	      disabled = props.disabled,
	      bottomHint = props.bottomHint,
	      labelClass = props.labelClass,
	      hideLabel = props.hideLabel,
	      children = props.children,
	      other = (0, _objectWithoutProperties3.default)(props, ['input', 'meta', 'type', 'disabled', 'bottomHint', 'labelClass', 'hideLabel', 'children']);
	
	  var formGroupClassName = (0, _bind2.default)('formLineTextInput', props.fieldClassName, { hasError: touched && error });
	
	  return _react2.default.createElement(
	    'div',
	    { className: formGroupClassName },
	    props.placeholder && !hideLabel && _react2.default.createElement(
	      'div',
	      { className: 'table-cell padding-right-10 width-perc-1' },
	      _react2.default.createElement(
	        'label',
	        { className: labelClass },
	        props.placeholder,
	        ':'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'table-cell' },
	      type === 'textarea' ? _react2.default.createElement('textarea', (0, _extends3.default)({}, other, input, { disabled: disabled, className: 'width-perc-100' })) : _react2.default.createElement('input', (0, _extends3.default)({}, other, input, { type: type, disabled: disabled, className: 'width-perc-100' })),
	      touched && error && _react2.default.createElement(
	        'div',
	        { className: 'fieldErrorText' },
	        error
	      ),
	      bottomHint && _react2.default.createElement(
	        'div',
	        { className: 'hint small' },
	        bottomHint
	      )
	    ),
	    children && _react2.default.createElement(
	      'div',
	      { className: 'table-cell width-perc-1 padding-left-10' },
	      children
	    )
	  );
	}
	
	formLineTextInput.propTypes = {
	  bottomHint: _propTypes2.default.string,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string, _propTypes2.default.number]),
	  disabled: _propTypes2.default.bool,
	  fieldClassName: _propTypes2.default.string,
	  hideLabel: _propTypes2.default.bool,
	  input: _propTypes2.default.object,
	  labelClass: _propTypes2.default.string,
	  meta: _propTypes2.default.object,
	  placeholder: _propTypes2.default.string,
	  type: _propTypes2.default.string
	};
	module.exports = exports['default'];

/***/ }),
/* 2137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(21);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	exports.default = formRadio;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _components = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formRadio(props) {
	  var input = props.input,
	      meta = props.meta,
	      type = props.type,
	      disabled = props.disabled,
	      other = (0, _objectWithoutProperties3.default)(props, ['input', 'meta', 'type', 'disabled']); // eslint-disable-line no-unused-vars
	
	  return _react2.default.createElement(_components.Checkbox, (0, _extends3.default)({}, other, input, { radio: true, disabled: disabled }));
	}
	
	formRadio.propTypes = {
	  disabled: _propTypes2.default.bool,
	  input: _propTypes2.default.object,
	  meta: _propTypes2.default.object,
	  type: _propTypes2.default.string
	};
	module.exports = exports['default'];

/***/ }),
/* 2138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(21);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	exports.default = formSimpleTextInput;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formSimpleTextInput(props) {
	  var input = props.input,
	      _props$meta = props.meta,
	      touched = _props$meta.touched,
	      error = _props$meta.error,
	      type = props.type,
	      disabled = props.disabled,
	      bottomHint = props.bottomHint,
	      labelClass = props.labelClass,
	      hideLabel = props.hideLabel,
	      noIndent = props.noIndent,
	      inputClassName = props.inputClassName,
	      fieldClassName = props.fieldClassName,
	      other = (0, _objectWithoutProperties3.default)(props, ['input', 'meta', 'type', 'disabled', 'bottomHint', 'labelClass', 'hideLabel', 'noIndent', 'inputClassName', 'fieldClassName']);
	
	  var formGroupClassName = (0, _bind2.default)(fieldClassName, { hasError: touched && error, 'margin-vert-10': !noIndent });
	
	  return _react2.default.createElement(
	    'div',
	    { className: formGroupClassName },
	    props.placeholder && !hideLabel && _react2.default.createElement(
	      'label',
	      { className: labelClass },
	      props.placeholder,
	      ':'
	    ),
	    type === 'textarea' ? _react2.default.createElement('textarea', (0, _extends3.default)({}, other, input, { disabled: disabled, className: (0, _bind2.default)('width-perc-100', inputClassName) })) : _react2.default.createElement('input', (0, _extends3.default)({}, other, input, { type: type, disabled: disabled, className: (0, _bind2.default)('width-perc-100', inputClassName) })),
	    touched && error && _react2.default.createElement(
	      'div',
	      { className: 'fieldErrorText' },
	      error
	    ),
	    bottomHint && _react2.default.createElement(
	      'div',
	      { className: 'hint small' },
	      bottomHint
	    )
	  );
	}
	
	formSimpleTextInput.propTypes = {
	  bottomHint: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  fieldClassName: _propTypes2.default.string,
	  hideLabel: _propTypes2.default.bool,
	  input: _propTypes2.default.object,
	  inputClassName: _propTypes2.default.string,
	  labelClass: _propTypes2.default.string,
	  meta: _propTypes2.default.object,
	  noIndent: _propTypes2.default.bool,
	  placeholder: _propTypes2.default.string,
	  type: _propTypes2.default.string
	};
	module.exports = exports['default'];

/***/ }),
/* 2139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(21);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _get3 = __webpack_require__(19);
	
	var _get4 = _interopRequireDefault(_get3);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _formAutosuggestInput = __webpack_require__(862);
	
	var _formAutosuggestInput2 = _interopRequireDefault(_formAutosuggestInput);
	
	var _utils = __webpack_require__(24);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _components = __webpack_require__(15);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1346);
	
	var formTagsInput = (_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(formTagsInput, _Component);
	
	  function formTagsInput() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, formTagsInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = formTagsInput.__proto__ || (0, _getPrototypeOf2.default)(formTagsInput)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { selectedTag: null, focused: false };
	    return _this;
	  }
	
	  (0, _createClass3.default)(formTagsInput, [{
	    key: 'onTagClick',
	    value: function onTagClick(tag) {
	      this.setState({ selectedTag: tag });
	    }
	  }, {
	    key: 'onKeyDown',
	    value: function onKeyDown(e) {
	      var tags = this.props.tags;
	      var selectedTag = this.state.selectedTag;
	
	
	      if (!e.target.value) {
	        if (e.which === 8 && tags.length) {
	          var lastTag = tags[tags.length - 1];
	          if (selectedTag === lastTag) {
	            this.deleteTag(selectedTag);
	          } else {
	            this.setState({ selectedTag: lastTag });
	          }
	        }
	      } else {
	        this.unselectTag();
	      }
	    }
	  }, {
	    key: 'getInputProps',
	    value: function getInputProps() {
	      var _this2 = this;
	
	      var _props$input = this.props.input,
	          input = _props$input === undefined ? {} : _props$input;
	
	
	      return (0, _extends3.default)({}, input, {
	        onFocus: function onFocus(e) {
	          (0, _get4.default)(input, 'onFocus', function () {})(e);
	          _this2.setState({ focused: true });
	        },
	        onBlur: function onBlur(e) {
	          (0, _get4.default)(input, 'onBlur', function () {})(e);
	          _this2.setState({ focused: false });
	        }
	      });
	    }
	  }, {
	    key: 'unselectTag',
	    value: function unselectTag() {
	      this.setState({ selectedTag: null });
	    }
	  }, {
	    key: 'deleteTag',
	    value: function deleteTag(tag) {
	      var _this3 = this;
	
	      var deletingTag = this.state.deletingTag;
	
	      if (deletingTag === tag) {
	        return false;
	      }
	
	      var onTagDelete = this.props.onTagDelete;
	
	
	      if (onTagDelete) {
	        this.setState({ deletingTag: tag });
	        onTagDelete(tag).then(function () {
	          return _this3.setState({ deletingTag: null });
	        }).catch(function () {
	          return _this3.setState({ deletingTag: null });
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          tags = _props.tags,
	          tagNameField = _props.tagNameField,
	          tagKeyField = _props.tagKeyField,
	          inputClassName = _props.inputClassName,
	          other = (0, _objectWithoutProperties3.default)(_props, ['tags', 'tagNameField', 'tagKeyField', 'inputClassName']);
	      var _state = this.state,
	          selectedTag = _state.selectedTag,
	          deletingTag = _state.deletingTag,
	          focused = _state.focused;
	
	      var input = this.getInputProps();
	
	      var onKeyDown = other.onKeyDown;
	
	      other.onKeyDown = function (e) {
	        if (onKeyDown) {
	          onKeyDown(e);
	        }
	        _this4.onKeyDown(e);
	      };
	
	      return _react2.default.createElement(
	        'label',
	        { className: (0, _classnames2.default)(styles.tagsInput, 'tagsInput', inputClassName, (0, _defineProperty3.default)({}, styles.focused, focused)), onClick: this.unselectTag },
	        tags.map(function (tag) {
	          var _classNames2;
	
	          return _react2.default.createElement(
	            'span',
	            {
	              key: tag[tagKeyField],
	              className: (0, _classnames2.default)(styles.tag, (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, styles.selected, selectedTag === tag), (0, _defineProperty3.default)(_classNames2, styles.deleting, deletingTag === tag), _classNames2)),
	              onClick: function onClick(e) {
	                return (0, _utils.stopEvent)(e) && _this4.onTagClick(tag);
	              }
	            },
	            tag[tagNameField],
	            _react2.default.createElement(
	              'span',
	              { className: styles.closer, onClick: function onClick() {
	                  return _this4.deleteTag(tag);
	                } },
	              _react2.default.createElement('i', { className: 'icon-close' }),
	              deletingTag === tag && _react2.default.createElement(_components.Loader, { small: true, mask: true, transparent: true })
	            )
	          );
	        }),
	        (0, _formAutosuggestInput2.default)((0, _extends3.default)({}, other, { input: input, fieldClassName: styles.autosuggest, autoWidth: true }))
	      );
	    }
	  }]);
	  return formTagsInput;
	}(_react.Component), _class2.propTypes = {
	  input: _propTypes2.default.object,
	  inputClassName: _propTypes2.default.string,
	  onTagDelete: _propTypes2.default.func,
	  tagKeyField: _propTypes2.default.string,
	  tagNameField: _propTypes2.default.string,
	  tags: _propTypes2.default.array
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'unselectTag', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'unselectTag'), _class.prototype)), _class);
	exports.default = formTagsInput;
	module.exports = exports['default'];

/***/ }),
/* 2140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _promise = __webpack_require__(62);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(55);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactI18next = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reduxConnect = __webpack_require__(33);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _account = __webpack_require__(184);
	
	var accountActions = _interopRequireWildcard(_account);
	
	var _components = __webpack_require__(15);
	
	var _containers = __webpack_require__(213);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _permissions = __webpack_require__(215);
	
	var _auth = __webpack_require__(77);
	
	var _asyncPromise = __webpack_require__(43);
	
	var _asyncPromise2 = _interopRequireDefault(_asyncPromise);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _AccountName = __webpack_require__(2141);
	
	var _AccountName2 = _interopRequireDefault(_AccountName);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1347);
	var dropboxImg = __webpack_require__(269);
	var boxcomImg = __webpack_require__(268);
	
	var Account = (_dec = (0, _reduxConnect.asyncConnect)([{
	  promise: function promise(_ref) {
	    var dispatch = _ref.store.dispatch;
	
	    var promises = [];
	    promises.push(dispatch(accountActions.loadAccount()).promise);
	    promises.push(dispatch(accountActions.loadUserEmails()).promise);
	    return (0, _asyncPromise2.default)(_promise2.default.all(promises));
	  }
	}]), _dec2 = (0, _reactRedux.connect)(function (state) {
	  return {
	    account: state.account.accountData,
	    accountLoading: state.account.accountLoading,
	    deleteEmailActionData: state.account.deleteEmailActionData,
	    deleteEmailLoading: state.account.deleteEmailLoading,
	    user: (0, _auth.getUser)(state),
	    userEmails: state.account.userEmailsData,
	    userEmailsLoading: state.account.userEmailsLoading
	  };
	}, (0, _extends3.default)({}, accountActions)), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(Account, _Component);
	
	  function Account() {
	    (0, _classCallCheck3.default)(this, Account);
	    return (0, _possibleConstructorReturn3.default)(this, (Account.__proto__ || (0, _getPrototypeOf2.default)(Account)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Account, [{
	    key: 'getEmailManagementElement',
	    value: function getEmailManagementElement(emails) {
	      var _this2 = this;
	
	      if (!emails) {
	        return false;
	      }
	
	      var _props = this.props,
	          t = _props.t,
	          deleteEmailLoading = _props.deleteEmailLoading,
	          deleteEmailActionData = _props.deleteEmailActionData;
	
	      var ret = [];
	
	      emails.map(function (email) {
	        ret.push(_react2.default.createElement(
	          _components.ListItem,
	          { fullWidth: true, key: email.email },
	          _react2.default.createElement(
	            'div',
	            { className: styles.emailAddress },
	            email.email
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: styles.emailType },
	            email.isPrimary ? t('Primary') : t('Secondary')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _bind2.default)(styles.emailStatus, 'colorInfo') },
	            t('Verified')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'moreCell' },
	            _react2.default.createElement('i', { className: 'more', onClick: function onClick(e) {
	                return _this2.accountEmailsPopover.toggle(e, email);
	              } }),
	            deleteEmailLoading && deleteEmailActionData.email === email.email && _react2.default.createElement(_components.Loader, { small: true, mask: true })
	          )
	        ));
	      });
	      return ret;
	    }
	  }, {
	    key: 'deleteEmail',
	    value: function deleteEmail(email) {
	      var _props2 = this.props,
	          deleteEmail = _props2.deleteEmail,
	          t = _props2.t;
	
	      var toastrConfirmOptions = {
	        onOk: function onOk() {
	          return deleteEmail(email.email);
	        },
	        onCancel: function onCancel() {}
	      };
	      _toastr2.default.confirm(t('Are you sure you want to delete this email address?'), toastrConfirmOptions);
	    }
	  }, {
	    key: 'makeEmailPrimary',
	    value: function makeEmailPrimary(email) {
	      this.props.makeEmailPrimary(email.email);
	    }
	  }, {
	    key: 'openForgotPasswordForm',
	    value: function openForgotPasswordForm() {
	      this.forgotPasswordDialog.getWrappedInstance().getWrappedInstance().open();
	    }
	  }, {
	    key: 'bindPopover',
	    value: function bindPopover(el) {
	      this.accountEmailsPopover = el;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          t = _props3.t,
	          account = _props3.account,
	          accountLoading = _props3.accountLoading,
	          userEmails = _props3.userEmails,
	          userEmailsLoading = _props3.userEmailsLoading,
	          user = _props3.user;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(_reactHelmet2.default, { title: 'Account' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'container-fluid' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            t('Account')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'hint' },
	            t('Manage personal information')
	          ),
	          _react2.default.createElement(
	            'section',
	            { className: styles.section },
	            _react2.default.createElement(
	              'h3',
	              null,
	              t('Personal information')
	            ),
	            accountLoading && _react2.default.createElement(_components.Loader, null),
	            account && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: styles.personalInfoGroupItem },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  t('Email')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  account.userEmail
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: styles.personalInfoGroupItem },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  t('First name')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(_AccountName2.default, {
	                    className: styles.nameField,
	                    fieldName: 'firstName'
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: styles.personalInfoGroupItem },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  t('Last name')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(_AccountName2.default, {
	                    className: styles.nameField,
	                    fieldName: 'lastName'
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: styles.personalInfoGroupItem },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  t('Contributor level')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  account.contributor_level
	                )
	              )
	            )
	          ),
	          (0, _permissions.hasCloudServicesAccess)(user) && _react2.default.createElement(
	            'section',
	            { className: styles.section },
	            _react2.default.createElement(
	              'h3',
	              null,
	              t('Cloud services integration')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-20 col-md-15 col-lg-10' },
	                _react2.default.createElement('img', { src: dropboxImg, alt: '' }),
	                ' ',
	                t('Dropbox')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-40 col-md-45 col-lg-50' },
	                _react2.default.createElement(_components.DropboxConnectButton, null)
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row margin-top-10' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-20 col-md-15 col-lg-10' },
	                _react2.default.createElement('img', { src: boxcomImg, alt: '' }),
	                ' ',
	                t('Box.com')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-40 col-md-45 col-lg-50' },
	                _react2.default.createElement(_components.BoxcomConnectButton, null)
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'section',
	            { className: styles.section },
	            _react2.default.createElement(
	              'h3',
	              null,
	              t('Multiple emails management')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'hint small' },
	              t('You can have several emails address on Cright so that different people can send you content on different emails. Just define you primary email and you will receive ALL information (new content received, information from us) on the same unique email.')
	            ),
	            _react2.default.createElement(
	              _components.List,
	              null,
	              _react2.default.createElement(
	                _components.ListItem,
	                { fullWidth: true, isTitle: true },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  t('Email')
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  t('Type')
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  t('Status')
	                ),
	                _react2.default.createElement('div', null)
	              ),
	              this.getEmailManagementElement(userEmails)
	            ),
	            userEmailsLoading && _react2.default.createElement(_components.Loader, null),
	            _react2.default.createElement(
	              _components.PopoverMenu,
	              { id: 'accountEmailsPopover', ref: this.bindPopover },
	              _react2.default.createElement(
	                'li',
	                { onClick: function onClick() {
	                    return _this3.makeEmailPrimary(_this3.accountEmailsPopover.data);
	                  } },
	                t('Make primary'),
	                ' ',
	                _react2.default.createElement('i', { className: 'icon-check' })
	              ),
	              _react2.default.createElement(
	                'li',
	                { onClick: function onClick() {
	                    return _this3.deleteEmail(_this3.accountEmailsPopover.data);
	                  } },
	                t('Delete'),
	                ' ',
	                _react2.default.createElement('i', { className: 'icon-delete' })
	              )
	            ),
	            _react2.default.createElement(_components.AccountEmailForm, null)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'text-right margin-top-20' },
	            _react2.default.createElement(
	              'button',
	              { type: 'button', className: 'btn btn-primary', onClick: function onClick() {
	                  return _this3.openForgotPasswordForm();
	                } },
	              t('Change password')
	            )
	          ),
	          _react2.default.createElement(_containers.ForgotPasswordDialog, { ref: function ref(el) {
	              return _this3.forgotPasswordDialog = el;
	            } })
	        )
	      );
	    }
	  }]);
	  return Account;
	}(_react.Component), _class3.propTypes = {
	  account: _propTypes2.default.object,
	  accountLoading: _propTypes2.default.bool,
	  deleteEmail: _propTypes2.default.func,
	  deleteEmailActionData: _propTypes2.default.object,
	  deleteEmailLoading: _propTypes2.default.bool,
	  makeEmailPrimary: _propTypes2.default.func,
	  t: _propTypes2.default.func,
	  user: _propTypes2.default.object,
	  userEmails: _propTypes2.default.array,
	  userEmailsLoading: _propTypes2.default.bool
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'bindPopover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'bindPopover'), _class2.prototype)), _class2)) || _class) || _class) || _class);
	exports.default = Account;
	module.exports = exports['default'];

/***/ }),
/* 2141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _regenerator = __webpack_require__(138);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _asyncToGenerator2 = __webpack_require__(137);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _account = __webpack_require__(184);
	
	var accountActions = _interopRequireWildcard(_account);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _EditableField = __webpack_require__(821);
	
	var _EditableField2 = _interopRequireDefault(_EditableField);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1348);
	
	var nameMaxLength = 30;
	
	var AccountName = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    account: state.account.accountData,
	    updateAccountActionData: state.account.updateAccountActionData,
	    updateAccountLoading: state.account.updateAccountLoading
	  };
	}, (0, _extends3.default)({}, accountActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(AccountName, _Component);
	
	  function AccountName() {
	    (0, _classCallCheck3.default)(this, AccountName);
	    return (0, _possibleConstructorReturn3.default)(this, (AccountName.__proto__ || (0, _getPrototypeOf2.default)(AccountName)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AccountName, [{
	    key: 'saveName',
	    value: function () {
	      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(value) {
	        var _props, updateAccount, fieldName;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _props = this.props, updateAccount = _props.updateAccount, fieldName = _props.fieldName;
	                _context.next = 3;
	                return updateAccount((0, _defineProperty3.default)({}, fieldName, value)).promise;
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function saveName(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return saveName;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          account = _props2.account,
	          updateAccountLoading = _props2.updateAccountLoading,
	          updateAccountActionData = _props2.updateAccountActionData,
	          className = _props2.className,
	          textClass = _props2.textClass,
	          fieldName = _props2.fieldName;
	
	      var loading = updateAccountLoading && !!updateAccountActionData[fieldName];
	
	      return _react2.default.createElement(_EditableField2.default, {
	        className: className,
	        textClass: textClass,
	        onSave: this.saveName,
	        value: account[fieldName],
	        loading: loading,
	        inputProps: { maxLength: nameMaxLength },
	        inputClass: styles.nameInput,
	        containerClass: styles.nameInputContainer,
	        saveOnBlur: false,
	        type: 'text'
	      });
	    }
	  }]);
	  return AccountName;
	}(_react.Component), _class3.propTypes = {
	  account: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  fieldName: _propTypes2.default.string.isRequired,
	  textClass: _propTypes2.default.string,
	  updateAccount: _propTypes2.default.func,
	  updateAccountActionData: _propTypes2.default.object,
	  updateAccountLoading: _propTypes2.default.bool
	}, _class3.defaultProps = {
	  account: {},
	  updateAccountActionData: {}
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'saveName', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'saveName'), _class2.prototype)), _class2)) || _class);
	exports.default = AccountName;
	module.exports = exports['default'];

/***/ }),
/* 2142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get4 = __webpack_require__(58);
	
	var _get5 = _interopRequireDefault(_get4);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _promise = __webpack_require__(62);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _get6 = __webpack_require__(19);
	
	var _get7 = _interopRequireDefault(_get6);
	
	var _dec, _dec2, _dec3, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClientSideComponent = __webpack_require__(30);
	
	var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);
	
	var _reactI18next = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactHelmet = __webpack_require__(55);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _info = __webpack_require__(2236);
	
	var _auth = __webpack_require__(31);
	
	var authActions = _interopRequireWildcard(_auth);
	
	var _common = __webpack_require__(265);
	
	var commonActions = _interopRequireWildcard(_common);
	
	var _components = __webpack_require__(15);
	
	var _reactRouterRedux = __webpack_require__(40);
	
	var _config = __webpack_require__(41);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _reduxConnect = __webpack_require__(33);
	
	var _audioplayer = __webpack_require__(83);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _GA = __webpack_require__(826);
	
	var _GA2 = _interopRequireDefault(_GA);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _CookiePolicyBar = __webpack_require__(1980);
	
	var _CookiePolicyBar2 = _interopRequireDefault(_CookiePolicyBar);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1349);
	
	var App = (_dec = (0, _reduxConnect.asyncConnect)([{
	  promise: function promise(_ref) {
	    var _ref$store = _ref.store,
	        dispatch = _ref$store.dispatch,
	        getState = _ref$store.getState;
	
	    var promises = [];
	
	    if (!(0, _info.isLoaded)(getState())) {
	      //promises.push(dispatch(loadInfo()));
	    }
	    if (!authActions.isLoaded(getState())) {
	      promises.push(dispatch(authActions.load()).promise);
	    }
	
	    return _promise2.default.all(promises);
	  }
	}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    action: ownProps.params.action,
	    cookieBarHidden: state.adbar.cookieBarHidden,
	    delayedToast: state.common.delayedToast,
	    isMobile: state.common.isMobile,
	    passwordCode: ownProps.location.query.code,
	    passwordKey: ownProps.location.query.key,
	    playlistKey: (0, _get7.default)(state, 'playlist.playlistActionData.key'),
	    redirect: state.auth.redirect,
	    user: state.auth.user
	  };
	}, (0, _extends3.default)({}, authActions, commonActions, { pushState: _reactRouterRedux.push, audioplayerStop: _audioplayer.stop })), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(App, _Component);
	
	  function App() {
	    (0, _classCallCheck3.default)(this, App);
	    return (0, _possibleConstructorReturn3.default)(this, (App.__proto__ || (0, _getPrototypeOf2.default)(App)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(App, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        getId: this.props.getId,
	        isMobile: this.props.isMobile,
	        logout: this.props.logout,
	        push: this.props.pushState,
	        t: this.props.t
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      (0, _get5.default)(App.prototype.__proto__ || (0, _getPrototypeOf2.default)(App.prototype), 'componentDidMount', this).call(this, function () {
	        __webpack_require__(1922).polyfill();
	        _this2.setViewport();
	        _GA2.default.init(_config2.default.app.ga.devKey, { name: 'dev' });
	        _GA2.default.pageview(_this2.props.location.pathname);
	        _this2.showDelayedToast();
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!this.props.user && nextProps.user) {
	        this.onLogin(nextProps.user);
	      } else if (this.props.user && !nextProps.user) {
	        this.onLogout();
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      if (nextProps.location.pathname !== this.props.location.pathname) {
	        _GA2.default.pageview(nextProps.location.pathname);
	      }
	    }
	  }, {
	    key: 'onLogin',
	    value: function onLogin() {
	      var _props = this.props,
	          redirect = _props.redirect,
	          setRedirect = _props.setRedirect,
	          removeLoginData = _props.removeLoginData;
	
	      removeLoginData();
	      if (redirect) {
	        setRedirect('');
	        this.props.pushState(redirect);
	      } else {
	        this.props.pushState(_config2.default.app.defaultUserRoute);
	      }
	    }
	  }, {
	    key: 'onLogout',
	    value: function onLogout() {
	      this.props.audioplayerStop();
	      this.props.pushState('/');
	      this.props.reset();
	    }
	  }, {
	    key: 'setViewport',
	    value: function setViewport() {
	      // change viewports for macbooks
	      var _screen = screen,
	          width = _screen.width,
	          height = _screen.height;
	
	      var viewports = [{ devicePixelRatio: 2, width: 1280, height: 800, resize: 2 }, // MacBook Pro 13-inch Retina display
	      { devicePixelRatio: 2, width: 1440, height: 900, resize: 2 }];
	
	      viewports.map(function (params) {
	        if (params.devicePixelRatio === window.devicePixelRatio && params.width === width && params.height === height) {
	          var viewport = document.querySelector('#viewport');
	          viewport.content = viewport.content.replace('width=device-width', 'width=' + Math.round(width * params.resize));
	        }
	      });
	    }
	  }, {
	    key: 'showDelayedToast',
	    value: function showDelayedToast() {
	      var _props2 = this.props,
	          _props2$delayedToast = _props2.delayedToast,
	          type = _props2$delayedToast.type,
	          message = _props2$delayedToast.message,
	          clearDelayedToast = _props2.clearDelayedToast;
	
	      if ((true) && message) {
	        _toastr2.default[type](message);
	        clearDelayedToast();
	      }
	    }
	  }, {
	    key: 'renderHomePages',
	    value: function renderHomePages(isLanding) {
	      var _props3 = this.props,
	          user = _props3.user,
	          playlistKey = _props3.playlistKey,
	          action = _props3.action,
	          passwordCode = _props3.passwordCode,
	          passwordKey = _props3.passwordKey;
	
	      var isShowPlayer = user || playlistKey;
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.homeRoot },
	        _react2.default.createElement(_reactHelmet2.default, _config2.default.app.head),
	        _react2.default.createElement(_components.AdBar, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'pos-rel' },
	          _react2.default.createElement(_components.HomeHeader, { action: action, passwordCode: passwordCode, passwordKey: passwordKey, isLanding: isLanding })
	        ),
	        isShowPlayer && _react2.default.createElement(_components.AudioPlayer, null),
	        _react2.default.createElement(
	          'div',
	          { className: styles.content },
	          this.props.mainChild
	        ),
	        _react2.default.createElement(_components.Footer, null),
	        _react2.default.createElement(_CookiePolicyBar2.default, null)
	      );
	    }
	  }, {
	    key: 'renderAppPages',
	    value: function renderAppPages() {
	      var _props4 = this.props,
	          user = _props4.user,
	          playlistKey = _props4.playlistKey;
	
	      var isShowPlayer = user || playlistKey;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(styles.app, (0, _defineProperty3.default)({}, styles.withSideMenu, !!user)) },
	        _react2.default.createElement(_reactHelmet2.default, _config2.default.app.head),
	        _react2.default.createElement(
	          'div',
	          { className: styles.header },
	          isShowPlayer && _react2.default.createElement(_components.AudioPlayer, null),
	          user && _react2.default.createElement(_components.SideMenu, null),
	          isShowPlayer ? _react2.default.createElement(_components.AppHeader, null) : _react2.default.createElement(_components.HomeHeader, { inApp: true })
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          this.props.mainChild
	        ),
	        _react2.default.createElement(_CookiePolicyBar2.default, null)
	      );
	    }
	  }, {
	    key: 'renderProcessingPages',
	    value: function renderProcessingPages() {
	      return _react2.default.createElement(
	        'div',
	        { className: styles.processingPage },
	        this.props.mainChild,
	        _react2.default.createElement(_CookiePolicyBar2.default, null)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          pathname = _props5.location.pathname,
	          cookieBarHidden = _props5.cookieBarHidden;
	
	      var isLanding = pathname === '/' || pathname.startsWith('/home') || pathname.startsWith('/password');
	      var isHomePath = isLanding || pathname.startsWith('/service');
	      var isProcessingPage = pathname.startsWith('/processing');
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)((0, _defineProperty3.default)({}, styles.cookieBarVisible, !cookieBarHidden)) },
	        isHomePath ? this.renderHomePages(isLanding) : isProcessingPage ? this.renderProcessingPages() : this.renderAppPages()
	      );
	    }
	  }]);
	  return App;
	}(_ClientSideComponent2.default), _class2.propTypes = {
	  action: _propTypes2.default.string,
	  audioplayerStop: _propTypes2.default.func,
	  clearDelayedToast: _propTypes2.default.func,
	  cookieBarHidden: _propTypes2.default.bool,
	  delayedToast: _propTypes2.default.object,
	  getId: _propTypes2.default.func,
	  isMobile: _propTypes2.default.bool,
	  location: _propTypes2.default.object,
	  logout: _propTypes2.default.func,
	  mainChild: _propTypes2.default.object.isRequired,
	  passwordCode: _propTypes2.default.string,
	  passwordKey: _propTypes2.default.string,
	  playlistKey: _propTypes2.default.string,
	  pushState: _propTypes2.default.func,
	  redirect: _propTypes2.default.string,
	  removeLoginData: _propTypes2.default.func,
	  reset: _propTypes2.default.func,
	  setRedirect: _propTypes2.default.func,
	  t: _propTypes2.default.func,
	  user: _propTypes2.default.object
	}, _class2.defaultProps = {
	  delayedToast: { type: 'info', message: null },
	  user: null
	}, _class2.contextTypes = {
	  store: _propTypes2.default.object.isRequired,
	  router: _propTypes2.default.object.isRequired
	}, _class2.childContextTypes = {
	  getId: _propTypes2.default.func,
	  isMobile: _propTypes2.default.bool,
	  logout: _propTypes2.default.func,
	  push: _propTypes2.default.func,
	  t: _propTypes2.default.func
	}, _temp)) || _class) || _class) || _class);
	exports.default = App;
	module.exports = exports['default'];

/***/ }),
/* 2143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _components = __webpack_require__(15);
	
	var _reactI18next = __webpack_require__(12);
	
	var _strings = __webpack_require__(59);
	
	var _responseCodes = __webpack_require__(99);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(629);
	
	var Login = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    loginData: state.auth.loginData,
	    user: state.auth.user
	  };
	}), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(Login, _Component);
	
	  function Login() {
	    (0, _classCallCheck3.default)(this, Login);
	    return (0, _possibleConstructorReturn3.default)(this, (Login.__proto__ || (0, _getPrototypeOf2.default)(Login)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Login, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          t = _props.t,
	          loginData = _props.loginData;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'homeContent ' + styles.auth },
	        loginData.email && loginData._code === _responseCodes.playlistCodes.loginRequired ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h1',
	            { className: styles.header },
	            t('Welcome back {{username}}', { username: (0, _strings.concat)(' ', loginData.name, loginData.surname) }),
	            '!'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: styles.hint },
	            t('Please enter your password below')
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: styles.hint },
	          t('Please login to verify your identity')
	        ),
	        _react2.default.createElement(_components.LoginForm, { className: styles.authForm, showTerms: !!loginData.email })
	      );
	    }
	  }]);
	  return Login;
	}(_react.Component), _class2.propTypes = {
	  loginData: _propTypes2.default.object,
	  t: _propTypes2.default.func
	}, _temp)) || _class) || _class);
	exports.default = Login;
	module.exports = exports['default'];

/***/ }),
/* 2144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _components = __webpack_require__(15);
	
	var _reactI18next = __webpack_require__(12);
	
	var _strings = __webpack_require__(59);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouterRedux = __webpack_require__(40);
	
	var _auth = __webpack_require__(31);
	
	var authActions = _interopRequireWildcard(_auth);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(629);
	// const defaultImage = require('assets/default-logo.png');
	
	
	var Registration = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    activateAccountLoaded: state.auth.activateAccountLoaded,
	    activateAccountLoading: state.auth.activateAccountLoading,
	    loginData: state.auth.loginData,
	    termsAccepted: state.auth.termsAccepted,
	    user: state.auth.user
	  };
	}, (0, _extends3.default)({}, authActions, { pushState: _reactRouterRedux.push })), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(Registration, _Component);
	
	  function Registration() {
	    (0, _classCallCheck3.default)(this, Registration);
	    return (0, _possibleConstructorReturn3.default)(this, (Registration.__proto__ || (0, _getPrototypeOf2.default)(Registration)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Registration, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          email = _props.loginData.email,
	          pushState = _props.pushState;
	
	      if (!email) {
	        pushState('/');
	      }
	    }
	  }, {
	    key: 'activate',
	    value: function activate() {
	      var _props2 = this.props,
	          email = _props2.loginData.email,
	          activateAccount = _props2.activateAccount;
	
	      activateAccount({ userEmail: email });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          t = _props3.t,
	          loginData = _props3.loginData,
	          activateAccountLoaded = _props3.activateAccountLoaded,
	          activateAccountLoading = _props3.activateAccountLoading,
	          termsAccepted = _props3.termsAccepted;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('homeContent', 'text-center', styles.auth) },
	        _react2.default.createElement(
	          'div',
	          { className: styles.registration },
	          loginData.email ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: styles.welcome },
	              _react2.default.createElement(
	                'div',
	                null,
	                t('We\'re glad you\'re here')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'colorPrimary' },
	                (0, _strings.concat)(' ', loginData.name, loginData.surname)
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'colorDark' },
	              t('You are just a few clicks away from being able to access your content')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'margin-top-40' },
	              activateAccountLoaded ? _react2.default.createElement(
	                'div',
	                { className: 'colorPrimary' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'h3' },
	                  t('Please check your email!')
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  t('We\'ve sent a message to \'{{email}}\' open it up and click Activate Account and we\'ll do the rest.', { email: loginData.email })
	                )
	              ) : _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_components.TermsAcceptance, { className: 'margin-top-20' }),
	                _react2.default.createElement(
	                  _components.Button,
	                  {
	                    type: 'button',
	                    className: 'btn-primary margin-top-20',
	                    disabled: !termsAccepted,
	                    onClick: this.activate,
	                    loading: activateAccountLoading
	                  },
	                  t('Activate account')
	                )
	              )
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: styles.hint },
	            t('Please create your own unique password now')
	          )
	        )
	      );
	    }
	  }]);
	  return Registration;
	}(_react.Component), _class3.propTypes = {
	  activateAccount: _propTypes2.default.func,
	  activateAccountLoaded: _propTypes2.default.bool,
	  activateAccountLoading: _propTypes2.default.bool,
	  loginData: _propTypes2.default.object,
	  pushState: _propTypes2.default.func,
	  t: _propTypes2.default.func,
	  termsAccepted: _propTypes2.default.bool
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'activate', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'activate'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = Registration;
	module.exports = exports['default'];

/***/ }),
/* 2145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(58);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClientSideComponent = __webpack_require__(30);
	
	var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	var _utils = __webpack_require__(24);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var BoxcomAuth = (_dec = (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    response: ownProps.location.query
	  };
	}), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(BoxcomAuth, _Component);
	
	  function BoxcomAuth() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, BoxcomAuth);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = BoxcomAuth.__proto__ || (0, _getPrototypeOf2.default)(BoxcomAuth)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { response: {} };
	    return _this;
	  }
	
	  (0, _createClass3.default)(BoxcomAuth, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _get3.default)(BoxcomAuth.prototype.__proto__ || (0, _getPrototypeOf2.default)(BoxcomAuth.prototype), 'componentDidMount', this).call(this, this.onMount);
	    }
	  }, {
	    key: 'onMount',
	    value: function onMount() {
	      var response = this.props.response;
	
	      this.setState({ response: response });
	      window.opener.dispatchEvent((0, _utils.customEvent)('onBoxcomAuth', response));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var t = this.props.t;
	      var response = this.state.response;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'compactContent' },
	        response.error_description ? _react2.default.createElement(
	          'div',
	          { className: 'error' },
	          response.error_description
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          t('Loading...'),
	          _react2.default.createElement(_components.Loader, { mask: true })
	        )
	      );
	    }
	  }]);
	  return BoxcomAuth;
	}(_ClientSideComponent2.default), _class3.propTypes = {
	  response: _propTypes2.default.object,
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onMount', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onMount'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = BoxcomAuth;
	module.exports = exports['default'];

/***/ }),
/* 2146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _components = __webpack_require__(15);
	
	var _reactI18next = __webpack_require__(12);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var ContactUs = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(ContactUs, _Component);
	
	  function ContactUs() {
	    (0, _classCallCheck3.default)(this, ContactUs);
	    return (0, _possibleConstructorReturn3.default)(this, (ContactUs.__proto__ || (0, _getPrototypeOf2.default)(ContactUs)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ContactUs, [{
	    key: 'onSend',
	    value: function onSend() {
	      _toastr2.default.success(this.props.t('Enquiry sent'));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var t = this.props.t;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'container-fluid' },
	        _react2.default.createElement(
	          'div',
	          { className: 'narrowContent' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            t('Contact Us')
	          ),
	          _react2.default.createElement(_components.LoginContactForm, { onSend: this.onSend })
	        )
	      );
	    }
	  }]);
	  return ContactUs;
	}(_react.Component), _class3.propTypes = {
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onSend', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSend'), _class2.prototype)), _class2)) || _class);
	exports.default = ContactUs;
	module.exports = exports['default'];

/***/ }),
/* 2147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClientSideComponent = __webpack_require__(30);
	
	var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);
	
	var _reactRedux = __webpack_require__(11);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _AddContactSuggestForm = __webpack_require__(348);
	
	var _AddContactSuggestForm2 = _interopRequireDefault(_AddContactSuggestForm);
	
	var _contacts = __webpack_require__(61);
	
	var contactsActions = _interopRequireWildcard(_contacts);
	
	var _contacts2 = __webpack_require__(185);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var AddContactField = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    addContactLoading: state.contacts.addContactLoading,
	    suggestionUsersList: (0, _contacts2.getGroupContactsSuggestionList)(state)
	  };
	}, (0, _extends3.default)({}, contactsActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(AddContactField, _Component);
	
	  function AddContactField() {
	    (0, _classCallCheck3.default)(this, AddContactField);
	    return (0, _possibleConstructorReturn3.default)(this, (AddContactField.__proto__ || (0, _getPrototypeOf2.default)(AddContactField)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AddContactField, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var loadSuggestionUsersList = this.props.loadSuggestionUsersList;
	
	      loadSuggestionUsersList();
	    }
	  }, {
	    key: 'onSuggestionSelected',
	    value: function onSuggestionSelected(_ref) {
	      var suggestion = _ref.suggestion;
	      var onAdd = this.props.onAdd;
	
	      var user = (0, _extends3.default)({}, suggestion);
	      return onAdd(user);
	    }
	  }, {
	    key: 'getAutosuggestItems',
	    value: function getAutosuggestItems() {
	      var suggestionUsersList = this.props.suggestionUsersList;
	
	      var items = [];
	      suggestionUsersList.map(function (user) {
	        return items.push((0, _extends3.default)({}, user, { _name: user.email, _type: 'user' }));
	      });
	      return items;
	    }
	  }, {
	    key: 'addContact',
	    value: function addContact(data) {
	      var onAdd = this.props.onAdd;
	
	      var contact = {
	        email: data.userEmail,
	        name: data.name,
	        surname: data.surname
	      };
	
	      onAdd(contact);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          addContactLoading = _props.addContactLoading,
	          required = _props.required,
	          loading = _props.loading;
	
	      var items = this.getAutosuggestItems();
	
	      return _react2.default.createElement(_AddContactSuggestForm2.default, {
	        onSuggestionSelected: this.onSuggestionSelected,
	        loading: loading,
	        items: items,
	        onAddNewContact: this.addContact,
	        onAddNewContactLoading: addContactLoading,
	        required: required,
	        autoFocus: false
	      });
	    }
	  }]);
	  return AddContactField;
	}(_ClientSideComponent2.default), _class3.propTypes = {
	  addContactLoading: _propTypes2.default.bool,
	  loading: _propTypes2.default.bool,
	  loadSuggestionUsersList: _propTypes2.default.func,
	  onAdd: _propTypes2.default.func,
	  required: _propTypes2.default.bool,
	  suggestionUsersList: _propTypes2.default.array
	}, _class3.defaultProps = {
	  onAdd: _noop3.default,
	  onAddGroup: _noop3.default,
	  recipientsList: [],
	  withTags: false
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onSuggestionSelected', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSuggestionSelected'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'addContact', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'addContact'), _class2.prototype)), _class2)) || _class);
	exports.default = AddContactField;
	module.exports = exports['default'];

/***/ }),
/* 2148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactI18next = __webpack_require__(12);
	
	var _reduxForm = __webpack_require__(50);
	
	var _formComponents = __webpack_require__(71);
	
	var _contacts = __webpack_require__(61);
	
	var _components = __webpack_require__(15);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var contactFormDefaults = {
	  name: '',
	  surname: '',
	  email: ''
	};
	
	var ContactForm = (_dec = (0, _reactRedux.connect)(null, { addContact: _contacts.addContact }), _dec2 = (0, _reduxForm.reduxForm)({
	  form: 'contactForm',
	  propNamespace: 'contactForm',
	  initialValues: contactFormDefaults
	}), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(ContactForm, _Component);
	
	  function ContactForm() {
	    (0, _classCallCheck3.default)(this, ContactForm);
	    return (0, _possibleConstructorReturn3.default)(this, (ContactForm.__proto__ || (0, _getPrototypeOf2.default)(ContactForm)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ContactForm, [{
	    key: 'addContact',
	    value: function addContact(formData) {
	      var _props = this.props,
	          groupId = _props.groupId,
	          reset = _props.contactForm.reset,
	          onAdd = _props.onAdd;
	
	      var promise = this.props.addContact((0, _extends3.default)({}, formData, { groupId: groupId })).promise;
	      promise.then(function () {
	        reset();
	        onAdd();
	      });
	      return promise;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          t = _props2.t,
	          _props2$contactForm = _props2.contactForm,
	          handleSubmit = _props2$contactForm.handleSubmit,
	          submitting = _props2$contactForm.submitting,
	          invalid = _props2$contactForm.invalid;
	
	
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit(this.addContact) },
	        _react2.default.createElement(_reduxForm.Field, { name: 'name', type: 'text', component: _formComponents.formSimpleTextInput, placeholder: t('First name'), labelClass: 'faded', hideLabel: true }),
	        _react2.default.createElement(_reduxForm.Field, { name: 'surname', type: 'text', component: _formComponents.formSimpleTextInput, placeholder: t('Last name'), labelClass: 'faded', hideLabel: true }),
	        _react2.default.createElement(_reduxForm.Field, { name: 'email', type: 'email', component: _formComponents.formSimpleTextInput, placeholder: t('Email'), labelClass: 'faded', hideLabel: true }),
	        _react2.default.createElement(
	          'button',
	          { type: 'submit', className: 'btn btn-primary pos-rel', disabled: submitting || invalid },
	          t('Create contact'),
	          submitting && _react2.default.createElement(_components.Loader, { mask: true })
	        )
	      );
	    }
	  }]);
	  return ContactForm;
	}(_react.Component), _class3.propTypes = {
	  addContact: _propTypes2.default.func,
	  contactForm: _propTypes2.default.object,
	  groupId: _propTypes2.default.number,
	  onAdd: _propTypes2.default.func,
	  t: _propTypes2.default.func
	}, _class3.defaultProps = {
	  groupId: 0,
	  onAdd: function onAdd() {}
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'addContact', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'addContact'), _class2.prototype)), _class2)) || _class) || _class) || _class);
	exports.default = ContactForm;
	module.exports = exports['default'];

/***/ }),
/* 2149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _promise = __webpack_require__(62);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(55);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactRedux = __webpack_require__(11);
	
	var _contacts = __webpack_require__(61);
	
	var contactsActions = _interopRequireWildcard(_contacts);
	
	var _reduxConnect = __webpack_require__(33);
	
	var _components = __webpack_require__(15);
	
	var _ContactForm = __webpack_require__(2148);
	
	var _ContactForm2 = _interopRequireDefault(_ContactForm);
	
	var _reactI18next = __webpack_require__(12);
	
	var _pagination = __webpack_require__(357);
	
	var _asyncPromise = __webpack_require__(43);
	
	var _asyncPromise2 = _interopRequireDefault(_asyncPromise);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var Contacts = (_dec = (0, _reduxConnect.asyncConnect)([{
	  promise: function promise(_ref) {
	    var _ref$store = _ref.store,
	        dispatch = _ref$store.dispatch,
	        getState = _ref$store.getState;
	
	    var promises = [];
	    promises.push(dispatch(contactsActions.loadContacts({ page: 1, limit: getState().contacts.contactsListLimit })).promise);
	    promises.push(dispatch(contactsActions.loadGroups()).promise);
	    return (0, _asyncPromise2.default)(_promise2.default.all(promises));
	  }
	}]), _dec2 = (0, _reactRedux.connect)(function (state) {
	  return {
	    contactsList: state.contacts.contactsListData.contacts,
	    contactsListLimit: state.contacts.contactsListLimit,
	    contactsCurrentPage: state.contacts.contactsListActionData.page,
	    kw: state.contacts.kw
	  };
	}, (0, _extends3.default)({}, contactsActions)), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(Contacts, _Component);
	
	  function Contacts() {
	    (0, _classCallCheck3.default)(this, Contacts);
	    return (0, _possibleConstructorReturn3.default)(this, (Contacts.__proto__ || (0, _getPrototypeOf2.default)(Contacts)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Contacts, [{
	    key: 'reloadContactsPage',
	    value: function reloadContactsPage() {
	      var _props = this.props,
	          loadContacts = _props.loadContacts,
	          kw = _props.kw,
	          contactsCurrentPage = _props.contactsCurrentPage,
	          contactsList = _props.contactsList,
	          contactsListLimit = _props.contactsListLimit;
	
	      var page = (0, _pagination.getReloadPage)(contactsList, contactsCurrentPage);
	      loadContacts({ page: page, limit: contactsListLimit, kw: kw });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          t = _props2.t,
	          contactsListLimit = _props2.contactsListLimit;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(_reactHelmet2.default, { title: 'Contacts' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'container-fluid' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            t('Contacts')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row wide-border' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-60 col-md-30 col-md-push-30 margin-bottom-20' },
	              _react2.default.createElement(_components.ManageLink, {
	                className: 'section',
	                link: '/contacts/groups',
	                header: t('Manage groups'),
	                text: t('Click here to create and manage your recipients groups')
	              }),
	              _react2.default.createElement(
	                'h3',
	                null,
	                t('Create new contact')
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'h5',
	                  null,
	                  t('Option'),
	                  ' 1'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'hint small' },
	                  t('You can import recipients from csv file.')
	                ),
	                _react2.default.createElement(_components.ContactsImportButton, { onImport: this.reloadContactsPage })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'margin-top-20' },
	                _react2.default.createElement(
	                  'h5',
	                  null,
	                  t('Option'),
	                  ' 2'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'hint small' },
	                  t('Enter your contact manually using the form below.')
	                ),
	                _react2.default.createElement(_ContactForm2.default, { onAdd: this.reloadContactsPage })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-60 col-md-30 col-md-pull-30' },
	              _react2.default.createElement(_components.ContactsList, { limit: contactsListLimit, onDelete: this.reloadContactsPage })
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return Contacts;
	}(_react.Component), _class3.propTypes = {
	  contactsCurrentPage: _propTypes2.default.number,
	  contactsList: _propTypes2.default.array,
	  contactsListLimit: _propTypes2.default.number,
	  kw: _propTypes2.default.string,
	  loadContacts: _propTypes2.default.func,
	  t: _propTypes2.default.func.isRequired
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'reloadContactsPage', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'reloadContactsPage'), _class2.prototype)), _class2)) || _class) || _class) || _class);
	exports.default = Contacts;
	module.exports = exports['default'];

/***/ }),
/* 2150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _contacts = __webpack_require__(61);
	
	var contactsActions = _interopRequireWildcard(_contacts);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _contacts2 = __webpack_require__(185);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var GroupContactsDeleteButton = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    checkedGroupContacts: (0, _contacts2.getCheckedGroupContactsArray)(state)
	  };
	}, (0, _extends3.default)({}, contactsActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(GroupContactsDeleteButton, _Component);
	
	  function GroupContactsDeleteButton() {
	    (0, _classCallCheck3.default)(this, GroupContactsDeleteButton);
	    return (0, _possibleConstructorReturn3.default)(this, (GroupContactsDeleteButton.__proto__ || (0, _getPrototypeOf2.default)(GroupContactsDeleteButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(GroupContactsDeleteButton, [{
	    key: 'deleteSelectedContacts',
	    value: function deleteSelectedContacts() {
	      var _props = this.props,
	          deleteGroupContacts = _props.deleteGroupContacts,
	          groupId = _props.groupId,
	          updateCheckedGroupContacts = _props.updateCheckedGroupContacts,
	          checkedGroupContacts = _props.checkedGroupContacts,
	          onDelete = _props.onDelete;
	
	      var promise = deleteGroupContacts({ contacts: checkedGroupContacts, groupId: groupId }).promise;
	      updateCheckedGroupContacts({});
	      onDelete({ count: checkedGroupContacts.length });
	      return promise;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          checkedGroupContacts = _props2.checkedGroupContacts;
	      var t = this.context.t;
	
	
	      if (!checkedGroupContacts.length) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(className) },
	        _react2.default.createElement(
	          _Button2.default,
	          { className: 'btn-default', onClick: this.deleteSelectedContacts },
	          t('Delete {{count}} contacts', { count: checkedGroupContacts.length })
	        )
	      );
	    }
	  }]);
	  return GroupContactsDeleteButton;
	}(_react.Component), _class3.propTypes = {
	  checkedGroupContacts: _propTypes2.default.array,
	  className: _propTypes2.default.string,
	  deleteGroupContacts: _propTypes2.default.func,
	  groupId: _propTypes2.default.number,
	  onDelete: _propTypes2.default.func,
	  updateCheckedGroupContacts: _propTypes2.default.func
	}, _class3.contextTypes = {
	  t: _propTypes2.default.func
	}, _class3.defaultProps = {
	  checkedGroupContacts: [],
	  onDelete: _noop3.default
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'deleteSelectedContacts', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'deleteSelectedContacts'), _class2.prototype)), _class2)) || _class);
	exports.default = GroupContactsDeleteButton;
	module.exports = exports['default'];

/***/ }),
/* 2151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _regenerator = __webpack_require__(138);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(137);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _promise = __webpack_require__(62);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClientSideComponent = __webpack_require__(30);
	
	var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactI18next = __webpack_require__(12);
	
	var _contacts = __webpack_require__(61);
	
	var contactsActions = _interopRequireWildcard(_contacts);
	
	var _reduxConnect = __webpack_require__(33);
	
	var _components = __webpack_require__(15);
	
	var _contacts2 = __webpack_require__(185);
	
	var _asyncPromise = __webpack_require__(43);
	
	var _asyncPromise2 = _interopRequireDefault(_asyncPromise);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _Page = __webpack_require__(350);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _AddContactField = __webpack_require__(2147);
	
	var _AddContactField2 = _interopRequireDefault(_AddContactField);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _Hint = __webpack_require__(2020);
	
	var _Hint2 = _interopRequireDefault(_Hint);
	
	var _GroupContactsHeadLine = __webpack_require__(2014);
	
	var _GroupContactsHeadLine2 = _interopRequireDefault(_GroupContactsHeadLine);
	
	var _BackButton = __webpack_require__(256);
	
	var _BackButton2 = _interopRequireDefault(_BackButton);
	
	var _Pagination = __webpack_require__(351);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	var _contacts3 = __webpack_require__(868);
	
	var _reactScroll = __webpack_require__(251);
	
	var _reactScroll2 = _interopRequireDefault(_reactScroll);
	
	var _GroupContactsListWrapper = __webpack_require__(2017);
	
	var _GroupContactsListWrapper2 = _interopRequireDefault(_GroupContactsListWrapper);
	
	var _GroupContactsDeleteButton = __webpack_require__(2150);
	
	var _GroupContactsDeleteButton2 = _interopRequireDefault(_GroupContactsDeleteButton);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1350);
	
	var scroll = _reactScroll2.default.animateScroll;
	
	var GroupContacts = (_dec = (0, _reduxConnect.asyncConnect)([{
	  promise: function promise(_ref) {
	    var dispatch = _ref.store.dispatch,
	        groupId = _ref.params.groupId;
	
	    var promises = [];
	    groupId = Number(groupId); // eslint-disable-line no-param-reassign
	    promises.push(dispatch(contactsActions.loadGroupContacts(groupId)).promise);
	    promises.push(dispatch(contactsActions.loadContacts()).promise);
	    promises.push(dispatch(contactsActions.loadGroups()).promise);
	    return (0, _asyncPromise2.default)(_promise2.default.all(promises));
	  }
	}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
	  var contactsEntities = (0, _contacts2.getFilteredGroupContactsPage)(state);
	  return {
	    group: (0, _contacts2.getGroup)(state),
	    groupContactsCount: contactsEntities.count,
	    groupContactsCountAll: contactsEntities.countAll,
	    groupId: Number(ownProps.params.groupId),
	    groupsListLoading: state.contacts.groupsListLoading,
	    kw: state.contacts.groupContactsKw,
	    page: state.contacts.groupContactsPage
	  };
	}, (0, _extends3.default)({}, contactsActions)), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(GroupContacts, _Component);
	
	  function GroupContacts() {
	    (0, _classCallCheck3.default)(this, GroupContacts);
	    return (0, _possibleConstructorReturn3.default)(this, (GroupContacts.__proto__ || (0, _getPrototypeOf2.default)(GroupContacts)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(GroupContacts, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.updateCheckedGroupContacts({});
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.updateCheckedGroupContacts({});
	    }
	  }, {
	    key: 'onImport',
	    value: function onImport() {
	      var groupId = this.props.groupId;
	
	      this.props.loadGroupContacts(groupId);
	    }
	  }, {
	    key: 'onContactAdd',
	    value: function () {
	      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(contact) {
	        var _props, t, addContact, moveContactToGroup, groupId, showSuccessToastr;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _props = this.props, t = _props.t, addContact = _props.addContact, moveContactToGroup = _props.moveContactToGroup, groupId = _props.groupId;
	
	                showSuccessToastr = function showSuccessToastr() {
	                  return _toastr2.default.success(t('Contact added'));
	                };
	
	                if (!contact.id) {
	                  _context.next = 7;
	                  break;
	                }
	
	                moveContactToGroup({ contact: contact, groupId: groupId });
	                showSuccessToastr();
	                _context.next = 16;
	                break;
	
	              case 7:
	                _context.prev = 7;
	                _context.next = 10;
	                return addContact((0, _extends3.default)({}, contact, { groupId: groupId })).promise;
	
	              case 10:
	                showSuccessToastr();
	                _context.next = 16;
	                break;
	
	              case 13:
	                _context.prev = 13;
	                _context.t0 = _context['catch'](7);
	
	                console.log(_context.t0);
	
	              case 16:
	                return _context.abrupt('return', true);
	
	              case 17:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[7, 13]]);
	      }));
	
	      function onContactAdd(_x) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return onContactAdd;
	    }()
	  }, {
	    key: 'onPageChange',
	    value: function onPageChange(_ref3) {
	      var page = _ref3.page;
	
	      this.props.setGroupContactsPage({ page: page });
	      scroll.scrollToTop();
	    }
	  }, {
	    key: 'onDelete',
	    value: function onDelete() {
	      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref4$count = _ref4.count,
	          count = _ref4$count === undefined ? 1 : _ref4$count;
	
	      var t = this.props.t;
	
	      _toastr2.default.success(t('{{count}} contacts deleted', { count: count }));
	    }
	  }, {
	    key: 'deleteGroupContact',
	    value: function deleteGroupContact(contact) {
	      var _props2 = this.props,
	          deleteGroupContact = _props2.deleteGroupContact,
	          groupId = _props2.groupId;
	
	      deleteGroupContact({ contact: contact, groupId: groupId });
	      this.onDelete();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          t = _props3.t,
	          groupId = _props3.groupId,
	          kw = _props3.kw,
	          group = _props3.group,
	          groupsListLoading = _props3.groupsListLoading,
	          page = _props3.page,
	          groupContactsCount = _props3.groupContactsCount,
	          groupContactsCountAll = _props3.groupContactsCountAll,
	          filterGroupContacts = _props3.filterGroupContacts;
	
	
	      return _react2.default.createElement(
	        _Page2.default,
	        { header: t('Group: {{groupName}}', { groupName: group.name }), className: styles.page },
	        _react2.default.createElement(_BackButton2.default, { backUrl: '/contacts/groups', asBlock: true, className: 'margin-bottom-20' }),
	        _react2.default.createElement(_components.Loader, { show: groupsListLoading, small: true, inline: true }),
	        _react2.default.createElement(
	          _Hint2.default,
	          null,
	          t('Manage your contacts in this group')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.form },
	          _react2.default.createElement(
	            'h3',
	            null,
	            t('Add user')
	          ),
	          _react2.default.createElement(
	            _Hint2.default,
	            { small: true },
	            t('The new contact will be added to the group.')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: styles.optionContainer },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'h5',
	                null,
	                t('Option'),
	                ' 1'
	              ),
	              _react2.default.createElement(
	                _Hint2.default,
	                { small: true },
	                t('You can import recipients from csv file.')
	              )
	            ),
	            _react2.default.createElement(_components.ContactsImportButton, { groupId: groupId, onImport: this.onImport, hintBefore: true })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: styles.optionContainer },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'h5',
	                null,
	                t('Option'),
	                ' 2'
	              ),
	              _react2.default.createElement(
	                _Hint2.default,
	                { small: true },
	                t('Enter email or contact.')
	              )
	            ),
	            _react2.default.createElement(_AddContactField2.default, {
	              groupId: groupId,
	              onAdd: this.onContactAdd
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          t('List of contacts in the group')
	        ),
	        _react2.default.createElement(_GroupContactsHeadLine2.default, {
	          className: styles.headLine,
	          count: groupContactsCountAll,
	          kw: kw,
	          filter: filterGroupContacts
	        }),
	        _react2.default.createElement(
	          _Hint2.default,
	          { small: true, className: 'margin-vert-10' },
	          t('Select to remove contacts from Group')
	        ),
	        _react2.default.createElement(_GroupContactsListWrapper2.default, {
	          onDelete: this.deleteGroupContact,
	          onSelectionChange: this.onSelectionChange
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: styles.bottomLine },
	          _react2.default.createElement(_GroupContactsDeleteButton2.default, {
	            className: styles.buttonContainer,
	            groupId: groupId,
	            onDelete: this.onDelete
	          }),
	          _react2.default.createElement(_Pagination2.default, {
	            className: styles.pagination,
	            count: groupContactsCount,
	            limit: _contacts3.pageLimit,
	            onChange: this.onPageChange,
	            page: page,
	            checkMaxPage: true
	          })
	        )
	      );
	    }
	  }]);
	  return GroupContacts;
	}(_ClientSideComponent2.default), _class3.propTypes = {
	  addContact: _propTypes2.default.func,
	  deleteGroupContact: _propTypes2.default.func,
	  filterGroupContacts: _propTypes2.default.func,
	  group: _propTypes2.default.object,
	  groupContactsCount: _propTypes2.default.number,
	  groupContactsCountAll: _propTypes2.default.number,
	  groupId: _propTypes2.default.number,
	  groupsListLoading: _propTypes2.default.bool,
	  kw: _propTypes2.default.string,
	  loadGroupContacts: _propTypes2.default.func,
	  moveContactToGroup: _propTypes2.default.func,
	  page: _propTypes2.default.number,
	  setGroupContactsPage: _propTypes2.default.func,
	  t: _propTypes2.default.func,
	  updateCheckedGroupContacts: _propTypes2.default.func
	}, _class3.defaultProps = {
	  checkedGroupContacts: [],
	  groupContacts: [],
	  groupContactsCount: 0,
	  groupContactsCountAll: 0
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onImport', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onImport'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onContactAdd', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onContactAdd'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onPageChange', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onPageChange'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onDelete', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onDelete'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'deleteGroupContact', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'deleteGroupContact'), _class2.prototype)), _class2)) || _class) || _class) || _class);
	exports.default = GroupContacts;
	module.exports = exports['default'];

/***/ }),
/* 2152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactI18next = __webpack_require__(12);
	
	var _reduxForm = __webpack_require__(50);
	
	var _contacts = __webpack_require__(61);
	
	var _components = __webpack_require__(15);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var GroupForm = (_dec = (0, _reactRedux.connect)(null, { addGroup: _contacts.addGroup }), _dec2 = (0, _reduxForm.reduxForm)({
	  form: 'groupForm',
	  propNamespace: 'groupForm',
	  initialValues: { name: '' }
	}), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(GroupForm, _Component);
	
	  function GroupForm() {
	    (0, _classCallCheck3.default)(this, GroupForm);
	    return (0, _possibleConstructorReturn3.default)(this, (GroupForm.__proto__ || (0, _getPrototypeOf2.default)(GroupForm)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(GroupForm, [{
	    key: 'addGroup',
	    value: function addGroup(formData) {
	      var reset = this.props.groupForm.reset;
	      var name = formData.name;
	
	      var promise = this.props.addGroup(name).promise;
	      promise.then(reset);
	      return promise;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          t = _props.t,
	          _props$groupForm = _props.groupForm,
	          handleSubmit = _props$groupForm.handleSubmit,
	          submitting = _props$groupForm.submitting,
	          invalid = _props$groupForm.invalid;
	
	
	      return _react2.default.createElement(
	        'form',
	        { className: 'table', onSubmit: handleSubmit(this.addGroup) },
	        _react2.default.createElement(
	          'div',
	          { className: 'table-cell' },
	          _react2.default.createElement(
	            'div',
	            { className: 'formLabel' },
	            t('Group name'),
	            ':'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'table-cell' },
	          _react2.default.createElement(_reduxForm.Field, { component: 'input', name: 'name', type: 'text', className: 'width-perc-100' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'hint small' },
	            t('Add additional group here.')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'table-cell' },
	          _react2.default.createElement(
	            'button',
	            { type: 'submit', className: 'btn btn-simple squared small margin-left-5 pos-rel', disabled: submitting || invalid },
	            t('Add'),
	            submitting && _react2.default.createElement(_components.Loader, { small: true, mask: true })
	          )
	        )
	      );
	    }
	  }]);
	  return GroupForm;
	}(_react.Component), _class3.propTypes = {
	  addGroup: _propTypes2.default.func,
	  groupForm: _propTypes2.default.object,
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'addGroup', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'addGroup'), _class2.prototype)), _class2)) || _class) || _class) || _class);
	exports.default = GroupForm;
	module.exports = exports['default'];

/***/ }),
/* 2153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _dec2, _dec3, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(55);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactRedux = __webpack_require__(11);
	
	var _contacts = __webpack_require__(61);
	
	var contactsActions = _interopRequireWildcard(_contacts);
	
	var _reduxConnect = __webpack_require__(33);
	
	var _components = __webpack_require__(15);
	
	var _GroupForm = __webpack_require__(2152);
	
	var _GroupForm2 = _interopRequireDefault(_GroupForm);
	
	var _reactI18next = __webpack_require__(12);
	
	var _asyncPromise = __webpack_require__(43);
	
	var _asyncPromise2 = _interopRequireDefault(_asyncPromise);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Groups = (_dec = (0, _reduxConnect.asyncConnect)([{
	  promise: function promise(_ref) {
	    var dispatch = _ref.store.dispatch;
	    return (0, _asyncPromise2.default)(dispatch(contactsActions.loadGroups()).promise);
	  }
	}]), _dec2 = (0, _reactRedux.connect)(null, (0, _extends3.default)({}, contactsActions)), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(Groups, _Component);
	
	  function Groups() {
	    (0, _classCallCheck3.default)(this, Groups);
	    return (0, _possibleConstructorReturn3.default)(this, (Groups.__proto__ || (0, _getPrototypeOf2.default)(Groups)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Groups, [{
	    key: 'render',
	    value: function render() {
	      var t = this.props.t;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(_reactHelmet2.default, { title: 'Groups' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'container-fluid' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            t('Groups')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row wide-border' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-60 col-md-30 col-md-push-30 margin-bottom-20' },
	              _react2.default.createElement(_components.ManageLink, {
	                className: 'section',
	                link: '/contacts',
	                header: t('Manage contacts'),
	                isBack: true,
	                text: t('Click here to create and manage your recipients contacts')
	              }),
	              _react2.default.createElement(
	                'h3',
	                null,
	                t('Create new group')
	              ),
	              _react2.default.createElement(_GroupForm2.default, null)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-60 col-md-30 col-md-pull-30' },
	              _react2.default.createElement(_components.GroupsList, null)
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return Groups;
	}(_react.Component), _class2.propTypes = {
	  t: _propTypes2.default.func.isRequired
	}, _temp)) || _class) || _class) || _class);
	exports.default = Groups;
	module.exports = exports['default'];

/***/ }),
/* 2154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GroupContacts = exports.Groups = exports.Contacts = undefined;
	
	var _Contacts2 = __webpack_require__(2149);
	
	var _Contacts3 = _interopRequireDefault(_Contacts2);
	
	var _Groups2 = __webpack_require__(2153);
	
	var _Groups3 = _interopRequireDefault(_Groups2);
	
	var _GroupContacts2 = __webpack_require__(2151);
	
	var _GroupContacts3 = _interopRequireDefault(_GroupContacts2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Contacts = _Contacts3.default;
	exports.Groups = _Groups3.default;
	exports.GroupContacts = _GroupContacts3.default;

/***/ }),
/* 2155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(55);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactI18next = __webpack_require__(12);
	
	var _downloads = __webpack_require__(262);
	
	var _config = __webpack_require__(41);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _playlist = __webpack_require__(217);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _auth = __webpack_require__(31);
	
	var _responseCodes = __webpack_require__(99);
	
	var _LoginDialog = __webpack_require__(863);
	
	var _LoginDialog2 = _interopRequireDefault(_LoginDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var isAuthRequireCode = function isAuthRequireCode(code) {
	  return [_responseCodes.downloadTracksCodes.needLogin, _responseCodes.downloadTracksCodes.requireAuth].includes(code);
	};
	
	var Download = (_dec = (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    downloadFileFromKeyCode: state.playlist.downloadFileFromKeyCode,
	    downloadKey: ownProps.location.query.key,
	    user: state.auth.user
	  };
	}, { downloadFileFromKey: _playlist.downloadFileFromKey, setRedirect: _auth.setRedirect }), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(Download, _Component);
	
	  function Download() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, Download);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = Download.__proto__ || (0, _getPrototypeOf2.default)(Download)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = {};
	    return _this;
	  }
	
	  (0, _createClass3.default)(Download, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.download();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var code = this.props.downloadFileFromKeyCode;
	      if (!prevProps.user && this.props.user && isAuthRequireCode(code)) {
	        this.download();
	      }
	    }
	  }, {
	    key: 'download',
	    value: function download() {
	      var _this2 = this;
	
	      var _props = this.props,
	          downloadKey = _props.downloadKey,
	          user = _props.user;
	
	
	      this.props.downloadFileFromKey(downloadKey).promise.then(function () {
	        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	            code = _ref2.code,
	            msg = _ref2.msg,
	            data = _ref2.data;
	
	        if (isAuthRequireCode(code)) {
	          if (!user) {
	            _this2.props.setRedirect('/service/download?key=' + downloadKey);
	            _this2.loginDialogEl.open();
	          }
	        } else if (code) {
	          _toastr2.default.warning(msg);
	        }
	        var file = data.file;
	
	        if (file) {
	          (0, _downloads.download)('' + _config2.default.app.urlParts.audioArchive + file);
	        }
	      }).catch(function (err) {
	        return err;
	      });
	    }
	  }, {
	    key: 'bindDialog',
	    value: function bindDialog(el) {
	      if (el) {
	        this.loginDialogEl = el.getWrappedInstance().getWrappedInstance();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          t = _props2.t,
	          downloadFileFromKeyCode = _props2.downloadFileFromKeyCode,
	          user = _props2.user;
	
	      var isAuthRequired = isAuthRequireCode(downloadFileFromKeyCode) && !user;
	      var isWrongUser = isAuthRequireCode(downloadFileFromKeyCode) && user;
	      var loginMsg = t('Please login to download your content');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'compactContent' },
	        _react2.default.createElement(_reactHelmet2.default, { title: t('Download') }),
	        _react2.default.createElement(
	          'h1',
	          null,
	          t('Downloading'),
	          '...'
	        ),
	        isAuthRequired && _react2.default.createElement(
	          'p',
	          null,
	          loginMsg
	        ),
	        isWrongUser && _react2.default.createElement(
	          'p',
	          { className: 'danger' },
	          t('You don\'t have a permissions to download this file')
	        ),
	        !isAuthRequired && !isWrongUser && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            t('Your file should start downloading in just a moment.')
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            t('If your download doesn\'t start automatically'),
	            _react2.default.createElement(
	              'a',
	              { className: 'margin-left-5 margin-right-5', onClick: this.download },
	              t('click here')
	            ),
	            t('to get your file'),
	            '.'
	          )
	        ),
	        _react2.default.createElement(_LoginDialog2.default, { ref: this.bindDialog, hint: loginMsg })
	      );
	    }
	  }]);
	  return Download;
	}(_react.Component), _class3.propTypes = {
	  downloadFileFromKey: _propTypes2.default.func,
	  downloadFileFromKeyCode: _propTypes2.default.number,
	  downloadKey: _propTypes2.default.string,
	  setRedirect: _propTypes2.default.func,
	  t: _propTypes2.default.func,
	  user: _propTypes2.default.object
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'download', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'download'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'bindDialog', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'bindDialog'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = Download;
	module.exports = exports['default'];

/***/ }),
/* 2156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(58);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClientSideComponent = __webpack_require__(30);
	
	var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	var _network = __webpack_require__(528);
	
	var _utils = __webpack_require__(24);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var DropboxAuth = (_dec = (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    response: (0, _network.parseHash)(ownProps.location.hash)
	  };
	}), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(DropboxAuth, _Component);
	
	  function DropboxAuth() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, DropboxAuth);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = DropboxAuth.__proto__ || (0, _getPrototypeOf2.default)(DropboxAuth)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { response: {} };
	    return _this;
	  }
	
	  (0, _createClass3.default)(DropboxAuth, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _get3.default)(DropboxAuth.prototype.__proto__ || (0, _getPrototypeOf2.default)(DropboxAuth.prototype), 'componentDidMount', this).call(this, this.onMount);
	    }
	  }, {
	    key: 'onMount',
	    value: function onMount() {
	      var response = this.props.response;
	
	      this.setState({ response: response });
	      window.opener.dispatchEvent((0, _utils.customEvent)('onDropboxAuth', response));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var t = this.props.t;
	      var response = this.state.response;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'compactContent' },
	        response.error_description ? _react2.default.createElement(
	          'div',
	          { className: 'error' },
	          response.error_description
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          t('Loading...'),
	          _react2.default.createElement(_components.Loader, { mask: true })
	        )
	      );
	    }
	  }]);
	  return DropboxAuth;
	}(_ClientSideComponent2.default), _class3.propTypes = {
	  response: _propTypes2.default.object,
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onMount', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onMount'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = DropboxAuth;
	module.exports = exports['default'];

/***/ }),
/* 2157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(55);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactI18next = __webpack_require__(12);
	
	var _account = __webpack_require__(184);
	
	var _components = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmailConfirm = (_dec = (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    addEmailConfirmError: state.account.addEmailConfirmLoadError,
	    addEmailConfirmLoaded: state.account.addEmailConfirmLoaded,
	    addEmailConfirmLoading: state.account.addEmailConfirmLoading,
	    emailCode: ownProps.location.query.code,
	    emailKey: ownProps.location.query.key
	  };
	}, { addEmailConfirm: _account.addEmailConfirm }), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(EmailConfirm, _Component);
	
	  function EmailConfirm() {
	    (0, _classCallCheck3.default)(this, EmailConfirm);
	    return (0, _possibleConstructorReturn3.default)(this, (EmailConfirm.__proto__ || (0, _getPrototypeOf2.default)(EmailConfirm)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(EmailConfirm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          emailKey = _props.emailKey,
	          emailCode = _props.emailCode;
	
	      this.props.addEmailConfirm(emailKey, emailCode);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          t = _props2.t,
	          addEmailConfirmLoading = _props2.addEmailConfirmLoading,
	          addEmailConfirmLoaded = _props2.addEmailConfirmLoaded,
	          addEmailConfirmError = _props2.addEmailConfirmError;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'compactContent' },
	        _react2.default.createElement(_reactHelmet2.default, { title: t('Confirm email') }),
	        _react2.default.createElement(
	          'h1',
	          null,
	          t('Confirm email address')
	        ),
	        addEmailConfirmLoading && _react2.default.createElement(_components.Loader, null),
	        addEmailConfirmLoaded && _react2.default.createElement(
	          'div',
	          { className: 'h3 colorSuccess' },
	          t('Email was successfully added')
	        ),
	        addEmailConfirmError && _react2.default.createElement(
	          'div',
	          { className: 'colorError' },
	          addEmailConfirmError.msg
	        )
	      );
	    }
	  }]);
	  return EmailConfirm;
	}(_react.Component), _class2.propTypes = {
	  addEmailConfirm: _propTypes2.default.func,
	  addEmailConfirmError: _propTypes2.default.object,
	  addEmailConfirmLoaded: _propTypes2.default.bool,
	  addEmailConfirmLoading: _propTypes2.default.bool,
	  emailCode: _propTypes2.default.string,
	  emailKey: _propTypes2.default.string,
	  t: _propTypes2.default.func
	}, _temp)) || _class) || _class);
	exports.default = EmailConfirm;
	module.exports = exports['default'];

/***/ }),
/* 2158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _auth = __webpack_require__(31);
	
	var authActions = _interopRequireWildcard(_auth);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var ForgotPasswordDialog = (_dec = (0, _reactRedux.connect)(null, (0, _extends3.default)({}, authActions), null, { withRef: true }), _dec2 = (0, _reactI18next.translate)(['common'], { withRef: true }), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(ForgotPasswordDialog, _Component);
	
	  function ForgotPasswordDialog() {
	    (0, _classCallCheck3.default)(this, ForgotPasswordDialog);
	    return (0, _possibleConstructorReturn3.default)(this, (ForgotPasswordDialog.__proto__ || (0, _getPrototypeOf2.default)(ForgotPasswordDialog)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ForgotPasswordDialog, [{
	    key: 'open',
	    value: function open() {
	      this.modal.open();
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.modal.close();
	    }
	  }, {
	    key: 'afterSet',
	    value: function afterSet() {
	      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var _props = this.props,
	          t = _props.t,
	          login = _props.login;
	
	      this.close();
	      _toastr2.default.success(t('Password successfully created'));
	      login(data.email, data.newPassword);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          t = _props2.t,
	          passwordCode = _props2.passwordCode,
	          passwordEmail = _props2.passwordEmail,
	          passwordKey = _props2.passwordKey,
	          isNew = _props2.isNew,
	          step = _props2.step;
	
	      var modalProps = {
	        backdrop: 'static',
	        closeByEsc: false,
	        title: passwordCode ? isNew ? t('Create password') : t('New password') : t('Forgot password')
	      };
	
	      return _react2.default.createElement(
	        _components.Modal,
	        (0, _extends3.default)({ ref: function ref(el) {
	            return _this2.modal = el;
	          } }, modalProps),
	        _react2.default.createElement(_components.ForgotPasswordForm, {
	          passwordCode: passwordCode,
	          passwordEmail: passwordEmail,
	          passwordKey: passwordKey,
	          isNew: isNew,
	          step: step,
	          afterSet: this.afterSet
	        })
	      );
	    }
	  }]);
	  return ForgotPasswordDialog;
	}(_react.Component), _class3.propTypes = {
	  isNew: _propTypes2.default.bool,
	  login: _propTypes2.default.func,
	  passwordCode: _propTypes2.default.string,
	  passwordEmail: _propTypes2.default.string,
	  passwordKey: _propTypes2.default.string,
	  step: _propTypes2.default.string,
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'afterSet', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'afterSet'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = ForgotPasswordDialog;
	module.exports = exports['default'];

/***/ }),
/* 2159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(58);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClientSideComponent = __webpack_require__(30);
	
	var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);
	
	var _reactHelmet = __webpack_require__(55);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactI18next = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(11);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _auth = __webpack_require__(31);
	
	var authActions = _interopRequireWildcard(_auth);
	
	var _containers = __webpack_require__(213);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1351);
	var mouseImg = __webpack_require__(2301);
	
	var fixedHeaderHeight = 70;
	
	var Home = (_dec = (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    action: ownProps.params.action,
	    isMobile: state.common.isMobile,
	    isNewPassword: !!Number(ownProps.location.query.new),
	    pathname: ownProps.location.pathname,
	    queryCode: ownProps.location.query.code,
	    queryEmail: ownProps.location.query.email,
	    queryKey: ownProps.location.query.key
	  };
	}, (0, _extends3.default)({}, authActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(Home, _Component);
	
	  function Home() {
	    (0, _classCallCheck3.default)(this, Home);
	    return (0, _possibleConstructorReturn3.default)(this, (Home.__proto__ || (0, _getPrototypeOf2.default)(Home)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Home, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _get3.default)(Home.prototype.__proto__ || (0, _getPrototypeOf2.default)(Home.prototype), 'componentDidMount', this).call(this, this.initVideo, 500);
	
	      var pathname = this.props.pathname;
	
	      if (pathname.startsWith('/password')) {
	        this.openForgotPasswordForm();
	      }
	    }
	  }, {
	    key: 'initVideo',
	    value: function initVideo() {
	      var isMobile = this.props.isMobile;
	
	
	      if (!isMobile) {
	        if (!this.videoEl.paused) {
	          return false;
	        }
	        window.addEventListener('touchstart', function videoStart() {
	          this.videoEl.play();
	          this.removeEventListener('touchstart', videoStart);
	        });
	      }
	    }
	  }, {
	    key: 'openContactForm',
	    value: function openContactForm() {
	      this.loginContactEl.getWrappedInstance().open();
	    }
	  }, {
	    key: 'openForgotPasswordForm',
	    value: function openForgotPasswordForm() {
	      this.forgotPasswordDialogEl.getWrappedInstance().getWrappedInstance().open();
	    }
	  }, {
	    key: 'scrollBottom',
	    value: function scrollBottom() {
	      var copyrightElRect = this.copyrightEl.getBoundingClientRect();
	      window.scroll({ top: copyrightElRect.bottom + scrollY - fixedHeaderHeight, left: 0, behavior: 'smooth' });
	    }
	
	    /* eslint-disable max-len */
	
	  }, {
	    key: 'renderFeatures',
	    value: function renderFeatures() {
	      var t = this.props.t;
	
	      var features = [{
	        title: t('Powerful collaboration and workflow platform'),
	        text: t('Make managing your entire creative process more effective. Create teams and share projects globally within your organisation giving you total control of who has access to distribute and receive content.'),
	        feedback: {
	          text: '',
	          author: '',
	          company: ''
	        },
	        graphics: __webpack_require__(2297),
	        icon: __webpack_require__(2298)
	      }, {
	        title: t('Secure'),
	        text: t('Using the highest security protocols combined with proprietary Watermark technology, your content is safe with us. In the event of a leak you will know who is responsible. Cybersecurity an arms race and we constantly review the body of technologies, processes and practices designed to protect our networks and data from attack, damage or unauthorized access.'),
	        feedback: {
	          text: '',
	          author: '',
	          company: ''
	        },
	        graphics: __webpack_require__(2306),
	        icon: __webpack_require__(2307)
	      }, {
	        title: t('Simple'),
	        text: t('Using our intuitive interface you will be sending out music securely in no time at all. Reach your target audience within minutes. No more CD\'s, no Courier costs, no pain, no waste.'),
	        feedback: {
	          text: '',
	          author: '',
	          company: ''
	        },
	        graphics: __webpack_require__(2308),
	        icon: __webpack_require__(2309)
	      }, {
	        title: t('Quick Send'),
	        text: t('In a rush...? Try out our new Quick Send feature. Send tracks in just seconds. Don\'t compromise your IP by using available cloud services such as Dropbox, Google or Box, Take advantage of our secure environment and all of our security features. Everything will be Watermarked for you automatically when you use this feature.'),
	        feedback: {
	          text: '',
	          author: '',
	          company: ''
	        },
	        graphics: __webpack_require__(2302),
	        icon: __webpack_require__(2303)
	      }, {
	        title: t('Mobile and apps'),
	        text: t('Work from anywhere and also use our apps when you\'re on the go, available for iOS and Android. Listen offline, create Playlists and send feedback directly from the app.'),
	        feedback: {
	          text: '',
	          author: '',
	          company: ''
	        },
	        graphics: __webpack_require__(2299),
	        icon: __webpack_require__(2300)
	      }, {
	        title: t('Reporting'),
	        text: t('Track the performance of your campaigns through metrics, such as user activity, location, duration and frequency of use; helping you better to engage, understand and effectively target your audience.'),
	        feedback: {
	          text: '',
	          author: '',
	          company: ''
	        },
	        graphics: __webpack_require__(2304),
	        icon: __webpack_require__(2305)
	      }];
	
	      var getTextPart = function getTextPart(feature) {
	        return _react2.default.createElement(
	          'div',
	          { className: styles.textBlock },
	          _react2.default.createElement(
	            'div',
	            { className: styles.header },
	            _react2.default.createElement('img', { src: feature.icon, className: styles.headIcon, alt: '' }),
	            _react2.default.createElement(
	              'span',
	              { className: styles.title },
	              feature.title
	            )
	          ),
	          _react2.default.createElement('img', { src: feature.graphics, className: (0, _bind2.default)(styles.graphics, 'visible-xs-inline'), alt: '' }),
	          _react2.default.createElement(
	            'div',
	            { className: styles.text },
	            feature.text
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: styles.feedback },
	            feature.feedback.text && _react2.default.createElement(
	              'div',
	              { className: styles.feedbackText },
	              '"',
	              feature.feedback.text,
	              '"'
	            ),
	            feature.feedback.author && _react2.default.createElement(
	              'div',
	              { className: styles.feedbackAuthor },
	              feature.feedback.author,
	              ', ',
	              feature.feedback.company
	            )
	          )
	        );
	      };
	
	      var getGraphicsPart = function getGraphicsPart(feature) {
	        return _react2.default.createElement('img', { src: feature.graphics, className: (0, _bind2.default)(styles.graphics, 'hidden-xs'), alt: '' });
	      };
	
	      /* eslint-disable react/no-array-index-key */
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(styles.features) },
	        _react2.default.createElement(
	          'div',
	          null,
	          features.map(function (feature, index) {
	            return _react2.default.createElement(
	              'div',
	              { key: index, className: styles.feature },
	              _react2.default.createElement(
	                'div',
	                { className: styles.left },
	                index % 2 === 0 ? getTextPart(feature) : getGraphicsPart(feature)
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: styles.right },
	                index % 2 ? getTextPart(feature) : getGraphicsPart(feature)
	              )
	            );
	          })
	        )
	      );
	      /* eslint-enable react/no-array-index-key */
	    }
	    /* eslint-enable max-len */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          t = _props.t,
	          queryCode = _props.queryCode,
	          queryKey = _props.queryKey,
	          isNewPassword = _props.isNewPassword,
	          action = _props.action,
	          isMobile = _props.isMobile,
	          queryEmail = _props.queryEmail;
	      var isMounted = this.state.isMounted;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.home },
	        _react2.default.createElement(_reactHelmet2.default, { title: 'Home' }),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _bind2.default)(styles.copyright, (0, _defineProperty3.default)({}, styles.withBg, isMobile && isMounted)), ref: function ref(el) {
	              return _this2.copyrightEl = el;
	            } },
	          _react2.default.createElement('div', { className: styles.mask }),
	          !isMobile && _react2.default.createElement(
	            'video',
	            { preload: 'auto', loop: true, autoPlay: true, ref: function ref(el) {
	                return _this2.videoEl = el;
	              } },
	            _react2.default.createElement('source', { src: 'https://s3-eu-west-1.amazonaws.com/crightvideo/crightLanding.mp4', type: 'video/mp4' }),
	            _react2.default.createElement('source', { src: 'https://s3-eu-west-1.amazonaws.com/crightvideo/crightLanding.webm', type: 'video/webm' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _bind2.default)('homeContent', styles.content) },
	            _react2.default.createElement(
	              'div',
	              { className: styles.title },
	              t('protect your copyright!')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: styles.subTitle },
	              t('Secure digital content delivery')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: styles.text },
	              t('Use CRight to distribute your content to whoever you want whenever you want.'),
	              _react2.default.createElement('br', null),
	              t('You are in control - your content is only available to the people you authorize.')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: styles.buttonContainer },
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-accent big', onClick: this.openContactForm },
	                t('Contact Us')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: styles.scrollHint },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement('img', { src: mouseImg, alt: '' })
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement('i', { className: (0, _bind2.default)('icon-chevron-thin-down', styles.scrollButton), onClick: this.scrollBottom })
	            )
	          )
	        ),
	        this.renderFeatures(),
	        _react2.default.createElement(
	          'div',
	          { className: styles.moreLine },
	          _react2.default.createElement(
	            'span',
	            { className: styles.moreHeader },
	            t('And so much more')
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-accent', onClick: this.openContactForm },
	            t('Contact us')
	          )
	        ),
	        _react2.default.createElement(_containers.ForgotPasswordDialog, {
	          ref: function ref(el) {
	            return _this2.forgotPasswordDialogEl = el;
	          },
	          passwordKey: queryKey,
	          passwordEmail: queryEmail,
	          passwordCode: queryCode,
	          isNew: isNewPassword,
	          step: action
	        }),
	        _react2.default.createElement(_containers.LoginContact, { ref: function ref(el) {
	            return _this2.loginContactEl = el;
	          } })
	      );
	    }
	  }]);
	  return Home;
	}(_ClientSideComponent2.default), _class3.propTypes = {
	  action: _propTypes2.default.string,
	  isMobile: _propTypes2.default.bool,
	  isNewPassword: _propTypes2.default.bool,
	  pathname: _propTypes2.default.string,
	  queryCode: _propTypes2.default.string,
	  queryEmail: _propTypes2.default.string,
	  queryKey: _propTypes2.default.string,
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'initVideo', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'initVideo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'openContactForm', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'openContactForm'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'scrollBottom', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'scrollBottom'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'renderFeatures', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'renderFeatures'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = Home;
	module.exports = exports['default'];

/***/ }),
/* 2160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactRouterBootstrap = __webpack_require__(1774);
	
	var _NavItem = __webpack_require__(464);
	
	var _NavItem2 = _interopRequireDefault(_NavItem);
	
	var _reactI18next = __webpack_require__(12);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Info = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    user: state.auth.user
	  };
	}), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(Info, _Component);
	
	  function Info() {
	    (0, _classCallCheck3.default)(this, Info);
	    return (0, _possibleConstructorReturn3.default)(this, (Info.__proto__ || (0, _getPrototypeOf2.default)(Info)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Info, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          t = _props.t,
	          user = _props.user;
	
	      var styles = __webpack_require__(1352);
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(styles.infoPartition, { homeContent: !user, 'container-fluid': !!user }) },
	        _react2.default.createElement(
	          'ul',
	          { className: 'tabs' },
	          _react2.default.createElement(
	            _reactRouterBootstrap.LinkContainer,
	            { to: '/info/terms-of-service' },
	            _react2.default.createElement(
	              _NavItem2.default,
	              null,
	              t('terms of service')
	            )
	          ),
	          _react2.default.createElement(
	            _reactRouterBootstrap.LinkContainer,
	            { to: '/info/privacy-policy' },
	            _react2.default.createElement(
	              _NavItem2.default,
	              null,
	              t('privacy policy')
	            )
	          ),
	          _react2.default.createElement(
	            _reactRouterBootstrap.LinkContainer,
	            { to: '/info/security' },
	            _react2.default.createElement(
	              _NavItem2.default,
	              null,
	              t('security')
	            )
	          ),
	          _react2.default.createElement(
	            _reactRouterBootstrap.LinkContainer,
	            { to: '/info/copyright-policy' },
	            _react2.default.createElement(
	              _NavItem2.default,
	              null,
	              t('copyright policy')
	            )
	          ),
	          _react2.default.createElement(
	            _reactRouterBootstrap.LinkContainer,
	            { to: '/info/cookie-policy' },
	            _react2.default.createElement(
	              _NavItem2.default,
	              null,
	              t('cookie policy')
	            )
	          ),
	          _react2.default.createElement(
	            _reactRouterBootstrap.LinkContainer,
	            { to: '/info/contact-us' },
	            _react2.default.createElement(
	              _NavItem2.default,
	              null,
	              t('contact us')
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          this.props.mainChild
	        )
	      );
	    }
	  }]);
	  return Info;
	}(_react.Component), _class2.propTypes = {
	  mainChild: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  t: _propTypes2.default.func,
	  user: _propTypes2.default.object
	}, _temp)) || _class) || _class);
	exports.default = Info;
	module.exports = exports['default'];

/***/ }),
/* 2161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var LoginContact = (_dec = (0, _reactI18next.translate)(['common'], { withRef: true }), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(LoginContact, _Component);
	
	  function LoginContact() {
	    (0, _classCallCheck3.default)(this, LoginContact);
	    return (0, _possibleConstructorReturn3.default)(this, (LoginContact.__proto__ || (0, _getPrototypeOf2.default)(LoginContact)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LoginContact, [{
	    key: 'onSend',
	    value: function onSend() {
	      this.modal.close();
	      _toastr2.default.success(this.props.t('Enquiry sent'));
	    }
	  }, {
	    key: 'open',
	    value: function open() {
	      this.modal.open();
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.modal.close();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var modalBackdrop = 'static';
	      var isCloseByEscEnabled = false;
	      var t = this.props.t;
	
	
	      return _react2.default.createElement(
	        _components.Modal,
	        {
	          ref: function ref(el) {
	            return _this2.modal = el;
	          },
	          title: t('Contact us to find out more'),
	          backdrop: modalBackdrop,
	          closeByEsc: isCloseByEscEnabled
	        },
	        _react2.default.createElement(_components.LoginContactForm, { onSend: this.onSend })
	      );
	    }
	  }]);
	  return LoginContact;
	}(_react.Component), _class3.propTypes = {
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onSend', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSend'), _class2.prototype)), _class2)) || _class);
	exports.default = LoginContact;
	module.exports = exports['default'];

/***/ }),
/* 2162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _promise = __webpack_require__(62);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reduxConnect = __webpack_require__(33);
	
	var _asyncPromise = __webpack_require__(43);
	
	var _asyncPromise2 = _interopRequireDefault(_asyncPromise);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _SongsSelectButton = __webpack_require__(2101);
	
	var _SongsSelectButton2 = _interopRequireDefault(_SongsSelectButton);
	
	var _BackButton = __webpack_require__(256);
	
	var _BackButton2 = _interopRequireDefault(_BackButton);
	
	var _MyPlaylistInfo = __webpack_require__(2163);
	
	var _MyPlaylistInfo2 = _interopRequireDefault(_MyPlaylistInfo);
	
	var _myPlaylists = __webpack_require__(88);
	
	var myPlaylistsActions = _interopRequireWildcard(_myPlaylists);
	
	var _playlists = __webpack_require__(100);
	
	var playlistsActions = _interopRequireWildcard(_playlists);
	
	var _myPlaylists2 = __webpack_require__(361);
	
	var _Loader = __webpack_require__(60);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Page = __webpack_require__(350);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _MyPlaylistTracks = __webpack_require__(2168);
	
	var _MyPlaylistTracks2 = _interopRequireDefault(_MyPlaylistTracks);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1353);
	
	var MyPlaylist = (_dec = (0, _reduxConnect.asyncConnect)([{
	  promise: function promise(_ref) {
	    var dispatch = _ref.store.dispatch;
	
	    var promises = [];
	    if (!dispatch(myPlaylistsActions.isLoaded())) {
	      promises.push(dispatch(myPlaylistsActions.loadMyPlaylists()).promise);
	    }
	    if (!dispatch(playlistsActions.isLoaded())) {
	      promises.push(dispatch(playlistsActions.loadPlaylists()).promise);
	    }
	    return (0, _asyncPromise2.default)(_promise2.default.all(promises).catch(function (err) {
	      return err;
	    }));
	  }
	}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    addTracksActionData: state.myPlaylists.addMyPlaylistTracksActionData,
	    addTracksLoading: state.myPlaylists.addMyPlaylistTracksLoading,
	    myPlaylistId: ownProps.params.myPlaylistId,
	    myPlaylistsLoading: state.myPlaylists.myPlaylistsLoading,
	    playlist: (0, _myPlaylists2.getMyPlaylist)(state, ownProps.params.myPlaylistId),
	    playlistsLoading: state.playlists.playlistsLoading,
	    tracks: (0, _myPlaylists2.getMyPlaylisTracks)(state, ownProps.params.myPlaylistId)
	  };
	}, (0, _extends3.default)({}, myPlaylistsActions)), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(MyPlaylist, _Component);
	
	  function MyPlaylist() {
	    (0, _classCallCheck3.default)(this, MyPlaylist);
	    return (0, _possibleConstructorReturn3.default)(this, (MyPlaylist.__proto__ || (0, _getPrototypeOf2.default)(MyPlaylist)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MyPlaylist, [{
	    key: 'onAddSongs',
	    value: function onAddSongs(tracksId) {
	      var _props = this.props,
	          addMyPlaylistTracks = _props.addMyPlaylistTracks,
	          playlist = _props.playlist;
	
	      return addMyPlaylistTracks({ guids: [playlist.guid], tracksId: tracksId });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          t = _props2.t,
	          playlist = _props2.playlist,
	          myPlaylistsLoading = _props2.myPlaylistsLoading,
	          tracks = _props2.tracks,
	          addTracksLoading = _props2.addTracksLoading,
	          addTracksActionData = _props2.addTracksActionData,
	          playlistsLoading = _props2.playlistsLoading;
	
	      var isAdding = addTracksLoading && addTracksActionData.guids.includes(playlist.guid);
	      var isListLoading = isAdding || playlistsLoading;
	      var title = t('My Playlist');
	
	      return _react2.default.createElement(
	        _Page2.default,
	        { title: title, header: title },
	        _react2.default.createElement(
	          'div',
	          { className: styles.headLine },
	          _react2.default.createElement(_BackButton2.default, null),
	          _react2.default.createElement(_SongsSelectButton2.default, { onSave: this.onAddSongs })
	        ),
	        myPlaylistsLoading ? _react2.default.createElement(_Loader2.default, { alignCenter: true }) : _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_MyPlaylistInfo2.default, {
	            className: styles.info,
	            playlist: playlist,
	            tracksCount: tracks.length
	          }),
	          _react2.default.createElement(_MyPlaylistTracks2.default, {
	            playlist: playlist,
	            tracks: tracks,
	            loading: isListLoading
	          })
	        )
	      );
	    }
	  }]);
	  return MyPlaylist;
	}(_react.Component), _class3.propTypes = {
	  addMyPlaylistTracks: _propTypes2.default.func,
	  addTracksActionData: _propTypes2.default.object,
	  addTracksLoading: _propTypes2.default.bool,
	  myPlaylistsLoading: _propTypes2.default.bool,
	  playlist: _propTypes2.default.object,
	  playlistsLoading: _propTypes2.default.bool,
	  t: _propTypes2.default.func,
	  tracks: _propTypes2.default.array
	}, _class3.defaultProps = {
	  addTracksActionData: {},
	  playlist: {},
	  tracks: []
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onAddSongs', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onAddSongs'), _class2.prototype)), _class2)) || _class) || _class) || _class);
	exports.default = MyPlaylist;
	module.exports = exports['default'];

/***/ }),
/* 2163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _Thumb = __webpack_require__(259);
	
	var _Thumb2 = _interopRequireDefault(_Thumb);
	
	var _MyPlaylistName = __webpack_require__(2164);
	
	var _MyPlaylistName2 = _interopRequireDefault(_MyPlaylistName);
	
	var _TracksCount = __webpack_require__(858);
	
	var _TracksCount2 = _interopRequireDefault(_TracksCount);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(630);
	
	var MyPlaylistInfo = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(MyPlaylistInfo, _PureComponent);
	
	  function MyPlaylistInfo() {
	    (0, _classCallCheck3.default)(this, MyPlaylistInfo);
	    return (0, _possibleConstructorReturn3.default)(this, (MyPlaylistInfo.__proto__ || (0, _getPrototypeOf2.default)(MyPlaylistInfo)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MyPlaylistInfo, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          playlist = _props.playlist,
	          className = _props.className,
	          tracksCount = _props.tracksCount;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(styles.container, className) },
	        _react2.default.createElement(_Thumb2.default, {
	          asBackground: true,
	          defaultImageName: 'default-logo',
	          fileName: playlist.thumb,
	          className: styles.thumb
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: styles.textContainer },
	          _react2.default.createElement(_MyPlaylistName2.default, {
	            textClass: styles.name,
	            className: styles.title,
	            playlist: playlist
	          }),
	          _react2.default.createElement(_TracksCount2.default, { count: tracksCount })
	        )
	      );
	    }
	  }]);
	  return MyPlaylistInfo;
	}(_react.PureComponent), _class2.propTypes = {
	  className: _propTypes2.default.string,
	  playlist: _propTypes2.default.object,
	  tracksCount: _propTypes2.default.number
	}, _class2.defaultProps = {
	  playlist: {},
	  tracksCount: 0
	}, _temp)) || _class);
	exports.default = MyPlaylistInfo;
	module.exports = exports['default'];

/***/ }),
/* 2164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _regenerator = __webpack_require__(138);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(137);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _myPlaylists = __webpack_require__(88);
	
	var myPlaylistsActions = _interopRequireWildcard(_myPlaylists);
	
	var _audioplayer = __webpack_require__(83);
	
	var audioplayerActions = _interopRequireWildcard(_audioplayer);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _EditableField = __webpack_require__(821);
	
	var _EditableField2 = _interopRequireDefault(_EditableField);
	
	var _myPlaylists2 = __webpack_require__(527);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(630);
	
	var MyPlaylistName = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    playerAlbum: state.audioplayer.album,
	    updateMyPlaylistsLoading: state.myPlaylists.updateMyPlaylistsLoading
	  };
	}, (0, _extends3.default)({}, myPlaylistsActions, audioplayerActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(MyPlaylistName, _Component);
	
	  function MyPlaylistName() {
	    (0, _classCallCheck3.default)(this, MyPlaylistName);
	    return (0, _possibleConstructorReturn3.default)(this, (MyPlaylistName.__proto__ || (0, _getPrototypeOf2.default)(MyPlaylistName)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MyPlaylistName, [{
	    key: 'saveName',
	    value: function () {
	      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(name) {
	        var _props, updateMyPlaylistName, playlist, playerAlbum, updateAlbumName;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _props = this.props, updateMyPlaylistName = _props.updateMyPlaylistName, playlist = _props.playlist, playerAlbum = _props.playerAlbum, updateAlbumName = _props.updateAlbumName;
	                _context.next = 3;
	                return updateMyPlaylistName({ guid: playlist.guid, name: name }).promise;
	
	              case 3:
	                if (playerAlbum.projectId === playlist.guid) {
	                  updateAlbumName({ name: name });
	                }
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function saveName(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return saveName;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          playlist = _props2.playlist,
	          updateMyPlaylistsLoading = _props2.updateMyPlaylistsLoading,
	          className = _props2.className,
	          textClass = _props2.textClass;
	
	
	      return _react2.default.createElement(_EditableField2.default, {
	        className: className,
	        textClass: textClass,
	        onSave: this.saveName,
	        value: playlist.name,
	        loading: updateMyPlaylistsLoading,
	        inputProps: { maxLength: _myPlaylists2.nameMaxLength },
	        inputClass: styles.nameInput,
	        containerClass: styles.nameInputContainer
	      });
	    }
	  }]);
	  return MyPlaylistName;
	}(_react.Component), _class3.propTypes = {
	  className: _propTypes2.default.string,
	  playerAlbum: _propTypes2.default.object,
	  playlist: _propTypes2.default.object,
	  textClass: _propTypes2.default.string,
	  updateAlbumName: _propTypes2.default.func,
	  updateMyPlaylistName: _propTypes2.default.func,
	  updateMyPlaylistsLoading: _propTypes2.default.bool
	}, _class3.defaultProps = {
	  playerAlbum: {},
	  playlist: {}
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'saveName', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'saveName'), _class2.prototype)), _class2)) || _class);
	exports.default = MyPlaylistName;
	module.exports = exports['default'];

/***/ }),
/* 2165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get2 = __webpack_require__(19);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _defaultTo2 = __webpack_require__(668);
	
	var _defaultTo3 = _interopRequireDefault(_defaultTo2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactI18next = __webpack_require__(12);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _TrackPlayPauseButton = __webpack_require__(857);
	
	var _TrackPlayPauseButton2 = _interopRequireDefault(_TrackPlayPauseButton);
	
	var _audioplayer = __webpack_require__(83);
	
	var audioplayerActions = _interopRequireWildcard(_audioplayer);
	
	var _myPlaylists = __webpack_require__(88);
	
	var myPlaylistsActions = _interopRequireWildcard(_myPlaylists);
	
	var _ListItem = __webpack_require__(76);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _TrackDuration = __webpack_require__(2130);
	
	var _TrackDuration2 = _interopRequireDefault(_TrackDuration);
	
	var _MyPlaylistTrackPopover = __webpack_require__(2167);
	
	var _MyPlaylistTrackPopover2 = _interopRequireDefault(_MyPlaylistTrackPopover);
	
	var _MoreButton = __webpack_require__(515);
	
	var _MoreButton2 = _interopRequireDefault(_MoreButton);
	
	var _MyPlaylistTrackName = __webpack_require__(2166);
	
	var _MyPlaylistTrackName2 = _interopRequireDefault(_MyPlaylistTrackName);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(424);
	
	var MyPlaylistTrack = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    currentTrackIndex: state.audioplayer.currentTrackIndex,
	    deleteTrackActionData: state.myPlaylists.deleteMyPlaylistTrackActionData,
	    deleteTrackLoading: state.myPlaylists.deleteMyPlaylistTrackLoading,
	    playStatsTracks: state.playstats.tracks
	  };
	}, (0, _extends3.default)({}, audioplayerActions, myPlaylistsActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(MyPlaylistTrack, _Component);
	
	  function MyPlaylistTrack() {
	    (0, _classCallCheck3.default)(this, MyPlaylistTrack);
	    return (0, _possibleConstructorReturn3.default)(this, (MyPlaylistTrack.__proto__ || (0, _getPrototypeOf2.default)(MyPlaylistTrack)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MyPlaylistTrack, [{
	    key: 'getRenderProps',
	    value: function getRenderProps() {
	      var _props = this.props,
	          track = _props.track,
	          trackIndex = _props.trackIndex,
	          deleteTrackLoading = _props.deleteTrackLoading,
	          deleteTrackActionData = _props.deleteTrackActionData;
	
	      var trackNumber = trackIndex + 1;
	      var isDeleting = deleteTrackLoading && deleteTrackActionData.trackId === track.id;
	      var isDenied = this.isTrackDenied();
	      return { trackNumber: trackNumber, isDeleting: isDeleting, isDenied: isDenied };
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      var _props2 = this.props,
	          playAlbum = _props2.playAlbum,
	          album = _props2.playlist,
	          tracks = _props2.playlistTracks,
	          currentTrackIndex = _props2.currentTrackIndex,
	          trackIndex = _props2.trackIndex;
	
	      playAlbum({ album: album, tracks: tracks, currentTrackIndex: (0, _defaultTo3.default)(trackIndex, currentTrackIndex) });
	    }
	  }, {
	    key: 'bindPopover',
	    value: function bindPopover(el) {
	      this.popover = el;
	    }
	  }, {
	    key: 'deleteTrack',
	    value: function deleteTrack() {
	      var _props3 = this.props,
	          track = _props3.track,
	          playlist = _props3.playlist,
	          deleteMyPlaylistTrack = _props3.deleteMyPlaylistTrack;
	
	      return deleteMyPlaylistTrack({ guid: playlist.guid, trackId: track.id });
	    }
	  }, {
	    key: 'togglePopover',
	    value: function togglePopover(e) {
	      this.popover.toggle(e);
	    }
	  }, {
	    key: 'isTrackDenied',
	    value: function isTrackDenied() {
	      var _props4 = this.props,
	          track = _props4.track,
	          playStatsTracks = _props4.playStatsTracks;
	
	      return (0, _get3.default)(playStatsTracks, [track.id, 'isDenied']);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          track = _props5.track,
	          playlist = _props5.playlist;
	
	      var _getRenderProps = this.getRenderProps(),
	          trackNumber = _getRenderProps.trackNumber,
	          isDeleting = _getRenderProps.isDeleting,
	          isDenied = _getRenderProps.isDenied;
	
	      return _react2.default.createElement(
	        _ListItem2.default,
	        {
	          fullWidth: true,
	          onClick: this.play,
	          className: (0, _classnames2.default)(styles.track, (0, _defineProperty3.default)({}, styles.denied, isDenied))
	        },
	        _react2.default.createElement(
	          'div',
	          { className: styles.trackNumber },
	          _react2.default.createElement(_TrackPlayPauseButton2.default, {
	            track: track,
	            album: playlist,
	            showTrackNumber: true,
	            trackNumber: trackNumber,
	            isDenied: isDenied
	          })
	        ),
	        _react2.default.createElement(_MyPlaylistTrackName2.default, { track: track }),
	        _react2.default.createElement(_TrackDuration2.default, {
	          track: track,
	          album: playlist,
	          className: styles.timeCell
	        }),
	        _react2.default.createElement(_MoreButton2.default, {
	          onClick: this.togglePopover,
	          loading: isDeleting,
	          containerClass: styles.more,
	          buttonClass: styles.moreButton
	        }),
	        _react2.default.createElement(_MyPlaylistTrackPopover2.default, {
	          id: 'myPlaylistTrackPopover_' + track.id,
	          onInit: this.bindPopover,
	          onDelete: this.deleteTrack
	        })
	      );
	    }
	  }]);
	  return MyPlaylistTrack;
	}(_react.Component), _class3.propTypes = {
	  currentTrackIndex: _propTypes2.default.number,
	  deleteMyPlaylistTrack: _propTypes2.default.func,
	  deleteTrackActionData: _propTypes2.default.object,
	  deleteTrackLoading: _propTypes2.default.bool,
	  playAlbum: _propTypes2.default.func,
	  playlist: _propTypes2.default.object,
	  playlistTracks: _propTypes2.default.array,
	  playStatsTracks: _propTypes2.default.object,
	  track: _propTypes2.default.object,
	  trackIndex: _propTypes2.default.number
	}, _class3.defaultProps = {
	  playlist: {},
	  playlistTracks: [],
	  track: {},
	  deleteTrackActionData: {}
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'play', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'play'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'bindPopover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'bindPopover'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'deleteTrack', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'deleteTrack'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'togglePopover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'togglePopover'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = MyPlaylistTrack;
	module.exports = exports['default'];

/***/ }),
/* 2166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(424);
	
	var MyPlaylistTrackName = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(MyPlaylistTrackName, _PureComponent);
	
	  function MyPlaylistTrackName() {
	    (0, _classCallCheck3.default)(this, MyPlaylistTrackName);
	    return (0, _possibleConstructorReturn3.default)(this, (MyPlaylistTrackName.__proto__ || (0, _getPrototypeOf2.default)(MyPlaylistTrackName)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MyPlaylistTrackName, [{
	    key: 'render',
	    value: function render() {
	      var track = this.props.track;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          track.trackName
	        ),
	        track.albumArtist && _react2.default.createElement(
	          'span',
	          { className: styles.trackArtist },
	          track.albumArtist
	        )
	      );
	    }
	  }]);
	  return MyPlaylistTrackName;
	}(_react.PureComponent), _class.propTypes = {
	  track: _propTypes2.default.object
	}, _class.defaultProps = {
	  track: {}
	}, _temp);
	exports.default = MyPlaylistTrackName;
	module.exports = exports['default'];

/***/ }),
/* 2167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _PopoverMenuItem = __webpack_require__(353);
	
	var _PopoverMenuItem2 = _interopRequireDefault(_PopoverMenuItem);
	
	var _PopoverMenu = __webpack_require__(258);
	
	var _PopoverMenu2 = _interopRequireDefault(_PopoverMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MyPlaylistTrackPopover = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(MyPlaylistTrackPopover, _PureComponent);
	
	  function MyPlaylistTrackPopover() {
	    (0, _classCallCheck3.default)(this, MyPlaylistTrackPopover);
	    return (0, _possibleConstructorReturn3.default)(this, (MyPlaylistTrackPopover.__proto__ || (0, _getPrototypeOf2.default)(MyPlaylistTrackPopover)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MyPlaylistTrackPopover, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          t = _props.t,
	          id = _props.id,
	          onInit = _props.onInit,
	          onDelete = _props.onDelete;
	
	
	      return _react2.default.createElement(
	        _PopoverMenu2.default,
	        { id: id, ref: onInit },
	        _react2.default.createElement(_PopoverMenuItem2.default, { onClick: onDelete, title: t('Delete'), iconClass: 'icon-delete' })
	      );
	    }
	  }]);
	  return MyPlaylistTrackPopover;
	}(_react.PureComponent), _class2.propTypes = {
	  id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	  onDelete: _propTypes2.default.func,
	  onInit: _propTypes2.default.func,
	  t: _propTypes2.default.func
	}, _temp)) || _class);
	exports.default = MyPlaylistTrackPopover;
	module.exports = exports['default'];

/***/ }),
/* 2168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _MyPlaylistTrack = __webpack_require__(2165);
	
	var _MyPlaylistTrack2 = _interopRequireDefault(_MyPlaylistTrack);
	
	var _List = __webpack_require__(182);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Loader = __webpack_require__(60);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _NoAudio = __webpack_require__(2169);
	
	var _NoAudio2 = _interopRequireDefault(_NoAudio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(424);
	
	var MyPlaylistTracks = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(MyPlaylistTracks, _Component);
	
	  function MyPlaylistTracks() {
	    (0, _classCallCheck3.default)(this, MyPlaylistTracks);
	    return (0, _possibleConstructorReturn3.default)(this, (MyPlaylistTracks.__proto__ || (0, _getPrototypeOf2.default)(MyPlaylistTracks)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MyPlaylistTracks, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          tracks = _props.tracks,
	          playlist = _props.playlist,
	          loading = _props.loading;
	
	      var isNoTracks = !loading && !tracks.length;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        !isNoTracks && _react2.default.createElement(
	          _List2.default,
	          { className: (0, _bind2.default)(styles.tracks) },
	          tracks.map(function (track, trackIndex) {
	            return _react2.default.createElement(_MyPlaylistTrack2.default, {
	              key: track.id,
	              playlist: playlist,
	              track: track,
	              trackIndex: trackIndex,
	              playlistTracks: tracks
	            });
	          })
	        ),
	        isNoTracks && _react2.default.createElement(_NoAudio2.default, null),
	        _react2.default.createElement(_Loader2.default, { alignCenter: true, small: true, show: loading })
	      );
	    }
	  }]);
	  return MyPlaylistTracks;
	}(_react.Component), _class.propTypes = {
	  loading: _propTypes2.default.bool,
	  playlist: _propTypes2.default.object,
	  tracks: _propTypes2.default.array
	}, _class.defaultProps = {
	  playlist: { list: [] },
	  tracks: []
	}, _temp);
	exports.default = MyPlaylistTracks;
	module.exports = exports['default'];

/***/ }),
/* 2169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1354);
	
	var NoAudio = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(NoAudio, _PureComponent);
	
	  function NoAudio() {
	    (0, _classCallCheck3.default)(this, NoAudio);
	    return (0, _possibleConstructorReturn3.default)(this, (NoAudio.__proto__ || (0, _getPrototypeOf2.default)(NoAudio)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(NoAudio, [{
	    key: 'render',
	    value: function render() {
	      var t = this.props.t;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(styles.container) },
	        _react2.default.createElement('p', { className: styles.icon }),
	        _react2.default.createElement(
	          'p',
	          null,
	          t('There are no audio files in this playlist')
	        )
	      );
	    }
	  }]);
	  return NoAudio;
	}(_react.PureComponent), _class2.propTypes = {
	  t: _propTypes2.default.func
	}, _temp)) || _class);
	exports.default = NoAudio;
	module.exports = exports['default'];

/***/ }),
/* 2170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _dec3, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reduxConnect = __webpack_require__(33);
	
	var _reactI18next = __webpack_require__(12);
	
	var _myPlaylists = __webpack_require__(88);
	
	var myPlaylistsActions = _interopRequireWildcard(_myPlaylists);
	
	var _playlists = __webpack_require__(100);
	
	var playlistsActions = _interopRequireWildcard(_playlists);
	
	var _asyncPromise = __webpack_require__(43);
	
	var _asyncPromise2 = _interopRequireDefault(_asyncPromise);
	
	var _MyPlaylistsList = __webpack_require__(864);
	
	var _MyPlaylistsList2 = _interopRequireDefault(_MyPlaylistsList);
	
	var _myPlaylists2 = __webpack_require__(361);
	
	var _AddPlaylistButton = __webpack_require__(2171);
	
	var _AddPlaylistButton2 = _interopRequireDefault(_AddPlaylistButton);
	
	var _Page = __webpack_require__(350);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1355);
	
	var MyPlaylists = (_dec = (0, _reduxConnect.asyncConnect)([{
	  promise: function promise(_ref) {
	    var dispatch = _ref.store.dispatch;
	    return (0, _asyncPromise2.default)(dispatch(myPlaylistsActions.loadMyPlaylists()));
	  }
	}, {
	  promise: function promise(_ref2) {
	    var dispatch = _ref2.store.dispatch;
	
	    if (!dispatch(playlistsActions.isLoaded())) {
	      return (0, _asyncPromise2.default)(dispatch(playlistsActions.loadPlaylists()).promise);
	    }
	  }
	}]), _dec2 = (0, _reactRedux.connect)(function (state) {
	  return {
	    myPlaylists: (0, _myPlaylists2.getMyPlaylists)(state),
	    myPlaylistsLoading: state.myPlaylists.myPlaylistsLoading
	  };
	}), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(MyPlaylists, _Component);
	
	  function MyPlaylists() {
	    (0, _classCallCheck3.default)(this, MyPlaylists);
	    return (0, _possibleConstructorReturn3.default)(this, (MyPlaylists.__proto__ || (0, _getPrototypeOf2.default)(MyPlaylists)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MyPlaylists, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          t = _props.t,
	          myPlaylists = _props.myPlaylists,
	          myPlaylistsLoading = _props.myPlaylistsLoading;
	
	      var title = t('My Playlists');
	
	      return _react2.default.createElement(
	        _Page2.default,
	        { title: title, header: title },
	        _react2.default.createElement(
	          'div',
	          { className: styles.headLine },
	          _react2.default.createElement(
	            'h3',
	            { className: 'margin-free' },
	            t('Playlists')
	          ),
	          _react2.default.createElement(_AddPlaylistButton2.default, null)
	        ),
	        _react2.default.createElement(_MyPlaylistsList2.default, { playlists: myPlaylists, loading: myPlaylistsLoading })
	      );
	    }
	  }]);
	  return MyPlaylists;
	}(_react.Component), _class2.propTypes = {
	  myPlaylists: _propTypes2.default.array,
	  myPlaylistsLoading: _propTypes2.default.bool,
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  myPlaylists: []
	}, _temp)) || _class) || _class) || _class);
	exports.default = MyPlaylists;
	module.exports = exports['default'];

/***/ }),
/* 2171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _last2 = __webpack_require__(151);
	
	var _last3 = _interopRequireDefault(_last2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(11);
	
	var _myPlaylists = __webpack_require__(88);
	
	var myPlaylistsActions = _interopRequireWildcard(_myPlaylists);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _reactRouterRedux = __webpack_require__(40);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _log = __webpack_require__(267);
	
	var _log2 = _interopRequireDefault(_log);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var AddPlaylistButton = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    addMyPlaylistLoading: state.myPlaylists.addMyPlaylistLoading
	  };
	}, (0, _extends3.default)({}, myPlaylistsActions, { pushState: _reactRouterRedux.push })), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(AddPlaylistButton, _Component);
	
	  function AddPlaylistButton() {
	    (0, _classCallCheck3.default)(this, AddPlaylistButton);
	    return (0, _possibleConstructorReturn3.default)(this, (AddPlaylistButton.__proto__ || (0, _getPrototypeOf2.default)(AddPlaylistButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AddPlaylistButton, [{
	    key: 'add',
	    value: function add() {
	      var _props = this.props,
	          pushState = _props.pushState,
	          addMyPlaylist = _props.addMyPlaylist;
	
	      addMyPlaylist().promise.then(function () {
	        var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { data: [] };
	
	        var lastPlaylists = (0, _last3.default)(resp.data) || {};
	        var guid = lastPlaylists.guid;
	        if (guid) {
	          pushState('/my-playlists/' + guid);
	        }
	      }).catch(_log2.default.w);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          t = _props2.t,
	          title = _props2.title,
	          className = _props2.className,
	          addMyPlaylistLoading = _props2.addMyPlaylistLoading;
	
	      var buttonTitle = title || t('Create new');
	
	      return _react2.default.createElement(
	        _Button2.default,
	        {
	          className: (0, _bind2.default)('btn btn-primary', className),
	          onClick: this.add,
	          loading: addMyPlaylistLoading
	        },
	        buttonTitle
	      );
	    }
	  }]);
	  return AddPlaylistButton;
	}(_react.Component), _class3.propTypes = {
	  addMyPlaylist: _propTypes2.default.func,
	  addMyPlaylistLoading: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  pushState: _propTypes2.default.func,
	  t: _propTypes2.default.func,
	  title: _propTypes2.default.string
	}, _class3.defaultProps = {
	  prop: {}
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'add', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'add'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = AddPlaylistButton;
	module.exports = exports['default'];

/***/ }),
/* 2172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _myPlaylists = __webpack_require__(88);
	
	var myPlaylistsActions = _interopRequireWildcard(_myPlaylists);
	
	var _SearchBar = __webpack_require__(183);
	
	var _SearchBar2 = _interopRequireDefault(_SearchBar);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1357);
	
	var MyPlaylistsSearchBar = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    kw: state.myPlaylists.kw
	  };
	}, (0, _extends3.default)({}, myPlaylistsActions)), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(MyPlaylistsSearchBar, _Component);
	
	  function MyPlaylistsSearchBar() {
	    (0, _classCallCheck3.default)(this, MyPlaylistsSearchBar);
	    return (0, _possibleConstructorReturn3.default)(this, (MyPlaylistsSearchBar.__proto__ || (0, _getPrototypeOf2.default)(MyPlaylistsSearchBar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MyPlaylistsSearchBar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          kw = _props.kw,
	          setMyPlaylistsFilter = _props.setMyPlaylistsFilter,
	          onChange = _props.onChange,
	          autoFocus = _props.autoFocus;
	
	
	      return _react2.default.createElement(_SearchBar2.default, {
	        autoFocus: autoFocus,
	        className: (0, _bind2.default)(className, styles.bar),
	        onChange: onChange,
	        kw: kw,
	        onSetFilter: setMyPlaylistsFilter
	      });
	    }
	  }]);
	  return MyPlaylistsSearchBar;
	}(_react.Component), _class2.propTypes = {
	  autoFocus: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  kw: _propTypes2.default.string,
	  onChange: _propTypes2.default.func,
	  setMyPlaylistsFilter: _propTypes2.default.func
	}, _class2.defaultProps = {
	  onChange: _noop3.default
	}, _temp)) || _class);
	exports.default = MyPlaylistsSearchBar;
	module.exports = exports['default'];

/***/ }),
/* 2173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TracksCount = __webpack_require__(858);
	
	var _TracksCount2 = _interopRequireDefault(_TracksCount);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(631);
	
	var MyPlaylistDescription = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(MyPlaylistDescription, _PureComponent);
	
	  function MyPlaylistDescription() {
	    (0, _classCallCheck3.default)(this, MyPlaylistDescription);
	    return (0, _possibleConstructorReturn3.default)(this, (MyPlaylistDescription.__proto__ || (0, _getPrototypeOf2.default)(MyPlaylistDescription)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MyPlaylistDescription, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          name = _props.name,
	          tracksCount = _props.tracksCount;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.description },
	        _react2.default.createElement(
	          'div',
	          { className: styles.title },
	          name
	        ),
	        _react2.default.createElement(_TracksCount2.default, { count: tracksCount })
	      );
	    }
	  }]);
	  return MyPlaylistDescription;
	}(_react.PureComponent), _class.propTypes = {
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]), //TODO: fix api
	  tracksCount: _propTypes2.default.number
	}, _class.defaultProps = {
	  tracksCount: 0
	}, _temp);
	exports.default = MyPlaylistDescription;
	module.exports = exports['default'];

/***/ }),
/* 2174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _Thumb = __webpack_require__(259);
	
	var _Thumb2 = _interopRequireDefault(_Thumb);
	
	var _MyPlaylistItemPopover = __webpack_require__(2175);
	
	var _MyPlaylistItemPopover2 = _interopRequireDefault(_MyPlaylistItemPopover);
	
	var _reactRouterRedux = __webpack_require__(40);
	
	var _audioplayer = __webpack_require__(83);
	
	var audioplayerActions = _interopRequireWildcard(_audioplayer);
	
	var _myPlaylists = __webpack_require__(88);
	
	var myPlaylistsActions = _interopRequireWildcard(_myPlaylists);
	
	var _MyPlaylistDescription = __webpack_require__(2173);
	
	var _MyPlaylistDescription2 = _interopRequireDefault(_MyPlaylistDescription);
	
	var _MoreButton = __webpack_require__(515);
	
	var _MoreButton2 = _interopRequireDefault(_MoreButton);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _reactI18next = __webpack_require__(12);
	
	var _myPlaylists2 = __webpack_require__(361);
	
	var _Checkbox = __webpack_require__(180);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _utils = __webpack_require__(24);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(631);
	
	var MyPlaylistItem = (_dec = (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    deletePlaylistActionData: state.myPlaylists.deleteMyPlaylistActionData,
	    deletePlaylistLoading: state.myPlaylists.deleteMyPlaylistLoading,
	    playlistTracks: (0, _myPlaylists2.getMyPlaylisTracks)(state, ownProps.playlist.guid)
	  };
	}, (0, _extends3.default)({}, myPlaylistsActions, audioplayerActions, { pushState: _reactRouterRedux.push })), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(MyPlaylistItem, _Component);
	
	  function MyPlaylistItem() {
	    (0, _classCallCheck3.default)(this, MyPlaylistItem);
	    return (0, _possibleConstructorReturn3.default)(this, (MyPlaylistItem.__proto__ || (0, _getPrototypeOf2.default)(MyPlaylistItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MyPlaylistItem, [{
	    key: 'onClick',
	    value: function onClick() {
	      var _props = this.props,
	          onClick = _props.onClick,
	          playlist = _props.playlist;
	
	      if (this.props.clickable) {
	        this.edit();
	      }
	      onClick(playlist);
	    }
	  }, {
	    key: 'deletePlaylist',
	    value: function deletePlaylist() {
	      var _props2 = this.props,
	          guid = _props2.playlist.guid,
	          deleteMyPlaylist = _props2.deleteMyPlaylist,
	          t = _props2.t;
	
	      var toastrConfirmOptions = {
	        onOk: function onOk() {
	          return deleteMyPlaylist({ guid: guid });
	        }
	      };
	      _toastr2.default.confirm(t('Are you sure you want to delete this playlist?'), toastrConfirmOptions);
	    }
	  }, {
	    key: 'togglePopover',
	    value: function togglePopover(e) {
	      this.popover.toggle(e);
	    }
	  }, {
	    key: 'bindPopover',
	    value: function bindPopover(el) {
	      this.popover = el;
	    }
	  }, {
	    key: 'playAll',
	    value: function playAll() {
	      var _props3 = this.props,
	          playAlbum = _props3.playAlbum,
	          album = _props3.playlist,
	          tracks = _props3.playlistTracks;
	
	      playAlbum({ album: album, tracks: tracks });
	    }
	  }, {
	    key: 'edit',
	    value: function edit() {
	      var _props4 = this.props,
	          pushState = _props4.pushState,
	          playlist = _props4.playlist;
	
	      pushState('/my-playlists/' + playlist.guid);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          playlist = _props5.playlist,
	          deletePlaylistActionData = _props5.deletePlaylistActionData,
	          deletePlaylistLoading = _props5.deletePlaylistLoading,
	          playlistTracks = _props5.playlistTracks,
	          checked = _props5.checked,
	          withOptions = _props5.withOptions,
	          withIndex = _props5.withIndex,
	          index = _props5.index,
	          selectable = _props5.selectable;
	
	      var isDeleting = deletePlaylistLoading && deletePlaylistActionData.guid === playlist.guid;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(styles.listItem), onClick: this.onClick },
	        withIndex && _react2.default.createElement(
	          'div',
	          { className: styles.index },
	          index
	        ),
	        _react2.default.createElement(_Thumb2.default, {
	          fileName: playlist.thumb,
	          defaultImageName: 'default-logo',
	          asBackground: true,
	          className: styles.thumb
	        }),
	        _react2.default.createElement(_MyPlaylistDescription2.default, {
	          tracksCount: playlistTracks.length,
	          name: playlist.name
	        }),
	        withOptions && _react2.default.createElement(_MoreButton2.default, { loading: isDeleting, onClick: this.togglePopover }),
	        selectable && _react2.default.createElement(_Checkbox2.default, {
	          className: styles.checkbox,
	          checked: checked,
	          onClick: _utils.stopEvent,
	          small: true
	        }),
	        withOptions && _react2.default.createElement(_MyPlaylistItemPopover2.default, {
	          id: 'myPlaylistItemPopover_' + playlist.guid,
	          onInit: this.bindPopover,
	          onPlayAll: this.playAll,
	          onDelete: this.deletePlaylist,
	          hidePlayAll: !playlistTracks.length
	        })
	      );
	    }
	  }]);
	  return MyPlaylistItem;
	}(_react.Component), _class3.propTypes = {
	  checked: _propTypes2.default.bool,
	  clickable: _propTypes2.default.bool,
	  deleteMyPlaylist: _propTypes2.default.func,
	  deletePlaylistActionData: _propTypes2.default.object,
	  deletePlaylistLoading: _propTypes2.default.bool,
	  index: _propTypes2.default.number,
	  onClick: _propTypes2.default.func,
	  playAlbum: _propTypes2.default.func,
	  playlist: _propTypes2.default.object,
	  playlistTracks: _propTypes2.default.array,
	  pushState: _propTypes2.default.func,
	  selectable: _propTypes2.default.bool,
	  t: _propTypes2.default.func,
	  withIndex: _propTypes2.default.bool,
	  withOptions: _propTypes2.default.bool
	}, _class3.defaultProps = {
	  clickable: true,
	  onClick: _noop3.default,
	  playlist: {},
	  playlistTracks: [],
	  selectable: false,
	  withOptions: true
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onClick'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'deletePlaylist', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'deletePlaylist'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'togglePopover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'togglePopover'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'bindPopover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'bindPopover'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'playAll', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'playAll'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'edit', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'edit'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = MyPlaylistItem;
	module.exports = exports['default'];

/***/ }),
/* 2175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _PopoverMenuItem = __webpack_require__(353);
	
	var _PopoverMenuItem2 = _interopRequireDefault(_PopoverMenuItem);
	
	var _PopoverMenu = __webpack_require__(258);
	
	var _PopoverMenu2 = _interopRequireDefault(_PopoverMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MyPlaylistItemPopover = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(MyPlaylistItemPopover, _PureComponent);
	
	  function MyPlaylistItemPopover() {
	    (0, _classCallCheck3.default)(this, MyPlaylistItemPopover);
	    return (0, _possibleConstructorReturn3.default)(this, (MyPlaylistItemPopover.__proto__ || (0, _getPrototypeOf2.default)(MyPlaylistItemPopover)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MyPlaylistItemPopover, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          t = _props.t,
	          id = _props.id,
	          onInit = _props.onInit,
	          onDelete = _props.onDelete,
	          onPlayAll = _props.onPlayAll,
	          hidePlayAll = _props.hidePlayAll;
	
	
	      return _react2.default.createElement(
	        _PopoverMenu2.default,
	        { id: id, ref: onInit },
	        !hidePlayAll && _react2.default.createElement(_PopoverMenuItem2.default, { onClick: onPlayAll, title: t('Play All'), iconClass: 'icon-play' }),
	        _react2.default.createElement(_PopoverMenuItem2.default, { onClick: onDelete, title: t('Delete'), iconClass: 'icon-delete' })
	      );
	    }
	  }]);
	  return MyPlaylistItemPopover;
	}(_react.PureComponent), _class2.propTypes = {
	  hidePlayAll: _propTypes2.default.bool,
	  id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	  onDelete: _propTypes2.default.func,
	  onInit: _propTypes2.default.func,
	  onPlayAll: _propTypes2.default.func,
	  t: _propTypes2.default.func
	}, _temp)) || _class);
	exports.default = MyPlaylistItemPopover;
	module.exports = exports['default'];

/***/ }),
/* 2176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactHelmet = __webpack_require__(55);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactI18next = __webpack_require__(12);
	
	var _reactRouter = __webpack_require__(124);
	
	var _auth = __webpack_require__(77);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1358);
	
	var newAudioImg = __webpack_require__(2310);
	var newVideoImg = __webpack_require__(2314);
	var newFromSSImg = __webpack_require__(2311);
	var newSSImg = __webpack_require__(2313);
	var newNewsletterImg = __webpack_require__(2312);
	
	var NewProject = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    permissions: (0, _auth.getPermissions)(state)
	  };
	}), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(NewProject, _Component);
	
	  function NewProject() {
	    (0, _classCallCheck3.default)(this, NewProject);
	    return (0, _possibleConstructorReturn3.default)(this, (NewProject.__proto__ || (0, _getPrototypeOf2.default)(NewProject)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(NewProject, [{
	    key: 'onVideoClick',
	    value: function onVideoClick() {
	      var t = this.context.t;
	
	      _toastr2.default.info(t('Currently Unavailable'));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          t = _props.t,
	          permissions = _props.permissions;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(_reactHelmet2.default, { title: t('Create New Project') }),
	        _react2.default.createElement(
	          'div',
	          { className: 'container-fluid' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            t('Create New Project')
	          ),
	          permissions.createSharespace && _react2.default.createElement(
	            _reactRouter.Link,
	            { className: styles.panel, to: '/projects/sharespace/0' },
	            _react2.default.createElement(
	              'div',
	              { className: styles.thumb },
	              _react2.default.createElement('img', { src: newSSImg, alt: '' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: styles.descr },
	              _react2.default.createElement(
	                'h3',
	                { className: styles.header },
	                t('Sharespace')
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                t('Upload content and allow other people in your organization to share & create projects')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { className: styles.panel, to: '/projects/sharespace' },
	            _react2.default.createElement(
	              'div',
	              { className: styles.thumb },
	              _react2.default.createElement('img', { src: newFromSSImg, alt: '' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: styles.descr },
	              _react2.default.createElement(
	                'h3',
	                { className: styles.header },
	                t('Create project from sharespace')
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                t('Use an existing Sharespace to create a project')
	              )
	            )
	          ),
	          permissions.createProject && _react2.default.createElement(
	            _reactRouter.Link,
	            { className: styles.panel, to: '/projects/audio/0' },
	            _react2.default.createElement(
	              'div',
	              { className: styles.thumb },
	              _react2.default.createElement('img', { src: newAudioImg, alt: '' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: styles.descr },
	              _react2.default.createElement(
	                'h3',
	                { className: styles.header },
	                t('Audio')
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                t('Create a new audio project')
	              )
	            )
	          ),
	          permissions.createProject && _react2.default.createElement(
	            'a',
	            { className: styles.panel, onClick: this.onVideoClick },
	            _react2.default.createElement(
	              'div',
	              { className: styles.thumb },
	              _react2.default.createElement('img', { src: newVideoImg, alt: '' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: styles.descr },
	              _react2.default.createElement(
	                'h3',
	                { className: styles.header },
	                t('Video')
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                t('Create a new video project')
	              )
	            )
	          ),
	          permissions.createNewsletter && _react2.default.createElement(
	            _reactRouter.Link,
	            { className: styles.panel, to: '/projects/newsletter/0' },
	            _react2.default.createElement(
	              'div',
	              { className: styles.thumb },
	              _react2.default.createElement('img', { src: newNewsletterImg, alt: '' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: styles.descr },
	              _react2.default.createElement(
	                'h3',
	                { className: styles.header },
	                t('Newsletter')
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                t('Create a beautiful newsletter based on your existing projects')
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return NewProject;
	}(_react.Component), _class3.propTypes = {
	  permissions: _propTypes2.default.object,
	  t: _propTypes2.default.func
	}, _class3.contextTypes = {
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onVideoClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onVideoClick'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = NewProject;
	module.exports = exports['default'];

/***/ }),
/* 2177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = NotFound;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(82);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function NotFound() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'container-fluid margin-top-20 text-center' },
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Doh! 404!'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'These are ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'not'
	      ),
	      ' the droids you are looking for!'
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _Link2.default,
	        { className: 'btn btn-primary', to: '/' },
	        'Home Page'
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),
/* 2178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends3 = __webpack_require__(8);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _isPlainObject2 = __webpack_require__(87);
	
	var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
	
	var _isEmpty2 = __webpack_require__(81);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _invertBy2 = __webpack_require__(132);
	
	var _invertBy3 = _interopRequireDefault(_invertBy2);
	
	var _get2 = __webpack_require__(19);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _defaultTo2 = __webpack_require__(668);
	
	var _defaultTo3 = _interopRequireDefault(_defaultTo2);
	
	var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(55);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactRedux = __webpack_require__(11);
	
	var _playlist = __webpack_require__(217);
	
	var playlistActions = _interopRequireWildcard(_playlist);
	
	var _playlists = __webpack_require__(100);
	
	var _auth = __webpack_require__(31);
	
	var _audioplayer = __webpack_require__(83);
	
	var audioplayerActions = _interopRequireWildcard(_audioplayer);
	
	var _reduxConnect = __webpack_require__(33);
	
	var _components = __webpack_require__(15);
	
	var _reactI18next = __webpack_require__(12);
	
	var _playlists2 = __webpack_require__(362);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _reactRouterRedux = __webpack_require__(40);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _reactHtml5video = __webpack_require__(1732);
	
	var _responseCodes = __webpack_require__(99);
	
	var _downloads = __webpack_require__(262);
	
	var _config = __webpack_require__(41);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _projects = __webpack_require__(28);
	
	var _AudioPlayer = __webpack_require__(135);
	
	var _AudioPlayer2 = _interopRequireDefault(_AudioPlayer);
	
	var _asyncPromise = __webpack_require__(43);
	
	var _asyncPromise2 = _interopRequireDefault(_asyncPromise);
	
	var _TrackPartHeader = __webpack_require__(856);
	
	var _TrackPartHeader2 = _interopRequireDefault(_TrackPartHeader);
	
	var _MyPlaylistsAddIcon = __webpack_require__(828);
	
	var _MyPlaylistsAddIcon2 = _interopRequireDefault(_MyPlaylistsAddIcon);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _TrackPlayPauseButton = __webpack_require__(857);
	
	var _TrackPlayPauseButton2 = _interopRequireDefault(_TrackPlayPauseButton);
	
	var _PlaylistNavButtons = __webpack_require__(2180);
	
	var _PlaylistNavButtons2 = _interopRequireDefault(_PlaylistNavButtons);
	
	var _PlaylistAlbum = __webpack_require__(2040);
	
	var _PlaylistAlbum2 = _interopRequireDefault(_PlaylistAlbum);
	
	var _PlaylistFeedbackForm = __webpack_require__(2043);
	
	var _PlaylistFeedbackForm2 = _interopRequireDefault(_PlaylistFeedbackForm);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1359);
	
	var changeUrlOnTrackChange = false; //TODO: temporary?
	var scrollPosition = 0;
	
	var Playlist = (_dec = (0, _reduxConnect.asyncConnect)([{
	  promise: function promise(_ref) {
	    var _ref$store = _ref.store,
	        dispatch = _ref$store.dispatch,
	        getState = _ref$store.getState,
	        key = _ref.params.key,
	        location = _ref.location;
	
	    var user = getState().auth.user;
	
	    // if we just change autoplay index by replaceState then not reload playlist
	    if (location.action !== 'REPLACE') {
	      var method = user ? 'load' : 'loadByKey';
	      return (0, _asyncPromise2.default)(dispatch(playlistActions[method]({ key: key })).promise);
	    }
	  }
	}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    album: (0, _playlists2.processAlbum)(state),
	    autoPlayIndex: ownProps.location.query.index ? Number(ownProps.location.query.index) : null,
	    currentTrackIndex: state.audioplayer.currentTrackIndex,
	    downloadTracksLoading: state.playlist.downloadTracksLoading,
	    format: state.playlist.format,
	    humanizedPosition: state.audioplayer.humanizedPosition,
	    partTracks: (0, _playlists2.getPartTracks)(state),
	    playerAlbum: state.audioplayer.album,
	    playerStatus: state.audioplayer.playerStatus,
	    playerTracks: state.audioplayer.tracks,
	    playlistEmail: (0, _get3.default)(state, 'playlist.playlistData.email', ''),
	    playlistKey: ownProps.params.key,
	    playlistLoadError: state.playlist.playlistLoadError,
	    playlistLoading: state.playlist.playlistLoading,
	    playlistName: (0, _get3.default)(state, 'playlist.playlistData.name', ''),
	    playlistSurname: (0, _get3.default)(state, 'playlist.playlistData.surname', ''),
	    playlistUser: (0, _get3.default)(state, 'playlist.playlistData.user', {}),
	    playStatsAlbums: state.playstats.albums,
	    playStatsTracks: state.playstats.tracks,
	    pressLoading: state.playlists.pressLoading,
	    recipientId: Number(ownProps.params.recipientId),
	    tracks: (0, _playlists2.processTracks)(state),
	    typeFilter: state.playlists.typeFilter,
	    user: state.auth.user
	  };
	}, (0, _extends4.default)({}, playlistActions, audioplayerActions, { loadPress: _playlists.loadPress, setRedirect: _auth.setRedirect, setLoginData: _auth.setLoginData, pushState: _reactRouterRedux.push, replaceState: _reactRouterRedux.replace })), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(Playlist, _Component);
	
	  function Playlist() {
	    var _ref2;
	
	    (0, _classCallCheck3.default)(this, Playlist);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = Playlist.__proto__ || (0, _getPrototypeOf2.default)(Playlist)).call.apply(_ref2, [this].concat(args)));
	
	    _this.state = { checkedTracks: {}, autoPlayStarted: false, isAllTracksSelected: false };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Playlist, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.isPlaylistDisallowed();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          clearPlaylistError = _props.clearPlaylistError,
	          playlistLoadError = _props.playlistLoadError,
	          t = _props.t,
	          replaceState = _props.replaceState;
	
	
	      setTimeout(function () {
	        if (!playlistLoadError) {
	          return false;
	        }
	
	        var errorMsg = void 0;
	        var timeOut = 4000;
	        if (playlistLoadError.code === _responseCodes.playlistCodes.notAvailable) {
	          errorMsg = _react2.default.createElement(
	            'span',
	            null,
	            t('Project is no longer available')
	          );
	        }
	        if (playlistLoadError.code === _responseCodes.playlistCodes.contentLocked) {
	          errorMsg = _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              t('Content locked to another device'),
	              '.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              t('You can listen again on your original device via the email link.')
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              t('Or, if you have a CRight account, simply log in to listen again.')
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              t('If you don’t have an account, or have forgotten your password, click “FORGOT PASSWORD” on the homepage.')
	            )
	          );
	          timeOut = 12000;
	        }
	        if (errorMsg) {
	          _toastr2.default.warning({ component: errorMsg, timeOut: timeOut });
	          clearPlaylistError();
	          replaceState({ pathname: '/' });
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      var _this2 = this;
	
	      var currentTrackIndex = props.currentTrackIndex,
	          playerStatus = props.playerStatus,
	          playerAlbum = props.playerAlbum,
	          album = props.album,
	          autoPlayIndex = props.autoPlayIndex,
	          tracks = props.tracks,
	          user = props.user;
	      var autoPlayStarted = this.state.autoPlayStarted;
	
	
	      if (this.isPlaylistDisallowed(props)) {
	        return false;
	      }
	
	      if (changeUrlOnTrackChange) {
	        // change url after page was loaded to contain autoplay index
	        if (playerAlbum.project_id === album.project_id && playerStatus !== _AudioPlayer2.default.status.stop) {
	          setTimeout(function () {
	            return _this2.changeTrackUrl(currentTrackIndex);
	          }, 200);
	        }
	      }
	
	      if (!autoPlayStarted && playerStatus === _AudioPlayer2.default.status.stop) {
	        // if url contains autoplay track index && props have album and tracks || album played from email link
	        var playTrackIndex = autoPlayIndex !== null && tracks[autoPlayIndex] ? autoPlayIndex : !user && tracks[0] ? 0 : null;
	
	        if (playTrackIndex !== null) {
	          this.setState({ autoPlayStarted: true });
	          setTimeout(function () {
	            return _this2.play(playTrackIndex);
	          }, 500);
	        }
	      }
	    }
	  }, {
	    key: 'onVideoEnded',
	    value: function onVideoEnded(e, track) {
	      console.log(e, track);
	    }
	  }, {
	    key: 'getCheckedTracksArray',
	    value: function getCheckedTracksArray(checkedTracks) {
	      return (0, _invertBy3.default)(checkedTracks || this.state.checkedTracks || {}).true || [];
	    }
	  }, {
	    key: 'redirectToAuth',
	    value: function redirectToAuth(url, loginData) {
	      var _props2 = this.props,
	          playlistKey = _props2.playlistKey,
	          pushState = _props2.pushState,
	          user = _props2.user;
	
	      if (playlistKey && !user) {
	        this.props.setRedirect('/playlists/fromkey/' + playlistKey);
	        this.props.setLoginData((0, _isPlainObject3.default)(loginData) ? loginData : {});
	        pushState(url);
	      }
	    }
	  }, {
	    key: 'isPlaylistDisallowed',
	    value: function isPlaylistDisallowed(nextProps) {
	      var _ref3 = nextProps || this.props,
	          playlistLoadError = _ref3.playlistLoadError;
	
	      var res = false;
	
	      if ((nextProps && !this.props.playlistLoadError || !nextProps) && playlistLoadError) {
	        var redirectData = (0, _get3.default)(playlistLoadError, 'data', {});
	        redirectData._code = playlistLoadError.code;
	
	        if (playlistLoadError.code === _responseCodes.playlistCodes.loginRequired) {
	          this.redirectToAuth('/login', redirectData);
	          res = true;
	        } else if (playlistLoadError.code === _responseCodes.playlistCodes.registrationRequired) {
	          this.redirectToAuth('/registration', redirectData);
	          res = true;
	        }
	      }
	
	      return res;
	    }
	  }, {
	    key: 'changeTrackUrl',
	    value: function changeTrackUrl(index) {
	      var _props3 = this.props,
	          location = _props3.location,
	          replaceState = _props3.replaceState;
	
	      if (Number(location.query.index) !== index) {
	        scrollPosition = document ? document.body.scrollTop : 0;
	        replaceState({ pathname: location.pathname, query: { index: index } });
	        if (scrollPosition) {
	          document.body.scrollTop = scrollPosition;
	        }
	      }
	    }
	  }, {
	    key: 'toggleTrackChecked',
	    value: function toggleTrackChecked(e, id) {
	      var checkedTracks = (0, _extends4.default)({}, this.state.checkedTracks, (0, _defineProperty3.default)({}, id, e.target.checked));
	      var checkedTracksArr = this.getCheckedTracksArray(checkedTracks);
	      var tracks = this.props.tracks;
	
	
	      this.setState({ checkedTracks: checkedTracks, isAllTracksSelected: checkedTracksArr.length === tracks.length });
	    }
	  }, {
	    key: 'play',
	    value: function play(index) {
	      var _props4 = this.props,
	          playAlbum = _props4.playAlbum,
	          album = _props4.album,
	          tracks = _props4.tracks,
	          currentTrackIndex = _props4.currentTrackIndex;
	
	      playAlbum({ album: album, tracks: tracks, currentTrackIndex: (0, _defaultTo3.default)(index, currentTrackIndex) });
	    }
	  }, {
	    key: 'selectAll',
	    value: function selectAll() {
	      var tracks = this.props.tracks;
	
	      var checkedTracks = {};
	      tracks.map(function (track) {
	        checkedTracks[track.track_number] = true;
	      });
	      this.setState({ checkedTracks: checkedTracks, isAllTracksSelected: true });
	    }
	  }, {
	    key: 'selectNone',
	    value: function selectNone() {
	      this.setState({ checkedTracks: {}, isAllTracksSelected: false });
	    }
	  }, {
	    key: 'downloadPress',
	    value: function downloadPress() {
	      var _props5 = this.props,
	          pressLoading = _props5.pressLoading,
	          t = _props5.t,
	          album = _props5.album;
	
	
	      if (pressLoading) {
	        return _toastr2.default.info(t('Downloading is in progress'));
	      }
	
	      this.props.loadPress({ key: album.contentKey }).promise.then(function (resp) {
	        var filename = resp.data.filename;
	
	        if (filename) {
	          (0, _downloads.download)('' + _config2.default.app.urlParts.press + filename);
	        }
	      });
	    }
	  }, {
	    key: 'isTrackDenied',
	    value: function isTrackDenied(_ref4) {
	      var track = _ref4.track,
	          album = _ref4.album;
	      var _props6 = this.props,
	          playStatsTracks = _props6.playStatsTracks,
	          playStatsAlbums = _props6.playStatsAlbums;
	
	      return (0, _get3.default)(playStatsTracks, [track.id, 'isDenied']) || (0, _get3.default)(playStatsAlbums, [album.project_id, 'isDenied']);
	    }
	  }, {
	    key: 'renderFormatCheckbox',
	    value: function renderFormatCheckbox(checkboxFormat) {
	      var _props7 = this.props,
	          selectFormat = _props7.selectFormat,
	          format = _props7.format;
	
	      return _react2.default.createElement(_components.Checkbox, {
	        className: 'padding-5 inline',
	        checked: format === checkboxFormat,
	        small: true,
	        thin: true,
	        textAfter: checkboxFormat,
	        onChange: function onChange() {
	          return selectFormat(checkboxFormat);
	        }
	      });
	    }
	  }, {
	    key: 'renderContentButton',
	    value: function renderContentButton() {
	      var _this3 = this;
	
	      var _props8 = this.props,
	          t = _props8.t,
	          playlistKey = _props8.playlistKey,
	          user = _props8.user,
	          playlistEmail = _props8.playlistEmail,
	          playlistName = _props8.playlistName,
	          playlistSurname = _props8.playlistSurname,
	          playlistUser = _props8.playlistUser;
	
	      var isPlayByKey = playlistKey && !user;
	      var redirectData = !(0, _isEmpty3.default)(playlistUser) ? playlistUser : { email: playlistEmail, name: playlistName, surname: playlistSurname };
	      redirectData._code = _responseCodes.playlistCodes.loginRequired;
	
	      return !isPlayByKey ? null : _react2.default.createElement(
	        'button',
	        {
	          type: 'button',
	          className: 'btn btn-primary margin-left-15 margin-top-10',
	          onClick: function onClick() {
	            return _this3.redirectToAuth('/login', redirectData);
	          }
	        },
	        t('My content')
	      );
	    }
	  }, {
	    key: 'renderSelectAll',
	    value: function renderSelectAll() {
	      var _this4 = this;
	
	      var t = this.props.t;
	      var isAllTracksSelected = this.state.isAllTracksSelected;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.selectAllContainer },
	        _react2.default.createElement(_components.Checkbox, {
	          className: 'padding-5 inline',
	          checked: isAllTracksSelected,
	          small: true,
	          thin: true,
	          textBefore: t('Select all'),
	          onChange: function onChange() {
	            return isAllTracksSelected ? _this4.selectNone() : _this4.selectAll();
	          }
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _props9 = this.props,
	          playlistLoading = _props9.playlistLoading,
	          t = _props9.t,
	          album = _props9.album,
	          tracks = _props9.tracks,
	          partTracks = _props9.partTracks,
	          humanizedPosition = _props9.humanizedPosition,
	          currentTrackIndex = _props9.currentTrackIndex,
	          playerTracks = _props9.playerTracks,
	          format = _props9.format,
	          user = _props9.user,
	          playlistLoadError = _props9.playlistLoadError,
	          playlistKey = _props9.playlistKey,
	          typeFilter = _props9.typeFilter,
	          pressLoading = _props9.pressLoading,
	          playlistUser = _props9.playlistUser;
	
	
	      if ((0, _get3.default)(playlistLoadError, 'code') === _responseCodes.playlistCodes.userConsentRequired) {
	        return _react2.default.createElement(_components.UserConsent, { playlistKey: playlistKey });
	      }
	
	      var currentTrack = playerTracks[currentTrackIndex] || {};
	      var checkedTracks = this.state.checkedTracks;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_components.Labels, { labels: album.subLabels, className: 'margin-bottom-10' }),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _bind2.default)('page', styles.playlist) },
	          _react2.default.createElement(
	            'div',
	            { className: 'container-fluid' },
	            _react2.default.createElement(_reactHelmet2.default, { title: t('Playlists') }),
	            _react2.default.createElement(_PlaylistNavButtons2.default, {
	              contentType: typeFilter || album.projectContentType,
	              playlistKey: playlistKey,
	              user: user
	            }),
	            _react2.default.createElement(_components.Loader, { show: playlistLoading, alignCenter: true }),
	            _react2.default.createElement(_PlaylistAlbum2.default, { album: album }),
	            album.audiovideo === _projects.projectTypes.audio && _react2.default.createElement(
	              'div',
	              { className: 'margin-top-20 margin-bottom-10' },
	              !album.multipleBoxSets && album.downloadable && _react2.default.createElement(
	                'div',
	                { className: 'overflow-hidden margin-bottom-10' },
	                this.renderSelectAll()
	              ),
	              partTracks.parts.map(function (part, index) {
	                return _react2.default.createElement(
	                  'div',
	                  { key: 'part-' + part },
	                  !!album.multipleBoxSets && _react2.default.createElement(
	                    _TrackPartHeader2.default,
	                    { part: part },
	                    album.downloadable && !index && _this5.renderSelectAll()
	                  ),
	                  _react2.default.createElement(
	                    _components.List,
	                    null,
	                    partTracks.tracks[part].map(function (trackIndex) {
	                      return _react2.default.createElement(
	                        _components.ListItem,
	                        {
	                          fullWidth: true,
	                          key: tracks[trackIndex].id,
	                          className: (0, _bind2.default)(styles.trackRow, (0, _defineProperty3.default)({}, styles.denied, _this5.isTrackDenied({ track: tracks[trackIndex], album: album })))
	                        },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'text-center width-perc-1', onClick: function onClick() {
	                              return _this5.play(trackIndex);
	                            } },
	                          _react2.default.createElement(_TrackPlayPauseButton2.default, {
	                            track: tracks[trackIndex],
	                            album: album,
	                            showTrackNumber: true,
	                            trackNumber: tracks[trackIndex].track_number,
	                            isDenied: _this5.isTrackDenied({ track: tracks[trackIndex], album: album })
	                          })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { onClick: function onClick() {
	                              return _this5.play(trackIndex);
	                            } },
	                          tracks[trackIndex].trackName
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: styles.timeCell, onClick: function onClick() {
	                              return _this5.play(trackIndex);
	                            } },
	                          currentTrack.id === tracks[trackIndex].id ? humanizedPosition : tracks[trackIndex].durationTime
	                        ),
	                        user && _react2.default.createElement(
	                          'div',
	                          { className: styles.addPlaylistCell },
	                          !_this5.isTrackDenied({ track: tracks[trackIndex], album: album }) && _react2.default.createElement(_MyPlaylistsAddIcon2.default, { track: tracks[trackIndex] })
	                        ),
	                        album.downloadable && _react2.default.createElement(
	                          'div',
	                          { className: styles.checkCell },
	                          _react2.default.createElement(_components.Checkbox, {
	                            className: 'padding-5 inline',
	                            checked: checkedTracks[tracks[trackIndex].track_number],
	                            small: true,
	                            thin: true,
	                            onChange: function onChange(e) {
	                              return _this5.toggleTrackChecked(e, tracks[trackIndex].track_number);
	                            }
	                          })
	                        )
	                      );
	                    })
	                  )
	                );
	              })
	            ),
	            album.audiovideo === _projects.projectTypes.video && tracks.map(function (track) {
	              return _react2.default.createElement(
	                'div',
	                { key: track.id, className: 'margin-vert-20' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  track.track_number,
	                  '. ',
	                  track.trackName
	                ),
	                _react2.default.createElement(
	                  _reactHtml5video.DefaultPlayer,
	                  {
	                    controls: ['PlayPause', 'Seek', 'Time', 'Volume', 'Fullscreen'],
	                    onEnded: function onEnded(e) {
	                      return _this5.onVideoEnded(e, track);
	                    }
	                  },
	                  _react2.default.createElement('source', { src: track.videoSrc, type: 'video/mp4' })
	                )
	              );
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'table width-perc-100' },
	              _react2.default.createElement(
	                'div',
	                { className: 'table-cell text-right' },
	                album.downloadable && _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    { className: styles.downloadFormat },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'margin-10' },
	                      t('Download format')
	                    ),
	                    this.renderFormatCheckbox('wav'),
	                    this.renderFormatCheckbox('mp3')
	                  ),
	                  _react2.default.createElement(_components.DownloadTracksButton, {
	                    className: 'margin-top-10 margin-left-15',
	                    format: format,
	                    playlistUser: playlistUser,
	                    requireAuth: !user,
	                    contentKey: playlistKey,
	                    tracksNumbers: this.getCheckedTracksArray()
	                  })
	                ),
	                album.isPress && _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn btn-primary margin-top-10 margin-left-15',
	                    onClick: function onClick() {
	                      return _this5.downloadPress();
	                    },
	                    disabled: pressLoading
	                  },
	                  t('Press Pack')
	                ),
	                this.renderContentButton()
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'hint small text-justify margin-top-20' },
	              album.iSpec
	            ),
	            _react2.default.createElement(_PlaylistFeedbackForm2.default, { album: album, line: !user })
	          )
	        )
	      );
	    }
	  }]);
	  return Playlist;
	}(_react.Component), _class3.propTypes = {
	  album: _propTypes2.default.object,
	  autoPlayIndex: _propTypes2.default.number,
	  clearPlaylistError: _propTypes2.default.func,
	  currentTrackIndex: _propTypes2.default.number,
	  format: _propTypes2.default.string,
	  humanizedPosition: _propTypes2.default.string,
	  loadPress: _propTypes2.default.func,
	  location: _propTypes2.default.object,
	  partTracks: _propTypes2.default.object,
	  playAlbum: _propTypes2.default.func,
	  playerAlbum: _propTypes2.default.object,
	  playerStatus: _propTypes2.default.string,
	  playerTracks: _propTypes2.default.array,
	  playlistEmail: _propTypes2.default.string,
	  playlistKey: _propTypes2.default.string,
	  playlistLoadError: _propTypes2.default.object,
	  playlistLoading: _propTypes2.default.bool,
	  playlistName: _propTypes2.default.string,
	  playlistSurname: _propTypes2.default.string,
	  playlistUser: _propTypes2.default.object,
	  playStatsAlbums: _propTypes2.default.object,
	  playStatsTracks: _propTypes2.default.object,
	  pressLoading: _propTypes2.default.bool,
	  pushState: _propTypes2.default.func,
	  replaceState: _propTypes2.default.func,
	  selectFormat: _propTypes2.default.func,
	  setLoginData: _propTypes2.default.func,
	  setRedirect: _propTypes2.default.func,
	  t: _propTypes2.default.func,
	  tracks: _propTypes2.default.array,
	  typeFilter: _propTypes2.default.string,
	  user: _propTypes2.default.object
	}, _class3.defaultProps = {
	  playStatsAlbums: {},
	  playStatsTracks: {}
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'renderFormatCheckbox', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'renderFormatCheckbox'), _class2.prototype)), _class2)) || _class) || _class) || _class);
	exports.default = Playlist;
	module.exports = exports['default'];

/***/ }),
/* 2179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1360);
	
	var PlaylistHomeButton = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(PlaylistHomeButton, _PureComponent);
	
	  function PlaylistHomeButton() {
	    (0, _classCallCheck3.default)(this, PlaylistHomeButton);
	    return (0, _possibleConstructorReturn3.default)(this, (PlaylistHomeButton.__proto__ || (0, _getPrototypeOf2.default)(PlaylistHomeButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PlaylistHomeButton, [{
	    key: 'onClick',
	    value: function onClick() {
	      var push = this.context.push;
	
	      push('/');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          hidden = _props.hidden;
	      var t = this.context.t;
	
	
	      if (hidden) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(styles.homeBtn, className) },
	        _react2.default.createElement(
	          'button',
	          { type: 'button', className: 'btn btn-stroke', onClick: this.onClick },
	          _react2.default.createElement('i', { className: 'icon-home' }),
	          _react2.default.createElement(
	            'span',
	            { className: 'margin-left-10' },
	            t('Home')
	          )
	        )
	      );
	    }
	  }]);
	  return PlaylistHomeButton;
	}(_react.PureComponent), _class2.propTypes = {
	  className: _propTypes2.default.string,
	  hidden: _propTypes2.default.bool
	}, _class2.contextTypes = {
	  push: _propTypes2.default.func,
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  onClick: _noop3.default
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onClick'), _class.prototype)), _class);
	exports.default = PlaylistHomeButton;
	module.exports = exports['default'];

/***/ }),
/* 2180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _BackButton = __webpack_require__(256);
	
	var _BackButton2 = _interopRequireDefault(_BackButton);
	
	var _PlaylistHomeButton = __webpack_require__(2179);
	
	var _PlaylistHomeButton2 = _interopRequireDefault(_PlaylistHomeButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlaylistNavButtons = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(PlaylistNavButtons, _PureComponent);
	
	  function PlaylistNavButtons() {
	    (0, _classCallCheck3.default)(this, PlaylistNavButtons);
	    return (0, _possibleConstructorReturn3.default)(this, (PlaylistNavButtons.__proto__ || (0, _getPrototypeOf2.default)(PlaylistNavButtons)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PlaylistNavButtons, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          playlistKey = _props.playlistKey,
	          contentType = _props.contentType,
	          user = _props.user;
	
	      var isPlayByKey = playlistKey && !user;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('margin-bottom-20', className) },
	        user && _react2.default.createElement(_BackButton2.default, { backUrl: '/playlists/' + contentType }),
	        _react2.default.createElement(_PlaylistHomeButton2.default, { hidden: !isPlayByKey })
	      );
	    }
	  }]);
	  return PlaylistNavButtons;
	}(_react.PureComponent), _class.propTypes = {
	  className: _propTypes2.default.string,
	  contentType: _propTypes2.default.string,
	  playlistKey: _propTypes2.default.string,
	  user: _propTypes2.default.object
	}, _temp);
	exports.default = PlaylistNavButtons;
	module.exports = exports['default'];

/***/ }),
/* 2181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(55);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactRedux = __webpack_require__(11);
	
	var _playlists = __webpack_require__(100);
	
	var playlistsActions = _interopRequireWildcard(_playlists);
	
	var _playlists2 = __webpack_require__(362);
	
	var _reduxConnect = __webpack_require__(33);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _asyncPromise = __webpack_require__(43);
	
	var _asyncPromise2 = _interopRequireDefault(_asyncPromise);
	
	var _PlaylistsFilterButtons = __webpack_require__(2182);
	
	var _PlaylistsFilterButtons2 = _interopRequireDefault(_PlaylistsFilterButtons);
	
	var _PlaylistsToggleViewButton = __webpack_require__(2186);
	
	var _PlaylistsToggleViewButton2 = _interopRequireDefault(_PlaylistsToggleViewButton);
	
	var _PlaylistsSorter = __webpack_require__(2185);
	
	var _PlaylistsSorter2 = _interopRequireDefault(_PlaylistsSorter);
	
	var _PlaylistsSearchBar = __webpack_require__(2184);
	
	var _PlaylistsSearchBar2 = _interopRequireDefault(_PlaylistsSearchBar);
	
	var _AlbumsItemsGroups = __webpack_require__(1950);
	
	var _AlbumsItemsGroups2 = _interopRequireDefault(_AlbumsItemsGroups);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1361);
	
	var Playlists = (_dec = (0, _reduxConnect.asyncConnect)([{
	  promise: function promise(_ref) {
	    var dispatch = _ref.store.dispatch,
	        projectType = _ref.params.projectType;
	
	    dispatch(playlistsActions.setTypeFilter(projectType));
	    return (0, _asyncPromise2.default)(dispatch(playlistsActions.loadPlaylists(projectType)).promise);
	  }
	}]), _dec2 = (0, _reactRedux.connect)(function (state) {
	  return {
	    albums: (0, _playlists2.getSortedAlbums)(state),
	    playlistsLoading: state.playlists.playlistsLoading,
	    showGroups: state.playlists.showGroups,
	    tracks: (0, _playlists2.getPlaylistsTracks)(state)
	  };
	}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(Playlists, _Component);
	
	  function Playlists() {
	    (0, _classCallCheck3.default)(this, Playlists);
	    return (0, _possibleConstructorReturn3.default)(this, (Playlists.__proto__ || (0, _getPrototypeOf2.default)(Playlists)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Playlists, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          playlistsLoading = _props.playlistsLoading,
	          albums = _props.albums,
	          showGroups = _props.showGroups,
	          tracks = _props.tracks;
	      var t = this.context.t;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(styles.playlists, 'container-fluid', 'page') },
	        _react2.default.createElement(_reactHelmet2.default, { title: t('Playlists') }),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_PlaylistsToggleViewButton2.default, { className: 'pull-right' }),
	          _react2.default.createElement(
	            'h1',
	            null,
	            t('My Content')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.filters },
	          _react2.default.createElement(_PlaylistsFilterButtons2.default, null),
	          _react2.default.createElement(
	            'div',
	            { className: 'pull-left margin-vert-5' },
	            _react2.default.createElement(_PlaylistsSorter2.default, null),
	            _react2.default.createElement(_PlaylistsSearchBar2.default, null)
	          )
	        ),
	        _react2.default.createElement(_AlbumsItemsGroups2.default, {
	          albums: albums,
	          tracks: tracks,
	          showTitles: showGroups,
	          loading: playlistsLoading
	        })
	      );
	    }
	  }]);
	  return Playlists;
	}(_react.Component), _class2.propTypes = {
	  albums: _propTypes2.default.array,
	  playlistsLoading: _propTypes2.default.bool,
	  showGroups: _propTypes2.default.bool,
	  tracks: _propTypes2.default.object
	}, _class2.contextTypes = {
	  t: _propTypes2.default.func
	}, _temp)) || _class) || _class);
	exports.default = Playlists;
	module.exports = exports['default'];

/***/ }),
/* 2182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _FilterButton = __webpack_require__(349);
	
	var _FilterButton2 = _interopRequireDefault(_FilterButton);
	
	var _projects = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1362);
	
	var PlaylistsFilterButtons = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    displayInfo: state.playlists.displayInfo,
	    typeFilter: state.playlists.typeFilter
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(PlaylistsFilterButtons, _Component);
	
	  function PlaylistsFilterButtons() {
	    (0, _classCallCheck3.default)(this, PlaylistsFilterButtons);
	    return (0, _possibleConstructorReturn3.default)(this, (PlaylistsFilterButtons.__proto__ || (0, _getPrototypeOf2.default)(PlaylistsFilterButtons)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PlaylistsFilterButtons, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          typeFilter = _props.typeFilter,
	          displayInfo = _props.displayInfo;
	      var t = this.context.t;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.sorterGroup },
	        _react2.default.createElement(_FilterButton2.default, {
	          route: '/playlists/' + _projects.projectTypes.all,
	          iconClass: 'icon-media-all',
	          title: t('View All'),
	          isActive: typeFilter === _projects.projectTypes.all
	        }),
	        _react2.default.createElement(_FilterButton2.default, {
	          route: '/playlists/' + _projects.projectTypes.audio,
	          iconClass: 'icon-playlist',
	          title: t('Audio'),
	          isActive: _projects.projectTypes.audio === typeFilter,
	          disabled: !displayInfo[_projects.projectTypes.audio]
	        }),
	        _react2.default.createElement(_FilterButton2.default, {
	          route: '/playlists/' + _projects.projectTypes.video,
	          iconClass: 'icon-video',
	          title: t('Video'),
	          isActive: _projects.projectTypes.video === typeFilter,
	          disabled: !displayInfo[_projects.projectTypes.video]
	        }),
	        _react2.default.createElement(_FilterButton2.default, {
	          route: '/playlists/' + _projects.projectTypes.quickSend,
	          iconClass: 'icon-paper-plane',
	          title: t('Quick Send'),
	          isActive: _projects.projectTypes.quickSend === typeFilter,
	          disabled: !displayInfo[_projects.projectTypes.quickSend]
	        })
	      );
	    }
	  }]);
	  return PlaylistsFilterButtons;
	}(_react.Component), _class2.propTypes = {
	  displayInfo: _propTypes2.default.object,
	  typeFilter: _propTypes2.default.string
	}, _class2.contextTypes = {
	  t: _propTypes2.default.func
	}, _temp)) || _class);
	exports.default = PlaylistsFilterButtons;
	module.exports = exports['default'];

/***/ }),
/* 2183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _Playlists = __webpack_require__(214);
	
	var _AlbumListItem = __webpack_require__(1947);
	
	var _AlbumListItem2 = _interopRequireDefault(_AlbumListItem);
	
	var _AlbumGridItem = __webpack_require__(1943);
	
	var _AlbumGridItem2 = _interopRequireDefault(_AlbumGridItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlaylistsItem = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    deletePlaylistActionData: state.playlists.deletePlaylistActionData,
	    deletePlaylistLoading: state.playlists.deletePlaylistLoading,
	    viewType: state.playlists.viewType
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(PlaylistsItem, _Component);
	
	  function PlaylistsItem() {
	    (0, _classCallCheck3.default)(this, PlaylistsItem);
	    return (0, _possibleConstructorReturn3.default)(this, (PlaylistsItem.__proto__ || (0, _getPrototypeOf2.default)(PlaylistsItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PlaylistsItem, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          viewType = _props.viewType,
	          album = _props.album,
	          deletePlaylistActionData = _props.deletePlaylistActionData,
	          deletePlaylistLoading = _props.deletePlaylistLoading,
	          coloredInfo = _props.coloredInfo,
	          tracks = _props.tracks;
	
	      var loading = deletePlaylistLoading && deletePlaylistActionData.key === album.contentKey;
	
	      return viewType === _Playlists.viewTypes.grid ? _react2.default.createElement(_AlbumGridItem2.default, {
	        album: album,
	        tracks: tracks,
	        coloredInfo: coloredInfo,
	        loading: loading
	      }) : _react2.default.createElement(_AlbumListItem2.default, {
	        album: album,
	        tracks: tracks,
	        coloredInfo: coloredInfo,
	        loading: loading
	      });
	    }
	  }]);
	  return PlaylistsItem;
	}(_react.Component), _class2.propTypes = {
	  album: _propTypes2.default.object,
	  coloredInfo: _propTypes2.default.bool,
	  deletePlaylistActionData: _propTypes2.default.object,
	  deletePlaylistLoading: _propTypes2.default.bool,
	  tracks: _propTypes2.default.object,
	  viewType: _propTypes2.default.string
	}, _class2.defaultProps = {
	  album: {},
	  tracks: {}
	}, _temp)) || _class);
	exports.default = PlaylistsItem;
	module.exports = exports['default'];

/***/ }),
/* 2184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _playlists = __webpack_require__(100);
	
	var playlistsActions = _interopRequireWildcard(_playlists);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _ClearableInput = __webpack_require__(819);
	
	var _ClearableInput2 = _interopRequireDefault(_ClearableInput);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1363);
	
	var PlaylistsSearchBar = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    kw: state.playlists.kw
	  };
	}, (0, _extends3.default)({}, playlistsActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(PlaylistsSearchBar, _Component);
	
	  function PlaylistsSearchBar() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, PlaylistsSearchBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = PlaylistsSearchBar.__proto__ || (0, _getPrototypeOf2.default)(PlaylistsSearchBar)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { kw: _this.props.kw };
	    return _this;
	  }
	
	  (0, _createClass3.default)(PlaylistsSearchBar, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.kw !== this.props.kw) {
	        this.setState({ kw: nextProps.kw });
	      }
	    }
	  }, {
	    key: 'filter',
	    value: function filter(kw) {
	      this.setState({ kw: kw });
	      this.props.filter(kw);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var t = this.context.t;
	      var kw = this.state.kw;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.searchBar },
	        _react2.default.createElement(_ClearableInput2.default, {
	          delay: 300,
	          onChange: this.filter,
	          kw: kw,
	          title: t('Search')
	        })
	      );
	    }
	  }]);
	  return PlaylistsSearchBar;
	}(_react.Component), _class3.propTypes = {
	  filter: _propTypes2.default.func,
	  kw: _propTypes2.default.string
	}, _class3.contextTypes = {
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'filter', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'filter'), _class2.prototype)), _class2)) || _class);
	exports.default = PlaylistsSearchBar;
	module.exports = exports['default'];

/***/ }),
/* 2185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get2 = __webpack_require__(19);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _playlists = __webpack_require__(100);
	
	var playlistsActions = _interopRequireWildcard(_playlists);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _FilterButton = __webpack_require__(349);
	
	var _FilterButton2 = _interopRequireDefault(_FilterButton);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1364);
	
	var PlaylistsSorter = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    activeOrder: state.playlists.activeOrder,
	    order: state.playlists.order,
	    orders: state.playlists.orders
	  };
	}, (0, _extends3.default)({}, playlistsActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(PlaylistsSorter, _Component);
	
	  function PlaylistsSorter() {
	    (0, _classCallCheck3.default)(this, PlaylistsSorter);
	    return (0, _possibleConstructorReturn3.default)(this, (PlaylistsSorter.__proto__ || (0, _getPrototypeOf2.default)(PlaylistsSorter)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PlaylistsSorter, [{
	    key: 'reorder',
	    value: function reorder(e) {
	      var _props = this.props,
	          reorder = _props.reorder,
	          activeOrder = _props.activeOrder;
	
	      var order = (0, _get3.default)(e, 'target.value', activeOrder);
	      reorder(order);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          orders = _props2.orders,
	          order = _props2.order,
	          activeOrder = _props2.activeOrder;
	      var t = this.context.t;
	
	      var _t = t;
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: (0, _bind2.default)(styles.sortTitle) },
	          _react2.default.createElement(
	            'span',
	            { className: 'nowrap' },
	            t('Sort by'),
	            ':'
	          )
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: styles.sorterBlock },
	          _react2.default.createElement(
	            'select',
	            { className: styles.orderSelect, onChange: this.reorder, value: activeOrder },
	            orders.map(function (orderItem) {
	              return _react2.default.createElement(
	                'option',
	                { key: orderItem.name, value: orderItem.name },
	                _t(orderItem.title)
	              );
	            })
	          ),
	          _react2.default.createElement(_FilterButton2.default, {
	            className: 'margin-left-5',
	            onClick: this.reorder,
	            iconClass: order[activeOrder] === 'asc' ? 'icon-sort-alpha-asc' : 'icon-sort-alpha-desc'
	          })
	        )
	      );
	    }
	  }]);
	  return PlaylistsSorter;
	}(_react.Component), _class3.propTypes = {
	  activeOrder: _propTypes2.default.string,
	  order: _propTypes2.default.object,
	  orders: _propTypes2.default.array,
	  reorder: _propTypes2.default.func
	}, _class3.contextTypes = {
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'reorder', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'reorder'), _class2.prototype)), _class2)) || _class);
	exports.default = PlaylistsSorter;
	module.exports = exports['default'];

/***/ }),
/* 2186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _playlists = __webpack_require__(100);
	
	var playlistsActions = _interopRequireWildcard(_playlists);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _Playlists = __webpack_require__(214);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1365);
	
	var PlaylistsToggleViewButton = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    viewType: state.playlists.viewType
	  };
	}, (0, _extends3.default)({}, playlistsActions)), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(PlaylistsToggleViewButton, _Component);
	
	  function PlaylistsToggleViewButton() {
	    (0, _classCallCheck3.default)(this, PlaylistsToggleViewButton);
	    return (0, _possibleConstructorReturn3.default)(this, (PlaylistsToggleViewButton.__proto__ || (0, _getPrototypeOf2.default)(PlaylistsToggleViewButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PlaylistsToggleViewButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          toggleView = _props.toggleView,
	          viewType = _props.viewType,
	          className = _props.className;
	      var t = this.context.t;
	
	      var toggleViewClass = (0, _bind2.default)(styles.viewToggle, {
	        'icon-list': viewType === _Playlists.viewTypes.grid,
	        'icon-grid': viewType === _Playlists.viewTypes.list
	      }, className);
	
	      return _react2.default.createElement('i', { onClick: toggleView, className: toggleViewClass, title: t('Toggle view') });
	    }
	  }]);
	  return PlaylistsToggleViewButton;
	}(_react.Component), _class2.propTypes = {
	  className: _propTypes2.default.string,
	  toggleView: _propTypes2.default.func,
	  viewType: _propTypes2.default.string
	}, _class2.contextTypes = {
	  t: _propTypes2.default.func
	}, _temp)) || _class);
	exports.default = PlaylistsToggleViewButton;
	module.exports = exports['default'];

/***/ }),
/* 2187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClientSideComponent = __webpack_require__(30);
	
	var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);
	
	var _reactRedux = __webpack_require__(11);
	
	var _project = __webpack_require__(37);
	
	var projectActions = _interopRequireWildcard(_project);
	
	var _contacts = __webpack_require__(61);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _AddContactSuggestForm = __webpack_require__(348);
	
	var _AddContactSuggestForm2 = _interopRequireDefault(_AddContactSuggestForm);
	
	var _contacts2 = __webpack_require__(185);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var AddSenderField = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    addSenderLoading: state.project.addSenderLoading,
	    projectData: state.project.projectData,
	    suggestionList: (0, _contacts2.getSuggestionList)(state)
	  };
	}, (0, _extends3.default)({}, projectActions, { loadSuggestionUsersList: _contacts.loadSuggestionUsersList })), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(AddSenderField, _Component);
	
	  function AddSenderField() {
	    (0, _classCallCheck3.default)(this, AddSenderField);
	    return (0, _possibleConstructorReturn3.default)(this, (AddSenderField.__proto__ || (0, _getPrototypeOf2.default)(AddSenderField)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AddSenderField, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.loadSuggestionUsersList();
	    }
	  }, {
	    key: 'onSuggestionSelected',
	    value: function onSuggestionSelected(_ref) {
	      var suggestion = _ref.suggestion;
	
	      return this.addSender(suggestion);
	    }
	  }, {
	    key: 'getAutosuggestItems',
	    value: function getAutosuggestItems() {
	      var suggestionList = this.props.suggestionList;
	
	      var items = [];
	      suggestionList.map(function (user) {
	        return items.push((0, _extends3.default)({}, user, { _name: user.email, _type: 'user' }));
	      });
	      return items;
	    }
	  }, {
	    key: 'addSender',
	    value: function addSender(formData) {
	      var _props = this.props,
	          projectId = _props.projectId,
	          onAdd = _props.onAdd;
	
	      var data = (0, _extends3.default)({ projectId: projectId }, formData);
	      if (data.userEmail) {
	        data.email = data.userEmail;
	      }
	
	      var promise = this.props.addSender(data).promise;
	      promise.then(function () {
	        return onAdd(data);
	      }).catch(function (err) {
	        return err;
	      });
	      return promise;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          addSenderLoading = _props2.addSenderLoading,
	          withZIndex = _props2.withZIndex;
	
	      var items = this.getAutosuggestItems();
	
	      return _react2.default.createElement(_AddContactSuggestForm2.default, {
	        onSuggestionSelected: this.onSuggestionSelected,
	        onSubmit: this.onSubmit,
	        items: items,
	        onAddNewContact: this.addSender,
	        onAddNewContactLoading: addSenderLoading,
	        loading: addSenderLoading,
	        withZIndex: withZIndex
	      });
	    }
	  }]);
	  return AddSenderField;
	}(_ClientSideComponent2.default), _class3.propTypes = {
	  addSender: _propTypes2.default.func,
	  addSenderLoading: _propTypes2.default.bool,
	  loadSuggestionUsersList: _propTypes2.default.func,
	  onAdd: _propTypes2.default.func,
	  projectId: _propTypes2.default.number.isRequired,
	  suggestionList: _propTypes2.default.array,
	  withZIndex: _propTypes2.default.bool
	}, _class3.defaultProps = {
	  addSenderLoading: false,
	  onAdd: _noop3.default,
	  projectData: {},
	  suggestionList: []
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onSuggestionSelected', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSuggestionSelected'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'addSender', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'addSender'), _class2.prototype)), _class2)) || _class);
	exports.default = AddSenderField;
	module.exports = exports['default'];

/***/ }),
/* 2188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClientSideComponent = __webpack_require__(30);
	
	var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);
	
	var _reactRedux = __webpack_require__(11);
	
	var _statistics = __webpack_require__(57);
	
	var statisticsActions = _interopRequireWildcard(_statistics);
	
	var _contacts = __webpack_require__(61);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _AddContactSuggestForm = __webpack_require__(348);
	
	var _AddContactSuggestForm2 = _interopRequireDefault(_AddContactSuggestForm);
	
	var _contacts2 = __webpack_require__(185);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var fieldName = 'statsViewerEmail';
	
	var AddStatsViewerField = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    addStatsViewerLoading: state.statistics.addStatsViewerLoading,
	    projectData: state.project.projectData,
	    suggestionList: (0, _contacts2.getSuggestionList)(state)
	  };
	}, (0, _extends3.default)({}, statisticsActions, { loadSuggestionUsersList: _contacts.loadSuggestionUsersList })), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(AddStatsViewerField, _Component);
	
	  function AddStatsViewerField() {
	    (0, _classCallCheck3.default)(this, AddStatsViewerField);
	    return (0, _possibleConstructorReturn3.default)(this, (AddStatsViewerField.__proto__ || (0, _getPrototypeOf2.default)(AddStatsViewerField)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AddStatsViewerField, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.loadSuggestionUsersList();
	    }
	  }, {
	    key: 'onSuggestionSelected',
	    value: function onSuggestionSelected(_ref) {
	      var suggestion = _ref.suggestion;
	
	      return this.addStatsViewer(suggestion);
	    }
	  }, {
	    key: 'getAutosuggestItems',
	    value: function getAutosuggestItems() {
	      var suggestionList = this.props.suggestionList;
	
	      var items = [];
	      suggestionList.map(function (user) {
	        return items.push((0, _extends3.default)({}, user, { _name: user.email, _type: 'user' }));
	      });
	      return items;
	    }
	  }, {
	    key: 'addStatsViewer',
	    value: function addStatsViewer(formData) {
	      var _props = this.props,
	          projectId = _props.projectId,
	          onAdd = _props.onAdd;
	
	      var data = (0, _extends3.default)({ projectId: projectId }, formData);
	      if (data[fieldName]) {
	        data.email = data[fieldName];
	      }
	
	      var promise = this.props.addStatsViewer(data).promise;
	      promise.then(function () {
	        return onAdd(data);
	      }).catch(function (err) {
	        return err;
	      });
	      return promise;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          addStatsViewerLoading = _props2.addStatsViewerLoading,
	          withZIndex = _props2.withZIndex;
	
	      var items = this.getAutosuggestItems();
	
	      return _react2.default.createElement(_AddContactSuggestForm2.default, {
	        fieldName: fieldName,
	        onSuggestionSelected: this.onSuggestionSelected,
	        onSubmit: this.onSubmit,
	        items: items,
	        onAddNewContact: this.addStatsViewer,
	        onAddNewContactLoading: addStatsViewerLoading,
	        loading: addStatsViewerLoading,
	        withZIndex: withZIndex
	      });
	    }
	  }]);
	  return AddStatsViewerField;
	}(_ClientSideComponent2.default), _class3.propTypes = {
	  addStatsViewer: _propTypes2.default.func,
	  addStatsViewerLoading: _propTypes2.default.bool,
	  loadSuggestionUsersList: _propTypes2.default.func,
	  onAdd: _propTypes2.default.func,
	  projectId: _propTypes2.default.number.isRequired,
	  suggestionList: _propTypes2.default.array,
	  withZIndex: _propTypes2.default.bool
	}, _class3.defaultProps = {
	  addStatsViewerLoading: false,
	  onAdd: _noop3.default,
	  projectData: {},
	  suggestionList: []
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onSuggestionSelected', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSuggestionSelected'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'addStatsViewer', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'addStatsViewer'), _class2.prototype)), _class2)) || _class);
	exports.default = AddStatsViewerField;
	module.exports = exports['default'];

/***/ }),
/* 2189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _keys = __webpack_require__(113);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends3 = __webpack_require__(8);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _promise = __webpack_require__(62);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(55);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactRedux = __webpack_require__(11);
	
	var _project = __webpack_require__(37);
	
	var projectActions = _interopRequireWildcard(_project);
	
	var _reduxConnect = __webpack_require__(33);
	
	var _reactRouter = __webpack_require__(124);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _projects = __webpack_require__(28);
	
	var _asyncPromise = __webpack_require__(43);
	
	var _asyncPromise2 = _interopRequireDefault(_asyncPromise);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _SharespacePublishButton = __webpack_require__(865);
	
	var _SharespacePublishButton2 = _interopRequireDefault(_SharespacePublishButton);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1366);
	
	var showConfirmCheckboxes = false;
	
	var ProjectConfirmation = (_dec = (0, _reduxConnect.asyncConnect)([{
	  promise: function promise(_ref) {
	    var dispatch = _ref.store.dispatch,
	        _ref$params = _ref.params,
	        projectId = _ref$params.projectId,
	        type = _ref$params.type;
	    var loadConfirmation = projectActions.loadConfirmation,
	        loadStatusInfo = projectActions.loadStatusInfo,
	        loadProject = projectActions.loadProject;
	
	    var id = Number(projectId);
	    var promises = [];
	
	    if (type === _projects.projectTypes.sharespace) {
	      promises.push(dispatch(loadProject(id)).promise);
	    } else {
	      promises.push(dispatch(loadConfirmation(id)).promise);
	      promises.push(dispatch(loadStatusInfo(id)).promise);
	    }
	
	    return (0, _asyncPromise2.default)(_promise2.default.all(promises).catch(function (err) {
	      return err;
	    }));
	  }
	}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    confirmation: state.project.confirmationData,
	    confirmationLoading: state.project.confirmationLoading,
	    projectData: state.project.projectData,
	    projectId: Number(ownProps.params.projectId),
	    projectLoading: state.project.projectLoading,
	    projectType: ownProps.params.type,
	    publishLoading: state.project.publishLoading,
	    statusInfo: state.project.statusInfoData,
	    statusInfoLoading: state.project.statusInfoLoading,
	    stopPublishLoading: state.project.stopPublishLoading
	  };
	}, (0, _extends4.default)({}, projectActions)), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(ProjectConfirmation, _Component);
	
	  function ProjectConfirmation() {
	    var _ref2;
	
	    (0, _classCallCheck3.default)(this, ProjectConfirmation);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = ProjectConfirmation.__proto__ || (0, _getPrototypeOf2.default)(ProjectConfirmation)).call.apply(_ref2, [this].concat(args)));
	
	    _this.state = { confirms: { artist: false, title: false, security: false, rights: false } };
	    return _this;
	  }
	
	  (0, _createClass3.default)(ProjectConfirmation, [{
	    key: 'publish',
	    value: function publish() {
	      var _props = this.props,
	          publish = _props.publish,
	          projectId = _props.projectId,
	          loadStatusInfo = _props.loadStatusInfo,
	          t = _props.t;
	
	
	      if (showConfirmCheckboxes && !this.isConfirmed()) {
	        _toastr2.default.warning(t('Please confirm the information to publish the project'));
	      } else {
	        return publish(projectId).promise.then(function () {
	          return loadStatusInfo(projectId);
	        }).catch(function (err) {
	          return err;
	        });
	      }
	    }
	  }, {
	    key: 'stopPublish',
	    value: function stopPublish() {
	      var _props2 = this.props,
	          stopPublish = _props2.stopPublish,
	          loadStatusInfo = _props2.loadStatusInfo,
	          loadConfirmation = _props2.loadConfirmation,
	          projectId = _props2.projectId,
	          projectType = _props2.projectType;
	
	      return stopPublish(projectId).promise.then(function () {
	        if (projectType !== _projects.projectTypes.sharespace) {
	          loadConfirmation(projectId);
	          loadStatusInfo(projectId);
	        }
	      }).catch(function (err) {
	        return err;
	      });
	    }
	  }, {
	    key: 'confirm',
	    value: function confirm(field) {
	      this.setState({
	        confirms: (0, _extends4.default)({}, this.state.confirms, (0, _defineProperty3.default)({}, field, !this.state.confirms[field]))
	      });
	    }
	  }, {
	    key: 'isConfirmed',
	    value: function isConfirmed() {
	      var confirms = this.state.confirms;
	
	      var res = true;
	
	      (0, _keys2.default)(confirms).map(function (field) {
	        if (!confirms[field]) {
	          res = false;
	        }
	      });
	
	      return res;
	    }
	
	    /* eslint-disable react/no-danger */
	
	  }, {
	    key: 'renderProjectConfirm',
	    value: function renderProjectConfirm() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          t = _props3.t,
	          projectId = _props3.projectId,
	          projectType = _props3.projectType,
	          confirmation = _props3.confirmation,
	          statusInfo = _props3.statusInfo,
	          publishLoading = _props3.publishLoading,
	          stopPublishLoading = _props3.stopPublishLoading,
	          confirmationLoading = _props3.confirmationLoading,
	          statusInfoLoading = _props3.statusInfoLoading;
	      var confirms = this.state.confirms;
	
	      var canStop = statusInfo.canStop;
	      var canPublish = confirmation.canProceed && !canStop;
	      var showCheckbox = canPublish && showConfirmCheckboxes;
	      var isPublishLoading = publishLoading || statusInfoLoading;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'section' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            t('We are about to process the files for your recipients.')
	          ),
	          _react2.default.createElement('div', { className: 'danger margin-top-15', dangerouslySetInnerHTML: { __html: confirmation.warnings } }),
	          _react2.default.createElement(
	            'div',
	            { className: 'hint colorPrimary margin-vert-15' },
	            t('Please verify the information below:')
	          ),
	          confirmationLoading ? _react2.default.createElement(_components.Loader, null) : _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: styles.infoRow },
	              showCheckbox ? _react2.default.createElement(_components.Checkbox, { small: true, checked: confirms.artist, onClick: function onClick() {
	                  return _this2.confirm('artist');
	                }, textAfter: t('Artist') + ':' }) : _react2.default.createElement(
	                'div',
	                null,
	                t('Artist'),
	                ':'
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                confirmation.artist
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: styles.infoRow },
	              showCheckbox ? _react2.default.createElement(_components.Checkbox, { small: true, checked: confirms.title, onClick: function onClick() {
	                  return _this2.confirm('title');
	                }, textAfter: t('Title') + ':' }) : _react2.default.createElement(
	                'div',
	                null,
	                t('Title'),
	                ':'
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                confirmation.title
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: styles.infoRow },
	              showCheckbox ? _react2.default.createElement(_components.Checkbox, { small: true, checked: confirms.security, onClick: function onClick() {
	                  return _this2.confirm('security');
	                }, textAfter: t('Security') + ':' }) : _react2.default.createElement(
	                'div',
	                null,
	                t('Security'),
	                ':'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'danger' },
	                confirmation.security
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: styles.infoRow },
	              showCheckbox ? _react2.default.createElement(_components.Checkbox, { small: true, checked: confirms.rights, onClick: function onClick() {
	                  return _this2.confirm('rights');
	                }, textAfter: t('Rights') + ':' }) : _react2.default.createElement(
	                'div',
	                null,
	                t('Rights'),
	                ':'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'danger' },
	                confirmation.rights
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: styles.infoRow + ' hint small' },
	            _react2.default.createElement('div', null),
	            _react2.default.createElement(
	              'div',
	              null,
	              t('We aim to deliver your project in less than 30 minutes but it can sometimes take a little longer'),
	              '.',
	              _react2.default.createElement('br', null),
	              t('We will send you a confirmation email as soon as recipients are notified'),
	              '.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'margin-top-30 text-right' },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/projects/' + projectType + '/' + projectId + '/recipients', className: 'btn btn-accent wide margin-vert-5' },
	            t('Back to project')
	          ),
	          canPublish && _react2.default.createElement(
	            'button',
	            { className: 'btn btn-primary pos-rel wide margin-left-20 margin-vert-5', onClick: this.publish, disabled: publishLoading },
	            t('Publish'),
	            isPublishLoading && _react2.default.createElement(_components.Loader, { mask: true })
	          ),
	          canStop && _react2.default.createElement(
	            'button',
	            { className: 'btn btn-danger pos-rel wide margin-left-20 margin-vert-5', onClick: this.stopPublish, disabled: stopPublishLoading },
	            t('Stop'),
	            '!',
	            stopPublishLoading && _react2.default.createElement(_components.Loader, { mask: true })
	          )
	        )
	      );
	    }
	    /* eslint-enable react/no-danger */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          t = _props4.t,
	          projectId = _props4.projectId,
	          projectData = _props4.projectData,
	          projectType = _props4.projectType,
	          confirmationLoading = _props4.confirmationLoading,
	          statusInfoLoading = _props4.statusInfoLoading,
	          projectLoading = _props4.projectLoading;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(_reactHelmet2.default, { title: 'Project' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'container-fluid' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            t('Confirmation'),
	            (confirmationLoading || statusInfoLoading || projectLoading) && _react2.default.createElement(_components.Loader, { small: true, inline: true, right: true })
	          ),
	          _react2.default.createElement(_components.ProjectBreadcrumbs, { projectId: projectId, projectType: projectType }),
	          projectType === _projects.projectTypes.sharespace ? _react2.default.createElement(_SharespacePublishButton2.default, { project: projectData }) : this.renderProjectConfirm()
	        )
	      );
	    }
	  }]);
	  return ProjectConfirmation;
	}(_react.Component), _class3.propTypes = {
	  confirmation: _propTypes2.default.object,
	  confirmationLoading: _propTypes2.default.bool,
	  loadConfirmation: _propTypes2.default.func,
	  loadStatusInfo: _propTypes2.default.func,
	  projectData: _propTypes2.default.object,
	  projectId: _propTypes2.default.number,
	  projectLoading: _propTypes2.default.bool,
	  projectType: _propTypes2.default.string,
	  publish: _propTypes2.default.func,
	  publishLoading: _propTypes2.default.bool,
	  statusInfo: _propTypes2.default.object,
	  statusInfoLoading: _propTypes2.default.bool,
	  stopPublish: _propTypes2.default.func,
	  stopPublishLoading: _propTypes2.default.bool,
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'publish', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'publish'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'stopPublish', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'stopPublish'), _class2.prototype)), _class2)) || _class) || _class) || _class);
	exports.default = ProjectConfirmation;
	module.exports = exports['default'];

/***/ }),
/* 2190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _promise = __webpack_require__(62);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _isEmpty2 = __webpack_require__(81);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _get3 = __webpack_require__(19);
	
	var _get4 = _interopRequireDefault(_get3);
	
	var _dec, _dec2, _dec3, _dec4, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(55);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactRedux = __webpack_require__(11);
	
	var _project = __webpack_require__(37);
	
	var projectActions = _interopRequireWildcard(_project);
	
	var _reduxConnect = __webpack_require__(33);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	var _reduxForm = __webpack_require__(50);
	
	var _reactRouter = __webpack_require__(124);
	
	var _formComponents = __webpack_require__(71);
	
	var _reactRouterRedux = __webpack_require__(40);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _asyncPromise = __webpack_require__(43);
	
	var _asyncPromise2 = _interopRequireDefault(_asyncPromise);
	
	var _projects = __webpack_require__(136);
	
	var _SharespaceMediaList = __webpack_require__(2191);
	
	var _SharespaceMediaList2 = _interopRequireDefault(_SharespaceMediaList);
	
	var _SharespacePressList = __webpack_require__(2192);
	
	var _SharespacePressList2 = _interopRequireDefault(_SharespacePressList);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var projectFormDefaults = {
	  title: '',
	  title2: '',
	  internalRef: ''
	};
	
	var ProjectCreateFromSS = (_dec = (0, _reduxConnect.asyncConnect)([{
	  promise: function promise(_ref) {
	    var dispatch = _ref.store.dispatch,
	        projectId = _ref.params.projectId;
	    var loadProject = projectActions.loadProject,
	        loadMediaList = projectActions.loadMediaList,
	        loadPressList = projectActions.loadPressList;
	
	    var id = Number(projectId);
	    var promises = [dispatch(loadProject(id)).promise.then(function () {
	      return _promise2.default.all([dispatch(loadMediaList(id)).promise, dispatch(loadPressList(id)).promise]);
	    })];
	    return (0, _asyncPromise2.default)(_promise2.default.all(promises));
	  }
	}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
	  var _ref2 = state.project.projectData || {},
	      title = _ref2.title,
	      title2 = _ref2.title2,
	      internalRef = _ref2.internalRef;
	
	  return {
	    createSubprojectLoading: state.project.createSubprojectLoading,
	    initialValues: state.project.projectData ? { title: title, title2: title2, internalRef: internalRef } : null,
	    mediaList: state.project.mediaListData,
	    mediaListLoading: state.project.mediaListLoading,
	    partTracks: (0, _projects.getPartTracks)(state),
	    pressList: state.project.pressListData,
	    pressListLoading: state.project.pressListLoading,
	    project: state.project.projectData,
	    projectId: Number(ownProps.params.projectId),
	    projectLoading: state.project.projectLoading,
	    projectType: ownProps.params.type
	  };
	}, (0, _extends3.default)({}, projectActions, { pushState: _reactRouterRedux.push })), _dec3 = (0, _reduxForm.reduxForm)({
	  form: 'projectForm',
	  propNamespace: 'projectForm',
	  initialValues: projectFormDefaults
	}), _dec4 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(ProjectCreateFromSS, _Component);
	
	  function ProjectCreateFromSS() {
	    var _ref3;
	
	    (0, _classCallCheck3.default)(this, ProjectCreateFromSS);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref3 = ProjectCreateFromSS.__proto__ || (0, _getPrototypeOf2.default)(ProjectCreateFromSS)).call.apply(_ref3, [this].concat(args)));
	
	    _this.state = { checkedTracks: [], checkedPress: [] };
	    return _this;
	  }
	
	  (0, _createClass3.default)(ProjectCreateFromSS, [{
	    key: 'onTracksSelect',
	    value: function onTracksSelect(checkedTracks) {
	      this.setState({ checkedTracks: checkedTracks });
	    }
	  }, {
	    key: 'onPressSelect',
	    value: function onPressSelect(checkedPress) {
	      this.setState({ checkedPress: checkedPress });
	    }
	  }, {
	    key: 'isLocked',
	    value: function isLocked() {
	      var project = this.props.project || {};
	      return !!project.isLocked;
	    }
	  }, {
	    key: 'isTracksSelected',
	    value: function isTracksSelected() {
	      var mediaList = this.props.mediaList;
	      var checkedTracks = this.state.checkedTracks;
	
	      return !((0, _isEmpty3.default)(checkedTracks) && !(0, _isEmpty3.default)(mediaList) && !this.isLocked());
	    }
	  }, {
	    key: 'submit',
	    value: function submit(formData) {
	      if (!this.isTracksSelected()) {
	        return _toastr2.default.warning('No tracks selected');
	      }
	
	      var _props = this.props,
	          t = _props.t,
	          createSubproject = _props.createSubproject,
	          projectId = _props.projectId,
	          pushState = _props.pushState;
	      var _state = this.state,
	          checkedTracks = _state.checkedTracks,
	          checkedPress = _state.checkedPress;
	
	      var params = {
	        projectId: projectId,
	        data: formData,
	        tracks: checkedTracks,
	        press: checkedPress
	      };
	
	      createSubproject(params).promise.then(function (resp) {
	        _toastr2.default.success(t('Project successfully created!'));
	
	        var _get2 = (0, _get4.default)(resp, 'data.subProject', {}),
	            id = _get2.id,
	            contentType = _get2.contentType;
	
	        return pushState('/projects/' + contentType + '/' + id);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          t = _props2.t,
	          _props2$projectForm = _props2.projectForm,
	          handleSubmit = _props2$projectForm.handleSubmit,
	          submitting = _props2$projectForm.submitting,
	          projectLoading = _props2.projectLoading,
	          createSubprojectLoading = _props2.createSubprojectLoading,
	          partTracks = _props2.partTracks,
	          mediaList = _props2.mediaList,
	          mediaListLoading = _props2.mediaListLoading,
	          pressListLoading = _props2.pressListLoading,
	          pressList = _props2.pressList;
	
	      var project = this.props.project || {};
	      var isLocked = this.isLocked();
	
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit(this.submit), className: 'page' },
	        _react2.default.createElement(_reactHelmet2.default, { title: 'Project' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'container-fluid' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            t('Create Project from Sharespace'),
	            projectLoading && _react2.default.createElement(_components.Loader, { small: true, inline: true, right: true })
	          ),
	          _react2.default.createElement(
	            'h3',
	            null,
	            t('Project name')
	          ),
	          _react2.default.createElement(
	            'h4',
	            null,
	            t('Project'),
	            ': ',
	            project && project.artistName
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'formRow' },
	            _react2.default.createElement(
	              'div',
	              null,
	              t('Title'),
	              '*'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_reduxForm.Field, { name: 'title', noIndent: true, type: 'text', component: _formComponents.formSimpleTextInput, required: true, disabled: isLocked })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'formRow' },
	            _react2.default.createElement(
	              'div',
	              null,
	              t('Title'),
	              ' 2'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_reduxForm.Field, { name: 'title2', noIndent: true, type: 'text', component: _formComponents.formSimpleTextInput })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'formRow' },
	            _react2.default.createElement(
	              'div',
	              null,
	              t('Internal Ref')
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_reduxForm.Field, { name: 'internalRef', noIndent: true, type: 'text', component: _formComponents.formSimpleTextInput }),
	              _react2.default.createElement(
	                'div',
	                null,
	                t('This field allows you to identify this project. It will not be shown to any recipients')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'h3',
	            null,
	            t('Music')
	          ),
	          _react2.default.createElement(_SharespaceMediaList2.default, {
	            partTracks: partTracks,
	            loading: mediaListLoading,
	            mediaList: mediaList,
	            project: project,
	            onSelect: this.onTracksSelect
	          }),
	          project.id && _react2.default.createElement(
	            'h3',
	            null,
	            t('Press list')
	          ),
	          _react2.default.createElement(_SharespacePressList2.default, {
	            loading: pressListLoading,
	            pressList: pressList,
	            project: project,
	            onSelect: this.onPressSelect
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'text-right margin-vert-40' },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { className: 'btn btn-default wide', to: '/projects/sharespace' },
	              t('Cancel')
	            ),
	            _react2.default.createElement(
	              'button',
	              { type: 'submit', className: 'btn btn-primary margin-left-10 wide pos-rel', disabled: submitting },
	              t('Next'),
	              createSubprojectLoading && _react2.default.createElement(_components.Loader, { mask: true })
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return ProjectCreateFromSS;
	}(_react.Component), _class3.propTypes = {
	  createSubproject: _propTypes2.default.func,
	  createSubprojectLoading: _propTypes2.default.bool,
	  mediaList: _propTypes2.default.array,
	  mediaListLoading: _propTypes2.default.bool,
	  partTracks: _propTypes2.default.object,
	  pressList: _propTypes2.default.array,
	  pressListLoading: _propTypes2.default.bool,
	  project: _propTypes2.default.object,
	  projectForm: _propTypes2.default.object,
	  projectId: _propTypes2.default.number,
	  projectLoading: _propTypes2.default.bool,
	  pushState: _propTypes2.default.func,
	  t: _propTypes2.default.func
	}, _class3.defaultProps = {
	  mediaList: [],
	  project: {}
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onTracksSelect', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onTracksSelect'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onPressSelect', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onPressSelect'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'submit', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'submit'), _class2.prototype)), _class2)) || _class) || _class) || _class) || _class);
	exports.default = ProjectCreateFromSS;
	module.exports = exports['default'];

/***/ }),
/* 2191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(8);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _invertBy3 = __webpack_require__(132);
	
	var _invertBy4 = _interopRequireDefault(_invertBy3);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _utils = __webpack_require__(24);
	
	var _components = __webpack_require__(15);
	
	var _reactI18next = __webpack_require__(12);
	
	var _TrackPartHeader = __webpack_require__(856);
	
	var _TrackPartHeader2 = _interopRequireDefault(_TrackPartHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(632);
	
	var SharespaceMediaList = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(SharespaceMediaList, _Component);
	
	  function SharespaceMediaList() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, SharespaceMediaList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = SharespaceMediaList.__proto__ || (0, _getPrototypeOf2.default)(SharespaceMediaList)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { checkedTracks: {} };
	    return _this;
	  }
	
	  (0, _createClass3.default)(SharespaceMediaList, [{
	    key: 'onSelectAllClick',
	    value: function onSelectAllClick() {
	      var isAllTracksSelected = this.state.isAllTracksSelected;
	
	      if (isAllTracksSelected) {
	        this.selectNone();
	      } else {
	        this.selectAll();
	      }
	    }
	  }, {
	    key: 'onSelect',
	    value: function onSelect() {
	      var checkedTracks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var onSelect = this.props.onSelect;
	
	      onSelect((0, _invertBy4.default)(checkedTracks).true || []);
	    }
	  }, {
	    key: 'getCheckedTracksArray',
	    value: function getCheckedTracksArray(checkedTracks) {
	      return (0, _invertBy4.default)(checkedTracks || this.state.checkedTracks || {}).true || [];
	    }
	  }, {
	    key: 'toggleTrackChecked',
	    value: function toggleTrackChecked(id) {
	      var mediaList = this.props.mediaList;
	
	
	      var checkedTracks = (0, _extends4.default)({}, this.state.checkedTracks, (0, _defineProperty3.default)({}, id, !this.state.checkedTracks[id]));
	      var checkedTracksArr = this.getCheckedTracksArray(checkedTracks);
	      this.setState({ checkedTracks: checkedTracks, isAllTracksSelected: checkedTracksArr.length === mediaList.length });
	      this.onSelect(checkedTracks);
	    }
	  }, {
	    key: 'selectAll',
	    value: function selectAll() {
	      var mediaList = this.props.mediaList;
	
	      var checkedTracks = {};
	      for (var i = 0; i < mediaList.length; i++) {
	        checkedTracks[i + 1] = true;
	      }
	      this.setState({ checkedTracks: checkedTracks, isAllTracksSelected: true });
	      this.onSelect(checkedTracks);
	    }
	  }, {
	    key: 'selectNone',
	    value: function selectNone() {
	      this.setState({ checkedTracks: {}, isAllTracksSelected: false });
	      this.onSelect({});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          t = _props.t,
	          mediaList = _props.mediaList,
	          loading = _props.loading,
	          partTracks = _props.partTracks,
	          project = _props.project;
	      var _state = this.state,
	          checkedTracks = _state.checkedTracks,
	          isAllTracksSelected = _state.isAllTracksSelected;
	
	      var isLocked = !!project.isLocked;
	
	      if (!project.id) {
	        return null;
	      }
	
	      if (isLocked) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'bold' },
	          t('Content will be automatically transferred to your new project.')
	        );
	      }
	
	      if (!mediaList.length && !loading) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          t('Music list is empty')
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'overflow-hidden margin-bottom-10' },
	          _react2.default.createElement(
	            'div',
	            { className: 'hint pull-left' },
	            t('Select tracks you want to reuse in your project.')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: styles.selectAllContainer },
	            _react2.default.createElement(_components.Checkbox, {
	              className: 'padding-5 inline',
	              checked: isAllTracksSelected,
	              textBefore: t('Select all'),
	              onChange: this.onSelectAllClick
	            })
	          )
	        ),
	        partTracks.parts.map(function (part) {
	          return _react2.default.createElement(
	            'div',
	            { key: 'part-' + part },
	            !!project.multipleBoxsets && _react2.default.createElement(_TrackPartHeader2.default, { part: part }),
	            _react2.default.createElement(
	              _components.List,
	              null,
	              partTracks.tracks[part].map(function (trackIndex) {
	                return _react2.default.createElement(
	                  _components.ListItem,
	                  {
	                    fullWidth: true,
	                    key: mediaList[trackIndex].id,
	                    onClick: function onClick() {
	                      return _this2.toggleTrackChecked(trackIndex + 1);
	                    }
	                  },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    mediaList[trackIndex].filename
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: styles.checkboxCell },
	                    _react2.default.createElement(_components.Checkbox, {
	                      className: 'padding-5 inline',
	                      checked: checkedTracks[trackIndex + 1],
	                      onClick: _utils.stopEvent
	                    })
	                  )
	                );
	              })
	            )
	          );
	        }),
	        loading && _react2.default.createElement(_components.Loader, null)
	      );
	    }
	  }]);
	  return SharespaceMediaList;
	}(_react.Component), _class3.propTypes = {
	  loading: _propTypes2.default.bool,
	  mediaList: _propTypes2.default.array,
	  onSelect: _propTypes2.default.func,
	  partTracks: _propTypes2.default.object,
	  project: _propTypes2.default.object,
	  t: _propTypes2.default.func
	}, _class3.defaultProps = {
	  mediaList: [],
	  onSelect: _noop3.default,
	  partTracks: {},
	  project: {}
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onSelectAllClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSelectAllClick'), _class2.prototype)), _class2)) || _class);
	exports.default = SharespaceMediaList;
	module.exports = exports['default'];

/***/ }),
/* 2192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(8);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _findIndex2 = __webpack_require__(318);
	
	var _findIndex3 = _interopRequireDefault(_findIndex2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _invertBy3 = __webpack_require__(132);
	
	var _invertBy4 = _interopRequireDefault(_invertBy3);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(12);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _utils = __webpack_require__(24);
	
	var _components = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(632);
	
	var SharespacePressList = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(SharespacePressList, _Component);
	
	  function SharespacePressList() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, SharespacePressList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = SharespacePressList.__proto__ || (0, _getPrototypeOf2.default)(SharespacePressList)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = { checkedItems: {} };
	    return _this;
	  }
	
	  (0, _createClass3.default)(SharespacePressList, [{
	    key: 'onSelectAllClick',
	    value: function onSelectAllClick() {
	      var isAllItemsSelected = this.state.isAllItemsSelected;
	
	      if (isAllItemsSelected) {
	        this.selectNone();
	      } else {
	        this.selectAll();
	      }
	    }
	  }, {
	    key: 'onSelect',
	    value: function onSelect() {
	      var checkedItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var _props = this.props,
	          onSelect = _props.onSelect,
	          pressList = _props.pressList;
	
	      var checkedArray = this.getCheckedItemsArray(checkedItems);
	      var result = [];
	      checkedArray.map(function (pressId) {
	        var index = (0, _findIndex3.default)(pressList, { pressId: Number(pressId) }) + 1;
	        result.push(index);
	      });
	      onSelect(result);
	    }
	  }, {
	    key: 'getCheckedItemsArray',
	    value: function getCheckedItemsArray(checkedItems) {
	      return (0, _invertBy4.default)(checkedItems || this.state.checkedItems || {}).true || [];
	    }
	  }, {
	    key: 'toggleItemChecked',
	    value: function toggleItemChecked(id) {
	      var pressList = this.props.pressList;
	
	
	      var checkedItems = (0, _extends4.default)({}, this.state.checkedItems, (0, _defineProperty3.default)({}, id, !this.state.checkedItems[id]));
	      var checkedItemsArr = this.getCheckedItemsArray(checkedItems);
	      this.setState({ checkedItems: checkedItems, isAllItemsSelected: checkedItemsArr.length === pressList.length });
	      this.onSelect(checkedItems);
	    }
	  }, {
	    key: 'selectAll',
	    value: function selectAll() {
	      var pressList = this.props.pressList;
	
	      var checkedItems = {};
	      pressList.map(function (item) {
	        return checkedItems[item.pressId] = true;
	      });
	      this.setState({ checkedItems: checkedItems, isAllItemsSelected: true });
	      this.onSelect(checkedItems);
	    }
	  }, {
	    key: 'selectNone',
	    value: function selectNone() {
	      this.setState({ checkedItems: {}, isAllItemsSelected: false });
	      this.onSelect({});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          t = _props2.t,
	          pressList = _props2.pressList,
	          loading = _props2.loading,
	          project = _props2.project;
	      var _state = this.state,
	          checkedItems = _state.checkedItems,
	          isAllItemsSelected = _state.isAllItemsSelected;
	
	      var isLocked = !!project.isLocked;
	
	      if (!project.id) {
	        return null;
	      }
	
	      if (isLocked) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'bold' },
	          t('Press will be automatically transferred to your new project.')
	        );
	      }
	
	      if (!pressList.length && !loading) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          t('Press list is empty')
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'overflow-hidden margin-bottom-10' },
	          _react2.default.createElement(
	            'div',
	            { className: 'hint pull-left' },
	            t('Select press you want to reuse in your project.')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: styles.selectAllContainer },
	            _react2.default.createElement(_components.Checkbox, {
	              className: 'padding-5 inline',
	              checked: isAllItemsSelected,
	              textBefore: t('Select all'),
	              onChange: this.onSelectAllClick
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _components.List,
	          null,
	          pressList.map(function (item) {
	            return _react2.default.createElement(
	              _components.ListItem,
	              { fullWidth: true, key: item.pressId, onClick: function onClick() {
	                  return _this2.toggleItemChecked(item.pressId);
	                } },
	              _react2.default.createElement(
	                'div',
	                null,
	                item.fileName
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: styles.checkboxCell },
	                _react2.default.createElement(_components.Checkbox, {
	                  className: 'padding-5 inline',
	                  checked: checkedItems[item.pressId],
	                  onClick: _utils.stopEvent
	                })
	              )
	            );
	          })
	        ),
	        loading && _react2.default.createElement(_components.Loader, null)
	      );
	    }
	  }]);
	  return SharespacePressList;
	}(_react.Component), _class3.propTypes = {
	  loading: _propTypes2.default.bool,
	  onSelect: _propTypes2.default.func,
	  pressList: _propTypes2.default.array,
	  project: _propTypes2.default.object,
	  t: _propTypes2.default.func
	}, _class3.defaultProps = {
	  onSelect: _noop3.default,
	  pressList: [],
	  project: {}
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onSelectAllClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSelectAllClick'), _class2.prototype)), _class2)) || _class);
	exports.default = SharespacePressList;
	module.exports = exports['default'];

/***/ }),
/* 2193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _project = __webpack_require__(37);
	
	var projectActions = _interopRequireWildcard(_project);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var ProjectDeleteSenderButton = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    deleteSenderLoading: state.project.deleteSenderLoading
	  };
	}, (0, _extends3.default)({}, projectActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(ProjectDeleteSenderButton, _Component);
	
	  function ProjectDeleteSenderButton() {
	    (0, _classCallCheck3.default)(this, ProjectDeleteSenderButton);
	    return (0, _possibleConstructorReturn3.default)(this, (ProjectDeleteSenderButton.__proto__ || (0, _getPrototypeOf2.default)(ProjectDeleteSenderButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProjectDeleteSenderButton, [{
	    key: 'deleteSender',
	    value: function deleteSender() {
	      var _props = this.props,
	          deleteSender = _props.deleteSender,
	          projectId = _props.projectId,
	          onDelete = _props.onDelete;
	
	      return deleteSender({ projectId: projectId }).promise.then(onDelete).catch(function (err) {
	        return err;
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          deleteSenderLoading = _props2.deleteSenderLoading;
	      var t = this.context.t;
	
	
	      return _react2.default.createElement(
	        _Button2.default,
	        {
	          className: (0, _bind2.default)('btn-danger', className),
	          onClick: this.deleteSender,
	          loading: deleteSenderLoading
	        },
	        t('Delete')
	      );
	    }
	  }]);
	  return ProjectDeleteSenderButton;
	}(_react.Component), _class3.propTypes = {
	  className: _propTypes2.default.string,
	  deleteSender: _propTypes2.default.func,
	  deleteSenderLoading: _propTypes2.default.bool,
	  onDelete: _propTypes2.default.func,
	  projectId: _propTypes2.default.number
	}, _class3.contextTypes = {
	  t: _propTypes2.default.func
	}, _class3.defaultProps = {
	  onDelete: _noop3.default
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'deleteSender', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'deleteSender'), _class2.prototype)), _class2)) || _class);
	exports.default = ProjectDeleteSenderButton;
	module.exports = exports['default'];

/***/ }),
/* 2194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get4 = __webpack_require__(58);
	
	var _get5 = _interopRequireDefault(_get4);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _promise = __webpack_require__(62);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(78);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(72);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _get6 = __webpack_require__(19);
	
	var _get7 = _interopRequireDefault(_get6);
	
	var _dec, _dec2, _dec3, _dec4, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClientSideComponent = __webpack_require__(30);
	
	var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);
	
	var _reactHelmet = __webpack_require__(55);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactRedux = __webpack_require__(11);
	
	var _project = __webpack_require__(37);
	
	var projectActions = _interopRequireWildcard(_project);
	
	var _statistics = __webpack_require__(57);
	
	var statisticsActions = _interopRequireWildcard(_statistics);
	
	var _reduxConnect = __webpack_require__(33);
	
	var _reactRouterRedux = __webpack_require__(40);
	
	var _components = __webpack_require__(15);
	
	var _reactI18next = __webpack_require__(12);
	
	var _reduxForm = __webpack_require__(50);
	
	var _formComponents = __webpack_require__(71);
	
	var _forms = __webpack_require__(526);
	
	var _ProjectInfoFormValidation = __webpack_require__(2195);
	
	var _ProjectInfoFormValidation2 = _interopRequireDefault(_ProjectInfoFormValidation);
	
	var _projects = __webpack_require__(136);
	
	var _Collapse = __webpack_require__(702);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _datetime = __webpack_require__(68);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _auth = __webpack_require__(77);
	
	var _projects2 = __webpack_require__(28);
	
	var _asyncPromise = __webpack_require__(43);
	
	var _asyncPromise2 = _interopRequireDefault(_asyncPromise);
	
	var _reactCookie = __webpack_require__(174);
	
	var _storage = __webpack_require__(529);
	
	var _storage2 = _interopRequireDefault(_storage);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _FormRow = __webpack_require__(2011);
	
	var _FormRow2 = _interopRequireDefault(_FormRow);
	
	var _AddSenderField = __webpack_require__(2187);
	
	var _AddSenderField2 = _interopRequireDefault(_AddSenderField);
	
	var _strings = __webpack_require__(59);
	
	var _ProjectSenderInfo = __webpack_require__(2198);
	
	var _ProjectSenderInfo2 = _interopRequireDefault(_ProjectSenderInfo);
	
	var _AddStatsViewerField = __webpack_require__(2188);
	
	var _AddStatsViewerField2 = _interopRequireDefault(_AddStatsViewerField);
	
	var _ProjectStatsViewersList = __webpack_require__(2200);
	
	var _ProjectStatsViewersList2 = _interopRequireDefault(_ProjectStatsViewersList);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1367);
	
	var formSelector = (0, _reduxForm.formValueSelector)('projectInfoForm');
	
	var projectInfoFormDefaults = {
	  bcove: '',
	  storyboard: '',
	  contentLink: '',
	  videoResolution: 'small',
	  artistName: '',
	  title: '',
	  title2: '',
	  internalRef: '',
	  copyrightNotice: '',
	  senderName: '',
	  senderEmail: '',
	  senderAdditionalEmail: '',
	  labelId0: 0,
	  labelId1: 0,
	  labelId2: 0,
	  labelName: '',
	  senderLabel: '',
	  releaseDate: '',
	  impactDate: '',
	  dispatchDate: '',
	  playsNumber: 0,
	  downloadAuthorised: 0,
	  expiryDate: '',
	  individualExpiryDate: 0,
	  watermarkTracks: 0,
	  isWatermarkVideo: 0,
	  directAccessWatermark: 0,
	  hideSender: 0
	};
	
	var ProjectInfo = (_dec = (0, _reduxConnect.asyncConnect)([{
	  promise: function promise(_ref) {
	    var _ref$store = _ref.store,
	        dispatch = _ref$store.dispatch,
	        getState = _ref$store.getState,
	        _ref$params = _ref.params,
	        projectId = _ref$params.projectId,
	        type = _ref$params.type;
	    var isLoadProjectTime = projectActions.isLoadProjectTime,
	        loadProject = projectActions.loadProject,
	        initProject = projectActions.initProject;
	
	    var id = Number(projectId);
	
	    // at first, get projectId for new SS to have ability to add recipients
	    if (!id) {
	      dispatch(initProject());
	      var method = type === _projects2.projectTypes.sharespace ? 'ssCreate' : 'projectCreate';
	      return (0, _asyncPromise2.default)(dispatch(projectActions[method]()).promise.then(function (resp) {
	        return dispatch((0, _reactRouterRedux.push)('/projects/' + type + '/' + resp.data.projectId));
	      }));
	    }
	
	    var promises = [];
	    var isCommonLoaded = getState().project.commonLoaded;
	    var commonDataPromise = void 0;
	
	    if (!isCommonLoaded) {
	      commonDataPromise = dispatch(projectActions.loadCommon()).promise;
	      promises.push(commonDataPromise);
	    }
	
	    var initFormData = function initFormData() {
	      var commonData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getState().project.commonData;
	
	      var commonDataDefaults = {};
	      (0, _entries2.default)(commonData.defaults).map(function (_ref2) {
	        var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
	            fieldName = _ref3[0],
	            field = _ref3[1];
	
	        commonDataDefaults[fieldName] = field.value;
	      });
	      //TODO: fix API
	      if (type === _projects2.projectTypes.sharespace) {
	        commonDataDefaults.downloadAuthorised = false;
	      }
	      var projectData = (0, _projects.getProjectData)(getState());
	      var formData = (0, _extends3.default)({}, projectInfoFormDefaults, commonDataDefaults, { type: type }, projectData);
	      /*if (id && !formData.senderLabel) {
	        formData.senderLabel = formData.labelName;
	      }*/
	      dispatch((0, _reduxForm.initialize)('projectInfoForm', formData));
	    };
	
	    var initForm = function initForm() {
	      if (commonDataPromise) {
	        commonDataPromise.then(function (resp) {
	          return initFormData(resp.data);
	        });
	      } else {
	        initFormData();
	      }
	    };
	
	    if (id) {
	      if (isLoadProjectTime(id, getState())) {
	        promises.push(dispatch(loadProject(id)).promise.then(initForm));
	        promises.push(dispatch(statisticsActions.loadProjectStatsViewers({ projectId: id })).promise);
	      } else {
	        initForm();
	      }
	    } else {
	      promises.push(dispatch(initProject()));
	      initForm();
	    }
	
	    return (0, _asyncPromise2.default)(_promise2.default.all(promises));
	  }
	}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    // initialValues: state.project.projectData,
	    commonData: state.project.commonData,
	    permissions: (0, _auth.getPermissions)(state),
	    projectData: (0, _projects.getProjectData)(state),
	    projectId: Number(ownProps.params.projectId),
	    projectType: ownProps.params.type,
	    projectLoading: state.project.projectLoading,
	    senderEmailValue: formSelector(state, 'senderEmail'),
	    senderNameValue: formSelector(state, 'senderName')
	  };
	}, (0, _extends3.default)({}, projectActions, statisticsActions, { changeFieldValue: _reduxForm.change, pushState: _reactRouterRedux.push })), _dec3 = (0, _reduxForm.reduxForm)({
	  form: 'projectInfoForm',
	  propNamespace: 'projectInfoForm',
	  initialValues: projectInfoFormDefaults,
	  validate: _ProjectInfoFormValidation2.default
	}), _dec4 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = (0, _reactCookie.withCookies)(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(ProjectInfo, _Component);
	
	  function ProjectInfo(props) {
	    (0, _classCallCheck3.default)(this, ProjectInfo);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ProjectInfo.__proto__ || (0, _getPrototypeOf2.default)(ProjectInfo)).call(this, props));
	
	    _this.cookies = new _storage2.default(props.cookies);
	    _this.state = {
	      timezone: '',
	      hideOptionalSection: !!_this.props.projectId && !_this.cookies.getAsBoolean({ name: 'showOptionalSection' })
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(ProjectInfo, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      (0, _get5.default)(ProjectInfo.prototype.__proto__ || (0, _getPrototypeOf2.default)(ProjectInfo.prototype), 'componentDidMount', this).call(this, function () {
	        // get timezone on clientside only
	        _this2.getTimezone();
	      });
	    }
	  }, {
	    key: 'onSenderAdd',
	    value: function onSenderAdd(data) {
	      this.setSender({
	        senderEmail: data.email,
	        senderName: (0, _strings.concat)(' ', data.name, data.surname)
	      });
	
	      var projectId = this.props.projectId;
	
	      this.props.loadProjectStatsViewers({ projectId: projectId });
	    }
	  }, {
	    key: 'onSenderDelete',
	    value: function onSenderDelete() {
	      this.setSender({ senderEmail: '', senderName: '' });
	    }
	  }, {
	    key: 'getTimezone',
	    value: function getTimezone() {
	      this.setState({ timezone: new Date().toLocaleString('en', { timeZoneName: 'short' }).split(' ').pop() });
	    }
	  }, {
	    key: 'getTitle',
	    value: function getTitle() {
	      var _props = this.props,
	          t = _props.t,
	          projectId = _props.projectId,
	          projectType = _props.projectType,
	          projectData = _props.projectData;
	
	      var title = void 0;
	      if (projectType === _projects2.projectTypes.sharespace) {
	        title = projectData.artistName ? t('Edit Sharespace') : t('Create Sharespace');
	      } else {
	        var _titles;
	
	        var titles = (_titles = {}, (0, _defineProperty3.default)(_titles, _projects2.projectTypes.audio, projectId ? t('Edit Audio Project') : t('Create Audio Project')), (0, _defineProperty3.default)(_titles, _projects2.projectTypes.video, projectId ? t('Edit Video Project') : t('Create Video Project')), (0, _defineProperty3.default)(_titles, _projects2.projectTypes.newsletter, projectId ? t('Edit Newsletter') : t('Create Newsletter')), _titles);
	        var defaultTitle = projectId ? t('Edit Project') : t('Create new Project');
	        title = titles[projectType] || defaultTitle;
	      }
	
	      return title;
	    }
	  }, {
	    key: 'setSender',
	    value: function setSender(_ref4) {
	      var senderEmail = _ref4.senderEmail,
	          senderName = _ref4.senderName;
	      var change = this.props.projectInfoForm.change;
	
	      change('senderEmail', senderEmail);
	      change('senderName', senderName);
	    }
	  }, {
	    key: 'submit',
	    value: function submit(formData) {
	      var _props2 = this.props,
	          projectId = _props2.projectId,
	          projectType = _props2.projectType,
	          pushState = _props2.pushState,
	          saveProject = _props2.saveProject;
	
	      var data = (0, _forms.normalizeFormData)(formData, { dateTimeFields: ['dispatchDate'] });
	      data.daySavingLight = (0, _datetime.isDaySavingLight)();
	      data.timeDifference = (0, _datetime.getTimeDifference)();
	      data.projectType = projectType === _projects2.projectTypes.sharespace ? 'root_project' : 'project';
	      data.contentType = projectType === _projects2.projectTypes.sharespace ? _projects2.projectTypes.audio : projectType;
	      data.projectId = projectId;
	      data.bcove = data.bcove || 0;
	      if (projectType === _projects2.projectTypes.sharespace && !projectId) {
	        data.dispatchDate = 0;
	      }
	      if (!projectId) {
	        data.senderLabel = data.senderLabel || data.labelName;
	      }
	      return saveProject(data).promise.then(function (resp) {
	        return pushState('/projects/' + projectType + '/' + (projectId || (0, _get7.default)(resp, 'data.id', 0)) + '/materials');
	      }).catch(function (err) {
	        return err;
	      });
	    }
	  }, {
	    key: 'fillNotice',
	    value: function fillNotice(e) {
	      var copyrights = this.props.commonData.copyrights;
	
	      var newCopyrightNotice = (0, _get7.default)(copyrights, [e.target.value, 'text'], '');
	      this.props.changeFieldValue('projectInfoForm', 'copyrightNotice', newCopyrightNotice);
	    }
	  }, {
	    key: 'toggleOptionalSection',
	    value: function toggleOptionalSection() {
	      var hideOptionalSection = !this.state.hideOptionalSection;
	      this.setState({ hideOptionalSection: hideOptionalSection });
	      this.cookies.setAsBoolean({ name: 'showOptionalSection', value: !hideOptionalSection });
	    }
	  }, {
	    key: 'renderLabelField',
	    value: function renderLabelField(name) {
	      var _props3 = this.props,
	          t = _props3.t,
	          subLabels = _props3.commonData.subLabels;
	
	
	      return _react2.default.createElement(
	        _reduxForm.Field,
	        { name: name, type: 'select', component: 'select' },
	        _react2.default.createElement(
	          'option',
	          { value: 0 },
	          t('none')
	        ),
	        subLabels && subLabels.map(function (subLabel) {
	          return _react2.default.createElement(
	            'option',
	            { key: subLabel.id, value: subLabel.id },
	            subLabel.subLabelName
	          );
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props4 = this.props,
	          projectLoading = _props4.projectLoading,
	          t = _props4.t,
	          projectId = _props4.projectId,
	          projectType = _props4.projectType,
	          projectData = _props4.projectData,
	          permissions = _props4.permissions,
	          _props4$projectInfoFo = _props4.projectInfoForm,
	          handleSubmit = _props4$projectInfoFo.handleSubmit,
	          submitting = _props4$projectInfoFo.submitting,
	          copyrights = _props4.commonData.copyrights,
	          senderEmailValue = _props4.senderEmailValue,
	          senderNameValue = _props4.senderNameValue;
	      var hideOptionalSection = this.state.hideOptionalSection;
	
	      var title = this.getTitle();
	      var isLocked = !!projectData.isLocked;
	
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit(this.submit), className: 'page' },
	        _react2.default.createElement(_reactHelmet2.default, { title: 'Project' }),
	        !projectId && projectType === _projects2.projectTypes.sharespace && _react2.default.createElement(_components.Loader, { mask: true }),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('container-fluid', styles.pageContainer) },
	          _react2.default.createElement(
	            'h1',
	            null,
	            title,
	            projectLoading && _react2.default.createElement(_components.Loader, { small: true, inline: true, right: true })
	          ),
	          _react2.default.createElement(_components.ProjectBreadcrumbs, {
	            projectId: projectId,
	            projectType: projectType,
	            activeSection: 'info',
	            notClickable: projectData.status === _projects2.projectStatus.draft
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'hint' },
	            t('Enter all the details of your project - you will then be prompted to add content and a list of recipients.')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              t('Project information')
	            ),
	            _react2.default.createElement(
	              _FormRow2.default,
	              { title: projectType === _projects2.projectTypes.video ? t('Director Name') : t('Artist Name'), isRequired: true },
	              _react2.default.createElement(_reduxForm.Field, { name: 'artistName', noIndent: true, type: 'text', component: _formComponents.formSimpleTextInput, required: true, disabled: isLocked })
	            ),
	            _react2.default.createElement(
	              _FormRow2.default,
	              { title: t('Title'), isRequired: true },
	              _react2.default.createElement(_reduxForm.Field, { name: 'title', noIndent: true, type: 'text', component: _formComponents.formSimpleTextInput, required: true, disabled: isLocked })
	            ),
	            _react2.default.createElement(
	              _FormRow2.default,
	              { title: t('Title') + ' 2' },
	              _react2.default.createElement(_reduxForm.Field, { name: 'title2', noIndent: true, type: 'text', component: _formComponents.formSimpleTextInput })
	            ),
	            projectType === _projects2.projectTypes.video && _react2.default.createElement(
	              _FormRow2.default,
	              { title: t('Storyboard') },
	              _react2.default.createElement(_reduxForm.Field, { name: 'storyboard', noIndent: true, type: 'textarea', rows: '3', component: _formComponents.formSimpleTextInput })
	            ),
	            projectType === _projects2.projectTypes.video && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'h3',
	                null,
	                t('Brightcove content access (optional)')
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'hint small' },
	                t('For non watermarked project only, you can point your recipients directly to the Brightcove content by using the link below.')
	              ),
	              _react2.default.createElement(
	                _FormRow2.default,
	                { title: t('Link to content') },
	                _react2.default.createElement(_reduxForm.Field, { name: 'bcove', noIndent: true, type: 'text', component: _formComponents.formSimpleTextInput })
	              )
	            ),
	            projectType === _projects2.projectTypes.sharespace && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'h3',
	                null,
	                t('Team members')
	              ),
	              _react2.default.createElement(_components.SSTeamMembers, { projectId: projectId })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section' },
	            _react2.default.createElement(
	              'div',
	              { onClick: this.toggleOptionalSection, className: (0, _classnames2.default)('table', styles.sectionToggle, styles.withToggleHint) },
	              _react2.default.createElement(
	                'h3',
	                { className: 'table-cell' },
	                t('Label / Sender settings')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'table-cell width-perc-1 text-center' },
	                _react2.default.createElement('i', { className: (0, _classnames2.default)('colorPrimary', hideOptionalSection ? 'icon-chevron-bold-down' : 'icon-chevron-bold-up') }),
	                _react2.default.createElement(
	                  'span',
	                  { className: styles.toggleHint },
	                  hideOptionalSection ? t('Click Arrow to Reveal') : t('Click Arrow to Hide')
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _Collapse2.default,
	              { 'in': !hideOptionalSection },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  t('Advanced information')
	                ),
	                _react2.default.createElement(
	                  _FormRow2.default,
	                  { title: t('Internal Ref'), hint: t('Will not be shown to recipient') },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'internalRef', noIndent: true, type: 'text', component: _formComponents.formSimpleTextInput })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'formRow' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      t('Copyright Notice')
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: styles.copyrights },
	                      _react2.default.createElement(
	                        'select',
	                        { onChange: function onChange(e) {
	                            return _this3.fillNotice(e);
	                          } },
	                        _react2.default.createElement(
	                          'option',
	                          { value: -1 },
	                          t('Select')
	                        ),
	                        copyrights && copyrights.map(function (copyright, index) {
	                          return _react2.default.createElement(
	                            'option',
	                            { key: copyright.id, value: index },
	                            copyright.header
	                          );
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_reduxForm.Field, { name: 'copyrightNotice', noIndent: true, type: 'textarea', rows: '3', component: _formComponents.formSimpleTextInput })
	                  )
	                ),
	                projectType !== _projects2.projectTypes.sharespace && _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    t('Sender settings')
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'hint small' },
	                    t('Use these fields to override your accounts default settings.')
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'hint small' },
	                    t('This will enable you to display a different senders name on the player & emails.')
	                  ),
	                  senderEmailValue ? _react2.default.createElement(_ProjectSenderInfo2.default, {
	                    projectId: projectId,
	                    onDelete: this.onSenderDelete,
	                    senderEmail: senderEmailValue,
	                    senderName: senderNameValue
	                  }) : _react2.default.createElement(
	                    _FormRow2.default,
	                    { title: t('Enter sender email here') },
	                    _react2.default.createElement(_AddSenderField2.default, {
	                      projectId: projectId,
	                      hideGroups: true,
	                      onAdd: this.onSenderAdd,
	                      withZIndex: false
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_formComponents.CheckboxField, {
	                      name: 'hideSender',
	                      type: 'checkbox',
	                      textAfter: t('Hide sender information on emails. Emails will be sent on behalf of your label.')
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'h4',
	                    { className: 'margin-top-20' },
	                    t('Statistics and Feedback')
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'hint small' },
	                    t('Use this field to add people you want to share statistics with'),
	                    '.'
	                  ),
	                  _react2.default.createElement(
	                    _FormRow2.default,
	                    { title: t('Enter their email here') },
	                    _react2.default.createElement(_AddStatsViewerField2.default, {
	                      projectId: projectId,
	                      hideGroups: true,
	                      withZIndex: false
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(_ProjectStatsViewersList2.default, {
	                      projectId: projectId,
	                      className: (0, _classnames2.default)('margin-bottom-20', styles.listRow)
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  t('Label')
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'hint small' },
	                  t('Labels logos will appear on emails and player'),
	                  '.'
	                ),
	                _react2.default.createElement(
	                  'h5',
	                  null,
	                  t('Option 1. Use existing Label')
	                ),
	                _react2.default.createElement(
	                  _FormRow2.default,
	                  { title: t('Label 1') },
	                  this.renderLabelField('labelId0')
	                ),
	                _react2.default.createElement(
	                  _FormRow2.default,
	                  { title: t('Label 2') },
	                  this.renderLabelField('labelId1')
	                ),
	                _react2.default.createElement(
	                  _FormRow2.default,
	                  { title: t('Label 3') },
	                  this.renderLabelField('labelId2')
	                ),
	                _react2.default.createElement(
	                  'h5',
	                  null,
	                  t('Option 2. Enter a different Label / Agency name')
	                ),
	                _react2.default.createElement(
	                  _FormRow2.default,
	                  { title: t('Label name') },
	                  _react2.default.createElement(_reduxForm.Field, { name: projectId ? 'senderLabel' : 'labelName', noIndent: true, type: 'text', component: _formComponents.formSimpleTextInput })
	                ),
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  t('Key Dates')
	                ),
	                _react2.default.createElement(
	                  _FormRow2.default,
	                  { title: t('Release date') },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'releaseDate', component: _formComponents.formDate, allowPast: true }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'hint small' },
	                    t('Official release date. This will appear on the player and email notification.')
	                  )
	                ),
	                _react2.default.createElement(
	                  _FormRow2.default,
	                  { title: t('Impact date') },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'impactDate', component: _formComponents.formDate, allowPast: true }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'hint small' },
	                    t('Official impact date. Will appear on the email notification only.')
	                  )
	                ),
	                projectType !== _projects2.projectTypes.sharespace && _react2.default.createElement(
	                  _FormRow2.default,
	                  { title: t('Dispatch date') },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'dispatchDate', component: _formComponents.formDatetime }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'hint small' },
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      t('IMPORTANT! Your project will be sent immediately unless you specify a dispatch date & time.')
	                    ),
	                    _react2.default.createElement(_reactI18next.Interpolate, { i18nKey: 'Your time zone: {{timezone}}', timezone: this.state.timezone })
	                  )
	                ),
	                projectType === _projects2.projectTypes.video && _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    t('Video resolution for your recipients')
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_reduxForm.Field, { name: 'videoResolution', component: _formComponents.formRadio, type: 'radio', value: 'small', textAfter: t('Small (eg. 480 x 270)') })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_reduxForm.Field, { name: 'videoResolution', component: _formComponents.formRadio, type: 'radio', value: 'medium', textAfter: t('Standard (eg. 640x360)') })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_reduxForm.Field, { name: 'videoResolution', component: _formComponents.formRadio, type: 'radio', value: 'hd', textAfter: t('High Definition (eg. 1280x720)') })
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              t('Security')
	            ),
	            projectType !== _projects2.projectTypes.video && _react2.default.createElement(
	              'div',
	              { className: 'margin-vert-10' },
	              _react2.default.createElement(_formComponents.CheckboxField, {
	                name: 'watermarkTracks',
	                type: 'checkbox',
	                textAfter: t('Watermark all tracks'),
	                disabled: isLocked || !permissions.setWatermark
	              })
	            ),
	            projectType === _projects2.projectTypes.video && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'margin-vert-10' },
	                _react2.default.createElement(_formComponents.CheckboxField, { name: 'isWatermarkVideo', type: 'checkbox', textAfter: t('Watermark video stream'), disabled: !permissions.setWatermark }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'hint small' },
	                  t('Watermarking enables you to trace your content.')
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'margin-vert-10' },
	                _react2.default.createElement(_formComponents.CheckboxField, { name: 'watermarkTracks', type: 'checkbox', textAfter: t('Watermark audio stream'), disabled: !permissions.setWatermark }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'hint small' },
	                  t('This feature is aimed at Music Video. Watermarking Audio enables you to trace the audio part of the video.')
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'formRow' },
	              _react2.default.createElement(
	                'div',
	                null,
	                t('Number of plays')
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _reduxForm.Field,
	                  { name: 'playsNumber', type: 'select', component: 'select' },
	                  _react2.default.createElement(
	                    'option',
	                    { value: 0 },
	                    t('Unlimited')
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 1 },
	                    t('1 play')
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 3 },
	                    t('3 plays')
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 5 },
	                    t('5 plays')
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'hint small' },
	                  t('Set the number of plays per content')
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'margin-vert-10' },
	              _react2.default.createElement(_formComponents.CheckboxField, { name: 'downloadAuthorised', type: 'checkbox', textAfter: t('Download album authorised'), disabled: isLocked }),
	              _react2.default.createElement(
	                'div',
	                { className: 'hint small' },
	                t('This will allow you to grant individual recipients with download rights. Option not available for video projects.')
	              )
	            ),
	            projectType !== _projects2.projectTypes.sharespace && _react2.default.createElement(
	              _FormRow2.default,
	              { title: t('Project expiration date') + '*' },
	              _react2.default.createElement(_reduxForm.Field, { name: 'expiryDate', component: _formComponents.formDate, required: true }),
	              _react2.default.createElement(
	                'div',
	                { className: 'hint small' },
	                t('Your project will expire at 23h59 on the above date')
	              )
	            ),
	            projectType !== _projects2.projectTypes.sharespace && _react2.default.createElement(
	              'div',
	              { className: 'margin-vert-10' },
	              _react2.default.createElement(_formComponents.CheckboxField, { name: 'individualExpiryDate', type: 'checkbox', textAfter: t('Individual expire dates') }),
	              _react2.default.createElement(
	                'div',
	                { className: 'hint error small' },
	                t('Set expiry date individually for each recipient')
	              )
	            ),
	            projectType !== _projects2.projectTypes.sharespace && _react2.default.createElement(
	              'div',
	              { className: 'margin-vert-10' },
	              _react2.default.createElement(_formComponents.CheckboxField, { name: 'directAccessWatermark', type: 'checkbox', textAfter: t('No Password'), disabled: !permissions.noPasswordFeature }),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('hint error small', { disabled: !permissions.noPasswordFeature }) },
	                t('WARNING - The recipient will NOT be required to enter a password.')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'text-right margin-vert-40' },
	            _react2.default.createElement(
	              'button',
	              { type: 'submit', className: 'btn btn-primary wide pos-rel', disabled: submitting },
	              t('Next'),
	              submitting && _react2.default.createElement(_components.Loader, { mask: true })
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return ProjectInfo;
	}(_ClientSideComponent2.default), _class3.propTypes = {
	  changeFieldValue: _propTypes2.default.func.isRequired,
	  commonData: _propTypes2.default.object,
	  cookies: _propTypes2.default.object,
	  loadProjectStatsViewers: _propTypes2.default.func,
	  permissions: _propTypes2.default.object,
	  projectData: _propTypes2.default.object,
	  projectId: _propTypes2.default.number,
	  projectInfoForm: _propTypes2.default.object,
	  projectLoading: _propTypes2.default.bool,
	  projectType: _propTypes2.default.string,
	  pushState: _propTypes2.default.func.isRequired,
	  saveProject: _propTypes2.default.func.isRequired,
	  senderEmailValue: _propTypes2.default.string,
	  senderNameValue: _propTypes2.default.string,
	  t: _propTypes2.default.func.isRequired
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onSenderAdd', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSenderAdd'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onSenderDelete', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSenderDelete'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'submit', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'submit'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'toggleOptionalSection', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'toggleOptionalSection'), _class2.prototype)), _class2)) || _class) || _class) || _class) || _class) || _class);
	exports.default = ProjectInfo;
	module.exports = exports['default'];

/***/ }),
/* 2195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _validation = __webpack_require__(157);
	
	var _formValidation = __webpack_require__(263);
	
	var _formValidation2 = _interopRequireDefault(_formValidation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by nkrasnov on 16/09/16.
	 * Copyright © 2016 Citronium. All rights reserved.
	 */
	
	var validate = (0, _validation.createValidator)({
	  artistName: _formValidation2.default.field,
	  title: _formValidation2.default.field,
	  expiryDate: _formValidation2.default.field
	});
	
	exports.default = validate;
	module.exports = exports['default'];

/***/ }),
/* 2196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _slicedToArray2 = __webpack_require__(78);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(72);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get4 = __webpack_require__(58);
	
	var _get5 = _interopRequireDefault(_get4);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _promise = __webpack_require__(62);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _range3 = __webpack_require__(1563);
	
	var _range4 = _interopRequireDefault(_range3);
	
	var _find3 = __webpack_require__(95);
	
	var _find4 = _interopRequireDefault(_find3);
	
	var _get6 = __webpack_require__(19);
	
	var _get7 = _interopRequireDefault(_get6);
	
	var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClientSideComponent = __webpack_require__(30);
	
	var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);
	
	var _reactHelmet = __webpack_require__(55);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactRedux = __webpack_require__(11);
	
	var _project = __webpack_require__(37);
	
	var projectActions = _interopRequireWildcard(_project);
	
	var _projects = __webpack_require__(359);
	
	var projectsActions = _interopRequireWildcard(_projects);
	
	var _auth = __webpack_require__(31);
	
	var _reduxConnect = __webpack_require__(33);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _strings = __webpack_require__(59);
	
	var _projects2 = __webpack_require__(136);
	
	var _reactRouter = __webpack_require__(124);
	
	var _uploads = __webpack_require__(112);
	
	var _config = __webpack_require__(41);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _permissions = __webpack_require__(215);
	
	var _projects3 = __webpack_require__(28);
	
	var _auth2 = __webpack_require__(77);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _asyncPromise = __webpack_require__(43);
	
	var _asyncPromise2 = _interopRequireDefault(_asyncPromise);
	
	var _reactRouterRedux = __webpack_require__(40);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _SharespacePublishButton = __webpack_require__(865);
	
	var _SharespacePublishButton2 = _interopRequireDefault(_SharespacePublishButton);
	
	var _ProjectLegendLine = __webpack_require__(517);
	
	var _ProjectLegendLine2 = _interopRequireDefault(_ProjectLegendLine);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var boxsetsNumbers = (0, _range4.default)(1, 11);
	var styles = __webpack_require__(1368);
	
	var ProjectMaterials = (_dec = (0, _reduxConnect.asyncConnect)([{
	  promise: function promise(_ref) {
	    var _ref$store = _ref.store,
	        dispatch = _ref$store.dispatch,
	        getState = _ref$store.getState,
	        projectId = _ref.params.projectId;
	    var isLoadProjectTime = projectActions.isLoadProjectTime,
	        loadProject = projectActions.loadProject,
	        initProject = projectActions.initProject,
	        initSubmittedFiles = projectActions.initSubmittedFiles,
	        loadMediaList = projectActions.loadMediaList,
	        loadPressList = projectActions.loadPressList;
	
	    var id = Number(projectId);
	    var promises = [];
	    if (id) {
	      if (isLoadProjectTime(id, getState())) {
	        promises.push(dispatch(loadProject(id)).promise);
	      }
	    } else {
	      promises.push(dispatch(initProject()));
	    }
	    promises.push(dispatch(initSubmittedFiles()));
	    promises.push(dispatch(loadPressList(id)).promise);
	    promises.push(dispatch(loadMediaList(id)).promise);
	
	    return (0, _asyncPromise2.default)(_promise2.default.all(promises));
	  }
	}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    copyProjectLoading: state.project.copyProjectLoading,
	    deletePressActionData: state.project.deletePressActionData,
	    deletePressLoading: state.project.deletePressLoading,
	    mediaList: state.project.mediaListData,
	    permissions: (0, _auth2.getPermissions)(state),
	    pressList: state.project.pressListData,
	    pressListLoading: state.project.pressListLoading,
	    project: (0, _projects2.getProjectData)(state),
	    projectId: Number(ownProps.params.projectId),
	    projectLoading: state.project.projectLoading,
	    projectType: ownProps.params.type,
	    submittedCloudFiles: state.project.submittedCloudFiles,
	    submittedMediaFiles: state.project.submittedMediaFiles,
	    submittedPressFiles: state.project.submittedPressFiles
	  };
	}, (0, _extends3.default)({}, projectActions, { logout: _auth.logout, needReloadProjects: projectsActions.needReloadProjects, pushState: _reactRouterRedux.push })), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(ProjectMaterials, _Component);
	
	  function ProjectMaterials() {
	    var _ref2;
	
	    (0, _classCallCheck3.default)(this, ProjectMaterials);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = ProjectMaterials.__proto__ || (0, _getPrototypeOf2.default)(ProjectMaterials)).call.apply(_ref2, [this].concat(args)));
	
	    _this._mediaUploaderOnSubmitted = function (id) {
	      _this.props.submitMediaFile(id);
	    };
	
	    _this._mediaUploaderOnComplete = function (id, name, resp) {
	      var code = resp.code,
	          msg = resp.msg;
	      var _this$props = _this.props,
	          submittedMediaFiles = _this$props.submittedMediaFiles,
	          addMedia = _this$props.addMedia,
	          projectId = _this$props.projectId;
	
	      if (code === 1) {
	        return _this.props.logout();
	      }
	      if (code && msg) {
	        _toastr2.default.error(msg);
	      }
	      var data = (0, _get7.default)(resp, 'data[0]');
	      if (data) {
	        addMedia((0, _extends3.default)({}, data, { uploaderId: id }), projectId);
	      }
	
	      console.log(submittedMediaFiles);
	      console.log('onComplete', id, name, resp);
	    };
	
	    _this._mediaUploaderOnAllComplete = function (succeeded, fail) {
	      console.log('onAllComplete', succeeded, fail);
	    };
	
	    _this._pressUploaderOnSubmitted = function (id) {
	      _this.props.submitPressFile(id);
	    };
	
	    _this._pressUploaderOnComplete = function (id, name, resp) {
	      var code = resp.code,
	          msg = resp.msg;
	      var _this$props2 = _this.props,
	          addPress = _this$props2.addPress,
	          projectId = _this$props2.projectId;
	
	      if (code === 1) {
	        return _this.props.logout();
	      }
	
	      if (code && msg) {
	        _toastr2.default.error(msg);
	      }
	
	      var data = (0, _get7.default)(resp, 'data');
	      if (data) {
	        addPress(data, projectId);
	      }
	    };
	
	    _this._pressUploaderOnAllComplete = function (succeeded, fail) {
	      console.log('onAllComplete', succeeded, fail);
	    };
	
	    _this._mountUploaders = function () {
	      var FineUploaderTraditional = __webpack_require__(257);
	      var _this$props3 = _this.props,
	          projectId = _this$props3.projectId,
	          projectType = _this$props3.projectType;
	
	      var postParams = { projectId: projectId, projectType: projectType };
	
	      _this.uploaders.media = new FineUploaderTraditional({
	        request: { params: (0, _extends3.default)({}, postParams, { replacedId: 0, part: _this.state.part }) },
	        chunking: { success: { endpoint: '/api/FileUpload_wa/uploadAudioVideo' } }
	      });
	
	      _this.uploaders.press = new FineUploaderTraditional({
	        request: { params: (0, _extends3.default)({}, postParams) },
	        chunking: { success: { endpoint: '/api/FileUpload_wa/uploadPress' } }
	      });
	
	      _this._registerUploadersEvents();
	    };
	
	    _this._unMountUploaders = function () {
	      _this._unRegisterUploadersEvents();
	      (0, _entries2.default)(_this.uploaders).map(function (_ref3) {
	        var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
	            name = _ref4[0],
	            uploader = _ref4[1];
	
	        uploader.methods.cancelAll();
	        _this.uploaders[name] = null;
	      });
	    };
	
	    _this.state = { part: 1 };
	    _this.uploaders = { media: null, press: null };
	    return _this;
	  }
	
	  (0, _createClass3.default)(ProjectMaterials, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _get5.default)(ProjectMaterials.prototype.__proto__ || (0, _getPrototypeOf2.default)(ProjectMaterials.prototype), 'componentDidMount', this).call(this, this._mountUploaders);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      (0, _get5.default)(ProjectMaterials.prototype.__proto__ || (0, _getPrototypeOf2.default)(ProjectMaterials.prototype), 'componentWillUnmount', this).call(this, this._unMountUploaders);
	    }
	  }, {
	    key: 'onCloudUpload',
	    value: function onCloudUpload(cloudFile) {
	      var _props = this.props,
	          addMedia = _props.addMedia,
	          projectId = _props.projectId;
	
	      if (cloudFile) {
	        addMedia(cloudFile, projectId);
	      }
	    }
	  }, {
	    key: 'getRenderProps',
	    value: function getRenderProps() {
	      var _props2 = this.props,
	          t = _props2.t,
	          projectType = _props2.projectType,
	          permissions = _props2.permissions;
	
	      var props = {};
	
	      props.project = this.props.project || {};
	      props.mediaSupportedFormats = (0, _uploads.getUploaderAcceptableFormats)(projectType);
	      props.pressSupportedFormats = (0, _uploads.getUploaderAcceptableFormats)('press');
	      props.isLocked = !!props.project.isLocked;
	      props.isStandardMode = !!props.project.isStandardMode;
	      props.canCopy = (0, _permissions.canCreateProjectByType)(permissions, projectType);
	      props.showUploadMediaSection = !props.isLocked && !props.isStandardMode;
	      props.mediaUploadDisabled = !(0, _permissions.canUploadMedia)(permissions, projectType);
	      props.mediaEditDisabled = !(0, _permissions.canEditMedia)(permissions, projectType);
	      props.isSharespace = projectType === _projects3.projectTypes.sharespace;
	      props.isAudioProject = projectType === _projects3.projectTypes.audio;
	      props.isVideoProject = projectType === _projects3.projectTypes.video;
	      props.copyButtonTitle = props.isSharespace ? t('Copy this sharespace') : t('Copy this project');
	      props.modifyButtonTitle = props.isSharespace ? t('Modify sharespace info') : t('Modify project info');
	      props.isWatermarked = props.isVideoProject ? !!props.project.isWatermarkVideo : !!props.project.watermarkTracks;
	      props.watermarkWarnText = props.isWatermarked ? t('All tracks will be watermarked') : t('No watermark will be applied');
	      props.fileManagementTitle = props.isAudioProject ? t('Audio File Management') : t('File Management');
	
	      return props;
	    }
	  }, {
	    key: '_registerUploadersEvents',
	    value: function _registerUploadersEvents() {
	      var _this2 = this;
	
	      (0, _entries2.default)(this.uploaders).map(function (_ref5) {
	        var _ref6 = (0, _slicedToArray3.default)(_ref5, 2),
	            name = _ref6[0],
	            uploader = _ref6[1];
	
	        uploader.on('submitted', _this2['_' + name + 'UploaderOnSubmitted']);
	        uploader.on('complete', _this2['_' + name + 'UploaderOnComplete']);
	        uploader.on('allComplete', _this2['_' + name + 'UploaderOnAllComplete']);
	      });
	    }
	  }, {
	    key: '_unRegisterUploadersEvents',
	    value: function _unRegisterUploadersEvents() {
	      var _this3 = this;
	
	      (0, _entries2.default)(this.uploaders).map(function (_ref7) {
	        var _ref8 = (0, _slicedToArray3.default)(_ref7, 2),
	            name = _ref8[0],
	            uploader = _ref8[1];
	
	        uploader.off('submitted', _this3['_' + name + 'UploaderOnSubmitted']);
	        uploader.off('complete', _this3['_' + name + 'UploaderOnComplete']);
	        uploader.off('allComplete', _this3['_' + name + 'UploaderOnAllComplete']);
	      });
	    }
	  }, {
	    key: 'copyProject',
	    value: function copyProject() {
	      var _props3 = this.props,
	          project = _props3.project,
	          copyProject = _props3.copyProject,
	          needReloadProjects = _props3.needReloadProjects,
	          t = _props3.t,
	          pushState = _props3.pushState;
	
	      copyProject(project.id).promise.then(function () {
	        needReloadProjects();
	        _toastr2.default.success(t('Project copied'));
	        pushState('/projects');
	      });
	    }
	  }, {
	    key: 'deletePress',
	    value: function deletePress(press) {
	      var _props4 = this.props,
	          deletePress = _props4.deletePress,
	          projectId = _props4.projectId,
	          t = _props4.t;
	
	      var toastrConfirmOptions = {
	        onOk: function onOk() {
	          return deletePress(projectId, press.pressId);
	        },
	        onCancel: function onCancel() {}
	      };
	      _toastr2.default.confirm(t('Are you sure you want to delete this file?'), toastrConfirmOptions);
	    }
	  }, {
	    key: '_setMultipleBoxsets',
	    value: function _setMultipleBoxsets(val) {
	      var _props5 = this.props,
	          setMultipleBoxsets = _props5.setMultipleBoxsets,
	          projectId = _props5.projectId;
	
	      setMultipleBoxsets(projectId, val ? 1 : 0);
	    }
	  }, {
	    key: '_changePart',
	    value: function _changePart(part) {
	      var newPart = Number(part) || 0;
	      var mediaUploader = this.uploaders.media;
	      this.setState({ part: newPart });
	      mediaUploader.methods.setParams((0, _extends3.default)({}, mediaUploader.options.request.params, { part: newPart }));
	    }
	  }, {
	    key: 'deleteMediaItem',
	    value: function deleteMediaItem(uploaderId) {
	      var _props6 = this.props,
	          projectId = _props6.projectId,
	          mediaList = _props6.mediaList;
	
	      var media = (0, _find4.default)(mediaList, { uploaderId: uploaderId });
	      if (media) {
	        return this.props.deleteMedia(projectId, media.id, uploaderId).promise;
	      }
	    }
	  }, {
	    key: 'cancelMediaFile',
	    value: function cancelMediaFile(id) {
	      this.props.deleteMediaFile(id);
	    }
	  }, {
	    key: 'cancelPressFile',
	    value: function cancelPressFile(id) {
	      this.props.deletePressFile(id);
	    }
	  }, {
	    key: 'uploadButtons',
	    value: function uploadButtons() {
	      var _props7 = this.props,
	          projectId = _props7.projectId,
	          projectType = _props7.projectType,
	          permissions = _props7.permissions;
	      var part = this.state.part;
	
	      var mediaUploadDisabled = !(0, _permissions.canUploadMedia)(permissions, projectType);
	      var supportedFileTypes = _config2.default.app.uploaderSupportedFormats.audio;
	
	      return _react2.default.createElement(_components.CloudUploader, {
	        disabled: mediaUploadDisabled,
	        projectId: projectId,
	        onCloudUpload: this.onCloudUpload,
	        part: part,
	        fileTypes: supportedFileTypes
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props8 = this.props,
	          t = _props8.t,
	          projectId = _props8.projectId,
	          projectType = _props8.projectType,
	          projectLoading = _props8.projectLoading,
	          copyProjectLoading = _props8.copyProjectLoading,
	          submittedMediaFiles = _props8.submittedMediaFiles,
	          submittedPressFiles = _props8.submittedPressFiles,
	          pressList = _props8.pressList,
	          pressListLoading = _props8.pressListLoading,
	          deletePressLoading = _props8.deletePressLoading,
	          deletePressActionData = _props8.deletePressActionData,
	          submittedCloudFiles = _props8.submittedCloudFiles,
	          permissions = _props8.permissions;
	      var uploaders = this.uploaders,
	          _state = this.state,
	          isMounted = _state.isMounted,
	          part = _state.part;
	
	      var _getRenderProps = this.getRenderProps(),
	          project = _getRenderProps.project,
	          mediaSupportedFormats = _getRenderProps.mediaSupportedFormats,
	          pressSupportedFormats = _getRenderProps.pressSupportedFormats,
	          isLocked = _getRenderProps.isLocked,
	          isStandardMode = _getRenderProps.isStandardMode,
	          canCopy = _getRenderProps.canCopy,
	          showUploadMediaSection = _getRenderProps.showUploadMediaSection,
	          mediaUploadDisabled = _getRenderProps.mediaUploadDisabled,
	          mediaEditDisabled = _getRenderProps.mediaEditDisabled,
	          copyButtonTitle = _getRenderProps.copyButtonTitle,
	          modifyButtonTitle = _getRenderProps.modifyButtonTitle,
	          watermarkWarnText = _getRenderProps.watermarkWarnText,
	          fileManagementTitle = _getRenderProps.fileManagementTitle;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(_reactHelmet2.default, { title: 'Project' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'container-fluid' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            t('Audio & Press Material'),
	            projectLoading && _react2.default.createElement(_components.Loader, { small: true, inline: true, right: true })
	          ),
	          _react2.default.createElement(_components.ProjectBreadcrumbs, { projectId: projectId, projectType: projectType }),
	          _react2.default.createElement(
	            'div',
	            { className: 'section' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              t('Project')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-60 col-lg-35' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  project.artistName
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  project.fullTitle
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-60 col-sm-30' },
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      t('Project Id'),
	                      ': ',
	                      project.id
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      t('Manager'),
	                      ': ',
	                      project.ownerName,
	                      ' ',
	                      project.ownerSurname
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-60 col-sm-30' },
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      t('Status'),
	                      ': ',
	                      _react2.default.createElement(_components.ProjectStatus, { status: project.status })
	                    ),
	                    project.expiryDate && _react2.default.createElement(
	                      'div',
	                      null,
	                      t('Expiry date'),
	                      ': ',
	                      project.expiryDateText
	                    )
	                  )
	                )
	              ),
	              !projectLoading && _react2.default.createElement(
	                'div',
	                { className: 'col-md-60 col-lg-25 ' + styles.panel },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'padding-15' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: styles.title },
	                    t('Security')
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: styles.content },
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      watermarkWarnText,
	                      '.'
	                    ),
	                    !!project.multipleIP && _react2.default.createElement(
	                      'div',
	                      null,
	                      t('Recipients can access content from multiple IP addresses'),
	                      '.'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      project.downloadAuthorised ? t('Selected recipients can download files') : t('Selected recipients can\'t download files'),
	                      '.'
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'margin-vert-20 text-right' },
	            copyProjectLoading && _react2.default.createElement(_components.Loader, null),
	            canCopy && _react2.default.createElement(
	              'button',
	              { onClick: this.copyProject, type: 'button', className: 'btn btn-default margin-right-10 margin-vert-5' },
	              copyButtonTitle
	            ),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { className: 'btn btn-primary margin-vert-5', to: '/projects/' + projectType + '/' + projectId + '/info' },
	              modifyButtonTitle
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              fileManagementTitle
	            ),
	            _react2.default.createElement(_components.MediaList, {
	              projectId: projectId,
	              projectType: projectType,
	              multipleBoxsets: !!project.multipleBoxsets,
	              isStandardMode: isStandardMode,
	              isLocked: isLocked || mediaEditDisabled,
	              hideReplaceFile: !permissions.uploadPrContent
	            }),
	            isMounted && showUploadMediaSection && _react2.default.createElement(
	              'div',
	              null,
	              project.id && _react2.default.createElement(
	                'div',
	                { className: 'margin-bottom-10' },
	                _react2.default.createElement(_components.Checkbox, {
	                  name: 'multipleBoxsets',
	                  disabled: mediaUploadDisabled,
	                  checked: !!project.multipleBoxsets,
	                  onChange: function onChange(e) {
	                    return _this4._setMultipleBoxsets(e.target.checked);
	                  },
	                  textAfter: t('Multiple boxsets')
	                }),
	                !!project.multipleBoxsets && _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    { className: (0, _classnames2.default)({ disabled: mediaUploadDisabled }) },
	                    t('Upload files for part'),
	                    ':'
	                  ),
	                  _react2.default.createElement(
	                    'select',
	                    {
	                      disabled: mediaUploadDisabled,
	                      className: 'margin-left-5',
	                      value: part,
	                      onChange: function onChange(e) {
	                        return _this4._changePart(e.target.value);
	                      }
	                    },
	                    boxsetsNumbers.map(function (partN) {
	                      return _react2.default.createElement(
	                        'option',
	                        { key: partN, value: partN },
	                        partN
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _components.UploadArea,
	                {
	                  uploader: uploaders.media,
	                  disabled: mediaUploadDisabled,
	                  uploadButtons: this.uploadButtons(),
	                  submittedFiles: submittedMediaFiles,
	                  submittedCloudFiles: submittedCloudFiles,
	                  accept: mediaSupportedFormats,
	                  onDelete: this.deleteMediaItem,
	                  onCancel: this.cancelMediaFile,
	                  showStatusIcon: true
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'hint small' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    t('Supported file formats: {{formats}}', { formats: mediaSupportedFormats })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    t('TIP - You can upload multiple files at once by pressing "CTRL" key while selecting your files')
	                  )
	                )
	              )
	            ),
	            !showUploadMediaSection && _react2.default.createElement(
	              'div',
	              { className: 'bold' },
	              t('You don\'t have permissions to manage files')
	            )
	          ),
	          projectType === _projects3.projectTypes.sharespace && _react2.default.createElement(
	            'div',
	            { className: 'section' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              t('Cover picture')
	            ),
	            _react2.default.createElement(_components.ProjectCover, { project: project, disabled: !permissions.uploadSharespaceCover }),
	            project.imageThumb && permissions.uploadSharespaceCover && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'h3',
	                null,
	                t('Choose the packshot style')
	              ),
	              _react2.default.createElement(_components.CoverStyle, null)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              t('Press pack')
	            ),
	            _react2.default.createElement(
	              _components.List,
	              { className: 'margin-bottom-20' },
	              _react2.default.createElement(
	                _components.ListItem,
	                { fullWidth: true, isTitle: true },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  t('File Name')
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  t('Uploader')
	                ),
	                _react2.default.createElement('div', null)
	              ),
	              pressList.map(function (press) {
	                return _react2.default.createElement(
	                  _components.ListItem,
	                  { fullWidth: true, key: press.pressId },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    press.fileName
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    (0, _strings.concat)(' ', press.name, press.surname)
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'moreCell' },
	                    _react2.default.createElement('i', { className: 'more', onClick: function onClick(e) {
	                        return _this4.pressListPopover.toggle(e, press);
	                      } }),
	                    deletePressLoading && deletePressActionData.pressId === press.pressId && _react2.default.createElement(_components.Loader, { small: true, mask: true })
	                  )
	                );
	              })
	            ),
	            pressListLoading && _react2.default.createElement(_components.Loader, null),
	            _react2.default.createElement(
	              _components.PopoverMenu,
	              { id: 'pressListPopover', ref: function ref(el) {
	                  return _this4.pressListPopover = el;
	                } },
	              _react2.default.createElement(
	                'li',
	                { onClick: function onClick() {
	                    return _this4.deletePress(_this4.pressListPopover.data);
	                  } },
	                t('Delete'),
	                _react2.default.createElement('i', { className: 'icon-delete' })
	              )
	            ),
	            isMounted && !isStandardMode && _react2.default.createElement(
	              _components.UploadArea,
	              {
	                uploader: uploaders.press,
	                submittedFiles: submittedPressFiles,
	                accept: pressSupportedFormats,
	                onCancel: this.cancelPressFile,
	                showStatusIcon: true
	              },
	              _react2.default.createElement(
	                'div',
	                { className: 'hint small' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  t('Upload and shared files of the press pack. Files can be of the following formats:')
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  t('{{formats}}. Max size limit: 7 MB', { formats: pressSupportedFormats })
	                )
	              )
	            ),
	            isStandardMode && _react2.default.createElement(
	              'div',
	              { className: 'bold' },
	              t('You don\'t have permissions to manage press pack files')
	            )
	          ),
	          projectType === _projects3.projectTypes.sharespace && _react2.default.createElement(
	            'div',
	            { className: 'section' },
	            _react2.default.createElement(
	              'div',
	              { className: styles.projectsHeader },
	              _react2.default.createElement(
	                'h3',
	                null,
	                t('Projects')
	              ),
	              _react2.default.createElement(_ProjectLegendLine2.default, { hideWatermark: true })
	            ),
	            _react2.default.createElement(_components.SSProjectsList, { projectId: projectId }),
	            _react2.default.createElement(
	              'div',
	              { className: 'text-right' },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { className: 'btn btn-primary', to: '/projects/' + projectType + '/' + projectId + '/create' },
	                t('Create project')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'text-right margin-vert-40' },
	            projectType === _projects3.projectTypes.sharespace ? _react2.default.createElement(_SharespacePublishButton2.default, { project: project }) : _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                className: 'btn btn-primary wide',
	                to: '/projects/' + projectType + '/' + projectId + '/' + (projectType === _projects3.projectTypes.sharespace ? 'confirmation' : 'recipients')
	              },
	              t('Next')
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return ProjectMaterials;
	}(_ClientSideComponent2.default), _class3.propTypes = {
	  addMedia: _propTypes2.default.func,
	  addPress: _propTypes2.default.func,
	  copyProject: _propTypes2.default.func,
	  copyProjectLoading: _propTypes2.default.bool,
	  deleteMedia: _propTypes2.default.func,
	  deleteMediaFile: _propTypes2.default.func,
	  deletePress: _propTypes2.default.func,
	  deletePressActionData: _propTypes2.default.object,
	  deletePressFile: _propTypes2.default.func,
	  deletePressLoading: _propTypes2.default.bool,
	  logout: _propTypes2.default.func,
	  mediaList: _propTypes2.default.array,
	  needReloadProjects: _propTypes2.default.func,
	  permissions: _propTypes2.default.object,
	  pressList: _propTypes2.default.array,
	  pressListLoading: _propTypes2.default.bool,
	  project: _propTypes2.default.object,
	  projectId: _propTypes2.default.number,
	  projectLoading: _propTypes2.default.bool,
	  projectType: _propTypes2.default.string,
	  pushState: _propTypes2.default.func,
	  setMultipleBoxsets: _propTypes2.default.func,
	  submitMediaFile: _propTypes2.default.func,
	  submitPressFile: _propTypes2.default.func,
	  submittedCloudFiles: _propTypes2.default.array,
	  submittedMediaFiles: _propTypes2.default.array,
	  submittedPressFiles: _propTypes2.default.array,
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onCloudUpload', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onCloudUpload'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'copyProject', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'copyProject'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'deleteMediaItem', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'deleteMediaItem'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'cancelMediaFile', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'cancelMediaFile'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'cancelPressFile', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'cancelPressFile'), _class2.prototype)), _class2)) || _class) || _class) || _class);
	exports.default = ProjectMaterials;
	module.exports = exports['default'];

/***/ }),
/* 2197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _promise = __webpack_require__(62);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(55);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactRedux = __webpack_require__(11);
	
	var _project = __webpack_require__(37);
	
	var projectActions = _interopRequireWildcard(_project);
	
	var _contacts = __webpack_require__(61);
	
	var contactsActions = _interopRequireWildcard(_contacts);
	
	var _reduxConnect = __webpack_require__(33);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	var _Link = __webpack_require__(82);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _auth = __webpack_require__(77);
	
	var _projects = __webpack_require__(28);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _reactRouterRedux = __webpack_require__(40);
	
	var _asyncPromise = __webpack_require__(43);
	
	var _asyncPromise2 = _interopRequireDefault(_asyncPromise);
	
	var _ImportRecipientsCSVButton = __webpack_require__(827);
	
	var _ImportRecipientsCSVButton2 = _interopRequireDefault(_ImportRecipientsCSVButton);
	
	var _AddRecipientRow = __webpack_require__(844);
	
	var _AddRecipientRow2 = _interopRequireDefault(_AddRecipientRow);
	
	var _ProjectRecipientsList = __webpack_require__(2087);
	
	var _ProjectRecipientsList2 = _interopRequireDefault(_ProjectRecipientsList);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1369);
	
	var ProjectRecipients = (_dec = (0, _reduxConnect.asyncConnect)([{
	  promise: function promise(_ref) {
	    var _ref$store = _ref.store,
	        dispatch = _ref$store.dispatch,
	        getState = _ref$store.getState,
	        projectId = _ref.params.projectId;
	    var isLoadProjectTime = projectActions.isLoadProjectTime,
	        loadProject = projectActions.loadProject,
	        initProject = projectActions.initProject;
	    var loadGroups = contactsActions.loadGroups;
	
	    var id = Number(projectId);
	    var promises = [dispatch(projectActions.loadRecipientsList(projectId)).promise];
	
	    if (id) {
	      if (isLoadProjectTime(id, getState())) {
	        promises.push(dispatch(loadProject(id)).promise, dispatch(loadGroups(id)).promise);
	      }
	    } else {
	      promises.push(dispatch(initProject()));
	    }
	
	    return (0, _asyncPromise2.default)(_promise2.default.all(promises));
	  }
	}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    addRecipientsFromGroupsLoading: state.project.addRecipientsFromGroupsLoading,
	    permissions: (0, _auth.getPermissions)(state),
	    project: state.project.projectData,
	    projectId: Number(ownProps.params.projectId),
	    projectLoading: state.project.projectLoading,
	    projectType: ownProps.params.type,
	    sendEmailLoading: state.project.sendEmailLoading
	  };
	}, (0, _extends3.default)({}, projectActions, { pushState: _reactRouterRedux.push }), null, { withRef: true }), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(ProjectRecipients, _Component);
	
	  function ProjectRecipients() {
	    var _ref2;
	
	    (0, _classCallCheck3.default)(this, ProjectRecipients);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = ProjectRecipients.__proto__ || (0, _getPrototypeOf2.default)(ProjectRecipients)).call.apply(_ref2, [this].concat(args)));
	
	    _this.state = { sendType: 'new' };
	    return _this;
	  }
	
	  (0, _createClass3.default)(ProjectRecipients, [{
	    key: 'onImportRecipients',
	    value: function onImportRecipients(_ref3) {
	      var data = _ref3.data;
	      var _props = this.props,
	          addRecipients = _props.addRecipients,
	          projectId = _props.projectId;
	
	      addRecipients(projectId, data);
	    }
	  }, {
	    key: 'setSendType',
	    value: function setSendType(sendType) {
	      this.setState({ sendType: sendType });
	    }
	  }, {
	    key: '_onSelectContacts',
	    value: function _onSelectContacts(contacts) {
	      var _props2 = this.props,
	          projectId = _props2.projectId,
	          addRecipientsFromContacts = _props2.addRecipientsFromContacts,
	          loadRecipientsList = _props2.loadRecipientsList;
	
	      this.selectContactsModalEl.close();
	      addRecipientsFromContacts(projectId, contacts).promise.then(function () {
	        return loadRecipientsList(projectId).promise;
	      });
	    }
	  }, {
	    key: '_onSelectGroups',
	    value: function _onSelectGroups(groups) {
	      var _props3 = this.props,
	          projectId = _props3.projectId,
	          addRecipientsFromGroups = _props3.addRecipientsFromGroups,
	          loadRecipientsList = _props3.loadRecipientsList;
	
	      this.selectGroupsModalEl.close();
	      addRecipientsFromGroups(projectId, groups).promise.then(function () {
	        return loadRecipientsList(projectId).promise;
	      });
	    }
	  }, {
	    key: '_onAddGroup',
	    value: function _onAddGroup() {
	      var _props4 = this.props,
	          projectId = _props4.projectId,
	          loadRecipientsList = _props4.loadRecipientsList;
	
	      loadRecipientsList(projectId);
	    }
	  }, {
	    key: 'sendEmail',
	    value: function sendEmail(sendType) {
	      var _props5 = this.props,
	          projectId = _props5.projectId,
	          sendEmail = _props5.sendEmail;
	
	      sendEmail(projectId, sendType);
	    }
	  }, {
	    key: 'next',
	    value: function next() {
	      var _props6 = this.props,
	          projectType = _props6.projectType,
	          projectId = _props6.projectId,
	          sendEmail = _props6.sendEmail,
	          pushState = _props6.pushState;
	      var sendType = this.state.sendType;
	
	      sendEmail(projectId, sendType).promise.then(function () {
	        return pushState('/projects/' + projectType + '/' + projectId + '/confirmation');
	      });
	    }
	  }, {
	    key: 'renderSendTypeRadios',
	    value: function renderSendTypeRadios() {
	      var t = this.props.t;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.remindersRadios },
	        this.renderSendTypeRadio({
	          type: 'new',
	          text: t('New recipients only')
	        }),
	        this.renderSendTypeRadio({
	          type: 'remind',
	          text: t('Send reminders')
	        }),
	        this.renderSendTypeRadio({
	          type: 'all',
	          text: t('Send to all recipients')
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: styles.reminderHint },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'bold margin-right-5' },
	              t('NEW Recipients Only'),
	              ':'
	            ),
	            _react2.default.createElement(_reactI18next.Interpolate, {
	              i18nKey: 'only sends to those marked as {{keyword}} in the recipient list',
	              keyword: _react2.default.createElement(
	                'span',
	                { className: 'bold' },
	                t('NEW')
	              )
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'bold margin-right-5' },
	              t('Send REMINDERS'),
	              ':'
	            ),
	            _react2.default.createElement(_reactI18next.Interpolate, {
	              i18nKey: 'only sends to those who have previously received the email but have {{keyword}} yet listened',
	              keyword: _react2.default.createElement(
	                'span',
	                { className: 'bold' },
	                t('NOT')
	              )
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'bold margin-right-5' },
	              t('Send to ALL recipients'),
	              ':'
	            ),
	            _react2.default.createElement(_reactI18next.Interpolate, {
	              i18nKey: 'sends to {{keyword}} in the recipient list regardless',
	              keyword: _react2.default.createElement(
	                'span',
	                { className: 'bold' },
	                t('EVERYONE')
	              )
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderSendTypeRadio',
	    value: function renderSendTypeRadio(_ref4) {
	      var _this2 = this;
	
	      var type = _ref4.type,
	          text = _ref4.text;
	      var sendType = this.state.sendType;
	
	
	      return _react2.default.createElement(_components.Checkbox, {
	        radio: true,
	        small: true,
	        checked: sendType === type,
	        onChange: function onChange() {
	          return _this2.setSendType(type);
	        },
	        className: styles.reminderRadio,
	        textAfter: _react2.default.createElement(
	          'span',
	          { className: styles.reminderText },
	          text
	        )
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props7 = this.props,
	          t = _props7.t,
	          projectId = _props7.projectId,
	          projectType = _props7.projectType,
	          projectLoading = _props7.projectLoading,
	          permissions = _props7.permissions,
	          sendEmailLoading = _props7.sendEmailLoading,
	          addRecipientsFromGroupsLoading = _props7.addRecipientsFromGroupsLoading;
	
	      var project = this.props.project || {};
	      var isNewProject = project.status === 'Created';
	      var importUploaderParams = {
	        queryParams: { projectId: projectId },
	        endpoint: '/api/contacts_wa/addRecipientsCSV'
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page pos-rel' },
	        _react2.default.createElement(_reactHelmet2.default, { title: 'Project' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'container-fluid' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            t('Recipients'),
	            projectLoading && _react2.default.createElement(_components.Loader, { small: true, inline: true, right: true })
	          ),
	          _react2.default.createElement(_components.ProjectBreadcrumbs, { projectId: projectId, projectType: projectType }),
	          _react2.default.createElement(
	            'div',
	            { className: 'section' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              t('Cover picture')
	            ),
	            _react2.default.createElement(_components.ProjectCover, { project: project, disabled: projectLoading || !permissions.editProjectCover })
	          ),
	          projectType !== _projects.projectTypes.video && project.imageThumb && permissions.editProjectCover && _react2.default.createElement(
	            'div',
	            { className: 'section' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              t('Choose the packshot style')
	            ),
	            _react2.default.createElement(_components.CoverStyle, null)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              t('Recipients management')
	            ),
	            _react2.default.createElement(
	              'h5',
	              null,
	              t('Option'),
	              ' 1'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: styles.addOption },
	              _react2.default.createElement(
	                'div',
	                { className: 'hint small' },
	                t('Import recipients from csv file. Take me there.')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: styles.csvHint },
	                _react2.default.createElement(_components.CsvHint, { className: 'margin-left-10' })
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_ImportRecipientsCSVButton2.default, {
	                  uploaderParams: importUploaderParams,
	                  onImport: this.onImportRecipients
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'h5',
	              null,
	              t('Option'),
	              ' 2'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: styles.addOption },
	              _react2.default.createElement(
	                'div',
	                { className: 'hint small' },
	                t('Import groups of contacts')
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                addRecipientsFromGroupsLoading ? _react2.default.createElement(_components.Loader, null) : _react2.default.createElement(
	                  'button',
	                  { type: 'button', className: 'btn btn-primary', onClick: function onClick() {
	                      return _this3.selectGroupsModalEl.open();
	                    } },
	                  t('Import')
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'h5',
	              null,
	              t('Option'),
	              ' 3'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'padding-left-10' },
	              _react2.default.createElement(_AddRecipientRow2.default, {
	                projectId: projectId,
	                onAddGroup: this._onAddGroup,
	                hintClassName: 'hint small'
	              })
	            ),
	            _react2.default.createElement(
	              _components.Modal,
	              { ref: function ref(el) {
	                  return _this3.selectContactsModalEl = el;
	                }, title: t('Select recipients from contacts'), backdrop: 'static', bsSize: 'lg' },
	              _react2.default.createElement(_components.SelectContactsList, { onSelect: this._onSelectContacts })
	            ),
	            _react2.default.createElement(
	              _components.Modal,
	              { ref: function ref(el) {
	                  return _this3.selectGroupsModalEl = el;
	                }, title: t('Select recipients from groups'), backdrop: 'static', bsSize: 'lg' },
	              _react2.default.createElement(_components.SelectGroupsList, { onSelect: this._onSelectGroups })
	            ),
	            _react2.default.createElement(
	              'h5',
	              { className: 'margin-top-20' },
	              t('List of recipients')
	            ),
	            _react2.default.createElement(_ProjectRecipientsList2.default, {
	              projectId: projectId,
	              individualExpiryDate: !!project.individualExpiryDate,
	              downloadAuthorised: !!project.downloadAuthorised,
	              className: 'fullWidthSm'
	            }),
	            !isNewProject && this.renderSendTypeRadios()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              t('Links')
	            ),
	            _react2.default.createElement(_components.RecipientsLinksForm, { projectId: projectId })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              t('Email')
	            ),
	            _react2.default.createElement(_components.RecipientsEmailWysiwyg, { projectId: projectId })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'margin-top-30 text-right' },
	            _react2.default.createElement(
	              _Link2.default,
	              { to: '/projects/' + projectType + '/' + projectId + '/materials', className: 'btn btn-accent wide margin-vert-5' },
	              t('Back')
	            ),
	            _react2.default.createElement(
	              _components.Button,
	              {
	                type: 'button',
	                className: 'btn-primary wide margin-left-20 margin-vert-5',
	                onClick: this.next,
	                loading: sendEmailLoading
	              },
	              t('Next')
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return ProjectRecipients;
	}(_react.Component), _class3.propTypes = {
	  addRecipients: _propTypes2.default.func,
	  addRecipientsFromContacts: _propTypes2.default.func,
	  addRecipientsFromGroups: _propTypes2.default.func,
	  addRecipientsFromGroupsLoading: _propTypes2.default.bool,
	  loadRecipientsList: _propTypes2.default.func,
	  permissions: _propTypes2.default.object,
	  project: _propTypes2.default.object,
	  projectId: _propTypes2.default.number,
	  projectLoading: _propTypes2.default.bool,
	  projectType: _propTypes2.default.string,
	  pushState: _propTypes2.default.func,
	  sendEmail: _propTypes2.default.func,
	  sendEmailLoading: _propTypes2.default.bool,
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onImportRecipients', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onImportRecipients'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, '_onSelectContacts', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, '_onSelectContacts'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, '_onSelectGroups', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, '_onSelectGroups'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, '_onAddGroup', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, '_onAddGroup'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'next', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'next'), _class2.prototype)), _class2)) || _class) || _class) || _class);
	exports.default = ProjectRecipients;
	module.exports = exports['default'];

/***/ }),
/* 2198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _ProjectDeleteSenderButton = __webpack_require__(2193);
	
	var _ProjectDeleteSenderButton2 = _interopRequireDefault(_ProjectDeleteSenderButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1370);
	
	var ProjectSenderInfo = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(ProjectSenderInfo, _PureComponent);
	
	  function ProjectSenderInfo() {
	    (0, _classCallCheck3.default)(this, ProjectSenderInfo);
	    return (0, _possibleConstructorReturn3.default)(this, (ProjectSenderInfo.__proto__ || (0, _getPrototypeOf2.default)(ProjectSenderInfo)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProjectSenderInfo, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          senderName = _props.senderName,
	          senderEmail = _props.senderEmail,
	          onDelete = _props.onDelete,
	          projectId = _props.projectId;
	      var t = this.context.t;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(styles.senderInfo, className) },
	        _react2.default.createElement(
	          'div',
	          { className: styles.senderName },
	          _react2.default.createElement(
	            'div',
	            null,
	            t('Sender name'),
	            ': ',
	            senderName
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            t('Sender email'),
	            ': ',
	            senderEmail
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.deleteSenderContainer },
	          _react2.default.createElement(_ProjectDeleteSenderButton2.default, { onDelete: onDelete, projectId: projectId })
	        )
	      );
	    }
	  }]);
	  return ProjectSenderInfo;
	}(_react.PureComponent), _class.propTypes = {
	  className: _propTypes2.default.string,
	  onDelete: _propTypes2.default.func,
	  projectId: _propTypes2.default.number,
	  senderEmail: _propTypes2.default.string,
	  senderName: _propTypes2.default.string
	}, _class.contextTypes = {
	  t: _propTypes2.default.func
	}, _class.defaultProps = {
	  onDelete: _noop3.default
	}, _temp);
	exports.default = ProjectSenderInfo;
	module.exports = exports['default'];

/***/ }),
/* 2199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _ListItem = __webpack_require__(76);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _loadReducer = __webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1371);
	
	var ProjectStatsViewerRow = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(ProjectStatsViewerRow, _PureComponent);
	
	  function ProjectStatsViewerRow() {
	    (0, _classCallCheck3.default)(this, ProjectStatsViewerRow);
	    return (0, _possibleConstructorReturn3.default)(this, (ProjectStatsViewerRow.__proto__ || (0, _getPrototypeOf2.default)(ProjectStatsViewerRow)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProjectStatsViewerRow, [{
	    key: 'deleteViewer',
	    value: function deleteViewer() {
	      var _props = this.props,
	          viewer = _props.viewer,
	          onDelete = _props.onDelete;
	
	      onDelete({ viewer: viewer });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          viewer = _props2.viewer,
	          projectId = _props2.projectId,
	          deleteLoaders = _props2.deleteLoaders;
	      var t = this.context.t;
	
	      var loaderKey = (0, _loadReducer.getLoaderKey)([projectId, viewer.userEmail]);
	      var isDeleteLoading = deleteLoaders[loaderKey];
	
	      return _react2.default.createElement(
	        _ListItem2.default,
	        { fullWidth: true, className: (0, _bind2.default)(className) },
	        _react2.default.createElement(
	          'div',
	          null,
	          viewer.fullName
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          viewer.userEmail
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.actionsCell },
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              className: 'btn-text',
	              onClick: this.deleteViewer,
	              loading: isDeleteLoading,
	              small: true
	            },
	            _react2.default.createElement('i', { className: 'icon-delete', title: t('Delete') })
	          )
	        )
	      );
	    }
	  }]);
	  return ProjectStatsViewerRow;
	}(_react.PureComponent), _class2.propTypes = {
	  className: _propTypes2.default.string,
	  deleteLoaders: _propTypes2.default.object,
	  onDelete: _propTypes2.default.func,
	  projectId: _propTypes2.default.number,
	  viewer: _propTypes2.default.object
	}, _class2.contextTypes = {
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  onDelete: _noop3.default,
	  viewer: {}
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'deleteViewer', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'deleteViewer'), _class.prototype)), _class);
	exports.default = ProjectStatsViewerRow;
	module.exports = exports['default'];

/***/ }),
/* 2200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _statistics = __webpack_require__(57);
	
	var statisticsActions = _interopRequireWildcard(_statistics);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _List = __webpack_require__(182);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ListItem = __webpack_require__(76);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _ProjectStatsViewerRow = __webpack_require__(2199);
	
	var _ProjectStatsViewerRow2 = _interopRequireDefault(_ProjectStatsViewerRow);
	
	var _Loader = __webpack_require__(60);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _statistics2 = __webpack_require__(126);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var ProjectStatsViewersList = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    deleteLoaders: state.statistics.deleteStatsViewerLoaders,
	    statsViewers: (0, _statistics2.getStatsViewers)(state),
	    statsViewersLoading: state.statistics.statsViewersLoading
	  };
	}, (0, _extends3.default)({}, statisticsActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(ProjectStatsViewersList, _Component);
	
	  function ProjectStatsViewersList() {
	    (0, _classCallCheck3.default)(this, ProjectStatsViewersList);
	    return (0, _possibleConstructorReturn3.default)(this, (ProjectStatsViewersList.__proto__ || (0, _getPrototypeOf2.default)(ProjectStatsViewersList)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProjectStatsViewersList, [{
	    key: 'deleteViewer',
	    value: function deleteViewer(_ref) {
	      var viewer = _ref.viewer;
	      var _props = this.props,
	          projectId = _props.projectId,
	          deleteStatsViewer = _props.deleteStatsViewer;
	
	      return deleteStatsViewer({ projectId: projectId, email: viewer.userEmail });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          className = _props2.className,
	          projectId = _props2.projectId,
	          statsViewers = _props2.statsViewers,
	          statsViewersLoading = _props2.statsViewersLoading,
	          deleteLoaders = _props2.deleteLoaders;
	      var t = this.context.t;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(className) },
	        _react2.default.createElement(
	          _List2.default,
	          null,
	          _react2.default.createElement(
	            _ListItem2.default,
	            { fullWidth: true, isTitle: true },
	            _react2.default.createElement(
	              'div',
	              null,
	              t('Name')
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              t('Email')
	            ),
	            _react2.default.createElement('div', null)
	          ),
	          statsViewers.map(function (viewer) {
	            return _react2.default.createElement(_ProjectStatsViewerRow2.default, {
	              key: viewer.userId,
	              viewer: viewer,
	              onDelete: _this2.deleteViewer,
	              deleteLoaders: deleteLoaders,
	              projectId: projectId
	            });
	          })
	        ),
	        _react2.default.createElement(_Loader2.default, { show: statsViewersLoading, small: true, alignCenter: true })
	      );
	    }
	  }]);
	  return ProjectStatsViewersList;
	}(_react.Component), _class3.propTypes = {
	  className: _propTypes2.default.string,
	  deleteLoaders: _propTypes2.default.object,
	  deleteStatsViewer: _propTypes2.default.func,
	  projectId: _propTypes2.default.number,
	  statsViewers: _propTypes2.default.array,
	  statsViewersLoading: _propTypes2.default.bool
	}, _class3.contextTypes = {
	  t: _propTypes2.default.func
	}, _class3.defaultProps = {
	  onClick: _noop3.default,
	  statsViewers: []
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'deleteViewer', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'deleteViewer'), _class2.prototype)), _class2)) || _class);
	exports.default = ProjectStatsViewersList;
	module.exports = exports['default'];

/***/ }),
/* 2201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _responseCodes = __webpack_require__(99);
	
	var _uuid = __webpack_require__(270);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _strings = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1372);
	
	var RecipientsImportReport = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(RecipientsImportReport, _PureComponent);
	
	  function RecipientsImportReport() {
	    (0, _classCallCheck3.default)(this, RecipientsImportReport);
	    return (0, _possibleConstructorReturn3.default)(this, (RecipientsImportReport.__proto__ || (0, _getPrototypeOf2.default)(RecipientsImportReport)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(RecipientsImportReport, [{
	    key: 'getExistingRecipients',
	    value: function getExistingRecipients() {
	      var _errors;
	
	      var data = this.props.data;
	      var t = this.context.t;
	
	      var _t = t;
	      var recipients = [];
	
	      var errors = (_errors = {}, (0, _defineProperty3.default)(_errors, _responseCodes.importRecipientsCodes.invalidContact, t('Invalid email address')), (0, _defineProperty3.default)(_errors, _responseCodes.importRecipientsCodes.emailExists, t('Contact already exists')), (0, _defineProperty3.default)(_errors, _responseCodes.importRecipientsCodes.recipientExists, t('Contact already exists')), (0, _defineProperty3.default)(_errors, _responseCodes.importRecipientsCodes.groupEmailExists, t('Contact exists in group')), _errors);
	
	      data.map(function (recipient) {
	        if (errors[recipient.result]) {
	          recipients.push((0, _extends3.default)({}, recipient, { uuid: (0, _uuid2.default)(), errorMessage: _t(recipient.info) || errors[recipient.result] }));
	        }
	      });
	
	      return recipients;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          showHeader = _props.showHeader,
	          showSubHeader = _props.showSubHeader,
	          className = _props.className;
	      var t = this.context.t;
	
	      var existingRecipients = this.getExistingRecipients();
	
	      if (!existingRecipients.length) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        showHeader && _react2.default.createElement(
	          'div',
	          { className: styles.header },
	          t('Contacts import report')
	        ),
	        showSubHeader && _react2.default.createElement(
	          'div',
	          { className: styles.subheader },
	          t('Could not add the following contacts'),
	          ':'
	        ),
	        existingRecipients.map(function (recipient) {
	          return _react2.default.createElement(
	            'li',
	            { key: recipient.uuid, className: styles.row },
	            _react2.default.createElement(
	              'span',
	              { className: styles.name },
	              (0, _strings.concat)(' ', recipient.name, recipient.surname),
	              ' (',
	              recipient.userEmail || recipient.email,
	              ')'
	            ),
	            '-',
	            _react2.default.createElement(
	              'span',
	              { className: styles.error },
	              recipient.errorMessage
	            )
	          );
	        })
	      );
	    }
	  }]);
	  return RecipientsImportReport;
	}(_react.PureComponent), _class.propTypes = {
	  className: _propTypes2.default.string,
	  data: _propTypes2.default.array,
	  showHeader: _propTypes2.default.bool,
	  showSubHeader: _propTypes2.default.bool
	}, _class.contextTypes = {
	  t: _propTypes2.default.func
	}, _class.defaultProps = {
	  data: []
	}, _temp);
	exports.default = RecipientsImportReport;
	module.exports = exports['default'];

/***/ }),
/* 2202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProjectCreateFromSS = exports.ProjectConfirmation = exports.ProjectRecipients = exports.ProjectMaterials = exports.ProjectInfo = undefined;
	
	var _ProjectInfo2 = __webpack_require__(2194);
	
	var _ProjectInfo3 = _interopRequireDefault(_ProjectInfo2);
	
	var _ProjectMaterials2 = __webpack_require__(2196);
	
	var _ProjectMaterials3 = _interopRequireDefault(_ProjectMaterials2);
	
	var _ProjectRecipients2 = __webpack_require__(2197);
	
	var _ProjectRecipients3 = _interopRequireDefault(_ProjectRecipients2);
	
	var _ProjectConfirmation2 = __webpack_require__(2189);
	
	var _ProjectConfirmation3 = _interopRequireDefault(_ProjectConfirmation2);
	
	var _ProjectCreateFromSS2 = __webpack_require__(2190);
	
	var _ProjectCreateFromSS3 = _interopRequireDefault(_ProjectCreateFromSS2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ProjectInfo = _ProjectInfo3.default;
	exports.ProjectMaterials = _ProjectMaterials3.default;
	exports.ProjectRecipients = _ProjectRecipients3.default;
	exports.ProjectConfirmation = _ProjectConfirmation3.default;
	exports.ProjectCreateFromSS = _ProjectCreateFromSS3.default;

/***/ }),
/* 2203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _dec3, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reduxConnect = __webpack_require__(33);
	
	var _reactHelmet = __webpack_require__(55);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	var _report = __webpack_require__(874);
	
	var _report2 = __webpack_require__(360);
	
	var reportActions = _interopRequireWildcard(_report2);
	
	var _asyncPromise = __webpack_require__(43);
	
	var _asyncPromise2 = _interopRequireDefault(_asyncPromise);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(633);
	
	var ProjectRecipientReport = (_dec = (0, _reduxConnect.asyncConnect)([{
	  promise: function promise(_ref) {
	    var dispatch = _ref.store.dispatch,
	        _ref$params = _ref.params,
	        projectId = _ref$params.projectId,
	        recipientId = _ref$params.recipientId;
	    return (0, _asyncPromise2.default)(dispatch(reportActions.loadRecipientReport({ projectId: projectId, recipientId: recipientId })).promise);
	  }
	}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    projectType: ownProps.params.type,
	    projectId: Number(ownProps.params.projectId),
	    reportData: (0, _report.getRecipientReportData)(state),
	    reportLoading: state.report.recipientReportLoading
	  };
	}), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(ProjectRecipientReport, _Component);
	
	  function ProjectRecipientReport() {
	    (0, _classCallCheck3.default)(this, ProjectRecipientReport);
	    return (0, _possibleConstructorReturn3.default)(this, (ProjectRecipientReport.__proto__ || (0, _getPrototypeOf2.default)(ProjectRecipientReport)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProjectRecipientReport, [{
	    key: 'getBackUrl',
	    value: function getBackUrl() {
	      var _props = this.props,
	          projectType = _props.projectType,
	          projectId = _props.projectId;
	
	      return '/projects/' + projectType + '/' + projectId + '/report';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          reportData = _props2.reportData,
	          reportLoading = _props2.reportLoading,
	          t = _props2.t;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(_reactHelmet2.default, { title: 'Project Recipient Report' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'container-fluid' },
	          _react2.default.createElement(_components.BackButton, { asBlock: true, backUrl: this.getBackUrl() }),
	          reportLoading ? _react2.default.createElement(_components.Loader, { className: 'margin-top-20' }) : _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'section',
	              { className: styles.section },
	              _react2.default.createElement(
	                'h3',
	                null,
	                t('File info')
	              ),
	              _react2.default.createElement(_components.ProjectRecipientReportInformation, { reportData: reportData })
	            ),
	            _react2.default.createElement(
	              'section',
	              { className: styles.section },
	              _react2.default.createElement(
	                'h3',
	                null,
	                t('Detailed actions')
	              ),
	              _react2.default.createElement(_components.ProjectRecipientReportDetailed, { reportData: reportData })
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return ProjectRecipientReport;
	}(_react.Component), _class2.propTypes = {
	  projectId: _propTypes2.default.number,
	  projectType: _propTypes2.default.string,
	  reportData: _propTypes2.default.object,
	  reportLoading: _propTypes2.default.bool,
	  t: _propTypes2.default.func
	}, _temp)) || _class) || _class) || _class);
	exports.default = ProjectRecipientReport;
	module.exports = exports['default'];

/***/ }),
/* 2204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _dec3, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reduxConnect = __webpack_require__(33);
	
	var _reactHelmet = __webpack_require__(55);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactI18next = __webpack_require__(12);
	
	var _components = __webpack_require__(15);
	
	var _report = __webpack_require__(360);
	
	var reportActions = _interopRequireWildcard(_report);
	
	var _report2 = __webpack_require__(874);
	
	var _asyncPromise = __webpack_require__(43);
	
	var _asyncPromise2 = _interopRequireDefault(_asyncPromise);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(633);
	
	var ProjecReport = (_dec = (0, _reduxConnect.asyncConnect)([{
	  promise: function promise(_ref) {
	    var dispatch = _ref.store.dispatch,
	        projectId = _ref.params.projectId;
	    return (0, _asyncPromise2.default)(dispatch(reportActions.loadReport({ projectId: projectId })).promise);
	  }
	}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    projectType: ownProps.params.type,
	    reportData: (0, _report2.getReportData)(state),
	    reportLoading: state.report.reportLoading
	  };
	}), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(ProjecReport, _Component);
	
	  function ProjecReport() {
	    (0, _classCallCheck3.default)(this, ProjecReport);
	    return (0, _possibleConstructorReturn3.default)(this, (ProjecReport.__proto__ || (0, _getPrototypeOf2.default)(ProjecReport)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProjecReport, [{
	    key: 'getBackUrl',
	    value: function getBackUrl() {
	      return '/projects/' + this.props.projectType;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          t = _props.t,
	          reportData = _props.reportData,
	          reportLoading = _props.reportLoading;
	      var project = reportData.project;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(_reactHelmet2.default, { title: 'Project Report' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'container-fluid' },
	          _react2.default.createElement(_components.BackButton, { asBlock: true, backUrl: this.getBackUrl() }),
	          _react2.default.createElement(_components.Loader, { className: 'margin-top-20', show: reportLoading, alignCenter: true }),
	          _react2.default.createElement(
	            'div',
	            { hidden: reportLoading },
	            _react2.default.createElement(
	              'section',
	              { className: styles.section },
	              _react2.default.createElement(
	                'h3',
	                null,
	                t('Project'),
	                ' "',
	                project.fullTitle,
	                '"'
	              ),
	              _react2.default.createElement(_components.ProjectReportInformation, { reportData: reportData })
	            ),
	            _react2.default.createElement(
	              'section',
	              { className: styles.section },
	              _react2.default.createElement(
	                'h3',
	                null,
	                t('Recipients statistic')
	              ),
	              _react2.default.createElement(_components.ProjectReportRecipientsStatistic, { reportData: reportData })
	            ),
	            _react2.default.createElement(
	              'section',
	              { className: styles.section },
	              _react2.default.createElement(
	                'h3',
	                null,
	                t('File info')
	              ),
	              _react2.default.createElement(_components.ProjectReportFileInfo, { reportData: reportData })
	            ),
	            _react2.default.createElement(
	              'section',
	              { className: styles.section },
	              _react2.default.createElement(
	                'h3',
	                null,
	                t('Users who played the content')
	              ),
	              _react2.default.createElement(_components.ProjectReportPlayedUsers, { reportData: reportData })
	            ),
	            _react2.default.createElement(
	              'section',
	              { className: styles.section },
	              _react2.default.createElement(
	                'h3',
	                null,
	                t('Users who did not access the content')
	              ),
	              _react2.default.createElement(_components.ProjectReportSkippedUsers, { reportData: reportData })
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return ProjecReport;
	}(_react.Component), _class2.propTypes = {
	  projectType: _propTypes2.default.string,
	  reportData: _propTypes2.default.object,
	  reportLoading: _propTypes2.default.bool,
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  reportData: {}
	}, _temp)) || _class) || _class) || _class);
	exports.default = ProjecReport;
	module.exports = exports['default'];

/***/ }),
/* 2205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(55);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactRedux = __webpack_require__(11);
	
	var _project = __webpack_require__(37);
	
	var projectActions = _interopRequireWildcard(_project);
	
	var _projects = __webpack_require__(359);
	
	var projectsActions = _interopRequireWildcard(_projects);
	
	var _reduxConnect = __webpack_require__(33);
	
	var _reactRouterRedux = __webpack_require__(40);
	
	var _components = __webpack_require__(15);
	
	var _reactI18next = __webpack_require__(12);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _auth = __webpack_require__(77);
	
	var _projects2 = __webpack_require__(28);
	
	var _permissions = __webpack_require__(215);
	
	var _asyncPromise = __webpack_require__(43);
	
	var _asyncPromise2 = _interopRequireDefault(_asyncPromise);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _ProjectLegendLine = __webpack_require__(517);
	
	var _ProjectLegendLine2 = _interopRequireDefault(_ProjectLegendLine);
	
	var _ProjectsTabs = __webpack_require__(2068);
	
	var _ProjectsTabs2 = _interopRequireDefault(_ProjectsTabs);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SearchBar = __webpack_require__(183);
	
	var _SearchBar2 = _interopRequireDefault(_SearchBar);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1374);
	
	var Projects = (_dec = (0, _reduxConnect.asyncConnect)([{
	  promise: function promise(_ref) {
	    var _ref$store = _ref.store,
	        dispatch = _ref$store.dispatch,
	        getState = _ref$store.getState;
	
	    if (projectsActions.isLoadTime(getState())) {
	      dispatch(projectsActions.filter(''));
	      return (0, _asyncPromise2.default)(dispatch(projectsActions.loadProjects()).promise);
	    }
	  }
	}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    kw: state.projects.kw,
	    permissions: (0, _auth.getPermissions)(state),
	    projectType: ownProps.params.type
	  };
	}, (0, _extends3.default)({}, projectsActions, { pushState: _reactRouterRedux.push, initProject: projectActions.init })), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(Projects, _Component);
	
	  function Projects() {
	    var _ref2;
	
	    (0, _classCallCheck3.default)(this, Projects);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = Projects.__proto__ || (0, _getPrototypeOf2.default)(Projects)).call.apply(_ref2, [this].concat(args)));
	
	    _this.state = { kw: _this.props.kw };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Projects, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.kw !== this.props.kw) {
	        this.setState({ kw: nextProps.kw });
	      }
	    }
	  }, {
	    key: 'getHeader',
	    value: function getHeader() {
	      var _headers;
	
	      var _props = this.props,
	          t = _props.t,
	          projectType = _props.projectType;
	
	      var headers = (_headers = {}, (0, _defineProperty3.default)(_headers, _projects2.projectTypes.audio, t('Audio')), (0, _defineProperty3.default)(_headers, _projects2.projectTypes.video, t('Video')), (0, _defineProperty3.default)(_headers, _projects2.projectTypes.sharespace, t('Sharespaces')), _headers);
	      return headers[projectType];
	    }
	  }, {
	    key: 'createNewProject',
	    value: function createNewProject() {
	      var _props2 = this.props,
	          t = _props2.t,
	          projectType = _props2.projectType,
	          initProject = _props2.initProject,
	          pushState = _props2.pushState;
	
	      initProject();
	      if (projectType === _projects2.projectTypes.all) {
	        pushState('/projects/new');
	      } else if (projectType === _projects2.projectTypes.video) {
	        _toastr2.default.info(t('Currently Unavailable'));
	      } else {
	        pushState('/projects/' + projectType + '/0');
	      }
	    }
	  }, {
	    key: 'filter',
	    value: function filter(kw) {
	      this.setState({ kw: kw });
	      this.props.filter(kw);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          t = _props3.t,
	          projectType = _props3.projectType,
	          permissions = _props3.permissions;
	      var kw = this.state.kw;
	
	      var canCreateProject = (0, _permissions.canCreateProjectByType)(permissions, projectType);
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(styles.projects, 'page') },
	        _react2.default.createElement(_reactHelmet2.default, { title: 'Projects' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'container-fluid' },
	          _react2.default.createElement(
	            'div',
	            { className: styles.header },
	            _react2.default.createElement(
	              'h1',
	              null,
	              this.getHeader()
	            ),
	            _react2.default.createElement(_ProjectsTabs2.default, null)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: styles.headerHint },
	            t('Please choose the project or sharespace you want to work on from the list below'),
	            '.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'overflow-hidden' },
	            _react2.default.createElement(_SearchBar2.default, {
	              className: styles.searchBar,
	              inputClass: styles.searchInput,
	              kw: kw,
	              onChange: this.filter
	            }),
	            _react2.default.createElement(_ProjectLegendLine2.default, { className: styles.legendLine }),
	            canCreateProject && _react2.default.createElement(
	              _Button2.default,
	              { className: 'btn-primary pull-right', onClick: this.createNewProject },
	              t('Create new')
	            )
	          ),
	          _react2.default.createElement(_components.ProjectsListWrapper, {
	            projectType: projectType,
	            showTypeColumn: projectType === 'all',
	            showActionsColumn: true
	          })
	        )
	      );
	    }
	  }]);
	  return Projects;
	}(_react.Component), _class3.propTypes = {
	  filter: _propTypes2.default.func.isRequired,
	  initProject: _propTypes2.default.func.isRequired,
	  kw: _propTypes2.default.string,
	  permissions: _propTypes2.default.object,
	  projectType: _propTypes2.default.string,
	  pushState: _propTypes2.default.func.isRequired,
	  t: _propTypes2.default.func.isRequired
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'createNewProject', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'createNewProject'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'filter', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'filter'), _class2.prototype)), _class2)) || _class) || _class) || _class);
	exports.default = Projects;
	module.exports = exports['default'];

/***/ }),
/* 2206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _isFinite = __webpack_require__(218);
	
	var _isFinite2 = _interopRequireDefault(_isFinite);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _get2 = __webpack_require__(19);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactI18next = __webpack_require__(12);
	
	var _quicksend = __webpack_require__(532);
	
	var _components = __webpack_require__(15);
	
	var _QuickSendRecipients = __webpack_require__(2076);
	
	var _QuickSendRecipients2 = _interopRequireDefault(_QuickSendRecipients);
	
	var _reactRouterRedux = __webpack_require__(40);
	
	var _audioplayer = __webpack_require__(83);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _projects = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1375);
	
	var QuickSendItem = (_dec = (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    boxType: ownProps.params.type,
	    loadedBoxType: state.quicksend.loadedBoxType,
	    qsId: Number(ownProps.params.qsId),
	    qsItem: (0, _quicksend.getQuickSendItem)(state, Number(ownProps.params.qsId) || 0),
	    qsList: (0, _quicksend.processQuickSends)(state)
	  };
	}, { playAlbum: _audioplayer.playAlbum, pushState: _reactRouterRedux.push }), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(QuickSendItem, _Component);
	
	  function QuickSendItem() {
	    (0, _classCallCheck3.default)(this, QuickSendItem);
	    return (0, _possibleConstructorReturn3.default)(this, (QuickSendItem.__proto__ || (0, _getPrototypeOf2.default)(QuickSendItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(QuickSendItem, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          qsId = _props.qsId,
	          pushState = _props.pushState,
	          boxType = _props.boxType;
	
	      var isHasId = !!qsId && (0, _isFinite2.default)(qsId);
	
	      if (!isHasId && !this.redirected) {
	        if (nextProps.qsList && nextProps.qsList.length && nextProps.boxType === nextProps.loadedBoxType) {
	          var redirectId = (0, _get3.default)(nextProps, ['qsList', 0, 'projectId']);
	          this.redirected = true;
	          pushState('/quick-send/' + boxType + '/' + redirectId);
	        }
	      } else if (this.redirected && isHasId) {
	        this.redirected = false;
	      }
	    }
	  }, {
	    key: 'playAll',
	    value: function playAll() {
	      var album = this.props.qsItem;
	
	      this.props.playAlbum({ album: album, tracks: album.tracks });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          t = _props2.t,
	          qsId = _props2.qsId,
	          qsItem = _props2.qsItem,
	          boxType = _props2.boxType,
	          loadedBoxType = _props2.loadedBoxType;
	
	      var tracks = qsItem.tracks;
	      var isHasTracks = !!(tracks && tracks.length);
	      var checkedTracksArr = tracks.map(function (track) {
	        return track.track_number;
	      });
	      var isCanReply = boxType === _projects.quickSendBox.inbox && !!qsItem.recipient_id;
	
	      if (!qsId || boxType !== loadedBoxType) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.item },
	        _react2.default.createElement(
	          'div',
	          { className: styles.subject },
	          qsItem.subject,
	          isCanReply && _react2.default.createElement(_components.QuickSendReplyButton, { contentKey: qsItem.contentKey, senderName: qsItem.owName })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.fromInfo },
	          _react2.default.createElement(
	            'div',
	            null,
	            qsItem.owName
	          ),
	          qsItem.label_name && _react2.default.createElement(
	            'div',
	            null,
	            t('from {{company}}', { company: qsItem.label_name })
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            qsItem.sentDateTimeText
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.message, hidden: !qsItem.message },
	          qsItem.message
	        ),
	        _react2.default.createElement(_QuickSendRecipients2.default, { recipients: qsItem.recipients }),
	        _react2.default.createElement(
	          'div',
	          { className: styles.playlist },
	          isHasTracks && _react2.default.createElement(_components.QuickSendTracklist, { tracks: tracks, album: qsItem, playable: boxType === _projects.quickSendBox.inbox })
	        ),
	        isHasTracks && boxType === _projects.quickSendBox.inbox && _react2.default.createElement(
	          'div',
	          { className: 'text-right margin-bottom-20' },
	          _react2.default.createElement(
	            'button',
	            { type: 'button', className: 'btn btn-primary wide margin-top-10', onClick: this.playAll },
	            t('Play all')
	          ),
	          !!qsItem.downloadable && _react2.default.createElement(_components.DownloadTracksButton, {
	            className: 'wide margin-top-10 margin-left-10',
	            format: 'mp3',
	            tracksNumbers: checkedTracksArr,
	            contentKey: qsItem.contentKey
	          })
	        ),
	        boxType === _projects.quickSendBox.inbox && _react2.default.createElement(
	          'div',
	          { className: 'hint small' },
	          qsItem.legalNotice
	        )
	      );
	    }
	  }]);
	  return QuickSendItem;
	}(_react.Component), _class3.propTypes = {
	  boxType: _propTypes2.default.string,
	  loadedBoxType: _propTypes2.default.string,
	  playAlbum: _propTypes2.default.func,
	  pushState: _propTypes2.default.func,
	  qsId: _propTypes2.default.number,
	  qsItem: _propTypes2.default.object,
	  qsList: _propTypes2.default.array,
	  t: _propTypes2.default.func
	}, _class3.defaultProps = {
	  qsListActionData: {}
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'playAll', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'playAll'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = QuickSendItem;
	module.exports = exports['default'];

/***/ }),
/* 2207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get3 = __webpack_require__(19);
	
	var _get4 = _interopRequireDefault(_get3);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(55);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reduxConnect = __webpack_require__(33);
	
	var _quicksend = __webpack_require__(156);
	
	var quickSendActions = _interopRequireWildcard(_quicksend);
	
	var _components = __webpack_require__(15);
	
	var _project = __webpack_require__(37);
	
	var _contacts = __webpack_require__(61);
	
	var _asyncPromise = __webpack_require__(43);
	
	var _asyncPromise2 = _interopRequireDefault(_asyncPromise);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1376);
	
	var QuickSendNew = (_dec = (0, _reduxConnect.asyncConnect)([{
	  promise: function promise(_ref) {
	    var dispatch = _ref.store.dispatch;
	
	    dispatch((0, _project.initProject)());
	    dispatch((0, _project.initSubmittedFiles)());
	    dispatch((0, _contacts.loadGroups)());
	    return (0, _asyncPromise2.default)(dispatch(quickSendActions.qsCreate()).promise);
	  }
	}]), _dec2 = (0, _reactRedux.connect)(function (state) {
	  return {
	    projectId: (0, _get4.default)(state.quicksend, 'qsCreateData.projectId', 0),
	    qsCreateLoadError: state.quicksend.qsCreateLoadError,
	    qsCreateLoading: state.quicksend.qsCreateLoading
	  };
	}, (0, _extends3.default)({}, quickSendActions)), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(QuickSendNew, _Component);
	
	  function QuickSendNew() {
	    (0, _classCallCheck3.default)(this, QuickSendNew);
	    return (0, _possibleConstructorReturn3.default)(this, (QuickSendNew.__proto__ || (0, _getPrototypeOf2.default)(QuickSendNew)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(QuickSendNew, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          qsCreateLoading = _props.qsCreateLoading,
	          qsCreateLoadError = _props.qsCreateLoadError,
	          projectId = _props.projectId;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.page },
	        _react2.default.createElement(_reactHelmet2.default, { title: 'Create Quick Send' }),
	        _react2.default.createElement(
	          'div',
	          { className: styles.container },
	          _react2.default.createElement(
	            'div',
	            { className: styles.content },
	            qsCreateLoading ? _react2.default.createElement(_components.Loader, null) : qsCreateLoadError ? _react2.default.createElement(
	              'div',
	              { className: 'error' },
	              qsCreateLoadError.msg
	            ) : _react2.default.createElement(_components.QuickSendForm, { projectId: projectId })
	          )
	        )
	      );
	    }
	  }]);
	  return QuickSendNew;
	}(_react.Component), _class2.propTypes = {
	  projectId: _propTypes2.default.number,
	  qsCreateLoadError: _propTypes2.default.object,
	  qsCreateLoading: _propTypes2.default.bool
	}, _temp)) || _class) || _class);
	exports.default = QuickSendNew;
	module.exports = exports['default'];

/***/ }),
/* 2208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _find3 = __webpack_require__(95);
	
	var _find4 = _interopRequireDefault(_find3);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(55);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reduxConnect = __webpack_require__(33);
	
	var _reactRedux = __webpack_require__(11);
	
	var _components = __webpack_require__(15);
	
	var _quicksend = __webpack_require__(156);
	
	var quickSendActions = _interopRequireWildcard(_quicksend);
	
	var _quicksend2 = __webpack_require__(532);
	
	var _reactRouterRedux = __webpack_require__(40);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _asyncPromise = __webpack_require__(43);
	
	var _asyncPromise2 = _interopRequireDefault(_asyncPromise);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1377);
	
	var QuickSends = (_dec = (0, _reduxConnect.asyncConnect)([{
	  promise: function promise(_ref) {
	    var _ref$store = _ref.store,
	        dispatch = _ref$store.dispatch,
	        getState = _ref$store.getState,
	        type = _ref.params.type;
	
	    if (!quickSendActions.isLoaded(type, getState())) {
	      return (0, _asyncPromise2.default)(dispatch(quickSendActions.loadBox(type)).promise);
	    }
	  }
	}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    boxType: ownProps.params.type,
	    boxView: state.quicksend.boxView,
	    loadedBoxType: state.quicksend.loadedBoxType,
	    qsId: Number(ownProps.params.qsId),
	    qsList: (0, _quicksend2.processQuickSends)(state),
	    qsListLoading: state.quicksend.qsListLoading
	  };
	}, (0, _extends3.default)({}, quickSendActions, { pushState: _reactRouterRedux.push })), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(QuickSends, _Component);
	
	  function QuickSends() {
	    (0, _classCallCheck3.default)(this, QuickSends);
	    return (0, _possibleConstructorReturn3.default)(this, (QuickSends.__proto__ || (0, _getPrototypeOf2.default)(QuickSends)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(QuickSends, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.toggleBoxView('box');
	    }
	  }, {
	    key: 'onDelete',
	    value: function onDelete() {
	      var _props = this.props,
	          pushState = _props.pushState,
	          boxType = _props.boxType;
	
	      pushState('/quick-send/' + boxType);
	    }
	  }, {
	    key: 'onRefresh',
	    value: function onRefresh() {
	      var _props2 = this.props,
	          pushState = _props2.pushState,
	          boxType = _props2.boxType,
	          qsList = _props2.qsList,
	          qsId = _props2.qsId;
	
	      if (!(0, _find4.default)(qsList, { projectId: qsId })) {
	        pushState('/quick-send/' + boxType);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          mainChild = _props3.mainChild,
	          boxType = _props3.boxType,
	          qsListLoading = _props3.qsListLoading,
	          qsList = _props3.qsList,
	          qsId = _props3.qsId,
	          boxView = _props3.boxView,
	          loadedBoxType = _props3.loadedBoxType;
	
	      var isBoxLoaded = loadedBoxType === boxType;
	      var isLoading = qsListLoading || !isBoxLoaded;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactHelmet2.default, { title: 'Quick Send' }),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('container-fluid', styles.container, (0, _defineProperty3.default)({}, styles.showItem, boxView === 'item')) },
	          _react2.default.createElement(
	            'div',
	            { className: styles.boxSection },
	            _react2.default.createElement(_components.QuickSendBoxTabs, { active: boxType }),
	            _react2.default.createElement(
	              'div',
	              { className: styles.boxContainer },
	              isBoxLoaded && _react2.default.createElement(_components.QuickSendList, {
	                items: qsList,
	                activeId: qsId,
	                boxType: boxType
	              }),
	              isLoading && _react2.default.createElement(_components.Loader, { mask: true })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: styles.viewSection },
	            _react2.default.createElement(_components.QuickSendActions, {
	              boxType: boxType,
	              qsId: qsId,
	              onDelete: this.onDelete,
	              onRefresh: this.onRefresh
	            }),
	            mainChild
	          )
	        )
	      );
	    }
	  }]);
	  return QuickSends;
	}(_react.Component), _class3.propTypes = {
	  boxType: _propTypes2.default.string,
	  boxView: _propTypes2.default.string,
	  loadedBoxType: _propTypes2.default.string,
	  mainChild: _propTypes2.default.object.isRequired,
	  pushState: _propTypes2.default.func,
	  qsId: _propTypes2.default.number,
	  qsList: _propTypes2.default.array,
	  qsListLoading: _propTypes2.default.bool,
	  toggleBoxView: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onDelete', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onDelete'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onRefresh', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onRefresh'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = QuickSends;
	module.exports = exports['default'];

/***/ }),
/* 2209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1378);
	
	var Service = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(Service, _Component);
	
	  function Service() {
	    (0, _classCallCheck3.default)(this, Service);
	    return (0, _possibleConstructorReturn3.default)(this, (Service.__proto__ || (0, _getPrototypeOf2.default)(Service)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Service, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: styles.service },
	        this.props.mainChild
	      );
	    }
	  }]);
	  return Service;
	}(_react.Component), _class.propTypes = {
	  mainChild: _propTypes2.default.object.isRequired
	}, _temp);
	exports.default = Service;
	module.exports = exports['default'];

/***/ }),
/* 2210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _statistics = __webpack_require__(57);
	
	var statisticsActions = _interopRequireWildcard(_statistics);
	
	var _CoverageRecipientsList = __webpack_require__(2111);
	
	var _CoverageRecipientsList2 = _interopRequireDefault(_CoverageRecipientsList);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _ChartNoData = __webpack_require__(519);
	
	var _ChartNoData2 = _interopRequireDefault(_ChartNoData);
	
	var _Loader = __webpack_require__(60);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var CoverageRecipientsListWrapper = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    activeOrder: state.statistics.coverageRecipientsActiveOrder,
	    order: state.statistics.coverageRecipientsOrder
	  };
	}, (0, _extends3.default)({}, statisticsActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(CoverageRecipientsListWrapper, _Component);
	
	  function CoverageRecipientsListWrapper() {
	    (0, _classCallCheck3.default)(this, CoverageRecipientsListWrapper);
	    return (0, _possibleConstructorReturn3.default)(this, (CoverageRecipientsListWrapper.__proto__ || (0, _getPrototypeOf2.default)(CoverageRecipientsListWrapper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CoverageRecipientsListWrapper, [{
	    key: 'reorder',
	    value: function reorder(name) {
	      this.props.coverageRecipientsReorder(name);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          recipients = _props.recipients,
	          activeOrder = _props.activeOrder,
	          order = _props.order,
	          columns = _props.columns,
	          loading = _props.loading,
	          showLoader = _props.showLoader,
	          projectId = _props.projectId;
	
	
	      var hasData = recipients.length;
	      if (loading) {
	        return showLoader ? _react2.default.createElement(_Loader2.default, { alignCenter: true }) : null;
	      } else if (!hasData) {
	        return _react2.default.createElement(_ChartNoData2.default, { className: 'padding-10' });
	      }
	
	      return _react2.default.createElement(_CoverageRecipientsList2.default, {
	        className: className,
	        columns: columns,
	        recipients: recipients,
	        activeOrder: activeOrder,
	        order: order,
	        onReorder: this.reorder,
	        projectId: projectId
	      });
	    }
	  }]);
	  return CoverageRecipientsListWrapper;
	}(_react.Component), _class3.propTypes = {
	  activeOrder: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  columns: _propTypes2.default.array,
	  coverageRecipientsReorder: _propTypes2.default.func,
	  loading: _propTypes2.default.bool,
	  order: _propTypes2.default.object,
	  projectId: _propTypes2.default.number,
	  recipients: _propTypes2.default.array,
	  showLoader: _propTypes2.default.bool
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'reorder', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'reorder'), _class2.prototype)), _class2)) || _class);
	exports.default = CoverageRecipientsListWrapper;
	module.exports = exports['default'];

/***/ }),
/* 2211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduxConnect = __webpack_require__(33);
	
	var _asyncPromise = __webpack_require__(43);
	
	var _asyncPromise2 = _interopRequireDefault(_asyncPromise);
	
	var _reactRedux = __webpack_require__(11);
	
	var _statistics = __webpack_require__(57);
	
	var statisticsActions = _interopRequireWildcard(_statistics);
	
	var _statistics2 = __webpack_require__(126);
	
	var _statistics3 = __webpack_require__(67);
	
	var _Panel = __webpack_require__(352);
	
	var _Panel2 = _interopRequireDefault(_Panel);
	
	var _DevicesChart = __webpack_require__(520);
	
	var _DevicesChart2 = _interopRequireDefault(_DevicesChart);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1379);
	
	var DevicesStatistics = (_dec = (0, _reduxConnect.asyncConnect)([{
	  promise: function promise(_ref) {
	    var dispatch = _ref.store.dispatch;
	    return (0, _asyncPromise2.default)(dispatch(statisticsActions.loadDevicesStats()).promise);
	  }
	}]), _dec2 = (0, _reactRedux.connect)(function (state) {
	  return {
	    devicesData: (0, _statistics2.getDevicesData)(state, true),
	    devicesStatsLoading: state.statistics.devicesStatsLoading,
	    endDate: state.statistics.endDate,
	    startDate: state.statistics.startDate
	  };
	}, (0, _extends3.default)({}, statisticsActions)), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(DevicesStatistics, _Component);
	
	  function DevicesStatistics() {
	    (0, _classCallCheck3.default)(this, DevicesStatistics);
	    return (0, _possibleConstructorReturn3.default)(this, (DevicesStatistics.__proto__ || (0, _getPrototypeOf2.default)(DevicesStatistics)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(DevicesStatistics, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var startDate = nextProps.startDate,
	          endDate = nextProps.endDate;
	
	      if (startDate !== this.props.startDate || endDate !== this.props.endDate) {
	        if (startDate && endDate) {
	          this.props.loadDevicesStats({ startDate: startDate, endDate: endDate });
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          devicesData = _props.devicesData,
	          devicesStatsLoading = _props.devicesStatsLoading;
	      var t = this.context.t;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _Panel2.default,
	          { className: styles.indent, title: t('Device Types') },
	          _react2.default.createElement(_DevicesChart2.default, {
	            loading: devicesStatsLoading,
	            id: 'globalDevicesStats',
	            data: devicesData.devices
	          })
	        ),
	        _react2.default.createElement(
	          _Panel2.default,
	          { className: styles.indent, title: t('Source Types') },
	          _react2.default.createElement(_DevicesChart2.default, {
	            loading: devicesStatsLoading,
	            id: 'globalSourcesStats',
	            data: devicesData.sources,
	            reverseColors: true
	          })
	        )
	      );
	    }
	  }]);
	  return DevicesStatistics;
	}(_react.Component), _class2.propTypes = {
	  devicesData: _propTypes2.default.object,
	  devicesStatsLoading: _propTypes2.default.bool,
	  endDate: _propTypes2.default.string,
	  loadDevicesStats: _propTypes2.default.func,
	  startDate: _propTypes2.default.string
	}, _class2.contextTypes = {
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  devicesData: _statistics3.defaultDevicesData,
	  devicesStatsLoading: false
	}, _temp)) || _class) || _class);
	exports.default = DevicesStatistics;
	module.exports = exports['default'];

/***/ }),
/* 2212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduxConnect = __webpack_require__(33);
	
	var _asyncPromise = __webpack_require__(43);
	
	var _asyncPromise2 = _interopRequireDefault(_asyncPromise);
	
	var _reactRedux = __webpack_require__(11);
	
	var _statistics = __webpack_require__(57);
	
	var statisticsActions = _interopRequireWildcard(_statistics);
	
	var _statistics2 = __webpack_require__(126);
	
	var _Loader = __webpack_require__(60);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _TrackDetailsStatistics = __webpack_require__(2129);
	
	var _TrackDetailsStatistics2 = _interopRequireDefault(_TrackDetailsStatistics);
	
	var _StatisticsRecipientBackButton = __webpack_require__(850);
	
	var _StatisticsRecipientBackButton2 = _interopRequireDefault(_StatisticsRecipientBackButton);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1380);
	
	var ProjectDetailsStatistics = (_dec = (0, _reduxConnect.asyncConnect)([{
	  promise: function promise(_ref) {
	    var dispatch = _ref.store.dispatch,
	        projectId = _ref.params.projectId;
	    return (0, _asyncPromise2.default)(dispatch(statisticsActions.loadTracksDetailsStats({ projectId: Number(projectId) })).promise);
	  }
	}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    endDate: state.statistics.endDate,
	    projectId: Number(ownProps.params.projectId),
	    startDate: state.statistics.startDate,
	    tracksDetailsData: (0, _statistics2.getTracksDetailsData)(state),
	    tracksDetailsLoading: state.statistics.tracksDetailsStatsLoading
	  };
	}, (0, _extends3.default)({}, statisticsActions)), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(ProjectDetailsStatistics, _Component);
	
	  function ProjectDetailsStatistics() {
	    (0, _classCallCheck3.default)(this, ProjectDetailsStatistics);
	    return (0, _possibleConstructorReturn3.default)(this, (ProjectDetailsStatistics.__proto__ || (0, _getPrototypeOf2.default)(ProjectDetailsStatistics)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProjectDetailsStatistics, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var projectId = nextProps.projectId,
	          startDate = nextProps.startDate,
	          endDate = nextProps.endDate;
	
	      var isDateChanged = startDate !== this.props.startDate || endDate !== this.props.endDate;
	      if (isDateChanged && startDate && endDate) {
	        this.props.loadTracksDetailsStats({ projectId: projectId, startDate: startDate, endDate: endDate });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          projectId = _props.projectId,
	          tracksDetailsData = _props.tracksDetailsData,
	          tracksDetailsLoading = _props.tracksDetailsLoading;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.newComponent },
	        _react2.default.createElement(_StatisticsRecipientBackButton2.default, { referrer: 'project', projectId: projectId }),
	        _react2.default.createElement(_Loader2.default, { show: tracksDetailsLoading, alignCenter: true }),
	        tracksDetailsData.map(function (trackDetails) {
	          return _react2.default.createElement(_TrackDetailsStatistics2.default, { key: trackDetails.trackId, data: trackDetails });
	        })
	      );
	    }
	  }]);
	  return ProjectDetailsStatistics;
	}(_react.Component), _class2.propTypes = {
	  endDate: _propTypes2.default.string,
	  loadTracksDetailsStats: _propTypes2.default.func,
	  projectId: _propTypes2.default.number,
	  startDate: _propTypes2.default.string,
	  tracksDetailsData: _propTypes2.default.array,
	  tracksDetailsLoading: _propTypes2.default.bool
	}, _class2.contextTypes = {
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  tracksDetailsData: []
	}, _temp)) || _class) || _class);
	exports.default = ProjectDetailsStatistics;
	module.exports = exports['default'];

/***/ }),
/* 2213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _defineProperty2 = __webpack_require__(18);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduxConnect = __webpack_require__(33);
	
	var _asyncPromise = __webpack_require__(43);
	
	var _asyncPromise2 = _interopRequireDefault(_asyncPromise);
	
	var _reactRedux = __webpack_require__(11);
	
	var _statistics = __webpack_require__(57);
	
	var statisticsActions = _interopRequireWildcard(_statistics);
	
	var _statistics2 = __webpack_require__(126);
	
	var _PopularityChart = __webpack_require__(847);
	
	var _PopularityChart2 = _interopRequireDefault(_PopularityChart);
	
	var _statistics3 = __webpack_require__(67);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _RecipientStatisticsTabs = __webpack_require__(2121);
	
	var _RecipientStatisticsTabs2 = _interopRequireDefault(_RecipientStatisticsTabs);
	
	var _SimpleTabContent = __webpack_require__(846);
	
	var _SimpleTabContent2 = _interopRequireDefault(_SimpleTabContent);
	
	var _RecipientDetailedStatsList = __webpack_require__(2116);
	
	var _RecipientDetailedStatsList2 = _interopRequireDefault(_RecipientDetailedStatsList);
	
	var _StatisticsSelectedRecipientInfo = __webpack_require__(852);
	
	var _StatisticsSelectedRecipientInfo2 = _interopRequireDefault(_StatisticsSelectedRecipientInfo);
	
	var _network = __webpack_require__(528);
	
	var _StatisticsRecipientBackButton = __webpack_require__(850);
	
	var _StatisticsRecipientBackButton2 = _interopRequireDefault(_StatisticsRecipientBackButton);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _StatisticsSelectedProjectInfo = __webpack_require__(851);
	
	var _StatisticsSelectedProjectInfo2 = _interopRequireDefault(_StatisticsSelectedProjectInfo);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1381);
	
	var ProjectRecipientStatistics = (_dec = (0, _reduxConnect.asyncConnect)([{
	  promise: function promise(_ref) {
	    var dispatch = _ref.store.dispatch,
	        _ref$params = _ref.params,
	        projectId = _ref$params.projectId,
	        recipientId = _ref$params.recipientId;
	    return (0, _asyncPromise2.default)(dispatch(statisticsActions.loadPopularityStats({ projectId: projectId, recipientId: recipientId })).promise);
	  }
	}, {
	  promise: function promise(_ref2) {
	    var dispatch = _ref2.store.dispatch,
	        _ref2$params = _ref2.params,
	        projectId = _ref2$params.projectId,
	        recipientId = _ref2$params.recipientId;
	    return (0, _asyncPromise2.default)(dispatch(statisticsActions.loadRecipientDetailedStats({ projectId: projectId, recipientId: recipientId })).promise);
	  }
	}, {
	  promise: function promise(_ref3) {
	    var dispatch = _ref3.store.dispatch,
	        projectId = _ref3.params.projectId;
	    return (0, _asyncPromise2.default)(dispatch(statisticsActions.loadCoverageStats({ projectId: projectId })).promise);
	  }
	}, {
	  promise: function promise(_ref4) {
	    var dispatch = _ref4.store.dispatch,
	        projectId = _ref4.params.projectId;
	    return (0, _asyncPromise2.default)(dispatch(statisticsActions.loadProjectInfo({ projectId: Number(projectId) })).promise);
	  }
	}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    endDate: state.statistics.endDate,
	    detailedData: (0, _statistics2.getRecipientDetailedData)(state),
	    popularityData: (0, _statistics2.getPopularityData)(state, true),
	    popularityLoading: state.statistics.popularityStatsLoading,
	    projectId: Number(ownProps.params.projectId),
	    projectInfo: (0, _statistics2.getProjectInfo)(state),
	    projectInfoLoading: state.statistics.projectInfoLoading,
	    detailedLoading: state.statistics.recipientDetailedStatsLoading,
	    recipient: (0, _statistics2.getCoverageDataRecipient)(state, Number(ownProps.params.recipientId)),
	    recipientId: Number(ownProps.params.recipientId),
	    referrer: (0, _network.getRoutesLastParam)({ routes: ownProps.routes, name: 'referrer' }),
	    referrerRecipient: Number(ownProps.location.query.referrerRecipient),
	    startDate: state.statistics.startDate
	  };
	}, (0, _extends3.default)({}, statisticsActions)), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(ProjectRecipientStatistics, _Component);
	
	  function ProjectRecipientStatistics() {
	    var _ref5;
	
	    (0, _classCallCheck3.default)(this, ProjectRecipientStatistics);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref5 = ProjectRecipientStatistics.__proto__ || (0, _getPrototypeOf2.default)(ProjectRecipientStatistics)).call.apply(_ref5, [this].concat(args)));
	
	    _this.state = { activeTab: _statistics3.recipientTabs.info };
	    return _this;
	  }
	
	  (0, _createClass3.default)(ProjectRecipientStatistics, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var projectId = nextProps.projectId,
	          recipientId = nextProps.recipientId,
	          startDate = nextProps.startDate,
	          endDate = nextProps.endDate;
	
	      var isDateChanged = startDate !== this.props.startDate || endDate !== this.props.endDate;
	      if (isDateChanged && startDate && endDate) {
	        this.props.loadPopularityStats({ projectId: projectId, recipientId: recipientId, startDate: startDate, endDate: endDate });
	        this.props.loadRecipientDetailedStats({ projectId: projectId, recipientId: recipientId, startDate: startDate, endDate: endDate });
	      }
	    }
	  }, {
	    key: 'onTabClick',
	    value: function onTabClick(tab) {
	      this.setState({ activeTab: tab });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classNames;
	
	      var _props = this.props,
	          popularityData = _props.popularityData,
	          detailedLoading = _props.detailedLoading,
	          recipient = _props.recipient,
	          detailedData = _props.detailedData,
	          popularityLoading = _props.popularityLoading,
	          referrer = _props.referrer,
	          projectId = _props.projectId,
	          recipientId = _props.recipientId,
	          projectInfo = _props.projectInfo,
	          projectInfoLoading = _props.projectInfoLoading,
	          referrerRecipient = _props.referrerRecipient;
	      var activeTab = this.state.activeTab;
	
	      var isInfoTab = activeTab === _statistics3.recipientTabs.info;
	      var isDetailedTab = activeTab === _statistics3.recipientTabs.detailed;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_StatisticsRecipientBackButton2.default, {
	          referrer: referrer,
	          projectId: projectId,
	          recipientId: referrerRecipient || recipientId
	        }),
	        referrer !== 'recipient' && _react2.default.createElement(_StatisticsSelectedRecipientInfo2.default, {
	          className: 'margin-bottom-20',
	          loading: detailedLoading,
	          recipient: recipient
	        }),
	        referrer !== 'project' && _react2.default.createElement(_StatisticsSelectedProjectInfo2.default, {
	          className: 'margin-bottom-20',
	          project: projectInfo,
	          loading: projectInfoLoading
	        }),
	        _react2.default.createElement(_RecipientStatisticsTabs2.default, {
	          activeTab: activeTab,
	          tabClass: styles.tab,
	          onClick: this.onTabClick
	        }),
	        _react2.default.createElement(
	          _SimpleTabContent2.default,
	          { className: (0, _bind2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, styles.chartContent, isInfoTab), (0, _defineProperty3.default)(_classNames, styles.listContent, isDetailedTab), _classNames)) },
	          isInfoTab && _react2.default.createElement(_PopularityChart2.default, { data: popularityData, loading: popularityLoading }),
	          isDetailedTab && _react2.default.createElement(_RecipientDetailedStatsList2.default, { data: detailedData, loading: detailedLoading })
	        )
	      );
	    }
	  }]);
	  return ProjectRecipientStatistics;
	}(_react.Component), _class3.propTypes = {
	  detailedData: _propTypes2.default.object,
	  detailedLoading: _propTypes2.default.bool,
	  endDate: _propTypes2.default.string,
	  loadPopularityStats: _propTypes2.default.func,
	  loadRecipientDetailedStats: _propTypes2.default.func,
	  popularityData: _propTypes2.default.array,
	  popularityLoading: _propTypes2.default.bool,
	  projectId: _propTypes2.default.number,
	  projectInfo: _propTypes2.default.object,
	  projectInfoLoading: _propTypes2.default.bool,
	  recipient: _propTypes2.default.object,
	  recipientId: _propTypes2.default.number,
	  referrer: _propTypes2.default.string,
	  referrerRecipient: _propTypes2.default.number,
	  startDate: _propTypes2.default.string
	}, _class3.contextTypes = {
	  t: _propTypes2.default.func
	}, _class3.defaultProps = {
	  coverageData: {},
	  detailedData: _statistics3.defaultDetailedData,
	  popularityData: [],
	  recipient: {}
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onTabClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onTabClick'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = ProjectRecipientStatistics;
	module.exports = exports['default'];

/***/ }),
/* 2214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduxConnect = __webpack_require__(33);
	
	var _asyncPromise = __webpack_require__(43);
	
	var _asyncPromise2 = _interopRequireDefault(_asyncPromise);
	
	var _reactRedux = __webpack_require__(11);
	
	var _statistics = __webpack_require__(57);
	
	var statisticsActions = _interopRequireWildcard(_statistics);
	
	var _statistics2 = __webpack_require__(126);
	
	var _StatisticsSelectedProjectInfo = __webpack_require__(851);
	
	var _StatisticsSelectedProjectInfo2 = _interopRequireDefault(_StatisticsSelectedProjectInfo);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectStatistics = (_dec = (0, _reduxConnect.asyncConnect)([{
	  promise: function promise(_ref) {
	    var dispatch = _ref.store.dispatch,
	        projectId = _ref.params.projectId;
	    return (0, _asyncPromise2.default)(dispatch(statisticsActions.loadProjectInfo({ projectId: Number(projectId) })).promise);
	  }
	}, {
	  promise: function promise(_ref2) {
	    var dispatch = _ref2.store.dispatch,
	        projectId = _ref2.params.projectId;
	    return dispatch(statisticsActions.setProjectId({ projectId: Number(projectId) }));
	  }
	}]), _dec2 = (0, _reactRedux.connect)(function (state) {
	  return {
	    projectInfo: (0, _statistics2.getProjectInfo)(state),
	    projectInfoLoading: state.statistics.projectInfoLoading
	  };
	}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(ProjectStatistics, _Component);
	
	  function ProjectStatistics() {
	    (0, _classCallCheck3.default)(this, ProjectStatistics);
	    return (0, _possibleConstructorReturn3.default)(this, (ProjectStatistics.__proto__ || (0, _getPrototypeOf2.default)(ProjectStatistics)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProjectStatistics, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          projectInfo = _props.projectInfo,
	          projectInfoLoading = _props.projectInfoLoading,
	          component = _props.component;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_StatisticsSelectedProjectInfo2.default, {
	          project: projectInfo,
	          loading: projectInfoLoading,
	          showChangeButton: true
	        }),
	        component
	      );
	    }
	  }]);
	  return ProjectStatistics;
	}(_react.Component), _class2.propTypes = {
	  component: _propTypes2.default.node,
	  projectInfo: _propTypes2.default.object,
	  projectInfoLoading: _propTypes2.default.bool
	}, _class2.defaultProps = {
	  projectInfo: {}
	}, _temp)) || _class) || _class);
	exports.default = ProjectStatistics;
	module.exports = exports['default'];

/***/ }),
/* 2215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduxConnect = __webpack_require__(33);
	
	var _asyncPromise = __webpack_require__(43);
	
	var _asyncPromise2 = _interopRequireDefault(_asyncPromise);
	
	var _reactRedux = __webpack_require__(11);
	
	var _statistics = __webpack_require__(57);
	
	var statisticsActions = _interopRequireWildcard(_statistics);
	
	var _Panel = __webpack_require__(352);
	
	var _Panel2 = _interopRequireDefault(_Panel);
	
	var _PopularityChart = __webpack_require__(847);
	
	var _PopularityChart2 = _interopRequireDefault(_PopularityChart);
	
	var _statistics2 = __webpack_require__(126);
	
	var _StatisticsCoverage = __webpack_require__(2122);
	
	var _StatisticsCoverage2 = _interopRequireDefault(_StatisticsCoverage);
	
	var _GeographyChartTypeWrapper = __webpack_require__(2113);
	
	var _GeographyChartTypeWrapper2 = _interopRequireDefault(_GeographyChartTypeWrapper);
	
	var _DevicesChart = __webpack_require__(520);
	
	var _DevicesChart2 = _interopRequireDefault(_DevicesChart);
	
	var _statistics3 = __webpack_require__(67);
	
	var _PlayStatsChart = __webpack_require__(521);
	
	var _PlayStatsChart2 = _interopRequireDefault(_PlayStatsChart);
	
	var _StatisticsTracksDetailsLink = __webpack_require__(2128);
	
	var _StatisticsTracksDetailsLink2 = _interopRequireDefault(_StatisticsTracksDetailsLink);
	
	var _StatisticsReminders = __webpack_require__(2225);
	
	var _StatisticsReminders2 = _interopRequireDefault(_StatisticsReminders);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1382);
	
	var ProjectStatisticsOverall = (_dec = (0, _reduxConnect.asyncConnect)([{
	  promise: function promise(_ref) {
	    var dispatch = _ref.store.dispatch,
	        projectId = _ref.params.projectId;
	    return (0, _asyncPromise2.default)(dispatch(statisticsActions.loadActivityStats({ projectId: projectId })).promise);
	  }
	}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    activityStatsLoading: state.statistics.activityStatsLoading,
	    coverageData: (0, _statistics2.getCoverageData)(state),
	    devicesData: (0, _statistics2.getDevicesData)(state),
	    endDate: state.statistics.endDate,
	    geographyCitiesData: (0, _statistics2.getGeographyCitiesData)(state),
	    geographyCountriesData: (0, _statistics2.getGeographyCountriesData)(state),
	    playStatsData: (0, _statistics2.getPlayStatsData)(state),
	    popularityData: (0, _statistics2.getPopularityData)(state),
	    projectId: Number(ownProps.params.projectId),
	    startDate: state.statistics.startDate
	  };
	}, (0, _extends3.default)({}, statisticsActions)), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(ProjectStatisticsOverall, _Component);
	
	  function ProjectStatisticsOverall() {
	    (0, _classCallCheck3.default)(this, ProjectStatisticsOverall);
	    return (0, _possibleConstructorReturn3.default)(this, (ProjectStatisticsOverall.__proto__ || (0, _getPrototypeOf2.default)(ProjectStatisticsOverall)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProjectStatisticsOverall, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var projectId = nextProps.projectId,
	          startDate = nextProps.startDate,
	          endDate = nextProps.endDate;
	
	      var isDateChanged = startDate !== this.props.startDate || endDate !== this.props.endDate;
	      if (isDateChanged && startDate && endDate) {
	        this.props.loadActivityStats({ projectId: projectId, startDate: startDate, endDate: endDate });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          popularityData = _props.popularityData,
	          coverageData = _props.coverageData,
	          geographyCountriesData = _props.geographyCountriesData,
	          geographyCitiesData = _props.geographyCitiesData,
	          devicesData = _props.devicesData,
	          projectId = _props.projectId,
	          playStatsData = _props.playStatsData;
	      var activityStatsLoading = this.props.activityStatsLoading;
	      var t = this.context.t;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: styles.indent },
	          _react2.default.createElement(
	            _Panel2.default,
	            { title: t('Recipients Statistics') },
	            _react2.default.createElement(_PlayStatsChart2.default, { data: playStatsData, loading: activityStatsLoading })
	          ),
	          _react2.default.createElement(_StatisticsTracksDetailsLink2.default, { projectId: projectId })
	        ),
	        _react2.default.createElement(
	          'h4',
	          { className: 'h4 margin-vert-20' },
	          t('Coverage')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.indent },
	          _react2.default.createElement(_StatisticsCoverage2.default, {
	            data: coverageData,
	            id: 'projectOverallCoverage',
	            loading: activityStatsLoading,
	            projectId: projectId
	          }),
	          !activityStatsLoading && _react2.default.createElement(_StatisticsReminders2.default, { projectId: projectId, className: styles.reminders })
	        ),
	        _react2.default.createElement(
	          _Panel2.default,
	          { className: styles.indent, title: t('File info') },
	          _react2.default.createElement(_PopularityChart2.default, { data: popularityData, loading: activityStatsLoading })
	        ),
	        _react2.default.createElement(
	          _Panel2.default,
	          { className: styles.indent, title: t('Geography of recipients') },
	          _react2.default.createElement(_GeographyChartTypeWrapper2.default, {
	            countriesPlaysData: geographyCountriesData.plays,
	            countriesDownloadsData: geographyCountriesData.downloads,
	            citiesPlaysData: geographyCitiesData.plays,
	            citiesDownloadsData: geographyCitiesData.downloads,
	            loading: activityStatsLoading
	          })
	        ),
	        _react2.default.createElement(
	          _Panel2.default,
	          { className: styles.indent, title: t('Device Types') },
	          _react2.default.createElement(_DevicesChart2.default, {
	            id: 'devicesStats',
	            data: devicesData.devices,
	            loading: activityStatsLoading
	          })
	        ),
	        _react2.default.createElement(
	          _Panel2.default,
	          { className: styles.indent, title: t('Source Types') },
	          _react2.default.createElement(_DevicesChart2.default, {
	            id: 'sourcesStats',
	            reverseColors: true,
	            data: devicesData.sources,
	            loading: activityStatsLoading
	          })
	        )
	      );
	    }
	  }]);
	  return ProjectStatisticsOverall;
	}(_react.Component), _class2.propTypes = {
	  activityStatsLoading: _propTypes2.default.bool,
	  coverageData: _propTypes2.default.object,
	  devicesData: _propTypes2.default.object,
	  endDate: _propTypes2.default.string,
	  geographyCitiesData: _propTypes2.default.object,
	  geographyCountriesData: _propTypes2.default.object,
	  loadActivityStats: _propTypes2.default.func,
	  playStatsData: _propTypes2.default.array,
	  popularityData: _propTypes2.default.array,
	  projectId: _propTypes2.default.number,
	  startDate: _propTypes2.default.string
	}, _class2.contextTypes = {
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  coverageData: {},
	  devicesData: _statistics3.defaultDevicesData,
	  geographyCitiesData: _statistics3.defaultGeographyData,
	  geographyCountriesData: _statistics3.defaultGeographyData,
	  playStatsData: [],
	  popularityData: [],
	  projectInfo: {}
	}, _temp)) || _class) || _class);
	exports.default = ProjectStatisticsOverall;
	module.exports = exports['default'];

/***/ }),
/* 2216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduxConnect = __webpack_require__(33);
	
	var _asyncPromise = __webpack_require__(43);
	
	var _asyncPromise2 = _interopRequireDefault(_asyncPromise);
	
	var _reactRedux = __webpack_require__(11);
	
	var _statistics = __webpack_require__(57);
	
	var statisticsActions = _interopRequireWildcard(_statistics);
	
	var _StatisticsSelectedRecipientInfo = __webpack_require__(852);
	
	var _StatisticsSelectedRecipientInfo2 = _interopRequireDefault(_StatisticsSelectedRecipientInfo);
	
	var _statistics2 = __webpack_require__(126);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RecipientStatistics = (_dec = (0, _reduxConnect.asyncConnect)([{
	  promise: function promise(_ref) {
	    var dispatch = _ref.store.dispatch;
	    return (0, _asyncPromise2.default)(dispatch(statisticsActions.loadRecipients()).promise);
	  }
	}, {
	  promise: function promise(_ref2) {
	    var dispatch = _ref2.store.dispatch,
	        recipientId = _ref2.params.recipientId,
	        referrerRecipient = _ref2.location.query.referrerRecipient;
	    return dispatch(statisticsActions.setRecipientId({ recipientId: Number(referrerRecipient || recipientId) }));
	  }
	}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    recipientInfo: (0, _statistics2.getRecipientFromList)(state, Number(ownProps.location.query.referrerRecipient || ownProps.params.recipientId)),
	    recipientInfoLoading: state.statistics.coverageStatsLoading
	  };
	}, (0, _extends3.default)({}, statisticsActions)), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(RecipientStatistics, _Component);
	
	  function RecipientStatistics() {
	    (0, _classCallCheck3.default)(this, RecipientStatistics);
	    return (0, _possibleConstructorReturn3.default)(this, (RecipientStatistics.__proto__ || (0, _getPrototypeOf2.default)(RecipientStatistics)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(RecipientStatistics, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          component = _props.component,
	          recipientInfo = _props.recipientInfo,
	          recipientInfoLoading = _props.recipientInfoLoading;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_StatisticsSelectedRecipientInfo2.default, {
	          recipient: recipientInfo,
	          loading: recipientInfoLoading,
	          showChangeButton: true
	        }),
	        component
	      );
	    }
	  }]);
	  return RecipientStatistics;
	}(_react.Component), _class2.propTypes = {
	  component: _propTypes2.default.node,
	  recipientInfo: _propTypes2.default.object,
	  recipientInfoLoading: _propTypes2.default.bool
	}, _class2.defaultProps = {
	  recipientInfo: {}
	}, _temp)) || _class) || _class);
	exports.default = RecipientStatistics;
	module.exports = exports['default'];

/***/ }),
/* 2217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduxConnect = __webpack_require__(33);
	
	var _asyncPromise = __webpack_require__(43);
	
	var _asyncPromise2 = _interopRequireDefault(_asyncPromise);
	
	var _reactRedux = __webpack_require__(11);
	
	var _statistics = __webpack_require__(57);
	
	var statisticsActions = _interopRequireWildcard(_statistics);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _statistics2 = __webpack_require__(126);
	
	var _Panel = __webpack_require__(352);
	
	var _Panel2 = _interopRequireDefault(_Panel);
	
	var _DevicesChart = __webpack_require__(520);
	
	var _DevicesChart2 = _interopRequireDefault(_DevicesChart);
	
	var _StatisticsRecipientProjectsList = __webpack_require__(2222);
	
	var _StatisticsRecipientProjectsList2 = _interopRequireDefault(_StatisticsRecipientProjectsList);
	
	var _PlayStatsChart = __webpack_require__(521);
	
	var _PlayStatsChart2 = _interopRequireDefault(_PlayStatsChart);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = __webpack_require__(1383);
	
	var RecipientStatisticsOverall = (_dec = (0, _reduxConnect.asyncConnect)([{
	  promise: function promise(_ref) {
	    var dispatch = _ref.store.dispatch,
	        recipientId = _ref.params.recipientId;
	    return (0, _asyncPromise2.default)(dispatch(statisticsActions.loadRecipientOverallStats({ userId: recipientId })).promise);
	  }
	}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    endDate: state.statistics.endDate,
	    globalStatsData: (0, _statistics2.getRecipientGlobalData)(state),
	    playStatsData: (0, _statistics2.getRecipientPlayStats)(state),
	    projects: (0, _statistics2.getRecipientProjects)(state),
	    recipientId: Number(ownProps.params.recipientId),
	    recipientStatsLoading: state.statistics.recipientOverallStatsLoading,
	    startDate: state.statistics.startDate
	  };
	}, (0, _extends3.default)({}, statisticsActions)), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(RecipientStatisticsOverall, _Component);
	
	  function RecipientStatisticsOverall() {
	    (0, _classCallCheck3.default)(this, RecipientStatisticsOverall);
	    return (0, _possibleConstructorReturn3.default)(this, (RecipientStatisticsOverall.__proto__ || (0, _getPrototypeOf2.default)(RecipientStatisticsOverall)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(RecipientStatisticsOverall, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var userId = nextProps.recipientId,
	          startDate = nextProps.startDate,
	          endDate = nextProps.endDate;
	
	      var isDateChanged = startDate !== this.props.startDate || endDate !== this.props.endDate;
	      if (isDateChanged && startDate && endDate) {
	        this.props.loadRecipientOverallStats({ userId: userId, startDate: startDate, endDate: endDate });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          recipientStatsLoading = _props.recipientStatsLoading,
	          globalStatsData = _props.globalStatsData,
	          projects = _props.projects,
	          recipientId = _props.recipientId,
	          playStatsData = _props.playStatsData;
	      var t = this.context.t;
	
	      var chartOptions = { vAxis: { title: t('Number of plays / downloads') } };
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(styles.newComponent) },
	        _react2.default.createElement(
	          _Panel2.default,
	          { className: styles.indent, title: t('Activity statistics') },
	          _react2.default.createElement(_PlayStatsChart2.default, {
	            id: 'recipientPlayStats',
	            data: playStatsData,
	            loading: recipientStatsLoading,
	            chartOptions: chartOptions
	          })
	        ),
	        _react2.default.createElement(
	          _Panel2.default,
	          { className: styles.indent, title: t('Global statistics on projects') },
	          _react2.default.createElement(_DevicesChart2.default, {
	            id: 'globalRecipientStats',
	            data: globalStatsData,
	            loading: recipientStatsLoading
	          })
	        ),
	        _react2.default.createElement(
	          'h4',
	          null,
	          t('Projects list')
	        ),
	        _react2.default.createElement(_StatisticsRecipientProjectsList2.default, {
	          recipientId: recipientId,
	          projects: projects,
	          loading: recipientStatsLoading
	        })
	      );
	    }
	  }]);
	  return RecipientStatisticsOverall;
	}(_react.Component), _class2.propTypes = {
	  endDate: _propTypes2.default.string,
	  globalStatsData: _propTypes2.default.object,
	  loadRecipientOverallStats: _propTypes2.default.func,
	  playStatsData: _propTypes2.default.array,
	  projects: _propTypes2.default.array,
	  recipientId: _propTypes2.default.number,
	  recipientStatsLoading: _propTypes2.default.bool,
	  startDate: _propTypes2.default.string
	}, _class2.contextTypes = {
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  globalStatsData: {},
	  playStatsData: []
	}, _temp)) || _class) || _class);
	exports.default = RecipientStatisticsOverall;
	module.exports = exports['default'];

/***/ }),
/* 2218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reduxConnect = __webpack_require__(33);
	
	var _Page = __webpack_require__(350);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _StatisticsTabs = __webpack_require__(2127);
	
	var _StatisticsTabs2 = _interopRequireDefault(_StatisticsTabs);
	
	var _StatisticsPeriod = __webpack_require__(2124);
	
	var _StatisticsPeriod2 = _interopRequireDefault(_StatisticsPeriod);
	
	var _StatisticsDatePicker = __webpack_require__(2219);
	
	var _StatisticsDatePicker2 = _interopRequireDefault(_StatisticsDatePicker);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _statistics = __webpack_require__(57);
	
	var statisticsActions = _interopRequireWildcard(_statistics);
	
	var _statistics2 = __webpack_require__(67);
	
	var _datetime = __webpack_require__(68);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1384);
	
	var Statistics = (_dec = (0, _reduxConnect.asyncConnect)([{
	  promise: function promise(_ref) {
	    var _ref$store = _ref.store,
	        dispatch = _ref$store.dispatch,
	        getState = _ref$store.getState;
	    var _getState$statistics = getState().statistics,
	        startDate = _getState$statistics.startDate,
	        endDate = _getState$statistics.endDate;
	
	    if (!startDate || !endDate) {
	      dispatch(statisticsActions.setPeriod({ periodName: _statistics2.reportPeriods.week }));
	    }
	  }
	}]), _dec2 = (0, _reactRedux.connect)(function (state) {
	  return {
	    endDate: state.statistics.endDate,
	    startDate: state.statistics.startDate,
	    periodName: state.statistics.periodName,
	    projectId: state.statistics.projectId,
	    recipientId: state.statistics.recipientId
	  };
	}, (0, _extends3.default)({}, statisticsActions)), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(Statistics, _Component);
	
	  function Statistics() {
	    (0, _classCallCheck3.default)(this, Statistics);
	    return (0, _possibleConstructorReturn3.default)(this, (Statistics.__proto__ || (0, _getPrototypeOf2.default)(Statistics)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Statistics, [{
	    key: 'setReportDates',
	    value: function setReportDates(_ref2) {
	      var startDate = _ref2.startDate,
	          endDate = _ref2.endDate;
	
	      this.props.setReportDates({ startDate: (0, _datetime.formatDateToSql)(startDate), endDate: (0, _datetime.formatDateToSql)(endDate) });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          component = _props.component,
	          startDate = _props.startDate,
	          endDate = _props.endDate,
	          periodName = _props.periodName,
	          projectId = _props.projectId,
	          recipientId = _props.recipientId;
	      var t = this.context.t;
	
	
	      return _react2.default.createElement(
	        _Page2.default,
	        {
	          className: styles.page,
	          header: t('Statistics'),
	          title: t('Statistics'),
	          pullHeaderLeft: true
	        },
	        _react2.default.createElement(_StatisticsTabs2.default, {
	          className: 'margin-bottom-10',
	          projectId: projectId,
	          recipientId: recipientId
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: styles.periodLine },
	          _react2.default.createElement(_StatisticsPeriod2.default, null),
	          _react2.default.createElement(_StatisticsDatePicker2.default, {
	            onChange: this.setReportDates,
	            onClose: this.setReportDates,
	            endDate: endDate,
	            startDate: startDate,
	            hidden: periodName !== _statistics2.reportPeriods.custom
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clear' },
	          component
	        )
	      );
	    }
	  }]);
	  return Statistics;
	}(_react.Component), _class3.propTypes = {
	  component: _propTypes2.default.node,
	  endDate: _propTypes2.default.string,
	  periodName: _propTypes2.default.string,
	  projectId: _propTypes2.default.number,
	  recipientId: _propTypes2.default.number,
	  setReportDates: _propTypes2.default.func,
	  startDate: _propTypes2.default.string
	}, _class3.contextTypes = {
	  t: _propTypes2.default.func
	}, _class3.defaultProps = {
	  setReportDates: _noop3.default
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'setReportDates', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setReportDates'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = Statistics;
	module.exports = exports['default'];

/***/ }),
/* 2219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _desc, _value, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _DateRangePickerWrapper = __webpack_require__(1983);
	
	var _DateRangePickerWrapper2 = _interopRequireDefault(_DateRangePickerWrapper);
	
	var _isInclusivelyBeforeDay = __webpack_require__(1647);
	
	var _isInclusivelyBeforeDay2 = _interopRequireDefault(_isInclusivelyBeforeDay);
	
	var _moment = __webpack_require__(20);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var StatisticsDatePicker = (_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(StatisticsDatePicker, _PureComponent);
	
	  function StatisticsDatePicker() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, StatisticsDatePicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = StatisticsDatePicker.__proto__ || (0, _getPrototypeOf2.default)(StatisticsDatePicker)).call.apply(_ref, [this].concat(args)));
	
	    var _args$ = args[0],
	        startDate = _args$.startDate,
	        endDate = _args$.endDate;
	
	    _this.state = { startDate: startDate, endDate: endDate };
	    return _this;
	  }
	
	  (0, _createClass3.default)(StatisticsDatePicker, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var startDate = nextProps.startDate,
	          endDate = nextProps.endDate;
	
	      this.setState({ startDate: startDate, endDate: endDate });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(_ref2) {
	      var startDate = _ref2.startDate,
	          endDate = _ref2.endDate,
	          focusedInput = _ref2.focusedInput;
	
	      this.setState({ startDate: startDate, endDate: endDate });
	      if (focusedInput !== 'startDate') {
	        this.props.onChange({ startDate: startDate, endDate: endDate });
	      }
	    }
	  }, {
	    key: 'onClose',
	    value: function onClose() {
	      var onClose = this.props.onClose;
	      var _state = this.state,
	          startDate = _state.startDate,
	          endDate = _state.endDate;
	
	      onClose({ startDate: startDate, endDate: endDate });
	    }
	  }, {
	    key: 'isOutsideRange',
	    value: function isOutsideRange(day) {
	      return !(0, _isInclusivelyBeforeDay2.default)(day, (0, _moment2.default)());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          hidden = _props.hidden;
	      var t = this.context.t;
	      var _state2 = this.state,
	          endDate = _state2.endDate,
	          startDate = _state2.startDate;
	
	      if (hidden) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(_DateRangePickerWrapper2.default, {
	          className: className,
	          onChange: this.onChange,
	          showClearDates: true,
	          reopenPickerOnClearDates: true,
	          showDefaultInputIcon: true,
	          isOutsideRange: this.isOutsideRange,
	          startDate: startDate,
	          endDate: endDate,
	          onClose: this.onClose
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'hint default padding-top-5' },
	          t('Please select Start and End Date')
	        )
	      );
	    }
	  }]);
	  return StatisticsDatePicker;
	}(_react.PureComponent), _class2.propTypes = {
	  className: _propTypes2.default.string,
	  endDate: _propTypes2.default.string,
	  hidden: _propTypes2.default.bool,
	  onChange: _propTypes2.default.func,
	  onClose: _propTypes2.default.func,
	  startDate: _propTypes2.default.string
	}, _class2.contextTypes = {
	  t: _propTypes2.default.func
	}, _class2.defaultProps = {
	  onChange: _noop3.default,
	  onClose: _noop3.default
	}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onChange', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onChange'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onClose', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onClose'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isOutsideRange', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isOutsideRange'), _class.prototype)), _class);
	exports.default = StatisticsDatePicker;
	module.exports = exports['default'];

/***/ }),
/* 2220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduxConnect = __webpack_require__(33);
	
	var _asyncPromise = __webpack_require__(43);
	
	var _asyncPromise2 = _interopRequireDefault(_asyncPromise);
	
	var _reactRedux = __webpack_require__(11);
	
	var _statistics = __webpack_require__(57);
	
	var statisticsActions = _interopRequireWildcard(_statistics);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _statistics2 = __webpack_require__(126);
	
	var _StatisticsProjectsList = __webpack_require__(2221);
	
	var _StatisticsProjectsList2 = _interopRequireDefault(_StatisticsProjectsList);
	
	var _StatisticsProjectsListTabs = __webpack_require__(2125);
	
	var _StatisticsProjectsListTabs2 = _interopRequireDefault(_StatisticsProjectsListTabs);
	
	var _statistics3 = __webpack_require__(67);
	
	var _ProjectLegendLine = __webpack_require__(517);
	
	var _ProjectLegendLine2 = _interopRequireDefault(_ProjectLegendLine);
	
	var _SearchBar = __webpack_require__(183);
	
	var _SearchBar2 = _interopRequireDefault(_SearchBar);
	
	var _Pagination = __webpack_require__(351);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	var _reactScroll = __webpack_require__(251);
	
	var _reactScroll2 = _interopRequireDefault(_reactScroll);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1385);
	
	var scroll = _reactScroll2.default.animateScroll;
	
	var StatisticsProjects = (_dec = (0, _reduxConnect.asyncConnect)([{
	  promise: function promise(_ref) {
	    var dispatch = _ref.store.dispatch,
	        id = _ref.params.id;
	
	    if (id) {
	      return (0, _asyncPromise2.default)(dispatch(statisticsActions.loadReport(id)).promise);
	    }
	  }
	}, {
	  promise: function promise(_ref2) {
	    var dispatch = _ref2.store.dispatch;
	    return (0, _asyncPromise2.default)(dispatch(statisticsActions.loadRecipients()).promise);
	  }
	}, {
	  promise: function promise(_ref3) {
	    var _ref3$store = _ref3.store,
	        dispatch = _ref3$store.dispatch,
	        getState = _ref3$store.getState,
	        _ref3$location$query$ = _ref3.location.query.tab,
	        tab = _ref3$location$query$ === undefined ? _statistics3.projectTabs.my : _ref3$location$query$;
	    var activeProjectsTab = getState().report.activeProjectsTab;
	
	    if (activeProjectsTab !== tab) {
	      dispatch(statisticsActions.setProjectsTab(tab));
	      var promise = null;
	      if (tab === _statistics3.projectTabs.available) {
	        promise = dispatch(statisticsActions.loadAvailableProjects({ useCache: true })).promise;
	      } else if (tab === _statistics3.projectTabs.my) {
	        promise = dispatch(statisticsActions.loadMyProjects({ useCache: true })).promise;
	      }
	      return (0, _asyncPromise2.default)(promise);
	    }
	  }
	}]), _dec2 = (0, _reactRedux.connect)(function (state) {
	  var activeProjectsTab = state.statistics.activeProjectsTab;
	
	  var projects = [];
	  var projectsCount = 0;
	  var projectsLoading = false;
	  var page = 1;
	  if (activeProjectsTab === _statistics3.projectTabs.my) {
	    var myProjectsEntities = (0, _statistics2.getMyProjects)(state);
	    projects = myProjectsEntities.projects;
	    projectsCount = myProjectsEntities.countAll;
	    projectsLoading = state.statistics.myProjectsLoading;
	    page = state.statistics.myProjectsListPage;
	  } else if (activeProjectsTab === _statistics3.projectTabs.available) {
	    projects = (0, _statistics2.getAvailableProjects)(state);
	    projectsCount = projects.length;
	    projectsLoading = state.statistics.availableProjectsLoading;
	  }
	  return {
	    activeProjectsTab: state.statistics.activeProjectsTab,
	    availableProjects: (0, _statistics2.getAvailableProjects)(state),
	    page: page,
	    projects: projects,
	    projectsCount: projectsCount,
	    projectsLoading: projectsLoading
	  };
	}, (0, _extends3.default)({}, statisticsActions)), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(StatisticsProjects, _Component);
	
	  function StatisticsProjects() {
	    (0, _classCallCheck3.default)(this, StatisticsProjects);
	    return (0, _possibleConstructorReturn3.default)(this, (StatisticsProjects.__proto__ || (0, _getPrototypeOf2.default)(StatisticsProjects)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(StatisticsProjects, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.setProjectsTab(null);
	      this.filter('');
	    }
	  }, {
	    key: 'onPageChange',
	    value: function onPageChange(_ref4) {
	      var page = _ref4.page;
	
	      this.props.setProjectsListPage({ page: page });
	      scroll.scrollToTop();
	    }
	  }, {
	    key: 'selectProjectsTab',
	    value: function selectProjectsTab(tab) {
	      this.context.push('/statistics/project?tab=' + tab);
	    }
	  }, {
	    key: 'filter',
	    value: function filter(kw) {
	      this.props.filterProjects(kw);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          projects = _props.projects,
	          projectsLoading = _props.projectsLoading,
	          activeProjectsTab = _props.activeProjectsTab,
	          projectsCount = _props.projectsCount,
	          page = _props.page;
	      var t = this.context.t;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(className) },
	        _react2.default.createElement(
	          'div',
	          { className: styles.searchLine },
	          _react2.default.createElement(_SearchBar2.default, {
	            className: styles.searchBar,
	            inputClass: styles.searchInput,
	            onChange: this.filter
	          }),
	          _react2.default.createElement(_ProjectLegendLine2.default, { className: styles.legendLine }),
	          _react2.default.createElement(
	            'div',
	            { className: styles.searchHint },
	            t('You can search by title, project ID')
	          )
	        ),
	        _react2.default.createElement(_StatisticsProjectsListTabs2.default, {
	          activeProjectsTab: activeProjectsTab,
	          onClick: this.selectProjectsTab
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: styles.list },
	          _react2.default.createElement(_StatisticsProjectsList2.default, {
	            projects: projects,
	            projectsLoading: projectsLoading
	          })
	        ),
	        _react2.default.createElement(_Pagination2.default, {
	          className: 'text-right',
	          count: projectsCount,
	          limit: _statistics3.pageLimit,
	          page: page,
	          onChange: this.onPageChange
	        })
	      );
	    }
	  }]);
	  return StatisticsProjects;
	}(_react.Component), _class3.propTypes = {
	  activeProjectsTab: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  filterProjects: _propTypes2.default.func,
	  page: _propTypes2.default.number,
	  projects: _propTypes2.default.array,
	  projectsCount: _propTypes2.default.number,
	  projectsLoading: _propTypes2.default.bool,
	  setProjectsListPage: _propTypes2.default.func,
	  setProjectsTab: _propTypes2.default.func
	}, _class3.defaultProps = {
	  projects: [],
	  onClick: _noop3.default,
	  tab: _statistics3.projectTabs.my
	}, _class3.contextTypes = {
	  push: _propTypes2.default.func,
	  t: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onPageChange', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onPageChange'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'selectProjectsTab', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'selectProjectsTab'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'filter', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'filter'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = StatisticsProjects;
	module.exports = exports['default'];

/***/ }),
/* 2221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _ProjectsList = __webpack_require__(834);
	
	var _ProjectsList2 = _interopRequireDefault(_ProjectsList);
	
	var _statistics = __webpack_require__(57);
	
	var statisticsActions = _interopRequireWildcard(_statistics);
	
	var _auth = __webpack_require__(77);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var StatisticsProjectsList = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    activeOrder: state.statistics.projectsActiveOrder,
	    order: state.statistics.projectsOrder,
	    userPermissions: (0, _auth.getPermissions)(state)
	  };
	}, (0, _extends3.default)({}, statisticsActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(StatisticsProjectsList, _Component);
	
	  function StatisticsProjectsList() {
	    (0, _classCallCheck3.default)(this, StatisticsProjectsList);
	    return (0, _possibleConstructorReturn3.default)(this, (StatisticsProjectsList.__proto__ || (0, _getPrototypeOf2.default)(StatisticsProjectsList)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(StatisticsProjectsList, [{
	    key: 'setStatisticsProject',
	    value: function setStatisticsProject(project) {
	      var push = this.context.push;
	
	      push('/statistics/project/' + project.id);
	    }
	  }, {
	    key: 'reorder',
	    value: function reorder(name) {
	      this.props.projectsReorder(name);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          projectsLoading = _props.projectsLoading,
	          projects = _props.projects,
	          activeOrder = _props.activeOrder,
	          order = _props.order,
	          userPermissions = _props.userPermissions;
	
	
	      return _react2.default.createElement(_ProjectsList2.default, {
	        activeOrder: activeOrder,
	        order: order,
	        onReorder: this.reorder,
	        projects: projects,
	        onClick: this.setStatisticsProject,
	        loading: projectsLoading,
	        userPermissions: userPermissions
	      });
	    }
	  }]);
	  return StatisticsProjectsList;
	}(_react.Component), _class3.propTypes = {
	  activeOrder: _propTypes2.default.string,
	  order: _propTypes2.default.object,
	  projects: _propTypes2.default.array.isRequired,
	  projectsLoading: _propTypes2.default.bool,
	  projectsReorder: _propTypes2.default.func,
	  userPermissions: _propTypes2.default.object
	}, _class3.contextTypes = {
	  push: _propTypes2.default.func
	}, _class3.defaultProps = {
	  projects: [],
	  projectsLoading: false
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'setStatisticsProject', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setStatisticsProject'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'reorder', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'reorder'), _class2.prototype)), _class2)) || _class);
	exports.default = StatisticsProjectsList;
	module.exports = exports['default'];

/***/ }),
/* 2222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _statistics = __webpack_require__(57);
	
	var statisticsActions = _interopRequireWildcard(_statistics);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _Loader = __webpack_require__(60);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _List = __webpack_require__(182);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _RecipientProjectsListHeader = __webpack_require__(2119);
	
	var _RecipientProjectsListHeader2 = _interopRequireDefault(_RecipientProjectsListHeader);
	
	var _RecipientProjectsListItem = __webpack_require__(2120);
	
	var _RecipientProjectsListItem2 = _interopRequireDefault(_RecipientProjectsListItem);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var StatisticsRecipientProjectsList = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    activeOrder: state.statistics.recipientProjectsActiveOrder,
	    order: state.statistics.recipientProjectsOrder
	  };
	}, (0, _extends3.default)({}, statisticsActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(StatisticsRecipientProjectsList, _Component);
	
	  function StatisticsRecipientProjectsList() {
	    (0, _classCallCheck3.default)(this, StatisticsRecipientProjectsList);
	    return (0, _possibleConstructorReturn3.default)(this, (StatisticsRecipientProjectsList.__proto__ || (0, _getPrototypeOf2.default)(StatisticsRecipientProjectsList)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(StatisticsRecipientProjectsList, [{
	    key: 'reorder',
	    value: function reorder(name) {
	      this.props.recipientProjectsReorder(name);
	    }
	  }, {
	    key: 'goProjectStats',
	    value: function goProjectStats(project) {
	      this.context.push('/statistics/recipient/' + project.recipientId + '/project/' + project.id + '?referrerRecipient=' + this.props.recipientId);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          loading = _props.loading,
	          projects = _props.projects,
	          activeOrder = _props.activeOrder,
	          order = _props.order,
	          recipientId = _props.recipientId;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _List2.default,
	          null,
	          _react2.default.createElement(_RecipientProjectsListHeader2.default, {
	            activeOrder: activeOrder,
	            order: order,
	            onReorder: this.reorder
	          }),
	          projects.map(function (project) {
	            return _react2.default.createElement(_RecipientProjectsListItem2.default, {
	              key: project.id + '-' + project.recipientId,
	              project: project,
	              recipientId: recipientId,
	              onClick: _this2.goProjectStats
	            });
	          })
	        ),
	        _react2.default.createElement(_Loader2.default, { show: loading, alignCenter: true })
	      );
	    }
	  }]);
	  return StatisticsRecipientProjectsList;
	}(_react.Component), _class3.propTypes = {
	  activeOrder: _propTypes2.default.string,
	  loading: _propTypes2.default.bool,
	  order: _propTypes2.default.object,
	  projects: _propTypes2.default.array.isRequired,
	  recipientId: _propTypes2.default.number,
	  recipientProjectsReorder: _propTypes2.default.func
	}, _class3.defaultProps = {
	  projects: []
	}, _class3.contextTypes = {
	  push: _propTypes2.default.func
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'reorder', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'reorder'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'goProjectStats', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'goProjectStats'), _class2.prototype)), _class2)) || _class);
	exports.default = StatisticsRecipientProjectsList;
	module.exports = exports['default'];

/***/ }),
/* 2223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduxConnect = __webpack_require__(33);
	
	var _asyncPromise = __webpack_require__(43);
	
	var _asyncPromise2 = _interopRequireDefault(_asyncPromise);
	
	var _reactRedux = __webpack_require__(11);
	
	var _statistics = __webpack_require__(57);
	
	var statisticsActions = _interopRequireWildcard(_statistics);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _SearchBar = __webpack_require__(183);
	
	var _SearchBar2 = _interopRequireDefault(_SearchBar);
	
	var _StatisticsRecipientsList = __webpack_require__(2224);
	
	var _StatisticsRecipientsList2 = _interopRequireDefault(_StatisticsRecipientsList);
	
	var _statistics2 = __webpack_require__(126);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1386);
	
	var StatisticsRecipients = (_dec = (0, _reduxConnect.asyncConnect)([{
	  promise: function promise(_ref) {
	    var dispatch = _ref.store.dispatch;
	    return (0, _asyncPromise2.default)(dispatch(statisticsActions.loadRecipients()).promise);
	  }
	}]), _dec2 = (0, _reactRedux.connect)(function (state) {
	  return {
	    recipients: (0, _statistics2.getRecipients)(state),
	    recipientsLoading: state.statistics.recipientsLoading
	  };
	}, (0, _extends3.default)({}, statisticsActions)), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(StatisticsRecipients, _Component);
	
	  function StatisticsRecipients() {
	    (0, _classCallCheck3.default)(this, StatisticsRecipients);
	    return (0, _possibleConstructorReturn3.default)(this, (StatisticsRecipients.__proto__ || (0, _getPrototypeOf2.default)(StatisticsRecipients)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(StatisticsRecipients, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.filter('');
	    }
	  }, {
	    key: 'filter',
	    value: function filter(kw) {
	      this.props.filterRecipients(kw);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          recipients = _props.recipients,
	          recipientsLoading = _props.recipientsLoading;
	      var t = this.context.t;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(className) },
	        _react2.default.createElement(
	          'div',
	          { className: styles.searchLine },
	          _react2.default.createElement(_SearchBar2.default, {
	            onChange: this.filter,
	            inputClass: styles.searchInput
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: styles.searchHint },
	            t('You can search by name, email, recipient ID')
	          )
	        ),
	        _react2.default.createElement(_StatisticsRecipientsList2.default, {
	          className: styles.list,
	          recipients: recipients,
	          recipientsLoading: recipientsLoading
	        })
	      );
	    }
	  }]);
	  return StatisticsRecipients;
	}(_react.Component), _class3.propTypes = {
	  className: _propTypes2.default.string,
	  filterRecipients: _propTypes2.default.func,
	  recipients: _propTypes2.default.array,
	  recipientsLoading: _propTypes2.default.bool
	}, _class3.contextTypes = {
	  t: _propTypes2.default.func
	}, _class3.defaultProps = {
	  recipients: []
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'filter', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'filter'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = StatisticsRecipients;
	module.exports = exports['default'];

/***/ }),
/* 2224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _RecipientsList = __webpack_require__(2090);
	
	var _RecipientsList2 = _interopRequireDefault(_RecipientsList);
	
	var _statistics = __webpack_require__(57);
	
	var statisticsActions = _interopRequireWildcard(_statistics);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var StatisticsRecipientsList = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    activeOrder: state.statistics.recipientsActiveOrder,
	    order: state.statistics.recipientsOrder
	  };
	}, (0, _extends3.default)({}, statisticsActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(StatisticsRecipientsList, _Component);
	
	  function StatisticsRecipientsList() {
	    (0, _classCallCheck3.default)(this, StatisticsRecipientsList);
	    return (0, _possibleConstructorReturn3.default)(this, (StatisticsRecipientsList.__proto__ || (0, _getPrototypeOf2.default)(StatisticsRecipientsList)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(StatisticsRecipientsList, [{
	    key: 'setStatisticsRecipient',
	    value: function setStatisticsRecipient(recipient) {
	      this.context.push('/statistics/recipient/' + recipient.id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          recipientsLoading = _props.recipientsLoading,
	          recipients = _props.recipients,
	          activeOrder = _props.activeOrder,
	          order = _props.order,
	          recipientsReorder = _props.recipientsReorder;
	
	
	      return _react2.default.createElement(_RecipientsList2.default, {
	        className: className,
	        activeOrder: activeOrder,
	        order: order,
	        onReorder: recipientsReorder,
	        recipients: recipients,
	        onClick: this.setStatisticsRecipient,
	        loading: recipientsLoading
	      });
	    }
	  }]);
	  return StatisticsRecipientsList;
	}(_react.Component), _class3.propTypes = {
	  activeOrder: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  order: _propTypes2.default.object,
	  recipients: _propTypes2.default.array.isRequired,
	  recipientsLoading: _propTypes2.default.bool,
	  recipientsReorder: _propTypes2.default.func
	}, _class3.contextTypes = {
	  push: _propTypes2.default.func
	}, _class3.defaultProps = {
	  recipients: [],
	  recipientsLoading: false
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'setStatisticsRecipient', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setStatisticsRecipient'), _class2.prototype)), _class2)) || _class);
	exports.default = StatisticsRecipientsList;
	module.exports = exports['default'];

/***/ }),
/* 2225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(9);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(11);
	
	var _statistics = __webpack_require__(57);
	
	var statisticsActions = _interopRequireWildcard(_statistics);
	
	var _autobindDecorator = __webpack_require__(10);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _bind = __webpack_require__(14);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var styles = __webpack_require__(1387);
	
	var sendTypes = { remind: 'remind', all: 'all' };
	
	var StatisticsReminders = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    sendRemindersActionData: state.statistics.sendRemindersActionData,
	    sendRemindersLoading: state.statistics.sendRemindersLoading
	  };
	}, (0, _extends3.default)({}, statisticsActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(StatisticsReminders, _Component);
	
	  function StatisticsReminders() {
	    (0, _classCallCheck3.default)(this, StatisticsReminders);
	    return (0, _possibleConstructorReturn3.default)(this, (StatisticsReminders.__proto__ || (0, _getPrototypeOf2.default)(StatisticsReminders)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(StatisticsReminders, [{
	    key: 'send',
	    value: function send(_ref) {
	      var sendType = _ref.sendType;
	      var _props = this.props,
	          sendReminders = _props.sendReminders,
	          projectId = _props.projectId;
	      var t = this.context.t;
	
	
	      return sendReminders({ projectId: projectId, sendType: sendType }).promise.then(function (resp) {
	        _toastr2.default.info(t('Reminders sent'));
	        return resp;
	      }).catch(function (err) {
	        return err;
	      });
	    }
	  }, {
	    key: 'sendReminders',
	    value: function sendReminders() {
	      this.send({ sendType: sendTypes.remind });
	    }
	  }, {
	    key: 'sendToAll',
	    value: function sendToAll() {
	      this.send({ sendType: sendTypes.all });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          sendRemindersLoading = _props2.sendRemindersLoading,
	          sendRemindersActionData = _props2.sendRemindersActionData;
	      var t = this.context.t;
	
	      var isSendRemindersLoading = sendRemindersLoading && sendRemindersActionData.sendType === sendTypes.remind;
	      var isSendToAllLoading = sendRemindersLoading && sendRemindersActionData.sendType === sendTypes.all;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(styles.container, className) },
	        _react2.default.createElement(
	          _Button2.default,
	          { className: 'btn-primary', onClick: this.sendReminders, loading: isSendRemindersLoading },
	          t('Send reminders')
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          { className: 'btn-primary', onClick: this.sendToAll, loading: isSendToAllLoading },
	          t('Send to all recipients')
	        )
	      );
	    }
	  }]);
	  return StatisticsReminders;
	}(_react.Component), _class3.propTypes = {
	  className: _propTypes2.default.string,
	  projectId: _propTypes2.default.number,
	  sendReminders: _propTypes2.default.func,
	  sendRemindersActionData: _propTypes2.default.object,
	  sendRemindersLoading: _propTypes2.default.bool
	}, _class3.contextTypes = {
	  t: _propTypes2.default.func
	}, _class3.defaultProps = {
	  onClick: _noop3.default
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'sendReminders', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'sendReminders'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'sendToAll', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'sendToAll'), _class2.prototype)), _class2)) || _class);
	exports.default = StatisticsReminders;
	module.exports = exports['default'];

/***/ }),
/* 2226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isUndefined2 = __webpack_require__(240);
	
	var _isUndefined3 = _interopRequireDefault(_isUndefined2);
	
	exports.copyTextToClipboard = copyTextToClipboard;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript
	function copyTextToClipboard(text) {
	  var result = false;
	
	  if ((0, _isUndefined3.default)(document)) {
	    return result;
	  }
	
	  var textArea = document.createElement('textarea');
	  //
	  // *** This styling is an extra step which is likely not required. ***
	  //
	  // Why is it here? To ensure:
	  // 1. the element is able to have focus and selection.
	  // 2. if element was to flash render it has minimal visual impact.
	  // 3. less flakyness with selection and copying which **might** occur if
	  //    the textarea element is not visible.
	  //
	  // The likelihood is the element won't even render, not even a flash,
	  // so some of these are just precautions. However in IE the element
	  // is visible whilst the popup box asking the user for permission for
	  // the web page to copy to the clipboard.
	  //
	
	  // Place in top-left corner of screen regardless of scroll position.
	  textArea.style.position = 'fixed';
	  textArea.style.top = 0;
	  textArea.style.left = 0;
	
	  // Ensure it has a small width and height. Setting to 1px / 1em
	  // doesn't work as this gives a negative w/h on some browsers.
	  textArea.style.width = '2em';
	  textArea.style.height = '2em';
	  textArea.style.padding = 0;
	  textArea.style.border = 'none';
	  textArea.style.outline = 'none';
	  textArea.style.boxShadow = 'none';
	
	  // Avoid flash of white box if rendered for any reason.
	  textArea.style.background = 'transparent';
	
	  textArea.value = text;
	  document.body.appendChild(textArea);
	  textArea.select();
	
	  try {
	    result = document.execCommand('copy');
	  } catch (err) {
	    result = false;
	  }
	
	  document.body.removeChild(textArea);
	
	  return result;
	}

/***/ }),
/* 2227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.processFile = undefined;
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.processFiles = processFiles;
	
	var _files = __webpack_require__(869);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var processFile = exports.processFile = {
	  dropbox: function dropbox(file) {
	    var processedFile = (0, _extends3.default)({}, file);
	    processedFile.__type = processedFile['.tag'];
	    processedFile.__id = processedFile.id;
	    processedFile.__name = processedFile.name;
	    processedFile.__ext = (0, _files.getFileExtention)(processedFile.name);
	    return processedFile;
	  },
	
	  boxcom: function boxcom(file) {
	    var processedFile = (0, _extends3.default)({}, file);
	    processedFile.__type = processedFile.type;
	    processedFile.__id = processedFile.id;
	    processedFile.__name = processedFile.name;
	    processedFile.__ext = processedFile.extension || '';
	    return processedFile;
	  }
	};
	
	function processFiles(files, service) {
	  if (files) {
	    var processedFiles = [];
	    files.map(function (file) {
	      return processedFiles.push(processFile[service](file));
	    });
	    return processedFiles;
	  }
	
	  return null;
	}

/***/ }),
/* 2228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _max3 = __webpack_require__(1556);
	
	var _max4 = _interopRequireDefault(_max3);
	
	var _keyBy3 = __webpack_require__(322);
	
	var _keyBy4 = _interopRequireDefault(_keyBy3);
	
	var _groupBy3 = __webpack_require__(669);
	
	var _groupBy4 = _interopRequireDefault(_groupBy3);
	
	var _get3 = __webpack_require__(19);
	
	var _get4 = _interopRequireDefault(_get3);
	
	exports.processReport = processReport;
	exports.processRecipientReport = processRecipientReport;
	
	var _projects = __webpack_require__(28);
	
	var _recipients = __webpack_require__(264);
	
	var _datetime = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function processReport(data) {
	  var processedData = (0, _extends3.default)({}, data);
	  processedData.project = (0, _projects.processProject)(processedData.project || {});
	  var _processedData$averag = processedData.averageStat,
	      averageStat = _processedData$averag === undefined ? [0] : _processedData$averag;
	
	  processedData.maxPlaysNumber = (0, _max4.default)(averageStat.map(function (stat) {
	    return stat.nbPlays;
	  }));
	  processedData.files = (0, _keyBy4.default)(processedData.listfiles, 'uploadId');
	  processedData.viewers = (0, _recipients.processRecipients)(processedData.Views || []);
	  processedData.nonViewers = (0, _recipients.processRecipients)(processedData.nonViews || []);
	  processedData.downloadedViewers = (0, _keyBy4.default)(processedData.DownloadList, 'recipientId');
	  return processedData;
	}
	
	function processRecipientFiles(files, timings) {
	  return files.map(function (file) {
	    var fileTimings = (0, _get4.default)(timings, [file.uploadId], []);
	    var playCount = fileTimings.length;
	    var playtime = fileTimings.reduce(function (timing1, timing2) {
	      return (0, _get4.default)(timing1, 'listeningDuration', timing1) + (0, _get4.default)(timing2, 'listeningDuration', 0);
	    }, 0);
	    var avgPlaytime = playtime / (playCount || 1);
	
	    return (0, _extends3.default)({}, file, {
	      durationMinutes: (0, _datetime.secToMin)(file.duration),
	      playCount: playCount,
	      avgPlaytime: avgPlaytime,
	      avgPlaytimeMinutes: (0, _datetime.secToMin)(avgPlaytime)
	    });
	  });
	}
	
	function processTimings(timings) {
	  return timings.map(function (timing) {
	    return (0, _extends3.default)({}, timing, {
	      durationMinutes: (0, _datetime.secToMin)(timing.listeningDuration),
	      durationString: (0, _datetime.secToMinString)(timing.listeningDuration),
	      dateString: (0, _datetime.formatDateTime)(timing.date)
	    });
	  });
	}
	
	function processRecipientReport(data) {
	  var processedData = (0, _extends3.default)({}, data);
	  processedData.fileTimings = (0, _groupBy4.default)(processedData.Timings, 'uploadId');
	  processedData.filesArray = processRecipientFiles(processedData.listfiles || [], processedData.fileTimings);
	  processedData.files = (0, _keyBy4.default)(processedData.filesArray, 'uploadId');
	  processedData.maxPlaysNumber = (0, _max4.default)(processedData.filesArray.map(function (file) {
	    return file.playCount;
	  }));
	  processedData.timings = processTimings(processedData.Timings || []);
	  return processedData;
	}

/***/ }),
/* 2229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _i18next = __webpack_require__(1430);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	var _i18nextExpressMiddleware = __webpack_require__(1414);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* i18n client entry-point */
	
	_i18next2.default.use(_i18nextExpressMiddleware.LanguageDetector).init({
	  detection: {
	    order: ['querystring', 'cookie', 'header'],
	    // keys or params to lookup language from
	    lookupQuerystring: 'lang',
	    lookupCookie: 'i18next',
	    // cache user language
	    caches: false // ['cookie']
	    // optional expire and domain for set cookie
	  },
	  whitelist: ['en', 'fr', 'ja', 'zh-CN', 'de', 'es', 'it', 'pt'],
	  fallbackLng: 'en',
	
	  nsSeparator: '::',
	  keySeparator: '##',
	  pluralSeparator: '_',
	  contextSeparator: '~~',
	
	  // have a common namespace used around the full app
	  ns: ['common'],
	  defaultNS: 'common',
	
	  interpolation: {
	    escapeValue: false // not needed for react!!
	  }
	});
	
	exports.default = _i18next2.default;
	module.exports = exports['default'];

/***/ }),
/* 2230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.moduleName = undefined;
	
	var _mapConstants = __webpack_require__(876);
	
	var _mapConstants2 = _interopRequireDefault(_mapConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moduleName = exports.moduleName = 'progresspopup';
	
	var constants = ['SHOW', 'HIDE'];
	
	exports.default = (0, _mapConstants2.default)({ moduleName: moduleName, constants: constants });

/***/ }),
/* 2231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.moduleName = undefined;
	
	var _mapConstants = __webpack_require__(876);
	
	var _mapConstants2 = _interopRequireDefault(_mapConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moduleName = exports.moduleName = 'statistics';
	
	var constants = ['PROJECTS_REORDER', 'PROJECTS_FILTER', 'SET_PROJECTS_TAB', 'RECIPIENTS_REORDER', 'RECIPIENTS_FILTER', 'SET_PERIOD_NAME', 'SET_REPORT_DATES', 'SET_PROJECT_ID', 'SET_RECIPIENT_ID', 'COVERAGE_RECIPIENTS_REORDER', 'RECIPIENT_PROJECTS_REORDER', 'SET_PROJECTS_LIST_PAGE'];
	
	exports.default = (0, _mapConstants2.default)({ moduleName: moduleName, constants: constants });

/***/ }),
/* 2232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createStore;
	
	var _redux = __webpack_require__(255);
	
	var _clientMiddleware = __webpack_require__(2233);
	
	var _clientMiddleware2 = _interopRequireDefault(_clientMiddleware);
	
	var _sessionMiddleware = __webpack_require__(2234);
	
	var _sessionMiddleware2 = _interopRequireDefault(_sessionMiddleware);
	
	var _reactRouterRedux = __webpack_require__(40);
	
	var _reduxThunk = __webpack_require__(1905);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createStore(history, client, data) {
	  var clientMiddleware = new _clientMiddleware2.default({ client: client });
	  var middleware = [clientMiddleware.middleware(client), (0, _sessionMiddleware2.default)(), (0, _reactRouterRedux.routerMiddleware)(history), _reduxThunk2.default];
	
	  var enhancer = void 0;
	  if (false) {
	    var _require = require('redux-devtools'),
	        persistState = _require.persistState;
	
	    enhancer = (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, middleware), window.devToolsExtension(), persistState(window.location.href.match(/[?&]debug_session=([^&]+)\b/)));
	  } else {
	    enhancer = _redux.applyMiddleware.apply(undefined, middleware);
	  }
	
	  var reducer = __webpack_require__(2238);
	  var store = (0, _redux.createStore)(reducer, data, enhancer);
	
	  if (false) {
	    module.hot.accept('./reducer', function () {
	      store.replaceReducer(require('./reducer'));
	    });
	  }
	
	  return store;
	}
	module.exports = exports['default'];

/***/ }),
/* 2233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _objectWithoutProperties2 = __webpack_require__(21);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _toConsumableArray2 = __webpack_require__(34);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(78);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _noop2 = __webpack_require__(16);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _get2 = __webpack_require__(19);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _auth = __webpack_require__(31);
	
	var _config = __webpack_require__(41);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _consoleColor = __webpack_require__(867);
	
	var _responseCodes = __webpack_require__(99);
	
	var _responseCodes2 = _interopRequireDefault(_responseCodes);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _common = __webpack_require__(265);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* API client middleware, catch API errors */
	
	var ClientMiddleware = function () {
	  function ClientMiddleware(_ref) {
	    var client = _ref.client;
	    (0, _classCallCheck3.default)(this, ClientMiddleware);
	
	    this.client = client;
	    this.promiseStore = {};
	    this.dispatch = _noop3.default;
	    this.getState = _noop3.default;
	    this.next = _noop3.default;
	    this.action = null;
	  }
	
	  (0, _createClass3.default)(ClientMiddleware, [{
	    key: 'showToast',
	    value: function showToast(_ref2) {
	      var type = _ref2.type,
	          message = _ref2.message;
	
	      var _t = __webpack_require__(56).getT();
	      var translatedMessage = _t(message);
	      if (false) {
	        this.dispatch((0, _common.setDelayedToast)({ type: type, message: translatedMessage }));
	      } else {
	        _toastr2.default[type](translatedMessage);
	      }
	    }
	  }, {
	    key: 'getUser',
	    value: function getUser() {
	      return (0, _get3.default)(this.getState(), 'auth.user');
	    }
	  }, {
	    key: 'setParams',
	    value: function setParams(_ref3) {
	      var dispatch = _ref3.dispatch,
	          getState = _ref3.getState,
	          action = _ref3.action,
	          next = _ref3.next;
	
	      this.dispatch = dispatch;
	      this.getState = getState;
	      this.action = action;
	      this.next = next;
	    }
	  }, {
	    key: 'onResultPopup',
	    value: function onResultPopup(_ref4) {
	      var result = _ref4.result;
	      var messageField = _config2.default.response.messageField;
	
	      var message = result[messageField];
	      var hidePopup = (0, _get3.default)(result, 'hidePopup');
	
	      if (message && hidePopup === false) {
	        this.showToast({ type: 'info', message: message });
	      }
	    }
	
	    /* eslint-disable no-use-before-define */
	
	  }, {
	    key: 'onErrorPopup',
	    value: function onErrorPopup(_ref5) {
	      var error = _ref5.error;
	      var _config$response = _config2.default.response,
	          messageField = _config$response.messageField,
	          statusField = _config$response.statusField;
	
	      var message = (0, _get3.default)(error, ['response', 'body', messageField]) || error[messageField] || error.reason || error.toString();
	      var hidePopup = (0, _get3.default)(error, 'hidePopup');
	      var hideErrors = (0, _get3.default)(error, 'hideErrors', false);
	      var errorCode = (0, _get3.default)(error, ['response', 'body', statusField], error[statusField]);
	      var hideErrorCodes = (0, _get3.default)(error, 'hideErrorCodes', []);
	      var isErrorTime = this.lastError !== message || Date.now() - this.lastErrorTime > 3000;
	      var isHideError = hideErrors || hidePopup || hideErrorCodes.includes(errorCode);
	
	      if (isErrorTime) {
	        this.lastError = message;
	        this.lastErrorTime = Date.now();
	        if (!isHideError) {
	          this.showToast({ type: 'error', message: message });
	        }
	      }
	    }
	    /* eslint-enable no-use-before-define */
	
	  }, {
	    key: 'checkResponseCode',
	    value: function checkResponseCode(_ref6) {
	      var response = _ref6.response;
	      var statusField = _config2.default.response.statusField;
	
	      if (response[statusField] === _responseCodes2.default.sessionError && this.getUser()) {
	        return this.dispatch((0, _auth.logout)());
	      }
	
	      return false;
	    }
	  }, {
	    key: 'onSuccess',
	    value: function onSuccess(_ref7) {
	      var result = _ref7.result;
	
	      var _action$types = (0, _slicedToArray3.default)(this.action.types, 2),
	          SUCCESS = _action$types[1];
	
	      this.onResultPopup({ result: result });
	      this.promiseStore[SUCCESS] = null;
	      var actionParams = this.getActionParams();
	      return this.next((0, _extends3.default)({}, actionParams, { result: result, type: SUCCESS }));
	    }
	  }, {
	    key: 'onError',
	    value: function onError(_ref8) {
	      var error = _ref8.error;
	
	      var _action$types2 = (0, _slicedToArray3.default)(this.action.types, 3),
	          FAILURE = _action$types2[2];
	
	      this.onErrorPopup({ error: error });
	      this.promiseStore[FAILURE] = null;
	
	      this.checkResponseCode({ response: error });
	
	      console.warn((0, _consoleColor.shellFg)('red') + 'Middleware server request error. Action: ' + FAILURE + (0, _consoleColor.shellReset)(), error);
	      return this.next((0, _extends3.default)({}, this.getActionParams(), { error: error, type: FAILURE }));
	    }
	  }, {
	    key: 'abortRequests',
	    value: function abortRequests(_ref9) {
	      var _this = this;
	
	      var abortKeys = _ref9.abortKeys;
	
	      if (!Array.isArray(abortKeys)) {
	        return false;
	      }
	      abortKeys.map(function (abortKey) {
	        if (_this.promiseStore[abortKey]) {
	          _this.promiseStore[abortKey].request.abort();
	          _this.promiseStore[abortKey] = null;
	        }
	      });
	    }
	
	    // save promise and request in promise store and abort the same previous request
	
	  }, {
	    key: 'updatePromiseStore',
	    value: function updatePromiseStore(_ref10) {
	      var actionResult = _ref10.actionResult;
	      var _action = this.action,
	          abortable = _action.abortable,
	          _action$abort = _action.abort,
	          abort = _action$abort === undefined ? [] : _action$abort;
	
	      var abortKeys = [].concat((0, _toConsumableArray3.default)(abort));
	
	      var _action$types3 = (0, _slicedToArray3.default)(this.action.types, 1),
	          REQUEST = _action$types3[0];
	
	      if (abortable) {
	        abortKeys.push(REQUEST);
	      }
	      this.abortRequests({ abortKeys: abortKeys });
	      this.promiseStore[REQUEST] = actionResult;
	    }
	  }, {
	    key: 'getActionParams',
	    value: function getActionParams() {
	      var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref11$action = _ref11.action,
	          action = _ref11$action === undefined ? this.action : _ref11$action;
	
	      var promise = action.promise,
	          abortable = action.abortable,
	          abort = action.abort,
	          types = action.types,
	          actionParams = (0, _objectWithoutProperties3.default)(action, ['promise', 'abortable', 'abort', 'types']); // eslint-disable-line no-unused-vars
	
	      return actionParams;
	    }
	  }, {
	    key: 'middleware',
	    value: function middleware() {
	      var _this2 = this;
	
	      return function (_ref12) {
	        var dispatch = _ref12.dispatch,
	            getState = _ref12.getState;
	        return function (next) {
	          return function (action) {
	            if (typeof action === 'function') {
	              return action(dispatch, getState);
	            } else if (!action.promise) {
	              return next(action);
	            }
	
	            _this2.setParams({ dispatch: dispatch, getState: getState, action: action, next: next });
	            var actionParams = _this2.getActionParams({ action: action });
	
	            var _action$types4 = (0, _slicedToArray3.default)(action.types, 1),
	                REQUEST = _action$types4[0];
	
	            next((0, _extends3.default)({}, actionParams, { type: REQUEST }));
	
	            var actionResult = action.promise(_this2.client);
	            actionResult.promise.then(function (result) {
	              _this2.setParams({ dispatch: dispatch, getState: getState, action: action, next: next });
	              return _this2.onSuccess({ result: result });
	            }, function (error) {
	              _this2.setParams({ dispatch: dispatch, getState: getState, action: action, next: next });
	              return _this2.onError({ error: error });
	            }).catch(function (error) {
	              _this2.setParams({ dispatch: dispatch, getState: getState, action: action, next: next });
	              return _this2.onError({ error: error });
	            });
	
	            _this2.updatePromiseStore({ actionResult: actionResult });
	
	            return actionResult;
	          };
	        };
	      };
	    }
	  }]);
	  return ClientMiddleware;
	}();
	
	exports.default = ClientMiddleware;
	module.exports = exports['default'];

/***/ }),
/* 2234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(34);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _values = __webpack_require__(158);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _debounce3 = __webpack_require__(317);
	
	var _debounce4 = _interopRequireDefault(_debounce3);
	
	var _get3 = __webpack_require__(19);
	
	var _get4 = _interopRequireDefault(_get3);
	
	exports.default = sessionMiddleware;
	
	var _auth = __webpack_require__(31);
	
	var _toastr = __webpack_require__(25);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _notSessionActions = __webpack_require__(2237);
	
	var notSessionActions = _interopRequireWildcard(_notSessionActions);
	
	var _reactRouterRedux = __webpack_require__(40);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* Session timeout middleware - logout on timeout */
	
	var sessionTimer = null;
	
	function getNotSessionActions() {
	  var res = [];
	  (0, _values2.default)(notSessionActions).map(function (actions) {
	    res = [].concat((0, _toConsumableArray3.default)(res), (0, _toConsumableArray3.default)(actions));
	  });
	  return res;
	}
	
	var notSessionActionsArray = getNotSessionActions();
	
	var timeoutFn = (0, _debounce4.default)(function (_ref) {
	  var dispatch = _ref.dispatch,
	      timeout = _ref.timeout;
	
	  var t = __webpack_require__(56).getT();
	  sessionTimer = setTimeout(function () {
	    dispatch((0, _auth.logout)(true)).promise.then(function () {
	      return _toastr2.default.info(t('Session timeout. Please login again.'));
	    });
	  }, timeout * 1000);
	}, 1000);
	
	function sessionMiddleware() {
	  return function (_ref2) {
	    var dispatch = _ref2.dispatch,
	        getState = _ref2.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState);
	        }
	
	        if (action.type === _auth.LOGOUT) {
	          dispatch((0, _reactRouterRedux.push)('/'));
	        }
	
	        var user = (0, _get4.default)(getState(), 'auth.user');
	        var timeout = (0, _get4.default)(user, 'rightMngt.sessionTimeout', 0);
	
	        if (!user) {
	          clearTimeout(sessionTimer);
	        }
	
	        if (timeout && !notSessionActionsArray.includes(action.type)) {
	          // console.log('set session timer', timeout, action.type);
	          clearTimeout(sessionTimer);
	          timeoutFn({ dispatch: dispatch, timeout: timeout });
	        }
	
	        next(action);
	      };
	    };
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 2235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.progresspopup = exports.statistics = exports.playstats = exports.songs = exports.myPlaylists = exports.report = exports.common = exports.cloud = exports.adbar = exports.quicksend = exports.account = exports.contacts = exports.auth = exports.audioplayer = exports.sidemenu = exports.project = exports.projects = exports.playlist = exports.playlists = undefined;
	
	var _playlists2 = __webpack_require__(100);
	
	var _playlists3 = _interopRequireDefault(_playlists2);
	
	var _playlist2 = __webpack_require__(217);
	
	var _playlist3 = _interopRequireDefault(_playlist2);
	
	var _projects2 = __webpack_require__(359);
	
	var _projects3 = _interopRequireDefault(_projects2);
	
	var _project2 = __webpack_require__(37);
	
	var _project3 = _interopRequireDefault(_project2);
	
	var _sidemenu2 = __webpack_require__(871);
	
	var _sidemenu3 = _interopRequireDefault(_sidemenu2);
	
	var _audioplayer2 = __webpack_require__(83);
	
	var _audioplayer3 = _interopRequireDefault(_audioplayer2);
	
	var _auth2 = __webpack_require__(31);
	
	var _auth3 = _interopRequireDefault(_auth2);
	
	var _contacts2 = __webpack_require__(61);
	
	var _contacts3 = _interopRequireDefault(_contacts2);
	
	var _account2 = __webpack_require__(184);
	
	var _account3 = _interopRequireDefault(_account2);
	
	var _quicksend2 = __webpack_require__(156);
	
	var _quicksend3 = _interopRequireDefault(_quicksend2);
	
	var _adbar2 = __webpack_require__(530);
	
	var _adbar3 = _interopRequireDefault(_adbar2);
	
	var _cloud2 = __webpack_require__(216);
	
	var _cloud3 = _interopRequireDefault(_cloud2);
	
	var _common2 = __webpack_require__(265);
	
	var _common3 = _interopRequireDefault(_common2);
	
	var _report2 = __webpack_require__(360);
	
	var _report3 = _interopRequireDefault(_report2);
	
	var _myPlaylists2 = __webpack_require__(88);
	
	var _myPlaylists3 = _interopRequireDefault(_myPlaylists2);
	
	var _songs2 = __webpack_require__(266);
	
	var _songs3 = _interopRequireDefault(_songs2);
	
	var _playstats2 = __webpack_require__(358);
	
	var _playstats3 = _interopRequireDefault(_playstats2);
	
	var _statistics2 = __webpack_require__(57);
	
	var _statistics3 = _interopRequireDefault(_statistics2);
	
	var _progresspopup2 = __webpack_require__(531);
	
	var _progresspopup3 = _interopRequireDefault(_progresspopup2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.playlists = _playlists3.default;
	exports.playlist = _playlist3.default;
	exports.projects = _projects3.default;
	exports.project = _project3.default;
	exports.sidemenu = _sidemenu3.default;
	exports.audioplayer = _audioplayer3.default;
	exports.auth = _auth3.default;
	exports.contacts = _contacts3.default;
	exports.account = _account3.default;
	exports.quicksend = _quicksend3.default;
	exports.adbar = _adbar3.default;
	exports.cloud = _cloud3.default;
	exports.common = _common3.default;
	exports.report = _report3.default;
	exports.myPlaylists = _myPlaylists3.default;
	exports.songs = _songs3.default;
	exports.playstats = _playstats3.default;
	exports.statistics = _statistics3.default;
	exports.progresspopup = _progresspopup3.default;

/***/ }),
/* 2236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = info;
	exports.isLoaded = isLoaded;
	exports.load = load;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* Info redux reducer and action creators */
	
	var LOAD = 'redux-example/LOAD';
	var LOAD_SUCCESS = 'redux-example/LOAD_SUCCESS';
	var LOAD_FAIL = 'redux-example/LOAD_FAIL';
	
	var initialState = {
	  loaded: false
	};
	
	function info() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case LOAD:
	      return (0, _extends3.default)({}, state, {
	        loading: true
	      });
	    case LOAD_SUCCESS:
	      return (0, _extends3.default)({}, state, {
	        loading: false,
	        loaded: true,
	        data: action.result.data
	      });
	    case LOAD_FAIL:
	      return (0, _extends3.default)({}, state, {
	        loading: false,
	        loaded: false,
	        error: action.error
	      });
	    default:
	      return state;
	  }
	}
	
	function isLoaded(globalState) {
	  return globalState.info && globalState.info.loaded;
	}
	
	function load() {
	  return {
	    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
	    promise: function promise(client) {
	      return client.get('/loadInfo');
	    }
	  };
	}

/***/ }),
/* 2237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(31);
	
	Object.defineProperty(exports, 'authNotSessionActions', {
	  enumerable: true,
	  get: function get() {
	    return _auth.notSessionActions;
	  }
	});
	var additionalActions = exports.additionalActions = ['@ReduxToastr/toastr/ADD', '@ReduxToastr/toastr/REMOVE', 'reduxAsyncConnect/BEGIN_GLOBAL_LOAD', 'reduxAsyncConnect/END_GLOBAL_LOAD'];

/***/ }),
/* 2238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redux = __webpack_require__(255);
	
	var _reactRouterRedux = __webpack_require__(40);
	
	var _reduxConnect = __webpack_require__(33);
	
	var _reactReduxToastr = __webpack_require__(494);
	
	var _modules = __webpack_require__(2235);
	
	var modules = _interopRequireWildcard(_modules);
	
	var _reduxForm = __webpack_require__(50);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)((0, _extends3.default)({
	  routing: _reactRouterRedux.routerReducer,
	  toastr: _reactReduxToastr.reducer,
	  form: _reduxForm.reducer,
	  reduxAsyncConnect: _reduxConnect.reducer
	}, modules));
	module.exports = exports['default'];

/***/ }),
/* 2239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _BaseReducer2 = __webpack_require__(872);
	
	var _BaseReducer3 = _interopRequireDefault(_BaseReducer2);
	
	var _qim = __webpack_require__(110);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProgressPopupReducer = function (_BaseReducer) {
	  (0, _inherits3.default)(ProgressPopupReducer, _BaseReducer);
	
	  function ProgressPopupReducer() {
	    (0, _classCallCheck3.default)(this, ProgressPopupReducer);
	    return (0, _possibleConstructorReturn3.default)(this, (ProgressPopupReducer.__proto__ || (0, _getPrototypeOf2.default)(ProgressPopupReducer)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProgressPopupReducer, [{
	    key: 'show',
	    value: function show(_ref) {
	      var state = _ref.state,
	          action = _ref.action;
	
	      return (0, _qim.update)([['visible', (0, _qim.$set)(true)], [(0, _qim.$merge)(action.options)]], this._mainReducer(state, action));
	    }
	  }, {
	    key: 'hide',
	    value: function hide(_ref2) {
	      var state = _ref2.state,
	          action = _ref2.action;
	
	      return (0, _qim.set)(['visible'], false, this._mainReducer(state, action));
	    }
	  }]);
	  return ProgressPopupReducer;
	}(_BaseReducer3.default);
	
	exports.default = ProgressPopupReducer;
	module.exports = exports['default'];

/***/ }),
/* 2240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _get2 = __webpack_require__(19);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _BaseReducer2 = __webpack_require__(872);
	
	var _BaseReducer3 = _interopRequireDefault(_BaseReducer2);
	
	var _qim = __webpack_require__(110);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StatisticsReducer = function (_BaseReducer) {
	  (0, _inherits3.default)(StatisticsReducer, _BaseReducer);
	
	  function StatisticsReducer() {
	    (0, _classCallCheck3.default)(this, StatisticsReducer);
	    return (0, _possibleConstructorReturn3.default)(this, (StatisticsReducer.__proto__ || (0, _getPrototypeOf2.default)(StatisticsReducer)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(StatisticsReducer, [{
	    key: 'addStatsViewerSuccess',
	    value: function addStatsViewerSuccess(_ref) {
	      var state = _ref.state,
	          action = _ref.action;
	
	      return (0, _qim.update)([['statsViewersData', (0, _qim.$merge)((0, _get3.default)(action, ['result', 'data', 0, 'statsViewers']))]], this._mainReducer(state, action));
	    }
	  }, {
	    key: 'deleteStatsViewerSuccess',
	    value: function deleteStatsViewerSuccess(_ref2) {
	      var state = _ref2.state,
	          action = _ref2.action;
	
	      return (0, _qim.update)([['statsViewersData', _qim.$each, function (viewer) {
	        return viewer.userEmail === action.email;
	      }, _qim.$none]], this._mainReducer(state, action));
	    }
	  }, {
	    key: 'projectsReorder',
	    value: function projectsReorder(_ref3) {
	      var state = _ref3.state,
	          action = _ref3.action;
	
	      return this._reorder({
	        orderFieldName: 'projectsOrder',
	        activeOrderFieldName: 'projectsActiveOrder',
	        action: action,
	        state: state
	      });
	    }
	  }, {
	    key: 'recipientsReorder',
	    value: function recipientsReorder(_ref4) {
	      var state = _ref4.state,
	          action = _ref4.action;
	
	      return this._reorder({
	        orderFieldName: 'recipientsOrder',
	        activeOrderFieldName: 'recipientsActiveOrder',
	        action: action,
	        state: state
	      });
	    }
	  }, {
	    key: 'recipientProjectsReorder',
	    value: function recipientProjectsReorder(_ref5) {
	      var state = _ref5.state,
	          action = _ref5.action;
	
	      return this._reorder({
	        orderFieldName: 'recipientProjectsOrder',
	        activeOrderFieldName: 'recipientProjectsActiveOrder',
	        action: action,
	        state: state
	      });
	    }
	  }, {
	    key: 'coverageRecipientsReorder',
	    value: function coverageRecipientsReorder(_ref6) {
	      var state = _ref6.state,
	          action = _ref6.action;
	
	      return this._reorder({
	        orderFieldName: 'coverageRecipientsOrder',
	        activeOrderFieldName: 'coverageRecipientsActiveOrder',
	        action: action,
	        state: state
	      });
	    }
	  }, {
	    key: 'projectsFilter',
	    value: function projectsFilter(_ref7) {
	      var state = _ref7.state,
	          action = _ref7.action;
	
	      return (0, _qim.update)([['projectsKw', (0, _qim.$set)(action.kw)], ['myProjectsListPage', (0, _qim.$set)(1)]], this._mainReducer(state, action));
	    }
	  }, {
	    key: 'recipientsFilter',
	    value: function recipientsFilter(_ref8) {
	      var state = _ref8.state,
	          action = _ref8.action;
	
	      return (0, _qim.set)(['recipientsKw'], action.kw, this._mainReducer(state, action));
	    }
	  }, {
	    key: 'setProjectsTab',
	    value: function setProjectsTab(_ref9) {
	      var state = _ref9.state,
	          action = _ref9.action;
	
	      return (0, _qim.set)(['activeProjectsTab'], action.tab, this._mainReducer(state, action));
	    }
	  }, {
	    key: 'setPeriodName',
	    value: function setPeriodName(_ref10) {
	      var state = _ref10.state,
	          action = _ref10.action;
	
	      return (0, _qim.set)(['periodName'], action.periodName, this._mainReducer(state, action));
	    }
	  }, {
	    key: 'setReportDates',
	    value: function setReportDates(_ref11) {
	      var state = _ref11.state,
	          action = _ref11.action;
	
	      return (0, _qim.update)([['startDate', (0, _qim.$set)(action.startDate)], ['endDate', (0, _qim.$set)(action.endDate)]], this._mainReducer(state, action));
	    }
	  }, {
	    key: 'setProjectId',
	    value: function setProjectId(_ref12) {
	      var state = _ref12.state,
	          action = _ref12.action;
	
	      return (0, _qim.set)(['projectId'], action.projectId, this._mainReducer(state, action));
	    }
	  }, {
	    key: 'setRecipientId',
	    value: function setRecipientId(_ref13) {
	      var state = _ref13.state,
	          action = _ref13.action;
	
	      return (0, _qim.set)(['recipientId'], action.recipientId, this._mainReducer(state, action));
	    }
	  }, {
	    key: 'setProjectsListPage',
	    value: function setProjectsListPage(_ref14) {
	      var state = _ref14.state,
	          action = _ref14.action;
	
	      return (0, _qim.set)(['myProjectsListPage'], action.page, this._mainReducer(state, action));
	    }
	  }]);
	  return StatisticsReducer;
	}(_BaseReducer3.default);
	
	exports.default = StatisticsReducer;
	module.exports = exports['default'];

/***/ }),
/* 2241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get3 = __webpack_require__(19);
	
	var _get4 = _interopRequireDefault(_get3);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(124);
	
	var _auth = __webpack_require__(31);
	
	var _permissions = __webpack_require__(215);
	
	var _config = __webpack_require__(41);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _containers = __webpack_require__(213);
	
	var _components = __webpack_require__(15);
	
	var _StatisticsProjects = __webpack_require__(2220);
	
	var _StatisticsProjects2 = _interopRequireDefault(_StatisticsProjects);
	
	var _StatisticsRecipients = __webpack_require__(2223);
	
	var _StatisticsRecipients2 = _interopRequireDefault(_StatisticsRecipients);
	
	var _Statistics = __webpack_require__(2218);
	
	var _Statistics2 = _interopRequireDefault(_Statistics);
	
	var _ProjectStatistics = __webpack_require__(2214);
	
	var _ProjectStatistics2 = _interopRequireDefault(_ProjectStatistics);
	
	var _ProjectStatisticsOverall = __webpack_require__(2215);
	
	var _ProjectStatisticsOverall2 = _interopRequireDefault(_ProjectStatisticsOverall);
	
	var _ProjectRecipientStatistics = __webpack_require__(2213);
	
	var _ProjectRecipientStatistics2 = _interopRequireDefault(_ProjectRecipientStatistics);
	
	var _ProjectDetailsStatistics = __webpack_require__(2212);
	
	var _ProjectDetailsStatistics2 = _interopRequireDefault(_ProjectDetailsStatistics);
	
	var _DevicesStatistics = __webpack_require__(2211);
	
	var _DevicesStatistics2 = _interopRequireDefault(_DevicesStatistics);
	
	var _RecipientStatistics = __webpack_require__(2216);
	
	var _RecipientStatistics2 = _interopRequireDefault(_RecipientStatistics);
	
	var _RecipientStatisticsOverall = __webpack_require__(2217);
	
	var _RecipientStatisticsOverall2 = _interopRequireDefault(_RecipientStatisticsOverall);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasPermission = function hasPermission(_ref) {
	  var user = _ref.user,
	      permissionField = _ref.permissionField;
	  return permissionField ? (0, _get4.default)(user, ['rightMngt', permissionField]) : true;
	};
	
	var isUserTypeDenied = function isUserTypeDenied(_ref2) {
	  var user = _ref2.user,
	      _ref2$deniedUserTypes = _ref2.deniedUserTypes,
	      deniedUserTypes = _ref2$deniedUserTypes === undefined ? [] : _ref2$deniedUserTypes;
	  return deniedUserTypes.includes((0, _get4.default)(user, 'rightMngt.accType'));
	};
	
	var processRequireAuth = function processRequireAuth(_ref3) {
	  var user = _ref3.user,
	      permissionField = _ref3.permissionField,
	      deniedUserTypes = _ref3.deniedUserTypes,
	      replace = _ref3.replace;
	
	  if (!user) {
	    // oops, not logged in, so can't be here!
	    replace(_config2.default.app.defaultRedirectRoute);
	  } else if (!hasPermission({ user: user, permissionField: permissionField }) || isUserTypeDenied({ user: user, deniedUserTypes: deniedUserTypes })) {
	    replace(_config2.default.app.defaultUserRoute);
	  }
	};
	
	var processRequireGuest = function processRequireGuest(_ref4) {
	  var user = _ref4.user,
	      replace = _ref4.replace;
	
	  if (user) {
	    replace(_config2.default.app.defaultRedirectRoute);
	  }
	};
	
	exports.default = function (store) {
	  var requireRole = function requireRole(_ref5) {
	    var requireAuth = _ref5.requireAuth,
	        replace = _ref5.replace,
	        cb = _ref5.cb,
	        permissionField = _ref5.permissionField,
	        deniedUserTypes = _ref5.deniedUserTypes;
	
	    function checkAuth() {
	      var _store$getState = store.getState(),
	          user = _store$getState.auth.user;
	
	      if (requireAuth) {
	        processRequireAuth({ user: user, permissionField: permissionField, deniedUserTypes: deniedUserTypes, replace: replace });
	      } else {
	        processRequireGuest({ user: user, replace: replace });
	      }
	      cb();
	    }
	
	    if (!(0, _auth.isLoaded)(store.getState())) {
	      store.dispatch((0, _auth.load)()).promise.then(checkAuth).catch(checkAuth);
	    } else {
	      checkAuth();
	    }
	  };
	
	  var requireLogin = function requireLogin(nextState, replace, cb) {
	    requireRole({ requireAuth: true, nextState: nextState, replace: replace, cb: cb });
	  };
	
	  var requireGuest = function requireGuest(nextState, replace, cb) {
	    requireRole({ requireAuth: false, nextState: nextState, replace: replace, cb: cb });
	  };
	
	  var requireCreateProjectPermissions = function requireCreateProjectPermissions(nextState, replace, cb) {
	    var _nextState$params = nextState.params,
	        projectId = _nextState$params.projectId,
	        type = _nextState$params.type;
	
	    if (!Number(projectId)) {
	      var permissionField = (0, _permissions.getRawPermissionsTypesFields)().createProject[type];
	      requireRole({ requireAuth: true, nextState: nextState, replace: replace, cb: cb, permissionField: permissionField });
	    } else {
	      cb();
	    }
	  };
	
	  var requireQuickSendPermissions = function requireQuickSendPermissions(nextState, replace, cb) {
	    var permissionField = _permissions.permissionsMap.quickSendAccess;
	    requireRole({ requireAuth: true, nextState: nextState, replace: replace, cb: cb, permissionField: permissionField });
	  };
	
	  var requireProjectsPermissions = function requireProjectsPermissions(nextState, replace, cb) {
	    requireRole({ requireAuth: true, nextState: nextState, replace: replace, cb: cb, deniedUserTypes: _permissions.sectionDeniedUserTypes.projects });
	  };
	
	  var requireContactsPermissions = function requireContactsPermissions(nextState, replace, cb) {
	    requireRole({ requireAuth: true, nextState: nextState, replace: replace, cb: cb, deniedUserTypes: _permissions.sectionDeniedUserTypes.contacts });
	  };
	
	  /**
	   * Please keep routes in alphabetical order
	   */
	  return _react2.default.createElement(
	    _reactRouter.Route,
	    { path: '/', component: _containers.App, isLanding: true },
	    _react2.default.createElement(_reactRouter.IndexRoute, { components: { mainChild: _containers.Home } }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'home', components: { mainChild: _containers.Home }, isLanding: true }),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: 'service', components: { mainChild: _containers.Service } },
	      _react2.default.createElement(_reactRouter.Route, { path: 'confirm-email', components: { mainChild: _containers.EmailConfirm } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'download', components: { mainChild: _containers.Download } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: 'processing' },
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: 'cloudauth' },
	        _react2.default.createElement(_reactRouter.Route, { path: 'dropbox', components: { mainChild: _containers.DropboxAuth } }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'boxcom', components: { mainChild: _containers.BoxcomAuth } })
	      )
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: 'password', isLanding: true },
	      _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'reset' }),
	      _react2.default.createElement(_reactRouter.Route, { path: ':action', components: { mainChild: _containers.Home } })
	    ),
	    _react2.default.createElement(_reactRouter.Route, { path: 'login', components: { mainChild: _containers.Login }, onEnter: requireGuest }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'registration', components: { mainChild: _containers.Registration }, onEnter: requireGuest }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'contact-us', components: { mainChild: _containers.ContactUs } }),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: 'info', components: { mainChild: _containers.Info } },
	      _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'terms-of-service' }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'terms-of-service', components: { mainChild: _components.TermOfService } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'security', components: { mainChild: _components.Security } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'copyright-policy', components: { mainChild: _components.CopyrightPolicy } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'privacy-policy', components: { mainChild: _components.PrivacyPolicy } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'cookie-policy', components: { mainChild: _components.CookiePolicy } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'contact-us', components: { mainChild: _components.ContactUsInfo } })
	    ),
	    _react2.default.createElement(_reactRouter.Route, { path: 'playlists/fromkey/:key', components: { mainChild: _containers.Playlist } }),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { onEnter: requireLogin },
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: 'playlists' },
	        _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'all' }),
	        _react2.default.createElement(_reactRouter.Route, { path: ':projectType', components: { mainChild: _containers.Playlists } }),
	        _react2.default.createElement(_reactRouter.Route, { path: ':projectId/:recipientId', components: { mainChild: _containers.Playlist } })
	      ),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: 'my-playlists' },
	        _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'all' }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'all', components: { mainChild: _containers.MyPlaylists } }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'new', components: { mainChild: _containers.MyPlaylist } }),
	        _react2.default.createElement(_reactRouter.Route, { path: ':myPlaylistId', components: { mainChild: _containers.MyPlaylist } })
	      ),
	      _react2.default.createElement(_reactRouter.Route, { path: 'account', components: { mainChild: _containers.Account } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'projects/new', components: { mainChild: _containers.NewProject } }),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: 'projects', onEnter: requireProjectsPermissions },
	        _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'all' }),
	        _react2.default.createElement(_reactRouter.Route, { path: ':type', components: { mainChild: _containers.Projects } }),
	        _react2.default.createElement(
	          _reactRouter.Route,
	          { path: ':type/:projectId', onEnter: requireCreateProjectPermissions },
	          _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'info' }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'info', components: { mainChild: _containers.ProjectInfo } }),
	          _react2.default.createElement(_reactRouter.Redirect, { from: '/projects/:type/0/*', to: '/projects' }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'materials', components: { mainChild: _containers.ProjectMaterials } }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'recipients', components: { mainChild: _containers.ProjectRecipients } }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'confirmation', components: { mainChild: _containers.ProjectConfirmation } }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'create', components: { mainChild: _containers.ProjectCreateFromSS } }),
	          _react2.default.createElement(
	            _reactRouter.Route,
	            { path: 'report' },
	            _react2.default.createElement(_reactRouter.IndexRoute, { components: { mainChild: _containers.ProjectReport } }),
	            _react2.default.createElement(_reactRouter.Route, { path: ':recipientId', components: { mainChild: _containers.ProjectRecipientReport } })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: 'statistics', components: { mainChild: _Statistics2.default } },
	        _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'project' }),
	        _react2.default.createElement(
	          _reactRouter.Route,
	          { path: 'project', referrer: 'project' },
	          _react2.default.createElement(_reactRouter.IndexRoute, { components: { component: _StatisticsProjects2.default } }),
	          _react2.default.createElement(
	            _reactRouter.Route,
	            { path: ':projectId', components: { component: _ProjectStatistics2.default } },
	            _react2.default.createElement(_reactRouter.IndexRoute, { components: { component: _ProjectStatisticsOverall2.default } }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'details', components: { component: _ProjectDetailsStatistics2.default } }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'recipient/:recipientId', components: { component: _ProjectRecipientStatistics2.default } })
	          )
	        ),
	        _react2.default.createElement(
	          _reactRouter.Route,
	          { path: 'recipient', referrer: 'recipient' },
	          _react2.default.createElement(_reactRouter.IndexRoute, { components: { component: _StatisticsRecipients2.default } }),
	          _react2.default.createElement(
	            _reactRouter.Route,
	            { path: ':recipientId', components: { component: _RecipientStatistics2.default } },
	            _react2.default.createElement(_reactRouter.IndexRoute, { components: { component: _RecipientStatisticsOverall2.default } }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'project/:projectId', components: { component: _ProjectRecipientStatistics2.default } })
	          )
	        ),
	        _react2.default.createElement(_reactRouter.Route, { path: 'devices', components: { component: _DevicesStatistics2.default } })
	      ),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: 'quick-send', onEnter: requireQuickSendPermissions },
	        _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'inbox' }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'new', components: { mainChild: _containers.QuickSendNew } }),
	        _react2.default.createElement(
	          _reactRouter.Route,
	          { path: ':type', components: { mainChild: _containers.QuickSend } },
	          _react2.default.createElement(_reactRouter.IndexRoute, { components: { mainChild: _containers.QuickSendItem } }),
	          _react2.default.createElement(_reactRouter.Route, { path: ':qsId', components: { mainChild: _containers.QuickSendItem } })
	        )
	      ),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: 'contacts', onEnter: requireContactsPermissions },
	        _react2.default.createElement(_reactRouter.IndexRoute, { components: { mainChild: _containers.Contacts } }),
	        _react2.default.createElement(
	          _reactRouter.Route,
	          { path: 'groups' },
	          _react2.default.createElement(_reactRouter.IndexRoute, { components: { mainChild: _containers.Groups } }),
	          _react2.default.createElement(_reactRouter.Route, { path: ':groupId', components: { mainChild: _containers.GroupContacts } })
	        )
	      )
	    ),
	    _react2.default.createElement(_reactRouter.Route, { path: '*', components: { mainChild: _containers.NotFound }, status: 404 })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),
/* 2242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(102);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.boxSelect = boxSelect;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable */
	
	function boxSelect() {
	  var BoxSelect = {};
	
	  /**
	   * Box.com doesn't have node package for BoxSelect widget
	   * File downloaded from https://app.box.com/js/static/select.js and 'window.BoxSelect' replaced to 'BoxSelect'
	   */
	  (function () {
	    var BROWSER_IS_NOT_SUPPORTED = 'Your browser is not supported';var CLIENT_ID_NOT_FOUND = 'The client id must be included';var INVALID_LINK_TYPE_OPTION = 'The link-type option must be "direct" or "shared"';var INVALID_MULTISELECT_OPTION = 'The multiselect option must be "true" or "false"';var INVALID_OPTION_TESTMODE = 'Invalid option "testmode"';var POPUP_CLOSE_DETECTION_INTERVAL = 1000;var rvalidchars = /^[\],:{}\s]*$/;var rvalidescape = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g;var rvalidtokens = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;var rvalidbraces = /(?:^|:|,)(?:\s*\[)+/g;var rvalidBoxDomains = /(https:\/\/([a-zA-Z0-9-]+\.)?(app\.box\.com|app\.boxcn\.net|ent\.box\.com)((\/.*)?))/i;var rvalidTestDomains = /(https:\/\/([a-zA-Z0-9-]+\.)?(app\.[A-Za-z0-9]+\.inside-box\.net)((\/.*)?))/i;var windowConfiguration = { height: 520, width: 590 };var booleanOptionNames = ['multiselect', 'testMode'];var boxSelectId = 1;function indexOf(array, value) {
	      for (var i = 0; i < array.length; i++) {
	        if (array[i] === value) {
	          return i;
	        }
	      }
	      return -1;
	    }
	    function validateOptions(options) {
	      var validationErrors = [];var type = '';if (!options.clientId) {
	        validationErrors.push(CLIENT_ID_NOT_FOUND);
	      }
	      if (!options.linkType || !(options.linkType === 'direct' || options.linkType === 'shared')) {
	        validationErrors.push(INVALID_LINK_TYPE_OPTION);
	      }
	      if (options.multiselect !== undefined && options.multiselect !== null) {
	        type = (0, _typeof3.default)(options.multiselect);if (type === 'boolean' || type === 'string') {
	          if (type === 'string' && !(options.multiselect === 'true' || options.multiselect === 'false')) {
	            validationErrors.push(INVALID_MULTISELECT_OPTION);
	          }
	        } else {
	          validationErrors.push(INVALID_MULTISELECT_OPTION);
	        }
	      }
	      if (options.testMode !== undefined && options.testMode !== null) {
	        type = (0, _typeof3.default)(options.testMode);if (type === 'boolean' || type === 'string') {
	          if (type === 'string' && !(options.testMode === 'true' || options.testMode === 'false')) {
	            validationErrors.push(INVALID_OPTION_TESTMODE);
	          }
	        } else {
	          validationErrors.push(INVALID_OPTION_TESTMODE);
	        }
	      }
	      return validationErrors;
	    }
	    function isValidEventOrigin(origin) {
	      return origin && (rvalidBoxDomains.test(origin) || rvalidTestDomains.test(origin));
	    }
	    function parseJSON(data) {
	      if (!data || typeof data !== 'string') {
	        return null;
	      }
	      try {
	        if (window.JSON && window.JSON.parse) {
	          return window.JSON.parse(data);
	        }
	        if (rvalidchars.test(data.replace(rvalidescape, '@').replace(rvalidtokens, ']').replace(rvalidbraces, ''))) {
	          return new Function('return ' + data)();
	        }
	      } catch (e) {}
	      return null;
	    }
	    BoxSelect = function BoxSelect(userOptions) {
	      var button;var proxy;var popup;var stylesheet;var eventCallbacks = {};var monitoringPopupClose = false;var configuredOptions = { clientId: '', linkType: 'direct', multiselect: true, headerPrompt: '', domain: 'https://app.box.com', testMode: false, navigator: navigator };var pickerId = boxSelectId++;function configureOptions(options) {
	        for (var optionName in options) {
	          if (options.hasOwnProperty(optionName) && options[optionName] !== null) {
	            var value = options[optionName];if (indexOf(booleanOptionNames, optionName) != -1 && typeof value === 'string') {
	              value = options[optionName] === 'true';
	            }
	            configuredOptions[optionName] = value;
	          }
	        }
	      }
	      function parseOptions(userButton) {
	        var parsedOptions = { clientId: userButton.getAttribute('data-client-id'), linkType: userButton.getAttribute('data-link-type'), multiselect: userButton.getAttribute('data-multiselect'), headerPrompt: userButton.getAttribute('data-header-prompt'), domain: userButton.getAttribute('data-domain'), testMode: userButton.getAttribute('data-testmode') };var validationErrors = validateOptions(parsedOptions);if (validationErrors.length === 0) {
	          configureOptions(parsedOptions);
	        }
	        return validationErrors;
	      }
	      function setOptions(options) {
	        options = options || {};var validationErrors = validateOptions(options);if (validationErrors.length === 0) {
	          configureOptions(options);
	        }
	        return validationErrors;
	      }
	      function findButton() {
	        if (button) {
	          return button;
	        }
	        button = document.getElementById('box-select');return button;
	      }
	      function createButton() {
	        if (button) {
	          return button;
	        }
	        button = document.createElement('div');button.className = 'box-select';return button;
	      }
	      function launchPopupDirectly() {
	        if (popup && !popup.closed) {
	          popup.focus();return false;
	        }
	        var name = '';var url = configuredOptions.domain + '/index.php?rm=box_select_view';url += '&client_id=' + configuredOptions.clientId;url += '&link_type=' + configuredOptions.linkType;url += '&multiselect=' + configuredOptions.multiselect;if (configuredOptions.headerPrompt) {
	          url += '&header_prompt=' + encodeURIComponent(configuredOptions.headerPrompt);
	        }
	        url += '&picker_id=' + pickerId;var specs = getWindowSpecs();popup = window.open(url, name, specs);detectPopupClose();return true;
	      }
	      function launchPopupViaProxy() {
	        if (proxy) {
	          return false;
	        }
	        proxy = document.createElement('iframe');var url = configuredOptions.domain + '/index.php?rm=box_select_proxy';url += '&client_id=' + configuredOptions.clientId;url += '&link_type=' + configuredOptions.linkType;url += '&multiselect=' + configuredOptions.multiselect;if (configuredOptions.headerPrompt) {
	          url += '&header_prompt=' + encodeURIComponent(configuredOptions.headerPrompt);
	        }
	        url += '&picker_id=' + pickerId;proxy.src = url;proxy.height = '0px';proxy.width = '0px';document.body.appendChild(proxy);return true;
	      }
	      function removeProxyFrame() {
	        if (proxy) {
	          proxy.parentNode.removeChild(proxy);proxy = null;
	        }
	      }
	      function notifyCancelListeners() {
	        if (eventCallbacks[object.CANCEL_EVENT_TYPE]) {
	          var listeners = eventCallbacks[object.CANCEL_EVENT_TYPE];for (var i = 0; i < listeners.length; i++) {
	            listeners[i]();
	          }
	        }
	      }
	      function checkPopupClosed() {
	        if (monitoringPopupClose) {
	          if (popup.closed) {
	            notifyCancelListeners();
	          } else {
	            detectPopupClose();
	          }
	        }
	      }
	      function detectPopupClose() {
	        monitoringPopupClose = true;if (popup && !popup.closed) {
	          window.setTimeout(checkPopupClosed, POPUP_CLOSE_DETECTION_INTERVAL);
	        }
	      }
	      function getWindowSpecs() {
	        var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;var width = screen.width;if (window.innerWidth) {
	          width = window.innerWidth;
	        } else if (document.documentElement.clientWidth) {
	          width = document.documentElement.clientWidth;
	        }
	        var height = screen.height;if (window.innerHeight) {
	          height = window.innerHeight;
	        } else if (document.documentElement.clientHeight) {
	          height = document.documentElement.clientHeight;
	        }
	        var left = width / 2 - windowConfiguration.width / 2 + dualScreenLeft;var top = height / 2 - windowConfiguration.height / 2 + dualScreenTop;left = left > 0 ? left : 0;top = top > 0 ? top : 0;var specs = 'width=' + windowConfiguration.width + ',height=' + windowConfiguration.height + ',top=' + top + ',left=' + left;return specs;
	      }
	      function receiveEventFromPopup(event) {
	        if (event.data) {
	          var data = parseJSON(event.data);var origin = event.origin || event.originalEvent.origin;if (isValidEventOrigin(origin)) {
	            if (data && (data.eventType === object.SUCCESS_EVENT_TYPE || data.eventType === object.CANCEL_EVENT_TYPE) && parseInt(data.pickerId, 10) === pickerId) {
	              if (eventCallbacks[data.eventType]) {
	                var listeners = eventCallbacks[data.eventType];for (var i = 0; i < listeners.length; i++) {
	                  if (data.eventType === object.SUCCESS_EVENT_TYPE) {
	                    listeners[i](data.links);
	                  } else {
	                    listeners[i]();
	                  }
	                }
	              }
	              object.closePopup();
	            }
	          }
	        }
	      }
	      function subscribeToEventsFromPopup() {
	        var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';var eventer = window[eventMethod];var messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';eventer(messageEvent, receiveEventFromPopup, false);
	      }
	      function unsubscribeToEventsFromPopup() {
	        var eventMethod = window.addEventListener ? 'removeEventListener' : 'detachEvent';var eventer = window[eventMethod];var messageEvent = eventMethod === 'detachEvent' ? 'onmessage' : 'message';eventer(messageEvent, receiveEventFromPopup, false);
	      }
	      function addEventCallback(eventType, callback) {
	        if (typeof callback === 'function') {
	          eventCallbacks[eventType] = eventCallbacks[eventType] || [];eventCallbacks[eventType].push(callback);return true;
	        }
	        return false;
	      }
	      function isMSIEInternetExplorer() {
	        var ua = configuredOptions.navigator.userAgent;var msieRe = new RegExp('MSIE');var operaRe = new RegExp('Opera');return msieRe.test(ua) && !operaRe.test(ua);
	      }
	      function isTridentInternetExplorer() {
	        var ua = configuredOptions.navigator.userAgent;var tridentRe = new RegExp('Trident');return tridentRe.test(ua);
	      }
	      function isInternetExplorer() {
	        return isMSIEInternetExplorer() || isTridentInternetExplorer();
	      }
	      function getInternetExplorerVersion() {
	        var ua = configuredOptions.navigator.userAgent;if (isMSIEInternetExplorer()) {
	          var msieRe = new RegExp('MSIE ([0-9]{1,}[\.0-9]{0,})');if (msieRe.exec(ua) !== null) {
	            return parseFloat(RegExp.$1);
	          }
	        } else if (isTridentInternetExplorer()) {
	          var rvRe = new RegExp('rv:([0-9]{1,}[\.0-9]{0,})');if (rvRe.exec(ua) !== null) {
	            return parseFloat(RegExp.$1);
	          }
	        }
	        return -1;
	      }
	      function injectStylesheet() {
	        if (stylesheet) {
	          return;
	        }
	        stylesheet = document.getElementById('box-select-stylesheet');if (stylesheet) {
	          return;
	        }
	        stylesheet = document.createElement('style');stylesheet.type = 'text/css';stylesheet.id = 'box-select-stylesheet';var rules = '';rules += '#box-select, .box-select { ' + 'width: 160px; ' + 'height: 42px; ' + 'border: none; ' + 'cursor: pointer; ' + 'background: url(\'https://app.box.com/img/box_select/Item_Selector_Button_Sprites.png\') no-repeat;' + 'background-position: -50px -100px; ' + '}';rules += '#box-select:hover, .box-select:hover { ' + 'background-position: -50px -50px ; ' + '}';rules += '#box-select:active, .box-select:active { ' + 'background-position: -50px 0;' + '}';rules += '#box-select.not-supported, .box-select.not-supported { ' + 'zoom: 1;' + 'filter: alpha(opacity=30);' + 'opacity: 0.3;' + '}';if (stylesheet.styleSheet) {
	          stylesheet.styleSheet.cssText = rules;
	        } else {
	          stylesheet.textContent = rules;
	        }
	        document.getElementsByTagName('head')[0].appendChild(stylesheet);
	      }
	      function render(validationErrors, isBrowserSupported) {
	        if (validationErrors.length > 0 || !isBrowserSupported) {
	          button.disabled = true;button.className += ' not-supported';if (!isBrowserSupported) {
	            button.title = BROWSER_IS_NOT_SUPPORTED;
	          } else {
	            button.title = validationErrors[0];
	          }
	        }
	        injectStylesheet();button.onclick = object.launchPopup;
	      }
	      function init(options) {
	        button = findButton();var validationErrors = [];if (button) {
	          validationErrors = parseOptions(button);
	        } else {
	          validationErrors = setOptions(options);button = createButton();
	        }
	        if (configuredOptions.testMode) {
	          rvalidTestDomains = /((https:\/\/(.+?\.)?(app\.[A-Za-z0-9]+\.inside-box\.net))|(https?:\/\/(.+?\.)?(localhost))((\/.*)?))/i;
	        }
	        var isBrowserSupported = object.isBrowserSupported();render(validationErrors, isBrowserSupported);subscribeToEventsFromPopup();
	      }
	      var object = { SUCCESS_EVENT_TYPE: 'BoxSelect:Success', CANCEL_EVENT_TYPE: 'BoxSelect:Cancel', closePopup: function closePopup() {
	          if (popup) {
	            popup.close();monitoringPopupClose = false;
	          }
	          removeProxyFrame();
	        }, success: function success(callback) {
	          return addEventCallback(object.SUCCESS_EVENT_TYPE, callback);
	        }, cancel: function cancel(callback) {
	          return addEventCallback(object.CANCEL_EVENT_TYPE, callback);
	        }, unregister: function unregister(eventType, callback) {
	          var unregistered = false;if (typeof callback === 'function') {
	            var callbacks = eventCallbacks[eventType] || [];eventCallbacks[eventType] = [];for (var i = 0; i < callbacks.length; i++) {
	              if (callbacks[i] !== callback) {
	                eventCallbacks[eventType].push(callbacks[i]);
	              } else {
	                unregistered = true;
	              }
	            }
	          } else if (eventCallbacks[eventType]) {
	            eventCallbacks[eventType] = [];unregistered = true;
	          }
	          return unregistered;
	        }, isBrowserSupported: function isBrowserSupported() {
	          return !isInternetExplorer() || getInternetExplorerVersion() >= 8.0;
	        }, launchPopup: function launchPopup() {
	          if (isInternetExplorer()) {
	            return launchPopupViaProxy();
	          } else {
	            return launchPopupDirectly();
	          }
	        }, getButton: function getButton() {
	          return button;
	        }, _destroy: function _destroy() {
	          unsubscribeToEventsFromPopup();
	        } };init(userOptions);return object;
	    };
	  })();
	
	  return BoxSelect;
	}

/***/ }),
/* 2243 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  AD: 'AndorrA',
	  AE: 'United Arab Emirates',
	  AF: 'Afghanistan',
	  AG: 'Antigua and Barbuda',
	  AI: 'Anguilla',
	  AL: 'Albania',
	  AM: 'Armenia',
	  AN: 'Netherlands Antilles',
	  AO: 'Angola',
	  AQ: 'Antarctica',
	  AR: 'Argentina',
	  AS: 'American Samoa',
	  AT: 'Austria',
	  AU: 'Australia',
	  AW: 'Aruba',
	  AX: 'land Islands',
	  AZ: 'Azerbaijan',
	  BA: 'Bosnia and Herzegovina',
	  BB: 'Barbados',
	  BD: 'Bangladesh',
	  BE: 'Belgium',
	  BF: 'Burkina Faso',
	  BG: 'Bulgaria',
	  BH: 'Bahrain',
	  BI: 'Burundi',
	  BJ: 'Benin',
	  BM: 'Bermuda',
	  BN: 'Brunei Darussalam',
	  BO: 'Bolivia',
	  BR: 'Brazil',
	  BS: 'Bahamas',
	  BT: 'Bhutan',
	  BV: 'Bouvet Island',
	  BW: 'Botswana',
	  BY: 'Belarus',
	  BZ: 'Belize',
	  CA: 'Canada',
	  CC: 'Cocos (Keeling) Islands',
	  CD: 'Congo, The Democratic Republic of the',
	  CF: 'Central African Republic',
	  CG: 'Congo',
	  CH: 'Switzerland',
	  CI: 'Cote D\'Ivoire',
	  CK: 'Cook Islands',
	  CL: 'Chile',
	  CM: 'Cameroon',
	  CN: 'China',
	  CO: 'Colombia',
	  CR: 'Costa Rica',
	  CU: 'Cuba',
	  CV: 'Cape Verde',
	  CX: 'Christmas Island',
	  CY: 'Cyprus',
	  CZ: 'Czech Republic',
	  DE: 'Germany',
	  DJ: 'Djibouti',
	  DK: 'Denmark',
	  DM: 'Dominica',
	  DO: 'Dominican Republic',
	  DZ: 'Algeria',
	  EC: 'Ecuador',
	  EE: 'Estonia',
	  EG: 'Egypt',
	  EH: 'Western Sahara',
	  ER: 'Eritrea',
	  ES: 'Spain',
	  ET: 'Ethiopia',
	  FI: 'Finland',
	  FJ: 'Fiji',
	  FK: 'Falkland Islands (Malvinas)',
	  FM: 'Micronesia, Federated States of',
	  FO: 'Faroe Islands',
	  FR: 'France',
	  GA: 'Gabon',
	  GB: 'United Kingdom',
	  GD: 'Grenada',
	  GE: 'Georgia',
	  GF: 'French Guiana',
	  GG: 'Guernsey',
	  GH: 'Ghana',
	  GI: 'Gibraltar',
	  GL: 'Greenland',
	  GM: 'Gambia',
	  GN: 'Guinea',
	  GP: 'Guadeloupe',
	  GQ: 'Equatorial Guinea',
	  GR: 'Greece',
	  GS: 'South Georgia and the South Sandwich Islands',
	  GT: 'Guatemala',
	  GU: 'Guam',
	  GW: 'Guinea-Bissau',
	  GY: 'Guyana',
	  HK: 'Hong Kong',
	  HM: 'Heard Island and Mcdonald Islands',
	  HN: 'Honduras',
	  HR: 'Croatia',
	  HT: 'Haiti',
	  HU: 'Hungary',
	  ID: 'Indonesia',
	  IE: 'Ireland',
	  IL: 'Israel',
	  IM: 'Isle of Man',
	  IN: 'India',
	  IO: 'British Indian Ocean Territory',
	  IQ: 'Iraq',
	  IR: 'Iran, Islamic Republic Of',
	  IS: 'Iceland',
	  IT: 'Italy',
	  JE: 'Jersey',
	  JM: 'Jamaica',
	  JO: 'Jordan',
	  JP: 'Japan',
	  KE: 'Kenya',
	  KG: 'Kyrgyzstan',
	  KH: 'Cambodia',
	  KI: 'Kiribati',
	  KM: 'Comoros',
	  KN: 'Saint Kitts and Nevis',
	  KP: 'Korea, Democratic People\'S Republic of',
	  KR: 'Korea, Republic of',
	  KW: 'Kuwait',
	  KY: 'Cayman Islands',
	  KZ: 'Kazakhstan',
	  LA: 'Lao People\'S Democratic Republic',
	  LB: 'Lebanon',
	  LC: 'Saint Lucia',
	  LI: 'Liechtenstein',
	  LK: 'Sri Lanka',
	  LR: 'Liberia',
	  LS: 'Lesotho',
	  LT: 'Lithuania',
	  LU: 'Luxembourg',
	  LV: 'Latvia',
	  LY: 'Libyan Arab Jamahiriya',
	  MA: 'Morocco',
	  MC: 'Monaco',
	  MD: 'Moldova, Republic of',
	  ME: 'Montenegro',
	  MG: 'Madagascar',
	  MH: 'Marshall Islands',
	  MK: 'Macedonia, The Former Yugoslav Republic of',
	  ML: 'Mali',
	  MM: 'Myanmar',
	  MN: 'Mongolia',
	  MO: 'Macao',
	  MP: 'Northern Mariana Islands',
	  MQ: 'Martinique',
	  MR: 'Mauritania',
	  MS: 'Montserrat',
	  MT: 'Malta',
	  MU: 'Mauritius',
	  MV: 'Maldives',
	  MW: 'Malawi',
	  MX: 'Mexico',
	  MY: 'Malaysia',
	  MZ: 'Mozambique',
	  NA: 'Namibia',
	  NC: 'New Caledonia',
	  NE: 'Niger',
	  NF: 'Norfolk Island',
	  NG: 'Nigeria',
	  NI: 'Nicaragua',
	  NL: 'Netherlands',
	  NO: 'Norway',
	  NP: 'Nepal',
	  NR: 'Nauru',
	  NU: 'Niue',
	  NZ: 'New Zealand',
	  OM: 'Oman',
	  PA: 'Panama',
	  PE: 'Peru',
	  PF: 'French Polynesia',
	  PG: 'Papua New Guinea',
	  PH: 'Philippines',
	  PK: 'Pakistan',
	  PL: 'Poland',
	  PM: 'Saint Pierre and Miquelon',
	  PN: 'Pitcairn',
	  PR: 'Puerto Rico',
	  PS: 'Palestinian Territory, Occupied',
	  PT: 'Portugal',
	  PW: 'Palau',
	  PY: 'Paraguay',
	  QA: 'Qatar',
	  RE: 'Reunion',
	  RO: 'Romania',
	  RS: 'Serbia',
	  RU: 'Russian Federation',
	  RW: 'RWANDA',
	  SA: 'Saudi Arabia',
	  SB: 'Solomon Islands',
	  SC: 'Seychelles',
	  SD: 'Sudan',
	  SE: 'Sweden',
	  SG: 'Singapore',
	  SH: 'Saint Helena',
	  SI: 'Slovenia',
	  SJ: 'Svalbard and Jan Mayen',
	  SK: 'Slovakia',
	  SL: 'Sierra Leone',
	  SM: 'San Marino',
	  SN: 'Senegal',
	  SO: 'Somalia',
	  SR: 'Suriname',
	  ST: 'Sao Tome and Principe',
	  SV: 'El Salvador',
	  SY: 'Syrian Arab Republic',
	  SZ: 'Swaziland',
	  TC: 'Turks and Caicos Islands',
	  TD: 'Chad',
	  TF: 'French Southern Territories',
	  TG: 'Togo',
	  TH: 'Thailand',
	  TJ: 'Tajikistan',
	  TK: 'Tokelau',
	  TL: 'Timor-Leste',
	  TM: 'Turkmenistan',
	  TN: 'Tunisia',
	  TO: 'Tonga',
	  TR: 'Turkey',
	  TT: 'Trinidad and Tobago',
	  TV: 'Tuvalu',
	  TW: 'Taiwan, Province of China',
	  TZ: 'Tanzania, United Republic of',
	  UA: 'Ukraine',
	  UG: 'Uganda',
	  UM: 'United States Minor Outlying Islands',
	  US: 'United States',
	  UY: 'Uruguay',
	  UZ: 'Uzbekistan',
	  VA: 'Holy See (Vatican City State)',
	  VC: 'Saint Vincent and the Grenadines',
	  VE: 'Venezuela',
	  VG: 'Virgin Islands, British',
	  VI: 'Virgin Islands, U.S.',
	  VN: 'Viet Nam',
	  VU: 'Vanuatu',
	  WF: 'Wallis and Futuna',
	  WS: 'Samoa',
	  YE: 'Yemen',
	  YT: 'Mayotte',
	  ZA: 'South Africa',
	  ZM: 'Zambia',
	  ZW: 'Zimbabwe'
	};
	module.exports = exports['default'];

/***/ }),
/* 2244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dropbox = dropbox;
	
	var _dropboxDropins = __webpack_require__(2245);
	
	var _dropboxDropins2 = _interopRequireDefault(_dropboxDropins);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function dropbox() {
	  return (0, _dropboxDropins2.default)();
	}

/***/ }),
/* 2245 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(102);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _stringify = __webpack_require__(365);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	exports.default = dropins;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable */
	
	/**
	 * Dropbox doesn't have node package
	 * File downloaded from https://www.dropbox.com/static/api/2/dropins.js and 'window.Dropbox' replaced to 'Dropbox'
	 */
	function dropins() {
	  var Dropbox = {};
	  var dropins = function () {
	    var e,
	        _o,
	        n,
	        t,
	        r,
	        i,
	        s,
	        a,
	        l,
	        c,
	        d,
	        p,
	        u,
	        f,
	        b,
	        m,
	        x,
	        g,
	        h,
	        w,
	        y,
	        v,
	        D,
	        k,
	        _,
	        E,
	        S,
	        C,
	        N,
	        L = [].slice,
	        U = [].indexOf || function (e) {
	      for (var o = 0, n = this.length; n > o; o++) {
	        if (o in this && this[o] === e) return o;
	      }return -1;
	    };return null == Dropbox && (Dropbox = {}), null == Dropbox.baseUrl && (Dropbox.baseUrl = "https://www.dropbox.com"), null == Dropbox.blockBaseUrl && (Dropbox.blockBaseUrl = "https://dl.dropbox.com"), Dropbox.addListener = function (e, o, n) {
	      e.addEventListener ? e.addEventListener(o, n, !1) : e.attachEvent("on" + o, function (e) {
	        return e.preventDefault = function () {
	          return this.returnValue = !1;
	        }, n(e);
	      });
	    }, Dropbox.removeListener = function (e, o, n) {
	      e.removeEventListener ? e.removeEventListener(o, n, !1) : e.detachEvent("on" + o, n);
	    }, r = function r(e) {
	      var o, n;return n = encodeURIComponent(Dropbox.VERSION), o = -1 === e.indexOf("?") ? "?" : "&", "" + e + o + "version=" + n;
	    }, s = function s(e, o) {
	      var n, t, i, s, a, l, c, d, p;return l = encodeURIComponent(window.location.protocol + "//" + window.location.host), n = encodeURIComponent(Dropbox.appKey), s = encodeURIComponent(e.linkType || ""), d = encodeURIComponent(e._trigger || "js"), a = Boolean(e.multiselect), t = encodeURIComponent((null != (c = e.extensions) && "function" == typeof c.join ? c.join(" ") : void 0) || ""), i = Boolean(e.folderselect), o = Boolean(o), p = Dropbox.baseUrl + "/chooser?origin=" + l + "&app_key=" + n + "&link_type=" + s, p += "&trigger=" + d + "&multiselect=" + a + "&extensions=" + t + "&folderselect=" + i + "&iframe=" + o, r(p);
	    }, C = function C() {
	      var e, o, n;return o = encodeURIComponent(window.location.protocol + "//" + window.location.host), e = encodeURIComponent(Dropbox.appKey), n = Dropbox.baseUrl + "/saver?origin=" + o + "&app_key=" + e, r(n);
	    }, y = 1, m = function m(e, o) {
	      var n, t, i, s;if (n = encodeURIComponent(Dropbox.appKey), s = Dropbox.baseUrl + "/dropins/job_status?job=" + o + "&app_key=" + n, s = r(s), i = function i(o) {
	        var n;"COMPLETE" === o.status ? ("function" == typeof e.progress && e.progress(1), "function" == typeof e.success && e.success()) : "PENDING" === (n = o.status) || "DOWNLOADING" === n ? (null != o.progress && "function" == typeof e.progress && e.progress(o.progress / 100), setTimeout(t, 1500)) : "FAILED" === o.status && "function" == typeof e.error && e.error(o.error);
	      }, "withCredentials" in new XMLHttpRequest()) t = function t() {
	        var o;return o = new XMLHttpRequest(), o.onload = function () {
	          return i(JSON.parse(o.responseText));
	        }, o.onerror = function () {
	          return "function" == typeof e.error ? e.error() : void 0;
	        }, o.open("GET", s, !0), o.send();
	      };else if (Dropbox.disableJSONP) {
	        if ("undefined" == typeof XDomainRequest || null === XDomainRequest || "https:" !== document.location.protocol) throw new Error("Unable to find suitable means of cross domain communication");t = function t() {
	          var o;return o = new XDomainRequest(), o.onload = function () {
	            return i(JSON.parse(o.responseText));
	          }, o.onerror = function () {
	            return "function" == typeof e.error ? e.error() : void 0;
	          }, o.open("get", s), o.send();
	        };
	      } else t = function t() {
	        var o, n, t;return o = "DropboxJsonpCallback" + y++, n = !1, window[o] = function (e) {
	          return n = !0, i(e);
	        }, t = document.createElement("script"), t.src = s + "&callback=" + o, t.onreadystatechange = function () {
	          var o;return "loaded" === t.readyState ? (n || "function" == typeof e.error && e.error(), null != (o = t.parentNode) ? o.removeChild(t) : void 0) : void 0;
	        }, document.getElementsByTagName("head")[0].appendChild(t);
	      };return "function" == typeof e.progress && e.progress(0), t();
	    }, x = function x(e, o, n) {
	      var t, r, i, s, a, l;switch (r = JSON.parse(e.data), i = "undefined" != typeof g && null !== g && n._popup ? g.contentWindow : e.source, r.method) {case "origin_request":
	          e.source.postMessage((0, _stringify2.default)({ method: "origin" }), Dropbox.baseUrl);break;case "ready":
	          null != n.files && (n._fetch_url_on_save ? (l = function () {
	            var e, o, t, r;for (t = n.files, r = [], e = 0, o = t.length; o > e; e++) {
	              s = t[e], r.push({ filename: s.filename });
	            }return r;
	          }(), a = (0, _stringify2.default)({ method: "files_with_callback", params: l })) : a = (0, _stringify2.default)({ method: "files", params: n.files }), i.postMessage(a, Dropbox.baseUrl)), "function" == typeof n.ready && n.ready();break;case "files_selected":case "files_saved":
	          "function" == typeof o && o(), "function" == typeof n.success && n.success(r.params);break;case "progress":
	          "function" == typeof n.progress && n.progress(r.params);break;case "close_dialog":
	          "function" == typeof o && o(), "function" == typeof n.cancel && n.cancel();break;case "web_session_error":
	          "function" == typeof o && o(), "function" == typeof n.webSessionFailure && n.webSessionFailure();break;case "web_session_unlinked":
	          "function" == typeof o && o(), "function" == typeof n.webSessionUnlinked && n.webSessionUnlinked();break;case "resize":
	          "function" == typeof n.resize && n.resize(r.params);break;case "error":
	          "function" == typeof o && o(), "function" == typeof n.error && n.error(r.params);break;case "job_id":
	          "function" == typeof o && o(), m(n, r.params);break;case "save_callback":
	          t = function t(e) {
	            if (null == e) throw new Error("Please supply {urls: [...]} to success callback");if (null != e.url && null != e.urls) throw new Error("Do not pass both url and urls to the save callback");if (null != e.url && (e.urls = [e.url]), null == e.urls) throw new Error("Please supply {urls: [...]} to success callback");r = { method: "continue_saving", params: { download_urls: e.urls } }, i.postMessage((0, _stringify2.default)(r), Dropbox.baseUrl);
	          }, u(n, r.params, t);break;case "_debug_log":
	          "undefined" != typeof console && null !== console && console.log(r.params.msg);}
	    }, u = function u(e, o, n) {
	      var t;e._fetch_url_on_save && (t = e.fetch_urls_fn, "function" != typeof t && "function" == typeof e.error && e.error("Something went wrong, file url callback not provided."), t(n, o));
	    }, g = null, l = function l() {
	      /\bTrident\b/.test(navigator.userAgent) && null != document.body && null == g && (g = document.createElement("iframe"), g.setAttribute("id", "dropbox_xcomm"), g.setAttribute("src", Dropbox.baseUrl + "/static/api/1/xcomm.html"), g.style.display = "none", document.body.appendChild(g));
	    }, Dropbox.createChooserWidget = function (e) {
	      var o;return o = c(s(e, !0)), o._handler = function (n) {
	        n.source === o.contentWindow && n.origin === Dropbox.baseUrl && x(n, null, e);
	      }, Dropbox.addListener(window, "message", o._handler), o;
	    }, Dropbox.cleanupWidget = function (e) {
	      if (!e._handler) throw new Error("Invalid widget!");Dropbox.removeListener(window, "message", e._handler), delete e._handler;
	    }, _ = function _(e, o) {
	      var n, t;return n = (window.screenX || window.screenLeft) + ((window.outerWidth || document.documentElement.offsetWidth) - e) / 2, t = (window.screenY || window.screenTop) + ((window.outerHeight || document.documentElement.offsetHeight) - o) / 2, "width=" + e + ",height=" + o + ",left=" + n + ",top=" + t;
	    }, Dropbox._dropinsjs_loaded ? void ("undefined" != typeof console && null !== console && "function" == typeof console.warn && console.warn("dropins.js included more than once")) : (Dropbox._dropinsjs_loaded = !0, null == Dropbox.appKey && (Dropbox.appKey = null != (E = document.getElementById("dropboxjs")) ? E.getAttribute("data-app-key") : void 0), t = function t(e) {
	      return e;
	    }, e = "https://www.dropbox.com/developers/dropins/chooser/js", n = ["text", "documents", "images", "video", "audio"], Dropbox.init = function (e) {
	      null != e.translation_function && (t = e.translation_function), null != e.appKey && (Dropbox.appKey = e.appKey);
	    }, c = function c(e) {
	      var o;return o = document.createElement("iframe"), o.src = e, o.style.display = "block", o.style.backgroundColor = "white", o.style.border = "none", o;
	    }, k = function k(e) {
	      var o, n, t, r, i, s, a, l, c;if ("string" == typeof e[0]) c = e.shift(), n = "string" == typeof e[0] ? e.shift() : b(c), s = e.shift() || {}, s.files = [{ url: c, filename: n }];else {
	        if (s = e.shift(), null == s) throw new Error("Missing arguments. See documentation.");if ((null != (a = s.files) ? !a.length : !0) && "function" != typeof s.files) throw new Error("Missing files. See documentation.");if (null != s.fetch_urls_fn) {
	          if ("function" != typeof s.fetch_urls_fn) throw new Error("fetch_urls_fn must be a function if supplied.  See documentation.");s._fetch_url_on_save = !0;
	        }for (l = s.files, t = r = 0, i = l.length; i > r; t = ++r) {
	          if (o = l[t], "function" == typeof o.url && (s._fetch_url_on_save = !0, s.fetch_urls_fn = o.url, o.url = null, t > 0)) throw new Error("Old style url as callback is only supported for single files.");o.filename || (o.filename = b(o.url));
	        }
	      }return s;
	    }, Dropbox.save = function () {
	      var e, o, n, r, i, s, a;if (e = 1 <= arguments.length ? L.call(arguments, 0) : [], s = k(e), !Dropbox.isBrowserSupported()) return void alert(t("Your browser does not support the Dropbox Saver"));if (s._popup = !0, "object" != (0, _typeof3.default)(s.files) || !s.files.length) throw new Error("The object passed in must have a 'files' property that contains a list of objects. See documentation.");for (a = s.files, r = 0, i = a.length; i > r; r++) {
	        if (n = a[r], s._fetch_url_on_save) {
	          if (s.fetch_urls_fn) {
	            if (null != n.url) throw new Error("You passed in a 'fetch_urls_fn' option to specify the file URLs.  Don't include individual URLs in each file objects.");
	          } else if ("function" != typeof n.url) throw new Error("File urls should be all urls, or a single file with function. See documentation.");
	        } else if ("string" != typeof n.url) throw new Error("File urls to download incorrectly configured. Each file must have a url. See documentation.");
	      }return o = _(352, 237), D(C(), o, s);
	    }, D = function D(e, o, n) {
	      var t, r, i, s, a;if (t = function t() {
	        s.closed || s.close(), Dropbox.removeListener(window, "message", r), clearInterval(a);
	      }, r = function r(e) {
	        e.source !== s && e.source !== (null != g ? g.contentWindow : void 0) || x(e, t, n);
	      }, i = function i() {
	        (function () {
	          try {
	            return s.closed;
	          } catch (e) {}
	        })() && (t(), "function" == typeof n.cancel && n.cancel());
	      }, s = window.open(e, "dropbox", o + ",resizable=yes,location=yes"), !s) throw new Error("Failed to open a popup window. Dropbox.choose and Dropbox.save should only be called from within a user-triggered event handler such as a tap or click event.");return s.focus(), a = setInterval(i, 100), Dropbox.addListener(window, "message", r), s;
	    }, N = function N(o) {
	      var t, r, i, s, a;if (null == o.success && "undefined" != typeof console && null !== console && "function" == typeof console.warn && console.warn("You must provide a success callback to the Chooser to see the files that the user selects"), r = function r() {
	        return "undefined" != typeof console && null !== console && "function" == typeof console.warn && console.warn("The provided list of extensions or file types is not valid. See Chooser documentation: " + e), "undefined" != typeof console && null !== console && "function" == typeof console.warn && console.warn("Available file types are: " + n.join(", ")), delete o.extensions;
	      }, null != o.extensions && null != Array.isArray) if (Array.isArray(o.extensions)) for (a = o.extensions, i = 0, s = a.length; s > i; i++) {
	        t = a[i], !t.match(/^\.[\.\w$#&+@!()\-'`_~]+$/) && U.call(n, t) < 0 && r();
	      } else r();return o;
	    }, i = function i(e) {
	      var o, _n, r, i, a, l;return Dropbox.isBrowserSupported() ? (l = 640, r = 552, void (e.iframe ? (a = c(s(e, !0)), a.style.width = l + "px", a.style.height = r + "px", a.style.margin = "125px auto 0 auto", a.style.border = "1px solid #ACACAC", a.style.boxShadow = "rgba(0, 0, 0, .2) 0px 4px 16px", i = document.createElement("div"), i.style.position = "fixed", i.style.left = i.style.right = i.style.top = i.style.bottom = "0", i.style.zIndex = "1000", i.style.backgroundColor = "rgba(160, 160, 160, 0.2)", i.appendChild(a), document.body.appendChild(i), _n = function n(o) {
	        o.source === a.contentWindow && x(o, function () {
	          document.body.removeChild(i), Dropbox.removeListener(window, "message", _n);
	        }, e);
	      }, Dropbox.addListener(window, "message", _n)) : (o = _(l, r), D(s(e), o, e)))) : void alert(t("Your browser does not support the Dropbox Chooser"));
	    }, Dropbox.choose = function (e) {
	      null == e && (e = {}), e = N(e), i(e);
	    }, Dropbox.isBrowserSupported = function () {
	      var e;return e = w(), Dropbox.isBrowserSupported = function () {
	        return e;
	      }, e;
	    }, w = function w() {
	      var e, o, n, t;for (t = [/IEMobile\/(7|8|9|10)\./, /BB10;/, /CriOS/], o = 0, n = t.length; n > o; o++) {
	        if (e = t[o], e.test(navigator.userAgent)) return !1;
	      }return "undefined" != typeof JSON && null !== JSON && null != window.postMessage && null != window.addEventListener;
	    }, f = function f(e) {
	      return e.replace(/\/+$/g, "").split("/").pop();
	    }, b = function b(e) {
	      var o;return o = document.createElement("a"), o.href = e, f(o.pathname);
	    }, a = function a(e, o) {
	      var n;return null != o ? o.innerHTML = "" : (o = document.createElement("a"), o.href = "#"), o.className += " dropbox-dropin-btn", Dropbox.isBrowserSupported() ? o.className += " dropbox-dropin-default" : o.className += " dropbox-dropin-disabled", n = document.createElement("span"), n.className = "dropin-btn-status", o.appendChild(n), e = document.createTextNode(e), o.appendChild(e), o;
	    }, Dropbox.createChooseButton = function (e) {
	      var o;return null == e && (e = {}), e = N(e), o = a(t("Choose from Dropbox")), Dropbox.addListener(o, "click", function (n) {
	        n.preventDefault(), i({ success: function success(n) {
	            o.className = "dropbox-dropin-btn dropbox-dropin-success", "function" == typeof e.success && e.success(n);
	          }, cancel: e.cancel, linkType: e.linkType, multiselect: e.multiselect, folderselect: e.folderselect, extensions: e.extensions, iframe: e.iframe, _trigger: "button" });
	      }), o;
	    }, Dropbox.createSaveButton = function () {
	      var e, o, n;return e = 1 <= arguments.length ? L.call(arguments, 0) : [], n = k(e), o = e.shift(), o = a(t("Save to Dropbox"), o), Dropbox.addListener(o, "click", function (e) {
	        var t;return e.preventDefault(), o.className.indexOf("dropbox-dropin-error") >= 0 || o.className.indexOf("dropbox-dropin-default") >= 0 || o.className.indexOf("dropbox-dropin-disabled") >= 0 ? (t = ("function" == typeof n.files ? n.files() : void 0) || n.files, (null != t ? t.length : void 0) ? void Dropbox.save({ files: t, success: function success() {
	            o.className = "dropbox-dropin-btn dropbox-dropin-success", "function" == typeof n.success && n.success();
	          }, progress: function progress(e) {
	            o.className = "dropbox-dropin-btn dropbox-dropin-progress", "function" == typeof n.progress && n.progress(e);
	          }, cancel: function cancel() {
	            "function" == typeof n.cancel && n.cancel();
	          }, error: function error(e) {
	            o.className = "dropbox-dropin-btn dropbox-dropin-error", "function" == typeof n.error && n.error(e);
	          } }) : (o.className = "dropbox-dropin-btn dropbox-dropin-error", void ("function" == typeof n.error && n.error("Missing files")))) : void 0;
	      }), o;
	    }, v = function v(e, o) {
	      return "background: " + e + ";\nbackground: -moz-linear-gradient(top, " + e + " 0%, " + o + " 100%);\nbackground: -webkit-linear-gradient(top, " + e + " 0%, " + o + " 100%);\nbackground: linear-gradient(to bottom, " + e + " 0%, " + o + " 100%);\nfilter: progid:DXImageTransform.Microsoft.gradient(startColorstr='" + e + "', endColorstr='" + o + "',GradientType=0);";
	    }, d = document.createElement("style"), d.type = "text/css", p = '@-webkit-keyframes rotate {\n  from  { -webkit-transform: rotate(0deg); }\n  to   { -webkit-transform: rotate(360deg); }\n}\n\n@keyframes rotate {\n  from  { transform: rotate(0deg); }\n  to   { transform: rotate(360deg); }\n}\n\n.dropbox-dropin-btn, .dropbox-dropin-btn:link, .dropbox-dropin-btn:hover {\n  display: inline-block;\n  height: 14px;\n  font-family: "Lucida Grande", "Segoe UI", "Tahoma", "Helvetica Neue", "Helvetica", sans-serif;\n  font-size: 11px;\n  font-weight: 600;\n  color: #636363;\n  text-decoration: none;\n  padding: 1px 7px 5px 3px;\n  border: 1px solid #ebebeb;\n  border-radius: 2px;\n  border-bottom-color: #d4d4d4;\n  ' + v("#fcfcfc", "#f5f5f5") + "\n}\n\n.dropbox-dropin-default:hover, .dropbox-dropin-error:hover {\n  border-color: #dedede;\n  border-bottom-color: #cacaca;\n  " + v("#fdfdfd", "#f5f5f5") + "\n}\n\n.dropbox-dropin-default:active, .dropbox-dropin-error:active {\n  border-color: #d1d1d1;\n  box-shadow: inset 0 1px 1px rgba(0,0,0,0.1);\n}\n\n.dropbox-dropin-btn .dropin-btn-status {\n  display: inline-block;\n  width: 15px;\n  height: 14px;\n  vertical-align: bottom;\n  margin: 0 5px 0 2px;\n  background: transparent url('" + Dropbox.baseUrl + "/static/images/widgets/dbx-saver-status.png') no-repeat;\n  position: relative;\n  top: 2px;\n}\n\n.dropbox-dropin-default .dropin-btn-status {\n  background-position: 0px 0px;\n}\n\n.dropbox-dropin-progress .dropin-btn-status {\n  width: 18px;\n  margin: 0 4px 0 0;\n  background: url('" + Dropbox.baseUrl + "/static/images/widgets/dbx-progress.png') no-repeat center center;\n  -webkit-animation-name: rotate;\n  -webkit-animation-duration: 1.7s;\n  -webkit-animation-iteration-count: infinite;\n  -webkit-animation-timing-function: linear;\n  animation-name: rotate;\n  animation-duration: 1.7s;\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n}\n\n.dropbox-dropin-success .dropin-btn-status {\n  background-position: -15px 0px;\n}\n\n.dropbox-dropin-disabled {\n  background: #e0e0e0;\n  border: 1px #dadada solid;\n  border-bottom: 1px solid #ccc;\n  box-shadow: none;\n}\n\n.dropbox-dropin-disabled .dropin-btn-status {\n  background-position: -30px 0px;\n}\n\n.dropbox-dropin-error .dropin-btn-status {\n  background-position: -45px 0px;\n}\n\n@media only screen and (-webkit-min-device-pixel-ratio: 1.4) {\n  .dropbox-dropin-btn .dropin-btn-status {\n    background-image: url('" + Dropbox.baseUrl + "/static/images/widgets/dbx-saver-status-2x.png');\n    background-size: 60px 14px;\n    -webkit-background-size: 60px 14px;\n  }\n\n  .dropbox-dropin-progress .dropin-btn-status {\n    background: url('" + Dropbox.baseUrl + "/static/images/widgets/dbx-progress-2x.png') no-repeat center center;\n    background-size: 20px 20px;\n    -webkit-background-size: 20px 20px;\n  }\n}\n\n.dropbox-saver:hover, .dropbox-chooser:hover {\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.dropbox-chooser, .dropbox-dropin-btn {\n  line-height: 11px !important;\n  text-decoration: none !important;\n  box-sizing: content-box !important;\n  -webkit-box-sizing: content-box !important;\n  -moz-box-sizing: content-box !important;\n}\n", d.styleSheet ? d.styleSheet.cssText = p : d.textContent = p, document.getElementsByTagName("head")[0].appendChild(d), setTimeout(l, 0), _o = function o() {
	      document.removeEventListener ? document.removeEventListener("DOMContentLoaded", _o, !1) : document.detachEvent && document.detachEvent("onreadystatechange", _o), l(), h();
	    }, "interactive" === (S = document.readyState) || "complete" === S ? setTimeout(_o, 0) : document.addEventListener ? document.addEventListener("DOMContentLoaded", _o, !1) : document.attachEvent("onreadystatechange", _o), Dropbox.VERSION = "2", void (h = function h() {
	      var e, o, n, t;for (t = document.getElementsByTagName("a"), o = 0, n = t.length; n > o; o++) {
	        e = t[o], U.call((e.getAttribute("class") || "").split(" "), "dropbox-saver") >= 0 && !function (e) {
	          Dropbox.createSaveButton({ files: function files() {
	              return [{ url: e.getAttribute("data-url") || e.href, filename: e.getAttribute("data-filename") || f(e.pathname) }];
	            } }, e);
	        }(e);
	      }
	    }));
	  }.bind(this);
	  dropins();
	  return Dropbox;
	}
	
	/* eslint-enable */
	
	module.exports = exports["default"];

/***/ }),
/* 2246 */,
/* 2247 */,
/* 2248 */,
/* 2249 */,
/* 2250 */,
/* 2251 */,
/* 2252 */,
/* 2253 */,
/* 2254 */,
/* 2255 */,
/* 2256 */,
/* 2257 */,
/* 2258 */,
/* 2259 */,
/* 2260 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2261 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2262 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1e862e148b98b34ea5e9dddc40a256ee.png";

/***/ }),
/* 2263 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWCAYAAAA8AXHiAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsSAAALEgHS3X78AAAAB3RJTUUH4QMPCzgwMxxrtwAABERJREFUeNrt3U1y00gYxvEnKfb2qncqwgnCpveaEwROEHECdAN8gxEniLhBOAGadS8wJ8CUdtrgnAAW7qphpmzlS7L74/+rygabckt6/PbbsixLAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAITiLZaC9tReSakmlpMtMjs83SZ2kpnBuQ7CmDdRS0krS+8yLwMfCuZpgTReqLqMK9ZAKVhbObQkWocoyXOcBj21FqPa69PuGivXERv37PU+7k9T6qrYtnOtiTktvbSlp6RcnlaTFPf/lVcgNfajBau5p1j9JqmPoNZ7RBjSSrmNt5l8EOq5y5LF3hXNtynOdf8NUvbWdpJsn7CN6rJE+Ym+lSj1U/wtY66vzY/YRwRqZBg71VLXyU/ttj8p5RGNtU+2pHjAttgRrmh25T6d8dQRrPtuMg7UlWPNVspwr1ppg4ZjtQbBepHxAjDGl/r3UZhHIsO4k3Uqqh2FIdno/TzhUraQvkq4CCpX8WK4ldcaYJcGKK1QrjX8cEoJLJXxeLtWKFcsBqwhWXBaRjPMlwQJYFY6uyGpJm2EYuiOuTF9L+ptgpasehqE95gv6AHfGmKyCldtUuGGSIlhzVQ8QLBAsIOPm/ZTT8FlO20vFAsECwQLByoc/Cw6CNTmCxapwFh+MMdLuWy/rlK/gJFgnCJf/kw/ZsX2WtBqGYZ3yTqZ5P74rSV+NMRXBis+PCMbYGGMuCFZc2gjGuFAEN1AjWH8YhmGlw3dpCckbghVfuCpJ77S7Z2ewVSvVr4AlvSr0V4uefFo0xrxRZvdUZVV4nIDf6sBX0lI9l0awjheuLqftJVggWCBYIFjA9JI83WCM+XWggT7jkFOxQLAAggWCNXnvVeb42gRrfs0pDrB/zRWrwnRdSvpyokuSmQoBgrXfZw4twZqll+INQLAm5y9RCf3S5KR/fzH1S5PfKsxLkz9Jej0Mw4ZVYZzhutXud2tAxQLBOqLe2jLXgxTjtsdUsZYZF4AlwZpPmXGwqFgzqnprs6tafpsrgjWfheI58TmlRvH8mlnwwTp07um6t7bKJVF+W68fuY8I1ohu5LGb3to25Wmxt3bZW9tKunniPjq5s0B37IWk7/c87U67+zJ0kraFc13MQdLup+eWvlGvHjD9vSqc2xCsx+/sRtJ7YZ+PhXNBf84YcvO+Cr2POFX/GXqogg5W4dzWTwuE678NexnDQKP4AifTYhzTX3TB+qOhr/07NpcbmH3zi5Mm5EY96mBFuNL7deChv2JewabQvKeqzmEjCdZ8/jnw71c5XAJEsOYzduVq63vGZNFjzddjLSX9HHnKnXbn6tYp9lwEa95wreR/EOq5CueiOlZMhfNqlOkJXoI1I//pQeWnPYKFScO1lnQxskqkeceze67SV7BS0suUeywAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA83W+iSCRJfPS1KAAAAABJRU5ErkJggg=="

/***/ }),
/* 2264 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWCAYAAAA8AXHiAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsSAAALEgHS3X78AAAAB3RJTUUH4QMPCzcWZonyhQAABINJREFUeNrt3c112kAYheGbnGy0gg7kDlAqCB2YVACpADoIrsCkguAO6CBKB0MFQR3ASktnwceJAtjGSMDM6H3O8SKEYBvdzHzzhyQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQPw+3OobPz8/8+5f4wJ/uM0l/shbD4IFggWCBRAsECwQLIBggWChrT7xFtyeK8q+pL79cZWlyTz034klndsEKbMg9SXdH3nKU5Ymo0Yu8I2WdAjWdYJ0VwnSQFLnhH/2OUsTF2qw6AovE6TuXpDSM15mIMmF+h7QYjVfJ/UlfWngJZdZmmR0hXSFfrYcbJtBTAgWKN73apqRpNmJI6w2eMjSZErxXqPGskL5F1k68DVLkwU11vn6ZOioETUWLqFLjdW8H5LmTcxWB1Bf3mk7gfpI8X5ZyyxNJm1plrI0WUma2ZrjkOmGy1m3tOtb+fqDBREsV5R9m15AID55GqRj20p+S5pzyQjWOYEaSZrqvN0Ar73uRNKk8robSTOfJhRj89GjUPUl/bxAqGY2eqq+bkfSd1eUtIAtqLEmFwjrnaTxK08ZWqDRwuL9QdvdlOcE4JSCf0AM4q6xch3u/77GwmpGDOJusfJjvdk1yjtiEHGwbClms/dw3frnlOJ8QQzir7EWTQbLlj5+vPKUpyxNcl8vjivKrivKhSvKZ/tyoQw2fAvW/kXu2YmXOuGaSPomqag8vLH6beRzqI7UnT1t5/ko3huoswaqOeNuJ4vnCoStPOQKeHesVy2WdV1Fw3VWUGIIlY9dYeN1FqEiWC91h6nNoMceqq79p4ricEgIwdrVWbGHKlfD66QE6/86a63tFplWdIeVUPVi+r18XSvM2xCsWEMVUrA6VtjGZhZjqLwNls2Gb2Kus2wv2FCR8nnbTLTdoe1ojTZUkt/Hv3Id/xhFX8Nyp+1yy35gljaNMMvSZG3brx8VOd+DFUqoppK+v/DXPfuaWPc3Vgt4G6wsTZwrykIez+28c1TXaUuofK+xvG61bJS6inVUR7BuE6qRIlnTa2uwFp6G6iehCjhYtryz9DBUCLzF8qY7JFTxTDdUgzVuOCRdbZdTqneJKOx7TW3DIaGKucXa/0zNBkI1sdHccK9OSu2xP64o57u99oQq3hZLOtxGc24rNddps/lDSQOb+HwkJnHWWLXrLFtuyfW+JaIOoYo/WIsaocq0Pe3MRCbBOqiznM74OMiYDicQLE+6Q0JFsE5ttWaEimDdDKFiuuGS9ViXS0uLBYIFtCtYbe36vD0SF0uN1bOP3W7bTZruCdbljSWNXVHSD9EVomFrglVPToaOmhOsOhXr9gj+Nx0ew2+zh6b3rtUR5M3G8Y4LzM3GQfEOvCHY6QZXlAs1M4+ztMHAwuebCRCs6zk3WLvTOLswrYkBwao6tXXZ7AVpxWVnVPhWdzjT8TOHvytBavXdvW41Kgx+usEV5UD/FmOdT3M5BCvgYMHPYDHdAIIFggWCBRAsECwQLIBggWABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAICI/QX0BYVTfy5t3wAAAABJRU5ErkJggg=="

/***/ }),
/* 2265 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2266 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2267 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2268 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2269 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAQCAYAAAD52jQlAAAACXBIWXMAAAsSAAALEgHS3X78AAAAvUlEQVQ4jdXUMQrCQBSE4X/jBpJlUUwnCvZewM5TeAyv4AksBe/kHSwsBC00gpolumbXC9g9Uzjw2g9migewAhwQf3AOWCmgKorCZFmGNHVdU5al04DJ8xxrrRhVSgGYRCx9SSuoXioYvj32+RRjD+85KNAzpRiFgG3eYvQeGg60VP9/UJ1OItk4knejGPM3SPegzRx600B/0IjR5Bg4b/9qU8A9Li8Tg3zT6uoBnI4Jm9OuWgDyNwUudlh/AD1vS5CLCLtGAAAAAElFTkSuQmCC"

/***/ }),
/* 2270 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAQCAYAAAD52jQlAAAACXBIWXMAAAsSAAALEgHS3X78AAAEAUlEQVQ4jXWQf0yUdRzHX9/neQ6OX3cH3IkecKhpIgmiM2wTNGqirdJMqKnlj5xa2nTr1+Zcm671R/9oOW3Vpqt/wkQzbTQrQZSavxUORCg44exEkl/Hz3vu7nm+/UFlNXr999ne++z9fokdeM5niUCRnFfA0No3OH9Kp/bcPSIRSZJdYde7VrQvDqE23MDInUN03Ubefy9EaASKn3RSvMwkKlXiDh1EXL9Kh0yv1TwiUDTDmUTatEziF2bzzIJU9uxpo+nmKDa74InH7BhnT2O0t6J60lHnP8qxhwfIzU1g+47JRLpuYdScQag63WkOZFegSF2al787Z6qH6YO9OPp7cOdPp6BkJlHTRjSSxOvr07H9fJ6k2+1MnD2bjNWrMFQX27d6yBzw4ThymOSrF5iQk0Ns8RJ+j8aida56k2heOmpHA3rlSfSmt8l4aT1vbS6h5kYiKCZSghQCqaooimDLyijhH75ksKIcrFZi1mxAX7ScZp/KmfZCtOOHe+H5HBLKXsaTnY/x/UkGP/2YGG8di0vXogg3f6OqKNIkuO8DItevoc0vRFtWRitT+O5YmG9ONFFXV4dWtDiOnDyNlEmJJOQtQMzJJdpyCxkOYUm1I4QAIcaeCgGKQtxzK4l/YQ3a9BnI+ERS70YpfjyGtHQnP11ORps1fIlZHT2k/HidMP9G9/mRuo4RCABg+P2MHj2KiI0duxubAHACLiDm7j36h1sRH1ksssDhYEp8PJLxkdEomCYoCkLTxs0I4PbICJf7+9H+csX/hJESDOPBfFV9oOO/qCoAWnj1eiyPZGPLdI/bVIZCjJaXE6mvxzJ3LnGlpQirddymljt3Cd9sRmtMKCB5wnzci2biTDEJt/2Kca+TuNw8LE4XZjBI+Nw5IvX1qBkZxK1YgTE8xMjNRiyeLNSsaQQ6DfztYZqHfDQm2NCqKodIUkcpnjdA9+lTBE9UYC8sxJKdy2/tOhl2OabgTxWmBNMwGaiuYqSlBfvqDQxPXkjVWZ2vj9+nqakX5cXNTsqeNtFOHKSvopzU0jJsr2yjxmtl//77SPMfGw2DqCFp7nMy6Z2dOJY+Re9nB7BXH2LrOiuvbsvCPdmF5v5qL6PfxjLiTiNz9x6MqfkcPjJAZWUQVREIEhEChJQIw0CRkg/3dVFSYmPJ8rVM8mTReWA/Fl8bhTPnsE7/HA2vl/6JTh7atJGOpGw+2e2lqiqIrkuSUxTqf+nD6O7FCIVQu3tQW1rxNgS5fAUuXrKzZdNcIq9tx7drJ0PHK3D1DKD5Sa+lK1DUtreCSpeDaxf8hMNjm3v6FKovWtH8AdTBQQx/gOilK7S2hRgMmvjaFLwNLoqejcWuWaE7yB0yav8A3PqoQFefvDAAAAAASUVORK5CYII="

/***/ }),
/* 2271 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAQCAYAAAD52jQlAAAACXBIWXMAAAsSAAALEgHS3X78AAAB0ElEQVQ4jaWSTWsTURSGnzN3ZjJpk2g+KEFTW/wAC1OrINiNiP4BC/4IBenKv2Hxf7iqW1duxAjZi+BXRdI0JjFNxslkJjPXRbBaUzExD5zFgcNzXu498ljxVGALsJifSMOu7CjC66WiVU47cxsbg4Baqx2ZgHVmIc3FXHZuqSECYJnKBnEEHDk2oDWMRmAYoNS4FznRdYSEgrLB3HwkFDYXoZwDoHPo0PUcAq/Pi1cp1tZszq+MOOxbXFrukXbiv0oL9ZgbVTCUDZJinNQR7FyCR4Xmc4XbNChu3Kf22aWfFDAWjKO5kwuUDcbEOh1TuXyXFWcVN0pxrq05W9ngys17KNOc7m1/b5JEePMxT3dUJP1wG3X7Dt72A9hv0OicZr+1OJX02GqtYe/DN+yKz4HXoBnXCW6tUy5k6XV9Rv0IlmaUGobmqgtmxmfv7Tua3leGlTxy8AX32hLpTDB7UhG4sKrR8oTSuub9qQzlkk8++xJrWEWccDppHIIeAoEeiwFhQEbAXR6iDA0JMIj+bQsgDsGs7mhKq9/J5yYPQU2V6xedns/rTz+TBhpsPaNiEh3ocVIgqvsDK9HzSxuDACA0NTyrtdpb/PFp/0mkYfcHqiCjNtS5s7gAAAAASUVORK5CYII="

/***/ }),
/* 2272 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAQCAYAAAD52jQlAAAACXBIWXMAAAsSAAALEgHS3X78AAAA2UlEQVQ4je2UL2/CUBTFf5e+lbYCwp+EBIkoggQ7PcGXgX0TJAHHV0DhEKi5mdWtCYi5iUGyLn1AXujEDI+kGCZ7zE3OPfd33ZFBfz4WkRHgc6F2DzqPGXlqLhdUX9bXthaRqRKRYcXv+mVVs7b90OFp4ORCJX6D6NXyEmP8D62HCgg81SBw21agVVeEnYdcqK7XOLqu/ehvBKXcqztUQAtoAf1PKSA9mK8g42wtPncO8fZGoez2cDpZXmIMQKrOWTb71u/PgHcZiGL4Wd2ovnhDNUmu7VREJr8sFzgizeJ+egAAAABJRU5ErkJggg=="

/***/ }),
/* 2273 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAQCAYAAAD52jQlAAAACXBIWXMAAAsSAAALEgHS3X78AAAA20lEQVQ4je2PsWrCUBhGzw0haW6spYKRhIJQips4OHVyFuyLqE/gKziKPoXgGxRXkU5uDoWAREhwMNR0S7p6hTvVMd94/u878AsmgynkI8DhKu/yjf5jB10aqyW19ect/s0x5ibkw7pfd6SrOOn6bT6aPa3UjkKsU6Kwc5o632E4NAHpViRPz1WlEPgerdemVlq8BOB5ChNCAEhDu/pHSmkpLaX3jAlkl59MFkWhHCI7Zm+F2qF9iLDiWGHnNAXITDAWyTEZAw/Xha/IwtvrH2lsttR2u1uc5YjZH+AxNq88JJjPAAAAAElFTkSuQmCC"

/***/ }),
/* 2274 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAQCAYAAAD52jQlAAAACXBIWXMAAAsSAAALEgHS3X78AAABeklEQVQ4ja3SuUoDURTG8f89M+OEEI2axF1i4VJIxMb3iCiKG4qFb2BhaWFlJ4IIdiJKCOh7iLhA0EILUcQ9GhsnycxYiIIwE4nxtN/9flzuuWpxZSOlXJUEDCqfgqvcPV25KjnQ32s0xaIVi7cPj8b+USapA0ZLYwOdHe0VoyICZAz915O2jWNZUCyAbiCmCZpWslISdV6yvG5t8pbepnB9hdHWTvXwGOGJKaS27g9osUh2bZXs+iquZQFgnZ2SX17Cyb0SmV8A3bsufub78SG59M43+DWuZZFL7/B+fOh7H180f3GO/fzkmdnPT+QvzstHEQGlvDOlPvNyUbOrBy0a88y0aAyzq/sPaCJBeHIGCQZ/FoJBwpPTmIk+X9R/+6JROzuHXh8ht5uicHmJEY9TMzhCKDkE4v9XS/5TCYWoGZ+iengU17FRoqGqqkq+56/opyyoQACflXmjIoqbu3scxymj5j23D4+ICHq8tZmDk9N/QUWEeGszH7wBbtItPqxaAAAAAElFTkSuQmCC"

/***/ }),
/* 2275 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsSAAALEgHS3X78AAAE2klEQVRIibWVW4hVVRjHf2vfzjkzZ85cdM6og1nepowkCiSoh4GgUkimCUFCKVARB3qIKEqCtBeh9CGQQUcDExwSScHBsR6Eyod6kcgEtZzQkVFnxjOeOXMu+7IuPZw9pzMTZD30Lb69Ye3vW79v/dfaa4nz589z6dIl/g9bvXo1ztDQEP39/TiOw4oVK3AcBwCtNWNjYxQKBQE4QCOQinMrQAmQmUzGdHZ2YlkWAFJKRkZGkFLS09ODM0trbW3l+PHjtLe3k8/nOXLkiHXixIlFwMvAK8ATQEscngeuAt8A33Z3d9/bsWOHbmlpIQgCuru7GR8fh7gyAIIg4OLFi+RyOQYHBxtGR0c3GWPeAx4H7HmzXwo8BbxeKBSuHTp06LNz586d2rJlS7m3txchRC3Qqc+6ceMGp06dasvlcnuAHUDyITLbwJPGmEOjo6PPDgwM7Onq6pqaE9HX1weA67pkMpk0cBCIAPMfPQIOdnR0pJPJal09PT1Ys6AoiuxCobAZ2DZ/Zv/SHGDb+Pj4Zt/3a5JadQGdwLs8XJZ/smQ8Rmc9FcBaCBvWIFY14ODG7mDjYMVNIKgunsGgMWg0GoNEERARIqkgV13FbJiEAUA7AAISzyPWv4Vtt5MmRQNpGkiRIIGHF6PseMIajUQSERGh8QmYpkiBEjlm7EHU+tOYL4GKFeuUWQJdTl2tsxVXaxbzGrV+0AgEdpzrYrEUumzI1NbAhqYUplkCOnZTE8PEktS3+v7qG0T8FKQxzRY01a+B0EAZQ4jGRaNQqHg4haqpPyuRqsNJ5Bxw/JuJGkBBeQYxE6AXlVB4KEIULgo7FsRgsOI1MDFUIpEowhgxiykiZhSmXA8ojMGIj17lIwlQeES4WIi4bh1rXD+DCElQ86gGGoURBYV6iSq3mq0LbS+2vLSordlqSrXSkMiQcJvw3DS2lcKyXCxhAwJtFFqHeLqCK8u40QypqITnP2CqNK2vD92/QF5W6gHqZmCGx1c6fWtfaHos3dJKonEBTqoVx2vGdtMIKwWWW402EqN8lCzihQWS/jRhkMebMfz8U/nmH74ergrzF8BUfD1yfGj68JoVyU8ecWwPAcYoUAFalrDsBCIGGCPRMkTLCioqEgUFgtIUd+7mwqMn7w+UfT0yuyNqZ44QIrj8e3Ts6Ne5p99+Q2xqx9hGS7TycdwSwvYQloNAoHVE9VtAFBbxi3lyuQfq8FcTp3/5TR6zLCvQWs85Kkin06xbt25i6OIPu2FSbO+Vry1Z5HvJxjJusgHbqQIAtIxQKkTLEL9S5O6d6fDomQdnzn4f7d61q29icHCQycnJuYBkMsm+ffvM8PDwzf37P31n5PbklTdfrWx/Zk1xaVNT0vISCSynummVUoR+SKkc6EtXSrePnZ05eu22/cUHH350b+vWrebkyZOzw86RiMbGRnbu3GkWL158b+/evQfe//zu8NqVxY3PrfW6u5Z5j7ZlrDQCpqZ18fqt6OaPl4Pvfr0Rnm1dsPjqgQMf+xs3bjRTU1PMygMg+vr66O/vx7Ztstkstl09yvP5PMViUQCegCbHEQtcp3q+RJKClCZnYAYI0+m0aWmpXtdKKSYmJlBKVS/9hQsXsnz5cuZbNpslm80aIIg9Ny/E/C0ptmXLlgHQ0dHBn7mlYIun4XDFAAAAAElFTkSuQmCC"

/***/ }),
/* 2276 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2277 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2278 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsSAAALEgHS3X78AAAFQklEQVRIibWVX2gc1xWHvzt3Zne0u5JWWnkdWQQHGVsyToshYIMpVHUfmuRBdV0S4qZPTYyJ85I4NKQOIbHz4IfSNFAqWqdQ1wUnULdpamK3D3ECpoY8uMEuSvxgUSmxqaxI2/03O3/u3Hv7IO14LTePvcPhnoG5v29+Zw5nxIULF7hy5Qr/j7Vt2zbcc+fOMTMzg+u6bNmyBdd1ATDGcOvWLZrNphBCuJ7nFXO5XB9AkiShUiqw1qYDAwN2bGwMx3EASNOUubk50jRl3759uF3a0NAQp0+fZsOGDdTrdd566zfOe+/9+b5du3Z9Z+/evQ/v2LFj+/DwcBmgVqvVZ2dnP7t48eJfP52d/du3pqYWnz540JTLZeI4Zmpqitu3bwPcAcRxzKVLl1hZWeHMmXcKy53SY889d/zHT//g25OFQkF2nVlrsdbev3v37q8dOHDg+5d/8cvrb/78jZ9eeP/8Hw788MnO/v37EUJkZcoAADdu3ODsH98dTvwHX9u0c/rgA1t3+uVyGcdxEEJkB621GGPwPE8+NDK645j1f3Xq8y8e+u3Jk69NTEzUejUzQBiGnHn7nZItfv346PbvHaqMbXIHRwaRUmaAbp3XXOA4Dr5XZJB+/0eIZ9RyzXnpxRdfqjca7a6u002UUjKyw08Mjz/8VLladSujg/iFHK7rZiGlREqZ5a7rkpd58hTpo+A+jvdU5fbSE1EUyXsAwsmNle77xgt9hX4/n5cU+nN4rswc9IYQIoN5MoePj4fPEL7/XZwXfBhbD3Dcwuijpcrk1v7hEfJ9HlK6SFdmte/9cN1cCIF0JDnyuHh45JhAbh1HPNrV7gLyXnHzI/lCWfrFPvpKfeTyblbzXsh6oMBBInFxkbgUceV2eERAPgMIIQdkvjIhXRfHEVgLgrvf+quXzSAODh6S+xETEgZ6HDj9QuQGrY4xWmNSjdGrnSKEyLomk1zLhRBYLBaToQSCEgw60N8DsMIYTRK2UFFMGqcksUJrc49w9/7OblAozNplMaz5FhnAYjtGdVoqDglbDZIwJmrFaKUz0fUBq/NKrwFSNCkag6GNbWno3HFgdTONvpxLopA4CIiCDmGrQxKprwQYs+pO25QYRUxCjCJF8TnMaWj2dlGow5sfxEHDhEGbsNWm0wiIwyQT6u7rQ5mUkISQhIiEJtr8Ez4Awl6ANsny+ai5sNBpNgiadYJ6gziM0Fqjtc4gvaG1JkkVIQkBER1irmHnF7DnAQ13ZpG1Vs2p1rVfd/IbjkspcwKHMOiQpilSSowxdw27LjDWMQEhbUL+TZq8DydjmANsLwAhRCz08qmofmUnQj5mLbITtFFKZeL/CxClEXU61FD6HPxpwZWnHGNiY1ZbN5tFpVKJqalvLjnqX0ej2sdnm8tfJK36fwjDkDiOSZKEJElQShHHMVEUEYYh9ShgAZW8C2f/kc8dfebZZ5cqlUrW2hnA931OnDhhX375J/N5cfP5uPbh6/M3PllYXFw09XqdVqtFEAS0222CIKDRaLC4uGj+fvPmwu/g9U8Kfc8ffeWV+SNHjlgps2F6V4koFoscOnTIjo6OLh47duxnb//+zfOfXvtwes+ePVOTk5MPDA0NlYQQ1Gq19vXr1+cvX7780dWrV/8ytGn0szdefTWanp62tVqNbnkAxOHDh5mZmUFKSbVapUuv1+u0220B5IQQ/a7rVjzPGwBQSjXTNF2x1raApFQq2XK5vNqOWrO0tITWevWnPzIywvj4OOtXtVqlWq1aIF6LlXWP2HsOra3NmzcDsHHjRv4LL6foDaCUODQAAAAASUVORK5CYII="

/***/ }),
/* 2279 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsSAAALEgHS3X78AAAFNklEQVRIibWVT2wV1xWHvzt35v23/Z6Nn0MsQgIKNqJVKyUClZXDJk1UEUSVKqjtpimyQlYBJUqJooSyYJE27aJyW1iUUolECmpEUSBdBFWiZRWaksoNC1xhpzS2Fb++f/Nm5t6Ze7uwZ/ximmXP6OieGc39ffecOTojrly5wo0bN/h/2I4dO3AvXbrEzMwMruuyfft2XNcFwBjD3bt3abfbQgjhep5XzuVyRQClVKC19q218eDgoB0fH8dxHADiOGZubo44jjlw4ABuSqvVapw7d47R0VGazSZnzpxxLl68eN/u3bsf37dv3zd37dq1c3h4uArQaDSas7Ozn1y9evX9f8zO/vGxqanFHx4+bKrVKlEUMTU1xdLSEsA6IIoirl27xsrKCuffPl/6V7n59Isnj704ve/7k6VSSaaZWWux1m7Zs2fPVw8dOvTt67/45a2fv/mTN668d/mdQ9/7bu/gwYMIIbIyZQCA27dv8867F4abO+3rxW89dHjL17YXqtUqjuMghMg2WmsxxuB5nnx09P5dJ2zhV2cXPn3kN6dPvz4xMdHo18wAQRBw/q3zle5X5I/LTz04PTg+5laGqkgpM0Ba57UscByHgldmiIHCDxDP6c8bzssvvfRys9XqprpOGmitZaemn8k/ft+z5bFhd6C6iVyuhOu6mUspkVJmseu65GSePGWKlNzv4D07srT8TBiG8h4AOWdcfqN6LF8pFfKyQCFfwZVulkG/CyEymCdzFCjiUaBGofAUzrECjG8EOGLMe9KbHHq4ODpIzsvjOqsCae37P1waCyGQjiRHDhcPjxwTyIe3IZ5MtVNAXjxQeMKtFmSuWCRXKiG9HI4jM6H/5asnc5C4uLhIXMq4cic8ISC/DpBikGF3QkqJIxyEXTvl+qG/1Ky1CAQSiYODh2QLYkLC4DpAMIAnhlAGmxiMibE2ASxCiKxr+kXXS2WxmNXnCASCCgw5MNBfIoExmLbChAqjNYlWGGPuEU7v09VYQ4zGrF0WkyYu1gGGHn7SiQOFavaIowgd9TCxzkQ3OqzOK2MNCk1MQkyCwdDFdhLo9QFs236u5pJehPYDtB+ifJ84Vl8KSLOLbUyEJkIRoYnRLMBcAu3+EgX8W3+g24FRnQDV9VFdHx1FmVC6bnRtYwIUAYoQRZvE/B0+AIJ+QGJXkst2oTcftXzC/3QJWx10GJIkCUmSZJB+T5IElWgCFD4hPSI+xt6Zx14Gkn6AJbZzzIa/1ksdFTTaBCstol5AHMckSZKtaZy6ihU+AR0CPiNW78HpCOYAC33DTggRiRXO2pv+1yNXPG2xMvR7aK0xxtwzTdOMgjikSY8GOrkEv5935VnHmMiY1dbNZlGlUuGxqalld4HjfNi9oBaaym+0CYKAKIpQSqGUQmtNFEWEYUgQBLQin3m0ehcu/DWfO/7c888vj4yMZK2dAQqFAqdOnbKv/OiVO8XPvBf4s39y4W//nF9cXDTNZpNOp4Pv+3S7XXzfp9Vqsbi4aP7y6cL8b+HkR6XiC8dfffXO0aNHrZTZMP1CiSiXy0xPT9vNmzcvnjhx4qe/+9nZyx9f/Wj/3r17pyYnJx+s1WoVIQSNRqN769atO9evX//TzZs3/1C7f/Mnb772Wrh//37baDRIywMgjhw5wszMDFJK6vU6Kb3ZbNLtdgWQE0IMuK474nneIIDWuh3H8Yq1tgOoSqViq9XqajsmCcvLyyRJsvrT37RpE9u2bWOj1et16vW6BaI1X9nwir1n05pt3boVgLGxMf4L7Djsg+0x8ooAAAAASUVORK5CYII="

/***/ }),
/* 2280 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2281 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2282 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QEMDiIAy1afpQAABOxJREFUSMedlktsHVcdxn/nNY97r3Pj69hBTaEKcqFqkEFq02CgLFjABiVbs2PZBYtKXbDKCglRoYBAYoXCBhEWVWQvKsSmClERROEhREhlt1UkhAkhD9vX9sycmfNica+DE0FKmdG3OY/v+4++c77/CD74ESsrK/nS0lKulNIpJaSUbmNjo7148WIHpCduftLkhQsXPrG4uPjizMzM54bD4aeMMfNCCNq2vbe3t/eX8Xj82xs3bvzu/Pnz735YgcHq6uqrJ0+eXBkOh6cGgwFC/HtpjJGUElVVUVXVzVu3br1x7ty57wO7jxOpxwdmZmaOra6urp06derro9FoYTAYoLVGa41S6iGklBRFQVmWC8eOHXv57NmzZ8bj8dX19fXxkwRGly9f/vXS0tKLg8FAFEWBlBIp5SPEBxBCHMzJ0Wj08RMnTpypqurN9fX16j8J9C5duvTG6dOnz/R6PbIse4T4sIBSCiHEQwAIIZibm/tonucn19bW1oDwiMAPf/C9bywvL79y9OhQ5EWG0RqtFEZrlJoKSYE8BHXwNUIgAKUlc6PR88cX5u5euXL1+s+vJzTA4nMvfMyrhZXbW8htu0uvV9LrlxijMSZOSJREIkhASomQEsRECIGuczS1xTYtVZU4svD8a8DPvvaS2NaA2Nwafua7P9lYmn8mMf/0HDNHC2Y/MsuR2R6DQUFR5OSZxiiNQNB5j+08ddNC8OzuVNy7s8P9zS0e3Nnh/uZfjxcLL3/V3n37p1KAVjr/tDJFUfb7KAVZZsiMRGuF0gqjJZlRFJmiyCVZpjBGYoyii5Es1+S5xmSKvNBkeVHo4vgygJblUxlCf3JiXELERIxpckUOjr4ERCJNL60QCSEBORlxLiKVQko18UIZIVT5DFDqGKVOkdnoW1LweB8IPhJCIoRIIBJixMeIEAEAFyMhBmKKxJjoWk/wEYAUIwiFQPWAUks5sc23DXZ/l7JncNbjrMPZjK7wKC1BMjEW8D7QOk/nAq71dNbT1o7gAt45UhSkRBKQdPK1i769412H3RvT9kvyMqepWkxhUEaCFISU0CqQgOAjXeexVUdXddiqxe5bXOvwtsO7QHDNOEGlk9vugqvesV1D1XmM7RA2ICpPKiPORHIRMTGiDZAE3kecjbR1pK4j+7WnaibYaz11l4Jr/vku0OkEYab525+fvd8+eLp5f2723ohhf8igHNDv9SnLgtwYtNaTeICJJyHQtR1Na6mbmtrW7Dc1O/sPGDdt++b+xhUADaSt9h9/fK7d/MPSjvjynCg5Sp8BOT0ycjIyNAqJRE6MZGJ+h6fF0eCwWPZpsKniN6SbEK8eiorYRGT3FPErPWIuD+V4mpwjEgFPwONxOFq6h7C01Fgqav5OCBcRr9Skdx7JorukjRIxP0v8bD7JKdL09UTcVGBStcfiaHG0U/J9Gm7jeQv5+k3ijw863eE0jbeQ13Po94gvGQIQSUTilNwRcHgsHc20+n0su1g2Cfwe8aNfkr4NVP+lHyR7G3GtQuyUpC9IvHYEAg5HmFbcUdOyS0eNZRvH+6TuV8hvvUV6Hdj6X1qmOYL84pdI31wknelDUYA2IAUCT0oW3C607yGu/QLxHT8xNXyopg+UGvXCMvHz8/BsTpoFgYXte/DeNcTbnvgnoP6//ioeW2emAHBTpA/a+C9BhIeweOlwEAAAAABJRU5ErkJggg=="

/***/ }),
/* 2283 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2284 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAQCAYAAAD52jQlAAAACXBIWXMAAAsSAAALEgHS3X78AAACJUlEQVQ4jZWUT0hUURSHv/ve0zdvxqlmxiEsppAUcaIyRAkhadeiZatokVBBmIsgaBHRqlXRKmrdPmjVwmrTUhcpJJklqRnjn5km1PH5fM/77m3RpjdjM3p2555zP378zuEIrvMEzW3AoSrSFbjzGkR14f/hGYrnFprhznynk8qkajpaSz4X33xG6L0Ri0o7k4TDFhDPZDO05doiDRaKs6lV8udBrQjCOQEN4KZQTIbEjV2LaE4avxjKTpF4IEnck1h5BebeFFv/JgLIGRsMmAV6jCKHhUugBc3HNM6tEPlR4783UIX6LkeUmigumItcNmfoEL/xXZvZ8R6CMI7RpbGvhNiXFDTVVxqBKgTr2kZjIKVgo+xQ/JnDrTTjuSZa8dfXBt4a0UTTQoAKDb6PHSFI3uX0zYfI1H0WPp0hDGOIOIgG3kagMSEZsAqgIHmij9b+G7Se6iXZPYR5oBupoemcQiTrS61RmkBSnE8zPx7DXVlFyR1Cb5PlqYCl6Rawq3/VRmT6gTb5ojJ0JLfZKU6wOPqUlfFulPuV9NFlsjmJnBBot/70I1Afi1eyi6vZGfqvLRF6o6wvf+Bg+xpOPEBOa7yXJtrdh1INzKlDPFZ9HA+3GWxaYHBnkc13Nu5YDGfeg+3Gl8Da7dHH5JuZYK3UTu+jAvaa13CNqqFb5VI5rpSqhZd8fpT9/RwUgC0LwYvZ6dkRIFbdlK7A22Bfp29LKJ79AXU92YvK3lNKAAAAAElFTkSuQmCC"

/***/ }),
/* 2285 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAQCAYAAAD52jQlAAAACXBIWXMAAAsSAAALEgHS3X78AAABJElEQVQ4jaWUvUoDURCFz9xMFrdQFoIs+A9KFCx9rNS+hDY2FnZ2til8DRErVzSYaAwkyyZZYffmGt2xyEbS2GQ+mPbjnBkYurppXiTJuCEAQwkB37VacMnJMG0cHezx1kaodaLb63PU6jQYIryzGeL4sA4RWT4lEQwB0Uub/yqLiEq6CFeZYAzBY4LGSTTzVJnA17cx7nsptndH6vpvnREe7gbgqG3xszpBN3Nqaf9jgufXHDyPbQyU9QFD5RqW1/wPCxkU5Qh09QsyECLwSf6IeuJhvfKu3ulg2MWafQI1A5L9wEfoVxU5AQLQt1O0xhbsCHDGg6usqKXOEBzZ2ROhcjQsOlgAm7ovX3OkOZ9uCgEylkLO49yexrn1tVIBsqKQs1/2I4CR7ys2/AAAAABJRU5ErkJggg=="

/***/ }),
/* 2286 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAQCAYAAAD52jQlAAAACXBIWXMAAAsSAAALEgHS3X78AAABo0lEQVQ4ja2UvWpVQRSFv7VnzrnXeMUg+ABiGcRCsNLOF7DRwmewtvAJfAJrEWsVRESuL6AYTMAijekCNuYG/Dk558zeFtcbomju0bib+Sm+NbNm7dHzZC9b92sB4pgliNpsqifCz43HWk0JDwiDCEgBEgTgPxSlo5VnpbDdNJEDdCZlzlYVrRfKZSN6yOtBbUaJoKwBu1DtQNKfsUbHB1AG8Ag6BV9PByduJGws9rb2mbSgDqrrFWXDiR0fZENemOHnYXJ7xPhqhgC7L/qHPfbKae91RAkihEnYEqjNmcK3nNmDFoBog9mjfbppIYeoOpEuJexmovflpz0QNYmTa4lms+fbm8LkYiaP9PPDDMxHXkzSitBn8eVui+8FK1cyaVWUj9BXgb91eC1qW3b5w9AG9LRwqojA6F84DpSA+k5FeeekZ77UTzjwFBIiu5Fl80xeEOlWIiLoHvfEug/ujnx4oV9GBElQvV+Efxg2/27TJNJmEBuFSnZk4AdDBVTSvC//oYb4/teVBfGp9HLi2LBZKQgi12bT7ab5L1+fQYzMpt8BOIejADqp5xsAAAAASUVORK5CYII="

/***/ }),
/* 2287 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2288 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8c30d42fb9b7056ac274f4fa272c16ff.png";

/***/ }),
/* 2289 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAIAAACQKrqGAAAACXBIWXMAAAsSAAALEgHS3X78AAAAlElEQVQokWP8fenSj/nz/3/8yIAbMPLzcyQmMpdxcOBXx8DAwPDz59/r11nQ1LFOnQpn/87OhrP/f/zIgtWU/7dv/926FU0QXSlE0f/btzH1M6Hx/0yY8P/2bUZVVZaCAgKmMqqqMnt7M6qqYpqKrhTTMJwOwAMGXCnj58JCwhHLwMDIz8/EkZDAyM9PQJ2gIEdCAgAOwTUybdzUPQAAAABJRU5ErkJggg=="

/***/ }),
/* 2290 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsSAAALEgHS3X78AAAAB3RJTUUH4QEfCgQH00nZjwAAAldJREFUOMutVM9rE0EUfm8ms7tkm2AqBqGE0MJCLA3RrEcRD+LFQwXBgxfx7KEn6T/hxbs3EQRFC9K7ehECpZCFEmgRQiOhUFZrNm6SmdnnwSZdkzQ/oN9lYN68j3nf980gjMHOzg64rvvf3uHhoen7PhNCJLTWhmEYKcbYwyAIrgghbhDRvWKxiAjnoFKpJG3bXouiKCulNCzLut/tdjOc8zUicpRSIz2u62LiPELG2C0p5QcAsIkIwjAEAIAoimASziVExMtaaxvmRGJCjab09uskhAAiYtMI4+MDEZ0gYi+KoqZlWV0A2E4mkz+Wl5dfnRq5NZGQiLgQoqG1fm+aZpeIvqXT6ZNcLvd5TCqSACCmaWgi4styufxiHg3ZhBpKKX/OawqDC8aFEIZhKAEAZ3Y5Ds/zsFgs0t7e3vNOp3MtkUigaZpvWq1WMCDc398Hx3FGNBzOYr1eh3w+T57nfex0OutEhEopUEqtc87PXHYcBw4ODq622+3HWutsJpP55Pu+HpYkn89Do9G4e3R09CAWLwCAzOn6j9DzvEIQBFWttQAA8H1/Uwjxq9frPRu+9vHx8fVxUnDOz0whotdKKRE/IKW8hIgjP0EqlaqPe5qMse8DQqXUTRz6yRhjIIQYScHKysqWZVnbRIT9MRERiOjpgNAwjN/9YgxtznkzvtFsNgERpWmaj2zb3lhYWPhjGMbbxcXFO6VS6WvfSdjd3b0dRdGX2LMDRHyXzWafLC0thbPE6TQBMJizWq2uA8AmEXU55zXG2Mbq6mqvVqtBoVCYOad/AV8d/iwdnCnSAAAAAElFTkSuQmCC"

/***/ }),
/* 2291 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsSAAALEgHS3X78AAAAB3RJTUUH4QEfCgQD1CQdlgAAAtpJREFUOMutlb1PFEEYxp93Z9n7QoIghyKoxXF7ew2GmFhYGKMxxkoqCiExWugfoIWFnbWFH7GyAQu/YoiFicSCaGJicZEr2L09DgLn5UD3IJvcwe7B7owNR1Y5MH48ySYzO+/89pl535klAMhmsyMAnnieZwMg/JmELMvtAK4NDAw8xRZwE/+o6elpDwAkAPA8bz2TyQzruv4un8/37jZJ1/Ud70zTJADwfd8GABkAiKgtHA4/IyIoitIDoPTrRMMwoGkaDMM4IYQYF0J0Kopyo7+//3UwTgIAIURF0zQ5FosNcc6zzdxpmgbTNLV6vf7ScZyU67pd1Wp1bG5u7mIwTm6AicgHMLHXPnmelwRwrNEnopjneUMA3v7kEIDYC1QoFAAAjLESEUEI0Xg4Y+z9jiUHtbKyst2u1WqqEEJKJBKYnZ09B+BeJBK529rauhaLxdxoNHo5kUg8b7Zk2srigc7OzkqpVNIsy5rM5XK9jLFFwzC+cc4/pFKp01vxdxqAfD6PZDK5w+E+XdcNSZKsYrF4xLbtSd/3e4lI+L5/lHN+SFXVW40SCSoICwLrrus+AvA5HA67RLQ/6FwIwQCgvb1d/K7At4GDg4MPOedn4/H4d8bYCGOskQj4vm9Vq9Vkd3c3gi7n5+d3AOVgJ51Or5mmCVVVJ8rl8pnV1dWTbW1tHyORSLVYLN43DOPV5ubmuGmaNyVJitu2fVsI4RCRaAoEAFVVAQA9PT1TAKYCQxcKhcINzrlbq9UghICiKNcXFxdPAcjsWjZ7yXGcuY2NjUZRw/O8kOM4w832kJaXl48bhjGWy+W6dgMyxtaIaC14eIio3AzYsbS0lJFleTQajR7cw+SXlpaWF5IkrRNRLRQKvVFV9XGzpNh9fX3nLcu6xDlfbkaamZlBOp12AFytVCoPJEmKdHR0fGr62Ww2K2zbPvw/LtiGw9GFhYWvmUzG+ttfABFdAYAf2EpHoyxchycAAAAASUVORK5CYII="

/***/ }),
/* 2292 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsSAAALEgHS3X78AAAAB3RJTUUH4QEfCTgJRUQzLgAABMZJREFUOMttVF1oW2UYft4vpzknycnPSZttpstYE1ZXZpnW1Y1544YOnYgwL7YLFQVFGKgoIkxxzDFlgpvgYOocTr3YRC9ERXvjUHY1LaV0Yu2y07Rdm/RnSXPOSXOa5OSc1wvTWmXP3fPB97w/z/N9hBamp6eRSqVgGIYoFAqypmnvVSqVvY7j9DQajRoA9vv9bYqimEKI47FYbKBQKIxv27YNhUIByWQSAEAAMD4+jkwmg2KxGLYs65DruueWl5fHwuHw99FodKFer19jZjsUCu2bm5srMfNbAPyKohwJhUJfJBKJ6ooo5fN5dHZ2IpfLqQAu2radiUajl1Kp1IlSqRQrlUo/VqvV3QAQiUSuZzKZrQAwMTHxouM4pwF8lk6nX5EkyS6XyxCdnZ0wDCPCzBeazWZvIBD4KJVKnQCAUqm0s16v73ZdF57nwTCMO4vF4gEA6OrqOhONRt8AcCiXy33MzLKmaRDMTOVy+ZFGo9GvqupBAB26rvtaq60wswcAzMw+nw+yLBsAsLS0dD8zH45Go4eI6KnZ2dmzACAGBwfbGo3GS0R0IZlM/k5Ep30+nwsAGzduHItEImcDgQDC4TApivKkqqq/tIoNMfPe9evXD0QikVOmaR6o1Wo7qFgs7s/n85/29vbuEELMrrhu2zYCgQDy+byoVCokSRIJIdxMJsOmacJ1XcTj8ZWEhDzPWyKic5JhGA8Fg8Epy7JqY2NjRwFsSCQSvwaDwa8BIJfLeT09PavRaplD2Wy2bWFh4WUhRKTRaJxi5vOO4zxI2Wx2qNlsfklEj9u2vYeZoSgKNm/e3Keq6nBL9C5JkqxNmzbdBIBqtbrh1q1b35qmucvzPMRisb+CweA3S0tLRwURbQ+FQluJaA8zMxGhVquhVCrtw7/4CsDrK8QwjHur1eoux3HgeR4WFxd7ms1mlJkhAQARzTDzCBFtZ2b4/X6oqnp1jeARAPMrhIhARLgdl5j5mmEYeiwWe9rzvMMA2jVN+y0ej19pjYt0Ov3D2uepadqQ67pXXdddHVmSJFMIAdJ1/QPP83Z2d3fvHh8fV5hZZDKZBhE1cRsMDQ2hr6+PdF1va29vf9XzvGnXdX+q1+vvO47zAIrF4v6RkZG867p3tDoSuVwOrTBHpqen3x4dHV3KZrN848aNvSvClmWtFpmZmQlMTU1ZExMT50Uul/tZUZTJbDb7fEvkTWb2AYCu6z3lcvk127ZDlmVxtVq9XKvV7gMASZKUQqHQBQB+v/+JSqXiaZr2iejv73f8fv+HzPzs3Nzcw47jXF9eXmYA8DwvTkTB1uLJdV1YltXdauweIcTl+fn5R4vF4klFUc7EYrFBQUSsadqALMtDi4uLJxVF+SOdTnsAoKrqTVmWC0IICCGgqmoxkUh8BwCBQOBPIvrcNM2LQogrmUzmXQAQ+XwesVjMIqJnZFmet237sK7rAgCSyeSoLMuPybL8AoCD8Xh8PxFVmDk+OTl52rKsY0R0acuWLc8R0bJhGKC1DjIzGYaR1DQt/393mbnXNM27Z2dnO4QQxyRJaguFQmeCweA7kUjEWv1gh4eHK57nrb1LAPg/B//A5/f7fYqiGEKI4x0dHQMAJsLhsLewsIB169YBAP4GLX9sXpsfkH0AAAAASUVORK5CYII="

/***/ }),
/* 2293 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAUCAYAAABroNZJAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsSAAALEgHS3X78AAAAB3RJTUUH4AwUDQovmf3aawAAALpJREFUOMvdlKEOgzAURU9HU02CnEBP8g2A41OQGBIQ/BKCkCD4GhQLCjHB0gm2MMOSlpntmOZVnPT2vTxxS1ONCVJy9TzORSFeVydMWRbGtmWoKm0veTJ2HUNZagDJAca+hzzXVpJLEGzFPNvHeeezRClUloFS9hIZRQjfR0aRnUS4Lk4YAuCEIcJ1zSVOkmwxlFpr4zjTxL3rANZzmvZj7w5m06wvimOWuj7Qna+0+Ockwnif/P+fPADLYy4wzqT5YAAAAABJRU5ErkJggg=="

/***/ }),
/* 2294 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2295 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2296 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2297 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "adf5903a293cc871eb017ea34436c4f2.png";

/***/ }),
/* 2298 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2299 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6b8fd76d7be3f7d0d6d0a88c9a892478.png";

/***/ }),
/* 2300 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2301 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAeCAYAAADD0FVVAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QEKEBAnsP+vGQAAAYZJREFUSMfdlrFKA0EQhn8ueBYS8wBioyl8BSNC8AmiJmm0jW9iccFOn8EipEh/BLS3slDBwqBFHiAK5lA+C+cghLvLimvjNMPN//Pv3O7szkgZBoRAG7gEnoAp3zYB7i3eAkK5GLAPPAJD4ASo2iKYr1p8aLyDIrESEFkm9QycjFjd+BFQyhKNgGtgNWdRcuJl4AqI5oEm8ABUCv6EAqxiGTdnD+UZ2Fmw1yzAa8ALEAo4AmKHA8SBEwPHgaSGpJ78WE9SQ8AIqHrKdBMYCXh3KWJH0RCYOpFdRVNe4Eg8lfRq3k8GwIdd06m3TCWlV9DpAQn0B/b/RD/NJz5FI0lvks7ks6hdLS2pCVD2JBhKSgJJY0lrnhJdlzQOJN1K2vUkuifpJpA0kNT2JNqWNJhtJ7Vf7ue2tZPlNNAC7ooa3wLBtPG15oGutdryDwXTFt3NGybO84aJHMF0mLjIHCZmiIc2zsRAB9gAlgxbAbYsHhuv6VzE1rr7NqAl9kgn9t03PPN9/QKnQ9+oAfJiOAAAAABJRU5ErkJggg=="

/***/ }),
/* 2302 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d6e6f834159fcc04ab212b5da427fd5e.png";

/***/ }),
/* 2303 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2304 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5672cce0f27c443f38b2ff0206b44ed1.png";

/***/ }),
/* 2305 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2306 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f1da05c6b2702b856ff8affd0138cbea.png";

/***/ }),
/* 2307 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2308 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e22fd76caf80fd705f5e3b3546aad008.png";

/***/ }),
/* 2309 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2310 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAAAzCAIAAABHf/LYAAAACXBIWXMAAAsSAAALEgHS3X78AAAGC0lEQVRoge1Z3VLTTBh+d5NsQ2LboRRaHVCkcCAIMnjAwBWgzgjcgA6D44FcgsfeAgfOWGe4AIceKF4BHOmoiKMDRbSDlNIf2zQxzSbZ7yBQKtBCf/j5ZnwOMkl28+7z7GY3+z5BlFL4n4M/r4YppbquF/ag63pvb29toc5CA2OsyLh4tG27UfEbr4ExVuza4pEx1vCGiqhXg23bBzqYUnqqjA+jOg2WZR1mfErMTo7qNKysrJwSj3qAz5tAA/BPw8XAPw0XA+epgRDi9XqDwWCdcc5uv4QQIoQ0lYDjOKcoHo/XE/kUNSCERFEsMhZFEeNKw84YQwjV0FAjNWCMD5CuipNt28WRqQp1aeA4rkhXkiRCSG0dWSdq0dDW1uZQJ4Q0nFANqEVD/StJY3FueVwpMMZut7vyjK+AC6Gh98YNa31de/WKRqNWImFrGgBgSeLa2oRQiAwMCN3dUH6mnbcGxvTFRW1hARByDQ5K9+/zly9jWQYAW1XNrS26sqLMzQFj0p074ujokUpQVUnMp0+fAGBgYKAh/K1kMvf8OSJEHh8Xrl+3NY3pOqMULAsAgOcRzyNRRJJkfv+uRiLMMDyPH3N+/0XRQL99y4XD8r174siIlc0yTYPyGSySZc7r1ZeW1NevPY8eCT09paXn8y4ZX74o4bDnyRM+GDTjcTjO42Cqamqa6/Ztrr09NzvrnpoifX3F0nPY81nxuBIOe2ZmuNZWa2fnWAG7YMxKJjm/3zMzo4TDVskW68w12HYuHJYnJvhAwE6nj6yizM0pc3NHP53J8IGAPDmZC4eL4s9ag760hAgRh4etZLJcHTMWM2OxcqVWMikODyNC9MVF587ZamBMW1iQJyasbLbCDD42iJXNyhMT2tu3TpAz0qCqqq7rdHUVESJ0djJVrScaU1WhsxMRQldX4Qw0MMY2Nzej0SjP88bysmtoyPkM1wlb01xDQ8byMpyBhs3NzVQqRQjheZ5Go0JPD9P1+sMyXRd6euj6Opy2hkwmk06nAcDZpVuJBBcMMsOoPzIzDC4YtLa3ocI3zrZthFCdOc329rZz4uxJbU3Dsmxns8UKytxcuSUo8+zZgTt8R4f7wYMiPyzLzmt5UEMul0un0/l83vk/wPO82+32+/1NTU3VCtA0zWhEl++jzFK2r8E0zZ8/f+bz+dJi0zQzmUwmk2lpably5UpVLaoli49pmgCAJclWVcB4d1cHsN+vJXBGoPnp00rRMbZVFUvSvgZKaTQardBtqVSq2k619ogCQKFQAACurc2Kx3FzM/vzp6pQh4EIseJxLhCA4pyOxWLHUlQUpapmeH5/kC3LKhQKQihEV1eRKFZJ+AggUaRra0JXFzgaFEU58Ao1BAemkKIopL+/8P698wLUCSxJhXfvSH8/OBoymUz9QQ9DlmVBEIqX6XRa6OlhhkE3NpAs1xMZyTLd2GCG4SQSGP6efI1FIBAonuu6ruTz0tiYOj/Peb0V8uNjgBDn9aqRiDQ25gTBAFBVKnfp0qWTV/b5fF6vt3i5tbXlGhlhhYK+tMS1tJR7iu/o4Nvby5VyLS360hLTdXF01LmDAaA2h/CEuHr1qs/nc851Xd/e2fFMT6uRiJlI4L37B+B+8MD98OGRRbi52Uwk1EjEMz0Ne14OBgCxmoWiqsoAgBBqb2/v6upyBjCRSCii6J6ays3OWskk19oKJ7SVEOL8fiuVcnJRrsSnQ5TSZDL569evE3IKhUJyrTPS+TUMALIsG58/Ky9fyuPju55AxTm57wlEIu6pKXLz5l+llFLbtr9+/ep8SitDluVQKFSbgMOw4vHcixfI5ZInJ4Vr13a9GcPYTTIxRoTsejM/fqjz80zXPdPT3CGndNebURRlY2Oj8v99nue7u7sb7BM7HtmbN8BxrsFB0tfHlXhk1taWsbJS+PABLEu6e/d4j+z379+xWKycDEEQOjs7a9j5nVAJXVszPn6k0ai1s7PvVba2CqEQuXWrslf5l0dWKBTi8Xi2ZG8MABhjn88XCAROdfmqB0f4fJRSVVUppRhjQogkSReWvYPqvMqLif8ArvMUI/clp+UAAAAASUVORK5CYII="

/***/ }),
/* 2311 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2312 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2313 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2314 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2315 */,
/* 2316 */,
/* 2317 */,
/* 2318 */,
/* 2319 */,
/* 2320 */,
/* 2321 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./boxcom-icon.png": 268,
		"./default-logo.png": 2260,
		"./desktop-icon.png": 363,
		"./dropbox-icon.png": 269,
		"./logo-dark.png": 878,
		"./logo.png": 2261,
		"./no-image-bg.png": 2262,
		"./no-image-qs.png": 2263,
		"./no-image.png": 2264
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 2321;


/***/ }),
/* 2322 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./flag-de.png": 2269,
		"./flag-en.png": 2270,
		"./flag-es.png": 2271,
		"./flag-fr.png": 2272,
		"./flag-it.png": 2273,
		"./flag-ja.png": 2274,
		"./flag-mobile-de.png": 2275,
		"./flag-mobile-en.png": 2276,
		"./flag-mobile-es.png": 2277,
		"./flag-mobile-fr.png": 2278,
		"./flag-mobile-it.png": 2279,
		"./flag-mobile-ja.png": 2280,
		"./flag-mobile-pt.png": 2281,
		"./flag-mobile-ru.png": 2282,
		"./flag-mobile-zh-cn.png": 2283,
		"./flag-pt.png": 2284,
		"./flag-ru.png": 2285,
		"./flag-zh-cn.png": 2286
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 2322;


/***/ }),
/* 2323 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 2324 */
2323,
/* 2325 */
2323,
/* 2326 */
2323,
/* 2327 */
2323,
/* 2328 */
2323
]);


// WEBPACK FOOTER //
// main-85e20787220dc1a0e61a.js